/**::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
@license Zoomify 图像查看器，版本位于下面第 25 行。版权所有 Zoomify, Inc.，1999-2016。版权所有。您可以
在私人和公共网站上出于个人和商业目的使用此文件，无论是否经过修改，只要此
通知已包含在内。未经事先许可，不得通过其他方式重新分发。适用附加条款。对于完整的
许可条款请参阅本产品中以及 Zoomify 网站 www.zoomify.com 上的 Zoomify 许可协议。
::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
*/

/*
以下功能按以下顺序分组列出：初始化、ZoomifyImageViewer、
ZoomifyViewport、ZoomifyToolbar、ZoomifyNavigator、ZoomifyGallery、ZoomifyRuler、NetConnector、
和实用工具。在每个组中，函数按照首次调用的顺序出现。每个
group 作为一个组件，具有自己的全局变量和函数，用于调整大小、定位和
相互作用。 Zoomify 图像查看器范围内的全局共享变量在单个文件中声明
“Z”对象提供轻松访问，同时防止与其他代码源的命名冲突。
*/
var dx =0;
var dy;
var temp;
var bblG
var hotspotListTitle;
var captionText;
var value;
var targetCtx;
var captionFontWeight
var background;
var captionFontWeight
var hCaption;
var canvasData;
var geoCoordsString;
var dataPath
var vpIDTemp
var viewportClickPt
var relatedTarget
var target
var touch
var index
var setHotspotVisibilityByID
var labelCaptionPositionListDP
var labelTargetListDP
var initVis
var bbsM;
var a
var b
var e
var f
var c
var d
var i
var j
var xml
var jsonTextOut
var tierTileOffsetsCount
var imageListFolder
var trackingFolder
var imageListFolder
var pValue
var slideList
var dragPtStart
var textH
var bbsmS
var setMask
var iconMedia
var dragPtCurrent
var id
var netReq
var ActiveXObject
var DocumentTouch
var containerUsers
var zImagePath
var zImagePath2
var tierTileOffsetChunks
var tierTileByteCountsCount
var tierTileByteCountLast
var imageFilterCurrent
var trackingPath
var currIDExt
var lfbtlS
var imageListPath
var dY
var labelListTempDP
var tbfggteS
var tbfgteS
var trsZ
var tbflteS
var lfbtnS
var lineStrokeColor
var tbfsteS
var unconvertedImage
var counterCountainer
var lfbtcrrS
var lfbtcrS
var tbfcgteS
var called
var btfE
var lfbthS
var createUnconvertedImageThumbnail
var gicS
var lfbtwbS
var tbfcbrte2S
var tbID
var syncOversize
var replyDataValue
var tileCounter
var tbfcrrteS
var tierTileByteCountLast
var fullImageTilesAllCachedNames
var btsisS
var XMLPath
var rsbnlS
var property
var rollover
var reTxt
var constrainImageFilter
var MessageDisplay
var getElementPosition
var lfbtsaS
var dimensionAxis
var loadTileInterval
var userCountainer
var destinationChange
var elmt2
var VBArray
var tbfbteS
var tbViewportID
var rsbnrS
var tbfgrteS
var btfcbr2S
var precacheBackfillTilesDelayed
var viewerEventsHandler
var setupSource
var annotationsXMLOut
var giC
var tierTileByteCountChunks
var btfCGR2
var tbfcrteS
var gB
var tbfnteS
var lfbtgbS
var tbfcteS
var rIconList
var trsisS
var setupNew
var getTrackingOverlayColor
var btfcrr2S
var btfCBR2
var navImageL
var tbfcrrte2S
var btszS
var btsiS
var trsiS
var lfbteS
var tbfcgrte2S
var trsFE
var trszS
var syncTransitionCanvas
var updateTrackingXML
var nboS
var insertIndex
var nBO
var smoothPanDeltaX
var tbfgbteS
var lfbtggS
var tbfblteS
var noteListTempDP
var tilesTimeStart
var winDimensions
var lfbtgS
var btfeS
var rSBNR
var btfCRR2
var tbfeteS
var overrideZoom
var trsfeS
var lfbtcgS
var throttleCounter
var tbfsateS
var constrainedZ
var tbfwbteS
var slideCurrentInList
var tbfhteS
var tbfcgrteS
var lfbtcbS
var tbfcbrteS
var buttonReset
var lfbtcgrS
var gspS
var z
var lfbtcbrS
var rSBNL
var lfbtgrS
var beginValue
var tierTileOffsetLast
var tbfcbteS
var navImageT
var dX
var navigatorTrackingOverlay
var tierBackfillScalePrior
var validateImageFiltersConvolve
var btsZ
var bblgS
var btfcgr2S
var viewModeAdj

(function () {
	//声明全局到页面对象以包含全局到查看器元素。
	var global = (function () { return this; } ).call();
	// global.Z = {};
})();
var Z={
	//调试值：在浏览器控制台中显示或使用函数 Z.Viewer.getVersion();以获得价值。
	version : '4.01 Enterprise',
}



//调试选项：用于捕获 Windows 上 Safari 中的错误。
//window.onerror = 函数（错误）{ 警报（错误）; };

//设置回调和权限函数作为 Z 全局对象的函数实现，以提供早期和全局支持。
Z.setCallback = function (callbackEvent, callbackFunction) {
	if (typeof Z.callbacks === 'undefined') { Z.callbacks = []; }
	var index = Z.Utils.arrayIndexOfObjectTwoValues(Z.callbacks, 'callbackEvent', callbackEvent, null, 'callbackFunction', callbackFunction);
	if (index == -1) { index = Z.callbacks.length; }
	Z.callbacks[index] = { callbackEvent:callbackEvent, callbackFunction:callbackFunction };
}



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::: INIT FUNCTIONS ::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.showImage = function (containerID, imagePath, optionalParams) {
	if (!Z.showImage.done) {
		// Ensure full initialization occurs only on first call to showImage.
		Z.showImage.done = true;

		// Ensure needed browser functions exist.
		Z.Utils.addCrossBrowserMethods();
		Z.Utils.addCrossBrowserEvents();

		// Declare all global variables in one global object and get web page parameters.
		Z.Utils.declareGlobals();
		Z.pageContainerID = containerID;

		//调试选项：
//Z.setCallback('viewUpdateComplete', function () { console.log('查看更新完成！'); } );
//Z.setCallback('labelCreatedGetInternalID', function () { console.log('标签已创建！'); } );

		Z.setEditPermissionFunction = function (permissionFunction) {
			Z.externalEditPermissionFunction = permissionFunction;
			//调试选项：Z.setEditPermissionFunction(function () { return true; } );
//调试选项：Z.setEditPermissionFunction(function () { return false; } );
//调试选项： Z.setEditPermissionFunction(function () { console.log('asking'); } );
		}

		Z.clearCallback = function (callbackEvent, callbackFunction) {
			var index = Z.Utils.arrayIndexOfObjectTwoValues(Z.callbacks, 'callbackEvent', callbackEvent, null, 'callbackFunction', callbackFunction);
			if (index != -1) {
				Z.callbacks = Z.Utils.arraySplice(Z.callbacks, index, 1);
			}
		}

		// Prepare image path, or, if optional XML parameters path is set using image path parameter, prepare to parse XML for image path and any optional parameters.
		var imagePathProvided = (typeof imagePath !== 'undefined' && Z.Utils.stringValidate(imagePath));
		var optionalParamsIncludeIIIFServer = (typeof optionalParams !== 'undefined')
			&& ((typeof optionalParams === 'string' && optionalParams.indexOf('zIIIFServer') != -1)
				|| (typeof optionalParams === 'object' && typeof optionalParams['zIIIFServer'] !== 'undefined'));
		if (imagePathProvided && imagePath.indexOf('zXMLParametersPath') != -1) {
			var xmlParamsPath = imagePath.substring(19, imagePath.length);
			Z.xmlParametersPath = Z.Utils.stringRemoveTrailingSlashCharacters(xmlParamsPath);
		} else if (optionalParamsIncludeIIIFServer) {
			Z.imagePath = 'IIIFImageServer';
		} else if (imagePathProvided) {
			Z.imagePath = Z.Utils.stringRemoveTrailingSlashCharacters(imagePath);
		} else {
			Z.imagePath = null;
		}

		// Process optional parameters.
		if (typeof optionalParams !== 'undefined') {
			if (typeof optionalParams === 'string') {
				// For optional parameters passed as strings, various escaping alternatives handled here for '&' concatenation delimiter:
				// \u0026 handled by browser, %26 handled by unescape (deprecated), &#38; and &#038; and &amp; handled by function stringUnescapeAmpersandCharacters.
				var optionalParamsUnescaped = unescape(optionalParams);
				var optionalParamsFullyUnescaped = Z.Utils.stringUnescapeAmpersandCharacters(optionalParamsUnescaped);
				Z.parameters = Z.Utils.parseParameters(optionalParamsFullyUnescaped);
			} else {
				// For optional parameters passed as objects, above escape handling not required.
				Z.parameters = Z.Utils.parseParameters(optionalParams);
			}

			// Debug options:
			// console.log('optionalParamsRaw: ' + optionalParams);
			// console.log('optionalParamsUnescaped: ' + optionalParamsUnescaped);
			// console.log('optionalParamsFullyUnescaped: ' + optionalParamsFullyUnescaped);
			// console.log('Z.parameters: ' + Z.parameters);
		}

		// Initialize on content load rather than full page load if supported by browser.
		// If showImage called by user interaction after page is loaded, call initialize() directly.
		if (document.readyState != 'complete') {
			Z.Utils.addEventListener(document, 'DOMContentLoaded', Z.initialize);
			Z.Utils.addEventListener(window, 'load', Z.initialize);
		} else {
			Z.initialize();
		}

	} else {
		// Re-declare all global variables to clear, and re-get web page parameters.
		Z.Utils.declareGlobals();
		Z.pageContainerID = containerID;
		if (typeof imagePath !== 'undefined' && Z.Utils.stringValidate(imagePath)) {
			Z.imagePath = Z.Utils.stringRemoveTrailingSlashCharacters(imagePath);
		} else {
			Z.imagePath = null;
		}

		if (typeof optionalParams !== 'undefined') { Z.parameters = Z.Utils.parseParameters(optionalParams); }

		// Re-initialize to apply new parameters.
		Z.initialize();
	}
};

Z.initialize = function () {
	// Ensure showImage called only once during page load.
	Z.Utils.removeEventListener(document, 'DOMContentLoaded', Z.initialize);
	Z.Utils.removeEventListener(window, 'load', Z.initialize);

	// Get browser features.
	Z.Utils.detectBrowserFeatures();

	// Parse web page parameters and create Zoomify Viewer.
	if (Z.xmlParametersPath && !Z.parameters) { // Image path contains parameters XML path.
		Z.loadParametersXML();

	} else if (Z.parameters !== null && typeof Z.parameters['zXMLParametersPath'] !== 'undefined') {
		// Image path used but third parameter is meta-parameter that substitutes XML parameter file for HTML parameters.
		// In this case call to setParameters in next line calls loadParametersXML which then calls functions to create and configure Viewer.
		Z.Utils.setParameters(Z.parameters);

	} else { // Image path used. No parameters XML file.
		Z.Utils.setParameters(Z.parameters);
		Z.Viewer = new Z.ZoomifyImageViewer();

		// Display user login request if optional parameter set.
		if (Z.userLogin == 'request' || Z.userPanelVisible != 0) {
			Z.Utils.enforceUserLogin();

		} else {
			// Display copyright text for user confirmation if optional parameter set.
			if (Z.Utils.stringValidate(Z.copyrightPath)) {
				Z.Utils.enforceCopyright();

			} else {
				Z.Viewer.configureViewer();
			}
		}

		// If in any debug mode, present basic debugging features (trace panel, globals dialog).
		if (Z.debug == 1 || Z.debug == 2 || Z.debug == 3) { Z.Utils.trace(Z.Utils.getResource('UI_TRACEDISPLAYDEBUGINFOTEXT'), false, true); }

	}
};

// Support parameters in XML file rather than as HTML string.
Z.loadParametersXML = function () {
	Z.xmlParametersParsing = true;
	var netConnector = new Z.NetConnector();
	var XMLPath = Z.Utils.cacheProofPath(Z.xmlParametersPath);
	netConnector.loadXML(XMLPath);
}



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::: VIEWER FUNCTIONS ::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.ZoomifyImageViewer = function () {
	var self = this;
	var viewerStatus = [];

	// Create Viewer display area as application environment for Viewport, Toolbar and Navigator.
	Z.ViewerDisplay = Z.Utils.createContainerElement('div', 'ViewerDisplay', 'inline-block', 'relative', 'hidden', '100%', '100%', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'pointer');
	Z.pageContainer = document.getElementById(Z.pageContainerID);
	var containerS = Z.Utils.getElementStyle(Z.pageContainer);

	// Prevent selection of elements within Viewer, not including annotation panel text.
	Z.ViewerDisplay.style['-webkit-touch-callout'] = 'none';
	Z.ViewerDisplay.style['-moz-user-select'] = 'none';
	//Z.ViewerDisplay.style['-moz-user-select'] = '-moz-none'; // Pre Firefox v31
	Z.ViewerDisplay.style['-khtml-user-select'] = 'none';
	Z.ViewerDisplay.style['-webkit-user-select'] = 'none';
	Z.ViewerDisplay.style['-ms-user-select'] = 'none';
	Z.ViewerDisplay.style['-o-user-select'] = 'none';
	Z.ViewerDisplay.style['user-select'] = 'none';

	// Get container dimensions. Handle standard size values, percents, non-numerics, and non-standard percents.
	var containerDims = Z.Utils.getContainerSize(Z.pageContainer, Z.ViewerDisplay);
	Z.viewerW = containerDims.x;
	Z.viewerH = containerDims.y;

	// Clear container and append Viewer.
	Z.pageContainer.innerHTML = '';
	Z.pageContainer.appendChild(Z.ViewerDisplay);

	// Set global value to allow function initializeViewerEventListeners to enable responsive sizing if not disabled by HTML parameter zAutoResize=0 and if enabled by % container dimensions.
	Z.autoResize = (Z.autoResize || Z.Utils.isElementFluid(Z.pageContainer));
	var autoResizeSkipDuration = parseInt(Z.Utils.getResource('DEFAULT_AUTORESIZESKIPDURATION'), 10);
	var autoResizeSkipTimer;

	// Set viewer variable for mousewheel support.
	Z.mouseWheelCompleteDuration = parseInt(Z.Utils.getResource('DEFAULT_MOUSEWHEELCOMPLETEDURATION'), 10);

	// Set viewer variables for virtual pointer.
	if (Z.virtualPointerVisible) {
		var virtualPointerPath = Z.Utils.getResource('DEFAULT_VIRTUALPOINTERPATH');
		var virtualPointer, virtualPointerImage;
	}

	// If viewing imageSet declare variables global to Viewer.
	if (Z.imageSet) { var imageSetObjects = [], imageSetList = null, imageSetListDP = []; }

	// Create Viewport or load imageSet XML to determine how many Viewports to create.
	this.configureViewer = function () {
		if (!Z.Viewer.getStatus('configureCalled')) {
			Z.Viewer.setStatus('configureCalled', true);

			// Set configuration functions to execute on initialization of only Viewport or last Viewport.
			function initCallbackFunction () {
				Z.clearCallback(initCallback, initCallbackFunction);
				initializeViewerEventListeners();

				// Use top viewport if multiple but do not use current pointer for overlays because it changes on interaction.
				var topVP = Z['Viewport' + (Z.imageSetLength - 1).toString()];
				var vpControl = (Z.overlays) ? topVP : Z.viewportCurrent;
				self.configureComponents(vpControl);
			}
			var initCallback = (!Z.imageSet) ? 'initializedViewport' : 'initializedViewer';
			Z.setCallback(initCallback, initCallbackFunction);

			// Set message clearing callback to execute on drawing complete of only Viewport or last Viewport.
			function viewerReadyCallbackFunction () {
				Z.clearCallback('readyViewer', viewerReadyCallbackFunction);
				if (Z.Utils.getMessage() == Z.Utils.getResource('ALERT_LOADINGIMAGESET') || Z.Utils.getMessage() == Z.Utils.getResource('ALERT_LOADINGANNOTATIONS')) {
					Z.Utils.hideMessage();
				}
				// Finish precaching of backfile tiles if delayed for faster image set start.
				if (Z.imageSet && !Z.comparison) { precacheBackfillTilesDelayed(); }

				// Alternative implementation: Finish precaching here for slidestacks but in function viewportSelect for animations.
				//if (Z.slidestack) { precacheBackfillTilesDelayed(); }

				// Sync counter tracking.
				if (Z.tracking) { Z.viewportCurrent.syncTrackingToViewport(); }
			}
			Z.setCallback('readyViewer', viewerReadyCallbackFunction);

			if (!Z.imageSet) {
				Z.Viewport = new Z.ZoomifyViewport(); // Enable references in all other functions that are modified for ImageSet support
				Z.viewportCurrent = Z.Viewport;

			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_LOADINGIMAGESET'), false, null, 'center');

				if (typeof Z.overlayJSONObject !== 'undefined' && typeof Z.overlayJSONObject === 'object' && Z.overlayJSONObject !== null) {
					var xmlText = Z.Utils.jsonConvertObjectToXMLText(Z.overlayJSONObject);
					var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
					self.parseImageSetXML(xmlDoc, 'overlay');

				} else {
					var XMLPath;
					var netConnector = new Z.NetConnector();
					if (Z.imageSetPath.toLowerCase().substring(Z.imageSetPath.length - 4, Z.imageSetPath.length) != ".xml") {
						Z.imageSetPath = Z.imageSetPath + "/" + Z.Utils.getResource("DEFAULT_IMAGESETXMLFILE");
					}
					XMLPath = Z.Utils.cacheProofPath(Z.imageSetPath);
					netConnector.loadXML(XMLPath);
				}
			}
		}
	}

	// Create Toolbar, Navigator, and Ruler
	this.configureComponents = function (viewport) {
		if (Z.toolbarVisible > 0 && !Z.Toolbar) {
			Z.Toolbar = new Z.ZoomifyToolbar(viewport);
		}
		if (Z.navigatorVisible > 0) {
			if (!Z.Navigator) {
				Z.Navigator = new Z.ZoomifyNavigator(viewport);
				if (Z.Navigator) { Z.Navigator.validateNavigatorGlobals(); }
			}
			if (Z.comparison && !Z.Navigator2) {
				Z.Navigator2 = new Z.ZoomifyNavigator(Z.Viewport1);
				if (Z.Navigator2) { Z.Navigator2.validateNavigatorGlobals(); }
			}
		}
		if (Z.galleryVisible > 0) {
			if (!Z.Gallery) {
				Z.Gallery = new Z.ZoomifyGallery(viewport);
				if (Z.Gallery) { Z.Gallery.validateGalleryGlobals(); }
			}
		}
		if (Z.rulerVisible > 0 && !Z.Ruler) {
			Z.Ruler = new Z.ZoomifyRuler(viewport);
		}
		if (Z.helpCustom) {
			loadHelp();
		}
	}

	function loadHelp () {
		var netConnector = new Z.NetConnector();
		netConnector.loadHTML(Z.helpPath, self.receiveHelpHTML, null, 'loadHTML');
	}

	this.receiveHelpHTML = function (xhr) {
		if (xhr.readyState == 4 && xhr.status == 200 && Z.Utils.stringValidate(xhr.responseText)) {
			Z.helpContent = xhr.responseText;
		}
	}

	this.getVersion = function () {
		return Z.version;
	}

	this.setSizeAndPosition = function (width, height, left, top, update) {
		Z.viewerW = width;
		Z.viewerH = height;
		Z.ViewerDisplay.style.width = width + 'px';
		Z.ViewerDisplay.style.height = height + 'px';
		if (Z.Viewport && Z.Viewport.getStatus('initializedViewport')) {
			Z.Viewport.setSizeAndPosition(width, height, left, top);
		}
		var toolbarTop = (Z.toolbarPosition == 1) ? height - Z.toolbarH : 0;
		if (Z.ToolbarDisplay && Z.Toolbar.getInitialized()) {
			Z.Toolbar.setSizeAndPosition(width, null, null, toolbarTop);
			if (Z.toolbarVisible != 0 && Z.toolbarVisible != 8) { Z.Toolbar.show(true); }
		}
		if (Z.Navigator && Z.Navigator.getInitialized()) {
			var navLeft = (Z.navigatorL == 0) ? left: (Z.navigatorL + Z.navigatorW > width) ? width - Z.navigatorW : Z.navigatorL;
			var navTop = (Z.navigatorT != 0) ? Z.navigatorT : top;
			Z.Navigator.setSizeAndPosition(null, null, navLeft, navTop, Z.navigatorFit);
			if (Z.navigatorVisible > 1) {
				Z.Navigator.setVisibility(true);
				if (Z.comparison && Z.Navigator2) {
					var left2 = width - Z.navigatorW;
					Z.Navigator2.setSizeAndPosition(null, null, left2, top, Z.navigatorFit);
					Z.Navigator2.setVisibility(true);
				}
			}
		}
		if (Z.imageList) {
			if (Z.Viewport.getStatus('initializedImageList')) {
				Z.Viewport.setSizeAndPositionImageList();
			}
		}
		if (Z.slideList && typeof slideList !== 'undefined' && slideList !== null) {
			var listCoords = Z.Viewport.calculateSlideListCoords(Z.viewerW, Z.viewerH); // viewH allows for toolbar height if static in viewer display area.
			slideList.style.left = listCoords.x + 'px';
			slideList.style.top = listCoords.y + 'px';
		}
		if (Z.Gallery && Z.Gallery.getInitialized()) {
			Z.Gallery.setSizeAndPosition(width, height, left, top);
			if (Z.galleryAutoShowHide) { Z.Gallery.setVisibility(true); }
		}
		if (update) { Z.Viewport.updateView(true); }
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::: PATH FUNCTIONS :::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getImagePath = function () {
		return self.getImage();
	}

	this.getImage = function () {
		return Z.imagePath;
	}

	// This function included for backward compatibility with version 1.
	this.setImagePath = function (imagePath, imageProperties) {
		if (typeof imageProperties !== 'undefined' && Z.Utils.stringValidate(imageProperties)) {
			Z.imageProperties = imageProperties;
		}
		self.setImage(imagePath);
	}

	// Use setImage to set image path as well as any image-specific optional parameters, and any non-image-specific
	// optional parameter including viewport, toolbar, navigator, tour, slide, hotspot, annotation, or other parameters.
	// Use showImage to force a full viewer reinitialization including all related components: toolbar, navigator, etc.
	this.setImage = function (imagePath, optionalParams, initializingCall, vpID) {

		if (Z.Viewport && (Z.Viewport.getStatus('initializedViewport') || initializingCall)) {
			Z.Viewport.zoomAndPanAllStop(true);

			var proceed = true;
			if (Z.editing !== null) { proceed = validateExitCustom(); }
			if (proceed) {

				// Clear mask and image-specific optional parameters.
				if (Z.maskingSelection) { self.clearLabelMask(); }
				if (!Z.overlays) { Z.Utils.clearImageParameters(); }

				// Clearing here unnecessary because occurs in function reinitializeViewport.
				//Z.Viewport.clearAll(true, true, true, true);

				// Reset image path.
				Z.imagePath = Z.Utils.stringRemoveTrailingSlashCharacters(imagePath);
				Z.Utils.validateImagePath();

				var targetViewport;
				if (typeof vpID === 'undefined' || vpID === null || vpID == 0) {
					targetViewport = Z.Viewport;
				} else {
					targetViewport = Z['Viewport' + vpID.toString()];
				}

				targetViewport.setImagePath(Z.imagePath);
				if (typeof optionalParams !== 'undefined' && optionalParams !== null) { Z.parameters = Z.Utils.parseParameters(optionalParams); }

				// If initializing, set parameters, otherwise, handled in function reinitializeViewport.
				if (initializingCall) { Z.Utils.setParameters(Z.parameters); }

				if (Z.tileSource == 'unconverted') {
					targetViewport.loadUnconvertedImage(imagePath);
				} else if (!Z.imageProperties) {
					var netConnector = new Z.NetConnector();
					targetViewport.loadImageProperties(Z.imagePath, netConnector, vpID);
				} else {
					var xmlDoc = Z.Utils.xmlConvertTextToDoc(Z.imageProperties);
					targetViewport.parseImageXML(xmlDoc);
				}
			}
		}
	}

	this.setImageWithFade = function (imagePath, optionalParams, initializingCall, changeFor) {
		if (Z.Viewport && (Z.Viewport.getStatus('initializedViewport') || initializingCall)) {
			if (typeof changeFor === 'undefined' || changeFor === null) { changeFor = 50; }
			Z.slideTransitionTimeout = window.setTimeout( function () { Z.Viewport.slideTransitionTimeoutHandler('out', imagePath, optionalParams, initializingCall); }, 1);
		}
	}

	this.setTourPath = function (tourPath, noReload) {
		if (Z.Viewport && Z.Viewport.getStatus('initializedViewport')) {
			Z.Viewport.setHotspotPath(tourPath, noReload);
		}
	}

	this.setHotspotPath = function (hotspotPath, noReload) {
		if (Z.Viewport && Z.Viewport.getStatus('initializedViewport')) {
			Z.Viewport.setHotspotPath(hotspotPath, noReload);
		}
	}

	this.setAnnotationPath = function (annotationPath, noReload) {
		if (Z.Viewport && Z.Viewport.getStatus('initializedViewport')) {
			Z.Viewport.setAnnotationPath(annotationPath, noReload);
		}
	}

	this.setTrackingPath = function (trackingPath, noReload) {
		if (Z.Viewport && Z.Viewport.getStatus('initializedViewport')) {
			Z.Viewport.setTrackingPath(trackingPath, noReload);
		}
	}

	this.initializePageExitEventHandler = function () {
		Z.Utils.addEventListener(window, 'beforeunload', validateExitBrowser);
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: GET & SET FUNCTIONS :::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getStatus = function (vState) {
		var index = Z.Utils.arrayIndexOfObjectValue(viewerStatus, 'state', vState);
		var statusVal = (index == -1) ? false : viewerStatus[index].status;
		return statusVal;
	}

	this.setStatus = function (vState, vStatus) {
		var notYetSet = false;
		var index = Z.Utils.arrayIndexOfObjectValue(viewerStatus, 'state', vState);
		if (index == -1) {
			notYetSet = vStatus;
			viewerStatus[viewerStatus.length] = { state:vState, status:vStatus };
		} else {
			if (!viewerStatus[index].status && vStatus) { notYetSet = true; }
			viewerStatus[index].status = vStatus;
		}
		if (notYetSet) {
			Z.Utils.validateCallback(vState);
			self.validateViewerReady(vState);
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::: VALIDATION FUNCTIONS :::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.validateViewerStatus = function (vState) {
		var statusVal = true;
		if (Z.imageSet) {
			for (var i = 0, j = Z.imageSetLength; i < j; i++) {
				var vpTest = Z['Viewport' + i.toString()];
				if (!vpTest.getStatus(vState)) {
					statusVal = false;
					break;
				}
			}
		}
		if (statusVal) {
			var indexVP = vState.indexOf('Viewport');
			if (indexVP != -1) { vState = vState.substring(0, indexVP); }
			self.setStatus(vState + 'Viewer', true);
		}
	}

	this.validateViewerReady = function (vState) {
		var viewportOK = (Z.Viewport && (Z.Viewport  && Z.Viewport.getStatus('initializedViewport') && (Z.tileSource == 'unconverted' || (Z.Viewport.getStatus('precacheLoadedViewport') && Z.Viewport.getStatus('backfillLoadedViewport') && Z.Viewport.getStatus('backfillDrawnViewport'))) && Z.Viewport.getStatus('displayLoadedViewport') && Z.Viewport.getStatus('displayDrawnViewport')));
		var hotspotsOK = (!Z.hotspots || (Z.Viewport  && Z.Viewport.getStatus('hotspotsLoadedViewport')));
		var annotationsOK = (!Z.annotations || (Z.Viewport && Z.Viewport.getStatus('annotationsLoadedViewport') && (!Z.annotationPanelVisible || Z.Viewport.getStatus('annotationPanelInitializedViewport'))));
		var toolbarOK = (Z.ToolbarVisible == 0 || (Z.Toolbar && Z.Toolbar.getInitialized()));
		var navigatorOK = (!Z.NavigatorVisible || (Z.Navigator && Z.Navigator.getInitialized()));
		var galleryOK = (!Z.GalleryVisible || (Z.Gallery && Z.Gallery.getInitialized()));
		var rulerOK = (!Z.RulerVisible || (Z.Ruler && Z.Ruler.getInitialized()));
		var imageSetOK = (!Z.imageSet || (Z.Viewer && Z.Viewer.getStatus('initializedViewer') && (Z.tileSource == 'unconverted' || (Z.Viewer.getStatus('precacheLoadedViewer')  && Z.Viewer.getStatus('backfillLoadedViewer') && Z.Viewer.getStatus('backfillDrawnViewer'))) && Z.Viewer.getStatus('displayLoadedViewer') && Z.Viewer.getStatus('displayDrawnViewer')));
		var imageSetHotspotsOK = (!Z.imageSet || !Z.hotspots || (Z.Viewer && Z.Viewer.getStatus('hotspotsLoadedViewer')));
		var imageSetAnnotationsOK = (!Z.imageSet || !Z.annotations || (Z.Viewer && Z.Viewer.getStatus('annotationsLoadedViewer') && (!Z.annotationPanelVisible || Z.Viewer.getStatus('annotationPanelInitializedViewer'))));
		var viewerReady = viewportOK && hotspotsOK && annotationsOK && toolbarOK && navigatorOK && galleryOK && rulerOK && imageSetOK && imageSetHotspotsOK && imageSetAnnotationsOK;

		// Debug options:
		//console.log('In validateViewerReady - state: ' + vState + '   viewerReady: ' + viewerReady + '    values: ' + viewportOK + '  ' + hotspotsOK + '  ' + annotationsOK + '  ' + toolbarOK + '  ' + navigatorOK + '  ' + galleryOK + '  ' + rulerOK + '  ' + imageSetOK + '  ' + imageSetHotspotsOK + '  ' + imageSetAnnotationsOK);
		//console.log(Z.Viewport.getStatus('backfillLoadedViewport'), Z.Viewport.getStatus('displayLoadedViewport'), Z.Viewport.getStatus('backfillDrawnViewport'), Z.Viewport.getStatus('displayDrawnViewport'));

		if (viewerReady) { Z.Viewer.setStatus('readyViewer', true); }
		return viewerReady;
	}

	function validateExitBrowser (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var confirmationMessage = null;
			if (Z.editing !== null && Z.Viewport.verifyEditsUnsaved()) {
				confirmationMessage = Z.Utils.getResource('ALERT_UNSAVEDEDITSEXIST-BROWSER');
				event.returnValue = confirmationMessage;
				return confirmationMessage;
			}
		}
	}

	function validateExitCustom () {
		var endEditing = true;
		if (Z.editing !== null && Z.Viewport.verifyEditsUnsaved()) {
			endEditing = window.confirm(Z.Utils.getResource('ALERT_UNSAVEDEDITSEXIST-CUSTOM'));
		}
		return endEditing;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: VIRTUAL POINTER FUNCTIONS ::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function loadVirtualPointer () {
		virtualPointerImage = new Image();
		virtualPointerImage.url = virtualPointerPath;
		virtualPointerImage.onload = self.createVirtualPointer;
		virtualPointerImage.onerror = virtualPointerLoadingFailed;
		virtualPointerImage.src = virtualPointerPath;
	}

	this.createVirtualPointer = function () {
		if (!virtualPointerImage){
			loadVirtualPointer();
		} else {
			var piW = virtualPointerImage.width;
			var piH = virtualPointerImage.height;
			var piL = Z.viewerW / 2 + 100;
			var piT = Z.viewerH - 200;
			drawVirtualPointerInHTML(piW, piH, piL, piT);
		}
	}

	this.setVirtualPointerVisibility = function (visible) {
		if (virtualPointer) {
			virtualPointer.style.display = (visible) ?  'inline-block' : 'none';
		}
	}
	
	this.setVirtualPointerSizeAndPosition = function (width, height, left, top, imageCoords) {
		if (virtualPointer) {
			if (typeof width === 'undefined' || width === null) { width = virtualPointerImage.width; }
			if (typeof height === 'undefined' || height === null) { height = virtualPointerImage.height; }
			if ((typeof left === 'undefined' || left === null || isNaN(left)) && (typeof virtualPointer.style.left === 'undefined' || virtualPointer.style.left === null)) { left = (Z.viewerW / 2 + 100); }
			if ((typeof top === 'undefined' || top === null || isNaN(top)) && (typeof virtualPointer.style.top === 'undefined' || virtualPointer.style.top === null)) { top = Z.viewerH - 200; }
			
			if (typeof imageCoords !== 'undefined' && imageCoords !== null) {
				var imagePixelPt = Z.Viewport.convertImageCoordsToViewportCoords(left, top);
				left = imagePixelPt.x;
				top = imagePixelPt.y;
			}
			
			virtualPointer.style.width = width + 'px';
			virtualPointer.style.height = height + 'px';
			virtualPointer.firstChild.width = width;
			virtualPointer.firstChild.height = height;
			
			virtualPointer.style.left = left + 'px';
			virtualPointer.style.top = top + 'px';
		}
	}

	function drawVirtualPointerInHTML (piW, piH, piL, piT) {
		// Draw virtual pointer graphic on screen in HTML not on canvas, to support movement
		//in front of contents of other displays (polygons, watermarks, hotspots, etc.). Clone graphic
		// file to ensure ability to create more than one pointer instance.
		var pImage = virtualPointerImage.cloneNode(false);
		pImage.width = piW;
		pImage.height = piH;
		virtualPointer = Z.Utils.createContainerElement('div', 'piC', 'inline-block', 'absolute', 'hidden', piW + 'px', piH + 'px', piL + 'px', piT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
		virtualPointer.appendChild(pImage);
		Z.ViewerDisplay.appendChild(virtualPointer);

		// Set tooltip.
		virtualPointer.setAttribute('title', Z.Utils.getResource('TIP_VIRTUALPOINTER'));

		// Ensure proper z-ordering of Viewer elements.
		virtualPointer.style.zIndex = (Z.baseZIndex + 32).toString();

		Z.Utils.addEventListener(virtualPointer, 'mousedown', virtualPointerMouseDownHandler);
		Z.Utils.addEventListener(virtualPointer, 'touchstart', virtualPointerTouchStartHandler)
		Z.Utils.addEventListener(virtualPointer, 'touchmove', virtualPointerTouchMoveHandler);
		Z.Utils.addEventListener(virtualPointer, 'touchend', virtualPointerTouchEndHandler);
		Z.Utils.addEventListener(virtualPointer, 'touchcancel', virtualPointerTouchCancelHandler);
		Z.Utils.addEventListener(pImage, 'contextmenu', Z.Utils.preventDefault);
		Z.Utils.addEventListener(pImage, 'mousedown', Z.Utils.preventDefault);
	}

	function virtualPointerLoadingFailed () {
		Z.Utils.showMessage(Z.Utils.getResource('ERROR_VIRTUALPOINTERPATHINVALID') + this.url, true);
	}

	function virtualPointerMouseDownHandler (event) {
		var event = Z.Utils.event(event);
		if (event && virtualPointer) {
			Z.Utils.removeEventListener(virtualPointer, 'mousedown', virtualPointerMouseDownHandler);
			Z.Utils.addEventListener(Z.ViewerDisplay, 'mousemove', virtualPointerMouseMoveHandler);
			Z.Utils.addEventListener(Z.ViewerDisplay, 'mouseup', virtualPointerMouseUpHandler);
			var mPt = Z.Utils.getMousePosition(event);
			dragPtStart = new Z.Utils.Point(mPt.x, mPt.y); // Variables for dragging set and cleared separately from mouse position variables.
			var dragHotPt = new Z.Utils.Point(parseFloat(virtualPointer.style.left), parseFloat(virtualPointer.style.top));
			virtualPointer.mouseXPrior = dragPtStart.x;
			virtualPointer.mouseYPrior = dragPtStart.y;
		}
	}

	function virtualPointerMouseMoveHandler (event) {
		var event = Z.Utils.event(event);
		if (event && virtualPointer) {
			var mPt = Z.Utils.getMousePosition(event);
			dragPtCurrent = new Z.Utils.Point(mPt.x, mPt.y);
			var mouseDeltaX = dragPtCurrent.x - virtualPointer.mouseXPrior;
			var mouseDeltaY = dragPtCurrent.y - virtualPointer.mouseYPrior;
			virtualPointer.mouseXPrior = dragPtCurrent.x;
			virtualPointer.mouseYPrior = dragPtCurrent.y;
			var vrptS = virtualPointer.style;
			var x = parseFloat(vrptS.left) + mouseDeltaX;
			var y = parseFloat(vrptS.top) + mouseDeltaY;
			vrptS.left = x + 'px';
			vrptS.top = y + 'px';
		}
	}

	function virtualPointerMouseUpHandler (event) {
		var event = Z.Utils.event(event);
		if (event && virtualPointer) {
			var mPt = Z.Utils.getMousePosition(event);
			var dragPtEnd;
			if (!Z.mouseOutDownPoint) {
				dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
			} else {
				dragPtEnd = Z.mouseOutDownPoint;
			}
			Z.Utils.removeEventListener(Z.ViewerDisplay, 'mousemove', virtualPointerMouseMoveHandler);
			Z.Utils.removeEventListener(Z.ViewerDisplay, 'mouseup', virtualPointerMouseUpHandler);
			Z.Utils.addEventListener(virtualPointer, 'mousedown', virtualPointerMouseDownHandler);
			var mouseDeltaX = dragPtEnd.x - virtualPointer.mouseXPrior;
			var mouseDeltaY = dragPtEnd.y - virtualPointer.mouseYPrior;
			var vrptS = virtualPointer.style;
			var x = parseFloat(vrptS.left) + mouseDeltaX;
			var y = parseFloat(vrptS.top) + mouseDeltaY;
			vrptS.left = x + 'px';
			vrptS.top = y + 'px';
		}
	}

	function virtualPointerTouchStartHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent copy selection, delay, and simulated mouse events.
			if (!Z.interactive) { return; } // Disallow any interaction.

			if (virtualPointer) {
				var touch = Z.Utils.getFirstTouch(event);
				if (touch) {
					var target = touch.target;
					var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
					dragPtStart = new Z.Utils.Point(mPt.x, mPt.y);
					virtualPointer.mouseXPrior = mPt.x;
					virtualPointer.mouseYPrior = mPt.y;
				}
			}
		}
	}

	function virtualPointerTouchMoveHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent copy selection, delay, and simulated mouse events.
			if (!Z.interactive || !Z.mousePan) { return; }  // Disallow mouse panning if parameter false.

			if (virtualPointer) {
				var touch = Z.Utils.getFirstTouch(event);
				if (touch) {
					var target = touch.target;
					var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
					var vpS = virtualPointer.style;
					var x = parseFloat(vpS.left);
					var y = parseFloat(vpS.top);
					vpS.left = x + (mPt.x - virtualPointer.mouseXPrior) + 'px';
					vpS.top = y + (mPt.y - virtualPointer.mouseYPrior) + 'px';
					virtualPointer.mouseXPrior = mPt.x;
					virtualPointer.mouseYPrior = mPt.y;
					return false;
				}
			}
		}
		return false;
	}

	function virtualPointerTouchEndHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent delay and simulated mouse events.
			if (!Z.interactive) { return; } // Disallow any interaction.

			if (virtualPointer) {
				var touch = Z.Utils.getFirstTouch(event);
				if (touch) {
					var target = touch.target;
					var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
					var dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
					var mouseDeltaX = dragPtEnd.x - virtualPointer.mouseXPrior;
					var mouseDeltaY = dragPtEnd.y - virtualPointer.mouseYPrior;
					var vrptS = virtualPointer.style;
					var x = parseFloat(vrptS.left) + mouseDeltaX;
					var y = parseFloat(vrptS.top) + mouseDeltaY;
					vrptS.left = x + 'px';
					vrptS.top = y + 'px';
				}
			}
		}
	}

	function virtualPointerTouchCancelHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent copy selection, delay, and simulated mouse events.
			if (!Z.interactive) { return; } // Disallow any interaction.

			if (virtualPointer) {
				var touch = Z.Utils.getFirstTouch(event);
				if (touch) {
					var target = touch.target;
					var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
					var dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
					var mouseDeltaX = dragPtEnd.x - virtualPointer.mouseXPrior;
					var mouseDeltaY = dragPtEnd.y - virtualPointer.mouseYPrior;
					var vrptS = virtualPointer.style;
					var x = parseFloat(vrptS.left) + mouseDeltaX;
					var y = parseFloat(vrptS.top) + mouseDeltaY;
					vrptS.left = x + 'px';
					vrptS.top = y + 'px';
				}
			}
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::: PRELOAD FUNCTIONS :::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.preloadTiles = function () {
		if (Z.Viewer.getStatus('readyViewer')) {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_PRELOADINGIMAGE-DATA'), false, Z.messageDurationLong, 'center');
			for (var i = 0, j = Z.imageSetLength; i < j; i++) {
				Z['Viewport' + i.toString()].preloadTiles(true);
			}
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::: COMPARISON FUNCTIONS :::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.syncComparisonViewport = function (updateView) {
		if (Z.syncComparison && Z.Viewport && Z.Viewport0 && Z.Viewport0.getStatus('initializedViewport') && Z.Viewport1 && Z.Viewport1.getStatus('initializedViewport')) {
			var vpID = Z.Viewport.getViewportID();
			var vpCurrent = (vpID == 0) ? Z.Viewport0 : Z.Viewport1;
			var vpComparison = (vpID == 0) ? Z.Viewport1 : Z.Viewport0;

			if (updateView) {
				var currCoordsFull = vpCurrent.getCoordinatesFull(true);
				vpComparison.setView(currCoordsFull.x, currCoordsFull.y, currCoordsFull.z, currCoordsFull.r, null, null);

			} else {
				var coordsS = vpCurrent.getCoordinatesDisplayFull();
				vpComparison.setViewNoUpdate(coordsS.cLeft, coordsS.cTop, coordsS.vWidth, coordsS.vHeight, coordsS.vLeft, coordsS.vTop, coordsS.bWidth, coordsS.bHeight, coordsS.bLeft, coordsS.bTop, coordsS.cRotation);

				// Sync navigator rectangle if visible.
				var navComparison = (vpID == 0) ? Z.Navigator2 : Z.Navigator;
				if (navComparison) {
					if (Z.zooming != 'stop') {
						navComparison.syncToViewport();
					} else {
						var constrainedPt = new Z.Utils.Point(parseFloat(coordsS.cLeft), parseFloat(coordsS.cTop));
						var currentCenterPt = vpComparison.calculateCurrentCenterCoordinates(constrainedPt, Z.imageZ, Z.imageR);
						navComparison.syncNavigatorRectangleToViewport(currentCenterPt);
					}
				}
			}
		}
	}

	// -1 restriction and vpIDCalling condition below prevent top and current VPs each from resetting themselves in loop.
	this.syncOverlayViewports = function (updateView, vpIDCalling) {
		var topVP = Z['Viewport' + (Z.imageSetLength - 1).toString()];
		if (Z.overlays && topVP && topVP.getStatus('initializedViewport')) {
			if (updateView) {
				var currCoordsFull = topVP.getCoordinatesFull(true);
				for (var i = 0, j = Z.imageSetLength - 1; i < j; i++) {
					if (vpIDCalling != i) { Z['Viewport' + i.toString()].setView(currCoordsFull.x, currCoordsFull.y, currCoordsFull.z, currCoordsFull.r, null, null); }
				}
			} else {
				var coordsS = topVP.getCoordinatesDisplayFull();
				for (var i = 0, j = Z.imageSetLength - 1; i < j; i++) {
					Z['Viewport' + i.toString()].setViewNoUpdate(coordsS.cLeft, coordsS.cTop, coordsS.vWidth, coordsS.vHeight, coordsS.vLeft, coordsS.vTop, coordsS.bWidth, coordsS.bHeight, coordsS.bLeft, coordsS.bTop, coordsS.cRotation);
				}
			}
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::: IMAGESET FUNCTIONS :::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Parse slide stack list.
	this.parseImageSetXML = function (xmlDoc, imageSetType) {
		// Clear any prior values.
		Z.Utils.arrayClear(imageSetObjects);
		Z.Utils.arrayClear(imageSetListDP);

		// Parse display setup information.
		Z.imageSetListPosition = Z.Utils.getResource('DEFAULT_IMAGESETLISTPOSITION');
		var imageSetListSource = Z.Utils.getResource('DEFAULT_IMAGESETLISTSOURCE');
		Z.imageSetListTitle = Z.Utils.getResource('UI_IMAGESETLISTTITLE');
		Z.imageSetStart = parseInt(Z.Utils.getResource('UI_IMAGESETSTART'), 10);
		Z.imageSetLoop = (Z.Utils.getResource('UI_IMAGESETLOOP') == '1');
		Z.sliderImageSetVisible = (Z.Utils.getResource('UI_IMAGESETSLIDER') == '1');

		var imageSetSetup = xmlDoc.getElementsByTagName('SETUP')[0];
		if (imageSetSetup) {
			var listPosition = imageSetSetup.getAttribute('CHOICELIST');
			if (Z.Utils.stringValidate(listPosition)) { Z.imageSetListPosition = listPosition; }
			var listSource = imageSetSetup.getAttribute('LISTSOURCE');
			if (Z.Utils.stringValidate(listSource)) { imageSetListSource = listSource; }
			var listTitle = imageSetSetup.getAttribute('LISTTITLE');
			if (Z.Utils.stringValidate(listTitle)) { Z.imageSetListTitle = listTitle; }

			var hotspotPath = imageSetSetup.getAttribute('HOTSPOTPATH');
			if (Z.Utils.stringValidate(hotspotPath)) {
				Z.imageSetHotspotPath = hotspotPath;
				Z.hotspotFileShared = true;
			}
			var annotationPath = imageSetSetup.getAttribute('ANNOTATIONPATH');
			if (Z.Utils.stringValidate(annotationPath)) {
				Z.imageSetAnnotationPath = annotationPath;
				Z.annotationFileShared = true;
			}
			var trackingPath = imageSetSetup.getAttribute('TRACKINGPATH');
			if (Z.Utils.stringValidate(trackingPath)) {
				Z.imageSetTrackingPath = trackingPath;
				Z.trackingFileShared = true;
			}
			var imageListPath = imageSetSetup.getAttribute('IMAGELISTPATH');
			if (Z.Utils.stringValidate(imageListPath)) {
				Z.imageSetImageListPath = imageListPath;
				Z.imageListFileShared = true;
			}

			var start = imageSetSetup.getAttribute('START');
			if (Z.Utils.stringValidate(start)) { Z.imageSetStart = parseInt(start, 10) - 1; }
			var loop = imageSetSetup.getAttribute('LOOP');
			if (Z.Utils.stringValidate(loop)) { Z.imageSetLoop = (loop == '1'); }
			var slider = imageSetSetup.getAttribute('SLIDER');
			if (Z.Utils.stringValidate(slider)) { Z.sliderImageSetVisible = (slider == '1'); }

			if (Z.overlays) {
				var initialVisibility = imageSetSetup.getAttribute('INITIALVISIBILITY');
				Z.overlaysInitialVisibility = (Z.Utils.stringValidate(initialVisibility)) ? (initialVisibility == '1' || initialVisibility == 'true') : (Z.Utils.getResource('DEFAULT_OVERLAYSVISIBLE') == '1');
			}
			if (Z.animation) {
				var animationAxis = imageSetSetup.getAttribute('AXIS');
				Z.animationAxis = (Z.Utils.stringValidate(animationAxis)) ? animationAxis : (Z.animationAxis !== null) ? Z.animationAxis : Z.Utils.getResource('DEFAULT_ANIMATIONAXIS');
				var animator = imageSetSetup.getAttribute('ANIMATOR');
				Z.animator = (Z.Utils.stringValidate(animator)) ? animator : (Z.animator !== null) ? Z.animator : Z.Utils.getResource('DEFAULT_ANIMATOR');
				var animationFlip = imageSetSetup.getAttribute('FLIP');
				Z.animationFlip = (Z.Utils.stringValidate(animationFlip)) ? (animationFlip == '1') : (Z.animationFlip !== null) ? Z.animationFlip : (Z.Utils.getResource('DEFAULT_ANIMATIONFLIP') == '1');
			}
			if (Z.comparison) {
				Z.initialSync = (Z.Utils.getResource('DEFAULT_COMPARISONINITIALSYNC') == '1');
				Z.syncComparison = (Z.Utils.getResource('DEFAULT_COMPARISONSYNC') == '1');
				var initSync = imageSetSetup.getAttribute('INITIALSYNC');
				if (Z.Utils.stringValidate(initSync)) {
					Z.initialSync = (initSync == '1');
					if (!Z.initialSync) { Z.syncComparison = false; }
				}
				var syncVis = imageSetSetup.getAttribute('SYNCVISIBLE');
				Z.syncVisible = (Z.Utils.stringValidate(syncVis)) ? (syncVis == '1') : (Z.Utils.getResource('DEFAULT_COMPARISONSYNCVISIBLE') == '1');
			}

		}

		// If creating overlays and image path used for base image, insert as node in imageSetNodes.
		if (Z.overlays) {
			var newNode = xmlDoc.createElement("OVERLAY");
			newNode.setAttribute('MEDIA', Z.imagePath);
			newNode.setAttribute('NAME', 'Base Image');
			var imageSetNodes = xmlDoc.getElementsByTagName('OVERLAY');
			var root = xmlDoc.documentElement;
			root.insertBefore(newNode, imageSetNodes[0]);
		}

		// Get values for individual images/slides/overlays.
		var imageSetNodeName = (imageSetType == 'animation' || imageSetType == 'comparison') ? 'IMAGE' : (imageSetType == 'overlay') ? 'OVERLAY' : 'SLIDE';
		var imageSetNodes = xmlDoc.getElementsByTagName(imageSetNodeName);

		// Parse values for individual images/slides/overlays.
		for (var i = 0, j = imageSetNodes.length; i < j; i++) {
			var imageObj = new ImageSetObject(imageSetNodes[i], i);
			imageSetObjects[imageSetObjects.length] = imageObj;
			var imageSetListText = (imageSetListSource == 'NAME') ? imageObj.name : imageObj.media.substring(imageObj.media.lastIndexOf("/")+1, imageObj.media.length);
			imageSetListDP[imageSetListDP.length] = { text:imageSetListText, value:imageObj.internalID };
		}

		// Reverse/invert array order if flip parameter set in HTML or XML (XML overrides HTML).
		if (Z.animationFlip) {
			imageSetObjects.reverse();
			imageSetListDP.reverse();
		}

		// Remove initial sync if viewport intial settings do not match.
		if (Z.comparison) {
			var img0 = imageSetObjects[0];
			var img1 = imageSetObjects[1];
			if (img0.initialX != img1.initialX || img0.initialY != img1.initialY || img0.initialZoom != img1.initialZoom || img0.minX != img1.minX || img0.maxX != img1.maxX) {
				Z.initialSync = false;
			}
		}

		// Set slide count global to Viewer, create image set choice list, create Viewports.
		Z.imageSetLength = imageSetObjects.length;
		if (!Z.comparison && !Z.overlays) { createImageSetChoiceList(Z.imageSetListPosition, Z.imageSetListTitle, imageSetListDP); }
		configureViewerMultipleViewports(imageSetObjects);
	}

	function configureViewerMultipleViewports (imageSetMediaList) {
		Z.imagePath = 'multiple';
		if (Z.tileSourceMultiple) { Z.Utils.validateImagePath(imageSetMediaList[0].media); }

		function viewerReadyMultipleViewportsCallbackFunction () {
			Z.clearCallback('readyViewer', viewerReadyMultipleViewportsCallbackFunction);
			Z.viewportCurrent = Z.Viewport0; // Sets prior viewport.

			// If using overlays set start and current viewport as top viewport.
			if (Z.overlays) { Z.imageSetStart = Z.imageSetLength - 1; }
			self.viewportSelect(Z.imageSetStart);
		}
		Z.setCallback('readyViewer', viewerReadyMultipleViewportsCallbackFunction);

		for (var i = 0, j = imageSetMediaList.length; i < j; i++) {
			var hotspotPath = (Z.hotspotFileShared) ? Z.imageSetHotspotPath :  imageSetMediaList[i].hotspotPath;
			var annotationPath = (Z.annotationFileShared) ? Z.imageSetAnnotationPath :  imageSetMediaList[i].annotationPath;
			var trackingPath = (Z.trackingFileShared) ? Z.imageSetTrackingPath :  imageSetMediaList[i].trackingPath;
			var imageListPath = (Z.imageListFileShared) ? Z.imageSetImageListPath :  imageSetMediaList[i].imageListPath;

			Z['Viewport' + i.toString()] = new Z.ZoomifyViewport(i, imageSetMediaList[i].media, annotationPath, hotspotPath, trackingPath, imageListPath);
			var isStartVP = (i == Z.imageSetStart);
			if (isStartVP) {
				Z.viewportCurrent = Z['Viewport' + i.toString()];
				self.viewportSelect(Z.imageSetStart);
			}
			Z['Viewport' + i.toString()].setVisibility(isStartVP || Z.comparison || Z.overlays);
		}

		// Debug option: console.log(imageSetMediaList[i].media + "  " + imageSetMediaList[i].annotationPath);
	}

	precacheBackfillTilesDelayed = function () {
		for (var i = 0, j = Z.imageSetLength; i < j; i++) {
			var vpTest = Z['Viewport' + i.toString()];
			if (!vpTest.getStatus('backfillPrecachedViewport')) {
				vpTest.precacheBackfillTiles(true);
			}
		}
	}

	this.viewportChange = function (direction) {
		if (direction != 'stop') {
			if (direction == 'forward') {
				Z.Viewer.viewportNext();
			} else {
				Z.Viewer.viewportPrior();
			}

			// Iterate change if animation, not if slidestack.
			if (Z.animation) {
				Z.viewportChangeTimeout = window.setTimeout( function () { Z.Viewer.viewportChange(direction); }, 10);
			}

		} else if (Z.viewportChangeTimeout) {
			window.clearTimeout(Z.viewportChangeTimeout);
			Z.viewportChangeTimeout = null;
		}
	}

	this.viewportPrior = function (skipFrames) {
		if (typeof skipFrames === 'undefined' || skipFrames === null) {
			skipFrames = 0;
		} else {
			skipFrames = Math.round(skipFrames); // Change more than one frame.
		}
		var vpIDMax = Z.imageSetLength - 1;
		var vpIDTest = Z.viewportCurrentID - (1 - skipFrames);
		if (vpIDTest < 0) {
			if (!Z.imageSetLoop) {
				vpIDTest = 0;
			} else {
				if (vpIDTest < -vpIDMax) { vpIDTest = -(-vpIDTest % vpIDMax); }
				if (vpIDTest < 0) { vpIDTest += (vpIDMax + 1); }
			}
		}
		self.viewportSelect(vpIDTest);
	}

	this.viewportNext = function (skipFrames) {
		if (typeof skipFrames === 'undefined' || skipFrames === null) {
			skipFrames = 0;
		} else {
			skipFrames = Math.round(skipFrames); // Change more than one frame.
		}
		var vpIDMax = Z.imageSetLength - 1;
		var vpIDTest = Z.viewportCurrentID + (1 + skipFrames);
		if (vpIDTest > vpIDMax) {
			if (!Z.imageSetLoop) {
				vpIDTest = vpIDMax;
			} else {
				vpIDTest = (vpIDTest % (vpIDMax + 1));
			}
		}
		self.viewportSelect(vpIDTest);
	}

	// Sync of imageSet slider is prevented in calls from slider by second parameter to prevent circular calls.
	this.viewportSelect = function (vpID, doNotSyncSlider) {
		var userInteracting = Z.mouseIsDown || Z.buttonIsDown || Z.keyIsDown;
		var initializingCall = (Z.Viewport === null);

		// Get new current viewport.
		if (typeof vpID === 'undefined' || vpID === null) { vpID = 0; }
		var vpID = Math.abs(vpID);

		// Permit selection if changing viewport or if initializing.
		if (vpID != Z.viewportCurrentID || !userInteracting) {

			var vpIDStr = vpID.toString();
			var vpTest = Z['Viewport' + vpIDStr];
			var repeatCall = (vpTest == Z.viewportCurrent);

			// Set current viewport if target Viewport is valid and is not already current or this is first time setting current.
			if (typeof vpTest !== 'undefined' && (!repeatCall || initializingCall || !userInteracting)) {

				// Record prior viewport.
				var vpIDStrPrior = Z.viewportCurrentID.toString();
				var viewportPrior = Z.viewportCurrent;

				// Set new current viewport.
				Z.viewportCurrent = vpTest;
				Z.viewportCurrentID = vpID
				if (!Z.comparison) { Z.viewportCurrent.setVisibility(true); }
				Z.Viewport = Z.viewportCurrent;  // Support references in other functions not modified for ImageSet support.
				if (!repeatCall && !Z.comparison && !Z.overlays) {
					// Hide prior viewport if animation. If slidestack, move behind current viewport.
					viewportPrior.setVisibility(false);
				}

				Z.Utils.validateCallback('viewportChanged');

				if (Z.comparison && Z.Viewport0 && Z.Viewport1) {
					var vpElement0 = document.getElementById('viewportContainer0');
					var vpElement1 = document.getElementById('viewportContainer1');
					Z.Utils.swapZIndices(vpElement0, vpElement1);
					setNavigatorCurrent(vpID);
				}

				// Alternative implementation: Finish precaching here for animations but in function viewerReadyCallbackFunction for slidestacks.
				/*if (Z.animation && Z.viewportCurrentID != Z.imageSetStart && !Z.viewportCurrent.getStatus('backfillPrecachedViewport')) {
					Z.viewportCurrent.precacheBackfillTiles(true);
				}*/

				// Synchronize new current viewport and viewer components.
				if (Z.viewportCurrent && Z.viewportCurrent.getStatus('initializedViewport')) {

					var viewportResized = (Z.viewportCurrent.getViewW() != Z.viewerW || Z.viewportCurrent.getViewH() != Z.viewerH);
					if (!Z.comparison) {
						if (viewportResized) {
							Z.viewportCurrent.syncViewportResize(Z.imageX, Z.imageY, Z.imageZ, Z.imageR);
						} else {
							if (Z.imageR != 0) {
								Z.viewportCurrent.rotateStep(Z.imageR, false, true);
							}
							Z.viewportCurrent.updateView(true);
						}
					}
					if (viewportPrior && (Z.hotspotFileShared || Z.annotationFileShared)) {
						var hotsArr = viewportPrior.getHotspots();
						if (hotsArr) { Z.viewportCurrent.setHotspots(hotsArr); }
					}
					// Dev Note: next line permits reset to link Navigator at top VP but setViewport function prevents change of thumbnail from base VP to top VP.
					if (!Z.comparison && Z.Navigator && Z.Navigator.getInitialized() && Z.navigatorVisible > 0) {
						Z.Navigator.setViewport(Z.viewportCurrent);
					}
					if (!Z.comparison && Z.Gallery && Z.Gallery.getInitialized() && Z.galleryVisible > 0) {
						Z.Gallery.setViewport(Z.viewportCurrent);
						Z.Gallery.syncGalleryToViewport(slideCurrentInList);
					}
					if (Z.Toolbar && Z.Toolbar.getInitialized()) {
						if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
							if (!Z.comparison && (typeof doNotSyncSlider === 'undefined' || doNotSyncSlider === null || !doNotSyncSlider)) {
								Z.Toolbar.syncSliderToViewportImageSet(Z.viewportCurrentID);
							}
							Z.Toolbar.setViewport(Z.viewportCurrent);
						}
						if (Z.annotationFileShared) {
							var labelID = viewportPrior.getCurrentLabel().internalID;
							Z.viewportCurrent.setCurrentLabel(labelID, true);
							Z.viewportCurrent.setEditModeLabel(Z.labelMode, true, null, true);
						}
						if (Z.annotationPanelVisibleState) {
							if (Z.annotationFileShared) {
								Z.Toolbar.setVisibilityAnnotationPanel(true, '0');
							} else {
								Z.Toolbar.setVisibilityAnnotationPanel(false, vpIDStrPrior);
								Z.Toolbar.setVisibilityAnnotationPanel(true, vpIDStr);
							}
						}
						if (Z.trackingPanelVisibleState) {
							if (Z.trackingFileShared) {
								Z.Toolbar.setVisibilityTrackingPanel(true, '0');
							} else {
								Z.Toolbar.setVisibilityTrackingPanel(false, vpIDStrPrior);
								Z.Toolbar.setVisibilityTrackingPanel(true, vpIDStr);
							}
						}
						if (Z.userPanelVisibleState) {
							Z.Toolbar.setVisibilityUserPanel(false);
							Z.Toolbar.setVisibilityUserPanel(true);
						}
					}
					if (Z.hotspots) {
						setVisibilityHotspotChoiceList(false, vpIDStrPrior);
						setVisibilityHotspotChoiceList(true, vpIDStr);
					}
					if (imageSetList) {
						imageSetList.blur();
						var indexTitleAdjust = (Z.Utils.stringValidate(Z.imageSetListTitle) && Z.imageSetListTitle != 'none') ? 1 : 0;
						imageSetList.selectedIndex = Z.viewportCurrentID + indexTitleAdjust;
					}
				}
			}
		}
	}

	function setNavigatorCurrent (vpID) {
		if (Z.Navigator) { Z.Navigator.setSelected(vpID == 0); }
		if (Z.Navigator2) { Z.Navigator2.setSelected(vpID == 1); }
	}

	this.setVisibilityHotspotChoiceList = function (visible, vpIDs) {
		setVisibilityHotspotChoiceList(visible, vpIDs);
	}

	function setVisibilityHotspotChoiceList (visible, vpIDs) {
		if (typeof vpIDs === 'undefined' || vpIDs === null) { vpIDs = '0'; }
		var hotspotList = document.getElementById('HotspotList' + vpIDs);
		if (hotspotList) {
			var visValue = (visible) ? 'visible' : 'hidden';
			hotspotList.style.visibility = visValue;
		}
	}

	function ImageSetObject (imageSetNode, id) {
		this.id = imageSetNode.getAttribute('ID');
		this.name = imageSetNode.getAttribute('NAME');
		this.internalID = id;
		this.media = imageSetNode.getAttribute('MEDIA'); // This is a path.
		this.imageListPath = imageSetNode.getAttribute("IMAGELIST");
		this.hotspotPath = imageSetNode.getAttribute("HOTSPOTPATH");
		this.annotationPath = imageSetNode.getAttribute("ANNOTATIONPATH");
		this.trackingPath = imageSetNode.getAttribute("TRACKINGPATH");

		this.initialX = imageSetNode.getAttribute('INITIALX');
		this.initialY = imageSetNode.getAttribute('INITIALY');
		this.initialZoom = imageSetNode.getAttribute('INITIALZOOM');
		this.minZoom = imageSetNode.getAttribute('MINZOOM');
		this.maxZoom = imageSetNode.getAttribute('MAXZOOM');
	}

	function createImageSetChoiceList (position, title, dataProvider) {
		var visible = (position == '0') ? 'hidden' : 'visible';
		var listW = parseInt(Z.Utils.getResource('DEFAULT_IMAGESETLISTWIDTH'), 10);
		var listCoords = getImageSetListCoords(position, listW, Z.viewerW, Z.viewerH); // Z.viewerW allows for toolbar height if static in viewer display area.

		// Create choice list and add to viewer.
		if (typeof imageSetList === 'undefined' || imageSetList === null) {
			imageSetList = new Z.Utils.createSelectElement('imageSetList', title, dataProvider, listW, listCoords.x, listCoords.y, null, visible, imageSetListChangeHandler, 'change');
			Z.ViewerDisplay.appendChild(imageSetList);
			var indexTitleAdjust = (Z.Utils.stringValidate(Z.imageSetListTitle) && Z.imageSetListTitle != 'none') ? 1 : 0;
			imageSetList.selectedIndex = indexTitleAdjust;
		} else {
			Z.Utils.arrayClear(dataProvider);
		}

		// Ensure proper z-ordering of Viewer elements.
		imageSetList.style.zIndex = (Z.baseZIndex + 24).toString();
	}

	function getImageSetListCoords (position, listW, viewerW, viewerH) {
		//ImageSet list positioning: 0 hides, 1 top left, 2 top-right, 3 bottom right, 4 bottom left
		var listX, listY;
		var margin = 15;
		switch (position) {
			case '0':
				listX = -1000;
				listY = -1000;
				break;
			case '1':
				listX = margin;
				listY = margin;
				break;
			case '2':
				listX = viewerW - listW - margin + 2;
				listY = margin - 5;
				break;
			case '3':
				listX = viewerW - listW - margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			case '4':
				listX = margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			default:
				listX = viewerW - listW;
				listY = margin;
		}
		return new Z.Utils.Point(listX, listY);
	}

	this.sizeAndPositionImageSetList = function () {
		if (imageSetList) {
			var listW = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELWIDTH'), 10) + 2;
			if (Z.editMode == 'markup') {
				listW -= 20;
				imageSetList.style.width = listW + 'px';
			}
			var listCoords = getImageSetListCoords(Z.imageSetListPosition, listW, Z.viewerW, Z.viewerH); // Z.viewerW allows for toolbar height if static in viewer display area.
			imageSetList.style.left = listCoords.x + 'px';
			imageSetList.style.top = listCoords.y + 'px';
		}
	}

	function imageSetListChangeHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			if (target.options[target.selectedIndex].value != 'null') {
				var indexTitleAdjust = (Z.Utils.stringValidate(Z.imageSetListTitle) && Z.imageSetListTitle != 'none') ? 1 : 0;
				self.viewportSelect(target.selectedIndex - indexTitleAdjust);
			}
		}
	}

	this.setVisibilityImageSetChoiceList = function (visible) {
		setVisibilityImageSetChoiceList(visible);
	}

	function setVisibilityImageSetChoiceList (visible) {
		var imageSetList = document.getElementById('imageSetList');
		if (imageSetList) {
			var visValue = (visible) ? 'visible' : 'hidden';
			imageSetList.style.visibility = visValue;
		}
	}

	// Set toolbar imageSet slider button position.
	this.syncToolbarImageSetSliderToViewport = function (imageSetSlide) {
		if (Z.ToolbarDisplay && Z.Toolbar.getInitialized() && Z.imageSet && Z.sliderImageSetVisible) {
			var vpCurrent = Z['Viewport' + imageSetSlide];
			var currentZ = vpCurrent.getZoom();
			Z.Toolbar.syncSliderToViewportZoom(currentZ);
		}
	}

	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::: EVENT FUNCTIONS ::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Handle keyboard, mouse, mousewheel, and touch events that are not Viewport-specific.
	// Mousewheel handler added here plus DOMMouseScroll added in addEventListener function.
	function initializeViewerEventListeners () {
		self.initializeViewerKeyEventListeners(true);
		Z.Utils.addEventListener(Z.ViewerDisplay, 'mouseover', viewerEventsHandler);
		Z.Utils.addEventListener(Z.ViewerDisplay, 'mouseout', viewerEventsHandler);
		Z.Utils.addEventListener(Z.ViewerDisplay, 'mousemove', Z.Utils.preventDefault);
		Z.Utils.addEventListener(Z.ViewerDisplay, 'mousewheel', viewerEventsHandler);
		Z.Utils.addEventListener(Z.ViewerDisplay, 'mousewheel', Z.Utils.preventDefault);
		initializeOrientationChangeHandler();
		if (Z.autoResize) { Z.Utils.addEventListener(window, 'resize', Z.Viewer.viewerEventsHandler); }

		// If tracking, prevent arrow keys from scrolling page because arrow keys are used for guided navigation by cell increments.
		if (Z.tracking) { Z.Viewer.initializeViewerKeyDefaultListeners(true); }

		// DEV NOTE: The following line prevents click-drag out of Viewer from selecting external text
		// in Safari, however, it disables all lists (hotspot, tour, slide, label). Working on alternative.
		// Z.Utils.addEventListener(Z.ViewerDisplay, 'mousedown', Z.Utils.preventDefault);
	}

	// The following handler assignment approach is necessary for iOS to properly respond. The test for a necessary
	// delay is required because Safari does not have access to the body tag when JavaScript in the head tag is loading.
	function initializeOrientationChangeHandler () {
		if (document.getElementsByTagName('body')) {
			document.getElementsByTagName('body')[0].onorientationchange = orientationChangeHandler;
		} else {
			var bodyOrientationHandlerTimer = window.setTimeout(initializeOrientationChangeHandler, 100);
		}
	}

	function orientationChangeHandler (event) {
		if (!Z.interactive) { return; }
		if (Z.fullView) {
			if (Z.Toolbar) {
				if (Z.toolbarAutoShowHide) { Z.Toolbar.show(false); }
				if (Z.annotations && (Z.annotationPanelVisible == 2 || Z.annotationPanelVisible == 3)) { Z.Toolbar.setVisibilityAnnotationPanel(false); }
				if (Z.tracking && (Z.trackingPanelVisible == 2 || Z.trackingPanelVisible == 3)) { Z.Toolbar.setVisibilityTrackingPanel(false); }
				if (Z.userPanelVisible == 2 || Z.trackingPanelVisible == 3) { Z.Toolbar.setVisibilityUserPanel(false); }
			}
			if (Z.Navigator && Z.navigatorVisible > 1) {
				Z.Navigator.setVisibility(false);
				if (Z.comparison && Z.Navigator2) { Z.Navigator2.setVisibility(false); }
			}
			if (Z.Gallery && Z.galleryAutoShowHide) { Z.Gallery.setVisibility(false); }

			if (Z.Viewport) {
				Z.Viewport.toggleFullViewMode(false);
				Z.Viewport.toggleFullViewMode(true);
			}

			if (Z.Gallery && Z.galleryAutoShowHide) { Z.Gallery.setVisibility(true); }
			if (Z.Navigator && Z.navigatorVisible > 1) {
				Z.Navigator.setVisibility(true);
				if (Z.comparison && Z.Navigator2) { Z.Navigator2.setVisibility(true); }
			}
			if (Z.Toolbar) {
				if (Z.annotations && (Z.annotationPanelVisible == 2 || Z.annotationPanelVisible == 3)) { Z.Toolbar.setVisibilityAnnotationPanel(true); }
				if (Z.tracking && (Z.trackingPanelVisible == 2 || Z.trackingPanelVisible == 3)) { Z.Toolbar.setVisibilityTrackingPanel(true); }
				if (Z.userPanelVisible == 2 || Z.trackingPanelVisible == 3) { Z.Toolbar.setVisibilityUserPanel(true); }
				if (Z.toolbarAutoShowHide) { Z.Toolbar.show(true); }
			}
		}
	}

	this.initializeViewerKeyEventListeners = function (enable) {
		if (enable) {
			Z.Utils.addEventListener(document, 'keydown', keyEventsHandler);
			Z.Utils.addEventListener(document, 'keyup', keyEventsHandler);
		} else {
			Z.Utils.removeEventListener(document, 'keydown', keyEventsHandler);
			Z.Utils.removeEventListener(document, 'keyup', keyEventsHandler);
		}
	}

	function keyEventsHandler (event) {
		// Disallow keyboard control if parameters require or if focus is on text field, in Viewer (annotation panel) or in page.
		if (!Z.interactive || !Z.keys || document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
			return;
		}

		var event = Z.Utils.event(event);
		var isAltKey = event.altKey;

		// Prevent conflicting zoom-and-pan function calls. Must not react to alt key release
		// in order to support alt-click zoom-to-100 and alt-dbl-click zoom-to-zoom-to-fit features.
		if (event.keyCode != 18 && !event.altKey) {
			Z.viewportCurrent.zoomAndPanAllStop(true, true);
			if (Z.maskingSelection) { Z.viewportCurrent.clearLabelMask(); }
		}

		// Handle key events.
		if (event) {
			var eventType = event.type;
			var kc = event.keyCode;
			if (eventType == 'keydown') {
				Z.keyIsDown = true;
				switch (kc) {
					case 90: // z
						Z.viewportCurrent.zoom('out');
						break;
					case 17: // control
						Z.viewportCurrent.zoom('out');
						break;
					case 65: // a
						Z.viewportCurrent.zoom('in');
						break;
					case 16: // shift
						Z.viewportCurrent.zoom('in');
						break;
					case 37: // left arrow
						if (!Z.tracking && !Z.animation || Z.viewportCurrent.getZoom() != Z.minZ) {
							Z.viewportCurrent.pan('left');
						} else if (Z.imageSet)  {
							self.viewportPrior();
						}
						break;
					case 38: // up arrow
						if (!Z.tracking && !Z.animation || Z.viewportCurrent.getZoom() != Z.minZ) {
							Z.viewportCurrent.pan('up');
						} else if (Z.imageSet)  {
							self.viewportNext();
						}
						break;
					case 40: // down arrow
						if (!Z.tracking && !Z.animation || Z.viewportCurrent.getZoom() != Z.minZ) {
							Z.viewportCurrent.pan('down');
						} else if (Z.imageSet) {
							self.viewportPrior();
						}
						break;
					case 39: // right arrow
						if (!Z.tracking && !Z.animation || Z.viewportCurrent.getZoom() != Z.minZ) {
							Z.viewportCurrent.pan('right');
						} else if (Z.imageSet) {
							self.viewportNext();
						}
						break;
					case 27: // escape
						if (!Z.fullView) {
							Z.viewportCurrent.reset();
						} else {
							Z.viewportCurrent.toggleFullViewMode(false);
						}
						break;
					case 190: // '>' ('.')
						if (Z.rotationVisible) { Z.viewportCurrent.rotate('clockwise', isAltKey); }
						break;
					case 188: // '<'  (',')
						if (Z.rotationVisible) { Z.viewportCurrent.rotate('counterwise', isAltKey); }
						break;

					case 33: // page up
						 if (Z.imageSet && !Z.overlays) { self.viewportNext(); }
						break;
					case 34: // page down
						 if (Z.imageSet && !Z.overlays) { self.viewportPrior(); }
						break;
				}

				if (Z.imageSet && (kc == 33 || kc == 34)) {
					if (event.preventDefault) {
						event.preventDefault();
					} else {
						event.returnValue = false;
					}
				}

			} else if (eventType == 'keyup') {
				Z.keyIsDown = false;
				if (kc == 90 || kc == 17 || kc == 65 || kc == 16) {  // z, ctrl, a, and shift keys
					Z.viewportCurrent.zoom('stop');
				} else if (kc == 37 || kc == 39 || kc == 38 || kc == 40) {  // Arrow keys
					if (!Z.tracking) {
						if (kc == 37 || kc == 39) {
							Z.viewportCurrent.pan('horizontalStop');
						} else if (kc == 38 || kc == 40) {
							Z.viewportCurrent.pan('verticalStop');
						}
					} else {
						if (kc == 37) {
							Z.viewportCurrent.goToNextCell('left');
						} else if (kc == 39) {
							Z.viewportCurrent.goToNextCell('right');
						} else if (kc == 38) {
							Z.viewportCurrent.goToNextCell('up');
						} else if (kc == 40) {
							Z.viewportCurrent.goToNextCell('down');
						}
					}
				} else if (Z.rotationVisible && (kc == 190 || kc == 188)) {
					Z.viewportCurrent.rotate('stop');
				} else if (Z.imageSet && (kc == 33 || kc == 34)) { // page up and page down keys.
					if (Z.imageSet) { Z.viewportCurrent.updateView(true); }
					if (event.preventDefault) {
						event.preventDefault();
					} else {
						event.returnValue = false;
					}
				}
			}
		}
	}

	this.initializeViewerKeyDefaultListeners = function (enable) {
		if (enable) {
			Z.Utils.addEventListener(document, 'keydown', Z.Utils.preventDefault);
			Z.Utils.addEventListener(document, 'keyup', Z.Utils.preventDefault);
		} else {
			Z.Utils.removeEventListener(document, 'keydown', Z.Utils.preventDefault);
			Z.Utils.removeEventListener(document, 'keyup', Z.Utils.preventDefault);
		}
	}

	this.viewerEventsHandler = function (event) {
		viewerEventsHandler(event);
	}

	function viewerEventsHandler (event) {
		// Handle all display events in this central event broker.
		var event = Z.Utils.event(event);
		var eventType = event.type;
		if (event && eventType) {
			var isRightMouseBtn = Z.Utils.isRightMouseButton(event);
			var isAltKey = event.altKey;

			// Prevent unwanted effects: interactivity or mouse-panning if parameters specify, zoom on right-click,
			// and page dragging in touch contexts. DEV NOTE: Timeout in next line is placeholder workaround for hotspot icon and caption anchor failure in IE.
			if ((eventType != 'mouseover' && eventType != 'mouseout' && !Z.interactive)
				|| (eventType == 'mousedown' && (!Z.interactive || (Z.coordinatesVisible && isAltKey)))
				|| isRightMouseBtn) { return; }
			if (Z.touchSupport && !Z.clickZoomAndPanBlock && eventType != 'touchmove' && eventType != 'gesturechange') {
				event.preventDefault();
			}

			// Handle event resetting.
			switch(eventType) {
				case 'mouseover' :
					// Prevent page scrolling using arrow keys. Also implemented in text element blur handler.
					if (!Z.fullView && document.activeElement.tagName != 'TEXTAREA') {
						Z.Viewer.initializeViewerKeyDefaultListeners(true);
					}
					break;
				case 'mouseout' :
					// If not tracking, disable prevention of page scrolling due to arrow keys. Also occurs in text element focus handler.
					if (!Z.tracking) { Z.Viewer.initializeViewerKeyDefaultListeners(false); }
					// Alternative implementation: Disable key interaction if mouse is not over viewer.
					//Z.Viewer.initializeViewerKeyEventListeners(false);
					break;
			}

			// Handle event actions.
			viewerEventsManager(event);

			if (eventType == 'mousedown' || eventType == 'mousemove') { return false; }
		}
	}

	function viewerEventsManager (event) {
		var event = Z.Utils.event(event);
		var eventType = event.type;
		if (event && eventType) {

			var touch, target, relatedTarget, mPt;
			target = Z.Utils.target(event);
			relatedTarget = Z.Utils.relatedTarget(event);
			if (eventType != 'resize') { mPt = Z.Utils.getMousePosition(event); }
			var isAltKey = event.altKey;

			// Standardize Firefox mouse wheel event.
			if (eventType == 'DOMMouseScroll') { eventType = 'mousewheel'; }

			// Implement actions.
			switch(eventType) {
				case 'mouseover' :
					// Block if moving within viewer display or subelements.
					var targetIsInViewer = Z.Utils.nodeIsInViewer(target);
					var relatedTargetIsInViewer = Z.Utils.nodeIsInViewer(relatedTarget);
					if (!(targetIsInViewer && relatedTargetIsInViewer)) {
						// Mouse-over bubbles from navigator or toolbar blocked by stop propagation handlers. Mouse-overs not
						// needed on return from outside viewer as components would be hidden if toolbar mode enables hiding.
						if (Z.viewportCurrent) { Z.viewportCurrent.showLists(true); }
						if (Z.ToolbarDisplay && Z.toolbarAutoShowHide) { Z.Toolbar.show(true); }
						if (Z.Navigator && Z.navigatorVisible > 1) {
							Z.Navigator.setVisibility(true);
							if (Z.comparison && Z.Navigator2) { Z.Navigator2.setVisibility(true); }
						}
						if (Z.Gallery && Z.galleryAutoShowHide) { Z.Gallery.setVisibility(true); }
						if (Z.Ruler && Z.rulerVisible > 1) { Z.Ruler.setVisibility(true); }
						if (Z.Toolbar) {
							if (Z.annotations && (Z.annotationPanelVisible == 2 || Z.annotationPanelVisible == 3)) { Z.Toolbar.setVisibilityAnnotationPanel(true); }
							if (Z.tracking && (Z.trackingPanelVisible == 2 || Z.trackingPanelVisible == 3)) { Z.Toolbar.setVisibilityTrackingPanel(true); }
							if (Z.userPanelVisible == 2 || Z.trackingPanelVisible == 3) { Z.Toolbar.setVisibilityUserPanel(true); }
						}
						Z.mouseOutDownPoint = null;
					}
					break;

				case 'mouseout' :
					var targetIsInViewer = Z.Utils.nodeIsInViewer(target);
					var relatedTargetIsInViewer = Z.Utils.nodeIsInViewer(relatedTarget);
					var listNavigation = (target == '[object HTMLSelectElement]' || target == '[object HTMLOptionElement]' || relatedTarget == '[object HTMLSelectElement]' || relatedTarget == '[object HTMLOptionElement]');

					// Block if moving within viewer display or subelements.
					if (!(targetIsInViewer && relatedTargetIsInViewer) && !listNavigation) {

						if (!Z.mouseIsDown) {
							if (Z.viewportCurrent) { Z.viewportCurrent.showLists(false); }
							if (Z.ToolbarDisplay && Z.toolbarAutoShowHide) { Z.Toolbar.show(false); }
							if (Z.Navigator && Z.navigatorVisible > 1) {
								Z.Navigator.setVisibility(false);
								if (Z.comparison && Z.Navigator2) { Z.Navigator2.setVisibility(false); }
							}
							if (Z.Gallery && Z.galleryAutoShowHide) { Z.Gallery.setVisibility(false); }
							if (Z.Ruler && Z.rulerVisible > 1) { Z.Ruler.setVisibility(false); }
							if (Z.Toolbar) {
								if (Z.annotations && (Z.annotationPanelVisible == 2 || Z.annotationPanelVisible == 3)) { Z.Toolbar.setVisibilityAnnotationPanel(false); }
								if (Z.tracking && (Z.trackingPanelVisible == 2 || Z.trackingPanelVisible == 3)) { Z.Toolbar.setVisibilityTrackingPanel(false); }
								if (Z.userPanelVisible == 2 || Z.userPanelVisible == 3) { Z.Toolbar.setVisibilityUserPanel(false); }
							}
						} else {
							Z.mouseOutDownPoint = new Z.Utils.Point(mPt.x, mPt.y);
						}
					}
					break;

				case 'resize' :
					if (!autoResizeSkipTimer) { autoResizeSkipTimer = window.setTimeout(autoResizeSkipTimerHandler, autoResizeSkipDuration); }
					break;

				case 'mousewheel' :
					// Firefox 'DOMMouseScroll' mouse wheel event standardized at beginning of this function to unify handling under this 'mousewheel' case.
					// Convert mouse wheel motion to zoom step in or out, then call mouse wheel handler which will determine which slider has focus and also
					// create or refresh mousewheel completion timer.
					if (Z.mouseWheel > 0) {
						var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
						Z.viewportCurrent.mouseWheelHandler(delta, isAltKey);
					}
					break;
			}
		}
	}

	function autoResizeSkipTimerHandler () {
		if (autoResizeSkipTimer) {
			window.clearTimeout(autoResizeSkipTimer);
			autoResizeSkipTimer = null;
			autoResizeViewer();
		}
	}

	this.autoResizeViewer = function () {
		autoResizeViewer();
	}

	function autoResizeViewer () {
		if (!Z.fullScreenEntering) {
			var containerDims = Z.Utils.getContainerSize(Z.pageContainer, Z.ViewerDisplay);
			var newZoom = Z.viewportCurrent.calculateZoomForResize(Z.viewportCurrent.getZoom(), Z.viewerW, Z.viewerH, containerDims.x, containerDims.y);
			self.resizeViewer(containerDims.x, containerDims.y, newZoom);

			if (Z.comparison) {
				var vpComparison = (Z.viewportCurrent.getViewportID() == 0) ? Z.Viewport1 : Z.Viewport0;
				if (vpComparison) { vpComparison.syncViewportResize(Z.imageX, Z.imageY, Z.imageZ, Z.imageR); }
			} else if (Z.overlays) {
				for (var i = 0, j = Z.imageSetLength - 1; i < j; i++) {
					// -1 in line above prevents top VP from resetting itself in loop.
					Z['Viewport' + i.toString()].syncViewportResize(Z.imageX, Z.imageY, Z.imageZ, Z.imageR);
				}
			}

		}
	}

	this.resizeViewer = function (w, h, z) {
		self.setSizeAndPosition(w, h, 0, 0, false);
		Z.viewportCurrent.resizeViewport(Z.imageX, Z.imageY, z, Z.imageR);

		if (Z.comparison) {
			var vpComparison = (Z.viewportCurrent.getViewportID() == 0) ? Z.Viewport1 : Z.Viewport0;
			if (vpComparison) {
				vpComparison.setSizeAndPosition(w, h, 0, 0, false);
				vpComparison.resizeViewport(Z.imageX, Z.imageY, z, Z.imageR);
			}
		}
	}

	this.mouseWheelCompleteHandler = function (event) {
		Z.mouseWheelIsDown = false;
		if (Z.mouseWheelCompleteTimer) {
			window.clearTimeout(Z.mouseWheelCompleteTimer);
			Z.mouseWheelCompleteTimer = null;
			Z.zooming = 'stop';
			Z.viewportCurrent.updateView(true);
		}
	}
};



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::: VIEWPORT FUNCTIONS ::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.ZoomifyViewport = function (vpID, vpImgPath, vpAnnotPath, vpHotPath, vpTrackPath, vpImageListPath) {
	// The following viewer global variables are limited to viewport scope when viewing an imageSet.
	// Z.imagePath, Z.hotspotPath, Z.hotspotFolder, Z.annotationPath, Z.annotationFolder, Z.tileSource, Z.imageW, Z.imageH, Z.imageX, Z.imageY, Z.imageZ, Z.initialX, Z.initialY, Z.initialZ, Z.minZ, Z.maxZ.
	var hotspotPath, hotspotFolder, annotationPath, annotationFolder;
	var imageX = null, imageY = null, imageZ = null;
	var timeoutCounterHotspotsVisibilityByFilter = 0;

	var viewportID = 0;
	if (typeof vpID !== "undefined" && vpID !== null) { viewportID = vpID; }

	var imagePath;
	if (typeof vpImgPath !== "undefined" && vpImgPath !== null) {
		imagePath = vpImgPath;
	} else {
		imagePath = Z.imagePath;
	}

	// Z.hotspotPath and Z.hotspotFolder or Z.annotationPath and Z.annotationFolder and/or Z.trackingPath and Z.trackingFolder are set here if multiples for imageSet, otherwise set in setParameters.
	if (typeof vpHotPath === "undefined" || vpHotPath === null) {
		hotspotPath = Z.hotspotPath;
		hotspotFolder = Z.hotspotPath;
	} else {
		hotspotPath = vpHotPath;
		hotspotFolder = hotspotPath;
		if (hotspotFolder.toLowerCase().substring(hotspotFolder.length - 4, hotspotFolder.length) == ".xml") {
			hotspotFolder = hotspotFolder.substring(0, hotspotFolder.lastIndexOf("/"));
		}
	}
	if (typeof vpAnnotPath === "undefined" || vpAnnotPath === null) {
		annotationPath = Z.annotationPath;
		annotationFolder = Z.annotationFolder;
	} else {
		annotationPath = vpAnnotPath;
		annotationFolder = annotationPath;
		if (annotationFolder.toLowerCase().substring(annotationFolder.length - 4, annotationFolder.length) == ".xml") {
			annotationFolder = annotationFolder.substring(0, annotationFolder.lastIndexOf("/"));
		}
	}
	if (typeof vpTrackPath === "undefined" || vpTrackPath === null) {
		trackingPath = Z.trackingPath;
		trackingFolder = Z.trackingFolder;
	} else {
		trackingPath = vpTrackPath;
		trackingFolder = trackingPath;
		if (trackingFolder.toLowerCase().substring(trackingFolder.length - 4, trackingFolder.length) == ".xml") {
			trackingFolder = trackingFolder.substring(0, trackingFolder.lastIndexOf("/"));
		}
	}
	if (typeof vpImageListPath === "undefined" || vpImageListPath === null) {
		imageListPath = Z.imageListPath;
		imageListFolder = Z.imageListFolder;
	} else {
		imageListPath = vpImageListPath;
		imageListFolder = imageListPath;
		if (imageListFolder.toLowerCase().substring(imageListFolder.length - 4, imageListFolder.length) == ".xml") {
			imageListFolder = imageListFolder.substring(0, imageListFolder.lastIndexOf("/"));
		}
	}

	// Set Viewer globals that cause hotspot/annotation display to be created and annotations.xml file(s) is/are parsed and annotation panel is created.
	if (typeof hotspotPath !== 'undefined' && Z.Utils.stringValidate(hotspotPath)) {
		Z.hotspots = true;
		Z.annotationPathProvided = true;
		if (Z.imageSet) { Z.hotspotPath = 'multiple'; }
	} else if (typeof annotationPath !== 'undefined' && Z.Utils.stringValidate(annotationPath)) {
		Z.annotations = true;
		Z.annotationPathProvided = true;
		if (Z.imageSet) { Z.annotationPath = 'multiple'; }
	}

	// Set Viewer globals that cause tracking display and/or image list to be created.
	if (typeof trackingPath !== 'undefined' && Z.Utils.stringValidate(trackingPath)) {
		Z.tracking = true;
		Z.trackingPathProvided = true;
	}
	if (typeof imageListPath !== 'undefined' && Z.Utils.stringValidate(imageListPath)) {
		Z.imageListPath = imageListPath;
		Z.imageList = true;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::: INIT FUNCTIONS ::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Declare variables for viewport internal self-reference and for initialization completion.
	var self = this;
	var viewportStatus = [];

	// Set viewport constants and static variables from value in Zoomify Image Folder 'ImageProperties.xml' file or Zoomify Image File (PFF) header.
	var IMAGE_VERSION = -1;
	var HEADER_SIZE = 0
	var HEADER_SIZE_TOTAL = 0;
	var CHUNK_SIZE = parseInt(Z.Utils.getResource('DEFAULT_CHUNKSIZE'), 10);
	var OFFSET_CHUNK_SIZE_BYTES = CHUNK_SIZE * 8;
	var BC_CHUNK_SIZE_BYTES = CHUNK_SIZE * 4;
	var TILE_COUNT = 0;
	var TILES_PER_FOLDER = 256;
	var TILE_WIDTH = parseInt(Z.Utils.getResource('DEFAULT_TILEW'), 10);
	var TILE_HEIGHT = parseInt(Z.Utils.getResource('DEFAULT_TILEH'), 10);

	// Set other defaults and calculate other constants.
	var TIERS_SCALE_UP_MAX = parseFloat(Z.Utils.getResource('DEFAULT_TIERSMAXSCALEUP'));
	var TIERS_SCALE_DOWN_MAX = TIERS_SCALE_UP_MAX / 2;
	var TILES_CACHE_MAX = parseInt(Z.Utils.getResource('DEFAULT_TILESMAXCACHE'), 10);
	var tlbrOffset = (Z.toolbarVisible == 1) ? Z.toolbarH : 0;
	var MOUSECLICK_THRESHOLD_VIEWPORT = parseInt(Z.Utils.getResource('DEFAULT_MOUSECLICKTHRESHOLDVIEWPORT'), 10);
	var MOUSECLICK_THRESHOLD_TIME_VIEWPORT = parseInt(Z.Utils.getResource('DEFAULT_MOUSECLICKTHRESHOLDTIMEVIEWPORT'), 10);
	var TOUCHTAP_THRESHOLD_VIEWPORT = parseInt(Z.Utils.getResource('DEFAULT_TOUCHTAPTHRESHOLDVIEWPORT'), 10);
	var TOUCHTAP_THRESHOLD_TIME_VIEWPORT = parseInt(Z.Utils.getResource('DEFAULT_TOUCHTAPTHRESHOLDTIMEVIEWPORT'), 10);

	// Declare variables for viewport displays.
	var oversizeDisplay, oD, oS, oCtx;
	var comparisonMaskContainer, cmD, cmS;
	var viewportContainer, cD, cS;
	var viewportBackfillDisplay, bD, bS, bCtx;
	var viewportDisplay, vD, vS, vCtx;
	var transitionCanvas, tC, tS, tCtx;
	var watermarkDisplay, wD, wS;
	var hotspotDisplay, hD, hS, hotD, hotS, annD, annS;
	var drawingDisplay, dD, dS, dCtx;
	var editingDisplay, eD, eS, eCtx;
	var imageFilterCanvas, fC, fS, fCtx;
	var imageFilterBackfillCanvas, fbC, fbS, fbCtx;
	var trkD, trkS;
	var upD, upS;
	var lastPtX, lastPtY;
	var maskCanvas, mC, mS, mCtx;
	var savingDisplay, sD, sS, sCtx;

	// Create backfill, viewport, watermark, and hotspot displays within container that can be
	// dragged. Scaling occurs in display canvases directly or in tiles if in non-canvas browser.
	createDisplays(viewportID);

	// Support unconverted image viewing.
	var unconvertedImage;

	// Declare variables and lists for viewport tiers and tiles.
	var tierCount = 1, tierCurrent = 0, tierBackfill = 0;
	var tierBackfillDynamic = false, tierBackfillOversize = 0, tierChanged = false;
	var tierScale, tierScalePrior, tierBackfillScale, tierBackfillOversizeScale;
	var tierWs = [], tierHs = [], tierWInTiles = [], tierHInTiles = [],  tierTileCounts = [];
	var tierTileOffsetsStart = []; tierTileOffsetsCount = [];  tierTileOffsetChunks = []; tierTileOffsetLast = [];  // ZIF support.
	var tierTileByteCountsStart = []; tierTileByteCountsCount = []; tierTileByteCountChunks = []; tierTileByteCountLast = [];  // ZIF support.
	var tilesBackfillDisplayingNames = [], tilesBackfillLoadingNames = [], tilesBackfillCached = [], tilesBackfillCachedNames = [];
	var tilesInView = [], tilesInViewNames = [], tilesToLoadTotal = 0, tilesLoadingNamesLength = 0;
	var tilesBackfillToPrecache = 0, tilesBackfillToPrecacheLoaded = 0;
	var tilesBackfillToDisplay = 0, tilesBackfillInCache = 0, tilesBackfillRequested = 0, tilesBackfillLoaded = 0, tilesBackfillDisplayed = 0, tilesBackfillWaiting;
	var tilesToDisplay = 0, tilesInCache = 0, tilesRequested = 0, tilesLoaded = 0, tilesDisplayed = 0, tilesWaiting = 0, tilesTimeElapsed = 0, tileLoadsPerSecond = 0;
	var tilesDisplayingNames = [], tilesLoadingNames = [], tilesCached = [], tilesCachedNames = [], tilesCachedInView = [], tilesCachedInViewNames = [];
	var validateViewTimer = null, validateViewRetryCounter = 0;
	var validateViewRetryLimit = parseInt(Z.Utils.getResource('DEFAULT_VALIDATEVIEWRETRYLIMIT'), 10);
	var validateViewDelay = parseInt(Z.Utils.getResource('DEFAULT_VALIDATEVIEWRETRYDELAY'), 10);
	var offsetChunks = [], offsetChunkBegins = [], tilesRetryNames = [], tilesRetryNamesChunks = [], tilesRetry = [], tilesBackfillRetryNames = []; // Support for Zoomify Image File storage.
	var tileNetConnector = new Z.NetConnector();

	// Declare variables and lists for annotation and image saving.
	var drawLabelCounter;
	var fullImageTilesCachedNames = [], fullImageTilesCached = [];
	var fullImageTilesBackfillCachedNames = [], fullImageTilesBackfillCached = [];

	// Declare and set backfill threshold variables.
	var backfillTreshold3 = parseInt(Z.Utils.getResource('DEFAULT_BACKFILLTHRESHOLD3'), 10);
	var backfillDynamicAdjust = parseInt(Z.Utils.getResource('DEFAULT_BACKFILLDYNAMICADJUST'), 10);
	var backfillTreshold2 = parseInt(Z.Utils.getResource('DEFAULT_BACKFILLTHRESHOLD2'), 10);
	var backfillChoice2 = parseInt(Z.Utils.getResource('DEFAULT_BACKFILLCHOICE2'), 10);
	var tierBackfillOversize = backfillChoice2;
	var backfillTreshold1 = parseInt(Z.Utils.getResource('DEFAULT_BACKFILLTHRESHOLD1'), 10);
	var backfillChoice1 = parseInt(Z.Utils.getResource('DEFAULT_BACKFILLCHOICE1'), 10);
	var backfillChoice0 = parseInt(Z.Utils.getResource('DEFAULT_BACKFILLCHOICE0'), 10);
	var backfillTresholdCached0 = null, backfillTresholdCached1 = null, backfillTresholdCached2 = null;

	// Declare variables for tile caching area and viewport.
	var panBufferUnconverted = parseFloat(Z.Utils.getResource('DEFAULT_PANBUFFERUNCONVERTED'), 10);
	var panBufferStandard = (Z.panBuffer !== null) ? Z.panBuffer : parseFloat(Z.Utils.getResource('DEFAULT_PANBUFFER'), 10);
	var PAN_BUFFER = (Z.tileSource != 'unconverted') ? panBufferStandard : panBufferUnconverted;
	var BACKFILL_BUFFER = parseFloat(Z.Utils.getResource('DEFAULT_BACKFILLBUFFER'), 10);
	var PAN_BUFFERSIZEMAXBROWSER = parseFloat(Z.Utils.getResource('DEFAULT_PAN_BUFFERSIZEMAXBROWSER'), 10);
	var PAN_BUFFERSIZEMAXFIREFOX = parseFloat(Z.Utils.getResource('DEFAULT_PAN_BUFFERSIZEMAXFIREFOX'), 10);
	var PAN_BUFFERSIZEMAXMOBILE = parseFloat(Z.Utils.getResource('DEFAULT_PAN_BUFFERSIZEMAXMOBILE'), 10);
	var PAN_BUFFERSIZEMAXIMAGESET = parseFloat(Z.Utils.getResource('DEFAULT_PAN_BUFFERSIZEMAXIMAGESET'), 10);
	var viewW, viewH, viewL, viewT, viewCtrX, viewCtrY;
	var displayW, displayH, displayCtrX, displayCtrY, displayL, displayR, displayT, displayB;
	var backfillW, backfillH, backfillCtrX, backfillCtrY, backfillL, backfillT;

	// Set initial values for tile selection and caching areas.
	viewW = Z.viewerW;
	viewH = Z.viewerH;
	viewL = viewT = 0;

	// Reset viewport height and top if toolbar visible and static (no hide/show or show/hide).
	viewH -= tlbrOffset;
	if (Z.toolbarPosition == 0) { viewT += tlbrOffset; }

	// Declare variables for viewport mouse support.
	var clickTimer = null;
	var dragPtStart, dragPtCurrent, dragTimeStart;

	// Declare variable for gesture support.
	var gestureInterval = null, gestureIntervalPercent = null, wasGesturing = false;
	var GESTURE_TEST_DURATION = parseInt(Z.Utils.getResource('DEFAULT_GESTURETESTDURATION'), 10);

	// Declare viewport variables for continuous zoom-and-pan, smooth pan, and smooth animation functions.
	var panStepDistance = Math.round(parseFloat(Z.Utils.getResource('DEFAULT_PANSTEPDISTANCE')) * Z.panSpeed);
	var panX = 0, panY = 0, smoothAnimationX = null, smoothAnimationY = null;
	var optimalMotionImages = parseInt(Z.Utils.getResource('DEFAULT_ANIMATIONOPTIMALMOTIONIMAGES'), 10);
	var optimalPositionDelta = parseInt(Z.Utils.getResource('DEFAULT_ANIMATIONOPTIMALPOSITIONDELTA'), 10);
	var smoothPanInterval = null, smoothPanStartPt = null, smoothPanDisplayStartPt = null, smoothPanMousePt = null;
	var smoothPanDeltaX = 0, smoothPanDeltaY = 0, smoothPanLastDeltaX = 0, smoothPanLastDeltaY = 0;
	var smoothPanGliding = null, smoothPanGlideX = null, smoothPanGlideY = null;
	var zoomStepDistance = (parseFloat(Z.Utils.getResource('DEFAULT_ZOOMSTEPDISTANCE')) * Z.zoomSpeed);
	if (Z.mobileDevice) { zoomStepDistance /= 2; }
	var zoomVal = 0, zapTimer = null, zapStepCount = 0;
	var zapStepDuration = parseInt(Z.Utils.getResource('DEFAULT_ZAPSTEPDURATION'), 10);
	var zapTierCurrentZoomUnscaledX, zapTierCurrentZoomUnscaledY;
	var fadeInStep = (parseFloat(Z.Utils.getResource('DEFAULT_FADEINSTEP')) * Z.fadeInSpeed);
	var fadeInInterval = null;
	var rotStepDegrees = parseInt(Z.Utils.getResource('DEFAULT_ROTATIONSTEPDEGREES'), 10);
	var rotStepDuration = parseInt(Z.Utils.getResource('DEFAULT_ROTATIONSTEPDURATION'), 10);
	var rotVal = 0, rotTimer = null;

	// Declare viewport variables for zoom-and-pan-to-view functions.
	var zaptvDuration = parseFloat(Z.Utils.getResource('DEFAULT_ZAPTVDURATION'));
	var zaptvSteps = parseFloat(Z.Utils.getResource('DEFAULT_ZAPTVSTEPS'));
	if (Z.mobileDevice) { zaptvSteps /= 2; }
	var zaptvTimer = null, zaptvStepCurrent = 0;

	// Declare viewport variables for full view, virtual pointer, crosshairs, and measurement, if needed.
	if (!Z.fullScreenVisible && !Z.fullPageVisible) {
		var fvBodW, fvBodH, fvBodO, fvDocO, fvContBC, fvContW, fvContH, fvContPos, fvContIdx;
		var buttonFullViewExitExternal, buttonFullViewExitExternalVisible;
	}
	if (Z.crosshairsVisible) {
		Z.Utils.drawCrosshairs(Z.ViewerDisplay, viewW, viewH);
	}
	if (Z.measureVisible || Z.editMode !== null) {
		var measureLengthText = Z.Utils.getResource('UI_MEASURELENGTH');
		var measureLengthTotalText = Z.Utils.getResource('UI_MEASURELENGTHTOTAL');
		var measurePerimeterText = Z.Utils.getResource('UI_MEASUREPERIMETER');
		var measureAreaText = Z.Utils.getResource('UI_MEASUREAREA');
		var measureSquareText = Z.Utils.getResource('UI_MEASURESQUARE');
		var measureCaptionBackOpacity = parseFloat(Z.Utils.getResource('DEFAULT_MEASURECAPTIONBACKALPHA'));
		var measureCaptionFontSize = parseInt(Z.Utils.getResource('DEFAULT_MEASURECAPTIONFONTSIZE'), 10);
		var captionW = parseInt(Z.Utils.getResource('DEFAULT_MEASURECAPTIONWIDTH'), 10);
	}

	if (Z.geoCoordinatesVisible) {
		var geoLeft, geoRight, geoTop, geoBottom;
		var geoLeftDec, geoTopDec, geoXSpan, geoYSpan;
	}

	// Declare viewport variables for filter functions.
	if (Z.imageFilters) {
		var imageFilterTimer = null, imageFilterBackfillTimer = null, imageFilterRetryTimer = null;
		var imageFilterStatesConvolve = false;
		var imageFiltersApplied = [], tileImages = [];
		var cachedCanvas, cachedCanvasFiltered, cachedCanvasBackfill;
		var imageFilterBrightnessValue = 0, imageFilterContrastValue = 0, imageFilterSharpnessValue = 0, imageFilterBlurrinessValue = 0, imageFilterColorRedValue = 0, imageFilterColorGreenValue = 0, imageFilterColorBlueValue = 0, imageFilterColorRedRangeValue = 0, imageFilterColorGreenRangeValue = 0, imageFilterColorBlueRangeValue = 0, imageFilterColorRedRangeValue2 = 0, imageFilterColorGreenRangeValue2 = 0, imageFilterColorBlueRangeValue2 = 0, imageFilterGammaValue = 0, imageFilterGammaRedValue = 0, imageFilterGammaGreenValue = 0, imageFilterGammaBlueValue = 0, imageFilterHueValue = 0, imageFilterSaturationValue = 0, imageFilterLightnessValue = 0, imageFilterWhiteBalanceValue = 0, imageFilterEqualizeValue = 0, imageFilterNoiseValue = 0, imageFilterGlowValue = 0;
	}

	// Prepare watermark variables and image if optional parameter set.
	if (Z.watermarks) {
		var watermarkImage, watermarkAlpha;
		var watermarksX = [], watermarksY = [];
	}

	// Prepare image list variables if optional parameter set.
	if (Z.imageList) {
		var imageCurrent, imageList, imageListPosition, imageListW, imageListSource;
		var imageListDP = [];
	}

	// Prepare tour variables if optional parameter set. Hotspot variables below also prepared because hotspotPath set to tourPath.
	// If screensaver, prepare tour variables but use modified in tour functions.
	if (Z.tour) {
		var destinationCurrent, destinationNextAudio, tourAutoStart, tourAutoLoop;
	}

	// Prepare multi-image/multi-viewport variables if optional comparison/slideshow/animation/slidestack path parameter is set using image path parameter.
	if (Z.imagePath !== null) {
		if (Z.imagePath.indexOf('zComparisonPath') != -1) {
			Z.imageSetPath = Z.imagePath.substring(16, Z.imagePath.length);
			Z.imageSet = true;
			Z.comparison = true;
		} else if (Z.imagePath.indexOf('zSlidePath') != -1) {
			Z.slidePath = Z.imagePath.substring(11, Z.imagePath.length);
			Z.slideshow = true;
		} else if (Z.imagePath.indexOf('zAnimationPath') != -1) {
			Z.imageSetPath = Z.imagePath.substring(15, Z.imagePath.length);
			Z.imageSet = true;
			Z.animation = true;
		} else if (Z.imagePath.indexOf('zSlidestackPath') != -1) {
			Z.imageSetPath = Z.imagePath.substring(16, Z.imagePath.length);
			Z.imageSet = true;
			Z.slidestack = true;
		}
	}

	if (Z.slideshow) {
		var slides = [], slideListDP = [];
		var slideCurrent, slideList, slideListPosition, slideListW, slideListSource, slideshowAutoStart, slideshowAutoLoop;
		var slideTransitionStep = (parseFloat(Z.Utils.getResource('DEFAULT_SLIDETRANSITIONSTEP')) * Z.slideTransitionSpeed);
		Z.slideTransitionTimeout = null;
		Z.slideOpacity = 0;
	}

	// Prepare hotspot and/or annotation variables global to Viewport if optional parameter set.
	if (Z.zoomRectangle || Z.measureVisible || Z.tour || Z.hotspots || Z.annotations || Z.tracking) {
		var zoomRectangleDragging = null;
		var mTypeLegacy = false;
		var hotspots = [], hotspotsMedia = [], hotspotPopups = [], hotspotsFilterDisplayIDs = [], hotspotsFilterDisplayInternalIDs = [];
		var hotspotCurrent = null, hotspotCurrentID = null, hotspotDragging = null, hotspotDragPtStart = null, hotspotDragPtEnd = null, hotspotDragTimeStart = null;
		var hotspotPopupsMaxZIndex = 0, poiPriorID = null, labelPriorID = null, notePriorID = null;
		var MOUSECLICK_THRESHOLD_HOTSPOT = parseInt(Z.Utils.getResource('DEFAULT_MOUSECLICKTHRESHOLDHOTSPOT'), 10);
		var annotationPanelDisplay;
		var polygonCurrentPts = null, polygonsRequireCanvasAlertShown = false;
		var polygonComplete = true, controlPointCurrent = null, controlPointDragging = false;
		var hotspotNetConnector = new Z.NetConnector();

		var iconLineW = Z.Utils.getResource('DEFAULT_ICONLINEWIDTH');
		var polygonLineW = Z.Utils.getResource('DEFAULT_POLYGONLINEWIDTH');
		var polygonOpacity = parseFloat(Z.Utils.getResource('DEFAULT_POLYGONALPHA'));
		var polygonViewBuffer = parseInt(Z.Utils.getResource('DEFAULT_POLYGONVIEWBUFFER'), 10);

		var ctrlPtLineW = Z.Utils.getResource('DEFAULT_CONTROLPOINTLINEWIDTH');
		var ctrlPtStrokeColor = Z.Utils.getResource('DEFAULT_CONTROLPOINTSTROKECOLOR');
		var firstCtrlPtFillColor = Z.Utils.getResource('DEFAULT_FIRSTCONTROLPOINTFILLCOLOR');
		var stdCtrlPtFillColor = Z.Utils.getResource('DEFAULT_STANDARDCONTROLPOINTFILLCOLOR');
		var ctrlPtRadius = parseInt(Z.Utils.getResource('DEFAULT_CONTROLPOINTRADIUS'), 10);
		var polygonLineWFreehand = Z.Utils.getResource('DEFAULT_POLYGONLINEWIDTHFREEHAND');

		var captionTextColor = (Z.captionTextColor) ? Z.Utils.stringValidateColorValue(Z.captionTextColor) : Z.Utils.getResource('DEFAULT_CAPTIONTEXTCOLOR');
		var captionBackColor = (Z.captionBackColor) ? Z.Utils.stringValidateColorValue(Z.captionBackColor) : Z.Utils.getResource('DEFAULT_CAPTIONBACKCOLOR');
		var defaultFontSize = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTCAPTIONFONTSIZE'), 10);
		var minFontSize = parseInt(Z.Utils.getResource('DEFAULT_MINHOTSPOTCAPTIONFONTSIZE'), 10);
		var maxFontSize = parseInt(Z.Utils.getResource('DEFAULT_MAXHOTSPOTCAPTIONFONTSIZE'), 10);
		var defaultPadding = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTCAPTIONPADDING'), 10);
		var minPadding = parseInt(Z.Utils.getResource('DEFAULT_MINHOTSPOTCAPTIONPADDING'), 10);
		var maxPadding = parseInt(Z.Utils.getResource('DEFAULT_MAXHOTSPOTCAPTIONPADDING'), 10);
		if (Z.mobileDevice) { ctrlPtRadius *= 2; }

		if (Z.maskVisible) {
			var labelNoMaskArr = [];
			var maskFadeStep = (parseFloat(Z.Utils.getResource('DEFAULT_MASKFADESTEP')) * Z.maskFadeSpeed);
			// Alternative implementation: Mask sync'ing on view updates. Unnecessary for current implementation which clears on interaction.
			Z.setCallback('viewUpdateComplete', function () {
				if (Z.maskingSelection) { setMask(); }
			} );
		}

		if (Z.tour || Z.hotspots) {
			var hotspotList, hotspotListSource, hotspotListPosition, hotspotsInitialVisibility;
			var hotspotsMinScale, hotspotsMaxScale;
			var hotspotListDP = [];
			var labelIconDefaultW = parseFloat(Z.Utils.getResource('DEFAULT_LABELICONWIDTH'));
			var labelIconDefaultH = parseFloat(Z.Utils.getResource('DEFAULT_LABELICONHEIGHT'));
			var labelListDP = [], labelListCurrentDP = [];

		} else if (Z.zoomRectangle || Z.measureVisible || Z.annotations || Z.tracking) {
			var annotationsXML, annotationsXMLRollback, annotationPanelPosition, annotationXMLVersion;
			var poiList, noteList, labelList, labelsMinScale, labelsMaxScale, captionTextElement;
			var poiVisibility, labelVisibility, noteVisibility, commentVisibility, poiVisibilityXML, labelVisibilityXML, noteVisibilityXML, commentVisibilityXML, tooltipSource;
			var poiListDP = [], noteListDP = [], noteListCurrentDP = [];
			var labelListDP = [], labelListCurrentDP = [], labelIconListDP = []; labelCaptionPositionListDP = []; labelTargetListDP = [];
			var hotspotsRollback = [], poiListDPRollback = [], labelListDPRollback = [], polygonRollback = [], noteListDPRollback = [];
			var createdNewLabel = false;
			var scaleVal = 0, scaleTimer = null;
			var labelScaleStepDistance = parseFloat(Z.Utils.getResource('DEFAULT_LABELSCALESTEPDISTANCE'));
			var labelScaleStepDuration = parseInt(Z.Utils.getResource('DEFAULT_LABELSCALESTEPDURATION'), 10);
			var labelIconDefaultW = parseFloat(Z.Utils.getResource('DEFAULT_LABELICONWIDTH'));
			var labelIconDefaultH = parseFloat(Z.Utils.getResource('DEFAULT_LABELICONHEIGHT'));
			if (Z.mobileDevice) { labelScaleStepDistance /= 2; }

			if (Z.tracking) {
				var trackingTypesList, trackingInstancesList, containerTracking, trackingCounterCurrent;
				var trackingTypesListDP = [], trackingCells = [], trackingInstancesListDP = [], rowCounterFilteredListDP = [];
				var trackingPanelDisplay;
			}
		}
	}

	// Load image properties to get image width and height and tile size.  Alert user that local viewing is not
	// supported in certain browsers nor from storage alternatives other than image folders. Image properties
	// are HTML parameters from web page, bytes from image server, ZIF, PFF file, or XML values.
	if (Z.imagePath !== null && Z.imagePath != 'null') {

		// Prevent initialization if attempting to view ZIF or PFF file locally.
		if (Z.localUse == true && Z.tileSource == 'ZoomifyImageFile') {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALVIEWING-FORMAT-ZIF'), false, Z.messageDurationShort, 'center');
			return;
		} else if (Z.localUse == true && Z.tileSource == 'ZoomifyPFFFile') {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALVIEWING-FORMAT-PFF'), false, Z.messageDurationStort, 'center');
			return;
		}

		// Warn user if attempting to view Zoomify Image Folder locally in non-supporting browser.
		if (Z.localUse == true && (Z.browser == Z.browsers.CHROME  || Z.browser == Z.browsers.OPERA || (Z.browser == Z.browsers.IE && Z.browserVersion == 11) || (Z.browser == Z.browsers.SAFARI && Z.browserVersion >= 7))) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALVIEWING-BROWSER'), false, Z.messageDurationStandard, 'center');
		}
		if (Z.imageW !== null && Z.imageH !== null && Z.sourceMagnification !== null ) {
			// Example image server protocol implementation: image properties provided via HTML parameters.
			// Note that this approach sets width, height, and tile size values directly from parameters during page
			// loading so it sets those values prior to viewer initialization and never during reinitialization.
			// See additional notes in function loadImagePropertiesImageServer.
			if (typeof self.getStatus !== 'undefined') {
				initializeViewport(Z.imageW, Z.imageH, TILE_WIDTH, TILE_HEIGHT, null, null, null, null, Z.sourceMagnification, Z.focal, Z.quality);
			} else {
				var viewportInitTimer = window.setTimeout( function () { initializeViewport(Z.imageW, Z.imageH, TILE_WIDTH, TILE_HEIGHT, null, null, null, null, Z.sourceMagnification, Z.focal, Z.quality); }, 100);
			}
			//var netConnector = new Z.NetConnector();
			//loadImageProperties(imagePath, netConnector);

		} else if (Z.imageProperties !== null) {
			// Receive image properties as XML text in HTML parameter. Convert to XML doc and parse - skipping XML loading steps. This
			// approach provides workaround for cross-domain image storage and also enables optional support for image server tile fulfillment.
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(Z.imageProperties);
			parseImageXML(xmlDoc);

		} else if (Z.tileSource == 'unconverted') {
			// Load unconverted image and use its dimensions to set needed values.
			loadUnconvertedImage(imagePath);

		} else if (Z.imagePath.indexOf('zComparisonPath') == -1 && Z.imagePath.indexOf('zSlidePath') == -1 && Z.imagePath.indexOf('zOverlayPath') == -1 && Z.imagePath.indexOf('zAnimationPath') == -1 && Z.imagePath.indexOf('zSlidestackPath') == -1) {
			// Load byte range from ZIF or PFF or ImageProperties.xml file from Zoomify Image folder.
			var netConnector = new Z.NetConnector();
			loadImageProperties(imagePath, netConnector, viewportID);
		}
	}

	// Load list of images in XML file if image list is to be presented. If image path parameter not provided and
	// image properties not loaded above, first values in image list XML file will be used at end of parseImageListXML function.
	if (Z.imageList) {
		var netConnector = new Z.NetConnector();
		loadImageListXML(netConnector);
	}

	function loadImageListXML (netConnector) {
		var defaultFilename = Z.Utils.getResource('DEFAULT_IMAGELISTXMLFILE');
		if (Z.imageListPath.toLowerCase().substring(Z.imageListPath.length - 4, Z.imageListPath.length) != '.xml') {
			Z.imageListPath = Z.imageListPath + '/' + defaultFilename;
		}
		XMLPath = Z.Utils.cacheProofPath(Z.imageListPath);
		if (typeof XMLPath !== 'undefined' && Z.Utils.stringValidate(XMLPath)) {
			var netConnector = new Z.NetConnector();
			netConnector.loadXML(XMLPath, vpID);
		}
	}

	// Load list of slides in XML file if multiple images are to be presented. If image path parameter not provided and
	// image properties not loaded above, first values in slides XML file will be used at end of parseSlidesXML function.
	if (Z.slideshow) {
		var netConnector = new Z.NetConnector();
		loadSlidesXML(netConnector);
	}

	function loadSlidesXML (netConnector) {
		var defaultFilename = Z.Utils.getResource('DEFAULT_SLIDESXMLFILE');
		if (Z.slidePath.toLowerCase().substring(Z.slidePath.length - 4, Z.slidePath.length) != '.xml') {
			Z.slidePath = Z.slidePath + '/' + defaultFilename;
		}
		XMLPath = Z.Utils.cacheProofPath(Z.slidePath);
		if (typeof XMLPath !== 'undefined' && Z.Utils.stringValidate(XMLPath)) {
			var netConnector = new Z.NetConnector();
			netConnector.loadXML(XMLPath);
		}
	}

	function initializeViewport (iW, iH, tW, tH, iTileCount, iVersion, iHeaderSize, iHeaderSizeTotal, iMagnification, iFocal, iQuality) {
		createCanvasContexts();

		// Set viewport variables to XML or header values.
		Z.imageW = iW;
		Z.imageH = iH;
		Z.imageCtrX = Z.imageW / 2;
		Z.imageCtrY = Z.imageH / 2;
		Z.imageD = Math.round(Math.sqrt(iW * iW + iH * iH));
		IMAGE_VERSION = iVersion;
		HEADER_SIZE = iHeaderSize;
		HEADER_SIZE_TOTAL = iHeaderSizeTotal;
		TILE_COUNT = iTileCount;
		TILE_WIDTH = tW;
		TILE_HEIGHT = tH;

		// Example image server implementation: from example HTML or XML parameters.
		if (iMagnification !== null && iFocal !== null && iQuality !== null) {
			Z.sourceMagnification = iMagnification;
			Z.focal = iFocal;
			Z.quality = iQuality;
		}

		// Record tier dimensions and tile counts for fast access.
		calculateTierValues();

		// Set initial dimensions and location of all viewport displays and ensure zoom and pan
		// initial values and limits do not conflict.
		setSizeAndPosition(viewW, viewH, viewL, viewT);
		self.validateXYZDefaults();

		// Set default scale for oversize backfill canvas or remove it if image size doesn't require it.
		if (tierCount > backfillTreshold3) {
			tierBackfillOversizeScale = convertZoomToTierScale(tierBackfillOversize, Z.initialZ);
			if (oD) { oCtx.scale(tierBackfillOversizeScale, tierBackfillOversizeScale); }
		} else {
			oD = null;
			oS = null;
			oCtx = null;
		}

		// Set default scales for other canvases.
		tierBackfillScale = convertZoomToTierScale(tierBackfill, Z.initialZ);
		tierScale = convertZoomToTierScale(tierCurrent, Z.initialZ);
		tierScalePrior = tierScale;
		if (Z.useCanvas) {
			// Trap possible NS_ERROR_FAILURE error if working with large unconverted image.
			// DEV NOTE: Add retry or soft fail in catch in future implementation for firefox issue with large canvases.
			try {
				vCtx.scale(tierScale, tierScale);
			} catch (e) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_SCALINGCANVASFORUNCONVERTEDIMAGE'), false, Z.messageDurationStandard, 'center');
				console.log('In function initializeViewportContinue scaling canvas:  ' + e);
			}
		}

		// Load watermark, hotspots or annotations, virtual pointer, backfill tiles, and set initial view.
		if (wD) { loadWatermark(); }
		if (Z.screensaver) {
			Z.Utils.validateCallback('screensaverStarting');
			Z.Utils.functionCallWithDelay(function () { self.tourStart(); }, 750);
		}
		if (hD) {
			self.setDrawingColor('buttonColor0' + viewportID, true);
			if (Z.tour || Z.hotspots || Z.annotations) {
				loadHotspotsOrAnnotationsData(viewportID);
			}
		}

		if (Z.tracking) { loadTrackingXML(viewportID); }

		if (Z.virtualPointerVisible) { Z.Viewer.createVirtualPointer(); }
		if (Z.tileSource != 'unconverted') { self.precacheBackfillTiles(); }

		view(Z.initialX, Z.initialY, Z.initialZ, Z.initialR, null, true);

		// Display hotspot coordinates panel if parameter set.
		if (Z.coordinatesVisible) { self.setCoordinatesDisplayVisibility(true); }

		// Load geo coordinate conversion values if parameter set.
		if (Z.geoCoordinatesVisible) { loadGeographicCoordinatesXML(); }

		// Set initial display to full screen if parameter true.
		if (Z.initialFullPage) { self.toggleFullViewMode(true); }

		// Enable event handlers specific to Viewport and set viewport as initialized.
		initializeViewportEventListeners();
		self.setStatus('initializedViewport', true);
		self.syncViewportRelated();

		// Start slideshow if optional parameter set, go to next slide is slideshow playing.
		if (Z.slideshow) {
			var indexTitleAdjust = (Z.Utils.stringValidate(Z.slideListTitle) && Z.slideListTitle != 'none') ? 1 : 0;
			if (typeof slideList !== 'undefined') { slideList.selectedIndex = indexTitleAdjust; }
			if (slideshowAutoStart && !Z.slideshowPlaying) {
				self.slideshowStart();
			} else if (Z.slideshowPlaying) {
				self.nextSlide();
			}
		}

		// If viewing imageSet set callback to ensure hotspots/annotations draw correctly.
		if (Z.imagePath == "multiple") {
			var hotspotsRedisplayEvent = (Z.hotspots) ? 'hotspotsLoadedViewer' : (Z.annotations) ? 'annotationsLoadedViewer' : null;
			var hotspotsRedisplay = function () {
				var imageSetHotspotsTimeout = window.setTimeout( function () {
						Z.viewportCurrent.redisplayHotspots();
					}, 1500);
				};
			if (hotspotsRedisplayEvent !== null) { Z.setCallback(hotspotsRedisplayEvent, hotspotsRedisplay); }
		}
	}

	// Initialization on callback after XML load after change of image path via setImage function.
	function reinitializeViewport (iW, iH, tW, tH, iTileCount, iVersion, iHeaderSize, iHeaderSizeTotal, iMagnification, iFocal, iQuality) {
		// Clear prior image values.
		self.setStatus('initializedViewport', false);
		self.clearAll(true, false, true, true);

		// Calculate new image values.
		Z.imageW = iW;
		Z.imageH = iH;
		Z.imageCtrX = Z.imageW / 2;
		Z.imageCtrY = Z.imageH / 2;
		Z.imageD = Math.round(Math.sqrt(iW * iW + iH * iH));
		IMAGE_VERSION = iVersion;
		HEADER_SIZE = iHeaderSize;
		HEADER_SIZE_TOTAL = iHeaderSizeTotal;
		TILE_COUNT = iTileCount;
		TILE_WIDTH = tW;
		TILE_HEIGHT = tH;

		Z.Utils.setParameters(Z.parameters);

		// DEV NOTE: Optional HTML parameter custom tile dimensions override defaults, XML values, or server provided values.
		// but not custom tile dimensions applied in image list optional parameter values, so must override here.
		if (Z.imageList) {
			if (Z.tileW != tW) { TILE_WIDTH = tW = Z.tileW; }
			if (Z.tileH != tH) { TILE_HEIGHT = tH = Z.tileH; }
		}

		calculateTierValues();

		if (Z.hotspotPath !== null) {
			hotspotPath = Z.hotspotPath;
			hotspotFolder = Z.hotspotFolder;
		}
		if (Z.annotationPath !== null) {
			annotationPath = Z.annotationPath;
			annotationFolder = Z.annotationFolder;
		}

		createDisplays(); // Create hotspots or annotation display and list or panel if required.
		createCanvasContexts();
		self.validateXYZDefaults();

		// Set default scale for oversize backfill canvas or remove it if image size doesn't require it.
		if (tierCount > backfillTreshold3) {
			tierBackfillOversizeScale = convertZoomToTierScale(tierBackfillOversize, Z.initialZ);
			oCtx.restore();
			oCtx.scale(tierBackfillOversizeScale, tierBackfillOversizeScale);
		} else {
			oD = oS = oCtx = null;
		}

		// Set default scales for other canvases.
		tierBackfillScale = convertZoomToTierScale(tierBackfill, Z.initialZ);
		tierScale = convertZoomToTierScale(tierCurrent, Z.initialZ);
		tierScalePrior = tierScale;
		if (Z.useCanvas) {
			vCtx.restore();
			vCtx.scale(tierScale, tierScale);
		}

		// Load watermark, hotspots or annotations, virtual pointer, backfill tiles, and set initial view.
		if (wD) { loadWatermark(); }
		if (hD) {
			self.setDrawingColor('buttonColor0' + viewportID, true);
			if (Z.tour || Z.hotspots || Z.annotations) {
				loadHotspotsOrAnnotationsData(viewportID);
			}
		}

		if (Z.virtualPointerVisible) { Z.Viewer.createVirtualPointer(); }
		if (Z.tileSource != 'unconverted') { self.precacheBackfillTiles(); }

		// Prior to setting size and position undo halving if two viewports. This permits function setSizeAndPosition to work simply for resizability.
		if (Z.comparison) { viewW *= 2; }

		// Set size and position and update view with new default initial coordinates unless Comparing, in which case use initial coordinates in comparison.xml file and if none, do not reset coordinates.
		self.setSizeAndPosition(viewW, viewH, viewL, viewT);
		var initialValuesSet = (typeof Z.parameters !== 'undefined' && Z.parameters !== null && (typeof Z.parameters.zInitialX !== 'undefined' || typeof Z.parameters.zInitialY !== 'undefined' || typeof Z.parameters.zInitialZoom !== 'undefined'));
		if ((Z.comparison || Z.overlays) && !initialValuesSet) {
		 	view(Z.priorX, Z.priorY, Z.priorZ, Z.priorR, null, true);
		} else {
			view(Z.initialX, Z.initialY, Z.initialZ, Z.initialR, null, true);
		}

		self.setStatus('initializedViewport', true);

		// Set Navigator thumbnail image and load tracking data if any.
		var navCurrent = (vpID == 0) ? Z.Navigator : Z.Navigator2;
		if (navCurrent) { navCurrent.setImage(self.getImagePath()); }
		if (Z.tracking) { loadTrackingXML(viewportID); }

		// Sync changing Viewport view to unchanged Viewport view.
		if (Z.comparison) {
			var vpComparison = (self.getViewportID() == 0) ? Z.Viewport1 : Z.Viewport0;
			var compCoordsFull = vpComparison.getCoordinatesFull(true);
			self.setView(compCoordsFull.x, compCoordsFull.y, compCoordsFull.z, compCoordsFull.r, null, null);
		}

		// Reinitialize and sync related components.
		self.syncViewportRelated();

		// Go to next slide if slideshow playing.
		if (Z.slideshowPlaying) { self.nextSlide(); }
	}

	this.clearAll = function (clearTileVals, clearTierVals, clearDisplayVals, clearDisps) {
		if (clearTileVals) { clearTileValues(); }
		if (clearTierVals) { clearTierValues(); }
		if (clearDisplayVals) { clearDisplayValues(); }
		if (clearDisps) { clearDisplays(); }
	}

	function clearTileValues () {
		// Tile support.
		tilesToLoadTotal = 0;
		tilesLoadingNamesLength = 0;
		if (typeof tilesBackfillCached !== 'undefined') {Z.Utils.arrayClear(tilesBackfillCached); }
		if (typeof tilesBackfillCachedNames !== 'undefined') {Z.Utils.arrayClear(tilesBackfillCachedNames); }
		if (typeof tilesBackfillDisplayingNames !== 'undefined') { Z.Utils.arrayClear(tilesBackfillDisplayingNames); }
		if (typeof tilesDisplayingNames !== 'undefined') { Z.Utils.arrayClear(tilesDisplayingNames); }
		if (typeof tilesLoadingNames !== 'undefined') { Z.Utils.arrayClear(tilesLoadingNames); }
		if (typeof tilesCached !== 'undefined') { Z.Utils.arrayClear(tilesCached); }
		if (typeof tilesCachedNames !== 'undefined') { Z.Utils.arrayClear(tilesCachedNames); }
		if (typeof tilesCachedInView !== 'undefined') { Z.Utils.arrayClear(tilesCachedInView); }
		if (typeof tilesCachedInViewNames !== 'undefined') { Z.Utils.arrayClear(tilesCachedInViewNames); }
		if (typeof tilesInView !== 'undefined') { Z.Utils.arrayClear(tilesInView); }
		if (typeof tilesInViewNames !== 'undefined') { Z.Utils.arrayClear(tilesInViewNames); }

		// ZIF & PFF support.
		if (typeof tilesRetry !== 'undefined') { Z.Utils.arrayClear(tilesRetry); }
		if (typeof tilesRetryNamesChunks !== 'undefined') { Z.Utils.arrayClear(tilesRetryNamesChunks); }
		if (typeof tilesRetryNames !== 'undefined') { Z.Utils.arrayClear(tilesRetryNames); }
		if (typeof tilesBackfillRetryNames !== 'undefined') { Z.Utils.arrayClear(tilesBackfillRetryNames); }

		// Annotation save-to-file support.
		if (typeof fullImageTilesBackfillCached !== 'undefined') { Z.Utils.arrayClear(fullImageTilesBackfillCached); }
		if (typeof fullImageTilesBackfillCachedNames !== 'undefined') { Z.Utils.arrayClear(fullImageTilesBackfillCachedNames); }
		if (typeof fullImageTilesCached !== 'undefined') {Z.Utils.arrayClear(fullImageTilesCached); }
		if (typeof fullImageTilesCachedNames !== 'undefined') {Z.Utils.arrayClear(fullImageTilesCachedNames); }
		if (typeof fullImageTilesAllCachedNames !== 'undefined') {Z.Utils.arrayClear(fullImageTilesAllCachedNames); }
	}

	function clearTierValues () {
		tierCount = 1;
		tierCurrent = 0;
		tierBackfill = 0;
		tierBackfillDynamic = false;
		backfillTresholdCached0 = false;
		backfillTresholdCached1 = false;
		backfillTresholdCached2 = false;
		if (typeof tierWs !== 'undefined') { Z.Utils.arrayClear(tierWs); }
		if (typeof tierHs !== 'undefined') { Z.Utils.arrayClear(tierHs); }
		if (typeof tierWInTiles !== 'undefined') { Z.Utils.arrayClear(tierWInTiles); }
		if (typeof tierHInTiles !== 'undefined') { Z.Utils.arrayClear(tierHInTiles); }
		if (typeof tierTileCounts !== 'undefined') { Z.Utils.arrayClear(tierTileCounts); }

		// ZIF support.
		if (typeof tierTileOffsetsStart !== 'undefined') { Z.Utils.arrayClear(tierTileOffsetsStart); }
		if (typeof tierTileOffsetsCount !== 'undefined') { Z.Utils.arrayClear(tierTileOffsetsCount); }
		if (typeof tierTileOffsetChunks !== 'undefined') { Z.Utils.arrayClear(tierTileOffsetChunks); }
		if (typeof tierTileOffsetLast !== 'undefined') { Z.Utils.arrayClear(tierTileOffsetLast); }
		if (typeof tierTileByteCountsStart !== 'undefined') { Z.Utils.arrayClear(tierTileByteCountsStart); }
		if (typeof tierTileByteCountsCount !== 'undefined') { Z.Utils.arrayClear(tierTileByteCountsCount); }
		if (typeof tierTileByteCountChunks !== 'undefined') { Z.Utils.arrayClear(tierTileByteCountChunks); }
		if (typeof tierTileByteCountLast !== 'undefined') { Z.Utils.arrayClear(tierTileByteCountLast); }

		// PFF support.
		if (typeof offsetChunks !== 'undefined') { Z.Utils.arrayClear(offsetChunks); }
		if (typeof offsetChunkBegins !== 'undefined') { Z.Utils.arrayClear(offsetChunkBegins); }
	}

	function clearDisplayValues () {
		if (wD) {
			if (typeof watermarksX !== 'undefined') { Z.Utils.arrayClear(watermarksX); }
			if (typeof watermarksY !== 'undefined') { Z.Utils.arrayClear(watermarksY); }
		}
		if (hD) {
			if (typeof hotspots !== 'undefined') { Z.Utils.arrayClear(hotspots); }
			if (typeof hotspotsMedia !== 'undefined') { Z.Utils.arrayClear(hotspotsMedia); }
			if (typeof hotspotPopups !== 'undefined') { Z.Utils.arrayClear(hotspotPopups); }
			if (hotspotList != null) {
				hotspotList.parentNode.removeChild(hotspotList);
				hotspotList = null;
				if (typeof hotspotListDP !== 'undefined') { Z.Utils.arrayClear(hotspotListDP); }
			} else {
				if (poiList != null) {
					poiList.parentNode.removeChild(poiList);
					poiList = null;
					if (typeof poiListDP !== 'undefined') { Z.Utils.arrayClear(poiListDP); }
				}
				if (labelList != null) {
					labelList.parentNode.removeChild(labelList);
					labelList = null;
					if (typeof labelListDP !== 'undefined') { Z.Utils.arrayClear(labelListDP); }
					if (typeof labelListCurrentDP !== 'undefined') { Z.Utils.arrayClear(labelListCurrentDP); }
				}
				if (noteList != null) {
					noteList.parentNode.removeChild(noteList);
					noteList = null;
					if (typeof noteListDP !== 'undefined') { Z.Utils.arrayClear(noteListDP); }
					if (typeof noteListCurrentDP !== 'undefined') { Z.Utils.arrayClear(noteListCurrentDP); }
				}
			}
		}
		if (Z.imageFilters) {
			imageFilterTimer = null;
			imageFilterBackfillTimer = null;
			imageFilterRetryTimer = null;
			imageFilterStatesConvolve = false;
			if (typeof imageFiltersApplied !== 'undefined') { Z.Utils.arrayClear(imageFiltersApplied); }
			if (typeof tileImages !== 'undefined') { Z.Utils.arrayClear(tileImages); }
			cachedCanvas = null;
			cachedCanvasFiltered = null;
			cachedCanvasBackfill = null;
			imageFilterBrightnessValue = 0;
			imageFilterContrastValue = 0;
			imageFilterSharpnessValue = 0;
			imageFilterBlurrinessValue = 0;
			imageFilterColorRedValue = 0;
			imageFilterColorGreenValue = 0;
			imageFilterColorBlueValue = 0;
			imageFilterColorRedRangeValue = 0;
			imageFilterColorGreenRangeValue = 0;
			imageFilterColorBlueRangeValue = 0;
			imageFilterColorRedRangeValue2 = 0;
			imageFilterColorGreenRangeValue2 = 0;
			imageFilterColorBlueRangeValue2 = 0;
			imageFilterGammaValue = 0;
			imageFilterGammaRedValue = 0;
			imageFilterGammaGreenValue = 0;
			imageFilterGammaBlueValue = 0;
			imageFilterHueValue = 0;
			imageFilterSaturationValue = 0;
			imageFilterLightnessValue = 0;
			imageFilterWhiteBalanceValue = 0;
			imageFilterEqualizeValue = 0;
			imageFilterNoiseValue = 0;
			imageFilterGlowValue = 0;
		}
	}

	function clearDisplays () {
		if (oD) { Z.Utils.clearDisplay(oD); }
		if (bD) { Z.Utils.clearDisplay(bD); }
		if (vD) { Z.Utils.clearDisplay(vD); }
		if (tC) { Z.Utils.clearDisplay(tC); }
		if (wD) { Z.Utils.clearDisplay(wD); }
		if (mC) { Z.Utils.clearDisplay(mC); }
		if (hD) {
			Z.Utils.clearDisplay(hD);
			hD = null;
		}
		if (annD) {
			//Z.Utils.clearDisplay(annD); // DEV NOTE: Use next line instead to delete panel DIV.
			self.clearAnnotationPanel(viewportID);
			self.setStatus('annotationPanelInitializedViewport', false);
			annD = null;
		}
		if (dD) { Z.Utils.clearDisplay(dD); }
		if (eD) { Z.Utils.clearDisplay(eD); }
		if (fC) { Z.Utils.clearDisplay(fC); }
		if (fbC) { Z.Utils.clearDisplay(fbC); }
	}

	function createDisplays (vpID) {
		if (typeof vpID === 'undefined' || vpID === null) { vpID = 0; }
		var vpIDStr = vpID.toString();

		// Create non-draggable non-moving, non-resizing deep background display for oversize
		// image temporary low-resolution fill during rapid zoom or pan while backfill and frontfill
		// tiles download. Must draw tiles on-the-fly unlike other displays.
		if (Z.useCanvas) {
			if (!oD) {
				oversizeDisplay = Z.Utils.createContainerElement('canvas', 'oversizeDisplay' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
				Z.ViewerDisplay.appendChild(oversizeDisplay);
				oD = oversizeDisplay;
				oS = oD.style;
			}
		}

		// Create masking container for displays if comparison requires limiting display to half of Viewer.
		if (Z.comparison && !cmD) {
			comparisonMaskContainer = Z.Utils.createContainerElement('div', 'comparisonMaskContainer' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			Z.ViewerDisplay.appendChild(comparisonMaskContainer);
			cmD = comparisonMaskContainer;
			cmS = cmD.style;
		}

		// Create draggable container for backfill, viewport, watermark, and hotspot displays.
		// Scaling occurs in display canvases directly or in tiles if in non-canvas browser.
		// Set position 'absolute' within parent viewerDisplay container that is set 'relative'.
		if (!cD) {
			viewportContainer = Z.Utils.createContainerElement('div', 'viewportContainer' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			if (!Z.comparison) {
				Z.ViewerDisplay.appendChild(viewportContainer);
			} else {
				comparisonMaskContainer.appendChild(viewportContainer);
			}
			cD = viewportContainer;
			cS = cD.style;
		}

		// Create background display to fill gaps between foreground tiles in viewportDisplay.
		// Note that using canvas is practical because backfill tier is low res and thus small and canvas is CSS scaled large, not internally scaled large or drawn large.
		if (!bD) {
			viewportBackfillDisplay = Z.Utils.createContainerElement(Z.useCanvas ? 'canvas' : 'div', 'viewportBackfillDisplay' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(viewportBackfillDisplay);
			bD = viewportBackfillDisplay;
			bS = bD.style;
		}

		// Create canvas or div container for image tiles.
		if (!vD) {
			viewportDisplay = Z.Utils.createContainerElement(Z.useCanvas ? 'canvas' : 'div', 'viewportDisplay' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(viewportDisplay);
			vD = viewportDisplay;
			vS = vD.style;
		}

		// Create transition canvas, if supported, for temporary display while display canvas is updated.
		// Also create temporary canvases for unifying tile sets for new views prior to applying convolution filters.
		if (Z.useCanvas) {
			if (!tC) {
				transitionCanvas = Z.Utils.createContainerElement('canvas', 'transitionCanvas', 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
				viewportContainer.appendChild(transitionCanvas);
				tC = transitionCanvas;
				tS = tC.style;
			}
			if (Z.imageFilters) {
				if (!fbC) {
					imageFilterBackfillCanvas = Z.Utils.createContainerElement('canvas', 'imageFilterBackfillCanvas', 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
					viewportContainer.appendChild(imageFilterBackfillCanvas);
					fbC = imageFilterBackfillCanvas;
					fbS = fbC.style;
				}
				if (!fC) {
					imageFilterCanvas = Z.Utils.createContainerElement('canvas', 'imageFilterCanvas', 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
					viewportContainer.appendChild(imageFilterCanvas);
					fC = imageFilterCanvas;
					fS = fC.style;
				}
			}
		}

		// Create canvas or div container for watermarks.
		if (Z.watermarks && !wD) {
			watermarkDisplay = Z.Utils.createContainerElement('div', 'watermarkDisplay', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(watermarkDisplay);
			wD = watermarkDisplay;
			wS = wD.style;
		}

		// Create masking canvas if hotspot/label selection masking enabled.
		if (Z.maskVisible && (Z.hotspots || Z.annotations) && !mC) {
			maskCanvas = Z.Utils.createContainerElement('canvas', 'maskCanvas', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(maskCanvas);
			mC = maskCanvas;
			mS = mC.style;
			mS.display = 'none';
		}

		// Create canvas or div containers for zoom rectangle, measuring, tours, screensavers, hotspots, annotations, editing, and saving to image file.
		var displaying = ((Z.zoomRectangle || Z.measureVisible || (Z.tour && !Z.screensaver) || Z.hotspots || Z.annotations));
		var drawing = Z.useCanvas && (displaying || (Z.hotspots && Z.labelIconsInternal));
		var editing = Z.useCanvas && (Z.zoomRectangle || Z.measureVisible || Z.editMode !== null);
		var saving = drawing && Z.saveImageHandlerProvided;
		if (drawing && !dD) {
			drawingDisplay = Z.Utils.createContainerElement('canvas', 'drawingDisplay', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(drawingDisplay);
			dD = drawingDisplay;
			dS = dD.style;
		}
		if (editing && !eD) {
			editingDisplay = Z.Utils.createContainerElement('canvas', 'editingDisplay', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(editingDisplay);
			eD = editingDisplay;
			eS = eD.style;
		}
		if (displaying && !hD) {
			hotspotDisplay = Z.Utils.createContainerElement('div', 'hotspotDisplay', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(hotspotDisplay);
			hD = hotspotDisplay;
			hS = hD.style;
			Z.Utils.addEventListener(hotspotDisplay, 'mousedown', Z.Utils.preventDefault);
		}
		if (saving && !sD) {
			savingDisplay = Z.Utils.createContainerElement('canvas', 'savingDisplay', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			viewportContainer.appendChild(savingDisplay);
			sD = savingDisplay;
			sS = sD.style;
			sS.display = 'none';
		}

		// Clear prior div contents.
		if (!Z.useCanvas) {
			bD.innerHTML = '';
			vD.innerHTML = '';
		}
		if (wD) { wD.innerHTML = ''; }
		if (hD) { hD.innerHTML = ''; }
	}

	function createCanvasContexts () {
		if (Z.useCanvas) {
			if (oD) { oCtx = oD.getContext('2d'); }
			bCtx = bD.getContext('2d');
			vCtx = vD.getContext('2d');
			tCtx = tC.getContext('2d');
			if (dD) { dCtx = dD.getContext('2d'); }
			if (eD) { eCtx = eD.getContext('2d'); }
			if (mC) { mCtx = mC.getContext('2d'); }
			if (sD) { sCtx = sD.getContext('2d'); }
			if (Z.imageFilters) {
				fCtx = fC.getContext('2d');
				fbCtx = fbC.getContext('2d');
			}
		}
	}

	// DEV NOTE: Dual setSizeAndPosition functions below are workaround for undefined error on load
	// due to unhoisted function expression vs hoisted function declaration and/or IE8 limitations.
	this.setSizeAndPosition = function (width, height, left, top) {
		setSizeAndPosition(width, height, left, top);
	}

	function setSizeAndPosition (width, height, left, top) {
		// Set Viewport size and set base values or subsequent gets and sets will fail.
		if (typeof left === 'undefined' || left === null) { left = 0; }
		if (typeof top === 'undefined' || top === null) { top = 0; }

		Z.viewerW = viewW = width;
		Z.viewerH = viewH = height;

		// If displaying two viewports, adjust widths and horizontal positions.
		if (Z.comparison) {
			var viewHalf = width / 2;
			viewW = width = viewHalf;
		}

		displayW = viewW * PAN_BUFFER;
		displayH = viewH * PAN_BUFFER;

		// Prevent canvas sizes too large if working with image set, image is unconverted in Firefox, or for lower limits of other browsers. Additional limit for
		// unconverted images to actual image size plus buffer if pan contraint is non-strict. Mobile devices also limit max canvas size: 3 to 32 decoded
		// megapixels depending on device, file format, and memory. Additional limit on creation of oversize backfill display. Last test ensures canvas at least as large as view area.
		var canvasSizeMax = (Z.imageSet) ? PAN_BUFFERSIZEMAXIMAGESET : (Z.tileSource == 'unconverted' && Z.mobileDevice) ? PAN_BUFFERSIZEMAXMOBILE : (Z.tileSource == 'unconverted' && Z.browser == Z.browsers.FIREFOX) ? PAN_BUFFERSIZEMAXFIREFOX : PAN_BUFFERSIZEMAXBROWSER;
		var imgW = (Z.constrainPanStrict) ? Z.imageW : Z.imageW * 2; // Alternative implementation: Limit to Z.imageW if (Z.constrainPanStrict || (Z.imageSet && Z.tileSource == 'unconverted')).
		var imgH = (Z.constrainPanStrict) ? Z.imageH : Z.imageH * 2;  // Alternative implementation: Limit to Z.imageH if (Z.constrainPanStrict || (Z.imageSet && Z.tileSource == 'unconverted')).
		if (displayW > canvasSizeMax) { displayW = canvasSizeMax; }
		if (displayH > canvasSizeMax) { displayH = canvasSizeMax; }
		if (displayW > imgW) { displayW = imgW; }
		if (displayH > imgH) { displayH = imgH; }
		if (displayW < viewW) { displayW = viewW; }
		if (displayH < viewH) { displayH = viewH; }

		// Calculate center and edge values.
		var digits = 4;
		displayCtrX = Z.Utils.roundToFixed(displayW / 2, digits);
		displayCtrY = Z.Utils.roundToFixed(displayH / 2, digits);
		displayL = Z.Utils.roundToFixed(-((displayW - viewW) / 2) + left, digits);
		displayR = Z.Utils.roundToFixed(((displayW - viewW) / 2) + left, digits);
		displayT = Z.Utils.roundToFixed(-((displayH - viewH) / 2) + top, digits);
		displayB = Z.Utils.roundToFixed(((displayH - viewH) / 2) + top, digits);

		if (oD) {
			oD.width = viewW;
			oD.height = viewH;
			oS.width = viewW + 'px';
			oS.height = viewH + 'px';
			oS.left = '0px';
			oS.top = '0px';
		}

		// Set comparison masking container dimension and position.
		if (Z.comparison) {
			cmD.width = viewW;
			cmD.height = viewH;
			cmS.width = viewW + 'px';
			cmS.height = viewH + 'px';

			cmS.left = (vpID == 0) ? '0px' : viewW + 'px';

			cmS.top = '0px';
		}

		cD.width = displayW;
		cD.height = displayH;
		cS.width = displayW + 'px';
		cS.height = displayH + 'px';

		// Set container position. Viewport, watermark, and hotspot display values are static as they move
		// via the container. Backfill display changes position and size as it scales to support Navigator panning.
		cS.left = displayL + 'px';
		cS.top = displayT + 'px';

		// Sync viewport display size.
		vD.width = displayW;
		vD.height = displayH;
		vS.width = displayW + 'px';
		vS.height = displayH + 'px';

		// Sync watermark display size.
		if (wD) {
			wD.width = displayW;
			wD.height = displayH;
			wS.width = displayW + 'px';
			wS.height = displayH + 'px';
		}

		// Sync mask display size.
		if (mC) {
			mC.width = displayW;
			mC.height = displayH;
			mS.width = displayW + 'px';
			mS.height = displayH + 'px';
		}

		// Sync hotspot display size.
		if (hD) {
			hD.width = displayW;
			hD.height = displayH;
			hS.width = displayW + 'px';
			hS.height = displayH + 'px';
			if (hotD) {
				var listW = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTLISTWIDTH'), 10);
				var listCoords = calculateHotspotListCoords(hotspotListPosition, listW, viewW, viewH); // viewH allows for toolbar height if static in viewer display area.
				hotS.left = listCoords.x + 'px';
				hotS.top = listCoords.y + 'px';
			}
		}

		// Sync drawing display size.
		if (dD) {
			dD.width = displayW;
			dD.height = displayH;
			dS.width = displayW + 'px';
			dS.height = displayH + 'px';
		}

		// Sync editing display size.
		if (eD) {
			eD.width = displayW;
			eD.height = displayH;
			eS.width = displayW + 'px';
			eS.height = displayH + 'px';
		}

		// Position annotation display.
		if (annD) {
			var panelDims = new self.calculateAnnotationPanelDimensions(poiVisibility, labelVisibility, noteVisibility, commentVisibility);
			var panelCoords = self.calculateAnnotationPanelCoords(annotationPanelPosition, panelDims.w, panelDims.h, viewW, viewH); // viewH allows for toolbar height if static in viewer display area.
			self.sizeAndPositionAnnotationPanel(annS, panelDims.w, panelDims.h, panelCoords.x, panelCoords.y);
		}

		if (Z.imageSet) { Z.Viewer.sizeAndPositionImageSetList(); }

		// Set drawing origin coordinates to viewport display center.
		if (Z.useCanvas) {
			if (oD) {
				oCtx.translate(viewW / 2, viewH / 2);
				oCtx.save();
			}

			// Trap possible NS_ERROR_FAILURE error especially in firefox especially if working with large unconverted image.
			// DEV NOTE: Add retry or soft fail in catch in future implementation for firefox issue with large canvases.
			try {
				vCtx.translate(displayCtrX, displayCtrY);
			} catch (e) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_TRANSLATINGCANVASFORUNCONVERTEDIMAGE'), false, Z.messageDurationStandard, 'center');
			}
			vCtx.save();

			if (mC) {
				mCtx.translate(displayCtrX, displayCtrY);
				mCtx.save();
			}
			if (dD) {
				dCtx.translate(displayCtrX, displayCtrY);
				dCtx.save();
			}
			if (eD) {
				eCtx.translate(displayCtrX, displayCtrY);
				eCtx.save();
			}
		}

		// No setSizeAndPosition steps required here for non-canvas browsers because positioning
		// occurs in drawTileInHTML function based on x and y values passed in by displayTile.
	}

	this.syncViewportResize = function (imgX, imgY, imgZ, imgR) {
		self.setSizeAndPosition(Z.viewerW, Z.viewerH, 0, 0);
		self.resizeViewport(imgX, imgY, imgZ, imgR);
	}

	this.resizeViewport = function (imgX, imgY, imgZ, imgR) {
		self.validateXYZDefaults();
		self.setView(imgX, imgY, imgZ, imgR);
	}

	this.loadImageProperties = function (imgPath, netCnnctr, vpID) {
		loadImageProperties(imgPath, netCnnctr, vpID);
	};

	function loadImageProperties (imgPath, netCnnctr, vpID) {
		// Load image properties from Zoomify Image ZIF file header, folder XML file, PFF file header, or other specified tile source.
		if (Z.tileSource == 'ZoomifyImageFile') {
			loadImagePropertiesZIF(imgPath, netCnnctr, vpID);
		} else if (Z.tileSource == 'ZoomifyImageFolder') {
			var imageXMLPath = Z.Utils.cacheProofPath(imgPath + '/' + 'ImageProperties.xml');
			netCnnctr.loadXML(imageXMLPath, vpID);
		} else if (Z.tileSource == 'ZoomifyPFFFile') {
			loadImagePropertiesPFF(imgPath, netCnnctr, vpID);
		} else if (Z.tileSource == 'IIIFImageServer') {
			var imageJSONPath = imgPath + '/' + 'info.json';
			loadImagePropertiesIIIFImageServer(imageJSONPath, netCnnctr, vpID);
		} else if (Z.tileSource == 'ImageServer') {
			// Example image server protocol implementation.
			loadImagePropertiesImageServer(imgPath, netCnnctr, vpID);
		}
	}

	function loadImagePropertiesZIF (imgPath, netCnnctr, vpID) {
		// Define constants. Load enough bytes for TIF IFDs for pyramid between 2,164,260,864 x 2,164,260,864 pixels
		// and 4,294,967,296 x 4,294,967,296 pixels (assuming a tile size of 256 x 256).
		var HEADER_START_BYTE = parseFloat(Z.Utils.getResource('DEFAULT_HEADERSTARTBYTE'));
		var HEADER_END_BYTE = parseFloat(Z.Utils.getResource('DEFAULT_HEADERENDBYTEZIF'));
		netCnnctr.loadByteRange(imgPath, HEADER_START_BYTE, HEADER_END_BYTE, 'header');
	}

	function loadImagePropertiesPFF (imgPath, netCnnctr, vpID) {
		// Define constants.
		var REQUEST_TYPE = 1; // 1 = header, 2 = offset, 0 = tile.
		var HEADER_START_BYTE = Z.Utils.getResource('DEFAULT_HEADERSTARTBYTE');
		var HEADER_END_BYTE = Z.Utils.getResource('DEFAULT_HEADERENDBYTEPFF');

		// Build data request with query string and send.
		var imgPathNoDot = imgPath.replace('.', '%2E');  // Required for servlet.
		var imageXMLPath = Z.tileHandlerPathFull + '?file=' + imgPathNoDot  + '&requestType=' + REQUEST_TYPE + '&begin=' + HEADER_START_BYTE + '&end=' + HEADER_END_BYTE;
		netCnnctr.loadXML(imageXMLPath, vpID);
	}

	function loadImagePropertiesIIIFImageServer (iiifInfoPath, netCnnctr, vpID) {
		netCnnctr.loadJSON(iiifInfoPath, vpID);
	}

	function loadImagePropertiesImageServer (imgPath, netCnnctr, vpID) {
		// Example image server protocol implementation - optional implementation:
		// Image properties provided by image server.  Modify the following line to request
		// image properties according to specific 3rd party image server protocol as documented
		// by image server provider. Minimum return values required: full source image width and
		// height, and tile size if not 256x256 pixels. Additionally modify function 'parseImageXML'
		// as noted in 'Optional implementation' notes within that function.
		//var imageXMLPath = Z.tileHandlerPathFull + '?' + '...';
		//netCnnctr.loadXML(imageXMLPath, vpID);
	}

	this.parseZIFHeader = function (data) {
		clearTierValues();

		if (data[0] == 0x49 && data[1] == 0x49 && data[2] == 0x2b && data[3] == 0x00 && data[4] == 0x08 &&  data[5] == 0x00 && data[6] == 0x00 && data[7] == 0x00 && data[8] == 0x10 && data[9] == 0x00 && data[10] == 0x00 && data[11] == 0x00 && data[12] == 0x00 && data[13] == 0x00 && data[14] == 0x00 && data[15] == 0x00) {

			// Set start values.
			var ifdOffset = Z.Utils.longValue(data, 8); // First IFD.
			var tagCounter = Z.Utils.longValue(data, ifdOffset); // First tag.
			var ifdCounter = 1;

			// Set key variables and constants of Zoomify Image.
			var iW = null, iH = null, tW = null, tH = null, iTileCount = null, iByteCountCount = null, iImageCount = null, iVersion = null, iHeaderSize = null, iHeaderSizeTotal = null, iMagnification = null, iFocal = null, iQuality = null;
			iImageCount=1;  // One image per ZIF file in current release.
			iVersion=2.0;  // ZIF designation (PFF latest revision v1.8).

			// Parse ZIF header to extract tier and tile values.
			while (ifdOffset != 0) {
				for (var x = 0; x < tagCounter; x++) {
					var itemOffset = ifdOffset + 8 + x * 20;
					var tag = Z.Utils.shortValue(data, itemOffset);

					switch (tag) {
						case 256: // Image width.
							tierWs[ifdCounter - 1] = Z.Utils.intValue(data, itemOffset + 12);
							break;
						case 257: // Image height.
							tierHs[ifdCounter - 1] = Z.Utils.intValue(data, itemOffset + 12);
							break;
						case 322: // Tile width.
							// DEV NOTE: Assume equal across tiers and equal to tile height in current release.
							tW = Z.Utils.intValue(data, itemOffset + 12);
							break;
						case 323: // Tile height.
							// DEV NOTE: Assume equal across tiers and equal to tile width in current release.
							tH = Z.Utils.intValue(data, itemOffset + 12);
							break;
						case 324: // Tile offsets.
							// At itemOffset, get start of tile offsets for tier, or of tile itself if only one.
							var itemCount = tierTileOffsetsCount[ifdCounter - 1] = Z.Utils.longValue(data, itemOffset + 4);
							tierTileOffsetsStart[ifdCounter - 1] = Z.Utils.longValue(data, itemOffset + 12);
							iTileCount +=  itemCount;
							break;
						case 325: // Tile byte counts.
							// At itemOffset, get start of tile byte counts for tier, or byte count itself if only one, or two byte counts if two.
							var itemCount = tierTileByteCountsCount[ifdCounter - 1] = Z.Utils.longValue(data, itemOffset + 4);
							if (itemCount == 1) {
								tierTileByteCountsStart[ifdCounter - 1] = Z.Utils.intValue(data, itemOffset + 12);
							} else if (itemCount == 2) {
								tierTileByteCountsStart[ifdCounter - 1] = Z.Utils.intValue(data, itemOffset + 12) + ',' + Z.Utils.intValue(data, itemOffset + 16);
							} else {
								tierTileByteCountsStart[ifdCounter - 1] = Z.Utils.longValue(data, itemOffset + 12);
							}
							iByteCountCount +=  itemCount;
							break;
					}
				}
				ifdOffset = Z.Utils.longValue(data, ifdOffset + tagCounter * 20 + 8);
				tagCounter = Z.Utils.longValue(data, ifdOffset);
				ifdCounter++;
			}

			iW = tierWs[0];
			iH = tierHs[0];
			tierCount = ifdCounter - 1;

			// Invert array orders so that 0 element is thumbnail tier not source tier.
			tierWs.reverse();
			tierHs.reverse();
			tierTileOffsetsCount.reverse();
			tierTileOffsetsStart.reverse();
			tierTileByteCountsCount.reverse();
			tierTileByteCountsStart.reverse();

			// Debug option: Display ZIF header values.
			/* console.log('Width & Height: ' + iW + ' & ' + iH);
			console.log('Tile Count: ' + iTileCount);
			console.log('tierWs: ' + tierWs.toString());
			console.log('tierTileOffsetsCount: ' + tierTileOffsetsCount.toString());
			console.log('tierTileOffsetsStart: ' + tierTileOffsetsStart.toString());
			console.log('tierTileByteCountsCount: ' + tierTileByteCountsCount.toString());
			console.log('tierTileByteCountsStart: ' + tierTileByteCountsStart.toString());
			*/

			// Initialize or reinitialize Viewport.
			if (!isNaN(iW) && iW > 0 && !isNaN(iH) && iH > 0 && !isNaN(tW) && tW > 0 && !isNaN(tH) && tH > 0 && iTileCount > 0) {
				if (!self.getStatus('initializedViewport')) {
					initializeViewport(iW, iH, tW, tH, iTileCount, iVersion, iHeaderSize, iHeaderSizeTotal, iMagnification, iFocal, iQuality);
				} else {
					reinitializeViewport(iW, iH, tW, tH, iTileCount, iVersion, iHeaderSize, iHeaderSizeTotal, iMagnification, iFocal, iQuality);
				}
			} else {
				if (Z.tileSource == 'ZoomifyImageFolder') {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGEPROPERTIESXMLINVALID'), false, Z.messageDurationStandard, 'center');
				} else {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGEPROPERTIESINVALID'), false, Z.messageDurationStandard, 'center');
				}
			}
		}
	}

	this.parseZIFOffsetChunk = function (data, chunkID) {
		var index = Z.Utils.arrayIndexOfObjectValue(tierTileOffsetChunks, 'chunkID', chunkID);
		if (index != -1) {
			tierTileOffsetChunks[index].chunk = data;
			selectTilesRetryZIF(chunkID, 'offset');
		}
	}

	this.parseZIFByteCountChunk = function (data, chunkID) {
		var index = Z.Utils.arrayIndexOfObjectValue(tierTileByteCountChunks, 'chunkID', chunkID);
		if (index != -1) {
			tierTileByteCountChunks[index].chunk = data;
			selectTilesRetryZIF(chunkID, 'byteCount');
		}
	}

	this.parseZIFImage = function (data, tile, target) {
		var src = 'data:image/jpeg;base64,' + Z.Utils.encodeBase64(data);
		var loadHandler;
		if (target == 'image-display') {
			loadHandler = (self.getStatus('imageSaving')) ? onTileLoadToSave : onTileLoad;
		} else if (target == 'image-backfill') {
			loadHandler = (self.getStatus('imageSaving')) ? onTileBackfillLoadToSave : onTileBackfillLoad;
		} else if (target == 'navigator') {
			loadHandler = Z.Navigator.initializeNavigator;
		} else if (target == 'gallery') {
			loadHandler = Z.Gallery.initializeGallery;
		}
		var func = Z.Utils.createCallback(null, loadHandler, tile);
		Z.Utils.createImageElementFromBytes(src, func);
	}

	this.parseImageXML = function (xmlDoc, callback) {
		parseImageXML(xmlDoc, callback);
	}

	function parseImageXML (xmlDoc, callback) {
		clearTierValues();

		if (typeof self.getStatus === 'undefined') {
			var viewportInitTimer = window.setTimeout( function () { parseImageXML(xmlDoc, callback); }, 100);
		} else {
			// Get key properties of Zoomify Image and initialize Viewport.
			var iW = null, iH = null, tW = null, tH = null, iTileCount = null, iImageCount = null, iVersion = null, iHeaderSize = null, iHeaderSizeTotal = null, iMagnification = null, iFocal = null, iQuality = null;

			if (Z.tileSource == 'ZoomifyImageFolder') {
				iW = parseInt(xmlDoc.documentElement.getAttribute('WIDTH'), 10);
				iH = parseInt(xmlDoc.documentElement.getAttribute('HEIGHT'), 10);
				iTileCount = parseInt(xmlDoc.documentElement.getAttribute('NUMTILES'), 10);
				iImageCount = parseInt(xmlDoc.documentElement.getAttribute('NUMIMAGES'), 10);
				iVersion = parseInt(xmlDoc.documentElement.getAttribute('VERSION'), 10);
				tW = tH = parseInt(xmlDoc.documentElement.getAttribute('TILESIZE'), 10);
			} else if (Z.tileSource == 'ZoomifyPFFFile') {
				iW = parseInt(xmlDoc.documentElement.getAttribute('WIDTH'), 10);
				iH = parseInt(xmlDoc.documentElement.getAttribute('HEIGHT'), 10);
				tW = tH = parseInt(xmlDoc.documentElement.getAttribute('TILESIZE'), 10);
				iTileCount = parseInt(xmlDoc.documentElement.getAttribute('NUMTILES'), 10);
				iImageCount = parseInt(xmlDoc.documentElement.getAttribute('NUMIMAGES'), 10);
				iVersion = parseInt(xmlDoc.documentElement.getAttribute('VERSION'), 10);
				iHeaderSize = parseInt(xmlDoc.documentElement.getAttribute('HEADERSIZE'), 10);
				iHeaderSizeTotal = 904 + 136 + 20 + iHeaderSize;
			} else if (Z.tileSource == 'IIIFImageServer') {
				// Allow for partial value set. All fields but image width and height will need to be internally calculated.
				iW = parseInt(xmlDoc.documentElement.getAttribute('WIDTH'), 10);
				iH = parseInt(xmlDoc.documentElement.getAttribute('HEIGHT'), 10);
				iTileCount = iImageCount = iVersion = tW = tH = null;
			} else if (Z.tileSource == 'ImageServer') {
				// Allow for partial XML where submission is via zImageProperties HTML parameter
				// because in that context all fields but image width and height will be optional.
				iW = parseInt(xmlDoc.documentElement.getAttribute('WIDTH'), 10);
				iH = parseInt(xmlDoc.documentElement.getAttribute('HEIGHT'), 10);
				var tempTSz = xmlDoc.documentElement.getAttribute('TILESIZE');
				tW = (Z.Utils.stringValidate(tempTSz)) ? parseInt(tempTSz, 10) : TILE_WIDTH;
				tH = (Z.Utils.stringValidate(tempTSz)) ? parseInt(tempTSz, 10) : TILE_HEIGHT;
				var tempMag = xmlDoc.documentElement.getAttribute('MAGNIFICATION');
				iMagnification = (Z.Utils.stringValidate(tempMag)) ? parseInt(tempMag, 10) : Z.sourceMagnification;
				var tempFoc = xmlDoc.documentElement.getAttribute('FOCAL');
				iFocal = (Z.Utils.stringValidate(tempFoc)) ? parseInt(tempFoc, 10) : Z.focal;
				var tempQual = xmlDoc.documentElement.getAttribute('QUALITY');
				iQuality = (Z.Utils.stringValidate(tempQual)) ? parseInt(tempQual, 10) : Z.quality;

				// Optional implementation: Add additional instructions here to receive image server
				// response with necessary image properties. Set values iW and iH, and also tSz if
				// tile size not 256x256 pixels for processing by remaining steps within this function.
			}

			// DEV NOTE: Optional HTML parameter custom tile dimensions override defaults, XML values, or server provided values.
			if (Z.tileW !== null) { tW = Z.tileW; }
			if (Z.tileH !== null) { tH = Z.tileH; }

			// Allow for minimal cross-domain XML and incorrectly edited image folder XML.
			if (Z.tileSource == 'ZoomifyImageFolder' || Z.tileSource == 'IIIFImageServer' || Z.tileSource == 'ImageServer') {
				if (tW === null || isNaN(tW)) { tW = TILE_WIDTH; }
				if (tH === null || isNaN(tH)) { tH = TILE_HEIGHT; }
				if (iTileCount === null || isNaN(iTileCount)) { iTileCount = 1; }
			}

			if (!isNaN(iW) && iW > 0 && !isNaN(iH) && iH > 0 && !isNaN(tW) && tW > 0 && !isNaN(tH) && tH > 0 && iTileCount > 0) {
				if (!self.getStatus('initializedViewport')) {
					initializeViewport(iW, iH, tW, tH, iTileCount, iVersion, iHeaderSize, iHeaderSizeTotal, iMagnification, iFocal, iQuality, callback);
				} else {
					reinitializeViewport(iW, iH, tW, tH, iTileCount, iVersion, iHeaderSize, iHeaderSizeTotal, iMagnification, iFocal, iQuality, callback);
				}
			} else {
				if (Z.tileSource == 'ZoomifyImageFolder') {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGEPROPERTIESXMLINVALID'), false, Z.messageDurationStandard, 'center');
				} else {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGEPROPERTIESINVALID'), false, Z.messageDurationStandard, 'center');
				}
			}
		}
	}

	function calculateTierValues () {
		if (Z.tileSource == 'unconverted') {
			calculateTierValuesUnconvertedMethod();
		} else if (Z.tileSource == 'ZoomifyImageFile') {
			calculateTierValuesZIFMethod();
		} else {
			var tilesCounted = calculateTierValuesSecondMethod();
			if (tilesCounted != TILE_COUNT && (Z.tileSource == 'ZoomifyImageFolder' || Z.tileSource == 'ZoomifyImageFile' || Z.tileSource == 'ZoomifyPFFFile')) {
				tilesCounted = calculateTierValuesFirstMethod();
				if (tilesCounted != TILE_COUNT) {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGETILECOUNTINVALID'), false, Z.messageDurationStandard, 'center');
				}
			}
		}
	}

	function calculateTierValuesUnconvertedMethod () {
		tierWs[0] = Z.imageW;
		tierHs[0] = Z.imageH;
		tierWInTiles[0] = 1;
		tierHInTiles[0] = 1;
		tierTileCounts[0] = 1;
		tierCount = 1;
	}

	// ZIF files contain tier width, height, and tile counts.  Values extracted
	// in function parseZIFHeader.  Minimal additional values derived here.
	function calculateTierValuesZIFMethod () {
		for (var t = tierCount - 1; t >= 0; t--) {
			tierWInTiles[t] = Math.ceil(tierWs[t] / TILE_WIDTH);
			tierHInTiles[t] = Math.ceil(tierHs[t] / TILE_HEIGHT);
			tierTileCounts[t] = tierWInTiles[t] * tierHInTiles[t];
		}
	}

	function calculateTierValuesSecondMethod () {
		// Determine the number of tiers.
		var tempW = Z.imageW;
		var tempH = Z.imageH;
		while (tempW > TILE_WIDTH || tempH > TILE_HEIGHT) {
			tempW = tempW / 2;
			tempH = tempH / 2;
			tierCount++;
		}

		// Determine and record dimensions of each image tier.
		tempW = Z.imageW;
		tempH = Z.imageH;
		var tileCounter = 0;
		for (var t = tierCount - 1; t >= 0; t--) {
			tierWs[t] = tempW;
			tierHs[t] = tempH;
			tierWInTiles[t] = Math.ceil(tierWs[t] / TILE_WIDTH);
			tierHInTiles[t] = Math.ceil(tierHs[t] / TILE_HEIGHT);
			tierTileCounts[t] = tierWInTiles[t] * tierHInTiles[t];
			tempW = tempW / 2;
			tempH = tempH / 2;

			tileCounter += tierTileCounts[t];
		}

		// Debug option: console.log('New method: ' + tileCounter + '  ' + TILE_COUNT);
		return tileCounter;
	}

	function calculateTierValuesFirstMethod () {
		// Clear values from prior calculation attempt.
		tierWs = [];
		tierHs = [];
		tierWInTiles = [];
		tierHInTiles = [];
		tierCount = 1;

		// Determine the number of tiers.
		var pyramidType = 'DIV2';
		var tempW = Z.imageW;
		var tempH = Z.imageH;
		var divider = 2;
		while (tempW > TILE_WIDTH || tempH > TILE_HEIGHT) {
			if (pyramidType == 'Div2') {
				tempW = Math.floor(tempW / 2);
				tempH = Math.floor(tempH / 2);
			} else if (pyramidType == 'Plus1Div2') {
				tempW = Math.floor((tempW+1) / 2);
				tempH = Math.floor((tempH+1) / 2);
			} else {
				tempW = Math.floor(Z.imageW / divider)
				tempH = Math.floor(Z.imageH / divider);
				divider *= 2;
				if (tempW % 2) { tempW++; }
				if (tempH % 2) { tempH++; }
			}
			tierCount++;
		}

		// Determine and record dimensions of each image tier.
		tempW = Z.imageW;
		tempH = Z.imageH;
		divider = 2;
		tileCounter = 0;
		for (var t = tierCount - 1; t >= 0; t--) {
			tierWInTiles[t] = Math.floor(tempW / TILE_WIDTH);
			if (tempW % TILE_WIDTH) { tierWInTiles[t]++; }
			tierHInTiles[t] = Math.floor(tempH / TILE_HEIGHT);
			if (tempH % TILE_HEIGHT) { tierHInTiles[t]++; }
			tierTileCounts[t] = tierWInTiles[t] * tierHInTiles[t];

			tileCounter += tierTileCounts[t];

			tierWs[t] = tempW;
			tierHs[t] = tempH;
			if (pyramidType == 'Div2') {
				tempW = Math.floor(tempW / 2);
				tempH = Math.floor(tempH / 2);
			} else if (pyramidType == 'Plus1Div2') {
				tempW = Math.floor((tempW + 1) / 2);
				tempH = Math.floor((tempH + 1) / 2);
			} else {
				tempW = Math.floor(Z.imageW / divider)
				tempH = Math.floor(Z.imageH / divider);
				divider *= 2;
				if (tempW % 2) { tempW++; }
				if (tempH % 2) { tempH++; }
			}
		}

		// Debug option: console.log('Old method: ' + tileCounter + '  ' + TILE_COUNT);
		return tileCounter;
	}

	this.validateXYZDefaults = function (override) {
		if (override) { Z.Utils.resetParametersXYZ(Z.parameters); }

		// Get default values.
		var iX = parseFloat(Z.Utils.getResource('DEFAULT_INITIALX'));
		var iY = parseFloat(Z.Utils.getResource('DEFAULT_INITIALY'));
		var iZ = parseFloat(Z.Utils.getResource('DEFAULT_INITIALZOOM'));
		var iR = parseFloat(Z.Utils.getResource('DEFAULT_INITIALR'));
		var mnZ = parseFloat(Z.Utils.getResource('DEFAULT_MINZOOM'));
		var mxZ = parseFloat(Z.Utils.getResource('DEFAULT_MAXZOOM'));
		var niX = !isNaN(iX) ? iX : null;
		var niY = !isNaN(iY) ? iY : null;
		var niZ = !isNaN(iZ) ? iZ : null;
		var niR = !isNaN(iR) ? iR : null;
		var nmnZ = !isNaN(mnZ) ? mnZ : null;
		var nmxZ = !isNaN(mxZ) ? mxZ : null;

		// Set default values for all or only specific variables, where parameters are not set.
		if (Z.bookmarksGet) {
			if (!Z.initialX) { Z.initialX = niX; }
			if (!Z.initialY) { Z.initialY = niY; }
			if (!Z.initialZ) { Z.initialZ = niZ; }
			if (!Z.initialR) { Z.initialR = niR; }
			if (!Z.minZ) { Z.minZ = nmnZ; }
			if (!Z.maxZ) { Z.maxZ = nmxZ; }

		} else if (Z.tileSource == 'IIIFImageServer') {
			// Calculate center for initial view using IIIF region x and y values.
			if (Z.iiifRegion) {
				var regionValues = Z.iiifRegion.split(',');
				var sizeValues = Z.iiifSize.split(',');
				Z.initialX = Math.round(parseFloat(regionValues[0]) + parseFloat(regionValues[2]) / 2);
				Z.initialY = Math.round(parseFloat(regionValues[1]) + parseFloat(regionValues[3]) / 2);
				Z.initialZ = Math.round((parseFloat(sizeValues[0]) / parseFloat(regionValues[2])) * 100) / 100;
				Z.initialR = parseInt(Z.iiifRotation, 10);
			}

		} else if (!Z.parameters) {
			Z.initialX = niX;
			Z.initialY = niY;
			Z.initialZ = niZ;
			Z.initialR = niR;
			Z.minZ = nmnZ;
			Z.maxZ = nmxZ;

		} else {
			if (!Z.parameters.zInitialX) {  Z.initialX = niX; }
			if (!Z.parameters.zInitialY) {  Z.initialY = niY; }
			if (!Z.parameters.zInitialZoom) {  Z.initialZ = niZ; }
			if (!Z.parameters.zInitialRotation) {  Z.initialR = niR; }
			if (!Z.parameters.zMinZoom) {  Z.minZ = nmnZ; }
			if (!Z.parameters.zMaxZoom) {  Z.maxZ = nmxZ; }
		}

		// Set pan center point as default if required.
		if (Z.initialX === null) { Z.initialX = Z.imageW / 2; }
		if (Z.initialY === null) { Z.initialY = Z.imageH / 2; }

		// Set defaults if required.
		Z.fitZ = self.calculateZoomToFit(null, null, 0);
		Z.fillZ = self.calculateZoomToFill(null, null, 0);
		var currentR = (self.getStatus('initializedViewport')) ? self.getRotation() : Z.initialR;
		var zFitR = self.calculateZoomToFit(null, null, currentR);
		var zFillR = self.calculateZoomToFill(null, null, currentR);

		// Constrain zoom-to-fit and zoom-to-fill to max zoom if set by parameter, or to 1 if viewing unconverted image.
		if (Z.fitZ > 1) {
			if (Z.maxZ !== null) {
				if (Z.fitZ > Z.maxZ) { Z.fitZ = Z.maxZ; }
			} else if (Z.tileSource == 'unconverted') {
				Z.fitZ = 1;
			}
		}
		if (Z.fillZ > 1) {
			if (Z.maxZ !== null) {
				if (Z.fillZ > Z.maxZ) { Z.fillZ = Z.maxZ; }
			} else if (Z.tileSource == 'unconverted') {
				Z.fillZ = 1;
			}
		}

		// Set min and max values if not set by parameter.
		if (Z.minZ === null || Z.minZ == -1) {
			Z.minZ = Z.fitZ;
		} else if (Z.minZ == 0) {
			Z.minZ = Z.fillZ;
		}
		if (Z.maxZ === null || Z.maxZ == -1) { Z.maxZ = 1; }

		// Constrain initial zoom within fit or fill, rotated fit or fill, and min and max zoom.
		if (Z.initialZ === null || Z.initialZ == -1) {
			Z.initialZ = zFitR;
		} else if (Z.initialZ == 0) {
			Z.initialZ = zFillR;
		}
		if (Z.initialZ < Z.minZ) { Z.initialZ = Z.minZ; }
		if (Z.initialZ > Z.maxZ) { Z.initialZ = Z.maxZ; }
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: GET & SET FUNCTIONS :::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getViewW = function () {
		return viewW;
	}

	this.getViewH = function () {
		return viewH;
	}

	this.getDisplayW = function () {
		return displayW;
	}

	this.getDisplayH = function () {
		return displayH;
	}

	// Support imageSet viewing.
	this.getImagePath = function () {
		return imagePath;
	}

	// Support non-imageSet viewing.
	this.setImagePath = function (value) {
		imagePath = value;
	}

	this.getViewportID = function () {
		return viewportID;
	}

	this.getTierCount = function () {
		return tierCount;
	}

	this.getTileW = function () {
		return TILE_WIDTH;
	}

	this.getTileH = function () {
		return TILE_HEIGHT;
	}

	this.getTierCurrent = function () {
		return tierCurrent;
	}

	this.getTierBackfill = function () {
		return tierBackfill;
	}

	this.getTierBackfillDynamic = function () {
		return tierBackfillDynamic;
	}

	this.getTierBackfillOversize = function () {
		return tierBackfillOversize;
	}

	this.getTierScale = function () {
		return tierScale;
	}

	this.getX = function (recalc) {
		var deltaX = parseFloat(cS.left) - displayL;
		var currentZ = self.getZoom(recalc);
		var currentX = imageX - (deltaX / currentZ);
		return currentX;
	}

	this.getY = function (recalc) {
		var deltaY = parseFloat(cS.top) - displayT;
		var currentZ = self.getZoom(recalc);
		var currentY = imageY - (deltaY / currentZ);
		return currentY;
	}

	// Returns decimal value.
	this.getZoom = function (recalc) {
		var tierScaleCurr = tierScale;
		if (recalc) { tierScaleCurr = tierScale * parseFloat(vS.width) / displayW; }
		var currentZ = convertTierScaleToZoom(tierCurrent, tierScaleCurr);
		return currentZ;
	}

	// DEV NOTE: Returns stored value rather than current value. Processing of CSS tranform matrix in development.
	// Needed for general access and for comparison viewing when viewports not sync'd.
	this.getRotation = function (recalc) {
		return Z.imageR;
	}

	this.getCoordinates = function () {
		var currentCoords = new Z.Utils.Point(self.getX(), self.getY());
	}

	this.getCoordinatesBookmark = function (recalc, iiifProtocol) {
		var bookmarkQueryString = '';
		if (iiifProtocol) {
			bookmarkQueryString = '?' + self.getViewCoordinatesIIIFString(recalc, null, 'bookmark');
		} else {
			bookmarkQueryString = '?' + self.getViewCoordinatesString(recalc);
		}
		return bookmarkQueryString;
	}

	this.getViewCoordinatesString = function (recalc) {
		var xStr = 'x=' + Math.round(self.getX(recalc)).toString();
		var yStr = '&y=' + Math.round(self.getY(recalc)).toString();
		var zStr = '&z=' + Math.round(self.getZoom(recalc) * 100).toString();
		var r = Math.round(self.getRotation(recalc));
		var rStr = (r == 0) ? '' : '&r=' + r.toString();
		var coordsString = xStr + yStr + zStr + rStr;
		return coordsString;
	}

	this.getCoordinatesFull = function (recalc) {
		return new Z.Utils.Coordinates(self.getX(recalc), self.getY(recalc), self.getZoom(recalc), self.getRotation(recalc));
	}

	this.getCoordinatesDisplayFull = function () {
		return new Z.Utils.CoordinatesDisplayStyle(cS.left, cS.top, vS.width, vS.height, vS.left, vS.top, bS.width, bS.height, bS.left, bS.top, cS.rotation);
	}

	this.getTiersScaleUpMax = function () {
		return TIERS_SCALE_UP_MAX;
	}

	this.getTiersScaleDownMax = function () {
		return TIERS_SCALE_DOWN_MAX;
	}

	this.getTilesCacheMax = function () {
		return TILES_CACHE_MAX;
	}

	this.getTierWs = function () {
		return tierWs.join(',');
	}

	this.getTierHs = function () {
		return tierHs.join(', ');
	}

	this.getTierTileCounts = function () {
		return tierTileCounts.join(', ');
	}

	this.getTilesToLoad = function () {
		return tilesToLoadTotal;
	}

	this.getTilesLoadingNames = function () {
		var tilesLoading = (tilesLoadingNames.join(', ') == '') ? 'Current view loading complete' : tilesLoadingNames.join(', ');
		return tilesLoading;
	}

	// Progress functions track tiles to display, load, etc. Tiles 'waiting' are loaded but not displayed, therefore, not drawn.
	this.getTilesToDraw = function () {
		return tilesWaiting;
	}

	this.getConstrainPan = function (value) {
		return Z.constrainPan;
	}

	this.setConstrainPan = function (value) {
		Z.constrainPan = (value != '0');
		Z.constrainPanLimit = parseInt(value, 10);
		Z.constrainPanStrict = (value == '3');
		if (Z.constrainPan) { self.toggleConstrainPan(true); }
	}

	this.getSmoothPan = function () {
		return Z.smoothPan;
	}

	this.setSmoothPan = function (value) {
		Z.smoothPan = value;
	}

	this.getSmoothPanEasing = function () {
		return Z.smoothPanEasing;
	}

	this.setSmoothPanEasing = function (value) {
		Z.smoothPanEasing = value;
	}

	this.getSmoothPanGlide = function () {
		return Z.smoothPanGlide;
	}

	this.setSmoothPanGlide = function (value) {
		Z.smoothPanGlide = value;
	}

	this.getSmoothZoom = function () {
		return Z.smoothZoom;
	}

	this.setSmoothZoom = function (value) {
		Z.smoothZoom = value;
	}

	this.getSmoothZoomEasing = function () {
		return Z.smoothZoomEasing;
	}

	this.setSmoothZoomEasing = function (value) {
		Z.smoothZoomEasing = value;
	}

	this.setCoordinatesDisplayVisibility = function (visible) {
		if (visible) {
			Z.Utils.addEventListener(document, 'mousemove', displayEventsCoordinatesHandler);
			Z.Utils.addEventListener(document, 'mousedown', displayEventsCoordinatesHandler);
		} else {
			Z.coordinatesVisible = false;
			Z.Utils.removeEventListener(document, 'mousemove', displayEventsCoordinatesHandler);
			Z.Utils.removeEventListener(document, 'mousedown', displayEventsCoordinatesHandler);
		}
	}

	this.setTourPath = function (tourPath, noReload) {
		self.setHotspotPath(tourPath, noReload);
	}

	this.setHotspotPath = function (hotspotPath, noReload) {
		if (typeof hotspotPath !== 'undefined' && !Z.Utils.stringValidate(hotspotPath)) {
			Z.hotspotPath = null;
			Z.hotspotFolder = null;
			self.deleteAllHotspots();
		} else {
			Z.hotspotPath = Z.Utils.stringRemoveTrailingSlashCharacters(hotspotPath);
			Z.hotspotFolder = Z.hotspotPath;
			if (Z.hotspotPath.toLowerCase().substring(Z.hotspotPath.length - 4, Z.hotspotPath.length) == '.xml') {
				Z.hotspotFolder = Z.hotspotFolder.substring(0, Z.hotspotFolder.lastIndexOf('/'));
			}
			if (!noReload) {
				self.deleteAllHotspots();
				loadHotspotsOrAnnotationsData(viewportID);
			}
		}
	}

	this.getHotspotCurrentID = function () {
		return hotspotCurrentID;
	}

	this.getHotspotCurrentIDExternal = function () {
		var currIDInt = self.getHotspotCurrentID();
		currIDExt = hotspots[currIDInt].id;
		return currIDExt;
	}

	this.getHotspots = function () {
		return hotspots;
	}

	this.setHotspots = function (hotsArr) {
		hotspots = hotsArr.slice(0);
	}

	this.setAnnotationPath = function (annotationPath, noReload) {
		if (typeof annotationPath === 'undefined' || !Z.Utils.stringValidate(annotationPath)) {
			Z.annotationPath = null;
			Z.annotationFolder = null;
			self.deleteAllAnnotations();
			Z.annotations = false;
		} else {
			Z.annotationPath = Z.Utils.stringRemoveTrailingSlashCharacters(annotationPath);
			Z.annotationFolder = Z.annotationPath;
			var annotPathLower = Z.annotationPath.toLowerCase();
			if ((annotPathLower.substring(Z.annotationPath.length - 5, Z.annotationPath.length) != '.json') && (annotPathLower.substring(Z.annotationPath.length - 4, Z.annotationPath.length) != '.xml')) {
				Z.annotationPath = Z.annotationPath + '/' + Z.Utils.getResource('DEFAULT_ANNOTATIONSXMLFILE');
			}
			if (annotPathLower.substring(Z.annotationPath.length - 4, Z.annotationPath.length) == '.xml') {
				Z.annotationFolder = Z.annotationFolder.substring(0, Z.annotationFolder.lastIndexOf('/'));
			}
			Z.annotations = true;
			if (!noReload) {
				self.deleteAllAnnotations();
				loadHotspotsOrAnnotationsData(viewportID);
			}
		}
	}

	this.getAnnotationsXML = function () {
		annotationsXML = updateAnnotationsXML(annotationsXML);
		return annotationsXML;
	}

	this.setAnnotationsXML = function (annotsXML) {
		annotationsXML = annotsXML;
	}

	// Debug option: Call this from function buttonEventsManager.
	this.testSetAnnotationPath = function () {
		self.setAnnotationPath('Assets/Annotations/annotations2.xml');
	}

	this.setXMLCallbackFunction = function (xmlParsingFunction) {
		Z.xmlCallbackFunction = xmlParsingFunction;
	}

	this.setLabelsClickDrag = function (draggable) {
		Z.labelsClickDrag = draggable;
	}

	// Support imageSet viewing.
	this.setVisibility = function (visible) {
		visibility(visible);
	}

	// Support imageSet viewing.
	function visibility (visible) {
		var dispValue = (visible) ? 'inline-block' : 'none';
		if (oversizeDisplay && !oS) { oS = oversizeDisplay.style; }
		if (oS) { oS.display = dispValue; }
		if (viewportContainer && !cS) { cS = viewportContainer.style; }
		if (cS) { cS.display = dispValue; }
	}

	// Support overlays. Ensure value is between 0 and 1. If far over 1 assume entered as range 1 to 100 and correct.
	this.setOpacity = function (percentage) {
		percentage = (percentage >= 2) ? (percentage / 100) : (percentage < 0) ? 0 : (percentage > 1) ? 1 : percentage;
		Z.Utils.setOpacity(viewportContainer, percentage);
	}

	this.showLists = function (visible) {
		var visValue = (visible) ? 'visible' : 'hidden';
		if (imageList) {
			self.setImageListVisibilty(visValue);
			if (Z.comparison) { Z.Viewport1.setImageListVisibilty(visValue); }
		}
		if (Z.hotspots) { Z.Viewer.setVisibilityHotspotChoiceList(visible, viewportID.toString()); }
		if (slideList) { slideList.style.visibility = visValue; }
		if (Z.imageSet && !Z.comparison) { Z.Viewer.setVisibilityImageSetChoiceList(visible); }
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::: CORE FUNCTIONS ::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Precache backfill tiers to ensure fast low-res background. Delay some precaching to speed image set display.
	this.precacheBackfillTiles = function (delayed) {
		if (!delayed) {
			precacheTierTileNames(backfillChoice0, tilesBackfillCachedNames);
			backfillTresholdCached0 = true;
		}
		if ((!Z.imageSet || Z.comparison || vpID == Z.imageSetStart || delayed) && tierCount > backfillTreshold1) {
			precacheTierTileNames(backfillChoice1, tilesBackfillCachedNames);
			backfillTresholdCached1 = true;
			if (tierCount > backfillTreshold2) {
				precacheTierTileNames(backfillChoice2, tilesBackfillCachedNames);
				backfillTresholdCached2 = true;
			}
			self.setStatus('backfillPrecachedViewport', true);
		}

		tilesBackfillCachedNames.sort();
		tilesBackfillCachedNames = Z.Utils.arrayUnique(tilesBackfillCachedNames);
		tilesBackfillDisplayingNames = tilesBackfillCachedNames.slice(0);

		self.traceDebugValues('tilesBackfillToPrecache', null, tilesBackfillDisplayingNames.length);
		loadNewTiles(tilesBackfillCachedNames, onTileBackfillLoad, 'simple', 'image-backfill');
	}

	function precacheTierTileNames (tier, cacheArr) {
		var tierColumnR = tierWInTiles[tier] - 1;
		var tierRowB = tierHInTiles[tier] - 1;
		for (var columnCntr = 0; columnCntr <= tierColumnR; columnCntr++) {
			for (var rowCntr = 0; rowCntr <= tierRowB; rowCntr++) {
				cacheArr[cacheArr.length] = tier + '-' + columnCntr + '-' + rowCntr;
			}
		}
	}

	this.preloadTiles = function (draw) {
		if (Z.imageSet) {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_PRELOADINGIMAGESET-LOADINGTILES'), false, Z.messageDurationLong, 'center');
			self.updateView(true, true);
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_PRELOADINGONEIMAGE-LOADINGTILES'), false, Z.messageDurationLong, 'center');
			Z.Utils.arrayClear(tilesLoadingNames);
			for (var i = 0, j = tierCount; i < j; i++) {
				var bBox = self.getViewportDisplayBoundingBoxInTiles(i, null, true, true);
				for (var columnCntr = bBox.l, tR = bBox.r; columnCntr <= tR; columnCntr++) {
					for (var rowCntr = bBox.t, tB = bBox.b; rowCntr <= tB; rowCntr++) {
						var tileName = i + '-' + columnCntr + '-' + rowCntr;
						tilesLoadingNames[tilesLoadingNames.length] = tileName;
					}
				}
			}
			if (tilesLoadingNames.length > 0 ) {
				var loadStart = new Date().getTime();
				for (var i = 0, j = tilesLoadingNames.length; i < j; i++) {
					var tileName = tilesLoadingNames[i];
					if (tileName) {
						var tile = new Tile(tileName, 'image-display');
						loadTile(tile, loadStart, onTileLoad);
					}
				}
			}
		}
	}

	function updateViewWhilePanning (stepX, stepY) {
		// Streamlined version of updateView code (which is called in full form on pan end).
		// DEV NOTE: Updating tiles while panning disabled. Requires optimization.
	}

	// Main drawing function called after every change of view.  First reposition and rescale backfill, viewport and related
	// displays to transfer any panning and/or scaling from container and CSS values to canvas or tile image values.
	this.updateView = function (override, preloading) {
	
		if (typeof vpID === 'undefined' || vpID === null) { vpID = 0; }

		// If switching comparison viewports and not sync'd, ensure globals not sync'd.
		if (vpID != Z.viewportCurrentID && !override) {
			var viewportComp = Z['Viewport' + vpID.toString()];
			Z.imageX = viewportComp.getX(true);
			Z.imageY = viewportComp.getY(true);
			Z.imageZ = viewportComp.getZoom(true);
			Z.imageR = viewportComp.getRotation(true);
		}

		// Get values to ensure action is needed and for callback validation at completion of function.
		var userInteracting = (Z.mouseIsDown || Z.buttonIsDown || Z.keyIsDown || Z.mouseWheelIsDown);
		var viewZoomed = (tierScale != tierScalePrior || self.getZoom() != Z.imageZ || Z.imageZ != Z.priorZ);
		var viewPanned = (parseFloat(cS.left) != displayL || parseFloat(cS.top) != displayT || self.getX() != Z.imageX || self.getY() != Z.imageY);
		var viewFullExiting = Z.fullViewPrior;

		if (viewZoomed || viewPanned || viewFullExiting || (typeof override !== 'undefined' && override && (!userInteracting || Z.animation)) || (typeof preloading !== 'undefined' && preloading)) {

			// Record prior X, Y, Z, and R values.
			recordPriorViewCoordinates();

			var changeBuffer = 1; // Update current viewport backfill, and if viewing imageSet, backfill for viewports before and after.
			if (Z.comparison || Z.overlays || !Z.imageSet || !Z.Viewer.getStatus('readyViewer') || (vpID > Z.viewportCurrentID - changeBuffer && vpID < Z.viewportCurrentID + changeBuffer) || preloading) {

				// Recenter position of container of displays and reset any scaling of canvases or
				// tile image elements. This prepares all objects for new content.
				resetDisplays(override);

				// If zooming, change viewport and backfill tiers if necessary.
				var delayClear = false;

				if ((typeof override !== 'undefined' && override) || tierScale != tierScalePrior || self.getZoom() != Z.imageZ || !self.getStatus('initializedViewport') || preloading) {
					selectTier();
					if (Z.tileSource != 'unconverted') {
						selectBackfillTier();
						syncImageFilterCanvas('backfill');
						redisplayCachedTiles(bD, tierBackfill, tilesBackfillCached, 'simple', false, '2. Updating view: changing tier - backfill');
					}
					if (!override && TILES_CACHE_MAX > 0) { delayClear = true; }
				} else {
					self.traceDebugValues('updateView-noChange');
				}

				// If zooming or panning, refill viewport with cached tiles or load new tiles. However, if no new tiles needed and convolution filter applied then tiles
				// have been drawn to temp canvas from cache and must now be filtered as one data object and then drawn to viewport display canvas.
				if (Z.tileSource != 'unconverted' && tierBackfillDynamic) {
					selectTiles(true);
				} else {
					if (oD) { Z.Utils.clearDisplay(oD); }
				}
			}
					
			// Update current viewport frontfill, even if viewing imageSet. Also update second viewport if comparison viewing.
			if (vpID == Z.viewportCurrentID || Z.comparison || Z.overlays || !Z.imageSet || preloading) {

				if (Z.tileSource != 'unconverted') {
					selectTiles();
					syncImageFilterCanvas('frontfill');
					redisplayCachedTiles(vD, tierCurrent, null, 'centerOut', delayClear, '3. Updating view: prior to loading of any new tiles');

				} else if (typeof unconvertedImage !== 'undefined') {
					var x = -Z.imageX;
					var y = -Z.imageY;
					Z.Utils.clearDisplay(vD);
					vCtx.drawImage(unconvertedImage, x, y);

					// No tile loading for unconverted image so signal update completion here.
					self.setStatus('displayLoadedViewport', true);
					self.setStatus('displayDrawnViewport', true);
					Z.Utils.validateCallback('viewUpdateComplete');
					Z.Utils.validateCallback('viewUpdateCompleteGetLabelIDs');
				}

				if (Z.maskingSelection) { setMask(); }

				if (tilesLoadingNames.length > 0) {
					loadNewTiles(tilesLoadingNames, onTileLoad, 'centerOut', 'image-display');
				} else if (Z.imageFilters) {
					self.cacheCanvasImage();
				}
				
				// Update related displays and components.
				var comparisonSync = (Z.comparison && vpID == Z.viewportCurrentID);
				var overlaySync = (Z.overlays && vpID == Z.viewportCurrentID);
				var bookmarksSync = Z.bookmarksSet;
				var trackingSync = Z.tracking;
				self.syncViewportRelated(true, true, true, true, true, true, comparisonSync, overlaySync, bookmarksSync, trackingSync);

			} else {
				// Override default false status for viewports other than starting viewport.
				self.setStatus('displayLoadedViewport', true);
				self.setStatus('displayDrawnViewport', true);
			}

			if (preloading) {
				var statusCounterStr = (self.getViewportID() + 1).toString() + ' of ' + Z.imageSetLength.toString();
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_PRELOADINGIMAGESET-UPDATINGVIEW') + '  ' + statusCounterStr, false, Z.messageDurationLong, 'center');
			}
						
			// Validate all view change callbacks.
			if (viewPanned) { Z.Utils.validateCallback('viewPanned'); }
			if (viewZoomed) { Z.Utils.validateCallback('viewZoomed'); }
			if (viewPanned || viewZoomed) { Z.Utils.validateCallback('viewChanged'); }

			// Debug option: console.log(Z.viewportCurrent.getLabelIDsInCurrentView(true, true, true));
		}
	}

	function resetDisplays (override) {
		// If display scaled or panned, reset scale and position to maintain container center
		// point and adjust current tiles to offset change and fill view while new tiles load.
		var redisplayRequired = false;

		// Test for scaling to reset.
		if (override || parseFloat(vS.width) != vD.width) {

			if (Z.useCanvas) {
				// Reset viewport display by returning to start values and reset viewport canvas then transfer CSS scaling to internal canvas scale.
				vS.width = vD.width + 'px';
				vS.height = vD.height + 'px';
				vS.left = '0px';
				vS.top = '0px';
				vCtx.restore();
				vCtx.save();

				// Trap possible NS_ERROR_FAILURE error especially in firefox especially if working with large unconverted image.
				// DEV NOTE: Add retry or soft fail in catch in future implementation for firefox issue with large canvases.
				try {
					vCtx.scale(tierScale, tierScale);
				} catch (e) {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_SCALINGCANVASFORUNCONVERTEDIMAGE'));
					console.log('In function resetDisplays scaling canvas:  ' + e);
				}

				// Sync mask canvas.
				if (mC) {
					mS.width = vD.width + 'px';
					mS.height = vD.height + 'px';
					mS.left = '0px';
					mS.top = '0px';
				}

				// Sync drawing canvas.
				if (dD) {
					dS.width = dD.width + 'px';
					dS.height = dD.height + 'px';
					dS.left = '0px';
					dS.top = '0px';
				}

				// Sync editing canvas.
				if (eD) {
					eS.width = eD.width + 'px';
					eS.height = eD.height + 'px';
					eS.left = '0px';
					eS.top = '0px';
				}

				// Backfill display resized and rescaled depending on whether display is dynamic and partially filled or static and complete as determined in function selectBackfillTier.
				// Backfill positioning and offsetting occurs below. Scaling occurs in the scaleTierToZoom or redisplayCachedTiles functions depending on whether backfill display is
				// implemented as a canvas or HTML div. Oversize backfill display, if present, is always implemented as a canvas as redraw must be fast to provide benefit.
				if (bD) {
					if (tierBackfillDynamic) {
						// Reset backfill display by returning to start values and reset backfill canvas then transfer CSS scaling to internal canvas scale.
						bS.width = bD.width + 'px';
						bS.height = bD.height + 'px';
						bS.left = backfillL + 'px';
						bS.top = backfillT + 'px';
						bCtx.restore();
						bCtx.save();
						bCtx.scale(tierBackfillScale, tierBackfillScale);
					} else {
						bS.width = backfillW + 'px';
						bS.height = backfillH + 'px';
						bS.left = backfillL + 'px';
						bS.top = backfillT + 'px';
					}
				}

			}
			// No 'else' clause here for non-canvas browsers because scaling occurs in the
			// drawTileInHTML function based on tierScale passed in by displayTile. The
			// dimensions of the displays are unimportant as the tiles are drawn to overflow.
			// The positions of the displays are set below where panning changes are reset.

			redisplayRequired = true;
		}

		// Test for panning to reset.  Update imageX and imageY to offset so that
    		// when tiles are redrawn they will be in the same position in the view.
    		if (override || parseFloat(cS.left) != displayL || parseFloat(cS.top) != displayT) {

    			// Calculate pan change in position.
			var deltaX = parseFloat(cS.left) - displayL;
    			var deltaY = parseFloat(cS.top) - displayT;

			// Correct coordinates for mouse-panning.
			if (Z.imageR != 0) {
				var deltaPt = Z.Utils.rotatePoint(deltaX, deltaY, Z.imageR);
				deltaX = deltaPt.x;
				deltaY = deltaPt.y;
			}

    			// Recenter viewport display.
			cS.left = displayL + 'px';
			cS.top = displayT + 'px';

			// Reset backfill tracking variables and reposition backfill display to offset container recentering. Backfill will not
			// be redrawn in the redisplayRequired clause below. If tierBackfillDynamic, full reset occurs in function selectBackfillTier.
			if (!tierBackfillDynamic) {
				backfillL = (parseFloat(bS.left) + deltaX);
				backfillT = (parseFloat(bS.top) + deltaY);
				bS.left = backfillL + 'px';
				bS.top = backfillT + 'px';
			}

			// Update coordinates values to offset.
			var currentZ = self.getZoom();
			Z.imageX = imageX = Z.imageX - (deltaX / currentZ);
    			Z.imageY = imageY = Z.imageY - (deltaY / currentZ);

			redisplayRequired = true;
		}

		if (redisplayRequired) {
			redisplayCachedTiles(vD, tierCurrent, tilesCached, 'centerOut', false, '1a. Updating view: resetting display positions');
			if (Z.maskingSelection && mC) { displayMask(); }
			if (tierBackfillDynamic) { redisplayCachedTiles(bD, tierBackfill, tilesBackfillCached, 'simple', false, '1b. Updating view: resetting backfill positions'); }
		}
    	}

	function selectTier () {

		// If tier has been scaled translate scaling to zoom tracking variable.
		if (tierScale != tierScalePrior) { Z.imageZ = self.getZoom(); }

		// Prevent infinite loop on constraint failure in case of JS timing errors.
		if (Z.imageZ < Z.minZ) { Z.imageZ = Z.minZ; }
		if (Z.imageZ > Z.maxZ) { Z.imageZ = Z.maxZ; }

		// Determine best image tier and scale combination for intended zoom.
		var calcZ = TIERS_SCALE_UP_MAX;
		var tierTarget = tierCount;
		while(tierTarget > 0 && calcZ / 2 >= Z.imageZ) {
			tierTarget--;
			calcZ /= 2;
		}
		tierTarget = (tierTarget - 1 < 0) ? 0 : tierTarget - 1; // Convert to array base 0.
		var tierScaleTarget = convertZoomToTierScale(tierTarget, Z.imageZ);

		// If zooming, apply new tier and scale calculations.  No steps required here for the
		// drawing canvas as its scale does not change, only the control point coordinates do.
		if (tierTarget != tierCurrent || tierScaleTarget != tierScale) {
			if (Z.useCanvas) {
				vCtx.restore();
				vCtx.save();
				vCtx.scale(tierScaleTarget, tierScaleTarget);
			}
			// No steps required here for non-canvas browsers because scaling occurs
			// in drawTileInHTML function based on tierScale passed in by displayTile.

			// Reset tier and zoom variables.
			if (tierCurrent != tierTarget) { tierChanged = true; }
			tierCurrent = tierTarget;
			tierScale = tierScaleTarget;
		}
		tierScalePrior = tierScale;
	}

	function selectBackfillTier () {
		// Use high backfill tier behind high frontfill tiers to avoid blurry backfill when panning at full zoom. Use 0 backfill tier
		// behind low frontfill tiers to avoid tiles gaps lining up. Backfill tiles for tiers 0 to 3 are precached (depending on total
		// image tiers) in precacheBackfillTiles in initializeViewport or reinitializeViewport and then loaded in redisplayCachedTiles
		// in updateView. Deep zoom on large images will force dynamic loading and positioning of backfill tiles.
		tierBackfillDynamic = false;
		if (tierCurrent > backfillTreshold3) {
			tierBackfill = tierCurrent - backfillDynamicAdjust;
			tierBackfillDynamic = true;
		} else {
			tierBackfill = (tierCurrent > backfillTreshold2) ? backfillChoice2 : (tierCurrent > backfillTreshold1) ? backfillChoice1 : backfillChoice0;
		}

		tierBackfillScale = convertZoomToTierScale(tierBackfill, Z.imageZ);
		tierBackfillScalePrior = tierBackfillScale;

		var tierBackfillW = tierWs[tierBackfill];
		var tierBackfillH = tierHs[tierBackfill];

		// Convert current pan position from image values to tier values.
		var deltaX = Z.imageX * Z.imageZ;
		var deltaY = Z.imageY * Z.imageZ;

		// Set backfill globals for use during fast scaling then set backfill display dimensions and position. If backfill is dynamic, no steps
		// required for non-canvas browsers because scaling occurs in drawTileInHTML function based on tierScale passed in by displayTile.
		if (tierBackfillDynamic) {
			var buffer = BACKFILL_BUFFER;
			backfillW = displayW * buffer;
			backfillH = displayH * buffer;
			backfillL = -(displayW / buffer);
			backfillT = -(displayH / buffer);
			backfillCtrX = displayCtrX * buffer;
			backfillCtrY = displayCtrY * buffer;
			bD.width = backfillW;
			bD.height = backfillH;
			bS.width = bD.width + 'px';
			bS.height = bD.height + 'px';
			bS.left = backfillL + 'px';
			bS.top = backfillT + 'px';
			if (Z.useCanvas) {
				if (oD) {
					tierBackfillOversizeScale = convertZoomToTierScale(tierBackfillOversize, Z.imageZ);
					oCtx.restore();
					oCtx.save();
					oCtx.scale(tierBackfillOversizeScale, tierBackfillOversizeScale);
					if (Z.imageR != 0) {
						oCtx.rotate(Z.imageR * Math.PI / 180);
					}
				}
				bCtx.restore();
				bCtx.translate(backfillCtrX, backfillCtrY);
				bCtx.save();
				bCtx.scale(tierBackfillScale, tierBackfillScale);
			}

		} else {
			// Set backfill globals for use during fast scaling then set backfill display dimensions and position.
			backfillW = tierBackfillW * tierBackfillScale;
			backfillH = tierBackfillH * tierBackfillScale;
			backfillL = (displayCtrX - deltaX);
			backfillT = (displayCtrY - deltaY);
			bD.width = tierBackfillW;
			bD.height = tierBackfillH;
			if (Z.useCanvas) {
				bS.width = backfillW + 'px';
				bS.height = backfillH + 'px';
			}
			bS.left = backfillL + 'px';
			bS.top = backfillT + 'px';
		}
	}

	// Calculate tiles at edges of viewport for current view then store names of tiles in view. Identify
	// required tiles that have not been previously loaded. Identify tiles needed for current view that
	// have been previously loaded. Remove previously loaded tile names to allow redisplay rather
	// than reload. Update loading tracking variable and also progress display if enabled. Remove
	// and re-add previously loaded tile names to promote so as to avoid clearing on cache validation.
	// Clear collection of tiles in current view before it is refilled in onTileLoad function. First ensure
	// all tiles' alpha values are set to 1 for drawing in progress and future use from cache. Implement
	// for backfill only if backfill is partially filled rather than completely precached due to the size of
	// the total image and the degree of current zoom.
	function selectTiles (backfill) {
		if (!backfill) {
			// Clear tracking lists.
			Z.Utils.arrayClear(tilesDisplayingNames);
			Z.Utils.arrayClear(tilesCachedInView);
			Z.Utils.arrayClear(tilesCachedInViewNames);
			Z.Utils.arrayClear(tilesLoadingNames);

			// Determine edge tiles of view.
			var bBox = self.getViewportDisplayBoundingBoxInTiles();

			// Determine tiles in view.
			for (var columnCntr = bBox.l, tR = bBox.r; columnCntr <= tR; columnCntr++) {
				for (var rowCntr = bBox.t, tB = bBox.b; rowCntr <= tB; rowCntr++) {
					var tileName = tierCurrent + '-' + columnCntr + '-' + rowCntr;
					tilesDisplayingNames[tilesDisplayingNames.length] = tileName;
					tilesLoadingNames[tilesLoadingNames.length] = tileName;
				}
			}

			// If current tier matches a precached backfill tier determine cached backfill tiles useful for frontfill and remove from loading list. Backfill tiles also in frontfill will be used in function onTileLoad called by onTileBackfillLoad.
			if (self.getStatus('initializedViewport') && tilesBackfillCached.length > 0 && (tierCurrent == backfillChoice0 || tierCurrent == backfillChoice1 || tierCurrent == backfillChoice2)) {
				for (var i = 0, j = tilesBackfillCached.length; i < j; i++) {
					var tile = tilesBackfillCached[i];
					if (tile && tile.t == tierCurrent && tile.c >= bBox.l && tile.c <= bBox.r && tile.r >= bBox.t && tile.r <= bBox.b) {
						tilesCachedInViewNames[tilesCachedInViewNames.length] = tile.name;
						tilesCachedInView[tilesCachedInView.length] = tile;
						var index = Z.Utils.arrayIndexOf(tilesLoadingNames, tile.name);
						if (index != -1) { tilesLoadingNames = Z.Utils.arraySplice(tilesLoadingNames, index, 1); }
					}
				}
			}

			// Determine cached frontfill tiles in view and remove from loading list. Backfill tiles also in frontfill will be used in function onTileLoad called by onTileBackfillLoad.
			for (var i = 0, j = tilesCached.length; i < j; i++) {
				var tile = tilesCached[i];
				if (tile && tile.t == tierCurrent && tile.c >= bBox.l && tile.c <= bBox.r && tile.r >= bBox.t && tile.r <= bBox.b) {
					var index = Z.Utils.arrayIndexOf(tilesCachedInViewNames, tile.name);
					if (index == -1) {
						tilesCachedInViewNames[tilesCachedInViewNames.length] = tile.name;
						tilesCachedInView[tilesCachedInView.length] = tile;
					}
					var index2 = Z.Utils.arrayIndexOf(tilesLoadingNames, tile.name);
					if (index2 != -1) { tilesLoadingNames = Z.Utils.arraySplice(tilesLoadingNames, index2, 1); }
				}
			}

			// Fully fade-in cached tiles in view and clear lists.
			if (tilesLoadingNamesLength != 0) {
				for (var i = 0, j = tilesInView.length; i < j; i++) {
					var tile = tilesInView[i];
					tile.alpha = 1;
				}
				Z.Utils.arrayClear(tilesInView);
				Z.Utils.arrayClear(tilesInViewNames);
			}

			// Track progress.
			tilesToLoadTotal = tilesLoadingNames.length;

			// Trace progress.
			self.traceDebugValues('tilesToDisplay', null, tilesDisplayingNames.length, tilesDisplayingNames);
			self.traceDebugValues('tilesInCache', null, tilesCachedInViewNames.length, tilesCachedInViewNames);
			self.traceDebugValues('tilesToLoad', null, tilesLoadingNames.length, tilesLoadingNames);

		} else {
			var bBox = self.getViewportDisplayBoundingBoxInTiles(tierBackfill);
			Z.Utils.arrayClear(tilesBackfillCachedNames);
			Z.Utils.arrayClear(tilesBackfillDisplayingNames);
			for (var columnCntr = bBox.l, tR = bBox.r; columnCntr <= tR; columnCntr++) {
				for (var rowCntr = bBox.t, tB = bBox.b; rowCntr <= tB; rowCntr++) {
					var tileName = tierBackfill + '-' + columnCntr + '-' + rowCntr;
					tilesBackfillDisplayingNames[tilesBackfillDisplayingNames.length] = tileName;
					tilesBackfillCachedNames[tilesBackfillCachedNames.length] = tileName;
				}
			}

			// Track progress.
			loadNewTiles(tilesBackfillCachedNames, onTileBackfillLoad, 'simple', 'image-backfill');
		}
	}

	function redisplayCachedTiles (display, tier, cacheArray, drawMethod, delayClear, purpose) {
		// If using canvas browser, display content of temporary transition canvas while display canvas
		// is updated. In non-canvas browsers, draw directly to display, optionally using
		// center-out order. Clear tiles previously drawn or wait until all tiles load - per parameter.
		if (!delayClear) { Z.Utils.clearDisplay(display); }
		
		if (drawMethod == 'canvasCopy') {
			Z.Utils.clearDisplay(vD);
			vCtx.restore();
			vCtx.save();
			vCtx.scale(1, 1);
			vCtx.drawImage(tC, -displayCtrX, -displayCtrY);
			vCtx.restore();
			vCtx.save();
			vCtx.scale(tierScale, tierScale);

		} else {
			// Calculate tiles at edges of viewport display for current view.
			var bBox = self.getViewportDisplayBoundingBoxInTiles(tier);
			var cacheArrayInView = [];

			// Determine cached tiles in view.
			if (cacheArray === null) {
				for (var i = 0, j = tilesCachedInView.length; i < j; i++) {
					cacheArrayInView[i] = tilesCachedInView[i];
				}
			} else if (cacheArray.length > 0) {
				for (var i = 0, j = cacheArray.length; i < j; i++) {
					var tile = cacheArray[i];
					// Filter list to tile in view unless backfill and not tierBackfillDynamic.
					if (tile && tile.t == tier && ((tier == tierBackfill && !tierBackfillDynamic) || (tile.c >= bBox.l && tile.c <= bBox.r && tile.r >= bBox.t && tile.r <= bBox.b))) {
						cacheArrayInView[cacheArrayInView.length] = cacheArray[i];
					}
				}
			}

			if (cacheArrayInView.length > 0) {
				self.traceDebugValues('redisplayCachedTiles-' + display.id, null, null, cacheArrayInView);

				if (drawMethod == 'centerOut') {
					// Draw from middle sorted array up & down to approximate drawing from center of view out.
					var arrayMidpoint = Math.floor(cacheArrayInView.length / 2);
					for (var i = arrayMidpoint, j = cacheArrayInView.length; i < j; i++) {
						displayTile(display, tier, cacheArrayInView[i]);
						if (cacheArrayInView.length-i-1 != i) {
							displayTile(display, tier, cacheArrayInView[cacheArrayInView.length-i-1]);
						}
					}

				} else {
					// Draw simple, first to last.
					for (var i = 0, j = cacheArrayInView.length; i < j; i++) {
						displayTile(display, tier, cacheArrayInView[i]);
					}
				}

			} else {
				self.traceDebugValues('No cached tiles in view');
			}

			self.traceDebugValues('blankLine');
		}
	}

	function displayCacheDisplay (tier, cacheArray) {
		// In canvas browsers avoid blink of visible backfill as canvas is fully cleared
		// and redrawn by first drawing cached tiles from prior view to temp canvas.

		// Calculate tiles at edges of viewport display for current view.
		var bBox = self.getViewportDisplayBoundingBoxInTiles();

		// Synchronize transition canvas to collect cached tiles.
		syncTransitionCanvas();

		for (var i = 0, j = cacheArray.length; i < j; i++) {
			var tile = cacheArray[i];
			if (tile && tile.t == tier && (tier == tierBackfill || (tile.c >= bBox.l && tile.c <= bBox.r && tile.r >= bBox.t && tile.r <= bBox.b))) {
				displayTile(tC, tier, tile);
			}
		}
	}

	syncTransitionCanvas = function () {
		if (tC && tS && tCtx) {
			tC.width = vD.width;
			tC.height = vD.height;
			tS.width = vS.width;
			tS.height = vS.height;
			tS.left = vS.left;
			tS.top = vS.top;
			tCtx.restore();
			tCtx.save();
			tCtx.translate(displayCtrX, displayCtrY);
			tCtx.scale(tierScale, tierScale);
		}
	}

	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::: UNCONVERTED IMAGE VIEWING FUNCTIONS :::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.loadUnconvertedImage = function (imgPath) {
		loadUnconvertedImage(imgPath);
	}

	function loadUnconvertedImage (imgPath) {
		unconvertedImage = null;
		unconvertedImage = new Image();
		unconvertedImage.onload = initializeViewportUnconverted;
		unconvertedImage.onerror = unconvertedImageLoadingFailed;
		unconvertedImage.src = imgPath;
	}

	function initializeViewportUnconverted () {
		if (typeof unconvertedImage !== 'undefined') {
			var testImageContainer = Z.Utils.createContainerElement('div', 'testImageContainer', 'inline-block', 'absolute', 'hidden', viewW + 'px', viewH + 'px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
			testImageContainer.appendChild(unconvertedImage);
			testImageContainer.removeChild(unconvertedImage);
			testImageContainer = null;
			var tW = unconvertedImage.width;
			var tH = unconvertedImage.height;

			if (tW != 0 && tH != 0) {
				initializeViewport(tW, tH, tW, tH, null, null, null, null, null, null, null);
			} else {
				var unconvertedImageLoadedTimer = window.setTimeout( function () { initializeViewportUnconverted(); }, 100);
			}
		} else {
			var unconvertedImageLoadedTimer = window.setTimeout( function () { initializeViewportUnconverted(); }, 100);
		}
	}

	function unconvertedImageLoadingFailed () {
		Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNCONVERTEDIMAGEPATHINVALID'));
	}

	this.getUnconvertedImage = function () {
		return unconvertedImage;
	}

	this.createUnconvertedImageThumbnail = function () {
		if (Z.useCanvas) {
			if (typeof unconvertedImage !== 'undefined') {
				var unconvertedImageThumb = null;
				var thumbScale = 150 / Z.imageW;
				var w = Z.imageW * thumbScale;
				var h = Z.imageH * thumbScale;
				var tempCanvas = Z.Utils.createContainerElement('canvas', 'tempCanvas', 'inline-block', 'absolute', 'visible', w + 'px', h + 'px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
				var tempCtx = tempCanvas.getContext('2d');

				// Trap possible NS_ERROR_FAILURE error if working with large unconverted image.
				// DEV NOTE: Add retry or soft fail in catch in future implementation for firefox issue with large canvases.
				try {
					tempCtx.scale(thumbScale, thumbScale);
					tempCtx.drawImage(unconvertedImage, 0, 0);
				} catch (e) {
					//Z.Utils.showMessage(Z.Utils.getResource('ERROR_SCALINGCANVASFORUNCONVERTEDIMAGE'));
					console.log('In function initializeViewportContinue scaling canvas:  ' + e);
				}

				unconvertedImageThumb = new Image();
				unconvertedImageThumb.src = tempCanvas.toDataURL('image/jpeg', Z.saveImageCompression);
				return unconvertedImageThumb;
			} else {
				var createUnconvertedImageThumbnailTimer = window.setTimeout( function () { createUnconvertedImageThumbnail(); }, 100);
			}
		}
	}

	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::: TILE LOADING FUNCTIONS ::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function loadNewTiles (tileNamesArray, loadHandler, drawMethod, requester) {
		// For Zoomify Image Files (ZIF or PFF) loading is contingent on offset chunk having loaded.
		var reqValue = (typeof requester !== 'undefined' && requester !== null) ? '-' + requester : '';

		if (tileNamesArray.length > 0 ) {
			self.traceDebugValues('loadNewTiles' + reqValue, null, null, tileNamesArray);

			var loadStart = new Date().getTime();

			if (drawMethod == 'centerOut' && tileNamesArray.length > 4) {
				// Draw from middle of view out by temporarily recentering coordinates over 0,0, then sorting by the
				// geometric distance from the new origin. Limitations: does not yet allow for non-square display areas.
				var tempTiles = [];
				var tL = 0, tR = 0, tT = 0, tB = 0;
				for (var i = 0; i < tileNamesArray.length; i++) {
					var tileName = tileNamesArray[i];
					if (tileName) {
						var tile = new Tile(tileName, requester);
						tempTiles[tempTiles.length] = tile;
						if (i == 0) {
							tL = tR = tile.c;
							tT = tB = tile.r;
						} else {
							if (tile.c < tL) {
								tL = tile.c;
							} else if (tile.c > tR) {
								tR = tile.c;
							}
							if (tile.r < tT) {
								tT = tile.r;
							} else if (tile.r > tB) {
								tB = tile.r;
							}
						}
					}
				}
				var width = tR - tL, height = tB - tT;
				var adjustX = tL + (width / 2);
				var adjustY = tT + (height / 2);
				for (var i = 0; i < tempTiles.length; i++) {
					tempTiles[i].r -= adjustY;
					tempTiles[i].c -= adjustX;
				}
				tempTiles.sort( function (a, b) {
					var distanceA = (a.r * a.r + a.c * a.c); // Math.sqrt(a.r * a.r + a.c * a.c); // Alternative implementation: sqrt not required.
					var distanceB = (b.r * b.r + b.c * b.c); // Math.sqrt(b.r * b.r + b.c * b.c); // Alternative implementation: sqrt not required.
					var distanceDiff = distanceA - distanceB;
					return distanceDiff;
				});
				for (var i = 0; i < tempTiles.length; i++) {
					tempTiles[i].r += adjustY;
					tempTiles[i].c += adjustX;
					loadTile(tempTiles[i], loadStart, loadHandler);
					// Debug option: console.log(tempTiles[i].name);
				}

			} else {
				// Draw simple, first to last.
				for (var i = 0, j = tileNamesArray.length; i < j; i++) {
					var tileName = tileNamesArray[i];
					if (tileName) {
						var tile = new Tile(tileName, requester);
						loadTile(tile, loadStart, loadHandler);
					}
				}
			}

			self.traceDebugValues('blankLine');
		} else {
			self.traceDebugValues('loadNewTiles' + reqValue, 'No new tiles requested');
		}
	}

	function Tile (name, requester) {
		// Enable invalidation of tile requests fulfilled after current image change.
		this.imagePath = Z.imagePath;

		// Values used by drawTileOnCanvas and drawTileInHTML.
		this.name = name;
		var tileVals = new TileCoords(name);
		this.t = tileVals.t;
		this.c = tileVals.c;
		this.r = tileVals.r;
		this.x = Math.floor(this.c * TILE_WIDTH);
		this.y = Math.floor(this.r * TILE_HEIGHT);
		this.image = null;
		this.alpha = 0;

		this.url = self.formatTilePath(this.t, this.c, this.r, requester);
		this.loadTime = null;

		// Values used only by drawTileInHTML.
		this.elmt = null;
		this.style = null;
	}

	function TileCoords (name) {
		this.t = parseInt(name.substring(0, name.indexOf('-')), 10);
		this.c = parseInt(name.substring(name.indexOf('-') + 1, name.lastIndexOf('-')), 10);
		this.r = parseInt(name.substring(name.lastIndexOf('-') + 1), 10);
	}

	this.formatTilePath = function (t, c, r, requester) {
		var tilePath;
		if (Z.tileSource == 'ZoomifyImageFile') {
			tilePath = formatTilePathZIF(t, c, r, requester);
		} else if (Z.tileSource == 'ZoomifyImageFolder') {
			tilePath = formatTilePathImageFolder(t, c, r, requester);
		} else if (Z.tileSource == 'ZoomifyPFFFile') {
			tilePath = formatTilePathPFF(t, c, r, requester);
		} else if (Z.tileSource == 'IIIFImageServer') {
			tilePath = formatTilePathIIIFImageServer(t, c, r, requester);
		} else if (Z.tileSource == 'ImageServer') {
			// Example image server protocol implementation.
			tilePath = formatTilePathImageServer(t, c, r, requester);
		}
		return tilePath;
	}

	// Tile path is actually image file path plus start and end byte positions in the ZIF file. This is used by
	// function loadImageByteRange to request tile image bytes.  Tile path is set to 'offsetLoading' if new
	// offset chunk must be loaded from ZIF to determine the start and end positions.
	function formatTilePathZIF (t, c, r, requester) {
		// Set default values to control asynchronous tile, offset, and byte count loading.
		var tilePath = 'offsetLoading', tileOffset = 'loading', tileByteCount = 'loading';
		var index, chunkData;

		// Load offset to tile offsets if many or actual tile offset if just one.
		if (tierTileOffsetsCount[t] == 1) {
			tileOffset = tierTileOffsetsStart[t];

		} else {
			// Determine chunkID, chunkStart, chunkEnd, and offsetStartInChunk.
			var offsetValues = new OffsetChunkValues(t, c, r);

			// Determine if tile offset must be loaded or already has previously. If must download, minimize round-trips by downloading many at once.
			// Offset values are 64-bit values (eight bytes each). Add 12 only during IFD parsing (for the offset from the start of the IFD entry).
			var offsetTileRetry = offsetValues.chunkID + ',' + t +',' + c +',' + r + ',' + requester + ',' + 'offset';
			index = Z.Utils.arrayIndexOfObjectValue(tierTileOffsetChunks, 'chunkID', offsetValues.chunkID);
			if (index == -1) {

				self.traceDebugValues('formatTilePathZIF', offsetValues.chunkID + ',' + t +',' + c +',' + r + ',' + requester);

				if (Z.Utils.arrayIndexOf(tilesRetryNamesChunks, offsetTileRetry) == -1) {
					tilesRetryNamesChunks[tilesRetryNamesChunks.length] = offsetTileRetry;
				}
				tierTileOffsetChunks[tierTileOffsetChunks.length] = { chunkID:offsetValues.chunkID, chunk:'loading' };
				var netConnector = new Z.NetConnector();
				netConnector.loadByteRange(imagePath, offsetValues.chunkStart, offsetValues.chunkEnd, 'offset', null, offsetValues.chunkID);

			} else if (tierTileOffsetChunks[index].chunk == 'loading') {
				if (Z.Utils.arrayIndexOf(tilesRetryNamesChunks, offsetTileRetry) == -1) {
					tilesRetryNamesChunks[tilesRetryNamesChunks.length] = offsetTileRetry;
				}

			} else if (tierTileOffsetChunks[index].chunk != 'loading') {
				chunkData = tierTileOffsetChunks[index].chunk;
				tileOffset = Z.Utils.longValue(chunkData, offsetValues.offsetStartInChunk);
			}
		}

		// Load bytecount offsets if many, actual byte count if one, or concatenated & delimited byte counts if two.
		var bcChunkNumInTier, bcTileRetry;
		if (tierTileByteCountsCount[t] == 1) {
			tileByteCount = tierTileByteCountsStart[t];

		} else {
			var bcNumInTier = c + r * tierWInTiles[t];

			if (tierTileByteCountsCount[t] == 2) {
				var bcConcat = tierTileByteCountsStart[t];
				if (bcNumInTier == 0) {
					tileByteCount = bcConcat.substring(0, bcConcat.indexOf(','));
				} else {
					tileByteCount = bcConcat.substring(bcConcat.indexOf(',') + 1, bcConcat.length);
				}

			} else {
				// Determine chunkID, chunkStart, chunkEnd, and byteCountStartInChunk.
				var byteCountValues = new ByteCountChunkValues(t, c, r);

				// Determine if tile byte count must be loaded or already has previously. If must download, minimize round-trips by downloading many at once.
				// Byte counts are 32-bit values (four bytes each). Use Z.Utils.intValue for the byte counts (which only decodes four bytes).  Add 12 only during IFD parsing (for the offset from the start of the IFD entry).
				var bcTileRetry = byteCountValues.chunkID + ',' + t +',' + c +',' + r + ',' + requester + ',' + 'byteCount';
				index = Z.Utils.arrayIndexOfObjectValue(tierTileByteCountChunks, 'chunkID', byteCountValues.chunkID);
				if (index == -1) {
					if (Z.Utils.arrayIndexOf(tilesRetryNamesChunks, bcTileRetry) == -1) {
						tilesRetryNamesChunks[tilesRetryNamesChunks.length] = bcTileRetry;
					}
					tierTileByteCountChunks[tierTileByteCountChunks.length] = { chunkID:byteCountValues.chunkID, chunk:'loading' };
					var netConnector = new Z.NetConnector();
					netConnector.loadByteRange(imagePath, byteCountValues.chunkStart, byteCountValues.chunkEnd, 'byteCount', null, byteCountValues.chunkID);

				} else if (tierTileByteCountChunks[index].chunk == 'loading') {
					if (Z.Utils.arrayIndexOf(tilesRetryNamesChunks, bcTileRetry) == -1) {
						tilesRetryNamesChunks[tilesRetryNamesChunks.length] = bcTileRetry;
					}

				} else if (tierTileByteCountChunks[index].chunk != 'loading') {
					chunkData = tierTileByteCountChunks[index].chunk;
					tileByteCount = Z.Utils.intValue(chunkData, byteCountValues.bcStartInChunk);

				}
			}
		}

		// Debug option:
		/*if ((tileOffset != 'loading' && isNaN(tileOffset)) || (tileByteCount != 'loading' && isNaN(tileByteCount))) {
			console.log(t + "-" + c + "-" + r + ": " + tileOffset + "  " + tileByteCount);
		}*/

		// Add retry information to retry list. Chunk number can be offset or byte count chunk.
		// Return tile path for loadNewTiles or loadNewTilesRetry to download tiles.
		if (tileOffset != 'loading' && !isNaN(tileOffset) && tileByteCount != 'loading' && !isNaN(tileByteCount) ) {
			tilePath = imagePath + '?' + tileOffset.toString() + ','+ tileByteCount.toString();

			// Alternative implementation: Cache-proofing of tile paths for ZIF requests is not required for current uses.
			//tilePath = Z.Utils.cacheProofPath(tilePath);
		}

		return tilePath;
	}

	// Determine offset chunk needed, its size, start, and end, and limit size to number of offsets in tier of tile in request.
	function OffsetChunkValues (t, c, r) {
		var offsetNumInTier = c + r * tierWInTiles[t];
		var offsetStartInTier = offsetNumInTier * 8 + tierTileOffsetsStart[t];
		var offsetChunkNumInTier = Math.floor(offsetNumInTier / CHUNK_SIZE);
		var chunkEndTest = offsetChunkNumInTier * CHUNK_SIZE;
		var chunkPastEndTest = chunkEndTest + CHUNK_SIZE;
		var currentChunkSize = (chunkPastEndTest > tierTileCounts[t]) ? (tierTileCounts[t] - chunkEndTest) * 8 : OFFSET_CHUNK_SIZE_BYTES;

		this.chunkStart = tierTileOffsetsStart[t] + (offsetChunkNumInTier * OFFSET_CHUNK_SIZE_BYTES);
		this.chunkEnd = this.chunkStart + currentChunkSize;
		this.offsetStartInChunk = offsetStartInTier - this.chunkStart;
		this.chunkID = t.toString() + '-' + offsetChunkNumInTier.toString();
	}

	// Determine byteCount chunk needed, its size, start, and end, and limit size to number of byteCounts in tier of tile in request.
	function ByteCountChunkValues (t, c, r) {
		var bcNumInTier = c + r * tierWInTiles[t];
		var bcStartInTier = bcNumInTier * 4 + tierTileByteCountsStart[t];
		var bcChunkNumInTier = Math.floor(bcNumInTier / CHUNK_SIZE);
		var chunkEndTest = bcChunkNumInTier * CHUNK_SIZE;
		var chunkPastEndTest = chunkEndTest + CHUNK_SIZE;
		var currentChunkSize = (chunkPastEndTest > tierTileCounts[t]) ? (tierTileCounts[t] - chunkEndTest) * 4 : BC_CHUNK_SIZE_BYTES;

		this.chunkStart = tierTileByteCountsStart[t] + (bcChunkNumInTier * BC_CHUNK_SIZE_BYTES);
		this.chunkEnd = this.chunkStart + currentChunkSize;
		this.bcStartInChunk = (bcStartInTier - this.chunkStart);
		this.chunkID = t.toString() + '-' + bcChunkNumInTier.toString();
	}

	function formatTilePathImageFolder (t, c, r, requester) {
		// URI for each tile includes image folder path, tile group subfolder name, and tile filename.
		var offset = r * tierWInTiles[t] + c;
		for (var i = 0; i < t; i++) { offset += tierTileCounts[i]; }
		var tileGroupNum = Math.floor(offset / TILES_PER_FOLDER);
		var tilePath = imagePath + '/' + 'TileGroup' + tileGroupNum + '/' + t + '-' + c + '-' + r + "." + Z.tileType;

		// DEV NOTE: Must cache-proof tile paths for old IE versions and if tile caching set off by resource change.
		// Implementing for all cases as precaution and monitoring for issue reports.  Implementing in function
		// formatTilePath rather than in call to it because excluding PFF (image file) and third party protocol
		// tile requests to avoid complications with server-side helper app or image server tile fulfillment.
		if ((Z.browser == Z.browsers.IE && Z.browserVersion < 9)|| TILES_CACHE_MAX == 0) {
			tilePath = Z.Utils.cacheProofPath(tilePath);
		}

		return tilePath;
	}

	function formatTilePathPFF (t, c, r, requester) {
		// Tile path is actually tile request to servlet or other server-side helper application.
		// Tile request is set to 'offsetLoading' if new header offset chunk must be loaded from PFF.
		// Tile request otherwise includes image file path, request type, begin byte, end byte, image version, and header size.
		// Request types include: 1 = image file header, 2 = header offset chunk, 0 = image tile.

		var tilePath = 'offsetLoading';

		var currentOffsetIndex = 0;
		var currentOffsetIndexBegin = 0;
		var currentOffsetChunk;
		var currentOffsetChunkBegin;
		var offsetChunkIndex;
		var offsetChunkIndexBegin;
		var offsetChunkBeginByte;
		var offsetChunkEndByte;
		var offsetChunkBeginBeginByte;
		var offsetChunkBeginEndByte;

		for (var tierCntr = tierCount - 1; tierCntr > t; tierCntr--) {
			currentOffsetIndex += tierTileCounts[tierCntr];
		}

		currentOffsetIndex += r * tierWInTiles[t] + c;
		currentOffsetChunk = Math.floor(currentOffsetIndex / CHUNK_SIZE);
		currentOffsetIndexBegin = (currentOffsetIndex - 1 == -1) ? 0 : currentOffsetIndex - 1;
		currentOffsetChunkBegin = Math.floor(currentOffsetIndexBegin / CHUNK_SIZE);

		if (offsetChunks[currentOffsetChunk] == undefined || offsetChunks[currentOffsetChunk] == 'offsetLoading' || offsetChunks[currentOffsetChunkBegin] == undefined || offsetChunks[currentOffsetChunkBegin] == 'offsetLoading') {
			var tileRetryString = currentOffsetChunk + ',' + t +',' + c +',' + r + ',' + requester;
			if (Z.Utils.arrayIndexOf(tilesRetryNamesChunks, tileRetryString) == -1) { tilesRetryNamesChunks[tilesRetryNamesChunks.length] = tileRetryString; }

			self.traceDebugValues('formatTilePathPFF', currentOffsetChunk + ',' + t +',' + c +',' + r + ',' + requester);

			// No redundant offset loads if call already in progress (element would be 'offsetLoading', not undefined).
			if (offsetChunks[currentOffsetChunk] == undefined) {
				offsetChunks[currentOffsetChunk] = 'offsetLoading';
				offsetChunkBeginByte = HEADER_SIZE_TOTAL + CHUNK_SIZE * currentOffsetChunk * 8;
				offsetChunkEndByte = offsetChunkBeginByte + CHUNK_SIZE * 8;
				loadOffsetChunk(offsetChunkBeginByte, offsetChunkEndByte, currentOffsetChunk);
			}
			// No redundant offset loads if this chunk would be same as above (element would be 'offsetLoading', not undefined).
			if (offsetChunks[currentOffsetChunkBegin] == undefined) {
				offsetChunks[currentOffsetChunkBegin] = 'offsetLoading';
				offsetChunkBeginBeginByte = HEADER_SIZE_TOTAL + CHUNK_SIZE * currentOffsetChunkBegin * 8;
				offsetChunkBeginEndByte = offsetChunkBeginBeginByte + CHUNK_SIZE * 8;
				loadOffsetChunk(offsetChunkBeginBeginByte, offsetChunkBeginEndByte, currentOffsetChunk);
			}

		} else {
			var absoluteBeginning = Math.floor(offsetChunks[currentOffsetChunk][0]);
			var absoluteBeginningBegin = Math.floor(offsetChunks[currentOffsetChunkBegin][0]);
			var offsetString = offsetChunks[currentOffsetChunkBegin][1];
			var offsetString2 = offsetChunks[currentOffsetChunk][1];
			offsetChunkIndexBegin = 9 * (currentOffsetIndexBegin % CHUNK_SIZE);
			var tempInt = Math.floor(parseFloat(offsetString.substring(offsetChunkIndexBegin, offsetChunkIndexBegin + 9)));
			offsetChunkIndex = 9 * (currentOffsetIndex % CHUNK_SIZE);
			var tempInt2 = Math.floor(parseFloat(offsetString2.substring(offsetChunkIndex, offsetChunkIndex + 9)));
			var sByte = (currentOffsetIndex == 0) ? HEADER_SIZE_TOTAL + TILE_COUNT * 8 : absoluteBeginningBegin + tempInt;
			var eByte = absoluteBeginning + tempInt2;

			if ((eByte - sByte) > 0) {
				tilePath = Z.tileHandlerPathFull + "?file=" + imagePath + "&requestType=0&begin=" + sByte.toString() + "&end=" + eByte.toString() + "&vers=" + IMAGE_VERSION.toString() + "&head=" + HEADER_SIZE.toString();
			} else {
				tilePath = 'skipTile:' + t + '-' + c + '-' + r;
			}
		}

		return tilePath;
	}

	function loadOffsetChunk (offsetStartByte, offsetEndByte, chunk) {
		offsetChunkBegins[offsetStartByte] = chunk;
		var REQUEST_TYPE = 2; // 1 = header, 2 = offset, 0 = tile.

		// Build data request with query string and send.
		var imgPathNoDot = imagePath.replace('.', '%2E');  // Required for servlet.
		var offsetChunkPath = Z.tileHandlerPathFull + '?file=' + imgPathNoDot + '&requestType=' + REQUEST_TYPE + '&begin=' + offsetStartByte + '&end=' + offsetEndByte;
		var netConnector = new Z.NetConnector();
		netConnector.loadXML(offsetChunkPath);
	}

	this.parseOffsetChunk = function (xmlDoc) {
		var begin = parseInt(xmlDoc.documentElement.getAttribute('BEGIN'), 10);
		var replyData = xmlDoc.documentElement.getAttribute('REPLYDATA');
		var chunk = offsetChunkBegins[begin];
		var offsetOfCurrentChunkBegin = Math.floor(((begin - HEADER_SIZE_TOTAL) / 8) / CHUNK_SIZE);
		offsetChunks[offsetOfCurrentChunkBegin] = new Array();
		offsetChunks[offsetOfCurrentChunkBegin] = replyData.split(',', 2);

		selectTilesRetryPFF(chunk);

		// Debug options:
		//Z.Utils.trace('parseOffsetChunk-begin + replyData + chunk: ' + begin + '  ' + replyData + '  ' + chunk);
		//Z.Utils.trace('parseOffsetChunk-offsetChunks[offsetOfCurrentChunkBegin][0] & [1]: ' + offsetChunks[offsetOfCurrentChunkBegin][0] + ', ' + offsetChunks[offsetOfCurrentChunkBegin][1]);
	}

	function selectTilesRetryZIF (chunkID, type) {

		for(var i = 0, j = tilesRetryNamesChunks.length; i < j; i++) {
			var tilesRetryElements = tilesRetryNamesChunks[i].split(',');
			if (tilesRetryElements[0] == chunkID && tilesRetryElements[5] == type) {
				if (tilesRetryElements[4] !== undefined && tilesRetryElements[4] == 'image-display') {
					tilesRetryNames[tilesRetryNames.length] = tilesRetryElements[1] + '-' + tilesRetryElements[2] + '-' + tilesRetryElements[3]; // t,c,r
				} else if (tilesRetryElements[4] == 'image-backfill') {
					tilesBackfillRetryNames[tilesBackfillRetryNames.length] = tilesRetryElements[1] + '-' + tilesRetryElements[2] + '-' + tilesRetryElements[3]; // t,c,r
				}
				tilesRetryNamesChunks = Z.Utils.arraySplice(tilesRetryNamesChunks, i, 1);
				i--;
				j--;
			}
		}

		if (tilesRetryNames.length > 0) {
			tilesRetryNames.sort();
			tilesRetryNames = Z.Utils.arrayUnique(tilesRetryNames);
			self.traceDebugValues('selectTilesRetryZIF', tilesRetryNames);
			var loadHandler = (self.getStatus('imageSaving')) ? onTileLoadToSave : onTileLoad;
			loadNewTilesRetry(tilesRetryNames, loadHandler, 'simple', 'image-display');
		}

		if (tilesBackfillRetryNames.length > 0) {
			tilesBackfillRetryNames.sort();
			tilesBackfillRetryNames = Z.Utils.arrayUnique(tilesBackfillRetryNames);
			var loadHandler = (self.getStatus('imageSaving')) ? onTileBackfillLoadToSave : onTileBackfillLoad;
			loadNewTilesRetry(tilesBackfillRetryNames, loadHandler, 'simple', 'image-backfill');
		}
	}

	function selectTilesRetryPFF (chunkN) {

		for(var i = 0, j = tilesRetryNamesChunks.length; i < j; i++) {
			var tilesRetryElements = tilesRetryNamesChunks[i].split(',');
			if (tilesRetryElements[0] == chunkN) {
				if (tilesRetryElements[4] !== undefined && tilesRetryElements[4] == 'image-display') {
					tilesRetryNames[tilesRetryNames.length] = tilesRetryElements[1] + '-' + tilesRetryElements[2] + '-' + tilesRetryElements[3]; // t,c,r
				} else if (tilesRetryElements[4] == 'image-backfill') {
					tilesBackfillRetryNames[tilesBackfillRetryNames.length] = tilesRetryElements[1] + '-' + tilesRetryElements[2] + '-' + tilesRetryElements[3]; // t,c,r
				}
				tilesRetryNamesChunks = Z.Utils.arraySplice(tilesRetryNamesChunks, i, 1);
				i--;
				j--;
			}
		}

		if (tilesRetryNames.length > 0) {
			tilesRetryNames.sort();
			tilesRetryNames = Z.Utils.arrayUnique(tilesRetryNames);
			self.traceDebugValues('selectTilesRetryPFF', tilesRetryNames);
			var loadHandler = (self.getStatus('imageSaving')) ? onTileLoadToSave : onTileLoad;
			loadNewTilesRetry(tilesRetryNames, loadHandler, 'simple', 'image-display');
		}
		if (tilesBackfillRetryNames.length > 0) {
			tilesBackfillRetryNames.sort();
			tilesBackfillRetryNames = Z.Utils.arrayUnique(tilesBackfillRetryNames);
			var loadHandler = (self.getStatus('imageSaving')) ? onTileBackfillLoadToSave : onTileBackfillLoad;
			loadNewTilesRetry(tilesBackfillRetryNames, loadHandler, 'simple', 'image-backfill');
		}
	}

	function loadNewTilesRetry (tileNamesArray, loadHandler, drawMethod, requester) {
		var loadStart = new Date().getTime();

		for (var i = 0, j = tileNamesArray.length; i < j; i++) {
			var tile = null;
			var tileName = tileNamesArray[i];
			if (tileName) {
				tileNamesArray = Z.Utils.arraySplice(tileNamesArray, i, 1);

				i--;
				j--;
				index = Z.Utils.arrayIndexOfObjectValue(tilesRetry, 'name', tileName);
				if (index != -1) {
					tile = tilesRetry[index];
					tilesRetry = Z.Utils.arraySplice(tilesRetry, index, 1);
					tile.url = self.formatTilePath(tile.t, tile.c, tile.r, requester);
				} else {
					tile = new Tile(tileName, requester);
				}

				if (tile != null && tile.url.indexOf('NaN') == -1) {
					self.traceDebugValues('loadNewTilesRetry', tile.name + '  ' + tile.url);
					loadTile(tile, loadStart, loadHandler);

				} else if (tile.url.indexOf('NaN') == -1) {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_TILEPATHINVALID-ZIF') + tile.name + '.jpg', false, Z.messageDurationShort, 'center', false);
				}
			}
		}
	}

	function skipTile (tile) {
		// Tiles to skip are tiles not captured at a particular position in an image at a particular resolution.  This
		// results from microscopy scanning to create a Zoomify Image File (ZIF) or Zoomify Pyramidal File (PFF)
		// where only areas of primary interest are scanned at high resolution while in other areas the lower resolution
		// backfill image tiles are allowed to show through. For these tiles, the PFF offset chunks will have a byte range
		// for the tile that is 0 bytes in length. This approach results in more efficient storage and bandwidth use.
		// Skipped tiles are not loaded but are added to tile cache to prevent redundant future loading attempts.

		// Debug option: Use next line to trace tiles not requested due to sparse PFF tile feature.
		// console.log('Tile skipped: ' + tile.name);

		cacheTile(tile);

		var tileName = tile.name;
		var index = Z.Utils.arrayIndexOf(tilesLoadingNames, tileName);
		if (index != -1) { tilesLoadingNames = Z.Utils.arraySplice(tilesLoadingNames, index, 1); }
		if (Z.tileSource == 'ZoomifyImageFile' || Z.tileSource == 'ZoomifyPFFFile') {
			var index2 = Z.Utils.arrayIndexOf(tilesRetryNames, tileName);
			if (index2 != -1) { tilesRetryNames = Z.Utils.arraySplice(tilesRetryNames, index2, 1); }
		}
		tilesInView[tilesInView.length] = tile;
		tilesInViewNames[tilesInViewNames.length] = tileName;
	}

	function loadTile (tile, loadTime, loadHandler) {
		// Asynchronously load tile and ensure handler function is called upon loading.
		var tileName = tile.name;
		if (tile.url.substr(0, 8) == 'skipTile') {
			skipTile(tile);

		} else if (tile.url == 'offsetLoading') {
			var index = Z.Utils.arrayIndexOfObjectValue(tilesRetry, 'name', tileName);
			if (index == -1) { tilesRetry[tilesRetry.length] = tile; }
			self.traceDebugValues('loadTileDelayForOffset', tileName);

		} else if (tile.url != 'offsetLoading') {
			var tileType;
			if (loadHandler == onTileLoad || loadHandler == onTileLoadToSave) {
				tileType = 'image-display';
			} else if (loadHandler == onTileBackfillLoad || loadHandler == onTileBackfillLoadToSave) {
				tileType = 'image-backfill';
			}

			// Load tile unless it is for frontfill but already loaded for backfill.
			var tilesCachedForBackfill = ((tile.t == backfillChoice0 && backfillTresholdCached0) || (tile.t == backfillChoice1 && backfillTresholdCached1) || (tile.t == backfillChoice2 && backfillTresholdCached2));
			if (!(tileType == 'image-display' && tilesCachedForBackfill)) {
				tile.loadTime = loadTime;
				self.traceDebugValues('loadTile-' + tileType, tileName);
				tileNetConnector.loadImage(tile.url, Z.Utils.createCallback(null, loadHandler, tile), tileType, tile);

				// DEV NOTE: This value returned by function for possible future storage and use (currently used when loading hotspot media).
				//tile.loading = tileNetConnector.loadImage(tile.url, Z.Utils.createCallback(null, loadHandler, tile), 'tile');
			}
		}
	}

	function onTileLoad (tile, image) {
		if (tile && image && tile.imagePath == Z.imagePath) {  // Verify tile and image are not null and current image hasn't changed during request fulfillment.
			tile.image = image;
			var tileName = tile.name;

			// Verify loading tile is still in loading list and thus still required.  Allows for loading delays due to network latency or PFF header chunk loading.
			var index = Z.Utils.arrayIndexOf(tilesLoadingNames, tileName);
			if (index != -1) {

				tilesLoadingNames = Z.Utils.arraySplice(tilesLoadingNames, index, 1);
				cacheTile(tile);

				// Stop here if preloading tiles from non-current tiers so tile is cached but not drawn.
				if (Z.preloadVisible && !Z.imageSet && tile.t != tierCurrent) {
					Z.Utils.showMessage(Z.Utils.getResource('ALERT_PRELOADING-STORINGORDRAWINGTILES') + '   Tile: ' + tileName, false, Z.messageDurationShort / 10, 'center');
					tile.alpha = 1;
					return;
				}

				// Also create current view tile collection for faster zoomAndPanToView function.
				if (Z.Utils.arrayIndexOf(tilesInViewNames, tileName) == -1) {
					tilesInViewNames[tilesInViewNames.length] = tileName;
					tilesInView[tilesInView.length] = tile;
				}

				// If preloading other Viewports for image set show message.
				if (Z.preloadVisible && Z.imageSet && self.getViewportID() != Z.viewportCurrentID) {
					var statusCounterStr = (self.getViewportID() + 1).toString() + ' of ' + Z.imageSetLength.toString()
					var viewportAndTile = statusCounterStr + '   Tile: ' + tileName;
					Z.Utils.showMessage(Z.Utils.getResource('ALERT_PRELOADING-STORINGORDRAWINGTILES') + viewportAndTile, false, Z.messageDurationShort / 10, 'center');
				}

				// Draw tile with fade-in.
				if (!fadeInInterval) { fadeInInterval = window.setInterval(fadeInIntervalHandler, 50); }

				// Determine if all new tiles have loaded.
				tilesLoadingNamesLength = tilesLoadingNames.length;
				if (tilesLoadingNamesLength == 0) {

					// Fully clear and redraw viewport display if canvas in use. If using canvas browser,
					// display temporary transition canvas while display canvas is updated.
					if (Z.useCanvas && (TILES_CACHE_MAX > 0)) {
						if (!tierChanged) {
							redisplayCachedTiles(vD, tierCurrent, tilesCached, 'centerOut', false, '4. Updating view: all new tiles loaded');
						} else {
							displayCacheDisplay(tierCurrent, tilesCached);
							redisplayCachedTiles(vD, tierCurrent, tilesCached, 'canvasCopy', false, '4. Updating view: all new tiles loaded');
							var transitionTimer = window.setTimeout( function () { Z.Utils.clearDisplay(tC); }, 200);
							tierChanged = false;
						}
					}

					// Last needed tile loaded and drawn by function drawTileOnCanvas to temp canvas.
					// Filter tile set as one data object and transfer to viewport display canvas.
					if (Z.imageFilters) {
						self.cacheCanvasImage();
						if (imageFilterStatesConvolve) { applyImageFiltersCanvas(); }
					}
										
					// Verify tiles cached in loaded list are under allowed maximum.
					validateCache();

					// Update value for toolbar progress display.
					tilesToLoadTotal = 0;
				}

				// Validate view update progress, and debugging display data.
				self.traceDebugValues('onTileLoad', tile.name, tile.loadTime);
				self.updateProgress(tilesToLoadTotal, tilesLoadingNamesLength); // Update loading tracking variable and also progress display if enabled.
			}

			// Validate loading status.
			if (tilesToDisplay == tilesInCache + tilesLoaded) { self.setStatus('displayLoadedViewport', true); }

		} else if (typeof image === 'undefined' || image === null) {
			if (Z.mobileDevice) {
				console.log(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			} else {
				console.log(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			}
		}
	}

	function onTileBackfillLoad (tile, image) {
		if (tile && image && tile.imagePath == Z.imagePath) {  // Verify tile and image are not null and current image hasn't changed during request fulfillment.
			tile.image = image;
			var tileName = tile.name;

			// Cache tile and move tile name from loading list to loaded list.
			tilesBackfillCached[tilesBackfillCached.length] = tile;
			var index = Z.Utils.arrayIndexOf(tilesBackfillCachedNames, tileName);
			if (index != -1) { tilesBackfillCachedNames = Z.Utils.arraySplice(tilesBackfillCachedNames, index, 1); }
			if (Z.tileSource == 'ZoomifyImageFile' || Z.tileSource == 'ZoomifyPFFFile') {
				var index2 = Z.Utils.arrayIndexOf(tilesBackfillRetryNames, tileName);
				if (index2 != -1) { tilesBackfillRetryNames = Z.Utils.arraySplice(tilesBackfillRetryNames, index2, 1); }
			}

			// Alternative implementation: If preloading show message using same conditions as function onTileLoad except compare tile.t != tierBackfill for non-imageSet case.

			// No backfill fade-in necessary. Tiles precached and load behind main display or outside view area.
			tile.alpha = 1;

			// Draw tile if in current backfill tier, otherwise it will be drawn from cache when needed.
			if (tile.t == tierBackfill ) { displayTile(bD, tierBackfill, tile); }

			// Validate loading status, view update, progress, and debugging display data.
			self.traceDebugValues('onTileBackfillPrecache', tile.name);
			if (tilesBackfillToPrecache == tilesBackfillToPrecacheLoaded) { self.setStatus('precacheLoadedViewport', true); }
			self.traceDebugValues('onTileBackfillLoad', tile.name);
			if (tilesBackfillToDisplay <= tilesBackfillInCache + tilesBackfillLoaded) { self.setStatus('backfillLoadedViewport', true); }

			// If tile is also present in frontfill pass to handler for caching, tracking, filtering, and display.
			if (tile.t == tierCurrent) { onTileLoad(tile, image); }

		} else if (typeof image === 'undefined' || image === null) {
			if (Z.mobileDevice) {
				console.log(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			}
		}
	}

	// DEV NOTE: Not currently applied.
	function onTileLoadWhilePanning (tile, image) {
		if (tile && image) {
			tile.image = image;
			var tileName = tile.name;
			displayTile(vD, tierCurrent, tile);
		} else if (typeof image === 'undefined' || image === null) {
			if (Z.mobileDevice) {
				console.log(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			}
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: DRAWING FUNCTIONS ::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function fadeInIntervalHandler () {
		var completeCount = 0;
		for (var i = 0, j = tilesInView.length; i < j; i++) {
			var tile = tilesInView[i];
			if (tile.t == tierCurrent) {

				if (Z.fadeIn && fadeInStep != 0 && (tile.alpha + fadeInStep) < 1) {
					tile.alpha += fadeInStep;
				} else {
					tile.alpha = 1;
					completeCount++;
				}

				// DEV NOTE: Draws tiles in view if any tile new. Allows for loading delays but may draw redundantly on rapid small pans.
				// Debug option: console.log('Fading: ' + tile.name + '  alpha: ' + tile.alpha);
				displayTile(vD, tierCurrent, tile);

				if (completeCount >= j) {
					window.clearInterval(fadeInInterval);
					fadeInInterval = null;
					i = j;
				}
			} else {
				tilesInView = Z.Utils.arraySplice(tilesInView, i, 1);
				tilesInViewNames = Z.Utils.arraySplice(tilesInViewNames, i, 1);
				var index = Z.Utils.arrayIndexOf(tilesLoadingNames, tile.name);
				if (index != -1) { tilesLoadingNames = Z.Utils.arraySplice(tilesLoadingNames, index, 1); }
				j--;
			}
		}
	}

	function displayTile (display, tier, tile) {
		// Draw tile on screen using canvas or image elements as appropriate to browser support.  Apply
		// zoom of current tier to imageX and Y but do not apply scale of current tier as that scaling is function
		// of the context or container object. Do not display tile if tile has been skipped (see skipTile function notes).
		if (tile.url.substr(0, 8) != 'skipTile' && tile.image.width != 0 && tile.image.height != 0) {

			var x = tile.x;
			var y = tile.y;
			var tierCurrentZoomUnscaled = convertTierScaleToZoom(tier, 1);

			tierBackfillOversizeScale = convertZoomToTierScale(tierBackfillOversize, self.getZoom());
			var override = (tierBackfillOversizeScale > 8); // Slider snap or mousewheel can create need for oversize backfill before selectTier resets tierBackfillDynamic = true.
			if (Z.useCanvas) {
				if (display == vD || display == tC || (display == bD && tierBackfillDynamic)) {
					x -= (Z.imageX * tierCurrentZoomUnscaled);
					y -= (Z.imageY * tierCurrentZoomUnscaled);
				} else if (display == oD && (tierBackfillDynamic  || override)) {
					var newVPImgCtrPt = self.calculateCurrentCenterCoordinates();
					x -= (newVPImgCtrPt.x * tierCurrentZoomUnscaled);
					y -= (newVPImgCtrPt.y * tierCurrentZoomUnscaled);
				}
				drawTileOnCanvas(display, tile, x, y);

			} else {
				var scale;
				if (display == vD) {
					x -= ((Z.imageX * tierCurrentZoomUnscaled) - (displayCtrX / tierScale));
					y -= ((Z.imageY * tierCurrentZoomUnscaled) - (displayCtrY / tierScale));
					scale = tierScale;
				} else {
					scale = tierBackfillScale;
				}
				drawTileInHTML(display, tile, x, y, scale);
			}

			// Validate drawing status, view update, progress, and debugging display data.
			if (display == vD) {
				self.traceDebugValues('displayTile', tile.name);
				if (tilesToDisplay == tilesDisplayed) { self.setStatus('displayDrawnViewport', true); }
			} else {
				self.traceDebugValues('displayBackfillTile', tile.name);
				if (tilesBackfillToDisplay <= tilesBackfillDisplayed) { self.setStatus('backfillDrawnViewport', true); }
			}
		}
	}

	function drawTileOnCanvas (container, tile, x, y) {
		// Debug option: Uncomment next two lines to display tile borders.
		//x += tile.c;
		//y += tile.r;

		var containerCtx = container.getContext('2d');

		if (Z.alphaSupported && tile.alpha < 1 && container.id != 'transitionCanvas' && (container.id.indexOf('oversizeDisplay') == -1) && container.id != 'savingDisplay' && !imageFilterStatesConvolve) {
			containerCtx.globalAlpha = tile.alpha;
		}

		// If no filter set, draw directly to canvas.  If filter set, apply filter to each tile and use
		// putImageData to place tile image on transfer canvas, then use drawImage to transfer
		// to main canvas and implement scaling (ignored by putImageData function).  If filter
		// set with convolution, reset 'container' to draw all tiles for new view to transfer canvas
		// for image filter display or backfill and function applyImageFilters or onTileLoad will apply
		// filters to full view as one data object to avoid tile lines and then transfer to main canvases.
		if (!Z.imageFilters || imageFiltersApplied.length == 0) {
			containerCtx.drawImage(tile.image, x, y);

		} else {
			if (!imageFilterStatesConvolve) {
				var imgDataObjFiltered = applyImageFiltersTile(tile.name, tile.image);
				Z.Utils.clearDisplay(tC);
				tCtx.putImageData(imgDataObjFiltered, 0, 0);
				containerCtx.drawImage(tC, x, y)
				
			} else {
				if (container.id.indexOf('oversizeDisplay') != -1) {
					containerCtx = oCtx;
				} else if (container.id.indexOf('viewportDisplay') != -1) {
					containerCtx = fCtx;
				} else if (container.id.indexOf('viewportBackfillDisplay') != -1) {
					containerCtx = fbCtx;
				} else if (container.id.indexOf('transitionCanvas') != -1) {
					// DEV NOTE: Add immediate individual filtering and drawing of cached tiles.
					// Currently this condition blocks temp cache display if convolution filter applied.
					containerCtx = fCtx;
				} else if (container.id == 'savingDisplay') {
					containerCtx = sCtx;
				}
				containerCtx.drawImage(tile.image, x, y);
			}
		}

		if (Z.alphaSupported && tile.alpha < 1 && container.id != 'transitionCanvas' && container.id != 'oversizeDisplay' && container.id != 'savingDisplay' && !imageFilterStatesConvolve) {
			containerCtx.globalAlpha = 1;
		}

		// If in debug mode 2, add tile name to tile.
		if (Z.debug == 2 || Z.debug == 4) { drawTileNameOnTile(container, tile.name, x, y, tierScale); }
	}

	function drawTileInHTML (container, tile, x, y, scale) {
		if (!tile.elmt) {
			// Simple conditional above is OK because tile.elmt will not be numeric and thus not 0.
			tile.elmt = Z.Utils.createContainerElement('img');
			tile.elmt.onmousedown = Z.Utils.preventDefault; // Disable individual tile mouse-drag.
			Z.Utils.addEventListener(tile.elmt, 'contextmenu', Z.Utils.preventDefault);
			tile.elmt.src = tile.url;
			tile.style = tile.elmt.style;
			tile.style.position = 'absolute';
			Z.Utils.renderQuality (tile, Z.renderQuality);
			if (Z.cssTransformsSupported) { tile.style[Z.cssTransformProperty + 'Origin'] = '0px 0px'; }
		}
		if (tile.elmt.parentNode != container) { container.appendChild(tile.elmt); }
		var tS = tile.style;

		// Speed redraw by hiding tile to avoid drawing on each change (width, height, left, top).
		tS.display = 'none';

		if (Z.cssTransformsSupported) {
			// Backfill in non-IE browsers.
			tS[Z.cssTransformProperty] = ['matrix(', (tile.image.width / tile.elmt.width * scale).toFixed(8), ',0,0,', (tile.image.height / tile.elmt.height * scale).toFixed(8), ',', (x * scale).toFixed(8), Z.cssTransformNoUnits ? ',' : 'px,', (y * scale).toFixed(8), Z.cssTransformNoUnits ? ')' : 'px)'].join('');
		} else {
			// Backfill and frontfill in IE without canvas support.
			tS.width = (tile.image.width * scale) + 'px';
			tS.height = (tile.image.height * scale) + 'px';
			tS.left = (x * scale) + 'px';
			tS.top = (y * scale) + 'px';
		}

		// Unhide tile.
		tS.display = 'inline-block';

		// Set alpha to fade-in tile if supported.
		Z.Utils.setOpacity(tile, tile.alpha);

		// Debug option: Uncomment next two lines to display tile borders.
		//tile.elmt.style.borderStyle = 'solid';
		//tile.elmt.style.borderWidth = '1px';

		// If in debug mode 2, add tile name to tile.
		if (Z.debug == 2 || Z.debug == 4) { drawTileNameOnTile(container, tile.name, x, y, scale); }
	}

	function drawTileNameOnTile (container, tileName, x, y, scale) {
		if (Z.useCanvas) {
			drawTileNameOnCanvas (container, tileName, x, y, scale);
		} else {
			drawTileNameInHTML(container, tileName, x, y, scale);
		}
	}

	function drawTileNameOnCanvas (container, tileName, x, y, scale) {
		// Get font size constraints.
		var defaultFontSize = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTCAPTIONFONTSIZE'), 10);
		var minFontSize = parseInt(Z.Utils.getResource('DEFAULT_MINHOTSPOTCAPTIONFONTSIZE'), 10);
		var maxFontSize = parseInt(Z.Utils.getResource('DEFAULT_MAXHOTSPOTCAPTIONFONTSIZE'), 10);
		var scaledFontSize = Math.round(defaultFontSize * scale);
		var constrainedFontSize = 2 * (( scaledFontSize < minFontSize) ? minFontSize : (( scaledFontSize > maxFontSize) ? maxFontSize : scaledFontSize));

		// Get canvas context and set font style.
		var vpdCtx = container.getContext('2d');
		vpdCtx.font = constrainedFontSize + 'px verdana';
		vpdCtx.textAlign = 'left';
		vpdCtx.textBaseline = 'top';

		// Calculate tile x and y offsets to center on scaled tile.
		var tileNameOffsetW = TILE_WIDTH * scale / 2;
		var tileNameOffsetH = TILE_HEIGHT * scale / 2;

		// Draw tile name white.
		vpdCtx.fillStyle = '#FFFFFF';
		vpdCtx.fillText(tileName, x + tileNameOffsetW, y + tileNameOffsetH);

		// Draw tile name black.
		vpdCtx.fillStyle = '#000000';
		vpdCtx.fillText(tileName, x + tileNameOffsetW + 1, y + tileNameOffsetH + 1);
	}

	function drawTileNameInHTML (container, tileName, x, y, scale) {
		// Get font size constraints.
		var defaultFontSize = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTCAPTIONFONTSIZE'), 10);
		var minFontSize = parseInt(Z.Utils.getResource('DEFAULT_MINHOTSPOTCAPTIONFONTSIZE'), 10);
		var maxFontSize = parseInt(Z.Utils.getResource('DEFAULT_MAXHOTSPOTCAPTIONFONTSIZE'), 10);
		var scaledFontSize = Math.round(defaultFontSize * scale);
		var constrainedFontSize = 2 * (( scaledFontSize < minFontSize) ? minFontSize : (( scaledFontSize > maxFontSize) ? maxFontSize : scaledFontSize));

		// Create caption text node and container, and set font style.
		var padding = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTCAPTIONPADDING'), 10) * scale;

		// Draw tile name white.
		var tileNameTextBox = Z.Utils.createContainerElement('div', 'tileNameTextBox', 'inline-block', 'absolute', 'hidden', 'auto', 'auto', '1px', '1px', 'none', '0px', 'transparent none', '0px', padding + 'px', 'nowrap');
		var tileNameTextNode = document.createTextNode(tileName);
		tileNameTextBox.appendChild(tileNameTextNode);
		container.appendChild(tileNameTextBox);
		Z.Utils.setTextNodeStyle(tileNameTextNode, 'white', 'verdana', constrainedFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none');

		// Draw tile name black.
		var tileNameTextBox2 = Z.Utils.createContainerElement('div', 'tileNameTextBox2', 'inline-block', 'absolute', 'hidden', 'auto', 'auto', '1px', '1px', 'none', '0px', 'transparent none', '0px', padding + 'px', 'nowrap');
		var tileNameTextNode2 = document.createTextNode(tileName);
		tileNameTextBox2.appendChild(tileNameTextNode2);
		container.appendChild(tileNameTextBox2);
		Z.Utils.setTextNodeStyle(tileNameTextNode2, 'black', 'verdana', constrainedFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none');

		// Position tile name. Must occur after added to display because text container width setting is 'auto'.
		var padding = parseFloat(tileNameTextBox.style.padding);
		var computedW = parseFloat(Z.Utils.getElementStyleProperty(tileNameTextBox, 'width'));
		if (isNaN(computedW)) {
			// Workaround for IE failure to report text container element width if setting is 'auto'.
			var font2Pixels = parseFloat(Z.Utils.getResource('DEFAULT_FONTTOPIXELSCONVERSIONFACTOR'));
			var ratioPixs2Chars = parseFloat(tileNameTextBox.style.fontSize) / font2Pixels;
			computedW = Math.round(parseFloat(tileName.length * ratioPixs2Chars));
		}
		var tileScaledW = TILE_WIDTH * scale / 2;
		var tileScaledH = TILE_HEIGHT * scale / 2;
		tileNameTextBox.style.left = ((x * scale) + ((tileScaledW - (computedW / 2)) - padding)) + 'px';
		tileNameTextBox.style.top = ((y * scale) + tileScaledH) + 'px';
		tileNameTextBox2.style.left = (1 + (x * scale) + ((tileScaledW - (computedW / 2)) - padding)) + 'px';
		tileNameTextBox2.style.top = (1 + (y * scale) + tileScaledH) + 'px';

		// Prevent text selection and context menu.
		Z.Utils.addEventListener(tileNameTextBox, 'contextmenu', Z.Utils.preventDefault);
		Z.Utils.disableTextInteraction(tileNameTextNode);
		Z.Utils.addEventListener(tileNameTextBox2, 'contextmenu', Z.Utils.preventDefault);
		Z.Utils.disableTextInteraction(tileNameTextNode2);
	}


	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::: IIIF IMAGE SERVER FUNCTIONS :::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getIIIFURI = function (recalc) {
		var currentViewIIIFURI;
		var scheme = self.getIIIFScheme();
		var server = self.getIIIFServer();
		var prefix = self.getIIIFPrefix();
		var identifier = self.getIIIFIdentifier();
		var regionStr = self.getIIIFRegion();
		var sizeStr = self.getIIIFSize();
		var rotationStr = self.getIIIFRotation();
		var quality = self.getIIIFQuality();
		var format = self.getIIIFFormat();
		if (scheme && server && identifier) {
			currentViewIIIFURI = scheme + '://' + server + '/' + prefix + '/' + identifier + '/' + regionStr + '/' + sizeStr + '/' + rotationStr + '/' + quality + format;
		} else {
			currentViewIIIFURI = Z.Utils.getResource('ERROR_SETTINGIIIFIMAGEPATH');
		}
		return currentViewIIIFURI;
	}

	this.getIIIFScheme = function () {
		var scheme = (typeof Z.iiifScheme != 'undefined' && Z.Utils.stringValidate(Z.iiifScheme)) ? Z.iiifScheme : 'https';
		return scheme;
	}

	this.getIIIFServer = function () {
		var server = (typeof Z.iiifServer != 'undefined' && Z.Utils.stringValidate(Z.iiifServer)) ? Z.iiifServer : null;
		return server;
	}

	this.getIIIFPrefix = function () {
		var prefix = (typeof Z.iiifPrefix != 'undefined' && Z.Utils.stringValidate(Z.iiifPrefix)) ? Z.iiifPrefix : null;
		return prefix;
	}

	this.getIIIFIdentifier = function () {
		var identifier = (typeof Z.iiifIdentifier != 'undefined' && Z.Utils.stringValidate(Z.iiifIdentifier)) ? Z.iiifIdentifier : null;
		return identifier;
	}

	this.getIIIFRegion = function () {
		var zoom = self.getZoom();
		var regionXStr = Math.min(Math.max(0, Math.round(self.getX() - (viewW / zoom) / 2)), Z.imageW).toString();
		var regionYStr = Math.min(Math.max(0, Math.round(self.getY() - (viewH / zoom) / 2)), Z.imageH).toString();
		var regionWStr = Math.min(Z.imageW, Math.round(viewW / zoom)).toString();
		var regionHStr = Math.min(Z.imageH, Math.round(viewH / zoom)).toString();
		return regionXStr + ',' + regionYStr + ',' + regionWStr + ',' + regionHStr;
	}

	this.getIIIFSize = function () {
		return viewW.toString() + ',' + viewH.toString();
	}

	this.getIIIFRotation = function () {
		return Z.imageR.toString();
	}

	this.getIIIFQuality = function () {
		var qualityStr = (Z.iiifQuality) ? Z.iiifQuality.toString() : 'default';
		return qualityStr;
	}

	this.getIIIFFormat = function () {
		var formatStr = (Z.iiifFormat !== null && (Z.iiifFormat == '.jpg' || Z.iiifFormat == '.png')) ? Z.iiifFormat.toString() : '.jpg';
		return formatStr;
	}

	this.getViewCoordinatesIIIFString = function (recalc, viewCtrPt, purpose) {
		var iiifCoordsString = '';
		var w = Math.round(viewW / self.getZoom(recalc));
		var h = Math.round(viewH / self.getZoom(recalc));
		w = (w < 1) ? 1 : (w > Z.imageW) ? Z.imageW : w;
		h = (h < 1) ? 1 : (h > Z.imageH) ? Z.imageH : h;
		var x = (viewCtrPt) ? Math.round(viewCtrPt.x) : Math.round(self.getX(recalc));
		var y = (viewCtrPt) ? Math.round(viewCtrPt.y) : Math.round(self.getY(recalc));

		// DEV NOTE: Coordinates adjusted per IIIF specification.
		x -= (w / 2);
		y -= (h / 2);
		x = (x < 0) ? 0 : (x > Z.imageW) ? Z.imageW : x;
		y = (y < 0) ? 0 : (y > Z.imageH) ? Z.imageH : y;

		var regionXStr = x.toString();
		var regionYStr = y.toString();
		var regionWStr = w.toString();
		var regionHStr = h.toString();
		var regionStr = regionXStr + ',' + regionYStr + ',' + regionWStr + ',' + regionHStr;
		var viewWStr = viewW.toString();
		var viewHStr = viewH.toString();
		var sizeStr = viewWStr + ',' + viewHStr;
		var rotationStr = Math.round(self.getRotation()).toString();
		var qualityStr = self.getIIIFQuality();
		var formatStr = self.getIIIFFormat();
		var iiifDetailsStr = regionStr + '/' + sizeStr + '/' + rotationStr + '/' + qualityStr + formatStr;

		if (purpose == 'show') {
			iiifCoordsString = 'RegionX="' + regionXStr + '"   RegionY="' + regionYStr;
		} else if (purpose == 'save') {
			iiifCoordsString = Z.imagePath + '/' + iiifDetailsStr;
		} else if (purpose == 'bookmark') {
			iiifCoordsString = Z.imagePath + '/' + iiifDetailsStr;
		}

		// Reference IIIF image server path: 'https://stacks.stanford.edu/image/iiif/ff139pd0160%252FK90113-43/2400,1400,512,512/512,512/0/default.jpg';

		return iiifCoordsString;
	}

	function formatTilePathIIIFImageServer (t, c, r, requester) {
		var tileW = TILE_WIDTH;
		var tileH = TILE_HEIGHT;
		var tierRatio = tierWs[t] / Z.imageW;
		var regionXStr = Math.round(c * (tileW / tierRatio)).toString();
		var regionYStr = Math.round(r * (tileH / tierRatio)).toString();
		var regionWStr = Math.round(tileW / tierRatio).toString();
		var regionHStr = Math.round(tileH / tierRatio).toString();
		var viewWStr = Math.min(Math.round((Z.imageW * tierRatio) - (tileW * c)), TILE_WIDTH).toString();
		var viewHStr = Math.min(Math.round((Z.imageH * tierRatio) - (tileH * r)), TILE_HEIGHT).toString();
		var rotationStr = '0';
		var qualityStr = self.getIIIFQuality();
		var formatStr = self.getIIIFFormat();

		// Debug Option: test value for reference implementation IIIF Image Server.
		// Reference IIIF image server path: 'https://stacks.stanford.edu/image/iiif/ff139pd0160%252FK90113-43/2400,1400,512,512/512,512/0/default.jpg';
		//console.log(t, c, r, tierWs[t], tierWInTiles[t], Z.imageW, tierRatio, TILE_WIDTH);

		var tilePath = Z.imagePath + '/' + regionXStr + ',' + regionYStr + ',' + regionWStr + ',' + regionHStr + '/' + viewWStr + ',' + viewHStr + '/' + rotationStr + '/' + qualityStr + formatStr;
		return tilePath;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::: EXAMPLE IMAGE SERVER STORAGE FUNCTIONS :::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function formatTilePathImageServer (t, c, r, requester) {
		// Example image server protocol implementation: the following steps support the tile
		// request protocol of one popular image server, the Slide Path Digital Slide Server.

		// Get file type from image path filename extension. Two options in example implementation.
		var fileType = (Z.imagePath.toLowerCase().indexOf('.svs') != -1) ? 'svs' : (Z.imagePath.toLowerCase().indexOf('.ndpi') != -1) ? 'ndpi': null;

		// Convert Viewer x, y, and zoom values to protocol of example image server.
		var zoom = convertViewerZoomToImageServerZoom();
		var x = Z.imageX * Z.imageZ;
		var y = Z.imageY * Z.imageZ;

		// DEV NOTE: Example implementation requires additional value.
		var miscValue = 1;
		var tilePath = Z.tileHandlerPathFull + '?FIF=' + imagePath + '&focal=' + Z.focal + '&QLT=' + Z.quality + '&DSTL=' + x + ',' + y + ',' + TILE_WIDTH + ',' + TILE_HEIGHT + ',' + zoom + ',' + miscValue + '&type=' + fileType;

		// Debug option: above example tilePath traced for review and then replaced
		// with substitute value to display Zoomify Logo for visual assessment of placement.
		Z.Utils.trace(tilePath);
		tilePath = 'Assets/Skins/Default/standard/toolbarLogo.png';

		// Example tile path values for example image server implementation:
		// 'http://slides.myDomain.com/fcgi-bin-dss/dss.fcgi?FIF=/Images/myImage1.svs&focal=1&QLT=55&DSTL=1,1,512,512,100,1&type=svs'
		// 'http://slides.myDomain.com/fcgi-bin-dss/dss.fcgi?FIF=/Images/myImage2.ndpi&focal=1&QLT=55&DSTL=1,1,512,512,100,1&type=ndpi'

		return tilePath;
	}

	function convertViewerZoomToImageServerZoom () {
		// Example image server protocol implementation: the following steps support the tile
		// request protocol of one popular image server, the Slide Path Digital Slide Server.
		// Zoom values are inverted relative to Zoomify range, and limited to discreet tiers.
		var zoomifyZ = Z.imageZ * 100;
		var maxScaleUp = TIERS_SCALE_UP_MAX;
		var imageServerZ;

		if (Z.sourceMagnification == 40) {
			// 100%=1=40x, 50%=2=20x, 25%=4=10x, 10%=8=4x, 5%=16=2x, 2.5%=32=1x.
			if (zoomifyZ <= 2.5 + maxScaleUp) {
				imageServerZ = 32;
			} else if (zoomifyZ <= 5 + maxScaleUp) {
				imageServerZ = 16;
			} else if (zoomifyZ <= 10 + maxScaleUp) {
				imageServerZ = 8;
			} else if (zoomifyZ <= 25 + maxScaleUp) {
				imageServerZ = 4;
			} else if (zoomifyZ <= 50 + maxScaleUp) {
				imageServerZ = 2;
			} else {
				imageServerZ = 1;
			}
		} else if (Z.sourceMagnification == 20) {
			// 100%=1=20x, 50%=2=10x, 20%=4=4x, 10%=8=2x, 5%=16=1x.
			if (zoomifyZ <= 5 + maxScaleUp) {
				imageServerZ = 16;
			} else if (zoomifyZ <= 10 + maxScaleUp) {
				imageServerZ = 8;
			} else if (zoomifyZ <= 20 + maxScaleUp) {
				imageServerZ = 4;
			} else if (zoomifyZ <= 50 + maxScaleUp) {
				imageServerZ = 2;
			} else {
				imageServerZ = 1;
			}
		}

		return imageServerZ;
	}


	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::: CALCULATION & CONVERSION FUNCTIONS ::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getClickCoordsAtZoom = function (event, zoom) {
		var imageClickPt = this.getClickCoordsInImage(event, zoom);
		var imageX = imageClickPt.x;
		var imageY = imageClickPt.y;
		var zoomedX = imageX * zoom;
		var zoomedY = imageY * zoom;
		var zoomedClickPt = new Z.Utils.Point(zoomedX, zoomedY);
		return zoomedClickPt;
	}

	this.getClickCoordsInImage = function (event, zoom, mPt) {
		var event = Z.Utils.event(event);
		var imageClickPt = null;
		if (event) {
			var eventType = event.type;

			if (typeof zoom === 'undefined' || zoom == null) {
				zoom = self.getZoom();
			}
			if (typeof mPt === 'undefined' || mPt === null) {
				if (eventType == 'touchstart' || eventType == 'touchend' || eventType == 'touchcancel') {
					touch = Z.Utils.getFirstTouch(event);
					if (typeof touch !== 'undefined') {
						target = touch.target;
						mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
					}
				} else {
					target = Z.Utils.target(event);
					relatedTarget = Z.Utils.relatedTarget(event);
					mPt = Z.Utils.getMousePosition(event);
				}
			}

			if (typeof mPt !== 'undefined' && mPt !== null) {
				var viewportClickPt = self.convertPageCoordsToViewportCoords(mPt.x, mPt.y);
				imageClickPt = self.convertViewportCoordsToImageCoords(viewportClickPt.x, viewportClickPt.y, zoom);
			}
		}
		return imageClickPt;
	}

	function getClickZoomCoords3DAsString (event) {
		var event = Z.Utils.event(event);
		var zVal = self.getZoom();
		var clickPt = self.getClickCoordsInImage(event, zVal);
		var xString = Math.round(clickPt.x).toString();
		var yString = Math.round(clickPt.y).toString();
		var zString = (Math.round(zVal * 1000)/10).toString();
		var coordsString = 'X="' + xString + '"   Y="' + yString + '"   ZOOM="' + zString + '"';

		// Alternative display, simpler view, less useful for pasting to hotspots XML file.
		// var coordsString = 'X ' + xString + ' px   Y ' + yString + ' px   Z ' + zString + ' %';

		return coordsString;
	}

	this.getClickZoomCoords3D = function (event, pageClickPt, tCurrent, tScale, dblClick) {
		// Set condition for zooming in or out by more than one tier.
		var tierSkipThreshold = parseFloat(Z.Utils.getResource('DEFAULT_CLICKZOOMTIERSKIPTHRESHOLD'));

		// Calculate image coordinates of click and set default target zoom.
		var viewportClickPt = self.convertPageCoordsToViewportCoords(pageClickPt.x, pageClickPt.y);
		var imageClickPt = self.convertViewportCoordsToImageCoords(viewportClickPt.x, viewportClickPt.y, Z.imageZ);
		var targetZ = convertTierScaleToZoom(tCurrent, tScale);
		var isAltKey = event.altKey;

 		// Calculate target zoom for next or prior tier. If very close to next tier, skip over it.
		if (!dblClick) {
			// Zoom-in.
			if (!isAltKey) {
				// Zoom-in to next tier.
				if (tScale < 1 - tierSkipThreshold) {
					targetZ = convertTierScaleToZoom(tCurrent, 1);
				} else if (tCurrent < tierCount - 1) {
					targetZ = convertTierScaleToZoom(tCurrent + 1, 1);
				} else if (Z.maxZ > 1) {
					targetZ = Z.maxZ; // Special case: one click-zoom to max zoom > 100%.
				}

			} else {
				// Zoom-in to max zoom.
				targetZ = Z.maxZ;
			}

		} else{
			// Zoom-out.
			if (!isAltKey) {
				// Scale current tier to zoom-to-fit, or current tier to 1, or prior tier to 1.
				var zFitScale = convertZoomToTierScale(tCurrent, Z.fitZ);

				if (tScale - zFitScale < tierSkipThreshold) {
					targetZ = Z.fitZ;
				} else if (tScale > 1 + tierSkipThreshold) {
					targetZ = convertTierScaleToZoom(tCurrent, 1);
				} else if (tCurrent > 0) {
					targetZ = convertTierScaleToZoom(tCurrent - 1, 1);
				} else if (Z.tileSource == 'unconverted') {
					targetZ = Z.fitZ;
				}

			} else {
				// Zoom-out to zoom-to-fit.
				targetZ = Z.fitZ;
			}
		}

		return new Z.Utils.Point3D(imageClickPt.x, imageClickPt.y, targetZ);
	}

	this.calculateCurrentCenterCoordinates = function (viewportPt, z, r) {
		if (typeof viewportPt === 'undefined' || viewportPt === null) { var viewportPt = new Z.Utils.Point(parseFloat(cS.left), parseFloat(cS.top)); }
		if (typeof r === 'undefined' || r === null) { r = self.getRotation(); }
		if (r < 0) { r += 360; } // Ensure positive values.
		if (typeof z === 'undefined' || z === null) { z = self.getZoom(); }

		var currentX = Math.round(Z.imageX - ((viewportPt.x - displayL) / z));
		var currentY = Math.round(Z.imageY - ((viewportPt.y - displayT) / z));
		var currentPtRotated = Z.Utils.getPositionRotated(currentX, currentY, Z.imageX, Z.imageY, -r);

		return new Z.Utils.Point(currentPtRotated.x, currentPtRotated.y);
	}

	// Get bounding box in image tiles for current view. Use tier parameter to current or backfill tier.
	// Use parameter viewportOnly to narrow bounds to view area, excluding pan buffer.
	// Use parameter viewCenterOnly to narrow bounds to view area as-if zoomed in to specified tier - used for preloading feature.
	this.getViewportDisplayBoundingBoxInTiles = function (tier, viewportOnly, viewCenterOnly, partials) {
		if (typeof tier === 'undefined' || tier === null) { tier = tierCurrent; }
		if (typeof viewportOnly === 'undefined' || viewportOnly === null) { viewportOnly = false; }
		var viewCenterTier = (viewCenterOnly) ? tier : null;
		return new BoundingBoxInTiles(self.getViewportDisplayBoundingBoxInPixels(viewportOnly, viewCenterTier, partials), tier);
	}

	// Get bounding box coordinates in image pixels for current view plus pan buffer border area.
	this.getViewportDisplayBoundingBoxInPixels = function (viewportOnly, vTier, partials) {

		// Allow for pan in progress via movement of display.
		var canvasOffsetL = parseFloat(cS.left) - displayL;
		var canvasOffsetT = parseFloat(cS.top) - displayT;

		// Allow for CSS scaling calculations.
		if (Z.useCanvas) {
			var cssScale = parseFloat(cS.width) / cD.width;
			canvasOffsetL /= cssScale;
			canvasOffsetT /= cssScale;
		}

		// Convert offset pixels of any pan in progress to image pixels.
		var currentZ = self.getZoom();
		if (canvasOffsetL != 0) { canvasOffsetL /= currentZ; }
		if (canvasOffsetT != 0) { canvasOffsetT /= currentZ; }

		var ctrX = Z.imageX - canvasOffsetL;
		var ctrY = Z.imageY - canvasOffsetT;
		var ctrToLeft, ctrToTop, ctrToRight, ctrToBottom;
		if (viewportOnly) {
			ctrToLeft = -(viewW / 2);
			ctrToRight = (viewW / 2);
			ctrToTop = -(viewH / 2);
			ctrToBottom = (viewH / 2);

		} else {
			ctrToLeft = -(displayW / 2);
			ctrToRight = (displayW / 2);
			ctrToTop = -(displayH / 2);
			ctrToBottom = (displayH / 2);
		}

		return new BoundingBoxInPixels(ctrX, ctrY, ctrToLeft, ctrToRight, ctrToTop, ctrToBottom, currentZ, vTier, partials);
	}

	this.HotspotsAllBoundingBoxInPixels = function () {
		// Find smallest and largest values, and related hotspots indices.
		var hC = new HotspotContext();
		var smallestX = Z.imageCtrX;
		var largestX = Z.imageCtrX;
		var smallestY = Z.imageCtrY;
		var largestY = Z.imageCtrY;

		for (var i = 0, j = hotspots.length; i < j; i++) {
			var hotspot = hotspots[i];
			var hotDims = new HotspotDimensions(hotspot, hC, null, true);
			var l = hotspot.x - (hotDims.w / 2);
			var r = hotspot.x + (hotDims.w / 2);
			var t = hotspot.y - (hotDims.h / 2);
			var b = hotspot.y + (hotDims.h / 2);

			if (l < smallestX) { smallestX = l; }
			if (r > largestX) { largestX = r; }
			if (t < smallestY) { smallestY = t; }
			if (b > largestY) { largestY = b; }
		}

		// Add margin beyond smallest and largest values.
		var labelMargin = parseInt(Z.Utils.getResource('DEFAULT_SAVEIMAGELABELMARGIN'), 10);
		smallestX -= labelMargin;
		smallestY -= labelMargin;
		largestX += labelMargin;
		largestY += labelMargin;

		// Recalculate center values.
		var ctrX = smallestX + ((largestX - smallestX) / 2);
		var ctrY = smallestY + ((largestY - smallestY) / 2);

		this.l = smallestX;
		this.r = largestX;
		this.t = smallestY;
		this.b = largestY;
		this.x = ctrX;
		this.y = ctrY;
	}

	function BoundingBoxInTiles (pixelsBoundingBox, tier) {
		// Caculate edges of view in image tiles of the current tier.
		var tierCurrentZoomUnscaled = convertTierScaleToZoom(tier, 1);
		var viewTileL = Math.floor(pixelsBoundingBox.l * tierCurrentZoomUnscaled / TILE_WIDTH);
		var viewTileR = Math.floor(pixelsBoundingBox.r * tierCurrentZoomUnscaled / TILE_WIDTH);
		var viewTileT = Math.floor(pixelsBoundingBox.t * tierCurrentZoomUnscaled / TILE_HEIGHT);
		var viewTileB = Math.floor(pixelsBoundingBox.b * tierCurrentZoomUnscaled / TILE_HEIGHT);

		// Constrain edge tile values to existing columns and rows.
		if (viewTileL < 0) { viewTileL = 0; }
		if (viewTileR > tierWInTiles[tier] - 1) { viewTileR = tierWInTiles[tier] - 1; }
		if (viewTileT < 0) { viewTileT = 0; }
		if (viewTileB > tierHInTiles[tier] - 1) { viewTileB = tierHInTiles[tier] - 1; }

		this.l = viewTileL;
		this.r = viewTileR;
		this.t = viewTileT;
		this.b = viewTileB;
	}

	function BoundingBoxInPixels (x, y, vpPixelsLeft, vpPixelsRight, vpPixelsTop, vpPixelsBottom, zoom, vTier, partials) {
		// Convert any bounding box from viewport pixels to image pixels.
		if (typeof vTier === 'undefined' || vTier === null) {
			this.l = x + vpPixelsLeft / zoom;
			this.r = x + vpPixelsRight / zoom;
			this.t = y + vpPixelsTop / zoom;
			this.b = y + vpPixelsBottom / zoom;
		} else {
			// Use vTier to calculate scale factor in place of zoom for preloading.
			var viewWRatio = viewW / tierWs[vTier];
			var viewHRatio = viewH / tierHs[vTier];
			this.l = x + vpPixelsLeft * viewWRatio;
			this.r = x + vpPixelsRight * viewWRatio;
			this.t = y + vpPixelsTop * viewHRatio;
			this.b = y + vpPixelsBottom * viewHRatio;
		}
		if (partials) {
			// Expand box out to nearest tile edge to enable caching of tiles partially in view. Used when preloading single image.
			this.l = this.l - (256 - this.l % 256);
			this.r = this.r + (256 - this.r % 256);
			this.t = this.t - (256 - this.t % 256);
			this.b = this.b + (256 - this.b % 256);
		}
	}

	// Returns coordinates within viewport display object including visible display area and out of view pan buffer area.
	this.convertPageCoordsToViewportDisplayCoords = function (pagePixelX, pagePixelY) {
		var viewportPt = self.convertPageCoordsToViewportCoords(pagePixelX, pagePixelY);
		var vpdPixelX = viewportPt.x - displayL;
		var vpdPixelY = viewportPt.y - displayT;
		return new Z.Utils.Point(vpdPixelX, vpdPixelY);
	}

	// Returns coordinates within web page using coordinates in display object including visible display area and out of view pan buffer area.
	this.convertViewportDisplayCoordsToPageCoords = function (vpdPixelX, vpdPixelY) {
		var vpPixelX = vpdPixelX + displayL;
		var vpPixelY = vpdPixelY + displayT;
		var pagePixelPt = self.convertViewportCoordsToPageCoords(vpPixelX, vpPixelY);
		return new Z.Utils.Point(pagePixelPt.x, pagePixelPt.y);
	}

	// Returns coordinates in viewport visible display area.
	this.convertPageCoordsToViewportCoords = function (pagePixelX, pagePixelY) {
		var pagePixelPt = Z.Utils.getElementPosition(viewportDisplay);
		var vpPixelX = pagePixelX - pagePixelPt.x + displayL;
		var vpPixelY = pagePixelY - pagePixelPt.y + displayT;
		return new Z.Utils.Point(vpPixelX, vpPixelY);
	}

	// Returns coordinates in web page.
	this.convertViewportCoordsToPageCoords = function (vpPixelX, vpPixelY) {
		var pagePixelPt = Z.Utils.getElementPosition(viewportDisplay);
		var pagePixelX = vpPixelX + pagePixelPt.x - displayL;
		var pagePixelY = vpPixelY + pagePixelPt.y - displayT;
		return new Z.Utils.Point(pagePixelX, pagePixelY);
	}

	this.convertPageCoordsToImageCoords = function (pagePixelX, pagePixelY) {
		var viewportPt = self.convertPageCoordsToViewportCoords(pagePixelX, pagePixelY);
		var imagePixelPt = self.convertViewportCoordsToImageCoords(viewportPt.x, viewportPt.y, Z.imageZ);
		return new Z.Utils.Point(imagePixelPt.x, imagePixelPt.y);
	}

	this.convertImageCoordsToPageCoords = function (imageX, imageY, z, r) {
		var viewportPt = self.convertImageCoordsToViewportCoords(imageX, imageY, z, r);
		var pagePixelPt = self.convertViewportCoordsToPageCoords(viewportPt.x, viewportPt.y, Z.imageZ);
		return new Z.Utils.Point(pagePixelPt.x, pagePixelPt.y);
	}

	this.convertViewportCoordsToImageCoords = function (viewportX, viewportY, z, r) {
		if (typeof z === 'undefined' || z === null) { z = Z.imageZ; }
		if (typeof r === 'undefined' || r === null) { r = Z.imageR; }
		if (r < 0) { r += 360; } // Ensure positive values.

		// Calculate current viewport center.
		var viewportCtrX = parseFloat(cS.left) + displayCtrX;
		var viewportCtrY = parseFloat(cS.top) + displayCtrY;

		// Calculate delta of input values from viewport center.
		var viewportDeltaX = viewportX - viewportCtrX;
		var viewportDeltaY = viewportY - viewportCtrY;

		// Correct coordinates for freehand drawing and polygon editing.
		if (Z.imageR != 0) {
			viewportClickPt = Z.Utils.rotatePoint(viewportDeltaX, viewportDeltaY, r);
			viewportDeltaX = viewportClickPt.x;
			viewportDeltaY = viewportClickPt.y;
		}

		// Scale delta to convert from viewport to image coordinates.
		var imageDeltaX = viewportDeltaX / z;
		var imageDeltaY = viewportDeltaY / z;

		// Combine with current image position to get image coordinates.
		var imageX = imageDeltaX + Z.imageX;
		var imageY = imageDeltaY + Z.imageY;

		return new Z.Utils.Point(imageX, imageY);
	}

	this.convertImageCoordsToViewportCoords = function (imageX, imageY, z, r) {
		if (imageX == 'center' || isNaN(parseFloat(imageX))) { imageX = Z.imageCtrX; }
		if (imageY == 'center' || isNaN(parseFloat(imageY))) { imageY = Z.imageCtrY; }
		if (typeof z === 'undefined' || z === null) { z = Z.imageZ; }
		if (typeof r === 'undefined' || r === null) { r = Z.imageR; }
		if (r < 0) { r += 360; } // Ensure positive values.

		// Calculate delta of input values from current image position.
		var imageDeltaX = imageX - Z.imageX ;
		var imageDeltaY = imageY - Z.imageY;

		// Scale delta to convert from image to viewport coordinates.
		var viewportDeltaX = imageDeltaX * z;
		var viewportDeltaY = imageDeltaY * z;

		// Correct coordinates for click-zoom, alt-click-zoom, and click-pan.
		if (Z.imageR != 0) {
			viewportClickPt = Z.Utils.rotatePoint(viewportDeltaX, viewportDeltaY, -r);
			viewportDeltaX = viewportClickPt.x;
			viewportDeltaY = viewportClickPt.y;
		}

		// Calculate current viewport center.
		var viewportCtrX = parseFloat(cS.left) + displayCtrX;
		var viewportCtrY = parseFloat(cS.top) + displayCtrY;

		// Convert display current to viewport target.
		var viewportX = viewportDeltaX + viewportCtrX;
		var viewportY = viewportDeltaY + viewportCtrY;

		return new Z.Utils.Point(viewportX, viewportY);
	}

	this.convertImageCoordsToViewportEdgeCoords = function (imageX, imageY, z, r) {
		if (typeof z === 'undefined' || z === null) { z = Z.imageZ; }
		if (typeof r === 'undefined' || r === null) { r = Z.imageR; }
		if (r < 0) { r += 360; } // Ensure positive values.

		// Calculate delta of input values from current image position.
		var imageDeltaX = Z.imageX - imageX;
		var imageDeltaY = Z.imageY - imageY;

		// Scale delta to convert from image to viewport coordinates.
		var viewportDeltaX = imageDeltaX * z;
		var viewportDeltaY = imageDeltaY * z;

		// Correct coordinates for click-zoom, alt-click-zoom, and click-pan.
		if (Z.imageR != 0) {
			viewportClickPt = Z.Utils.rotatePoint(viewportDeltaX, viewportDeltaY, -r);
			viewportDeltaX = viewportClickPt.x;
			viewportDeltaY = viewportClickPt.y;
		}

		// Convert display current to viewport target.
		var displayTargetL = displayL + viewportDeltaX;
		var displayTargetT = displayT + viewportDeltaY;

		return new Z.Utils.Point(displayTargetL, displayTargetT);
	}

	this.convertViewportEdgeCoordsToImageCoords = function (displayTargetL, displayTargetT, z, r) {
		if (typeof z === 'undefined' || z === null) { z = Z.imageZ; }
		if (typeof r === 'undefined' || r === null) { r = Z.imageR; }
		if (r < 0) { r += 360; } // Ensure positive values.

		// Convert display current to viewport target.
		var viewportDeltaX = displayTargetL - displayL;
		var viewportDeltaY = displayTargetT - displayT;

		// Correct coordinates for click-zoom, alt-click-zoom, and click-pan.
		if (Z.imageR != 0) {
			viewportClickPt = Z.Utils.rotatePoint(viewportDeltaX, viewportDeltaY, -r);
			viewportDeltaX = viewportClickPt.x;
			viewportDeltaY = viewportClickPt.y;
		}

		// Scale delta to convert from image to viewport coordinates.
		var imageDeltaX = viewportDeltaX / z;
		var imageDeltaY = viewportDeltaY / z;

		// Calculate delta of input values from current image position.
		var imageX = Z.imageX - imageDeltaX;
		var imageY = Z.imageY - imageDeltaY;

		return new Z.Utils.Point(imageX, imageY);
	}

	this.calculateZoomToFit = function (w, h, targetR) {
		// Determine zoom to fit the entire image in the viewport. This may leave empty space on the sides or on the top and bottom, depending on the aspect ratios of the image and the viewport.

		// If w and h for rectangle not provided, use image dimensions.
		if (typeof w === 'undefined' || w === null) { w = Z.imageW; }
		if (typeof h === 'undefined' || h === null) { h = Z.imageH; }

		// Alternative creates space around image for annotating.
		//var marginPercent = 1.2;
		//return ((w * marginPercent) / (h * marginPercent) > viewW / viewH) ? viewW / (w * marginPercent) : viewH / (h * marginPercent);

		var zoomToFitValue = (w / h > viewW / viewH) ? viewW / w : viewH / h;
		if (targetR == 90 || targetR == 270) {
			zoomToFitValue = (w / h > viewW / viewH) ? viewW / h : viewH / w;
		}

		return zoomToFitValue;
	}

	this.calculateZoomToFill = function (w, h, targetR) {
		// Determine zoom to fill the viewport and leave no empty space on the sides or top and bottom, regardless of the aspect ratios of the image and the viewport.

		// If w and h for rectangle not provided, use image dimensions.
		if (typeof w === 'undefined' || w === null) { w = Z.imageW; }
		if (typeof h === 'undefined' || h === null) { h = Z.imageH; }

		var zoomToFillValue = (w / h > viewW / viewH) ? viewH / h : viewW / w;
		if (targetR == 90 || targetR == 270) {
			zoomToFillValue = (w / h > viewW / viewH) ? viewH / w : viewW / h;
		}

		return zoomToFillValue;
	}

	this.calculateZoomForResize = function (currZ, priorViewW, priorViewH, newViewW, newViewH) {
		var newZ = currZ;
		var currImgW = Z.imageW * currZ;
		var currImgH = Z.imageH * currZ;
		var deltaViewW = newViewW / priorViewW;
		var deltaViewH = newViewH / priorViewH;
		if (currImgW < newViewW && currImgH < newViewH) {
			newZ = currZ;
		} else if (currImgW == newViewW && currImgH < newViewH) {
			newZ = -1;
		} else if (currImgW < newViewW && currImgH == newViewH) {
			newZ = -1;
		} else if (currImgW > newViewW && currImgH <= newViewH) {
			newZ = currZ * deltaViewW;
		} else if (currImgW <= newViewW && currImgH > newViewH) {
			newZ = currZ * deltaViewH;
		} else if (currImgW > newViewW && currImgH > newViewH) {
			var deltaView = 1;
			if (deltaViewW >= 1 && deltaViewH >= 1) {
				deltaView = (deltaViewW > deltaViewH) ? deltaViewW : deltaViewH;
			} else if (deltaViewW <= 1 && deltaViewH <= 1) {
				deltaView = (deltaViewW < deltaViewH) ? deltaViewW : deltaViewH;
			}
			newZ = currZ * deltaView;
		}

		if (newZ < Z.minZ) { newZ = Z.minZ; }
		if (newZ > Z.maxZ) { newZ = Z.maxZ; }

		// Debug option: console.log(priorViewW, newViewW, priorViewH, newViewH, deltaZ, z, newZ);

		return newZ;
	}

	this.convertTierScaleToZoom = function (tier, scale) {
		var zoom = convertTierScaleToZoom(tier, scale);
		return zoom;
	}

	function convertTierScaleToZoom (tier, scale) {
		var zoom = scale * (tierWs[tier] / Z.imageW);
		return zoom;
	}

	function convertZoomToTierScale (tier, zoom) {
		var scale = zoom / (tierWs[tier] / Z.imageW);
		return scale;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::: CONSTRAIN & SYNC FUNCTIONS :::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function constrainPan (x, y, z, r, input) {
		// Limit target pan coordinates (view, setView, zoomAndPanToView) or new
		// display container position (mouse, touch, navigator, key, slider-zoom).

		if (Z.constrainPan) {
			// Validate and record input values.
			var z = (typeof z !== 'undefined' && z !== null) ? z : Z.imageZ;
			var r = (typeof r !== 'undefined' && r !== null) ? Math.round(r) : Math.round(Z.imageR);
			if (r < 0) { r += 360; } // Ensure positive values.
			var unconstrainedX = x, unconstrainedY = y;

			if (input == 'image') {
				// Convert image pixel values to viewport values.
				var newPt = self.convertImageCoordsToViewportEdgeCoords(x, y, z, r);
				x = newPt.x;
				y = newPt.y;
			}

			// Abbreviate input values.
			var iW = Z.imageW;
			var iH = Z.imageH;
			var iWz = Math.round(iW * z);
			var iHz = Math.round(iH * z);
			var iWz2 = Math.round((iW * z) / 2);
			var iHz2 = Math.round((iH * z) / 2);
			var vW = viewW;
			var vH = viewH;
			var vEdgeX = Math.round(viewW * 0.1);
			var vEdgeY = Math.round(viewH * 0.1);
			var vCtrX = Math.round(viewW * 0.5);
			var vCtrY = Math.round(viewH * 0.5);

			// Get viewport pixels coordinates of image center.
			var currX, currY;
			currX = (vCtrX - displayL) + (Z.imageCtrX - Z.imageX) * z + x;
			currY = (vCtrY - displayT) + (Z.imageCtrY - Z.imageY) * z + y;

			// Get viewport pixel coordinates at unrotated image corners.
			var imgULX = currX - iWz / 2;
			var imgULY = currY - iHz / 2;
			var imgURX = currX + iWz / 2;
			var imgURY = currY - iHz / 2;
			var imgBRX = currX + iWz / 2;
			var imgBRY = currY + iHz / 2;
			var imgBLX = currX - iWz / 2;
			var imgBLY = currY + iHz / 2;

			// Get viewport pixel coordinate points at rotated image corners.
			var imgPtULRot = Z.Utils.getPositionRotated(imgULX, imgULY, currX, currY, r);
			var imgPtURRot = Z.Utils.getPositionRotated(imgURX, imgURY, currX, currY, r);
			var imgPtBRRot = Z.Utils.getPositionRotated(imgBRX, imgBRY, currX, currY, r);
			var imgPtBLRot = Z.Utils.getPositionRotated(imgBLX, imgBLY, currX, currY, r);

			// Get rotated bounding box display coordinate points.
			var imgRotL = Math.min(imgPtULRot.x, imgPtURRot.x, imgPtBRRot.x, imgPtBLRot.x);
			var imgRotT = Math.min(imgPtULRot.y, imgPtURRot.y, imgPtBRRot.y, imgPtBLRot.y);
			var imgRotR = Math.max(imgPtULRot.x, imgPtURRot.x, imgPtBRRot.x, imgPtBLRot.x);
			var imgRotB = Math.max(imgPtULRot.y, imgPtURRot.y, imgPtBRRot.y, imgPtBLRot.y);
			// Debug option: console.log('left: ', imgRotL, '  top: ', imgRotT, '  right: ', imgRotR, '  bottom: ', imgRotB);

			// Determine if zoomed in or out.
			var imgRotW = imgRotR - imgRotL;
			var imgRotH = imgRotB - imgRotT;
			var zoomedInHorizontal = (imgRotW > vW);
			var zoomedInVertical = (imgRotH > vH);

			// Strict constrain limits trailing edge of image to far edge of display and center image when zoomed-out. Default 'relaxed' pan constraint limits trailing edge to viewport center. Loose constraint limits image center to viewport edge (allows image half out of view).
			if (zoomedInHorizontal || !Z.constrainPanStrict) {
				if (Z.constrainPanLimit == 3) { // Strict.
					x = (imgRotL > 0) ? x - imgRotL : (imgRotR < vW) ? x - (imgRotR - vW) : x;
				} else if (Z.constrainPanLimit == 2) { // Relaxed (default).
					x = (imgRotL > vCtrX) ? x - (imgRotL - vCtrX) : (imgRotR < vCtrX) ? x - (imgRotR - vCtrX) : x;
				} else if (Z.constrainPanLimit == 1) { // Loose.
					x = (imgRotL > vEdgeX * 9) ? x - (imgRotL - vEdgeX * 9) : (imgRotR < vEdgeX) ? x - (imgRotR - vEdgeX) : x;
				}
			} else {
				x = (imgRotL > (vCtrX - iWz / 2)) ? x - (imgRotL - (vCtrX - iWz / 2)) : (imgRotR < vCtrX + iWz / 2) ? x - (imgRotR - (vCtrX + iWz / 2)) : x;
			}
			if (zoomedInVertical || !Z.constrainPanStrict) {
				if (Z.constrainPanLimit == 3) { // Strict.
					y = (imgRotT > 0) ? y - imgRotT : (imgRotB < vH) ? y - (imgRotB - vH) : y;
				} else if (Z.constrainPanLimit == 2) { // Relaxed (default).
					y = (imgRotT > vCtrY) ? y - (imgRotT - vCtrY) : (imgRotB < vCtrY) ? y - (imgRotB - vCtrY) : y;
				} else if (Z.constrainPanLimit == 1) { // Loose.
					y = (imgRotT > vEdgeY * 9) ? y - (imgRotT - vEdgeY * 9) : (imgRotB < vEdgeY) ? y - (imgRotB - vEdgeY) : y;
				}
			} else {
				y = (imgRotT > (vCtrY - iHz / 2)) ? y - (imgRotT - (vCtrY - iHz / 2)) : (imgRotB < vCtrY + iHz / 2) ? y - (imgRotB - (vCtrY + iHz / 2)) : y;
			}

			if (input == 'image') {
				// Convert viewport values to image pixel values.
				var newPt = self.convertViewportEdgeCoordsToImageCoords(x, y, z, r);
				x = newPt.x;
				y = newPt.y;
			}

			// Validate pan constraint callback.
			if (x != unconstrainedX || y != unconstrainedY) {
				x = Math.round(x);
				y = Math.round(y);
				Z.Utils.validateCallback('panConstrained');
			}
		}

		return new Z.Utils.Point(x, y);
	}

	// Ensure image is not zoomed beyond specified min and max values.
	function constrainZoom (z) {
		if (z > Z.maxZ) {
			z = Z.maxZ;
			Z.Utils.validateCallback('zoomConstrainedMax');
		} else if (z < Z.minZ) {
			z = Z.minZ;
			Z.Utils.validateCallback('zoomConstrainedMin');
		}
		return z;
	}

	function constrainRotation (targetR) {
		// Constrain to integer values in increments of 90 or -90 degrees.
		if (!Z.rotationFree) {
			targetR = Math.round(Math.abs(targetR) / 90) * 90 * Z.Utils.getSign(targetR);
		}

		// Constrain to 0 to 359 range. Reset display at constraints to avoid backspin.
		if (targetR <= -360) {
			targetR += 360;
		} else if (targetR >= 360) {
			targetR -= 360;
		}

		return targetR;
	}

	// Set toolbar slider button position.
	function syncToolbarSliderToViewport () {
		if (Z.ToolbarDisplay && Z.Toolbar.getInitialized()) {
			var currentZ = self.getZoom();
			Z.Toolbar.syncSliderToViewportZoom(currentZ);
		}
		Z.Utils.validateCallback('viewZoomingGetCurrentZoom');
	}

	function syncNavigatorToViewport () {
		// Set navigator rectangle size and position.
		if (!Z.comparison || viewportID == 0) {
			if (Z.Navigator) { Z.Navigator.syncToViewport(); }
		} else {
			if (Z.Navigator2) { Z.Navigator2.syncToViewport(); }
		}
	}

	function syncRulerToViewport () {
		// Set ruler scale bar text.
		if (Z.Ruler && Z.Ruler.getInitialized()) {
			Z.Ruler.syncToViewport();
		}
	}

	this.syncViewportToNavigator = function (newVPImgCtrPt) {
		var r = Z.imageR;
		if (r < 0) { r += 360; } // Ensure positive values.
		var constrainedPt = constrainPan(newVPImgCtrPt.x, newVPImgCtrPt.y, Z.imageZ, r, 'image');
		var zX = Z.imageX;
		var zY = Z.imageY;
		var nX = constrainedPt.x;
		var nY = constrainedPt.y;

		// Allow for rotation.
		var rdX = dX = zX - nX;
		var rdY = dY = zY - nY;
		if (r != 0) {
			if (r >= 270) {
				rdX = dY;
				rdY = -dX;
			} else if (r >= 180) {
				rdX = -dX;
				rdY = -dY;
			} else if (r >= 90) {
				rdX = -dY;
				rdY = dX;
			}
		}

		// Allow for prior display scaling and default offset.
		var deltaX = rdX * Z.imageZ;
		var deltaY = rdY * Z.imageZ;
		var newX = deltaX + displayL;
		var newY = deltaY + displayT;

		// Sync viewport display to navigator rectangle.
		cS.left = newX + 'px';
		cS.top = newY + 'px';

		if (oD && tierBackfillDynamic && (Z.mobileDevice || (Math.abs(deltaX) > (viewW / 2) || Math.abs(deltaY) > (viewH / 2)))) {
			redisplayCachedTiles(oD, tierBackfillOversize, tilesBackfillCached, 'simple', false, 'Updating backfill oversize display');
		}

		// Sync comparison and overlay viewports.
		Z.Viewer.syncComparisonViewport();
		Z.Viewer.syncOverlayViewports(null, vpID);
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::: VALIDATION FUNCTIONS CACHE, STATUS, VIEW, AND PROGRESS ::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Verify cached tiles less than maximum permitted by resourced constant. Approach assumes cache arrays are filled in sync and never sorted so orders match.
	function validateCache (imgFilter) {
		if (imgFilter) {
			while (tileImages.length > TILES_CACHE_MAX) {
				tileImages = Z.Utils.arraySplice(tileImages, 0, 1);
			}
		} else {
			while (tilesCachedNames.length > TILES_CACHE_MAX && tilesCached.length > TILES_CACHE_MAX) {
				tilesCachedNames = Z.Utils.arraySplice(tilesCachedNames, 0, 1);
				tilesCached = Z.Utils.arraySplice(tilesCached, 0, 1);
			}
		}
	}

	// Tiles and tile names added to end of cache arrays or moved to end if already included.
	function cacheTile (tile) {
		if (TILES_CACHE_MAX > 0) {
			var index = Z.Utils.arrayIndexOf(tilesCachedNames, tile.name);
			if (index != -1) {
				tilesCachedNames = Z.Utils.arraySplice(tilesCachedNames, index, 1);
				tilesCached = Z.Utils.arraySplice(tilesCached, index, 1);
			}
			tilesCachedNames[tilesCachedNames.length] = tile.name;
			tilesCached[tilesCached.length] = tile;
		}
		// Debug option: console.log(tilesCached.length + '  ' + tilesCached[tilesCached.length - 1].name + '  ' + tilesCachedNames.length + '  ' + tilesCachedNames[tilesCachedNames.length - 1]);
	}

	this.getStatus = function (vState) {
		var index = Z.Utils.arrayIndexOfObjectValue(viewportStatus, 'state', vState);
		var statusVal = (index == -1) ? false : viewportStatus[index].status;
		return statusVal;
	}

	this.setStatus = function (vState, vStatus) {
		var notYetSet = false;
		var index = Z.Utils.arrayIndexOfObjectValue(viewportStatus, 'state', vState);
		if (index == -1) {
			notYetSet = vStatus;
			viewportStatus[viewportStatus.length] = { state:vState, status:vStatus};
		} else {
			if (!viewportStatus[index].status && vStatus) { notYetSet = true; }
			viewportStatus[index].status = vStatus;
		}
		if (notYetSet) {
			Z.Utils.validateCallback(vState);
			Z.Viewer.validateViewerStatus(vState);
		}
	}

	// Display debug information if parameter set. DEV NOTE: modification in progress to use viewportStatus values.
	this.traceDebugValues = function (step, infoTxt, infoNum, dataArr) {
		var infoNumber = (typeof infoNum !== 'undefined' && infoNum !== null) ? infoNum : null;
		var infoText = (infoTxt !== null) ? infoTxt : '';

		// Calculate tracking values.
		switch (step) {
			case 'tilesToDisplay' :
				tilesToDisplay = infoNumber;
				tilesInCache = 0;
				tilesRequested = 0;
				tilesLoaded = 0;
				tilesDisplayed = 0;
				tilesWaiting = infoNumber;
				tilesTimeElapsed = 0;
				tilesTimeStart = new Date().getTime();
				tileLoadsPerSecond = 0;
				window.clearTimeout(validateViewTimer);
				validateViewTimer = null;
				validateViewTimer = window.setTimeout( validateViewTimerHandler, validateViewDelay);
				break;
			case 'tilesInCache' :
				tilesInCache = infoNumber;
				break;
			case 'loadTile-image-display' :
				tilesRequested += 1;
				break;
			case 'onTileLoad' :
				tilesLoaded += 1;
				var timeNow = new Date().getTime();
				tilesTimeElapsed = (timeNow - infoNumber) / 1000; // Seconds.
				tileLoadsPerSecond = tilesLoaded / tilesTimeElapsed;
				break;
			case 'displayTile' :
				// Increment displayed tiles counter and decrement waiting tiles counter and
				// ensure no duplicate counting for redisplays by removing from display list.
				var nameIndex = Z.Utils.arrayIndexOf(tilesDisplayingNames, infoText);
				if (nameIndex != -1) {
					tilesDisplayingNames.splice(nameIndex, 1);
					tilesDisplayed += 1;
					tilesWaiting -= 1;
				}
				break;
			case 'tilesBackfillToPrecache' :
				tilesBackfillToPrecache = infoNumber;
				break;
			case 'onTileBackfillPrecache' :
				tilesBackfillToPrecacheLoaded += 1;
				break;
			case 'tilesBackfillToDisplay' :
				tilesBackfillToDisplay = infoNumber;
				tilesBackfillWaiting = infoNumber;
				break;
			case 'onTileBackfillLoad' :
				tilesBackfillLoaded += 1;
				break;
			case 'displayBackfillTile' :
				// Increment displayed tiles counter and decrement waiting tiles counter and
				// ensure no duplicate counting for redisplays by removing from display list.
				var nameIndex = Z.Utils.arrayIndexOf(tilesBackfillDisplayingNames, infoText);
				if (nameIndex != -1) {
					tilesBackfillDisplayingNames.splice(nameIndex, 1);
					tilesBackfillDisplayed += 1;
					tilesBackfillWaiting -= 1;
				}
				break;
		}

		// Display validation values.
		if (Z.debug == 2 || Z.debug == 3) {
			Z.Utils.traceTileStatus(tilesToDisplay, tilesInCache, tilesRequested, tilesLoaded, tilesDisplayed, tilesWaiting);
		}

		// Debug options: Use zDebug=2 parameter to display messages below at appropriate steps during view updating.
		if (Z.debug == 2) {
			var dataText = (typeof dataArr !== 'undefined' && dataArr !== null && dataArr.length > 0) ? dataArr.join(', ') : 'none';
			var blankLineBefore = false, blankLineAfter = true;
			var traceText = '';
			switch (step) {
				case 'updateView-noChange' :
					traceText = 'Updating view: no change of tier.';
					break;
				case 'tilesToDisplay' :
					traceText = 'Tiles to display: ' + dataText;
					break;
				case 'tilesInCache' :
					traceText = 'Tiles in cache: ' + dataText;
					break;
				case 'tilesToLoad' :
					traceText = 'Tiles to load: ' + dataText;
					break;
				case 'tilesToLoad-backfill' :
					traceText = 'Tiles to load-backfill: ' + dataText;
					break;
				case 'redisplayCachedTiles-viewportDisplay' :
					var cachedTileNames = [];
					for (var i = 0, j = dataArr.length; i < j; i++) { cachedTileNames[cachedTileNames.length] = dataArr[i].name; }
					traceText = 'Tiles from cache-' + infoText + ': ' + cachedTileNames.join(', ');
					break;
				case 'redisplayCachedTiles-backfillDisplay' :
					var cachedTileNames = [];
					for (var i = 0, j = dataArr.length; i < j; i++) { cachedTileNames[cachedTileNames.length] = dataArr[i].name; }
					traceText = 'Tiles from cache-' + infoText + ': ' + cachedTileNames.join(', ');
					break;
				case 'loadNewTiles-image-display' :
					traceText = 'Tile requests for display: ' + infoText + dataText;
					break;
				case 'loadNewTiles-image-backfill' :
					traceText = 'Tile requests for backfill: ' + infoText + dataText;
					break;
				case 'imageRequestTimeout' :
					traceText = 'Image request for ' + infoText;
					break;
				case 'loadTile-image-display' :
					traceText = 'Tile request-display: ' + infoText;
					blankLineAfter = false;
					break;
				case 'loadTile-image-backfill' :
					traceText = 'Tile request-backfill: ' + infoText;
					blankLineAfter = false;
					break;
				case 'loadTileDelayForOffset' :
					traceText = 'Tile not yet being loaded - offset chunk loading in progress: ' + infoText;
					break;
				case 'onTileLoad' :
					traceText = 'Tiles received-display: ' + infoText;
					blankLineAfter = false;
					break;
				case 'onTileBackfillLoad' :
					traceText = 'Tiles received-backfill: ' + infoText;
					if (tilesBackfillCachedNames.length == 0) { traceText += '\n\nTile loading complete for backfill: all requested tiles received.'; }
					blankLineAfter = false;
					break;
				case 'formatTilePathZIF' :
					traceText = 'Tile request recorded for after load offset chunk: ' + infoText;
					break;
				case 'selectTilesRetryZIF' :
					traceText = 'Requesting tiles after offset chunk received: ' + dataText;
					break;
				case 'formatTilePathPFF' :
					traceText = 'Tile request recorded for after load offset chunk: ' + infoText;
					blankLineAfter = false;
					break;
				case 'selectTilesRetryPFF' :
					traceText = 'Requesting tiles after offset chunk received: ' + dataText;
					blankLineAfter = false;
					break;
				case 'loadNewTilesRetry' :
					traceText = infoText;
					break;
				case 'displayTile' :
					traceText = 'Tile displaying: ' + infoText;
					blankLineAfter = false;
					break;
				case 'blankLine' :
					traceText = ' ';
					break;
			}

			if (traceText != '') { Z.Utils.trace(traceText, blankLineBefore, blankLineAfter); }
		}
	}

	function validateViewTimerHandler () {
		window.clearTimeout(validateViewTimer);
		validateViewTimer = null;

		var timeNow = new Date().getTime();
		tilesTimeElapsed = ((timeNow - tilesTimeStart) / 1000); // Seconds.

		var loadsExpected = (tileLoadsPerSecond * tilesTimeElapsed);
		var loadingDelay = (tilesWaiting && (tilesLoaded < loadsExpected));
		var displayDelay = (tilesWaiting && (tilesLoaded >= tilesRequested));

		// Display validate values.
		if (Z.debug == 2 || Z.debug == 3) {
			Z.Utils.trace('View validation-time elapsed: ' + tilesTimeElapsed);
			if (tilesWaiting > 0) {
				if (loadingDelay) {
					Z.Utils.trace('Loading delay - re-calling updateView');
				} else if (displayDelay) {
					Z.Utils.trace('Display delay - re-calling updateView');
				} else {
					Z.Utils.trace('Progress slow, resetting timer');
				}
			}
			Z.Utils.trace('');
			Z.traces.scrollTop = Z.traces.scrollHeight;
			Z.Utils.traceTileSpeed(tilesTimeElapsed, tileLoadsPerSecond);
		}

		// Validate speed values.
		if (tilesWaiting > 0) {
			if (validateViewRetryCounter < validateViewRetryLimit) {
				if (loadingDelay || displayDelay) {
					validateViewRetryCounter += 1;
					self.updateView(true);
				} else {
					validateViewTimer = window.setTimeout( validateViewTimerHandler, validateViewDelay);
				}
			} else {
				console.log(Z.Utils.getResource('ERROR_VALIDATEVIEW'));

				// Alternative implementation: Display status in Viewport.
				//Z.Utils.showMessage(Z.Utils.getResource('ERROR_VALIDATEVIEW'), false, Z.messageDurationStandard, 'center');
			}
		} else {
			validateViewRetryCounter = 0;

			// Debug option: console.log('viewUpdateComplete - time elapsed: ' + tilesTimeElapsed);
			Z.Utils.validateCallback('viewUpdateComplete');
			Z.Utils.validateCallback('viewUpdateCompleteGetLabelIDs');
		}
	}

	// Update progress indicator in toolbar.
	this.updateProgress = function (total, current) {
		Z.updateViewPercent = calculateProgressPercent(total, current);
		if (Z.ToolbarDisplay && Z.Toolbar.getInitialized()) { Z.Toolbar.updateProgress(total, current); }
	}

	function calculateProgressPercent (total, current) {
		if (total == 0 && current == 0) {
			// Debug option: console.log('loadingTilesComplete');
			Z.Utils.validateCallback('loadingTilesComplete');
			Z.Utils.validateCallback('loadingTilesCompleteGetLabelIDs');
		} else {
			var percentComplete = Math.round(100 - (current / total) * 100);
			return Math.round(percentComplete / 10);
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: WATERMARK FUNCTIONS ::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function loadWatermark () {
		watermarkImage = new Image();
		watermarkAlpha = parseFloat(Z.Utils.getResource('DEFAULT_WATERMARKALPHA'));
		watermarkImage.url = Z.watermarkPath;
		watermarkImage.onload = displayWatermarks;
		watermarkImage.onerror = watermarkLoadingFailed;
		watermarkImage.src = Z.watermarkPath;
	}

	function displayWatermarks () {
		if (wD) {
			var markMinScale = parseFloat(Z.Utils.getResource('DEFAULT_WATERMARKMINSCALE'));
			var markSpanW = parseFloat(Z.Utils.getResource('DEFAULT_WATERMARKSPANW'));
			var markSpanH = parseFloat(Z.Utils.getResource('DEFAULT_WATERMARKSPANH'));
			var currentZ = self.getZoom();
			var displayOffsetL = ((Z.imageW * currentZ) - wD.width) / 2;
			var displayOffsetT = ((Z.imageH * currentZ) - wD.height) / 2;
			var imageOffsetL = ((Z.imageW / 2) - Z.imageX) * currentZ;
			var imageOffsetT = ((Z.imageH / 2) - Z.imageY) * currentZ;

			var markScale = (currentZ < markMinScale) ? markMinScale : currentZ;
			var marksAcross = Math.round(Z.imageW / markSpanW);
			var marksDown = Math.round(Z.imageH / markSpanH);
			var box = self.getViewportDisplayBoundingBoxInPixels();
			var wiScaledW = watermarkImage.width * markScale;
			var wiScaledH = watermarkImage.height * markScale;
			var wicLPrior = 0, wicTPrior = 0;

			// Create rows and columns of watermarks, without overlap, within current view.
			for (var i = 1; i <= marksAcross; i++) {
				for (var j = 1; j <= marksDown; j++) {
					var x = Math.round(Z.imageW / (marksAcross + 1) * i);
					var y = Math.round(Z.imageH / (marksDown + 1) * j);
					if (x > box.l && x < box.r && y > box.t && y < box.b) {
						var wicL = Math.round((x * currentZ) - (wiScaledW / 2) - displayOffsetL + imageOffsetL);
						var wicT = Math.round((y * currentZ) - (wiScaledH / 2) - displayOffsetT + imageOffsetT);

						// Skip row/column if too close to row/column at left or above.
						if (Z.imageW > 4000) {
							var wicLTarget = wicLPrior + 100;
							var wicTTarget = wicTPrior + 100;
							if (wicL < wicLTarget && wicT < wicTTarget) { continue; }
							wicLPrior = wicL;
							wicTPrior = wicT;
						}

						displayWatermark(wiScaledW, wiScaledH, wicL, wicT);
					}
				}
			}
		}
	}

	function displayWatermark (wiScaledW, wiScaledH, wicL, wicT) {
		// DEV NOTE: If implementing drawWatermarkOnCanvas alternative, branch here.
		drawWatermarkInHTML(wiScaledW, wiScaledH, wicL, wicT);
	}

	function drawWatermarkInHTML (wiScaledW, wiScaledH, wicL, wicT) {
		// Draw watermark graphic on screen in HTML not on canvas, to support clearing
		// and displaying as necessary for rapid and smooth zoom and pan. Clone graphic
		// file to fill all instances of watermark rather than only last instance.
		var wImage = watermarkImage.cloneNode(false);
		Z.Utils.setOpacity(wImage, watermarkAlpha);
		wImage.width = wiScaledW;
		wImage.height = wiScaledH;
		var wiContainer = Z.Utils.createContainerElement('div', 'wiC', 'inline-block', 'absolute', 'hidden', wiScaledW + 'px', wiScaledH + 'px', wicL + 'px', wicT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
		wiContainer.appendChild(wImage);
		wD.appendChild(wiContainer);
		Z.Utils.addEventListener(wImage, 'contextmenu', Z.Utils.preventDefault);
		Z.Utils.addEventListener(wImage, 'mousedown', Z.Utils.preventDefault);
	}

	function redisplayWatermarks () {
		if (wD) {
			// First clear watermarks previously drawn.
			Z.Utils.clearDisplay(wD);

			// Redraw watermarks at new scale.
			displayWatermarks();
		}
	}

	function watermarkLoadingFailed () {
		Z.Utils.showMessage(Z.Utils.getResource('ERROR_WATERMARKPATHINVALID') + this.url);
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::: SAVE TO FILE FUNCTIONS :::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Draw label icon and/or caption on saving canvas after polygons, after frontfill tiles, after backfill tiles.
	this.saveAnnotationsToImageFile = function (saveAll, showSaved, saveLocal) {
		if (self.getStatus('initializedViewport') && sD) {
			if (!Z.Utils.stringValidate(Z.saveHandlerPath) && !saveLocal) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_XMLSAVEHANDLERPATHINVALID'), true, null, 'center');
			} else if (Z.saveHandlerPath && Z.saveHandlerPath.indexOf(Z.Utils.getResource('ALERT_SAVEDISABLEDFORDEMOKEY')) != -1) {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_SAVEDISABLEDFORDEMOTEXT'), false, Z.messageDurationStandard, 'center');

			} else {
				var messageText = (saveAll) ? Z.Utils.getResource('ALERT_IMAGESAVEPREPARING') : Z.Utils.getResource('ALERT_VIEWSAVEPREPARING');
				Z.Utils.showMessage(messageText, false, 'none', 'center');

				// Disable interactivity during saving process and set status value to guide load handler selection.
				Z.interactive = false;
				self.setStatus('imageSaving', true);

				// First clear contents previously drawn to save and sync display and prepare temp variables.
				Z.Utils.clearDisplay(sD);

				// Use callback to post image data because function drawAnnotationsOnCanvasToSave below must wait for onload event to draw.
				Z.setCallback('drawLabelsOnCanvasComplete', function () {
						Z.Utils.functionCallWithDelay(function () { Z.Viewport.saveCanvasDataToFile(saveAll, showSaved, saveLocal); }, 750);
					} );

				// Prepare compositing canvas.
				syncSavingDisplay(saveAll);

				// Load tile data or, if loaded, draw.
				if (saveAll && Z.tileSource != 'unconverted') {
					loadTilesToSave(saveAll); // Will set callback for load completion to call drawImageOnCanvasToSave and drawAnnotationsOnCanvasToSave.
				} else {
					drawAllOnCanvasToSave(saveAll);
				}
			}
		}
	}

	function syncSavingDisplay (saveAll) {
		if (sD && sS && sCtx) {
			// Support annotations outside image area.
			var box = new self.HotspotsAllBoundingBoxInPixels();
			var left = Math.min(box.l, 0);
			var top = Math.min(box.t, 0);
			var right = Math.max(Z.imageW, box.r);
			var bottom = Math.max(Z.imageH, box.b)

			// If hotspot outside image area on any side, add margin to all sides.
			var labelMargin2 = parseInt(Z.Utils.getResource('DEFAULT_SAVEIMAGELABELMARGIN'), 10) * 2;
			if (left < 0 || top < 0 || right > Z.imageW || bottom > Z.imageH) {
				left -= (left < 0) ? 0 : labelMargin2;
				top -= (top < 0) ? 0 : labelMargin2;
				right += (right > Z.imageW) ? 0 : labelMargin2;
				bottom += (bottom > Z.imageH) ? 0 : labelMargin2;
			}

			// Calculate values for savingDisplay canvas.
			var saveW, saveH, saveSW, saveSH, saveCtrX, saveCtrY;
			if (saveAll) {
				var z = (saveAll) ? 1 : self.getZoom();
				var width = right - left;
				var height = bottom - top;
				saveW = width * z;
				saveH = height * z;
				saveSW = saveW + 'px';
				saveSH = saveH + 'px';
				var offsetCtrX = right - Z.imageW + left;
				var offsetCtrY = bottom - Z.imageH + top;
				saveCtrX = parseInt((width / 2) - (offsetCtrX / 2), 10);
				saveCtrY = parseInt((height / 2) - (offsetCtrY / 2), 10);
			} else {
				saveW = viewW;
				saveH = viewH;
				saveSW = viewW + 'px';
				saveSH = viewH + 'px';
				saveCtrX = viewW / 2;
				saveCtrY = viewH / 2;
			}

			// Set values for savingDisplay canvas.
			sD.width = saveW;
			sD.height = saveH;
			sS.width = saveSW;
			sS.height = saveSH;
			sCtx.restore();
			sCtx.save();
			sCtx.translate(saveCtrX, saveCtrY);

			// Set background color of saving display.
			Z.Utils.colorCanvas(sD, Z.saveImageBackColor);

			// Debug option: make saving display visible.
			//sS.left = vS.left;
			//sS.top = vS.top;
			//sS.display = 'inline-block';
		}
	}

	function loadTilesToSave (saveAll) {
		// Saving an entire image with annotations requires downloading tiles of entire backfill and
		// source level tiers, combining them with all annotations, and then uploading the result.
		// Additionally browsers have maximum size limits for canvases: approximately 10,000,
		// 100,000, and 1M for Chrome, Firefox, and IE/Safari respectively. The smallest of these
		// can create a download/upload requirement exceeding 40 megabytes. This may be of
		// use on local networks and is therefore the limit of this feature for the current implementation.

		// Set callback to draw full image tiles when loading complete.
		Z.setCallback('loadingTilesFullImageComplete', function () { drawAllOnCanvasToSave(saveAll); });

		Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVELOADINGDATA'), false, 'none', 'center');

		// Load and cache full image backfill and frontfill tiles.
		precacheFullImageTiles();
	}

	// Load all backfill and frontfill tiles for largest tiers within limits limits of browser and bandwidth.
	// Add to loading names array to enable tracking loading completion.
	function precacheFullImageTiles () {

		// Determine largest tier under limit and best fit backfill tier.
		var saveTier = tierCount - 1;
		while (tierWs[saveTier] > 10000 || tierWs[saveTier] > 10000) {
			saveTier--;
		}
		var saveTierBackfill = (saveTier > backfillTreshold2) ? backfillChoice2 : (saveTier > backfillTreshold1) ? backfillChoice1 : backfillChoice0;

		// Clear standard tile cache arrays.
		clearTileValues();

		// Create tile name lists for backfill, frontfill, and loading counter.
		precacheTierTileNames(saveTierBackfill, fullImageTilesBackfillCachedNames);
		for (var i = 0, j = fullImageTilesBackfillCachedNames.length; i < j; i++) {
			tilesLoadingNames[tilesLoadingNames.length] = fullImageTilesBackfillCachedNames[i];
		}
		precacheTierTileNames(saveTier, fullImageTilesCachedNames);
		for (var i = 0, j = fullImageTilesCachedNames.length; i < j; i++) {
			tilesLoadingNames[tilesLoadingNames.length] = fullImageTilesCachedNames[i];
		}
		tilesToLoadTotal = tilesLoadingNames.length;

		// Load all tiles.
		loadNewTiles(fullImageTilesBackfillCachedNames, onTileBackfillLoadToSave, 'simple', 'image-backfill');
		loadNewTiles(fullImageTilesCachedNames, onTileLoadToSave, 'simple', 'image-display');
	}

	// Alternative implementation: Limit rate of tile requests to avoid exceeding maximum XMLHttpRequest calls supported by browser (typically 5). Not currently required in actual use.
	// DEV NOTE: Requires adding declaration of throttleCounter and loadTileInterval variables in Viewport setup (where declare fullImageTilesCachedNames).  Also requires supporting
	// separate backfill and frontfill tile lists and replacing interval duration value with resourced constant.
	function loadNewTilesThrottled (tileNamesArray, loadHandler, drawMethod, requester) {
		var loadStart = new Date().getTime();
		throttleCounter = 0;
		loadTileInterval = window.setInterval( function () {
			if (throttleCounter < tileNamesArray.length) {
				var tileName = tileNamesArray[throttleCounter];
				if (tileName) {
					var tile = new Tile(tileName, requester);
					loadTile(tile, loadStart, loadHandler);
				}
				throttleCounter++;
			} else {
				Z.Utils.arrayClear(tileNamesArray);
				if (loadTileInterval) {
					window.clearInterval(loadTileInterval);
					loadTileInterval = null;
				}
			}
		}, 100);
	}

	function onTileBackfillLoadToSave (tile, image) {
		onTileLoadToSave(tile, image, true);
	}

	function onTileLoadToSave (tile, image, backfill) {
		if (tile && image) {
			// Cache tile for drawing when all loading complete.
			tile.image = image;
			var index = Z.Utils.arrayIndexOf(tilesLoadingNames, tile.name);
			tilesLoadingNames = Z.Utils.arraySplice(tilesLoadingNames, index, 1);
			cacheTileToSave(tile, backfill);

			// Determine if all new tiles have loaded and update value for toolbar progress display.
			tilesLoadingNamesLength = tilesLoadingNames.length;
			if (tilesLoadingNamesLength == 0) { tilesToLoadTotal = 0; }
			self.traceDebugValues('onTileLoad', tile.name, tile.loadTime);
			self.updateProgress(tilesToLoadTotal, tilesLoadingNamesLength); // Update loading tracking variable and also progress display if enabled.
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVERECEIVINGTILE') + tile.name, false, 'none', 'center');

			// Callback executes drawing when all tile loading complete.
			if (tilesToLoadTotal == 0) { Z.Utils.validateCallback('loadingTilesFullImageComplete'); }

		} else if (typeof image === 'undefined' || image === null) {
			if (Z.mobileDevice) {
				console.log(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			} else {
				console.log(Z.Utils.getResource('ERROR_TILEPATHINVALID') + tile.name + '.jpg');
			}
		}
	}

	// Tiles and tile names added to end of cache arrays. No search for duplicates or reordering as with standard tile cache.
	function cacheTileToSave (tile, backfill) {
		if (backfill) {
			fullImageTilesBackfillCachedNames[fullImageTilesBackfillCachedNames.length] = tile.name;
			fullImageTilesBackfillCached[fullImageTilesBackfillCached.length] = tile;
		} else {
			fullImageTilesCachedNames[fullImageTilesCachedNames.length] = tile.name;
			fullImageTilesCached[fullImageTilesCached.length] = tile;
		}
	}

	function drawAllOnCanvasToSave (saveAll) {
		drawImageOnCanvasToSave(saveAll);
		drawAnnotationsOnCanvasToSave(saveAll);
	}

	// Draw image data - first backfill tiles, then frontfill tiles.
	function drawImageOnCanvasToSave (saveAll) {
		if (sCtx) {
			if (saveAll) {

				if (Z.tileSource != 'unconverted') {
					// Determine largest tier under limit and best fit backfill tier.
					var saveTier = tierCount - 1;
					while (tierWs[saveTier] > 10000 || tierWs[saveTier] > 10000) {
						saveTier--;
					}
					var saveTierBackfill = (saveTier > backfillTreshold2) ? backfillChoice2 : (saveTier > backfillTreshold1) ? backfillChoice1 : backfillChoice0;

					sCtx.save();
					var saveTierBackfillScale = convertZoomToTierScale(saveTierBackfill, 1);
					sCtx.scale(saveTierBackfillScale, saveTierBackfillScale);
					var x = - tierWs[saveTierBackfill] / 2;
					var y = - tierHs[saveTierBackfill] / 2;
					sCtx.translate(x, y);
					for (var i = 0, j = fullImageTilesBackfillCached.length; i < j; i++) {
						var tile = fullImageTilesBackfillCached[i];
						Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVEDRAWINGTILE') + tile.name, false, 'none', 'center');
						drawTileOnCanvas(sD, tile, tile.x, tile.y);
					}
					sCtx.restore();
					sCtx.save();

					var saveTierScale = convertZoomToTierScale(saveTier, 1);
					sCtx.scale(saveTierScale, saveTierScale);
					var x = - tierWs[saveTier] / 2;
					var y = - tierHs[saveTier] / 2;
					sCtx.translate(x, y);
					for (var i = 0, j = fullImageTilesCached.length; i < j; i++) {
						var tile = fullImageTilesCached[i];
						Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVEDRAWINGTILE') + tile.name, false, 'none', 'center');
						drawTileOnCanvas(sD, tile, tile.x, tile.y);
					}
					sCtx.restore();

				} else {
					sCtx.drawImage(unconvertedImage, -unconvertedImage.width/2, -unconvertedImage.height/2);
				}

			} else {
				sCtx.save();
				sCtx.scale(tierBackfillScale, tierBackfillScale);
				var tierBackfillZoomUnscaled = convertTierScaleToZoom(tierBackfill, 1);
				var x = -(Z.imageX - Z.imageW / 2) * tierBackfillZoomUnscaled;
				var y = -(Z.imageY - Z.imageH / 2) * tierBackfillZoomUnscaled;
				sCtx.translate(x, y);

				if (tierBackfillDynamic) {
					sCtx.drawImage(oD, -oD.width/2, -oD.height/2, oD.width, oD.height);
				} else {
					sCtx.drawImage(bD, -bD.width/2, -bD.height/2, bD.width, bD.height);
				}

				sCtx.restore();
				sCtx.save();

				sCtx.drawImage(vD, -vD.width/2, -vD.height/2, vD.width, vD.height);

				// DEV NOTE: Investigate using putImageData to address possible failure of blank areas stay transparent in some contexts.
				/*var imgViewW = viewW;
				var imgViewH = viewH;
				var imgViewL = (vD.width - imgViewW) / 2;
				var imgViewT = (vD.height - imgViewH) / 2;
				var imgDataObj = vCtx.getImageData(imgViewL, imgViewT, imgViewW, imgViewH);
				var imageSaveL = (viewW - imgViewW) / 2;
				var imageSaveT = (viewH - imgViewH) / 2;
				sCtx.putImageData(imgDataObj, imageSaveL, imageSaveT);
				*/

				sCtx.restore();
			}
		}
	}

	function drawAnnotationsOnCanvasToSave (saveAll) {
		if (saveAll) {
			var scaleVal = 1 / self.getZoom();
			sCtx.scale(scaleVal, scaleVal);
		}
		drawLabelCounter = 0;

		// Draw polygons and icons.
		if (hD && hS && hS.display == 'inline-block' && hotspots.length > 0) {
			var hC = new HotspotContext();
			for (var i = 0, j = hotspots.length; i < j; i++) {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVEDRAWINGANNOTATION') + hotspots[i].name, false, 'none', 'center');
				var hotspot = hotspots[i];
				var media = hotspot.media;
				var mediaType = hotspot.mediaType;
				var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
				var isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
				var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
				var isPolygon = (media && media == 'polygon');

				if (isShape) {
					drawShapeOnCanvas(hotspot, hC, null, null, true, saveAll);
					drawCaptionOnCanvas(hotspot, hC, null, null, null, true);
				} else if (isPolygon) {
					drawPolygonOnCanvas(hotspot, null, null, null, true, saveAll, i);
				} else {
					drawLabelOnCanvas(hotspot, null, null, null, true, saveAll, i);
				}
			}
		} else {
			Z.Utils.validateCallback('drawLabelsOnCanvasComplete');
		}
	}

	function drawLabelOnCanvas (hotspot, clickPt, rollover, mask, saving, saveAll, counter) {
		if (hotspot.visibility && (Z.Utils.stringValidate(hotspot.media) || hotspot.mediaType == 'text')) {
			var hotspotInternalID = hotspot.internalID;
			var hC = new HotspotContext();
			var hotspotZ = hotspot.z / 100;

			// Select canvas to draw on.
			targetCtx = sCtx;

			// Draw label on canvas.
			if (hotspot.mediaType == 'text') {
				// Record scale and translation state to return to after temporary changes.
				targetCtx.save();

				// Temporarily change center point of canvas. Use stored zoom value to adjust only for panning, not scaling.
				var panOffsetX = (saveAll) ? Z.imageW / 2 : Z.imageX;
				var panOffsetY = (saveAll) ? Z.imageH / 2 : Z.imageY;

				// Temporarily create and append caption to support size calculation.
				hCaption = createHotspotCaption(hotspot, hC);
				hD.appendChild(hCaption);
				var hotDims = new calculateCaptionSize(hCaption, hotspotZ, true);
				hD.removeChild(hCaption);

				// Temporarily translate canvas and draw caption.
				targetCtx.translate((hotspot.x - (hotDims.w / 2 / hotspotZ) - panOffsetX) * Z.imageZ, (hotspot.y - (hotDims.h / 2 / hotspotZ) - panOffsetY) * Z.imageZ);
				drawCaptionOnCanvas(hotspot, hC, clickPt, null, null, true);
				targetCtx.restore();

				// Execute callback to save image file if all labels drawn on canvas.
				if (saving) { validateDrawLabelCount(); }

			} else {
				var img = document.createElement("img"); // Use instead of 'new Image()' because of reported Chrome bug.
				img.src = hotspot.media;
				img.onload = function() {

					// Record scale and translation state to return to after temporary changes.
					var zVal = self.getZoom();
					targetCtx.save();

					// Temporarily change center point of canvas. Use stored zoom value to adjust only for panning, not scaling.
					var panOffsetX = (saveAll) ? Z.imageW / 2 : Z.imageX;
					var panOffsetY = (saveAll) ? Z.imageH / 2 : Z.imageY;
					targetCtx.translate((hotspot.x - (img.width / 2 / hotspotZ) - panOffsetX) * Z.imageZ, (hotspot.y - (img.height / 2 / hotspotZ) - panOffsetY) * Z.imageZ);

					// Record again post-translation but pre-scaling.
					targetCtx.save();

					// Temporarily scale canvas.
					var scaleDelta = tierScale / tierScalePrior;

					// Calculate scaled dimensions.
					var labelScaleX = (hotspot.xScale / 100) / hotspotZ / scaleDelta * zVal;
					var labelScaleY = (hotspot.yScale / 100) / hotspotZ / scaleDelta * zVal;
					if (labelScaleX != 1 && labelScaleY != 1) {
						targetCtx.scale(labelScaleX, labelScaleY);
					}

					// Rotate hotspot if XML value set but counter image rotation if icon hotpot/label.
					var rHot = this.rotation;
					if (typeof rHot !== 'undefined' && rHot !== null && rHot != 0) {
						targetCtx.rotate(rHot * Math.PI / 180);
					}

					// Translation above makes x, y both zero.
					targetCtx.drawImage(img, 0, 0);

					// Undo temporary scaling.
					targetCtx.restore();

					// Draw caption on canvas.
					drawCaptionOnCanvas(hotspot, hC, clickPt, null, null, true);

					// Undo temporary translation.
					targetCtx.restore();

					// Execute callback to save image file if all labels drawn on canvas.
					if (saving) { validateDrawLabelCount(); }
				};
			}
		}
	}

	function drawCaptionOnCanvas (hotspot, hC, clickPt, rollover, mask, saving, saveAll) {
		var noCaption = (!Z.Utils.stringValidate(hotspot.caption) && !Z.Utils.stringValidate(hotspot.captionHTML) && hotspot.mediaType != 'measure');
		if (!noCaption) {
			var textX = 0, textY = 0;
			var boxX = 0, boxY = 0, boxW = 100, boxH = 20;
			var adjX = 0, adjY = 0;
			var captionBoxes = (Z.captionBoxes || hotspot.mediaType == 'measure');
			captionFontWeight = 'normal';
			var dropShadow = !captionBoxes;
			var hCaption = null, hCaption2 = null;
			var hiScaledW, hiScaledH;

			// Select canvas to draw on.
			var targetCtx = sCtx;

			// Set colors for text and backfill based on hotspot values, boxing, or parameter values.
			var textColor = (Z.Utils.stringValidate(hotspot.textColor)) ? hotspot.textColor : captionTextColor;
			var backColor = (Z.Utils.stringValidate(hotspot.backColor)) ? hotspot.backColor : captionBackColor;

			// Alternative implementation: If caption background boxes enabled by parameter, reverse font and background colors.
			if (Z.captionBoxes && Z.captionsColorsDefault && hotspot.mediaType != 'measure') {
				textColor = hotspot.backColor;
				background = hotspot.textColor;
			}

			// Avoid hidden text.
			if (textColor == backColor) {
				if (textColor == '#ffffff') {
					backColor = '#000000';
				} else if (textColor == '#000000') {
					backColor = '#ffffff';
				}
			}

			// Calculate current size values.
			var hotspotZ = hotspot.z / 100;
			var scale = (hC.currentZ / hotspotZ);

			// For non-polygon types, constrain scaling if min or max scale set. 0 values mean no limit.
			if (hotspot.media != 'polygon') {
				if (hC.constrainedScaleMin > 0 && scale < hC.constrainedScaleMin) { scale = hC.constrainedScaleMin; }
				if (hC.constrainedScaleMax > 0 && scale > hC.constrainedScaleMax) { scale = hC.constrainedScaleMax; }
			}

			// Get hotspot dimensions.
			var hotDims = new HotspotDimensions(hotspot, hC, clickPt);
			hiScaledW = hotDims.w;
			hiScaledH = hotDims.h;

			// Temporarily create and append caption to support size calculation.
			hCaption = createHotspotCaption(hotspot, hC);
			hD.appendChild(hCaption);

			var isCurrentHotspotAndPolygon = (hotspotCurrentID == hotspot.internalID && hotspot.media == 'polygon');
			var capPosPt = calculateHotspotCaptionPosition(hCaption, hotspot.captionPosition, hiScaledW, hiScaledH, Z.imageR, isCurrentHotspotAndPolygon);

			// Calculate adjustment if is polygon on canvas (as when saving annotations to image file). Compensate for polygon
			// x,y coordinates being in untranslated space due to control points being in source resolution pixel values.
			var media = hotspot.media;
			var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
			var isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
			var isInternalMedia = (media != 'External Graphics File' && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
			var isPolygon = (media && media == 'polygon');
			if (isInternalMedia || isPolygon) {
				var panOffsetX = (saveAll) ? Z.imageW / 2 : Z.imageX;
				var panOffsetY = (saveAll) ? Z.imageH / 2 : Z.imageY;
				adjX = (hotspot.x - panOffsetX - hotspot.iW / 2) * scale;
				adjY = (hotspot.y - panOffsetY - hotspot.iH / 2) * scale;
			}
			textX = capPosPt.x + adjX;
			textY = capPosPt.y + adjY;

			var padding = parseFloat(hCaption.style.padding);
			var constrainedFontSize = hCaption.style.fontSize;

			// Workaround for difficult to see fonts on canvas when zoomed out.
			var minFontSize = parseInt(Z.Utils.getResource('DEFAULT_MINHOTSPOTCAPTIONFONTSIZE'), 10);
			if (parseInt(constrainedFontSize, 10) < (minFontSize + 2) && !captionBoxes) {
				captionFontWeight = 'bold';
			}

			if (captionBoxes) {
				var dimensions = new calculateCaptionSize(hCaption, hotspotZ, true);
				textX += padding;
				textY += padding;
				boxX = capPosPt.x + adjX;
				boxY = capPosPt.y + adjY;
				boxW = dimensions.w + padding * 2;
				boxH = dimensions.h; // Padding implemented within function calculateCaptionSize based on current font size.
			}
			hD.removeChild(hCaption);

			// Draw caption box if parameter set.
			if (captionBoxes) {
				targetCtx.beginPath();
				targetCtx.rect(boxX, boxY, boxW, boxH);
				targetCtx.fillStyle = backColor;
				targetCtx.fill();
				targetCtx.lineWidth = 1;
				targetCtx.strokeStyle = '#696969'; // Alternative implementation: Use lineColor;
				targetCtx.stroke();
			}

			if (typeof hotspot.captionHTML !== 'undefined' && Z.Utils.stringValidate(hotspot.captionHTML)) {
				// Dev Note: following approach is experimental and not supported in IE. It is under investigation.
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVEHTMLCAPTIONUNSUPPORTED'), false, Z.messageDurationShort, 'center');
				/*
				var data = "<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'>" +
				"<foreignObject width='100%' height='100%'>" +
				"<div xmlns='http://www.w3.org/1999/xhtml'>" + hotspot.captionHTML + "</div>" +
				"</foreignObject>" +
				"</svg>";
				// DEV NOTE: Next line may require: window.createObjectUrl (that is Url, not URL)
				var DOMURL = self.URL || self.webkitURL || self;
				var img = new Image();
				var svg = new Blob([data], {type: "image/svg+xml;charset=utf-8"});
				var url = DOMURL.createObjectURL(svg);
				img.onload = function() {
					ctx.drawImage(img, 0, 0);
					DOMURL.revokeObjectURL(url);
				};
				img.src = url;
				targetCtx.putImageData(img, 0, 0);
				*/

			} else if (typeof hotspot.caption !== 'undefined' && Z.Utils.stringValidate(hotspot.caption)) {
				targetCtx.textBaseline="hanging";
				if (dropShadow) { // Use same dropshadow approach as in HTML for consistent look.
					var dropShadowOffset = 1;
					targetCtx.fillStyle = backColor;
					targetCtx.font = captionFontWeight + '  ' + constrainedFontSize + ' Verdana';
					targetCtx.fillText(hotspot.caption, textX + dropShadowOffset, textY + dropShadowOffset);
				}
				targetCtx.fillStyle = textColor;
				targetCtx.font = captionFontWeight + '  ' + constrainedFontSize + ' Verdana';
				targetCtx.fillText(hotspot.caption, textX, textY);
			}

			// Clear temp caption objects.
			hCaption = null;
			hCaption2 = null;
		}
	}

	function HotspotDimensions (hotspot, hC, clickPt, ignoreZoom) {
		var w, h;
		var currZ = (ignoreZoom) ? 1 : hC.currentZ;
		var hotspotZ = hotspot.z / 100;
		var scale = (currZ / hotspotZ);

		// Constrain scale within limits set in XML.
		scale = (scale < hC.constrainedScaleMin) ? hC.constrainedScaleMin : (scale > hC.constrainedScaleMax) ? hC.constrainedScaleMax : scale;

		// Calculate dimensions based on type.
		if (hotspot.mediaType == 'text') {
			// Temporarily create and append caption to support size calculation.
			var hC = new HotspotContext();
			var hotspotZ = hotspot.z / 100;
			hCaption = createHotspotCaption(hotspot, hC);
			hD.appendChild(hCaption);
			var dimensions = new calculateCaptionSize(hCaption, hotspotZ, true);
			hD.removeChild(hCaption);
			w = dimensions.w;
			h = dimensions.h;
		} else if (hotspot.mediaType == 'icon') {
			w = hotspot.iW;
			h = hotspot.iH;
		} else if (hotspot.mediaType == 'polygon') {
			var polyDimensions = Z.Utils.polygonDimensions(hotspot.polygonPts, clickPt);
			w = polyDimensions.x;
			h = polyDimensions.y;
		}

		// Apply hotspot scale values, if any.
		w *= scale * (hotspot.xScale / 100);
		h *= scale * (hotspot.yScale / 100);

		this.w = w;
		this.h = h;
	}

	function validateDrawLabelCount () {
		drawLabelCounter++;
		if (drawLabelCounter == hotspots.length) {
			Z.Utils.validateCallback('drawLabelsOnCanvasComplete');
		}
	}

	// Get canvas data and send data to file save handler. DEV NOTE: This will cause browser error if
	// getImageData calls above use image data from a different origin (cross-domain). Use ZsaveImageFormat
	// parameter to set file type. Supported values: 'png' and 'jpg'. PNG alternative provides non-lossy
	// compression but larger upload. Data start example: 'data:image/jpg;base64,iVBORw0KGgo...'
	self.saveCanvasDataToFile = function (saveAll, showSaved, saveLocal) {
		Z.saveImageMessage = (saveAll) ? Z.Utils.getResource('ALERT_IMAGESAVEINPROGRESS') : Z.Utils.getResource('ALERT_VIEWSAVEINPROGRESS');

		switch (Z.saveImageFormat) {
			case 'png' :
				canvasData = sD.toDataURL('image/png');
				break;
			default :
				canvasData = sD.toDataURL('image/jpeg', Z.saveImageCompression);
		}

		if (!saveLocal) {
			//Alternative implementation: Do not automatically append file extension in save image handler script.
			var saveImageFilename = Z.Utils.stringRemoveFileExtension(Z.saveImageFilename);
			var postData = saveImageFilename + ',' + canvasData;
			var netConnector = new Z.NetConnector();
			netConnector.postImage(Z.saveImageHandlerPath, postData);

			// Debug option: display image content in browser window.
			if (showSaved) {
				window.location = canvasData;
			}

		} else {
			if (Z.browser == Z.browsers.FIREFOX || Z.browser == Z.browsers.CHROME || Z.browser == Z.browsers.OPERA) {
				Z.Utils.hideMessage();
				var link = document.createElement('a');
				document.body.appendChild(link); // Firefox requires link in body.
				var saveImageFilename = Z.Utils.stringRemoveFileExtension(Z.saveImageFilename);
				link.download = saveImageFilename + '.jpg';
				link.href = canvasData;
				link.click();
				document.body.removeChild(link); // Remove temporary link in body.

			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGESAVELOCALUNSUPPORTEDBROWSER'), true, null, 'center');
			}
		}

		// Clear status and reenable interactivity.
		self.setStatus('imageSaving', false);
		Z.interactive = true;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::: GEOGRAPHIC COORDINATE FUNCTIONS ::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function loadGeographicCoordinatesXML () {
		if (Z.Utils.stringValidate(Z.geoCoordinatesPath)) {
			var dataPath = Z.Utils.cacheProofPath(Z.geoCoordinatesPath);
			var netConnector = new Z.NetConnector();
			netConnector.loadXML(dataPath);
		}
	}

	self.parseGeoCoordinatesXML = function (xmlDoc) {
		var geoSetup = xmlDoc.getElementsByTagName('SETUP')[0];
		if (geoSetup) {
			geoTop = geoSetup.getAttribute('GEOTOP');
			geoBottom = geoSetup.getAttribute('GEOBOTTOM');
			geoLeft = geoSetup.getAttribute('GEOLEFT');
			geoRight = geoSetup.getAttribute('GEORIGHT');
			geoDataPrep(geoLeft, geoRight, geoTop, geoBottom);
		}
	}

	function geoDataPrep (geoLeft, geoRight, geoTop, geoBottom) {
		var geoLeftDeg = geoLeft.substring(0, geoLeft.indexOf(",", 0));
		var geoLeftMin = geoLeft.substring(geoLeft.indexOf(",", 0)+1, geoLeft.indexOf(",", geoLeftDeg.length+1));
		var geoLeftWE = geoLeft.substring(geoLeft.indexOf(",", geoLeftDeg.length+1+geoLeftMin.length)+1, geoLeft.length);
		var geoLeftNegPos = 1;

		if (geoLeftWE == "W") { geoLeftNegPos = -1; }
		geoLeftDec = (parseFloat(geoLeftDeg) + (parseFloat(geoLeftMin) / 60)) * geoLeftNegPos;

		var geoRightDeg = geoRight.substring(0, geoRight.indexOf(",", 0));
		var geoRightMin = geoRight.substring(geoRight.indexOf(",", 0)+1, geoRight.indexOf(",", geoRightDeg.length+1));
		var geoRightWE = geoRight.substring(geoRight.indexOf(",", geoRightDeg.length+1+geoRightMin.length)+1, geoRight.length);
		var geoRightNegPos = 1;
		if (geoRightWE == "W") { geoRightNegPos = -1; }
		var geoRightDec = (parseFloat(geoRightDeg) + (parseFloat(geoRightMin) / 60)) * geoRightNegPos;

		var geoTopDeg = geoTop.substring(0, geoTop.indexOf(",", 0));
		var geoTopMin = geoTop.substring(geoTop.indexOf(",", 0)+1, geoTop.indexOf(",", geoTopDeg.length+1));
		var geoTopNS = geoTop.substring(geoTop.indexOf(",", geoTopDeg.length+1+geoTopMin.length)+1, geoTop.length);
		var geoTopNegPos = 1;
		if (geoTopNS == "S") { geoTopNegPos = -1; }
		geoTopDec = (parseFloat(geoTopDeg) + (parseFloat(geoTopMin) / 60)) * geoTopNegPos;

		var geoBottomDeg = geoBottom.substring(0, geoBottom.indexOf(",", 0));
		var geoBottomMin = geoBottom.substring(geoBottom.indexOf(",", 0)+1, geoBottom.indexOf(",", geoBottomDeg.length+1));
		var geoBottomNS = geoBottom.substring(geoBottom.indexOf(",", geoBottomDeg.length+1+geoBottomMin.length)+1, geoBottom.length);
		var geoBottomNegPos = 1;
		if (geoBottomNS == "S") { geoBottomNegPos = -1; }
		var geoBottomDec = (parseFloat(geoBottomDeg) + (parseFloat(geoBottomMin) / 60)) * geoBottomNegPos;

		// Calculate span of geo coords. Allow for longitude ranges that span equator and latitude ranges that span Prime Meridian.
		if (geoRightDec < geoLeftDec) {
			geoXSpan = (180-geoLeftDec) + (180+geoRightDec);
		}else{
			geoXSpan = geoRightDec - geoLeftDec;
		}
		geoYSpan = geoTopDec - geoBottomDec;
	}

	function convertPixelsToLatitudeLongitudeString (coordsPixelPt) {
		// Convert to geo coordinates.
		var mouseXCoordGeo = geoLeftDec + (coordsPixelPt.x * Math.abs(geoXSpan / Z.imageW));
		var mouseYCoordGeo = geoTopDec - (coordsPixelPt.y * Math.abs(geoYSpan / Z.imageH));

		//Convert to degrees and decimal minutes and 'N/S' or 'W/E' value;
		var geoXWE = "E";
		var geoXNegPos = 1;
		if (mouseXCoordGeo > 180) { mouseXCoordGeo = mouseXCoordGeo - 360; }
		if (mouseXCoordGeo < -180) { 	mouseXCoordGeo = mouseXCoordGeo + 360; }
		if (mouseXCoordGeo < 0) {
			geoXWE = "W";
			geoXNegPos = -1;
		}
		var degreesValueX = (mouseXCoordGeo-(mouseXCoordGeo % 1))*geoXNegPos;
		var minutesValueX = ((mouseXCoordGeo % 1)*60)*geoXNegPos;
		var minutesValueXRounded = Z.Utils.roundToFixed(minutesValueX, 5);
		var mouseXCoordGeoString = degreesValueX +", "+ minutesValueXRounded +", "+geoXWE;

		var geoYNS = "N";
		var geoYNegPos = 1;
		if (mouseYCoordGeo < 0) {
			geoYNS = "S";
			geoYNegPos = -1;
		}
		var degreesValueY = (mouseYCoordGeo-(mouseYCoordGeo % 1))*geoYNegPos;
		var minutesValueY = ((mouseYCoordGeo % 1)*60)*geoYNegPos;
		var minutesValueYRounded = Z.Utils.roundToFixed(minutesValueY, 5);
		var mouseYCoordGeoString = degreesValueY +", "+ minutesValueYRounded +", "+geoYNS;

		geoCoordsString = mouseYCoordGeoString + "    " + mouseXCoordGeoString;

		return geoCoordsString;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::: HOTSPOT & ANNOTATION FUNCTIONS ::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Debug option: set var true to colorize disabling overlays, false to enable default color.
	var overlaysVisibleForDebugging = false;

	function loadHotspotsOrAnnotationsData (vpID) {
		// Load hotspot, tour, or annotation XML to get graphic, placement, and other properties.
		if (Z.Utils.stringValidate(hotspotPath)) {
			if (!Z.simplePath) {
				if (hotspotPath.toLowerCase().substring(hotspotPath.length - 4, hotspotPath.length) != '.xml') {
					var defaultFilename = (Z.tour) ? Z.Utils.getResource('DEFAULT_TOURSXMLFILE') : Z.Utils.getResource('DEFAULT_HOTSPOTSXMLFILE');
					hotspotPath = hotspotPath + '/' + defaultFilename;
				}
				dataPath = Z.Utils.cacheProofPath(hotspotPath);
			} else {
				dataPath = hotspotPath;
			}

		} else if (Z.Utils.stringValidate(annotationPath)) {
			// Use zSimplePath parameter to avoid processing of annotation.xml path for integrated applications.
			if (!Z.simplePath) {
				if ((annotationPath.toLowerCase().substring(annotationPath.length - 5, annotationPath.length) != '.json') && (annotationPath.toLowerCase().substring(annotationPath.length - 4, annotationPath.length) != '.xml')) {
					annotationPath = annotationPath + '/' + Z.Utils.getResource('DEFAULT_ANNOTATIONSXMLFILE');
				}
				dataPath = Z.Utils.cacheProofPath(annotationPath);
			} else {
				dataPath = annotationPath;
			}
		}

		if (typeof dataPath !== 'undefined' && Z.Utils.stringValidate(dataPath)) {
			vpIDTemp = (Z.imageSet) ? vpID : null;
			var netConnector = new Z.NetConnector();
			if (dataPath.toLowerCase().indexOf('.xml') != -1) {
				netConnector.loadXML(dataPath, vpIDTemp);
			} else if (dataPath.toLowerCase().indexOf('.json') != -1) {
				netConnector.loadJSON(dataPath, vpIDTemp);
			}

		} else if (typeof Z.annotationXMLText === 'string' && Z.Utils.stringValidate(Z.annotationXMLText)) {
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(Z.annotationXMLText);
			self.parseAnnotationsXML(xmlDoc);

		} else if (typeof Z.annotationJSONObject !== 'undefined' && typeof Z.annotationJSONObject === 'object' && Z.annotationJSONObject !== null) {
			var xmlText = Z.Utils.jsonConvertObjectToXMLText(Z.annotationJSONObject);
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
			self.parseAnnotationsXML(xmlDoc);

		} else if (Z.measureVisible && Z.editMode == null) {
			// If in measure mode but not in edit mode create placeholder XML.
			var xmlText = '<ZAS></ZAS>';
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
			self.parseAnnotationsXML(xmlDoc);

		}
	}

	// DEV NOTE: Hotspot XML handling is simpler than annotation XML handling. Validation is in-line
	// and functions are fewer. These differences ensure the simpler functionality is simple to modify.
	// Perform double-unescaping here, as each attribute value is received. This is after loaded XML is converted to an XMLDocument,
	// to protect any escaped multiline or other content the DOMParser would remove. Use custom function to clear HTML entities
	// created with custom function and standard unescape to clear hex codes created by escaping by external functions, if any.
	this.parseHotspotsXML = function (xmlDoc) {

		// Clear any prior values.
		Z.Utils.arrayClear(hotspotListDP);
		Z.Utils.arrayClear(hotspotsMedia);
		Z.Utils.arrayClear(hotspotPopups);
		mTypeLegacy = false;
		self.setStatus('XMLParsedViewport', false);

		// Parse display setup information.
		tourAutoStart = Z.Utils.getResource('DEFAULT_TOURAUTOSTART');
		tourAutoLoop = Z.Utils.getResource('DEFAULT_TOURAUTOLOOP');
		hotspotListPosition = Z.Utils.getResource('DEFAULT_HOTSPOTLISTPOSITION');
		hotspotListSource = Z.Utils.getResource('DEFAULT_HOTSPOTLISTSOURCE');
		hotspotListTitle = (Z.tourPath) ? Z.Utils.getResource('UI_TOURLISTTITLE') : Z.Utils.getResource('UI_HOTSPOTLISTTITLE');
		hotspotsInitialVisibility = Z.Utils.getResource('DEFAULT_HOTSPOTSINITIALVISIBILITY');
		hotspotsMinScale = parseFloat(Z.Utils.getResource('DEFAULT_HOTSPOTSMINSCALE'));
		hotspotsMaxScale = parseFloat(Z.Utils.getResource('DEFAULT_HOTSPOTSMAXSCALE'));

		// Fallback test for 'HOTSPOTSETUP' for backward compatibility.
		var hotspotSetup = xmlDoc.getElementsByTagName('SETUP')[0];
		if (typeof hotspotSetup === 'undefined' || !Z.Utils.stringValidate(hotspotSetup)) {
			var hotspotSetup = xmlDoc.getElementsByTagName('HOTSPOTSETUP')[0];
			if (typeof hotspotSetup === 'undefined' || !Z.Utils.stringValidate(hotspotSetup)) {
				var xmlSetupText = '<HOTSPOTSETUP />';
				var xmlSetupDoc = Z.Utils.xmlConvertTextToDoc(xmlSetupText);
				hotspotSetup = xmlSetupDoc.getElementsByTagName('HOTSPOTSETUP')[0];
			}
		}

		// Parse auto values for tours and other values for tours and hotspots.
		if (hotspotSetup) {
			var autoStart = hotspotSetup.getAttribute('AUTOSTART');
			if (Z.Utils.stringValidate(autoStart)) { tourAutoStart = (autoStart != '0' && autoStart != 'false'); }
			var autoLoop = hotspotSetup.getAttribute('AUTOLOOP');
			if (Z.Utils.stringValidate(autoLoop)) { tourAutoLoop = (autoLoop != '0' && autoLoop != 'false'); }
			var listPosition = hotspotSetup.getAttribute('CHOICELIST');
			if (Z.Utils.stringValidate(listPosition)) { hotspotListPosition = listPosition; }
			var listSource = hotspotSetup.getAttribute('LISTSOURCE');
			if (Z.Utils.stringValidate(listSource)) { hotspotListSource = listSource; }
			var listTitle = Z.Utils.xmlUnescapeMinimal(unescape(hotspotSetup.getAttribute('LISTTITLE')));
			if (Z.Utils.stringValidate(listTitle)) { hotspotListTitle = listTitle; }
			var initialVisibility = hotspotSetup.getAttribute('INITIALVISIBILITY');
			if (Z.Utils.stringValidate(initialVisibility)) { hotspotsInitialVisibility = (initialVisibility == '1' || initialVisibility == 'true'); }
			var minScaleAttrib = parseFloat(hotspotSetup.getAttribute('MINSCALE'));
			if (!isNaN(minScaleAttrib)) { // Legacy 0 values become 0.00001 denoting no limit.
				hotspotsMinScale = (minScaleAttrib != 0) ? minScaleAttrib : 0.00001;
			}
			var maxScaleAttrib = parseFloat(hotspotSetup.getAttribute('MAXSCALE'));
			if (!isNaN(maxScaleAttrib)) { // Legacy 0 values become 10000 denoting no limit.
				hotspotsMaxScale = (maxScaleAttrib != 0) ? maxScaleAttrib : 10000;
			}
		}

		// Set initial visibility.
		hS.visibility = (hotspotsInitialVisibility) ? 'visible' : 'hidden';

		// Validate list title: if HTML parameter present, override XML value, otherwise set global to HTML parameter.
		if (Z.Utils.stringValidate(Z.hotspotListTitle)) {
			hotspotListTitle = Z.hotspotListTitle;
		} else if (Z.Utils.stringValidate(hotspotListTitle)) {
			Z.hotspotListTitle = hotspotListTitle;
		}

		// Create hotpot choice list.
		createHotspotChoiceList(hotspotListPosition, hotspotListTitle, hotspotListDP, vpID);

		// Parse hotspots XML and call create function.
		var hotspotNodes = xmlDoc.getElementsByTagName('HOTSPOT');
		for (var i = 0, j = hotspotNodes.length; i < j; i++) {
			var hotspotNode = hotspotNodes[i];
			hotspotNode = validateAnnotationMedia(hotspotNode);
			self.createHotspotFromXML(hotspotNode, true); // Second parameter forces validation, necessary because hotspots.xml data not validated on load like annotations.xml data.
		}

		// Trace one error for Flash library graphic, if tracking variable set during hotspots XML parsing.
		if (Z.debug == 2 && mTypeLegacy) { Z.Utils.trace(Z.Utils.getResource('ERROR_HOTSPOTMEDIAINVALID')); }
		self.setStatus('XMLParsedViewport', true);
		redisplayHotspots();

		if (Z.tour) {
			// Set audio mute buttons visible if AUDIO attribute in use.
			self.initializeAudioMuteButtons();
			Z.Utils.validateCallback('tourLoaded');
			if (tourAutoStart && !Z.tourStop) { Z.Utils.functionCallWithDelay(function () { self.tourStart(); }, 750); }
		} else {
			Z.Utils.validateCallback('hotspotsLoadedViewport');
			self.setStatus('hotspotsLoadedViewport', true);
		}
	}

	this.createHotspotFromParameters = function (id, name, mediaType, media, audio, x, y, zoom, xScale, yScale, radius, zMin, zMax, clickURL, urlTarget, rollover, caption, tooltip, textColor, backColor, lineColor, fillColor, textVisible, backVisible, lineVisible, fillVisible, captionPosition, saved, internalID, poiID, captionHTML, tooltipHTML, polyClosed, polygonPts, showFor, transition, changeFor, rotation, editable, popup, popupOffsetX, popupOffsetY, comment, user, date) {
		var poID = (typeof poiID !== 'undefined' && poiID !== null) ? poiID.toString() : null;
		var hotspotParams = Z.Utils.arrayToArrayOfStrings( [id, name, mediaType, media, audio, x, y, zoom, xScale, yScale, radius, zMin, zMax, clickURL, urlTarget, rollover, caption, tooltip, textColor, backColor, lineColor, fillColor, textVisible, backVisible, lineVisible, fillVisible, captionPosition, saved, internalID, poiID, captionHTML, tooltipHTML, polyClosed, polygonPts, showFor, transition, changeFor, rotation, editable, popup, popupOffsetX, popupOffsetY, comment, user, date] );
		var xmlText = '<HOTSPOT ID="' + hotspotParams[0]  + '" NAME="' + hotspotParams[1] + '" MEDIATYPE="' + hotspotParams[2] + '" MEDIA="' + hotspotParams[3] + '" AUDIO="' + hotspotParams[4] + '" X="' + hotspotParams[5] + '" Y="' + hotspotParams[6] + '" ZOOM="' + hotspotParams[7] + '" XSCALE="' + hotspotParams[8] +'" YSCALE="' + hotspotParams[9] + '" RADIUS="' + hotspotParams[10] + '" ZMIN="' + hotspotParams[11] +'" ZMAX="' + hotspotParams[12] + '" CLICKURL="' + hotspotParams[13] + '" URLTARGET="' + hotspotParams[14] + '" ROLLOVER="' + hotspotParams[15] + '" CAPTION="' + hotspotParams[16] + '" TOOLTIP="' + hotspotParams[17] + '" TEXTCOLOR="' + hotspotParams[18] + '" BACKCOLOR="' + hotspotParams[19] + '" LINECOLOR="' + hotspotParams[20] + '" FILLCOLOR="' + hotspotParams[21] + '" TEXTVISIBLE="' + hotspotParams[22] + '" BACKVISIBLE="' + hotspotParams[23] + '" LINEVISIBLE="' + hotspotParams[24] + '" FILLVISIBLE="' + hotspotParams[25] + '" CAPTIONPOSITION="' + hotspotParams[26] + '" SAVED="' + hotspotParams[27] + '" INTERNALID="' + hotspotParams[28]  + '" POIID="' + hotspotParams[29] + '" SHOWFOR="' + hotspotParams[34] + '" TRANSITION="' + hotspotParams[35] + '" CHANGEFOR="' + hotspotParams[36] + '" ROTATION="' + hotspotParams[37] + '" EDITABLE="' + hotspotParams[38] + '" POPUP="' + hotspotParams[39] + '" POPOFFSETX="' + hotspotParams[40] + '" POPOFFSETY="' + hotspotParams[41] + '" COMMENT="' + hotspotParams[42] + '" USER="' + hotspotParams[43] + '" DATE="' + hotspotParams[44] + '" ></HOTSPOT>';
		var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
		var hotspotNode = xmlDoc.getElementsByTagName('HOTSPOT')[0];

		// Ensure unique hotspot internalID for code use.
		if (hotspotNode.getAttribute('INTERNALID') === null) { hotspotNode.setAttribute('INTERNALID', getFreeID('hotspot')); }

		// Duplicate complex content, if present, for caption, tooltip, polygon.
		var xmlDocTemp = Z.Utils.xmlConvertTextToDoc('<TEMP></TEMP>');
		if (Z.Utils.stringValidate(hotspotParams[30])) {
			var tempHTML = Z.Utils.xmlConvertTextToDoc(captionHTML).getElementsByTagName('CAPTION')[0].innerHTML;
			var captionNode = xmlDocTemp.createElement('CAPTION');
			captionNode.innerHTML = tempHTML;
			hotspotNode.appendChild(captionNode);
		}
		if (Z.Utils.stringValidate(hotspotParams[31])) {
			var tempHTML = Z.Utils.xmlConvertTextToDoc(tooltipHTML).getElementsByTagName('TOOLTIP')[0].innerHTML;
			var tooltipNode = xmlDocTemp.createElement('TOOLTIP');
			tooltipNode.innerHTML = tempHTML;
			hotspotNode.appendChild(tooltipNode);
		}
		if (Z.Utils.stringValidate(hotspotParams[33])) {
			var poiPolyTemp = xmlDocTemp.createElement('POLYGON');
			poiPolyTemp.setAttribute('CLOSED', hotspotParams[32]);
			for (var p = 0, q = polygonPts.length; p < q; p++) {
				var poiPointTemp = xmlDocTemp.createElement('POINT');
				poiPointTemp.setAttribute('X', polygonPts[p].x);
				poiPointTemp.setAttribute('Y', polygonPts[p].y);
				poiPolyTemp.appendChild(poiPointTemp);
			}
			hotspotNode.appendChild(poiPolyTemp);
		}
		self.createHotspotFromXML(hotspotNode, true);

		// Debug option: Example use of createHotspotFromParameters function (apply in button click handler or other function).
		// self.createHotspotFromParameters('200', 'Test', 'icon', 'Assets/Hotspots/hotspotFromJPG.jpg', null, '250', '250', '100', '100','100', null, '0', '0', 'http://www.zoomify.com', '_self', 'false', 'Test Caption', 'This is a test tooltip.');
	}

	this.createHotspotFromXML = function (hotspotNode, validate) {
		if (validate) { hotspotNode = validateAnnotationXMLNode(hotspotNode, 'hotspot'); }
		var hotspot = new Hotspot(hotspotNode);

		// Add hotspot value to choicelist based on optional parameter.
		if (hotspotIsValid(hotspot) || Z.annotations) {
			hotspots[hotspots.length] = hotspot;
			var hotspotListText = (hotspotListSource == 'NAME') ? hotspot.name : (hotspotListSource == 'CAPTION') ? hotspot.caption : hotspot.tooltip;
			if (hotspotList) { addToHotspotChoiceList(hotspotListText, hotspot.internalID); }
		}

		// Load popup media if path provided. Popup loaded before hotspot media because no need to delay display if popup not already loaded.
		if (Z.Utils.stringValidate(hotspot.popup)) { addHotspotPopup(hotspot); }

		// Display hotspot if no image or if image previously loaded, else load new hotspot image content and display will occur on load.
		// Conversion of external graphics paths to canvas drawing or vice versa require isInternalMedia condition below.
		var hC = new HotspotContext();
		var mediaType = hotspot.mediaType;
		var media = hotspot.media;
		var isExternalSymbol = false, isInternalSymbol = false;
		if (media) {
			isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
			isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
		}
		var isInternalMedia = (media != 'External Graphics File' && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));

		if (!Z.Utils.stringValidate(media) || mediaType == 'text' || media == 'polygon' || isInternalMedia) {
			displayHotspot(hotspot, hC);
			// Debug option: console.log('display', isExternalSymbol, isInternalSymbol, isInternalMedia);
		} else {
			addHotspotMedia(hotspot, true);
			// Debug option: console.log('add media', isExternalSymbol, isInternalSymbol, isInternalMedia);
		}

		if (Z.Viewer.getStatus('readyViewer')) {
			Z.Utils.validateCallback('labelCreated');
			Z.Utils.validateCallback('labelCreatedGetInternalID');
		}
	}

	function addHotspotPopup (hotspot) {
		var index = Z.Utils.arrayIndexOfObjectValue(hotspotPopups, 'popup', hotspot.popup);
		if (index != -1) {
			if (hotspotPopups[index].element) {
				hotspot.popupImage = hotspotPopups[index].element.cloneNode(false);
			}
		} else {
			hotspotPopups[hotspotPopups.length] = { popup:hotspot.popup, element:null };
			var loadStart = new Date().getTime();
			loadHotspotPopup(hotspot.popup, loadStart);
		}
	}

	function addHotspotMedia (hotspot, displayNow) {
		var index = Z.Utils.arrayIndexOfObjectValue(hotspotsMedia, 'media', hotspot.media);
		if (index != -1) {
			var tempImg = new Image(); // DEV NOTE: Workaround for image sizing issues.
			tempImg.src = hotspot.media;
			var w = tempImg.width;
			var h = tempImg.height;
			tempImg = null;
			if (hotspotsMedia[index].element) {
				hotspot.image = hotspotsMedia[index].element.cloneNode(false);
			}
			hotspot.iW = w;
			hotspot.iH = h;
			if (displayNow) {
				var hC = new HotspotContext();
				displayHotspot(hotspot, hC);
			}
		} else {
			hotspotsMedia[hotspotsMedia.length] = { media:hotspot.media, element:null };
			var loadStart = new Date().getTime();
			loadHotspotMedia(hotspot.media, loadStart);
		}
	}

	function Hotspot (hotspotNode) {
		var tempS, tempN;
		tempS = hotspotNode.getAttribute('ID');
		this.id = (tempS != '') ? tempS : getFreeID('labelExternal');
		tempS = hotspotNode.getAttribute('INTERNALID');
		this.internalID = (!isNaN(parseInt(tempS))) ? tempS : (hotspotList) ? getFreeID('hotspot') : getFreeID('label');
		this.poiID = hotspotNode.getAttribute('POIID');
		tempS = hotspotNode.getAttribute('NAME'); // Exception to unescaping at creation time.
		this.name = (tempS != '') ? tempS : this.id;

		this.mediaType = hotspotNode.getAttribute('MEDIATYPE'); // Supported values: 'freehand', 'text', 'icon' (internal shape or external graphic), 'rectangle', 'polygon', 'measure'. Legacy values 'url' and 'symbol' converted on import of tour, hotspots, or annotations XML.
		this.media = hotspotNode.getAttribute('MEDIA'); // Supported values: URL path, shape name ('circle', 'triangle', 'square', arrows...), 'polygon', empty string.
		this.image = null; // Media content, added on load.

		tempN = parseFloat(hotspotNode.getAttribute('X'));
		this.x = isNaN(tempN) ? 0 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('Y'));
		this.y = isNaN(tempN) ? 0 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('ZOOM'));
		this.z = isNaN(tempN) ? -1 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('XSCALE'));
		this.xScale = isNaN(tempN) ? 100 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('YSCALE'));
		this.yScale = isNaN(tempN) ? 100 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('RADIUS'));
		this.radius = isNaN(tempN) ? null : tempN;

		// Media width stored to avoid width of 0 when cloning.
		var media = this.media;
		var mediaType = this.mediaType;
		var isExternalSymbol = false, isInternalSymbol = false;
		if (media) {
			isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
			isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
		}
		var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
		if (isShape) {
			this.iW = (this.radius) ? this.radius * 2 : labelIconDefaultW;
			this.iH = (this.radius) ? this.radius * 2 : labelIconDefaultH;
		} else {
			this.iW = null;
			this.iH = null;
		}

		tempN = parseFloat(hotspotNode.getAttribute('ZMIN'));
		this.zMin = isNaN(tempN) ? 0 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('ZMAX'));
		this.zMax = isNaN(tempN) ? 0 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('ROTATION'));
		this.rotation = isNaN(tempN) ? 0 : tempN;

		this.clickURL = hotspotNode.getAttribute('CLICKURL');
		this.urlTarget = hotspotNode.getAttribute('URLTARGET');
		tempS = hotspotNode.getAttribute('ROLLOVER');
		this.rollover = ((tempS == '1') || (tempS == 'true'));
		this.caption = hotspotNode.getAttribute('CAPTION');
		this.comment = hotspotNode.getAttribute('COMMENT');
		this.tooltip = hotspotNode.getAttribute('TOOLTIP');
		this.user = hotspotNode.getAttribute('USER');
		this.initials = hotspotNode.getAttribute('INITIALS');
		this.date = hotspotNode.getAttribute('DATE');
		this.textColor = Z.Utils.stringValidateColorValue(hotspotNode.getAttribute('TEXTCOLOR'))
		this.backColor = Z.Utils.stringValidateColorValue(hotspotNode.getAttribute('BACKCOLOR'))
		this.lineColor = Z.Utils.stringValidateColorValue(hotspotNode.getAttribute('LINECOLOR'))
		this.fillColor = Z.Utils.stringValidateColorValue(hotspotNode.getAttribute('FILLCOLOR'))
		tempS = hotspotNode.getAttribute('TEXTVISIBLE');
		this.textVisible = (tempS != 'false' && tempS != '0' && Z.captionTextVisible);
		tempS = hotspotNode.getAttribute('BACKVISIBLE');
		this.backVisible = (tempS != 'false' && tempS != '0' && Z.captionBackVisible);
		tempS = hotspotNode.getAttribute('LINEVISIBLE');
		this.lineVisible = (tempS != 'false' && tempS != '0' && Z.polygonLineVisible);
		tempS = hotspotNode.getAttribute('FILLVISIBLE');
		this.fillVisible = ((tempS != 'false' && tempS != '0') || Z.polygonFillVisible); // HTML does not override XML.

		var capPos = hotspotNode.getAttribute('CAPTIONPOSITION');
		this.captionPosition = Z.Utils.stringValidate(capPos) ? capPos : '8';

		var savedParam = hotspotNode.getAttribute('SAVED');
		this.saved = (savedParam === null) ? true : savedParam;

		// Create value to be reset by setHotspotVisibility function, not rollover handlers, for reference in drawHotspotInHTML function during redisplay during zoom.
		this.visibility = true;

		// Duplicate complex field content.
		var captionNodes = hotspotNode.getElementsByTagName('CAPTION');
		if (captionNodes.length > 0){
			this.captionHTML = unescape(Z.Utils.xmlConvertDocToText(captionNodes[0]));
		}
		// Tooltips implemented using div title attribute. Alternative supporting HTML TBD.
		var tooltipNodes = hotspotNode.getElementsByTagName('TOOLTIP');
		if (tooltipNodes.length > 0){
			this.tooltipHTML = unescape(Z.Utils.xmlConvertDocToText(tooltipNodes[0]));
		}

		this.popup = hotspotNode.getAttribute('POPUP'); // Supported values: URL path.
		this.popupImage = null; // Popup content, added on load.
		tempN = parseFloat(hotspotNode.getAttribute('POPOFFSETX'));
		this.popupOffsetX = isNaN(tempN) ? 0 : tempN;
		tempN = parseFloat(hotspotNode.getAttribute('POPOFFSETY'));
		this.popupOffsetY = isNaN(tempN) ? 0 : tempN;

		// For mediaType 'text' media is null.
		// For mediaType 'icon' if media is 'External Graphics File' or !Z.labelIconsInternal then media is external graphics file unless no file extension ('.jpg', '.png', '.gif').
		// For mediaType 'icon' if media is 'circle', 'triangle', 'square', 'arrow', 'line', media is shape to draw (polygon but not 'polygon').
		// For mediaType 'rectangle', 'polygon', and 'measurment' media is 'polygon'.
		// For legacy mediaType 'symbol' media is Flash library graphic to be substituted during XML parsing.
		if (hotspotNode.getAttribute('MEDIA') == 'freehand' || hotspotNode.getAttribute('MEDIA') == 'rectangle' || hotspotNode.getAttribute('MEDIA') == 'polygon' || hotspotNode.getAttribute('MEDIA') == 'measure') {
			var polyNodes = hotspotNode.getElementsByTagName('POLYGON');
			if (polyNodes.length > 0){
				var polyNode = hotspotNode.getElementsByTagName('POLYGON')[0];
				this.polyClosed = (polyNode.getAttribute('CLOSED') != '0');
				var polyPoints = polyNode.getElementsByTagName('POINT');
				var polyPts = [];
				for (var i = 0, j = polyPoints.length; i < j; i++) {
					var xPtParam = parseFloat(polyPoints[i].getAttribute('X'));
					var xPt = isNaN(xPtParam) ? 0 : xPtParam;
					var yPtParam = parseFloat(polyPoints[i].getAttribute('Y'));
					var yPt = isNaN(yPtParam) ? 0 : yPtParam;
					polyPts[polyPts.length] = { x:xPt, y:yPt };
					//console.log(this.id, '   ', this.x, '   ', this.y);
				}
				this.polygonPts = polyPts;
			}
		}

		// Get hotspot attributes relevant to tours and/or slideshows.
		this.audio = hotspotNode.getAttribute('AUDIO');
		if (Z.Utils.stringValidate(this.audio)) { Z.audioContent = true; }
		tempN = parseFloat(hotspotNode.getAttribute('SHOWFOR'));
		this.showFor = isNaN(tempN) ? 0 : tempN;
		this.transition = hotspotNode.getAttribute('TRANSITION');
		tempN = parseFloat(hotspotNode.getAttribute('CHANGEFOR'));
		this.changeFor = isNaN(tempN) ? 0 : tempN;

		this.category = hotspotNode.getAttribute('CATEGORY');

		this.zIndex = hotspots.length.toString();

		tempS = hotspotNode.getAttribute('EDITABLE');
		this.editable = (tempS != 'false' && tempS != '0');
	}

	// Pass id value in first parameter as string. Use last parameter to specify whether
	// value is user id string value or internal Zoomify unique numeric value.
	this.modifyHotspot = function (idValue, property, newVal, wait, useInternalID) {
		var index = -1;
		if (useInternalID) {
			index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', idValue);
		} else {
			index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'id', idValue.toString());
		}
		if (index != -1) {
			var hotspot = hotspots[index];

			// Reposition polygon points if hotspot x or y modified - before updating hotspot x or y.
			if (hotspot.media == 'polygon' && (property == 'x' || property == 'y')) {
				var currX = (property == 'x') ? newVal : hotspot.x;
				var currY = (property == 'y') ? newVal : hotspot.y;
				var hotPtCurrent = new Z.Utils.Point(currX, currY);
				polygonPointsPan(hotspot, hotPtCurrent);
			}

			// Test if scaling polygon.
			var scalingPoly = (hotspot.media == 'polygon' && (property == 'xScale' || property == 'yScale'));

			// Set new property value - unless setting scale of polygon. In that case, change position of control points.
			if (!scalingPoly) {
				hotspot[property] = newVal;
			} else {
				polygonPointsScale(hotspot, property, newVal / 100);
			}

			// Implement rollover effect on visibility.
			if (property == 'rollover' && newVal == false) { hotspot.visibility = true; }

			// Add media if type 'icon' and external path, or internal icons parameter false or not set, or no file extension ('.jpg', '.png', '.gif').
			if (property == 'media' && hotspot.mediaType == 'icon' && (hotspot.media == 'External Graphics File' || !Z.labelIconsInternal)) { addHotspotMedia(hotspot, false); }

			// Redisplay if wait not specified.
			if (typeof wait === 'undefined' || wait === null || !wait) {
				redisplayHotspots();
			}
		}
	}

	// Pass id value in first parameter as string. Use last parameter to specify whether
	// value is user id string value or internal Zoomify unique numeric value.
	this.deleteHotspot = function (idValue, replace, useInternalID) {
		var index = -1;
		if (useInternalID) {
			index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', idValue);
		} else {
			index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'id', idValue.toString());
			if (index != -1) { idValue = hotspots[index].internalID; }
		}
		if (index != -1) {
			hotspots = Z.Utils.arraySplice(hotspots, index, 1);
			clearHotspotFromHTML(idValue);
			if (!replace) { clearHotspotFromChoiceList(idValue); }
		}
	}

	this.deleteAllHotspots = function () {
		Z.Utils.arrayClear(hotspots);
		if (hD) { hD.innerHTML = ''; }
		clearAllFromHotspotChoiceList();
	}

	this.deleteAllMeasureHotspots = function () {
		var hotLen = hotspots.length;
		if (hotLen > 0 && hD && hD.childNodes.length > 0) {
			for (var i = 0; i < hotLen; i++) {
				if (hotspots[i].mediaType == 'measure') { hotspots = Z.Utils.arraySplice(hotspots, i, 1); }
			}
			redisplayHotspots();
		}
	}

	// Asynchronously load hotspot popup graphic and ensure handler function is called upon loading.
	function loadHotspotPopup (popup, loadTime) {
		var hotspotLoading = hotspotNetConnector.loadImage(popup, Z.Utils.createCallback(null, onHotspotPopupLoad, popup, loadTime), 'hotspot');
	}

	// Asynchronously load hotspot media and ensure handler function is called upon loading.
	function loadHotspotMedia (media, loadTime) {
		var hotspotLoading = hotspotNetConnector.loadImage(media, Z.Utils.createCallback(null, onHotspotMediaLoad, media, loadTime), 'hotspot');
	}

	// Clone element into hotspot array for more rapid display during zoom.
	function onHotspotPopupLoad (popup, loadTime, element) {
		if (popup && loadTime && element) {
			var hC = new HotspotContext();
			for (var i = 0, j = hotspots.length; i < j; i++) {
				var hotspot = hotspots[i];
				if (hotspot.popup == popup) {
					var index = Z.Utils.arrayIndexOfObjectValue(hotspotPopups, 'popup', popup);
					if (index != -1) {
						hotspotPopups[index].element = element;
					} else {
						hotspotPopups[hotspotPopups.length] = { popup:popup, element:element };
					}
					hotspot.popupImage = element.cloneNode(false);
					displayHotspot(hotspot, hC);
				}
			}
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_HOTSPOTPOPUPPATHINVALID'), true, null, 'center');
		}
	}

	// Clone element into hotspot array for more rapid display during zoom.
	function onHotspotMediaLoad (media, loadTime, element) {
		if (media && loadTime && element) {
			var hC = new HotspotContext();
			for (var i = 0, j = hotspots.length; i < j; i++) {
				var hotspot = hotspots[i];
				if (hotspot.media == media) {
					var index = Z.Utils.arrayIndexOfObjectValue(hotspotsMedia, 'media', media);
					if (index != -1) {
						hotspotsMedia[index].element = element;
					} else {
						hotspotsMedia[hotspotsMedia.length] = { media:media, element:element };
					}
					hotspot.image = element.cloneNode(false);
					hotspot.iW = element.width;
					hotspot.iH = element.height;
					displayHotspot(hotspot, hC);
				}
			}
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_HOTSPOTMEDIAPATHINVALID'), true, null, 'center');
		}
	}

	this.redisplayHotspots = function () {
		redisplayHotspots();
	}

	function redisplayHotspots () {
		if (hD && self.getStatus('initializedViewport')) {
			// First clear hotspots previously drawn.
			Z.Utils.clearDisplay(hD);
			if (dD) { Z.Utils.clearDisplay(dD); }
			if (eD) { Z.Utils.clearDisplay(eD); }

			// Redraw hotspots if label display layer not hidden by call to function setHotspotsVisibility.
			if (hS.display == 'inline-block') {
				displayHotspots();
			}
		}
	}

	function displayHotspotsWithoutMedia () {
		var hC = new HotspotContext();
		for (var i = 0, j = hotspots.length; i < j; i++) {
			if (hotspots[i].media == '' || hotspots[i].media == 'polygon') {
				displayHotspot(hotspots[i], hC);
			}
		}
	}

	this.getLabelsVisibility = function () {
		return self.getHotspotsVisibility();
	}

	this.setLabelsVisibility = function (visible) {
		self.setLabelsVisibility(visible);
	}

	this.setLabelVisibility = function (hotspotElement, visible) {
		self.setHotspotVisibility(hotspotElement, visible);
	}

	this.setLabelsVisibilityByFilter = function (filterBy, filterValue, visible) {
		self.setHotspotsVisibilityByFilter(filterBy, filterValue, visible);
		return visible;
	}

	this.setLabelVisibilityByID = function (id, visible, useInternalID) {
		self.setHotspotVisibilityByID(id, visible, useInternalID);
	}

	this.setLabelFilterByDisplayList = function (idList, useInternalID) {
		self.setHotspotFilterByDisplayList(idList, useInternalID);
	}

	this.setHotspotFilterByDisplayList = function (idList, useInternalID) {
		// First clear hotspots previously drawn, if parameter true.
		if (hD) { Z.Utils.clearDisplay(hD); }
		if (dD) { Z.Utils.clearDisplay(dD); }
		if (eD) { Z.Utils.clearDisplay(eD); }

		// Set filter list to array, if provided.
		if (typeof idList !== 'undefined' && idList !== null && idList.length > 0) {
			if (useInternalID) {
				hotspotsFilterDisplayInternalIDs = idList;
			} else {
				hotspotsFilterDisplayIDs = idList;
			}
		}

		// Draw hotspots if label display layer not hidden by call to function setHotspotsVisibility.
		if (hS.display == 'inline-block') {
			displayHotspots();
		}
	}

	this.clearLabelFilterByDisplayList = function () {
		self.clearHotspotFilterByDisplayList();
	}

	this.clearHotspotFilterByDisplayList = function () {
		if (typeof hotspotsFilterDisplayIDs !== 'undefined') { Z.Utils.arrayClear(hotspotsFilterDisplayIDs); }
		if (typeof hotspotsFilterDisplayInternalIDs !== 'undefined') { Z.Utils.arrayClear(hotspotsFilterDisplayInternalIDs); }
		if (hS.display == 'inline-block') {
			redisplayHotspots();
		}
	}

	function displayHotspots () {
		var hC = new HotspotContext();
		for (var i = 0, j = hotspots.length; i < j; i++) {
			displayHotspot(hotspots[i], hC);
		}
		// DEV NOTE: Workaround for zero contents mousemove problem in some browsers.
		// Ensure at least one item in hotspotsDisplay container or second click-drags will fail.
		if (hD.childNodes.length == 0) {
			var hotspotImmortal = Z.Utils.createContainerElement('div', 'hotspotImmortal', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			hD.appendChild(hotspotImmortal);
		}
	}

	// Polygonal hotspot graphics are drawn on canvas for diagonal line support. Draw prior to related hotspot to
	// place under caption and/or graphics. Other hotspot elements are drawn in HTML for simplicity: media, caption, etc.
	function displayHotspot (hotspot, hC) {
		// First filter by ID or internalID if filter set.
		if (hotspotsFilterDisplayIDs.length > 0) {
			var filterIndex = Z.Utils.arrayIndexOf(hotspotsFilterDisplayIDs, hotspot.id);
			if (filterIndex == -1) { return; }
		} else if (hotspotsFilterDisplayInternalIDs.length > 0) {
			var filterIndex = Z.Utils.arrayIndexOf(hotspotsFilterDisplayInternalIDs, hotspot.internalID);
			if (filterIndex == -1) { return; }
		}

		// Validate zoom visibility range.
		var zoom = Math.round(hC.currentZ * 100);
		var zMin = (hotspot.zMin == -1) ? Math.round(Z.initialZ * 100) : Math.round(hotspot.zMin);
		var zMax = (hotspot.zMax == -1) ? Math.round(Z.initialZ * 100) : Math.round(hotspot.zMax);
		if ((zMin == 0 || zMin <= zoom) && (zMax == 0 || zMax >= zoom)) {

			// Draw polygon, if any.
			if ((!Z.hotspotsDrawOnlyInView || ((hotspot.x + polygonViewBuffer) > hC.box.l && (hotspot.x - polygonViewBuffer) < hC.box.r && (hotspot.y + polygonViewBuffer) > hC.box.t && (hotspot.y - polygonViewBuffer) < hC.box.b))) {
				var media = hotspot.media;
				var mediaType = hotspot.mediaType;
				var isExternalSymbol = false, isInternalSymbol = false;
				if (media) {
					isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
					isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
				}
				var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
				var isPolygon = (media && media == 'polygon');
				if (isShape) {
					drawShapeOnCanvas(hotspot, hC);
				} else if (isPolygon) {
					drawPolygonOnCanvas(hotspot);
				}
			}

			// Draw hotspot.
			if (!Z.hotspotsDrawOnlyInView || (hotspot.x > hC.box.l && hotspot.x < hC.box.r && hotspot.y > hC.box.t && hotspot.y < hC.box.b)) {
				var skipSetVis = (Z.mouseIsDown || hotspot.rollover == 0);
				drawHotspotInHTML(hotspot, hC, null, skipSetVis);
			}
		}
	}

	function drawHotspotInHTML (hotspot, hC, clickPt, skipSetVisibility) {
		// Remove prior instance of hotspot, if any.
		var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspot.internalID);
		if (hotspotCurrentIndex != -1) { clearHotspotFromHTML(hotspot.internalID); }

		// Calculate hotspot size if polygon. For images values set in onHotspotMediaLoad.
		if (Z.useCanvas && hotspot.media == 'polygon') {
			var polyPts = hotspot.polygonPts;
			if (polyPts) {
				var polyDimensions = Z.Utils.polygonDimensions(hotspot.polygonPts, clickPt);
				hotspot.iW = polyDimensions.x;
				hotspot.iH = polyDimensions.y;
			}
		}

		// Avoid mispositioned captions or negative width or height errors in code below by verifying hotspot media is specified and loaded.
		// Drawing is called on load of media, during view updating, and when setting up annotation panel choice lists - the latter can
		// happen before all media have loaded. Final clause allows for difference between loading process for hotspots.xml and annotation.xml.
		var noMedia = !Z.Utils.stringValidate(hotspot.media);
		var noCaption = (!Z.Utils.stringValidate(hotspot.caption) && !Z.Utils.stringValidate(hotspot.captionHTML) && hotspot.mediaType != 'measure');
		var noDimensions = (hotspot.iW === null || hotspot.iH === null);
		var noPolygon = (hotspot.media != 'polygon');
		if (noMedia && noCaption && (noDimensions && noPolygon)) { return; }

		// Calculate scaled dimensions. Do not scale polygon types (freehand, rectangle, polygon) except for their
		// captions. This allows use for creating graphics encircling or otherwize sized to the details within the image.
		// Especially important with min zoom less than zoom-to-fit to provide extra area to draw in margins.
		var hotspotZ = (hotspot.media != 'polygon') ? hotspot.z / 100 : 1;
		var scale = (hC.currentZ / hotspotZ);

		// For non-polygon types, constrain scaling if min or max scale set. 0 values mean no limit.
		if (hotspot.media != 'polygon') {
			if (hC.constrainedScaleMin > 0 && scale < hC.constrainedScaleMin) { scale = hC.constrainedScaleMin; }
			if (hC.constrainedScaleMax > 0 && scale > hC.constrainedScaleMax) { scale = hC.constrainedScaleMax; }
		}

		var hiScaledW = hotspot.iW * scale * (hotspot.xScale / 100);
		var hiScaledH = hotspot.iH * scale * (hotspot.yScale / 100);

		// Draw hotspot graphic on screen in HTML not on canvas, to support clearing
		// and displaying as necessary for rapid and smooth zoom and pan, as well as
		// to support click and rollover events and other interactive features.
		var hImage;
		if (hotspot.media != 'placeholder' && hotspot.image) {
			hImage = hotspot.image;
			hImage.align = 'top';
			hImage.width = hiScaledW;
			hImage.height = hiScaledH;
		}

		// Calculate hotspot position.
		var hicL = Math.round((hotspot.x * hC.currentZ) - (hiScaledW / 2) - hC.displayOffsetL + hC.imageOffsetL);
		var hicT = Math.round((hotspot.y * hC.currentZ) - (hiScaledH / 2) - hC.displayOffsetT + hC.imageOffsetT);

		// Create hotspot caption. Override caption box hiding and drop shadowing for measure captions.
		var hCaption = null, hCaption2 = null;
		if (!noCaption) {
			if (Z.captionBoxes || hotspot.mediaType == 'measure') {
				hCaption = createHotspotCaption(hotspot, hC);
			} else {
				hCaption2 = createHotspotCaption(hotspot, hC, true, true);
				hCaption = createHotspotCaption(hotspot, hC, true, false);
			}
		}

		// Create hotspot contents visibility cloak.
		var hCloak = Z.Utils.createContainerElement('div', 'hCloak', 'inline-block', 'absolute', 'visible');

		// Create hotspot element in display.
		var hotVPIDStr = (Z.imageSet) ? '-' + vpID.toString() : '';
		var elementID = 'hot' + hotspot.internalID.toString() + hotVPIDStr;
		var hContainer = Z.Utils.createContainerElement('div', elementID, 'inline-block', 'absolute', 'visible', hiScaledW + 'px', hiScaledH + 'px', hicL + 'px', hicT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');

		// Debug option: Replace line above with line below to display outline of hotspot for comparison with position of contained icon and caption or of associated polygon on canvas.
		//var hContainer = Z.Utils.createContainerElement('div', elementID, 'inline-block', 'absolute', 'visible', hiScaledW + 'px', hiScaledH + 'px', hicL + 'px', hicT + 'px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal');

		// Set hotspot tooltip.
		if (typeof tooltipSource === 'undefined' || tooltipSource === null || tooltipSource == 'TOOLTIP') {
			hContainer.title = (Z.Utils.stringValidate(hotspot.tooltip)) ? hotspot.tooltip : '';
		} else if (tooltipSource == 'COMMENT') {
			hContainer.title = (Z.Utils.stringValidate(hotspot.comment)) ? hotspot.comment : '';
		}


		// Implement click effect url using anchor href on image and/or caption, rather than using window.open in mousedown
		// handler. This ensures user interaction and avoids triggering popup blockers if a new window is targeted.
		// Exception: if hotspot.clickURL == 'function', then urlTarget is a function.
		if (!Z.labelClickSelect && Z.Utils.stringValidate(hotspot.clickURL)) {
			 if (Z.editMode !== null) {
				// Replace hotspot click links with developer notification message when in edit mode, to ensure hotspot click-link does not conflict with drag-positioning of hotspots.
				Z.Utils.addEventListener(hCloak, 'mousedown', hotspotEditMouseDownHandler);
				Z.Utils.addEventListener(hCloak, 'touchstart', hotspotEditTouchStartHandler);

			} else if (hotspot.clickURL == 'function') {
				hotspotCurrentID = hotspot.internalID;
				Z.Utils.addEventListener(hContainer, 'mousedown', validateExternalFunction);
				Z.Utils.addEventListener(hContainer, 'touchstart', validateExternalFunction);
				Z.Utils.addEventListener(hContainer, 'touchmove', validateExternalFunction);
				Z.Utils.addEventListener(hContainer, 'mouseup', executeExternalFunction);
				Z.Utils.addEventListener(hContainer, 'touchend', executeExternalFunction);
				Z.Utils.addEventListener(hContainer, 'touchcancel', executeExternalFunction);

			} else {
				if (hImage) {
					var hiAnchor = document.createElement('a');
					hiAnchor.setAttribute('href', hotspot.clickURL);
					hiAnchor.setAttribute('target', hotspot.urlTarget);
					hiAnchor.setAttribute('outline', 'none');
					hiAnchor.appendChild(hImage);
					hImage.style.cursor = 'help';
					hImage.style.border = 'none';
				}
				if (hCaption) {
					var hcAnchor = document.createElement('a');
					hcAnchor.setAttribute('href', hotspot.clickURL);
					hcAnchor.setAttribute('target', hotspot.urlTarget);
					hcAnchor.setAttribute('outline', 'none');
					if (hCaption2) {
						hcAnchor.appendChild(hCaption2);
						hCaption2.style.cursor = 'help';
					}
					hcAnchor.appendChild(hCaption);
					hCaption.style.cursor = 'help';

					// DEV NOTE: Border sometimes appears regardless of setting in Firefox so leave visible.
					//hCaption.style.border = 'none';
				}
				hCloak.style.border = 'none';
			}

			// Ensure hotspot click-link does not conflict with viewport click-zoom-and-pan.
			if (Z.editMode === null && (Z.clickZoom || Z.clickPan)) {
				Z.Utils.addEventListener(hContainer, 'mousedown', hotspotMouseDownHandler);
				Z.Utils.addEventListener(hContainer, 'touchstart', hotspotTouchStartHandler);
			}
		}

		// Add anchor or image and anchor or caption to cloak.
		if (!Z.labelClickSelect && Z.Utils.stringValidate(hotspot.clickURL) && Z.editMode === null && hotspot.clickURL != 'function') {
			if (hiAnchor) { hCloak.appendChild(hiAnchor); }
			if (hcAnchor) { hCloak.appendChild(hcAnchor); }
		} else {
			if (hImage) { hCloak.appendChild(hImage); }
			if (hCaption2) { hCloak.appendChild(hCaption2); }
			if (hCaption) { hCloak.appendChild(hCaption); }
		}

		// Add hotspot popup graphic if provided and set invisible.
		var hPopup;
		if (hotspot.popup != 'placeholder' && hotspot.popupImage) {
			hPopup = hotspot.popupImage;
			hPopup.style.display = 'none';
			hPopup.id = 'popup';
			var hPopupContainer = Z.Utils.createContainerElement('div', 'hPopupContainer', 'inline-block', 'absolute', 'visible');
			hPopupContainer.appendChild(hPopup);
			hCloak.appendChild(hPopupContainer);
			var ctrOffX = -(hPopup.width / 2) + (hiScaledW / 2);
			var ctrOffY = -(hPopup.height / 2) + (hiScaledH / 2);
			var pOffX = (hotspot.popupOffsetX != 0) ? hotspot.popupOffsetX + ctrOffX : ctrOffX;
			var pOffY = (hotspot.popupOffsetY != 0) ? hotspot.popupOffsetY + ctrOffY : ctrOffY;
			if (pOffX != 0 && pOffY !=0) {
				hPopupContainer.style.left = pOffX + 'px';
				hPopupContainer.style.top = pOffY + 'px';
			}
		}

		// Add cloak to container, and container to display.
		hContainer.appendChild(hCloak);
		hD.appendChild(hContainer);

		// Store zIndex in hotspot element for access during dragging.
		hContainer.zIndex = hotspot.zIndex;

		// Set caption background transparency.
		if (!noCaption && (Z.captionBoxes || hotspot.mediaType == 'measure')) {
			var backColor = (Z.Utils.stringValidate(hotspot.backColor)) ? hotspot.backColor : captionBackColor;
			var hexStr = backColor.toString();
			if (hexStr) {
				var r = Z.Utils.hexToRGB(hexStr).r;
				var g = Z.Utils.hexToRGB(hexStr).g;
				var b = Z.Utils.hexToRGB(hexStr).b;
				var a = measureCaptionBackOpacity;
				var colorStr = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
				hCaption.style.backgroundColor = colorStr;
			}
		}

		// Set hotspot visibility.
		if (hotspot.rollover) { hCloak.rollover = hotspot.rollover; }
		hContainer.internalID = hotspot.internalID;
		if (!skipSetVisibility) { self.setHotspotVisibility(hContainer, (!hotspot.rollover && hotspot.visibility)); }

		// Rotate hotspot if XML value set but counter image rotation if icon hotpot/label.
		if (hImage) {
			var r = self.getRotation();
			if (r != 0) { Z.Utils.rotateElement(hImage.style, -r); }
			var rHot = this.rotation;
			if (typeof rHot !== 'undefined' && rHot !== null && rHot != 0) {
				Z.Utils.rotateElement(hContainer, rHot);
			}
		}

		// Position hotspot caption. Must occur after added to display because text container width setting is 'auto'.
		if (hCaption2) { positionHotspotCaption(hotspot, hCaption2, hiScaledW, hiScaledH, true); }
		positionHotspotCaption(hotspot, hCaption, hiScaledW, hiScaledH);

		// Handle mouseover and out events.
		if (hotspot.rollover) {
			Z.Utils.addEventListener(hContainer, 'mouseover', hotspotRolloverHandler);
			Z.Utils.addEventListener(hContainer, 'mouseout', hotspotRolloutHandler);
		}
		if (hotspot.popup) {
			Z.Utils.addEventListener(hContainer, 'mouseover', hotspotPopoverHandler);
			Z.Utils.addEventListener(hContainer, 'mouseout', hotspotPopoutHandler);
		}

		// DEV NOTE: Use event handlers below for custom functionality as alternative to use of hiAnchor above.
		// If implementing handlers, also modify or comment out lines above in section 'Implement click effect url as href...'
		// If passing a function name using url attribute in XML, modify lines above in section 'Add anchor or image to cloak.'
		// Additional note: hotspotMouseDownHandler used for block to prevent conflict between hotspot click and click-zoom. 
		/* if (Z.Utils.stringValidate(hotspot.clickURL)) {
			Z.Utils.addEventListener(hContainer, 'mousedown', hotspotMouseDownHandler);
			Z.Utils.addEventListener(hContainer, "mouseup", hotspotMouseUpHandler);
			Z.Utils.addEventListener(hContainer, 'touchstart', hotspotTouchStartHandler);
			Z.Utils.addEventListener(hContainer, 'touchend', hotspotTouchEndHandler);
			Z.Utils.addEventListener(hContainer, 'touchcancel', hotspotTouchCancelHandler);
		} */

		//  Prevent graphic dragging and disable context menu.
		Z.Utils.addEventListener(hContainer, 'mousedown', Z.Utils.preventDefault);
		Z.Utils.addEventListener(hContainer, 'contextmenu', Z.Utils.preventDefault);
	}

	// Call context function outside 'for' loops that display hotspots so that zoom, scale, and position values are only calculated once for all iterations.
	function HotspotContext (viewportOnly) {
		if (hD) {
			this.box = self.getViewportDisplayBoundingBoxInPixels(viewportOnly);
			this.currentZ = self.getZoom();
			this.constrainedScale = (this.currentZ < hotspotsMinScale) ? hotspotsMinScale : ((this.currentZ > hotspotsMaxScale) ? hotspotsMaxScale : this.currentZ); // Constrain scaling per max and min scale setup values in XML.
			this.constrainedScaleMax = hotspotsMaxScale;
			this.constrainedScaleMin = hotspotsMinScale;
			this.displayOffsetL = ((Z.imageW * this.currentZ) - hD.width) / 2;
			this.displayOffsetT = ((Z.imageH * this.currentZ) - hD.height) / 2;
			this.imageOffsetL = ((Z.imageW / 2) - Z.imageX) * this.currentZ;
			this.imageOffsetT = ((Z.imageH / 2) - Z.imageY) * this.currentZ;
		}
	}

	this.getHotspotTarget = function (target) {
		return getHotspotTarget(target);
	}

	function getHotspotTarget (target) {
		if (typeof target === 'undefined' || target === null) {
			target = document.getElementById('progressTextBox');
		}
		var hotTarget = null;
		if (target.id.indexOf('hot') != -1 && target.id.indexOf('hotspotDisplay') == -1) {
			hotTarget = target;
		} else if (target.parentNode && target.parentNode.id.indexOf('hot') != -1 && target.parentNode.id.indexOf('hotspotDisplay') == -1) {
			hotTarget = target.parentNode;
		}else if (target.parentNode.parentNode && target.parentNode.parentNode.id.indexOf('hot') != -1 && target.parentNode.parentNode.id.indexOf('hotspotDisplay') == -1) { // Image inside click-link anchor.
			hotTarget = target.parentNode.parentNode;
		} else if (target.parentNode.parentNode.parentNode && target.parentNode.parentNode.parentNode.id.indexOf('hot') != -1 && target.parentNode.parentNode.parentNode.id.indexOf('hotspotDisplay') == -1) { // No click-link anchor.
			hotTarget = target.parentNode.parentNode.parentNode;
		}
		return hotTarget;
	}

	this.getLabelIDsInCurrentView = function (useInternalID, viewportOnly, includePartials) {
		var labelsInViewIDs = [];
		var hC = new HotspotContext(viewportOnly);
		var z = self.getZoom();
		var boxScaledL = hC.box.l;
		var boxScaledR = hC.box.r;
		var boxScaledT = hC.box.t;
		var boxScaledB = hC.box.b;
		for (var i = 0, j = hotspots.length; i < j; i++) {
			var hotspot = hotspots[i];
			if (includePartials) {
				var hotDims = new HotspotDimensions(hotspot, hC, null, false);
				var halfW = (hotDims.w / 2) / z;
				var halfH = (hotDims.h / 2) / z;
				boxScaledL = hC.box.l - halfW;
				boxScaledR = hC.box.r + halfW;
				boxScaledT = hC.box.t - halfH;
				boxScaledB = hC.box.b + halfH;
			}
			if (hotspot.x > boxScaledL && hotspot.x < boxScaledR && hotspot.y > boxScaledT && hotspot.y < boxScaledB) {
				var id = (useInternalID) ? hotspot.internalID : hotspot.id;
				labelsInViewIDs[labelsInViewIDs.length] = id;
			}
		}
		return labelsInViewIDs;
	}

	// Transfer change in coordinates of hotspot element to hotspot object.  Offset mouse
	// position for distance mouse clicked hotspot from center of hotspot before convert
	// viewport display coordinates to image pixel coordinates.
	function updateHotspotPosition (event, hotspotDragging, hotClickPt) {
		var hotspotInternalID = hotspotDragging.id.substring(3, hotspotDragging.id.length);
		var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
		if (hotspotCurrentIndex != -1) {
			var hotspot = hotspots[hotspotCurrentIndex];
			var media = hotspot.media;
			var mediaType = hotspot.mediaType;
			var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
			var isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
			var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
			var isPolygon = (media && media == 'polygon');
			if (event.type == 'mouseup' || (event.type == 'mousemove' && (isShape || isPolygon))) {
				var offsetX = hotClickPt.x -= hotspotDragging.mouseXOffset - (parseFloat(hotspotDragging.style.width) / 2);
				var offsetY = hotClickPt.y -= hotspotDragging.mouseYOffset - (parseFloat(hotspotDragging.style.height) / 2);
				var offsetPt = new Z.Utils.Point(offsetX, offsetY);
				var clickPt = self.getClickCoordsInImage(event, self.getZoom(), offsetPt);
				if (isShape || isPolygon) {
					if (isPolygon) { polygonPointsPan(hotspot, clickPt); }
					redisplayShapesAndPolygons();
				}
				hotspot.x = clickPt.x;
				hotspot.y = clickPt.y;
			}
		}
	}

	function polygonPointsPan (hotspot, clickPt) {
		var deltaX = clickPt.x - hotspot.x;
		var deltaY = clickPt.y - hotspot.y;
		var tPolyPts = hotspot.polygonPts.slice(0);
		for (var i = 0, j = tPolyPts.length; i < j; i++) {
			tPolyPts[i].x += deltaX;
			tPolyPts[i].y += deltaY;
		}
		hotspot.polygonPts = tPolyPts.slice(0);
	}

	function polygonPointsScale (hotspot, property, scaleVal) {
		var tPolyPts = hotspot.polygonPts.slice(0);
		var scaleDim = (property == 'xScale') ? 'x' : 'y';
		var centerOffset = hotspot[scaleDim] - (hotspot[scaleDim] * scaleVal);
		for (var i = 0, j = tPolyPts.length; i < j; i++) {
			tPolyPts[i][scaleDim] = (tPolyPts[i][scaleDim] * scaleVal) + centerOffset;
		}
		hotspot.polygonPts = tPolyPts.slice(0);
	}

	function polygonPointsZoom (hotspot, zoom) {
		var centerOffsetX = hotspot.x - (hotspot.x * zoom);
		var centerOffsetY = hotspot.y - (hotspot.y * zoom);
		var tPolyPts = hotspot.polygonPts.slice(0);
		for (var i = 0, j = tPolyPts.length; i < j; i++) {
			tPolyPts[i].x = (tPolyPts[i].x * zoom) + centerOffsetX;
			tPolyPts[i].y = (tPolyPts[i].y * zoom) + centerOffsetY;
		}
		hotspot.polygonPts = tPolyPts.slice(0);
	}

	function polygonPointsZoomXML (hotspotNode) {
		// Get hotspot values.
		var hotX = hotspotNode.getAttribute('X');
		var hotY = hotspotNode.getAttribute('Y');
		var hotZ = hotspotNode.getAttribute('ZOOM');
		var scaleFactor = 100 / hotZ;
		var centerOffsetX = hotX - (hotX * scaleFactor);
		var centerOffsetY = hotY - (hotY * scaleFactor);

		// Get and modify polygon point values.
		var polyNodes = hotspotNode.getElementsByTagName('POLYGON');
		if (polyNodes.length > 0){
			var polyNode = hotspotNode.getElementsByTagName('POLYGON')[0];
			var polyPoints = polyNode.getElementsByTagName('POINT');
			var polyPts = [];
			for (var i = 0, j = polyPoints.length; i < j; i++) {

				var xPtParam = parseFloat(polyPoints[i].getAttribute('X'));
				var xPt = isNaN(xPtParam) ? 0 : xPtParam;
				xPt = (xPt * scaleFactor) + centerOffsetX;

				var yPtParam = parseFloat(polyPoints[i].getAttribute('Y'));
				var yPt = isNaN(yPtParam) ? 0 : yPtParam;
				yPt = (yPt * scaleFactor) + centerOffsetY;

				polyPts[polyPts.length] = { x:xPt, y:yPt };
			}
		}

		// Replace old values with new values in XML.
		hotspotNode.removeChild(polyNode);
		var xmlDocNew = createAnnotationsXML();
		var labelNew = createAnnotationsXMLNode(xmlDocNew, 'label');
		if (polyPts != null && polyPts.length > 0) {
			var poiPolyTemp = xmlDocNew.createElement('POLYGON');
			for (var p = 0, q = polyPts.length; p < q; p++) {
				var poiPointTemp = xmlDocNew.createElement('POINT');
				poiPointTemp.setAttribute('X', polyPts[p].x);
				poiPointTemp.setAttribute('Y', polyPts[p].y);
				poiPolyTemp.appendChild(poiPointTemp);
			}
			hotspotNode.appendChild(poiPolyTemp);
		}
		return hotspotNode;
	}

	function createHotspotCaption (hotspot, hC, noCaptionBoxes, dropShadow) {
		// Calculate current size values.
		var hotspotZ = hotspot.z / 100;
		var scale = (hC.currentZ / hotspotZ);
		var textScale = (hotspot.mediaType != 'text') ? 1 : ((hotspot.xScale + hotspot.yScale) / 2) / 100;

		// Scale caption if label type is text. If not, constrain scaling if min or max scale set. 0 values mean no limit.
		// Scale caption regardless of type because polygon captions scale even though their points don't change.
		if (hotspot.mediaType == 'text') {
			scale *= textScale;
		} else {
			if (hC.constrainedScaleMin > 0 && scale < hC.constrainedScaleMin) { scale = hC.constrainedScaleMin; }
			if (hC.constrainedScaleMax > 0 && scale > hC.constrainedScaleMax) { scale = hC.constrainedScaleMax; }
		}
		var scaledFontSize = Math.round(defaultFontSize * scale);
		var constrainedFontSize = (hotspot.mediaType == 'text') ? scaledFontSize : ((scaledFontSize < minFontSize) ? minFontSize : (( scaledFontSize > maxFontSize) ? maxFontSize : scaledFontSize));

		// Ensure counters clearly visible.
		if (hotspot.mediaType == 'counter') { constrainedFontSize += 2; }

		// Set defaults.
		var padding = defaultPadding * scale;
		var constrainedPadding = ((padding < minPadding) ? minPadding : (( padding > maxPadding) ? maxPadding : padding));
		var borderWidth, background, captionFontWeight;

		// Create caption text node and container. Use node.firstChild.nodeValue for text and node.innerHTML for HTML.
		// Default backdrop color setting is not used here as it is in drawCaptionOnCanvas because caption box is container for text node in HTML, not simple
		// rectangle drawn as backdrop on canvas.  As such it must be 'transparent none' if no box needed. To clarify this it is named 'background' not 'backColor'.
		var textColor = (Z.Utils.stringValidate(hotspot.textColor)) ? hotspot.textColor : captionTextColor;
		var backColor = (Z.Utils.stringValidate(hotspot.backColor)) ? hotspot.backColor : captionBackColor;

		if (typeof noCaptionBoxes !== 'undefined' && noCaptionBoxes !== null && noCaptionBoxes) {
			borderWidth = '0px';
			background = 'transparent none';
			captionFontWeight = (hotspot.mediaType != 'counter') ? 'normal' : 'bold';
		} else {
			borderWidth = '1px';
			background = backColor;
			captionFontWeight = 'normal';
		}
		if (typeof dropShadow !== 'undefined' && dropShadow !== null && dropShadow) {
			textColor = hotspot.backColor;
		}

		if (!hotspot.textVisible) {
			textColor = 'transparent none';
		}

		// Alternative implementation: If caption background boxes enabled by parameter, reverse font and background colors.
		if (Z.captionBoxes && Z.captionsColorsDefault && hotspot.mediaType != 'measure') {
			textColor = hotspot.backColor;
			background = hotspot.textColor;
		}

		// Avoid hidden text.
		if (textColor == background) {
			if (textColor == '#ffffff') {
				background = '#000000';
			} else if (textColor == '#000000') {
				background = '#ffffff';
			}
		}

		// DEV NOTE: Value 'pre' in whitespace parameter (last) in next line allows use of '%0A' to break lines in caption. '%0D' will not work,
		// though this does work in tooltip which is simply assigned to 'title' tag of hotspot div and is handled by browsers.
		var captionTextBox = Z.Utils.createContainerElement('div', 'captionTextBox', 'inline-block', 'absolute', 'hidden', 'auto', 'auto', '1px', '1px', 'solid', borderWidth, background, '0px', constrainedPadding + 'px', 'pre');
		if (typeof hotspot.captionHTML !== 'undefined' && Z.Utils.stringValidate(hotspot.captionHTML)) {
			captionTextBox.innerHTML = hotspot.captionHTML;
			Z.Utils.setHTMLTextDefaultCaptionStyle(captionTextBox, hotspot.captionHTML, textColor, 'verdana', constrainedFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none');
		} else if (textColor != 'transparent none' && typeof hotspot.caption !== 'undefined' && Z.Utils.stringValidate(hotspot.caption)) {
			var captionTextNode = document.createTextNode(hotspot.caption);
			captionTextBox.appendChild(captionTextNode);
			Z.Utils.setTextNodeStyle(captionTextNode, textColor, 'verdana', constrainedFontSize + 'px', 'none', 'normal', 'normal', 'normal', captionFontWeight, '1em', 'center', 'none');
			Z.Utils.disableTextInteraction(captionTextNode);
		} else if (hotspot.mediaType == 'measure') {
			var hotPt = new Z.Utils.Point(hotspot.x, hotspot.y);
			setHotspotCaptionMeasure(hotspot, hotPt);
		}

		// Prevent text selection and context menu.
		Z.Utils.addEventListener(captionTextBox, 'contextmenu', Z.Utils.preventDefault);

		return captionTextBox;
	}

	function positionHotspotCaption (hotspot, hCaption, hiScaledW, hiScaledH, dropShadow) {
		if (hCaption) {
			var isCurrentHotspotAndPolygon = (hotspotCurrentID == hotspot.internalID && hotspot.media == 'polygon');
			var capPosPt = calculateHotspotCaptionPosition(hCaption, hotspot.captionPosition, hiScaledW, hiScaledH, Z.imageR, isCurrentHotspotAndPolygon);
			if (capPosPt) {
				var dropShadowOffset = (dropShadow) ? 1 : 0;
				hCaption.style.left = (capPosPt.x + dropShadowOffset) + 'px';
				hCaption.style.top = (capPosPt.y + dropShadowOffset) + 'px';
			}
		}
	}

	// Positions hotspot caption if hotspot is polygon and dragging is in progress. Not accurate when
	// not dragging polygon as could be resizing polygon which then requires recentering hotspot itself.
	function positionPolygonCaption (hotspot, hC) {
		var hCaption = getHotspotCaptionElement(hotspot);
		var polyDimensions = Z.Utils.polygonDimensions(hotspot.polygonPts);

		// Calculate constrained scaled dimensions. Do not constrain freehand, rectangle, or polygon hotspots
		// to allow use for creating graphics encircling or otherwize sized to the details within the image.
		// Especially important with min zoom less than zoom-to-fit to provide extra area to draw in margins.
		var hotspotZ = (hotspot.media != 'polygon') ? hotspot.z / 100 : 1;
		var scale = (hC.currentZ / hotspotZ);
		var hiScaledW = polyDimensions.x * scale * (hotspot.xScale / 100);
		var hiScaledH = polyDimensions.y * scale * (hotspot.yScale / 100);
		positionHotspotCaption(hotspot, hCaption, hiScaledW, hiScaledH);
	}

	function calculateHotspotCaptionPosition (hCaption, p, hW, hH, r, isCurrHotAndPoly) {
		// At 0 rotation, left to right: 1,2,3 top, 4,5,6 center, 7, 8, 9 bottom.
		var x, y, temp;
		var hcS = hCaption.style;
		var marginForEditing = (isCurrHotAndPoly && ((Z.editing == 'addLabel' || Z.editing == 'editLabel') || (Z.editMode === null && Z.labelMode == 'measure'))) ? 40 : 0;
		var padding = parseFloat(hcS.padding);
		if (r < 0) { r += 360; }

		// Calculate caption dimensions.
		var dimensions = new calculateCaptionSize(hCaption);

		// Center caption over icon, then rotate caption to offset display rotation.
		x = (hW - dimensions.w) / 2 - padding;
		y = (hH - dimensions.h) / 2 - padding;
		Z.Utils.rotateElement(hcS, -r);

		if (r % 90 == 0) {
			// Reposition caption to preserve position relative to hotspot while rotated and cast
			// position type numeric to avoid quotes in code.  Ensure rotation value positive.
			var p = adjustCalculationForRotation(p, r);

			// Cast position type numeric to avoid quotes in code.
			var p = parseInt(p, 10);

			// Calculate positioning values. Swap if needed to adjust for rotation.
			var wOffset = hW / 2 + dimensions.w / 2 + padding + marginForEditing;
			var hOffset = hH / 2 + dimensions.h + padding + marginForEditing;

			if (r == 90 || r == 270) {
				temp = wOffset;
				wOffset = hOffset;
				hOffset = temp;
			}

			// Move caption to adjust for position and rotation.
			switch(p) {
				case 1 :
					x -= wOffset;
					y -= hOffset;
					break;
				case 2 :
					y -= hOffset;
					break;
				case 3 :
					x += wOffset;
					y -= hOffset;
					break;
				case 4 :
					x -= wOffset;
					break;
				case 6 :
					x += wOffset;
					break;
				case 7 :
					x -= wOffset;
					y += hOffset;
					break;
				case 8 :
					y += hOffset;
					break;
				case 9 :
					x += wOffset;
					y += hOffset;
					break;
			}
		}

		return new Z.Utils.Point(x, y);
	}

	function calculateCaptionSize (hCaption, hZoom, onCanvas) {
		if (typeof hZoom === 'undefined' || hZoom === null) { hZoom = 1; }
		var hcS = hCaption.style;
		var currentZ = self.getZoom();
		var computedW = parseFloat(Z.Utils.getElementStyleProperty(hCaption, 'width'));
		if (isNaN(computedW)) {
			// Workaround for IE failure to report text container element width if setting is 'auto'.
			var font2Pixels = parseFloat(Z.Utils.getResource('DEFAULT_FONTTOPIXELSCONVERSIONFACTOR'));
			var ratioPixs2Chars = parseFloat(hcS.fontSize) / font2Pixels;
			computedW = Math.round(parseFloat(hCaption.firstChild.length * ratioPixs2Chars));
		}

		var defaultFontSize = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTCAPTIONFONTSIZE'), 10);
		var fontRatio = defaultFontSize / parseFloat(hcS.fontSize);
		var minCapHeightCanvas = 2 * parseFloat(Z.Utils.getResource('DEFAULT_MINHOTSPOTCAPTIONFONTSIZE'));
		var maxCapHeightCanvas = 2 * parseFloat(Z.Utils.getResource('DEFAULT_MAXHOTSPOTCAPTIONFONTSIZE'));

		var computedH = defaultFontSize * 1.7 * currentZ / hZoom;
		if (onCanvas) {
			if (computedH < minCapHeightCanvas) {
				computedH = minCapHeightCanvas;
			} else if (computedH > maxCapHeightCanvas) {
				computedH = maxCapHeightCanvas;
			}
		}

		this.w = computedW;
		this.h = computedH;
	}

	// Adjust caption position for to keep in intended relative position to hotspot icon.
	// At 0 rotation, left to right: 1,2,3 top, 4,5,6 center, 7, 8, 9 bottom. Position 5 is center
	// of center row and does not change. Default to 5 during rotation when r != increment of 90.
	// DEV NOTE: Free rotation resulting in non-90 degree values currently results in centered caption.
	function adjustCalculationForRotation (position, r) {

		var p = parseInt(position, 10); // Cast position type numeric to avoid quotes in code.
		if (r < 0) { r += 360; } // Ensure rotation value positive.

		switch(p) {
			case 1 :
				p = (r == 0) ? p : (r == 90) ? 7 : (r == 180) ? 9 : (r == 270) ? 3 : 5;
				break;
			case 2 :
				p = (r == 0) ? p : (r == 90) ? 4 : (r == 180) ? 8 : (r == 270) ? 6 : 5;
				break;
			case 3 :
				p = (r == 0) ? p : (r == 90) ? 1 : (r == 180) ? 7 : (r == 270) ? 9 : 5;
				break;
			case 4 :
				p = (r == 0) ? p : (r == 90) ? 8 : (r == 180) ? 6 : (r == 270) ? 2 : 5;
				break;
			case 6 :
				p = (r == 0) ? p : (r == 90) ? 2 : (r == 180) ? 4 : (r == 270) ? 8 : 5;
				break;
			case 7 :
				p = (r == 0) ? p : (r == 90) ? 9 : (r == 180) ? 3 : (r == 270) ? 1 : 5;
				break;
			case 8 :
				p = (r == 0) ? p : (r == 90) ? 6 : (r == 180) ? 2 : (r == 270) ? 4 : 5;
				break;
			case 9 :
				p = (r == 0) ? p : (r == 90) ? 3 : (r == 180) ? 1 : (r == 270) ? 7 : 5;
				break;
		}

		position = p.toString();
		return position;
	}

	function setHotspotCaptionMeasure (hotspot, clickPt) {
		var polygonClosed = hotspot.polyClosed;
		var polyPts = hotspot.polygonPts.slice(0);
		var pPtsLen = polyPts.length;

		// Set caption title.
		var measureType = '';
		var measurement = 0;
		var measureSq = '';
		var digits = (Z.units == 'pixels') ? 0 : 4;
		var units = (Z.units != 'um') ? Z.units : '\u03BC' + 'm'; // Unicode representation for lowercase mu symbol ('�').

		if (pPtsLen == 0) {
			measureType = measureLengthText;
			measurement = Z.Utils.polygonPerimeter(polyPts, polygonClosed, clickPt, digits);
			captionText = measureType + measurement.toString() + "  " + units;
			hotspot.caption = captionText;
		} else if (pPtsLen > 0 && !polygonClosed) {
			measureType = measureLengthTotalText;
			measurement = Z.Utils.polygonPerimeter(polyPts, polygonClosed, clickPt, digits);
			captionText = measureType + measurement.toString() + "  " + units;
			hotspot.caption = captionText;
		} else {
			measureType = measurePerimeterText;
			measurement = Z.Utils.polygonPerimeter(polyPts, polygonClosed, clickPt, digits);
			var measureSq = measureSquareText
			captionText = measureType + measurement.toString() + "  " + units;
			measureType = measureAreaText;
			measurement = Z.Utils.polygonArea(polyPts, polygonClosed, clickPt, digits);
			captionText += '\n' + measureType + measurement.toString() + "  " + units + measureSq;
			hotspot.caption = captionText;
		}

		// Update annotation panel caption value.
		if (captionTextElement && captionTextElement.firstChild && captionTextElement.firstChild.value) {
			captionTextElement.firstChild.value = hotspotCurrent.caption;
		}
	}

	function setHotspotCaption (hCaption, captionContent, isHTML) {
		if (isHTML) {
			hCaption.innerHTML = captionContent;
		} else {
			hCaption.firstChild.nodeValue = captionContent;
		}
	}

	function removeHotspotCaption (hotspot) {
		var hCaption = getHotspotCaptionElement(hotspot);
		if (hCaption) { hCaption.parentNode.removeChild(hCaption); }
	}

	// Caption will be placed in container, in cloak, (in anchor), as first or second child.
	// hD hContainer hCloak hiAnchor hImage, hD hContainer hCloak hcAnchor hCaption, hD hContainer hCloak hImage, hD hContainer hCloak hCaption
	function getHotspotCaptionElement (hotspot) {
		var hElement = null, hCaption = null;
		var hotVPIDStr = (Z.imageSet) ? '-' + vpID.toString() : '';
		hElement = document.getElementById('hot' + hotspot.id + hotVPIDStr);
		if (hElement) { hCaption = Z.Utils.getChildElementByID(hElement, 'captionTextBox'); }
		return hCaption;
	}

	function createHotspotChoiceList (position, title, dataProvider, vpID) {
		if (typeof vpID === "undefined" || vpID === null) { vpID = viewportID; }
		var vpIDStr = vpID.toString()
		var visible = (position == '0' || Z.imageSet) ? 'hidden' : 'visible';
		var hotListW = parseInt(Z.Utils.getResource('DEFAULT_HOTSPOTLISTWIDTH'), 10);
		var imageSetListW = parseInt(Z.Utils.getResource('DEFAULT_IMAGESETLISTWIDTH'), 10);
		var listW = (Z.imageSet) ? imageSetListW: hotListW;
		var listCoords = calculateHotspotListCoords(position, listW, viewW, viewH); // viewH allows for toolbar height if static in viewer display area.

		// Create choice list and add to viewer.
		if (typeof hotspotList === 'undefined' || hotspotList === null) {
			Z['HotspotList' + vpIDStr] = new Z.Utils.createSelectElement('HotspotList' + vpIDStr, title, dataProvider, listW, listCoords.x, listCoords.y, null, visible, hotspotListMouseDownHandler, 'mousedown');
			hotspotList = Z['HotspotList' + vpIDStr];
			hotD = hotspotList;
			hotS = hotD.style;
			if (position != '0') { Z.ViewerDisplay.appendChild(hotspotList); }
			if (Z.tour) { destinationCurrent = 0; }
			var indexTitleAdjust = (Z.Utils.stringValidate(Z.hotspotListTitle) && Z.hotspotListTitle != 'none') ? 1 : 0;
			hotspotList.selectedIndex = indexTitleAdjust;
		} else {
			Z.Utils.arrayClear(dataProvider);
		}

		// Next line not required as default selection on hotspot list is title value so no initial
		// view adjustment is needed. Also, handler therefore does not call update view so
		// call to displayHotspotsWithoutMedia is needed on initial load.
		//hotspotListMouseDownHandler();
	}

	// Add item to list unless list item exists, then modify current item. Use +1 in list unless data provider includes no title.
	function addToHotspotChoiceList (text, value) {
		if (hotspotList != null) {
			var index = Z.Utils.arrayIndexOfObjectValue(hotspotListDP, 'value', value);
			if (index != -1) {
				var titleAdjust = (Z.hotspotListTitle != 'none' && Z.tourListTitle != 'none') ? 1 : 0;
				hotspotList.options[index + titleAdjust] = new Option(text, value.toString());
				hotspotListDP[index] = { text:text, value:value };
			} else {
				hotspotList.options[hotspotList.options.length] = new Option(text, value.toString());
				hotspotListDP[hotspotListDP.length] = { text:text, value:value };
			}
		}
	}

	function clearHotspotFromChoiceList (intID) {
		if (Z.hotspots) {
			if (hotspotList != null) {
				var index = Z.Utils.arrayIndexOfObjectValue(hotspotListDP, 'value', intID);
				if (index != -1) {
					hotspotListDP = Z.Utils.arraySplice(hotspotListDP, index, 1);
					Z.Utils.updateSelectElement(hotspotList, hotspotListDP);
					var hLen = hotspotList.length;
					if (hLen != 0) { hotspotList.selectedIndex = (index > hLen - 1) ? hLen - 1 : index; }
				}
			}
		}
	}

	function clearAllFromHotspotChoiceList () {
		hotspotList.options.length = 0;
	}

	function clearHotspotFromHTML (intID) {
		var hotVPIDStr = (Z.imageSet) ? '-' + vpID.toString() : '';
		var hotspotElmt = document.getElementById('hot' + intID + hotVPIDStr);
		if (hotspotElmt !== null) { hotspotElmt.parentNode.removeChild(hotspotElmt); }
	}

	this.getHotspots = function () {
		return hotspots;
	}

	this.getHotspotsVisibility = function () {
		return (hS.display == 'inline-block');
	}

	this.setHotspotsVisibility = function (visible) {
		// Set visibility of all hotspots (function name is plural).
		hS.display = (visible) ?  'inline-block' : 'none';
		redisplayHotspots();
	}

	// See notes on function setHotspotVisibility below.
	this.setHotspotPopupVisibility = function (hotspotElement, visible) {
		var popup = getHotspotPopup(hotspotElement);
		if (popup && popup.style) {
			var pDisplay = (visible) ? 'inline-block' : 'none';
			popup.style.display = pDisplay;
			var pVisibility = (visible) ? 'visible' : 'hidden';
			popup.style.visibility = pVisibility;
			hotspotPopupsMaxZIndex++;
			hotspotElement.style.zIndex = hotspotPopupsMaxZIndex.toString();
		}
	}

	function getHotspotPopup (hotspotElement) {
		var cloak = hotspotElement.firstChild;
		var hotspotChildren = hotspotElement.firstChild.childNodes;
		var popup = null;
		if (cloak) {
			for (var i = 0, j = hotspotChildren.length; i < j; i++) {
				var hotspotPopTest = hotspotChildren[i].firstChild;
				if (hotspotPopTest && hotspotPopTest.id && hotspotPopTest.id == 'popup') {
					popup = hotspotPopTest;
				}
			}
		}
		return popup;
	}

	// This function operates on hotspot element in display, and records data
	// in hotspot object in hotspots array. This function hides hotspot by hiding
	// internal contents using nested 'cloak' container. This process uses opacity
	// rather than visibility to ensure mouse events trigger.
	this.setHotspotVisibility = function (hotspotElement, visible) {
		var cloak = hotspotElement.firstChild;
		if (cloak && cloak.style) {
			cloak.style.visibility = 'visible';

			var hVisibility = (visible) ? 'visible' : 'hidden';
			var hBackColor = (visible) ? '' : '#FFFFFF';
			var hOpacity = (visible) ? 1 : 0.01;

			// Set hotspotElement visibility (opacity).
			// DEV NOTE: Alternative non-IE approach. Fails for non-icon label types.
			// if (!(Z.browser == Z.browsers.IE)) { cloak.style.visibility = hVisibility;  } else {...
			cloak.style.backgroundColor = hBackColor;
			Z.Utils.setOpacity(cloak, hOpacity);
			var caption = hotspotElement.firstChild.childNodes[1];
			if (caption && caption.style) { caption.style.visibility = hVisibility; }

			// Record state in hotspot object in array, not display, for reference in drawHotspotInHTML function during redisplay during zoom.
			// If hotspot media is polygon redraw on canvas to show or hide hotspot in html and polygon on canvas.
			// DEV NOTE: Custom property 'visibility' named to not conflict with standard 'visible' property.

			// Get hotspot object ID from hotspot element name.
			var hotspotInternalID = hotspotElement.id.substring(3, hotspotElement.id.length);
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
			if (index != -1) {
				var hotspot = hotspots[index];
				hotspot.visibility = visible;

				// DEV NOTE: Next section necessary to hide rollover polygons. Watch for speed impact on creating new polygons.
				var media = hotspot.media;
				var mediaType = hotspot.mediaType;
				var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
				var isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
				var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
				var isPolygon = (media && media == 'polygon');
				if (isShape || isPolygon) {
					redisplayShapesAndPolygons(true);
				}
			}
		}
	}

	this.setHotspotsVisibilityByFilter = function (filterBy, filterValue, visible) {
		if (hotspots.length > 0) {
			if (hD && hD.childNodes.length > 0) {
				for (var i = 0, j = hotspots.length; i < j; i++) {
					if (hotspots[i][filterBy] == filterValue) {
						var hotspot = hotspots[i];
						hotspot.visibility = visible;
						var hotspotTargetID = hotspot.internalID;
						var hotVPIDStr = (Z.imageSet) ? '-' + vpID.toString() : '';
						var hotspotElement = document.getElementById('hot' + hotspotTargetID + hotVPIDStr);
						if (hotspotElement !== null) { self.setHotspotVisibility(hotspotElement, visible); }
					}
				}
				timeoutCounterHotspotsVisibilityByFilter = 0;
			} else if (timeoutCounterHotspotsVisibilityByFilter < 10) {
				timeoutCounterHotspotsVisibilityByFilter++;
				var hotspotsVisibilityByFilterTimer = window.setTimeout( function () { self.setHotspotsVisibilityByFilter(filterBy, filterValue, visible); }, 100);
			}
		}
		return visible;
	}

	this.setHotspotVisibilityByID = function (id, visible, useInternalID) {
		var idField = (useInternalID) ? 'internalID' : 'id';
		if (hotspots.length > 0) {
			if (hD && hD.childNodes.length > 0) {
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, idField, id);
				if (index != -1) {
					var hotspotTargetID = hotspots[index].internalID;
					var hotVPIDStr = (Z.imageSet) ? '-' + vpID.toString() : '';
					var hotspotElement = document.getElementById('hot' + hotspotTargetID + hotVPIDStr);
					if (hotspotElement != null) { self.setHotspotVisibility(hotspotElement, visible); }
				}
			} else {
				var hotspotsVisibilityByIDTimer = window.setTimeout( function () { setHotspotVisibilityByID(id, visible); }, 100);
			}
		}
	}

	function calculateHotspotListCoords (position, listW, viewerW, viewerH) {
		//Hotspot list positioning: 0 hides, 1 top left, 2 top-right, 3 bottom right, 4 bottom left
		var listX, listY;
		var margin = (Z.imageSet) ? 13 : 25;
		switch (position) {
			case '0':
				listX = 0;
				listY = 0;
				break;
			case '1':
				listX = margin;
				listY = margin;
				break;
			case '2':
				listX = viewerW - listW - margin;
				listY = (Z.imageSet) ? 32 : 20; // DEV NOTE: Add tests and accomodation for image set choicelist position.
				break;
			case '3':
				listX = viewerW - listW - margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			case '4':
				listX = margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			default:
				listX = viewerW - listW;
				listY = margin;
		}
		return new Z.Utils.Point(listX, listY);
	}

	function hotspotIsValid (hotspot) {
		return (Z.Utils.stringValidate(hotspot.media) || Z.Utils.stringValidate(hotspot.caption) || Z.tourPath !== null);
	}

	function hotspotToString (hotspot) {
		var s = '[Hotspot ';
		s += 'id:' + hotspot.id + ', ';
		s += 'internalID:' + hotspot.internalID.toString() + ', ';
		s += 'name:' + hotspot.name + ', ';
		s += 'mediaType:' + hotspot.mediaType + ', ';
		s += 'media:' + hotspot.media + ', ';
		s += 'x:' + hotspot.x.toString() + ', ';
		s += 'y:' + hotspot.y.toString() + ', ';
		s += 'zoom:' + hotspot.z.toString() + ', ';
		s += 'xScale:' + hotspot.xScale.toString() + ', ';
		s += 'yScale:' + hotspot.yScale.toString() + ', ';
		s += 'clickURL:' + hotspot.clickURL + ', ';
		s += 'urlTarget:' + hotspot.urlTarget + ', ';
		s += 'rollover:' + hotspot.rollover + ', ';
		s += 'caption:' + hotspot.caption + ', ';
		s += 'tooltip:' + hotspot.tooltip;
		s += ']';
		return s;
	}

	// If annotations XML file is missing but path is zAnnotationPath and zSaveHandlerPath are provided, try to create new XML file.
	this.createAnnotationsXMLFile = function () {
		var xmlDocNew = createAnnotationsXML();
		if (Z.editMode !== null && !Z.noPost) {
			if (Z.Utils.stringValidate(Z.saveHandlerPath)) {
				var netConnector = new Z.NetConnector();
				netConnector.postXML(Z.saveHandlerPath, xmlDocNew, 'annotation');
				self.parseAnnotationsXML(xmlDocNew);
			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_XMLSAVEHANDLERPATHINVALID'), true, null, 'center');
			}
		}
	}

	this.parseAnnotationsXML = function (xmlDoc, vpID) {
		if (typeof vpID === "undefined" || vpID === null) { vpID = viewportID; }

		if (Z.imageSet) { Z.Utils.showMessage(Z.Utils.getResource('ALERT_LOADINGANNOTATIONS'), false, 2000, 'center'); }

		if (typeof poiListDP !== 'undefined') { Z.Utils.arrayClear(poiListDP); }
		if (typeof hotspotsMedia !== 'undefined') { Z.Utils.arrayClear(hotspotsMedia); }
		if (typeof hotspotPopups !== 'undefined') { Z.Utils.arrayClear(hotspotPopups); }
		if (typeof labelListDP !== 'undefined') { Z.Utils.arrayClear(labelListDP); }
		if (typeof labelListCurrentDP !== 'undefined') { Z.Utils.arrayClear(labelListCurrentDP); }
		if (typeof labelIconListDP !== 'undefined') { Z.Utils.arrayClear(labelIconListDP); }
		if (typeof labelCaptionPositionListDP !== 'undefined') { Z.Utils.arrayClear(labelCaptionPositionListDP); }
		if (typeof labelTargetListDP !== 'undefined') { Z.Utils.arrayClear(labelTargetListDP); }
		if (typeof noteListDP !== 'undefined') { Z.Utils.arrayClear(noteListDP); }
		if (typeof noteListCurrentDP !== 'undefined') { Z.Utils.arrayClear(noteListCurrentDP); }
		mTypeLegacy = false;
		self.setStatus('XMLParsedViewport', false);

		// Verify XML structure is complete, and IDs are unique, regardless of version.
		annotationsXML = validateAnnotationsXMLToLoad(xmlDoc);

		// Parse global annotation setup values.
		var labelSetup = annotationsXML.getElementsByTagName('SETUP')[0];
		annotationPanelPosition = labelSetup.getAttribute('PANELPOSITION');
		var initialVisibilityDefault = Z.Utils.getResource('DEFAULT_HOTSPOTSINITIALVISIBILITY');
		var initialVisibility = labelSetup.getAttribute('INITIALVISIBILITY');
		if (initialVisibilityDefault) {
			hotspotsInitialVisibility = (initialVisibility != '0' && initialVisibility != 'hide'); // Default true.
		} else {
			hotspotsInitialVisibility = (initialVisibility != '1' && initialVisibility != 'show'); // Default false.
		}
		var minScaleAttrib = parseFloat(labelSetup.getAttribute('MINSCALE'));
		if (!isNaN(minScaleAttrib)) { // Legacy 0 values become 0.00001 denoting no limit.
			hotspotsMinScale = (minScaleAttrib != 0) ? minScaleAttrib : 0.00001;
		}
		var maxScaleAttrib = parseFloat(labelSetup.getAttribute('MAXSCALE'));
		if (!isNaN(maxScaleAttrib)) { // Legacy 0 values become 10000 denoting no limit.
			hotspotsMaxScale = (maxScaleAttrib != 0) ? maxScaleAttrib : 10000;
		}

		// Record visibility of annotation panel elements. DEV NOTE: POI and Note elements default to visible in full annotation editing panel but not in markup mode in this version.
		poiVisibility = poiVisibilityXML = (Z.editMode != 'markup' && labelSetup.getAttribute('POIVISIBILITY') != '0');
		labelVisibility = labelVisibilityXML = (labelSetup.getAttribute('LABELVISIBILITY') != '0');
		noteVisibility = noteVisibilityXML = (Z.editMode != 'markup' && labelSetup.getAttribute('NOTEVISIBILITY') != '0');

		// Record visibility of comments field in annotation panel. DEV NOTE: Comments field supported in markup but not full annotation editing panel in this version.
		commentVisibility = commentVisibilityXML = (Z.editMode != 'edit' && labelSetup.getAttribute('COMMENTVISIBILITY') != '0');

		// Set tooltip source.
		tooltipSource = (labelSetup.getAttribute('TOOLTIPSOURCE') == 'COMMENT') ? 'COMMENT' : 'TOOLTIP';

		// Fill POI, Note, and Label arrays. Duplicate processing relative to validateAnnotationsXMLToLoad function allows removal of that function if not desired.
		var poiNodes = annotationsXML.getElementsByTagName('POI');

		// Process POIs - and within each, Notes and Labels.
		for (var i = 0, j = poiNodes.length; i < j; i++) {
			var poiID = getFreeID('poi');
			poiNodes[i].setAttribute('INTERNALID', poiID);
			createPOIFromXML(poiNodes[i]);

			// Process Labels of this POI.
			var poiLabelsContainer = poiNodes[i].getElementsByTagName('LABELS')[0];
			if (poiLabelsContainer) {
				var poiLabels = poiLabelsContainer.getElementsByTagName('LABEL');
				for (var n = 0, o = poiLabels.length; n < o; n++) {
					var labelID = getFreeID('label');
					poiLabels[n].setAttribute('INTERNALID', labelID);
					if (n > 0 && poiLabels[n].getAttribute('ID') == '0' && poiLabels[n-1].getAttribute('ID') == '0') { poiLabels[n].setAttribute('ID', labelID); }
					poiLabels[n].setAttribute('POIID', poiID);
					if (!(Z.browser == Z.browsers.IE && Z.browserVersion < 11)) { // Validate XML content in label node. Workaround included for limited access provided by IE < 11 to HTMLCollection returned by getElementsByTagName above (and DOM elements in general).
						poiLabels[n] = validateAnnotationMedia(poiLabels[n]);
					} else {
						poiLabels[n].parentNode.replaceChild(poiLabels[n], validateAnnotationMedia(poiLabels[n]));
					}
					self.createLabelFromXML(poiLabels[n]);
				}
			}

			// Process Notes of this POI.
			var poiNotesContainer = poiNodes[i].getElementsByTagName('NOTES')[0];
			if (poiNotesContainer) {
				var poiNotes = poiNotesContainer.getElementsByTagName('NOTE');
				for (var k = 0, m = poiNotes.length; k < m; k++) {
					var noteID = getFreeID('note');
					poiNotes[k].setAttribute('INTERNALID', noteID);
					poiNotes[k].setAttribute('POIID', poiID);
					createNoteFromXML(poiNotes[k]);
				}
			}
		}

		// Next line not needed as in hotspotsXML parsing because POI list has no title element so calling its handler will force processing of dependent lists.
		//displayHotspotsWithoutMedia();

		// Trace one error for Flash library graphic, if tracking variable set during annotations XML parsing.
		if (Z.debug == 2 && mTypeLegacy) { Z.Utils.trace(Z.Utils.getResource('ERROR_HOTSPOTMEDIAINVALID')); }

		// Complete XML parsing and process XML as in saveAnnotations function to ensure first call to verifyEditsUnsaved will make valid comparison. Note that
		// minimization by removal of default values occurs only in removeAnnotationDefaults called by saveAnnotations for posting.
		annotationsXML = updateAnnotationsXML(annotationsXML);
		self.setStatus('XMLParsedViewport', true);

		// Set visibility of annotation panel elements and create panel. Allow for possibility of switching display
		// modes between View and Edit and need to record non-true values for Annotation panel sections.
		if (Z.editMode == 'markup') { poiVisibility = labelVisibility = noteVisibility = false; }
		self.createAnnotationPanel(vpID);

		Z.Utils.validateCallback('annotationsLoaded');
		self.setStatus('annotationsLoadedViewport', true);
	}

	// Verify annotations XML is complete and includes all fields for edit tracking.
	// Perform double-unescaping here, as each attribute value is received. This is after loaded XML is converted to an XMLDocument,
	// to protect any escaped multiline or other content the DOMParser would remove. Use custom function to clear HTML entities
	// created with custom function and standard unescape to clear hex codes created by escaping by external functions, if any.
	function validateAnnotationsXMLToLoad (xmlDocIn) {

		// Create XML doc to transfer input values into.
		var xmlDocNew = createAnnotationsXML();
		var xmlRootNew = createAnnotationsXMLNode(xmlDocNew, 'root');

		// Ensure SETUP XML structure is complete, then load data. Ensure backward compatibility with prior node name, changed because setup values no longer all label-specific.
		var setupTemp = createAnnotationsXMLNode(xmlDocNew, 'setup');
		var setupElmtsIn = xmlDocIn.getElementsByTagName('SETUP');
		if (setupElmtsIn.length == 0) { setupElmtsIn = xmlDocIn.getElementsByTagName('LABELSETUP'); }
		if (setupElmtsIn.length > 0) { setupTemp = loadAnnotationSetupNode(setupTemp, setupElmtsIn[0]); }
		xmlRootNew.appendChild(setupTemp);

		// Determine if XML from Flash-based Annotation Viewer is being loaded.
		annotationXMLVersion = parseFloat(setupTemp.getAttribute('ZOOMIFYXMLVERSION'));

		// Process POIs - and within each, Notes and Labels.
		var poiNodesIn = xmlDocIn.getElementsByTagName('POI');
		for (var i = 0, j = poiNodesIn.length; i < j; i++) {

			// Ensure POI XML structure is complete, then update.
			var poiTemp = createAnnotationsXMLNode(xmlDocNew, 'poi');
			poiTemp = loadAnnotationPOINode(poiTemp, poiNodesIn[i]);
			xmlRootNew.appendChild(poiTemp);

			// Process Labels of this POI.
			var poiLabelsContainerIn = poiNodesIn[i].getElementsByTagName('LABELS')[0];
			if (typeof poiLabelsContainerIn !== 'undefined' && poiLabelsContainerIn !== null) {
				var poiLabelsContainerTemp = xmlDocNew.createElement('LABELS');
				poiTemp.appendChild(poiLabelsContainerTemp);
				var poiLabelsIn = poiLabelsContainerIn.getElementsByTagName('LABEL');
				for (var n = 0, o = poiLabelsIn.length; n < o; n++) {
					// Ensure LABEL XML structure is complete, then update.
					var poiLabelTemp = createAnnotationsXMLNode(xmlDocNew, 'label');
					poiLabelTemp = loadAnnotationLabelNode(xmlDocNew, poiLabelTemp, poiLabelsIn[n]);

					// If XML was created by Flash Annotation Viewer, convert polygon points based on zoom value
					// to represent scale properly in HTML5 Viewer where all polygons are drawn at 100% zoom.
					if (annotationXMLVersion == 4 && poiLabelTemp.getAttribute('MEDIA') == 'polygon' && parseFloat(poiLabelTemp.getAttribute('ZOOM')) != 100) {
						poiLabelTemp = polygonPointsZoomXML(poiLabelTemp);
					}

					poiLabelsContainerTemp.appendChild(poiLabelTemp);
				}
			}

			// Process Notes of this POI.
			var poiNotesContainerIn = poiNodesIn[i].getElementsByTagName('NOTES')[0];
			if (typeof poiNotesContainerIn !== 'undefined' && poiNotesContainerIn !== null) {
				var poiNotesContainerTemp = xmlDocNew.createElement('NOTES');
				poiTemp.appendChild(poiNotesContainerTemp);
				var poiNotesIn = poiNotesContainerIn.getElementsByTagName('NOTE');
				for (var k = 0, m = poiNotesIn.length; k < m; k++) {
					// Ensure NOTE XML structure is complete, then update.
					var poiNoteTemp = createAnnotationsXMLNode(xmlDocNew, 'note');
					poiNoteTemp = loadAnnotationNoteNode(poiNoteTemp, poiNotesIn[k]);
					poiNotesContainerTemp.appendChild(poiNoteTemp);
				}
			}
		}

		// Ensure at least one POI exists.
		if (poiNodesIn.length == 0) {
			var poiTemp = createAnnotationsXMLNode(xmlDocNew, 'poi');
			xmlRootNew.appendChild(poiTemp);
		}

		// Debug option: Compare annotations XML loaded and parsed.
		//console.log('XML loaded: ' + Z.Utils.xmlConvertDocToText(xmlDocIn));
		//console.log('XML parsed: ' + Z.Utils.xmlConvertDocToText(xmlDocNew));

		return xmlDocNew;
	}

	function loadAnnotationSetupNode (setupNew, setupSource) {
		temp = setupSource.getAttribute('PANELPOSITION');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('PANELPOSITION', temp); }
		var initVisAtt = setupSource.getAttribute('INITIALVISIBILITY');
		if (Z.Utils.stringValidate(initVisAtt)) {
			var initVisDef = Z.Utils.getResource('DEFAULT_HOTSPOTSINITIALVISIBILITY');
			if (initVisDef) {
				initVis = (initVisAtt != '0' && initVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (initVisAtt != '1' && initVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupNew.setAttribute('INITIALVISIBILITY', initVis);
		}
		var poiVisAtt = setupSource.getAttribute('POIVISIBILITY');
		if (Z.Utils.stringValidate(poiVisAtt)) {
			var poiVisDef = (Z.Utils.getResource('DEFAULT_ANNOTATIONPOIVISIBILITY') == '1');
			if (poiVisDef) {
				initVis = (poiVisAtt != '0' && poiVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (poiVisAtt != '1' && poiVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupNew.setAttribute('POIVISIBILITY', initVis);
		}

		var labelVisAtt = setupSource.getAttribute('LABELVISIBILITY');
		if (Z.Utils.stringValidate(labelVisAtt)) {
			var labelVisDef = (Z.Utils.getResource('DEFAULT_ANNOTATIONLABELVISIBILITY') == '1');
			if (labelVisDef) {
				initVis = (labelVisAtt != '0' && labelVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (labelVisAtt != '1' && labelVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupNew.setAttribute('LABELVISIBILITY', initVis);
		}
		var noteVisAtt = setupSource.getAttribute('NOTEVISIBILITY');
		if (Z.Utils.stringValidate(noteVisAtt)) {
			var noteVisDef = (Z.Utils.getResource('DEFAULT_ANNOTATIONNOTEVISIBILITY') == '1');
			if (noteVisDef) {
				initVis = (noteVisAtt != '0' && noteVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (noteVisAtt != '1' && noteVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupNew.setAttribute('NOTEVISIBILITY', initVis);
		}
		var commentVisAtt = setupSource.getAttribute('COMMENTVISIBILITY');
		if (Z.Utils.stringValidate(noteVisAtt)) {
			var commentVisDef = (Z.Utils.getResource('DEFAULT_ANNOTATIONCOMMENTVISIBILITY') == '1');
			if (commentVisDef) {
				initVis = (commentVisAtt != '0' && commentVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (commentVisAtt != '1' && commentVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupNew.setAttribute('COMMENTVISIBILITY', initVis);
		}
		temp = setupSource.getAttribute('MINSCALE');
		if (Z.Utils.stringValidate(temp)) {
			if (!isNaN(parseFloat(temp)) && parseFloat(temp) >= 0) {
				setupNew.setAttribute('MINSCALE', temp);
			}
		}
		temp = setupSource.getAttribute('MAXSCALE');
		if (Z.Utils.stringValidate(temp)) {
			if (!isNaN(parseFloat(temp)) && parseFloat(temp) >= 0) {
				setupNew.setAttribute('MAXSCALE', temp);
			}
		}
		temp = setupSource.getAttribute('ZOOMIFYXMLVERSION');
		if (Z.Utils.stringValidate(temp)) {
			if (!isNaN(parseFloat(temp)) && parseFloat(temp) == 4) {
				setupNew.setAttribute('ZOOMIFYXMLVERSION', temp);
			}
		}
		temp = setupSource.getAttribute('TOOLTIPSOURCE');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('TOOLTIPSOURCE', temp); }

		return setupNew;
	}

	function loadAnnotationPOINode (poiNew, poiSource) {
		temp = poiSource.getAttribute('ID');
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('ID', temp); }
		temp = Z.Utils.xmlUnescapeMinimal(unescape(poiSource.getAttribute('NAME')));
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('NAME', temp); }
		temp = poiSource.getAttribute('X');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			poiNew.setAttribute('X', ((temp == 'center') ? Z.imageCtrX.toString() : temp));
		}
		temp = poiSource.getAttribute('Y');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			poiNew.setAttribute('Y', ((temp == 'center') ? Z.imageCtrY.toString() : temp));
		}
		temp = poiSource.getAttribute('ZOOM');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			poiNew.setAttribute('ZOOM', temp);
		}
		temp = poiSource.getAttribute('USER');
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('USER', temp); }
		temp = poiSource.getAttribute('DATE');
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('DATE', temp); }
		temp = poiSource.getAttribute('EDITABLE');
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('EDITABLE', temp); }

		return poiNew;
	}

	function loadAnnotationLabelNode (xmlDocNew, labelNew, labelSource) {
		var temp, temp2;
		temp = labelSource.getAttribute('ID');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('ID', temp); }
		temp = Z.Utils.xmlUnescapeMinimal(unescape(labelSource.getAttribute('NAME')));
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('NAME', temp); }

		// Ensure backward compatibility with prior node values changed to relate label types to edit modes.
		// Do not change type 'symbol' to 'icon' if media has no path (no '.') as function validateAnnotationMedia will handle.
		temp = labelSource.getAttribute('MEDIATYPE');
		if (Z.Utils.stringValidate(temp)) {
			labelNew.setAttribute('MEDIATYPE', temp);
			temp2 = labelSource.getAttribute('MEDIA');
			if (Z.Utils.stringValidate(temp2)) { labelNew.setAttribute('MEDIA', temp2); }
			if (temp == 'url') {
				labelNew.setAttribute('MEDIATYPE', 'icon');
			} else if (temp == 'symbol' && Z.Utils.stringValidate(temp2) && temp2 == 'polygon') {
				labelNew.setAttribute('MEDIATYPE', 'polygon');
			} else if (temp == 'symbol' && Z.Utils.stringValidate(temp2) && temp2 == 'caption') {
				labelNew.setAttribute('MEDIATYPE', 'text');
				labelNew.setAttribute('MEDIA', '');
			} else if (temp == 'symbol' && Z.Utils.stringValidate(temp2) && temp2 != 'polygon' && temp2.indexOf('.') != -1) {
				labelNew.setAttribute('MEDIATYPE', 'icon');
			} else if (temp == 'text') {
				labelNew.setAttribute('MEDIA', '');
			}
		}

		temp = labelSource.getAttribute('X');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('X', ((temp == 'center') ? Z.imageCtrX.toString() : temp));
		}
		temp = labelSource.getAttribute('Y');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('Y', ((temp == 'center') ? Z.imageCtrY.toString() : temp));
		}
		temp = labelSource.getAttribute('ZOOM');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('ZOOM', temp);
		}
		temp = labelSource.getAttribute('XSCALE');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('XSCALE', temp);
		}
		temp = labelSource.getAttribute('YSCALE');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('YSCALE', temp);
		}
		temp = labelSource.getAttribute('ZMIN');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('ZMIN', temp);
		}
		temp = labelSource.getAttribute('ROTATION');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('ROTATION', temp);
		}
		temp = labelSource.getAttribute('RADIUS');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('RADIUS', temp);
		}
		temp = labelSource.getAttribute('ZMAX');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('ZMAX', temp);
		}
		temp = labelSource.getAttribute('CLICKURL');
		if (Z.Utils.stringValidate(temp)) {
			labelNew.setAttribute('CLICKURL', temp);
		} else {
			// Ensure backward compatibility with prior node name, changed to avoid
			// mistaking attribute with MEDIA attribute (a URL depending on label MEDIATYPE).
			temp = labelSource.getAttribute('URL');
			if (Z.Utils.stringValidate(temp)) {
				labelNew.setAttribute('CLICKURL', temp);
			}
		}
		temp = labelSource.getAttribute('URLTARGET');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('URLTARGET', temp); }
		temp = labelSource.getAttribute('ROLLOVER');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('ROLLOVER', temp); }
		temp = Z.Utils.xmlUnescapeMinimal(unescape(labelSource.getAttribute('CAPTION')));
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('CAPTION', temp); }
		temp = Z.Utils.xmlUnescapeMinimal(unescape(labelSource.getAttribute('COMMENT')));
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('COMMENT', temp); }
		temp = Z.Utils.xmlUnescapeMinimal(unescape(labelSource.getAttribute('TOOLTIP')));
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('TOOLTIP', temp); }
		temp = labelSource.getAttribute('USER');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('USER', temp); }
		temp = labelSource.getAttribute('DATE');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('DATE', temp); }
		temp = labelSource.getAttribute('TEXTCOLOR');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('TEXTCOLOR', Z.Utils.stringValidateColorValue(temp)); }
		temp = labelSource.getAttribute('BACKCOLOR');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('BACKCOLOR', Z.Utils.stringValidateColorValue(temp)); }
		temp = labelSource.getAttribute('LINECOLOR');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('LINECOLOR', Z.Utils.stringValidateColorValue(temp)); }
		temp = labelSource.getAttribute('FILLCOLOR');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('FILLCOLOR', Z.Utils.stringValidateColorValue(temp)); }
		temp = labelSource.getAttribute('TEXTVISIBLE');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('TEXTVISIBLE', temp); }
		temp = labelSource.getAttribute('BACKVISIBLE');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('BACKVISIBLE', temp); }
		temp = labelSource.getAttribute('LINEVISIBLE');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('LINEVISIBLE', temp); }
		temp = labelSource.getAttribute('FILLVISIBLE');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('FILLVISIBLE', temp); }
		temp = labelSource.getAttribute('CAPTIONPOSITION');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('CAPTIONPOSITION', temp); }
		temp = labelSource.getAttribute('CATEGORY');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('CATEGORY', temp); }

		// Load optional HTML content in caption and tooltip. Workaround attempted for limited access provided by IE < 11 to HTMLCollection returned by getElementsByTagName above (and DOM elements in general) fails due to problem with getting and setting innerHTML.
		tempNode = labelSource.getElementsByTagName('CAPTION')[0];
		if (typeof tempNode !== 'undefined' && tempNode !== null) {
			if (!(Z.browser == Z.browsers.IE && Z.browserVersion < 11)) {
				labelNew.appendChild(tempNode);
			} else {
				var tempCaptionText = Z.Utils.xmlConvertDocToText(tempNode);
				labelNew.setAttribute('CAPTION', tempCaptionText);
			}
		}
		var tempNode = labelSource.getElementsByTagName('TOOLTIP')[0];
		if (typeof tempNode !== 'undefined' && tempNode !== null) {
			if (!(Z.browser == Z.browsers.IE && Z.browserVersion < 11)) {
				labelNew.appendChild(tempNode);
			} else {
				var tempTooltipText = Z.Utils.xmlConvertDocToText(tempNode);
				labelNew.setAttribute('TOOLTIP', tempTooltipText);
			}
		}

		var polygonIn = labelSource.getElementsByTagName('POLYGON')[0];
		if (polygonIn) {
			var polygonOut = createAnnotationsXMLNode(xmlDocNew, 'polygon');
			var pointsIn = polygonIn.getElementsByTagName('POINT');
			for (var p = 0, r = pointsIn.length; p < r; p++) {
				var pointIn = polygonIn.getElementsByTagName('POINT')[p];
				var pointOut = createAnnotationsXMLNode(xmlDocNew, 'point');
				temp = pointIn.getAttribute('X');
				if (Z.Utils.stringValidate(temp)) { pointOut.setAttribute('X', temp); }
				temp = pointIn.getAttribute('Y');
				if (Z.Utils.stringValidate(temp)) { pointOut.setAttribute('Y', temp); }
				polygonOut.appendChild(pointOut);
			}
			temp = labelSource.getAttribute('CLOSED');
			if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('CLOSED', temp); }
			labelNew.appendChild(polygonOut);
		}
		temp = labelSource.getAttribute('POPUP');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('POPUP', temp); }
		temp = labelSource.getAttribute('POPOFFSETX');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('POPOFFSETX', temp);
		}
		temp = labelSource.getAttribute('POPOFFSETY');
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) {
			labelNew.setAttribute('POPOFFSETY', temp);
		}
		temp = labelSource.getAttribute('EDITABLE');
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('EDITABLE', temp); }
		
		return labelNew;
	}

	function loadAnnotationNoteNode (noteNew, noteSource) {
		temp = noteSource.getAttribute('ID');
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('ID', temp); }
		temp = Z.Utils.xmlUnescapeMinimal(unescape(noteSource.getAttribute('NAME')));
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('NAME', temp); }
		temp = Z.Utils.xmlUnescapeMinimal(unescape(noteSource.getAttribute('TEXT')));
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('TEXT', temp); }
		temp = noteSource.getAttribute('USER');
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('USER', temp); }
		temp = noteSource.getAttribute('DATE');
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('DATE', temp); }
		temp = noteSource.getAttribute('EDITABLE');
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('EDITABLE', temp); }

		return noteNew;
	}

	// Verify annotations XML is minimum required by removing all attributes with default values as well as # signs from color values.
	function removeAnnotationDefaults (xmlDocIn) {
		var xmlTextIn = Z.Utils.xmlConvertDocToText(xmlDocIn);
		var xmlDocOut = Z.Utils.xmlConvertTextToDoc(xmlTextIn);

		var setup = xmlDocOut.getElementsByTagName('SETUP')[0];
		if (setup.getAttribute('PANELPOSITION') == '2') { setup.removeAttribute('PANELPOSITION'); }
		if (setup.getAttribute('INITIALVISIBILITY') == '1') { setup.removeAttribute('INITIALVISIBILITY'); }
		if (setup.getAttribute('POIVISIBILITY') == '1') { setup.removeAttribute('POIVISIBILITY'); }
		if (setup.getAttribute('LABELVISIBILITY') == '1') { setup.removeAttribute('LABELVISIBILITY'); }
		if (setup.getAttribute('NOTEVISIBILITY') == '1') { setup.removeAttribute('NOTEVISIBILITY'); }
		if (setup.getAttribute('COMMENTVISIBILITY') == '1') { setup.removeAttribute('COMMENTVISIBILITY'); }
		if (parseFloat(setup.getAttribute('MINSCALE')) == 0.2) { setup.removeAttribute('MINSCALE'); }
		if (parseFloat(setup.getAttribute('MAXSCALE')) == 2) { setup.removeAttribute('MAXSCALE'); }

		var poiNodes = xmlDocOut.getElementsByTagName('POI');
		for (var i = 0, j = poiNodes.length; i < j; i++) {
			var poi = poiNodes[i];
			if (poi.getAttribute('NAME') == Z.Utils.getResource('CONTENT_POINAME')) { poi.removeAttribute('NAME'); }
			if (poi.getAttribute('X') == 'center') { poi.removeAttribute('X'); }
			if (poi.getAttribute('Y') == 'center') { poi.removeAttribute('Y'); }
			if (poi.getAttribute('ZOOM') == '-1') { poi.removeAttribute('ZOOM'); }
			if (poi.hasAttribute('INTERNALID')) { poi.removeAttribute('INTERNALID'); }

			var poiLabelsContainer = poiNodes[i].getElementsByTagName('LABELS')[0];
			if (poiLabelsContainer) {
				var poiLabels = poiLabelsContainer.getElementsByTagName('LABEL');
				for (var n = 0, o = poiLabels.length; n < o; n++) {
					var label = poiLabels[n];
					if (label.getAttribute('NAME') == Z.Utils.getResource('CONTENT_LABELNAME')) { label.removeAttribute('NAME'); }
					if (label.getAttribute('X') == 'center') { label.removeAttribute('X'); }
					if (label.getAttribute('Y') == 'center') { label.removeAttribute('Y'); }
					if (label.getAttribute('ZOOM') == '100') { label.removeAttribute('ZOOM'); }
					if (label.getAttribute('XSCALE') == '100') { label.removeAttribute('XSCALE'); }
					if (label.getAttribute('YSCALE') == '100') { label.removeAttribute('YSCALE'); }
					if (label.getAttribute('RADIUS') == '') { label.removeAttribute('RADIUS'); }
					if (label.getAttribute('ZMIN') == '0') { label.removeAttribute('ZMIN'); }
					if (label.getAttribute('ZMAX') == '0') { label.removeAttribute('ZMAX'); }
					if (label.getAttribute('CLICKURL') == '') { label.removeAttribute('CLICKURL'); }
					if (label.getAttribute('URLTARGET') == '_blank') { label.removeAttribute('URLTARGET'); }
					if (label.getAttribute('ROLLOVER') == '0') { label.removeAttribute('ROLLOVER'); }
					if (label.getAttribute('CAPTION') == '') { label.removeAttribute('CAPTION'); }
					if (label.getAttribute('COMMENT') == '') { label.removeAttribute('COMMENT'); }
					if (label.getAttribute('TOOLTIP') == '') { label.removeAttribute('TOOLTIP'); }
					if (label.getAttribute('TEXTCOLOR') == Z.Utils.getResource('CONTENT_CAPTIONTEXTCOLOR')) { label.removeAttribute('TEXTCOLOR'); }
					if (label.getAttribute('BACKCOLOR') == Z.Utils.getResource('CONTENT_CAPTIONBACKCOLOR')) { label.removeAttribute('BACKCOLOR'); }
					if (label.getAttribute('LINECOLOR') == Z.Utils.getResource('CONTENT_POLYGONLINECOLOR')) { label.removeAttribute('LINECOLOR'); }
					if (label.getAttribute('FILLCOLOR') == Z.Utils.getResource('CONTENT_POLYGONFILLCOLOR')) { label.removeAttribute('FILLCOLOR'); }
					if (label.getAttribute('TEXTVISIBLE') == Z.Utils.getResource('CONTENT_CAPTIONTEXTVISIBLE')) { label.removeAttribute('TEXTVISIBLE'); }
					if (label.getAttribute('BACKVISIBLE') == Z.Utils.getResource('CONTENT_CAPTIONBACKVISIBLE')) { label.removeAttribute('BACKVISIBLE'); }
					if (label.getAttribute('LINEVISIBLE') == Z.Utils.getResource('CONTENT_POLYGONLINEVISIBLE')) { label.removeAttribute('LINEVISIBLE'); }
					if (label.getAttribute('FILLVISIBLE') == Z.Utils.getResource('CONTENT_POLYGONFILLVISIBLE')) { label.removeAttribute('FILLVISIBLE'); }
					if (label.getAttribute('CAPTIONPOSITION') == Z.Utils.getResource('CONTENT_CAPTIONPOSITION')) { label.removeAttribute('CAPTIONPOSITION'); }
					if (label.getAttribute('EDITABLE') == Z.Utils.getResource('CONTENT_EDITABLE')) { label.removeAttribute('EDITABLE'); }
					// Caption node, if present, not minimalized.
					// Tooltip node, if present, not minimalized.
					// Polygon node, if present, not minimalized.
					if (label.hasAttribute('INTERNALID')) { label.removeAttribute('INTERNALID'); }
					// POIID, if present, not minimalized.
				}
			}

			var poiNotesContainer = poiNodes[i].getElementsByTagName('NOTES')[0];
			if (poiNotesContainer) {
				var poiNotes = poiNotesContainer.getElementsByTagName('NOTE');
				for (var k = 0, m = poiNotes.length; k < m; k++) {
					var note = poiNotes[k];
					if (note.getAttribute('NAME') == Z.Utils.getResource('CONTENT_NOTENAME')) { note.removeAttribute('NAME'); }
					if (note.getAttribute('TEXT') == Z.Utils.getResource('CONTENT_NOTETEXT')) { note.removeAttribute('TEXT'); }
					if (note.hasAttribute('INTERNALID')) { note.removeAttribute('INTERNALID'); }
					// POIID, if present, not minimalized.
				}
			}
		}

		// Debug options:
		//console.log('xmlDocIn: ' + Z.Utils.xmlConvertDocToText(xmlDocIn));
		//console.log('xmlDocOut: ' + Z.Utils.xmlConvertDocToText(xmlDocOut));

		return xmlDocOut;
	}

	// Substitute url of external graphic for Flash library graphic and set tracking variable to enable one-time user alert.
	function validateAnnotationMedia (nodeToValidate) {
		var mediaType = nodeToValidate.getAttribute('MEDIATYPE');
		var media = nodeToValidate.getAttribute('MEDIA');

		if (media) {

			// DEV NOTE: Different tests than for isExternalIcon and isShape because focused on subset of external graphics.
			var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
			var isInternalSymbol = (media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');

			var mediaNew = null;
			if (Z.labelIconsInternal) {
				if (isExternalSymbol) {
					if (mediaType == 'symbol' || mediaType == 'icon') {
						mediaNew = media.substring(media.lastIndexOf('/') + 1, media.indexOf('.'));
					}
				} else {
					if (mediaType == 'symbol') {
						mediaNew = annotationFolder + '/noSubstitutePlaceholder.png';
					}
				}
			} else if (Z.labelIconsInternal !== null && !Z.labelIconsInternal) {
				if (mediaType == 'symbol') {
					if (isInternalSymbol) {
						mediaNew = annotationFolder + '/' + media + '.png';
					} else {
						mediaNew = annotationFolder + '/' + 'noSubstitutePlaceholder.png';
					}
				}
			}

			if (mediaNew) {
				nodeToValidate.setAttribute('MEDIATYPE', 'icon');
				nodeToValidate.setAttribute('MEDIA', mediaNew);
				mTypeLegacy = true;
			}
		}

		return nodeToValidate;
	}

	function createAnnotationsXML () {
		var xmlText = '<ZAS></ZAS>';
		var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
		return xmlDoc;
	}

	function createAnnotationsXMLNode (xmlDoc, nodeType) {
		var tempNode;
		switch (nodeType) {
			case 'root' :
				// Node exists, created in prior call to createAnnotationsXML;
				tempNode = xmlDoc.getElementsByTagName('ZAS')[0];
				break;
			case 'setup' :
				tempNode = xmlDoc.createElement('SETUP');
				tempNode.setAttribute('PANELPOSITION','2');
				tempNode.setAttribute('INITIALVISIBILITY','1');
				tempNode.setAttribute('POIVISIBILITY','0');
				tempNode.setAttribute('LABELVISIBILITY','1');
				tempNode.setAttribute('NOTEVISIBILITY','0');
				tempNode.setAttribute('COMMENTVISIBILITY','1');
				tempNode.setAttribute('MINSCALE','0.2');
				tempNode.setAttribute('MAXSCALE','2');
				tempNode.setAttribute('ZOOMIFYXMLVERSION','5');
				break;
			case 'poi' :
				tempNode = xmlDoc.createElement('POI');
				tempNode.setAttribute('ID','0');
				tempNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_POINAME'));
				tempNode.setAttribute('EDITABLE', Z.Utils.getResource('CONTENT_EDITABLE'));
				tempNode.setAttribute('X','center');
				tempNode.setAttribute('Y','center');
				tempNode.setAttribute('ZOOM','-1');
				tempNode.setAttribute('USER', Z.Utils.getResource('CONTENT_POIUSER'));
				tempNode.setAttribute('DATE', Z.Utils.getCurrentUTCDateAsString());
				break;
			case 'label' :
				tempNode = xmlDoc.createElement('LABEL');
				tempNode.setAttribute('ID','0');
				tempNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_LABELNAME'));
				tempNode.setAttribute('MEDIATYPE', 'text');
				tempNode.setAttribute('MEDIA', '');
				tempNode.setAttribute('X', 'center');
				tempNode.setAttribute('Y', 'center');
				tempNode.setAttribute('ZOOM', '100');
				tempNode.setAttribute('XSCALE', '100');
				tempNode.setAttribute('YSCALE', '100');
				tempNode.setAttribute('RADIUS', '');
				tempNode.setAttribute('ZMIN', '0');
				tempNode.setAttribute('ZMAX', '0');
				tempNode.setAttribute('CLICKURL', '');
				tempNode.setAttribute('URLTARGET', '');
				tempNode.setAttribute('ROLLOVER', '0');
				// Do not set default caption value: permitted to have no caption.
				//tempNode.setAttribute('CAPTION', Z.Utils.getResource('CONTENT_LABELCAPTION'));
				tempNode.setAttribute('CAPTION', '');
				// Do not set default comment value: permitted to have no comment.
				//tempNode.setAttribute('COMMENT', Z.Utils.getResource('CONTENT_LABELCOMMENT'));
				tempNode.setAttribute('COMMENT', '');
				tempNode.setAttribute('TOOLTIP', '');
				tempNode.setAttribute('USER', Z.Utils.getResource('CONTENT_LABELUSER'));
				tempNode.setAttribute('DATE', Z.Utils.getCurrentUTCDateAsString());
				tempNode.setAttribute('TEXTCOLOR', Z.Utils.getResource('CONTENT_CAPTIONTEXTCOLOR'));
				tempNode.setAttribute('BACKCOLOR', Z.Utils.getResource('CONTENT_CAPTIONBACKCOLOR'));
				tempNode.setAttribute('LINECOLOR', Z.Utils.getResource('CONTENT_POLYGONLINECOLOR'));
				tempNode.setAttribute('FILLCOLOR', Z.Utils.getResource('CONTENT_POLYGONFILLCOLOR'));
				tempNode.setAttribute('TEXTVISIBLE', Z.Utils.getResource('CONTENT_CAPTIONTEXTVISIBLE'));
				tempNode.setAttribute('BACKVISIBLE', Z.Utils.getResource('CONTENT_CAPTIONBACKVISIBLE'));
				tempNode.setAttribute('LINEVISIBLE', Z.Utils.getResource('CONTENT_POLYGONLINEVISIBLE'));
				tempNode.setAttribute('FILLVISIBLE', Z.Utils.getResource('CONTENT_POLYGONFILLVISIBLE'));
				tempNode.setAttribute('CAPTIONPOSITION', Z.Utils.getResource('CONTENT_CAPTIONPOSITION'));
				tempNode.setAttribute('ROTATION', '0');
				tempNode.setAttribute('CATEGORY', '');
				tempNode.setAttribute('POPUP', '');
				tempNode.setAttribute('POPOFFSETX', '');
				tempNode.setAttribute('POPOFFSETY', '');
				tempNode.setAttribute('EDITABLE', '1');
				break;
			case 'polygon' :
				tempNode = xmlDoc.createElement('POLYGON');
				break;
			case 'point' :
				tempNode = xmlDoc.createElement('POINT');
				tempNode.setAttribute('X', '0');
				tempNode.setAttribute('Y', '0');
				break;
			case 'note' :
				tempNode = xmlDoc.createElement('NOTE');
				tempNode.setAttribute('ID','0');
				tempNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_NOTENAME'));
				tempNode.setAttribute('EDITABLE', '1');
				tempNode.setAttribute('TEXT', Z.Utils.getResource('CONTENT_NOTETEXT'));
				tempNode.setAttribute('USER', Z.Utils.getResource('CONTENT_NOTEUSER'));
				tempNode.setAttribute('DATE', Z.Utils.getCurrentUTCDateAsString());
				break;
		}
		return tempNode;
	}

	function createFirstPOI () {
		var name = Z.Utils.getResource('CONTENT_FIRSTPOINAME');
		createPOIFromParameters('0', name, 'center', 'center', '-1', '0', '1');
		poiPriorID = '0';
	}

	function createPOIFromParameters (id, name, x, y, zoom, internalID, editable) {
		// Receive parameters as array rather than using 'argument' local object to include values even if none passed.
		var poiParams = Z.Utils.arrayToArrayOfStrings( [id, name, x, y, zoom, internalID, editable] );
		var xmlText = '<POI ID="' + poiParams[0]  + '" NAME="' + poiParams[1] + '" X="' + poiParams[2] + '" Y="' + poiParams[3] + '" ZOOM="' + poiParams[4] + '" INTERNALID="' + poiParams[5] + '" EDITABLE="' + poiParams[6] + '" ></POI>';
		var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
		var poiNode = xmlDoc.getElementsByTagName('POI')[0];
		createPOIFromXML(poiNode, true);
	}

	function createPOIFromXML (poiNode, validate) {
		self.saveEditsPOI(true);
		if (validate) { poiNode = validateAnnotationXMLNode(poiNode, 'poi'); }
		var poiNodeIntID = poiNode.getAttribute('INTERNALID');
		var poiNodeEditable = poiNode.getAttribute('EDITABLE');
		var poiEditable = poiNodeEditable != '0' && poiNodeEditable != 'false';
		var index = Z.Utils.arrayIndexOfObjectValue(poiListDP, 'value', poiNodeIntID);
		if (index == -1) { index = poiListDP.length; }
		poiListDP[index] = { text:poiNode.getAttribute('NAME'), value:poiNodeIntID, id:poiNode.getAttribute('ID'), x:poiNode.getAttribute('X'), y:poiNode.getAttribute('Y'), z:poiNode.getAttribute('ZOOM'), user:poiNode.getAttribute('USER'), date:poiNode.getAttribute('DATE'), editable:poiEditable };
	}

	this.createLabelFromParameters = function (id, name, mediaType, media, audio, x, y, zoom, xScale, yScale, radius, zMin, zMax, url, urlTarget, rollover, caption, comment, tooltip, textColor, backColor, lineColor, fillColor, textVisible, backVisible, lineVisible, fillVisible, captionPosition, saved, internalID, poiID, captionHTML, tooltipHTML, polyClosed, polygonPts, showFor, transition, changeFor, rotation, category, editable, popup, popupOffsetX, popupOffsetY, user, initials, date) {
		// Receive parameters as array rather than using 'argument' local object to include values even if none passed.
		var labelParams = Z.Utils.arrayToArrayOfStrings( [id, name, mediaType, media, audio, x, y, zoom, xScale, yScale, radius, zMin, zMax, url, urlTarget, rollover, caption, comment, tooltip, textColor, backColor, lineColor, fillColor, textVisible, backVisible, lineVisible, fillVisible, captionPosition, saved, internalID, poiID, captionHTML, tooltipHTML, polyClosed, polygonPts, showFor, transition, changeFor, rotation, category, editable, popup, popupOffsetX, popupOffsetY, user, initials, date ] );
		var xmlText = '<LABEL ID="' + labelParams[0]  + '" NAME="' + labelParams[1] + '" MEDIATYPE="' + labelParams[2] + '" MEDIA="' + labelParams[3] + '" AUDIO="' + labelParams[4] + '" X="' + labelParams[5] + '" Y="' + labelParams[6] + '" ZOOM="' + labelParams[7] + '" XSCALE="' + labelParams[8] +'" YSCALE="' + labelParams[9] + '" RADIUS="' + labelParams[10] +'" ZMIN="' + labelParams[11] +'" ZMAX="' + labelParams[12] + '" CLICKURL="' + labelParams[13] + '" URLTARGET="' + labelParams[14] + '" ROLLOVER="' + labelParams[15] + '" CAPTION="' + labelParams[16] + '" COMMENT="' + labelParams[17] + '" TOOLTIP="' + labelParams[18] + '" TEXTCOLOR="' + labelParams[19] + '" BACKCOLOR="' + labelParams[20] + '" LINECOLOR="' + labelParams[21] + '" FILLCOLOR="' + labelParams[22] + '" TEXTVISIBLE="' + labelParams[23] + '" BACKVISIBLE="' + labelParams[24] + '" LINEVISIBLE="' + labelParams[25] + '" FILLVISIBLE="' + labelParams[26] + '" CAPTIONPOSITION="' + labelParams[27] + '" SAVED="' + labelParams[28] + '" INTERNALID="' + labelParams[29]  + '" POIID="' + labelParams[30] + '" POLYGONCLOSED="' + labelParams[33] + '" SHOWFOR="' + labelParams[35] + '" TRANSITION="' + labelParams[36] + '" CHANGEFOR="' + labelParams[37] + '" ROTATION="' + labelParams[38] + '" CATEGORY="' + labelParams[39] + '" EDITABLE="' + labelParams[40] + '" POPUP="' + labelParams[41] + '" POPOFFSETX="' + labelParams[42] + '" POPOFFSETY="' + labelParams[43] + '" USER="' + labelParams[44] + '" INITIALS="' + labelParams[45] + '" DATE="' + labelParams[46] + '" ></LABEL>';
		var xmlDocNew = Z.Utils.xmlConvertTextToDoc(xmlText);
		var labelNode = xmlDocNew.getElementsByTagName('LABEL')[0];

		// Ensure unique label internalID for code use.
		if (!Z.Utils.stringValidate(labelNode.getAttribute('INTERNALID'))) { labelNode.setAttribute('INTERNALID', getFreeID('label')); }

		// Duplicate complex content, if present, for caption, tooltip, polygon.
		var temp = captionHTML;
		if (Z.Utils.stringValidate(temp)) {
			var tempHTML = Z.Utils.xmlConvertTextToDoc(temp).getElementsByTagName('CAPTION')[0].innerHTML;
			var captionNode = xmlDocNew.createElement('CAPTION');
			captionNode.innerHTML = tempHTML;
			labelNode.appendChild(captionNode);
		}
		temp = tooltipHTML;
		if (Z.Utils.stringValidate(temp)) {
			var tempHTML = Z.Utils.xmlConvertTextToDoc(temp).getElementsByTagName('TOOLTIP')[0].innerHTML;
			var tooltipNode = xmlDocNew.createElement('TOOLTIP');
			tooltipNode.innerHTML = tempHTML;
			labelNode.appendChild(tooltipNode);
		}
		if (polygonPts != null) {
			var poiPolyTemp = xmlDocNew.createElement('POLYGON');
			for (var p = 0, q = polygonPts.length; p < q; p++) {
				var poiPointTemp = xmlDocNew.createElement('POINT');
				poiPointTemp.setAttribute('X', polygonPts[p].x);
				poiPointTemp.setAttribute('Y', polygonPts[p].y);
				poiPolyTemp.appendChild(poiPointTemp);
			}
			labelNode.appendChild(poiPolyTemp);
		}
		self.createLabelFromXML(labelNode, true);
	}

	this.createLabelFromJSON = function (labelObject, validate) {
		var xmlText = Z.Utils.jsonConvertObjectToXMLText(labelObject);
		var xmlDocNew = Z.Utils.xmlConvertTextToDoc(xmlText);
		var labelNode = xmlDocNew.getElementsByTagName('LABEL')[0];
		self.createLabelFromXML(labelNode, true);
	}

	this.createLabelFromXML = function (labelNode, validate) {
		if (validate) { labelNode = validateAnnotationXMLNode(labelNode, 'label'); }

		var labelNodeIntID = labelNode.getAttribute('INTERNALID');
		var labelNodeEditable = labelNode.getAttribute('EDITABLE');
		var labelEditable = labelNodeEditable != '0' && labelNodeEditable != 'false';

		// DEV NOTE: Add key fields to data provider. Store other values including id, user, date, etc. in associated hotspot.
		var index = Z.Utils.arrayIndexOfObjectValue(labelListDP, 'value', labelNodeIntID);
		if (index == -1) { index = labelListDP.length; }
		labelListDP[index] = { text:labelNode.getAttribute('NAME'), value:labelNodeIntID, poiID:labelNode.getAttribute('POIID'), editable:labelEditable };
		self.createHotspotFromXML(labelNode);
	}

	// Enables creation of hotspots for polygon control points without creation of label for every control point.
	function updateLabelsForHotspot (hotspot, poiID) {
		if (!(Z.measureVisible && Z.editMode === null)) {
			var index = Z.Utils.arrayIndexOfObjectValue(labelListDP, 'value', hotspotCurrentID);
			if (index != -1) {
				labelListDP[index] = { text:hotspot.name, value:hotspotCurrentID, poiID:poiID };
				var index2 = Z.Utils.arrayIndexOfObjectValue(labelListCurrentDP, 'value', hotspotCurrentID);
				if (index2 != -1) {
					labelListCurrentDP[index2] = { text:hotspot.name, value:hotspotCurrentID, poiID:poiID };
					if (self.getStatus('XMLParsedViewport')) { Z.Utils.updateSelectElement(labelList, labelListCurrentDP); }
				}
			} else {
				labelListDP[labelListDP.length] = { text:hotspot.name, value:hotspotCurrentID, poiID:poiID };
				labelListCurrentDP[labelListCurrentDP.length] = { text:hotspot.name, value:hotspotCurrentID, poiID:poiID };
			}

			if (self.getStatus('XMLParsedViewport') && labelList) {
				var newLabel = labelListDP[labelListDP.length - 1];
				populateLabels(newLabel.poiID, newLabel.value);
			}
		}
	}

	function createNoteFromParameters (id, name, noteText, internalID, poiID, editable) {
		// Receive parameters as array rather than using 'argument' local object to include values even if none passed.
		var noteParams = Z.Utils.arrayToArrayOfStrings( [id, name, noteText, internalID, poiID, editable] );
		var xmlText = '<NOTE ID="' + noteParams[0]  + '" NAME="' + noteParams[1] + '" TEXT="' + noteParams[2] + '" INTERNALID="' + noteParams[3] + '" POIID="' + noteParams[4] + '" EDITABLE="' + noteParams[5] + '" ></NOTE>';
		var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
		var noteNode = xmlDoc.getElementsByTagName('NOTE')[0];
		createNoteFromXML(noteNode, true);
	}

	function createNoteFromXML (noteNode, validate) {
		self.saveEditsNote(true);
		if (validate) { noteNode = validateAnnotationXMLNode(noteNode, 'note'); }
		var noteNodeIntID = noteNode.getAttribute('INTERNALID');
		var noteNodeEditable = noteNode.getAttribute('EDITABLE');
		var noteEditable = noteNodeEditable != '0' && noteNodeEditable != 'false';
		var index = Z.Utils.arrayIndexOfObjectValue(noteListDP, 'value', noteNodeIntID);
		if (index == -1) { index = noteListDP.length; }
		noteListDP[index] = { text:noteNode.getAttribute('NAME'), value:noteNodeIntID, noteText:noteNode.getAttribute('TEXT'), poiID:noteNode.getAttribute('POIID'), id:noteNode.getAttribute('ID'), user:noteNode.getAttribute('USER'), date:noteNode.getAttribute('DATE'), editable:noteEditable };
	}

	function validateAnnotationXMLNode (xmlNode, nodeType) {
		var idFree, labelMode;

		// Ensure xmlNode meets requirements for nodeType.
		switch (nodeType) {
			case 'hotspot' :
				idFree = (hotspotList) ? getFreeID('hotspot') : getFreeID('label');
				labelMode = (Z.Utils.stringValidate(Z.labelMode)) ? Z.labelMode : '';
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ID'))) { xmlNode.setAttribute('ID', idFree); }
				var defaultName = (hotspotList) ? Z.Utils.getResource('CONTENT_HOTSPOTNAME') : Z.Utils.getResource('CONTENT_LABELNAME');
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('NAME'))) { xmlNode.setAttribute('NAME', defaultName + idFree + ': ' + labelMode); }
				var defaultCaption = (hotspotList) ? Z.Utils.getResource('CONTENT_HOTSPOTCAPTION'): Z.Utils.getResource('CONTENT_LABELCAPTION');
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('CAPTION')) && Z.editMode != 'freehand' && !Z.tourPath && !Z.Utils.stringValidate(xmlNode.getAttribute('MEDIA')) && !(Z.Utils.stringValidate(xmlNode.getAttribute('MEDIA') && xmlNode.getAttribute('MEDIA') == 'polygon'))) { xmlNode.setAttribute('CAPTION', defaultCaption + idFree); }

				// Apply custom unescape here for hotspots. Labels handled in function loadAnnotationLabelNode due to more detailed processing on load.
				xmlNode.setAttribute('NAME', Z.Utils.xmlUnescapeMinimal(unescape(xmlNode.getAttribute('NAME'))));
				xmlNode.setAttribute('CAPTION', Z.Utils.xmlUnescapeMinimal(unescape(xmlNode.getAttribute('CAPTION'))));

				if (!Z.Utils.stringValidate(xmlNode.getAttribute('X'))) { xmlNode.setAttribute('X', Z.imageX.toString()); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('Y'))) { xmlNode.setAttribute('Y', Z.imageY.toString()); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ZOOM'))) { xmlNode.setAttribute('ZOOM', (Z.imageZ * 100).toString()); }
				//if (!Z.Utils.stringValidate(xmlNode.getAttribute('RADIUS'))) { xmlNode.setAttribute('RADIUS', ''); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ZMIN'))) { xmlNode.setAttribute('ZMIN', '0'); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ZMAX'))) { xmlNode.setAttribute('ZMAX', '0'); }
				// Ensure backward compatibility with prior node name, changed to avoid mistaking attribute with MEDIA attribute (a URL depending on label MEDIATYPE).
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('CLICKURL')) && Z.Utils.stringValidate(xmlNode.getAttribute('URL'))) { xmlNode.setAttribute('CLICKURL', xmlNode.getAttribute('URL')); }
				if (isNaN(parseInt(xmlNode.getAttribute('INTERNALID'), 10))) { xmlNode.setAttribute('INTERNALID', idFree); }
				var mediaType = xmlNode.getAttribute('MEDIATYPE');
				if (!(!Z.Utils.stringValidate(xmlNode.getAttribute('TEXTCOLOR')) || !Z.Utils.stringValidate(xmlNode.getAttribute('BACKCOLOR')))) {
					Z.captionsColorsDefault = false;
				}
				if ((Z.captionBoxes || mediaType == 'measure') && Z.captionsColorsDefault) {
					xmlNode.setAttribute('TEXTCOLOR', Z.Utils.getResource('CONTENT_CAPTIONTEXTCOLOR'));
					xmlNode.setAttribute('BACKCOLOR', Z.Utils.getResource('CONTENT_CAPTIONBACKCOLOR'));
				}
				break;
			case 'poi' :
				idFree = getFreeID('poi');
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ID'))) { xmlNode.setAttribute('ID', idFree); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('NAME'))) { xmlNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_POINAME') + idFree); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('X'))) { xmlNode.setAttribute('X', Z.imageX.toString()); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('Y'))) { xmlNode.setAttribute('Y', Z.imageY.toString()); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ZOOM'))) { xmlNode.setAttribute('ZOOM', (Z.imageZ * 100).toString()); }
				if (isNaN(parseInt(xmlNode.getAttribute('INTERNALID'), 10))) { xmlNode.setAttribute('INTERNALID', idFree); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('EDITABLE'))) { xmlNode.setAttribute('EDITABLE', '1'); }
				break;
			case 'label' :
				idFree = getFreeID('label');
				labelMode = (Z.Utils.stringValidate(Z.labelMode)) ? Z.labelMode : '';
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ID'))) { xmlNode.setAttribute('ID', idFree); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('NAME'))) { xmlNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_LABELNAME') + idFree + ': ' + labelMode); }
				var mediaType = xmlNode.getAttribute('MEDIATYPE');
				var media = xmlNode.getAttribute('MEDIA');
				if (!Z.Utils.stringValidate(media) && mediaType != 'text') {
					xmlNode.setAttribute('MEDIA', annotationFolder + '/' + Z.Utils.getResource('DEFAULT_ANNOTATIONMEDIA'));
					xmlNode.setAttribute('MEDIATYPE', Z.Utils.getResource('DEFAULT_ANNOTATIONMEDIATYPE'));
				}
				if (!(!Z.Utils.stringValidate(xmlNode.getAttribute('TEXTCOLOR')) || !Z.Utils.stringValidate(xmlNode.getAttribute('BACKCOLOR')))) {
					Z.captionsColorsDefault = false;
				}
				if ((Z.captionBoxes || mediaType == 'measure') && Z.captionsColorsDefault) {
					xmlNode.setAttribute('TEXTCOLOR', Z.Utils.getResource('CONTENT_CAPTIONTEXTCOLOR'));
					xmlNode.setAttribute('BACKCOLOR', Z.Utils.getResource('CONTENT_CAPTIONBACKCOLOR'));
				}
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('CAPTION'))) { xmlNode.setAttribute('CAPTION', Z.Utils.getResource('CONTENT_LABELCAPTION') + idFree); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('COMMENT'))) { xmlNode.setAttribute('COMMENT', Z.Utils.getResource('CONTENT_LABELCOMMENT')); }
				// Ensure backward compatibility with prior node name, changed to avoid mistaking attribute with MEDIA attribute (a URL depending on label MEDIATYPE).
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('CLICKURL')) && Z.Utils.stringValidate(xmlNode.getAttribute('URL'))) { xmlNode.setAttribute('CLICKURL', xmlNode.getAttribute('URL')); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('X'))) { xmlNode.setAttribute('X', Z.imageX.toString()); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('Y'))) { xmlNode.setAttribute('Y', Z.imageY.toString()); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ZOOM'))) { xmlNode.setAttribute('ZOOM', (Z.imageZ * 100).toString()); }
				//if (!Z.Utils.stringValidate(xmlNode.getAttribute('RADIUS'))) { xmlNode.setAttribute('RADIUS', ''); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ZMIN'))) { xmlNode.setAttribute('ZMIN', '0'); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ZMAX'))) { xmlNode.setAttribute('ZMAX', '0'); }
				if (isNaN(parseInt(xmlNode.getAttribute('INTERNALID'), 10))) { xmlNode.setAttribute('INTERNALID', idFree); }
				if (isNaN(parseInt(xmlNode.getAttribute('POIID'), 10))) { xmlNode.setAttribute('POIID', poiList.options[poiList.selectedIndex].value); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('EDITABLE'))) { xmlNode.setAttribute('EDITABLE', '1'); }
				break;
			case 'note' :
				idFree = getFreeID('note');
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('ID'))) { xmlNode.setAttribute('ID', idFree); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('NAME'))) { xmlNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_NOTENAME') + idFree); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('TEXT'))) { xmlNode.setAttribute('TEXT', ''); }
				if (isNaN(parseInt(xmlNode.getAttribute('INTERNALID'), 10))) { xmlNode.setAttribute('INTERNALID', idFree); }
				if (isNaN(parseInt(xmlNode.getAttribute('POIID'), 10))) { xmlNode.setAttribute('POIID', poiList.options[poiList.selectedIndex].value); }
				if (!Z.Utils.stringValidate(xmlNode.getAttribute('EDITABLE'))) { xmlNode.setAttribute('EDITABLE', '1'); }
				break;
		}
		return xmlNode;
	}

	// Pass id value in first parameter as string. Use last parameter to specify whether
	// value is user id string value or internal Zoomify unique numeric value.
	this.modifyLabel = function (idValue, property, newVal, wait, useInternalID) {
		self.modifyHotspot(idValue.toString(), property, newVal, wait, useInternalID);
	}

	function sortAnnotationAssocArrayByField (objA, objB) {
		var result = 0;
		var stringA = '', stringB = '';
		if (Z.annotationSort != 'none') {
			switch (Z.annotationSort) {
				case 'id':
					stringA = objA.value.toLowerCase();
					stringB = objB.value.toLowerCase();
					break;
				case 'name':
					stringA = objA.text.toLowerCase();
					stringB = objB.text.toLowerCase();
					break;
			}
			if (stringA < stringB) {
				result = -1;
			} else if (stringA > stringB) {
				result = 1;
			}
		}

		// Debug option:
		//console.log(objA);
		//console.log(objB);

		return result;
	}

	this.createAnnotationPanel = function (vpID) {
		var vpIDStr = vpID.toString()

		if (!Z.ToolbarDisplay || !Z.Toolbar.getInitialized()) {
			var createAnnotationPanelTimer = window.setTimeout( function () { self.createAnnotationPanel(vpID); }, 100);
		} else {
			var tlbrSknArr = Z.Toolbar.getSkinArray();
			var toolbarSkinSizes = Z.Toolbar.getSkinSizes();

			// Create panel to contain lists and notes text box.
			Z['AnnotationPanelDisplay' + vpIDStr] = Z.Utils.createContainerElement('div', 'AnnotationPanelDisplay' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '1px', '1px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', 'default');
			annotationPanelDisplay = Z['AnnotationPanelDisplay' + vpIDStr];
			annD = annotationPanelDisplay;
			annS = annD.style;
			Z.ViewerDisplay.appendChild(annotationPanelDisplay);

			// Ensure proper z-ordering of Viewer elements.
			annS.zIndex = (Z.baseZIndex + 14).toString();

			// Create background.
			var annotationPanelBackground = Z.Utils.createContainerElement('div', 'annotationPanelBackground' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			annotationPanelDisplay.appendChild(annotationPanelBackground);

			// Create placeholder content for lists.
			var listFontSize = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELLISTFONTSIZE'), 10);
			var placeHolderListText = Z.Utils.getResource('CONTENT_ANNOTATIONPLACEHOLDERLISTTEXT');
			var placeholderDP = [ { text:placeHolderListText, value:'0' } ];

			if (typeof poiList === 'undefined' || poiList === null) {
				var labelPOITextBox = Z.Utils.createContainerElement('div', 'labelPOITextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelPOITextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELPOI'));
				labelPOITextBox.appendChild(labelPOITextNode);
				poiList = new Z.Utils.createSelectElement('poiList' + vpIDStr, '', placeholderDP, 1, 1, 0, listFontSize, 'hidden', poiListChangeHandler, 'change');
				annotationPanelDisplay.appendChild(labelPOITextBox);
				annotationPanelDisplay.appendChild(poiList);
				if (Z.editMode != 'markup') {
					var buttonPOIGo = new Z.Utils.Button('buttonPOIGo' + vpIDStr, null, Z.skinPath, tlbrSknArr[30], tlbrSknArr[31], tlbrSknArr[32], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_POIGO');
					annotationPanelDisplay.appendChild(buttonPOIGo.elmt);
				}
			} else {
				 Z.Utils.arrayClear(poiListDP);
			}

			if (typeof labelList === 'undefined' || labelList === null) {
				if (Z.editMode != 'markup') {
					var labelLabelTextBox = Z.Utils.createContainerElement('div', 'labelLabelTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
					var labelLabelTextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELLABEL'));
					labelLabelTextBox.appendChild(labelLabelTextNode);
					annotationPanelDisplay.appendChild(labelLabelTextBox);

				}
				labelList = new Z.Utils.createSelectElement('labelList' + vpIDStr, '', placeholderDP, 1, 1, 0, listFontSize, 'hidden', labelListChangeHandler, 'change');
				annotationPanelDisplay.appendChild(labelList);
				var buttonLabelGo = new Z.Utils.Button('buttonLabelGo' + vpIDStr, null, Z.skinPath, tlbrSknArr[30], tlbrSknArr[31], tlbrSknArr[32], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELGO');
				annotationPanelDisplay.appendChild(buttonLabelGo.elmt);

				if (commentVisibility) {
					var comReadOnly = (Z.editMode != 'markup');
					var placeHolderCommentText = Z.Utils.getResource('CONTENT_ANNOTATIONPLACEHOLDERCOMMENTTEXT');
					var commentTextElement = Z.Utils.createTextElement('commentTextElement' + vpIDStr, placeHolderCommentText, '1px', '1px', '1px', '1px', '0px', 'solid', '1px', comReadOnly, 'verdana', '1px',  'none', null, 1, 'auto', 'auto', null);
					Z.Utils.addEventListener(commentTextElement.firstChild, 'focus', annotationEditFocusHandler);
					Z.Utils.addEventListener(commentTextElement.firstChild, 'blur', annotationEditBlurHandler);
					annotationPanelDisplay.appendChild(commentTextElement);
				}

			} else {
				Z.Utils.arrayClear(labelListDP);
				Z.Utils.arrayClear(labelListCurrentDP);
			}

			if (typeof noteList === 'undefined' || noteList === null) {
				var labelNoteTextBox = Z.Utils.createContainerElement('div', 'labelNoteTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelNoteTextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELNOTE'));
				labelNoteTextBox.appendChild(labelNoteTextNode);
				noteList = new Z.Utils.createSelectElement('noteList' + vpIDStr, '', placeholderDP, 1, 1, 0, listFontSize, 'hidden', noteListChangeHandler, 'change');
				var placeHolderNoteText = Z.Utils.getResource('CONTENT_ANNOTATIONPLACEHOLDERNOTETEXT');
				var noteTextElement = Z.Utils.createTextElement('noteTextElement' + vpIDStr, placeHolderNoteText, '1px', '1px', '1px', '1px', '0px', 'solid', '1px', true, 'verdana', '1px',  'none', null, 1, 'auto', 'auto', null);
				Z.Utils.addEventListener(noteTextElement.firstChild, 'focus', annotationEditFocusHandler);
				Z.Utils.addEventListener(noteTextElement.firstChild, 'blur', annotationEditBlurHandler);
				annotationPanelDisplay.appendChild(labelNoteTextBox);
				annotationPanelDisplay.appendChild(noteList);
				annotationPanelDisplay.appendChild(noteTextElement);
				var nTB = document.getElementById('textBoxFor-noteTextElement' + vpIDStr);
				if (nTB) { nTB.style.visibility = 'hidden'; }
			} else {
				Z.Utils.arrayClear(noteListDP);
				Z.Utils.arrayClear(noteListCurrentDP);
			}

			// Add buttons to annotation panel using toolbar state management functions.
			if (Z.editMode === null) {
				drawLayoutAnnotationPanel(toolbarSkinSizes, vpID);
				if (self.getStatus('XMLParsedViewport')) { populateAnnotationPanel(); }
			} else {
				createAnnotationPanelEditingFeatures(vpID);
			}

			// DEV NOTE: This prevents drag selection from panel over hotspots, but not if cursor is in list or text
			// region in panel. Preventing default on container not helpful, because disables list and text editing.
			Z.Utils.addEventListener(annotationPanelBackground, 'mousedown', Z.Utils.preventDefault);
		}
	}

	function createAnnotationPanelEditingFeatures (vpID) {
		var vpIDStr = vpID.toString()

		// Get skin content and data from Toolbar.
		var tlbrSknArr = Z.Toolbar.getSkinArray();
		var toolbarSkinSizes = Z.Toolbar.getSkinSizes();
		var listFontSize = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELLISTFONTSIZE'), 10);

		if (Z.editMode != 'markup') {
			var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDSMALLDALPHA') / 1.5);
			var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
			var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');
		}

		if (Z.editMode != 'markup') {
			// Create POI editing buttons in container to handle background mouseover events instead of button mouseout events.
			var buttonContainerPOI = Z.Utils.createContainerElement('div', 'buttonContainerPOI' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'default', true);
			annotationPanelDisplay.appendChild(buttonContainerPOI);
			Z.Utils.addEventListener(buttonContainerPOI, 'mouseover', Z.Toolbar.backgroundEventsHandler);
			var poiNameTextElement = Z.Utils.createTextElement('poiNameTextElement' + vpIDStr, '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.Utils.addEventListener(poiNameTextElement.firstChild, 'focus', annotationEditFocusHandler);
			Z.Utils.addEventListener(poiNameTextElement.firstChild, 'blur', annotationEditBlurHandler);
			annotationPanelDisplay.appendChild(poiNameTextElement);
			var tbP = document.getElementById('textBoxFor-poiNameTextElement' + vpIDStr);
			if (tbP) { tbP.style.visibility = 'hidden'; }

			var buttonPOIAdd = new Z.Utils.Button('buttonPOIAdd' + vpIDStr, null, Z.skinPath, tlbrSknArr[153], tlbrSknArr[154], tlbrSknArr[155], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_POIADD');
			buttonContainerPOI.appendChild(buttonPOIAdd.elmt);
			var buttonPOIEdit = new Z.Utils.Button('buttonPOIEdit' + vpIDStr, null, Z.skinPath, tlbrSknArr[156], tlbrSknArr[157], tlbrSknArr[158], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_POIEDIT');
			buttonContainerPOI.appendChild(buttonPOIEdit.elmt);
			var buttonPOIDelete = new Z.Utils.Button('buttonPOIDelete' + vpIDStr, null, Z.skinPath, tlbrSknArr[147], tlbrSknArr[148], tlbrSknArr[149], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_POIDELETE');
			buttonContainerPOI.appendChild(buttonPOIDelete.elmt);
			var buttonPOICancel = new Z.Utils.Button('buttonPOICancel' + vpIDStr, null, Z.skinPath, tlbrSknArr[159], tlbrSknArr[160], tlbrSknArr[161], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_POICANCEL');
			buttonContainerPOI.appendChild(buttonPOICancel.elmt);
			if (Z.saveHandlerProvided) {
				var buttonPOISave = new Z.Utils.Button('buttonPOISave' + vpIDStr, null, Z.skinPath, tlbrSknArr[150], tlbrSknArr[151], tlbrSknArr[152], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_POISAVE');
				buttonContainerPOI.appendChild(buttonPOISave.elmt);
			}

			// Create overlay to to disable POI editing.
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'blue' : backColor;
			var overlayPOIDisable = Z.Utils.createContainerElement('div', 'overlayPOIDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			Z.Utils.setOpacity(overlayPOIDisable, backAlpha, backColorNoAlpha);
			annotationPanelDisplay.appendChild(overlayPOIDisable);
		}

		if (Z.editMode !== null) {
			var labelNameTextElement = Z.Utils.createTextElement('labelNameTextElement' + vpIDStr, '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.Utils.addEventListener(labelNameTextElement.firstChild, 'focus', annotationEditFocusHandler);
			Z.Utils.addEventListener(labelNameTextElement.firstChild, 'blur', annotationEditBlurHandler);
			annotationPanelDisplay.appendChild(labelNameTextElement);
			if (Z.editMode != 'markup') {
				var tbL = document.getElementById('textBoxFor-labelNameTextElement' + vpIDStr);
				if (tbL) { tbL.style.visibility = 'hidden'; }
			}
		}

		if (Z.editMode != 'markup') {
			var buttonBorderLabel = Z.Utils.createContainerElement('div', 'buttonBorderLabel' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', 'default', true);
			annotationPanelDisplay.appendChild(buttonBorderLabel);
		}

		// Create Label editing buttons in container to handle background mouseover events instead of button mouseout events.
		var buttonContainerLabelModes = Z.Utils.createContainerElement('div', 'buttonContainerLabelModes' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'default', true);
		annotationPanelDisplay.appendChild(buttonContainerLabelModes);
		var buttonContainerLabelEdit = Z.Utils.createContainerElement('div', 'buttonContainerLabelEdit' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'default', true);
		annotationPanelDisplay.appendChild(buttonContainerLabelEdit);
		Z.Utils.addEventListener(buttonContainerLabelModes, 'mouseover', Z.Toolbar.backgroundEventsHandler);
		Z.Utils.addEventListener(buttonContainerLabelEdit, 'mouseover', Z.Toolbar.backgroundEventsHandler);

		var buttonBorderLg = Z.Utils.createContainerElement('div', 'buttonBorderLg' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '1px', '1px', 'solid', '2px', 'transparent none', '0px', '0px', 'normal', null, true);
		buttonBorderLg.style.borderColor = Z.Utils.getResource('DEFAULT_BUTTONBORDERCOLOR');
		buttonContainerLabelModes.appendChild(buttonBorderLg);
		bblG = buttonBorderLg;
		bblgS = bblG.style;

		var buttonViewMode = new Z.Utils.Button('buttonViewMode' + vpIDStr, null, Z.skinPath, tlbrSknArr[101], tlbrSknArr[102], tlbrSknArr[103], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_VIEWMODE');
		buttonContainerLabelModes.appendChild(buttonViewMode.elmt);
		if (Z.editMode != 'markup') {
			var buttonEditColorPicker = new Z.Utils.Button('buttonEditColorPicker' + vpIDStr, null, Z.skinPath, tlbrSknArr[104], tlbrSknArr[105], tlbrSknArr[106], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_EDITMODECOLORPICKER');
			buttonContainerLabelModes.appendChild(buttonEditColorPicker.elmt);
		}
		var editModeDivider = new Z.Utils.Graphic('editModeDivider' + vpIDStr, Z.skinPath, tlbrSknArr[107], '1px', '1px', '1px', '1px');
		buttonContainerLabelModes.appendChild(editModeDivider.elmt);

		if (Z.freehandVisible) {
			var buttonEditModeFreehand = new Z.Utils.Button('buttonEditModeFreehand' + vpIDStr, null, Z.skinPath, tlbrSknArr[108], tlbrSknArr[109], tlbrSknArr[110], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_EDITMODEFREEHAND');
			buttonContainerLabelModes.appendChild(buttonEditModeFreehand.elmt);
		}
		if (Z.textVisible) {
			var buttonEditModeText = new Z.Utils.Button('buttonEditModeText' + vpIDStr, null, Z.skinPath, tlbrSknArr[111], tlbrSknArr[112], tlbrSknArr[113], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_EDITMODETEXT');
			buttonContainerLabelModes.appendChild(buttonEditModeText.elmt);
		}
		if (Z.iconVisible) {
			var buttonEditModeIcon = new Z.Utils.Button('buttonEditModeIcon' + vpIDStr, null, Z.skinPath, tlbrSknArr[114], tlbrSknArr[115], tlbrSknArr[116], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_EDITMODEICON');
			buttonContainerLabelModes.appendChild(buttonEditModeIcon.elmt);
		}
		if (Z.rectangleVisible) {
			var buttonEditModeRectangle = new Z.Utils.Button('buttonEditModeRectangle' + vpIDStr, null, Z.skinPath, tlbrSknArr[117], tlbrSknArr[118], tlbrSknArr[119], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_EDITMODERECTANGLE');
			buttonContainerLabelModes.appendChild(buttonEditModeRectangle.elmt);
		}
		if (Z.polygonVisible) {
			var buttonEditModePolygon = new Z.Utils.Button('buttonEditModePolygon' + vpIDStr, null, Z.skinPath, tlbrSknArr[120], tlbrSknArr[121], tlbrSknArr[122], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_EDITMODEPOLYGON');
			buttonContainerLabelModes.appendChild(buttonEditModePolygon.elmt);
		}
		if (Z.measureVisible) {
			var buttonEditModeMeasure = new Z.Utils.Button('buttonEditModeMeasure' + vpIDStr, null, Z.skinPath, tlbrSknArr[46], tlbrSknArr[47], tlbrSknArr[48], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_EDITMODEMEASURE');
			buttonContainerLabelModes.appendChild(buttonEditModeMeasure.elmt);
		}

		var labelCaptionTextBox = Z.Utils.createContainerElement('div', 'labelCaptionTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
		var labelCaptionTextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELCAPTION'));
		labelCaptionTextBox.appendChild(labelCaptionTextNode);
		var placeHolderCaptionText = Z.Utils.getResource('CONTENT_LABELCAPTION');
		captionTextElement = Z.Utils.createTextElement('captionTextElement' + vpIDStr, placeHolderCaptionText, '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
		Z.Utils.addEventListener(captionTextElement.firstChild, 'focus', annotationEditFocusHandler);
		Z.Utils.addEventListener(captionTextElement.firstChild, 'blur', annotationEditBlurHandler);
		annotationPanelDisplay.appendChild(labelCaptionTextBox);
		annotationPanelDisplay.appendChild(captionTextElement);

		if (Z.editMode != 'markup') {
			var labelTooltipTextBox = Z.Utils.createContainerElement('div', 'labelTooltipTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelTooltipTextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELTOOLTIP'));
			labelTooltipTextBox.appendChild(labelTooltipTextNode);
			var placeHolderTooltipText = Z.Utils.getResource('CONTENT_LABELTOOLTIP');
			var tooltipTextElement = Z.Utils.createTextElement('tooltipTextElement' + vpIDStr, placeHolderTooltipText, '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.Utils.addEventListener(tooltipTextElement.firstChild, 'focus', annotationEditFocusHandler);
			Z.Utils.addEventListener(tooltipTextElement.firstChild, 'blur', annotationEditBlurHandler);
			annotationPanelDisplay.appendChild(labelTooltipTextBox);
			annotationPanelDisplay.appendChild(tooltipTextElement);

			var labelClickURLTextBox = Z.Utils.createContainerElement('div', 'labelClickURLTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelClickURLTextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELURL'));
			labelClickURLTextBox.appendChild(labelClickURLTextNode);
			var placeHolderClickURLText = Z.Utils.getResource('CONTENT_LABELCLICKURL');
			var clickURLTextElement = Z.Utils.createTextElement('clickURLTextElement' + vpIDStr, placeHolderClickURLText, '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.Utils.addEventListener(clickURLTextElement.firstChild, 'focus', annotationEditFocusHandler);
			Z.Utils.addEventListener(clickURLTextElement.firstChild, 'blur', annotationEditBlurHandler);
			annotationPanelDisplay.appendChild(labelClickURLTextBox);
			annotationPanelDisplay.appendChild(clickURLTextElement);

			var annotationLabelCaptionPositionListTextArray = Z.Utils.getResource('UI_ANNOTATIONLABELCAPTIONPOSITIONCHOICELISTTEXT').split(',');
			var annotationLabelCaptionPositionListValuesArray = Z.Utils.getResource('UI_ANNOTATIONLABELCAPTIONPOSITIONCHOICELISTVALUES').split(',');
			for (var i = 0, j = annotationLabelCaptionPositionListTextArray.length; i < j; i++) {
				labelCaptionPositionListDP[labelCaptionPositionListDP.length] = { text:annotationLabelCaptionPositionListTextArray[i], value:annotationLabelCaptionPositionListValuesArray[i] };
			}
			var labelCaptionPositionList = new Z.Utils.createSelectElement('labelCaptionPositionList' + vpIDStr, '', labelCaptionPositionListDP, 1, 1, 0, listFontSize, 'hidden', labelCaptionPositionListChangeHandler, 'change');
			annotationPanelDisplay.appendChild(labelCaptionPositionList);

			var annotationLabelTargetListTextArray = Z.Utils.getResource('UI_ANNOTATIONLABELTARGETCHOICELISTTEXT').split(',');
			var annotationLabelTargetListValuesArray = Z.Utils.getResource('UI_ANNOTATIONLABELTARGETCHOICELISTVALUES').split(',');
			for (var i = 0, j = annotationLabelTargetListTextArray.length; i < j; i++) {
				labelTargetListDP[labelTargetListDP.length] = { text:annotationLabelTargetListTextArray[i], value:annotationLabelTargetListValuesArray[i] };
			}
			var labelTargetList = new Z.Utils.createSelectElement('labelTargetList' + vpIDStr, '', labelTargetListDP, 1, 1, 0, listFontSize, 'hidden', labelTargetListChangeHandler, 'change');
			annotationPanelDisplay.appendChild(labelTargetList);

			var labelScaleTextBox = Z.Utils.createContainerElement('div', 'labelScaleTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelScaleTextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELSCALE'));
			labelScaleTextBox.appendChild(labelScaleTextNode);
			annotationPanelDisplay.appendChild(labelScaleTextBox);

			var buttonLabelScaleDown = new Z.Utils.Button('buttonLabelScaleDown' + vpIDStr, null, Z.skinPath, tlbrSknArr[27], tlbrSknArr[28], tlbrSknArr[29], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELSCALEDOWN');
			annotationPanelDisplay.appendChild(buttonLabelScaleDown.elmt);
			var buttonLabelScaleUp = new Z.Utils.Button('buttonLabelScaleUp' + vpIDStr, null, Z.skinPath, tlbrSknArr[24], tlbrSknArr[25], tlbrSknArr[26], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELSCALEUP');
			annotationPanelDisplay.appendChild(buttonLabelScaleUp.elmt);

			var labelRolloverTextBox = Z.Utils.createContainerElement('div', 'labelRolloverTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelRolloverTextNode = document.createTextNode(Z.Utils.getResource('UI_ANNOTATIONPANELLABELROLLOVER'));
			labelRolloverTextBox.appendChild(labelRolloverTextNode);
			var checkboxRollover = new Z.Utils.Checkbox('checkboxRollover' + vpIDStr, 'test', '1px', '1px', '1px', '1px', 'click', rolloverCheckboxClickHandler, 'TIP_ROLLOVER');
			annotationPanelDisplay.appendChild(labelRolloverTextBox);
			annotationPanelDisplay.appendChild(checkboxRollover);
		}

		var buttonContainerLabelColors = Z.Utils.createContainerElement('div', 'buttonContainerLabelColors' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'default', true);
		buttonContainerLabelModes.appendChild(buttonContainerLabelColors);

		if (Z.editMode != 'markup') {
			var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
			var buttonContainerLabelColorsBackground = Z.Utils.createContainerElement('div', 'buttonContainerLabelColorsBackground' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'solid', '1px', backColor, '0px', '0px', 'normal', null, true);
			buttonContainerLabelColors.appendChild(buttonContainerLabelColorsBackground);
			buttonContainerLabelColors.style.display = 'none';
		}

		var buttonBorderSm = Z.Utils.createContainerElement('div', 'buttonBorderSm' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '1px', '1px', 'solid', '2px', 'transparent none', '0px', '0px', 'normal', null, true);
		buttonBorderSm.style.borderColor = Z.Utils.getResource('DEFAULT_BUTTONBORDERCOLOR');
		buttonContainerLabelColors.appendChild(buttonBorderSm);
		bbsM = buttonBorderSm;
		bbsmS = bbsM.style;

		var buttonColor0 = new Z.Utils.Button('buttonColor0' + vpIDStr, null, Z.skinPath, tlbrSknArr[123], tlbrSknArr[124], tlbrSknArr[125], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR0');
		buttonContainerLabelColors.appendChild(buttonColor0.elmt);
		var buttonColor1 = new Z.Utils.Button('buttonColor1' + vpIDStr, null, Z.skinPath, tlbrSknArr[126], tlbrSknArr[127], tlbrSknArr[128], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR1');
		buttonContainerLabelColors.appendChild(buttonColor1.elmt);
		var buttonColor2 = new Z.Utils.Button('buttonColor2' + vpIDStr, null, Z.skinPath, tlbrSknArr[129], tlbrSknArr[130], tlbrSknArr[131], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR2');
		buttonContainerLabelColors.appendChild(buttonColor2.elmt);
		var buttonColor3 = new Z.Utils.Button('buttonColor3' + vpIDStr, null, Z.skinPath, tlbrSknArr[132], tlbrSknArr[133], tlbrSknArr[134], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR3');
		buttonContainerLabelColors.appendChild(buttonColor3.elmt);
		var buttonColor4 = new Z.Utils.Button('buttonColor4' + vpIDStr, null, Z.skinPath, tlbrSknArr[135], tlbrSknArr[136], tlbrSknArr[137], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR4');
		buttonContainerLabelColors.appendChild(buttonColor4.elmt);
		var buttonColor5 = new Z.Utils.Button('buttonColor5' + vpIDStr, null, Z.skinPath, tlbrSknArr[138], tlbrSknArr[139], tlbrSknArr[140], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR5');
		buttonContainerLabelColors.appendChild(buttonColor5.elmt);
		var buttonColor6 = new Z.Utils.Button('buttonColor6' + vpIDStr, null, Z.skinPath, tlbrSknArr[141], tlbrSknArr[142], tlbrSknArr[143], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR6');
		buttonContainerLabelColors.appendChild(buttonColor6.elmt);
		var buttonColor7 = new Z.Utils.Button('buttonColor7' + vpIDStr, null, Z.skinPath, tlbrSknArr[144], tlbrSknArr[145], tlbrSknArr[146], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COLOR7');
		buttonContainerLabelColors.appendChild(buttonColor7.elmt);

		if (Z.editMode == 'edit') {
			var buttonLabelAdd = new Z.Utils.Button('buttonLabelAdd' + vpIDStr, null, Z.skinPath, tlbrSknArr[153], tlbrSknArr[154], tlbrSknArr[155], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELADD');
			buttonContainerLabelEdit.appendChild(buttonLabelAdd.elmt);
			var buttonLabelEdit = new Z.Utils.Button('buttonLabelEdit' + vpIDStr, null, Z.skinPath, tlbrSknArr[156], tlbrSknArr[157], tlbrSknArr[158], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELEDIT');
			buttonContainerLabelEdit.appendChild(buttonLabelEdit.elmt);
			var buttonLabelCancel = new Z.Utils.Button('buttonLabelCancel' + vpIDStr, null, Z.skinPath, tlbrSknArr[159], tlbrSknArr[160], tlbrSknArr[161], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELCANCEL');
			buttonContainerLabelEdit.appendChild(buttonLabelCancel.elmt);
		}

		var buttonLabelDelete = new Z.Utils.Button('buttonLabelDelete' + vpIDStr, null, Z.skinPath, tlbrSknArr[147], tlbrSknArr[148], tlbrSknArr[149], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELDELETE');
		buttonContainerLabelEdit.appendChild(buttonLabelDelete.elmt);
		if (Z.saveHandlerProvided && Z.saveButtonVisible) {
			var buttonLabelSave = new Z.Utils.Button('buttonLabelSave' + vpIDStr, null, Z.skinPath, tlbrSknArr[150], tlbrSknArr[151], tlbrSknArr[152], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_LABELSAVE');
			buttonContainerLabelEdit.appendChild(buttonLabelSave.elmt);
		}

		// Dev Note: append icon list container to annotation display not button container, to avoid disabling list when preventing drag with prevent default.
		var buttonContainerLabelIcons = Z.Utils.createContainerElement('div', 'buttonContainerLabelIcons' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'default', false);
		annotationPanelDisplay.appendChild(buttonContainerLabelIcons);
		var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
		var buttonContainerLabelIconsBackground = Z.Utils.createContainerElement('div', 'buttonContainerLabelIconsBackground' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'solid', '1px', backColor, '0px', '0px', 'normal', null, true);
		buttonContainerLabelIcons.appendChild(buttonContainerLabelIconsBackground);
		buttonContainerLabelIcons.style.display = 'none';
		var annotationLabelIconListTextArray = Z.Utils.getResource('UI_ANNOTATIONLABELICONCHOICELISTTEXT').split(',');
		var annotationLabelIconListValuesArray = Z.Utils.getResource('UI_ANNOTATIONLABELICONCHOICELISTVALUES').split(',');
		for (var i = 0, j = annotationLabelIconListTextArray.length; i < j; i++) {
			labelIconListDP[labelIconListDP.length] = { text:annotationLabelIconListTextArray[i], value:annotationLabelIconListValuesArray[i] };
		}
		var labelIconList = new Z.Utils.createSelectElement('labelIconList' + vpIDStr, '', labelIconListDP, 1, 1, 0, listFontSize, 'visible', labelIconListChangeHandler, 'change');
		buttonContainerLabelIcons.appendChild(labelIconList);

		if (Z.editMode != 'markup') {
			// Create overlay to to disable Label editing.
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'green' : backColor;
			var overlayLabelDisable = Z.Utils.createContainerElement('div', 'overlayLabelDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'red' : backColor;
			var overlayLabelDetailDisable = Z.Utils.createContainerElement('div', 'overlayLabelDetailDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'yellow' : backColor;
			var overlayLabelDetailEditableDisable = Z.Utils.createContainerElement('div', 'overlayLabelDetailEditableDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			var overlayMessageBox = Z.Utils.createTextElement('overlayMessageBox' + vpIDStr, '', '1px', '1px', '4px', '4px', '4px', 'solid', '1px', true, 'verdana', '12px', 'none', null, 1, 'auto', 'auto', null);
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'pink' : backColor;
			var overlayLabelNameEditableDisable = Z.Utils.createContainerElement('div', 'overlayLabelNameEditableDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'brown' : backColor;
			var overlayLabelCaptionPositionDisable = Z.Utils.createContainerElement('div', 'overlayLabelCaptionPositionDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			Z.Utils.setOpacity(overlayLabelDisable, backAlpha, backColorNoAlpha);
			Z.Utils.setOpacity(overlayLabelDetailDisable, backAlpha, backColorNoAlpha);
			Z.Utils.setOpacity(overlayLabelDetailEditableDisable, backAlpha, backColorNoAlpha);
			Z.Utils.setOpacity(overlayLabelNameEditableDisable, backAlpha, backColorNoAlpha);
			Z.Utils.setOpacity(overlayLabelCaptionPositionDisable, backAlpha, backColorNoAlpha);
			annotationPanelDisplay.appendChild(overlayLabelDisable);
			annotationPanelDisplay.appendChild(overlayLabelDetailDisable);
			annotationPanelDisplay.appendChild(overlayLabelDetailEditableDisable);
			annotationPanelDisplay.appendChild(overlayMessageBox);
			annotationPanelDisplay.appendChild(overlayLabelNameEditableDisable);
			annotationPanelDisplay.appendChild(overlayLabelCaptionPositionDisable);

			Z.overlayMessage = document.getElementById('overlayMessageBox' + vpIDStr);
			var tbOMB = document.getElementById('textBoxFor-overlayMessageBox' + vpIDStr);
			if (Z.overlayMessage && tbOMB) {
				Z.overlayMessage.value = Z.Utils.getResource('ALERT_HOWTOCREATEFIRSTLABELSHORT');
				Z.Utils.setHTMLTextStyle(Z.overlayMessage, '#666666', 'verdana', '12px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none');
				tbOMB.style.display = 'none';
			}

			// Ensure proper z-ordering of Viewer elements. Label colors choicelist must be in front of other elements in annotation panel and
			// label icons choicelist must bein front of overlayLabelDetailEditableDisable in annotation panel.
			// but both must be behind label disabling overlay.
			buttonContainerLabelColors.style.zIndex = (Z.baseZIndex + 16).toString();
			buttonContainerLabelModes.style.zIndex = (Z.baseZIndex + 17).toString();
			buttonContainerLabelIcons.style.zIndex = (Z.baseZIndex + 18).toString();
			overlayLabelDetailDisable.style.zIndex = (Z.baseZIndex + 19).toString();
			overlayLabelDisable.style.zIndex = (Z.baseZIndex + 20).toString();
		}

		if (Z.editMode != 'markup') {
			var noteNameTextElement = Z.Utils.createTextElement('noteNameTextElement' + vpIDStr, '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.Utils.addEventListener(noteNameTextElement.firstChild, 'focus', annotationEditFocusHandler);
			Z.Utils.addEventListener(noteNameTextElement.firstChild, 'blur', annotationEditBlurHandler);
			annotationPanelDisplay.appendChild(noteNameTextElement);
			var tbN = document.getElementById('textBoxFor-noteNameTextElement' + vpIDStr);
			if (tbN) { tbN.style.visibility = 'hidden'; }

			// Create Note editing buttons in container to handle background mouseover events instead of button mouseout events.
			var buttonContainerNote = Z.Utils.createContainerElement('div', 'buttonContainerNote' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'default', true);
			annotationPanelDisplay.appendChild(buttonContainerNote);
			Z.Utils.addEventListener(buttonContainerNote, 'mouseover', Z.Toolbar.backgroundEventsHandler);

			var buttonNoteAdd = new Z.Utils.Button('buttonNoteAdd' + vpIDStr, null, Z.skinPath, tlbrSknArr[153], tlbrSknArr[154], tlbrSknArr[155], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_NOTEADD');
			buttonContainerNote.appendChild(buttonNoteAdd.elmt);
			var buttonNoteEdit = new Z.Utils.Button('buttonNoteEdit' + vpIDStr, null, Z.skinPath, tlbrSknArr[156], tlbrSknArr[157], tlbrSknArr[158], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_NOTEEDIT');
			buttonContainerNote.appendChild(buttonNoteEdit.elmt);
			var buttonNoteDelete = new Z.Utils.Button('buttonNoteDelete' + vpIDStr, null, Z.skinPath, tlbrSknArr[147], tlbrSknArr[148], tlbrSknArr[149], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_NOTEDELETE');
			buttonContainerNote.appendChild(buttonNoteDelete.elmt);
			var buttonNoteCancel = new Z.Utils.Button('buttonNoteCancel' + vpIDStr, null, Z.skinPath, tlbrSknArr[159], tlbrSknArr[160], tlbrSknArr[161], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_NOTECANCEL');
			buttonContainerNote.appendChild(buttonNoteCancel.elmt);
			if (Z.saveHandlerProvided) {
				var buttonNoteSave = new Z.Utils.Button('buttonNoteSave' + vpIDStr, null, Z.skinPath, tlbrSknArr[150], tlbrSknArr[151], tlbrSknArr[152], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_NOTESAVE');
				buttonContainerNote.appendChild(buttonNoteSave.elmt);
			}

			// Create overlay to to disable Note editing.
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'pink' : backColor;
			var overlayNoteDetailDisable = Z.Utils.createContainerElement('div', 'overlayNoteDetailDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			Z.Utils.setOpacity(overlayNoteDetailDisable, backAlpha, backColorNoAlpha);
			var backColorOverlay = (overlaysVisibleForDebugging) ? 'purple' : backColor;
			var overlayNoteDisable = Z.Utils.createContainerElement('div', 'overlayNoteDisable' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', backColorOverlay, '0px', '0px', 'normal', 'default', true);
			Z.Utils.setOpacity(overlayNoteDisable, backAlpha, backColorNoAlpha);
			annotationPanelDisplay.appendChild(overlayNoteDetailDisable);
			annotationPanelDisplay.appendChild(overlayNoteDisable);
		}

		if (Z.helpVisible == 1 || Z.helpVisible == 2) {
			if (Z.editMode == 'markup') {
				var buttonHelpMarkup = new Z.Utils.Button('buttonHelpMarkup' + vpIDStr, null, Z.skinPath, tlbrSknArr[43], tlbrSknArr[44], tlbrSknArr[45], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_HELPMARKUP');
				buttonContainerLabelEdit.appendChild(buttonHelpMarkup.elmt);
			} else if (Z.editMode == 'edit') {
				var buttonHelpAnnotation = new Z.Utils.Button('buttonHelpAnnotation' + vpIDStr, null, Z.skinPath, tlbrSknArr[43], tlbrSknArr[44], tlbrSknArr[45], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_HELPANNOTATION');
				buttonContainerNote.appendChild(buttonHelpAnnotation.elmt);
			}
		}

		// Draw layout, add data, and set page to watch for unsaved changes.
		drawLayoutAnnotationPanel(toolbarSkinSizes, vpID);
		populateAnnotationPanel();
		if (Z.unsavedEditsTest) { Z.Viewer.initializePageExitEventHandler(); }
	}

	// Size and position annotation panel elements. Add buttons to annotation panel using toolbar state management functions.
	function drawLayoutAnnotationPanel (tlbrSknSzs, vpID) {
		var vpIDStr = vpID.toString();

		// Size and position panel.
		var panelDims = new self.calculateAnnotationPanelDimensions(poiVisibility, labelVisibility, noteVisibility, commentVisibility);
		var panelCoords = self.calculateAnnotationPanelCoords(annotationPanelPosition, panelDims.w, panelDims.h, viewW, viewH); // viewH allows for toolbar height if static in viewer display area.
		self.sizeAndPositionAnnotationPanel(annS, panelDims.w, panelDims.h, panelCoords.x, panelCoords.y);
		Z.annotationPanelVisibleState = !(Z.annotationPanelVisible == 0 || Z.annotationPanelVisible == 3 || Z.annotationPanelVisible == 4 || annotationPanelPosition == '0' || (Z.zoomRectangle && !Z.annotations) || (Z.measureVisible && Z.editMode === null) || (Z.imageSet && Z.annotationFileShared && vpID == 0));
		annS.display = (Z.annotationPanelVisibleState) ? 'inline-block' : 'none';

		// Debug option: display multiple panels right to left when imageSet viewing.
		//annS.left = parseFloat(annS.left) - (parseFloat(annS.width) * vpID) + 'px';

		// Get dimensions from skins.
		var btnW = tlbrSknSzs[6];
		var btnH = tlbrSknSzs[7];
		var btnSpan = tlbrSknSzs[8];

		// Get dimensions from defaults.
		var labelW = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONLABELWIDTH'), 10);
		var labelTextW = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONLABELTEXTWIDTH'), 10);
		var listW = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONLISTWIDTH'), 10);
		var listNarrowW = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONLISTNARROWWIDTH'), 10);
		var margin = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONMARGIN'), 10);
		var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELLABELFONTSIZE'), 10);
		var listFontSize = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELLISTFONTSIZE'), 10);
		var textFontSize = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELTEXTFONTSIZE'), 10);
		var textPaddingSmall = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONTEXTPADDINGSMALL'), 10);
		var textPadding = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONTEXTPADDING'), 10);
		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
		var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
		var backColorLight = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORLIGHT');
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');
		var commentH = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONCOMMENTHEIGHT'), 10);
		var noteH = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONNOTEHEIGHT'), 10);

		// Comments field optional.
		if (!commentVisibility) { commentH = 0; }

		// DEV NOTE: Adjust for font and adjust font for context.
		// Set other dimensions.
		var labelTextWAdj = 9;
		var labelH = 15;
		var listH = 17;
		var listTextW = listW - 24;
		var rowGap = listH * 0.5;
		var adjSm = 1;
		var adjLg = 4;
		var adjLabel = 3;
		var adjComment = 0.98;
		var adjNote = 0.98;
		var adjHelp = 0;

		// Calculate dependent dimensions.
		var btnRight = panelDims.w - margin - btnW - 5;

		// DEV NOTE: Adjust for select element height and placement variations among browsers.
		var selectElementAdj = (Z.browser == Z.browsers.CHROME || Z.browser == Z.browsers.SAFARI) ? -2 : 0;

		// Declare row variables.
		var rLabelName = 0, rContLabelMode = 0, rBtnsLabelMode = 0, rBtnsColor = 0, rContIcon = 0, rCaption = 0, rComment = 0, rContLabelEdit = 0, rBtnsLabelEdit = 0;
		if (Z.editMode == 'edit') {
			var rPOIName = 0, rContPOIEdit = 0, rBtnsPOIEdit = 0, rContColor = 0, rTooltip = 0, rClickURL = 0, rCaptionPos = 0, rScale = 0, rNoteName = 0, rNoteText = 0, rContNoteEdit = 0, rBtnsNoteEdit = 0;
		}
		var lastSection = 0;

		if (Z.editMode === null) {
			if (poiVisibility) {
				rPOIName = margin + adjLg;
				lastSection = rPOIName + listH;
			}
			if (labelVisibility) {
				rLabelName = lastSection + adjLg + adjSm * 2;
				rComment = rLabelName + listH + adjLg;
				lastSection = (commentVisibility) ? rComment + commentH : rLabelName + listH;
			}
			if (noteVisibility) {
				rNoteName = lastSection + adjLg + adjSm;
				rNoteText = rNoteName + listH + adjLg;
			}

		} else {
			// Get dimensions from skins.
			var dvdrW = tlbrSknSzs[4];
			var dvdrH = tlbrSknSzs[5];

			// DEV NOTE: Workaround for layout issues. On mobile devices large button and divider sizes used and panel must
			// grow too large. Requires addition of minimize button as no mouse-out to hide panel and allow full view of image.
			if (btnW > 15) { btnW = 15; }
			if (btnH > 15) { btnH = 15; }
			if (btnSpan > 22) { btnSpan = 22; }
			if (dvdrW > 1) { dvdrW = 1; }
			if (dvdrH > 18) { dvdrH = 18; }

			// Calculate dependent dimensions.
			// DEV NOTE: Add modification labelH and listH calculations based on font.
			var btnColorW = btnW * 0.75;
			var btnColorH = btnH * 0.75;
			var btnColorSpan = btnColorW * 2;
			var btnContL = margin + 3;
			var btnContH = btnH * 1.5;
			var btnContTallH = btnH * 2 + btnColorH * 1.5;
			var dvdrSpan = btnW / 2;
			var adjDivT = (dvdrH - btnH) / 2;
			var btnGap = btnH * 0.5;
			var marginLabel = margin * 1.75;
			var buttonBorderLabelW = panelDims.w - margin * 2 - 2;
			var buttonBorderLabelH = btnH * 7 + rowGap * 5 + adjLg;
			var bx = 0;
			var iconPickerW = panelDims.w - margin * 3;
			var iconPickerH = labelH + rowGap * 3;
			var btnRight = panelDims.w - margin - btnW - 5;
			var btnRight2 = btnRight - btnSpan;
			var btnRight3 = btnRight2 - btnSpan;

			// Calculate row positions and other dependent values for markup or edit mode.
			if (Z.editMode == 'markup') {
				labelTextWAdj = 0;
				marginLabel = margin + adjLg;
				listW = panelDims.w - margin * 2;
				listTextW = listW - 24;
				btnContL = 0;
				rContLabelMode = adjSm * 2;
				rBtnsLabelMode = btnGap;
				rBtnsColor = rBtnsLabelMode + btnH + rowGap - adjSm;
				rContIcon = rContLabelMode + btnH * 2 - adjSm;
				rIconList = rowGap + adjLg - adjSm;
				rLabelName = rContLabelMode + btnContTallH + rowGap - adjLg - adjSm * 2;
				rCaption = rLabelName + labelH + adjLg * 2;
				rComment = rCaption + labelH + adjLg * 2;
				rContLabelEdit = (commentVisibility) ? rComment + commentH + 5 : rCaption + labelH + 5;
				rBtnsLabelEdit = btnGap - 5;
				if (Z.helpVisible == 1 || Z.helpVisible == 2) { adjHelp = btnSpan; }

			} else if (Z.editMode == 'edit') {

				if (poiVisibility) {
					rPOIName = margin + adjLg;
					rContPOIEdit = rPOIName + listH - adjSm;
					rBtnsPOIEdit = btnGap;
					lastSection = rContPOIEdit + btnContH + adjLg;
				}
				if (labelVisibility) {
					rLabelName = lastSection + margin;
					rContLabelMode = rLabelName + listH + adjLg + adjSm;
					rBtnsLabelMode = btnGap + adjSm;
					rContColor = rBtnsLabelMode + btnH + btnGap;
					rBtnsColor = adjLg + adjSm;
					rContIcon = rContLabelMode + btnH * 2 - adjSm;
					rIconList = rowGap * 1.5;
					rCaption = rContLabelMode + btnContH + rowGap + adjLg;
					rComment = rCaption + btnH + rowGap;
					rTooltip = (commentVisibility) ? rComment + commentH + 5 : rCaption + btnH + rowGap;
					rClickURL = rTooltip + btnH + rowGap;
					rCaptionPos = rClickURL + btnH + rowGap;
					rScale = rCaptionPos + btnH + rowGap;
					rContLabelEdit = rScale + btnH + rowGap + 5;
					rBtnsLabelEdit= btnGap - 5;
					lastSection = rContLabelEdit + btnContH + adjLg - 5;
				}
				if (noteVisibility) {
					rNoteName = lastSection + margin;
					rNoteText = rNoteName + listH + adjLg + adjSm;
					rContNoteEdit = rNoteText + noteH + adjSm * 2;
					rBtnsNoteEdit = btnGap;
				}
				var colorPickerW = btnColorSpan * 8.5 + 1;
				var colorPickerH = btnColorH * 1.8;
			}

			// Debug Option: console.log(rPOIName + ', ' + rContPOIEdit + ', ' + rBtnsPOIEdit + ', ' + rLabelName + ', ' + rContLabelMode + ', ' + rBtnsLabelMode + ', ' + rBtnsColor + ', ' + rContIcon + ', ' + rCaption + ', ' + rContLabelEdit + ', ' + rBtnsLabelEdit + ', ' + rContColor + ', ' + rTooltip + ', ' + rClickURL + ', ' + rCaptionPos + ', ' + rScale + ', ' + rNoteName + ', ' + rNoteText + ', ' + rContNoteEdit + ', ' + rBtnsNoteEdit);
		}

		// Draw background.
		var aPBG = document.getElementById('annotationPanelBackground' + vpIDStr);
		if (aPBG) {
			var apbgS = aPBG.style;
			apbgS.width = panelDims.w + 'px';
			apbgS.height = panelDims.h + 'px';
			apbgS.backgroundColor = backColor;
			Z.Utils.setOpacity(aPBG, backAlpha, backColorNoAlpha);
		}

		if (poiVisibility) {
			var lPOITB = document.getElementById('labelPOITextBox' + vpIDStr);
			if (lPOITB && poiList) {
				var lpoitbS = lPOITB.style;
				lpoitbS.width = (labelW - btnSpan) + 'px';
				lpoitbS.height = labelH + 'px';
				lpoitbS.left = margin + 'px';
				lpoitbS.top = rPOIName + adjLabel + 'px';
				lpoitbS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(lPOITB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var plS = poiList.style;
				plS.width = (listW - btnSpan) + 'px';
				plS.left = labelW + 'px';
				plS.top = (rPOIName + selectElementAdj) + 'px';
				plS.visibility = 'visible';
				var bPG = document.getElementById('buttonPOIGo' + vpIDStr);
				if (bPG) {
					Z.Utils.buttonSize(bPG, btnW, btnH);
					var bpgS = bPG.style;
					bpgS.left = (btnRight + adjLg) + 'px';
					bpgS.top = (rPOIName + adjSm) + 'px';
				}

				if (Z.editMode !== null) {

					var tbPNTE = document.getElementById('textBoxFor-poiNameTextElement' + vpIDStr);
					if (tbPNTE) {
						var tbpnteS = tbPNTE.style;
						tbpnteS.width = listTextW - btnSpan + 'px';
						tbpnteS.height = labelH + 'px';
						tbpnteS.left = labelW + 'px';
						tbpnteS.top = rPOIName + 'px';
						Z.Utils.setTextAreaStyle(tbPNTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none', textPaddingSmall + 'px');
					}

					var bCP = document.getElementById('buttonContainerPOI' + vpIDStr);
					if (bCP) {
						var bcpS = bCP.style;
						bcpS.width = panelDims.w + 'px';
						bcpS.height = btnContH + 'px';
						bcpS.left = '0px';
						bcpS.top = rContPOIEdit + 'px';
					}
					// Position Add, Edit, Delete, Cancel, Save buttons from right to left of panel.
					var bPE = document.getElementById('buttonPOIEdit' + vpIDStr);
					if (bPE) {
						Z.Utils.buttonSize(bPE, btnW, btnH);
						var bpeS = bPE.style;
						bpeS.left = btnRight + 'px';
						bpeS.top = rBtnsPOIEdit + 'px';
					}
					var bPA = document.getElementById('buttonPOIAdd' + vpIDStr);
					if (bPA) {
						Z.Utils.buttonSize(bPA, btnW, btnH);
						var bpaS = bPA.style;
						bpaS.left = btnRight2 + 'px';
						bpaS.top = rBtnsPOIEdit + 'px';
					}
					var bPS = document.getElementById('buttonPOISave' + vpIDStr);
					if (bPS) {
						Z.Utils.buttonSize(bPS, btnW, btnH);
						var bpsS = bPS.style;
						bpsS.left = btnRight + 'px';
						bpsS.top = rBtnsPOIEdit + 'px';
						bpsS.display = 'none';
					}
					var bPC = document.getElementById('buttonPOICancel' + vpIDStr);
					if (bPC) {
						Z.Utils.buttonSize(bPC, btnW, btnH);
						var bpcS = bPC.style;
						bpcS.left = (bPS) ? (btnRight2 + 'px') : (btnRight + 'px');
						bpcS.top = rBtnsPOIEdit + 'px';
						bpcS.display = 'none';
					}
					var bPD = document.getElementById('buttonPOIDelete' + vpIDStr);
					if (bPD) {
						Z.Utils.buttonSize(bPD, btnW, btnH);
						var bpdS = bPD.style;
						bpdS.left = (bPS && bPC) ? (btnRight3 + 'px') : (bPS) ? (btnRight2 + 'px') : (btnRight + 'px');
						bpdS.top = rBtnsPOIEdit + 'px';
						bpdS.display = 'none';
					}
					var oPOID = document.getElementById('overlayPOIDisable' + vpIDStr);
					if (oPOID) {
						var opoidS = oPOID.style;
						opoidS.width = panelDims.w + 'px';
						opoidS.height = (margin + labelH + btnH + rowGap * 2 + adjLg) + 'px';
						opoidS.left = '0px';
						opoidS.top = '0px';
					}
				}
			}
		}

		if (labelVisibility) {
			var lLTB = document.getElementById('labelLabelTextBox' + vpIDStr);
			if (lLTB) {
				var lltbS = lLTB.style;
				lltbS.width = labelW + 'px';
				lltbS.height = labelH + 'px';
				lltbS.left = margin + 'px';
				lltbS.top = rLabelName + adjLabel + 'px';
				lltbS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(lLTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			}
		}

		if (Z.editMode == 'markup' || labelVisibility) {
			if (labelList) {
				var llS = labelList.style;
				llS.width = (listW - btnSpan) + 'px';
				llS.left = (Z.editMode == 'markup') ? margin + 'px' : labelW + 'px';
				llS.top = rLabelName + selectElementAdj + 'px';
				llS.visibility = 'visible';
			}
		}

		var bLG = document.getElementById('buttonLabelGo' + vpIDStr);
		if (bLG) {
			Z.Utils.buttonSize(bLG, btnW, btnH);
			var blgS = bLG.style;
			blgS.left = (btnRight + adjLg) + 'px';
			blgS.top = rLabelName + adjSm + 'px';
		}

		if ((Z.editMode == 'edit' && labelVisibility) || Z.editMode == 'markup') {
			var tbLNTE = document.getElementById('textBoxFor-labelNameTextElement' + vpIDStr);
			if (tbLNTE) {
				var tblnteS = tbLNTE.style;
				tblnteS.width = listTextW - btnSpan + 'px';
				tblnteS.height = labelH + 'px';
				tblnteS.left = (Z.editMode == 'markup') ? margin + 'px' : labelW + 'px';
				tblnteS.top = rLabelName + 'px';
				Z.Utils.setTextAreaStyle(tbLNTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none', textPaddingSmall + 'px');
			}

			var bBL = document.getElementById('buttonBorderLabel' + vpIDStr);
			if (bBL) {
				var bblS = bBL.style;
				bblS.width = buttonBorderLabelW + 'px';
				bblS.height = buttonBorderLabelH + 'px';
				bblS.left = margin + 'px';
				bblS.top = rContLabelMode + 'px';
			}

			var bCL = document.getElementById('buttonContainerLabelModes' + vpIDStr);
			if (bCL) {
				var bclS = bCL.style;
				bclS.width = panelDims.w - 2 + 'px';
				bclS.height = (Z.editMode == 'markup') ? btnContTallH + 'px' : (btnContTallH * 0.7) + 'px';
				bclS.left = 0 + 'px';
				bclS.top = rContLabelMode + 'px';
			}

			var bVM = document.getElementById('buttonViewMode' + vpIDStr);
			if (bVM) {
				bx += marginLabel + adjSm;
				Z.Utils.buttonSize(bVM, btnW, btnH);
				var bvmS = bVM.style;
				bvmS.left = bx + 'px';
				bvmS.top = rBtnsLabelMode + 'px';
			}
			var bECP = document.getElementById('buttonEditColorPicker' + vpIDStr);
			if (bECP) {
				bx += btnSpan;
				Z.Utils.buttonSize(bECP, btnW, btnH);
				var becpS = bECP.style;
				becpS.left = bx + 'px';
				becpS.top = rBtnsLabelMode + 'px';
			}
			var emD = document.getElementById('editModeDivider' + vpIDStr);
			if (emD) {
				bx += btnSpan + adjSm;
				if (Z.editMode == 'markup') { bx += dvdrSpan - adjSm; }
				Z.Utils.graphicSize(emD, dvdrW, dvdrH);
				var emdS = emD.style;
				emdS.left = bx + 'px';
				emdS.top = rBtnsLabelMode - adjDivT + 'px';
			}
			var bEMF = document.getElementById('buttonEditModeFreehand' + vpIDStr);
			if (bEMF) {
				bx += btnSpan - btnW + adjLg;
				if (Z.editMode == 'markup') { bx += dvdrSpan - adjLg; }
				Z.Utils.buttonSize(bEMF, btnW, btnH);
				var bemfS = bEMF.style;
				bemfS.left = bx + 'px';
				bemfS.top = rBtnsLabelMode + 'px';
			}
			var bEMT = document.getElementById('buttonEditModeText' + vpIDStr);
			if (bEMT) {
				bx += btnSpan;
				Z.Utils.buttonSize(bEMT, btnW, btnH);
				var bemtS = bEMT.style;
				bemtS.left = bx + 'px';
				bemtS.top = rBtnsLabelMode + 'px';
			}
			var bEMI = document.getElementById('buttonEditModeIcon' + vpIDStr);
			if (bEMI) {
				bx += btnSpan;
				Z.Utils.buttonSize(bEMI, btnW, btnH);
				var bemiS = bEMI.style;
				bemiS.left = bx + 'px';
				bemiS.top = rBtnsLabelMode + 'px';
			}
			var bEMR = document.getElementById('buttonEditModeRectangle' + vpIDStr);
			if (bEMR) {
				bx += btnSpan;
				Z.Utils.buttonSize(bEMR, btnW, btnH);
				var bemrS = bEMR.style;
				bemrS.left = bx + 'px';
				bemrS.top = rBtnsLabelMode + 'px';
			}
			var bEMP = document.getElementById('buttonEditModePolygon' + vpIDStr);
			if (bEMP) {
				bx += btnSpan;
				Z.Utils.buttonSize(bEMP, btnW, btnH);
				var bempS = bEMP.style;
				bempS.left = bx + 'px';
				bempS.top = rBtnsLabelMode + 'px';
			}
			var bEMM = document.getElementById('buttonEditModeMeasure' + vpIDStr);
			if (bEMM) {
				bx += btnSpan;
				Z.Utils.buttonSize(bEMM, btnW, btnH);
				var bemmS = bEMM.style;
				bemmS.left = bx + 'px';
				bemmS.top = rBtnsLabelMode + 'px';
			}

			if (Z.editMode != 'markup') {
				var bCLCB = document.getElementById('buttonContainerLabelColorsBackground' + vpIDStr);
				if (bCLCB) {
					var bclcbS = bCLCB.style;
					bclcbS.width = colorPickerW  + 'px';
					bclcbS.height = colorPickerH + 'px';
					bclcbS.left = '0px';
					bclcbS.top = '0px';
				}
			}
			var bCLC = document.getElementById('buttonContainerLabelColors' + vpIDStr);
			if (bCLC) {
				var bclcS = bCLC.style;
				bclcS.left = btnContL + 'px';
				bclcS.top = rContColor + 'px';
			}
			var bC0 = document.getElementById('buttonColor0' + vpIDStr);
			if (bC0) {
				bx = margin + adjLg + adjSm;
				Z.Utils.buttonSize(bC0, btnColorW, btnColorH);
				var bc0S = bC0.style;
				bc0S.left = bx + 'px';
				bc0S.top = rBtnsColor + 'px';
			}
			var bC1 = document.getElementById('buttonColor1' + vpIDStr);
			if (bC1) {
				bx += btnColorSpan;
				Z.Utils.buttonSize(bC1, btnColorW, btnColorH);
				var bc1S = bC1.style;
				bc1S.left = bx + 'px';
				bc1S.top = rBtnsColor + 'px';
			}
			var bC2 = document.getElementById('buttonColor2' + vpIDStr);
			if (bC2) {
				bx += btnColorSpan;
				Z.Utils.buttonSize(bC2, btnColorW, btnColorH);
				var bc2S = bC2.style;
				bc2S.left = bx + 'px';
				bc2S.top = rBtnsColor + 'px';
			}
			var bC3 = document.getElementById('buttonColor3' + vpIDStr);
			if (bC3) {
				bx += btnColorSpan;
				Z.Utils.buttonSize(bC3, btnColorW, btnColorH);
				var bc3S = bC3.style;
				bc3S.left = bx + 'px';
				bc3S.top = rBtnsColor + 'px';
			}
			var bC4 = document.getElementById('buttonColor4' + vpIDStr);
			if (bC4) {
				bx += btnColorSpan;
				Z.Utils.buttonSize(bC4, btnColorW, btnColorH);
				var bc4S = bC4.style;
				bc4S.left = bx + 'px';
				bc4S.top = rBtnsColor + 'px';
			}
			var bC5 = document.getElementById('buttonColor5' + vpIDStr);
			if (bC5) {
				bx += btnColorSpan;
				Z.Utils.buttonSize(bC5, btnColorW, btnColorH);
				var bc5S = bC5.style;
				bc5S.left = bx + 'px';
				bc5S.top = rBtnsColor + 'px';
			}
			var bC6 = document.getElementById('buttonColor6' + vpIDStr);
			if (bC6) {
				bx += btnColorSpan;
				Z.Utils.buttonSize(bC6, btnColorW, btnColorH);
				var bc6S = bC6.style;
				bc6S.left = bx + 'px';
				bc6S.top = rBtnsColor + 'px';
			}
			var bC7 = document.getElementById('buttonColor7' + vpIDStr);
			if (bC7) {
				bx += btnColorSpan;
				Z.Utils.buttonSize(bC7, btnColorW, btnColorH);
				var bc7S = bC7.style;
				bc7S.left = bx + 'px';
				bc7S.top = rBtnsColor + 'px';
			}

			var bblG = document.getElementById('buttonBorderLg' + vpIDStr);
			if (bblG) {
				var bblgS = bblG.style;
				bblgS.width = btnW + 'px';
				bblgS.height = btnH + 'px';

				if (bVM) {
					bblgS.left = parseFloat(bvmS.left) - 2 + 'px';
					bblgS.top = parseFloat(bvmS.top) - 2 + 'px';
				} else if (bEMF) {
					bblgS.left = parseFloat(bemfS.left) - 2 + 'px';
					bblgS.top = parseFloat(bemfS.top) - 2 + 'px';
				} else if (bEMR) {
					bblgS.left = parseFloat(bemrS.left) - 2 + 'px';
					bblgS.top = parseFloat(bemrS.top) - 2 + 'px';
				} else if (bEMP) {
					bblgS.left = parseFloat(bempS.left) - 2 + 'px';
					bblgS.top = parseFloat(bempS.top) - 2 + 'px';
				} else if (bEMM) {
					bblgS.left = parseFloat(bemmS.left) - 2 + 'px';
					bblgS.top = parseFloat(bemmS.top) - 2 + 'px';
				}
			}
			var bbsM = document.getElementById('buttonBorderSm' + vpIDStr);
			if (bbsM && bc0S) {
				var bbsmS = bbsM.style;
				bbsmS.width = btnColorW + 'px';
				bbsmS.height = btnColorH + 'px';
				bbsmS.left = parseFloat(bc0S.left) - 2 + 'px';
				bbsmS.top = parseFloat(bc0S.top) - 2 + 'px';
			}
		}

		// Include caption label and text element in edit mode for markup and non-markup use.
		if (Z.editMode == 'markup' || (Z.editMode == 'edit' && labelVisibility)) {

			var tbLC = document.getElementById('labelCaptionTextBox' + vpIDStr);
			var teC = document.getElementById('textBoxFor-captionTextElement' + vpIDStr);
			if (tbLC && teC) {
				var tblcS = tbLC.style;
				tblcS.width = labelW + 'px';
				tblcS.height = labelH + 'px';
				tblcS.left = marginLabel + 'px';
				tblcS.top = rCaption + adjLabel + 'px';
				tblcS.visibility = (Z.editMode == 'markup') ? 'hidden' : 'visible';
				Z.Utils.setTextNodeStyle(tbLC, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var tecS = teC.style;
				tecS.width = (Z.editMode == 'markup') ? (panelDims.w - margin * 2 - adjLg + adjSm) + 'px' :  (labelTextW + labelTextWAdj) + 'px';
				tecS.height = labelH + 'px';
				tecS.left = (Z.editMode == 'markup') ? margin + 'px' : marginLabel + labelW + 'px';
				tecS.top = rCaption + 'px';
				Z.Utils.setTextAreaStyle(teC, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none', textPaddingSmall + 'px');
			}
		}

		var comTB = document.getElementById('textBoxFor-commentTextElement' + vpIDStr);
		if (comTB) {
			var adjW = (Z.editMode === null) ? 2 : 3;
			var commentW = panelDims.w - margin * 2 - adjW;
			var comtbS = comTB.style;
			comtbS.width = commentW + 'px';
			comtbS.height = commentH + 'px';
			comtbS.left = margin + 'px';
			comtbS.top = rComment + 'px';
			comtbS.visibility = 'visible';
			Z.Utils.setTextAreaStyle(comTB, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1.5em', 'left', 'none', 0 + 'px');

			// Provide slight left edge margin.
			var comTE = document.getElementById('commentTextElement' + vpIDStr);
			var margin = commentW * (1 - adjNote);
			comTE.style.marginLeft = margin + 'px';
			comTE.style.width = (adjComment * 100) + '%';
		}

		if (Z.editMode == 'edit' && labelVisibility) {

			var tbLT = document.getElementById('labelTooltipTextBox' + vpIDStr);
			var teT = document.getElementById('textBoxFor-tooltipTextElement' + vpIDStr);
			if (tbLT && teT) {
				var tbltS = tbLT.style;
				tbltS.width = labelW + 'px';
				tbltS.height = labelH + 'px';
				tbltS.left = marginLabel + 'px';
				tbltS.top = rTooltip + adjLabel + 'px';
				tbltS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLT, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var tetS = teT.style;
				tetS.width = labelTextW + labelTextWAdj + 'px';
				tetS.height = labelH + 'px';
				tetS.left = marginLabel + labelW + 'px';
				tetS.top = rTooltip + 'px';
				Z.Utils.setTextAreaStyle(teT, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none', textPaddingSmall + 'px');
			}
			var tbLU = document.getElementById('labelClickURLTextBox' + vpIDStr);
			var teU = document.getElementById('textBoxFor-clickURLTextElement' + vpIDStr);
			if (tbLU && teU) {
				var tbluS = tbLU.style;
				tbluS.width = labelW + 'px';
				tbluS.height = labelH + 'px';
				tbluS.left = marginLabel + 'px';
				tbluS.top = rClickURL + adjLabel + 'px';
				tbluS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLU, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var tetS = teU.style;
				tetS.width = labelTextW + labelTextWAdj + 'px';
				tetS.height = labelH + 'px';
				tetS.left = marginLabel + labelW + 'px';
				tetS.top = rClickURL + 'px';
				Z.Utils.setTextAreaStyle(teU, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none', textPaddingSmall + 'px');
			}
			var lCPL = document.getElementById('labelCaptionPositionList' + vpIDStr);
			if (lCPL) {
				var lcplS = lCPL.style;
				lcplS.width = listNarrowW + 'px';
				lcplS.left = marginLabel + 'px';
				lcplS.top = rCaptionPos + 'px';
				lcplS.visibility = 'visible';
			}
			var lTPL = document.getElementById('labelTargetList' + vpIDStr);
			if (lTPL) {
				var ltplS = lTPL.style;
				ltplS.width = listNarrowW + 'px';
				ltplS.left = (marginLabel + listNarrowW + btnSpan - btnW) + 'px';
				ltplS.top = rCaptionPos + 'px';
				ltplS.visibility = 'visible';
			}

			var tbLS = document.getElementById('labelScaleTextBox' + vpIDStr);
			var bLSU = document.getElementById('buttonLabelScaleDown' + vpIDStr);
			var bLSD = document.getElementById('buttonLabelScaleUp' + vpIDStr);
			if (tbLS && bLSU && bLSD) {
				bx = marginLabel + adjLg * 3;
				var tblsS = tbLS.style;
				tblsS.width = labelW + 'px';
				tblsS.height = labelH + 'px';
				tblsS.left = bx + 'px';
				tblsS.top = rScale + adjLabel + 'px';
				tblsS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLS, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				bx += labelW - 10;
				Z.Utils.buttonSize(bLSU, btnW, btnH);
				var blsuS = bLSU.style;
				blsuS.left = bx + 'px';
				blsuS.top = rScale + 'px';
				bx += btnSpan;
				Z.Utils.buttonSize(bLSD, btnW, btnH);
				var blsdS = bLSD.style;
				blsdS.left = bx + 'px';
				blsdS.top = rScale + 'px';
				bx += btnSpan + 3;
			}

			var tbLR = document.getElementById('labelRolloverTextBox' + vpIDStr);
			var cCBR = document.getElementById('containerFor-checkboxRollover' + vpIDStr);
			var cbR = document.getElementById('checkboxRollover' + vpIDStr);
			if (tbLR && cCBR && cbR) {
				var tblrS = tbLR.style;
				tblrS.width = labelW + 'px';
				tblrS.height = labelH + 'px';
				tblrS.left = bx + 'px';
				tblrS.top = rScale + adjLabel + 'px';
				tblrS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLR, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				bx += labelW - 1;
				var ccbrS = cCBR.style;
				ccbrS.width = (btnW * 1.5) + 'px';
				ccbrS.height = (btnH * 1.5) + 'px';
				ccbrS.left = (bx + 3) + 'px';
				ccbrS.top = rScale - adjLabel + 'px';
				cbR.width = btnW;
				cbR.height = btnH;
			}
		}

		if ((Z.editMode == 'edit' && labelVisibility) || Z.editMode == 'markup') {

			// Position Add, Edit, Delete, Cancel, Save buttons from right to left of panel.
			var bCL2 = document.getElementById('buttonContainerLabelEdit' + vpIDStr);
			if (bCL2) {
				var bcl2S = bCL2.style;
				bcl2S.width = panelDims.w + 'px';
				bcl2S.height = btnContH + 'px';
				bcl2S.left = '0px';
				bcl2S.top = rContLabelEdit + 'px';
			}
		}

		if (Z.editMode == 'edit' && labelVisibility) {

			var bLE = document.getElementById('buttonLabelEdit' + vpIDStr);
			if (bLE) {
				Z.Utils.buttonSize(bLE, btnW, btnH);
				var bleS = bLE.style;
				bleS.left = btnRight + 'px';
				bleS.top = rBtnsLabelEdit + 'px';
			}
			var bLA = document.getElementById('buttonLabelAdd' + vpIDStr);
			if (bLA) {
				Z.Utils.buttonSize(bLA, btnW, btnH);
				var blaS = bLA.style;
				blaS.left = btnRight2 + 'px';
				blaS.top = rBtnsLabelEdit + 'px';
			}
		}

		if ((Z.editMode == 'edit' && labelVisibility) || Z.editMode == 'markup') {

			var bLS = document.getElementById('buttonLabelSave' + vpIDStr);
			if (bLS) {
				Z.Utils.buttonSize(bLS, btnW, btnH);
				var blsS = bLS.style;
				blsS.left = (btnRight - adjHelp) + 'px';
				blsS.top = rBtnsLabelEdit + 'px';
				if (Z.editMode != 'markup') { blsS.display = 'none'; }
			}
		}

		if (Z.editMode == 'edit' && labelVisibility) {
			var bLC = document.getElementById('buttonLabelCancel' + vpIDStr);
			if (bLC) {
				Z.Utils.buttonSize(bLC, btnW, btnH);
				var blcS = bLC.style;
				blcS.left = (bLS) ? btnRight2 + 'px' : btnRight + 'px';
				blcS.top = rBtnsLabelEdit + 'px';
				if (Z.editMode != 'markup') { blcS.display = 'none'; }
			}
		}

		if ((Z.editMode == 'edit' && labelVisibility) || Z.editMode == 'markup') {
			var bLD = document.getElementById('buttonLabelDelete' + vpIDStr);
			if (bLD) {
				Z.Utils.buttonSize(bLD, btnW, btnH);
				var bldS = bLD.style;
				bldS.left = (bLS && bLC) ? (btnRight3 - adjHelp) + 'px' : (bLS) ? (btnRight2 - adjHelp) + 'px' : (btnRight - adjHelp) + 'px';
				bldS.top = rBtnsLabelEdit + 'px';
				if (Z.editMode != 'markup') { bldS.display = 'none'; }
			}
		}

		if (Z.editMode == 'markup') {
			var bHM = document.getElementById('buttonHelpMarkup' + vpIDStr);
			if (bHM) {
				Z.Utils.buttonSize(bHM, btnW, btnH);
				var bhmS = bHM.style;
				bhmS.left = btnRight + 'px';
				bhmS.top = rBtnsLabelEdit + 'px';
			}
		}

		if ((Z.editMode == 'edit' && labelVisibility) || Z.editMode == 'markup') {
			var bCLIL = document.getElementById('buttonContainerLabelIcons' + vpIDStr);
			if (bCLIL) {
				var bclilS = bCLIL.style;
				bclilS.left = margin / 2 + 'px';
				bclilS.top = rContIcon + 'px';
			}
			var bCLILB = document.getElementById('buttonContainerLabelIconsBackground' + vpIDStr);
			if (bCLILB) {
				var bclilbS = bCLILB.style;
				bclilbS.width = (iconPickerW + margin * 2 - 1) + 'px';
				bclilbS.height = iconPickerH + 'px';
				bclilbS.left = '0px';
				bclilbS.top = '0px';
			}
			var lLI = document.getElementById('labelIconList' + vpIDStr);
			if (lLI) {var lilS = lLI.style;
				lilS.width = iconPickerW + 'px';
				lilS.left = margin + 'px';
				lilS.top = rIconList + 'px';
			}
		}

		if (Z.editMode == 'edit' && labelVisibility) {

			var oLD = document.getElementById('overlayLabelDisable' + vpIDStr);
			if (oLD) {
				var oldS = oLD.style;
				oldS.width = panelDims.w + 'px';
				oldS.height = (buttonBorderLabelH + btnGap * 2 + btnH * 2 + adjLg * 2) + 'px';
				oldS.left = '0px';
				oldS.top = rLabelName + 'px';
			}
			var oLDD = document.getElementById('overlayLabelDetailDisable' + vpIDStr);
			if (oLDD && bblS) {
				var olddS = oLDD.style;
				olddS.width = (parseFloat(bblS.width) + 2) + 'px';
				olddS.height = (parseFloat(bblS.height) + 2) + 'px';
				olddS.left = parseFloat(bblS.left) + 'px';
				olddS.top = parseFloat(bblS.top) + 'px';
				olddS.display = 'inline-block';
			}
			var oLDED = document.getElementById('overlayLabelDetailEditableDisable' + vpIDStr);
			if (oLDED) {
				var oldedS = oLDED.style;
				oldedS.width = parseFloat(bblS.width) + 'px';
				oldedS.height = parseFloat(bblS.height) + 'px';
				oldedS.left = (parseFloat(bblS.left) + 1)+ 'px';
				oldedS.top = (parseFloat(bblS.top) + 1) + 'px';
			}
			var oMB = document.getElementById('overlayMessageBox' + vpIDStr);
			var tbOMB = document.getElementById('textBoxFor-overlayMessageBox' + vpIDStr);
			if (oMB && tbOMB) {
				var tbombS = tbOMB.style;
				tbombS.width = (buttonBorderLabelW - 50) + 'px';
				tbombS.height = (labelH * 2 - 5) + 'px';
				tbombS.left = (parseFloat(bblS.left) + 21) + 'px';
				tbombS.top = (parseFloat(bblS.top) + labelH * 3) + 'px';
				tbombS.backgroundColor = backColorLight;
				var ombS = oMB.style;
				ombS.backgroundColor = backColorLight;
			}
			var oLNED = document.getElementById('overlayLabelNameEditableDisable' + vpIDStr);
			if (oLNED) {
				var olnedS = oLNED.style;
				olnedS.width = panelDims.w + 'px';
				olnedS.height = labelH + 10 + 'px';
				olnedS.left = '0px';
				olnedS.top = (rLabelName - adjLg) + 'px';
			}
			var oLCPD = document.getElementById('overlayLabelCaptionPositionDisable' + vpIDStr);
			if (oLCPD) {
				var olcpdS = oLCPD.style;
				olcpdS.width = (panelDims.w / 2 - 12) + 'px';
				olcpdS.height = (labelH + rowGap + 1) + 'px';
				olcpdS.left = (margin + 1) + 'px';
				olcpdS.top = (parseFloat(lcplS.top) - 4) + 'px';
			}
		}

		if (noteVisibility) {
			var lNTB = document.getElementById('labelNoteTextBox' + vpIDStr);
			var nTB = document.getElementById('textBoxFor-noteTextElement' + vpIDStr);
			if (lNTB && noteList && nTB) {
				var lntbS = lNTB.style;
				lntbS.width = labelW + 'px';
				lntbS.height = labelH + 'px';
				lntbS.left = margin +  'px';
				lntbS.top = rNoteName + adjLabel + 'px';
				lntbS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(lNTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var nlS = noteList.style;
				nlS.width = listW + 'px';
				nlS.left = labelW + 'px';
				nlS.top = rNoteName + selectElementAdj + 'px';
				nlS.visibility = 'visible';
				var noteW = panelDims.w - margin * 2 - 2;
				var ntbS = nTB.style;
				ntbS.width = noteW + 'px';
				ntbS.height = noteH + 'px';
				ntbS.left = margin + 'px';
				ntbS.top = rNoteText + 'px';
				ntbS.visibility = 'visible';
				Z.Utils.setTextAreaStyle(nTB, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1.5em', 'left', 'none', 0 + 'px');

				// Provide slight left edge margin.
				var nTE = document.getElementById('noteTextElement' + vpIDStr);
				var margin = noteW * (1 - adjNote);
				nTE.style.marginLeft = margin + 'px';
				nTE.style.width = (adjNote * 100) + '%';

				if (Z.editMode !== null) {

					var tbNNTE = document.getElementById('textBoxFor-noteNameTextElement' + vpIDStr);
					if (tbNNTE) {
						var tbnnteS = tbNNTE.style;
						tbnnteS.width = listTextW + 'px';
						tbnnteS.height = labelH + 'px';
						tbnnteS.left = labelW + 'px';
						tbnnteS.top = rNoteName + 'px';
						Z.Utils.setTextAreaStyle(tbNNTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none', textPaddingSmall + 'px');
					}

					var bCN = document.getElementById('buttonContainerNote' + vpIDStr);
					if (bCN) {
						var bcnS = bCN.style;
						bcnS.width = panelDims.w + 'px';
						bcnS.height = btnContTallH + 'px';
						bcnS.left = '0px';
						bcnS.top = rContNoteEdit + 'px';
					}

					// Position Add, Edit, Delete, Cancel, Save buttons from right to left of panel.
					var bNE = document.getElementById('buttonNoteEdit' + vpIDStr);
					if (bNE) {
						Z.Utils.buttonSize(bNE, btnW, btnH);
						var bneS = bNE.style;
						bneS.left = btnRight + 'px';
						bneS.top = rBtnsNoteEdit + 'px';
					}
					var bNA = document.getElementById('buttonNoteAdd' + vpIDStr);
					if (bNA) {
						Z.Utils.buttonSize(bNA, btnW, btnH);
						var bnaS = bNA.style;
						bnaS.left = btnRight2 + 'px';
						bnaS.top = rBtnsNoteEdit + 'px';
					}
					var bNS = document.getElementById('buttonNoteSave' + vpIDStr);
					if (bNS) {
						Z.Utils.buttonSize(bNS, btnW, btnH);
						var bnsS = bNS.style;
						bnsS.left = btnRight + 'px';
						bnsS.top = rBtnsNoteEdit + 'px';
						bnsS.display = 'none';
					}
					var bNC = document.getElementById('buttonNoteCancel' + vpIDStr);
					if (bNC) {
						Z.Utils.buttonSize(bNC, btnW, btnH);
						var bncS = bNC.style;
						bncS.left = (bNS) ? (btnRight2 + 'px') : (btnRight + 'px');
						bncS.top = rBtnsNoteEdit + 'px';
						bncS.display = 'none';
					}
					var bND = document.getElementById('buttonNoteDelete' + vpIDStr);
					if (bND) {
						Z.Utils.buttonSize(bND, btnW, btnH);
						var bndS = bND.style;
						bndS.left = (bNS && bNC) ? (btnRight3 + 'px') : (bNS) ? (btnRight2 + 'px') : (btnRight + 'px');
						bndS.top = rBtnsNoteEdit + 'px';
						bndS.display = 'none';
					}

					if (Z.editMode == 'edit') {
						var bHA = document.getElementById('buttonHelpAnnotation' + vpIDStr);
						if (bHA) {
							Z.Utils.buttonSize(bHA, btnW, btnH);
							var bhaS = bHA.style;
							bhaS.left = marginLabel + 'px';
							bhaS.top = rBtnsNoteEdit + 'px';
						}
					}

					var oNDD = document.getElementById('overlayNoteDetailDisable' + vpIDStr);
					if (oNDD) {
						var onddS = oNDD.style;
						onddS.width = (parseFloat(ntbS.width) + 2) + 'px';
						onddS.height = (parseFloat(ntbS.height) + 2) + 'px';
						onddS.left = parseFloat(ntbS.left) + 'px';
						onddS.top = parseFloat(ntbS.top) + 'px';
						onddS.display = 'inline-block';
					}
					var oND = document.getElementById('overlayNoteDisable' + vpIDStr);
					if (oND) {
						var ondS = oND.style;
						ondS.width = panelDims.w + 'px';
						ondS.height = (labelH + rowGap + noteH + textPadding + rowGap + btnH + adjLg) + 'px';
						ondS.left = '0px';
						ondS.top = rNoteName + 'px';
					}
				}
			}
		}

		// Support imageSet viewing by hiding additional annotation panels as created.
		if (vpID > 0) { annS.display = 'none'; };
	}

	// Fill choice lists based on default (first) POI selection.
	function populateAnnotationPanel () {
		populatePOIs('0');
		if (!self.getStatus('annotationPanelInitializedViewport') && (Z.editMode != 'edit' || document.getElementById('buttonLabelSave' + viewportID.toString()))) {
			self.setStatus('annotationPanelInitializedViewport', true);
		}
	}

	this.calculateAnnotationPanelDimensions = function (poiVis, labelVis, noteVis, commentVis) {
		// Set default dimensions for View mode.
		var aPanelW = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELWIDTH'), 10);
		var aPanelH = parseInt(Z.Utils.getResource('DEFAULT_ANNOTATIONPANELHEIGHT'), 10);

		// Add length for Markup or Edit modes and for elements hidden by optional parameters.
		if (Z.editMode == 'markup') {
			aPanelW -= 20;
			aPanelH += 115;
			if (!poiVis) { aPanelH -= 24; }
			if (!labelVis) { aPanelH -= 24; }
			if (!noteVis) { aPanelH -= 115; }
			if (!commentVis) { aPanelH -= 80; }
		} else if (Z.editMode !== null) {
			aPanelH += 244;
			if (!poiVis) { aPanelH -= 50; }
			if (!labelVis) { aPanelH -= 215; }
			if (!noteVis) { aPanelH -= 140; }
			if (!commentVis) { aPanelH -= 80; }
		} else {
			if (!poiVis) { aPanelH -= 24; }
			if (!labelVis) { aPanelH -= 24; }
			if (!noteVis) { aPanelH -= 115; }
			if (!commentVis) { aPanelH -= 80; }
			if (!poiVis && !noteVis && !commentVis) { aPanelH -= 9; }
		}

		this.w = aPanelW;
		this.h = aPanelH;
	}

	this.calculateAnnotationPanelCoords = function (position, annotPanelW, annotPanelH, viewerW, viewerH) {
		// Annotation panel positioning: 0 hides, 1 top left, 2 top-right, 3 bottom right, 4 bottom left
		// Note that viewerH  allows for toolbar height if static in viewer display area, but annotationPanelH
		// requires additional adjustment to Y position of panel if position is at bottom of viewer.
		var panelX, panelY;

		if (Z.annotationPanelVisible == 0) {
			panelX = -1000;
			panelY = -1000;
		} else {
			var margin = 15;
			switch (position) {
				case '0':
					panelX = -1000;
					panelY = -1000;
					break;
				case '1':
					panelX = margin;
					panelY = margin;
					break;
				case '2':
					panelX = viewerW - annotPanelW - margin;
					panelY = margin;
					if (Z.trackingPanelPosition == 2) { panelY += 20; }
					if (Z.imageSetListPosition == 2) { panelY += 20; }
					break;
				case '3':
					panelX = viewerW - annotPanelW - margin;
					if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
						panelY = viewerH - annotPanelH - margin;
					} else {
						panelY = viewerH - margin;
					}
					break;
				case '4':
					panelX = margin;
					if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
						panelY = viewerH - annotPanelH - margin;
					} else {
						panelY = viewerH - margin;
					}
					break;
				default:
					panelX = viewerW - annotPanelW - margin;
					panelY = margin;
			}
		}
		return new Z.Utils.Point(panelX, panelY);
	}

	this.sizeAndPositionAnnotationPanel = function (panel, width, height, left, top) {
		if (typeof width !== 'undefined' && width !== null) { panel.width = width + 'px'; }
		if (typeof height !== 'undefined' && height !== null) { panel.height = height + 'px'; }
		if (typeof left !== 'undefined' && left !== null) { panel.left = left + 'px'; }
		if (typeof top !== 'undefined' && top !== null) { panel.top = top + 'px'; }
	}

	this.clearAnnotationPanel = function (vpIDStr) {
		if (annD) {
			poiList = null;
			labelList = null;
			noteList = null;
			Z.Utils.deleteDiv('AnnotationPanelDisplay' + vpIDStr);
		}
	}

	function getFreeID (idTarget) {
		// DEV NOTE: Conditions on each case are workaround for Safari issue - unexpected access to irrelevant cases: "TypeError: 'undefined' is not an object (evaluating 'labelListDP.length')".
		var id = 0;
		var idList = []
		switch(idTarget) {
			case 'image' :
				if (imageListDP) { for (var i = 0, j = imageListDP.length; i < j; i++) { idList[idList.length] = parseInt(imageListDP[i].value, 10); } }
				break;
			case 'slide' :
				if (slides) { for (var i = 0, j = slides.length; i < j; i++) { idList[idList.length] = parseInt(slides[i].internalID, 10); } }
				break;
			case 'hotspot' :
				if (hotspots) { for (var i = 0, j = hotspots.length; i < j; i++) { idList[idList.length] = parseInt(hotspots[i].internalID, 10); } }
				break;
			case 'poi' :
				if (poiListDP) { for (var i = 0, j = poiListDP.length; i < j; i++) { idList[idList.length] = parseInt(poiListDP[i].value, 10); } }
				break;
			case 'label' :
				if (labelListDP) { for (var i = 0, j = labelListDP.length; i < j; i++) { idList[idList.length] = parseInt(labelListDP[i].value, 10); } }
				break;
			case 'labelExternal':
				if (hotspots) { for (var i = 0, j = hotspots.length; i < j; i++) { idList[idList.length] = parseInt(hotspots[i].id, 10); } }
				break;
			case 'note' :
				if (noteListDP) { for (var i = 0, j = noteListDP.length; i < j; i++) { idList[idList.length] = parseInt(noteListDP[i].value, 10); } }
				break;
		}
		if (idList.length > 0) {
			idList = Z.Utils.arraySortNumericAscending(idList);
			id = idList[idList.length - 1] + 1;
		}

		// Alternative implementation: Use ID values from gaps in sorted ID values.
		/* for (var i = 0, j = idList.length; i < j; i++) {
			if (idList[i] != id) {
				i = j;
			} else {
				id++;
			}
		}*/

		return id.toString();
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::: HOTSPOT / ANNOTATION MASK FUNCTIONS ::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.setLabelMaskByDisplayID = function (id, useInternalID) {
		var idList = [];
		idList[0] = id;
		self.setHotspotMaskByDisplayList(idList, useInternalID);
	}

	this.setLabelMaskByDisplayList = function (idList, useInternalID) {
		self.setHotspotMaskByDisplayList(idList, useInternalID);
	}

	// Highlight selected hotspot(s)/label(s) by grayscaling image content everywhere else.
	this.setHotspotMaskByDisplayList = function (idList, useInternalID) {
		if (mC && typeof idList !== 'undefined' && idList !== null && idList.length > 0) {
			if (!Z.maskingSelection) {
				setMask(idList, useInternalID);
				Z.Viewport.maskFadeTimeoutHandler('in');
			} else {
				function maskDelayed () {
					setMask(idList, useInternalID);
					Z.Viewport.maskFadeTimeoutHandler('in');
					Z.clearCallback('maskClear', maskDelayed);
				}
				Z.setCallback('maskClear', maskDelayed);
				Z.Viewport.clearMask();
			}
		}
	}

	setMask = function (idList, useInternalID) {
		if ((typeof idList === 'undefined' || idList === null) && (typeof labelNoMaskArr !== 'undefined' && labelNoMaskArr !== null && labelNoMaskArr.length > 0)) {
			idList = labelNoMaskArr;
		}
		if (typeof idList !== 'undefined' && idList !== null && idList.length > 0) {
			labelNoMaskArr = idList.slice(0);

			if (typeof useInternalID === 'undefined' || useInternalID === null) { useInternalID = false; }

			// Size and position mask canvas to match viewport display.
			syncMask();

			// Draw grayscale version of current viewport display content on mask canvas.
			displayMask();

			// Draw regions to be highlighted on mask canvas with xor value set. Non-polygonal hotspots cut as circle polygons centered on hotspot coordinates.
			cutMaskRegions(idList, useInternalID);
		}
	}

	function syncMask () {
		if (mC) {
			mC.width = vD.width;
			mC.height = vD.height;
			mS.width = vS.width;
			mS.height = vS.height;
			mS.left = vS.left;
			mS.top = vS.top;
			mCtx.restore();
			mCtx.save();
			mCtx.translate(displayCtrX, displayCtrY);
		}
	}

	// Capture and combine backfill and frontfill image data, grayscale, and drawImage to maintain transparency of frontfill so
	// backfill shows through tile gaps and mask data is complete when cutouts are created and it is overlayed on current image.
	function displayMask () {
		if (mC) {
			Z.Utils.clearDisplay(mC);
			mCtx.save();
			mCtx.scale(tierBackfillScale, tierBackfillScale);
			var tierCurrentZoomUnscaled = convertTierScaleToZoom(tierBackfill, 1);
			var x = -(Z.imageX - Z.imageW / 2) * tierCurrentZoomUnscaled;
			var y = -(Z.imageY - Z.imageH / 2) * tierCurrentZoomUnscaled;
			mCtx.translate(x, y);
			mCtx.drawImage(bD, -bD.width/2, -bD.height/2, bD.width, bD.height);
			mCtx.restore();
			mCtx.drawImage(vD, -vD.width/2, -vD.height/2, vD.width, vD.height);
			var imgDataObj = mCtx.getImageData(0, 0, mC.width, mC.height);
			var imgDataObjFiltered = filterImageObject(imgDataObj, 'grayscale', '');
			mCtx.putImageData(imgDataObjFiltered, 0, 0);
		}
	}

	function cutMaskRegions (idList, useInternalID) {
		for (var i = 0, j = hotspots.length; i < j; i++) {
			var hotspot = hotspots[i];
			var id = (useInternalID) ? hotspot.internalID : hotspot.id;
			var arr = Z.Utils.arrayMap(idList, String);
			var unmaskIndex = Z.Utils.arrayIndexOf(arr, id);
			if (unmaskIndex != -1) {
				cutPolygonFromMask(hotspot);
			}
		}
	}

	// Draw polygon or arc at position of non-polygon hotspot on mask canvas.
	function cutPolygonFromMask (hotspot) {
		if (Z.useCanvas) {
			if (hotspot.visibility || hotspot.rollover || rollover) {
				var hotspotInternalID = hotspot.internalID;

				// Record mask state and set cut, translation, style, and alpha values.
				mCtx.save();
				mCtx.globalCompositeOperation = 'xor';
				mCtx.translate((hotspot.x - Z.imageX) * Z.imageZ, (hotspot.y - Z.imageY) * Z.imageZ);
				mCtx.lineWidth = 0.000001;
				mCtx.strokeStyle = hotspot.lineColor;
				mCtx.globalAlpha = 1;

				// Temporarily change scale of canvas to implement scaling of polygon set of control points (vertices).
				var scaleDelta = tierScale / tierScalePrior;
				var zVal = self.getZoom();
				var polyScaleX = (hotspot.xScale / 100) / scaleDelta * zVal;
				var polyScaleY = (hotspot.yScale / 100) / scaleDelta * zVal;
				if (polyScaleX != 1 && polyScaleY != 1) {
					mCtx.scale(polyScaleX, polyScaleY);
				}

				// Draw polygon on canvas or draw circle on mask.
				var x = hotspot.x;
				var y = hotspot.y;
				mCtx.beginPath();

				if (hotspot.polygonPts) {
					var tPolyPts = hotspot.polygonPts.slice(0);
					var firstPolyPtX = tPolyPts[0].x - x;
					var firstPolyPtY = tPolyPts[0].y - y;
					mCtx.moveTo(firstPolyPtX, firstPolyPtY);
					for (var i = 1, j = tPolyPts.length; i < j; i++) {
						var polyPtX = tPolyPts[i].x - x;
						var polyPtY = tPolyPts[i].y - y;
						mCtx.lineTo(polyPtX, polyPtY);
					}
					if (hotspot.mediaType != 'freehand' && hotspot.polyClosed) {
						mCtx.lineTo(firstPolyPtX, firstPolyPtY);
						mCtx.closePath();
					}

				} else {
					var w = hotspot.iW * (100 / hotspot.z);
					var h = hotspot.iH * (100 / hotspot.z);
					var x = 0;
					var y = (hotspot.media.indexOf('triangle') == -1) ? 0 : (hotspot.iH * 0.23);
					var maskMargin = 1.2;
					var radius = Math.max(w, h) / 2 * maskMargin;
					mCtx.arc(x, y, radius, 0, 2 * Math.PI);
				}

				mCtx.fill();
				mCtx.restore();
			}

		} else {
			if (!polygonsRequireCanvasAlertShown) {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_POLYGONSREQUIRECANVAS'));
				polygonsRequireCanvasAlertShown = true;
			}
		}
	}

	this.clearMask = function () {
		if (mC) { Z.Viewport.maskFadeTimeoutHandler('out'); }
	}

	this.maskFadeTimeoutHandler = function (direction) {
		if (mC) {
			// Enable mask.
			if (!Z.maskingSelection && direction !== null) {
				Z.maskingSelection = true;
				mS.display = 'inline-block';
			}

			// Validate fading status.
			if (direction == 'in') {
				Z.maskOpacity += maskFadeStep;
				if (Z.maskOpacity > 1) {
					Z.maskOpacity = 1;
					direction = null;
					Z.Utils.validateCallback('maskSet');
				}
			} else if (direction == 'out' || direction == 'outIn') {
				Z.maskOpacity -= maskFadeStep;
				if (Z.maskOpacity <= 0) {
					Z.maskOpacity = 0;
					if (direction == 'outIn') {
						direction = 'In'; // Reverse direction if resetting mask by fading out then in.
					} else {
						Z.maskingSelection = false;
						Z.Utils.clearDisplay(mC);
						mS.display = 'none';
						direction = null;
						Z.Utils.validateCallback('maskClear');
					}
				}
			}

			// Update opacity.
			Z.Utils.setOpacity(mC, Z.maskOpacity);

			// Iterate fading transition.
			if (direction !== null && Z.maskOpacity > 0 && Z.maskOpacity < 1) {
				Z.maskFadeTimeout = window.setTimeout( function () { Z.Viewport.maskFadeTimeoutHandler(direction); }, 50);
			} else {
				window.clearTimeout(Z.maskFadeTimeout);
				Z.maskFadeTimeout = null;
			}
		} else {
			direction = null;
			Z.maskingSelection = false;
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::: HOTSPOT & ANNOTATION EVENT FUNCTIONS ::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function hotspotRolloverHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			var relatedTarget = Z.Utils.relatedTarget(event);
			var hotTarget = getHotspotTarget(target);

			// Reset visibility if mouse is not: moving from polygon, not from display, into nested caption or from caption into polygon, not into display.
			if (hotTarget !== null && (relatedTarget !== null && !(relatedTarget.id == 'captionTextBox' && target.id.indexOf('hot') != -1 && target.id.indexOf('hotspotDisplay') == -1) && !(target.id == 'captionTextBox' && relatedTarget.id.indexOf('hot') != -1 && relatedTarget.id.indexOf('hotspotDisplay') == -1))) {
				self.setHotspotVisibility(hotTarget, true);
			}
		}
	}

	function hotspotPopoverHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			var relatedTarget = Z.Utils.relatedTarget(event);
			var hotTarget = getHotspotTarget(target);

			// Reset visibility if mouse is not: moving from polygon, not from display, into nested caption or from caption into polygon, not into display.
			if (hotTarget !== null && (relatedTarget !== null && !(relatedTarget.id == 'captionTextBox' && target.id.indexOf('hot') != -1 && target.id.indexOf('hotspotDisplay') == -1) && !(target.id == 'captionTextBox' && relatedTarget.id.indexOf('hot') != -1 && relatedTarget.id.indexOf('hotspotDisplay') == -1))) {
				self.setHotspotPopupVisibility(hotTarget, true);
			}
		}
	}

	// DEV NOTE: This event handler currently assigned to hotspot container (formerly hotspot cloak) and only used to
	// disable click-zoom-and-pan effect to ensure it does not conflict with click url effect.  Alternative to href
	// click effect implementation. See notes above commented handlers in drawHotspotInHTML function.
	function hotspotMouseDownHandler (event) {
		var event = Z.Utils.event(event);
		if (event) { Z.clickZoomAndPanBlock = true; }
	}

	// DEV NOTE: Alternative to href click effect implementation. See notes above commented handlers in drawHotspotInHTML function.
	// If using mouse down handler may need to track distance and/or time to verify click of hotspot is not click-drag of image.
	//function hotspotMouseUpHandler (event) {
	//}

	function hotspotRolloutHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			var relatedTarget = Z.Utils.relatedTarget(event);
			var hotTarget = getHotspotTarget(target);

			// Reset visibility if mouse is not: moving from polygon, not from display, into nested caption or from caption into polygon, not into display.
			if (hotTarget !== null && (relatedTarget !== null && !(relatedTarget.id == 'captionTextBox' && target.id.indexOf('hot') != -1 && target.id.indexOf('hotspotDisplay') == -1) && !(target.id == 'captionTextBox' && relatedTarget.id.indexOf('hot') != -1 && relatedTarget.id.indexOf('hotspotDisplay') == -1))) {
				self.setHotspotVisibility(hotTarget, false);
			}
		}
	}

	function hotspotPopoutHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			var relatedTarget = Z.Utils.relatedTarget(event);
			var hotTarget = getHotspotTarget(target);

			// Reset visibility if mouse is not: moving from polygon, not from display, into nested caption or from caption into polygon, not into display.
			if (hotTarget !== null && (relatedTarget !== null && !(relatedTarget.id == 'captionTextBox' && target.id.indexOf('hot') != -1 && target.id.indexOf('hotspotDisplay') == -1) && !(target.id == 'captionTextBox' && relatedTarget.id.indexOf('hot') != -1 && relatedTarget.id.indexOf('hotspotDisplay') == -1))) {
				self.setHotspotPopupVisibility(hotTarget, false);
			}
		}
	}

	// DEV NOTE: This event handler currently assigned to hotspot container (formerly hotspot cloak) and only used to
	// disable click-zoom-and-pan effect to ensure it does not conflict with click url effect.  Alternative to href
	// click effect implementation. See notes above commented handlers in drawHotspotInHTML function.
	function hotspotTouchStartHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			// DEV NOTE: Next line currently not called. Investigating if needed to prevent delay and simulated mouse events, however it may block hotspot click event for clickURL effect on iOS in Safari.
			//event.preventDefault();
			Z.clickZoomAndPanBlock = true;
		}
	}

	// DEV NOTE: Alternative to href click effect implementation. See notes above commented handlers in drawHotspotInHTML function.
	// If using mouse down handler may need to track distance and/or time to verify click of hotspot is not click-drag of image.
	// Currently not called. Investigating if needed to prevent delay and simulated mouse events, however it may block hotspot click event for clickURL effect on iOS in Safari.
	/*function hotspotTouchEndHandler (event) {
		var event = Z.Utils.event(event);
		if (event) { event.preventDefault(); }
	}*/

	// DEV NOTE: Alternative to href click effect implementation. See notes above commented handlers in drawHotspotInHTML function.
	// If using mouse down handler may need to track distance and/or time to verify click of hotspot is not click-drag of image.
	// Currently not called. Investigating if needed to prevent delay and simulated mouse events, however it may block hotspot click event for clickURL effect on iOS in Safari.
	/*function hotspotTouchCancelHandler (event) {
		var event = Z.Utils.event(event);
		if (event) { event.preventDefault(); }
	}*/

	// This event handler assigned to hotspot cloak not hotspot container and is only used to show message regarding disabled click url effect in edit mode.
	function hotspotEditMouseDownHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			if (!event.altKey) {
				var target = Z.Utils.target(event);
				var hotTarget = getHotspotTarget(target);
				var hotspotInternalID = hotTarget.id.substring(3, hotTarget.id.length);
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
				if (index != -1) { var clickURL = hotspots[index].clickURL; }
				var message = Z.Utils.getResource('ALERT_HOTSPOTCLICKURLDISABLED');
				Z.Utils.showMessage(message, true, null, 'center', true);

				// Alternative implementation:
				//var message = Z.Utils.getResource('ALERT_HOTSPOTCLICKURLDISABLED') + clickURL;
				//Z.Utils.showMessage(message, true, Z.messageDurationLong, 'center');
			}
		}
	}

	// This event handler assigned to hotspot cloak not hotspot container and is only used to show message regarding disabled click url effect in edit mode.
	function hotspotEditTouchStartHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			if (!event.altKey) {
				var target = Z.Utils.target(event);
				var hotTarget = getHotspotTarget(target);
				var hotspotInternalID = hotTarget.id.substring(3, hotTarget.id.length);
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
				if (index != -1) { var clickURL = hotspots[index].clickURL; }
				var message = Z.Utils.getResource('ALERT_HOTSPOTCLICKURLDISABLED');
				Z.Utils.showMessage(message, true, null, 'center', true);
			}
		}
	}

	// Record mouse down or touch start coordinates (and touch move coordinates in case touch end fails to return values).
	function validateExternalFunction (event) {
		var eventType = event.type;
		var target = Z.Utils.target(event);
		if (target) {
			var hotTarget = getHotspotTarget(target);
			hotspotCurrentID = hotTarget.id.substring(3, hotTarget.id.length);
		}
		if (eventType == 'touchstart') {
			var touch = Z.Utils.getFirstTouch(event);
			if (typeof touch !== 'undefined') {
				hotspotDragPtStart = new Z.Utils.Point(touch.pageX, touch.pageY);
				hotspotDragTimeStart = new Date().getTime();
			}
		} else if (eventType == 'touchmove') {
			// Workaround for undefined first touch on touchend and touchcancel.
			var touch = Z.Utils.getFirstTouch(event);
			if (typeof touch !== 'undefined') { hotspotDragPtEnd = new Z.Utils.Point(touch.pageX, touch.pageY); }
		} else {
			hotspotDragPtStart = Z.Utils.getMousePosition(event);
			hotspotDragTimeStart = new Date().getTime();
		}
	}

	// Determine mouse up or touch end/cancel coordinates and verify not dragging.
	function executeExternalFunction (event) {
		var eventType = event.type;
		if (eventType == 'touchend' || eventType == 'touchcancel') {
			var touch = Z.Utils.getFirstTouch(event); 
			if (typeof touch !== 'undefined') { 
				hotspotDragPtEnd = new Z.Utils.Point(touch.pageX, touch.pageY);
			} else if (hotspotDragTimeStart !== null) {
				// Workaround for undefined first touch on touchend and touchcancel.
				var hotspotDragTimeEnd = new Date().getTime();
				var hotspotDragDuration = hotspotDragTimeEnd - hotspotDragTimeStart;
				if (hotspotDragDuration < TOUCHTAP_THRESHOLD_TIME_VIEWPORT) {
					hotspotDragPtEnd = hotspotDragPtStart;
					hotspotDragTimeStart = null;
				}
			}
		} else {
			hotspotDragPtEnd = Z.Utils.getMousePosition(event);
		}
		var hotspotDragDist = Z.Utils.calculatePointsDistance(hotspotDragPtStart.x, hotspotDragPtStart.y, hotspotDragPtEnd.x, hotspotDragPtEnd.y);
		var isAltKey = (event) ? event.altKey : null;
		if (hotspotDragDist < MOUSECLICK_THRESHOLD_HOTSPOT && !isAltKey) {

			// Get relevant hotspot HTML click target: for hotspots require this.parentNode, for labels simply this.
			var hotTarget = Z.Viewport.getHotspotTarget(this);

			// Get related element in hotspots objects array.
			var hotspotInternalID = hotTarget.id.substring(3, hotTarget.id.length);
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);

			// Get element function value.
			if (index != -1) {
				var externalFunctionString = unescape(hotspots[index].urlTarget);
				var externalFunction = new Function(externalFunctionString);
				var externalFxnCallTimer = window.setTimeout(externalFunction, 200);
			}
		}
	}

	function hotspotListMouseDownHandler (event) {
		Z.Utils.removeEventListener(hotspotList, 'mousedown', hotspotListMouseDownHandler);
		if (Z.hotspotListTitle && Z.Utils.stringValidate(Z.hotspotListTitle) && Z.hotspotListTitle != 'none') {
			hotspotList.selectedIndex = 0;
		} else {
			// Add placeholder text to avoid blank list first element while selected item is unset to allow reselection of any item.
			var listTitleTemp = Z.Utils.getResource('UI_LISTMOUSEDOWNTEXT');
			if (hotspotList.options[0].text != listTitleTemp) {
				var option = document.createElement("option");
				option.text = listTitleTemp;
				option.value = null;
				hotspotList.add( option, 0);
			}
			hotspotList.selectedIndex = 0;

			// Alternative implementation: Do not insert placeholder text. First list row blank when list open.
			//hotspotList.selectedIndex = -1;
		}
		Z.Utils.addEventListener(hotspotList, 'change', hotspotListChangeHandler);
	}

	function hotspotListChangeHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			if (Z.tourPlaying) { self.tourStop(); }
			var target = Z.Utils.target(event);
			var hotspotInternalID = target.options[target.selectedIndex].value;

			if (!isNaN(parseInt(hotspotInternalID), 10)) {
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
				if (index != -1 ) {
					var hotspot = hotspots[index];
					hotspotCurrentID = hotspot.internalID;
					Z.Utils.playAudio(destinationNextAudio, hotspot.audio);
					self.zoomAndPanToView(hotspot.x, hotspot.y, (hotspot.z / 100), hotspot.rotation);
				}
			}

			Z.Utils.removeEventListener(hotspotList, 'change', hotspotListChangeHandler);
			var listTimer = window.setTimeout( function () { Z.Utils.addEventListener(hotspotList, 'mousedown', hotspotListMouseDownHandler); }, 10);

			//Debug options: Hotspot API features can be tested here, using hotspots choicelist change handler.
			//self.createHotspotFromParameters('200', 'Test', 'icon', 'Assets/Hotspots/hotspotFromJPG.jpg', null, '250', '250', '100', '100','100', null, '0', '0', 'http://www.zoomify.com', '_self', 'false', 'Test Caption', 'This is a test tooltip.');
			//self.setHotspotsVisibilityByFilter('name', 'Hotspot Without Click Link', false);
			//self.setHotspotVisibilityByID('3', false);
		}
	}

	function populatePOIs (poiID, labelID, noteID) {
		poiListDP.sort(sortAnnotationAssocArrayByField);
		Z.Utils.updateSelectElement(poiList, poiListDP, poiID);
		if (typeof poiID === 'undefined' || poiID === null) {
			if (poiList.options.length == 0) { createFirstPOI(); }
			poiID = '0';
		} else {
			var index = Z.Utils.arrayIndexOfObjectValue(poiListDP, 'value', poiID);
			if (index != -1) { poiID = poiListDP[index].value; }
		}
		populateCurrentPOIDetails(poiID);
		populateLabels(poiID, labelID);
		if (Z.editMode != 'markup') { populateNotes(poiID, noteID); }
	}

	function populateCurrentPOIDetails (poiID) {
		var vpIDStr = viewportID.toString();
		var index = Z.Utils.arrayIndexOfObjectValue(poiListDP, 'value', poiID);
		var poiNameTE = document.getElementById('poiNameTextElement' + vpIDStr);
		if (poiNameTE && index != -1) { poiNameTE.value = poiListDP[index].text; }
	}

	function populateLabels (poiID, labelID, saving) {
		labelListDP.sort(sortAnnotationAssocArrayByField);
		if (Z.editMode == 'markup') {
			labelListCurrentDP = Z.Utils.arrayClone('labels', labelListDP, labelListCurrentDP);
		} else {
			labelListCurrentDP = filterListByPOIID(labelListDP, poiID);
		}
		Z.Utils.updateSelectElement(labelList, labelListCurrentDP, labelID);
		if (typeof labelID === 'undefined' || labelID === null) {
			labelID = (labelList.options.length > 0) ? labelList.options[0].value : null;
		}
		populateCurrentLabelDetails(labelID, saving);
	}

	function populateCurrentLabelDetails (labelID, saving) {
		var vpIDStr = viewportID.toString();
		hotspotCurrentID = labelID; // Set current hotspot tracking variable for editing use.
		polygonCurrentPts = null;
		controlPointCurrent = null;
		polygonComplete = true;
		var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
		hotspotCurrent = (index != -1) ? hotspots[index] : null;
		var labelNonEditable = !self.getLabelEditable(hotspotCurrentID);
		if (commentVisibility) {
			var comTE = document.getElementById('commentTextElement' + vpIDStr);
			if (comTE) {
				var noFirstLabel = ((poiList !== 'undefined' && poiList !== null && poiList.options.length > 0 && poiList.options[poiList.selectedIndex].text != Z.Utils.getResource('UI_LISTMOUSEDOWNTEXT')) && typeof labelListDP === 'undefined' || labelListDP.length === null || labelListDP.length == 0);
				comTE.value = (Z.editMode == 'markup' && noFirstLabel) ? Z.Utils.getResource('CONTENT_LABELCOMMENTMARKUPNOLABELS') : '';
				if (hotspotCurrent !== null) {
					var comVal = hotspotCurrent.comment;
					if (comVal !== null && Z.Utils.stringValidate(comVal)) {
						var comUnesc = comVal;
						comTE.value = comUnesc;
					}
					comTE.readOnly = labelNonEditable;
				}
			}
		}
		if (Z.editMode !== null) {
			var labelNameTE = document.getElementById('labelNameTextElement' + vpIDStr);
			if (labelNameTE) {
				labelNameTE.value = (hotspotCurrent !== null) ? hotspotCurrent.name : '';
				labelNameTE.readOnly = labelNonEditable;
			}
			var captionTE = document.getElementById('captionTextElement' + vpIDStr);
			if (captionTE) {
				captionTE.value = '';
				if (hotspotCurrent !== null) {
					var captionHTML = hotspotCurrent.captionHTML;
					if (typeof captionHTML === 'undefined' || !Z.Utils.stringValidate(captionHTML)) {
						// Unescape text content to support apostrophes, new lines, etc.
						captionTE.value = hotspotCurrent.caption;
					} else {
						// Do not unescape HTML content to display as HTML in edit field.
						captionTE.value = captionHTML;
					}
					captionTE.readOnly = labelNonEditable;
				}
			}
			if (Z.editMode != 'markup' && !saving && (Z.editing != 'addLabel' || !createdNewLabel)) {
				var iconList = document.getElementById('labelIconList' + vpIDStr);
				var tooltipTE = document.getElementById('tooltipTextElement' + vpIDStr);
				var cuTE = document.getElementById('clickURLTextElement' + vpIDStr);
				var capPosList = document.getElementById('labelCaptionPositionList' + vpIDStr);
				var targetList = document.getElementById('labelTargetList' + vpIDStr);
				var rolloverCB = document.getElementById('checkboxRollover' + vpIDStr);

				// If adding new label do not clear tooltip, click URL, caption position etc. to speed data entry.
				if (iconList && tooltipTE && cuTE && capPosList && targetList && rolloverCB) {
					// Leave selection unless replaced below: iconList.selectedIndex = 0;
					tooltipTE.value = '';
					cuTE.value = '';
					capPosList.selectedIndex = 0;
					targetList.selectedIndex = 0;
					rolloverCB.checked = false;

					if (hotspotCurrent !== null) {
						// Select icon list item to match label media if label mediaType is icon. In non-markup
						// mode this presets list to show correct item if icon edit mode button is clicked.
						if (hotspotCurrent.mediaType == 'icon') {
							var media = hotspotCurrent.media.toLowerCase();
							var isInternalSymbol = (media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
							var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
							var iconType = null;
							if (isInternalSymbol) {
								iconType = media;
							} else if (isExternalSymbol) {
								var start = media.lastIndexOf('/') + 1;
								var end = media.lastIndexOf('.');
								if (start != -1 && end != -1) { iconType = media.substring(start, end).toLowerCase(); }
							}
							if (iconType) {
								var index = Z.Utils.arrayIndexOfObjectValueSubstring(iconList, 'value', iconType, null, true);
								if (index != -1) { iconList.selectedIndex = index; }
								self.toggleLabelIconPicker(false);
							}
						}

						// Set caption position list.
						var capPos = hotspotCurrent.captionPosition;
						if (Z.Utils.stringValidate(capPos)) {
							var index = Z.Utils.arrayIndexOfObjectValue(capPosList, 'value', capPos);
							if (index != -1) { capPosList.selectedIndex = index; }
						}

						// Set tooltip, and url text values.
						var tooltipHTML = hotspotCurrent.tooltipHTML;
						if (typeof tooltipHTML === 'undefined' || !Z.Utils.stringValidate(tooltipHTML)) {
							tooltipTE.value = hotspotCurrent.tooltip;
						} else {
							tooltipTE.value = tooltipHTML;
						}

						// Set click-url.
						var clickURL = hotspotCurrent.clickURL;
						if (Z.Utils.stringValidate(clickURL)) {
							cuTE.value = clickURL;
						}

						// Set click-url target list.
						var urlTarget = hotspotCurrent.urlTarget;
						if (Z.Utils.stringValidate(urlTarget)) {
							var index = Z.Utils.arrayIndexOfObjectValue(targetList, 'value', urlTarget);
							if (index != -1) { targetList.selectedIndex = index; }
						}

						// Set rollover checkbox.
						rolloverCB.checked = (hotspotCurrent.rollover == true);
					}
				}
			}
		}

		if (hotspotCurrent !== null) {
			hotspotCurrentID = labelID = hotspotCurrent.internalID;
			// DEV NOTE: Implement further regression testing prior to removing line below.
			// Ensures label edit mode matches current label if in edit mode.
			/*if (Z.labelMode != 'view' && Z.editing !== null) {
				self.setEditModeLabel(hotspotCurrent.mediaType, true, hotspotCurrent.media, true);
			}*/
		}

		if (hotspotCurrentID != labelPriorID) {
			// Debug option: Z.setCallback('currentLabelChangedGetID', function (param1, param2) { alert('id: ' + param1 + ', internalID: ' + param2); } );
			if (Z.Viewer.getStatus('readyViewer')) { Z.Utils.validateCallback('currentLabelChangedGetID'); }
		}

		if (!hotspotDragging) {
			redisplayHotspots();
		} else {
			redisplayShapesAndPolygons();
		}
	}

	function populateNotes (poiID, noteID) {
		noteListDP.sort(sortAnnotationAssocArrayByField);
		noteListCurrentDP = filterListByPOIID(noteListDP, poiID);
		Z.Utils.updateSelectElement(noteList, noteListCurrentDP, noteID);
		if (typeof noteID === 'undefined' || noteID === null) {
			noteID = null;
			noteList.selectedIndex = 0;
			if (noteList.options.length > 0) { noteID = noteList.options[0].value; }
		}
		populateCurrentNoteDetails(noteID);
	}

	function populateCurrentNoteDetails (noteID) {
		var vpIDStr = viewportID.toString();
		var index = Z.Utils.arrayIndexOfObjectValue(noteListCurrentDP, 'value', noteID);
		if (Z.editMode !== null) {
			var noteNameTE = document.getElementById('noteNameTextElement' + vpIDStr);
			if (noteNameTE) { noteNameTE.value = (index != -1) ? noteListCurrentDP[index].text : ''; }
		}
		var noteTE = document.getElementById('noteTextElement' + vpIDStr);
		if (noteTE) { noteTE.value = (index != -1) ? noteListCurrentDP[index].noteText : ''; }
	}

	function poiListChangeHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			var poiID = target.options[target.selectedIndex].value;

			if (poiID && !isNaN(parseInt(poiID), 10)) {
				// Update XML, display elements, and choicelist.
				self.saveEditsPOI(true);
				populatePOIs(poiID);
			}
		}
	}

	this.goToPOICurrent = function () {
		var poiID = self.getCurrentPOIID();
		if (poiID && !isNaN(parseInt(poiID), 10)) {
			self.goToPOIByID(poiID);
		}
	}

	this.goToPOIByID = function (poiID) {
		var index = Z.Utils.arrayIndexOfObjectValue(poiListDP, 'value', poiID);
		if (index != -1) {
			var temp;
			temp = poiListDP[index].x;
			var X = (temp == 'center') ? Z.imageCtrX : parseFloat(temp);
			temp = poiListDP[index].y;
			var Y = (temp == 'center') ? Z.imageCtrY : parseFloat(temp);
			temp = poiListDP[index].z;
			var Zoom = (temp == '-1') ? Z.fitZ : parseFloat(temp);
			if (!self.getStatus('annotationPanelInitializedViewport')) {
				self.setView(X, Y, (Zoom / 100));
			} else {
				self.zoomAndPanToView(X, Y, (Zoom / 100));
			}
		}
	}

	this.getCurrentPOIID = function () {
		var poiID = null;
		if (poiList.length > 0) { poiID = poiList[poiList.selectedIndex].value; }
		return poiID;
	}

	this.getPOIEditable = function (poiID) {
		var editable = Z.editAdmin;
		// If true due to admin mode, no need to test specific POI value.
		if (!editable) {
			var index = Z.Utils.arrayIndexOfObjectValue(poiListDP, 'value', poiID);
			if (index != -1) { editable = poiListDP[index].editable; }
		}
		return editable;
	}

	function labelListChangeHandler (event) {
		var labelID;
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			labelID = target.options[target.selectedIndex].value;

			if (labelID && !isNaN(parseInt(labelID, 10))) {
				// Update XML, display elements, and choicelist.
				self.saveEditsLabel(true, false, false);
				populateCurrentLabelDetails(labelID);

				// Set current hotspot tracking variable for editing use.
				hotspotCurrentID = labelID;
				polygonComplete = true;
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
				hotspotCurrent = (index != -1) ? hotspots[index] : null;

				// Mask area other than label selected.
				if (Z.maskVisible) {
					Z.Utils.arrayClear(labelNoMaskArr);
					labelNoMaskArr[labelNoMaskArr.length] = hotspotCurrent.id;
					self.setLabelMaskByDisplayList(labelNoMaskArr, false);
				}

				// Set edit mode to match hotspot.
				if (Z.labelMode != 'view') {
					self.setEditModeLabel(hotspotCurrent.mediaType, true, hotspotCurrent.media, true);
				}
			}
		}
	}

	// Zoom and pan to current hotspot.
	this.goToLabelCurrent = function () {
		self.goToLabelByID(null, hotspotCurrent);
	}

	// Zoom and pan to hotspot by ID.
	this.goToLabelByID = function (labelID, hotCurr, useInternalID) {
		if (typeof hotCurr !== 'undefined' && hotCurr !== null) {
			hotspotCurrent = hotCurr;
		} else if (typeof labelID !== 'undefined' && labelID !== null) {
			if (typeof useInternalID !== 'undefined' && useInternalID !== null && useInternalID) {
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', labelID);
			} else {
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'id', labelID);
			}
			hotspotCurrent = (index != -1) ? hotspots[index] : null;
		}

		if (hotspotCurrent) {
			var temp;
			temp = hotspotCurrent.x;
			var X = (temp == 'center') ? Z.imageCtrX : parseFloat(temp);
			temp = hotspotCurrent.y;
			var Y = (temp == 'center') ? Z.imageCtrY : parseFloat(temp);
			temp = hotspotCurrent.z;
			var Zoom = (temp == '-1') ? Z.fitZ : parseFloat(temp);
			self.zoomAndPanToView(X, Y, (Zoom / 100));
		}
	}

	this.getCurrentLabel = function () {
		return hotspotCurrent;
	}

	// This function uses hotspotCurrent rather than selectedIndex of related list as with POIs and Notes.
	this.getCurrentLabelID = function () {
		var labelIDCurrent = null;
		if (hotspotCurrent) { labelIDCurrent = hotspotCurrent.internalID; }
		return labelIDCurrent;
	}

	this.getLabelEditable = function (labelID) {
		var editable = Z.editAdmin;		
		// If true due to admin mode, no need to test specific label value.
		if (!editable) {
			var index = Z.Utils.arrayIndexOfObjectValue(labelListDP, 'value', labelID);
			if (index != -1) {
				var editVal = labelListDP[index].editable;
				editable = !(typeof editVal !== 'undefined' && editVal == false);
			}
		}
		return editable;
	}

	this.setCurrentLabel = function (labelID, useInternalID) {
		if (useInternalID) {
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', labelID);
		} else {
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'id', labelID);
		}
		if (index != -1) {
			hotspotCurrent = hotspots[index];
			hotspotCurrentID = hotspotCurrent.internalID;
			redisplayHotspots();
		}
	}

	this.getLabelXMLText = function (labelID) {
		var xmlDoc = null, xmlText = null;
		var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', labelID);
		if (index != -1) {
			var hotspot = hotspots[index];
			xmlDoc = self.convertLabelToXML(hotspot);
			xmlText = Z.Utils.xmlConvertDocToText(xmlDoc);
		}
		return xmlText;
	}

	this.getLabelJSONObject = function (labelID, useInternalID) {
		var jsonObject = null;
		if (useInternalID) {
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', labelID);
		} else {
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'id', labelID);
		}
		if (index != -1) {
			var hotspot = hotspots[index];
			jsonObject = self.convertLabelToJSON(hotspot);
		}
		return jsonObject;
	}

	function labelIconListChangeHandler (event) {
		self.toggleLabelIconPicker(false);
		var event = Z.Utils.event(event);
		var target = Z.Utils.target(event);
		var iconTypeOrPath = target[target.selectedIndex].value;

		if (Z.editMode != 'markup' && Z.editing == 'editLabel' && iconTypeOrPath != 'shim') {
			// Alternative implementation: Allow label change in markup mode.
			// if ((Z.editMode == 'markup' || (Z.editMode == 'edit' && (Z.editing == 'addLabel' || Z.editing == 'editLabel'))) && iconTypeOrPath != 'shim') {

			var media;
			switch (iconTypeOrPath) {
				case 'shim' :
					// Alternative implementation: Implement default value.
					//media = (Z.labelIconsInternal) ? 'circle' : annotationFolder + '/' + 'circle.png';
					break;
				case 'External Graphics File' :
					// DEV NOTE: Display field to enter path for external graphics file.
					break;
				default :
					media = (Z.labelIconsInternal) ? iconTypeOrPath : annotationFolder + '/' + iconTypeOrPath;
			}

			self.modifyHotspot(hotspotCurrentID, 'mediaType', 'icon', true, true);
			self.modifyHotspot(hotspotCurrentID, 'media', media, false, true);
		}
	}

	function labelCaptionPositionListChangeHandler (event) {
		var event = Z.Utils.event(event);
		var target = Z.Utils.target(event);
		var value = labelCaptionPositionListDP[target.selectedIndex].value;
		if (value !== 'shim') { self.modifyHotspot(hotspotCurrentID, 'captionPosition', value, false, true); }
	}

	function labelTargetListChangeHandler (event) {
		var event = Z.Utils.event(event);
		var target = Z.Utils.target(event);
		var value = labelTargetListDP[target.selectedIndex].value;
		if (value !== 'shim') {self.modifyHotspot(hotspotCurrentID, 'urlTarget', value, false, true); }
	}

	function rolloverCheckboxClickHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			self.modifyHotspot(hotspotCurrentID, 'rollover', target.checked, false, true);
		}
	}

	function noteListChangeHandler (event) {
		var noteID;
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			noteID = target.options[target.selectedIndex].value;
		}

		if (noteID && !isNaN(parseInt(noteID, 10))) {
			// Update XML, display elements, and choicelist.
			self.saveEditsNote(true);
			populateCurrentNoteDetails(noteID);
		}
	}

	this.getCurrentNoteID = function () {
		var noteID = null;
		if (noteList.length > 0) { noteID = noteList[noteList.selectedIndex].value; }
		return noteID;
	}

	this.getNoteEditable = function (noteID) {
		var editable = Z.editAdmin;
		// If true due to admin mode, no need to test specific note value.
		if (!editable) {
			var index = Z.Utils.arrayIndexOfObjectValue(noteListDP, 'value', noteID);
			if (index != -1) { editable = noteListDP[index].editable; }
		}
		return editable;
	}

	function annotationEditFocusHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			if (target) {
				// Ensure tab order cycles through accessible text elements.
				manageTabIndices(target.id);

				// Disable viewport key support. Also occurs in setAnnotationPanelEditability called by add and edit buttons.
				Z.Viewer.initializeViewerKeyEventListeners(false);

				// Permit page scrolling using arrow keys. Also implemented in viewerEventsHandler event handler.
				Z.Utils.removeEventListener(document, 'keydown', Z.Utils.preventDefault);
				Z.Utils.removeEventListener(document, 'keyup', Z.Utils.preventDefault);
			}
		}
	}

	function annotationEditBlurHandler (event) {
		var vpIDStr = Z.viewportCurrentID;

		// Use vp ID 0 if one panel, or actual ID if many panels.
		var vp0MIDStr = (Z.annotationFileShared) ? '0' : vpIDStr;

		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			if (target) {

				// DEV NOTE: This condition should not occur for POIs or Notes because a first POI will be automatically created
				// when needed and Notes are only displayed in Edit mode where an Add button is available if needed.
				if (labelList.options.length == 0 && (target.id == 'labelNameTextElement' + vp0MIDStr || target.id == 'captionTextElement' + vp0MIDStr || target.id == 'tooltipTextElement' + vp0MIDStr || target.id == 'clickURLTextElement' + vp0MIDStr)) {
					Z.Utils.showMessage(Z.Utils.getResource('ALERT_HOWTOCREATEFIRSTLABEL'), true, Z.messageDurationLong, 'center', true);
					return;
				}

				var property = null;
				switch (target.id) {
					case 'poiNameTextElement' + vp0MIDStr :
						var index = poiList.selectedIndex;
						poiListDP[index].text = target.value;

						var id = poiList[index].value;
						poiListDP.sort(sortAnnotationAssocArrayByField);
						Z.Utils.updateSelectElement(poiList, poiListDP, id);
						break;

					case 'labelNameTextElement' + vp0MIDStr :
						var index = labelList.selectedIndex;
						labelListCurrentDP[index].text = target.value;
						var id = labelList[index].value;
						if (typeof poiID === 'undefined' || poiID === null) { poiID = '0'; }
						var index2 = Z.Utils.arrayIndexOfObjectTwoValues(labelListDP, 'poiID', poiID, null, 'value', id);
						if (index2 != -1) {
							console.log('setting list dp');
							labelListDP[index2].text = target.value;
						}
						labelListDP.sort(sortAnnotationAssocArrayByField);
						labelListCurrentDP.sort(sortAnnotationAssocArrayByField);
						Z.Utils.updateSelectElement(labelList, labelListCurrentDP, id);
						var index3 = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
						if (index3 != -1) { hotspots[index3].name = target.value; }
						break;

					case 'captionTextElement' + vp0MIDStr :
						var value = target.value;
						if (value && value.indexOf('<CAPTION>') != -1) {
							property = 'captionHTML';
						} else {
							property = 'caption'
						}
						break;

					case 'commentTextElement' + vp0MIDStr :
						var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
						if (index != -1) { hotspots[index].comment = target.value; }
						break;

					case 'tooltipTextElement' + vp0MIDStr :
						var value = target.value;
						if (value && value.indexOf('<TOOLTIP>') != -1) {
							property = 'tooltipHTML';
						} else {
							property = 'tooltip'
						}
						break;

					case 'clickURLTextElement' + vp0MIDStr :
						property = 'clickURL'
						break;

					case 'noteNameTextElement' + vp0MIDStr :
						var index = noteList.selectedIndex;
						noteListCurrentDP[index].text = target.value;

						var poiID = noteListCurrentDP[index].poiID;
						var id = noteListCurrentDP[index].value;
						var index2 = Z.Utils.arrayIndexOfObjectTwoValues(noteListDP, 'poiID', poiID, null, 'value', id);
						if (index2 != -1) { noteListDP[index2].text = target.value; }

						noteListDP.sort(sortAnnotationAssocArrayByField);
						noteListCurrentDP.sort(sortAnnotationAssocArrayByField);
						Z.Utils.updateSelectElement(noteList, noteListCurrentDP, id);
						break;

					case 'noteTextElement' + vp0MIDStr :
						var index = noteList.selectedIndex;
						noteListCurrentDP[index].noteText = target.value;

						var poiID = noteListCurrentDP[index].poiID;
						var id = noteListCurrentDP[index].value;
						var index2 = Z.Utils.arrayIndexOfObjectTwoValues(noteListDP, 'poiID', poiID, null, 'value', id);
						if (index2 != -1) { noteListDP[index2].noteText = target.value; }
						break;
				}

				// Update hotspot display for label edits.
				if (property !== null) {
					Z.viewportCurrent.modifyHotspot(hotspotCurrentID, property, target.value, false, true);
				}
			}

			// Enable viewport key support. Also occurs in setAnnotationPanelEditability called by cancel and save buttons
			// and in initializeViewerEventListeners called on viewer initialization.
			Z.Viewer.initializeViewerKeyEventListeners(true);

			// Enable prevention of page scrolling using arrow keys. Also occurs in viewerEventsHandler event handler.
			Z.Viewer.initializeViewerKeyDefaultListeners(true);
		}
	}

	function manageTabIndices (focusTarget) {
		var vpIDStr = viewportID.toString();
		if (Z.editMode == 'markup') {
			var lnTE = document.getElementById('labelNameTextElement' + vpIDStr);
			var cTE = document.getElementById('captionTextElement' + vpIDStr);
			var comTE = document.getElementById('commentTextElement' + vpIDStr);
			var comAdj = (comTE) ? 1 : 0;
			if (lnTE && cTE) {
				switch (focusTarget) {
					case 'labelNameTextElement' + vpIDStr :
						lnTE.tabIndex = 1;
						cTE.tabIndex = 2;
						if (comTE) { comTE.tabIndex = 3; }
						break;
					case 'captionTextElement' + vpIDStr :
						lnTE.tabIndex = 3;
						cTE.tabIndex = 1;
						if (comTE) { comTE.tabIndex = 2; }
						break;
					case 'commentTextElement' + vpIDStr :
						lnTE.tabIndex = 2;
						cTE.tabIndex = 3;
						if (comTE) { comTE.tabIndex = 1; }
						break;
				}
			}
		} else if (Z.editMode !== null) {
			var pnTE = document.getElementById('poiNameTextElement' + vpIDStr);
			var lnTE = document.getElementById('labelNameTextElement' + vpIDStr);
			var cTE = document.getElementById('captionTextElement' + vpIDStr);
			var comTE = document.getElementById('commentTextElement' + vpIDStr);
			var tTE = document.getElementById('tooltipTextElement' + vpIDStr);
			var cuTE = document.getElementById('clickURLTextElement' + vpIDStr);
			var nnTE = document.getElementById('noteNameTextElement' + vpIDStr);
			var nTE = document.getElementById('noteTextElement' + vpIDStr);
			if (pnTE) { pnTE.tabIndex = ''; }
			if (lnTE) { lnTE.tabIndex = ''; }
			if (cTE) { cTE.tabIndex = ''; }
			if (comTE) { comTE.tabIndex = ''; }
			if (tTE) { tTE.tabIndex = ''; }
			if (cuTE) { cuTE.tabIndex = ''; }
			if (nnTE) { nnTE.tabIndex = ''; }
			if (nTE) { nTE.tabIndex = ''; }
			switch (focusTarget) {
				case 'poi' :
					pnTE.tabIndex = 1;
					break;
				case 'label' :
					var comAdj = (comTE) ? 1 : 0;
					lnTE.tabIndex = 1;
					cTE.tabIndex = 2;
					if (comTE) { comTE.tabIndex = 3; }
					tTE.tabIndex = 3 + comAdj;
					cuTE.tabIndex = 4 + comAdj;
					break;
				case 'note' :
					nnTE.tabIndex = 1;
					nTE.tabIndex = 2;
					break;
				case 'noteNameTextElement' :
					nnTE.tabIndex = 1;
					nTE.tabIndex = 2;
					break;
				case 'noteTextElement' :
					nnTE.tabIndex = 2;
					nTE.tabIndex = 1;
					break;
				case 'clickURLTextElement' :
					lnTE.tabIndex = 2;
					cTE.tabIndex = 3;
					tTE.tabIndex = 4;
					cuTE.tabIndex = 1;
					break;
				default :
					lnTE.tabIndex = 1;
					cTE.tabIndex = 2;
					tTE.tabIndex = 3;
					cuTE.tabIndex = 4;
			}
		}
	}

	function filterListByPOIID (dependentArray, poiID) {
		var outputArray = [];
		for (var i = 0, j = dependentArray.length; i < j; i++) {
			if (dependentArray[i].poiID == poiID) {
				outputArray[outputArray.length] = dependentArray[i];
			}
		}
		return outputArray;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::: HOTSPOT SHAPE FUNCTIONS ::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function drawShapeOnCanvas (hotspot, hC, rollover, mask, saving, saveAll) {
		var media = hotspot.media;
		var mediaType = hotspot.mediaType;
		var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
		var isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
		var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));

		if (Z.useCanvas && (isShape || mask)) {

			if (hotspot.visibility || hotspot.rollover || rollover) {

				// Select canvas to draw on.
				var ctx;
				if (mask) {
					ctx = mCtx;
				} else if ((Z.labelMode == 'view' || hotspot.internalID !== hotspotCurrentID) && !saving) {
					ctx = dCtx;
				} else if (saving) {
					ctx = sCtx;
				} else {
					ctx = eCtx;
				}

				if (ctx) {
					var shape = (typeof hotspot.media !== 'undefined' && hotspot.media !== null) ? hotspot.media : 'circle';
					var w = hotspot.iW;
					var h = hotspot.iH;
					var x = hotspot.x;
					var y = hotspot.y;
					var r = (hotspot.r) ? hotspot.r : 0;

					// Arrows and line use one shape with rotated positioning and default to down and vertical, respectively.
					var shapeSimple = (shape.indexOf('arrow') != -1) ? 'arrow' : shape.indexOf('line') != -1 ? 'line' : shape;
					if (shape != 'arrowUp' && shape != 'lineVertical') {
						switch (shape) {
							case 'arrowDownLeft' :
								r += 45;
								break;
							case 'arrowLeft' :
								r += 90;
								break;
							case 'arrowUpLeft' :
								r += 135;
								break;
							case 'arrowUp' :
								r += 180;
								break;
							case 'arrowUpRight' :
								r += 225;
								break;
							case 'arrowRight' :
								r += 270;
								break;
							case 'arrowDownRight' :
								r += 315;
								break;
							case 'lineHorizontal' :
								r += 90;
								break;
						}
					}
					shape = shapeSimple;

					// Record canvas state.
					ctx.save();

					// Temporarily change center point of canvas. Use stored zoom value to adjust only for panning, not scaling.
					var panOffsetX = (saveAll) ? Z.imageW / 2 : Z.imageX;
					var panOffsetY = (saveAll) ? Z.imageH / 2 : Z.imageY;
					ctx.translate((hotspot.x - panOffsetX) * Z.imageZ, (hotspot.y - panOffsetY) * Z.imageZ);
					x = 0;
					y = 0;

					// Temporarily change scale of canvas to implement scaling of icon.
					var zoomDelta = hC.currentZ / (hotspot.z / 100);
					var scaleDelta = tierScale / tierScalePrior;
					var scale = zoomDelta / scaleDelta;
					if (hC.constrainedScaleMin > 0 && scale < hC.constrainedScaleMin) { scale = hC.constrainedScaleMin; }
					if (hC.constrainedScaleMax > 0 && scale > hC.constrainedScaleMax) { scale = hC.constrainedScaleMax; }
					var shapeScaleX = (hotspot.xScale / 100) * scale;
					var shapeScaleY = (hotspot.yScale / 100) * scale;
					if (shapeScaleX != 1 && shapeScaleY != 1) {
						ctx.scale(shapeScaleX, shapeScaleY);
					}

					// Temporarily change line style. Scale line widths to offset zoom and maintain visibility in large images.
					if (mask) {
						ctx.lineWidth = 0.000001;
					} else {
						var testLineW = iconLineW / zoomDelta;
						ctx.lineWidth = (!hotspot.lineVisible) ? 0 : (testLineW < 8) ? testLineW : 8;
						ctx.fillStyle = hotspot.fillColor;
					}
					ctx.strokeStyle = hotspot.lineColor;

					// Rotate hotspot if XML value set but counter image rotation if icon hotpot/label.
					if (r != 0) {
						var deltaR = r - Z.imageR;
						ctx.rotate(deltaR * Math.PI / 180);
					}
					var rHot = hotspot.rotation;
					if (typeof rHot !== 'undefined' && rHot !== null && rHot != 0) {
						ctx.rotate(rHot * Math.PI / 180);
					}

					// Ensure no transparency for lines.
					ctx.globalAlpha = 1;

					// Start drawing. Arrows use two steps and handle their own beginPath below.
					if (shape != 'arrow') { ctx.beginPath(); }

					switch (shape) {
						case 'counter' : // Also circle.
							var radius = (hotspot.radius) ? hotspot.radius : w / 2;
							ctx.arc(x, y, radius, 0, 2 * Math.PI);
							break;
						case 'circle' :
							var radius = (hotspot.radius) ? hotspot.radius : w / 2;
							ctx.arc(x, y, radius, 0, 2 * Math.PI);
							break;
						case 'triangle' :
							ctx.moveTo(x, y - (h / 2));
							ctx.lineTo(x + (w / 2), y + (h / 2));
							ctx.lineTo(x - (w / 2), y + (h / 2));
							break;
						case 'square' :
							ctx.moveTo(x - (w / 2), y - (h / 2));
							ctx.lineTo(x + (w / 2), y - (h / 2));
							ctx.lineTo(x + (w / 2), y + (h / 2));
							ctx.lineTo(x - (w / 2), y + (h / 2));
							break;
						case 'line' : // Vertical assumed, width unused.
							ctx.moveTo(x, y - (h / 2));
							ctx.lineTo(x, y + (h / 2));
							break;
						case 'arrow' :  // Vertical assumed, width unused.
							ctx.fillStyle = (Z.polygonFillColor) ? Z.polygonFillColor : '#FFFFFF';
							var arrowTipEdgeLength = 30;
							var arrowTipCenterLength = 20;
							var fromX = x;
							var fromY = y - h;

							// Draw shaft stopping early to avoid flat tip due to wide line.
							var distance = Math.sqrt((fromX - x) * (fromX - x) + (fromY - y) * (fromY - y));
							var ratio = (distance - arrowTipCenterLength / 3) / distance;
							var toX = Math.round(fromX + ((x- fromX) * ratio));
							var toY = Math.round(fromY + ((y - fromY) * ratio));
							ctx.beginPath();
							ctx.moveTo(fromX, fromY);
							ctx.lineTo(toX, toY);
							ctx.stroke();

							// Draw tip with curved fill.
							var lineAngle = Math.atan2(fromY - y, 0);
							var edgeAngle = Math.PI/8;
							var angle1 = lineAngle + edgeAngle;
							var leftX = x + Math.cos(angle1) * arrowTipEdgeLength;
							var leftY = y + Math.sin(angle1) * arrowTipEdgeLength;
							var angle2 = lineAngle - edgeAngle;
							var rightX = x + Math.cos(angle2) * arrowTipEdgeLength;
							var rightY = y + Math.sin(angle2) * arrowTipEdgeLength;
							var curveX = (leftX + x + rightX) / 3;
							var curveY = (leftY + y + rightY) / 3;
							ctx.save();
							ctx.beginPath();
							ctx.moveTo(rightX, rightY); // Start right.
							ctx.lineTo(x, y); // Draw down to tip.
							ctx.lineTo(leftX, leftY); // Draw up to left.
							ctx.stroke(); // Draw lines to ensure sharp points.
							ctx.beginPath();
							ctx.lineTo(x, y); // Draw down to tip.
							ctx.lineTo(rightX, rightY); // Draw up to right.
							ctx.quadraticCurveTo(curveX, curveY, leftX, leftY); // Curve down to curveX/Y then up to left.
							ctx.fill();
							ctx.restore();
							break;
					}

					// End drawing. Arrows use two steps and handle their own strokes above.
					if (shape != 'arrow') {
						if (hotspot.fillVisible) {
							ctx.fillStyle = (hotspot.fillColor) ? hotspot.fillColor : (Z.polygonFillColor) ? Z.polygonFillColor : '#FFFFFF';
							ctx.globalAlpha = (mediaType == 'counter') ? parseFloat(Z.Utils.getResource('DEFAULT_TRACKINGALPHA')) : parseFloat(Z.Utils.getResource('DEFAULT_POLYGONALPHA'));
							ctx.fill();
						}

						if (shape != 'line') { ctx.closePath(); }
						ctx.globalAlpha = 1; // Ensure no transparency for lines.
						ctx.stroke();
					}

					// Reset canvas alpha and rotation.
					ctx.restore();
				}
			}

			// Execute callback to save image file if all labels drawn on canvas.
			if (saving) { validateDrawLabelCount(); }
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::: HOTSPOT POLYGON FUNCTIONS ::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Draw polygon on drawing canvas unless is polygon of current hotspot and it is
	// it is currently being edited, in which case, draw on editing canvas.
	function drawPolygonOnCanvas (hotspot, clickPt, rollover, mask, saving, saveAll, counter) {
		if (Z.useCanvas && (hotspot.media == 'polygon' || mask)) {
			if (hotspot.visibility || hotspot.rollover || rollover) {
				var hotspotInternalID = hotspot.internalID;

				if ((typeof hotspot.polygonPts !== 'undefined' && hotspot.polygonPts !== null && hotspot.polygonPts.length > 0) || mask) {
					// Select canvas to draw on.
					var ctx;
					if (mask) {
						ctx = mCtx;
					} else if ((hotspotInternalID !== hotspotCurrentID) && !saving) {
						ctx = dCtx;
					} else if (saving) {
						ctx = sCtx;
					} else {
						ctx = eCtx;
					}

					// Record scale and translation state to return to after temporary changes.
					ctx.save();

					// Temporarily change center point of canvas. Use stored zoom value to adjust only for panning, not scaling.
					var panOffsetX = (saveAll) ? Z.imageW / 2 : Z.imageX;
					var panOffsetY = (saveAll) ? Z.imageH / 2 : Z.imageY;
					ctx.translate((hotspot.x - panOffsetX) * Z.imageZ, (hotspot.y - panOffsetY) * Z.imageZ);

					// Temporarily change scale of canvas to implement scaling of polygon set of control points (vertices).
					var scaleDelta = tierScale / tierScalePrior;
					var zVal = self.getZoom();
					var scaleVal = ((hotspot.xScale + hotspot.yScale) / 2) / 100;

					// Calculate scaled dimensions.
					var polyScaleX = (hotspot.xScale / 100) / scaleDelta * zVal;
					var polyScaleY = (hotspot.yScale / 100) / scaleDelta * zVal;
					if (polyScaleX != 1 && polyScaleY != 1) {
						ctx.scale(polyScaleX, polyScaleY);
					}

					// Temporarily change polygon line style. Scale freehand and other polygon line widths to offset zoom and maintain visibility in large images.
					if (mask) {
						ctx.lineWidth = 0.000001;
					} else if (hotspot.mediaType == 'freehand') {
						ctx.lineWidth = polygonLineWFreehand / zVal;
					} else {
						ctx.lineWidth = (hotspot.lineVisible) ? polygonLineW / zVal / scaleVal : 0;
						ctx.fillStyle = hotspot.fillColor;
					}
					ctx.strokeStyle = hotspot.lineColor;

					// Draw polygon on canvas or draw circle on mask.
					var x = hotspot.x;
					var y = hotspot.y;
					ctx.beginPath();

					if (hotspot.polygonPts) {
						var tPolyPts = hotspot.polygonPts.slice(0);

						// Add mouse position as additional control point if measuring.
						if (Z.labelMode == 'measure' && !hotspot.polyClosed && !polygonComplete && typeof clickPt !== 'undefined' && clickPt !== null) {
							tPolyPts[tPolyPts.length] = { x:clickPt.x, y:clickPt.y };
						}

						// Draw polygon lines.
						var firstPolyPtX = tPolyPts[0].x - x;
						var firstPolyPtY = tPolyPts[0].y - y;
						ctx.moveTo(firstPolyPtX, firstPolyPtY);
						for (var i = 1, j = tPolyPts.length; i < j; i++) {
							var polyPtX = tPolyPts[i].x - x;
							var polyPtY = tPolyPts[i].y - y;
							ctx.lineTo(polyPtX, polyPtY);
						}

						// Close polygon and draw fill.
						if (hotspot.mediaType != 'freehand' && (hotspot.polyClosed || (Z.mouseIsDown && controlPointCurrent == 0))) {
							if (hotspot.polyClosed) {
								ctx.lineTo(firstPolyPtX, firstPolyPtY);
								ctx.closePath();
							}
							if (!mask && hotspot.fillVisible && (hotspot.polyClosed || hotspotInternalID != hotspotCurrentID)) {
								ctx.globalAlpha = polygonOpacity;
								ctx.fill();
							}
							ctx.globalAlpha = 1;
						}

					} else {
						// Draw circle if masking and hotspot is not of polygon type. Use 0,0 because mask canvas translated above to hotspot coordinates.
						var w = hotspot.iW * (100 / hotspot.z);
						var h = hotspot.iH * (100 / hotspot.z);
						var x = 0;
						var y = (hotspot.media.indexOf('triangle') == -1) ? 0 : (hotspot.iH * 0.23);
						var maskMargin = 1.2;
						var radius = Math.max(w, h) / 2 * maskMargin;
						ctx.arc(x, y, radius, 0, 2 * Math.PI);
					}

					ctx.stroke();

					// Draw polygon control points.
					if (!mask && ((Z.editMode === null && Z.labelMode == 'measure') || Z.editing == 'addLabel' || Z.editing == 'editLabel') && ((Z.labelMode == 'rectangle' && tPolyPts.length == 4) || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && hotspot.internalID == hotspotCurrentID && (typeof hotspot !== 'undefined' && hotspot !== null && hotspot.mediaType != 'freehand')) {
						var scaleOffset = 1 / zVal / scaleVal;
						for (var i = 0, j = tPolyPts.length; i < j; i++) {
							var polyPtX = tPolyPts[i].x - x;
							var polyPtY = tPolyPts[i].y - y;
							drawControlPoint(polyPtX, polyPtY, (!polygonComplete && i == 0), scaleOffset);
						}
					}

					// Undo temporary changes to canvas scale and center point to reset canvas
					// to base scale before scaling & drawing other polygons, tiles, etc.
					ctx.restore();
				}

				// Draw polygon caption. DEV NOTE: condition enables caption hiding when rollover polygon is hidden on mouseout.
				if (saving) {
					var hC = new HotspotContext();
					drawCaptionOnCanvas(hotspot, hC, clickPt, null, null, true, saveAll);
				} else if (Z.mouseIsDown && (!(mask && hotspot.media != 'polygon') && hotspotInternalID !== null && typeof clickPt !== 'undefined' && !hotspotDragging)) {
					captionPolygon(hotspotInternalID, clickPt, saving, saveAll);
				}
			}

			// Execute callback to save image file if all labels drawn on canvas.
			if (saving) { validateDrawLabelCount(); }

		} else {
			if (!polygonsRequireCanvasAlertShown) {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_POLYGONSREQUIRECANVAS'));
				polygonsRequireCanvasAlertShown = true;
			}
		}
	}

	function drawControlPoint (x, y, firstCtrlPt, scaleOffset) {
		var ctrlPtRadiusUnscaled = ctrlPtRadius * scaleOffset;
		eCtx.lineWidth = ctrlPtLineW * scaleOffset;
		eCtx.strokeStyle = ctrlPtStrokeColor;
		eCtx.fillStyle = (firstCtrlPt) ? firstCtrlPtFillColor : stdCtrlPtFillColor;
		eCtx.beginPath();
		eCtx.arc(x, y, ctrlPtRadiusUnscaled, 0, Math.PI * 2, false);
		eCtx.closePath();
		eCtx.globalAlpha = 0.5;
		eCtx.fill();
		eCtx.globalAlpha = 1;
		eCtx.stroke();
	}

	function drawPolygonBungeeLine (mPtX, mPtY, clickPt) {
		Z.Utils.clearDisplay(eD);
		var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
		if (hotspotCurrentIndex != -1) {
			var hotspot = hotspots[hotspotCurrentIndex];
			drawPolygonOnCanvas(hotspot);

			// Draw bungee line.
			var zVal = self.getZoom();
			var polyPts = hotspot.polygonPts;
			if (polyPts) {
				var polyPtsLast = polyPts[polyPts.length-1];
				var polyPtX = (polyPtsLast.x - Z.imageX) * zVal;
				var polyPtY = (polyPtsLast.y - Z.imageY) * zVal;
				if (!hotspot.polyClosed) {
					eCtx.lineWidth = polygonLineW;
					eCtx.strokeStyle = lineStrokeColor;
					eCtx.beginPath();
					eCtx.moveTo(polyPtX, polyPtY);
					eCtx.lineTo(mPtX, mPtY);
					eCtx.closePath();
					eCtx.stroke();
				}
			}

			if ((Z.labelMode == 'polygon' || Z.labelMode == 'measure') && hotspotCurrentID !== null) {
				captionPolygon(hotspotCurrentID, clickPt);
			}
		}
	}

	function redisplayShapesAndPolygons (rollover) {
		// First clear shapes and polygons previously drawn.
		if (dD) { Z.Utils.clearDisplay(dD); }
		if (eD) { Z.Utils.clearDisplay(eD); }

		// Redraw polygons in view if hotspots (label display layer) not hidden by call to function setHotspotsVisibility.
		// Add polygonViewBuffer to ensure polygons partially in view are displayed.
		// If zHotspotsDrawOnlyInView parameter set to false, draw all polygons.
		if (hS.display == 'inline-block') {
			var hC = new HotspotContext();
			for (var i = 0, j = hotspots.length; i < j; i++) {
				var hotspot = hotspots[i];

				// Validate zoom visibility range.
				var zoom = Math.round(hC.currentZ * 100);
				var zMin = (hotspot.zMin == -1) ? Math.round(Z.initialZ * 100) : Math.round(hotspot.zMin);
				var zMax = (hotspot.zMax == -1) ? Math.round(Z.initialZ * 100) : Math.round(hotspot.zMax);
				if ((zMin == 0 || zMin <= zoom) && (zMax == 0 || zMax >= zoom)) {

					var media = hotspot.media;
					var mediaType = hotspot.mediaType;
					var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
					var isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
					var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
					var isPolygon = (media && media == 'polygon');
					if (hotspot.visibility && (isPolygon || isShape)) {
						if (rollover || !(Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') || typeof hotspotCurrentID === 'undefined' || hotspotCurrentID === null || hotspotCurrentID !== i) {
							var x = hotspot.x, y = hotspot.y;
							if (!Z.hotspotsDrawOnlyInView || ((x + polygonViewBuffer) > hC.box.l && (x - polygonViewBuffer) < hC.box.r && (y + polygonViewBuffer) > hC.box.t && (y - polygonViewBuffer) < hC.box.b)) {
								if (isShape) {
									drawShapeOnCanvas(hotspot, hC, rollover, null, null, null);
								} else if (isPolygon) {
									drawPolygonOnCanvas(hotspot, null, rollover);
								}
							}
						}
					}
				}
			}
		}
	}

	function drawFreehand (fromX, fromY, toX, toY, clickPt) {
		// Draw freehand segment on canvas.
		eCtx.lineWidth = polygonLineWFreehand;
		eCtx.strokeStyle = lineStrokeColor;
		eCtx.beginPath();
		eCtx.moveTo(fromX, fromY);
		eCtx.lineTo(toX, toY);
		eCtx.closePath();
		eCtx.stroke();
		eCtx.strokeStyle = ctrlPtStrokeColor;

		// Record freehand path as control points by distance traveled in pixels.
		var ctrlPtDensity = 2;
		var dragDist = Z.Utils.calculatePointsDistance(fromX, fromY, toX, toY);
		if (dragDist > ctrlPtDensity) {
			createControlPoint(hotspotCurrentID, false, clickPt);
		}

		// Draw all hotspots to clear canvas if freehand complete.
		if (!Z.mouseIsDown) { redisplayHotspots(); }
	}

	function updatePolygon (hotspotInternalID, ctrlPtIndex, clickPt) {
		controlPointDragging = true;
		Z.Utils.clearDisplay(eD);
		var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
		if (hotspotCurrentIndex != -1) {
			var hotspot = hotspots[hotspotCurrentIndex];
			hotspot.polygonPts[ctrlPtIndex] = clickPt;

			// Update three related control points if editing drag rect.
			var polyPts = hotspot.polygonPts.length;
			if (polyPts == 4 && (zoomRectangleDragging || Z.labelMode == 'rectangle')) {
				hotspot.polygonPts = updateRectangleControlPoints(hotspot.polygonPts, ctrlPtIndex);
			}
			drawPolygonOnCanvas(hotspot, clickPt);
		}
	}

	function updateRectangleControlPoints (ptsArray, ctrlPtIndex) {
		// Master (clicked) control point updated in calling function. Get values.
		var masterIndex = ctrlPtIndex;
		var masterX = ptsArray[masterIndex].x;
		var masterY = ptsArray[masterIndex].y;

		// Anchor (diagonally opposed, -2) control point requires no change.
		var anchorIndex = ctrlPtIndex - 2;
		if (anchorIndex < 0) { anchorIndex += 4; }

		// Dependent control points are left or up from master and right or down.
		var dependentCounterwise = ctrlPtIndex - 1;
		if (dependentCounterwise < 0) { dependentCounterwise += 4; }
		var dependentClockwise = ctrlPtIndex + 1;
		if (dependentClockwise > 3) { dependentClockwise -= 4; }

		// Dependent control points (-1 and +1) match either x or y of master.
		if (dependentCounterwise == 1 || dependentCounterwise == 3) {
			// Upper right or bottom left.
			ptsArray[dependentCounterwise].x = masterX;
			ptsArray[dependentClockwise].y = masterY;
		} else {
			// Upper left or bottom right.
			ptsArray[dependentClockwise].x = masterX;
			ptsArray[dependentCounterwise].y = masterY;
		}

		return ptsArray;
	}

	function polygonClickHandler (event, clickPt, isDblClick) {
		var event = Z.Utils.event(event);
		var isRightMouseBtn = (event) ? Z.Utils.isRightMouseButton(event) : null;
		var isAltKey = (event) ? event.altKey : null;

		if (typeof hotspotCurrentID === 'undefined' || hotspotCurrentID === null) {
			// Failsafe clause. No current hotspot. No polygon. Clicked off control points. Create hotspot, polygon, and control point.  Make current.
			createControlPoint(null, true, clickPt);

		} else {
			var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
			if (hotspotCurrentIndex != -1) {
				var hotspot = hotspots[hotspotCurrentIndex];
				polygonCurrentPts = hotspot.polygonPts;
				var polygonClosed = hotspot.polyClosed;
				if (polygonCurrentPts === null) {
					// Current hotspot. No polygon. Clicked off control points (none). Create polygon and control point.
					createControlPoint(hotspotCurrentID, true, clickPt);
					captionPolygon(hotspotCurrentID, clickPt);

				} else {
					controlPointCurrent = getClickedControlPoint(event, clickPt);
					if (!polygonClosed) {
						if (controlPointCurrent === null) {
							if (!isAltKey && !isRightMouseBtn && !isDblClick) {
								// Current hotspot. Existing polygon. Unclosed. Clicked off control points. Create control point in current polygon including freehand drawings.
								createControlPoint(hotspotCurrentID, false, clickPt);

							} else {
								// Current hotspot. Existing polygon. Unclosed. Clicked off control points. Alt key pressed or right-click. Create control point in current polygon and complete polygon.
								createControlPoint(hotspotCurrentID, false, clickPt);
								completePolygon(hotspotCurrentID, false);
							}

						} else {
							if (controlPointCurrent == 0 && polygonCurrentPts.length > 2 && !polygonComplete) {
								// Current hotspot. Existing polygon. Unclosed and not complete. Clicked first control point. Close polygon.
								completePolygon(hotspotCurrentID, true);
							}
						}

					} else if (controlPointCurrent === null) {
						// Current hotspot. Existing polygon. Closed. Clicked off control points. Create new hotspot, polygon, and control point.  Make current.
						createControlPoint(null, true, clickPt);
					}
				}
			}
		}

		if (!isAltKey || (Z.labelMode == 'measure' && hotspotCurrentID !== null)) {
			captionPolygon(hotspotCurrentID, clickPt);
		}
	}

	function createControlPoint (hotspotInternalID, polygonRedisplay, clickPt) {
		var hotspot; // Defined outside conditions below to apply to all and be accessible to control point drawing condition below.
		var firstCtrlPt = false;
		var fullRedisplay = false;
		if (typeof hotspotInternalID === 'undefined' || hotspotInternalID === null || ((Z.editing === null || Z.editing == 'addLabel') && polygonComplete && (Z.labelMode == 'polygon' || Z.labelMode == 'measure'))) {
			// If measuring while not in edit mode be sure to delete any hotspot polygons previously created to display a measurement.
			if (Z.editMode === null && Z.labelMode == 'measure' &&  hotspots.length > 0) { self.deleteAllMeasureHotspots(); }

			// Create new polygon hotspot and update labels interface.
			var mediaType = (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') ? Z.labelMode : null;
			var capPos = '8'; // Alternative implementation: var capPos = (Z.labelMode == 'measure') ? '5' : '8';
			var polygonPts = [];
			polygonPts[0] = { x:clickPt.x, y:clickPt.y };
			var poiID = (typeof poiList !== 'undefined' && poiList.options.length > 0) ? poiID = poiList.options[poiList.selectedIndex].value : 1;

			// DEV NOTE: Hotspot created at current zoom for caption size and zoom-to-view but all polygons drawn at 100% zoom to preserve meaningfulness of polygon point coordinates, simplify polygon point management, and remain consistent with prior versions.
			var zValStr = (self.getZoom() * 100).toString();
			self.createHotspotFromParameters(null, null, mediaType, 'polygon', null, clickPt.x.toString(), clickPt.y.toString(), zValStr, null, null, null, '0', '0', null, null, null, null, null, captionTextColor, null, lineStrokeColor, null, null, null, null, null, capPos, '0', null, poiID, null, null, '0', polygonPts, null, null, null, null, '1', null, null, null);
			var hotspot = hotspots[hotspots.length - 1];
			hotspotCurrentID = hotspot.internalID;
			updateLabelsForHotspot(hotspot, hotspot.poiID);
			fullRedisplay = true;
			firstCtrlPt = true;

		} else {
			var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
			if (hotspotCurrentIndex != -1) {
				var hotspot = hotspots[hotspotCurrentIndex];
				var polyPts = (hotspot.polygonPts) ? hotspot.polygonPts : [];
				polyPts[polyPts.length] = { x:clickPt.x, y:clickPt.y };
				hotspot.polyClosed = false;
				hotspot.polygonPts = polyPts;
				hotspot.saved = false;
			}
		}

		// Drawing control point standard, conditions added.
		if ((Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && (typeof hotspot !== 'undefined' && hotspot !== null && hotspot.mediaType != 'freehand')) {
			var zVal = self.getZoom();
			var polyPtX = (clickPt.x - Z.imageX) * zVal;
			var polyPtY = (clickPt.y - Z.imageY) * zVal;
			drawControlPoint(polyPtX, polyPtY, firstCtrlPt, 1);
		}
		if (Z.labelMode != 'rectangle' && Z.labelMode != 'freehand') {
			polygonComplete = false;
		}

		// Redisplay of hotspots occurs if new hotspot created to contain new polygon.
		// Redisplay of polygons occurs to redraw all polygons and control points in order
		// to reselect current polygon, remove control points from any prior current polygon,
		// and move prior current polygon to drawing canvas from editing canvas, and move
		// new current polygon to editing canvas.
		if (fullRedisplay) {
			redisplayHotspots();
		} else if (polygonRedisplay) {
			redisplayShapesAndPolygons();
		}
	}

	function getClickedControlPoint (event, clickPt) {
		var polygonCtrlPtIndex = null;
		var ctrlPtRadiusScaled = (ctrlPtRadius + 1) / Z.imageZ;
		for (var i = 0, j = hotspots.length; i < j; i++) {
			if (hotspots[i].media == 'polygon' && hotspots[i].internalID == hotspotCurrentID) {
				var polyPts = hotspots[i].polygonPts;
				if (typeof polyPts !== 'undefined' && polyPts !== null) {
					for (var k = 0, m = polyPts.length; k < m; k++) {
						if (Z.Utils.calculatePointsDistance(clickPt.x, clickPt.y, polyPts[k].x, polyPts[k].y) < ctrlPtRadiusScaled) {
							polygonCtrlPtIndex = k;
						}
					}
				}
			}
		}
		return polygonCtrlPtIndex;
	}

	function completePolygon (hotspotInternalID, closePoly) {
		Z.Utils.clearDisplay(eD);

		var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
		hotspots[hotspotCurrentIndex].polyClosed = closePoly;
		polygonComplete = true;

		if (hotspotCurrentIndex != -1) {
			var hotspot = hotspots[hotspotCurrentIndex];
			var polyCenter = Z.Utils.polygonCenter(hotspot.polygonPts, hotspot.polyClosed);
			hotspot.x = polyCenter.x;
			hotspot.y = polyCenter.y;

			if (!zoomRectangleDragging && Z.labelMode != 'view' && Z.labelMode != 'freehand' && hotspot.caption == '' && typeof hotspot.captionHTML === 'undefined') {
				var placeHolderCaptionPolyText = Z.Utils.getResource('CONTENT_POLYGONCAPTION');
				hotspot.caption = placeHolderCaptionPolyText + hotspotInternalID.toString();
			}
			var hC = new HotspotContext();
			displayHotspot(hotspot, hC);
		}
	}

	function captionPolygon (hotspotInternalID, clickPt, saving, saveAll) {
		var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
		if (hotspotCurrentIndex != -1) {
			var hotspot = hotspots[hotspotCurrentIndex];
			var captionText = '';

			// If currently measuring calculate values and create caption, otherwise use stored caption calculations.
			if (!zoomRectangleDragging && Z.labelMode != 'view') {
				if (Z.labelMode == 'measure' && hotspot.mediaType == 'measure') {
					setHotspotCaptionMeasure(hotspot, clickPt);
				} else if (Z.labelMode != 'freehand' && hotspot.mediaType != 'freehand' && hotspot.caption == '' && typeof hotspot.captionHTML === 'undefined') {
					var placeHolderCaptionPolyText = Z.Utils.getResource('CONTENT_POLYGONCAPTION');
					hotspot.caption = placeHolderCaptionPolyText + hotspotInternalID.toString();
				}
			}

			// Calculate center, dimensions, and position for caption.
			var polygonClosed = hotspot.polyClosed;
			var polyPts = (hotspot.polygonPts) ? hotspot.polygonPts.slice(0) : [];
			var polyCenter = Z.Utils.polygonCenter(polyPts, polygonClosed, clickPt);
			var polyDimensions = Z.Utils.polygonDimensions(polyPts, clickPt);
			hotspot.x = polyCenter.x;
			hotspot.y = polyCenter.y;
			hotspot.iW = polyDimensions.x;
			hotspot.iH = polyDimensions.y;
			var hC = new HotspotContext();

			// Draw polygon if dragging control point, or hotspot if freehand incomplete.
			if (hotspotDragging) {
				positionPolygonCaption(hotspot, hC);
			} else if (saving) {
				drawCaptionOnCanvas(hotspot, hC, clickPt, null, null, true, saveAll);
			} else {
				drawHotspotInHTML(hotspot, hC, clickPt, true);
			}
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::: ANNOTATION EDITING FUNCTIONS ::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.toggleEditMode = function () {
		var togglePanel = false;
		if (Z.editMode !== null) {
			poiVisibility = poiVisibilityXML;
			labelVisibility = labelVisibilityXML;
			commentVisibility = commentVisibilityXML;
			noteVisibility = noteVisibilityXML;
			Z.editMode = null;
			Z.measureVisible = false;
			self.saveAnnotations(true, true, null);
			togglePanel = true;
		} else {
			if (typeof Z.parameters !== 'undefined' && Z.parameters !== null) {
				if (Z.parameters.zEditMode !== 'undefined' && (Z.parameters.zEditMode == '1' || Z.parameters.zEditMode == '2')) {
					Z.editMode = 'edit';
					togglePanel = true;
				} else if (typeof Z.parameters.zMarkupMode !== 'undefined' && (Z.parameters.zMarkupMode == '1' || Z.parameters.zMarkupMode == '2')) {
					poiVisibility = labelVisibility = noteVisibility = false;
					Z.editMode = 'markup';
					togglePanel = true;
				}
				Z.measureVisible = (typeof Z.parameters.zEditMode !== 'undefined' && Z.parameters.zMeasureVisible == '0');
			}
		}
		if (Z.Toolbar && togglePanel) { Z.Toolbar.toggleAnnotationPanelMode(Z.editMode); }
	}

	this.setEditModeLabel = function (mode, syncUIToLabel, media, hideList) {
		var vpIDStr = viewportID.toString();

		var priorMode = Z.labelMode;
		Z.labelMode = mode;

		// Remove mouse movement event handlers previously assigned, if any.
		Z.Utils.removeEventListener(document, 'mousemove', viewportEventsHandler);
		Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler);

		if (mode != 'view' || Z.editMode !== null) {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_HOWTOEDITMODE' + mode.toUpperCase()), false, Z.messageDurationLong, 'center', true); // Alternative implementation: + Z.Utils.getResource('ALERT_HOWTOHELPREMINDER'), true, Z.messageDurationLong, 'center', true);
		}
		if (Z.overlayMessage) { Z.overlayMessage.parentNode.style.display = 'none'; }
		if (Z.editMode == 'edit' && Z.editing == 'editLabel') {
			self.modifyHotspot(hotspotCurrentID, 'mediaType', mode, true, true);
			if (mode == 'freehand') {
				if (priorMode != 'freehand') { self.modifyHotspot(hotspotCurrentID, 'polygonPts', null, true, true); }
				self.modifyHotspot(hotspotCurrentID, 'image', null, true, true);
				self.modifyHotspot(hotspotCurrentID, 'closed', 'false', true, true);
				self.modifyHotspot(hotspotCurrentID, 'media', 'polygon', false, true);

			} else if (mode == 'text') {
				self.modifyLabel(hotspotCurrentID, 'image', null, true, true);
				self.modifyLabel(hotspotCurrentID, 'captionPosition', '5', true, true);
				self.modifyLabel(hotspotCurrentID, 'media', null, false, true);

			} else if (mode == 'icon') {
				var iconList = document.getElementById('labelIconList' + vpIDStr);
				if (iconList) {
					if (hideList && priorMode != 'icon' && iconList.selectedIndex > 0) { hideList = true; }
					var iconTypeOrPath = iconList[iconList.selectedIndex].value;
					var media;
					switch (iconTypeOrPath) {
						case 'shim' :
							media = (Z.labelIconsInternal) ? 'circle' : annotationFolder + '/' + 'circle.png';
							break;
						case 'External Graphics File' :
							media = iconTypeOrPath;
							break;
						default :
							media = (Z.labelIconsInternal) ? iconTypeOrPath : annotationFolder + '/' + iconTypeOrPath;
					}
					self.modifyHotspot(hotspotCurrentID, 'media', media, false, true);
				}

			} else if (mode == 'rectangle') {
				var polyPtsFour = (hotspotCurrent && hotspotCurrent.polygonPts && hotspotCurrent.polygonPts.length == 4);
				if (polyPtsFour && (priorMode == 'polygon' || priorMode == 'measure')) {
					var polyPts = updateRectangleControlPoints(hotspotCurrent.polygonPts, 0);
					self.modifyHotspot(hotspotCurrentID, 'polygonPts', polyPts, true, true);
					var polyPts = updateRectangleControlPoints(hotspotCurrent.polygonPts, 1);
					self.modifyHotspot(hotspotCurrentID, 'polygonPts', polyPts, true, true);
					var polyPts = updateRectangleControlPoints(hotspotCurrent.polygonPts, 2);
					self.modifyHotspot(hotspotCurrentID, 'polygonPts', polyPts, true, true);
					var polyPts = updateRectangleControlPoints(hotspotCurrent.polygonPts, 3);
					self.modifyHotspot(hotspotCurrentID, 'polygonPts', polyPts, true, true);
				} else {
					self.modifyHotspot(hotspotCurrentID, 'polygonPts', null, true, true);
				}
				self.modifyHotspot(hotspotCurrentID, 'image', null, true, true);
				self.modifyHotspot(hotspotCurrentID, 'media', 'polygon', false, true);
				var polyPtsExist = (hotspotCurrent && hotspotCurrent.polygonPts && hotspotCurrent.polygonPts.length > 0);
				if (polyPtsExist) {
					var clickPt = new Z.Utils.Point(hotspotCurrent.polygonPts[0].x, hotspotCurrent.polygonPts[0].y);
					captionPolygon(hotspotCurrentID, clickPt);
				}

			} else if (mode == 'polygon') {
				if (priorMode != 'view' && priorMode != 'rectangle' && priorMode != 'polygon' && priorMode != 'measure') {
					self.modifyHotspot(hotspotCurrentID, 'polygonPts', null, true, true);
				}
				self.modifyHotspot(hotspotCurrentID, 'image', null, true, true);
				self.modifyHotspot(hotspotCurrentID, 'media', 'polygon', false, true);

			} else if (mode == 'measure') {
				var polyPtsExist = (hotspotCurrent && hotspotCurrent.polygonPts && hotspotCurrent.polygonPts.length > 0);
				if (polyPtsExist && priorMode != 'rectangle' && priorMode != 'polygon' && priorMode != 'measure') {
					self.modifyHotspot(hotspotCurrentID, 'polygonPts', null, true, true);
				}
				self.modifyHotspot(hotspotCurrentID, 'image', null, true, true);
				self.modifyHotspot(hotspotCurrentID, 'media', 'polygon', false, true);
				if (polyPtsExist) {
					var clickPt = new Z.Utils.Point(hotspotCurrent.polygonPts[0].x, hotspotCurrent.polygonPts[0].y);
					captionPolygon(hotspotCurrentID, clickPt);
				}

			}
		}

		// Select edit button for selected label.
		if (Z.Toolbar && Z.annotationPanelVisible != 0) {
			if (Z.editMode !== null) {
				var tbID = (mode == 'view') ? 'buttonViewMode'  + vpIDStr : 'buttonEditMode' + Z.Utils.stringUpperCaseFirstLetter(mode) + vpIDStr;
				Z.Toolbar.positionButtonBorder(tbID);
			} else if (Z.measureVisible) {
				var bM = document.getElementById('buttonMeasure' + vpIDStr);
				var bME = document.getElementById('buttonMeasureExit' + vpIDStr);
				if (bM && bME) {
					bM.style.display = (Z.labelMode == 'measure') ? 'none' : 'inline-block';
					bME.style.display = (Z.labelMode == 'measure') ? 'inline-block' : 'none';
				}
			}

			// Hide icon list if not in icon edit mode or if changing labels due to label list,
			// otherwise, if label mediaType is icon, select icon list item to match label media.
			self.toggleLabelIconPicker((mode == 'icon' && !hideList));

			if (syncUIToLabel) {
				if (mode == 'icon' && typeof iconMedia !== 'undefined' && Z.Utils.stringValidate(iconMedia)) {
					var iconList = document.getElementById('labelIconList' + vpIDStr);
					if (iconList) {
						var start = iconMedia.lastIndexOf('/') + 1;
						var end = iconMedia.lastIndexOf('.');
						if (start != -1 && end != -1) {
							var iconType = iconMedia.substring(start, end).toLowerCase();
							var index = Z.Utils.arrayIndexOfObjectValueSubstring(iconList, 'value', iconType, null, true);
							if (index != -1) { iconList.selectedIndex = index; }
						}
					}
				}
			}
		}

		controlPointCurrent = null;
		polygonCurrentPts = null;
		controlPointDragging = false;
		polygonComplete = true;
		if (!hotspotDragging) {
			redisplayHotspots();
		} else {
			redisplayShapesAndPolygons();
		}
	}

	this.getEditability = function (annotElement, mode) {
		var isEditable = true;
		var nonEditablePOI = !self.getPOIEditable(self.getCurrentPOIID());
		var nonEditableLabel = !self.getLabelEditable(self.getCurrentLabelID());
		var nonEditableNote = !self.getNoteEditable(self.getCurrentNoteID());
		if (nonEditablePOI) {
			if (annotElement == 'poi' && mode == 'edit') {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_NONEDITABLEPOI'), false, Z.messageDurationShort, 'center');
				isEditable = false;
			} else if (annotElement == 'label') {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_NONEDITABLELABELPOI'), false, Z.messageDurationShort, 'center');
				isEditable = false;
			} else if (annotElement == 'note') {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_NONEDITABLENOTEPOI'), false, Z.messageDurationShort, 'center');
				isEditable = false;
			}

		} else if (annotElement == 'label' && mode == 'edit' && nonEditableLabel) {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_NONEDITABLELABEL'), false, Z.messageDurationShort, 'center');
			isEditable = false;

		} else if (annotElement == 'note' && mode == 'edit' && nonEditableNote) {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_NONEDITABLENOTE'), false, Z.messageDurationShort, 'center');
			isEditable = false;

		}

		return isEditable;
	}

	function setAnnotationPanelEditability (annotElement, editing) {
		// If element is set non-editable individually prevent entry into edit mode.
		var vpIDStr = viewportID.toString();

		// Use vp ID 0 if one panel, or actual ID if many panels.
		var vp0MIDStr = (Z.annotationFileShared) ? '0' : vpIDStr;

		// Set unsaved edits tracking variable to trigger XML comparison on leaving page.
		Z.editing = editing;

		// Set button display states.
		var addEdit = (editing !== null) ?  'none' : 'inline-block';
		var delCanSave = (editing !== null || Z.editMode == 'markup') ? 'inline-block' : 'none';
		switch (annotElement) {
			case 'poi' :
				var btnAdd = document.getElementById('buttonPOIAdd' + vp0MIDStr);
				var btnEdit = document.getElementById('buttonPOIEdit' + vp0MIDStr);
				var btnDelete = document.getElementById('buttonPOIDelete' + vp0MIDStr);
				var btnCancel = document.getElementById('buttonPOICancel' + vp0MIDStr);
				var btnSave = document.getElementById('buttonPOISave' + vp0MIDStr);
				break;
			case 'labelPartial' :
				var btnAdd = document.getElementById('buttonLabelAdd' + vp0MIDStr);
				var btnEdit = document.getElementById('buttonLabelEdit' + vp0MIDStr);
				var btnDelete = document.getElementById('buttonLabelDelete' + vp0MIDStr);
				var btnCancel = document.getElementById('buttonLabelCancel' + vp0MIDStr);
				var btnSave = document.getElementById('buttonLabelSave' + vp0MIDStr);
				break;
			case 'label' :
				var btnAdd = document.getElementById('buttonLabelAdd' + vp0MIDStr);
				var btnEdit = document.getElementById('buttonLabelEdit' + vp0MIDStr);
				var btnDelete = document.getElementById('buttonLabelDelete' + vp0MIDStr);
				var btnCancel = document.getElementById('buttonLabelCancel' + vp0MIDStr);
				var btnSave = document.getElementById('buttonLabelSave' + vp0MIDStr);
				break;
			case 'note' :
				var btnAdd = document.getElementById('buttonNoteAdd' + vp0MIDStr);
				var btnEdit = document.getElementById('buttonNoteEdit' + vp0MIDStr);
				var btnDelete = document.getElementById('buttonNoteDelete' + vp0MIDStr);
				var btnCancel = document.getElementById('buttonNoteCancel' + vp0MIDStr);
				var btnSave = document.getElementById('buttonNoteSave' + vp0MIDStr);
				break;
		}

		if (btnAdd) {
			Z.Utils.setButtonDefaults(btnAdd);
			btnAdd.style.display = addEdit;
		}
		if (btnEdit) {
			Z.Utils.setButtonDefaults(btnEdit);
			btnEdit.style.display = addEdit;
		}
		if (btnDelete) {
			Z.Utils.setButtonDefaults(btnDelete);
			btnDelete.style.display = delCanSave;
		}
		if (btnCancel) {
			Z.Utils.setButtonDefaults(btnCancel);
			btnCancel.style.display = delCanSave;
		}
		if (btnSave) {
			Z.Utils.setButtonDefaults(btnSave);
			btnSave.style.display = delCanSave;
		}

		// Set overlay display states.
		var oPD = document.getElementById('overlayPOIDisable' + vp0MIDStr);
		var oLD = document.getElementById('overlayLabelDisable' + vp0MIDStr);
		var oLDD = document.getElementById('overlayLabelDetailDisable' + vp0MIDStr);
		var oLDED = document.getElementById('overlayLabelDetailEditableDisable' + vp0MIDStr);

		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');

		var tbOMB = document.getElementById('textBoxFor-overlayMessageBox' + vp0MIDStr);

		var oLNED = document.getElementById('overlayLabelNameEditableDisable' + vp0MIDStr);
		var oLCPD = document.getElementById('overlayLabelCaptionPositionDisable' + vp0MIDStr);
		var oND = document.getElementById('overlayNoteDisable' + vp0MIDStr);
		var oNDD = document.getElementById('overlayNoteDetailDisable' + vp0MIDStr);

		var tbPN = document.getElementById('textBoxFor-poiNameTextElement' + vp0MIDStr);
		var tbLN = document.getElementById('textBoxFor-labelNameTextElement' + vp0MIDStr);
		var comTE = document.getElementById('commentTextElement' + vp0MIDStr);
		var tbNN = document.getElementById('textBoxFor-noteNameTextElement' + vp0MIDStr);
		var nTE = document.getElementById('noteTextElement' + vp0MIDStr);

		if (oPD && oLD && oLDD && oLDED && oLNED && oLCPD && oNDD && tbPN && tbLN && tbNN && nTE) {
			if (editing === null) {
				Z.Viewer.initializeViewerKeyEventListeners(true);
				oPD.style.display = 'none';
				oLD.style.display = 'none';
				oLDD.style.display = 'inline-block';
				oLDED.style.display = 'none';
				Z.Utils.setOpacity(oLDED, backAlpha, backColorNoAlpha);
				if (tbOMB) { tbOMB.style.display = 'none'; }
				oLNED.style.display = 'none';
				oLCPD.style.display = 'none';
				oND.style.display = 'none';
				oNDD.style.display = 'inline-block';
				tbPN.style.visibility = 'hidden';
				tbLN.style.visibility = 'hidden';
				tbNN.style.visibility = 'hidden';
				if (comTE) { comTE.readOnly = true; }
				nTE.readOnly = true;
			} else {
				switch (annotElement) {
					case 'poi' :
						tbPN.style.visibility = 'visible';
						oLD.style.display = 'inline-block';
						oLDD.style.display = 'none';
						oND.style.display = 'inline-block';
						oNDD.style.display = 'none';
						break;
					case 'labelPartial' :
						oLDD.style.display = 'none';
						oLDED.style.display = 'inline-block';
						Z.Utils.setOpacity(oLDED, backAlpha, backColorNoAlpha);
						if (tbOMB) { tbOMB.style.display = 'inline-block'; }
						oLNED.style.display = 'inline-block';
						oLCPD.style.display = (Z.labelMode == 'text') ? 'inline-block' : 'none';
						tbLN.style.visibility = 'visible';
						oPD.style.display = 'inline-block';
						oND.style.display = 'inline-block';
						oNDD.style.display = 'none';
						break;
					case 'label' :
						oLDD.style.display = 'none';
						oLDED.style.display = 'none';
						Z.Utils.setOpacity(oLDED, backAlpha, backColorNoAlpha);
						if (tbOMB) { tbOMB.style.display = 'none'; }
						// Alternative implementation: Simple freehand labels without captions and other features.
						//oLDED.style.display = (Z.labelMode == 'freehand') ? 'inline-block' : 'none';
						oLNED.style.display = 'none';
						oLCPD.style.display = (Z.labelMode == 'text') ? 'inline-block' : 'none';
						tbLN.style.visibility = 'visible';
						oPD.style.display = 'inline-block';
						oND.style.display = 'inline-block';
						oNDD.style.display = 'none';
						if (comTE) { comTE.readOnly = false; }
						break;
					case 'note' :
						oPD.style.display = 'inline-block';
						oLD.style.display = 'inline-block';
						oLDD.style.display = 'none';
						oNDD.style.display = 'none';
						tbNN.style.visibility = 'visible';
						nTE.readOnly = false;
						break;
				}
				manageTabIndices(annotElement);
			}
		}
	}

	this.toggleLabelColorPicker = function (override) {
		var vp0MIDStr = (Z.annotationFileShared) ? '0' : viewportID.toString();
		var bCLC = document.getElementById('buttonContainerLabelColors' + vp0MIDStr);
		if (bCLC) {
			var showing = (bCLC.style.display == 'inline-block');
			var show = (typeof override !== 'undefined' && override !== null) ? override : !showing;
			bCLC.style.display = (show) ? 'inline-block' : 'none';
		 }
	}

	this.setDrawingColor = function (buttonName, override) {
		var vp0MIDStr = (Z.annotationFileShared) ? '0' : viewportID.toString();
		if (Z.editMode != 'markup') { self.toggleLabelColorPicker(false); }
		var newColor;
		switch(buttonName) {
			case 'buttonColor0' + vp0MIDStr:
				newColor = '#FFFFFF';  // White.
				break;
			case 'buttonColor1' + vp0MIDStr:
				newColor = '#FFFF00';  // Yellow.
				break;
			case 'buttonColor2' + vp0MIDStr:
				newColor = '#00FFFF';  // Aqua.
				break;
			case 'buttonColor3' + vp0MIDStr:
				newColor = '#800080';  // Purple.
				break;
			case 'buttonColor4' + vp0MIDStr:
				newColor = '#008000';  // Green.
				break;
			case 'buttonColor5' + vp0MIDStr:
				newColor = '#FF0000';  // Red.
				break;
			case 'buttonColor6' + vp0MIDStr:
				newColor = '#0000FF';  // Blue.
				break;
			case 'buttonColor7' + vp0MIDStr:
				newColor = '#000000';  // Black,
				break;
		}

		ctrlPtStrokeColor = lineStrokeColor = newColor;
		if (Z.markupMode || Z.editMode) { captionTextColor = newColor; }
		var newBackColor = (newColor == '#FFFFFF') ? '#000000' : '#FFFFFF';

		// If editing, modify current hotspot's relevant properties.
		if (!override && hotspotCurrentID !== null && Z.editMode == 'edit' && (Z.editing == 'addLabel' || Z.editing == 'editLabel')) {
			self.modifyHotspot(hotspotCurrentID, 'textColor', newColor, true, true);
			self.modifyHotspot(hotspotCurrentID, 'backColor', newBackColor, true, true);
			self.modifyHotspot(hotspotCurrentID, 'lineColor', newColor, false, true);
		}
	}

	this.toggleLabelIconPicker = function (override) {
		var bCLI = document.getElementById('buttonContainerLabelIcons' + viewportID.toString());
		if (bCLI) {
			var showing = (bCLI.style.display == 'inline-block');
			var show = (typeof override !== 'undefined' && override !== null) ? override : !showing;
			bCLI.style.display = (show) ? 'inline-block' : 'none';
		 }
	}

	this.addNewPOI = function () {
		if (self.getEditability('poi', 'add')) {
			poiPriorID = (poiList.options.length > 0) ? poiList.options[poiList.selectedIndex].value : 0;
			savePoint('save', 'pois');
			createPOIFromParameters();
			var newPOI = poiListDP[poiListDP.length - 1];
			populatePOIs(newPOI.value);
			setAnnotationPanelEditability('poi', 'addPOI');
		}
	}

	this.editCurrentPOI = function () {
		if (self.getEditability('poi', 'edit')) {
			poiPriorID = poiList.options[poiList.selectedIndex].value;
			savePoint('save', 'pois');
			setAnnotationPanelEditability('poi', 'editPOI');
		}
	}

	this.deleteCurrentPOI = function () {
		setAnnotationPanelEditability('poi', null);
		if (typeof poiList !== 'undefined' && poiList !== null && poiList.options.length > 0) {
			var index = (poiList.selectedIndex != -1) ? poiList.selectedIndex : 0;
			var poiID = poiList[poiList.selectedIndex].value;
			var poiIndex = Z.Utils.arrayIndexOfObjectValue(poiListDP, 'value', poiID);
			if (poiIndex != -1) { poiListDP = Z.Utils.arraySplice(poiListDP, poiIndex, 1); }
			if (poiListDP.length > 0) {
				var indexLast = poiListDP.length - 1;
				index = (index <= indexLast) ? index : indexLast;
				var poiID = poiListDP[index].value;
			} else {
				poiID = null;
			}
			populatePOIs(poiID);
			poiPriorID = (poiList.options.length > 0) ? poiList.options[poiList.selectedIndex].value : 0;
			savePoint('save', 'pois');
		}
		//self.saveAnnotations(true, true, 'poi');
		self.saveAnnotations(true, false, 'poi'); // DEV NOTE: Failing to save a deletion may introduce rollback issues.
	}

	this.cancelEditsPOI = function () {
		setAnnotationPanelEditability('poi', null);
		Z.Utils.showMessage(Z.Utils.getResource('ALERT_CANCELLINGUNSAVEDEDITS'), false, Z.messageDurationVeryShort, 'center');
		savePoint('rollback', 'pois');
		populatePOIs(poiPriorID);
	}

	this.saveEditsPOI = function (continueEditing) {
		var saveNeeded = (self.getStatus('XMLParsedViewport') && Z.editing !== null && Z.Viewport.verifyEditsUnsaved());
		if (!continueEditing) { setAnnotationPanelEditability('poi', null); }
		if (saveNeeded) {
			poiPriorID = poiList.options[poiList.selectedIndex].value;
			self.saveAnnotations(true, true, 'poi'); // Note: edit field values are passed to data provider object in fields' blur handlers.
			savePoint('save', 'pois');
			Z.Utils.validateCallback('poiSaved');
		}
	}

	this.addNewLabel = function () {
		if (self.getEditability('label', 'add')) {
			labelPriorID = (labelList.options.length > 0) ? labelList.options[labelList.selectedIndex].value : 0;
			savePoint('save', 'labels');

			// Alternative implementation: Show message in display rather than in annotation panel overlay.
			//Z.Utils.showMessage(Z.Utils.getResource('ALERT_HOWTOCREATEFIRSTLABEL') + Z.Utils.getResource('ALERT_HOWTOHELPREMINDER'), true, null, 'center', true);

			hotspotCurrentID = null;
			setAnnotationPanelEditability('labelPartial', 'addLabel');
		}
	}

	this.editCurrentLabel = function () {
		if (self.getEditability('label', 'edit')) {
			labelPriorID = hotspotCurrentID;
			savePoint('save', 'labels');
			setAnnotationPanelEditability('label', 'editLabel');
			if (hotspotCurrent !== null) {
				var media = hotspotCurrent.media;
				var mediaType = hotspotCurrent.mediaType;
				if (Z.labelMode != 'view' && Z.editing !== null) {
					self.setEditModeLabel(mediaType, true, media, true);
				}
				var isExternalSymbol = (media.indexOf('/circle.') != -1 || media.indexOf('/square.') != -1 || media.indexOf('/triangle.') != -1 || media.indexOf('/arrowDownLeft.') != -1 || media.indexOf('/arrowDownRight.') != -1 || media.indexOf('/arrowUpLeft.') != -1 || media.indexOf('/arrowUpRight.') != -1 || media.indexOf('/arrowUp.') != -1 || media.indexOf('/arrowDown.') != -1 || media.indexOf('/arrowLeft.') != -1 || media.indexOf('/arrowRight.') != -1 || media.indexOf('/lineHorizontal.') != -1 || media.indexOf('/lineVertical.') != -1);
				var isInternalSymbol = (media == 'counter' || media == 'circle' || media == 'square' || media == 'triangle' || media == 'arrowDown' || media == 'arrowDownLeft' || media == 'arrowLeft' || media == 'arrowUpLeft' || media == 'arrowUp' || media == 'arrowUpRight' || media == 'arrowRight' || media == 'arrowDownRight' || media == 'lineHorizontal' || media == 'lineVertical');
				var isShape = ((mediaType == 'counter' || mediaType == 'icon') && (!media || media != 'External Graphics File') && (isInternalSymbol || (isExternalSymbol && Z.labelIconsInternal)));
				var isPolygon = (media && media == 'polygon');
				if (isShape || isPolygon) {
					redisplayShapesAndPolygons();
				}
			}
		}
	}

	this.deleteCurrentLabel = function () {
		// Remove mouse movement event handlers previously assigned, if any.
		Z.Utils.removeEventListener(document, 'mousemove', viewportEventsHandler);
		Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler);

		if (Z.editMode != 'markup') { self.toggleLabelColorPicker(false); }
		self.toggleLabelIconPicker(false);
		if (Z.editMode != 'markup') { setAnnotationPanelEditability('label', null); }
		if (typeof labelList !== 'undefined' && labelList !== null && labelList.options.length > 0) {
			var index = (labelList.selectedIndex != -1) ? labelList.selectedIndex : 0;
			var labelID = labelList[labelList.selectedIndex].value;
			self.deleteLabel(labelID);
		}
	}

	this.deleteLabel = function (labelID, useInternalID) {
		if (typeof useInternalID !== 'undefined' && useInternalID !== null && !useInternalID) {
			for (var i = 0, j = hotspots.length; i < j; i++) {
				if (hotspots[i].id == labelID) {
					labelID = hotspots[i].internalID;
					break;
				}
			}
		}

		// Remove label from list and label and hotspot from source arrays.
		if (typeof labelID !== 'undefined' && labelID !== null && typeof labelListDP !== 'undefined' && labelListDP !== null) {
			var labelIDStr = labelID.toString();
			var labelIndex = Z.Utils.arrayIndexOfObjectValue(labelListDP, 'value', labelIDStr);
			if (labelIndex != -1) {
				labelListDP = Z.Utils.arraySplice(labelListDP, labelIndex, 1);
				var labelCurrIndex = Z.Utils.arrayIndexOfObjectValue(labelListCurrentDP, 'value', labelIDStr);
				if (labelCurrIndex != -1) { labelListCurrentDP = Z.Utils.arraySplice(labelListCurrentDP, labelCurrIndex, 1); }
				self.deleteHotspot(labelIDStr, null, true);
				if (labelListCurrentDP.length > 0 && typeof labelList !== 'undefined' && labelList !== null && labelList.options.length > 0) {
					var index = (labelList.selectedIndex != -1) ? labelList.selectedIndex : 0;
					var indexLast = labelListCurrentDP.length - 1;
					index = (index <= indexLast) ? index : indexLast;
					labelID = labelListCurrentDP[index].value;
				} else {
					labelID = null;
				}

				if (zoomRectangleDragging || Z.tracking) {
					redisplayShapesAndPolygons();
				} else {
					populateLabels(poiList.options[poiList.selectedIndex].value, labelID);
					labelPriorID = (labelList.options.length > 0) ? labelList.options[labelList.selectedIndex].value : '0';
					savePoint('save', 'labels');
					self.saveAnnotations(true, false, 'label'); // DEV NOTE: Failing to save a deletion may introduce rollback issues.
				}
			}
		}
	}

	this.deleteAllLabels = function () {
		if (hD) {
			if (typeof hotspots !== 'undefined') { Z.Utils.arrayClear(hotspots); }
			if (typeof hotspotsMedia !== 'undefined') { Z.Utils.arrayClear(hotspotsMedia); }
			if (typeof hotspotPopups !== 'undefined') { Z.Utils.arrayClear(hotspotPopups); }
			if (hotspotList != null) {
				if (typeof hotspotListDP !== 'undefined') { Z.Utils.arrayClear(hotspotListDP); }
			} else {
				if (typeof poiListDP !== 'undefined') { Z.Utils.arrayClear(poiListDP); }
				if (typeof labelListDP !== 'undefined') { Z.Utils.arrayClear(labelListDP); }
				if (typeof labelListCurrentDP !== 'undefined') { Z.Utils.arrayClear(labelListCurrentDP); }
				if (typeof noteListDP !== 'undefined') { Z.Utils.arrayClear(noteListDP); }
				if (typeof noteListCurrentDP !== 'undefined') { Z.Utils.arrayClear(noteListCurrentDP); }
			}
		}
		redisplayHotspots();
	}

	this.cancelEditsLabel = function () {
		// Remove mouse movement event handlers previously assigned, if any.
		Z.Utils.removeEventListener(document, 'mousemove', viewportEventsHandler);
		Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler);

		if (Z.editMode != 'markup') { self.toggleLabelColorPicker(false); }
		self.toggleLabelIconPicker(false);
		setAnnotationPanelEditability('label', null);
		Z.Utils.showMessage(Z.Utils.getResource('ALERT_CANCELLINGUNSAVEDEDITS'), false, Z.messageDurationVeryShort, 'center');
		savePoint('rollback', 'labels');
		polygonComplete = true;
		populateLabels(poiList.options[poiList.selectedIndex].value, labelPriorID);
		redisplayHotspots();
	}

	this.saveEditsLabel = function (continueEditing, saveForce, saveImage) {
		if (Z.editMode != 'markup') { self.toggleLabelColorPicker(false); }
		self.toggleLabelIconPicker(false);

		// Workaround for difference in execution order of IE which causes blur of panel field to occur after code of Save button. This ensures label values in label display object and relevant arrays match values in panel.
		if (Z.browser == Z.browsers.IE && !Z.fullView) { applyValuesFromPanel(); }
		
		var saveNeeded = Z.saveImageHandlerProvided || (self.getStatus('XMLParsedViewport') && Z.editing !== null && Z.Viewport.verifyEditsUnsaved());
		if (!continueEditing && Z.editMode != 'markup') {
			// Remove mouse movement event handlers previously assigned, if any. Only remove if not continueEditing because
			// each label edit mode change will cause save using this function after mousedown has added mousemove listener.
			Z.Utils.removeEventListener(document, 'mousemove', viewportEventsHandler);
			Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler);
			setAnnotationPanelEditability('label', null);
		}

		if (saveForce) { self.setEditModeLabel('view', false); }

		if (saveNeeded) {
			labelPriorID = (labelList.options.length > 0) ? labelList.options[labelList.selectedIndex].value : 0;
			self.saveAnnotations(saveForce, saveImage, 'label'); // Note: edit field values are passed to data provider object in fields' blur handlers.
			savePoint('save', 'labels');
			polygonComplete = true;
			populateLabels(poiList.options[poiList.selectedIndex].value, labelPriorID, true);
			Z.Utils.validateCallback('labelSaved');
			Z.Utils.validateCallback('labelSavedGetJSONObject');
		}
		redisplayHotspots();
	}

	function applyValuesFromPanel () {
		var vpIDStr = viewportID.toString();
		var hotspotCurrentID = hotspotCurrent.internalID;

		var labelNameTE = document.getElementById('labelNameTextElement' + vpIDStr);
		if (labelNameTE) {
			var index = labelList.selectedIndex;
			labelListCurrentDP[index].text = labelNameTE.value;

			var poiID = self.getCurrentPOIID();
			var id = labelList[index].value;
			var index2 = Z.Utils.arrayIndexOfObjectTwoValues(labelListDP, 'poiID', poiID, null, 'value', id);
			if (index2 != -1) { labelListDP[index2].text = labelNameTE.value; }

			labelListDP.sort(sortAnnotationAssocArrayByField);
			labelListCurrentDP.sort(sortAnnotationAssocArrayByField);
			Z.Utils.updateSelectElement(labelList, labelListCurrentDP, id);

			var index3 = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
			if (index3 != -1) { hotspots[index3].name = labelNameTE.value; }
		}
		var captionTE = document.getElementById('captionTextElement' + vpIDStr);
		if (captionTE) {
			var value = captionTE.value;
			if (value && value.indexOf('<CAPTION>') != -1) {
				property = 'captionHTML';
			} else {
				property = 'caption'
			}
			Z.viewportCurrent.modifyHotspot(hotspotCurrentID, property, value, false, true);
		}
		var comTE = document.getElementById('commentTextElement' + vpIDStr);
		if (comTE) {
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
			if (index != -1) { hotspots[index].comment = comTE.value; }
		}
	}

	this.addNewNote = function () {
		if (self.getEditability('note', 'add')) {
			notePriorID = (noteList.options.length > 0) ? noteList.options[noteList.selectedIndex].value : 0;
			savePoint('save', 'notes');
			createNoteFromParameters();
			var newNote = noteListDP[noteListDP.length - 1];
			populateNotes(newNote.poiID, newNote.value);
			setAnnotationPanelEditability('note', 'addNote');
		}
	}

	this.editCurrentNote = function () {
		if (self.getEditability('note', 'edit')) {
			notePriorID = noteList.options[noteList.selectedIndex].value;
			savePoint('save', 'notes');
			setAnnotationPanelEditability('note', 'editNote');
		}
	}

	this.deleteCurrentNote = function () {
		setAnnotationPanelEditability('note', null);
		if (typeof noteList !== 'undefined' && noteList !== null && noteList.options.length > 0) {
			var index = (noteList.selectedIndex != -1) ? noteList.selectedIndex : 0;
			var noteID = noteList[noteList.selectedIndex].value;
			var noteIndex = Z.Utils.arrayIndexOfObjectValue(noteListDP, 'value', noteID);
			if (noteIndex != -1) { noteListDP = Z.Utils.arraySplice(noteListDP, noteIndex, 1); }
			if (noteListDP.length > 0) {
				var indexLast = noteListDP.length - 1;
				index = (index <= indexLast) ? index : indexLast;
				var noteID = noteListDP[index].value;
			} else {
				noteID = null;
			}
			if (Z.editMode != 'markup') { populateNotes(poiList.options[poiList.selectedIndex].value, noteID); }
			notePriorID = (noteList.options.length > 0) ? noteList.options[noteList.selectedIndex].value : 0;
			savePoint('save', 'notes');
		}
		self.saveAnnotations(true, false, 'note');
	}

	this.cancelEditsNote = function () {
		setAnnotationPanelEditability('note', null);
		Z.Utils.showMessage(Z.Utils.getResource('ALERT_CANCELLINGUNSAVEDEDITS'), false, Z.messageDurationVeryShort, 'center');
		savePoint('rollback', 'notes');
		populateNotes(poiList.options[poiList.selectedIndex].value, notePriorID);
	}

	this.saveEditsNote = function (continueEditing) {
		var saveNeeded = (self.getStatus('XMLParsedViewport') && Z.editing !== null && Z.Viewport.verifyEditsUnsaved());
		if (!continueEditing) { setAnnotationPanelEditability('note', null); }
		if (saveNeeded) {
			notePriorID = noteList.options[noteList.selectedIndex].value;
			self.saveAnnotations(true, false, 'note'); // Note: edit field values are passed to data provider object in fields' blur handlers.
			savePoint('save', 'notes');
			Z.Utils.validateCallback('noteSaved');
		}
	}

	function savePoint (mode, target) {
		switch (target) {
			case 'pois' :
				if (mode == 'save') {
					poiListDPRollback = Z.Utils.arrayClone('pois', poiListDP, poiListDPRollback);
				} else {
					poiListDP = Z.Utils.arrayClone('pois', poiListDPRollback, poiListDP);
				}
				break;
			case 'labels' :
				// DEV NOTE: Polygon points separately backed up from hotspots array because points are directly modified in current hotspot if polygon dragged.
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', labelPriorID);
				if (mode == 'save') {
					if (hotspotCurrent && hotspotCurrent.polygonPts) {
						polygonRollback = Z.Utils.arrayClone('polygon', hotspotCurrent.polygonPts, polygonRollback);
					}
					labelListDPRollback = Z.Utils.arrayClone('labels', labelListDP, labelListDPRollback);
					hotspotsRollback = Z.Utils.arrayClone('hotspots', hotspots, hotspotsRollback);
					hotspotCurrent = (index != -1) ? hotspots[index] : null;
				} else {
					labelListDP = Z.Utils.arrayClone('labels', labelListDPRollback, labelListDP);
					hotspots = Z.Utils.arrayClone('hotspots', hotspotsRollback, hotspots);
					hotspotCurrent = (index != -1) ? hotspots[index] : null;
					if (hotspotCurrent) {
						if (polygonRollback.length > 0) {
							hotspotCurrent.polygonPts = Z.Utils.arrayClone('polygon', polygonRollback, hotspotCurrent.polygonPts);
						} else if (hotspotCurrent.media != 'polygon') {
							Z.Utils.arrayClear(hotspotCurrent.polygonPts);
						}
					}
				}
				break;
			case 'notes' :
				if (mode == 'save') {
					noteListDPRollback = Z.Utils.arrayClone('notes', noteListDP, noteListDPRollback);
				} else {
					noteListDP = Z.Utils.arrayClone('notes', noteListDPRollback, noteListDP);
				}
				break;
		}
	}

	this.deleteAllAnnotations = function () {
		// Create empty annotations XML doc to transfer input values into.
		var xmlText = '<ZAS></ZAS>';
		var xmlDocOut = Z.Utils.xmlConvertTextToDoc(xmlText);
		var xmlRootOut = xmlDocOut.getElementsByTagName('ZAS')[0];

		// Ensure XML structure for label setup information is complete.
		var setupOut = createAnnotationsXMLNode(xmlDocOut, 'setup');
		xmlRootOut.appendChild(setupOut);

		// Transfer data for SETUP from loaded XML where fields exist.
		var labelSetupIn = annotationsXML.getElementsByTagName('SETUP')[0];
		var temp = labelSetupIn.getAttribute('PANELPOSITION');
		if (Z.Utils.stringValidate(temp)) { setupOut.setAttribute('PANELPOSITION', temp); }

		var initVis;
		var initVisAtt = labelSetupIn.getAttribute('INITIALVISIBILITY');
		if (Z.Utils.stringValidate(initVisAtt)) {
			var initVisDef = Z.Utils.getResource('DEFAULT_HOTSPOTSINITIALVISIBILITY');
			if (initVisDef) {
				initVis = (initVisAtt != '0' && initVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (initVisAtt != '1' && initVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupOut.setAttribute('INITIALVISIBILITY', initVis);
		}
		var poiVisAtt = labelSetupIn.getAttribute('POIVISIBILITY');
		if (Z.Utils.stringValidate(poiVisAtt)) {
			var poiVisDef = (Z.Utils.getResource('DEFAULT_ANNOTATIONPOIVISIBILITY') == '1');
			if (poiVisDef) {
				initVis = (poiVisAtt != '0' && poiVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (poiVisAtt != '1' && poiVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupOut.setAttribute('POIVISIBILITY', initVis);
		}
		var labelVisAtt = labelSetupIn.getAttribute('LABELVISIBILITY');
		if (Z.Utils.stringValidate(labelVisAtt)) {
			var labelVisAtt = (Z.Utils.getResource('DEFAULT_ANNOTATIONLABELVISIBILITY') == '1');
			if (labelVisAtt) {
				initVis = (labelVisAtt != '0' && labelVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (labelVisAtt != '1' && labelVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupOut.setAttribute('LABELVISIBILITY', initVis);
		}
		var noteVisAtt = (labelSetupIn.getAttribute('NOTEVISIBILITY') == '1');
		if (Z.Utils.stringValidate(noteVisAtt)) {
			var noteVisDef = Z.Utils.getResource('DEFAULT_ANNOTATIONNOTEVISIBILITY');
			if (noteVisDef) {
				initVis = (noteVisAtt != '0' && noteVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (noteVisAtt != '1' && noteVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupOut.setAttribute('NOTEVISIBILITY', initVis);
		}
		var commentVisAtt = setupSource.getAttribute('COMMENTVISIBILITY');
		if (Z.Utils.stringValidate(noteVisAtt)) {
			var commentVisDef = (Z.Utils.getResource('DEFAULT_ANNOTATIONCOMMENTVISIBILITY') == '1');
			if (commentVisDef) {
				initVis = (commentVisAtt != '0' && commentVisAtt != 'hide') ? '1' : '0'; // Default true.
			} else {
				initVis = (commentVisAtt != '1' && commentVisAtt != 'show') ? '0' : '1'; // Default false.
			}
			setupNew.setAttribute('COMMENTVISIBILITY', initVis);
		}
		temp = labelSetupIn.getAttribute('MINSCALE');
		if (Z.Utils.stringValidate(temp)) {
			if (!isNaN(parseFloat(temp)) && parseFloat(temp) >= 0) {
				setupOut.setAttribute('MINSCALE', temp);
			}
		}
		temp = labelSetupIn.getAttribute('MAXSCALE');
		if (Z.Utils.stringValidate(temp)) {
			if (!isNaN(parseFloat(temp)) && parseFloat(temp) >= 0) {
				setupOut.setAttribute('MAXSCALE', temp);
			}
		}

		// Clear lists and previously drawn hotspots.
		if (hD) {
			if (typeof hotspots !== 'undefined') { Z.Utils.arrayClear(hotspots); }
			if (typeof hotspotsMedia !== 'undefined') { Z.Utils.arrayClear(hotspotsMedia); }
			if (typeof hotspotPopups !== 'undefined') { Z.Utils.arrayClear(hotspotPopups); }
			if (hotspotList != null) {
				if (typeof hotspotListDP !== 'undefined') { Z.Utils.arrayClear(hotspotListDP); }
			} else {
				if (typeof poiListDP !== 'undefined') { Z.Utils.arrayClear(poiListDP); }
				if (typeof labelListDP !== 'undefined') { Z.Utils.arrayClear(labelListDP); }
				if (typeof labelListCurrentDP !== 'undefined') { Z.Utils.arrayClear(labelListCurrentDP); }
				if (typeof noteListDP !== 'undefined') { Z.Utils.arrayClear(noteListDP); }
				if (typeof noteListCurrentDP !== 'undefined') { Z.Utils.arrayClear(noteListCurrentDP); }
			}
		}

		// Debug option:
		//console.log(Z.Utils.xmlConvertDocToText(self.getAnnotationsXML()));

		Z.Viewport.parseAnnotationsXML(xmlDocOut);
		redisplayHotspots();
	}

	// Not used internally. Supports external calls for integration projects.
	this.saveLabel = function (labelID, useInternalID) {
		if (typeof useInternalID !== 'undefined' && useInternalID !== null && !useInternalID) {
			for (var i = 0, j = hotspots.length; i < j; i++) {
				if (hotspots[i].id == labelID) {
					labelID = hotspots[i].internalID;
					break;
				}
			}
		}
		if (typeof labelID !== 'undefined' && labelID !== null) {
			var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', labelID);
			var hotspotToSave = (index != -1) ? hotspots[index] : null;
			if (hotspotToSave) {
				var tempXML = annotationsXML;
				annotationsXML = self.convertLabelToXML(hotspotToSave);
				self.saveAnnotations(true, true, 'label');
				annotationsXML = tempXML;
			}
		}
	}

	this.convertLabelToXML = function (hotspot) {
		var temp;
		var xmlDocNew = createAnnotationsXML();
		var labelNew = createAnnotationsXMLNode(xmlDocNew, 'label');

		labelNew.setAttribute('ID', hotspot.id);
		labelNew.setAttribute('NAME', Z.Utils.xmlEscapeMinimal(hotspot.name));
		labelNew.setAttribute('MEDIATYPE', hotspot.mediaType);
		labelNew.setAttribute('MEDIA', hotspot.media);
		labelNew.setAttribute('X', hotspot.x);
		labelNew.setAttribute('Y', hotspot.y);
		labelNew.setAttribute('ZOOM', hotspot.z);
		labelNew.setAttribute('XSCALE', hotspot.xScale);
		labelNew.setAttribute('YSCALE', hotspot.yScale);
		labelNew.setAttribute('ZMIN', hotspot.zMin);
		labelNew.setAttribute('ZMAX', hotspot.zMax);
		labelNew.setAttribute('CLICKURL', hotspot.clickURL);
		labelNew.setAttribute('URLTARGET', hotspot.urlTarget);
		temp = (hotspot.rollover == true) ? '1' : '0';
		labelNew.setAttribute('ROLLOVER', temp);
		labelNew.setAttribute('CAPTION', Z.Utils.xmlEscapeMinimal(hotspot.caption));
		if (commentVisibility) { labelNew.setAttribute('COMMENT', Z.Utils.xmlEscapeMinimal(hotspot.comment)); }
		labelNew.setAttribute('TOOLTIP', Z.Utils.xmlEscapeMinimal(hotspot.tooltip));
		labelNew.setAttribute('USER', hotspot.user);
		labelNew.setAttribute('DATE', hotspot.date);
		labelNew.setAttribute('TEXTCOLOR', hotspot.textColor);
		labelNew.setAttribute('BACKCOLOR', hotspot.backColor);
		labelNew.setAttribute('LINECOLOR', hotspot.lineColor);
		labelNew.setAttribute('FILLCOLOR', hotspot.fillColor);
		temp = (hotspot.textVisible != false) ? '1' : '0';
		labelNew.setAttribute('TEXTVISIBLE', temp);
		temp = (hotspot.backVisible != false) ? '1' : '0';
		labelNew.setAttribute('BACKVISIBLE', temp);
		temp = (hotspot.lineVisible != false) ? '1' : '0';
		labelNew.setAttribute('LINEVISIBLE', temp);
		temp = (hotspot.fillVisible != false) ? '1' : '0';
		labelNew.setAttribute('FILLVISIBLE', temp);
		labelNew.setAttribute('CAPTIONPOSITION', hotspot.captionPosition);
		labelNew.setAttribute('INTERNALID', hotspot.internalID.toString());
		labelNew.setAttribute('POIID', hotspot.poiID.toString());
		labelNew.setAttribute('POPUP', hotspot.popup);
		labelNew.setAttribute('POPOFFSETX', hotspot.popupOffsetX);
		labelNew.setAttribute('POPOFFSETX', hotspot.popupOffsetY);
		labelNew.setAttribute('ROTATION', hotspot.rotation);
		labelNew.setAttribute('CATEGORY', hotspot.category);
		labelNew.setAttribute('EDITABLE', hotspot.editable);

		// Duplicate complex content, if present, for caption, tooltip, polygon.
		temp = hotspot.captionHTML;
		if (Z.Utils.stringValidate(temp)) {
			var tempHTML = Z.Utils.xmlConvertTextToDoc(temp).getElementsByTagName('CAPTION')[0];
			if (tempHTML) {
				var tempInner = tempHTML.innerHTML;
				var captionNode = xmlDocNew.createElement('CAPTION');
				captionNode.innerHTML = tempInner;
				labelNew.appendChild(captionNode);
			}
		}
		temp = hotspot.tooltipHTML;
		if (Z.Utils.stringValidate(temp)) {
			var tempHTML = Z.Utils.xmlConvertTextToDoc(temp).getElementsByTagName('TOOLTIP')[0];
			if (tempHTML) {
				var tempInner = tempHTML.innerHTML;
				var tooltipNode = xmlDocNew.createElement('TOOLTIP');
				tooltipNode.innerHTML = tempInner;
				labelNew.appendChild(tooltipNode);
			}
		}
		var polyPts = hotspot.polygonPts;
		if (polyPts) {
			var poiPolyTemp = xmlDocNew.createElement('POLYGON');
			for (var p = 0, q = polyPts.length; p < q; p++) {
				var poiPointTemp = xmlDocNew.createElement('POINT');
				poiPointTemp.setAttribute('X', polyPts[p].x);
				poiPointTemp.setAttribute('Y', polyPts[p].y);
				poiPolyTemp.appendChild(poiPointTemp);
			}
			labelNew.appendChild(poiPolyTemp);
		}

		return labelNew;
	}

	this.convertLabelToJSON = function (hotspot) {
		var jsonObject = null;
		var labelXML = self.convertLabelToXML(hotspot);
		var jsonText = Z.Utils.jsonConvertXMLTextToJSONText(labelXML);
		try {
			var jsonObject = JSON.parse(jsonText);
		} catch (e) {
			Z.Utils.showMessage(e.name + Z.Utils.getResource('ERROR_PARSINGANNOTATIONSJSONLABEL') + e.message);
		}
		return jsonObject;
	}

	// Save edits to hotspots and polygons from current editing session and end editing session.
	this.saveAnnotations = function (saveForce, saveImage, target) {
		// DEV NOTE: Parameter 'target' is for future use to optimize save to only update XML for target: POIs, Labels, or Notes.
		if ((Z.annotationsAutoSave || saveForce) && Z.editMode !== null && !Z.noPost) {

			if (Z.localUse) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALSAVING'), false, Z.messageDurationStandard, 'center', true);
			} else if (!Z.Utils.stringValidate(Z.saveHandlerPath)) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_XMLSAVEHANDLERPATHINVALID'), true, null, 'center', true);
			} else if (Z.saveHandlerPath.indexOf(Z.Utils.getResource('ALERT_SAVEDISABLEDFORDEMOKEY')) != -1) {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_SAVEDISABLEDFORDEMOTEXT'), false, Z.messageDurationStandard, 'center', true);
			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_SAVINGUNSAVEDEDITS'), false, Z.messageDurationStandard, 'center');
				var priorAnnotXML = annotationsXML;
				annotationsXML = updateAnnotationsXML(annotationsXML);
				annotationsXMLOut = (Z.noPostDefaults) ? removeAnnotationDefaults(annotationsXML) : annotationsXML;

				// Debug option: Compare annotations XML last saved and posting.
				//console.log('XML prior: ' + Z.Utils.xmlConvertDocToText(priorAnnotXML));
				//console.log('XML out: ' + Z.Utils.xmlConvertDocToText(annotationsXMLOut));

				var netConnector = new Z.NetConnector();
				netConnector.postXML(Z.saveHandlerPath, annotationsXMLOut, 'annotation');
			}

			// If saveImageHandlerPath provided, also draw annotations onto canvas and save to file.
			if (Z.saveImageHandlerProvided && saveImage) {
				// If HTML parameter set, over
				var forceSaveAll = (Z.saveImageFull) ? true : null;
				self.saveAnnotationsToImageFile(forceSaveAll);
			}
		}
	}

	// Transfer POI, Label, and Note edits into XML to save. First create XML doc to transfer input values into. Then
	// ensure SETUP XML structure is complete, then update. Then process POIs, and within each, Notes and Labels.
	function updateAnnotationsXML (xmlDocPrior) {
		var temp, tempNode;
		var xmlDocNew = createAnnotationsXML();
		var xmlRootNew = createAnnotationsXMLNode(xmlDocNew, 'root');

		var setupTemp = createAnnotationsXMLNode(xmlDocNew, 'setup');
		var setupPrior = xmlDocPrior.getElementsByTagName('SETUP')[0];
		setupTemp = updateAnnotationSetupNode(setupTemp, setupPrior);
		xmlRootNew.appendChild(setupTemp);

		for (var i = 0, j = poiListDP.length; i < j; i++) {
			var poiTemp = createAnnotationsXMLNode(xmlDocNew, 'poi');
			poiTemp = updateAnnotationPOINode(poiTemp, poiListDP[i]);
			xmlRootNew.appendChild(poiTemp);

			labelListTempDP = filterListByPOIID(labelListDP, poiListDP[i].value);
			if (labelListTempDP.length > 0) {
				var poiLabelsContainerTemp = xmlDocNew.createElement('LABELS');
				poiTemp.appendChild(poiLabelsContainerTemp);
				for (var n = 0, o = labelListTempDP.length; n < o; n++) {
					var poiLabelTemp = createAnnotationsXMLNode(xmlDocNew, 'label');
					poiLabelTemp = updateAnnotationLabelNode(xmlDocNew, poiLabelTemp, labelListTempDP[n]);
					poiLabelsContainerTemp.appendChild(poiLabelTemp);
				}
			}

			noteListTempDP = filterListByPOIID(noteListDP, poiListDP[i].value);
			if (noteListTempDP.length > 0) {
				var poiNotesContainerTemp = xmlDocNew.createElement('NOTES');
				poiTemp.appendChild(poiNotesContainerTemp);
				for (var k = 0, m = noteListTempDP.length; k < m; k++) {
					var poiNoteTemp = createAnnotationsXMLNode(xmlDocNew, 'note');
					poiNoteTemp = updateAnnotationNoteNode(poiNoteTemp, noteListTempDP[k]);
					poiNotesContainerTemp.appendChild(poiNoteTemp);
				}
			}
		}

		// Debug options:
		//console.log('xmlDocPrior: ' + Z.Utils.xmlConvertDocToText(xmlDocPrior));
		//console.log('xmlDocNew: ' + Z.Utils.xmlConvertDocToText(xmlDocNew));

		return xmlDocNew;
	}

	function updateAnnotationSetupNode (setupNew, setupSource) {
		var temp;
		temp = setupSource.getAttribute('PANELPOSITION');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('PANELPOSITION', temp); }
		temp = setupSource.getAttribute('INITIALVISIBILITY');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('INITIALVISIBILITY', temp); }
		temp = setupSource.getAttribute('POIVISIBILITY');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('POIVISIBILITY', temp); }
		temp = setupSource.getAttribute('LABELVISIBILITY');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('LABELVISIBILITY', temp); }
		temp = setupSource.getAttribute('NOTEVISIBILITY');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('NOTEVISIBILITY', temp); }
		temp = setupSource.getAttribute('COMMENTVISIBILITY');
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('COMMENTVISIBILITY', temp); }
		temp = setupSource.getAttribute('MINSCALE');
		if (Z.Utils.stringValidate(temp)) {
			if (!isNaN(parseFloat(temp)) && parseFloat(temp) >= 0) {
				setupNew.setAttribute('MINSCALE', temp);
			}
		}
		temp = setupSource.getAttribute('MAXSCALE');
		if (Z.Utils.stringValidate(temp)) {
			if (!isNaN(parseFloat(temp)) && parseFloat(temp) >= 0) {
				setupNew.setAttribute('MAXSCALE', temp);
			}
		}
		return setupNew;
	}

	function updateAnnotationPOINode (poiNew, poiSource) {
		temp = Z.Utils.xmlEscapeMinimal(poiSource.text);
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('NAME', temp); }
		temp = poiSource.value;
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('INTERNALID', temp); }
		var temp = poiSource.id;
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('ID', temp); }
		temp = poiSource.x;
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) { poiNew.setAttribute('X', ((temp == 'center') ? Z.imageCtrX.toString() : temp)); }
		temp = poiSource.y;
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) { poiNew.setAttribute('Y', ((temp == 'center') ? Z.imageCtrY.toString() : temp)); }
		temp = poiSource.z;
		if (Z.Utils.stringValidate(temp) && !isNaN(parseFloat(temp))) { poiNew.setAttribute('ZOOM', temp); }
		temp = poiSource.user;
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('USER', temp); }
		temp = poiSource.date;
		if (Z.Utils.stringValidate(temp)) { poiNew.setAttribute('DATE', temp); }
		return poiNew;
	}

	function updateAnnotationLabelNode (xmlDocNew, labelNew, labelSource) {
		var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', labelSource.value);
		if (index != -1) {
			var hotspot = hotspots[index];
			labelNew = self.convertLabelToXML(hotspot);
		}
		return labelNew;
	}

	function updateAnnotationNoteNode (noteNew, noteSource) {
		temp = Z.Utils.xmlEscapeMinimal(noteSource.text);
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('NAME', temp); }
		var temp = noteSource.value;
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('INTERNALID', temp); }
		temp = Z.Utils.xmlEscapeMinimal(noteSource.noteText);
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('TEXT', temp); }
		temp = noteSource.poiID;
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('POIID', temp); }
		temp = noteSource.id;
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('ID', temp); }
		temp = noteSource.user;
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('USER', temp); }
		temp = noteSource.date;
		if (Z.Utils.stringValidate(temp)) { noteNew.setAttribute('DATE', temp); }
		return noteNew;
	}

	this.setAllHotspotsSaved = function () {
		for (var i = 0, j = hotspots.length; i < j; i++) {
			hotspots[i].saved = true;
		}
	}

	this.verifyEditsUnsaved = function (target) {
		// DEV NOTE: Optimize to constrain verification to target: POIs, Labels, or Notes.
		if (typeof annotationsXML !== 'undefined') {
			var currentAnnotationsXML = updateAnnotationsXML(annotationsXML);
			var editsUnsaved = !(Z.Utils.xmlConvertDocToText(annotationsXML) == Z.Utils.xmlConvertDocToText(currentAnnotationsXML));

			// Debug option: Compare annotations XML last saved and now.
			//console.log('XML last saved: ' + Z.Utils.xmlConvertDocToText(annotationsXML));
			//console.log('XML last now: ' + Z.Utils.xmlConvertDocToText(currentAnnotationsXML));
		}

		return editsUnsaved;
	}



	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::: TRACKING METHODS ::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Load tracking preset label types and/or previously saved labels data.
	function loadTrackingXML (vpID) {
		if (Z.Utils.stringValidate(Z.trackingPath)) {
			// Use zSimplePath parameter to avoid processing of tracking.xml path for integrated applications.
			if (!Z.simplePath) {
				if ((Z.trackingPath.toLowerCase().substring(Z.trackingPath.length - 5, Z.trackingPath.length) != '.json') && (Z.trackingPath.toLowerCase().substring(Z.trackingPath.length - 4, Z.trackingPath.length) != '.xml')) {
					Z.trackingPath = Z.trackingPath + '/' + Z.Utils.getResource('DEFAULT_TRACKINGXMLFILE');
				}
				dataPath = Z.Utils.cacheProofPath(Z.trackingPath);
			} else {
				dataPath = Z.trackingPath;
			}
		}
		if (typeof dataPath !== 'undefined' && Z.Utils.stringValidate(dataPath)) {
			vpIDTemp = (Z.imageSet) ? vpID : null;
			var netConnector = new Z.NetConnector();
			if (dataPath.toLowerCase().indexOf('.xml') != -1) {
				netConnector.loadXML(dataPath, vpIDTemp);
			} else if (dataPath.toLowerCase().indexOf('.json') != -1) {
				netConnector.loadJSON(dataPath, vpIDTemp);
			}
		} else if (typeof Z.trackingXMLText === 'string' && Z.Utils.stringValidate(Z.trackingXMLText)) {
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(Z.trackingXMLText);
			self.parseTrackingXML(xmlDoc);
		} else if (typeof Z.trackingJSONObject !== 'undefined' && typeof Z.trackingJSONObject === 'object' && Z.trackingJSONObject !== null) {
			var xmlText = Z.Utils.jsonConvertObjectToXMLText(Z.trackingJSONObject);
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
			self.parseTrackingXML(xmlDoc);
		}
	}

	this.parseTrackingXML = function (xmlDoc, vpID) {
		if (typeof vpID === "undefined" || vpID === null) { vpID = viewportID; }

		if (Z.imageSet) { Z.Utils.showMessage(Z.Utils.getResource('ALERT_LOADINTRACKINGDATA'), false, 2000, 'center'); }

		if (typeof trackingTypesListDP !== 'undefined') { Z.Utils.arrayClear(trackingTypesListDP); }
		if (typeof trackingCells !== 'undefined') { Z.Utils.arrayClear(trackingCells); }
		if (typeof trackingInstancesListDP !== 'undefined') { Z.Utils.arrayClear(trackingInstancesListDP); }
		self.setStatus('XMLParsedViewport', false);

		// Parse tracking setup values.
		var trackingSetup = xmlDoc.getElementsByTagName('SETUP')[0];
		var trackingPanelPosition = trackingSetup.getAttribute('PANELPOSITION');
		Z.trackingPanelPosition = (Z.Utils.stringValidate(trackingPanelPosition)) ? trackingPanelPosition : Z.Utils.getResource('DEFAULT_TRACKINGPANELPOSITION');

		// Parse counter label types for list.
		var counterTypesContainer = trackingSetup.getElementsByTagName('TYPES')[0];
		if (counterTypesContainer) {
			var types = counterTypesContainer.getElementsByTagName('TYPE');
			for (var i = 0, j = types.length; i < j; i++) {
				var typeNode = types[i];
				trackingTypesListDP[trackingTypesListDP.length] = { text:typeNode.getAttribute('NAME'), value:typeNode.getAttribute('ID'), mediaType:typeNode.getAttribute('MEDIATYPE'), media:typeNode.getAttribute('MEDIA'), radius:typeNode.getAttribute('RADIUS'), caption:typeNode.getAttribute('CAPTION'), captionPosition:typeNode.getAttribute('CAPTIONPOSITION'), fillColor:typeNode.getAttribute('FILLCOLOR') };
			}
		}

		// Parse existing cell instances for completed checkbox and Navigator overlay.
		var cellsContainer = xmlDoc.getElementsByTagName('CELLS')[0];
		if (cellsContainer) {
			var cells = cellsContainer.getElementsByTagName('CELL');
			for (var k = 0, m = cells.length; k < m; k++) {
				var cellNode = cells[k];
				trackingCells[trackingCells.length] = { id:cellNode.getAttribute('ID'), complete:(cellNode.getAttribute('COMPLETE') != '0'), user:cellNode.getAttribute('USER'), date:cellNode.getAttribute('DATE') };
			}
		}

		// Parse existing counter instances for list and display.
		var counterInstancesContainer = xmlDoc.getElementsByTagName('INSTANCES')[0];
		if (counterInstancesContainer) {
			var instances = counterInstancesContainer.getElementsByTagName('LABEL');
			for (var n = 0, o = instances.length; n < o; n++) {
				var labelID = getFreeID('label');
				var instanceNode = instances[n];
				instanceNode.setAttribute('INTERNALID', labelID);
				if (n > 0 && instanceNode.getAttribute('ID') == '0' && instances[n-1].getAttribute('ID') == '0') { instanceNode.setAttribute('ID', labelID); }
				instanceNode.setAttribute('POIID', 'TZ');
				if (instanceNode.getAttribute('TEXTCOLOR') === null) { instanceNode.setAttribute('TEXTCOLOR', '#FFFFFF'); }
				instanceNode.setAttribute('TEXTVISIBLE', '1');
				instanceNode.setAttribute('FILLVISIBLE', '1');
				instanceNode.setAttribute('CATEGORY', instanceNode.getAttribute('TYPEID'));
				var name = instanceNode.getAttribute('NAME');
				instanceNode.setAttribute('TOOLTIP', name + ' : ' + instanceNode.getAttribute('USER'));

				var typeID = instanceNode.getAttribute('TYPEID');
				var value = instanceNode.getAttribute('ID');
				var cell = instanceNode.getAttribute('CELL');
				var x = instanceNode.getAttribute('X');
				var y = instanceNode.getAttribute('Y');
				var zoom = instanceNode.getAttribute('ZOOM');
				var user = instanceNode.getAttribute('USER');
				var sortKey = Z.Utils.stringPadFront(cell, 6, '0') + Z.Utils.stringPadFront(value, 6, '0');
				var text = cell + '   ' + x + ', ' + y + ', ' + zoom + ': ' + user;

				trackingInstancesListDP[trackingInstancesListDP.length] = { text:text, value:value, sortKey:sortKey, cell:cell, typeID:typeID, x:x, y:y, zoom:zoom, user:user, name:name, mediaType:instanceNode.getAttribute('MEDIATYPE'), media:instanceNode.getAttribute('MEDIA'), radius:instanceNode.getAttribute('RADIUS'), caption:instanceNode.getAttribute('CAPTION'), captionPosition:instanceNode.getAttribute('CAPTIONPOSITION'), fillColor:instanceNode.getAttribute('FILLCOLOR'), initials:instanceNode.getAttribute('INITIALS'), date:instanceNode.getAttribute('DATE') }
				self.createLabelFromXML(instanceNode);
			}

			self.syncTrackingToViewport();
		}

		// Complete XML parsing and process XML as in saveTracking function to ensure first call to verifyEditsUnsaved will make valid comparison.
		self.setStatus('XMLParsedViewport', true);

		self.createTrackingPanel(vpID);

		// Set Navigator tracking overlay visible.
		if (Z.initialTrackingOverlayVisible) {
			if (Z.Viewer.getStatus('readyViewer')) {
				self.toggleTrackingNavigatorOverlay(true);
			} else {
				Z.setCallback('readyViewer', function () { self.toggleTrackingNavigatorOverlay(true); });
			}
		}

		self.setStatus('trackingLoadedViewport', true);
		Z.Utils.validateCallback('trackingLoaded');
	}

	this.createTrackingPanel = function (vpID) {
		// Add buttons to tracking panel using toolbar state management functions.

		if (!Z.ToolbarDisplay || !Z.Toolbar.getInitialized()) {
			var createTrackingPanelTimer = window.setTimeout( function () { self.createTrackingPanel(vpID); }, 100);

		} else if (typeof Z['TrackingPanelDisplay' + vpID.toString()] === 'undefined') {
			var tlbrSknArr = Z.Toolbar.getSkinArray();
			var vpIDStr = vpID.toString();

			// Create panel to tracking counter choices and use values.
			Z['TrackingPanelDisplay' + vpIDStr] = Z.Utils.createContainerElement('div', 'TrackingPanelDisplay' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '1px', '1px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', 'default');
			trackingPanelDisplay = Z['TrackingPanelDisplay' + vpIDStr];
			trkD = trackingPanelDisplay;
			trkS = trkD.style;
			Z.ViewerDisplay.appendChild(trackingPanelDisplay);

			// Ensure proper z-ordering of Viewer elements.
			trkS.zIndex = (Z.baseZIndex + 22).toString();

			// Create background.
			var trackingPanelBackground = Z.Utils.createContainerElement('div', 'trackingPanelBackground' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
			trackingPanelDisplay.appendChild(trackingPanelBackground);

			// Create placeholder content for lists.
			var listFontSize = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGPANELLISTFONTSIZE'), 10);
			var placeHolderListText = Z.Utils.getResource('CONTENT_TRACKINGPLACEHOLDERLISTTEXT');
			var placeholderDP = [ { text:placeHolderListText, value:'0' } ];

			// Create scrollable container.
			if (typeof counterCountainer === 'undefined' || counterCountainer === null) {

				// Create text descriptions for six counter features: Add button (colored), Show checkbox, Name text (non-editable), Count, Count All, and List (instances filtered).
				var containerCounterLabels = Z.Utils.createContainerElement('div', 'containerCounterLabels' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				trackingPanelDisplay.appendChild(containerCounterLabels);

				var labelAddTextBox = Z.Utils.createContainerElement('div', 'labelAddTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelAddTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELADD'));
				labelAddTextBox.appendChild(labelAddTextNode);
				containerCounterLabels.appendChild(labelAddTextBox);

				var labelShowTextBox = Z.Utils.createContainerElement('div', 'labelShowTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelShowTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELSHOW'));
				labelShowTextBox.appendChild(labelShowTextNode);
				containerCounterLabels.appendChild(labelShowTextBox);

				var labelNameTextBox = Z.Utils.createContainerElement('div', 'labelNameTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelNameTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELNAME'));
				labelNameTextBox.appendChild(labelNameTextNode);
				containerCounterLabels.appendChild(labelNameTextBox);

				var labelCountPerCellTextBox = Z.Utils.createContainerElement('div', 'labelCountPerCellTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelCountPerCellTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELCOUNT'));
				labelCountPerCellTextBox.appendChild(labelCountPerCellTextNode);
				containerCounterLabels.appendChild(labelCountPerCellTextBox);

				var labelCountPerImageTextBox = Z.Utils.createContainerElement('div', 'labelCountPerImageTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelCountPerImageTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELCOUNTALL'));
				labelCountPerImageTextBox.appendChild(labelCountPerImageTextNode);
				containerCounterLabels.appendChild(labelCountPerImageTextBox);

				var labelListTextBox = Z.Utils.createContainerElement('div', 'labelListTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelListTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELLIST'));
				labelListTextBox.appendChild(labelListTextNode);
				containerCounterLabels.appendChild(labelListTextBox);

				// Create and hide text descriptions for five features of counter instance list: Cell, X, Y, Zoom, and UserName.
				var containerCounterListLabels = Z.Utils.createContainerElement('div', 'containerCounterListLabels' + vpIDStr, 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				trackingPanelDisplay.appendChild(containerCounterListLabels);

				var labelCellTextBox = Z.Utils.createContainerElement('div', 'labelCellTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelCellTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELCELL'));
				labelCellTextBox.appendChild(labelCellTextNode);
				containerCounterListLabels.appendChild(labelCellTextBox);

				var labelXTextBox = Z.Utils.createContainerElement('div', 'labelXTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelXTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELX'));
				labelXTextBox.appendChild(labelXTextNode);
				containerCounterListLabels.appendChild(labelXTextBox);

				var labelYTextBox = Z.Utils.createContainerElement('div', 'labelYTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelYTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELY'));
				labelYTextBox.appendChild(labelYTextNode);
				containerCounterListLabels.appendChild(labelYTextBox);

				var labelZoomTextBox = Z.Utils.createContainerElement('div', 'labelZoomTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelZoomTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELZOOM'));
				labelZoomTextBox.appendChild(labelZoomTextNode);
				containerCounterListLabels.appendChild(labelZoomTextBox);

				var labelUserNameTextBox = Z.Utils.createContainerElement('div', 'labelUserNameTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelUserNameTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELUSERNAME'));
				labelUserNameTextBox.appendChild(labelUserNameTextNode);
				containerCounterListLabels.appendChild(labelUserNameTextBox);

				// Set size and position variables.
				var rowColor = '#FFFFFF', rowH = 24, marginL = 8;
				var colorBtnW = 22, colorBtnH = 14, colorBtnSpan = 34, colorBtnT = 4;
				var btnW = 15, btnH = 15, btnSpan = 34, btnT = 4;
				var chkBxW = 20, chkBxH = 20, chkBxT = 1;
				var textW = 120, textH = 20, textT = 6, labelW = 34, adjLg = 4;
				var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGPANELLABELFONTSIZE'), 10);
				dx = marginL;
				dy = 0;

				// Create scrollable container with row of elements for each Counter Type.
				containerTracking = Z.Utils.createContainerElement('div', 'containerTracking' + vpIDStr, 'inline-block', 'absolute', 'scroll', '1px', '1px', '0px', '0px', 'solid', '1px', '#FFFFFF', '0px', '0px', 'nowrap', null, true);
				containerTracking.style.overflowX = 'hidden';
				trackingPanelDisplay.appendChild(containerTracking);

				// Add rows for each counter type.
				for (var i = 0, j = trackingTypesListDP.length; i < j; i++) {
					var rowColor = (i % 2 == 0) ? '#F8F8F8' : '#FFFFFF';
					var rowContainer = Z.Utils.createContainerElement('div', 'rowContainer', 'inline-block', 'absolute', 'hidden', '100%', rowH + 'px', '0px', dy + 'px', 'none', '0px', rowColor, '0px', '0px', 'nowrap', null, true);
					containerTracking.appendChild(rowContainer);

					var backAlpha = parseFloat(Z.Utils.getResource('UI_TOOLBARINTERNALBACKGROUNDALPHA'));
					var backColor = Z.Utils.getResource('UI_TOOLBARINTERNALBACKGROUNDCOLOR');
					var buttonCounterTypeColor = Z.Utils.stringValidateColorValue(trackingTypesListDP[i].fillColor);
					var buttonCounterType = 'buttonCounterType' + i.toString();
					rowContainer[buttonCounterType] = Z.Utils.createContainerElement('div', buttonCounterType, 'inline-block', 'absolute', 'visible', colorBtnW + 'px', colorBtnH + 'px', dx + 'px', colorBtnT +'px', 'solid', '1px', buttonCounterTypeColor, '0px', '0px', 'normal');
					rowContainer[buttonCounterType].title = Z.Utils.getResource('TIP_COUNTERTYPE');
					if (Z.trackingEditMode != 'edit') {
						Z.Utils.setOpacity(rowContainer[buttonCounterType], 0.7, '');
					} else if (i > 0) {
						Z.Utils.setOpacity(rowContainer[buttonCounterType], 0.4, '');
					} else {
						trackingCounterCurrent = rowContainer[buttonCounterType];
					}
					rowContainer.appendChild(rowContainer[buttonCounterType]);
					if (Z.trackingEditMode == 'edit') {
						Z.Utils.addEventListener(rowContainer[buttonCounterType], 'mouseover', buttonCounterTypeEventsHandler);
						Z.Utils.addEventListener(rowContainer[buttonCounterType], 'mousedown', buttonCounterTypeEventsHandler);
						Z.Utils.addEventListener(rowContainer[buttonCounterType], 'mouseout', buttonCounterTypeEventsHandler);
					}
					dx += colorBtnSpan;

					var checkboxCountersShowStr = 'checkboxCountersShow' + i.toString();
					rowContainer[checkboxCountersShowStr] = new Z.Utils.Checkbox(checkboxCountersShowStr, 'show', chkBxW + 'px', chkBxH + 'px', dx + 'px', chkBxT + 'px', 'click', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTERTYPESHOW');
					rowContainer.appendChild(rowContainer[checkboxCountersShowStr]);
					var checkboxCountersShowInDOM = document.getElementById(checkboxCountersShowStr);
					checkboxCountersShowInDOM.checked = true;
					dx += btnSpan;

					var rowNameTextBox = 'rowNameTextBox' + i.toString();
					var rowNameTextNode = 'rowNameTextNode' + i.toString();
					rowContainer[rowNameTextBox] = Z.Utils.createContainerElement('div', rowNameTextBox, 'inline-block', 'absolute', 'hidden', textW + 'px', textH + 'px', dx + 'px', textT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
					rowContainer[rowNameTextNode] = document.createTextNode(trackingTypesListDP[i].text);
					rowContainer[rowNameTextBox].appendChild(rowContainer[rowNameTextNode]);
					rowContainer.appendChild(rowContainer[rowNameTextBox]);
					Z.Utils.setTextNodeStyle(rowContainer[rowNameTextBox], 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					dx += textW + adjLg * 3;

					var rowCountPerCellTextBox = 'rowCountPerCellTextBox' + i.toString();
					var rowCountPerCellTextNode = 'rowCountPerCellTextNode' + i.toString();
					rowContainer[rowCountPerCellTextBox] = Z.Utils.createContainerElement('div', rowCountPerCellTextBox, 'inline-block', 'absolute', 'hidden', textW + 'px', textH + 'px', dx + 'px', textT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
					rowContainer[rowCountPerCellTextNode] = document.createTextNode('...');
					rowContainer[rowCountPerCellTextBox].appendChild(rowContainer[rowCountPerCellTextNode]);
					rowContainer.appendChild(rowContainer[rowCountPerCellTextBox]);
					Z.Utils.setTextNodeStyle(rowContainer[rowCountPerCellTextBox], 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					dx += labelW - adjLg;

					var rowCountPerImageTextBox = 'rowCountPerImageTextBox' + i.toString();
					var rowCountPerImageTextNode = 'rowCountPerImageTextNode' + i.toString();
					rowContainer[rowCountPerImageTextBox] = Z.Utils.createContainerElement('div', rowCountPerImageTextBox, 'inline-block', 'absolute', 'hidden', textW + 'px', textH + 'px', dx + 'px', textT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
					rowContainer[rowCountPerImageTextNode] = document.createTextNode('...');
					rowContainer[rowCountPerImageTextBox].appendChild(rowContainer[rowCountPerImageTextNode]);
					rowContainer.appendChild(rowContainer[rowCountPerImageTextBox]);
					Z.Utils.setTextNodeStyle(rowContainer[rowCountPerImageTextBox], 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					dx += labelW - adjLg * 2;

					var buttonCounterListShow = 'buttonCounterListShow' + i.toString();
					rowContainer[buttonCounterListShow] = new Z.Utils.Button(buttonCounterListShow, null, Z.skinPath, tlbrSknArr[30], tlbrSknArr[31], tlbrSknArr[32], btnW + 'px', btnH + 'px', dx + 'px', btnT + 'px',  'mousedown', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTERLIST');
					rowContainer.appendChild(rowContainer[buttonCounterListShow].elmt);

					var rowCounterFilteredList = 'rowCounterFilteredList' + vpIDStr; // One list that gets repopulated prior to each display.
					trackingPanelDisplay[rowCounterFilteredList] = new Z.Utils.createSelectElement(rowCounterFilteredList, '', rowCounterFilteredListDP, 1, 0, 0, listFontSize, 'hidden', rowCounterListClickHandler, 'click');
					trackingPanelDisplay[rowCounterFilteredList].style.fontSize = '12px';
					trackingPanelDisplay[rowCounterFilteredList].size = 15;
					trackingPanelDisplay.appendChild(trackingPanelDisplay[rowCounterFilteredList]);

					dx = marginL;
					dy += rowH;
				}
			}

			var labelCurrentCellTextBox = Z.Utils.createContainerElement('div', 'labelCurrentCellTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelCurrentCellTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELCURRENTCELL'));
			labelCurrentCellTextBox.appendChild(labelCurrentCellTextNode);
			trackingPanelDisplay.appendChild(labelCurrentCellTextBox);
			var currentCellTextBox = Z.Utils.createContainerElement('div', 'currentCellTextBox' + vpIDStr, 'inline-block', 'absolute', 'hidden', textW + 'px', textH + 'px', dx + 'px', textT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var currentCellTextNode = document.createTextNode('...');
			currentCellTextBox.appendChild(currentCellTextNode);
			trackingPanelDisplay.appendChild(currentCellTextBox);
			Z.Utils.setTextNodeStyle(currentCellTextNode, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');

			if (Z.trackingEditMode == 'edit') {
				var countingDivider = new Z.Utils.Graphic('countingDivider' + vpIDStr, Z.skinPath, tlbrSknArr[20], '1px', '1px','1px', '1px');
				trackingPanelDisplay.appendChild(countingDivider.elmt);
			}

			var labelCountingCompleteTextBox = Z.Utils.createContainerElement('div', 'labelCountingCompleteTextBox' + vpIDStr, 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelCountingCompleteTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACKINGPANELLABELCOUNTINGCOMPLETE'));
			labelCountingCompleteTextBox.appendChild(labelCountingCompleteTextNode);
			trackingPanelDisplay.appendChild(labelCountingCompleteTextBox);
			var checkboxCountingComplete = new Z.Utils.Checkbox('checkboxCountingComplete' + vpIDStr, true, chkBxW + 'px', chkBxH + 'px', dx + 'px', chkBxT + 'px', 'click', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTINGCOMPLETE');
			trackingPanelDisplay.appendChild(checkboxCountingComplete);

			var buttonToggleTrackingNav = new Z.Utils.Button('buttonToggleTrackingNav' + vpIDStr, null, Z.skinPath, tlbrSknArr[162], tlbrSknArr[163], tlbrSknArr[164], '1px', '1px', '1px', '1px', 'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_TRACKINGNAVTOGGLE');
			trackingPanelDisplay.appendChild(buttonToggleTrackingNav.elmt);

			if (Z.trackingEditMode == 'edit') {

				var buttonTrackingClearLast = new Z.Utils.Button('buttonTrackingClearLast' + vpIDStr, null, Z.skinPath, tlbrSknArr[165], tlbrSknArr[166], tlbrSknArr[167], '1px', '1px', '1px', '1px', 'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTERCLEARLAST');
				trackingPanelDisplay.appendChild(buttonTrackingClearLast.elmt);
				var buttonTrackingClearType = new Z.Utils.Button('buttonTrackingClearType' + vpIDStr, null, Z.skinPath, tlbrSknArr[168], tlbrSknArr[169], tlbrSknArr[170], '1px', '1px', '1px', '1px', 'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTERCLEARTYPE');
				trackingPanelDisplay.appendChild(buttonTrackingClearType.elmt);
				var buttonTrackingClearAll = new Z.Utils.Button('buttonTrackingClearAll' + vpIDStr, null, Z.skinPath, tlbrSknArr[171], tlbrSknArr[172], tlbrSknArr[173], '1px', '1px', '1px', '1px', 'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTERSCLEARALL');
				trackingPanelDisplay.appendChild(buttonTrackingClearAll.elmt);
				var trackingDivider = new Z.Utils.Graphic('trackingDivider' + vpIDStr, Z.skinPath, tlbrSknArr[20], '1px', '1px','1px', '1px');
				trackingPanelDisplay.appendChild(trackingDivider.elmt);

				var buttonTrackingSave = new Z.Utils.Button('buttonTrackingSave' + vpIDStr, null, Z.skinPath, tlbrSknArr[174], tlbrSknArr[175], tlbrSknArr[176], '1px', '1px', '1px', '1px', 'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTERSSAVE');
				trackingPanelDisplay.appendChild(buttonTrackingSave.elmt);
			}

			var buttonCounterListHide = new Z.Utils.Button('buttonCounterListHide' + vpIDStr, null, Z.skinPath, tlbrSknArr[30], tlbrSknArr[31], tlbrSknArr[32], '1px', '1px', '1px', '1px',  'mouseover', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTINGLISTHIDE');
			trackingPanelDisplay.appendChild(buttonCounterListHide.elmt);

			drawLayoutTrackingPanel(vpID);
			self.syncTrackingToViewport();

			// DEV NOTE: This prevents drag selection from panel over hotspots, but not if cursor is in list or text
			// region in panel. Preventing default on container not helpful, because disables list and text editing.
			Z.Utils.addEventListener(trackingPanelBackground, 'mousedown', Z.Utils.preventDefault);
		}
	}

	function drawLayoutTrackingPanel (vpID) {
		var tlbrSknSzs = Z.Toolbar.getSkinSizes();
		var vpIDStr = vpID.toString();

		// Size and position panel.
		var panelW = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGPANELWIDTH'), 10);

		// Alternative implementation: Hide all buttons in View mode.
		//var viewModeAdj = (Z.trackingEditMode == 'edit') ? 0 : -16;
		viewModeAdj = 0;

		var panelH = viewModeAdj + parseInt(Z.Utils.getResource('DEFAULT_TRACKINGPANELHEIGHT'), 10);
		var panelCoords = self.calculateTrackingPanelCoords(Z.trackingPanelPosition, panelW, panelH, viewW, viewH); // viewH allows for toolbar height if static in viewer display area.
		self.sizeAndPositionTrackingPanel(trkS, panelW, panelH, panelCoords.x, panelCoords.y);
		Z.trackingPanelVisibleState = !(Z.trackingPanelVisible == 0 || Z.trackingPanelPosition == '0' || (Z.imageSet && Z.trackingFileShared && vpID == 0));
		trkS.display = (Z.trackingPanelVisibleState) ? 'inline-block' : 'none';

		// Debug option: display multiple panels right to left when imageSet viewing.
		//trkS.left = parseFloat(trkS.left) - (parseFloat(trkS.width) * vpID) + 'px';

		// Get dimensions from defaults.
		var labelW = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGLABELWIDTH'), 10);
		var labelTextW = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGLABELTEXTWIDTH'), 10);
		var listW = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGLISTWIDTH'), 10);
		var listNarrowW = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGLISTNARROWWIDTH'), 10);
		var margin = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGMARGIN'), 10);
		var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGPANELLABELFONTSIZE'), 10);
		var listFontSize = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGPANELLISTFONTSIZE'), 10);
		var textFontSize = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGPANELTEXTFONTSIZE'), 10);
		var textPaddingSmall = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGTEXTPADDINGSMALL'), 10);
		var textPadding = parseInt(Z.Utils.getResource('DEFAULT_TRACKINGTEXTPADDING'), 10);
		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
		var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
		var backColorLight = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORLIGHT');
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');

		// DEV NOTE: Adjust for font and adjust font for context.
		// Set other dimensions.
		var labelTextWAdj = 9;
		var labelH = 15;
		var listH = 17;
		var listTextW = listW - 24;
		var rowGap = listH * 0.5;
		var adjSm = 1;
		var adjLg = 4;
		var adjLabel = 3;
		var adjHelp = 0;
		var marginEdgeL = 15;
		var marginEdgeT = 15;
		var containerTrackingW = (panelW - marginEdgeL * 2);
		var containerTrackingH = -(viewModeAdj * 0.9) + (panelH - marginEdgeT * 3 - (rowGap * 2) - adjLg);

		// DEV NOTE: Adjust for select element height and placement variations among browsers.
		var selectElementAdj = (Z.browser == Z.browsers.CHROME || Z.browser == Z.browsers.SAFARI) ? -2 : 0;

		// Get dimensions from skins.
		var btnW = tlbrSknSzs[6];
		var btnH = tlbrSknSzs[7];
		var btnSpan = tlbrSknSzs[8];
		var dvdrW = tlbrSknSzs[4];
		var dvdrH = tlbrSknSzs[5];

		// DEV NOTE: Workaround for layout issues. On mobile devices large button and divider sizes used and panel must
		// grow too large. Requires addition of minimize button as no mouse-out to hide panel and allow full view of image.
		if (btnW > 15) { btnW = 15; }
		if (btnH > 15) { btnH = 15; }
		if (btnSpan > 22) { btnSpan = 22; }
		if (dvdrW > 1) { dvdrW = 1; }
		if (dvdrH > 18) { dvdrH = 18; }

		// Calculate dependent dimensions.
		// DEV NOTE: Add modification labelH and listH calculations based on font.
		var labelWNarrow = labelW / 2;
		var dvdrTOffset = (btnH - dvdrH) / 2;
		var dvdrSpan = btnW / 2;
		var adjDivT = (dvdrH - btnH) / 2;
		var btnGap = btnH * 0.5;
		var marginLabel = margin * 1.75;
		var bx = 0;
		var iconPickerW = panelW - margin * 3;
		var iconPickerH = labelH + rowGap * 3;

		// Draw background.
		var tPBG = document.getElementById('trackingPanelBackground' + vpIDStr);
		if (tPBG) {
			var tpbgS = tPBG.style;
			tpbgS.width = panelW + 'px';
			tpbgS.height = panelH + 'px';
			tpbgS.backgroundColor = backColor;
			Z.Utils.setOpacity(tPBG, backAlpha, backColorNoAlpha);
		}

		dx = marginEdgeL + adjLg;
		var cCL = document.getElementById('containerCounterLabels' + vpIDStr);
		if (cCL) {
			var cclS = cCL.style;
			cclS.width = panelW + 'px';
			cclS.height = labelH + 'px';
			cclS.left = dx + 'px';
			cclS.top = marginEdgeT + 'px';
			cclS.visibility = 'visible';
			Z.Utils.setTextNodeStyle(cCL.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
		}
		dx = 0;
		var lATB = document.getElementById('labelAddTextBox' + vpIDStr);
		if (lATB) {
			var latbS = lATB.style;
			latbS.width = labelW + 'px';
			latbS.height = labelH + 'px';
			latbS.left = '0px'
			latbS.top = '0px'
			Z.Utils.setTextNodeStyle(lATB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelWNarrow + adjLg * 2;
		}
		var lSTB = document.getElementById('labelShowTextBox' + vpIDStr);
		if (lSTB) {
			var lstbS = lSTB.style;
			lstbS.width = labelW + 'px';
			lstbS.height = labelH + 'px';
			lstbS.left = dx + 'px';
			lstbS.top = '0px'
			Z.Utils.setTextNodeStyle(lSTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW - adjLg;
		}
		var lNTB = document.getElementById('labelNameTextBox' + vpIDStr);
		if (lNTB) {
			var lntbS = lNTB.style;
			lntbS.width = labelW + 'px';
			lntbS.height = labelH + 'px';
			lntbS.left = dx + 'px';
			lntbS.top = '0px'
			Z.Utils.setTextNodeStyle(lNTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW * 2 + adjLg * 4;
		}
		var lCPCTB = document.getElementById('labelCountPerCellTextBox' + vpIDStr);
		if (lCPCTB) {
			var lcpctbS = lCPCTB.style;
			lcpctbS.width = labelW + 'px';
			lcpctbS.height = labelH + 'px';
			lcpctbS.left = dx + 'px';
			lcpctbS.top = '0px'
			Z.Utils.setTextNodeStyle(lCPCTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW - adjLg * 3;
		}
		var lCPITB = document.getElementById('labelCountPerImageTextBox' + vpIDStr);
		if (lCPITB) {
			var lcpitbS = lCPITB.style;
			lcpitbS.width = labelW + 'px';
			lcpitbS.height = labelH + 'px';
			lcpitbS.left = dx + 'px';
			lcpitbS.top = '0px'
			Z.Utils.setTextNodeStyle(lCPITB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelWNarrow;
		}
		var lLTB = document.getElementById('labelListTextBox' + vpIDStr);
		if (lLTB) {
			var lltbS = lLTB.style;
			lltbS.width = labelW + 'px';
			lltbS.height = labelH + 'px';
			lltbS.left = dx + 'px';
			lltbS.top = '0px'
			Z.Utils.setTextNodeStyle(lLTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
		}

		dx = marginEdgeL + adjLg;
		var cCLL = document.getElementById('containerCounterListLabels' + vpIDStr);
		if (cCLL) {
			var ccllS = cCLL.style;
			ccllS.width = panelW + 'px';
			ccllS.height = labelH + 'px';
			ccllS.left = dx + 'px';
			ccllS.top = marginEdgeT + 'px';
			Z.Utils.setTextNodeStyle(cCLL.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
		}
		var lCTB = document.getElementById('labelCellTextBox' + vpIDStr);
		if (lCTB) {
			var lctbS = lCTB.style;
			lctbS.width = labelW + 'px';
			lctbS.height = labelH + 'px';
			lctbS.left = '0px';
			lctbS.top = '0px'
			Z.Utils.setTextNodeStyle(lCTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW - adjLg * 3;
		}
		var lXTB = document.getElementById('labelXTextBox' + vpIDStr);
		if (lXTB) {
			var lxtbS = lXTB.style;
			lxtbS.width = labelW + 'px';
			lxtbS.height = labelH + 'px';
			lxtbS.left = dx + 'px';
			lxtbS.top = '0px'
			Z.Utils.setTextNodeStyle(lXTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelWNarrow + adjLg;
		}
		var lYTB = document.getElementById('labelYTextBox' + vpIDStr);
		if (lYTB) {
			var lytbS = lYTB.style;
			lytbS.width = labelW + 'px';
			lytbS.height = labelH + 'px';
			lytbS.left = dx + 'px';
			lytbS.top = '0px'
			Z.Utils.setTextNodeStyle(lYTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelWNarrow;
		}
		var lZTB = document.getElementById('labelZoomTextBox' + vpIDStr);
		if (lZTB) {
			var lztbS = lZTB.style;
			lztbS.width = labelW + 'px';
			lztbS.height = labelH + 'px';
			lztbS.left = dx + 'px';
			lztbS.top = '0px'
			Z.Utils.setTextNodeStyle(lZTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW + adjLg;
		}
		var lUNTB = document.getElementById('labelUserNameTextBox' + vpIDStr);
		if (lUNTB) {
			var luntbS = lUNTB.style;
			luntbS.width = labelW + 'px';
			luntbS.height = labelH + 'px';
			luntbS.left = dx + 'px';
			luntbS.top = '0px'
			Z.Utils.setTextNodeStyle(lUNTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
		}

		dy = (marginEdgeT * 2 + adjLg);
		var cTRK = document.getElementById('containerTracking' + vpIDStr);
		var rCFL = document.getElementById('rowCounterFilteredList' + vpIDStr);
		if (cTRK && rCFL) {
			var ctrkS = cTRK.style;
			ctrkS.width = containerTrackingW + 'px';
			ctrkS.height = containerTrackingH + 'px';
			ctrkS.left = marginEdgeL + 'px';
			ctrkS.top = dy + 'px';
			cTRK.size = 6;
			var rcflS = rCFL.style;
			rcflS.width = (containerTrackingW + 2) + 'px';
			rcflS.height = (containerTrackingH + 2) + 'px';
			rcflS.left = ctrkS.left;
			rcflS.top = ctrkS.top;
		}
		var bCLH = document.getElementById('buttonCounterListHide' + vpIDStr);
		if (bCLH) {
			Z.Utils.buttonSize(bCLH, btnW, btnH);
			var bclhS = bCLH.style;
			bclhS.left = (containerTrackingW - btnW * 2) + 'px';
			bclhS.top = (marginEdgeT - adjSm * 2) + 'px';
			bclhS.display = 'none';
		}

		// Reset position counters for counter tracking buttons.
		dx = (Z.trackingEditMode == 'edit') ? marginEdgeL * 1.3  : marginEdgeL * 5;
		dy = panelH - btnH - adjLg * 2;

		var lCCLTB = document.getElementById('labelCurrentCellTextBox' + vpIDStr);
		if (lCCLTB) {
			var lccltbS = lCCLTB.style;
			lccltbS.width = (labelW / 2) + 'px';
			lccltbS.height = labelH + 'px';
			lccltbS.left = dx + 'px';
			lccltbS.top = (dy + adjSm * 2) + 'px'
			Z.Utils.setTextNodeStyle(lCCLTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW / 2 + adjLg;
		}
		var cCLTB = document.getElementById('currentCellTextBox' + vpIDStr);
		if (cCLTB) {
			var ccltbS = cCLTB.style;
			ccltbS.width = labelW + 'px';
			ccltbS.height = labelH + 'px';
			ccltbS.left = dx + 'px';
			ccltbS.top = (dy + adjSm * 2) + 'px'
			Z.Utils.setTextNodeStyle(cCLTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx = (Z.trackingEditMode == 'edit') ? dx + labelW + adjLg * 2  : dx + labelW + marginEdgeL * 2;
		}
		var cnD = document.getElementById('countingDivider' + vpIDStr);
		if (cnD) {
			Z.Utils.graphicSize(cnD, dvdrW, dvdrH);
			var cndS = cnD.style;
			cndS.left = dx + 'px';
			cndS.top = dy + dvdrTOffset + 'px';
			dx += dvdrSpan;
		}
		var lCCTB = document.getElementById('labelCountingCompleteTextBox' + vpIDStr);
		if (lCCTB) {
			var lcctbS = lCCTB.style;
			lcctbS.width = labelWNarrow + 'px';
			lcctbS.height = labelH + 'px';
			lcctbS.left = dx + 'px';
			lcctbS.top = (dy + adjSm * 2) + 'px'
			Z.Utils.setTextNodeStyle(lCCTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW + adjLg * 3;
		}

		var cCBCC = document.getElementById('containerFor-checkboxCountingComplete' + vpIDStr);
		var cbCC = document.getElementById('checkboxCountingComplete' + vpIDStr);
		if (cCBCC && cbCC) {
			var ccbccS = cCBCC.style;
			ccbccS.left = dx + 'px';
			ccbccS.top = (dy - adjSm * 3) + 'px';
			Z.Utils.scaleElement(ccbccS, 0.9);
			dx += btnSpan + adjSm * 3;
			if (Z.trackingEditMode != 'edit') { cbCC.disabled = true; }
		}

		var bTTNA = document.getElementById('buttonToggleTrackingNav' + vpIDStr);
		if (bTTNA) {
			Z.Utils.buttonSize(bTTNA, btnW, btnH);
			var bttnaS = bTTNA.style;
			bttnaS.left = dx + 'px';
			bttnaS.top = dy + 'px';
		}

		if (Z.trackingEditMode == 'edit') {
			dx = panelW - (btnSpan * 5 - adjLg);
			var bTCLL = document.getElementById('buttonTrackingClearLast' + vpIDStr);
			if (bTCLL) {
				Z.Utils.buttonSize(bTCLL, btnW, btnH);
				var btcllS = bTCLL.style;
				btcllS.left = dx + 'px';
				btcllS.top = dy + 'px';
				dx += btnSpan;
			}
			var bTCLT = document.getElementById('buttonTrackingClearType' + vpIDStr);
			if (bTCLT) {
				Z.Utils.buttonSize(bTCLT, btnW, btnH);
				var btcltS = bTCLT.style;
				btcltS.left = dx + 'px';
				btcltS.top = dy + 'px';
				dx += btnSpan;
			}
			var bTCLA = document.getElementById('buttonTrackingClearAll' + vpIDStr);
			if (bTCLA) {
				Z.Utils.buttonSize(bTCLA, btnW, btnH);
				var btclaS = bTCLA.style;
				btclaS.left = dx + 'px';
				btclaS.top = dy + 'px';
				dx += btnSpan;
			}
			var tnD = document.getElementById('trackingDivider' + vpIDStr);
			if (tnD) {
				Z.Utils.graphicSize(tnD, dvdrW, dvdrH);
				var tndS = tnD.style;
				tndS.left = dx + 'px';
				tndS.top = dy + dvdrTOffset + 'px';
				dx += dvdrSpan;
			}

			var bTS = document.getElementById('buttonTrackingSave' + vpIDStr);
			if (bTS) {
				Z.Utils.buttonSize(bTS, btnW, btnH);
				var btsS = bTS.style;
				btsS.left = dx + 'px';
				btsS.top = dy + 'px';
				dx += btnSpan;
			}
		}
	}

	this.calculateTrackingPanelCoords = function (position, trackPanelW, trackPanelH, viewerW, viewerH) {
		// Tracking panel positioning: 0 hides, 1 top left, 2 top-right, 3 bottom right, 4 bottom left
		// Note that viewerH  allows for toolbar height if static in viewer display area, but annotationPanelH
		// requires additional adjustment to Y position of panel if position is at bottom of viewer.
		var panelX, panelY;
		if (Z.trackingPanelVisible == 0) {
			panelX = -1000;
			panelY = -1000;
		} else {
			var margin = 5;
			switch (position) {
				case '0':
					panelX = -1000;
					panelY = -1000;
					break;
				case '1':
					panelX = margin;
					panelY = margin;
					break;
				case '2':
					panelX = viewerW - trackPanelW - margin - 2;
					panelY = margin;
					if (Z.imageSetListPosition == 2) { panelY += 20; }
					break;
				case '3':
					panelX = viewerW - trackPanelW - margin;
					if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
						panelY = viewerH - trackPanelH - margin;
					} else {
						panelY = viewerH - margin;
					}
					break;
				case '4':
					panelX = margin;
					if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
						panelY = viewerH - trackPanelH - margin;
					} else {
						panelY = viewerH - margin;
					}
					break;
				default:
					panelX = viewerW - trackPanelW - margin;
					panelY = margin;
			}
		}
		return new Z.Utils.Point(panelX, panelY);
	}

	this.sizeAndPositionTrackingPanel = function (panel, width, height, left, top) {
		if (typeof width !== 'undefined' && width !== null) { panel.width = width + 'px'; }
		if (typeof height !== 'undefined' && height !== null) { panel.height = height + 'px'; }
		if (typeof left !== 'undefined' && left !== null) { panel.left = left + 'px'; }
		if (typeof top !== 'undefined' && top !== null) { panel.top = top + 'px'; }
	}

	this.goToNextCell = function (panDir) {
		var panDistPt = self.calculateNextCellCoordinates(panDir);
		self.zoomAndPanToView(panDistPt.x, panDistPt.y);
	}

	this.calculateNextCellCoordinates = function (panDir) {
		// Calculate current cell row and column.
		var x = Math.round(self.getX());
		var y = Math.round(self.getY());
		var zoom = self.getZoom();

		// Get current column and row.
		var cellColumnCurr = Math.max(0, Math.floor((x * zoom) / Z.viewerW));
		var cellRowCurr = Math.max(0, Math.floor((y * zoom) / Z.viewerH));

		// Increment column or row.
		var cellColumnNext = cellColumnCurr;
		var cellRowNext = cellRowCurr;
		switch (panDir) {
			case 'left' :
				cellColumnNext -= 1;
				break;
			case 'right' :
				cellColumnNext += 1;
				break;
			case 'up' :
				cellRowNext -= 1;
				break;
			case 'down' :
				cellRowNext += 1;
				break;
		}

		// Get and constrain zoom to levels of magnification.
		var z = Math.round(zoom * 100);
		z = (z < 1.5) ? 1.25 : (z < 2) ? 1.5 : (z < 2.5) ? 2 : (z < 4) ? 2.5 : (z < 5) ? 4 : (z < 10) ? 5 : (z < 16) ? 10 : (z < 20) ? 16 : (z < 25) ? 20 : (z < 32) ? 25 : (z < 40) ? 32 : (z < 50) ? 40 : (z < 60) ? 50 : (z < 100) ? 60 : (z < 150) ? 100: (z < 250) ? 150 : 250;
		z /= 100;

		// Get scaled cell dimensions.
		var cellW = Math.ceil(Z.viewerW / z);
		var cellH = Math.ceil(Z.viewerH / z);

		// Constrain next cell value to existing columns and rows.
		var cellColumnMax = Math.ceil(Z.imageW / cellW) - 1;
		if (cellColumnNext < 0) { cellColumnNext = 0; }
		if (cellColumnNext > cellColumnMax) { cellColumnNext = cellColumnMax; }
		var cellRowMax = Math.ceil(Z.imageH / cellH) - 1;
		if (cellRowNext < 0) { cellRowNext = 0; }
		if (cellRowNext > cellRowMax) { cellRowNext = cellRowMax; }

		// Get next cell centerpoint coordinates.
		var newPt = new Z.Utils.Point(x, y);
		var newX = Math.round((cellColumnNext * cellW) + (cellW / 2));
		var newY = Math.round((cellRowNext * cellH) + (cellH / 2));

		// Align first column and row to left and top.
		if (newX - (cellW / 2) < 0) { newX = cellW / 2; }
		if (newY - (cellH / 2) < 0) { newY = cellH / 2; }

		// Alternative implementation: Adjust center point for partial column or row.
		//if (newX + (cellW / 2) > Z.imageW) { newX = Z.imageW - (cellW / 2); }
		//if (newY + (cellH / 2) > Z.imageH) { newY = Z.imageH - (cellH / 2); }

		// Next line not required for current uses because coordinates constrained in function zoomAndPanToView if not disabled.
		//if (newX != x || newY != y) { newPt = constrainPan(newX, newY, z, Z.imageR, 'image'); }

		newPt = new Z.Utils.Point(newX, newY);
		return newPt;
	}

	this.syncTrackingToViewport = function () {
		if (Z.tracking) {
			// Update global cell value.
			Z.trackingCellCurrent = self.getCurrentTrackingCellID();

			// Update current cell text display.
			var cCLTB = document.getElementById('currentCellTextBox' + viewportID.toString());
			if (cCLTB) { cCLTB.textContent = Z.trackingCellCurrent; }

			// Update cell complete checkbox display.
			var index = Z.Utils.arrayIndexOfObjectValue(trackingCells, 'id', Z.trackingCellCurrent);
			var cbCC = document.getElementById('checkboxCountingComplete' + viewportID.toString());
			if (cbCC) { cbCC.checked = (index != -1 && trackingCells[index].complete) ? true : false; }

 			if (Z.trackingCounts) {
				self.calculateCounterCounts();

 				// Update counts in tracking panel.
 				for (var i = 0, j = trackingTypesListDP.length; i < j; i++) {
					var countCellStr = (Z.trackingCounts.length > 0) ? Z.trackingCounts[i].countCell.toString() : '0';
					var countImageStr = (Z.trackingCounts.length > 0) ? Z.trackingCounts[i].countImage.toString() : '0';
					var rowCountPerCell = document.getElementById('rowCountPerCellTextBox' + i.toString());
					if (rowCountPerCell) { rowCountPerCell.firstChild.textContent = countCellStr; }
					var rowCountPerImage = document.getElementById('rowCountPerImageTextBox' + i.toString());
					if (rowCountPerImage) { rowCountPerImage.firstChild.textContent = countImageStr; }
				}

				// Update counts in user panel.
				if (Z.userLogging) {
					for (var k = 0, m = Z.userList.length; k < m; k++) {
						var countImageStr = (Z.userList[k].countImage !== null) ? Z.userList[k].countImage.toString() : '0';
						var rowCountPerUserTextBox = document.getElementById('rowCountPerUserTextBox' + k.toString());
						if (rowCountPerUserTextBox) { rowCountPerUserTextBox.firstChild.textContent = countImageStr; }
					}
				}
			}
			if (Z.Navigator && Z.Navigator.getInitialized()) { Z.Navigator.drawNavigatorTrackingOverlay(trackingCells); }
		}
	}

	this.getCurrentTrackingCellID = function () {
		var x = self.getX();
		var y = self.getY();
		var zoom = self.getZoom();
		return self.getTrackingCellIDFromCoordinates(x, y, zoom);
	}

	this.getTrackingCellIDFromCoordinates = function (x, y, zoom) {
		if (typeof x === 'undefined' || x === null) { x = self.getX(); }
		if (typeof y=== 'undefined' || y === null) { y = self.getY(); }
		if (typeof zoom === 'undefined' || zoom === null) { zoom = self.getZoom(); }
		var currentCellRow = Math.max(0, Math.floor((y * zoom) / Z.viewerH));
		var currentCellColumn = Math.max(0, Math.floor((x * zoom) / Z.viewerW));
		var zoomStr = Math.round(zoom * 100).toString();
		var currentCellStr = currentCellRow.toString() + ':' + currentCellColumn.toString() + ':' + zoomStr;
		return currentCellStr;
	}

	this.getCoordinatesFromTrackingCellID = function (cellID) {
		var x = null, y = null, z = null;
		if (typeof cellID !== 'undefined' && cellID !== null) {
			var cellIDValues = cellID.split(':');
			x = parseInt(cellIDValues[1], 10);
			y = parseInt(cellIDValues[0], 10); // Y is 0th element because cell ID is column:row:zoom.
			z = parseInt(cellIDValues[2], 10);
		}
		return new Z.Utils.Point3D(x, y, z);
	}

	this.calculateCounterCounts = function () {
		if (Z.tracking && trackingInstancesListDP) {
			var user, instance, countCell, countImage;
			var trackingTypes = (typeof trackingTypesListDP !== 'undefined' && trackingTypesListDP.length > 0);
			var cellCurrent = Z.trackingCellCurrent;
			Z.Utils.arrayClear(Z.trackingCounts);
			var userLogging = (Z.userLogging && typeof Z.userList !== 'undefined' && Z.userList.length > 0);
			if (userLogging) {
				Z.Utils.arrayClearObjectValue(Z.userList, 'countCell');
				Z.Utils.arrayClearObjectValue(Z.userList, 'countImage');
			}

			for (var i = 0, j = trackingInstancesListDP.length; i < j; i++) {
				instance = trackingInstancesListDP[i];

				// Count per type.
				if (trackingTypes) {
					for (var n = 0, o = trackingTypesListDP.length; n < o; n++) {
						if (typeof Z.trackingCounts[n] === 'undefined') { Z.trackingCounts[n] = { typeID:n.toString, countCell:0, countImage:0 }; }
						if (instance.typeID == n.toString()) {
							if (instance.cell == cellCurrent) {
								Z.trackingCounts[n].countCell += 1;
							}
							Z.trackingCounts[n].countImage += 1;
						}
					}
				}

				// Count per user.
				if (userLogging) {
					for (var k = 0, m = Z.userList.length; k < m; k++) {
						user = Z.userList[k];
						if (user.name == instance.user) {
							user.countImage += 1;
							if (instance.cell == cellCurrent) {
								user.countCell += 1;
							}
						}
					}
				}
			}
		}
	}

	this.setCellCountComplete = function (complete) {
		var index = Z.Utils.arrayIndexOfObjectValue(trackingCells, 'id', Z.trackingCellCurrent);
		if (index == -1) { index = trackingCells.length; }
		trackingCells[index] = { id:Z.trackingCellCurrent, complete:complete, user:Z.userName, date:Z.Utils.getCurrentUTCDateAsString() };
		Z.Navigator.drawNavigatorTrackingOverlay(trackingCells);
	}

	this.getTrackingCells = function () {
		return trackingCells;
	}

	this.toggleTrackingNavigatorOverlay = function (override) {
		Z.trackingOverlayVisible = (typeof override !== 'undefined' && override !== null) ? override : !Z.trackingOverlayVisible;
		var nTO = document.getElementById('navigatorTrackingOverlay');
		if (nTO) {
			var ntoS = nTO.style;
			ntoS.display = (Z.trackingOverlayVisible) ? 'inline-block' : 'none';
			updateTrackingOverlay(nTO);
		}
	}

	function updateTrackingOverlay (nTO) {
		var navImgArr = Z.Navigator.getSizeAndPositionNavigatorImage();
		if (navImgArr) {
			self.setSizeAndPositionNavigatorTrackingOverlay(navImgArr.width, navImgArr.height, navImgArr.left, navImgArr.top, nTO);
			Z.Navigator.drawNavigatorTrackingOverlay(trackingCells, navImgArr);
		} else {
			var updateTrackingOverlayTimer = window.setTimeout( function () { updateTrackingOverlay(nTO); }, 10);
		}
	}

	this.setSizeAndPositionNavigatorTrackingOverlay = function (width, height, left, top, nTO) {
		if (typeof nTO === 'undefined' || nTO === null) { nTO = document.getElementById('navigatorTrackingOverlay'); }
		if (nTO) {
			var ntoS = nTO.style;
			ntoS.width = width + 'px';
			ntoS.height = height + 'px';
			ntoS.left = left + 'px';
			ntoS.top = top + 'px';
		}
	}

	this.deleteCounterLast = function () {
		var lastIndex = trackingInstancesListDP.length - 1;
		if (lastIndex != -1) {
			self.deleteLabel(trackingInstancesListDP[lastIndex].value);
			trackingInstancesListDP = Z.Utils.arraySplice(trackingInstancesListDP, lastIndex, 1);
			self.syncTrackingToViewport();
		}
	}

	this.deleteCountersOfType = function (typeID) {
		for (var i = 0, j = trackingTypesListDP.length; i < j; i++) {
			for (var k = 0, m = trackingInstancesListDP.length; k < m; k++) {
				if (trackingInstancesListDP[k].typeID == typeID) {
					self.deleteLabel(trackingInstancesListDP[k].value);
					trackingInstancesListDP = Z.Utils.arraySplice(trackingInstancesListDP, k, 1);
					m--;
				}
			}
		}
		self.syncTrackingToViewport();
	}

	this.deleteCountersAll = function () {
		self.deleteAllLabels();
		Z.Utils.arrayClear(trackingInstancesListDP);
		self.syncTrackingToViewport();
	}

	this.saveTracking = function (typesArr, cellsArr, instancesArr) {// Prevent local posting attempts.
		if (Z.localUse) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALSAVING'), false, Z.messageDurationStandard, 'center', true);
		} else if (!Z.Utils.stringValidate(Z.saveHandlerPath)) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_XMLSAVEHANDLERPATHINVALID'), true, null, 'center');
		} else if (Z.saveHandlerPath.indexOf(Z.Utils.getResource('ALERT_SAVEDISABLEDFORDEMOKEY')) != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_SAVEDISABLEDFORDEMOTEXT'), false, Z.messageDurationStandard, 'center');
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_SAVINGUNSAVEDEDITS'), false, 2000, 'center');
			var trackingXMLOut = updateTrackingXML(typesArr, cellsArr, instancesArr);
			var netConnector = new Z.NetConnector();
			netConnector.postXML(Z.saveHandlerPath, trackingXMLOut, 'tracking');
		}
	}

	updateTrackingXML = function (tArr, cArr, iArr) {
		// Create XML doc to transfer input values into.
		var xmlDocNew = createTrackingXML();
		var xmlRootNew = createTrackingXMLNode(xmlDocNew, 'root');

		var setupTemp = createTrackingXMLNode(xmlDocNew, 'setup');
		setupTemp = updateTrackingSetupNode(setupTemp, Z.trackingPanelPosition);
		xmlRootNew.appendChild(setupTemp);

		if (tArr.length > 0) {
			var typesContainerTemp = xmlDocNew.createElement('TYPES');
			for (var i = 0, j = tArr.length; i < j; i++) {
				var typeTemp = createTrackingXMLNode(xmlDocNew, 'type');
				typeTemp = updateTrackingTypeNode(typeTemp, tArr[i]);
				typesContainerTemp.appendChild(typeTemp);
			}
		}
		xmlRootNew.appendChild(typesContainerTemp);

		if (cArr.length > 0) {
			var cellsContainerTemp = xmlDocNew.createElement('CELLS');
			for (var i = 0, j = cArr.length; i < j; i++) {
				var cellTemp = createTrackingXMLNode(xmlDocNew, 'cell');
				cellTemp = updateTrackingCellNode(cellTemp, cArr[i]);
				cellsContainerTemp.appendChild(cellTemp);
			}
		}
		xmlRootNew.appendChild(cellsContainerTemp);

		if (iArr.length > 0) {
			var instancesContainerTemp = xmlDocNew.createElement('INSTANCES');
			for (var i = 0, j = iArr.length; i < j; i++) {
				var labelTemp = createTrackingXMLNode(xmlDocNew, 'label');
				labelTemp = updateTrackingLabelNode(labelTemp, iArr[i]);
				instancesContainerTemp.appendChild(labelTemp);
			}
		}
		xmlRootNew.appendChild(instancesContainerTemp);

		// Debug options:
		//console.log(tArr, cArr, iArr);
		//console.log('xmlDocNew: ' + Z.Utils.xmlConvertDocToText(xmlDocNew));

		return xmlDocNew;
	}

	function createTrackingXML () {
		var xmlText = '<TRACKINGDATA></TRACKINGDATA>';
		var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
		return xmlDoc;
	}

	function createTrackingXMLNode (xmlDoc, nodeType) {
		var tempNode;
		switch (nodeType) {
			case 'root' :
				// Node exists, created in prior call to createTrackingXML;
				tempNode = xmlDoc.getElementsByTagName('TRACKINGDATA')[0];
				break;
			case 'setup' :
				tempNode = xmlDoc.createElement('SETUP');
				tempNode.setAttribute('PANELPOSITION','2');
				break;
			case 'type' :
				tempNode = xmlDoc.createElement('TYPE');
				tempNode.setAttribute('ID','0');
				tempNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_COUNTERNAME'));
				tempNode.setAttribute('MEDIATYPE', 'counter');
				tempNode.setAttribute('MEDIA', 'circle');
				tempNode.setAttribute('RADIUS', '40');
				// Do not set default caption value: permitted to have no caption.
				//tempNode.setAttribute('CAPTION', Z.Utils.getResource('CONTENT_COUNTERCAPTION'));
				tempNode.setAttribute('CAPTION', '');
				tempNode.setAttribute('CAPTIONPOSITION', Z.Utils.getResource('CONTENT_COUNTERCAPTIONPOSITION'));
				tempNode.setAttribute('FILLCOLOR', Z.Utils.getResource('CONTENT_COUNTERFILLCOLOR'));
				break;
			case 'cell' :
				tempNode = xmlDoc.createElement('CELL');
				tempNode.setAttribute('ID', Z.Utils.getResource('CONTENT_COUNTERCELL'));
				tempNode.setAttribute('COMPLETE','0');
				tempNode.setAttribute('USER', Z.Utils.getResource('CONTENT_COUNTERUSER'));
				tempNode.setAttribute('DATE', Z.Utils.getCurrentUTCDateAsString());
				break;
			case 'label' :
				tempNode = xmlDoc.createElement('LABEL');
				tempNode.setAttribute('ID','0');
				tempNode.setAttribute('TYPEID','0');
				tempNode.setAttribute('NAME', Z.Utils.getResource('CONTENT_COUNTERNAME'));
				tempNode.setAttribute('MEDIATYPE', 'counter');
				tempNode.setAttribute('MEDIA', 'circle');
				tempNode.setAttribute('RADIUS', '40');
				// Do not set default caption value: permitted to have no caption.
				//tempNode.setAttribute('CAPTION', Z.Utils.getResource('CONTENT_COUNTERCAPTION'));
				tempNode.setAttribute('CAPTION', '');
				tempNode.setAttribute('CAPTIONPOSITION', Z.Utils.getResource('CONTENT_COUNTERCAPTIONPOSITION'));
				tempNode.setAttribute('FILLCOLOR', Z.Utils.getResource('CONTENT_COUNTERFILLCOLOR'));
				tempNode.setAttribute('CELL', Z.Utils.getResource('CONTENT_COUNTERCELL'));
				tempNode.setAttribute('X', 'center');
				tempNode.setAttribute('Y', 'center');
				tempNode.setAttribute('ZOOM', '100');
				tempNode.setAttribute('USER', Z.Utils.getResource('CONTENT_COUNTERUSER'));
				tempNode.setAttribute('INITIALS', Z.Utils.getResource('CONTENT_COUNTERUSERINITIALS'));
				tempNode.setAttribute('DATE', Z.Utils.getCurrentUTCDateAsString());
				break;
		}
		return tempNode;
	}

	function updateTrackingSetupNode (setupNew, setupSource) {
		// DEV NOTE: Unlike for updateAnnotationsSetupNode there is no trackingXML with original setup data, only one setup var and arrays.
		var temp;
		temp = setupSource;
		if (Z.Utils.stringValidate(temp)) { setupNew.setAttribute('PANELPOSITION', temp); }
		return setupNew;
	}

	function updateTrackingTypeNode (typeNew, typeSource) {
		var temp;
		temp = typeSource.value;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('ID', temp); }
		temp = typeSource.text;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('NAME', temp); }
		temp = typeSource.mediaType;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('MEDIATYPE', temp); }
		temp = typeSource.media;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('MEDIA', temp); }
		temp = typeSource.radius;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('RADIUS', temp); }
		temp = typeSource.caption;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('CAPTION', temp); }
		temp = typeSource.captionPosition;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('CAPTIONPOSITION', temp); }
		temp = typeSource.fillColor;
		if (Z.Utils.stringValidate(temp)) { typeNew.setAttribute('FILLCOLOR', temp); }
		return typeNew;
	}

	function updateTrackingCellNode (cellNew, cellSource) {
		var temp;
		temp = cellSource.value;
		if (Z.Utils.stringValidate(temp)) { cellNew.setAttribute('ID', temp); }
		temp = (cellSource.complete) ? '1' : '0';
		if (Z.Utils.stringValidate(temp)) { cellNew.setAttribute('COMPLETE', temp); }
		temp = cellSource.user;
		if (Z.Utils.stringValidate(temp)) { cellNew.setAttribute('USER', temp); }
		temp = cellSource.date;
		if (Z.Utils.stringValidate(temp)) { cellNew.setAttribute('DATE', temp); }
		return cellNew;
	}

	function updateTrackingLabelNode (labelNew, labelSource) {
		var temp;
		temp = labelSource.value;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('ID', temp); }
		temp = labelSource.typeID;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('TYPEID', temp); }
		temp = labelSource.name;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('NAME', temp); }
		temp = labelSource.mediaType;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('MEDIATYPE', temp); }
		temp = labelSource.media;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('MEDIA', temp); }
		temp = labelSource.radius;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('RADIUS', temp); }
		temp = labelSource.caption;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('CAPTION', temp); }
		temp = labelSource.captionPosition;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('CAPTIONPOSITION', temp); }
		temp = labelSource.fillColor;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('FILLCOLOR', temp); }
		temp = labelSource.cell;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('CELL', temp); }
		temp = labelSource.x;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('X', temp); }
		temp = labelSource.y;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('Y', temp); }
		temp = labelSource.zoom;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('ZOOM', temp); }
		temp = labelSource.user;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('USER', temp); }
		temp = labelSource.initials;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('INITIALS', temp); }
		temp = labelSource.date;
		if (Z.Utils.stringValidate(temp)) { labelNew.setAttribute('DATE', temp); }
		return labelNew;
	}


	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::: TRACKING EVENT FUNCTIONS ::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function buttonCounterTypeEventsHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var eventType = event.type;
			var eventTarget = Z.Utils.target(event);
			if (eventTarget) {
				switch(eventType) {
					case 'mouseover' :
						Z.Utils.setOpacity(eventTarget, 0.2, '');
						break;
					case 'mousedown' :
						for (var i = 0, j = containerTracking.children.length; i < j; i++) {
							Z.Utils.setOpacity(containerTracking.childNodes[i].firstChild, 0.4, '');
						}
						Z.Utils.setOpacity(eventTarget, 1, '');
						trackingCounterCurrent = eventTarget;
						var rowBtnColorID = eventTarget.id;
						Z.trackingTypeCurrent = rowBtnColorID.substring(rowBtnColorID.length - 1, rowBtnColorID.length);
						break;
					case 'mouseout' :
						Z.Utils.setOpacity(eventTarget, 0.4, '');
						Z.Utils.setOpacity(trackingCounterCurrent, 1, '');
						break;
				}
			}
		}
	}

	this.trackingEventsManager = function (event, tbID) {
		if (event) {
			var eventTarget = Z.Utils.target(event);
			if (eventTarget) {
				var vpIDStr = viewportID.toString();
				var rowChkBxID = eventTarget.parentNode.id;
				var rowStr = rowChkBxID.substring(rowChkBxID.length - 1, rowChkBxID.length);

				switch (tbID) {
					case 'containerFor-checkboxCountersShow' + rowStr :
						Z.Viewport.setHotspotsVisibilityByFilter('category', rowStr, eventTarget.checked);
						break;
					case 'containerFor-checkboxCountingComplete' + vpIDStr :
						Z.Viewport.setCellCountComplete(eventTarget.checked);
						break;
					case 'buttonCounterListShow' :
						// Populate counter list with filtered content and display.
						Z.Utils.arrayClear(rowCounterFilteredListDP);
						for (var k = 0, m = trackingInstancesListDP.length; k < m; k++) {
							var instance = trackingInstancesListDP[k];
							if (instance.typeID == rowStr) {
								rowCounterFilteredListDP[rowCounterFilteredListDP.length] = { text:instance.text, value:instance.value, sortKey:instance.sortKey, x:instance.x, y:instance.y, zoom:instance.zoom }
							}
						}
						Z.Utils.arraySortByObjectValue(rowCounterFilteredListDP, 'sortKey');
						var rowList = document.getElementById('rowCounterFilteredList' + vpIDStr);
						Z.Utils.updateSelectElement(rowList, rowCounterFilteredListDP, 0);

						// Display counter list and button to hide it.
						rowList.style.visibility = 'visible';
						var bCLH = document.getElementById('buttonCounterListHide' + vpIDStr);
						if (bCLH) { bCLH.style.display = 'inline-block'; }
						var cCL = document.getElementById('containerCounterLabels' + vpIDStr);
						if (cCL) { cCL.style.display = 'none'; }
						var cCLL = document.getElementById('containerCounterListLabels' + vpIDStr);
						if (cCLL) { cCLL.style.display = 'inline-block'; }
						break;

					case 'buttonCounterListHide' + vpIDStr :
						for (var i = 0, j = containerTracking.children.length; i < j; i++) {
							var rowList = document.getElementById('rowCounterFilteredList' + vpID.toString());
							rowList.style.visibility = 'hidden';
						}
						var btnListHideTimer = window.setTimeout( function () {
							var bCLH = document.getElementById('buttonCounterListHide' + vpIDStr);
							if (bCLH) { bCLH.style.display = 'none'; }
						}, 10);
						var cCL = document.getElementById('containerCounterLabels' + vpIDStr);
						if (cCL) { cCL.style.display = 'inline-block'; }
						var cCLL = document.getElementById('containerCounterListLabels' + vpIDStr);
						if (cCLL) { cCLL.style.display = 'none'; }
						break;

					case 'buttonToggleTrackingNav' + vpIDStr :
						self.toggleTrackingNavigatorOverlay();
						break;

					case 'buttonTrackingClearLast' + vpIDStr :
						self.deleteCounterLast();
						break;

					case 'buttonTrackingClearType' + vpIDStr :
						self.deleteCountersOfType(Z.trackingTypeCurrent);
						break;

					case 'buttonTrackingClearAll' + vpIDStr :
						self.deleteCountersAll();
						break;

					case 'buttonTrackingSave' + vpIDStr :
						self.saveTracking(trackingTypesListDP, trackingCells, trackingInstancesListDP);
						break;
					case 'containerFor-checkboxUserCountersShow' + rowStr :
						var rowUserName = Z.userList[rowStr].name;
						Z.Viewport.setHotspotsVisibilityByFilter('user', rowUserName, eventTarget.checked);
						break;
				}
			}
		}
	}

	function rowCounterListClickHandler (event) {
		if (event) {
			var rowList = document.getElementById('rowCounterFilteredList' + vpID.toString());
			var index = rowList.selectedIndex;
			var x = parseInt(rowCounterFilteredListDP[index].x, 10);
			var y = parseInt(rowCounterFilteredListDP[index].y, 10);
			var zoom = parseFloat(rowCounterFilteredListDP[index].zoom);
			self.zoomAndPanToView(x, y, zoom);

			// Alternative implementation: Hide list on click.
			//rowList.style.visibility = 'hidden';
			//var bLH = document.getElementById('buttonListHide' + vpID.toString());
			//bLH.style.visibility = 'hidden';
		}
	}



	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::: IMAGE LIST, SCREENSAVER, TOUR & SLIDESHOW METHODS :::::::::::::
	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.tourStart = function () {
		self.tourStop();
		if (!Z.tourStop) {
			Z.tourPlaying = true;

			// Swap buttons.
			var bTRS = document.getElementById('buttonTourStop');
			var bTRST = document.getElementById('buttonTourStart');
			if (bTRS && bTRST) {
				bTRS.style.display = 'inline-block';
				bTRST.style.display = 'none';
			}

			if (Z.screensaver) {
				if (!Z.constrainPanStrict) { Z.constrainPanStrict = true; }
			} else {
				Z.Utils.playAudio(destinationNextAudio, hotspots[destinationCurrent].audio);
			}

			// Set destination to next destination in list excluding title and not exceeding end of list.
			// Go to destination to start iteration, with abbreviated delay if starting tour with button.
			var targetIndex = (Z.screensaver) ? 0 : calculateTargetIndex(destinationCurrent, 'next', hotspots.length - 1);
			if (targetIndex !== null) {
				Z.Utils.functionCallWithDelay(function () { self.goToDestination(targetIndex); }, 1500);
			}
		}
	}

	this.tourStop = function () {
		Z.tourPlaying = false;

		// Swap buttons.
		var bTRS = document.getElementById('buttonTourStop');
		var bTRST = document.getElementById('buttonTourStart');
		if (bTRS && bTRST) {
			bTRS.style.display = 'none';
			bTRST.style.display = 'inline-block';
		}
	}

	this.priorDestination = function (override) {
		if (Z.tourPlaying && override) { self.tourStop(); }
		if (Z.screensaver) {
			self.zoomAndPanToView(Z.priorX, Z.priorY, Z.priorZ, Z.priorR);
		} else {
			destinationChange('prior');
		}
	}

	this.nextDestination = function (override) {
		if (Z.tourPlaying && override) { self.tourStop(); }
		destinationChange('next');
	}

	destinationChange = function (direction) {
		var targetIndex;
		if (Z.screensaver) {
			var showFor = (Z.screensaverSpeed > 0) ? 8000 / Z.screensaverSpeed : 3000;
			Z.Utils.functionCallWithDelay(function () { self.goToDestination(0); }, showFor);

		} else {
			if (typeof hotspotList !== 'undefined' && hotspotList !== null && hotspotList.length > 0) {
				Z.Utils.playAudio(destinationNextAudio, hotspots[destinationCurrent].audio);
				var delay = (Z.tourPlaying) ? hotspots[destinationCurrent].showFor : 0;

				// DEV NOTE: Increase delay as workaround for audio pre-loading issues.
				if (Z.Utils.stringValidate(hotspots[destinationCurrent].audio)) { delay += 500; }

				targetIndex = calculateTargetIndex(destinationCurrent, direction, hotspots.length - 1);
				if (targetIndex !== null) {
					if (!Z.screensaver) { Z.Utils.loadAudio(hotspots[targetIndex].audio); }
					Z.Utils.functionCallWithDelay(function () { self.goToDestination(targetIndex); }, delay);
				} else {
					self.tourStop();
				}
			}
		}
	}

	this.goToDestination = function (index) {
		if (Z.tourStop) {
			self.tourStop();
			Z.tourStop = false;
		} else {
			var x, y, z, r;
			var callback = (Z.tourPlaying) ? self.nextDestination : null;
			if (Z.screensaver) {
				x = Z.Utils.getRandomInt(1, Z.imageW);
				y = Z.Utils.getRandomInt(1, Z.imageH);
				z = Z.Utils.getRandomInt(Z.minZ * 100, Z.maxZ * 100) / 100;
				// Ensure significant change. Pan and zoom constraints limit values.
				if ((Z.imageX - x) < 500) {
					x += 500;
					if (x > Z.imageW) { x -= 1000; }
				}
				if ((Z.imageY - y) < 500) {
					y += 500;
					if (y > Z.imageH) { y -= 1000; }
				}
				if ((Z.imageZ - z) < 0.3) {
					z += 0.3;
					if (z > Z.maxZ) { z -= 0.6; }
				}
				r = 0; // DEV NOTE: Add rotation option in future update.
				var chgFor = (Z.screensaverSpeed > 0) ? 8000 / Z.screensaverSpeed : null;
				if (chgFor !== null) {
					self.zoomAndPanToView(x, y, z, r, chgFor, null, callback);
				} else {
					self.setView(x, y, z, r, callback);
				}
			} else {
				destinationCurrent = index;
				var hotspot = hotspots[index];
				x = hotspot.x;
				y = hotspot.y;
				z = hotspot.z / 100;
				r = hotspot.rotation;
				chgFor = hotspot.changeFor;
				switch (hotspots.transition) {
					case 'ZoomAndPanToView' :
						self.zoomAndPanToView(x, y, z, r, chgFor, null, callback);
						break;
					case 'SetView' :
						self.setView(x, y, z, r, callback);
						break;
					default:
						self.zoomAndPanToView(x, y, z, r, chgFor, null, callback);
						break;
				}
				var destinationCurrentInList = Z.Utils.arrayIndexOfObjectValue(hotspotList.options, 'value', hotspot.internalID.toString());
				if (destinationCurrentInList != -1) { hotspotList.selectedIndex = destinationCurrentInList; }
			}
		}
	}

	this.parseImageListXML = function (xmlDoc, vpID) {
		// Clear any prior values.
		Z.Utils.arrayClear(imageListDP);

		// Parse display setup information.
		imageListPosition = Z.Utils.getResource('DEFAULT_IMAGELISTPOSITION');
		imageListSource = Z.Utils.getResource('DEFAULT_IMAGELISTSOURCE');
		var imageListSetup = xmlDoc.getElementsByTagName('SETUP')[0];
		if (imageListSetup) {
			var listPosition = imageListSetup.getAttribute('LISTPOSITION');
			if (Z.Utils.stringValidate(listPosition)) { imageListPosition = listPosition; }
			var listSource = imageListSetup.getAttribute('LISTSOURCE');
			if (Z.Utils.stringValidate(listSource)) { imageListSource = listSource; }
			var listTitle = imageListSetup.getAttribute('LISTTITLE');
			if (Z.Utils.stringValidate(listTitle)) { Z.imageListTitle = listTitle; }
		}

		// Parse values for individual images.
		var imageNodes = xmlDoc.getElementsByTagName('IMAGE');
		for (var i = 0, j = imageNodes.length; i < j; i++) {
			var image = imageNodes[i];
			var imageName = image.getAttribute('NAME');
			var imagePath = image.getAttribute('MEDIA');
			var imageListText = (imageListSource == 'NAME') ? imageName : imagePath.substring(imagePath.lastIndexOf("/")+1, imagePath.length);
			var internalID = getFreeID('image');
			var optionalParams = '';
			for (var k=0, m = image.attributes.length; k < m; k++) {
				var attrib = image.attributes[k];
				if (attrib.name != 'MEDIA' && attrib.name != 'NAME' && Z.Utils.stringValidate(attrib.value)) {
					optionalParams += convertImageNodeNameToParamName(attrib.name) + '=' + attrib.value;
					if (k < m - 1) { optionalParams += '&'; }
				}
			}

			// DEV NOTE: Optional HTML parameter custom tile dimensions override defaults, XML values, or server provided values.
			// but not custom tile dimensions applied in image list optional parameter values, so must clear here.
			if (image.getAttribute('TILEW') === null) { optionalParams += '&zTileW=256'; }
			if (image.getAttribute('TILEH') === null) { optionalParams += '&zTileH=256'; }

			imageListDP[imageListDP.length] = { text:imageListText, value:internalID, media:imagePath, optionalParams:optionalParams };
		}

		// Create slide choice list.
		createImageChoiceList(Z.imageListTitle, imageListDP, vpID);
	}

	function convertImageNodeNameToParamName (nodeName) {
		var pName = '';
		switch (nodeName) {
			case 'INITIALX' :
				pName = 'zInitialX';
				break;
			case 'INITIALY' :
				pName = 'zInitialY';
				break;
			case 'INITIALZOOM' :
				pName = 'zInitialZoom';
				break;
			case 'MINZOOM' :
				pName = 'zMinZoom';
				break;
			case 'MAXZOOM' :
				pName = 'zMaxZoom';
				break;
			case 'INITIALROTATION' :
				pName = 'zInitialRotation';
				break;
			case 'RULERLISTTYPE' :
				pName = 'zRulerListType';
				break;
			case 'UNITS' :
				pName = 'zUnits';
				break;
			case 'UNITSPERIMAGE' :
				pName = 'zUnitsPerImage';
				break;
			case 'PIXELSPERUNIT' :
				pName = 'zPixelsPerUnit';
				break;
			case 'SOURCEMAGNIFICATION' :
				pName = 'zSourceMagnification';
				break;
			case 'IMAGEPROPERTIES' :
				pName = 'zImageProperties';
				break;
			case 'TILESPNG' :
				pName = 'zTilesPNG';
				break;
			case 'TILEW' :
				pName = 'zTileW';
				break;
			case 'TILEH' :
				pName = 'zTileH';
				break;
			case 'IMAGEW' :
				pName = 'zImageW';
				break;
			case 'IMAGEH' :
				pName = 'zImageH';
				break;
			case 'MAGNIFICATION' :
				pName = 'zMagnification';
				break;
			case 'FOCAL' :
				pName = 'zFocal';
				break;
			case 'QUALITY' :
				pName = 'zQuality';
				break;
			case 'HOTSPOTS' :
				pName = 'zHotspotPath';
				break;
			case 'ANNOTATIONS' :
				pName = 'zAnnotationPath';
				break;
			case 'TRACKING' :
				pName = 'zTrackingPath';
				break;
		}
		return pName;
	}

	function createImageChoiceList (title, dataProvider, vpIDComp) {
		if (self.getStatus('initializedViewport')) {
			var visible = (slideListPosition == '0') ? 'hidden' : 'visible';
			imageListW = (Z.tracking && Z.navigatorVisible && Z.navigatorW !== null) ? Z.navigatorW + 2 : parseInt(Z.Utils.getResource('DEFAULT_IMAGELISTWIDTH'), 10);
			var listCoords = self.calculateImageListCoords(viewW, viewH, vpIDComp); // viewH allows for toolbar height if static in viewer display area.
			var vpIDStr = (typeof vpIDComp === 'undefined' || !Z.Utils.stringValidate(vpIDComp)) ? '' : vpIDComp.toString();

			// Create choice list and add to viewer.
			if (typeof imageList === 'undefined' || imageList === null) {
				imageList = new Z.Utils.createSelectElement('imageList' + vpIDStr, title, dataProvider, imageListW, listCoords.x, listCoords.y, null, visible, imageListChangeHandler, 'change');
				Z.ViewerDisplay.appendChild(imageList);

				// Ensure proper z-ordering of Viewer elements.
				imageList.style.zIndex = (Z.baseZIndex + 8).toString();

				imageCurrent = 0;
				imageList.selectedIndex = 0;
				self.setStatus('initializedImageList', true);
			} else {
				Z.Utils.arrayClear(dataProvider);
			}

		} else {
			Z.imageListTimeout = window.setTimeout( function () { createImageChoiceList(title, dataProvider, vpIDComp); } );
		}
	}
	
	this.setSizeAndPositionImageList = function (width, left, top) {
		if (typeof width === 'undefined' || width === null) { 
			width = (Z.tracking && Z.navigatorVisible && Z.navigatorW !== null) ? Z.navigatorW + 2 : parseInt(Z.Utils.getResource('DEFAULT_IMAGELISTWIDTH'), 10);
		}
		var listCoords = self.calculateImageListCoords(viewW, viewH, vpID); // viewH allows for toolbar height if static in viewer display area.
		if (typeof left === 'undefined' || left === null) { left = listCoords.x; }
		if (typeof top === 'undefined' || top === null) { top = listCoords.y; }		
		imageList.style.width = width + 'px'; 
		imageList.style.left = left + 'px';
		imageList.style.top = top + 'px';
	}
	
	this.calculateImageListCoords = function (viewerW, viewerH, vpIDComp) {
		//Slide list positioning: 0 hides, 1 top left, 2 top-right, 3 bottom right, 4 bottom left
		var position = imageListPosition;
		var listW = imageListW;
		if (Z.tracking && position == '1') { listW += 2; }
		var listX, listY;
		var margin = 25;
		switch (position) {
			case '0':
				listX = 0;
				listY = 0;
				break;
			case '1':
				if (!Z.tracking) {
					listX = margin;
					listY = margin;
				} else {
					var userPanelH = parseInt(Z.Utils.getResource('DEFAULT_USERPANELHEIGHT'), 10);
					listX = Z.navigatorL;
					listY = Z.navigatorT + Z.navigatorH + Z.rulerH + userPanelH + 6;
				}
				break;
			case '2':
				listX = viewerW - listW - margin;
				listY = 20;
				break;
			case '3':
				listX = viewerW - listW - margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			case '4':
				listX = margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			default:
				listX = viewerW - listW;
				listY = margin;
		}

		// If comparing two images adjust base list position on viewport and list position as set in XML.
		if (Z.comparison && typeof vpIDComp !== 'undefined' && vpIDComp !== null) {
			if (vpIDComp == 0 && (position == '2' || position == '3')) {
				listX = viewerW - margin;
			} else if (vpIDComp == 1 && (position == '1' || position == '4')) {
				listX = (viewerW * 2) - (margin + listW);
			}
		}
		
		return new Z.Utils.Point(listX, listY);
	}

	this.setImageListVisibilty = function (visibility) {
		imageList.style.visibility = visibility;
	}

	function imageListChangeHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			Z.Viewer.viewportSelect(vpID);
			var target = Z.Utils.target(event);
			var indexTitleAdjust = (Z.Utils.stringValidate(Z.imageListTitle) && Z.imageListTitle != 'none') ? 1 : 0;
			var index = target.selectedIndex - indexTitleAdjust;
			if (imageListDP[index].value != 'null') {
				Z.Viewer.setImage(imageListDP[index].media, imageListDP[index].optionalParams, false, vpID);
			}
		}
	}

	this.parseSlidesXML = function (xmlDoc) {
		// Clear any prior values.
		Z.Utils.arrayClear(slides);
		Z.Utils.arrayClear(slideListDP);

		// Parse display setup information.
		slideshowAutoStart = Z.Utils.getResource('DEFAULT_SLIDESHOWAUTOSTART');
		slideshowAutoLoop = Z.Utils.getResource('DEFAULT_SLIDESHOWAUTOLOOP');
		slideListPosition = Z.Utils.getResource('DEFAULT_SLIDELISTPOSITION');
		slideListW = parseInt(Z.Utils.getResource('DEFAULT_SLIDELISTWIDTH'), 10);
		slideListSource = Z.Utils.getResource('DEFAULT_SLIDELISTSOURCE');
		if (Z.slideListTitle === null) { Z.slideListTitle = Z.Utils.getResource('UI_SLIDELISTTITLE'); }
		var slideshowSetup = xmlDoc.getElementsByTagName('SETUP')[0];
		if (slideshowSetup) {
			var autoStart = slideshowSetup.getAttribute('AUTOSTART');
			if (Z.Utils.stringValidate(autoStart)) { slideshowAutoStart = (autoStart != '0' && autoStart != 'false'); }
			var autoLoop = slideshowSetup.getAttribute('AUTOLOOP');
			if (Z.Utils.stringValidate(autoLoop)) { slideshowAutoLoop = (autoLoop != '0' && autoLoop != 'false'); }
			var listPosition = slideshowSetup.getAttribute('CHOICELIST');
			if (Z.Utils.stringValidate(listPosition)) { slideListPosition = listPosition; }
			var listSource = slideshowSetup.getAttribute('LISTSOURCE');
			if (Z.Utils.stringValidate(listSource)) { slideListSource = listSource; }
			var listTitle = slideshowSetup.getAttribute('LISTTITLE');
			if (Z.Utils.stringValidate(listTitle)) { Z.slideListTitle = listTitle; }
		}

		// Parse values for individual slides.
		var slideNodes = xmlDoc.getElementsByTagName('SLIDE');
		for (var i = 0, j = slideNodes.length; i < j; i++) {
			var slide = new Slide(slideNodes[i]);
			slides[slides.length] = slide;
			var slideListText = (slideListSource == 'NAME') ? slide.name : slide.media.substring(slide.media.lastIndexOf("/")+1, slide.media.length);
			slideListDP[slideListDP.length] = { text:slideListText, value:slide.internalID };
		}

		// Create slide choice list.
		createSlideChoiceList(Z.slideListTitle, slideListDP);

		// Set audio mute buttons visible if AUDIO attribute in use.
		self.initializeAudioMuteButtons();

		// If first image path not loaded from image path parameter, use first values in slides XML file.
		// Otherwise start slideshow if auto start parameter set.
		if (Z.imagePath === null || Z.imagePath == 'null' || Z.imagePath.indexOf('zSlidePath') != -1) {
			self.goToSlide(0, true);
		} else if (slideshowAutoStart) {
			self.slideshowStart();
		}
	}

	function Slide (slideNode) {
		var tempN;
		this.id = slideNode.getAttribute('ID');
		this.name = slideNode.getAttribute('NAME');

		this.internalID = slideNode.getAttribute('INTERNALID');
		if (isNaN(parseInt(this.internalID, 10))) { this.internalID = getFreeID('slide'); }

		this.media = slideNode.getAttribute('MEDIA'); // This is a path.
		this.audio = slideNode.getAttribute('AUDIO'); // This is a path.
		if (Z.Utils.stringValidate(this.audio)) { Z.audioContent = true; }

		this.initialX = slideNode.getAttribute('INITIALX');
		this.initialY = slideNode.getAttribute('INITIALY');
		this.initialZoom = slideNode.getAttribute('INITIALZOOM');
		this.minZoom = slideNode.getAttribute('MINZOOM');
		this.maxZoom = slideNode.getAttribute('MAXZOOM');
		
		this.hotspotPath = slideNode.getAttribute('HOTSPOTPATH');
		this.annotationPath = slideNode.getAttribute('ANNOTATIONPATH');

		tempN = parseFloat(slideNode.getAttribute('SHOWFOR'));
		this.showFor = isNaN(tempN) ? 0 : tempN;
		this.transition = slideNode.getAttribute('TRANSITION');
		tempN = parseFloat(slideNode.getAttribute('CHANGEFOR'));
		this.changeFor = isNaN(tempN) ? 0 : tempN;
	}

	function createSlideChoiceList (title, dataProvider) {
		var visible = (slideListPosition == '0') ? 'hidden' : 'visible';
		var listCoords = self.calculateSlideListCoords(viewW, viewH); // viewH allows for toolbar height if static in viewer display area.

		// Create choice list and add to viewer.
		if (typeof slideList === 'undefined' || slideList === null) {
			slideList = new Z.Utils.createSelectElement('slideList', title, dataProvider, slideListW, listCoords.x, listCoords.y, null, visible, slideListChangeHandler, 'change');
			Z.ViewerDisplay.appendChild(slideList);
			Z.slideList = true;
			slideCurrent = 0;
			var indexTitleAdjust = (Z.Utils.stringValidate(Z.slideListTitle) && Z.slideListTitle != 'none') ? 1 : 0;
			slideList.selectedIndex = indexTitleAdjust;
		} else {
			Z.Utils.arrayClear(dataProvider);
		}
	}

	this.calculateSlideListCoords = function (viewerW, viewerH) {
		//Slide list positioning: 0 hides, 1 top left, 2 top-right, 3 bottom right, 4 bottom left
		var position = slideListPosition;
		var listW = slideListW;
		var listX, listY;
		var margin = 25;
		switch (position) {
			case '0':
				listX = 0;
				listY = 0;
				break;
			case '1':
				listX = margin;
				listY = margin;
				break;
			case '2':
				listX = viewerW - listW - margin;
				listY = 20;
				break;
			case '3':
				listX = viewerW - listW - margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			case '4':
				listX = margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					listY = viewerH - margin * 2;
				} else {
					listY = viewerH - margin * 1.5;
				}
				break;
			default:
				listX = viewerW - listW;
				listY = margin;
		}
		return new Z.Utils.Point(listX, listY);
	}

	function slideListChangeHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			if (Z.slideshowPlaying) { self.slideshowStop(); }
			var target = Z.Utils.target(event);
			if (target.options[target.selectedIndex].value != 'null') {
				var indexTitleAdjust = (Z.Utils.stringValidate(Z.slideListTitle) && Z.slideListTitle != 'none') ? 1 : 0;
				self.goToSlide(target.selectedIndex - indexTitleAdjust, null, true);
			}
		}
	}

	this.slideshowStart = function (initialCall) {
		self.slideshowStop();
		Z.slideshowPlaying = true;

		// Swap buttons.
		var bSSS = document.getElementById('buttonSlideshowStop');
		var bSSST = document.getElementById('buttonSlideshowStart');
		if (bSSS && bSSST) {
			bSSS.style.display = 'inline-block';
			bSSST.style.display = 'none';
		}

		Z.Utils.playAudio(destinationNextAudio, slides[slideCurrent].audio);

		// Set slide to next slide in list excluding title and not exceeding end of list.
		// Go to slide to start iteration, with abbreviated delay if starting show with button.
		var delay = (Z.slideshowPlaying) ? slides[slideCurrent].showFor : 0;
		var targetIndex = (initialCall) ? 0 : calculateTargetIndex(slideCurrent, 'next', slides.length - 1);
		if (targetIndex !== null) {
			Z.Utils.loadAudio(slides[targetIndex].audio);
			Z.Utils.functionCallWithDelay(function () { self.goToSlide(targetIndex, null, null, true); }, delay);
		}
	}

	this.slideshowStop = function () {
		Z.slideshowPlaying = false;

		// Swap buttons.
		var bSSS = document.getElementById('buttonSlideshowStop');
		var bSSST = document.getElementById('buttonSlideshowStart');
		if (bSSS && bSSST) {
			bSSS.style.display = 'none';
			bSSST.style.display = 'inline-block';
		}
	}

	this.priorSlide = function (override) {
		if (Z.slideshowPlaying && override) { self.slideshowStop(); }
		slideChange('prior');
	}

	this.nextSlide = function (override) {
		if (Z.slideshowPlaying && override) { self.slideshowStop(); }
		slideChange('next');
	}

	function slideChange (direction) {
		if (typeof slideList !== 'undefined' && slideList !== null && slideList.length > 0) {

			var delay = (Z.slideshowPlaying) ? slides[slideCurrent].showFor : 0;
			// DEV NOTE: Increase delay as workaround for audio pre-loading issues.
			if (Z.Utils.stringValidate(slides[slideCurrent].audio)) { delay += 500; }
			var targetIndex = calculateTargetIndex(slideCurrent, direction, slides.length - 1);
			if (targetIndex !== null) {
				Z.Utils.functionCallWithDelay(function () { self.goToSlide(targetIndex, null, null, true); }, delay);
			} else {
				self.slideshowStop();
			}
		}
	}

	this.goToSlide = function (index, initializingCall, changeHandler, buttonHandler) {
		if (Z.slideshowPlaying || initializingCall || changeHandler || buttonHandler) {
			slideCurrent = index;
			var slide = slides[index];
			var viewerParams = Z.Utils.parametersToDelimitedString(Z.parameters, '&');
			var slideParams = getSlideOptionalParams(slide);
			var concat = (Z.Utils.stringValidate(slideParams)) ? '&' : '';
			var optionalParams = viewerParams + concat + slideParams;
			switch (slide.transition) {
				case 'Fade' :
					Z.Viewer.setImageWithFade(slide.media, optionalParams, initializingCall, slide.changeFor);
					break;
				case 'None' :
					Z.Viewer.setImage(slide.media, optionalParams, initializingCall);
					break;
				default:
					Z.Viewer.setImageWithFade(slide.media, optionalParams, initializingCall);
					break;
			}
			var slideCurrentInList = Z.Utils.arrayIndexOfObjectValue(slideList.options, 'value', slide.internalID.toString());
			if (slideCurrentInList != -1) { slideList.selectedIndex = slideCurrentInList; }
			if (Z.Gallery && Z.Gallery.getInitialized()) { Z.Gallery.syncGalleryToViewport(slideCurrentInList - 1); }		
		}
	}

	this.getSlides = function () {
		return slides;
	}

	function getSlideOptionalParams (slide) {
		temp = slide.initialX;
		var initXStr = (Z.Utils.stringValidate(temp)) ? (temp == 'center') ? 'zInitialX=' + (Z.imageW / 2).toString() : (!isNaN(parseFloat(temp))) ? 'zInitialX=' + temp : null : null;
		temp = slide.initialY;
		var initYStr = (Z.Utils.stringValidate(temp)) ? (temp == 'center') ? 'zInitialY=' + (Z.imageH / 2).toString() : (!isNaN(parseFloat(temp))) ? 'zInitialY=' + temp : null : null;
		temp = slide.initialZoom;
		var initZStr = (Z.Utils.stringValidate(temp)) ? (!isNaN(parseFloat(temp))) ? 'zInitialZoom=' + temp : null : null;
		temp = slide.minZoom;
		var minZStr = (Z.Utils.stringValidate(temp)) ? (!isNaN(parseFloat(temp))) ? 'zMinZoom=' + temp : null : null;
		temp = slide.maxZoom;
		var maxZStr = (Z.Utils.stringValidate(temp)) ? (!isNaN(parseFloat(temp))) ? 'zMaxZoom=' + temp : null : null;
		temp = slide.hotspotPath;
		var hotPathStr = (Z.Utils.stringValidate(temp)) ? 'zHotspotPath=' + temp : null;
		temp = slide.annotationPath;
		var annotPathStr = (Z.Utils.stringValidate(temp)) ? 'zAnnotationPath=' + temp : null;

		var optParams = (initXStr !== null) ? initXStr : null;
		optParams = (initYStr !== null) ? (optParams !== null) ? optParams + '&' + initYStr : initYStr : null;
		optParams = (initZStr !== null) ? (optParams !== null) ? optParams + '&' + initZStr : initZStr : null;
		optParams = (minZStr !== null) ? (optParams !== null) ? optParams + '&' + minZStr : minZStr : null;
		optParams = (maxZStr !== null) ? (optParams !== null) ? optParams + '&' + maxZStr : maxZStr : null;
		optParams = (hotPathStr !== null) ? (optParams !== null) ? optParams + '&' + hotPathStr : hotPathStr : null;
		optParams = (annotPathStr !== null) ? (optParams !== null) ? optParams + '&' + annotPathStr : annotPathStr : null;

		return optParams;
	}

	this.slideTransitionTimeoutHandler = function (direction, imagePath, optionalParams, initializingCall, changeFor) {
		if (typeof changeFor === 'undefined' || changeFor === null) { changeFor = 50; }
		if (initializingCall) {
			Z.Viewer.setImage(imagePath, optionalParams, initializingCall);
			direction = 'in';
		}
		window.clearTimeout(Z.slideTransitionTimeout);
		Z.slideTransitionTimeout = null;
		if (direction == 'out') {
			if (Z.slideOpacity >= 0) {
				Z.slideOpacity -= slideTransitionStep;
				direction = 'out';
			} else {
				Z.slideOpacity = 0;
				direction = 'in';
				Z.setCallback('viewUpdateComplete', function () { Z.slideTransitionTimeout = window.setTimeout( function () { Z.Viewport.slideTransitionTimeoutHandler(direction, imagePath, optionalParams); }, changeFor); });
				Z.Viewer.setImage(imagePath, optionalParams, null);
			}
		} else {
			if (Z.slideOpacity == 0) {
				Z.Utils.playAudio(destinationNextAudio, slides[slideCurrent].audio);
				Z.clearCallback('viewUpdateComplete', function () { Z.slideTransitionTimeout = window.setTimeout( function () { Z.Viewport.slideTransitionTimeoutHandler(direction, imagePath, optionalParams); }, changeFor); });
			}
			if (Z.slideOpacity <= 1) {
				Z.slideOpacity += slideTransitionStep;
				direction = 'in';
			} else {
				Z.slideOpacity = 1;
				direction = null;
			}
		}

		// Update opacity.
		if (cD) { Z.Utils.setOpacity(cD, Z.slideOpacity); }
		if (Z.NavigatorDisplay) { Z.Utils.setOpacity(Z.NavigatorDisplay, Z.slideOpacity); }
		if (Z.GalleryDisplay) { Z.Utils.setOpacity(Z.GalleryDisplay, Z.slideOpacity); }

		// Iterate fading transition.
		if (direction !== null && Z.slideOpacity != 0) {
			Z.slideTransitionTimeout = window.setTimeout( function () { Z.Viewport.slideTransitionTimeoutHandler(direction, imagePath, optionalParams); }, changeFor);
		}
	}

	function calculateTargetIndex (index, direction, max) {
		var loop = (tourAutoLoop || slideshowAutoLoop); // Simple test because won't have both tour and slides.
		var skipTest = 'Skip';
		while (skipTest == 'Skip') {
			if (direction == 'next') {
				index += 1;
				if (index > max) {
					if (loop) {
						index = 0;
					} else {
						index = null;
					}
				}
			} else {
				index -= 1;
				if (index < 0) {
					if (loop) {
						index = max;
					} else {
						index = null;
					}
				}
			}
			if (Z.hotspots) {
				skipTest = (index !== null) ? hotspots[index].transition : null;
			} else if (Z.slideshow) {
				skipTest = (index !== null) ? slides[index].transition : null;
			} else {
				skipTest = null;
			}
		}
		return index;
	}

	this.initializeAudioMuteButtons = function () {
		if (Z.audioContent) {
			var bAO = document.getElementById('buttonAudioOn');
			if (bAO) { bAO.style.display = 'inline-block'; }
		}
	}

	this.audioMute = function (muted) {
		Z.audioMuted = muted;

		// Swap buttons.
		var bAM = document.getElementById('buttonAudioMuted');
		var bAO = document.getElementById('buttonAudioOn');
		if (bAM && bAO) {
			if (muted) {
				bAM.style.display = 'inline-block';
				bAO.style.display = 'none';
			} else {
				bAM.style.display = 'none';
				bAO.style.display = 'inline-block';
			}
		}

	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: INTERACTION FUNCTIONS :::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// DEV NOTES: Variable Z.imageR updated during implementation of rotation rather than
	// once in updateView. This differs from updating of variables Z.imageX/Y/Z. Comparison of
	// approaches in progress. Variable Z.preventDupCall set to ensure values set by call in reset
	// function are not overridden by duplicated call in updateView function. Rounding required
	// because rotation functions currently support exact 90 degree increments only.
	function recordPriorViewCoordinates () {
		if (!Z.preventDupCall) {
			Z.priorX = Math.round(Z.imageX);
			Z.priorY = Math.round(Z.imageY);
			Z.priorZ = Z.imageZ;
			Z.priorR = Math.round(Z.imageR);
		}
		Z.preventDupCall = (typeof called !== 'undefined' && called !== null);
	}

	// Fast update of viewport position, scale, and rotation without updateView.
	this.setViewNoUpdate = function (cLeft, cTop, vWidth, vHeight, vLeft, vTop, bWidth, bHeight, bLeft, bTop, cRotation) {
		cS.left = cLeft;
		cS.top = cTop;
		vS.width = vWidth;
		vS.height = vHeight;
		vS.left = vLeft;
		vS.top = vTop;
		bS.width = bWidth;
		bS.height = bHeight;
		bS.left = bLeft;
		bS.top = bTop;
		cS.rotation = cRotation;
	}

	this.setView = function (x, y, z, r, callback, override) {
		view(x, y, z, r, callback, override);
	}

	// View assignment function.
	function view (x, y, z, r, callback, override) {
		if (!override) { self.zoomAndPanAllStop(); }
		if (Z.maskingSelection && Z.maskClearOnUserAction) { self.clearMask(); }

		// Validate coordinate values.
		if (typeof x === 'undefined' || x === null) { x = (Z.imageW / 2); }
		if (typeof y === 'undefined' || y === null) { y = (Z.imageH / 2); }

		if (typeof z === 'undefined' || z === null) {
			z = Z.fitZ;
		} else if (z > 1 && z > Z.maxZ) {
			z = z / 100;
		}
		if (typeof r === 'undefined' || r === null) { r = Z.imageR; }

		// Constrain coordinate values.
		z = constrainZoom(z);
		r = constrainRotation(r);
		var constrainedPt = constrainPan(x, y, z, r, 'image');

		// Assign coordinate values.
		Z.imageX = imageX = constrainedPt.x;
		Z.imageY = imageY = constrainedPt.y;
		Z.imageZ = z;

		// Apply coordinate values.
		if (r != Z.imageR) { Z.Utils.rotateElement(cS, r); }
		Z.imageR = r;
		self.updateView(true);
		if (typeof callback === 'function') { callback(); }
	}

	this.zoom = function (zoomDir) {
		// Avoid redundant calls resulting in redundant updateView calls below.
		if (zoomDir == 'stop' && Z.zooming == 'stop') { return; }

		switch(zoomDir) {
			case 'out' :
				if (zoomVal >= 0) { zoomVal -= zoomStepDistance; }
				break;
			case 'in' :
				if (zoomVal <= 0) { zoomVal += zoomStepDistance; }
				break;
			case 'stop' :
				zoomVal = 0;
				break;
		}
		Z.zooming = (zoomVal == 0) ? 'stop' : ((zoomVal > 0) ? 'in' : 'out');

		if (zoomVal !=0) {
			if (!zapTimer) {
				if (((zoomVal < 0) && (Z.imageZ > Z.minZ)) || ((zoomVal > 0) && (Z.imageZ < Z.maxZ))) {
					self.toggleWatermarks(false);
					if (hotspots && hotspots.length > 39) { self.setHotspotsVisibility(false); }
				}
				if (!Z.useCanvas) { Z.Utils.clearDisplay(wD); }
				zapTimer = window.setTimeout(zoomAndPanContinuousStep, zapStepDuration);
			}
		} else {
			zoomAndPanContinuousStop();
			self.updateView();
			self.toggleWatermarks(true);
			if (hotspots && hotspots.length > 39) { self.setHotspotsVisibility(true); }
		}
	}

	// Pan direction refers to the pan of the view - the opposite of the movement of the image.
	this.pan = function (panDir) {
		// Avoid redundant calls resulting in redundant updateView calls below.
		if (panDir == 'horizontalStop' && Z.panningX == 'stop') { return; }
		if (panDir == 'verticalStop' && Z.panningY == 'stop') { return; }

		if (!Z.tracking) {
			switch(panDir) {
				case 'left' :
					if (panX <= 0) { panX += panStepDistance; }
					break;
				case 'up' :
					if (panY <= 0) { panY += panStepDistance; }
					break;
				case 'down' :
					if (panY >= 0) { panY -= panStepDistance; }
					break;
				case 'right' :
					if (panX >= 0) { panX -= panStepDistance; }
					break;
				case 'horizontalStop' :
					panX = 0;
					break;
				case 'verticalStop' :
					panY = 0;
					break;
				case 'stop' :
					panX = 0;
					panY = 0;
					break;
			}
		}

		Z.panningX = (panX == 0) ? 'stop' : ((panX > 0) ? 'left' : 'right');
		Z.panningY = (panY == 0) ? 'stop' : ((panY > 0) ? 'up' : 'down');
		zapTierCurrentZoomUnscaledX = Z.imageX * convertTierScaleToZoom(tierCurrent, 1);
		zapTierCurrentZoomUnscaledY = Z.imageY * convertTierScaleToZoom(tierCurrent, 1);

		if (panX !=0 || panY != 0) {
			if (!zapTimer) {
				// Clear watermarks for faster, smoother zoom.
				self.toggleWatermarks(false);
				if (!Z.useCanvas) { Z.Utils.clearDisplay(wD); }
				if (hotspots && hotspots.length > 39) { self.setHotspotsVisibility(false); }
				zapTimer = window.setTimeout(zoomAndPanContinuousStep, zapStepDuration);
			}
		} else {
			zoomAndPanContinuousStop();
			self.updateView();
			self.toggleWatermarks(true);
			if (hotspots && hotspots.length > 39) { self.setHotspotsVisibility(true); }
		}
	}

	function zoomAndPanContinuousStep () {
		if (zapTimer) {
			// If interval, pan, zoom values not cleared, pan and/or zoom one step.
			if (panX != 0 || panY != 0 || zoomVal != 0) {
				if (!Z.tracking || zoomVal != 0) {
					zoomAndPan(panX, panY, zoomVal);
					// If pan and zoom variables have not been cleared, recall timer.
					zapTimer = window.setTimeout(zoomAndPanContinuousStep, zapStepDuration);
				} else {
					self.zoomAndPanToView(self.getX() + panX, self.getY() + panY);
				}
			}
		}
	}

	function zoomAndPan (stepX, stepY, stepZ) {
		// Pan constraint is applied separately to direct pan and to the indirect pan that
		// occurs when zooming out if image off-center. This enables prevention rather
		// than correction of dissallowed pan and avoids jitter at boundary conditions.
		var viewPanned = false, syncSlider = false, syncNav = false;
		var constrainedZ = self.getZoom();

		if (stepZ != 0) {
			// Calculate change to scale of tier.  For zoom buttons and keys, meter progress by
			// increasing weight of each step as tier scale grows and decreasing as scale shrinks.
			var targetScale = tierScale *  (1 + stepZ);

			// Calculate target zoom for current step based on target scale for current step.
			var targetZoom = convertTierScaleToZoom(tierCurrent, targetScale);

			// Constrain target zoom.
			constrainedZ = constrainZoom(targetZoom);
			if (constrainedZ != Z.imageZ) {
				// Scale the viewport display to implement zoom step.
				syncSlider = syncNav = scaleTierToZoom(constrainedZ);
			}
		}

		if (stepX != 0 || stepY != 0) {
			// Calculate new container position.
			var targetL = parseFloat(cS.left) + stepX;
			var targetT = parseFloat(cS.top) + stepY;

			// Calculate constrained new position and set viewport display to new position.
			var constrainedPt = constrainPan(targetL, targetT, constrainedZ, Z.imageR, 'container');

			// DEV NOTE: Rounding addresses Firefox bug that causes assignment of zero value to fail when scrolling up from
			// bottom and value of cS.top to stop incrementing at -50 rather than increasing to appropriate positive constraint.
			cS.left = Math.round(constrainedPt.x) + 'px';
			cS.top = Math.round(constrainedPt.y) + 'px';

			viewPanned = true;
			syncNav = true;

			var deltaX = constrainedPt.x - displayL;
			var deltaY = constrainedPt.y - displayT;
			if (oD && tierBackfillDynamic && (Z.mobileDevice || (Math.abs(deltaX) > (viewW / 2) || Math.abs(deltaY) > (viewH / 2)))) {
				redisplayCachedTiles(oD, tierBackfillOversize, tilesBackfillCached, 'simple', false, 'Updating backfill oversize display');
			}
		}

		// Sync watermarks, hotspots, zoom slider, navigator, ruler, image set slider on every iteration of zoom function
		// unless number of hotspots is large, then skip every other step. Tradeoff is smooth zoom vs smooth scaling of hotspots.
		var hotspotsSkip = (hotspots && hotspots.length > 30);
		if (!hotspotsSkip) {
			self.syncViewportRelated();
		} else if (zapStepCount % 2 == 0) {
			self.syncViewportRelated();
		}
		zapStepCount++;

		// Load new tiles as needed during panning (not zooming).
		/* DEV NOTE: Updating tiles while panning disabled. Requires optimization.
		if (viewPanned) {
			var canvasScale = (Z.useCanvas) ? (parseFloat(vS.width) / vD.width) : 1;
			var maxDim = Math.max(TILE_WIDTH, TILE_HEIGHT);
			var loadThreshold = Math.round(maxDim / panStepDistance * tierScale * canvasScale);
			var loadStep = (zapStepCount % loadThreshold == 0 && zapStepCount != 0);
			if (loadStep) { updateViewWhilePanning(stepX, stepY); }
		}*/
	}

	// Transition smoothly to new view. Image coordinates input, converted to viewport coordinates,
	// then zoom and pan, then updateView to convert changes back to image coordinates.
	this.zoomAndPanToView = function (targetX, targetY, targetZ, targetR, duration, steps, callback) {

		//First stop any zoom or pan in progress.
		self.zoomAndPanAllStop();
		
		// Second, if block enabled to prevent conflict with hotspot click-link,
		//do not implement new zoom-and-pan effect and clear block.
		if (Z.clickZoomAndPanBlock) {
			Z.clickZoomAndPanBlock = false;
			return;
		}

		// Optional parameters override defaults, if set.
		if (typeof targetX === 'undefined' || targetX === null) { targetX = Z.imageX; }
		if (typeof targetY === 'undefined' || targetY === null) { targetY = Z.imageY; }
		if (typeof targetZ === 'undefined' || targetZ === null) { targetZ = Z.imageZ; }
		if (typeof targetR === 'undefined' || targetR === null) { targetR = Z.imageR; }
		if (typeof duration === 'undefined' || duration === null) { duration = zaptvDuration; }
		if (typeof steps === 'undefined' || steps === null) { steps = zaptvSteps; }

		// Calculate special values.
		if (targetX == 'center' || isNaN(parseFloat(targetX))) { targetX = Z.imageCtrX; }
		if (targetY == 'center' || isNaN(parseFloat(targetY))) { targetY = Z.imageCtrY; }
		if (targetZ == -1 || isNaN(parseFloat(targetZ))) { targetZ = Z.fitZ; }

		// Next, clear watermarks and hotspots for fast, smooth zoom.
		self.toggleWatermarks(false);
		if (!Z.useCanvas) { Z.Utils.clearDisplay(wD); }
		if (hotspots && hotspots.length > 39) { self.setHotspotsVisibility(false); }

		// If X or Y values are null, assign initial value (typically center point).
		if (typeof targetX === 'undefined' || targetX === null) { targetX = Z.initialX; }
		if (typeof targetY === 'undefined' || targetY === null) { targetY = Z.initialY; }
		if (typeof targetR === 'undefined' || targetR === null) { targetR = Z.imageR; } // Note: current R not initial R. Permits standard use without R parameter.

		// Validate zoom value.
		if (typeof targetZ === 'undefined' || targetZ === null) { // Define target zoom if not provided.
			targetZ = Z.initialZ;
		} else if (targetZ > 100) { // Convert to decimal range.
			targetZ /= 100;
		} else if (targetZ > Z.maxZ) { // Constrain to max zoom.
			targetZ = Z.maxZ;
		} else if (targetZ < Z.maxZ && targetZ > Z.maxZ - 0.01) { // Force exact arrival at max zoom.
			targetZ = Z.maxZ;
		}

		// Constrain target coordinates.
		var constrainedTargetPoint = constrainPan(targetX, targetY, targetZ, targetR, 'image');
		targetX = constrainedTargetPoint.x;
		targetY = constrainedTargetPoint.y;
		targetZ = constrainZoom(targetZ);

		// Implement zoom and pan to view, if pan is needed or zoom is needed and it is not outside min and max constraints.
		if (Math.round(targetX) != Math.round(Z.imageX) || Math.round(targetY) != Math.round(Z.imageY) || Math.round(targetZ * 100000) != Math.round(Z.imageZ * 100000) || Math.round(targetR) != Math.round(Z.imageR)) {
			// Disable interactivity if steps include rotation to avoid stopping between 90 degree increments.
			Z.interactive = false;

			// Set step counter.
			zaptvStepCurrent = 0;

			// Debug option: add horizontal and vertical lines ('cross hairs') to verify
			// end point accuracy. Can also be set using HTML parameter zCrosshairsVisible=1.
			//Z.Utils.drawCrosshairs(Z.ViewerDisplay, viewW, viewH);

			// Begin steps toward target coordinates.
			zoomAndPanToViewStep(targetX, targetY, targetZ, targetR, duration, steps, callback);
		}
	}

	function zoomAndPanToViewStep (tX, tY, tZ, tR, duration, steps, callback) {
		// Increment step counter and calculate time values.
		zaptvStepCurrent++;
		var stepDuration = duration / steps;
		var currentStepTime = zaptvStepCurrent * stepDuration;

		// Calculate eased step values.
		var newX = Z.Utils.easing(Z.imageX, tX, currentStepTime, duration);
		var newY = Z.Utils.easing(Z.imageY, tY, currentStepTime, duration);
		var newZ = Z.Utils.easing(Z.imageZ, tZ, currentStepTime, duration);
		var newR = Z.Utils.easing(Z.imageR, tR, currentStepTime, duration);

		// DEV NOTE: Additional option: adjust pan for zoom. When zooming in, all points move
		// away from center which magnifies pan toward points to right and/or below center and
		// minifies pan toward points to left and above center. Zooming out creates opposite
		// effect. Current implementation mitigates this impact partially and adequately.

		// Convert step image pixel values to viewport values.
		var newPt = self.convertImageCoordsToViewportEdgeCoords(newX, newY, newZ);
		var newL = newPt.x;
		var newT = newPt.y;

		// Apply new x, y, z, r values and set components to sync.
		var syncSlider = false, syncNav = syncOversize = false;
		if (parseFloat(cS.left) != newL || parseFloat(cS.top) != newT) {
			cS.left = newL + 'px';
			cS.top = newT + 'px';
			syncNav = true;
			if (oD && tierBackfillDynamic) {
				syncOversize = true;
			}
		}
		if (newZ != Z.imageZ) {
			scaleTierToZoom(newZ, false);
			syncSlider = syncNav = true;
			if (oD && tierBackfillDynamic) {
				oCtx.restore();
				oCtx.save();
				oCtx.scale(tierBackfillOversizeScale, tierBackfillOversizeScale);
				syncOversize = true;
			}
		}
		if (newR != Z.imageR) {
			Z.Utils.rotateElement(cS, newR);
			if (oD && tierBackfillDynamic) {
				var deltaR = newR - Z.imageR;
				oCtx.rotate(deltaR * Math.PI / 180);
				syncOversize = true;
			}
			Z.imageR = newR;
			syncNav = true;
		}

		// Redraw oversizeDisplay if sync required. Pan, zoom, and rotation set above.
		if (syncOversize) {
			redisplayCachedTiles(oD, tierBackfillOversize, tilesBackfillCached, 'simple', false, 'Updating backfill oversize display');
		}

		// Sync related displays every step if visible to ensure smoothly synchronized scaling. Passing
		// no value defaults to sync'ing within sync function. Watermarks hidden during zooming by
		// default. Toolbar slider, navigator, and ruler sync every other step if visible and update required.
		var syncHotspots = (hotspots && hotspots.length < 40);
		self.syncViewportRelated(false, syncHotspots, false, false, false);
		if (zaptvStepCurrent % 2 == 0) {
			self.syncViewportRelated(false, false, syncSlider, syncNav, syncSlider);
		}

		var blockSteps = (Z.tour && Z.tourStop && Math.round(Z.imageR % 90) == 0)

		// Take additional step toward target or finalize view, depending on step counter.
		if (zaptvStepCurrent < steps+1 && !blockSteps) {
			zaptvTimer = window.setTimeout( function () { zoomAndPanToViewStep(tX, tY, tZ, tR, duration, steps, callback); }, stepDuration);

		} else {
			// Update view and reset watermarks to visible if present.
			if (blockSteps) { Z.tourPlaying = false; }
			Z.interactive = true;
			zoomAndPanToViewStop();
			self.updateView();
			self.toggleWatermarks(true);
			if (hotspots && hotspots.length > 39) { self.setHotspotsVisibility(true); }
			if (typeof callback === 'function') { callback(); }
		}
	}

	this.zoomAndPanAllStop = function (override, overridePlaying) {
		if (Z.interactive) {
			if (zaptvTimer) {
				zoomAndPanToViewStop();
			}
			if (Z.tourPlaying && overridePlaying) {
				self.tourStop();
				override = false;
			}
			if (Z.slideshowPlaying && overridePlaying) {
				self.slideshowStop();
				override = false;
			}
			if (Z.smoothPan && smoothPanInterval !== null) {
				if (!Z.mouseIsDown) { smoothPanStop(true); }
				override = true;
			}

			if (!override) { self.updateView(); }
		}
	}

	function zoomAndPanContinuousStop () {
		panX = 0;
		panY = 0;
		zoomVal = 0;
		zapStepCount = 0;
		if (zapTimer) {
			window.clearTimeout(zapTimer);
			zapTimer = null;
		}
	}

	function zoomAndPanToViewStop () {
		// Call when completing zoomAndPanToView steps, when interrupting them, and when
		// beginning user interaction that would conflict with continued zoom and pan steps.
		if (zaptvTimer) {
			window.clearTimeout(zaptvTimer);
			zaptvTimer = null;
		}
	}

	// Sync related displays and components.
	this.syncViewportRelated = function (syncWatermarks, syncHotspots, syncSlider, syncNav, syncRuler, syncImageSetSlider, syncComparisonVP, syncOverlayVPs, syncBookmarksURL, syncTracking) {
		if (Z.watermarks && (typeof syncWatermarks === 'undefined' || syncWatermarks === null || syncWatermarks)) { redisplayWatermarks(); }
		if (hotspots && (typeof syncHotspots === 'undefined' || syncHotspots === null || syncHotspots)) { redisplayHotspots(); }
		if (Z.sliderZoomVisible && (typeof syncSlider === 'undefined' || syncSlider === null || syncSlider)) { syncToolbarSliderToViewport(); }
		if (Z.Navigator && (typeof syncNav === 'undefined' || syncNav === null || syncNav))  { syncNavigatorToViewport(); }
		if (Z.Ruler && (typeof syncRuler === 'undefined' || syncRuler === null || syncRuler)) { syncRulerToViewport(); }
		if (Z.sliderImageSetVisible && (typeof syncImageSetSlider !== 'undefined' && syncImageSetSlider)) { Z.Viewer.syncToolbarImageSetSliderToViewport(Z.viewportCurrentID); }
		if (Z.comparison && (typeof syncComparisonVP === 'undefined' || syncComparisonVP === null || syncComparisonVP)) { Z.Viewer.syncComparisonViewport(syncComparisonVP); }
		if (Z.overlays && (typeof syncOverlayVPs === 'undefined' || syncOverlayVPs === null || syncOverlayVPs)) { Z.Viewer.syncOverlayViewports(syncOverlayVPs, vpID); }
		if (Z.bookmarksSet && (typeof syncBookmarksURL === 'undefined' || syncBookmarksURL === null || syncBookmarksURL)) { Z.Utils.setBookmarksURL(); }
		if (Z.tracking && (typeof syncTracking === 'undefined' || syncTracking === null || syncTracking)) { self.syncTrackingToViewport(); }
		Z.Utils.validateCallback('viewChanging');
	}

	this.scaleTierToZoom = function (imageZ, syncOversize) {
		var sync = scaleTierToZoom(imageZ, syncOversize);
		if (sync) { self.syncViewportRelated(); }
	}

	function scaleTierToZoom (imageZ, syncOversize) {
		// Main function implementing zoom through current tier scaling.  Used by zoomAndPan
		// function of zoom buttons and keys, sliderSlide and sliderSnap functions of slider, and
		// zoomAndPanToView function of Reset key and mouse-click and alt-click zoom features.
		// Note that it uses CSS scaling in canvas contexts and image element scaling otherwise.

		// Track whether function has scaled values so other components will be updated.
		var sync = false;

		// Calculate target tier scale from zoom input value.
		var targetTierScale = convertZoomToTierScale(tierCurrent, imageZ);

		// If input zoom requires a change in scale, continue.
		if (targetTierScale != tierScale) {

			// Update tracking variables.
			tierScale = targetTierScale;

			// Calculate scale adjusting for current scale previously applied to canvas or tiles.
			var scaleDelta = targetTierScale / tierScalePrior;

			// Calculate new size and position - X and Y from panning are applied when drawing tiles or, for backfill, below.
			var newW = displayW * scaleDelta;
			var newH = displayH * scaleDelta;
			var newL = (displayW - newW) / 2;
			var newT = (displayH - newH) / 2;

			// Constrain pan during zoom-out.
			if (targetTierScale < tierScalePrior) {
				var constrainedPt = constrainPan(parseFloat(cS.left), parseFloat(cS.top), imageZ, Z.imageR, 'container');
				cS.left = constrainedPt.x + 'px';
				cS.top = constrainedPt.y + 'px';
			}

			// Apply new scale to displays.
			if (Z.useCanvas) {
				// Redraw viewport display using CSS scaling.
				vS.width = newW + 'px';
				vS.height = newH + 'px';
				vS.left = newL + 'px';
				vS.top = newT + 'px';

				// Sync mask display.
				if (mC) {
					mS.width = newW + 'px';
					mS.height = newH + 'px';
					mS.left = newL + 'px';
					mS.top = newT + 'px';
				}

				// Sync drawing display.
				if (dD) {
					dS.width = newW + 'px';
					dS.height = newH + 'px';
					dS.left = newL + 'px';
					dS.top = newT + 'px';
				}

				// Sync editing display.
				if (eD) {
					eS.width = newW + 'px';
					eS.height = newH + 'px';
					eS.left = newL + 'px';
					eS.top = newT + 'px';
				}

				// Sync backfill display and oversize backfill display, if present. Backfill display assigned different size and position because backfill is sized
				// to content not viewport, to support Navigator panning. Dynamic backfill used where image size prevent caching of a tier of sufficient quality
				// (three tiers less than current tier).  Oversize display used whenever dynamic backfill is used, to provide fast backfill for rapid zoom or pan
				// using tiles from always precached third tier. Oversize implementation conditional on scale threshold of 10,000 pixels width or height, through
				// actual scaling limit of browser are approximately 10,000, 100,000, and 1M for Chrome, Firefox, and IE/Safari respectively.
				tierBackfillOversizeScale = convertZoomToTierScale(tierBackfillOversize, self.getZoom());
				var override = (tierBackfillOversizeScale > 8); // Slider snap or mousewheel can create need for oversize backfill before selectTier resets tierBackfillDynamic = true.
				if (tierBackfillDynamic || override) {

					// Update oversize backfill if conditions apply. Variable syncOversize avoids duplicate redisplays of oversize backfill. Set false by calls from zoomAndPan,
					// zoomAndPanToViewStep (and indirectly, Reset), and set true or unset by sliderSnap, sliderSlide, and handlers for mousewheel, and gestures.
					if (oCtx !== null && typeof syncOversize === 'undefined' || syncOversize === null || syncOversize && oD && (Z.zooming != 'in' || (newW > Z.scaleThreshold || newH > Z.scaleThreshold))) {
						oCtx.restore();
						oCtx.save();
						oCtx.scale(tierBackfillOversizeScale, tierBackfillOversizeScale);
						oCtx.rotate(Z.imageR * Math.PI / 180);
						redisplayCachedTiles(oD, tierBackfillOversize, tilesBackfillCached, 'simple', false, 'Updating backfill oversize display');
					}

					var targetBackfillTierScale = convertZoomToTierScale(tierBackfill, imageZ);
					tierBackfillScale = targetBackfillTierScale;
					var scaleBackfillDelta = targetBackfillTierScale / tierBackfillScalePrior;
					var newBackfillW = backfillW * scaleBackfillDelta;
					var newBackfillH = backfillH * scaleBackfillDelta;
					var newBackfillL = backfillL + ((backfillW - newBackfillW) / 2);
					var newBackfillT = backfillT + ((backfillH - newBackfillH) / 2);
					bS.width = newBackfillW + 'px';
					bS.height = newBackfillH + 'px';
					bS.left = newBackfillL + 'px';
					bS.top = newBackfillT + 'px';

				} else {
					if (oD) { Z.Utils.clearDisplay(oD); } // If use slider to zoom-in then zoom-out without stopping to update view, must clear oversize backfill, if present, or it will show in borders.

					newW = backfillW * scaleDelta;
					newH = backfillH * scaleDelta;
					newL = backfillL + ((Z.imageX  * (1 - scaleDelta)) * Z.imageZ);
					newT = backfillT + ((Z.imageY * (1 - scaleDelta)) * Z.imageZ);
					bS.width = newW + 'px';
					bS.height = newH + 'px';
					bS.left = newL + 'px';
					bS.top = newT + 'px';
				}

			} else {
				// In non-canvas context, scaling of each tile image is required.
				redisplayCachedTiles(vD, tierCurrent, tilesCached, 'centerOut', false, 'Scaling: non-canvas zoom');

				if (tierBackfillDynamic) {
					var buffer = BACKFILL_BUFFER;
					backfillW = displayW * buffer;
					backfillH = displayH * buffer;
					backfillL = -(displayW / buffer);
					backfillT = -(displayH / buffer);
					backfillCtrX = displayCtrX * buffer;
					backfillCtrY = displayCtrY * buffer;
					bD.width = backfillW;
					bD.height = backfillH;
					bS.width = bD.width + 'px';
					bS.height = bD.height + 'px';
					bS.left = backfillL + 'px';
					bS.top = backfillT + 'px';
				} else {
					var tierBackfillW = tierWs[tierBackfill];
					var tierBackfillH = tierHs[tierBackfill];
					bD.width = tierBackfillW;
					bD.height = tierBackfillH;
					var deltaX = Z.imageX * imageZ;
					var deltaY = Z.imageY * imageZ;
					backfillL = (displayCtrX - deltaX);
					backfillT = (displayCtrY - deltaY);
					bS.left = backfillL + 'px';
					bS.top = backfillT + 'px';
				}

				// And scaling of each tile is also required for backfill display.
				redisplayCachedTiles(bD, tierBackfill, tilesBackfillCached, 'simple', false, 'Scaling: non-canvas zoom - backfill');
			}
			sync = true;
		}
		return sync;
	}

	this.reset = function (prior) {
		if (Z.maskingSelection && Z.maskClearOnUserAction) { self.clearMask(); }
		if (!prior) {
			self.zoomAndPanToView(Z.initialX, Z.initialY, Z.initialZ, Z.initialR);
		} else {
			Z.Utils.setButtonDefaults(buttonReset);
			self.zoomAndPanToView(Z.priorX, Z.priorY, Z.priorZ, Z.priorR);
		}
		recordPriorViewCoordinates(true);
	}

	this.labelScale = function (scaleDir) {
		switch(scaleDir) {
			case 'down' :
				if (scaleVal >= 0) { scaleVal -= labelScaleStepDistance; }
				break;
			case 'up' :
				if (scaleVal <= 0) { scaleVal += labelScaleStepDistance; }
				break;
			case 'stop' :
				scaleVal = 0;
				break;
		}
		if (scaleVal != 0) {
			if (!scaleTimer) {
				scaleTimer = window.setTimeout(labelScaleContinuousStep, labelScaleStepDuration);
			}
		} else {
			labelScaleContinuousStop();
		}
	}

	function labelScaleContinuousStep () {
		if (scaleTimer) {
			// If interval, scaleVal values not cleared, scale one step.
			if (scaleVal != 0) {
				var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
				if (index != -1) {
					var cH = hotspots[index];
					var targetScaleX = cH.xScale *  (1 + scaleVal);
					var targetScaleY = cH.yScale *  (1 + scaleVal);
					self.modifyHotspot(hotspotCurrentID, 'xScale', targetScaleX, true, true);
					self.modifyHotspot(hotspotCurrentID, 'yScale', targetScaleY, false, true);				;

					// If scaleVal variable has not been cleared, recall timer.
					scaleTimer = window.setTimeout(labelScaleContinuousStep, labelScaleStepDuration);
				}
			}
		}
	}

	function labelScaleContinuousStop () {
		if (scaleTimer) {
			window.clearTimeout(scaleTimer);
			scaleTimer = null;
		}
		scaleVal = 0;
	}

	this.toggleWatermarks = function (override) {
		if (wS) {
			var showing = (wS.display == 'inline-block');
			var show = (typeof override !== 'undefined' && override !== null) ? override : !showing;
			wS.display = (show) ? 'inline-block' : 'none';
		}
	}

	this.toggleConstrainPan = function (override) {
		Z.constrainPan = (typeof override !== 'undefined' && override !== null) ? override : !Z.constrainPan;
		if (Z.constrainPan) {
			var x = parseFloat(vS.left);
			var y = parseFloat(vS.top);
			var constrainedPt = constrainPan(x, y, Z.imageZ, Z.imageR, 'container');
			cS.left = constrainedPt.x + 'px';
			cS.top = constrainedPt.y + 'px';
			self.updateView();
		}
	}

	this.toggleSmoothPan = function () {
		smoothPanStop();
		Z.smoothPan = !Z.smoothPan;
	}

	this.toggleSmoothZoom = function () {
		zoomAndPanToViewStop();
		Z.smoothZoom = !Z.smoothZoom;
	}

	this.buttonToggleBackfillHandler = function () {
		self.toggleBackfill();
	}

	this.toggleBackfill = function (override) {
		var bD = document.getElementById('viewportBackfillDisplay' + viewportID.toString());
		if (bD) {
			var bS = bD.style;
			var visibilityCurrent = (bS.display == 'inline-block');
			var visibility = (typeof override !== 'undefined' && override !== null) ? override : !visibilityCurrent;
			bS.display = (visibility) ? 'inline-block' : 'none';
		}
	}

	this.buttonToggleDisplayHandler = function () {
		self.toggleDisplay();
	}

	this.toggleDisplay = function (override) {
		var vD = document.getElementById('viewportDisplay' + viewportID.toString());
		if (vD) {
			vS = vD.style;
			var visibilityCurrent = (vS.display == 'inline-block');
			var visibility = (typeof override !== 'undefined' && override !== null) ? override : !visibilityCurrent;
			vS.display = (visibility) ? 'inline-block' : 'none';
		}
	}

	this.toggleDisplaysOther = function (value) {
		var displayVal = (value) ? 'inline-block' : 'none';
		if (oS) { oS.display = displayVal; }
		if (bS) { bS.display = displayVal; }
		if (tS) { tS.display = displayVal; }
		if (fbS) { fbS.display = displayVal; }
		if (wS) { wS.display = displayVal; }
		if (dS) { dS.display = displayVal; }
		if (eS) { eS.display = displayVal; }
		if (hS) { hS.display = displayVal; }
		if (sS) { sS.display = displayVal; }
	}


	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::: ZOOM RECTANGLE, FULL VIEW, ROTATION, & MEASURE FUNCTIONS :::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.zoomAndPanToZoomRectangle = function (zRectPts) {
		//Get rect height and width and center x and y.
		var left = Math.min(zRectPts[0].x, zRectPts[1].x, zRectPts[2].x, zRectPts[3].x)
		var right = Math.max(zRectPts[0].x, zRectPts[1].x, zRectPts[2].x, zRectPts[3].x)
		var top = Math.min(zRectPts[0].y, zRectPts[1].y, zRectPts[2].y, zRectPts[3].y)
		var bottom = Math.max(zRectPts[0].y, zRectPts[1].y, zRectPts[2].y, zRectPts[3].y)
		var w = right - left;
		var h = bottom - top;
		var centerX = left + w / 2;
		var centerY = top + h / 2;
		var currentR = self.getRotation();
		var zRectZ = self.calculateZoomToFit(w, h, currentR);

		// Alternative implementation: Compare narrower rectangle dimension to display rather than wider.
		//var zRectZ = self.calculateZoomToFill(w, h, currentR);

		self.zoomAndPanToView(centerX, centerY, zRectZ);
	}

	this.toggleFullViewModeExternal = function () {
		// Assumes call from external toolbar and internal toolbar hidden. Sets tracking variable to cause display
		// Exit button over viewport in full screen mode when external toolbar is hidden under viewport.
		buttonFullViewExitExternalVisible = true;
		self.toggleFullViewMode();
	}

	this.toggleFullViewMode = function (override, escaped) {
		// DEV NOTE: Testing interaction between mode change and zoom-and-pan in progress.
		//self.zoomAndPanAllStop();

		if (Z.maskingSelection && Z.maskClearOnUserAction) { self.clearMask(); }

		// Hide toolbar if visible.
		if (Z.ToolbarDisplay) { Z.Toolbar.show(false); }

		var width = null;
		var height = null;

		// If override is false (called by Escape key) set false, otherwise, set to opposite of current state.
		Z.fullViewPrior = Z.fullView;
		Z.fullView = (typeof override !== 'undefined' && override !== null) ? override : !Z.fullView;

		// Declare and set document references.
		var fvB = document.body;
		var fvbS = fvB.style;
		var fvdS = document.documentElement.style;
		var fvvS = Z.ViewerDisplay.style;
		var fvcS = Z.Utils.getElementStyle(Z.pageContainer);
		var dimensions;

		if (Z.fullView) {
			// Record non-full-page values.
			var containerDims = Z.Utils.getContainerSize(Z.pageContainer, Z.ViewerDisplay);

			fvBodW = containerDims.x;
			fvBodH = containerDims.y;
			fvBodO = fvbS.overflow;
			fvDocO = fvdS.overflow;
			fvContBC = (Z.Utils.stringValidate(fvcS.backgroundColor) && fvcS.backgroundColor != 'transparent') ? fvcS.backgroundColor : (Z.Utils.stringValidate(fvbS.backgroundColor) && fvbS.backgroundColor != 'transparent') ? fvbS.backgroundColor : Z.Utils.getResource('DEFAULT_FULLVIEWBACKCOLOR');
			fvContPos = fvvS.position;
			fvContIdx = fvvS.zIndex;

			// Implement full screen or full page view.
			if (Z.fullScreenSupported && !Z.fullPageVisible) {
				dimensions = Z.Utils.getScreenSize();
				Z.fullScreenEntering = true; // Subverts change event on mode entry.
				Z.Utils.fullScreenView(Z.ViewerDisplay, true);

			} else {
				dimensions = Z.Utils.getWindowSize();
				if (!Z.mobileDevice) {
					fvbS.width = '100%';
					fvbS.height = '100%';
				} else {
					fvbS.width = dimensions.x;
					fvbS.height = dimensions.y;
				}
			}

			width = dimensions.x;
			height = dimensions.y;

			// Update related settings.
			fvbS.overflow = 'hidden';
			fvdS.overflow = 'hidden';
			fvvS.backgroundColor = fvContBC;
			fvvS.position = 'fixed';
			fvvS.zIndex = '99999999';

			// Temporarily disable auto-resizing to prevent conflict with full view mode change.
			if (Z.autoResize) { Z.Utils.removeEventListener(window, 'resize', Z.Viewer.viewerEventsHandler); }

		} else {
			// Reset related settings.
			fvbS.overflow = fvBodO;
			fvdS.overflow = fvDocO;
			fvvS.backgroundColor = fvContBC;
			fvvS.position = 'relative';
			fvvS.zIndex = fvContIdx;

			// Unimplement full screen or full page view.
			if (Z.fullScreenSupported && !Z.fullPageVisible) {
				Z.Utils.fullScreenView(Z.ViewerDisplay, false, escaped);
			}

			fvbS.width = fvBodW;
			fvbS.height = fvBodH;
			width = fvBodW;
			height = fvBodH;
			if (isNaN(width)) { width = Z.ViewerDisplay.clientWidth; }
			if (isNaN(height)) { height = Z.ViewerDisplay.clientHeight; }

			// Hide exit button in case visible due to external full view call.
			buttonFullViewExitExternalVisible = false;

			// Reenable auto-resizing disabled above to prevent conflict with full view mode change.
			if (Z.autoResize) { Z.Utils.addEventListener(window, 'resize', Z.Viewer.viewerEventsHandler); }
		}

		// If page container is sized with pixel values rather than percentages or �vw� and �vh� auto-resizing will occur and resize must be called.
		if (Z.initialFullPage) { self.setSizeAndPosition(width, height); }

		var newZoom = Z.viewportCurrent.calculateZoomForResize(Z.viewportCurrent.getZoom(), Z.viewerW, Z.viewerH, width, height);
		Z.Viewer.resizeViewer(width, height, newZoom);

		var vpComparison = null;		
		if (Z.comparison) {
			vpComparison = (self.getViewportID() == 0) ? Z.Viewport1 : Z.Viewport0;
			if (vpComparison) { vpComparison.syncViewportResize(Z.imageX, Z.imageY, Z.imageZ, Z.imageR); }
		} else if (Z.overlays) {
			for (var i = 0, j = Z.imageSetLength - 1; i < j; i++) {
				// -1 in line above prevents top VP from resetting itself in loop.
				Z['Viewport' + i.toString()].syncViewportResize(Z.imageX, Z.imageY, Z.imageZ, Z.imageR);
			}
		}
		if (Z.imageList && self.getStatus('initializedImageList')) {
			self.setSizeAndPositionImageList();
			if (vpComparison && vpComparison.getStatus('initializedImageList')) { 
				vpComparison.setSizeAndPositionImageList();
			}
		}

		// Set full view or full view exit button visible based on full view status. If using external toolbar in page, display external exit button over viewport.
		showButtonFullViewExitInternal(Z.fullView);
		showButtonFullViewExitExternal(buttonFullViewExitExternalVisible);

		// Clear variable ensuring updateView on exit of full page view.
		Z.fullViewPrior = false;
	}

	function showButtonFullViewExitInternal (value) {
		var bFV = document.getElementById('buttonFullView');
		var bFVE = document.getElementById('buttonFullViewExit');
		if (bFV && bFVE) {
			bFV.style.display = (value) ? 'none' : 'inline-block';
			bFVE.style.display = (value) ? 'inline-block' : 'none';
		}
	}

	function showButtonFullViewExitExternal (value) {
		if (value) {
			if (!buttonFullViewExitExternal) { configureButtonFullViewExitExternal(); }
			buttonFullViewExitExternal.elmt.style.display = 'inline-block';
		} else {
			if (buttonFullViewExitExternal) { buttonFullViewExitExternal.elmt.style.display = 'none'; }
		}
	}

	function configureButtonFullViewExitExternal () {
		var btnTxt = Z.Utils.getResource('UI_FVCANCELBUTTONTEXT');
		var btnW = 34;
		var btnH = 34;
		var btnMargin = 20;
		var btnL = parseFloat(Z.viewerW) - (btnW + btnMargin);
		var btnT = parseFloat(Z.viewerH) - (btnH + btnMargin);
		var btnColor = Z.Utils.getResource('DEFAULT_FULLVIEWEXITEXTERNALBUTTONCOLOR');
		buttonFullViewExitExternal = new Z.Utils.Button('buttonFullViewExitExternal', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', buttonFullViewExitExternalHandler, 'TIP_TOGGLEFULLVIEWEXITEXTERNAL', 'solid', '1px', btnColor, '0px', '0px');
		Z.ViewerDisplay.appendChild(buttonFullViewExitExternal.elmt);
	}

	function buttonFullViewExitExternalHandler () {
		self.toggleFullViewMode(false);
	}

	this.rotate = function (rotationDir, isAltKey) {
		// Record prior X, Y, Z, and R values.
		recordPriorViewCoordinates();

		if (!Z.rotationFree || isAltKey) {
			if (Z.imageR % 90 != 0) { Z.imageR = Math.round(Z.imageR / 90) * 90; }
			var degDelta = (rotationDir == 'clockwise') ? 90 : -90;
			self.rotateStep(degDelta, true);

		} else {
			if (rotationDir == 'stop' && Z.rotating == 'stop') { return; }
			rotVal = (rotationDir == 'stop') ? 0 : (rotationDir == 'clockwise') ? rotStepDegrees : -rotStepDegrees;
			Z.rotating = (rotVal == 0) ? 'stop' : ((rotVal > 0) ? 'clockwise' : 'counterwise');
			if (rotVal !=0) {
				if (!rotTimer) {
					rotTimer = window.setTimeout(rotateContinuousStep, rotStepDuration);
				}
			} else {
				rotateContinuousStop();
				self.updateView();
			}
		}
	}

	function rotateContinuousStep () {
		if (rotTimer) {
			// If interval and rotation values not cleared, rotate one step.
			if (rotVal != 0) {
				self.rotateStep(rotVal, false);
				// If rotation variable has not been cleared, recall timer.
				rotTimer = window.setTimeout(rotateContinuousStep, rotStepDuration);
				var syncHotspots = (hotspots && hotspots.length < 40);
				self.syncViewportRelated(false, syncHotspots, false, true, false);
			}
		}
	}

	function rotateContinuousStop () {
		rotVal = 0;
		if (rotTimer) {
			window.clearTimeout(rotTimer);
			rotTimer = null;
		}
	}

	this.rotateStep = function (degreesDelta, useZaptv, syncVP) {
		if (!Z.interactive) { return; }
		if (Z.rotationSupported) {
			var rotationValueNew = Z.imageR + degreesDelta;

			if (!Z.rotationFree) {
				Z.interactive = false;
				var rotationValueConstrained = constrainRotation(rotationValueNew);

				// Use zoom and pan function to gradually rotate to new rotation and/or to invoke pan constraint and reset
				// coordinates, if necessary.  Set Z.imageR to constrained value after new unconstrained value implemented
				// to avoid backward 270 rotation when rotating from 270 to 360 (0) or from -270 to -360 (0).
				if (useZaptv) {
					self.zoomAndPanToView(Z.imageX, Z.imageY, Z.imageZ, rotationValueNew, 600, 12, function () { Z.imageR = rotationValueConstrained; });
				} else if (syncVP) {
					Z.Utils.rotateElement(cS, Z.imageR, true);
					Z.interactive = true;
				} else {
					Z.Utils.rotateElement(cS, rotationValueNew);
					if (oD && Z.imageR != 0) {
						var deltaR = rotationValueNew - Z.imageR;
						oCtx.rotate(deltaR * Math.PI / 180);
					}
					Z.imageR = rotationValueConstrained;
					self.zoomAndPanToView(Z.imageX, Z.imageY, Z.imageZ);
				}

			} else {
				Z.Utils.rotateElement(cS, rotationValueNew);
				Z.imageR = rotationValueNew;

				// Sync related components.
				syncNavigatorToViewport();

				// Alternative implementation: do not hide backfills, hotspots, watermarks, etc. and sync rotation.
				//var syncHotspots = (hotspots && hotspots.length < 40);
				//self.syncViewportRelated(false, syncHotspots, false, true, false, false, true, false, false, false);
			}
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ALERT_ROTATIONREQUIRESNEWERBROWSER'));
		}
	}

	this.toggleEditModeMeasure = function (override) {
		self.zoomAndPanAllStop();
		if (Z.maskingSelection && Z.maskClearOnUserAction) { self.clearMask(); }

		// If override is false set false, otherwise, set to opposite of current state.
		if (typeof override !== 'undefined' && !override || Z.labelMode == 'measure') {

			// If measuring while not in edit mode be sure to delete any hotspot polygons previously created to display a measurement.
			if (Z.editMode === null && Z.labelMode == 'measure' && hotspots.length > 0) {
				self.deleteAllMeasureHotspots();
				hotspotCurrentID = null;
			}
			self.setEditModeLabel('view');

		} else {
			self.setEditModeLabel('measure');
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::: IMAGE FILTER FUNCTIONS :::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getImageFilterValuePrior = function (filter) {
		var filterValuePrior = 0;
		switch (filter) {
			case 'brightness' :
				filterValuePrior = imageFilterBrightnessValue;
				break;
			case 'contrast' :
				filterValuePrior = imageFilterContrastValue;
				break;
			case 'sharpness' :
				filterValuePrior = imageFilterSharpnessValue;
				break;
			case 'blurriness' :
				filterValuePrior = imageFilterBlurrinessValue;
				break;
			case 'colorRed' :
				filterValuePrior = imageFilterColorRedValue;
				break;
			case 'colorGreen' :
				filterValuePrior = imageFilterColorGreenValue;
				break;
			case 'colorBlue' :
				filterValuePrior = imageFilterColorBlueValue;
				break;
			case 'colorRedRange' :
				filterValuePrior = imageFilterColorRedRangeValue;
				break;
			case 'colorGreenRange' :
				filterValuePrior = imageFilterColorGreenRangeValue;
				break;
			case 'colorBlueRange' :
				filterValuePrior = imageFilterColorBlueRangeValue;
				break;
			case 'colorRedRange2' :
				filterValuePrior = imageFilterColorRedRangeValue2;
				break;
			case 'colorGreenRange2' :
				filterValuePrior = imageFilterColorGreenRangeValue2;
				break;
			case 'colorBlueRange2' :
				filterValuePrior = imageFilterColorBlueRangeValue2;
				break;
			case 'gamma' :
				filterValuePrior = imageFilterGammaValue;
				break;
			case 'gammaRed' :
				filterValuePrior = imageFilterGammaRedValue;
				break;
			case 'gammaGreen' :
				filterValuePrior = imageFilterGammaGreenValue;
				break;
			case 'gammaBlue' :
				filterValuePrior = imageFilterGammaBlueValue;
				break;
			case 'hue' :
				filterValuePrior = imageFilterHueValue;
				break;
			case 'saturation' :
				filterValuePrior = imageFilterSaturationValue;
				break;
			case 'lightness' :
				filterValuePrior = imageFilterLightnessValue;
				break;
			case 'whiteBalance' :
				filterValuePrior = imageFilterWhiteBalanceValue;
				break;
			case 'noise' :
				filterValuePrior = imageFilterNoiseValue;
				break;
		}
		return filterValuePrior;
	}

	this.setImageFilterValuePrior = function (filter, filterValue) {
		switch (filter) {
			case 'brightness' :
				imageFilterBrightnessValue = filterValue;
				break;
			case 'contrast' :
				imageFilterContrastValue = filterValue;
				break;
			case 'sharpness' :
				imageFilterSharpnessValue = filterValue;
				break;
			case 'blurriness' :
				imageFilterBlurrinessValue = filterValue;
				break;
			case 'colorRed' :
				imageFilterColorRedValue = filterValue;
				break;
			case 'colorGreen' :
				imageFilterColorGreenValue = filterValue;
				break;
			case 'colorBlue' :
				imageFilterColorBlueValue = filterValue;
				break;
			case 'colorRedRange' :
				imageFilterColorRedRangeValue = filterValue;
				break;
			case 'colorGreenRange' :
				imageFilterColorGreenRangeValue = filterValue;
				break;
			case 'colorBlueRange' :
				imageFilterColorBlueRangeValue = filterValue;
				break;
			case 'colorRedRange2' :
				imageFilterColorRedRangeValue2 = filterValue;
				break;
			case 'colorGreenRange2' :
				imageFilterColorGreenRangeValue2 = filterValue;
				break;
			case 'colorBlueRange2' :
				imageFilterColorBlueRangeValue2 = filterValue;
				break;
			case 'gamma' :
				imageFilterGammaValue = filterValue;
				break;
			case 'gammaRed' :
				imageFilterGammaRedValue = filterValue;
				break;
			case 'gammaGreen' :
				imageFilterGammaGreenValue = filterValue;
				break;
			case 'gammaBlue' :
				imageFilterGammaBlueValue = filterValue;
				break;
			case 'hue' :
				imageFilterHueValue = filterValue;
				break;
			case 'saturation' :
				imageFilterSaturationValue = filterValue;
				break;
			case 'lightness' :
				imageFilterLightnessValue = filterValue;
				break;
			case 'whiteBalance' :
				imageFilterWhiteBalanceValue = filterValue;
				break;
			case 'noise' :
				imageFilterNoiseValue = filterValue;
				break;
		}
	}

	// Image filtering implemented using utility functions of Z.Utils object.
	this.setImageFilter = function (filter, filterValue, filterValue2) {
		Z.Utils.arrayClear(tileImages);
		if (typeof filter !== 'undefined' && filter !== null && filter !== 'null') {
			if (typeof filterValue !== undefined && filterValue !== null && (filterValue == 0 && filter.indexOf('Range') == -1)) {
				clearImageFilter(filter);
			} else {
				addImageFilter(filter, filterValue, filterValue2);
			}
		}
	}

	function addImageFilter (filter, filterValue, filterValue2) {
		var valueProvided = typeof filterValue !== undefined && filterValue !== null;
		var filterBoolean = (filter == 'grayscale' || filter == 'threshold' || filter == 'inversion' || filter == 'normalize' || filter == 'equalize' || filter == 'edges' || filter == 'sepia');

		var filterAppliedIndex = Z.Utils.arrayIndexOfObjectValue(imageFiltersApplied, 'filter', filter);
		var filterNew = (filterAppliedIndex == -1);
		var filterLatest = (imageFiltersApplied.length > 0 && imageFiltersApplied[imageFiltersApplied.length - 1].filter == filter);

		// When applying multiple filters, the order is important unless only applying color filters. Permits mixing color, color range, gamma, and gamma split-channel filters.
		var filterColorsOnly = (imageFiltersApplied.length > 0);
		for (var i = 0, j = imageFiltersApplied.length; i < j; i++) {
			var filtersItem = imageFiltersApplied[i].filter.toLowerCase();
			if (filtersItem.indexOf('color') == -1 && filtersItem.indexOf('gamma') == -1) {
				filterColorsOnly = false;
				break;
			}
		}
		
		// Add filter to applied and display lists.
		if (valueProvided || filterBoolean) {
			var updateRequired = false;
			if (filterColorsOnly && filterAppliedIndex != -1) {
				Z.Toolbar.addFilterToImageFilterList(filter, filterValue, null, true);
				imageFiltersApplied[filterAppliedIndex].value = filterValue;
				imageFiltersApplied[filterAppliedIndex].value2 = filterValue2;
				filter = null; // Clear variable so not passed into function applyImageFilter below so imageFiltersApplied will be used to apply multiple filters.
				updateRequired = true;
			} else if (filterLatest && !filterBoolean) {
				Z.Toolbar.addFilterToImageFilterList(filter, filterValue);
				imageFiltersApplied[imageFiltersApplied.length - 1].value = filterValue;
				imageFiltersApplied[imageFiltersApplied.length - 1].value2 = filterValue2;
				updateRequired = true;
			} else if (filterNew || !filterBoolean) {
				Z.Toolbar.addFilterToImageFilterList(filter, filterValue, filterValue2);
				imageFiltersApplied[imageFiltersApplied.length] = { filter:filter, value:filterValue, value2:filterValue2 };
				updateRequired = true;
			}

			// Record if convolution requires processing tiles of view together and apply filter to current view of frontfill, then to full backfill.
			// If multiple filters to apply set filter value null to cause applyImageFilter to call multiFilterImageObject.
			if (updateRequired) {
				if (imageFiltersApplied.length > 1) { filter = null; }				
				validateImageFiltersConvolve();
				self.applyImageFilter(filter, filterValue, null, filterValue2);
			}
		}
	}

	function clearImageFilter (filter, last) {
		var index = (last) ? imageFiltersApplied.length - 1 : Z.Utils.arrayIndexOfObjectValue(imageFiltersApplied, 'filter', filter);
		if (index != -1) {
			// Clear filter in interface.
			Z.Toolbar.clearImageFilterInPanel(filter, last);

			// Clear filter from applied filter list.
			imageFiltersApplied = Z.Utils.arraySplice(imageFiltersApplied, index, 1);

			// Combine matching consecutive filters.
			if (imageFiltersApplied.length > 2 && typeof imageFiltersApplied[index] !== 'undefined'  && typeof imageFiltersApplied[index - 1] !== 'undefined' && imageFiltersApplied[index].filter == imageFiltersApplied[index - 1].filter) {
				imageFiltersApplied[index - 1].value += imageFiltersApplied[index].value;
				imageFiltersApplied = Z.Utils.arraySplice(imageFiltersApplied, index, 1);
			}

			// Clear filter from display.
			validateImageFiltersConvolve();
			self.updateView(true);
		}
	}

	this.clearImageFilterLast = function () {
		if (imageFiltersApplied.length > 0) {
			var filterLast = imageFiltersApplied[(imageFiltersApplied.length - 1)].filter;
			clearImageFilter(filterLast, true);
		}
	}

	this.clearImageFiltersAll = function () {
		if (imageFiltersApplied.length > 0) {
			for (var i = 0, j = imageFiltersApplied.length; i < j; i++) {
				Z.Toolbar.clearImageFilterInPanel(imageFiltersApplied[i].filter);
			}

			// Clear all image filters from applied list, reset convolution tracking variable, redisplay view unfiltered.
			Z.Utils.arrayClear(imageFiltersApplied);
			validateImageFiltersConvolve();
			self.updateView(true);
		}
		Z.Toolbar.setFilterSliderReferences(imageFilterCurrent);
	}

	this.imageFilterButtonsHandler = function (filter, direction) {
		var directionFactor = (direction == 'plus') ? 1 : -1;
		if (Z.Utils.stringValidate(filter)) {
			var step = 0.05 * directionFactor;
			var rangeMaxAbs = self.getImageFilterRangeMaxAbsolute(filter);
			var priorValue = self.getImageFilterValuePrior(filter);
			var filterValue = priorValue + (rangeMaxAbs * step);
			filterValue = constrainImageFilter(filter, filterValue);
			Z.Toolbar.syncImageFilterPanel(filter, filterValue);
			self.setImageFilterValuePrior(filter, filterValue);
			self.setImageFilter(filter, filterValue);
		}
	}

	this.getImageFilterRange = function (filter) {
		var min = 0;
		var max = 100;
		switch (filter) {
			case 'brightness' :
				min = -150;
				max = 150;
				break;
			case 'contrast' :
				min = -50;
				max = 100;
				break;
			case 'sharpness' :
				max = 40;
				break;
			case 'blurriness' :
				max = 30;
				break;
			case 'colorRed' :
				min = -100;
				max = 100;
				break;
			case 'colorGreen' :
				min = -100;
				max = 100;
				break;
			case 'colorBlue' :
				min = -100;
				max = 100;
				break;
			case 'colorRedRange' :
				min = 0;
				max = self.getImageFilterRangeMaxAbsolute(filter);
				break;
			case 'colorGreenRange' :
				min = 0;
				max = self.getImageFilterRangeMaxAbsolute(filter);
				break;
			case 'colorBlueRange' :
				min = 0;
				max = self.getImageFilterRangeMaxAbsolute(filter);
				break;
			case 'colorRedRange2' :
				min = 0;
				max = self.getImageFilterRangeMaxAbsolute(filter);
				break;
			case 'colorGreenRange2' :
				min = 0;
				max = self.getImageFilterRangeMaxAbsolute(filter);
				break;
			case 'colorBlueRange2' :
				min = 0;
				max = self.getImageFilterRangeMaxAbsolute(filter);
				break;
			case 'gamma' :
				min = 0;
				max = 2;
				break;
			case 'gammaRed' :
				min = 0;
				max = 2;
				break;
			case 'gammaGreen' :
				min = 0;
				max = 2;
				break;
			case 'gammaBlue' :
				min = 0;
				max = 2;
				break;
			case 'hue' :
				min = 0;
				max = 351;
				break;
			case 'saturation' :
				min = -100;
				max = 100;
				break;
			case 'lightness' :
				min = -100;
				max = 100;
				break;
			case 'whiteBalance' :
				min = 0;
				max = 40000;
				break;
			case 'noise' :
				min = 0;
				max = 100;
				break;
		}
		return new Z.Utils.RangeScale(min, max);
	}

	this.getImageFilterRangeMaxAbsolute = function (filter) {
		var maxAbs = 100;
		switch (filter) {
			case 'brightness' :
				maxAbs = 300;
				break;
			case 'contrast' :
				maxAbs = 150;
				break;
			case 'sharpness' :
				maxAbs = 40;
				break;
			case 'blurriness' :
				maxAbs = 30;
				break;
			case 'colorRed' :
				maxAbs = 200;
				break;
			case 'colorGreen' :
				maxAbs = 200;
				break;
			case 'colorBlue' :
				maxAbs = 200;
				break;
			case 'colorRedRange' :
				maxAbs = 255;
				break;
			case 'colorGreenRange' :
				maxAbs = 255;
				break;
			case 'colorBlueRange' :
				maxAbs = 255;
				break;
			case 'colorRedRange2' :
				maxAbs = 255;
				break;
			case 'colorGreenRange2' :
				maxAbs = 255;
				break;
			case 'colorBlueRange2' :
				maxAbs = 255;
				break;
			case 'gamma' :
				maxAbs = 2;
				break;
			case 'gammaRed' :
				maxAbs = 2;
				break;
			case 'gammaGreen' :
				maxAbs = 2;
				break;
			case 'gammaBlue' :
				maxAbs = 2;
				break;
			case 'hue' :
				maxAbs = 359;
				break;
			case 'saturation' :
				maxAbs = 200;
				break;
			case 'lightness' :
				maxAbs = 200;
				break;
			case 'whiteBalance' :
				maxAbs = 40000;
				break;
			case 'noise' :
				maxAbs = 100;
				break;
		}
		return maxAbs;
	}

	constrainImageFilter = function (filter, filterValue) {
		var filterNumber = (typeof filterValue !== 'undefined' && filterValue !== null && filterValue != '' && !isNaN(filterValue));
		if (filterNumber) {
			var range = self.getImageFilterRange(filter);
			filterValue = Math.max(filterValue, range.min);
			filterValue = Math.min(filterValue, range.max);
		}
		return filterValue;
	}

	validateImageFiltersConvolve = function () {
		// Record if convolution required. Requires processing tiles of new view together.
		var s = Z.Utils.arrayIndexOfObjectValue(imageFiltersApplied, 'filter', 'sharpness') != -1;
		var b = Z.Utils.arrayIndexOfObjectValue(imageFiltersApplied, 'filter', 'blurriness') != -1;
		var e = Z.Utils.arrayIndexOfObjectValue(imageFiltersApplied, 'filter', 'edges') != -1;
		imageFilterStatesConvolve = (s || b || e);
	}

	// During slider drag apply filter only to frontfill. On mouse-up or when not using slider apply filter to frontfill and backfill
	// sequentially.  If removing the latest filter, use applyImageFilters (plural) instead to be sure any prior filters are reapplied.
	this.applyImageFilter = function (filter, filterValue, source, filterValue2) {
		if (typeof imageFilterRetryTimer === 'undefined' || typeof imageFilterBackfillTimer === 'undefined') {
			return;
		} else if (imageFilterTimer !== null || imageFilterBackfillTimer !== null) {
			window.clearTimeout(imageFilterRetryTimer);
			imageFilterRetryTimer = null;
			window.clearTimeout(imageFilterBackfillTimer);
			imageFilterBackfillTimer = null;

		} else {
			imageFilterTimer = window.setTimeout( function () {

				imageFilterTimer = null;
				var filterIsConvolve = (filter == 'sharpness' || filter == 'blurriness' || filter == 'edges');

				if (Z.buttonIsDown && !filterIsConvolve) {
					filterImageDisplayFast(filter, filterValue, filterValue2);

				} else {
					if (typeof tileImages !== 'undefined') { Z.Utils.arrayClear(tileImages); }

					filterImageDisplay(vD, filter, filterValue, source, filterValue2);
					if (filterIsConvolve) { Z.Utils.showMessage(Z.Utils.getResource('ALERT_PROCESSINGIMAGEFILTER-CONVOLUTION'), false, null, 'center', false, '2'); }
					imageFilterBackfillTimer = window.setTimeout( function () {
						imageFilterBackfillTimer = null;

						//Alternative implementation: if (filterIsConvolve) { Z.Utils.showMessage(Z.Utils.getResource('ALERT_PROCESSINGBACKFILLIMAGEFILTER-CONVOLUTION'), false, null, 'center', false, '2'); }
						filterImageDisplay(bD, filter, filterValue, source, filterValue2);
						Z.Utils.hideMessage();
					}, 100);
				}
			}, 100);
		}
	}

	// Records image data after all other filters, before beginning of current filter.
	this.cacheCanvasImage = function (fast) {
		if (fast) {
			cachedCanvasFiltered = vCtx.getImageData(0, 0, vD.width, vD.height);
		} else {
			cachedCanvas = vCtx.getImageData(0, 0, vD.width, vD.height);
			cachedCanvasBackfill = bCtx.getImageData(0, 0, bD.width, bD.height);
		}
	}
	
	this.cacheTileImage = function (imgDataObj) {
		tileImages[tileImages.length] = imgDataObj;
	}

	function filterImageDisplayFast (filter, filterValue, filterValue2) {
		// Reset to image data after last filter complete, then apply current slider value.
		if (cachedCanvasFiltered && vCtx) {
			vCtx.putImageData(cachedCanvasFiltered, 0, 0);
			var imgDataObjFast = vCtx.getImageData(0, 0, vD.width, vD.height);
			var imgDataObjFiltered = filterImageObject(imgDataObjFast, filter, filterValue, filterValue2);
			vCtx.putImageData(imgDataObjFiltered, 0, 0);
		}
	}

	// If called due to filter button click, function putImageData applied directly to frontfill
	// and backfill canvases without subsequent drawImage call because data already scaled
	// by display canvas. If called due to view change and convolution filter being reapplied
	// to tile set (parameter), data already scaled by image filter transfer canvas.  If filter
	// parameter not provided filter list will be used.
	function filterImageDisplay (display, filter, filterValue, source, filterValue2) {
		var isViewportDisplay = (display.id.indexOf('viewportDisplay') != -1);
		var sourceCtx, imgDataObj;
		if (source != 'canvas') {
			if (isViewportDisplay && cachedCanvas !== null) { vCtx.putImageData(cachedCanvas, 0, 0); }
			if (!isViewportDisplay && cachedCanvasBackfill !== null) { bCtx.putImageData(cachedCanvasBackfill, 0, 0); }
			sourceCtx = display.getContext('2d');
		} else {
			if (isViewportDisplay) {
				sourceCtx = fCtx; // Canvas source, non-convolution filter, frontfill.
			} else {
				sourceCtx = fbCtx;  // Canvas source, non-convolution filter, backfill.
			}
		}
		
		imgDataObj = sourceCtx.getImageData(0, 0, display.width, display.height);
		if (typeof filter !== 'undefined' && filter !== null) {
			var imgDataObjFiltered = filterImageObject(imgDataObj, filter, filterValue, filterValue2);
		} else {
			var imgDataObjFiltered = multiFilterImageObject(window.name||"", imgDataObj);
		}

		var ctx = display.getContext('2d');
		ctx.putImageData(imgDataObjFiltered, 0, 0);
	}

	function filterImageObject (imageDataObject, filter, filterValue, filterValue2) {
		return Z.Utils.filterImage(imageDataObject, filter, filterValue, filterValue2);
	}

	function multiFilterImageObject (name, imageDataObject, filter, filterValue, filterValue2) {
		return applyImageFiltersObject(name, imageDataObject, filter, filterValue, filterValue2);
	}

	// Apply all filters in imageFiltersApplied list to frontfill and backfill. Passing null
	// filter parameter through applyImageFilter to filterImageDisplay causes call to
	// multiFilterImageObject function rather than to filterImageObject.
	function applyImageFiltersCanvas () {
		self.applyImageFilter(null, null, 'canvas');
	}

	function applyImageFiltersTile (name, image) {
		var imageDataObject = Z.Utils.getImageData(image);
		return applyImageFiltersObject(name, imageDataObject);
	}

	function applyImageFiltersObject (name, imageDataObject) {
		// Get and return image data in object form.
		var index = Z.Utils.arrayIndexOfObjectValue(tileImages, 'name', name);
		if (index != -1) {
			imageDataObject = tileImages[index].object;
		} else {
			for (var i = 0, j = imageFiltersApplied.length; i < j; i++) {
				var filter = imageFiltersApplied[i].filter;
				var filterValue = imageFiltersApplied[i].value;
				var filterValue2 = imageFiltersApplied[i].value2;
				if (filterValue != 0) {
					imageDataObject = Z.Utils.filterImage(imageDataObject, filter, filterValue, filterValue2);
					//DEV NOTE: some filter-related tile caching disabled for current release.
					//self.cacheTileImage(imageDataObject);
				}
			}

			// Verify tiles cached in image filtered list are under allowed maximum.
			validateCache(true);
		}
		return imageDataObject;
	}

	function syncImageFilterCanvas (frontOrBack) {
		if (Z.imageFilters && imageFilterStatesConvolve && fC && fbC) {
			if (frontOrBack == 'frontfill') {
				Z.Utils.clearDisplay(fC);
				fC.width = vD.width;
				fC.height = vD.height;
				fS.width = vS.width;
				fS.height = vS.height;
				fCtx.translate(displayCtrX, displayCtrY);
				fCtx.scale(tierScale, tierScale);
			} else {
				Z.Utils.clearDisplay(fbC);
				fbC.width = bD.width;
				fbC.height = bD.height;
				fbS.width = bS.width;
				fbS.height = bS.height;
			}
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::: EVENT FUNCTIONS ::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Handle mouse and touch events that are Viewport-specific. Keyboard events are handled
	// at the level of the Viewer. Disable right-click / control-click / click-hold menu.
	function initializeViewportEventListeners () {
		Z.Utils.addEventListener(cD, 'mousedown', viewportEventsHandler);
		Z.Utils.addEventListener(cD, 'mousemove', Z.Utils.preventDefault);
		Z.Utils.addEventListener(cD, 'touchstart', viewportEventsHandler);
		Z.Utils.addEventListener(cD, 'touchmove', viewportEventsHandler);
		Z.Utils.addEventListener(cD, 'touchend', viewportEventsHandler);
		Z.Utils.addEventListener(cD, 'touchcancel', viewportEventsHandler);
		Z.Utils.addEventListener(cD, 'gesturestart', viewportEventsHandler);
		Z.Utils.addEventListener(cD, 'gesturechange', viewportEventsHandler);
		Z.Utils.addEventListener(cD, 'gestureend', viewportEventsHandler);
		Z.Utils.addEventListener(bD, 'contextmenu', Z.Utils.preventDefault);
		Z.Utils.addEventListener(vD, 'contextmenu', Z.Utils.preventDefault);
		if (wD) { Z.Utils.addEventListener(wD, 'contextmenu', Z.Utils.preventDefault); }
		if (hD) { Z.Utils.addEventListener(hD, 'contextmenu', Z.Utils.preventDefault); }
	}

	function viewportEventsHandler (event) {
		var event = Z.Utils.event(event);
		var eventType = event.type;
		if (event && eventType) {

			// Debug option: use next line to verify touch events properly preventing default simulation of mouse events.
			//if (eventType == 'mouseover' || eventType == 'mousedown' || eventType == 'mouseup' || eventType == 'mouseout') { alert('mouse event: ' + eventType); }

			// Prevent unwanted effects: interactivity or mouse-panning if parameters specify, zoom on right-click,
			// page dragging in touch contexts, and conflicting zoom-and-pan function calls. DEV NOTE: Timeout in
			// next line is placeholder workaround for hotspot icon and caption anchor failure in IE.
			var openPoly = (!polygonComplete && (Z.labelMode == 'polygon' || Z.labelMode == 'measure'));
			var isRightMouseBtn = Z.Utils.isRightMouseButton(event);
			var isAltKey = event.altKey;
			var blockRightClick = isRightMouseBtn && !openPoly;

			if ((eventType != 'mouseover' && eventType != 'mouseout' && !Z.interactive)
				|| (eventType == 'mousedown' && (!Z.interactive || (Z.coordinatesVisible && isAltKey)))
				|| blockRightClick) {
				Z.tourStop = true; // Prevents autostart if not started or next destination.
				return;
			} else if (eventType == 'mousedown' || eventType == 'touchstart' || (Z.tourPlaying && Z.tourStop)) {
				self.zoomAndPanAllStop();
				self.tourStop(); // Sets Z.tourPlaying = false;
				Z.tourStop = true;
				Z.interactive = true;
			}

			if (Z.touchSupport && !Z.clickZoomAndPanBlock && eventType != 'touchmove' && eventType != 'gesturechange') {
				event.preventDefault();
			}
			if (eventType == 'mousedown') {
				var displayMouseDownTimer = window.setTimeout( function () { self.zoomAndPanAllStop(false, true); }, 1);
				if (Z.maskingSelection && Z.maskClearOnUserAction) { self.clearMask(); }

			} else if (eventType == 'touchstart' || eventType == 'gesturestart') {
				// DEV NOTE: Next line is necessary to prevent simulated mouse events which can cause duplicate event such as second function call.
				// However, must not be implemented on standard mouse click of hotspot as will prevent hotspot clickURL effect implemented as anchor href.
				var prevDef = false;
				touch = Z.Utils.getFirstTouch(event);
				if (typeof touch !== 'undefined' && touch !== null) {
					var hotTarget = touch.target;
					var hotspotSelect = getHotspotTarget(hotTarget);
					if (hotspotSelect === null) {
						prevDef = true; // Not clicking hotspot.
					} else {
						var hotID = hotspotSelect.id.substring(3, hotspotSelect.id.length);
						var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotID);
						if (index != -1) {
							var hotspot = hotspots[index];
							if (hotspot !== null && hotspot.clickURL == 'function') {
								prevDef = true; // Click hotspot that has click function.
							}
						}
					}
				}
				if (prevDef) { event.preventDefault(); }

				self.zoomAndPanAllStop(false, true);
				if (Z.maskingSelection && Z.maskClearOnUserAction) { self.clearMask(); }
			}

			// Handle event resetting.
			switch(eventType) {
				case 'mouseover' :
					// Prevent page scrolling using arrow keys. Also implemented in text element blur handler.
					if (!Z.fullView && document.activeElement.tagName != 'TEXTAREA') {
						Z.Viewer.initializeViewerKeyDefaultListeners(true);
					}
					break;
				case 'mousedown' :
					// Ensure mouse interaction with viewport re-enables key interaction by removing focus from any text area and adding key listeners.
					if (!Z.fullView && document.activeElement) { document.activeElement.blur(); }
					Z.Viewer.initializeViewerKeyEventListeners(true);

					// Note: handler for mouse down event attached to viewport, mouse up attached to viewer.
					Z.Utils.addEventListener(document, 'mousemove', viewportEventsHandler);
					Z.Utils.addEventListener(document, 'mouseup', viewportEventsHandler);
					break;
				case 'mouseup' :
					Z.Utils.removeEventListener(document, 'mousemove', viewportEventsHandler);
					Z.Utils.removeEventListener(document, 'mouseup', viewportEventsHandler);
					break;
			}

			// Handle event actions.
			viewportEventsManager(event);

			if (eventType == 'mousedown' || eventType == 'mousemove') { return false; }
		}
	}

	function viewportEventsManager (event) {
		var vpIDStr = viewportID.toString();

		var event = Z.Utils.event(event);
		var eventType = event.type;
		if (event && eventType) {

			var touch, target, relatedTarget, mPt;
			if (eventType == 'touchstart' || eventType == 'touchmove' || eventType == 'touchend' || eventType == 'touchcancel') {
				touch = Z.Utils.getFirstTouch(event);
				if (typeof touch !== 'undefined') {
					target = touch.target;
					mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				}
			} else {
				target = Z.Utils.target(event);
				relatedTarget = Z.Utils.relatedTarget(event);
				var isRightMouseBtn = Z.Utils.isRightMouseButton(event);
				var isAltKey = event.altKey;
				if (eventType != 'resize') { mPt = Z.Utils.getMousePosition(event); }
				if (Z.smoothPan) { smoothPanMousePt = mPt; }
			}

			// Standardize Firefox mouse wheel event.
			if (eventType == 'DOMMouseScroll') { eventType = 'mousewheel'; }

			// Calculate zoom and click values.
			var zVal = self.getZoom();
			var zValStr = (zVal * 100).toString();
			var clickPt;
			if (typeof mPt !== 'undefined' && mPt !== null) {
				clickPt = self.getClickCoordsInImage(event, zVal, mPt);
			}

			// Implement actions.
			switch(eventType) {

				case 'mousedown' :
					Z.mouseIsDown = true;

					if (Z.comparison) {
						var tID = target.id;
						var vpIDStr = tID.substring(tID.indexOf('viewportDisplay') + 15, tID.length);
						viewportID = (Z.Utils.stringValidate(vpIDStr)) ? parseInt(vpIDStr, 10) : 0;
						Z.Viewer.viewportSelect(viewportID);
					}

					dragPtStart = new Z.Utils.Point(mPt.x, mPt.y); // Variables for dragging set and cleared separately from mouse position variables.
					dragTimeStart = new Date().getTime();
					cD.mouseXPrior = mPt.x;
					cD.mouseYPrior = mPt.y;

					if (((Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && hotspotCurrentID !== null) || (Z.labelMode == 'rectangle' && hotspotCurrentID === null)) {
						// Click polygon control point to edit. If click-drag to create rectangle, hotspot ID null until creation on mouse-up.
						controlPointCurrent = getClickedControlPoint(event, clickPt);
					}

					if (Z.zoomRectangle && isAltKey && !Z.measureVisible && Z.labelMode == 'view' && Z.editing === null) {
						// Create Zoom Rectangle - four control points (0:upper left, 1:upper right, 2:bottom right, 3:bottom left).
						if (hS.display == 'none' || eS.display == 'none' || dS.display == 'none') {
							hS.display = eS.display = dS.display = 'inline-block';
							Z.Utils.addEventListener(hotspotDisplay, 'mousedown', Z.Utils.preventDefault);
						}
						zoomRectangleDragging = true;
						createdNewLabel = false;
						var initialRectSpan = 1;
						var hotCurrID = null;
						createControlPoint(hotCurrID, false, clickPt);
						createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x + initialRectSpan, clickPt.y));
						createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x + initialRectSpan, clickPt.y + initialRectSpan));
						createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x, clickPt.y + initialRectSpan));
						completePolygon(hotspotCurrentID, true);
						controlPointCurrent = 2;

					} else if (!isAltKey && Z.labelMode != 'view' && ((Z.editing == 'addLabel' || Z.editing == 'editLabel') || (Z.editMode === null && Z.labelMode == 'measure'))) {
						// Create or modify freehand or rectangle labels. Text, icon, polygon, and measure modes handled in mouseup event.
						// First clear choicelists and messages and save prior label if freehand or rectangle, but not if polygon and measurements as these can have multiple mouse-up events.
						if (Z.editMode != 'markup') { self.toggleLabelColorPicker(false); }
						self.toggleLabelIconPicker(false);
						Z.Utils.hideMessage(); // Hide any tip if first use to avoid need for clicking OK button.

						// Prevent save of current hotspot/label and creation of new label if permissions are required and not provided.
						// Applies only if label edit mode is of click-drag-create or click-click-click type: freehand, rectangle, polygon, or measure.
						if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction() && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
							return;
						}

						if (Z.editing == 'addLabel' && (Z.labelMode == 'freehand' || (Z.labelMode == 'rectangle' && controlPointCurrent === null))) {
							self.saveEditsLabel(true, false, false);
						}

						createdNewLabel = false;
						if (Z.labelMode == 'freehand' && Z.mouseIsDown) {
							// Clear any prior freehand drawing for this label to ensure latest click-drag is only drawing.
							if (Z.editing == 'editLabel' && hotspotCurrent) { Z.Utils.arrayClear(hotspotCurrent.polygonPts); }

							// Create control point to create hotspot container.
							var hotCurrID = (Z.editing == 'editLabel') ? hotspotCurrentID : null;
							createControlPoint(hotCurrID, false, clickPt);
							lastPtX = (clickPt.x - Z.imageX) * zVal;
							lastPtY = (clickPt.y - Z.imageY) * zVal;
							completePolygon(hotspotCurrentID, false);
							createdNewLabel = true;

						} else if (Z.labelMode == 'rectangle' && controlPointCurrent === null) {
							// Create four control points (0:upper left, 1:upper right, 2:bottom right, 3:bottom left).
							var initialRectSpan = 1;
							var hotCurrID = null;
							if (Z.editing == 'editLabel') {
								hotCurrID = hotspotCurrentID;
								if (hotspotCurrent && controlPointCurrent === null) {
									Z.Utils.arrayClear(hotspotCurrent.polygonPts);
								}
							}
							createControlPoint(hotCurrID, false, clickPt);
							createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x + initialRectSpan, clickPt.y));
							createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x + initialRectSpan, clickPt.y + initialRectSpan));
							createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x, clickPt.y + initialRectSpan));
							completePolygon(hotspotCurrentID, true);
							controlPointCurrent = 2;
							createdNewLabel = true;
						}

						if (createdNewLabel && !Z.annotationsAddMultiple) { Z.editing = 'editLabel'; }

					} else if ((isAltKey || Z.labelsClickDrag) && (Z.editing == 'addLabel' || Z.editing == 'editLabel')) {
						// Select label in panel or to drag-position. Alternative implementation: To allow hotspot dragging without Alt key in view mode change above condition to: if (isAltKey || Z.labelMode == 'view') {
						hotspotDragging = getHotspotTarget(target);
						if (hotspotDragging) {
							var viewportDisplayClickPt = self.convertPageCoordsToViewportDisplayCoords(event.clientX, event.clientY);
							var dragHotPt = new Z.Utils.Point(parseFloat(hotspotDragging.style.left), parseFloat(hotspotDragging.style.top));
							var offsetX = viewportDisplayClickPt.x - dragHotPt.x;
							var offsetY = viewportDisplayClickPt.y - dragHotPt.y;
							hotspotDragging.mouseXPrior = dragPtStart.x;
							hotspotDragging.mouseYPrior = dragPtStart.y;
							hotspotDragging.mouseXOffset = offsetX;
							hotspotDragging.mouseYOffset = offsetY;
							hotspotDragging.style.zIndex = hotspots.length + 1;

							// If alt-click hotspot other than current hotspot, set current POI, Label, and hotspot based on alt-clicked hotspot.
							// If not in any edit mode (not view mode), change edit mode to match label media.
							var hotspotInternalID = hotspotDragging.id.substring(3, hotspotDragging.id.length);
							if (hotspotCurrentID && hotspotCurrentID != hotspotInternalID) {

								// Prevent change of current hotspot/label if permissions are required and not provided.
								// Applies regardless of label edit mode: freehand, text, icon, rectangle, polygon, or measure.
								if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
									return;
								}

								// Save point for Cancel to return to but do not post to XML with self.saveEditsLabel(true, true, 'label');
								// as that is for the Save button to call or would interfere with alt-click-drag.
								savePoint('save', 'labels');
								var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
								if (index != -1) {
									var hotspot = hotspots[index];
									populatePOIs(hotspot.poiID, hotspot.internalID);
								}

								// Debug option: Z.setCallback('labelSelectedInViewportGetIDs', function (param1, param2) { alert('id: ' + param1 + ', internalID: ' + param2); } );
								Z.Utils.validateCallback('labelSelectedInViewportGetIDs');

							}
							// If hotspot or tour list, with title, unset current selection and set to title.
							if (hotspotList && (Z.hotspotListTitle || Z.tourListTitle)) { hotspotList.selectedIndex = 0; }
						}

					} else if (Z.smoothPan && !isAltKey && Z.mousePan) {
						smoothPanStart();
					}
					break;

				case 'mousemove' :
					dragPtCurrent = new Z.Utils.Point(mPt.x, mPt.y);
					var mPtZX = (clickPt.x - Z.imageX) * zVal;
					var mPtZY = (clickPt.y - Z.imageY) * zVal;

					// Clear double-click timer if no need to close polygon.
					if (clickTimer) {
						clearTimeout(clickTimer);
						clickTimer = null;
						polygonClickHandler(event, clickPt, isDblClick);
					}

					if (Z.zoomRectangle && isAltKey && Z.labelMode == 'view' && Z.editing === null) {
						// Resize zoom rectangle.
						updatePolygon(hotspotCurrentID, controlPointCurrent, clickPt);

					} else if (!isAltKey && !Z.tracking && ((Z.editMode === null && Z.labelMode == 'measure') || (Z.labelMode != 'view' && (Z.editing == 'addLabel' || Z.editing == 'editLabel')))) {
						// Prevent addition to current label if permissions are required and not provided.
						// Applies if label edit mode supports click-drag of control points: rectangle, polygon, or measure.
						if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction() && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
							return;
						}

						// Create or modify labels.
						var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
						var polygonClosed = (hotspotCurrentIndex != -1) ? hotspots[hotspotCurrentIndex].polyClosed : false;

						if (Z.labelMode == 'freehand' && Z.mouseIsDown) {
							// Draw freehand.
							drawFreehand(lastPtX, lastPtY, mPtZX, mPtZY, clickPt);

							// Update prior mouse position tracker.
							lastPtX = mPtZX;
							lastPtY = mPtZY;

						} else if ((Z.measureVisible || self.getLabelEditable(hotspotCurrentID)) && (Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && controlPointCurrent !== null && Z.mouseIsDown) {
							// Drag existing control point.
							updatePolygon(hotspotCurrentID, controlPointCurrent, clickPt);
						} else if ((Z.labelMode == 'polygon' || Z.labelMode == 'measure') && !polygonClosed && (!Z.mouseIsDown || (Z.mouseIsDown && controlPointCurrent !== null))) {
							// Draw bungee.
							drawPolygonBungeeLine(mPtZX, mPtZY, clickPt);
						}
						// Alternative Implementation: auto-exist measure mode. Note that this prevents editing of measurement line/polygon after it is completed/closed.
						/*else {
							//Z.Utils.showMessage(Z.Utils.getResource('ALERT_CLICKDRAGEXITTOVIEWMODE'), false, Z.messageDurationShort, 'center');
							self.setEditModeLabel('view');
						}*/

					} else if (hotspotDragging) {
						// Prevent addition to, or editing of, current label if permissions are required and not provided.
						// Applies to all label types if label or control point is being dragged.
						if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
							return;
						}

						var editableLabel = self.getLabelEditable(hotspotCurrentID);
						if (editableLabel) {
							// Drag label.
							var htS = hotspotDragging.style;
							var mouseDeltaX = dragPtCurrent.x - hotspotDragging.mouseXPrior;
							var mouseDeltaY = dragPtCurrent.y - hotspotDragging.mouseYPrior;
							var x = parseFloat(htS.left) + mouseDeltaX;
							var y = parseFloat(htS.top) + mouseDeltaY;
							htS.left = x + 'px';
							htS.top = y + 'px';
							hotspotDragging.mouseXPrior = dragPtCurrent.x;
							hotspotDragging.mouseYPrior = dragPtCurrent.y;
							updateHotspotPosition(event, hotspotDragging, dragPtCurrent);
						}

					} else if (!isAltKey && Z.mousePan) {
						// Pan the image.
						if (smoothPanInterval) {
							// In smooth pan mode. Pan occurs in interval handler. Get mouse position.
							smoothPanMousePt = mPt;

						} else {
							// In direct pan mode. Pan image if no image set or zoomed in, otherwise animate by changing Viewport.
							if (!Z.animation || self.getZoom() != Z.minZ) {

								// Calculate change in mouse position.
								var deltaX = mPt.x - cD.mouseXPrior;
								var deltaY = mPt.y - cD.mouseYPrior;

								if (!isNaN(deltaX) && !isNaN(deltaY)) {

									// Calculate new position of displays container.
									var newL = parseFloat(cS.left) + deltaX;
									var newT = parseFloat(cS.top) + deltaY;

									// Constrain new position.
									var constrainedPt = constrainPan(newL, newT, Z.imageZ, Z.imageR, 'container');
									cS.left = constrainedPt.x + 'px';
									cS.top = constrainedPt.y + 'px';

									// Update stored page coordinates for next call to this function.
									cD.mouseXPrior = mPt.x;
									cD.mouseYPrior = mPt.y;

									// Implement oversize backfill if required.
									var deltaX = constrainedPt.x - displayL;
									var deltaY = constrainedPt.y - displayT;
									if (oD && tierBackfillDynamic && (Z.mobileDevice || (Math.abs(deltaX) > (viewW / 2) || Math.abs(deltaY) > (viewH / 2)))) {
										redisplayCachedTiles(oD, tierBackfillOversize, tilesBackfillCached, 'simple', false, 'Updating backfill oversize display');
									}

									// Sync navigator rectangle if visible.
									var currentCenterPt = self.calculateCurrentCenterCoordinates(constrainedPt, Z.imageZ, Z.imageR);
									if (Z.Navigator) { Z.Navigator.syncNavigatorRectangleToViewport(currentCenterPt); }

									// Update browser address bar for bookmarking.
									Z.Utils.setBookmarksURL();

									// Sync comparison and overlay viewports.
									Z.Viewer.syncComparisonViewport();
									Z.Viewer.syncOverlayViewports(null, vpID);

									// Sync counter tracking.
									if (Z.tracking) { self.syncTrackingToViewport(); }
								}

							} else {
								if (mPt.x > cD.mouseXPrior) {
									Z.Viewer.viewportNext();
								} else if (mPt.x < cD.mouseXPrior) {
									Z.Viewer.viewportPrior();
								}

								// Update stored page coordinates for next call to this function.
								cD.mouseXPrior = mPt.x;
								cD.mouseYPrior = mPt.y;
							}
						}
					}
					break;

				case 'mouseup' :
					Z.mouseIsDown = false;
					document.mousemove = null;
					document.mouseup = null;
					var dragTimeEnd = new Date().getTime();
					var dragPtEnd;

					if (!Z.mouseOutDownPoint) {
						dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
					} else {
						dragPtEnd = Z.mouseOutDownPoint;
						clickPt = self.getClickCoordsInImage(event, zVal, Z.mouseOutDownPoint);
					}
					var dragDist = Z.Utils.calculatePointsDistance(dragPtStart.x, dragPtStart.y, dragPtEnd.x, dragPtEnd.y);
					var dragDuration = dragTimeEnd - dragTimeStart;
					if ((dragDist < MOUSECLICK_THRESHOLD_VIEWPORT && dragDuration < MOUSECLICK_THRESHOLD_TIME_VIEWPORT) || (!isAltKey && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle'))) {

						if (!hotspotDragging && ((Z.editMode === null && Z.labelMode == 'measure') || (Z.labelMode != 'view' && (Z.editing == 'addLabel' || Z.editing == 'editLabel')))) {

							// Prevent save of current hotspot/label and creation of new label if permissions are required and not provided.
							// Applies if label edit mode is of simple click to create type: text or icon.
							if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
								return;
							}

							// First save any previously edited label not saved on mousedown.
							if (Z.editing == 'addLabel' && !isAltKey && polygonComplete && (Z.labelMode == 'text' || Z.labelMode == 'icon' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
								self.saveEditsLabel(true, false, false);
							}

							if ((!(isAltKey && polygonComplete) || isRightMouseBtn) && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
								// In edit mode, handle click on or off control point with current polygon/rectangle or without. If drawing new polygon reset mouse move event handler to support bungee line drawing.
								// Freehand completion also handled here. First double condition above prevents creation of polygon with one control point by alt-clicking before ever clicking.
								// Alternative implemenation: enable next two lines and disable if/else clause below to disable double-click close option for polygons and only support alt-click and right-click.

								if (isAltKey || isRightMouseBtn) {
									polygonClickHandler(event, clickPt);
									if (!polygonComplete) { Z.Utils.addEventListener(document, 'mousemove', viewportEventsHandler); }
								} else {
									Z.Utils.addEventListener(document, 'mousemove', viewportEventsHandler);
									var isDblClick = false;
									if (!clickTimer) { // First click, delay and wait for second click.
										clickTimer = setTimeout(function(event) {
											clickTimer = null;
											polygonClickHandler(event, clickPt, isDblClick);
										}, Z.doubleClickDelay);
										if (Z.labelMode != 'polygon' && Z.labelMode != 'measure') { Z.Utils.removeEventListener(document, 'mousemove', viewportEventsHandler); }
									} else { // Second click.
										isDblClick = true;
										clearTimeout(clickTimer);
										clickTimer = null;
										polygonClickHandler(event, clickPt, isDblClick);
										Z.Utils.removeEventListener(document, 'mousemove', viewportEventsHandler);
									}
								}

							} else if (!isAltKey) {
								var poiID = (typeof poiList !== 'undefined' && poiList.options.length > 0) ? poiID = poiList.options[poiList.selectedIndex].value : 0;
								createdNewLabel = false;

								if (Z.labelMode == 'text') {
									// Create or modify text label.
									if (Z.editing == 'addLabel') {
										self.createLabelFromParameters(null, null, 'text', null, null, clickPt.x.toString(), clickPt.y.toString(), zValStr, null, null, null, '0', '0', null, null, null, null, null, null, captionTextColor, null, null, null, null, null, null, null, '5', '0', null, poiID);
										createdNewLabel = true;
									} else {
										if (hotspotCurrent) {
											self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
											self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
										}
									}

								} else if (Z.labelMode == 'icon') {
									// Create or modify icon label.
									var iconList = document.getElementById('labelIconList' + vpIDStr);
									if (iconList) {
										var iconTypeOrPath = iconList[iconList.selectedIndex].value;
										var media;
										switch (iconTypeOrPath) {
											case 'shim' :
												media = (Z.labelIconsInternal) ? 'circle' : annotationFolder + '/' + 'circle.png';
												break;
											case 'External Graphics File' :
												media = iconTypeOrPath;
												break;
											default :
												media = (Z.labelIconsInternal) ? iconTypeOrPath : annotationFolder + '/' + iconTypeOrPath;
										}
										if (Z.editing == 'addLabel') {
											self.createLabelFromParameters(null, null, 'icon', media, null, clickPt.x.toString(), clickPt.y.toString(), zValStr, null, null, null, '0', '0', null, null, null, null, null, null, captionTextColor, null, lineStrokeColor, null, null, null, null, null, null, '0', null, poiID);
											createdNewLabel = true;

										} else {
											if (hotspotCurrent) {
												self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
												self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
											}
										}
									}

								} else if (Z.labelMode == 'counter') {
									// Create counter label.
									if (Z.editing == 'addLabel') {
										// Get default values.
										var textColor = Z.Utils.getResource('CONTENT_TRACKINGTEXTCOLOR');
										var lineColor = Z.Utils.getResource('CONTENT_TRACKINGLINECOLOR');
										var fillColor = Z.Utils.getResource('CONTENT_TRACKINGFILLCOLOR');

										// Get global values.
										var user = Z.userName;
										var caption = Z.userInitials;
										var id = getFreeID('label');

										// Get current view values.
										var x = Math.round(clickPt.x).toString();
										var y = Math.round(clickPt.y).toString();
										var zoom = '100'; // Alternative implementation: Use current value.
										var cell = self.getTrackingCellIDFromCoordinates(x, y, zoom);

										// Get current counter type values.
										var name = null;
										var typeID = null;
										var tooltip = null;
										var index = Z.Utils.arrayIndexOfObjectValue(trackingTypesListDP, 'value', Z.trackingTypeCurrent);
										if (index != -1) {
											var typeCurrent = trackingTypesListDP[index];
											name = typeCurrent.text;
											tooltip = typeCurrent.text + ' : ' + Z.userName;
											typeID = typeCurrent.value;
											fillColor = typeCurrent.fillColor;
										}

										// Create derived values.
										var text = cell + '   ' + x + ', ' + y + ', ' + zoom + ': ' + user;
										var sortKey = Z.Utils.stringPadFront(cell, 6, '0') + Z.Utils.stringPadFront(id, 6, '0');

										// Set defaults for label and tracking instance array.
										var mediaType = 'counter';
										var media = 'circle';
										var radius = 40;
										var captionPosition = Z.Utils.getResource('CONTENT_COUNTERCAPTIONPOSITION');
										var date = Z.Utils.getCurrentUTCDateAsString();

										// Create label.
										self.createLabelFromParameters(id, name, mediaType, media, null, x, y, zoom, null, null, radius, '0', '0', null, null, null, caption, null, tooltip, textColor, null, lineColor, fillColor, '1', '0', '1', '1', captionPosition, '0', null, poiID, null, null, null, null, null, null, null, null, typeID, null, null, null, null, user, Z.userInitials, date);
										createdNewLabel = true;

										// Create counter instance tracking record and recalc counts.
										trackingInstancesListDP[trackingInstancesListDP.length] = { text:text, value:id, sortKey:sortKey, cell:cell, typeID:typeID, x:x, y:y, zoom:zoom, user:user, name:name, mediaType:mediaType, media:media, radius:radius.toString(), caption:caption, captionPosition:captionPosition, fillColor:fillColor, initials:Z.userInitials, date:date }
										self.syncTrackingToViewport();
									}
								}

								if (createdNewLabel) {
									var newLabel = labelListDP[labelListDP.length - 1];
									populateLabels(newLabel.poiID, newLabel.value);
									createdNewLabel = false;

									if (!Z.annotationsAddMultiple) { Z.editing = 'editLabel'; }
								}

							} else if (isAltKey && (Z.labelMode == 'text' || Z.labelMode == 'icon')) {
								if (hotspotCurrent) {
									self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
									self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
								}

							}
							setAnnotationPanelEditability('label', Z.editing);

						} else if (hotspotDragging !== null && (Z.measureVisible || Z.tour || Z.hotspots || Z.annotations)) {
							hotspotDragging = null;

						} else if ((Z.editing === null || Z.labelMode == 'view') && !hotspotDragging) {

							// Detect if label clicked.
							var hotspotSelect = null;
							if (Z.labelClickSelect) { hotspotSelect = getHotspotTarget(target); }

							if (hotspotSelect !== null) {
								// Select label in panel and zoom and pan to its coordinates.
								var hotspotInternalID = hotspotSelect.id.substring(3, hotspotSelect.id.length);
								var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
								if (index != -1) {
									var hotspot = hotspots[index];
									populatePOIs(hotspot.poiID, hotspot.internalID);
									self.zoomAndPanToView(hotspot.x, hotspot.y, (hotspot.z / 100), hotspot.rotation);

									// Debug option: Z.setCallback('labelSelectedInViewportGetIDs', function (param1, param2) { alert('id: ' + param1 + ', internalID: ' + param2); } );
									Z.Utils.validateCallback('labelSelectedInViewportGetIDs');
								}
								// If hotspot or tour list, with title, unset current selection and set to title.
								if (hotspotList && (Z.hotspotListTitle || Z.tourListTitle)) { hotspotList.selectedIndex = 0; }

							} else {

								// Zoom and/or pan.
								if (Z.clickZoom || Z.clickPan) {
									var doubleClick = (clickTimer && Z.doubleClickZoom) ? true : false;
									var clickPtZoom = self.getClickZoomCoords3D(event, dragPtStart, tierCurrent, tierScale, doubleClick);
								}
								if (Z.clickZoom) {
									if (!Z.doubleClickZoom) {
										// DEV NOTE: Timeout in line below is placeholder workaround for caption anchor failure in Firefox necessary if not implementing single-click delay below.
										var viewerDisplayMouseUpClickZoomTimer = window.setTimeout( function () { self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z); }, 1);

									} else {
										if (!clickTimer) { // First click, delay and wait for second click.
											clickTimer = setTimeout(function(event) {
												clickTimer = null;
												self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z);
											}, Z.doubleClickDelay);

										} else { // Second click.
											clearTimeout(clickTimer);
											clickTimer = null;
											self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z);
										}
									}

								} else if (Z.clickPan) {
									self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, Z.imageZ);
								}
								if (Z.zoomRectangle && zoomRectangleDragging) {
									var zoomRectanglePts = hotspots[hotspotCurrentID].polygonPts;
									self.deleteLabel(hotspotCurrentID);
									zoomRectangleDragging = null;
									if (!Z.measureVisible && !Z.tour && !Z.hotspots && !Z.annotations) {
										hS.display = eS.display = dS.display = 'none';
										Z.Utils.removeEventListener(hotspotDisplay, 'mousedown', Z.Utils.preventDefault);
									}
								}
							}
						}

					} else {
						// Prevent addition to, or editing of, current label if permissions are required and not provided.
						// Applies if label edit mode is of click-drag-create type: freehand or rectangle.
						if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
							return;
						}

						if (Z.zoomRectangle && zoomRectangleDragging && Z.labelMode == 'view' && Z.editing === null) {
							var zoomRectanglePts = hotspots[hotspotCurrentID].polygonPts;
							self.deleteLabel(hotspotCurrentID, true);
							zoomRectangleDragging = null;
							if (!Z.measureVisible && !Z.tour && !Z.hotspots && !Z.annotations) {
								hS.display = eS.display = dS.display = 'none';
								Z.Utils.removeEventListener(hotspotDisplay, 'mousedown', Z.Utils.preventDefault);
							}
							self.zoomAndPanToZoomRectangle(zoomRectanglePts);

						} else if ((Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && (controlPointDragging || (controlPointCurrent === null && !polygonComplete))) {
							// Drag control point.
							controlPointCurrent = null;
							controlPointDragging = false;
							var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
							if (hotspotCurrentIndex != -1) {
								var hotspot = hotspots[hotspotCurrentIndex];
								var polyCenter = Z.Utils.polygonCenter(hotspot.polygonPts, hotspot.polyClosed);
								hotspot.x = polyCenter.x;
								hotspot.y = polyCenter.y;
								Z.Utils.clearDisplay(eD);
								var hC = new HotspotContext();
								displayHotspot(hotspot, hC);
								if (!polygonComplete) { Z.Utils.addEventListener(document, 'mousemove', viewportEventsHandler); }
							}

						} else if (hotspotDragging) {
							if (self.getLabelEditable(hotspotCurrentID)) {
								var htS = hotspotDragging.style;	
								var mouseDeltaX = dragPtEnd.x - hotspotDragging.mouseXPrior;
								var mouseDeltaY = dragPtEnd.y - hotspotDragging.mouseYPrior;
								var x = parseFloat(htS.left) + mouseDeltaX;
								var y = parseFloat(htS.top) + mouseDeltaY;
								htS.left = x + 'px';
								htS.top = y + 'px';
								updateHotspotPosition(event, hotspotDragging, dragPtEnd);
							}
							hotspotDragging.style.zIndex = hotspotDragging.zIndex;
							hotspotDragging = null;
						}

						dragPtCurrent = null;

						// Test for need for updateView. If in smoothPanGliding this test occurs before smooth pan interval sees that mouse is up.
						if (Z.mousePan && !Z.smoothPan) { self.updateView(); }
					}


					// If mouse-dragged out of viewer display rather than mousing out, hide components.
					if (Z.mouseOutDownPoint) {
						if (Z.ToolbarDisplay && Z.toolbarAutoShowHide) { Z.Toolbar.show(false); }
						if (Z.Navigator && Z.navigatorVisible > 1) {
							Z.Navigator.setVisibility(false);
							if (Z.comparison && Z.Navigator2) { Z.Navigator2.setVisibility(false); }
						}
						if (Z.Toolbar) {
							if (Z.annotations && (Z.annotationPanelVisible == 2 || Z.annotationPanelVisible == 3)) { Z.Toolbar.setVisibilityAnnotationPanel(false); }
							if (Z.tracking && (Z.trackingPanelVisible == 2 || Z.trackingPanelVisible == 3)) { Z.Toolbar.setVisibilityTrackingPanel(false); }
							if (Z.userPanelVisible == 2 || Z.trackingPanelVisible == 3) { Z.Toolbar.setVisibilityUserPanel(false); }
						}
					}
					break;

				case 'touchstart' :
					if (touch && !gestureInterval) {
						Z.mouseIsDown = true;
						wasGesturing = false;

						if (Z.comparison) {
							var tID = target.id;
							var vpIDStr = tID.substring(tID.indexOf('viewportDisplay') + 15, tID.length);
							viewportID = parseInt(vpIDStr, 10);
							Z.Viewer.viewportSelect(viewportID);
						}

						dragPtStart = new Z.Utils.Point(mPt.x, mPt.y);
						dragTimeStart = new Date().getTime();
						cD.mouseXPrior = mPt.x;
						cD.mouseYPrior = mPt.y;

						if (((Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && hotspotCurrentID !== null) || (Z.labelMode == 'rectangle' && hotspotCurrentID === null)) {
							// Click polygon control point to edit. If click-drag to create rectangle, hotspot ID null until creation on mouse-up.
							controlPointCurrent = getClickedControlPoint(event, clickPt);
						}

						if (!isAltKey && Z.labelMode != 'view' && ((Z.editing == 'addLabel' || Z.editing == 'editLabel') || (Z.editMode === null && Z.labelMode == 'measure'))) {
							// Create or modify freehand or rectangle labels. Text, icon, polygon, and measure modes handled in mouseup event.
							// First clear choicelists and messages and save prior label if freehand or rectangle, but not if polygon and measurements as these can have multiple mouse-up events.
							if (Z.editMode != 'markup') { self.toggleLabelColorPicker(false); }
							self.toggleLabelIconPicker(false);
							Z.Utils.hideMessage(); // Hide any tip if first use to avoid need for clicking OK button.

							// Prevent save of current hotspot/label and creation of new label if permissions are required and not provided.
							// Applies only if label edit mode is of click-drag-create or click-click-click type: freehand, rectangle, polygon, or measure.
							if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction() && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
								return;
							}

							if (Z.editing == 'addLabel' && (Z.labelMode == 'freehand' || (Z.labelMode == 'rectangle' && controlPointCurrent === null))) {
								self.saveEditsLabel(true, false, false);
							}

							if (Z.labelMode == 'freehand' && Z.mouseIsDown) {
								// Clear any prior freehand drawing for this label to ensure latest click-drag is only drawing.
								if (Z.editing == 'editLabel' && hotspotCurrent) { Z.Utils.arrayClear(hotspotCurrent.polygonPts); }

								// Create control point to create hotspot container.
								var hotCurrID = (Z.editing == 'editLabel') ? hotspotCurrentID : null;
								createControlPoint(hotCurrID, false, clickPt);
								lastPtX = (clickPt.x - Z.imageX) * zVal;
								lastPtY = (clickPt.y - Z.imageY) * zVal;
								completePolygon(hotspotCurrentID, false);

							} else if (Z.labelMode == 'rectangle' && controlPointCurrent === null) {
								// Create four control points (0:upper left, 1:upper right, 2:bottom right, 3:bottom left).
								var initialRectSpan = 1;
								var hotCurrID = null;
								if (Z.editing == 'editLabel') {
									hotCurrID = hotspotCurrentID;
									if (hotspotCurrent && controlPointCurrent === null) {
										Z.Utils.arrayClear(hotspotCurrent.polygonPts);
									}
								}
								createControlPoint(hotCurrID, false, clickPt);
								createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x + initialRectSpan, clickPt.y));
								createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x + initialRectSpan, clickPt.y + initialRectSpan));
								createControlPoint(hotspotCurrentID, false, new Z.Utils.Point(clickPt.x, clickPt.y + initialRectSpan));
								completePolygon(hotspotCurrentID, true);
								controlPointCurrent = 2;
							}

						} else if (isAltKey && (Z.editing == 'addLabel' || Z.editing == 'editLabel')) {
							// Select label in panel or to drag-position. Alternative implementation: To allow hotspot dragging without Alt key in view mode change above condition to: if (isAltKey || Z.labelMode == 'view') {
							hotspotDragging = getHotspotTarget(target);
							if (hotspotDragging) {
								var viewportDisplayClickPt = self.convertPageCoordsToViewportDisplayCoords(event.clientX, event.clientY);
								var dragHotPt = new Z.Utils.Point(parseFloat(hotspotDragging.style.left), parseFloat(hotspotDragging.style.top));
								var offsetX = viewportDisplayClickPt.x - dragHotPt.x;
								var offsetY = viewportDisplayClickPt.y - dragHotPt.y;
								hotspotDragging.mouseXPrior = dragPtStart.x;
								hotspotDragging.mouseYPrior = dragPtStart.y;
								hotspotDragging.mouseXOffset = offsetX;
								hotspotDragging.mouseYOffset = offsetY;
								hotspotDragging.style.zIndex = hotspots.length + 1;

								// If alt-click hotspot other than current hotspot, set current POI, Label, and hotspot based on alt-clicked hotspot.
								// If not in any edit mode (not view mode), change edit mode to match label media.
								var hotspotInternalID = hotspotDragging.id.substring(3, hotspotDragging.id.length);
								if (hotspotCurrentID && hotspotCurrentID != hotspotInternalID) {

									// Prevent change of current hotspot/label if permissions are required and not provided.
									// Applies regardless of label edit mode: freehand, text, icon, rectangle, polygon, or measure.
									if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
										return;
									}

									// Save point for Cancel to return to but do not post to XML with self.saveEditsLabel(true, true, 'label');
									// as that is for the Save button to call or would interfere with alt-click-drag.
									savePoint('save', 'labels');
									var index = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotInternalID);
									if (index != -1) {
										var hotspot = hotspots[index];
										populatePOIs(hotspot.poiID, hotspot.internalID);
									}

									// Debug option: Z.setCallback('labelSelectedInViewportGetIDs', function (param1, param2) { alert('id: ' + param1 + ', internalID: ' + param2); } );
									Z.Utils.validateCallback('labelSelectedInViewportGetIDs');

								}
								// If hotspot or tour list, with title, unset current selection and set to title.
								if (hotspotList && (Z.hotspotListTitle || Z.tourListTitle)) { hotspotList.selectedIndex = 0; }
							}

						// DEV NOTE: Smooth pan disabled for touch events in current implementation because touch interfaces introduce smooth interaction due to response delays.
						/*} else if (Z.smoothPan && !isAltKey  && Z.mousePan) {
							smoothPanStart();*/
						}
					}
					break;

				case 'touchmove' :
					// Touches are prevented when gesturing, as well as when in process of ending gesture
					// by lifting fingers - even when fingers are lifted separately. No bungee drawing between
					// touches to create control points as no tracking of finger when not touching.
					if (touch && !gestureInterval && !wasGesturing) {

						dragPtCurrent = new Z.Utils.Point(mPt.x, mPt.y);
						var mPtZX = (clickPt.x - Z.imageX) * zVal;
						var mPtZY = (clickPt.y - Z.imageY) * zVal;

						// Clear double-click timer if no need to close polygon.
						if (clickTimer) {
							clearTimeout(clickTimer);
							clickTimer = null;
							polygonClickHandler(event, clickPt, isDblClick);
						}

						if (!isAltKey && ((Z.editMode === null && Z.labelMode == 'measure') || (Z.labelMode != 'view' && (Z.editing == 'addLabel' || Z.editing == 'editLabel')))) {

							// Prevent addition to current label if permissions are required and not provided.
							// Applies if label edit mode supports click-drag of control points: rectangle, polygon, or measure.
							if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction() && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
								return;
							}

							// Create or modify labels.
							var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
							var polygonClosed = (hotspotCurrentIndex != -1) ? hotspots[hotspotCurrentIndex].polyClosed : false;

							if (Z.labelMode == 'freehand' && Z.mouseIsDown) {
								// Draw freehand.
								drawFreehand(lastPtX, lastPtY, mPtZX, mPtZY, clickPt);

								// Update prior mouse position tracker.
								lastPtX = mPtZX;
								lastPtY = mPtZY;

							} else if ((Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && controlPointCurrent !== null && Z.mouseIsDown) {
								// Drag existing control point.
								updatePolygon(hotspotCurrentID, controlPointCurrent, clickPt);

							} else if ((Z.labelMode == 'polygon' || Z.labelMode == 'measure') && !polygonClosed && (!Z.mouseIsDown || (Z.mouseIsDown && controlPointCurrent !== null))) {
								// Draw bungee.
								drawPolygonBungeeLine(mPtZX, mPtZY, clickPt);
							}

						} else if (hotspotDragging) {
							// Prevent addition to, or editing of, current label if permissions are required and not provided.
							// Applies to all label types if label or control point is being dragged.
							if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
								return;
							}

							// Drag label.
							var htS = hotspotDragging.style;
							var mouseDeltaX = dragPtCurrent.x - hotspotDragging.mouseXPrior;
							var mouseDeltaY = dragPtCurrent.y - hotspotDragging.mouseYPrior;
							var x = parseFloat(htS.left) + mouseDeltaX;
							var y = parseFloat(htS.top) + mouseDeltaY;
							htS.left = x + 'px';
							htS.top = y + 'px';
							hotspotDragging.mouseXPrior = dragPtCurrent.x;
							hotspotDragging.mouseYPrior = dragPtCurrent.y;
							updateHotspotPosition(event, hotspotDragging, dragPtCurrent);

						} else if (!isAltKey && Z.mousePan) {

							// Pan the image. DEV NOTE: smooth pan disabled for touch events in current implementation because touch interfaces introduce smooth interaction due to response delays.
							if (smoothPanInterval) {
								// In smooth pan mode. Pan occurs in interval handler. Get mouse position.
								smoothPanMousePt = mPt;

							} else {
								// In direct pan mode. Calculate change in mouse position.
								var deltaX = mPt.x - cD.mouseXPrior;
								var deltaY = mPt.y - cD.mouseYPrior;

								if (!isNaN(deltaX) && !isNaN(deltaY)) {
									// Calculate new position of displays container.
									var newL = parseFloat(cS.left) + deltaX;
									var newT = parseFloat(cS.top) + deltaY;

									// Constrain new position.
									var constrainedPt = constrainPan(newL, newT, Z.imageZ, Z.imageR, 'container');
									cS.left = constrainedPt.x + 'px';
									cS.top = constrainedPt.y + 'px';

									// Update stored page coordinates for next call to this function.
									cD.mouseXPrior = mPt.x;
									cD.mouseYPrior = mPt.y;

									// Implement oversize backfill if required.
									var deltaX = constrainedPt.x - displayL;
									var deltaY = constrainedPt.y - displayT;
									if (oD && tierBackfillDynamic && (Z.mobileDevice || (Math.abs(deltaX) > (viewW / 2) || Math.abs(deltaY) > (viewH / 2)))) {
										redisplayCachedTiles(oD, tierBackfillOversize, tilesBackfillCached, 'simple', false, 'Updating backfill oversize display');
									}

									// Sync navigator rectangle if visible.
									var currentCenterPt = self.calculateCurrentCenterCoordinates(constrainedPt, Z.imageZ, Z.imageR);
									if (Z.Navigator) { Z.Navigator.syncNavigatorRectangleToViewport(currentCenterPt); }

									// Update browser address bar for bookmarking.
									Z.Utils.setBookmarksURL();

									// Sync comparison and overlay viewports.
									Z.Viewer.syncComparisonViewport();
									Z.Viewer.syncOverlayViewports(null, vpID);

									// Sync counter tracking.
									if (Z.tracking) { self.syncTrackingToViewport(); }
								}
							}
						}
					}
					break;

				case 'touchend' :
					if (!gestureInterval && !wasGesturing) {

						Z.mouseIsDown = false;
						document.mousemove = null;
						document.mouseup = null;
						var dragTimeEnd = new Date().getTime();
						var dragPtEnd;

						// End event returns touches object as undefined. Use last postion from touchmove
						// or if that has not been set use position from touchstart.
						if (!Z.mouseOutDownPoint) {
							if (typeof mPt !== 'undefined' && mPt !== null) {
								dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
							} else if (typeof dragPtCurrent !== 'undefined' && dragPtCurrent !== null) {
								dragPtEnd = dragPtCurrent;
							} else {
								dragPtEnd = dragPtStart;
							}
						} else {
							dragPtEnd = Z.mouseOutDownPoint;
							clickPt = self.getClickCoordsInImage(event, zVal, Z.mouseOutDownPoint);
						}

						var dragDist = Z.Utils.calculatePointsDistance(dragPtStart.x, dragPtStart.y, dragPtEnd.x, dragPtEnd.y);
						var dragDuration = dragTimeEnd - dragTimeStart;
						if ((dragDist < TOUCHTAP_THRESHOLD_VIEWPORT && dragDuration < TOUCHTAP_THRESHOLD_TIME_VIEWPORT) || (!isAltKey && (Z.labelMode == 'rectangle' || Z.labelMode == 'freehand'))) {

								if (!hotspotDragging && ((Z.editMode === null && Z.labelMode == 'measure') || (Z.labelMode != 'view' && (Z.editing == 'addLabel' || Z.editing == 'editLabel')))) {

									// Prevent save of current hotspot/label and creation of new label if permissions are required and not provided.
									// Applies if label edit mode is of simple click to create type: text or icon.
									if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
										return;
									}

									// First save any previously edited label not saved on mousedown.
									if (Z.editing == 'addLabel' && !isAltKey && polygonComplete && (Z.labelMode == 'text' || Z.labelMode == 'icon' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
										self.saveEditsLabel(true, false, false);
									}

									if (!(isAltKey && polygonComplete) && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
										// In edit mode, handle click on or off control point with current polygon/rectangle or without. If drawing new polygon reset mouse move event handler to support bungee line drawing.
										// Freehand completion also handled here. First double condition above prevents creation of polygon with one control point by alt-clicking before ever clicking.
										// Alternative implemenation: enable next two lines and disable if/else clause below to disable double-click close option for polygons and only support alt-click and right-click.

										if (isAltKey || isRightMouseBtn) {
											polygonClickHandler(event, clickPt);
											if (!polygonComplete) { Z.Utils.addEventListener(document, 'mousemove', viewerEventsHandler); }

										} else {
											Z.Utils.addEventListener(document, 'touchmove', viewportEventsHandler);
											var isDblClick = false;
											if (!clickTimer) { // First click, delay and wait for second click.
												clickTimer = setTimeout(function(event) {
													clickTimer = null;
													polygonClickHandler(event, clickPt, isDblClick);
												}, Z.doubleClickDelay);
												if (Z.labelMode != 'polygon' && Z.labelMode != 'measure') { Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler); }
											} else { // Second click.
												isDblClick = true;
												clearTimeout(clickTimer);
												clickTimer = null;
												polygonClickHandler(event, clickPt, isDblClick);
												Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler);
											}
										}

								} else if (!isAltKey) {
									var poiID = (typeof poiList !== 'undefined' && poiList.options.length > 0) ? poiID = poiList.options[poiList.selectedIndex].value : 0;
									createdNewLabel = false;

									if (Z.labelMode == 'text') {
										// Create or modify text label.
										if (Z.editing == 'addLabel') {
											self.createLabelFromParameters(null, null, 'text', null, null, clickPt.x.toString(), clickPt.y.toString(), zValStr, null, null, null, '0', '0', null, null, null, null, null, null, captionTextColor, null, null, null, null, null, null, null, '5', '0', null, poiID);
											createdNewLabel = true;
										} else {
											if (hotspotCurrent) {
												self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
												self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
											}
										}

									} else if (Z.labelMode == 'icon') {
										// Create or modify icon label.
										var iconList = document.getElementById('labelIconList' + vpIDStr);
										if (iconList) {
											var iconTypeOrPath = iconList[iconList.selectedIndex].value;
											var media;
											switch (iconTypeOrPath) {
												case 'shim' :
													media = (Z.labelIconsInternal) ? 'circle' : annotationFolder + '/' + 'circle.png';
													break;
												case 'External Graphics File' :
													media = iconTypeOrPath;
													break;
												default :
													media = (Z.labelIconsInternal) ? iconTypeOrPath : annotationFolder + '/' + iconTypeOrPath;
											}
											if (Z.editing == 'addLabel') {
												self.createLabelFromParameters(null, null, 'icon', media, null, clickPt.x.toString(), clickPt.y.toString(), zValStr, null, null, null, '0', '0', null, null, null, null, null, null, captionTextColor, null, lineStrokeColor, null, null, null, null, null, null, '0', null, poiID);
												createdNewLabel = true;

											} else {
												if (hotspotCurrent) {
													self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
													self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
												}
											}
										}
									}

									if (createdNewLabel) {
										var newLabel = labelListDP[labelListDP.length - 1];
										populateLabels(newLabel.poiID, newLabel.value);
										createdNewLabel = false;
									}

								} else if (isAltKey && (Z.labelMode == 'text' || Z.labelMode == 'icon')) {
									if (hotspotCurrent) {
										self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
										self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
									}

								}
								setAnnotationPanelEditability('label', Z.editing);

							} else if (hotspotDragging !== null && (Z.measureVisible || Z.tour || Z.hotspots || Z.annotations)) {
								hotspotDragging = null;

							} else if ((Z.editing === null || Z.labelMode == 'view') && !hotspotDragging) {
								// Zoom and/or pan.
								if (Z.clickZoom) {
									var doubleClick = (clickTimer && Z.doubleClickZoom) ? true : false;
									var clickPtZoom = self.getClickZoomCoords3D(event, dragPtStart, tierCurrent, tierScale, doubleClick);

									if (!Z.doubleClickZoom) {
										// DEV NOTE: Timeout in line below is placeholder workaround for caption anchor failure in Firefox necessary if not implementing single-click delay below.
										var viewerDisplayMouseUpClickZoomTimer = window.setTimeout( function () { self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z); }, 1);

									} else {
										if (!clickTimer) { // First click, delay and wait for second click.
											clickTimer = setTimeout(function(event) {
												clickTimer = null;
												self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z);
											}, Z.doubleClickDelay);

										} else { // Second click.
											clearTimeout(clickTimer);
											clickTimer = null;
											self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z);
										}
									}

								} else if (Z.clickPan) {
									self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, Z.imageZ);
								}
							}

						} else {
							// Prevent addition to, or editing of, current label if permissions are required and not provided.
							// Applies if label edit mode is of click-drag-create type: freehand or rectangle.
							if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
								return;
							}

							// Drag control point.
							if ((Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && (controlPointDragging || (controlPointCurrent === null && !polygonComplete))) {
								controlPointCurrent = null;
								controlPointDragging = false;
								var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
								if (hotspotCurrentIndex != -1) {
									var hotspot = hotspots[hotspotCurrentIndex];
									var polyCenter = Z.Utils.polygonCenter(hotspot.polygonPts, hotspot.polyClosed);
									hotspot.x = polyCenter.x;
									hotspot.y = polyCenter.y;
									Z.Utils.clearDisplay(eD);
									var hC = new HotspotContext();
									displayHotspot(hotspot, hC);
									if (!polygonComplete) { Z.Utils.addEventListener(document, 'touchmove', viewportEventsHandler); }
								}

							} else if (hotspotDragging) {
								var htS = hotspotDragging.style;	
								var mouseDeltaX = dragPtEnd.x - hotspotDragging.mouseXPrior;
								var mouseDeltaY = dragPtEnd.y - hotspotDragging.mouseYPrior;
								var x = parseFloat(htS.left) + mouseDeltaX;
								var y = parseFloat(htS.top) + mouseDeltaY;
								htS.left = x + 'px';
								htS.top = y + 'px';
								updateHotspotPosition(event, hotspotDragging, dragPtEnd);
								hotspotDragging.style.zIndex = hotspotDragging.zIndex;
								hotspotDragging = null;
							}

							dragPtCurrent = null;

							// Test for need for updateView. If in smoothPanGliding this test occurs before smooth pan interval sees that mouse is up.
							if (Z.mousePan && !smoothPanInterval) { self.updateView(); }
						}

						// If mouse-dragged out of viewer display rather than mousing out, hide components.
						if (Z.mouseOutDownPoint) {
							if (Z.ToolbarDisplay && Z.toolbarAutoShowHide) { Z.Toolbar.show(false); }
							if (Z.Navigator && Z.navigatorVisible > 1) {
								Z.Navigator.setVisibility(false);
								if (Z.comparison && Z.Navigator2) { Z.Navigator2.setVisibility(false); }
							}
							if (Z.Toolbar) {
								if (Z.annotations && (Z.annotationPanelVisible == 2 || Z.annotationPanelVisible == 3)) { Z.Toolbar.setVisibilityAnnotationPanel(false); }
								if (Z.tracking && (Z.trackingPanelVisible == 2 || Z.trackingPanelVisible == 3)) { Z.Toolbar.setVisibilityTrackingPanel(false); }
								if (Z.userPanelVisible == 2 || Z.trackingPanelVisible == 3) { Z.Toolbar.setVisibilityUserPanel(false); }
							}
						}
					}

					break;

				case 'touchcancel' :
					if (!gestureInterval && !wasGesturing) {

						Z.mouseIsDown = false;
						document.mousemove = null;
						document.mouseup = null;
						var dragTimeEnd = new Date().getTime();
						var dragPtEnd;

						// End event returns touches object as undefined. Use last postion from touchmove
						// or if that has not been set use position from touchstart.
						if (!Z.mouseOutDownPoint) {
							if (typeof mPt !== 'undefined' && mPt !== null) {
								dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
							} else if (typeof dragPtCurrent !== 'undefined' && dragPtCurrent !== null) {
								dragPtEnd = dragPtCurrent;
							} else {
								dragPtEnd = dragPtStart;
							}
						} else {
							dragPtEnd = Z.mouseOutDownPoint;
							clickPt = self.getClickCoordsInImage(event, zVal, Z.mouseOutDownPoint);
						}

						var dragDist = Z.Utils.calculatePointsDistance(dragPtStart.x, dragPtStart.y, dragPtEnd.x, dragPtEnd.y);
						var dragDuration = dragTimeEnd - dragTimeStart;
						if ((dragDist < TOUCHTAP_THRESHOLD_VIEWPORT && dragDuration < TOUCHTAP_THRESHOLD_TIME_VIEWPORT) || (!isAltKey && (Z.labelMode == 'rectangle' || Z.labelMode == 'freehand'))) {

								if (!hotspotDragging && ((Z.editMode === null && Z.labelMode == 'measure') || (Z.labelMode != 'view' && (Z.editing == 'addLabel' || Z.editing == 'editLabel')))) {

									// Prevent save of current hotspot/label and creation of new label if permissions are required and not provided.
									// Applies if label edit mode is of simple click to create type: text or icon.
									if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
										return;
									}

									// First save any previously edited label not saved on mousedown.
									if (Z.editing == 'addLabel' && !isAltKey && polygonComplete && (Z.labelMode == 'text' || Z.labelMode == 'icon' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
										self.saveEditsLabel(true, false, false);
									}

									if (!(isAltKey && polygonComplete) && (Z.labelMode == 'freehand' || Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure')) {
										// In edit mode, handle click on or off control point with current polygon/rectangle or without. If drawing new polygon reset mouse move event handler to support bungee line drawing.
										// Freehand completion also handled here. First double condition above prevents creation of polygon with one control point by alt-clicking before ever clicking.
										// Alternative implemenation: enable next two lines and disable if/else clause below to disable double-click close option for polygons and only support alt-click and right-click.

										if (isAltKey || isRightMouseBtn) {
											polygonClickHandler(event, clickPt);
											if (!polygonComplete) { Z.Utils.addEventListener(document, 'mousemove', viewerEventsHandler); }

										} else {
											Z.Utils.addEventListener(document, 'touchmove', viewportEventsHandler);
											var isDblClick = false;
											if (!clickTimer) { // First click, delay and wait for second click.
												clickTimer = setTimeout(function(event) {
													clickTimer = null;
													polygonClickHandler(event, clickPt, isDblClick);
												}, Z.doubleClickDelay);
												if (Z.labelMode != 'polygon' && Z.labelMode != 'measure') { Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler); }
											} else { // Second click.
												isDblClick = true;
												clearTimeout(clickTimer);
												clickTimer = null;
												polygonClickHandler(event, clickPt, isDblClick);
												Z.Utils.removeEventListener(document, 'touchmove', viewportEventsHandler);
											}
										}

								} else if (!isAltKey) {
									var poiID = (typeof poiList !== 'undefined' && poiList.options.length > 0) ? poiID = poiList.options[poiList.selectedIndex].value : 0;
									createdNewLabel = false;

									if (Z.labelMode == 'text') {
										// Create or modify text label.
										if (Z.editing == 'addLabel') {
											self.createLabelFromParameters(null, null, 'text', null, null, clickPt.x.toString(), clickPt.y.toString(), zValStr, null, null, null, '0', '0', null, null, null, null, null, null, captionTextColor, null, null, null, null, null, null, null, '5', '0', null, poiID);
											createdNewLabel = true;
										} else {
											if (hotspotCurrent) {
												self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
												self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
											}
										}

									} else if (Z.labelMode == 'icon') {
										// Create or modify icon label.
										var iconList = document.getElementById('labelIconList' + vpIDStr);

										if (iconList) {
											var icon = iconList[iconList.selectedIndex].value;
											var media = (icon == 'shim') ? '' : (icon == 'External Graphics File') ? icon : annotationFolder + '/' + icon;
											if (Z.editing == 'addLabel') {
												self.createLabelFromParameters(null, null, 'icon', media, null, clickPt.x.toString(), clickPt.y.toString(), zValStr, null, null, null, '0', '0', null, null, null, null, null, null, captionTextColor, null, lineStrokeColor, null, null, null, null, null, null, '0', null, poiID);
												createdNewLabel = true;
											} else {
												if (hotspotCurrent) {
													self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
													self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
												}
											}
										}
									}

									if (createdNewLabel) {
										var newLabel = labelListDP[labelListDP.length - 1];
										populateLabels(newLabel.poiID, newLabel.value);
										createdNewLabel = false;
									}

								} else if (isAltKey && (Z.labelMode == 'text' || Z.labelMode == 'icon')) {
									if (hotspotCurrent) {
										self.modifyHotspot(hotspotCurrentID, 'x', clickPt.x, true, true);
										self.modifyHotspot(hotspotCurrentID, 'y', clickPt.y, false, true);
									}

								}
								setAnnotationPanelEditability('label', Z.editing);

							} else if (hotspotDragging !== null && (Z.measureVisible || Z.tour || Z.hotspots || Z.annotations)) {
								hotspotDragging = null;

							} else if ((Z.editing === null || Z.labelMode == 'view') && !hotspotDragging) {
								// Zoom and/or pan.
								if (Z.clickZoom) {
									var doubleClick = (clickTimer && Z.doubleClickZoom) ? true : false;
									var clickPtZoom = self.getClickZoomCoords3D(event, dragPtStart, tierCurrent, tierScale, doubleClick);

									if (!Z.doubleClickZoom) {
										// DEV NOTE: Timeout in line below is placeholder workaround for caption anchor failure in Firefox necessary if not implementing single-click delay below.
										var viewerDisplayMouseUpClickZoomTimer = window.setTimeout( function () { self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z); }, 1);

									} else {
										if (!clickTimer) { // First click, delay and wait for second click.
											clickTimer = setTimeout(function(event) {
												clickTimer = null;
												self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z);
											}, Z.doubleClickDelay);

										} else { // Second click.
											clearTimeout(clickTimer);
											clickTimer = null;
											self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, clickPtZoom.z);
										}
									}

								} else if (Z.clickPan) {
									self.zoomAndPanToView(clickPtZoom.x, clickPtZoom.y, Z.imageZ);
								}
							}

						} else {
							// Prevent addition to, or editing of, current label if permissions are required and not provided.
							// Applies if label edit mode is of click-drag-create type: freehand or rectangle.
							if (typeof Z.externalEditPermissionFunction === 'function' && !Z.externalEditPermissionFunction()) {
								return;
							}

							// Drag control point.
							if ((Z.labelMode == 'rectangle' || Z.labelMode == 'polygon' || Z.labelMode == 'measure') && (controlPointDragging || (controlPointCurrent === null && !polygonComplete))) {
								controlPointCurrent = null;
								controlPointDragging = false;
								var hotspotCurrentIndex = Z.Utils.arrayIndexOfObjectValue(hotspots, 'internalID', hotspotCurrentID);
								if (hotspotCurrentIndex != -1) {
									var hotspot = hotspots[hotspotCurrentIndex];
									var polyCenter = Z.Utils.polygonCenter(hotspot.polygonPts, hotspot.polyClosed);
									hotspot.x = polyCenter.x;
									hotspot.y = polyCenter.y;
									Z.Utils.clearDisplay(eD);
									var hC = new HotspotContext();
									displayHotspot(hotspot, hC);
									if (!polygonComplete) { Z.Utils.addEventListener(document, 'touchmove', viewportEventsHandler); }
								}

							} else if (hotspotDragging) {
								var htS = hotspotDragging.style;	
								var mouseDeltaX = dragPtEnd.x - hotspotDragging.mouseXPrior;
								var mouseDeltaY = dragPtEnd.y - hotspotDragging.mouseYPrior;
								var x = parseFloat(htS.left) + mouseDeltaX;
								var y = parseFloat(htS.top) + mouseDeltaY;
								htS.left = x + 'px';
								htS.top = y + 'px';
								updateHotspotPosition(event, hotspotDragging, dragPtEnd);
								hotspotDragging.style.zIndex = hotspotDragging.zIndex;
								hotspotDragging = null;
							}

							dragPtCurrent = null;

							// Test for need for updateView. If in smoothPanGliding this test occurs before smooth pan interval sees that mouse is up.
							if (Z.mousePan && !smoothPanInterval) { self.updateView(); }
						}

						// If mouse-dragged out of viewer display rather than mousing out, hide components.
						if (Z.mouseOutDownPoint) {
							if (Z.ToolbarDisplay && Z.toolbarAutoShowHide) { Z.Toolbar.show(false); }
							if (Z.Navigator && Z.navigatorVisible > 1) {
								Z.Navigator.setVisibility(false);
								if (Z.comparison && Z.Navigator2) { Z.Navigator2.setVisibility(false); }
							}
							if (Z.Toolbar) {
								if (Z.annotations && (Z.annotationPanelVisible == 2 || Z.annotationPanelVisible == 3)) { Z.Toolbar.setVisibilityAnnotationPanel(false); }
								if (Z.tracking && (Z.trackingPanelVisible == 2 || Z.trackingPanelVisible == 3)) { Z.Toolbar.setVisibilityTrackingPanel(false); }
								if (Z.userPanelVisible == 2 || Z.trackingPanelVisible == 3) { Z.Toolbar.setVisibilityUserPanel(false); }
							}
						}
					}

					break;

				case 'gesturestart' :
					viewerDisplayGestureChangeHandler(event); // Run once so values are defined at first movement.
					if (!gestureInterval) { gestureInterval = window.setInterval(zoomGesture, GESTURE_TEST_DURATION); }
					break;

				case 'gesturechange' :
					gestureIntervalPercent = Math.round(event.scale * 100) / 100;
					break;

				case 'gestureend' :
					if (gestureInterval) {
						window.clearInterval(gestureInterval);
						wasGesturing = true;
						gestureInterval = null;
					}
					if (Z.mousePan) { self.updateView(); }
					break;
			}
		}
	}

	function smoothPanStart (newPan) {
	 	if (Z.smoothPanEasing > 1) {
	 		// Stop smooth pan interval already in progress, if any.
			smoothPanStop(newPan);

			// Get starting cursor and display positions.
			smoothPanStartPt = dragPtStart;
			if (smoothPanDisplayStartPt === null) { smoothPanDisplayStartPt = new Z.Utils.Point(parseFloat(cS.left), parseFloat(cS.top)); }

			// Start smooth pan interval.
			if (smoothPanInterval === null || newPan) { smoothPanInterval = window.setInterval(smoothPanIntervalHandler, 50); }
		}
	}

	function smoothPanStop (clearPan) {
		if (smoothPanInterval !== null && clearPan) {
			window.clearInterval(smoothPanInterval);
			smoothPanInterval = null;
		}
		smoothPanGliding = null;
		smoothPanDisplayStartPt = smoothPanGlideX = smoothPanGlideY = null;
		smoothPanDeltaX = smoothPanDeltaY = smoothPanLastDeltaX = smoothPanLastDeltaY = 0;
	}

	// Implement drag-pan or drag-glide if no image set of animation type or if zoomed in. Otherwies animate by changing Viewport.
	function smoothPanIntervalHandler () {
		if (!Z.animation || self.getZoom() != Z.minZ) {
			smoothPanStep();
		} else {
			smoothAnimateStep();
		}
	}

	function smoothPanStep () {
		// Get current display position.
		var displayCurrL = parseFloat(cS.left);
		var displayCurrT = parseFloat(cS.top);

		if (Z.mouseIsDown || smoothPanGliding) {

			// Calculate offsets of mouse and display. Use float endpoint for target if set because mouse is up.
			var targetX = (smoothPanGliding) ? smoothPanGlideX : smoothPanMousePt.x;
			var targetY = (smoothPanGliding) ? smoothPanGlideY : smoothPanMousePt.y;
			var deltaMouseX = targetX - smoothPanStartPt.x;
			var deltaMouseY = targetY - smoothPanStartPt.y;

			// Calculate offsets of display.
			var deltaDisplayX = displayCurrL - smoothPanDisplayStartPt.x;
			var deltaDisplayY = displayCurrT - smoothPanDisplayStartPt.y;

			// Pan the display if mouse offsets do not equal display offsets.
			var smoothPanRequired = ((!isNaN(deltaMouseX) && !isNaN(deltaMouseY) && !isNaN(deltaDisplayX) && !isNaN(deltaDisplayY)) && (deltaMouseX != 0 || deltaMouseY != 0 || deltaDisplayX != 0 || deltaDisplayY != 0));
			if (smoothPanRequired) {

				// Calculate new position of displays container.
				var easingMore = (smoothPanGliding) ? Z.smoothPanGlide : 1;
				var easingEndLess = (smoothPanGliding) ? 1 : 100;
				smoothPanDeltaX = Math.round((((deltaMouseX - deltaDisplayX) / (Z.smoothPanEasing * easingMore)) * easingEndLess) / easingEndLess);
				smoothPanDeltaY = Math.round((((deltaMouseY - deltaDisplayY) / (Z.smoothPanEasing * easingMore)) * easingEndLess) / easingEndLess);

				// If dragging track deltas, if gliding use last tracked deltas to constrain glide deltas.
				if (Z.mouseIsDown) {
					smoothPanLastDeltaX = smoothPanDeltaX;
					smoothPanLastDeltaY = smoothPanDeltaY;
				} else {
					if (Math.abs(smoothPanDeltaX) > Math.abs(smoothPanLastDeltaX)) { smoothPanDeltaX = smoothPanLastDeltaX; }
					if (Math.abs(smoothPanDeltaY) > Math.abs(smoothPanLastDeltaY)) { smoothPanDeltaY = smoothPanLastDeltaY; }
				}

				// Constrain and implement new position and if effect constrained, also apply constraint to delta values.
				var newL = displayCurrL + smoothPanDeltaX;
				var newT = displayCurrT + smoothPanDeltaY;
				var constrainedPt = constrainPan(newL, newT, Z.imageZ, Z.imageR, 'container');
				cS.left = constrainedPt.x + 'px';
				cS.top = constrainedPt.y + 'px';
				smoothPanDeltaX -= (newL - constrainedPt.x);
				smoothPanDeltaY -= (newT - constrainedPt.y);

				// Implement oversize backfill if required.
				var deltaX = constrainedPt.x - displayL;
				var deltaY = constrainedPt.y - displayT;
				if (oD && tierBackfillDynamic) {
					redisplayCachedTiles(oD, tierBackfillOversize, tilesBackfillCached, 'simple', false, 'Updating backfill oversize display');
				}

				// Set gliding variable false if delta variable reaches zero to finish glide and updateView. Complemented by test in viewportEventsManager in mouseup event.
				if (smoothPanGliding && Math.round(smoothPanDeltaX * easingEndLess) / easingEndLess == 0 && Math.round(smoothPanDeltaY * easingEndLess) / easingEndLess == 0) {
					smoothPanGliding = false;
				}

				// Sync navigator rectangle if visible.
				var currentCenterPt = self.calculateCurrentCenterCoordinates(constrainedPt, Z.imageZ, Z.imageR);
				if (!Z.comparison || viewportID == 0) {
					if (Z.Navigator) { Z.Navigator.syncNavigatorRectangleToViewport(currentCenterPt); }
				} else {
					if (Z.Navigator2) { Z.Navigator2.syncNavigatorRectangleToViewport(currentCenterPt); }
				}

				// Update browser address bar for bookmarking.
				Z.Utils.setBookmarksURL();

				// Sync comparison and overlay viewports.
				Z.Viewer.syncComparisonViewport();
				Z.Viewer.syncOverlayViewports(null, vpID);

				// Sync counter tracking.
				if (Z.tracking) { self.syncTrackingToViewport(); }
			}

		} else if (!Z.mouseIsDown && smoothPanGliding === null && smoothPanDeltaX != 0 && smoothPanDeltaY != 0) {
			// Calculate and record extended pan endpoint to enable drag-glide.
			var testL = displayCurrL + smoothPanLastDeltaX;
			var testT = displayCurrT + smoothPanLastDeltaY;
			var constrainedPt = constrainPan(testL, testT, Z.imageZ, Z.imageR, 'container');
			smoothPanLastDeltaX = constrainedPt.x - displayCurrL;
			smoothPanLastDeltaY = constrainedPt.y - displayCurrT;
			if (smoothPanLastDeltaX != 0 || smoothPanLastDeltaY != 0) {
				smoothPanGlideX = smoothPanMousePt.x + smoothPanLastDeltaX;
				smoothPanGlideY = smoothPanMousePt.y + smoothPanLastDeltaY;
				smoothPanGliding = true;
			}

		} else {
			// Stop smooth pan by clearing interval.
			smoothPanStop(true);
			self.updateView();
		}
	}

	// For simplicity and to support future optimization, the following animation step function is based on the above pan step function.
	// Frame rate based on drag motion or drag position depending on value in animation XML.  Setting 'motion' recommended for spinning
	// objects, and 'position' recommended for pivoting panoramas. Horizontal and vertical dragging supported by value in animation XML.
	// To increase animation rate, interval speed is prioritized over frame count (speed over smoothness) by skipping frames rather than
	// changes in frames. However, skipping frame changes (intervals) is prioritized over skipping frames where changes in frame content
	// are significant such as with pivoting panoramas ('position' setting used) or when image sets are small in total number of images.
	function smoothAnimateStep (event) {
		Z.animationCount++;

		// Prepare lagging position variable.
		if (smoothAnimationX === null) { smoothAnimationX = parseFloat(cS.left); }
		if (smoothAnimationY === null) { smoothAnimationY = parseFloat(cS.top); }
		var displayCurrL = smoothAnimationX;
		var displayCurrT = smoothAnimationY;

		if (Z.mouseIsDown || smoothPanGliding) {
			// Calculate offsets of mouse and display. Use float endpoint for target if set because mouse is up.
			var targetX = (smoothPanGliding) ? smoothPanGlideX : smoothPanMousePt.x;
			var targetY = (smoothPanGliding) ? smoothPanGlideY : smoothPanMousePt.y;
			var deltaMouseX = targetX - smoothPanStartPt.x;
			var deltaMouseY = targetY - smoothPanStartPt.y;

			// Calculate offsets of display.
			var deltaDisplayX = displayCurrL - smoothPanDisplayStartPt.x;
			var deltaDisplayY = displayCurrT - smoothPanDisplayStartPt.y;

			// Pan the display if mouse offsets do not equal display offsets.
			var smoothPanRequired = ((!isNaN(deltaMouseX) && !isNaN(deltaMouseY) && !isNaN(deltaDisplayX) && !isNaN(deltaDisplayY)) && (deltaMouseX != 0 || deltaMouseY != 0 || deltaDisplayX != 0 || deltaDisplayY != 0));
			if (smoothPanRequired) {

				// Calculate new position of displays container.
				var easingMore = (smoothPanGliding) ? Z.smoothPanGlide : 1;
				var easingEndLess = (smoothPanGliding) ? 1 : 100;
				smoothPanDeltaX = Math.round((((deltaMouseX - deltaDisplayX) / (Z.smoothPanEasing * easingMore)) * easingEndLess) / easingEndLess);
				smoothPanDeltaY = Math.round((((deltaMouseY - deltaDisplayY) / (Z.smoothPanEasing * easingMore)) * easingEndLess) / easingEndLess);

				// If dragging track deltas, if gliding use last tracked deltas to constrain glide deltas.
				if (Z.mouseIsDown) {
					smoothPanLastDeltaX = smoothPanDeltaX;
					smoothPanLastDeltaY = smoothPanDeltaY;
				} else {
					if (Math.abs(smoothPanDeltaX) > Math.abs(smoothPanLastDeltaX)) { smoothPanDeltaX = smoothPanLastDeltaX; }
					if (Math.abs(smoothPanDeltaY) > Math.abs(smoothPanLastDeltaY)) { smoothPanDeltaY = smoothPanLastDeltaY; }
				}

				// Constrain and implement new position and if effect constrained, also apply constraint to delta values.
				var newL = displayCurrL + smoothPanDeltaX;
				var newT = displayCurrT + smoothPanDeltaY;
				smoothAnimationX = newL;
				smoothAnimationY = newT;

				// Adjust animation speed by skipping frame changes (intervals) or by skipping frames.
				var deltaAnimationAxis, skipCalls, skipFrames, animationGap;
				if (Z.animator == 'motion') {
					deltaAnimationAxis = (Z.animationAxis == 'horizontal') ? smoothPanDeltaX : smoothPanDeltaY;
					dimensionAxis = (Z.animationAxis == 'horizontal') ? viewW : viewH;
					skipCalls = Math.round(optimalMotionImages / Z.imageSetLength);
					skipFrames = (deltaAnimationAxis / 40);
					animationGap = 0;
				} else if (Z.animator == 'position') {
					deltaAnimationAxis = (Z.animationAxis == 'horizontal') ? deltaDisplayX : deltaDisplayY;
					dimensionAxis = (Z.animationAxis == 'horizontal') ? viewW : viewH;
					skipCalls = Math.max(0, Math.round(((dimensionAxis / 2) - Math.abs(deltaAnimationAxis)) / optimalPositionDelta));
					skipFrames = 0;
					animationGap = (Z.animationAxis == 'horizontal') ? viewW / 10 : viewH /10;
				}
				if (skipCalls == 0) { skipCalls++; } // Variable represents number of calls to skip but is used as divisor so base value must be 1.

				// Implement frame change.
				if (Z.animationCount % skipCalls == 0) {
					if (deltaAnimationAxis < -animationGap) {
						Z.Viewer.viewportPrior(skipFrames);
					} else if (deltaAnimationAxis > animationGap) {
						Z.Viewer.viewportNext(skipFrames);
					}
				}

				// Set gliding variable false if delta variable reaches zero to finish glide. Complemented by test in viewportEventsManager in mouseup event.
				if (smoothPanGliding && Math.round(smoothPanDeltaX * easingEndLess) / easingEndLess == 0 && Math.round(smoothPanDeltaY * easingEndLess) / easingEndLess == 0) {
					smoothPanGliding = false;
				}
			}

		} else if (!Z.mouseIsDown && smoothPanGliding === null && smoothPanDeltaX != 0 && smoothPanDeltaY != 0) {
			// Calculate and record extended pan endpoint to enable drag-glide.
			if (smoothPanLastDeltaX != 0 || smoothPanLastDeltaY != 0) {
				smoothPanGlideX = smoothPanMousePt.x + smoothPanLastDeltaX;
				smoothPanGlideY = smoothPanMousePt.y + smoothPanLastDeltaY;
				smoothPanGliding = true;
			}

		} else {
			// Stop smooth animation by clearing interval.
			smoothPanStop(true);
			smoothAnimationX = null;
			smoothAnimationY = null;
		}
	}

	this.getSmoothPanGliding = function () {
		return smoothPanGliding;
	}

	this.setSmoothPanGliding = function (gliding) {
		smoothPanGliding = gliding;
	}

	function viewerDisplayGestureChangeHandler (event) {
		var event = Z.Utils.event(event);
		event.preventDefault();
		gestureIntervalPercent = Math.round(event.scale * 100) / 100;
	}

	function zoomGesture (event) {
		var sync = false;
		if (!Z.mousePan) { return; }  // Disallow touch panning if parameter false.
		var gestureZoom = calculateGestureZoom(tierCurrent, tierScalePrior, gestureIntervalPercent);
		var gestureZoomConstrained = constrainZoom(gestureZoom);
		if (gestureZoom != Z.imageZ) { sync = self.scaleTierToZoom(gestureZoomConstrained); }
	}

	function calculateGestureZoom (tier, scale, gesturePercent) {
		var newScale = scale * gesturePercent;
		var gestureZ = convertTierScaleToZoom(tier, newScale);
		return gestureZ;
	}

	// This is executed on change into and also out of full screen mode, and is needed because
	// browsers assign their own change event listener that will fire on entry as well as exit.
	this.fullScreenEscapeHandler = function (event) {
		if (Z.fullScreenEntering) {
			Z.fullScreenEntering = false;
		} else {
			self.toggleFullViewMode(false, true);
		}
	}

	this.mouseWheelHandler = function (delta, isAltKey) {
		Z.mouseWheelIsDown = true;
		if (Z.mouseWheelCompleteTimer) { window.clearTimeout(Z.mouseWheelCompleteTimer); }
		Z.mouseWheelCompleteTimer = window.setTimeout(Z.Viewer.mouseWheelCompleteHandler, Z.mouseWheelCompleteDuration);

		if (Z.sliderFocus == 'zoom' && !(Z.imageSet && isAltKey)) {
			// Calculate current step, then target zoom based on step and target scale for current step.
			// Constrain target zoom and scale viewport display to implement.
			var stepZ = (delta > 0) ? zoomStepDistance : -zoomStepDistance;
			var targetScale = tierScale *  (1 + stepZ);
			var targetZoom = self.convertTierScaleToZoom(tierCurrent, targetScale);
			constrainedZ = constrainZoom(targetZoom);
			if (constrainedZ != Z.imageZ) {
				Z.zooming = (delta > 0) ? 'in' : (delta < 0) ? 'out' : 'stop';
				var sync = self.scaleTierToZoom(constrainedZ);
			}
			// Debug option: console.log('targetScale: ' + targetScale);

		} else if (Z.sliderFocus == 'imageSet' || isAltKey) {
			// Simple increment or decrement with degree of view updating handled in function updateView.
			if (delta > 0) {
				Z.Viewer.viewportNext();
			} else if (delta < 0) {
				Z.Viewer.viewportPrior();
			}
		}
	}

	function displayEventsCoordinatesHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var coordsString;
			if (Z.geoCoordinatesVisible) {
				coordsString = '';
				if (geoTop && geoBottom && geoLeft && geoRight) {
					var coordsPixelPt = self.getClickCoordsInImage(event);
					coordsString = convertPixelsToLatitudeLongitudeString(coordsPixelPt);
				}
			} else if (Z.tileSource == 'IIIFImageServer') {
				var coordsPixelPt = self.getClickCoordsInImage(event);
				if (event.type == 'mousemove') {
					coordsString = self.getViewCoordinatesIIIFString(null, coordsPixelPt, 'show');
				} else if (event.type == 'mousedown' && event.altKey) {
					coordsString = self.getViewCoordinatesIIIFString(null, coordsPixelPt, 'save') + '\n';
				}
			} else {
				coordsString = getClickZoomCoords3DAsString(event);
			}

			if (event.type == 'mousemove') {
				Z.Utils.showCoordinates(coordsString);
			} else if (event.type == 'mousedown' && event.altKey) {
				Z.Utils.saveCoordinates(coordsString);
			}
		}
	}
};



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::: TOOLBAR FUNCTIONS ::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.ZoomifyToolbar = function (tbViewport) {

	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: INIT FUNCTIONS :::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Declare variables for toolbar internal self-reference and for initialization completion.
	var self = this;
	var isInitialized = false;
	var tbViewportIDStr = tbViewport.getViewportID().toString();

	if (!Z.toolbarInternal) {

		// Load toolbar skins XML file and determine selection mode setting for optional support of
		// small screen devices with large graphic files. Build names list for needed skin files.
		Z.skinPath = Z.Utils.stringRemoveTrailingSlashCharacters(Z.skinPath);
		var netConnector = new Z.NetConnector();
		netConnector.loadXML(Z.skinPath + '/' + Z.Utils.getResource('DEFAULT_SKINXMLFILE'));

		// Declare variables for Toolbar and slider.
		var tlbrH, tbS, trS, btS;
		var toolbarSkinArray = [], toolbarDimensions = [], toolbarSkinFilePaths = [], toolbarSkinSizes = [];
		var SLIDERTESTDURATION_ZOOM = parseInt(Z.Utils.getResource('DEFAULT_SLIDERTESTDURATIONZOOM'), 10);
		var buttonSliderZoomDown = false;
		var sliderIntervalZoom = null, sliderIntervalMousePtZoom = null;
		var progressInterval = null, progressTextColor = null;
		var overrideSliderZoom, overrideProgress, overrideLogo, overridePan, overrideReset;

		// Declare variables for imageSet slider.
		if (Z.imageSet) {
			var SLIDERTESTDURATION_IMAGESET = parseInt(Z.Utils.getResource('DEFAULT_SLIDERTESTDURATIONIMAGESET'), 10);
			var buttonSliderImageSetDown = false;
			var sliderIntervalImageSet = null, sliderIntervalMousePtImageSet = null;
			var overrideSliderImageSet;
		}

		// Declare variables for image filter panel.
		if (Z.imageFilters) {
			var SLIDERTESTDURATION_FILTER = parseInt(Z.Utils.getResource('DEFAULT_SLIDERTESTDURATIONFILTER'), 10);
			var buttonSliderFilterDown = false;
			var sliderIntervalFilter = null, sliderIntervalMousePtFilter = null;
			var imageFilterPanelW;
			var imageFilterListDP = [];
			var imageFilterPanelVisible = Z.initialImageFilters;
			var imageFilterInProgress = false, imageFilterCurrent = null, imageFilterPrior = null, imageFilterChanged = true;
			var lfbtbS, trsFB, trsfbS, btfB, btfbS; // Brightness.
			var lfctbS, trsFC, trsfcS, btfC, btfcS; // Contrast.
			var lfstbS, trsFS, trsfsS, btfS, btfsS; // Sharpness.
			var lfblbS, trsFBL, trsfblS, btfBL, btfblS; // Blurriness.
			var lfcrbS, trsFCR, trsfcrS, btfCR, btfcrS; // Color Red.
			var lfcgbS, trsFCG, trsfcgS, btfCG, btfcgS; // Color Green.
			var lfcbbS, trsFCB, trsfcbS, btfCB, btfcbS; // Color Blue.
			var lfcrrbS, trsFCRR, trsfcrrS, btfCRR, btfcrrS; // Color Red Range.
			var lfcgrbS, trsFCGR, trsfcgrS, btfCGR, btfcgrS; // Color Green Range.
			var lfcbrbS, trsFCBR, trsfcbrS, btfCBR, btfcbrS; // Color Blue Range.
			var lfgbS, trsFG, trsfgS, btfG, btfgS; // Gamma.
			var lfgrbS, trsFGR, trsfgrS, btfGR, btfgrS; // Gamma Red.
			var lfggbS, trsFGG, trsfggS, btfGG, btfggS; // Gamma Green.
			var lfgbbS, trsFGB, trsfgbS, btfGB, btfgbS; // Gamma Blue.
			var lfhbS, trsFH, trsfhS, btfH, btfhS; // Hue.
			var lfsabS, trsFSA, trsfsaS, btfSA, btfsaS; // Saturation.
			var lflbS, trsFL, trsflS, btfL, btflS; // Lightness.
			var lfwbbS, trsFWB, trsfwbS, btfWB, btfwbS; // White Balance.
			var lfnbS, trsFN, trsfnS, btfN, btfnS; // Noise.
			// Viewport globals not needed for boolean filters because they do not use sliders:
			// Grayscale, Threshold, Inversion, Equalize, Edges, Sepia.

			var filterTrack, filterTrackS, filterButton, filterButtonS, filterButtonOther, filterButtonOtherS;
			var sliderPositionPrior = 0;
		}

	} else {
		var buttonZoomInInternalS, buttonResetInternalS, buttonZoomOutInternalS;
		var colorButtonInternalOver = Z.Utils.getResource('UI_TOOLBARINTERNALBUTTONOVERCOLOR');
		var colorButtonInternalDown = Z.Utils.getResource('UI_TOOLBARINTERNALBUTTONDOWNCOLOR');
		var colorButtonInternalUp = Z.Utils.getResource('UI_TOOLBARINTERNALBUTTONUPCOLOR');
		initializeToolbarSimple();
	}

	function initializeToolbarSimple () {
		var backAlpha = parseFloat(Z.Utils.getResource('UI_TOOLBARINTERNALBACKGROUNDALPHA'));
		var backColor = Z.Utils.getResource('UI_TOOLBARINTERNALBACKGROUNDCOLOR');
		var buttonColor = Z.Utils.getResource('UI_TOOLBARINTERNALBUTTONUPCOLOR');
		var width = 100;
		var height = 25;
		var left = (Z.viewerW / 2 - width / 2);
		var top = (Z.viewerH - height - 10);
		var btnW = Math.round(width / 4);
		var btnH = Math.round(height / 1.5);
		var gapL = (width - (btnW * 3)) / 4;
		var gapT = (height - btnH) / 2;

		Z.ToolbarDisplay = Z.Utils.createContainerElement('div', 'ToolbarDisplay', 'inline-block', 'absolute', 'visible', width + 'px', height + 'px', left + 'px', top + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
		tbS = Z.ToolbarDisplay.style;

		var toolbarBackgroundInternal = Z.Utils.createContainerElement('div', 'toolbarBackgroundInternal', 'inline-block', 'absolute', 'visible', width + 'px', height + 'px', '0px', '0px', 'solid', '1px', backColor, '0px', '0px', 'normal');
		Z.Utils.setOpacity(toolbarBackgroundInternal, backAlpha, backColor);
		Z.ToolbarDisplay.appendChild(toolbarBackgroundInternal);

		var buttonZoomOutInternal = Z.Utils.createContainerElement('div', 'buttonZoomOutInternal', 'inline-block', 'absolute', 'visible', btnW + 'px', btnH + 'px', (gapL + 1) + 'px', gapT + 1 +'px', 'none', '0px', buttonColor, '0px', '0px', 'normal');
		Z.Utils.setOpacity(buttonZoomOutInternal, 0.4, backColor);
		var btnTxtZO = Z.Utils.getResource('UI_TOOLBARINTERNALBUTTONZOOMOUTTEXT');
		var textNodeZO = document.createTextNode(btnTxtZO);
		buttonZoomOutInternal.appendChild(textNodeZO);
		Z.ToolbarDisplay.appendChild(buttonZoomOutInternal);
		buttonZoomOutInternalS = buttonZoomOutInternal.style;
		Z.Utils.setTextNodeStyle(textNodeZO, 'black', 'verdana', '15px', 'none', 'normal', 'normal', 'normal', 'bold', '1em', 'center', 'none');
		Z.Utils.disableTextInteraction(textNodeZO);

		var buttonResetInternal = Z.Utils.createContainerElement('div', 'buttonResetInternal', 'inline-block', 'absolute', 'visible', btnW + 'px', btnH + 'px', (gapL * 2 + btnW) + 1 + 'px', gapT + 1 + 'px', 'none', '0px', buttonColor, '0px', '0px', 'normal');
		Z.Utils.setOpacity(buttonResetInternal, 0.4, backColor);
		var btnTxtR = Z.Utils.getResource('UI_TOOLBARINTERNALBUTTONRESETTEXT');
		var textNodeR = document.createTextNode(btnTxtR);
		buttonResetInternal.appendChild(textNodeR);
		Z.ToolbarDisplay.appendChild(buttonResetInternal);
		buttonResetInternalS = buttonResetInternal.style;
		Z.Utils.setTextNodeStyle(textNodeR, 'blue', 'verdana', '15px', 'none', 'normal', 'normal', 'normal', 'bold', '1em', 'center', 'none');
		Z.Utils.disableTextInteraction(textNodeR);

		var buttonZoomInInternal = Z.Utils.createContainerElement('div', 'buttonZoomInInternal', 'inline-block', 'absolute', 'visible', btnW + 'px', btnH + 'px', (gapL * 3 + btnW * 2) + 1 + 'px', gapT + 1 + 'px', 'none', '0px', buttonColor, '0px', '0px', 'normal');
		Z.Utils.setOpacity(buttonZoomInInternal, 0.4, backColor);
		var btnTxt = Z.Utils.getResource('UI_TOOLBARINTERNALBUTTONZOOMINTEXT');
		var textNode = document.createTextNode(btnTxt);
		buttonZoomInInternal.appendChild(textNode);
		Z.ToolbarDisplay.appendChild(buttonZoomInInternal);
		buttonZoomInInternalS = buttonZoomInInternal.style;
		Z.Utils.setTextNodeStyle(textNode, 'black', 'verdana', '15px', 'none', 'normal', 'normal', 'normal', 'bold', '1em', 'center', 'none');
		Z.Utils.disableTextInteraction(textNode);

		Z.Utils.addEventListener(buttonZoomOutInternal, 'mouseover', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonZoomOutInternal, 'mousedown', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonZoomOutInternal, 'mouseup', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonZoomOutInternal, 'mouseout', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonResetInternal, 'mouseover', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonResetInternal, 'mousedown', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonResetInternal, 'mouseup', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonResetInternal, 'mouseout', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonZoomInInternal, 'mouseover', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonZoomInInternal, 'mousedown', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonZoomInInternal, 'mouseup', buttonEventsHandlerInternal);
		Z.Utils.addEventListener(buttonZoomInInternal, 'mouseout', buttonEventsHandlerInternal);
		
		// Ensure proper z-ordering of Viewer elements.
		tbS.zIndex = (Z.baseZIndex + 2).toString();

		// Add toolbar to viewer display.
		Z.ViewerDisplay.appendChild(Z.ToolbarDisplay);

		// Prevent event bubbling.
		Z.Utils.addEventListener(Z.ToolbarDisplay, 'mouseover', Z.Utils.stopPropagation);

		setInitialized(true);
	}

	function initializeToolbar (tlbrSknDims, tlbrSknArr) {
		toolbarSkinArray = tlbrSknArr;
		// Create Toolbar display area for Toolbar buttons and set size and position.
		Z.ToolbarDisplay = Z.Utils.createContainerElement('div', 'ToolbarDisplay', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '1px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
		tbS = Z.ToolbarDisplay.style;
		tbS.textAlign = 'left'; // Dev Note: this workaround prevents containing aligns from affecting positioning of Toolbar button graphics.

		// Ensure proper z-ordering of Viewer elements.
		tbS.zIndex = (Z.baseZIndex + 2).toString();

		var toolbarBackground = new Z.Utils.Graphic('toolbarBackground', Z.skinPath, tlbrSknArr[0], '1px', '1px', '0px', '0px');
		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');
		Z.ToolbarDisplay.appendChild(toolbarBackground.elmt);

		// DEV NOTE: Optional transparent toolbar background. No parameter in current release, requires skin file review.
		//Z.Utils.setOpacity(toolbarBackground.elmt, backAlpha, backColorNoAlpha);

		// Create toolbar global array to hold skin sizes from XML but use placeholders here
		// and apply actual sizes in drawLayout function called in setSizeAndPosition function.
		toolbarSkinSizes = tlbrSknDims;

		if (Z.logoVisible) {
			var toolbarLogo;
			if (!(Z.Utils.stringValidate(Z.logoCustomPath))) {
				toolbarLogo = new Z.Utils.Graphic('toolbarLogo', Z.skinPath, tlbrSknArr[7], '1px', '1px', '1px', '1px');
			} else {
				var logoPath = Z.Utils.cacheProofPath(Z.logoCustomPath);
				toolbarLogo = new Z.Utils.Graphic('toolbarLogo', logoPath, null, '1px', '1px', '1px', '1px');
			}

			if (!Z.Utils.stringValidate(Z.logoLinkURL)) {
				toolbarLogo.elmt.setAttribute('title', Z.Utils.getResource('UI_LOGOLINKDISPLAY'));
				Z.ToolbarDisplay.appendChild(toolbarLogo.elmt);
			} else {
				var zlogoAnchor = document.createElement('a');
				zlogoAnchor.setAttribute('href', Z.logoLinkURL);
				zlogoAnchor.setAttribute('target', Z.Utils.getResource('UI_LOGOLINKTARGET'));
				zlogoAnchor.setAttribute('title', Z.Utils.getResource('TIP_LOGO'));
				zlogoAnchor.setAttribute('outline', 'none');
				zlogoAnchor.appendChild(toolbarLogo.elmt);
				Z.ToolbarDisplay.appendChild(zlogoAnchor);
			}

			if (Z.toolbarVisible == 0 || Z.toolbarVisible == 1) {
				var logoDivider = new Z.Utils.Graphic('logoDivider', Z.skinPath, tlbrSknArr[8], '1px', '1px', '1px', '1px');
				Z.ToolbarDisplay.appendChild(logoDivider.elmt);
			}
		}

		// Add button container to handle background mouseover events instead of button mouseout events.
		var buttonContainer = Z.Utils.createContainerElement('div', 'buttonContainer', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', 'default');
		Z.ToolbarDisplay.appendChild(buttonContainer);
		Z.Utils.addEventListener(buttonContainer, 'mousedown', Z.Utils.preventDefault);
		Z.Utils.addEventListener(buttonContainer, 'mouseover', self.backgroundEventsHandler);
		Z.Utils.addEventListener(buttonContainer, 'touchstart', Z.Utils.preventDefault);

		// Add background graphic to button container to ensure IE events fire.
		var buttonBackground = new Z.Utils.Graphic('buttonBackground', Z.skinPath, tlbrSknArr[0], '1px', '1px', '0px', '0px');
		buttonContainer.appendChild(buttonBackground.elmt);

		// DEV NOTE: Zero opacity avoids interfering with option to set opacity of of toolbarBackground above.
		Z.Utils.setOpacity(buttonBackground.elmt, '0', '#FBFAFA');

		if (((Z.toolbarVisible != 0 && Z.toolbarVisible != 1) || Z.mobileDevice) && Z.minimizeVisible) {
			var buttonMinimize = new Z.Utils.Button('buttonMinimize', null, Z.skinPath, tlbrSknArr[9], tlbrSknArr[10], tlbrSknArr[11], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_MINIMIZE');
			Z.ToolbarDisplay.appendChild(buttonMinimize.elmt);
			var buttonExpand = new Z.Utils.Button('buttonExpand', null, Z.skinPath, tlbrSknArr[12], tlbrSknArr[13], tlbrSknArr[14], '1px', '1px', '1px', '1px',  'mouseover', buttonEventsHandler, 'TIP_EXPAND');
			Z.ToolbarDisplay.appendChild(buttonExpand.elmt);
		}

		if (Z.zoomButtonsVisible) {
			var buttonZoomOut = new Z.Utils.Button('buttonZoomOut', null, Z.skinPath, tlbrSknArr[1], tlbrSknArr[2], tlbrSknArr[3], '1px', '1px', '1px', '1px',  'mouseover', buttonEventsHandler, 'TIP_ZOOMOUT');
			buttonContainer.appendChild(buttonZoomOut.elmt);
		}

		if (Z.sliderZoomVisible) {
			var trackSliderZoom = new Z.Utils.Graphic('trackSliderZoom', Z.skinPath, tlbrSknArr[15], '1px', '1px', '0px', '0px', 'TIP_SLIDERZOOM');
			buttonContainer.appendChild(trackSliderZoom.elmt);
			Z.Utils.addEventListener(trackSliderZoom.elmt, 'mousedown', buttonEventsHandler);
			Z.Utils.addEventListener(trackSliderZoom.elmt, 'touchstart', buttonEventsHandler);
			Z.Utils.addEventListener(trackSliderZoom.elmt, 'mouseover', buttonEventsHandler);
			var buttonSliderZoom = new Z.Utils.Button('buttonSliderZoom', null, Z.skinPath, tlbrSknArr[17], tlbrSknArr[18], tlbrSknArr[19], '1px', '1px', '1px', '1px',  'mouseover', buttonEventsHandler, 'TIP_SLIDERZOOM');
			buttonContainer.appendChild(buttonSliderZoom.elmt);
			var trsZ, trszS, btsZ, btszS;
		}

		if (Z.zoomButtonsVisible) {
			var buttonZoomIn = new Z.Utils.Button('buttonZoomIn', null, Z.skinPath, tlbrSknArr[4], tlbrSknArr[5], tlbrSknArr[6], '1px', '1px', '1px', '1px',  'mouseover', buttonEventsHandler, 'TIP_ZOOMIN');
			buttonContainer.appendChild(buttonZoomIn.elmt);
		}

		if (Z.panButtonsVisible) {
			if (Z.zoomButtonsVisible || Z.sliderZoomVisible) {
				var panDivider = new Z.Utils.Graphic('panDivider', Z.skinPath, tlbrSknArr[20], '1px', '1px','1px', '1px');
				buttonContainer.appendChild(panDivider.elmt);
			}
			var buttonPanLeft = new Z.Utils.Button('buttonPanLeft', null, Z.skinPath, tlbrSknArr[21], tlbrSknArr[22], tlbrSknArr[23], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_PANLEFT');
			buttonContainer.appendChild(buttonPanLeft.elmt);
			var buttonPanUp = new Z.Utils.Button('buttonPanUp', null, Z.skinPath, tlbrSknArr[24], tlbrSknArr[25], tlbrSknArr[26], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_PANUP');
			buttonContainer.appendChild(buttonPanUp.elmt);
			var buttonPanDown = new Z.Utils.Button('buttonPanDown', null, Z.skinPath, tlbrSknArr[27], tlbrSknArr[28], tlbrSknArr[29], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_PANDOWN');
			buttonContainer.appendChild(buttonPanDown.elmt);
			var buttonPanRight = new Z.Utils.Button('buttonPanRight', null, Z.skinPath, tlbrSknArr[30], tlbrSknArr[31], tlbrSknArr[32], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_PANRIGHT');
			buttonContainer.appendChild(buttonPanRight.elmt);
		}
		if (Z.resetVisible) {
			var buttonReset = new Z.Utils.Button('buttonReset', null, Z.skinPath, tlbrSknArr[33], tlbrSknArr[34], tlbrSknArr[35], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_RESET');
			buttonContainer.appendChild(buttonReset.elmt);
		}

		if (Z.fullScreenVisible || Z.fullPageVisible) {
			if (Z.editMode === null) {
				var fullViewDivider = new Z.Utils.Graphic('fullViewDivider', Z.skinPath, tlbrSknArr[36], '1px', '1px', '1px', '1px');
				buttonContainer.appendChild(fullViewDivider.elmt);
			}
			var buttonFullViewExit = new Z.Utils.Button('buttonFullViewExit', null, Z.skinPath, tlbrSknArr[40], tlbrSknArr[41], tlbrSknArr[42], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOGGLEFULLVIEWEXIT');
			buttonContainer.appendChild(buttonFullViewExit.elmt);
			var buttonFullView = new Z.Utils.Button('buttonFullView', null, Z.skinPath, tlbrSknArr[37], tlbrSknArr[38], tlbrSknArr[39], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOGGLEFULLVIEW');
			buttonContainer.appendChild(buttonFullView.elmt);
		}

		if (Z.measureVisible && Z.editMode === null) {
			if (!Z.fullScreenVisible && !Z.fullPageVisible) {
				var measureDivider = new Z.Utils.Graphic('measureDivider', Z.skinPath, tlbrSknArr[36], '1px', '1px', '1px', '1px');
				buttonContainer.appendChild(measureDivider.elmt);
			}
			if (Z.editMode === null) {
				var buttonMeasureExit = new Z.Utils.Button('buttonMeasureExit', null, Z.skinPath, tlbrSknArr[49], tlbrSknArr[50], tlbrSknArr[51], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOGGLEMEASURINGEXIT');
				buttonContainer.appendChild(buttonMeasureExit.elmt);
			}
			var buttonMeasure = new Z.Utils.Button('buttonMeasure', null, Z.skinPath, tlbrSknArr[46], tlbrSknArr[47], tlbrSknArr[48], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOGGLEMEASURING');
			buttonContainer.appendChild(buttonMeasure.elmt);
		}

		if (Z.rotationVisible) {
			var rotateDivider = new Z.Utils.Graphic('rotateDivider', Z.skinPath, tlbrSknArr[52], '1px', '1px', '1px', '1px');
			buttonContainer.appendChild(rotateDivider.elmt);
			var buttonRotateCounterwise = new Z.Utils.Button('buttonRotateCounterwise', null, Z.skinPath, tlbrSknArr[53], tlbrSknArr[54], tlbrSknArr[55], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_ROTATECOUNTERWISE');
			buttonContainer.appendChild(buttonRotateCounterwise.elmt);
			var buttonRotateClockwise = new Z.Utils.Button('buttonRotateClockwise', null, Z.skinPath, tlbrSknArr[56], tlbrSknArr[57], tlbrSknArr[58], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_ROTATECLOCKWISE');
			buttonContainer.appendChild(buttonRotateClockwise.elmt);
		}

		if (Z.tour) {
			var tourDivider = new Z.Utils.Graphic('tourDivider', Z.skinPath, tlbrSknArr[59], '1px', '1px', '1px', '1px');
			buttonContainer.appendChild(tourDivider.elmt);
			var buttonTourPrior = new Z.Utils.Button('buttonTourPrior', null, Z.skinPath, tlbrSknArr[60], tlbrSknArr[61], tlbrSknArr[62], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOURPRIOR');
			buttonContainer.appendChild(buttonTourPrior.elmt);
			var buttonTourNext = new Z.Utils.Button('buttonTourNext', null, Z.skinPath, tlbrSknArr[63], tlbrSknArr[64], tlbrSknArr[65], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOURNEXT');
			buttonContainer.appendChild(buttonTourNext.elmt);
			var buttonTourStart = new Z.Utils.Button('buttonTourStart', null, Z.skinPath, tlbrSknArr[66], tlbrSknArr[67], tlbrSknArr[68], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOURSTART');
			buttonContainer.appendChild(buttonTourStart.elmt);
			var buttonTourStop = new Z.Utils.Button('buttonTourStop', null, Z.skinPath, tlbrSknArr[69], tlbrSknArr[70], tlbrSknArr[71], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_TOURSTOP');
			buttonContainer.appendChild(buttonTourStop.elmt);
		}

		if (Z.slideshow) {
			var slideshowDivider = new Z.Utils.Graphic('slideshowDivider', Z.skinPath, tlbrSknArr[59], '1px', '1px', '1px', '1px');
			buttonContainer.appendChild(slideshowDivider.elmt);
			var buttonSlideshowPrior = new Z.Utils.Button('buttonSlideshowPrior', null, Z.skinPath, tlbrSknArr[60], tlbrSknArr[61], tlbrSknArr[62], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_SLIDEPRIOR');
			buttonContainer.appendChild(buttonSlideshowPrior.elmt);
			var buttonSlideshowNext = new Z.Utils.Button('buttonSlideshowNext', null, Z.skinPath, tlbrSknArr[63], tlbrSknArr[64], tlbrSknArr[65], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_SLIDENEXT');
			buttonContainer.appendChild(buttonSlideshowNext.elmt);
			var buttonSlideshowStart = new Z.Utils.Button('buttonSlideshowStart', null, Z.skinPath, tlbrSknArr[66], tlbrSknArr[67], tlbrSknArr[68], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_SLIDESHOWSTART');
			buttonContainer.appendChild(buttonSlideshowStart.elmt);
			var buttonSlideshowStop = new Z.Utils.Button('buttonSlideshowStop', null, Z.skinPath, tlbrSknArr[69], tlbrSknArr[70], tlbrSknArr[71], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_SLIDESHOWSTOP');
			buttonContainer.appendChild(buttonSlideshowStop.elmt);
		}

		if (Z.tour || Z.slideshow) {
			var buttonAudioOn = new Z.Utils.Button('buttonAudioOn', null, Z.skinPath, tlbrSknArr[72], tlbrSknArr[73], tlbrSknArr[74], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_AUDIOMUTE');
			buttonContainer.appendChild(buttonAudioOn.elmt);
			var buttonAudioMuted = new Z.Utils.Button('buttonAudioMuted', null, Z.skinPath, tlbrSknArr[75], tlbrSknArr[76], tlbrSknArr[77], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_AUDIOON');
			buttonContainer.appendChild(buttonAudioMuted.elmt);
		}

		if (Z.imageFilters) {
			var imageFilterDivider = new Z.Utils.Graphic('imageFilterDivider', Z.skinPath, tlbrSknArr[78], '1px', '1px', '1px', '1px');
			buttonContainer.appendChild(imageFilterDivider.elmt);
			var buttonImageFilterPanelHide = new Z.Utils.Button('buttonImageFilterPanelHide', null, Z.skinPath, tlbrSknArr[79], tlbrSknArr[80], tlbrSknArr[81], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGEFILTERPANELHIDE');
			buttonContainer.appendChild(buttonImageFilterPanelHide.elmt);
			var buttonImageFilterPanelShow = new Z.Utils.Button('buttonImageFilterPanelShow', null, Z.skinPath, tlbrSknArr[82], tlbrSknArr[83], tlbrSknArr[84], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGEFILTERPANELSHOW');
			buttonContainer.appendChild(buttonImageFilterPanelShow.elmt);
			createImageFilterPanel(tlbrSknArr);
		}

		if (Z.imageSet && !Z.overlays) {
			if (buttonContainer.childNodes.length > 1) {
				var imageSetDivider = new Z.Utils.Graphic('imageSetDivider', Z.skinPath, tlbrSknArr[59], '1px', '1px', '1px', '1px');
				buttonContainer.appendChild(imageSetDivider.elmt);
			}
			var buttonImageSetPrior = new Z.Utils.Button('buttonImageSetPrior', null, Z.skinPath, tlbrSknArr[60], tlbrSknArr[61], tlbrSknArr[62], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGESETPRIOR');
			buttonContainer.appendChild(buttonImageSetPrior.elmt);

			if (Z.sliderImageSetVisible) {
				var trackSliderImageSet = new Z.Utils.Graphic('trackSliderImageSet', Z.skinPath, tlbrSknArr[15], '1px', '1px', '0px', '0px', 'TIP_SLIDERIMAGESET');
				buttonContainer.appendChild(trackSliderImageSet.elmt);
				Z.Utils.addEventListener(trackSliderImageSet.elmt, 'mousedown', buttonEventsHandler);
				Z.Utils.addEventListener(trackSliderImageSet.elmt, 'touchstart', buttonEventsHandler);
				Z.Utils.addEventListener(trackSliderImageSet.elmt, 'mouseover', buttonEventsHandler);
				var buttonSliderImageSet = new Z.Utils.Button('buttonSliderImageSet', null, Z.skinPath, tlbrSknArr[17], tlbrSknArr[18], tlbrSknArr[19], '1px', '1px', '1px', '1px',  'mouseover', buttonEventsHandler, 'TIP_SLIDERIMAGESET');
				buttonContainer.appendChild(buttonSliderImageSet.elmt);
				var trsiS, trsisS, btsiS, btsisS;
			}

			var buttonImageSetNext = new Z.Utils.Button('buttonImageSetNext', null, Z.skinPath, tlbrSknArr[63], tlbrSknArr[64], tlbrSknArr[65], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGESETNEXT');
			buttonContainer.appendChild(buttonImageSetNext.elmt);
		}

		if (Z.preloadVisible) {
			var preloadDivider = new Z.Utils.Graphic('preloadDivider', Z.skinPath, tlbrSknArr[59], '1px', '1px', '1px', '1px');
			buttonContainer.appendChild(preloadDivider.elmt);
			var buttonPreload = new Z.Utils.Button('buttonPreload', null, Z.skinPath, tlbrSknArr[69], tlbrSknArr[70], tlbrSknArr[71], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_PRELOAD');
			buttonContainer.appendChild(buttonPreload.elmt);
		}

		if (Z.comparison) {
			var labelSyncTextBox = Z.Utils.createContainerElement('div', 'labelSyncTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelSyncTextNode = document.createTextNode(Z.Utils.getResource('UI_TOOLBARLABELSYNC'));
			labelSyncTextBox.appendChild(labelSyncTextNode);
			var checkboxSyncComparison = new Z.Utils.Checkbox('checkboxSyncComparison', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_SYNC');
			buttonContainer.appendChild(labelSyncTextBox);
			buttonContainer.appendChild(checkboxSyncComparison);
		}

		if (Z.helpVisible == 1 || Z.helpVisible == 3) {
			var buttonHelp = new Z.Utils.Button('buttonHelp', null, Z.skinPath, tlbrSknArr[43], tlbrSknArr[44], tlbrSknArr[45], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_HELP');
			buttonContainer.appendChild(buttonHelp.elmt);
		}

		if (Z.progressVisible) {
			// Create with placeholder size and position until drawLayout.
			var progressTextBox = Z.Utils.createContainerElement('div', 'progressTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '1px', '1px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
			var progressFontSize=toolbarSkinSizes[16];
			buttonContainer.appendChild(progressTextBox);
			var progressTextNode = document.createTextNode(Z.Utils.getResource('DEFAULT_PROGRESSTEXT'));
			progressTextBox.appendChild(Z.Utils.createCenteredElement(progressTextNode, 'progressTextBoxCenteredDiv'));
			if (progressTextColor === null) { progressTextColor = Z.Utils.getResource('DEFAULT_PROGRESSTEXTCOLOR'); }
			Z.Utils.setTextNodeStyle(progressTextNode, progressTextColor, 'verdana', progressFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			Z.Utils.disableTextInteraction(progressTextNode); // Prevent text selection.
		}

		// Add toolbar to viewer display.
		Z.ViewerDisplay.appendChild(Z.ToolbarDisplay);

		// Set toolbar size, position, and visibility.
		Z.toolbarW = toolbarSkinSizes[0];
		Z.toolbarCurrentW = (Z.toolbarW == -1) ? Z.viewerW : Z.toolbarW;
		Z.toolbarH = tlbrH = toolbarSkinSizes[1];
		var toolbarTop = (Z.toolbarPosition == 1) ? Z.viewerH - Z.toolbarH : 0;
		self.setSizeAndPosition(Z.toolbarCurrentW, Z.toolbarH, 0, toolbarTop);

		if (tbViewport && tbViewport.getStatus('initializedViewport')) {
			if (Z.toolbarVisible == 1) {
				tbViewport.setSizeAndPosition(Z.viewerW, (Z.viewerH - Z.toolbarH), 0, 0);
				tbViewport.validateXYZDefaults(true);
			}
			var currentZ = tbViewport.getZoom();
			syncSliderToViewportZoom(currentZ);
			tbViewport.setDrawingColor('buttonColor0' + tbViewportIDStr, true);
		}

		show(Z.toolbarVisible == 1 || Z.toolbarVisible == 2 || Z.toolbarVisible == 4 || Z.toolbarVisible == 7);

		// Prevent event bubbling.
		Z.Utils.addEventListener(Z.ToolbarDisplay, 'mouseover', Z.Utils.stopPropagation);

		setInitialized(true);

		// Reset size and position Gallery, if present.
		gallerySizeAndPositionReset();
	}

	function gallerySizeAndPositionReset () {
		if (Z.Gallery && Z.Gallery.getInitialized()) {
			Z.Gallery.setSizeAndPosition();
		} else {
			var galleryPositionTimer = window.setTimeout( gallerySizeAndPositionReset, 100);
		}
	}

	function createImageFilterPanel (tlbrSknArr) {
		// Add button container to handle background mouseover events instead of button mouseout events.
		// Hide until filter panel Show button pressed using 0,0 background size and 'none' value for container display.
		// DEV NOTE: Do note use prevent default lines below to block panel selection because blocks choicelist use.
		var buttonContainerImageFilter = Z.Utils.createContainerElement('div', 'buttonContainerImageFilter', 'none', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', 'default');
		Z.ToolbarDisplay.appendChild(buttonContainerImageFilter);
		Z.Utils.addEventListener(buttonContainerImageFilter, 'mouseover', self.backgroundEventsHandler);

		// Create background.
		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
		var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');
		var imageFilterPanelBackground = Z.Utils.createContainerElement('div', 'imageFilterPanelBackground', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', backColor, '0px', '0px', 'normal', null, true);
		Z.Utils.setOpacity(imageFilterPanelBackground, backAlpha, backColorNoAlpha);
		buttonContainerImageFilter.appendChild(imageFilterPanelBackground);

		// Create filter choicelist object from resourced data.
		var imageFilterListTextArray = Z.Utils.getResource('UI_IMAGEFILTERCHOICELISTTEXT').split(',');
		var imageFilterListValuesArray = Z.Utils.getResource('UI_IMAGEFILTERCHOICELISTVALUES').split(',');
		for (var i = 0, j = imageFilterListTextArray.length; i < j; i++) {
			imageFilterListDP[imageFilterListDP.length] = { text:imageFilterListTextArray[i], value:imageFilterListValuesArray[i] };
		}
		var imageFilterList = new Z.Utils.createSelectElement('imageFilterList', '', imageFilterListDP, 1, 1, 1, null, true, imageFilterListChangeHandler, 'change');
		buttonContainerImageFilter.appendChild(imageFilterList);

		// Create filter sliders.
		if (Z.brightnessVisible) { var brightnessSlider = new Z.Utils.Slider('brightness', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.contrastVisible) { var contrastSlider = new Z.Utils.Slider('contrast', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.sharpnessVisible) { var sharpnessSlider = new Z.Utils.Slider('sharpness', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.blurrinessVisible) { var blurrinessSlider = new Z.Utils.Slider('blurriness', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.colorRedVisible) { var colorRedSlider = new Z.Utils.Slider('colorRed', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.colorGreenVisible) { var colorGreenSlider = new Z.Utils.Slider('colorGreen', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.colorBlueVisible) { var colorBlueSlider = new Z.Utils.Slider('colorBlue', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.colorRedRangeVisible) { var colorRedRangeSlider = new Z.Utils.Slider('colorRedRange', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager, true); }
		if (Z.colorGreenRangeVisible) { var colorGreenRangeSlider = new Z.Utils.Slider('colorGreenRange', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager, true); }
		if (Z.colorBlueRangeVisible) { var colorBlueRangeSlider = new Z.Utils.Slider('colorBlueRange', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager, true); }
		if (Z.gammaVisible) { var gammaSlider = new Z.Utils.Slider('gamma', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.gammaRedVisible) { var gammaRedSlider = new Z.Utils.Slider('gammaRed', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.gammaGreenVisible) { var gammaGreenSlider = new Z.Utils.Slider('gammaGreen', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.gammaBlueVisible) { var gammaBlueSlider = new Z.Utils.Slider('gammaBlue', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.hueVisible) { var hueSlider = new Z.Utils.Slider('hue', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.saturationVisible) { var saturationSlider = new Z.Utils.Slider('saturation', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.lightnessVisible) { var lightnessSlider = new Z.Utils.Slider('lightness', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.whiteBalanceVisible) { var whiteBalanceSlider = new Z.Utils.Slider('whiteBalance', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }
		if (Z.noiseVisible) { var noiseSlider = new Z.Utils.Slider('noise', buttonContainerImageFilter, tlbrSknArr, buttonEventsHandler, imageFilterSliderTextEventsManager); }

		// Create filter magnitude buttons.
		var buttonImageFilterMinus = new Z.Utils.Button('buttonImageFilterMinus', null, Z.skinPath, tlbrSknArr[85], tlbrSknArr[86], tlbrSknArr[87], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGEFILTERMINUS');
		buttonContainerImageFilter.appendChild(buttonImageFilterMinus.elmt);
		var buttonImageFilterPlus = new Z.Utils.Button('buttonImageFilterPlus', null, Z.skinPath, tlbrSknArr[88], tlbrSknArr[89], tlbrSknArr[90], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGEFILTERPLUS');
		buttonContainerImageFilter.appendChild(buttonImageFilterPlus.elmt);

		// Create divider between magnitude and binary filters.
		var imageFilterStateDivider = new Z.Utils.Graphic('imageFilterStateDivider', Z.skinPath, tlbrSknArr[94], '1px', '1px', '1px', '1px');
		buttonContainerImageFilter.appendChild(imageFilterStateDivider.elmt);

		// Create filter checkboxes: Grayscale, Threshold, Inversion, Edges, Sepia
		if (Z.grayscaleVisible) {
			var labelGrayscaleTextBox = Z.Utils.createContainerElement('div', 'labelGrayscaleTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelGrayscaleTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABELGRAYSCALE'));
			labelGrayscaleTextBox.appendChild(labelGrayscaleTextNode);
			var checkboxFilterGrayscale = new Z.Utils.Checkbox('checkboxFilterGrayscale', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_GRAYSCALE');
			buttonContainerImageFilter.appendChild(labelGrayscaleTextBox);
			buttonContainerImageFilter.appendChild(checkboxFilterGrayscale);
		}

		if (Z.thresholdVisible) {
			var labelThresholdTextBox = Z.Utils.createContainerElement('div', 'labelThresholdTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelThresholdTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABELTHRESHOLD'));
			labelThresholdTextBox.appendChild(labelThresholdTextNode);
			var checkboxFilterThreshold = new Z.Utils.Checkbox('checkboxFilterThreshold', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_THRESHOLD');
			buttonContainerImageFilter.appendChild(labelThresholdTextBox);
			buttonContainerImageFilter.appendChild(checkboxFilterThreshold);
		}

		if (Z.inversionVisible) {
			var labelInversionTextBox = Z.Utils.createContainerElement('div', 'labelInversionTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelInversionTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABELINVERSION'));
			labelInversionTextBox.appendChild(labelInversionTextNode);
			var checkboxFilterInversion = new Z.Utils.Checkbox('checkboxFilterInversion', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_INVERSION');
			buttonContainerImageFilter.appendChild(labelInversionTextBox);
			buttonContainerImageFilter.appendChild(checkboxFilterInversion);
		}

		if (Z.normalizeVisible) {
			var labelNormalizeTextBox = Z.Utils.createContainerElement('div', 'labelNormalizeTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelNormalizeTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABELEQUALIZE'));
			labelNormalizeTextBox.appendChild(labelNormalizeTextNode);
			var checkboxFilterNormalize = new Z.Utils.Checkbox('checkboxFilterNormalize', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_EQUALIZE');
			buttonContainerImageFilter.appendChild(labelNormalizeTextBox);
			buttonContainerImageFilter.appendChild(checkboxFilterNormalize);
		}

		if (Z.equalizeVisible) {
			var labelEqualizeTextBox = Z.Utils.createContainerElement('div', 'labelEqualizeTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelEqualizeTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABELEQUALIZE'));
			labelEqualizeTextBox.appendChild(labelEqualizeTextNode);
			var checkboxFilterEqualize = new Z.Utils.Checkbox('checkboxFilterEqualize', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_EQUALIZE');
			buttonContainerImageFilter.appendChild(labelEqualizeTextBox);
			buttonContainerImageFilter.appendChild(checkboxFilterEqualize);
		}

		if (Z.edgesVisible) {
			var labelEdgesTextBox = Z.Utils.createContainerElement('div', 'labelEdgesTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelEdgesTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABELEDGES'));
			labelEdgesTextBox.appendChild(labelEdgesTextNode);
			var checkboxFilterEdges = new Z.Utils.Checkbox('checkboxFilterEdges', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_EDGES');
			buttonContainerImageFilter.appendChild(labelEdgesTextBox);
			buttonContainerImageFilter.appendChild(checkboxFilterEdges);
		}

		if (Z.sepiaVisible) {
			var labelSepiaTextBox = Z.Utils.createContainerElement('div', 'labelSepiaTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelSepiaTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABELSEPIA'));
			labelSepiaTextBox.appendChild(labelSepiaTextNode);
			var checkboxFilterSepia = new Z.Utils.Checkbox('checkboxFilterSepia', 'test', '1px', '1px', '1px', '1px', 'click', buttonEventsHandler, 'TIP_SEPIA');
			buttonContainerImageFilter.appendChild(labelSepiaTextBox);
			buttonContainerImageFilter.appendChild(checkboxFilterSepia);
		}

		// Create divider between panel contents and panel buttons.
		var imageFilterPanelDivider = new Z.Utils.Graphic('imageFilterPanelDivider', Z.skinPath, tlbrSknArr[94], '1px', '1px', '1px', '1px');
		buttonContainerImageFilter.appendChild(imageFilterPanelDivider.elmt);

		// Create filter state buttons.
		var buttonImageFilterClear = new Z.Utils.Button('buttonImageFilterClear', null, Z.skinPath, tlbrSknArr[95], tlbrSknArr[96], tlbrSknArr[97], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGEFILTERCLEAR');
		buttonContainerImageFilter.appendChild(buttonImageFilterClear.elmt);
		var buttonImageFiltersClearAll = new Z.Utils.Button('buttonImageFiltersClearAll', null, Z.skinPath, tlbrSknArr[98], tlbrSknArr[99], tlbrSknArr[100], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGEFILTERCLEARALL');
		buttonContainerImageFilter.appendChild(buttonImageFiltersClearAll.elmt);

		// Create divider and panel hide button.
		var imageFilterStateDivider3 = new Z.Utils.Graphic('imageFilterStateDivider3', Z.skinPath, tlbrSknArr[94], '1px', '1px', '1px', '1px');
		buttonContainerImageFilter.appendChild(imageFilterStateDivider3.elmt);
		var buttonImageFilterPanelHideOnPanel = new Z.Utils.Button('buttonImageFilterPanelHideOnPanel', null, Z.skinPath, tlbrSknArr[79], tlbrSknArr[80], tlbrSknArr[81], '1px', '1px', '1px', '1px', 'mouseover', buttonEventsHandler, 'TIP_IMAGEFILTERPANELHIDE');
		buttonContainerImageFilter.appendChild(buttonImageFilterPanelHideOnPanel.elmt);
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::: GET & SET FUNCTIONS :::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getInitialized = function () {
		return getInitialized();
	}

	this.getSkinArray = function () {
		return toolbarSkinArray;
	}

	this.getSkinSizes = function () {
		return toolbarSkinSizes;
	}

	this.show = function (value) {
		show(value);
	}

	this.setVisibility = function (visible) {
		visibility(visible);
	}

	this.minimize = function (value) {
		minimize(value);
	}

	this.setVisibilityAnnotationPanel = function (visible, vpIDs) {
		setVisibilityAnnotationPanel(visible, vpIDs);
	}

	function setVisibilityAnnotationPanel (visible, vpIDs) {
		if (typeof vpIDs === 'undefined' || vpIDs === null) {
			vpIDs = (Z.annotationFileShared) ? '0' : tbViewport.getViewportID().toString();
		}
		var annotPanel = document.getElementById('AnnotationPanelDisplay' + vpIDs);
		if (annotPanel) {
			if (visible && !(Z.measureVisible && Z.editMode === null)) {
				annotPanel.style.display = 'inline-block';
				Z.annotationPanelVisibleState = true;
			} else {
				annotPanel.style.display = 'none'; // Debug option: comment out this line to keep visible on mouseout.
				Z.annotationPanelVisibleState = false;
			}
		}
	}

	this.toggleAnnotationPanelMode = function (editMode) {
		tbViewport.clearAnnotationPanel(tbViewportIDStr);
		tbViewport.setStatus('annotationPanelInitializedViewport', false);
		tbViewport.createAnnotationPanel(tbViewportIDStr);
	}

	this.setVisibilityTrackingPanel = function (visible, vpIDs) {
		setVisibilityTrackingPanel(visible, vpIDs);
	}

	function setVisibilityTrackingPanel (visible, vpIDs) {
		if (typeof vpIDs === 'undefined' || vpIDs === null) {
			vpIDs = (Z.trackingFileShared) ? '0' : tbViewport.getViewportID().toString();
		}
		var trackPanel = document.getElementById('TrackingPanelDisplay' + vpIDs);
		if (trackPanel) {
			if (visible) {
				trackPanel.style.display = 'inline-block';
				Z.trackingPanelVisibleState = true;
			} else {
				trackPanel.style.display = 'none'; // Debug option: comment out this line to keep visible on mouseout.
				Z.trackingPanelVisibleState = false;
			}
		}
	}

	this.setVisibilityUserPanel = function (visible) {
		setVisibilityUserPanel(visible);
	}

	function setVisibilityUserPanel (visible) {
		var usePanel = document.getElementById('userPanelDisplay');
		if (usePanel) {
			if (visible) {
				usePanel.style.display = 'inline-block';
				Z.userPanelVisibleState = true;
			} else {
				usePanel.style.display = 'none'; // Debug option: comment out this line to keep visible on mouseout.
				Z.userPanelVisibleState = false;
			}
		}
	}

	this.showProgress = function () {
		var ptB = document.getElementById('progressTextBox');
		if (ptB) {
			var ptbS = ptB.style;
			if (ptbS) {
				ptbS.display = 'inline-block';
			}
		}
	}

	this.hideProgress = function () {
		var ptB = document.getElementById('progressTextBox');
		if (ptB) {
			var ptbS = ptB.style;
			if (ptbS) {
				ptbS.display = 'none';
			}
		}
	}

	this.updateProgress = function (total, current) {
		if (Z.progressVisible) {
			if (progressInterval) { window.clearInterval(progressInterval); }
			var percentComplete;
			var ptcD = document.getElementById('progressTextBoxCenteredDiv');
			if (ptcD) {
				var ptn = ptcD.firstChild;
				if (ptn) {
					if (total == 0 || current == 0) {
						ptn.nodeValue = 'llllllllll'
						progressInterval = window.setInterval(clearProgress, parseInt(Z.Utils.getResource('DEFAULT_PROGRESSDURATION')), 10);
					} else {
						percentComplete = Math.round(100 - (current / total) * 100);
						var percCompTrunc = Math.round(percentComplete / 10);
						ptn.nodeValue = Z.Utils.stringMultiply('l', percCompTrunc);
					}
				}
			}
		}
	}

	function clearProgress () {
		window.clearInterval(progressInterval);
		progressInterval = null;
		var ptcD = document.getElementById('progressTextBoxCenteredDiv');
		if (ptcD) {
			var ptn = ptcD.firstChild;
			if (ptn) { ptn.nodeValue = ''; }
		}
	}

	// Support Image Set viewing.
	this.setViewport = function (tbVwprt) {
		tbViewport = tbVwprt;
		tbViewportIDStr = tbViewport.getViewportID().toString();
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::: CORE FUNCTIONS ::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function getInitialized () {
		return isInitialized;
	}

	function setInitialized (initialized) {
		if (!isInitialized && initialized) {
			isInitialized = true;
			Z.Utils.validateCallback('toolbarInitialized');
			Z.Viewer.validateViewerReady('toolbarInitialized');
		}
	}

	this.parseSkinXML = function (xmlDoc) {
		// Get selection mode for optional small screen graphics fileset.
		Z.skinMode = xmlDoc.getElementsByTagName('SETUP')[0].attributes.getNamedItem('SKINMODE').nodeValue;
		var skinFolder, skinSizesTag;

		// Debug option - forces large skins for mobile device layout testing:
		//Z.skinMode = 2;

		if (Z.skinMode == 1 || (Z.skinMode == 0 && !Z.mobileDevice)) {
			skinFolder = xmlDoc.getElementsByTagName('SETUP')[0].attributes.getNamedItem('FOLDERSTANDARD').nodeValue;
			skinSizesTag = 'SIZESSTANDARD';
		} else {
			skinFolder = xmlDoc.getElementsByTagName('SETUP')[0].attributes.getNamedItem('FOLDERLARGE').nodeValue;
			skinSizesTag = 'SIZESLARGE';
		}

		// Get color value for progress display.
		var progressTextColorAtt = xmlDoc.getElementsByTagName('SETUP')[0].attributes.getNamedItem('PROGRESSCOLOR');
		if (typeof progressTextColorAtt !== 'undefined' && progressTextColorAtt !== null) {
			progressTextColor = xmlDoc.getElementsByTagName('SETUP')[0].attributes.getNamedItem('PROGRESSCOLOR').nodeValue;
		}

		// Get toolbar element dimensions.
		var toolbarSkinSizes = [];
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('TOOLBARW').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('TOOLBARH').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('LOGOW').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('LOGOH').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('DIVIDERW').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('DIVIDERH').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('BUTTONW').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('BUTTONH').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('BUTTONSPAN').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('SLIDERBUTTONW').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('SLIDERBUTTONH').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('SLIDERTRACKW').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('SLIDERTRACKH').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('SLIDERSPAN').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('PROGRESSW').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('PROGRESSH').nodeValue);
		toolbarSkinSizes[toolbarSkinSizes.length] = parseFloat(xmlDoc.getElementsByTagName(skinSizesTag)[0].attributes.getNamedItem('PROGRESSFONTSIZE').nodeValue);

		// Get names of skin files of the Zoomify Toolbar.
		var skinMax, skinFirstAtt, skinFirst, skinLastAtt, skinLast;
		skinMax = (Z.trackingEditMode=='edit') ? 176 : (Z.tracking) ? 164 : (Z.editMode == 'edit' || Z.trackingEditMode == 'edit') ? 161 : (Z.editMode == 'markup') ? 152 : (Z.imageFilters) ? 100 : (Z.screensaver || Z.preloadVisible || Z.tourPath || Z.slidePath || Z.imageSetPath) ? 77 : (Z.rotationVisible) ? 58 : (Z.measureVisible) ? 51 : (Z.helpVisible > 0) ? 45 : (Z.fullScreenVisible || Z.fullPageVisible) ? 45 : (Z.resetVisible) ? 35 : (Z.panButtonsVisible) ? 32 : (Z.sliderZoomVisible) ? 19 : (Z.minimizeVisible) ? 14 : (Z.logoVisible) ? 8 : 6;
		skinFirstAtt = xmlDoc.getElementsByTagName('FILES')[0].attributes.getNamedItem('SKIN0');
		if (skinFirstAtt !== null) { skinFirst = skinFirstAtt.nodeValue; }
		skinLastAtt = xmlDoc.getElementsByTagName('FILES')[0].attributes.getNamedItem('SKIN' + skinMax.toString());
		if (skinLastAtt !== null) { skinLast = skinLastAtt.nodeValue; }
		if (typeof skinFirst !== 'undefined' && Z.Utils.stringValidate(skinFirst) && typeof skinLast !== 'undefined' && Z.Utils.stringValidate(skinLast)) {
			var xmlMissingNames = false;
			for (var i = 0, j = skinMax + 1; i < j; i++) {
				var skinCounter = xmlDoc.getElementsByTagName('FILES')[0].attributes.getNamedItem('SKIN' + i).nodeValue;
				if (Z.Utils.stringValidate(skinCounter)) {
					toolbarSkinFilePaths[i] = skinFolder + '/' + skinCounter;
				} else {
					toolbarSkinFilePaths[i] = 'null';
					xmlMissingNames = true;
				}
			}
			if (xmlMissingNames) { Z.Utils.showMessage(Z.Utils.getResource('ERROR_SKINXMLMISSINGNAMES')); }
			initializeToolbar(toolbarSkinSizes, toolbarSkinFilePaths);
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_SKINXMLINVALID'));
		}
	}

	this.setSizeAndPosition = function (width, height, left, top) {
		if (typeof width === 'undefined' || width === null) {
			width = (Z.toolbarVisible > 0) ? Z.toolbarCurrentW : 0;
		} else {
			Z.toolbarCurrentW = width;
		}
		if (typeof height === 'undefined' || height === null) { height = (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) ? tlbrH : 0; }
		if (typeof left === 'undefined' || left === null) { left = 0; }
		if (typeof top === 'undefined' || top === null) { top = (Z.toolbarPosition == 1) ? Z.viewerH - tlbrH : 0; }

		tbS = Z.ToolbarDisplay.style;
		tbS.width = width + 'px';
		tbS.height = height + 'px';
		tbS.left = left + 'px';
		tbS.top = top + 'px';
		drawLayout(width, height);
	}

	function drawLayout (width, height) {
		// Set toolbar width and height as specified in the call to this function by the
		// setSizeAndPosition function.  That function tests for null assignments and uses
		// preset values from the Skins XML file if appropriate.
		var toolbarW = width;
		var toolbarH = height;

		 // Set remaining values to the values in the Skins XML file.
		var logoW = toolbarSkinSizes[2];
		var logoH = toolbarSkinSizes[3];
		var dvdrW = toolbarSkinSizes[4];
		var dvdrH = toolbarSkinSizes[5];
		var btnW = toolbarSkinSizes[6];
		var btnH = toolbarSkinSizes[7];
		var btnSpan = toolbarSkinSizes[8];
		var sldrBtnW = toolbarSkinSizes[9];
		var sldrBtnH = toolbarSkinSizes[10];
		var sldrTrkW = toolbarSkinSizes[11];
		var sldrTrkH = toolbarSkinSizes[12];
		var sldrSpan = toolbarSkinSizes[13];
		var prgW = toolbarSkinSizes[14];
		var prgH = toolbarSkinSizes[15];

		// Calculate positioning values.
		var dx = 0;
		var logoTOffset = (toolbarH - logoH) / 2 + 1;
		var dvdrTOffset = (toolbarH - dvdrH) / 2;
		var btnTOffset = (toolbarH - btnH) / 2;
		var btnMinExpTOffset = (btnTOffset * 1.3);
		var sldrTrkTOffset = btnTOffset + 4;
		var btnSldrTOffset = btnTOffset + 2;
		var btnMinSpan = (Z.logoVisible == 1) ? 0 : btnSpan / 2;
		var btnExpSpan = (Z.logoVisible == 1) ? 0 : btnSpan / 2;
		var dvdrSpan = btnSpan - (btnW - dvdrW);
		var btnContainerMargin = 20;

		// Calculate width of button area.
		var btnCount = 0;
		var dvdrCount = 0;

		if (Z.zoomButtonsVisible) {
			btnCount += 2;
		}
		if (Z.panButtonsVisible) {
			btnCount += 4;
			dvdrCount += 1;
		}
		if (Z.resetVisible) {
			btnCount += 1;
		}
		if (Z.fullScreenVisible || Z.fullPageVisible) {
			btnCount += 1;
			dvdrCount += 1;
		}
		if (Z.helpVisible) {
			btnCount += 1;
			if (!Z.fullScreenVisible && !Z.fullPageVisible) {
				dvdrCount += 1;
			}
		}
		if (Z.measureVisible) {
			if (!Z.fullScreenVisible && !Z.fullPageVisible) {
				dvdrCount += 1;
			}
			btnCount += 1;
		}
		if (Z.rotationVisible) {
			btnCount += 2;
			dvdrCount += 1;
		}
		if (Z.tour || Z.slideshow) {
			btnCount += 3;
			dvdrCount += 1;
			if (Z.audioContent) {
				btnCount += 1;	// DEV NOTE: Does not currently allow for timing of toolbar initialization vs viewer initialization and tour/slideshow XML parsing.
			}
		}
		if (Z.imageFilters) {
			btnCount += 1;
			dvdrCount += 1;
		}
		if (Z.preloadVisible) {
			btnCount += 1;
			dvdrCount += 1;
		}
		if (Z.comparison && Z.syncVisible) {
			btnCount += 1;
			dvdrCount += 1;
		}

		if (Z.imageSet && Z.sliderImageSetVisible) {
			// Following values separate from standard toolbar slider values for possible separate future use.
			var sldrStackSpan = sldrSpan;
			var imageSetSldrTrkW = sldrTrkW;
			var imageSetSldrTrkH = sldrTrkH;
			overrideSliderImageSet = false;
			btnCount += 2;
		}

		if (!Z.progressVisible) { prgW = 0; }

		var btnSetW = (btnCount * btnSpan) + (dvdrCount * dvdrSpan);

		if (Z.sliderZoomVisible) { btnSetW += sldrSpan; }
		if (Z.imageSet && Z.sliderImageSetVisible) { btnSetW += sldrStackSpan; }

		// Validate toolbar contents fit within toolbar width. If not, implement overrides. First
		// hide slider and recalculate. Next hide, progress display.  Next, hide logo and
		// minimize and maximize buttons. Finally, hide pan buttons.
		overrideSliderZoom = overrideProgress = overrideLogo = overridePan = overrideZoom = false;
		var logoOffset = (Z.logoVisible == 1) ? logoW + 2 : 0;
		var minBtnOffset = (Z.toolbarVisible != 0 && Z.toolbarVisible != 1 && Z.minimizeVisible != 0) ? btnSpan : 0;
		var logoButtonSetW = logoOffset + minBtnOffset;
		var panButtonSetW = (Z.panButtonsVisible == 1) ? (btnSpan * 4) + dvdrSpan : 0;
		var zoomButtonSetW = (Z.zoomButtonsVisible == 1) ? (btnSpan * 2) : 0;
		var resetButtonW = (Z.resetVisible == 1) ? btnSpan : 0;
		var toolbarContentsW = logoButtonSetW + btnContainerMargin + btnSetW + btnContainerMargin + prgW;

		if (toolbarContentsW > toolbarW) {
			overrideSliderZoom = true;
			if ((toolbarContentsW - sldrSpan) > toolbarW) {
				overrideProgress = true;
				if ((toolbarContentsW - sldrSpan - prgW) > toolbarW) {
					overrideLogo = true;
					if ((toolbarContentsW - sldrSpan - prgW - logoButtonSetW) > toolbarW) {
						overrideReset = true;
						if ((toolbarContentsW - sldrSpan - prgW - logoButtonSetW - resetButtonW) > toolbarW) {
							overridePan = true;
							btnSetW -= panButtonSetW;
							if ((toolbarContentsW - sldrSpan - prgW - logoButtonSetW - resetButtonW - panButtonSetW) > toolbarW) {
								overrideZoom = true;
								btnSetW -= zoomButtonSetW;
							}
						}
						btnSetW -= resetButtonW;
					}
					logoButtonSetW = 0;
				}
				prgW = 0;
			}
			btnSetW -= sldrSpan;
		}

		// Calculate position for main button set centered in toolbar.
		var btnSetL = ((toolbarW - btnSetW) / 2) - btnContainerMargin + 3;

		// Set the sizes and positions of the toolbar contents.
		var bG = document.getElementById('toolbarBackground');
		if (bG) {
			bG.style.width = toolbarW + 'px';
			bG.style.height = toolbarH + 'px';
			bG.firstChild.style.width = toolbarW + 'px';
			bG.firstChild.style.height = toolbarH + 'px';
		}

		var bC = document.getElementById('buttonContainer');
		if (bC) {
			bC.style.width = (btnSetW + (btnContainerMargin * 2)) + 'px';
			bC.style.height = toolbarH + 'px';
			bC.style.left = btnSetL + 'px';
		}

		var bB = document.getElementById('buttonBackground');
		if (bB) {
			bB.style.width = toolbarW + 'px';
			Z.Utils.graphicSize(bB, parseFloat(bC.style.width), parseFloat(bC.style.height));
			bB.style.left = '0px';
		}

		var tbL = document.getElementById('toolbarLogo');
		if (tbL) {
			var tblS = tbL.style;
			if (tblS) {
				if (!overrideLogo) {
					tblS.display = 'inline-block';
					Z.Utils.graphicSize(tbL, logoW, logoH);
					tblS.left = dx + 'px';
					tblS.top = logoTOffset + 'px';
					dx += logoW + 2;
					var logoD = document.getElementById('logoDivider');
					if (logoD) {
						Z.Utils.graphicSize(logoD, dvdrW, dvdrH);
						var ldS = logoD.style;
						ldS.left = dx + 'px';
						ldS.top = dvdrTOffset + 'px';
					}
				} else {
					tblS.display = 'none';
				}
			}
		}

		if (Z.toolbarVisible != 0 && Z.toolbarVisible != 1) {
			var bM = document.getElementById('buttonMinimize');
			var bE = document.getElementById('buttonExpand');
			if (bM && bE) {
				var bmS = bM.style;
				var beS = bE.style;
				if (bmS && beS) {
					if (!overrideLogo) {
						bmS.display = 'inline-block';
						beS.display = 'inline-block';
						Z.Utils.buttonSize(bM, btnW, btnH);
						Z.Utils.buttonSize(bE, btnW, btnH);
						bmS.left = dx + btnMinSpan + 'px';
						bmS.top = btnMinExpTOffset + 'px';
						beS.left = dx + btnExpSpan + 'px';
						beS.top = btnMinExpTOffset + 'px';
					} else {
						bmS.display = 'none';
						beS.display = 'none';
					}
				}
			}
		}

		dx = btnContainerMargin; // Reset to adjust for placement within buttonContainer which is offset.

		if (!overrideZoom) {
			var bZO = document.getElementById('buttonZoomOut');
			if (bZO) {
				Z.Utils.buttonSize(bZO, btnW, btnH);
				var bzoS = bZO.style;
				bzoS.left = dx + 'px';
				bzoS.top = btnTOffset + 'px';
				dx += btnSpan;
			}
			trsZ = document.getElementById('trackSliderZoom');
			btsZ = document.getElementById('buttonSliderZoom');
			if (trsZ && btsZ) {
				trszS = trsZ.style;
				btszS = btsZ.style;
				if (trszS && btszS) {
					if (!overrideSliderZoom) {
						trszS.display = 'inline-block';
						btszS.display = 'inline-block';
						Z.Utils.graphicSize(trsZ, sldrTrkW, sldrTrkH);
						trszS.left = (dx - 2) + 'px';
						trszS.top = sldrTrkTOffset + 'px';
						Z.Utils.buttonSize(btsZ, sldrBtnW, sldrBtnH);
						btszS.left = parseFloat(trszS.left) + 'px';
						btszS.top = btnSldrTOffset + 'px';
						dx += sldrSpan;
					} else {
						trszS.display = 'none';
						btszS.display = 'none';
					}
				}
			}
			var bZI = document.getElementById('buttonZoomIn');
			if (bZI) {
				Z.Utils.buttonSize(bZI, btnW, btnH);
				var bziS = bZI.style;
				bziS.left = dx + 'px';
				bziS.top = btnTOffset + 'px';
				dx += btnSpan + 1;
			}
		}

		if (!overridePan) {
			var pnD = document.getElementById('panDivider');
			if (pnD) {
				Z.Utils.graphicSize(pnD, dvdrW, dvdrH);
				var pndS = pnD.style;
				pndS.left = dx + 'px';
				pndS.top = dvdrTOffset + 'px';
				dx += dvdrSpan;
			}
			var bPL = document.getElementById('buttonPanLeft');
			if (bPL) {
				Z.Utils.buttonSize(bPL, btnW, btnH);
				var bplS = bPL.style;
				bplS.left = dx + 'px';
				bplS.top = btnTOffset + 'px';
				dx += btnSpan;
			}
			var bPU = document.getElementById('buttonPanUp');
			if (bPU) {
				Z.Utils.buttonSize(bPU, btnW, btnH);
				var bpuS = bPU.style;
				bpuS.left = dx + 'px';
				bpuS.top = btnTOffset + 'px';
				dx += btnSpan;
			}
			var bPD = document.getElementById('buttonPanDown');
			if (bPD) {
				Z.Utils.buttonSize(bPD, btnW, btnH);
				var bpdS = bPD.style;
				bpdS.left = dx + 'px';
				bpdS.top = btnTOffset + 'px';
				dx += btnSpan;
			}
			var bPR = document.getElementById('buttonPanRight');
			if (bPR) {
				Z.Utils.buttonSize(bPR, btnW, btnH);
				var bprS = bPR.style;
				bprS.left = dx + 'px';
				bprS.top = btnTOffset + 'px';
				dx += btnSpan;
			}
		}
		if (!overrideReset) {
			var bR = document.getElementById('buttonReset');
			if (bR) {
				Z.Utils.buttonSize(bR, btnW, btnH);
				var brS = bR.style;
				brS.left = dx + 'px';
				brS.top = btnTOffset + 'px';
				dx += btnSpan + 1;
			}
		}

		var fvD = document.getElementById('fullViewDivider');
		if (fvD) {
			Z.Utils.graphicSize(fvD, dvdrW, dvdrH);
			var fvdS = fvD.style;
			fvdS.left = dx + 'px';
			fvdS.top = dvdrTOffset + 'px';
			dx += dvdrSpan;
		}
		var bFVE = document.getElementById('buttonFullViewExit');
		if (bFVE) {
			Z.Utils.buttonSize(bFVE, btnW, btnH);
			var bfveS = bFVE.style;
			bfveS.left = dx + 'px';
			bfveS.top = btnTOffset + 'px';

			// Set full view or full view exit button visible based on full view status.
			bfveS.display = (Z.fullView) ? 'inline-block' : 'none';
		}
		var bFV = document.getElementById('buttonFullView');
		if (bFV) {
			Z.Utils.buttonSize(bFV, btnW, btnH);
			var bfvS = bFV.style;
			bfvS.left = dx + 'px';
			bfvS.top = btnTOffset + 'px';
			dx += btnSpan + 1;

			// Set measure or measure exit button visible based on full view status.
			bfvS.display = (Z.fullView) ? 'none' : 'inline-block';
		}

		var mD = document.getElementById('measureDivider');
		if (mD) {
			Z.Utils.graphicSize(mD, dvdrW, dvdrH);
			var mdS = mD.style;
			mdS.left = dx + 'px';
			mdS.top = dvdrTOffset + 'px';
			dx += dvdrSpan;
		}
		if (Z.editMode === null) {
			var bME = document.getElementById('buttonMeasureExit');
			if (bME) {
				Z.Utils.buttonSize(bME, btnW, btnH);
				var bmeS = bME.style;
				bmeS.left = dx + 'px';
				bmeS.top = btnTOffset + 'px';

				// Set measure or measure exit button visible based on measuring status.
				bmeS.display = (Z.labelMode == 'measure') ? 'inline-block' : 'none';
			}
		}
		var bM = document.getElementById('buttonMeasure');
		if (bM) {
			Z.Utils.buttonSize(bM, btnW, btnH);
			var bmS = bM.style;
			bmS.left = dx + 'px';
			bmS.top = btnTOffset + 'px';
			dx += btnSpan + 1;

			// Set measure or measure exit button visible based on measuring status.
			bmS.display = (Z.labelMode == 'measure') ? 'none' : 'inline-block';
		}

		var rD = document.getElementById('rotateDivider');
		if (rD ) {
			Z.Utils.graphicSize(rD, dvdrW, dvdrH);
			var rdS = rD.style;
			rdS.left = dx + 'px';
			rdS.top = dvdrTOffset + 'px';
			dx += dvdrSpan;
			var bRCCW = document.getElementById('buttonRotateCounterwise');
			if (bRCCW) {
				Z.Utils.buttonSize(bRCCW, btnW, btnH);
				var brccwS = bRCCW.style;
				brccwS.left = dx + 'px';
				brccwS.top = btnTOffset + 'px';
				dx += btnSpan;
			}
			var bRCW = document.getElementById('buttonRotateClockwise');
			if (bRCW) {
				Z.Utils.buttonSize(bRCW, btnW, btnH);
				var brcwS = bRCW.style;
				brcwS.left = dx + 'px';
				brcwS.top = btnTOffset + 'px';
				dx += btnSpan + 1;
			}
		}

		// Add either tour or slideshow buttons.
		if (Z.tour) {
			var trD = document.getElementById('tourDivider');
			if (trD) {
				Z.Utils.graphicSize(trD, dvdrW, dvdrH);
				var trdS = trD.style;
				trdS.left = dx + 'px';
				trdS.top = dvdrTOffset + 'px';
				dx += dvdrSpan;
				var bTP = document.getElementById('buttonTourPrior');
				if (bTP) {
					Z.Utils.buttonSize(bTP, btnW, btnH);
					var btpS = bTP.style;
					btpS.left = dx + 'px';
					btpS.top = btnTOffset + 'px';
					dx += btnSpan + 1;
				}
				var bTN = document.getElementById('buttonTourNext');
				if (bTN) {
					Z.Utils.buttonSize(bTN, btnW, btnH);
					var btnS = bTN.style;
					btnS.left = dx + 'px';
					btnS.top = btnTOffset + 'px';
					dx += btnSpan + 1;
				}
				var bTRS = document.getElementById('buttonTourStop');
				if (bTRS) {
					Z.Utils.buttonSize(bTRS, btnW, btnH);
					var btrsS = bTRS.style;
					btrsS.left = dx + 'px';
					btrsS.top = btnTOffset + 'px';

					// Set start or stop button visible based on tour playing status.
					btrsS.display = (Z.tourPlaying) ? 'inline-block' : 'none';
				}
				// Do not increment dx so place Show button on Hide button.
				var bTRST = document.getElementById('buttonTourStart');
				if (bTRST) {
					Z.Utils.buttonSize(bTRST, btnW, btnH);
					var btrstS = bTRST.style;
					btrstS.left = dx + 'px';
					btrstS.top = btnTOffset + 'px';
					dx += btnSpan + 1;

					// Set start or stop button visible based on tour playing status.
					btrstS.display = (Z.tourPlaying) ? 'none' : 'inline-block';
				}
			}
		} else if (Z.slideshow) {
			var sSD = document.getElementById('slideshowDivider');
			if (sSD) {
				Z.Utils.graphicSize(sSD, dvdrW, dvdrH);
				var ssdS = sSD.style;
				ssdS.left = dx + 'px';
				ssdS.top = dvdrTOffset + 'px';
				dx += dvdrSpan;
				var bSSP = document.getElementById('buttonSlideshowPrior');
				if (bSSP) {
					Z.Utils.buttonSize(bSSP, btnW, btnH);
					var bsspS = bSSP.style;
					bsspS.left = dx + 'px';
					bsspS.top = btnTOffset + 'px';
					dx += btnSpan + 1;
				}
				var bSSN = document.getElementById('buttonSlideshowNext');
				if (bSSN) {
					Z.Utils.buttonSize(bSSN, btnW, btnH);
					var bssnS = bSSN.style;
					bssnS.left = dx + 'px';
					bssnS.top = btnTOffset + 'px';
					dx += btnSpan + 1;
				}
				var bSSS = document.getElementById('buttonSlideshowStop');
				if (bSSS) {
					Z.Utils.buttonSize(bSSS, btnW, btnH);
					var bsssS = bSSS.style;
					bsssS.left = dx + 'px';
					bsssS.top = btnTOffset + 'px';

					// Set start or stop button visible based on slideshow playing status.
					bsssS.display = (Z.slideshowPlaying) ? 'inline-block' : 'none';
				}
				// Do not increment dx so place Show button on Hide button.
				var bSSST = document.getElementById('buttonSlideshowStart');
				if (bSSST) {
					Z.Utils.buttonSize(bSSST, btnW, btnH);
					var bssstS = bSSST.style;
					bssstS.left = dx + 'px';
					bssstS.top = btnTOffset + 'px';
					dx += btnSpan + 1;

					// Set start or stop button visible based on slideshow playing status.
					bssstS.display = (Z.slideshowPlaying) ? 'none' : 'inline-block';
				}
			}
		} else if (Z.imageSetPath !== null && !Z.comparison) {
			var iSD = document.getElementById('imageSetDivider');
			if (iSD) {
				Z.Utils.graphicSize(iSD, dvdrW, dvdrH);
				var isdS = iSD.style;
				isdS.left = dx + 'px';
				isdS.top = dvdrTOffset + 'px';
				dx += dvdrSpan;
			}
			var bISP = document.getElementById('buttonImageSetPrior');
			if (bISP) {
				Z.Utils.buttonSize(bISP, btnW, btnH);
				var bispS = bISP.style;
				bispS.left = dx + 'px';
				bispS.top = btnTOffset + 'px';
				dx += btnSpan + 1;
			}
			trsiS = document.getElementById('trackSliderImageSet');
			btsiS = document.getElementById('buttonSliderImageSet');
			if (trsiS && btsiS) {
				trsisS = trsiS.style;
				btsisS = btsiS.style;
				if (trsisS && btsisS) {
					if (!overrideSliderImageSet) {
						trsisS.display = 'inline-block';
						btsisS.display = 'inline-block';
						Z.Utils.graphicSize(trsiS, imageSetSldrTrkW, imageSetSldrTrkH);
						trsisS.left = (dx - 2) + 'px';
						trsisS.top = sldrTrkTOffset + 'px';
						Z.Utils.buttonSize(btsiS, sldrBtnW, sldrBtnH);
						btsisS.left = parseFloat(trsisS.left) + 'px';
						btsisS.top = btnSldrTOffset + 'px';
						dx += sldrStackSpan;
					} else {
						trsisS.display = 'none';
						btsisS.display = 'none';
					}
				}
			}
			var bISN = document.getElementById('buttonImageSetNext');
			if (bISN) {
				Z.Utils.buttonSize(bISN, btnW, btnH);
				var bisnS = bISN.style;
				bisnS.left = dx + 'px';
				bisnS.top = btnTOffset + 'px';
				dx += btnSpan + 1;
			}
		}

		// Add either audio buttons if adding tour or slideshow buttons, but Hide both buttons
		// until tour or slideshow XML is parsed and can determine if audio content exists.
		if (Z.tour || Z.slideshow) {
			var bAM = document.getElementById('buttonAudioMuted');
			if (bAM) {
				Z.Utils.buttonSize(bAM, btnW, btnH);
				var bamS = bAM.style;
				bamS.left = dx + 'px';
				bamS.top = btnTOffset + 'px';
				bamS.display = 'none';
			}
			// Do not increment dx so place On button on Mute button.
			var bAO = document.getElementById('buttonAudioOn');
			if (bAO) {
				Z.Utils.buttonSize(bAO, btnW, btnH);
				var baoS = bAO.style;
				baoS.left = dx + 'px';
				baoS.top = btnTOffset + 'px';
				dx += btnSpan + 1;
				baoS.display = 'none';
			}
			tbViewport.initializeAudioMuteButtons();
		}

		// Add filter panel.
		if (Z.imageFilters) {
			var ifD = document.getElementById('imageFilterDivider');
			if (ifD ) {
				Z.Utils.graphicSize(ifD, dvdrW, dvdrH);
				var ifdS = ifD.style;
				ifdS.left = dx + 'px';
				ifdS.top = dvdrTOffset + 'px';
				dx += dvdrSpan;
				var bFPH = document.getElementById('buttonImageFilterPanelHide');
				if (bFPH) {
					Z.Utils.buttonSize(bFPH, btnW, btnH);
					var bfphS = bFPH.style;
					bfphS.left = dx + 'px';
					bfphS.top = btnTOffset + 'px';

					// Set Show or Hide button on top.
					bfphS.display = (imageFilterPanelVisible) ? 'inline-block' : 'none';
				}
				// Do not increment dx so place Show button on Hide button.
				var bFPS = document.getElementById('buttonImageFilterPanelShow');
				if (bFPS) {
					Z.Utils.buttonSize(bFPS, btnW, btnH);
					var bfpsS = bFPS.style;
					bfpsS.left = dx + 'px';
					bfpsS.top = btnTOffset + 'px';
					dx += btnSpan + 1;

					// Set Hide or Show button on top.
					bfpsS.display = (imageFilterPanelVisible) ? 'none' : 'inline-block';
				}

				drawLayoutImageFilterPanel();
			}
		}

		if (Z.preloadVisible) {
			var pD = document.getElementById('preloadDivider');
			var bP = document.getElementById('buttonPreload');
			if (pD && bP) {
				Z.Utils.graphicSize(pD, dvdrW, dvdrH);
				var pdS = pD.style;
				pdS.top = dvdrTOffset + 'px';
				if (!Z.imageSet) {
					pdS.left = dx + 'px';
					dx += dvdrSpan;
				}
				Z.Utils.buttonSize(bP, btnW, btnH);
				var bpS = bP.style;
				bpS.left = dx + 'px';
				bpS.top = btnTOffset + 'px';
				dx += btnSpan;
				if (Z.imageSet) {
					pdS.left = dx + 'px';
					dx += dvdrSpan;
				}
				dx += 8;
			}
		}

		if (Z.helpVisible == 1 || Z.helpVisible == 3) {
			var bH = document.getElementById('buttonHelp');
			if (bH) {
				Z.Utils.buttonSize(bH, btnW, btnH);
				var bhS = bH.style;
				bhS.left = dx + 'px';
				bhS.top = btnTOffset + 'px';
				dx += btnSpan + 8;
			}
		}
	
	 	if (Z.comparison && Z.syncVisible) {
			var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_TOOLBARLABELFONTSIZE'), 10);
			var labelW = 28;
			var labelH = 20;
			var adjLabel = 3;
			var tbLSY = document.getElementById('labelSyncTextBox');
			var cCBSY = document.getElementById('containerFor-checkboxSyncComparison');
			var cbSY = document.getElementById('checkboxSyncComparison');
			if (tbLSY && cCBSY && cbSY) {
				var tblsyS = tbLSY.style;
				tblsyS.width = labelW + 'px';
				tblsyS.height = labelH + 'px';
				tblsyS.left = dx + 'px';
				tblsyS.top = btnTOffset + adjLabel + 'px';
				tblsyS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLSY, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var ccbsyS = cCBSY.style;
				ccbsyS.width = (btnW * 1.5) + 'px';
				ccbsyS.height = (btnH * 1.5) + 'px';
				ccbsyS.left = (dx + labelW + 3) + 'px';
				ccbsyS.top = btnTOffset - adjLabel + 'px';
				cbSY.width = btnW;
				cbSY.height = btnH;
				cbSY.checked = Z.initialSync;
			}
		}

		var ptB = document.getElementById('progressTextBox');
		if (ptB) {
			var ptbS = ptB.style;
			if (ptbS) {
				if (!overrideProgress) {
					ptbS.display = 'inline-block';
					ptbS.width = prgW + 'px';
					ptbS.height = prgH + 'px';
					ptbS.left = (toolbarW - parseFloat(bC.style.left) - parseFloat(ptbS.width)) + 'px';
					ptbS.top = ((toolbarH - parseFloat(ptbS.height)) / 2) + 'px';
				} else {
					ptbS.display = 'none';
				}
			}
		}
	}

	function drawLayoutImageFilterPanel () {
		 // Set layout sizes.
		var marginEdgeL = 15;
		var marginEdgeT = 10;
		var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_IMAGEFILTERPANELLABELFONTSIZE'), 10);
		var textFontSize = parseInt(Z.Utils.getResource('DEFAULT_IMAGEFILTERPANELTEXTFONTSIZE'), 10);
		var textPaddingSmall = parseInt(Z.Utils.getResource('DEFAULT_IMAGEFILTERTEXTPADDINGSMALL'), 10);

		 // Set remaining values to the values in the Skins XML file.
		var btnW = toolbarSkinSizes[6];
		var btnH = toolbarSkinSizes[7];
		var btnSpan = toolbarSkinSizes[8];
		var dvdrW = toolbarSkinSizes[4];
		var dvdrH = toolbarSkinSizes[5];
		var sldrTrkW = toolbarSkinSizes[11];
		var sldrTrkH = toolbarSkinSizes[12];
		var sldrBtnW = toolbarSkinSizes[9];
		var sldrBtnH = toolbarSkinSizes[10];
		var sldrSpan = toolbarSkinSizes[13];
		var fmH = toolbarSkinSizes[15];

		// Calculate positioning values.
		var btnT = marginEdgeT + 2;
		var dvdrSpan = btnSpan - (btnW - dvdrW);
		var dvdrTOffset = (btnH - dvdrH) / 2;
		var sldrTrkTOffset = marginEdgeT + 8;
		var labelW = 90;
		var labelH = 20;
		var adjLabel = 3;
		var fmW = 50;
		var textW = 37;
		var textH = 14;
		var imageFilterListW = parseInt(Z.Utils.getResource('DEFAULT_IMAGEFILTERLISTWIDTH'), 10);
		var filterSliderCount = (Z.brightnessVisible + Z.contrastVisible + Z.sharpnessVisible + Z.blurrinessVisible + Z.colorRedVisible + Z.colorGreenVisible + Z.colorBlueVisible + Z.colorRedRangeVisible + Z.colorGreenRangeVisible + Z.colorBlueRangeVisible +Z.gammaVisible + Z.gammaRedVisible + Z.gammaGreenVisible + Z.gammaBlueVisible + Z.hueVisible + Z.saturationVisible + Z.lightnessVisible + Z.whiteBalanceVisible + Z.noiseVisible);
		var filterSlidersHeight = (btnH + adjLabel * 2) + ((textH + adjLabel + 1) * filterSliderCount) + 10;
		var filterCheckBoxCount = (Z.grayscaleVisible + Z.thresholdVisible + Z.inversionVisible + Z.normalizeVisible + Z.equalizeVisible + Z.edgesVisible + Z.sepiaVisible);
		var filterCheckBoxesHeight = (btnH + adjLabel * 2) * filterCheckBoxCount;
		var filtersTaller = Math.max(filterSlidersHeight, filterCheckBoxesHeight);
		var factorW = (filterCheckBoxCount > 0) ? 2 : 0.96;

		// If range filters, widen slider. If no wide text labels, widen slider more.
		var rangeAdj = (Z.colorRedRangeVisible || Z.colorGreenRangeVisible || Z.colorBlueRangeVisible) ? 100 : 0;
		var rangeAdj2 = !(Z.colorRedVisible || Z.colorGreenVisible || Z.colorBlueVisible || Z.whiteBalanceVisible || Z.gammaRedVisible || Z.gammaGreenVisible || Z.gammaBlueVisible) ? 30 : 0;
		sldrTrkW += (rangeAdj + rangeAdj2);
		sldrSpan += (rangeAdj + rangeAdj2);
		var secondTextElement = (Z.colorRedRangeVisible || Z.colorGreenRangeVisible || Z.colorBlueRangeVisible) ? textW + 5 : 0;
		labelW -= rangeAdj2;

		var panelW = imageFilterPanelW = Math.round(labelW * factorW + sldrTrkW + btnSpan * 2 + btnSpan * factorW + dvdrSpan * factorW + marginEdgeL * factorW - 4 + secondTextElement);
		var panelH = (marginEdgeT * 2 + dvdrH) + filtersTaller;
		var sectionDvdrH = panelH - dvdrH - marginEdgeT * 3.8;
		var panelDvdrW = panelW - marginEdgeL - btnW;
		var panelDvdrH = dvdrW;
		var panelDvdrT = panelH - marginEdgeT - btnH * 1.9;
		var listL = marginEdgeL + 5;
		var listT = panelH - marginEdgeT - btnH - 1;
		var dx = marginEdgeL;
		dy = sldrTrkTOffset + 2;

		// Size filter panel and position above and left of calling button in toolbar.
		var bFPS = document.getElementById('buttonImageFilterPanelShow');
		var bCIF = document.getElementById('buttonContainerImageFilter');
		var cliF = document.getElementById('imageFilterList');
		if (bCIF && bFPS && cliF) {
			var bfpsL = parseFloat(bFPS.style.left);
			var bfpspL = parseFloat(bFPS.parentNode.style.left);
			var bcifS = bCIF.style;
			bcifS.width = panelW + 'px';
			bcifS.height = panelH + 'px';
			bcifS.left = bfpsL + bfpspL + btnSpan - panelW + 'px';
			bcifS.top = -(panelH + marginEdgeT / 2) + 'px';
			var bGF = document.getElementById('imageFilterPanelBackground');
			if (bGF) {
				var bgfS = bGF.style;
				bgfS.width = panelW + 'px';
				bgfS.height = panelH + 'px';
			}

			// Image filter list includes filter history.
			var clifS = cliF.style;
			//clifS.display = 'none'; // Alternative implementation: Hide list.
			clifS.width = imageFilterListW + 'px';
			clifS.left = listL + 'px';
			clifS.top = listT + 'px';

			var lBTB = document.getElementById('labelBrightnessTextBox');
			trsFB = document.getElementById('trackSliderFilterBrightness');
			btfB = document.getElementById('buttonSliderFilterBrightness');
			var tbFBTE = document.getElementById('textBoxFor-brightnessTextElement');
			if (lBTB && trsFB && btfB && tbFBTE) {
				lfbtbS = lBTB.style;
				trsfbS = trsFB.style;
				btfbS = btfB.style;
				tbfbteS = tbFBTE.style;
				if (lfbtbS && trsfbS && btfbS && tbfbteS) {
					lfbtbS.width = labelW + 'px';
					lfbtbS.height = labelH + 'px';
					lfbtbS.left = dx + 'px';
					lfbtbS.top = dy - adjLabel + 'px';
					lfbtbS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lBTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfbS.display = 'inline-block';
					btfbS.display = 'inline-block';
					Z.Utils.graphicSize(trsFB, sldrTrkW, sldrTrkH);
					trsfbS.left = dx + labelW + 3 + 'px';
					trsfbS.top = dy + 'px';
					Z.Utils.buttonSize(btfB, sldrBtnW, sldrBtnH);
					btfbS.left = parseFloat(trsfbS.left) + 'px'; // Reset below.
					btfbS.top = dy - 4 + 'px';
					tbfbteS.width = textW + 'px';
					tbfbteS.height = textH + 'px';
					tbfbteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfbteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFBTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lCTB = document.getElementById('labelContrastTextBox');
			trsFC = document.getElementById('trackSliderFilterContrast');
			btfC = document.getElementById('buttonSliderFilterContrast');
			var tbFCTE = document.getElementById('textBoxFor-contrastTextElement');
			if (lCTB && trsFC && btfC && tbFCTE) {
				lfctbS = lCTB.style;
				trsfcS = trsFC.style;
				btfcS = btfC.style;
				tbfcteS = tbFCTE.style;
				if (lfctbS && trsfcS && btfcS && tbfcteS) {
					lfctbS.width = labelW + 'px';
					lfctbS.height = labelH + 'px';
					lfctbS.left = dx + 'px';
					lfctbS.top = dy - adjLabel + 'px';
					lfctbS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lCTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfcS.display = 'inline-block';
					btfcS.display = 'inline-block';
					Z.Utils.graphicSize(trsFC, sldrTrkW, sldrTrkH);
					trsfcS.left = dx + labelW + 3 + 'px';
					trsfcS.top = dy + 'px';
					Z.Utils.buttonSize(btfC, sldrBtnW, sldrBtnH);
					btfcS.left = parseFloat(trsfcS.left) + 'px';
					btfcS.top = dy - 4 + 'px';
					tbfcteS.width = textW + 'px';
					tbfcteS.height = textH + 'px';
					tbfcteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfcteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lSTB = document.getElementById('labelSharpnessTextBox');
			trsFS = document.getElementById('trackSliderFilterSharpness');
			btfS = document.getElementById('buttonSliderFilterSharpness');
			var tbFSTE = document.getElementById('textBoxFor-sharpnessTextElement');
			if (lSTB && trsFS && btfS && tbFSTE) {
				lfstbS = lSTB.style;
				trsfsS = trsFS.style;
				btfsS = btfS.style;
				tbfsteS = tbFSTE.style;
				if (lfstbS && trsfsS && btfsS && tbfsteS) {
					lfstbS.width = labelW + 'px';
					lfstbS.height = labelH + 'px';
					lfstbS.left = dx + 'px';
					lfstbS.top = dy - adjLabel + 'px';
					lfstbS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lSTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfsS.display = 'inline-block';
					btfsS.display = 'inline-block';
					Z.Utils.graphicSize(trsFS, sldrTrkW, sldrTrkH);
					trsfsS.left = dx + labelW + 3 + 'px';
					trsfsS.top = dy + 'px';
					Z.Utils.buttonSize(btfS, sldrBtnW, sldrBtnH);
					btfsS.left = parseFloat(trsfsS.left) + 'px';
					btfsS.top = dy - 4 + 'px';
					tbfsteS.width = textW + 'px';
					tbfsteS.height = textH + 'px';
					tbfsteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfsteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFSTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lBLTB = document.getElementById('labelBlurrinessTextBox');
			trsFBL = document.getElementById('trackSliderFilterBlurriness');
			btfBL = document.getElementById('buttonSliderFilterBlurriness');
			var tbFBLTE = document.getElementById('textBoxFor-blurrinessTextElement');
			if (lBLTB && trsFBL && btfBL && tbFBLTE) {
				lfblbS = lBLTB.style;
				trsfblS = trsFBL.style;
				btfblS = btfBL.style;
				tbfblteS = tbFBLTE.style;
				if (lfblbS && trsfblS && btfblS && tbfblteS) {
					lfblbS.width = labelW + 'px';
					lfblbS.height = labelH + 'px';
					lfblbS.left = dx + 'px';
					lfblbS.top = dy - adjLabel + 'px';
					lfblbS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lBLTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfblS.display = 'inline-block';
					btfblS.display = 'inline-block';
					Z.Utils.graphicSize(trsFBL, sldrTrkW, sldrTrkH);
					trsfblS.left = dx + labelW + 3 + 'px';
					trsfblS.top = dy + 'px';
					Z.Utils.buttonSize(btfBL, sldrBtnW, sldrBtnH);
					btfblS.left = parseFloat(trsfblS.left) + 'px';
					btfblS.top = dy - 4 + 'px';
					tbfblteS.width = textW + 'px';
					tbfblteS.height = textH + 'px';
					tbfblteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfblteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFBLTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lCRTB = document.getElementById('labelColorRedTextBox');
			trsFCR = document.getElementById('trackSliderFilterColorRed');
			btfCR = document.getElementById('buttonSliderFilterColorRed');
			var tbFCRTE = document.getElementById('textBoxFor-colorRedTextElement');
			if (lCRTB && trsFCR && btfCR && tbFCRTE) {
				lfbtcrS = lCRTB.style;
				trsfcrS = trsFCR.style;
				btfcrS = btfCR.style;
				tbfcrteS = tbFCRTE.style;
				if (lfbtcrS && trsfcrS && btfcrS && tbfcrteS) {
					lfbtcrS.width = labelW + 'px';
					lfbtcrS.height = labelH + 'px';
					lfbtcrS.left = dx + 'px';
					lfbtcrS.top = dy - adjLabel + 'px';
					lfbtcrS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lCRTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfcrS.display = 'inline-block';
					btfcrS.display = 'inline-block';
					Z.Utils.graphicSize(trsFCR, sldrTrkW, sldrTrkH);
					trsfcrS.left = dx + labelW + 3 + 'px';
					trsfcrS.top = dy + 'px';
					Z.Utils.buttonSize(btfCR, sldrBtnW, sldrBtnH);
					btfcrS.left = parseFloat(trsfcrS.left) + 'px'; // Reset below.
					btfcrS.top = dy - 4 + 'px';
					tbfcrteS.width = textW + 'px';
					tbfcrteS.height = textH + 'px';
					tbfcrteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfcrteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCRTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lCGTB = document.getElementById('labelColorGreenTextBox');
			trsFCG = document.getElementById('trackSliderFilterColorGreen');
			btfCG = document.getElementById('buttonSliderFilterColorGreen');
			var tbFCGTE = document.getElementById('textBoxFor-colorGreenTextElement');
			if (lCGTB && trsFCG && btfCG && tbFCGTE) {
				lfbtcgS = lCGTB.style;
				trsfcgS = trsFCG.style;
				btfcgS = btfCG.style;
				tbfcgteS = tbFCGTE.style;
				if (lfbtcgS && trsfcgS && btfcgS && tbfcgteS) {
					lfbtcgS.width = labelW + 'px';
					lfbtcgS.height = labelH + 'px';
					lfbtcgS.left = dx + 'px';
					lfbtcgS.top = dy - adjLabel + 'px';
					lfbtcgS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lCGTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfcgS.display = 'inline-block';
					btfcgS.display = 'inline-block';
					Z.Utils.graphicSize(trsFCG, sldrTrkW, sldrTrkH);
					trsfcgS.left = dx + labelW + 3 + 'px';
					trsfcgS.top = dy + 'px';
					Z.Utils.buttonSize(btfCG, sldrBtnW, sldrBtnH);
					btfcgS.left = parseFloat(trsfcgS.left) + 'px'; // Reset below.
					btfcgS.top = dy - 4 + 'px';
					tbfcgteS.width = textW + 'px';
					tbfcgteS.height = textH + 'px';
					tbfcgteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfcgteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCGTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lCBTB = document.getElementById('labelColorBlueTextBox');
			trsFCB = document.getElementById('trackSliderFilterColorBlue');
			btfCB = document.getElementById('buttonSliderFilterColorBlue');
			var tbFCBTE = document.getElementById('textBoxFor-colorBlueTextElement');
			if (lCBTB && trsFCB && btfCB && tbFCBTE) {
				lfbtcbS = lCBTB.style;
				trsfcbS = trsFCB.style;
				btfcbS = btfCB.style;
				tbfcbteS = tbFCBTE.style;
				if (lfbtcbS && trsfcbS && btfcbS && tbfcbteS) {
					lfbtcbS.width = labelW + 'px';
					lfbtcbS.height = labelH + 'px';
					lfbtcbS.left = dx + 'px';
					lfbtcbS.top = dy - adjLabel + 'px';
					lfbtcbS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lCBTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfcbS.display = 'inline-block';
					btfcbS.display = 'inline-block';
					Z.Utils.graphicSize(trsFCB, sldrTrkW, sldrTrkH);
					trsfcbS.left = dx + labelW + 3 + 'px';
					trsfcbS.top = dy + 'px';
					Z.Utils.buttonSize(btfCB, sldrBtnW, sldrBtnH);
					btfcbS.left = parseFloat(trsfcbS.left) + 'px'; // Reset below.
					btfcbS.top = dy - 4 + 'px';
					tbfcbteS.width = textW + 'px';
					tbfcbteS.height = textH + 'px';
					tbfcbteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfcbteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCBTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lCRRTB = document.getElementById('labelColorRedRangeTextBox');
			trsFCRR = document.getElementById('trackSliderFilterColorRedRange');
			btfCRR = document.getElementById('buttonSliderFilterColorRedRange');
			btfCRR2 = document.getElementById('buttonSliderFilterColorRedRange2');
			var tbFCRRTE = document.getElementById('textBoxFor-colorRedRangeTextElement');
			var tbFCRRTE2 = document.getElementById('textBoxFor-colorRedRangeTextElement2');
			if (lCRRTB && trsFCRR && btfCRR && btfCRR2 && tbFCRRTE && tbFCRRTE2) {
				lfbtcrrS = lCRRTB.style;
				trsfcrrS = trsFCRR.style;
				btfcrrS = btfCRR.style;
				btfcrr2S = btfCRR2.style;
				tbfcrrteS = tbFCRRTE.style;
				tbfcrrte2S = tbFCRRTE2.style;
				if (lfbtcrrS && trsfcrrS && btfcrrS && btfcrr2S && tbfcrrteS && tbfcrrte2S) {
					lfbtcrrS.width = labelW + 'px';
					lfbtcrrS.height = labelH + 'px';
					lfbtcrrS.left = dx + 'px';
					lfbtcrrS.top = dy - adjLabel + 'px';
					lfbtcrrS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lCRRTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfcrrS.display = 'inline-block';
					btfcrrS.display = 'inline-block';
					Z.Utils.graphicSize(trsFCRR, sldrTrkW, sldrTrkH);
					trsfcrrS.left = dx + labelW + 3 + 'px';
					trsfcrrS.top = dy + 'px';
					Z.Utils.buttonSize(btfCRR, sldrBtnW, sldrBtnH);
					btfcrrS.left = parseFloat(trsfcrrS.left) + 'px'; // Reset below.
					btfcrrS.top = dy - 4 + 'px';
					Z.Utils.buttonSize(btfCRR2, sldrBtnW, sldrBtnH);
					btfcrr2S.left = parseFloat(trsfcrrS.left) + 50 + 'px'; // Reset below.
					btfcrr2S.top = dy - 4 + 'px';
					tbfcrrteS.width = textW + 'px';
					tbfcrrteS.height = textH + 'px';
					tbfcrrteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfcrrteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCRRTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					tbfcrrte2S.width = textW + 'px';
					tbfcrrte2S.height = textH + 'px';
					tbfcrrte2S.left = dx + labelW + 3 + sldrSpan + textW + 5 + 'px';
					tbfcrrte2S.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCRRTE2, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lCGRTB = document.getElementById('labelColorGreenRangeTextBox');
			trsFCGR = document.getElementById('trackSliderFilterColorGreenRange');
			btfCGR = document.getElementById('buttonSliderFilterColorGreenRange');
			btfCGR2 = document.getElementById('buttonSliderFilterColorGreenRange2');
			var tbFCGRTE = document.getElementById('textBoxFor-colorGreenRangeTextElement');
			var tbFCGRTE2 = document.getElementById('textBoxFor-colorGreenRangeTextElement2');
			if (lCGRTB && trsFCGR && btfCGR && btfCGR2 && tbFCGRTE && tbFCGRTE2) {
				lfbtcgrS = lCGRTB.style;
				trsfcgrS = trsFCGR.style;
				btfcgrS = btfCGR.style;
				btfcgr2S = btfCGR2.style;
				tbfcgrteS = tbFCGRTE.style;
				tbfcgrte2S = tbFCGRTE2.style;
				if (lfbtcgrS && trsfcgrS && btfcgrS && btfcgr2S && tbfcgrteS && tbfcgrte2S) {
					lfbtcgrS.width = labelW + 'px';
					lfbtcgrS.height = labelH + 'px';
					lfbtcgrS.left = dx + 'px';
					lfbtcgrS.top = dy - adjLabel + 'px';
					lfbtcgrS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lCGRTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfcgrS.display = 'inline-block';
					btfcgrS.display = 'inline-block';
					Z.Utils.graphicSize(trsFCGR, sldrTrkW, sldrTrkH);
					trsfcgrS.left = dx + labelW + 3 + 'px';
					trsfcgrS.top = dy + 'px';
					Z.Utils.buttonSize(btfCGR, sldrBtnW, sldrBtnH);
					btfcgrS.left = parseFloat(trsfcgrS.left) + 'px'; // Reset below.
					btfcgrS.top = dy - 4 + 'px';
					Z.Utils.buttonSize(btfCGR2, sldrBtnW, sldrBtnH);
					btfcgr2S.left = parseFloat(trsfcrrS.left) + 50 + 'px'; // Reset below.
					btfcgr2S.top = dy - 4 + 'px';
					tbfcgrteS.width = textW + 'px';
					tbfcgrteS.height = textH + 'px';
					tbfcgrteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfcgrteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCGRTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					tbfcgrte2S.width = textW + 'px';
					tbfcgrte2S.height = textH + 'px';
					tbfcgrte2S.left = dx + labelW + 3 + sldrSpan + textW + 5 + 'px';
					tbfcgrte2S.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCGRTE2, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lCBRTB = document.getElementById('labelColorBlueRangeTextBox');
			trsFCBR = document.getElementById('trackSliderFilterColorBlueRange');
			btfCBR = document.getElementById('buttonSliderFilterColorBlueRange');
			btfCBR2 = document.getElementById('buttonSliderFilterColorBlueRange2');
			var tbFCBRRTE = document.getElementById('textBoxFor-colorBlueRangeTextElement');
			var tbFCBRRTE2 = document.getElementById('textBoxFor-colorBlueRangeTextElement2');
			if (lCBRTB && trsFCBR && btfCBR && btfCBR2 && tbFCBRRTE && tbFCBRRTE2) {
				lfbtcbrS = lCBRTB.style;
				trsfcbrS = trsFCBR.style;
				btfcbrS = btfCBR.style;
				btfcbr2S = btfCBR2.style;
				tbfcbrteS = tbFCBRRTE.style;
				tbfcbrte2S = tbFCBRRTE2.style;
				if (lfbtcbrS && trsfcbrS && btfcbrS && btfcbr2S && tbfcbrteS && tbfcbrte2S) {
					lfbtcbrS.width = labelW + 'px';
					lfbtcbrS.height = labelH + 'px';
					lfbtcbrS.left = dx + 'px';
					lfbtcbrS.top = dy - adjLabel + 'px';
					lfbtcbrS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lCBRTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfcbrS.display = 'inline-block';
					btfcbrS.display = 'inline-block';
					Z.Utils.graphicSize(trsFCBR, sldrTrkW, sldrTrkH);
					trsfcbrS.left = dx + labelW + 3 + 'px';
					trsfcbrS.top = dy + 'px';
					Z.Utils.buttonSize(btfCBR, sldrBtnW, sldrBtnH);
					btfcbrS.left = parseFloat(trsfcbrS.left) + 'px'; // Reset below.
					btfcbrS.top = dy - 4 + 'px';
					Z.Utils.buttonSize(btfCBR2, sldrBtnW, sldrBtnH);
					btfcbr2S.left = parseFloat(trsfcrrS.left) + 50 + 'px'; // Reset below.
					btfcbr2S.top = dy - 4 + 'px';
					tbfcbrteS.width = textW + 'px';
					tbfcbrteS.height = textH + 'px';
					tbfcbrteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfcbrteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCBRRTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					tbfcbrte2S.width = textW + 'px';
					tbfcbrte2S.height = textH + 'px';
					tbfcbrte2S.left = dx + labelW + 3 + sldrSpan + textW + 5 + 'px';
					tbfcbrte2S.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFCBRRTE2, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lGTB = document.getElementById('labelGammaTextBox');
			trsFG = document.getElementById('trackSliderFilterGamma');
			btfG = document.getElementById('buttonSliderFilterGamma');
			var tbFGTE = document.getElementById('textBoxFor-gammaTextElement');
			if (lGTB && trsFG && btfG && tbFGTE) {
				lfbtgS = lGTB.style;
				trsfgS = trsFG.style;
				btfgS = btfG.style;
				tbfgteS = tbFGTE.style;
				if (lfbtgS && trsfgS && btfgS && tbfgteS) {
					lfbtgS.width = labelW + 'px';
					lfbtgS.height = labelH + 'px';
					lfbtgS.left = dx + 'px';
					lfbtgS.top = dy - adjLabel + 'px';
					lfbtgS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lGTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfgS.display = 'inline-block';
					btfgS.display = 'inline-block';
					Z.Utils.graphicSize(trsFG, sldrTrkW, sldrTrkH);
					trsfgS.left = dx + labelW + 3 + 'px';
					trsfgS.top = dy + 'px';
					Z.Utils.buttonSize(btfG, sldrBtnW, sldrBtnH);
					btfgS.left = parseFloat(trsfgS.left) + 'px'; // Reset below.
					btfgS.top = dy - 4 + 'px';
					tbfgteS.width = textW + 'px';
					tbfgteS.height = textH + 'px';
					tbfgteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfgteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFGTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lGRTB = document.getElementById('labelGammaRedTextBox');
			trsFGR = document.getElementById('trackSliderFilterGammaRed');
			btfGR = document.getElementById('buttonSliderFilterGammaRed');
			var tbFGRTE = document.getElementById('textBoxFor-gammaRedTextElement');
			if (lGRTB && trsFGR && btfGR && tbFGRTE) {
				lfbtgrS = lGRTB.style;
				trsfgrS = trsFGR.style;
				btfgrS = btfGR.style;
				tbfgrteS = tbFGRTE.style;
				if (lfbtgrS && trsfgrS && btfgrS && tbfgrteS) {
					lfbtgrS.width = labelW + 'px';
					lfbtgrS.height = labelH + 'px';
					lfbtgrS.left = dx + 'px';
					lfbtgrS.top = dy - adjLabel + 'px';
					lfbtgrS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lGRTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfgrS.display = 'inline-block';
					btfgrS.display = 'inline-block';
					Z.Utils.graphicSize(trsFGR, sldrTrkW, sldrTrkH);
					trsfgrS.left = dx + labelW + 3 + 'px';
					trsfgrS.top = dy + 'px';
					Z.Utils.buttonSize(btfGR, sldrBtnW, sldrBtnH);
					btfgrS.left = parseFloat(trsfgrS.left) + 'px'; // Reset below.
					btfgrS.top = dy - 4 + 'px';
					tbfgrteS.width = textW + 'px';
					tbfgrteS.height = textH + 'px';
					tbfgrteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfgrteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFGRTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lGGTB = document.getElementById('labelGammaGreenTextBox');
			trsFGG = document.getElementById('trackSliderFilterGammaGreen');
			btfGG = document.getElementById('buttonSliderFilterGammaGreen');
			var tbFGGTE = document.getElementById('textBoxFor-gammaGreenTextElement');
			if (lGGTB && trsFGG && btfGG && tbFGGTE) {
				lfbtggS = lGGTB.style;
				trsfggS = trsFGG.style;
				btfggS = btfGG.style;
				tbfggteS = tbFGGTE.style;
				if (lfbtggS && trsfggS && btfggS && tbfggteS) {
					lfbtggS.width = labelW + 'px';
					lfbtggS.height = labelH + 'px';
					lfbtggS.left = dx + 'px';
					lfbtggS.top = dy - adjLabel + 'px';
					lfbtggS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lGGTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfggS.display = 'inline-block';
					btfggS.display = 'inline-block';
					Z.Utils.graphicSize(trsFGG, sldrTrkW, sldrTrkH);
					trsfggS.left = dx + labelW + 3 + 'px';
					trsfggS.top = dy + 'px';
					Z.Utils.buttonSize(btfGG, sldrBtnW, sldrBtnH);
					btfggS.left = parseFloat(trsfggS.left) + 'px'; // Reset below.
					btfggS.top = dy - 4 + 'px';
					tbfggteS.width = textW + 'px';
					tbfggteS.height = textH + 'px';
					tbfggteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfggteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFGGTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lGBTB = document.getElementById('labelGammaBlueTextBox');
			trsFGB = document.getElementById('trackSliderFilterGammaBlue');
			btfGB = document.getElementById('buttonSliderFilterGammaBlue');
			var tbFGBTE = document.getElementById('textBoxFor-gammaBlueTextElement');
			if (lGBTB && trsFGB && btfGB && tbFGBTE) {
				lfbtgbS = lGBTB.style;
				trsfgbS = trsFGB.style;
				btfgbS = btfGB.style;
				tbfgbteS = tbFGBTE.style;
				if (lfbtgbS && trsfgbS && btfgbS && tbfgbteS) {
					lfbtgbS.width = labelW + 'px';
					lfbtgbS.height = labelH + 'px';
					lfbtgbS.left = dx + 'px';
					lfbtgbS.top = dy - adjLabel + 'px';
					lfbtgbS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lGBTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfgbS.display = 'inline-block';
					btfgbS.display = 'inline-block';
					Z.Utils.graphicSize(trsFGB, sldrTrkW, sldrTrkH);
					trsfgbS.left = dx + labelW + 3 + 'px';
					trsfgbS.top = dy + 'px';
					Z.Utils.buttonSize(btfGB, sldrBtnW, sldrBtnH);
					btfgbS.left = parseFloat(trsfgbS.left) + 'px'; // Reset below.
					btfgbS.top = dy - 4 + 'px';
					tbfgbteS.width = textW + 'px';
					tbfgbteS.height = textH + 'px';
					tbfgbteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfgbteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFGBTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lHTB = document.getElementById('labelHueTextBox');
			trsFH = document.getElementById('trackSliderFilterHue');
			btfH = document.getElementById('buttonSliderFilterHue');
			var tbFHTE = document.getElementById('textBoxFor-hueTextElement');
			if (lHTB && trsFH && btfH && tbFHTE) {
				lfbthS = lHTB.style;
				trsfhS = trsFH.style;
				btfhS = btfH.style;
				tbfhteS = tbFHTE.style;
				if (lfbthS && trsfhS && btfhS && tbfhteS) {
					lfbthS.width = labelW + 'px';
					lfbthS.height = labelH + 'px';
					lfbthS.left = dx + 'px';
					lfbthS.top = dy - adjLabel + 'px';
					lfbthS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lHTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfhS.display = 'inline-block';
					btfhS.display = 'inline-block';
					Z.Utils.graphicSize(trsFH, sldrTrkW, sldrTrkH);
					trsfhS.left = dx + labelW + 3 + 'px';
					trsfhS.top = dy + 'px';
					Z.Utils.buttonSize(btfH, sldrBtnW, sldrBtnH);
					btfhS.left = parseFloat(trsfhS.left) + 'px'; // Reset below.
					btfhS.top = dy - 4 + 'px';
					tbfhteS.width = textW + 'px';
					tbfhteS.height = textH + 'px';
					tbfhteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfhteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFHTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lSATB = document.getElementById('labelSaturationTextBox');
			trsFSA = document.getElementById('trackSliderFilterSaturation');
			btfSA = document.getElementById('buttonSliderFilterSaturation');
			var tbFSATE = document.getElementById('textBoxFor-saturationTextElement');
			if (lSATB && trsFSA && btfSA && tbFSATE) {
				lfbtsaS = lSATB.style;
				trsfsaS = trsFSA.style;
				btfsaS = btfSA.style;
				tbfsateS = tbFSATE.style;
				if (lfbtsaS && trsfsaS && btfsaS && tbfsateS) {
					lfbtsaS.width = labelW + 'px';
					lfbtsaS.height = labelH + 'px';
					lfbtsaS.left = dx + 'px';
					lfbtsaS.top = dy - adjLabel + 'px';
					lfbtsaS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lSATB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfsaS.display = 'inline-block';
					btfsaS.display = 'inline-block';
					Z.Utils.graphicSize(trsFSA, sldrTrkW, sldrTrkH);
					trsfsaS.left = dx + labelW + 3 + 'px';
					trsfsaS.top = dy + 'px';
					Z.Utils.buttonSize(btfSA, sldrBtnW, sldrBtnH);
					btfsaS.left = parseFloat(trsfsaS.left) + 'px'; // Reset below.
					btfsaS.top = dy - 4 + 'px';
					tbfsateS.width = textW + 'px';
					tbfsateS.height = textH + 'px';
					tbfsateS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfsateS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFSATE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lLTB = document.getElementById('labelLightnessTextBox');
			trsFL = document.getElementById('trackSliderFilterLightness');
			btfL = document.getElementById('buttonSliderFilterLightness');
			var tbFLTE = document.getElementById('textBoxFor-lightnessTextElement');
			if (lLTB && trsFL && btfL && tbFLTE) {
				lfbtlS = lLTB.style;
				trsflS = trsFL.style;
				btflS = btfL.style;
				tbflteS = tbFLTE.style;
				if (lfbtlS && trsflS && btflS && tbflteS) {
					lfbtlS.width = labelW + 'px';
					lfbtlS.height = labelH + 'px';
					lfbtlS.left = dx + 'px';
					lfbtlS.top = dy - adjLabel + 'px';
					lfbtlS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lLTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsflS.display = 'inline-block';
					btflS.display = 'inline-block';
					Z.Utils.graphicSize(trsFL, sldrTrkW, sldrTrkH);
					trsflS.left = dx + labelW + 3 + 'px';
					trsflS.top = dy + 'px';
					Z.Utils.buttonSize(btfL, sldrBtnW, sldrBtnH);
					btflS.left = parseFloat(trsflS.left) + 'px'; // Reset below.
					btflS.top = dy - 4 + 'px';
					tbflteS.width = textW + 'px';
					tbflteS.height = textH + 'px';
					tbflteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbflteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFLTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lWBTB = document.getElementById('labelWhiteBalanceTextBox');
			trsFWB = document.getElementById('trackSliderFilterWhiteBalance');
			btfWB = document.getElementById('buttonSliderFilterWhiteBalance');
			var tbFWBTE = document.getElementById('textBoxFor-whiteBalanceTextElement');
			if (lWBTB && trsFWB && btfWB && tbFWBTE) {
				lfbtwbS = lWBTB.style;
				trsfwbS = trsFWB.style;
				btfwbS = btfWB.style;
				tbfwbteS = tbFWBTE.style;
				if (lfbtwbS && trsfwbS && btfwbS && tbfwbteS) {
					lfbtwbS.width = labelW + 'px';
					lfbtwbS.height = labelH + 'px';
					lfbtwbS.left = dx + 'px';
					lfbtwbS.top = dy - adjLabel + 'px';
					lfbtwbS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lWBTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfwbS.display = 'inline-block';
					btfwbS.display = 'inline-block';
					Z.Utils.graphicSize(trsFWB, sldrTrkW, sldrTrkH);
					trsfwbS.left = dx + labelW + 3 + 'px';
					trsfwbS.top = dy + 'px';
					Z.Utils.buttonSize(btfWB, sldrBtnW, sldrBtnH);
					btfwbS.left = parseFloat(trsfwbS.left) + 'px'; // Reset below.
					btfwbS.top = dy - 4 + 'px';
					tbfwbteS.width = textW + 'px';
					tbfwbteS.height = textH + 'px';
					tbfwbteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfwbteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFWBTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lNTB = document.getElementById('labelNormalizeTextBox');
			trsFN = document.getElementById('trackSliderFilterNormalize');
			btfN = document.getElementById('buttonSliderFilterNormalize');
			var tbFNTE = document.getElementById('textBoxFor-normalizeTextElement');
			if (lNTB && trsFN && btfN && tbFNTE) {
				lfbtnS = lNTB.style;
				trsfnS = trsFN.style;
				btfnS = btfN.style;
				tbfnteS = tbFNTE.style;
				if (lfbtnS && trsfnS && btfnS && tbfnteS) {
					lfbtnS.width = labelW + 'px';
					lfbtnS.height = labelH + 'px';
					lfbtnS.left = dx + 'px';
					lfbtnS.top = dy - adjLabel + 'px';
					lfbtnS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lNTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfnS.display = 'inline-block';
					btfnS.display = 'inline-block';
					Z.Utils.graphicSize(trsFN, sldrTrkW, sldrTrkH);
					trsfnS.left = dx + labelW + 3 + 'px';
					trsfnS.top = dy + 'px';
					Z.Utils.buttonSize(btfN, sldrBtnW, sldrBtnH);
					btfnS.left = parseFloat(trsfnS.left) + 'px'; // Reset below.
					btfnS.top = dy - 4 + 'px';
					tbfnteS.width = textW + 'px';
					tbfnteS.height = textH + 'px';
					tbfnteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfnteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFNTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lETB = document.getElementById('labelEqualizeTextBox');
			trsFE = document.getElementById('trackSliderFilterEqualize');
			btfE = document.getElementById('buttonSliderFilterEqualize');
			var tbFETE = document.getElementById('textBoxFor-equalizeTextElement');
			if (lETB && trsFE && btfE && tbFETE) {
				lfbteS = lETB.style;
				trsfeS = trsFE.style;
				btfeS = btfE.style;
				tbfeteS = tbFETE.style;
				if (lfbteS && trsfeS && btfeS && tbfeteS) {
					lfbteS.width = labelW + 'px';
					lfbteS.height = labelH + 'px';
					lfbteS.left = dx + 'px';
					lfbteS.top = dy - adjLabel + 'px';
					lfbteS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lETB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfeS.display = 'inline-block';
					btfeS.display = 'inline-block';
					Z.Utils.graphicSize(trsFE, sldrTrkW, sldrTrkH);
					trsfeS.left = dx + labelW + 3 + 'px';
					trsfeS.top = dy + 'px';
					Z.Utils.buttonSize(btfE, sldrBtnW, sldrBtnH);
					btfeS.left = parseFloat(trsfeS.left) + 'px'; // Reset below.
					btfeS.top = dy - 4 + 'px';
					tbfeteS.width = textW + 'px';
					tbfeteS.height = textH + 'px';
					tbfeteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfeteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFETE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			var lNTB = document.getElementById('labelNoiseTextBox');
			trsFN = document.getElementById('trackSliderFilterNoise');
			btfN = document.getElementById('buttonSliderFilterNoise');
			var tbFNTE = document.getElementById('textBoxFor-noiseTextElement');
			if (lNTB && trsFN && btfN && tbFNTE) {
				lfbtnS = lNTB.style;
				trsfnS = trsFN.style;
				btfnS = btfN.style;
				tbfnteS = tbFNTE.style;
				if (lfbtnS && trsfnS && btfnS && tbfnteS) {
					lfbtnS.width = labelW + 'px';
					lfbtnS.height = labelH + 'px';
					lfbtnS.left = dx + 'px';
					lfbtnS.top = dy - adjLabel + 'px';
					lfbtnS.visibility = 'visible';
					Z.Utils.setTextNodeStyle(lNTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					trsfnS.display = 'inline-block';
					btfnS.display = 'inline-block';
					Z.Utils.graphicSize(trsFN, sldrTrkW, sldrTrkH);
					trsfnS.left = dx + labelW + 3 + 'px';
					trsfnS.top = dy + 'px';
					Z.Utils.buttonSize(btfN, sldrBtnW, sldrBtnH);
					btfnS.left = parseFloat(trsfnS.left) + 'px'; // Reset below.
					btfnS.top = dy - 4 + 'px';
					tbfnteS.width = textW + 'px';
					tbfnteS.height = textH + 'px';
					tbfnteS.left = dx + labelW + 3 + sldrSpan + 'px';
					tbfnteS.top = dy - 6 + 'px';
					Z.Utils.setTextAreaStyle(tbFNTE, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
					dy += dvdrH;
				}
			}

			// Reset position counters for smaller image filter + / - buttons.
			dx = marginEdgeL + labelW + sldrTrkW + 11 + (secondTextElement / 2);
			dy -= 5;

			var bIFM = document.getElementById('buttonImageFilterMinus');
			if (bIFM) {
				Z.Utils.buttonSize(bIFM, btnW * 0.9, btnH * 0.9);
				var bifmS = bIFM.style;
				bifmS.left = dx + 'px';
				bifmS.top = dy + 'px';
				dx += btnW + 3;
			}

			var bIFP = document.getElementById('buttonImageFilterPlus');
			if (bIFP) {
				Z.Utils.buttonSize(bIFP, btnW * 0.9, btnH * 0.9);
				var bifpS = bIFP.style;
				bifpS.left = dx + 'px';
				bifpS.top = dy + 'px';
				dx += btnSpan;
			}

			// Reset position counters for image filter checkboxes.
			dx = panelW - marginEdgeL * 1.5 - btnW - labelW;
			dy = sldrTrkTOffset - 4;

			var ifsD = document.getElementById('imageFilterStateDivider');
			if (ifsD ) {
				Z.Utils.graphicSize(ifsD, dvdrW, sectionDvdrH);
				var ifsdS = ifsD.style;
				ifsdS.left = (filterCheckBoxCount > 0) ? dx - marginEdgeL + 'px' : -1000 + 'px';
				ifsdS.top = marginEdgeT + 'px';
			}

			var tbLG = document.getElementById('labelGrayscaleTextBox');
			var cCBG = document.getElementById('containerFor-checkboxFilterGrayscale');
			var cbG = document.getElementById('checkboxFilterGrayscale');
			if (tbLG && cCBG && cbG) {
				var tblgS = tbLG.style;
				tblgS.width = labelW + 'px';
				tblgS.height = labelH + 'px';
				tblgS.left = dx + 'px';
				tblgS.top = dy + adjLabel + 'px';
				tblgS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLG, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var ccbgS = cCBG.style;
				ccbgS.width = (btnW * 1.5) + 'px';
				ccbgS.height = (btnH * 1.5) + 'px';
				ccbgS.left = (dx + labelW + 3) + 'px';
				ccbgS.top = dy - adjLabel + 'px';
				cbG.width = btnW;
				cbG.height = btnH;
				dy += dvdrH;
			}

			var tbLT = document.getElementById('labelThresholdTextBox');
			var cCBT = document.getElementById('containerFor-checkboxFilterThreshold');
			var cbT = document.getElementById('checkboxFilterThreshold');
			if (tbLT && cCBT && cbT) {
				var tbltS = tbLT.style;
				tbltS.width = labelW + 'px';
				tbltS.height = labelH + 'px';
				tbltS.left = dx + 'px';
				tbltS.top = dy + adjLabel + 'px';
				tbltS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLT, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var ccbtS = cCBT.style;
				ccbtS.width = (btnW * 1.5) + 'px';
				ccbtS.height = (btnH * 1.5) + 'px';
				ccbtS.left = (dx + labelW + 3) + 'px';
				ccbtS.top = dy - adjLabel + 'px';
				cbT.width = btnW;
				cbT.height = btnH;
				dy += dvdrH;
			}

			var tbLI = document.getElementById('labelInversionTextBox');
			var cCBI = document.getElementById('containerFor-checkboxFilterInversion');
			var cbI = document.getElementById('checkboxFilterInversion');
			if (tbLI && cCBI && cbI) {
				var tbliS = tbLI.style;
				tbliS.width = labelW + 'px';
				tbliS.height = labelH + 'px';
				tbliS.left = dx + 'px';
				tbliS.top = dy + adjLabel + 'px';
				tbliS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLI, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var ccbiS = cCBI.style;
				ccbiS.width = (btnW * 1.5) + 'px';
				ccbiS.height = (btnH * 1.5) + 'px';
				ccbiS.left = (dx + labelW + 3) + 'px';
				ccbiS.top = dy - adjLabel + 'px';
				cbI.width = btnW;
				cbI.height = btnH;
				dy += dvdrH;
			}

			var tbLEQ = document.getElementById('labelEqualizeTextBox');
			var cCEQ = document.getElementById('containerFor-checkboxFilterEqualize');
			var cbEQ = document.getElementById('checkboxFilterEqualize');
			if (tbLEQ && cCEQ && cbEQ) {
				var tbleqS = tbLEQ.style;
				tbleqS.width = labelW + 'px';
				tbleqS.height = labelH + 'px';
				tbleqS.left = dx + 'px';
				tbleqS.top = dy + adjLabel + 'px';
				tbleqS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLEQ, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var ccbeqS = cCEQ.style;
				ccbeqS.width = (btnW * 1.5) + 'px';
				ccbeqS.height = (btnH * 1.5) + 'px';
				ccbeqS.left = (dx + labelW + 3) + 'px';
				ccbeqS.top = dy - adjLabel + 'px';
				cbEQ.width = btnW;
				cbEQ.height = btnH;
				dy += dvdrH;
			}

			var tbLE = document.getElementById('labelEdgesTextBox');
			var cCBE = document.getElementById('containerFor-checkboxFilterEdges');
			var cbE = document.getElementById('checkboxFilterEdges');
			if (tbLE && cCBE && cbE) {
				var tbleS = tbLE.style;
				tbleS.width = labelW + 'px';
				tbleS.height = labelH + 'px';
				tbleS.left = dx + 'px';
				tbleS.top = dy + adjLabel + 'px';
				tbleS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLE, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var ccbeS = cCBE.style;
				ccbeS.width = (btnW * 1.5) + 'px';
				ccbeS.height = (btnH * 1.5) + 'px';
				ccbeS.left = (dx + labelW + 3) + 'px';
				ccbeS.top = dy - adjLabel + 'px';
				cbE.width = btnW;
				cbE.height = btnH;
				dy += dvdrH;
			}

			var tbLS = document.getElementById('labelSepiaTextBox');
			var cCBS = document.getElementById('containerFor-checkboxFilterSepia');
			var cbS = document.getElementById('checkboxFilterSepia');
			if (tbLS && cCBS && cbS) {
				var tblsS = tbLS.style;
				tblsS.width = labelW + 'px';
				tblsS.height = labelH + 'px';
				tblsS.left = dx + 'px';
				tblsS.top = dy + adjLabel + 'px';
				tblsS.visibility = 'visible';
				Z.Utils.setTextNodeStyle(tbLS, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
				var ccbsS = cCBS.style;
				ccbsS.width = (btnW * 1.5) + 'px';
				ccbsS.height = (btnH * 1.5) + 'px';
				ccbsS.left = (dx + labelW + 3) + 'px';
				ccbsS.top = dy - adjLabel + 'px';
				cbS.width = btnW;
				cbS.height = btnH;
			}

			// Reset position counters for image filter clearing buttons.
			dx = panelW - marginEdgeL - btnW * 5;
			dy = panelH - marginEdgeT - btnH;

			var ifpD = document.getElementById('imageFilterPanelDivider');
			if (ifpD ) {
				Z.Utils.graphicSize(ifpD, panelDvdrW, 5.5);
				var ifpdS = ifpD.style;
				ifpdS.left = marginEdgeL + 'px';
				ifpdS.top = panelDvdrT + 2 + 'px';
			}

			var bIFC = document.getElementById('buttonImageFilterClear');
			if (bIFC) {
				Z.Utils.buttonSize(bIFC, btnW, btnH);
				var bifcS = bIFC.style;
				bifcS.left = dx + 'px';
				bifcS.top = dy + 'px';
				dx += btnSpan;
			}

			var bIFCA = document.getElementById('buttonImageFiltersClearAll');
			if (bIFCA) {
				Z.Utils.buttonSize(bIFCA, btnW, btnH);
				var bifcaS = bIFCA.style;
				bifcaS.left = dx + 'px';
				bifcaS.top = dy + 'px';
				dx += btnSpan;
			}

			var ifsD3 = document.getElementById('imageFilterStateDivider3');
			if (ifsD3) {
				Z.Utils.graphicSize(ifsD3, dvdrW, dvdrH);
				var ifsd3S = ifsD3.style;
				ifsd3S.left = dx + 'px';
				ifsd3S.top = dy + 'px';
				dx += dvdrSpan;
			}

			var bFPHOP = document.getElementById('buttonImageFilterPanelHideOnPanel');
			if (bFPHOP) {
				Z.Utils.buttonSize(bFPHOP, btnW, btnH);
				var bfphopS = bFPHOP.style;
				bfphopS.left = dx + 'px';
				bfphopS.top = dy + 'px';
			}
			
			if (Z.contrastVisible) {
				setFilterReferences(null, 'contrast', true);
				self.setImageFilterSlider('contrast', 0);
				self.setImageFilterText('contrast', 0);
				tbViewport.setImageFilterValuePrior('contrast', 0);
			}
			if (Z.sharpnessVisible) {
				setFilterReferences(null, 'sharpness', true);
				self.setImageFilterSlider('sharpness', 0);
				self.setImageFilterText('sharpness', 0);
				tbViewport.setImageFilterValuePrior('sharpness', 0);
			}
			if (Z.blurrinessVisible) {
				setFilterReferences(null, 'blurriness', true);
				self.setImageFilterSlider('blurriness', 0);
				self.setImageFilterText('blurriness', 0);
				tbViewport.setImageFilterValuePrior('blurriness', 0);
			}
			if (Z.colorRedVisible) {
				setFilterReferences(null, 'colorRed', true);
				self.setImageFilterSlider('colorRed', 0);
				self.setImageFilterText('colorRed', 0);
				tbViewport.setImageFilterValuePrior('colorRed', 0);
			}
			if (Z.colorGreenVisible) {
				setFilterReferences(null, 'colorGreen', true);
				self.setImageFilterSlider('colorGreen', 0);
				self.setImageFilterText('colorGreen', 0);
				tbViewport.setImageFilterValuePrior('colorGreen', 0);
			}
			if (Z.colorBlueVisible) {
				setFilterReferences(null, 'colorBlue', true);
				self.setImageFilterSlider('colorBlue', 0);
				self.setImageFilterText('colorBlue', 0);
				tbViewport.setImageFilterValuePrior('colorBlue', 0);
			}
			if (Z.colorRedRangeVisible) {
				setFilterReferences(null, 'colorRedRange', true);
				self.setImageFilterSlider('colorRedRange', 0);
				self.setImageFilterText('colorRedRange', 0);
				tbViewport.setImageFilterValuePrior('colorRedRange', 0);
				setFilterReferences(null, 'colorRedRange2', true);
				self.setImageFilterSlider('colorRedRange2', 255);
				self.setImageFilterText('colorRedRange2', 255);
				tbViewport.setImageFilterValuePrior('colorRedRange2', 255);
			}
			if (Z.colorGreenRangeVisible) {
				setFilterReferences(null, 'colorGreenRange', true);
				self.setImageFilterSlider('colorGreenRange', 0);
				self.setImageFilterText('colorGreenRange', 0);
				tbViewport.setImageFilterValuePrior('colorGreenRange', 0);
				setFilterReferences(null, 'colorGreenRange2', true);
				self.setImageFilterSlider('colorGreenRange2', 255);
				self.setImageFilterText('colorGreenRange2', 255);
				tbViewport.setImageFilterValuePrior('colorGreenRange2', 255);
			}
			if (Z.colorBlueRangeVisible) {
				setFilterReferences(null, 'colorBlueRange', true);
				self.setImageFilterSlider('colorBlueRange', 0);
				self.setImageFilterText('colorBlueRange', 0);
				tbViewport.setImageFilterValuePrior('colorBlueRange', 0);
				setFilterReferences(null, 'colorBlueRange2', true);
				self.setImageFilterSlider('colorBlueRange2', 255);
				self.setImageFilterText('colorBlueRange2', 255);
				tbViewport.setImageFilterValuePrior('colorBlueRange2', 255);
			}
			if (Z.gammaVisible) {
				setFilterReferences(null, 'gamma', true);
				self.setImageFilterSlider('gamma', 1);
				self.setImageFilterText('gamma', 1);
				tbViewport.setImageFilterValuePrior('gamma', 1);
			}
			if (Z.gammaRedVisible) {
				setFilterReferences(null, 'gammaRed', true);
				self.setImageFilterSlider('gammaRed', 1);
				self.setImageFilterText('gammaRed', 1);
				tbViewport.setImageFilterValuePrior('gammaRed', 1);
			}
			if (Z.gammaGreenVisible) {
				setFilterReferences(null, 'gammaGreen', true);
				self.setImageFilterSlider('gammaGreen', 1);
				self.setImageFilterText('gammaGreen', 1);
				tbViewport.setImageFilterValuePrior('gammaGreen', 1);
			}
			if (Z.gammaBlueVisible) {
				setFilterReferences(null, 'gammaBlue', true);
				self.setImageFilterSlider('gammaBlue', 1);
				self.setImageFilterText('gammaBlue', 1);
				tbViewport.setImageFilterValuePrior('gammaBlue', 1);
			}
			if (Z.hueVisible) {
				setFilterReferences(null, 'hue', true);
				self.setImageFilterSlider('hue', 0);
				self.setImageFilterText('hue', 0);
				tbViewport.setImageFilterValuePrior('hue', 0);
			}
			if (Z.saturationVisible) {
				setFilterReferences(null, 'saturation', true);
				self.setImageFilterSlider('saturation', 0);
				self.setImageFilterText('saturation', 0);
				tbViewport.setImageFilterValuePrior('saturation', 0);
			}
			if (Z.lightnessVisible) {
				setFilterReferences(null, 'lightness', true);
				self.setImageFilterSlider('lightness', 0);
				self.setImageFilterText('lightness', 0);
				tbViewport.setImageFilterValuePrior('lightness', 0);
			}			
			if (Z.whiteBalanceVisible) {
				setFilterReferences(null, 'whiteBalance', true);
				self.setImageFilterSlider('whiteBalance', 6500);
				self.setImageFilterText('whiteBalance', 6500);
				tbViewport.setImageFilterValuePrior('whiteBalance', 6500);
			}
			if (Z.noiseVisible) {
				setFilterReferences(null, 'noise', true);
				self.setImageFilterSlider('noise', 0);
				self.setImageFilterText('noise', 0);
				tbViewport.setImageFilterValuePrior('noise', 0);
			}
			if (Z.brightnessVisible) {
				setFilterReferences(null, 'brightness', true);
				self.setImageFilterSlider('brightness', 0);
				self.setImageFilterText('brightness', 0);
				tbViewport.setImageFilterValuePrior('brightness', 0);
			}
		}
	}

	function show (value) {
		if ((Z.toolbarVisible < 4 && !Z.mobileDevice) || Z.toolbarVisible == 8 || Z.toolbarInternal) {
			visibility(value);
		} else {
			minimize(!value);
		}
	}

	function visibility (visible) {
		if (tbS) {
			if (visible) {
				tbS.display = 'inline-block';
			} else {
				tbS.display = 'none';
			}
		}
	}

	function minimize (value) {
		Z.ToolbarMinimized = value;
		if (tbS) {
			var bC = document.getElementById('buttonContainer');
			var bG = document.getElementById('toolbarBackground');
			var bM = document.getElementById('buttonMinimize');
			var bE = document.getElementById('buttonExpand');
			var logoD = document.getElementById('logoDivider');
			var minW = 0;
			if (bE && !overrideLogo) { minW = parseFloat(bE.style.left) + parseFloat(bE.style.width) + 4; }
			if (Z.imageFilters) {
				var bGF = document.getElementById('imageFilterPanelBackground');
				var bCF = document.getElementById('buttonContainerImageFilter');
			}

			var expW = Z.toolbarCurrentW;
			if (value) {
				if (bC) { bC.style.display = 'none'; }
				if (bM && bE && !overrideLogo) {
					if (logoD) { logoD.style.display = 'none'; }
					bM.style.display = 'none';
					bE.style.display = 'inline-block';
				}
				tbS.width = minW + 'px';
				if (bG) { bG.style.width = minW + 'px'; }
				if (bGF && bCF) {
					bGF.style.width = '0px';
					bCF.style.display = 'none';
				}
			} else {
				if (bC) { bC.style.display = 'inline-block'; }
				if (bM && bE && !overrideLogo) {
					if (logoD) { logoD.style.display = 'inline-block'; }
					bM.style.display = 'inline-block';
					bE.style.display = 'none';
				}
				tbS.width = expW + 'px';
				if (bG) { bG.style.width = expW + 'px'; }
				if (bGF && bCF && imageFilterPanelVisible) {
					bGF.style.width = imageFilterPanelW + 'px';
					bCF.style.display = 'inline-block';
				}
			}
		}
	}

	this.syncSliderToViewportZoom = function (imageZ) {
		syncSliderToViewportZoom(imageZ);
	}

	function syncSliderToViewportZoom (imageZ) {
		if (typeof trszS !== 'undefined' && typeof btszS !== 'undefined') {
			var imageSpan = Z.maxZ - Z.minZ;
			var sliderPercent = (imageZ - Z.minZ) / imageSpan;
			var trackL = parseFloat(trszS.left);
			var trackR = parseFloat(trszS.left) + parseFloat(trszS.width) - parseFloat(btszS.width);
			var trackSpan = trackR - trackL;
			var sliderPosition = (sliderPercent * trackSpan) + trackL;
			btszS.left = sliderPosition + 'px';
		}
	}

	function sliderSnapZoom (event) {
		if (typeof trsZ !== 'undefined' && typeof trszS !== 'undefined') {
			var tszPt = Z.Utils.getElementPosition(trsZ);
			var sliderClick = Z.Utils.getMousePosition(event).x - tszPt.x;
			var sliderZoom = calculateSliderZoom(sliderClick, 0, parseFloat(trszS.width));

			if (sliderZoom < Z.minZ + 0.1) { sliderZoom = Z.minZ; }
			if (sliderZoom > Z.maxZ - 0.1) { sliderZoom = Z.maxZ; }

			var delta = sliderZoom - tbViewport.getZoom();
			Z.zooming = (delta > 0) ? 'in' : (delta < 0) ? 'out' : 'stop';
			tbViewport.scaleTierToZoom(sliderZoom);
			Z.zooming = 'stop';

			tbViewport.updateView();
		}
	}

	function sliderSlideStartZoom (event) {
		if (typeof btsZ !== 'undefined') {
			buttonSliderZoomDown = true;
			var mPt = Z.Utils.getMousePosition(event);
			btsZ.mouseXPrior = mPt.x;
			btsZ.mouseYPrior = mPt.y;
		}
	}

	function sliderSlideZoom () {
		if (typeof trszS !== 'undefined' && typeof btsZ !== 'undefined' && typeof btszS !== 'undefined') {
			var trackL = parseFloat(trszS.left);
			var trackR = parseFloat(trszS.left) + parseFloat(trszS.width) - parseFloat(btszS.width);
			var trackPosition = parseFloat(btszS.left) + (sliderIntervalMousePtZoom.x - btsZ.mouseXPrior);
			if (trackPosition < trackL) {
				trackPosition = trackL;
			} else if (trackPosition > trackR) {
				trackPosition = trackR;
			} else {
				btsZ.mouseXPrior = sliderIntervalMousePtZoom.x;
			}
			btszS.left = trackPosition + 'px';
			var sliderZoom = calculateSliderZoom(trackPosition, trackL, trackR);

			var delta = sliderZoom - tbViewport.getZoom();
			Z.zooming = (delta > 0) ? 'in' : (delta < 0) ? 'out' : 'stop';

			tbViewport.scaleTierToZoom(sliderZoom);
		}
	}

	function sliderSlideEndZoom () {
		buttonSliderZoomDown = false;
		Z.zooming = 'stop';
		tbViewport.updateView();
	}

	function calculateSliderZoom (sliderPosition, trkL, trkR) {
		var trackSpan = trkR - trkL;
		var sliderPercent = (sliderPosition - trkL) / trackSpan;
		var imageSpan = Z.maxZ - Z.minZ;
		var sliderZoom = Z.minZ + (imageSpan * sliderPercent);
		return sliderZoom;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::: IMAGE FILTER FUNCTIONS ::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function imageFilterEventsManager (event, tbID, filterEventType) {					
		if (typeof filterEventType === 'undefined' || filterEventType === null) { filterEventType = tbID; }
		if (filterEventType != 'sliderStart' || !imageFilterInProgress) {
			var event = Z.Utils.event(event);
			if (event) {
				switch (filterEventType) {
					case 'sliderSnap' :
						setFilterReferences(tbID);
						if (typeof filterTrack !== 'undefined' && typeof filterTrackS !== 'undefined') {
							var trackL = parseFloat(filterTrackS.left);
							var trackR = parseFloat(filterTrackS.left) + parseFloat(filterTrackS.width) - parseFloat(filterButtonS.width);
							var trackPt = Z.Utils.getElementPosition(filterTrack);
							var sliderClick = Z.Utils.getMousePosition(event).x - trackPt.x - parseFloat(filterButtonS.width) / 2;
							var trackValue = calculateSliderFilter(sliderClick, trackL, trackR);
							if (trackValue != tbViewport.getImageFilterValuePrior(imageFilterCurrent)) {

								// Determine if two slider buttons (RGB ranger filters) and if so, which is active.
								var filterValue, filterValue2, closerButton, closerFilter;
								var twoButtons = (filterButtonS !== null && filterButtonOtherS !== null);
								if (!twoButtons) {
									filterValue = trackValue;
									closerButton = filterButtonS;
									closerFilter = imageFilterCurrent;

								} else {
									var firstBtnL = parseFloat(filterButtonS.left) - trackL;
									var secondBtnL = parseFloat(filterButtonOtherS.left) - trackL;
									var firstDist = Math.abs(firstBtnL - sliderClick);
									var secondDist = Math.abs(secondBtnL - sliderClick);
									if (firstDist < secondDist) {
										filterValue = trackValue;
										filterValue2 = tbViewport.getImageFilterValuePrior(imageFilterCurrent+'2');
										closerButton = filterButtonS;
										closerFilter = imageFilterCurrent;
									} else {
										filterValue = tbViewport.getImageFilterValuePrior(imageFilterCurrent);
										filterValue2 = trackValue;
										closerButton = filterButtonOtherS;
										if (imageFilterCurrent.substring(imageFilterCurrent.length - 1) != '2') {
											closerFilter = imageFilterCurrent + '2';
										}
									}
								}

								self.syncImageFilterPanel(closerFilter, trackValue, closerButton);
								tbViewport.setImageFilterValuePrior(closerFilter, trackValue);
								tbViewport.setImageFilter(closerFilter, filterValue, filterValue2);
							}
						}
						break;
					case 'sliderStart' :
						imageFilterInProgress = true;
						setFilterReferences(tbID);
						if (imageFilterCurrent == 'hue' || imageFilterCurrent == 'saturation' || imageFilterCurrent == 'sharpness' || imageFilterCurrent == 'blurriness') {
							Z.Utils.showMessage('\n'+Z.Utils.stringUpperCaseFirstLetter(imageFilterCurrent) + Z.Utils.getResource('ALERT_PROCESSINGIMAGEFILTER-CONVOLUTION-ONMOUSEUP'), false, null, 'center', true, '2');
						}
						if (typeof filterButton !== 'undefined') {
							buttonSliderFilterDown = true;
							var mPt = Z.Utils.getMousePosition(event);
							filterButton.mouseXPrior = mPt.x;
							filterButton.mouseYPrior = mPt.y;
							if (imageFilterChanged) { tbViewport.cacheCanvasImage(true); }
						}
						break;
					case 'sliderSlide' :
						if (typeof filterTrackS !== 'undefined' && typeof filterButton !== 'undefined' && typeof filterButtonS !== 'undefined') {
							var trackL = parseFloat(filterTrackS.left);
							var trackR = parseFloat(filterTrackS.left) + parseFloat(filterTrackS.width) - parseFloat(filterButtonS.width);
							var trackPosition = parseFloat(filterButtonS.left) + (sliderIntervalMousePtFilter.x - filterButton.mouseXPrior);
							if (trackPosition < trackL) {
								trackPosition = trackL;
							} else if (trackPosition > trackR) {
								trackPosition = trackR;
							} else {
								filterButton.mouseXPrior = sliderIntervalMousePtFilter.x;
							}
							var currentButtonValue = calculateSliderFilter(trackPosition - trackL, trackL, trackR);
							filterButtonS.left = trackPosition + 'px';

							// Determine if two slider buttons (RGB ranger filters) and if so, which is active.
							var filterValue, filterValue2;
							var twoButtons = (filterButtonS !== null && filterButtonOtherS !== null);
							if (!twoButtons) {
								filterValue = currentButtonValue;

							} else {
								var isFirstButton = (imageFilterCurrent.substring(imageFilterCurrent.length - 1) != '2'); // Use filter rather than tbID in case of mouseout on button.

								if (isFirstButton) {
									filterValue = currentButtonValue;
									filterValue2 = tbViewport.getImageFilterValuePrior(imageFilterCurrent+'2');

								} else {
									filterValue = tbViewport.getImageFilterValuePrior(imageFilterCurrent.substring(0, imageFilterCurrent.length - 1));
									filterValue2 = currentButtonValue;
								}

								// If two slider buttons, ensure they do not pass each other.
								if (isFirstButton) {
									if (parseFloat(filterButtonOtherS.left) <= trackPosition) {
										filterButtonOtherS.left = trackPosition + 'px';
										var filterOther = imageFilterCurrent+'2';
										self.setImageFilterText(filterOther, filterValue);
										tbViewport.setImageFilterValuePrior(filterOther, filterValue);
									}
								} else {
									if (parseFloat(filterButtonOtherS.left) >= trackPosition) {
										filterButtonOtherS.left = trackPosition + 'px';
										var filterOther = imageFilterCurrent.substring(0, imageFilterCurrent.length - 1);
										self.setImageFilterText(filterOther, filterValue2);
										tbViewport.setImageFilterValuePrior(filterOther, filterValue2);
									}
								}
							}

							// Apply filter.
							if (currentButtonValue != tbViewport.getImageFilterValuePrior(imageFilterCurrent)) {
								self.setImageFilterText(imageFilterCurrent, currentButtonValue);
								if (imageFilterCurrent != 'hue' && imageFilterCurrent != 'saturation' && imageFilterCurrent != 'sharpness' && imageFilterCurrent != 'blurriness') {
									tbViewport.applyImageFilter(imageFilterCurrent, filterValue, 'canvas', filterValue2);
								}
								tbViewport.setImageFilterValuePrior(imageFilterCurrent, currentButtonValue);
							}
						}
						break;

					case 'sliderEnd' :
						imageFilterInProgress = false;
						if (typeof filterTrackS !== 'undefined' && typeof filterButton !== 'undefined' && typeof filterButtonS !== 'undefined') {
							var trackL = parseFloat(filterTrackS.left);
							var trackR = parseFloat(filterTrackS.left) + parseFloat(filterTrackS.width) - parseFloat(filterButtonS.width);
							var trackPosition = parseFloat(filterButtonS.left) + (sliderIntervalMousePtFilter.x - filterButton.mouseXPrior);
							if (trackPosition < trackL) {
								trackPosition = trackL;
							} else if (trackPosition > trackR) {
								trackPosition = trackR;
							} else {
								filterButton.mouseXPrior = sliderIntervalMousePtFilter.x;
							}
							var currentButtonValue = calculateSliderFilter(trackPosition - trackL, trackL, trackR);
							filterButtonS.left = trackPosition + 'px';

							// Determine if two slider buttons (RGB ranger filters) and if so, which is active.
							var filterValue, filterValue2;
							if (imageFilterCurrent.indexOf('Range') == -1) {
								filterValue = currentButtonValue;

							} else {
								var isFirstButton = (imageFilterCurrent.substring(imageFilterCurrent.length - 1) != '2'); // Use filter rather than tbID in case of mouseout on button.

								if (isFirstButton) {
									filterValue = currentButtonValue;
									filterValue2 = tbViewport.getImageFilterValuePrior(imageFilterCurrent+'2');

								} else {
									filterValue = tbViewport.getImageFilterValuePrior(imageFilterCurrent.substring(0, imageFilterCurrent.length - 1));
									filterValue2 = currentButtonValue;
								}

								// If two slider buttons, ensure they do not pass each other.
								if (isFirstButton) {
									if (parseFloat(filterButtonOtherS.left) <= trackPosition) {
										filterButtonOtherS.left = trackPosition + 'px';
										var filterOther = imageFilterCurrent+'2';
										self.setImageFilterText(filterOther, filterValue);
										tbViewport.setImageFilterValuePrior(filterOther, filterValue);
									}
								} else {
									if (parseFloat(filterButtonOtherS.left) >= trackPosition) {
										filterButtonOtherS.left = trackPosition + 'px';
										var filterOther = imageFilterCurrent.substring(0, imageFilterCurrent.length - 1);
										self.setImageFilterText(filterOther, filterValue2);
										tbViewport.setImageFilterValuePrior(filterOther, filterValue2);
									}
								}
							}

							// Apply filter if value has changed or if ending slider use of filterImageDisplayFast which does not filter backfill canvas.
							if (currentButtonValue != tbViewport.getImageFilterValuePrior(imageFilterCurrent) || filterEventType == 'sliderEnd') {
								self.setImageFilterText(imageFilterCurrent, currentButtonValue);

								tbViewport.setImageFilter(imageFilterCurrent, filterValue, filterValue2);
								validateImageFiltersConvolve();
								
								//DEV NOTE: some multi-filter processing disabled for current release.
								tbViewport.applyImageFilter(imageFilterCurrent, filterValue, null, filterValue2);

								tbViewport.setImageFilterValuePrior(imageFilterCurrent, currentButtonValue);
							}	
						}
						buttonSliderFilterDown = false;
						break;

					case 'imageFilterText' :
						var eventType = event.type;
						var eventTarget = Z.Utils.target(event);
						var filterValue = eventTarget.value;
						var filterNumber = (typeof filterValue !== 'undefined' && filterValue !== null && filterValue != '' && !isNaN(filterValue));
						if (filterNumber || eventType == 'blur') {
							switch(eventType) {
								case 'focus' :
									if (eventTarget.value == 0) { eventTarget.value = ''; }
									imageFilterCurrent = eventTarget.id.substring(0, eventTarget.id.indexOf('TextElement'));
									setFilterReferences(null, imageFilterCurrent);
									break;
								case 'input' :
									if (filterValue != tbViewport.getImageFilterValuePrior(imageFilterCurrent)) {
										filterValue = constrainImageFilter(imageFilterCurrent, filterValue);
										eventTarget.value = filterValue;
										self.setImageFilterSlider(imageFilterCurrent, filterValue);
										tbViewport.setImageFilter(imageFilterCurrent, filterValue);
									}
									break;
								case 'change' :
									// Failsafe in case input event above does not fire or is not supported.
									if (imageFilterCurrent != imageFilterPrior && filterValue != tbViewport.getImageFilterValuePrior(imageFilterCurrent)) {
										filterValue = constrainImageFilter(imageFilterCurrent, filterValue);
										eventTarget.value = filterValue;
										self.setImageFilterSlider(imageFilterCurrent, filterValue);
										tbViewport.setImageFilter(imageFilterCurrent, filterValue);
									}
									break;
								case 'blur' :
									if (eventTarget.value == '') { eventTarget.value = 0; }
									break;
							}
						}
						break;
					case 'checkbox' :
						var eventTarget = Z.Utils.target(event);
						textElementRemoveFocus(); // Remove editing cursor from any current text region.
						var checked = eventTarget.checked;
						var filter = tbID.substring(tbID.indexOf('Filter') + 6, tbID.length).toLowerCase();
						var filterValue = null;
						if (checked) {
							tbViewport.setImageFilter(filter, filterValue);
						} else {
							filterValue = 0;
							tbViewport.setImageFilter(filter, filterValue);
						}
						break;
					case 'buttonImageFilterPlus' :
						setFilterReferences(null, imageFilterCurrent);
						tbViewport.imageFilterButtonsHandler(imageFilterCurrent, 'plus');
						break;
					case 'buttonImageFilterMinus' :
						setFilterReferences(null, imageFilterCurrent);
						tbViewport.imageFilterButtonsHandler(imageFilterCurrent, 'minus');
						break;
				}
			}
		}
	}

	function imageFilterSliderTextEventsManager (event) {
		imageFilterEventsManager(event, null, 'imageFilterText');
	}

	this.syncImageFilterPanel = function (filter, filterValue, closerButton) {
		self.setImageFilterSlider(filter, filterValue, closerButton);
		self.setImageFilterText(filter, filterValue);
		tbViewport.setImageFilterValuePrior(filter, filterValue);
	}

	this.clearImageFilterInPanel = function (filter, last) {
		// Clear all applied filter names from image filter history.
		removeFilterFromImageFilterList(filter, last);

		var filterBoolean = (filter == 'grayscale' || filter == 'threshold' || filter == 'inversion' || filter == 'normalize' || filter == 'equalize' || filter == 'edges' || filter == 'sepia');
		if (filterBoolean) {
			var filterCheckboxName = 'checkboxFilter' + Z.Utils.stringUpperCaseFirstLetter(filter);
			var checkbox = document.getElementById(filterCheckboxName);
			if (checkbox) { checkbox.checked = false; }
		} else {
			var isSecondButton = filter.substring(filter.length - 1) == '2';
			var isSecondButtonName = (isSecondButton) ? '2' : '';
			var filterName = (!isSecondButton) ? filter : filter.substring(0, filter.length - 1);
			var clearVal = (filter.indexOf('gamma') == -1) ? 0 : 1;
			self.setImageFilterSlider(filterName, clearVal);
			var filterTextElementName = filterName + 'TextElement' + isSecondButtonName;
			var filterTextElement = document.getElementById(filterTextElementName);
			if (filterTextElement) { filterTextElement.value = clearVal; }
		}
	}

	this.setImageFilterSlider = function (filter, filterValue, closerButton) {
		// Calculate percent values for ranges without considering differing filter names.
		var filterName = (filter.substring(filter.length - 1) != '2') ? filter : filter.substring(0, filter.length - 1);

		if (Z[filterName + 'Visible']) {
			var rangeMaxAbs = tbViewport.getImageFilterRangeMaxAbsolute(filter);
			var sliderPercent = filterValue / rangeMaxAbs;

			// Convert percentFactor to range appropriate to filters (matching Adobe Photoshop: brightness: -150 to 150, contrast: -50 to 100, sharpness and blurriness: 0 to 100).
			switch(filter) {
				case 'brightness' :
					sliderPercent += 0.5;
					break;
				case 'contrast' :
					sliderPercent += 0.3333;
					break;
				case 'colorRed' :
					sliderPercent += 0.5;
					break;
				case 'colorGreen' :
					sliderPercent += 0.5;
					break;
				case 'colorBlue' :
					sliderPercent += 0.5;
					break;
				case 'saturation' :
					sliderPercent += 0.5;
					break;
				case 'lightness' :
					sliderPercent += 0.5;
					break;
			}

			// Position slider button.
			Z.Toolbar.setFilterSliderReferences(filter);
			if (typeof filterTrackS !== 'undefined' && typeof filterButtonS !== 'undefined') {
				var trackL = parseFloat(filterTrackS.left);
				var trackR = parseFloat(filterTrackS.left) + parseFloat(filterTrackS.width) - parseFloat(filterButtonS.width);
				var trackSpan = trackR - trackL;
				var sliderPosition = (sliderPercent * trackSpan) + trackL;
				if (sliderPosition < trackL) { sliderPosition = trackL; }
				if (sliderPosition > trackR) { sliderPosition = trackR; }

				// Parameter allows track click to set button closest to click.
				var targetButtonS = (closerButton) ? closerButton : filterButtonS;
				targetButtonS.left = sliderPosition + 'px';
			}
		}
	}

	this.setImageFilterText = function (filter, filterValue) {
		var isSecondButton = filter.substring(filter.length - 1) == '2';
		var isSecondButtonName = (isSecondButton) ? '2' : '';
		var filterName = (!isSecondButton) ? filter : filter.substring(0, filter.length - 1);
		if (Z[filterName + 'Visible']) {
			if (filter.indexOf('gamma') == -1) { filterValue = Math.round(filterValue); }
			var valueStr = filterValue.toString();
			var filterTextElementName = filterName + 'TextElement' + isSecondButtonName;
			var filterTextElement = document.getElementById(filterTextElementName);
			filterTextElement.value = valueStr;
		}
	}

	function setFilterReferences (tbID, filter, initializing) {
		var updateRefs = false;
		if (typeof tbID === 'undefined' || tbID === null) {
			if (typeof filter !== 'undefined' && Z.Utils.stringValidate(filter)) {
				imageFilterCurrent = filter;
				updateRefs = true;
			} else if (typeof imageFilterCurrent === 'undefined' || !Z.Utils.stringValidate(imageFilterCurrent)) {
				imageFilterCurrent = 'brightness';
				updateRefs = true;
			}
		} else {
			var indexStart = 17; // Target is slider track.
			if (tbID.indexOf('buttonSliderFilter') != -1) { indexStart = 18; } // Target is slider button.
			var filterName = tbID.substring(indexStart, tbID.length);
			imageFilterCurrent = Z.Utils.stringLowerCaseFirstLetter(filterName);
			updateRefs = true;
		}

		if (updateRefs) {
			Z.Toolbar.setFilterSliderReferences(imageFilterCurrent);
			if (!initializing) {
				imageFilterChanged = (imageFilterCurrent != imageFilterPrior);
				imageFilterPrior = imageFilterCurrent;
			}
		}
	}

	this.setFilterSliderReferences = function (imgFltrCurr) {
		filterButtonOtherS = null;
		switch (imgFltrCurr) {
			case 'brightness' :
				if (trsFB) {
					filterTrack = trsFB;
					filterTrackS = trsFB.style;
					filterButton = btfB;
					filterButtonS = btfB.style;
				}
				break;
			case 'contrast' :
				if (trsFC) {
					filterTrack = trsFC;
					filterTrackS = trsFC.style;
					filterButton = btfC;
					filterButtonS = btfC.style;
				}
				break;
			case 'sharpness' :
				if (trsFS) {
					filterTrack = trsFS;
					filterTrackS = trsFS.style;
					filterButton = btfS;
					filterButtonS = btfS.style;
				}
				break;
			case 'blurriness' :
				if (trsFBL) {
					filterTrack = trsFBL;
					filterTrackS = trsFBL.style;
					filterButton = btfBL;
					filterButtonS = btfBL.style;
				}
				break;
			case 'colorRed' :
				if (trsFCR) {
					filterTrack = trsFCR;
					filterTrackS = trsFCR.style;
					filterButton = btfCR;
					filterButtonS = btfCR.style;
				}
				break;
			case 'colorGreen' :
				if (trsFCG) {
					filterTrack = trsFCG;
					filterTrackS = trsFCG.style;
					filterButton = btfCG;
					filterButtonS = btfCG.style;
				}
				break;
			case 'colorBlue' :
				if (trsFCB) {
					filterTrack = trsFCB;
					filterTrackS = trsFCB.style;
					filterButton = btfCB;
					filterButtonS = btfCB.style;
				}
				break;
			case 'colorRedRange' :
				if (trsFCRR) {
					filterTrack = trsFCRR;
					filterTrackS = trsFCRR.style;
					filterButton = btfCRR;
					filterButtonS = btfCRR.style;
					filterButtonOther = btfCRR2;
					filterButtonOtherS = btfCRR2.style;
				}
				break;
			case 'colorRedRange2' :
				if (trsFCRR) {
					filterTrack = trsFCRR;
					filterTrackS = trsFCRR.style;
					filterButton = btfCRR2;
					filterButtonS = btfCRR2.style;
					filterButtonOther = btfCRR;
					filterButtonOtherS = btfCRR.style;
				}
				break;
			case 'colorGreenRange' :
				if (trsFCGR) {
					filterTrack = trsFCGR;
					filterTrackS = trsFCGR.style;
					filterButton = btfCGR;
					filterButtonS = btfCGR.style;
					filterButtonOther = btfCGR2;
					filterButtonOtherS = btfCGR2.style;
				}
				break;
			case 'colorGreenRange2' :
				if (trsFCGR) {
					filterTrack = trsFCGR;
					filterTrackS = trsFCGR.style;
					filterButton = btfCGR2;
					filterButtonS = btfCGR2.style;
					filterButtonOther = btfCGR;
					filterButtonOtherS = btfCGR.style;
				}
				break;
			case 'colorBlueRange' :
				if (trsFCBR) {
					filterTrack = trsFCBR;
					filterTrackS = trsFCBR.style;
					filterButton = btfCBR;
					filterButtonS = btfCBR.style;
					filterButtonOther = btfCBR2;
					filterButtonOtherS = btfCBR2.style;
				}
				break;
			case 'colorBlueRange2' :
				if (trsFCBR) {
					filterTrack = trsFCBR;
					filterTrackS = trsFCBR.style;
					filterButton = btfCBR2;
					filterButtonS = btfCBR2.style;
					filterButtonOther = btfCBR;
					filterButtonOtherS = btfCBR.style;
				}
				break;
			case 'gamma' :
				if (trsFG) {
					filterTrack = trsFG;
					filterTrackS = trsFG.style;
					filterButton = btfG;
					filterButtonS = btfG.style;
				}
				break;
			case 'gammaRed' :
				if (trsFGR) {
					filterTrack = trsFGR;
					filterTrackS = trsFGR.style;
					filterButton = btfGR;
					filterButtonS = btfGR.style;
				}
				break;
			case 'gammaGreen' :
				if (trsFGG) {
					filterTrack = trsFGG;
					filterTrackS = trsFGG.style;
					filterButton = btfGG;
					filterButtonS = btfGG.style;
				}
				break;
			case 'gammaBlue' :
				if (trsFGB) {
					filterTrack = trsFGB;
					filterTrackS = trsFGB.style;
					filterButton = btfGB;
					filterButtonS = btfGB.style;
				}
				break;
			case 'hue' :
				if (trsFH) {
					filterTrack = trsFH;
					filterTrackS = trsFH.style;
					filterButton = btfH;
					filterButtonS = btfH.style;
				}
				break;
			case 'saturation' :
				if (trsFSA) {
					filterTrack = trsFSA;
					filterTrackS = trsFSA.style;
					filterButton = btfSA;
					filterButtonS = btfSA.style;
				}
				break;
			case 'lightness' :
				if (trsFL) {
					filterTrack = trsFL;
					filterTrackS = trsFL.style;
					filterButton = btfL;
					filterButtonS = btfL.style;
				}
				break;
			case 'whiteBalance' :
				if (trsFWB) {
					filterTrack = trsFWB;
					filterTrackS = trsFWB.style;
					filterButton = btfWB;
					filterButtonS = btfWB.style;
				}
				break;
			case 'noise' :
				if (trsFN) {
					filterTrack = trsFN;
					filterTrackS = trsFN.style;
					filterButton = btfN;
					filterButtonS = btfN.style;
				}
				break;
		}
	}

	// Filter slider calculations differ from zoom and image set slider calculations due to center placement of zero point.
	function calculateSliderFilter (sliderPosition, trkL, trkR) {
		var filterValue = tbViewport.getImageFilterValuePrior(imageFilterCurrent);

		// Don't process if no slider change.
		if (sliderPosition != sliderPositionPrior) {

			// Update tracking variable.
			sliderPositionPrior = sliderPosition;

			// Calculate position percentage.
			var trackSpan = trkR - trkL;
			var sliderPercent = sliderPosition / trackSpan;

			// Constrain percent.
			if (sliderPercent < 0) { sliderPercent = 0; }
			if (sliderPercent > 1) { sliderPercent = 1; }
			var percentFactor = sliderPercent;

			// Convert percentFactor to range appropriate to filters (matching Adobe Photoshop: brightness: -150 to 150, contrast: -50 to 100, sharpness and blurriness: 0 to 100).
			switch(imageFilterCurrent) {
				case 'brightness' :
					percentFactor -= 0.5;
					break;
				case 'contrast' :
					percentFactor -= 0.3333;
					break;
				case 'colorRed' :
					percentFactor -= 0.5;
					break;
				case 'colorGreen' :
					percentFactor -= 0.5;
					break;
				case 'colorBlue' :
					percentFactor -= 0.5;
					break;
				case 'saturation' :
					percentFactor -= 0.5;
					break;
				case 'lightness' :
					percentFactor -= 0.5;
					break;
			}
			var rangeMaxAbs = tbViewport.getImageFilterRangeMaxAbsolute(imageFilterCurrent);
			filterValue = rangeMaxAbs  * percentFactor;
			if (imageFilterCurrent.indexOf('gamma') == -1) {
				filterValue = Math.round(filterValue);
			} else {
				filterValue = Math.round(filterValue * 10) / 10;
			}
		}

		return filterValue;
	}

	function sliderMouseMoveHandlerFilter (event, tbID) {
		sliderIntervalMousePtFilter = new Z.Utils.Point(event.clientX, event.clientY);
	}

	function sliderTouchMoveHandlerFilter (event, tbID) {
		var touch = Z.Utils.getFirstTouch(event);
		if (touch) {
			var target = touch.target;
			sliderIntervalMousePtFilter = new Z.Utils.Point(touch.pageX, touch.pageY);
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::: IMAGESET FUNCTIONS :::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.syncSliderToViewportImageSet = function (imageSetSlide) {
		syncSliderToViewportImageSet(imageSetSlide);
	}

	function syncSliderToViewportImageSet (imageSetSlide) {
		if (typeof trsisS !== 'undefined' && typeof btsisS !== 'undefined') {
			var imageSetSpan = Z.imageSetLength - 1;
			var sliderPercent = Z.viewportCurrentID / imageSetSpan;
			var trackL = parseFloat(trsisS.left);
			var trackR = parseFloat(trsisS.left) + parseFloat(trsisS.width) - parseFloat(btsisS.width);
			var trackSpan = trackR - trackL;
			var sliderPosition = (sliderPercent * trackSpan) + trackL;
			btsisS.left = sliderPosition + 'px';
		}
	}

	function sliderSnapImageSet (event) {
		if (trsiS && trsisS) {
			var tsisPt = Z.Utils.getElementPosition(trsiS);
			var sliderClick = Z.Utils.getMousePosition(event).x - tsisPt.x;

			var sliderSlide = calculateSliderImage(sliderClick, 0, parseFloat(trsisS.width));
			if (sliderSlide < 0) { sliderSlide = 0; }
			if (sliderSlide > Z.imageSetLength - 1) { sliderSlide = Z.imageSetLength - 1; }

			var changed = (sliderSlide != Z.viewportCurrentID);
			if (changed) { Z.Viewer.viewportSelect(sliderSlide, true) } // Do not allow viewportSelect to call syncSliderToViewportImageSet.
			syncSliderToViewportImageSet(sliderSlide);
		}
	}

	function sliderSlideStartImageSet (event) {
		if (btsiS) {
			buttonSliderImageSetDown = true;
			var mPt = Z.Utils.getMousePosition(event);
			btsiS.mouseXPrior = mPt.x;
			btsiS.mouseYPrior = mPt.y;
		}
	}

	function sliderSlideImageSet () {
		if (trsiS && btsiS && btsiS) {
			var trackL = parseFloat(trsisS.left);
			var trackR = parseFloat(trsisS.left) + parseFloat(trsisS.width) - parseFloat(btsisS.width);
			var trackPosition = parseFloat(btsisS.left) + (sliderIntervalMousePtImageSet.x - btsiS.mouseXPrior);
			if (trackPosition < trackL) {
				trackPosition = trackL;
			} else if (trackPosition > trackR) {
				trackPosition = trackR;
			} else {
				btsiS.mouseXPrior = sliderIntervalMousePtImageSet.x;
			}
			btsisS.left = trackPosition + 'px';
			var sliderSlide = calculateSliderImage(trackPosition, trackL, trackR);

			var changed = (sliderSlide != Z.viewportCurrentID);
			if (changed) { Z.Viewer.viewportSelect(sliderSlide, true) }  // Do not allow viewportSelect to call syncSliderToViewportImageSet.
		}
	}

	function sliderSlideEndImageSet () {
		buttonSliderImageSetDown = false;
		Z.Viewer.viewportSelect(Z.viewportCurrentID, true); // Do not allow viewportSelect to call syncSliderToViewportImageSet.
	}

	function calculateSliderImage (trackPosition, trkL, trkR) {
		var trackSpan = trkR - trkL;
		var sliderPercent = (trackPosition - trkL) / trackSpan;
		var imageSetSpan = Z.imageSetLength - 1;
		var sliderSlide = Math.round(imageSetSpan * sliderPercent);
		return sliderSlide;
	}

	function sliderMouseMoveHandlerImageSet (event) {
		sliderIntervalMousePtImageSet = new Z.Utils.Point(event.clientX, event.clientY);
	}

	function sliderTouchMoveHandlerImageSet (event) {
		var touch = Z.Utils.getFirstTouch(event);
		if (touch) {
			var target = touch.target;
			sliderIntervalMousePtImageSet = new Z.Utils.Point(touch.pageX, touch.pageY);
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::: EVENT FUNCTIONS :::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Handled simplified internal toolbar events.
	function buttonEventsHandlerInternal (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var eventType = event.type;
			var eventTarget = Z.Utils.target(event);
			if (eventTarget) {
				buttonZoomOutInternalS.background = colorButtonInternalUp;
				buttonResetInternalS.background = colorButtonInternalUp;
				buttonZoomInInternalS.background = colorButtonInternalUp;
				var tbID = eventTarget.id;
				var isAltKey = event.altKey;
				switch(eventType) {
					case 'mouseover' :
						eventTarget.style.background = colorButtonInternalOver;
						break;
					case 'mousedown' :
						eventTarget.style.background = colorButtonInternalDown;
						if (tbID == 'buttonZoomInInternal') {
							if (!isAltKey) { tbViewport.zoom('in'); }
						} else if (tbID == 'buttonZoomOutInternal') {
							if (!isAltKey) { tbViewport.zoom('out'); }
						}
						break;
					case 'mouseup' :
						eventTarget.style.background = colorButtonInternalOver;
						tbViewport.zoom('stop');
						if (tbID == 'buttonResetInternal') { tbViewport.reset(isAltKey); }
						break;
					case 'mouseout' :
						break;
				}
			}
		}
	}

	this.buttonEventsHandler = function (event) {
		buttonEventsHandler(event);
	}

	// Handle all button events and graphic states by clearing all event handlers on exit
	// and resetting this handler as event broker. Prevent right mouse button use. Note that
	// call to setToolbarDefaults is redundant vs call by background mouseover handler
	// only if move slowly between buttons, not if move fast or if move directly off toolbar.
	function buttonEventsHandler (event) {
		// Get needed values.
		var event = Z.Utils.event(event);
		if (event) {
			var eventType = event.type;
			var eventTarget = Z.Utils.target(event);
			if (eventTarget) {
				var targetBtn = eventTarget.parentNode;
				if (targetBtn) {
					var targetBtnOrig = targetBtn;
					tbID = targetBtn.id;
				}
			}
			var relatedTarget = Z.Utils.relatedTarget(event);
		}

		// Prevent conflicting zoom-and-pan function calls and clear mask, if any.
		if (eventType == 'mousedown' && tbViewport && !(tbID == 'buttonAudioOn' || tbID == 'buttonAudioMuted')) {
			tbViewport.zoomAndPanAllStop(false, true);
			if (Z.maskingSelection && Z.maskClearOnUserAction) { tbViewport.clearMask(); }
		}

		// Prevent events if optional parameter set, or if due to choicelist navigation, right-click, or copy menu on mobile OS.
		if (!Z.interactive && (eventType == 'mousedown' || eventType == 'mouseup') && (tbID != 'buttonRotateClockwise' && tbID != 'buttonRotateCounterwise')) { return; }
		if (relatedTarget && (relatedTarget == '[object HTMLSelectElement]' || relatedTarget == '[object HTMLOptionElement]')) { return; }
		if (Z.Utils.isRightMouseButton(event)) { return; }
		if (Z.touchSupport) { event.preventDefault(); }

		// If event firing on viewport if mouse dragged off slider button, reassign target to slider button to prevent buttonGraphicsUpdate function from setting visibility of viewport elements.
		if (tbID && tbID.indexOf('viewportContainer') != -1 || buttonSliderZoomDown || buttonSliderFilterDown || buttonSliderImageSetDown) {
			if (buttonSliderZoomDown) {
				targetBtn = document.getElementById('buttonSliderZoom');
			} else if (buttonSliderImageSetDown) {
				targetBtn = document.getElementById('buttonSliderImageSet');
			}
			if (targetBtn) { tbID = targetBtn.id; }
		}

		// Update button graphics.
		buttonGraphicsUpdate(targetBtn, eventType);

		// Handle events.
		if (tbID && tbID != 'buttonBackground' && eventType) {

			switch(eventType) {
				case 'click' :
					var isCheckbox = tbID.toLowerCase().indexOf('checkbox') != -1;
					if (tbViewport && isCheckbox) {
						buttonEventsManager(event, tbID);
					}
					break;
				case 'mouseover' :
					if (tbID != 'trackSliderZoom' && tbID != 'trackSliderImageSet') { // Slider track for image set will have mouse over and out event handlers for setting mousewheel focus.
						Z.Utils.removeEventListener(targetBtn.childNodes[0], 'mouseover', buttonEventsHandler);
						Z.Utils.addEventListener(targetBtn.childNodes[1], 'mousedown', buttonEventsHandler);
						Z.Utils.addEventListener(targetBtn.childNodes[1], 'mouseout', buttonEventsHandler);
						if (buttonSliderZoomDown && targetBtnOrig) { Z.Utils.addEventListener(targetBtnOrig.childNodes[0], 'mouseup', buttonEventsHandler); }
						if (buttonSliderImageSetDown && targetBtnOrig) { Z.Utils.addEventListener(targetBtnOrig.childNodes[0], 'mouseup', buttonEventsHandler); }
						if (tbID == 'buttonZoomIn' || tbID == 'buttonSliderZoom' || tbID == 'buttonZoomOut') {
							Z.sliderFocus = 'zoom';
						} else if (tbID == 'buttonImageSetPrior' || tbID == 'buttonSliderImageSet' || tbID == 'buttonImageSetNext') {
							Z.sliderFocus = 'imageSet';
						}
					} else {
						Z.Utils.addEventListener(targetBtn.childNodes[0], 'mouseout', buttonEventsHandler);
						Z.sliderFocus = (tbID == 'trackSliderImageSet') ? 'imageSet' : 'zoom';
					}
					break;
				case 'mousedown' :
					Z.buttonIsDown = true;
					if (!Z.fullView && document.activeElement) { document.activeElement.blur(); }
					if (tbID != 'trackSliderZoom' && tbID != 'trackSliderImageSet' && tbID.indexOf('trackSliderFilter') == -1) { // Sliders actions handled in event manager below.
						Z.Utils.removeEventListener(targetBtn.childNodes[1], 'mousedown', buttonEventsHandler);
						Z.Utils.removeEventListener(targetBtn.childNodes[1], 'mouseout', buttonEventsHandler);
						Z.Utils.addEventListener(targetBtn.childNodes[2], 'mouseup', buttonEventsHandler);
						Z.Utils.addEventListener(targetBtn.childNodes[2], 'mouseout', buttonEventsHandler);
						if (tbID == 'buttonSliderZoom') {
							sliderSlideStartZoom(event);
							sliderMouseMoveHandlerZoom(event); // Run once so values are defined at first movement.
							Z.Utils.addEventListener(document, 'mousemove', sliderMouseMoveHandlerZoom);
							if (!sliderIntervalZoom) { sliderIntervalZoom = window.setInterval(sliderSlideZoom, SLIDERTESTDURATION_ZOOM); }
							Z.Utils.addEventListener(document, 'mouseup', buttonEventsHandler);
						} else if (tbID.indexOf('buttonSliderFilter') != -1) {
							imageFilterEventsManager(event, tbID, 'sliderStart');
							sliderMouseMoveHandlerFilter(event, tbID); // Run once so values are defined at first movement.
							Z.Utils.addEventListener(document, 'mousemove', sliderMouseMoveHandlerFilter);
							if (!sliderIntervalFilter) { sliderIntervalFilter = window.setInterval( function() { imageFilterEventsManager(event, tbID, 'sliderSlide'); }, SLIDERTESTDURATION_FILTER); }
							Z.Utils.addEventListener(document, 'mouseup', buttonEventsHandler);
						} else if (tbID == 'buttonSliderImageSet') {
							sliderSlideStartImageSet(event);
							sliderMouseMoveHandlerImageSet(event); // Run once so values are defined at first movement.
							Z.Utils.addEventListener(document, 'mousemove', sliderMouseMoveHandlerImageSet);
							if (!sliderIntervalImageSet) { sliderIntervalImageSet = window.setInterval(sliderSlideImageSet, SLIDERTESTDURATION_IMAGESET); }
							Z.Utils.addEventListener(document, 'mouseup', buttonEventsHandler);
						}
					} else {
						Z.Utils.addEventListener(document, 'mouseup', buttonEventsHandler);
					}
					if (tbViewport) { buttonEventsManager(event, tbID); }
					break;
				case 'mouseup' :
					Z.buttonIsDown = false;
					if (tbID != 'trackSliderZoom' && tbID != 'trackSliderImageSet' && tbID.indexOf('trackSliderFilter') == -1) { // Sliders actions handled in event manager below.
						Z.Utils.removeEventListener(targetBtn.childNodes[2], 'mouseup', buttonEventsHandler);
						Z.Utils.removeEventListener(targetBtn.childNodes[2], 'mouseout', buttonEventsHandler);
						Z.Utils.addEventListener(targetBtn.childNodes[1], 'mousedown', buttonEventsHandler);
						Z.Utils.addEventListener(targetBtn.childNodes[1], 'mouseout', buttonEventsHandler);
						if (targetBtnOrig && (buttonSliderZoomDown || buttonSliderFilterDown || buttonSliderImageSetDown)) {
							Z.Utils.removeEventListener(targetBtnOrig.childNodes[0], 'mouseup', buttonEventsHandler);
						}
					} else {
						Z.Utils.addEventListener(document, 'mouseup', buttonEventsHandler);
					}
					if (tbViewport) { buttonEventsManager(event, tbID); }
					break;
				case 'mouseout' :
					if (tbID != 'trackSliderZoom' && tbID.indexOf('trackSliderFilter') == -1 && tbID != 'trackSliderImageSet') { // Slider track for image set will have mouse over and out event handlers for setting mousewheel focus.
						Z.Utils.removeEventListener(targetBtn.childNodes[1], 'mousedown', buttonEventsHandler);
						Z.Utils.removeEventListener(targetBtn.childNodes[1], 'mouseout', buttonEventsHandler);
						Z.Utils.addEventListener(targetBtn.childNodes[0], 'mouseover', buttonEventsHandler);
						if (tbViewport) { buttonEventsManager(event, tbID); }
						if (tbID == 'buttonImageSetPrior' || tbID == 'buttonSliderImageSet' || tbID == 'trackSliderImageSet' || tbID == 'buttonImageSetNext' || tbID == 'buttonZoomIn' || tbID == 'buttonSliderZoom' || tbID == 'buttonZoomOut') {
							Z.sliderFocus = (Z.mouseWheel == 2) ? 'imageSet' : 'zoom';
						}
					} else {
						Z.Utils.removeEventListener(targetBtn.childNodes[0], 'mouseout', buttonEventsHandler);
						Z.sliderFocus = (Z.mouseWheel == 2) ? 'imageSet' : 'zoom';
					}
					break;
				case 'touchstart' :
					if (tbID == 'buttonSliderZoom') {
						sliderSlideStartZoom(event);
						sliderTouchMoveHandlerZoom(event); // Run once so values are defined at first movement.
						Z.Utils.addEventListener(document, 'touchmove', sliderTouchMoveHandlerZoom);
						if (!sliderIntervalZoom) { sliderIntervalZoom = window.setInterval(sliderSlideZoom, SLIDERTESTDURATION_ZOOM); }
					} else if (tbID.indexOf('buttonSliderFilter') != -1) {
						imageFilterEventsManager(event, tbID, 'sliderStart');
						sliderTouchMoveHandlerFilter(event, tbID); // Run once so values are defined at first movement.
						Z.Utils.addEventListener(document, 'touchmove', sliderTouchMoveHandlerFilter);
						if (!sliderIntervalFilter) { sliderIntervalFilter = window.setInterval( function() { imageFilterEventsManager(event, tbID, 'sliderSlide'); }, SLIDERTESTDURATION_FILTER); }
					} else if (tbID == 'buttonSliderImageSet') {
						sliderSlideStartImageSet(event);
						sliderTouchMoveHandlerImageSet(event); // Run once so values are defined at first movement.
						Z.Utils.addEventListener(document, 'touchmove', sliderTouchMoveHandlerImageSet);
						if (!sliderIntervalImageSet) { sliderIntervalImageSet = window.setInterval(sliderSlideImageSet, SLIDERTESTDURATION_IMAGESET); }
					}
					Z.Utils.addEventListener(targetBtn, 'touchend', buttonEventsHandler);
					Z.Utils.addEventListener(targetBtn, 'touchcancel', buttonEventsHandler);
					if (tbViewport) { buttonEventsManager(event, tbID); }
					break;
				case 'touchend' :
					Z.Utils.addEventListener(targetBtn, 'touchstart', buttonEventsHandler);
					if (tbViewport) { buttonEventsManager(event, tbID); }
					break;
				case 'touchcancel' :
					Z.Utils.addEventListener(targetBtn, 'touchstart', buttonEventsHandler);
					if (tbViewport) { buttonEventsManager(event, tbID); }
					break;
				case 'MSPointerDown' :
					if (tbID == 'buttonSliderZoom') {
						sliderSlideStartZoom(event);
						sliderTouchMoveHandlerZoom(event); // Run once so values are defined at first movement.
						Z.Utils.addEventListener(document, 'MSPointerMove', sliderTouchMoveHandlerZoom);
						if (!sliderIntervalZoom) { sliderIntervalZoom = window.setInterval(sliderSlideZoom, SLIDERTESTDURATION_ZOOM); }
					} else if (tbID.indexOf('SliderFilter') != -1) {
						imageFilterEventsManager(event, tbID, 'sliderStart');
						sliderTouchMoveHandlerFilter(event, tbID); // Run once so values are defined at first movement.
						Z.Utils.addEventListener(document, 'MSPointerMove', sliderTouchMoveHandlerFilter);
						if (!sliderIntervalFilter) { sliderIntervalFilter = window.setInterval( function() { imageFilterEventsManager(event, tbID, 'sliderSlide'); }, SLIDERTESTDURATION_FILTER); }
					} else if (tbID == 'buttonSliderImageSet') {
						sliderSlideStartImageSet(event);
						sliderTouchMoveHandlerImageSet(event); // Run once so values are defined at first movement.
						Z.Utils.addEventListener(document, 'MSPointerMove', sliderTouchMoveHandlerImageSet);
						if (!sliderIntervalImageSet) { sliderIntervalImageSet = window.setInterval(sliderSlideImageSet, SLIDERTESTDURATION_IMAGESET); }
					}
					Z.Utils.addEventListener(targetBtn, 'MSPointerUp', buttonEventsHandler);
					if (tbViewport) { buttonEventsManager(event, tbID); }
					break;
				case 'MSPointerUp' :
					Z.Utils.addEventListener(targetBtn, 'MSPointerDown', buttonEventsHandler);
					if (tbViewport) { buttonEventsManager(event, tbID); }
					break;
			}
		}
	}

	function buttonEventsManager (event, tbID) {
		var eventType = event.type;

		// Use vp ID 0 if one panel, or actual ID if many panels.
		var vp0MIDStr = (Z.annotationFileShared) ? '0' : tbViewportIDStr;
		var isAltKey = event.altKey;

		if (eventType == 'click') {
			if (Z.comparison && tbID.indexOf('Sync') != -1) {
				var eventTarget = Z.Utils.target(event);
				Z.syncComparison = eventTarget.checked;
				Z.Viewer.syncComparisonViewport(true); // checkboxSyncComparison
			} else if (Z.tracking && tbID.indexOf('Count') != -1) {
				tbViewport.trackingEventsManager(event, tbID); // checkboxCountersShow, checkboxCountingComplete
			} else if (Z.userLogging && tbID.indexOf('User') != -1) {
				tbViewport.trackingEventsManager(event, tbID); // checkboxUserCountersShow
			} else if (Z.imageFilters && tbID.indexOf('Filter') != -1) {
				imageFilterEventsManager(event, tbID, 'checkbox'); // checkboxFilterGrayscale, checkboxFilterThreshold, checkboxFilterInversion, checkboxFilterEqualize, checkboxFilterEdges, checkboxFilterSepia
			}
			// DEV NOTE: Review need for checkboxRollover dedicated handler.

		} else if (eventType == 'mousedown' || eventType == 'touchstart') {

			// Remove editing cursor from any current text region and position current edit mode indicator.
			textElementRemoveFocus();
			self.positionButtonBorder(tbID);

			// DEV NOTE: Workaround for conflict between viewport ID and counter row ID suffixes.
			if (Z.tracking && tbID.indexOf('buttonCounterListShow') != -1) {
				tbID = 'buttonCounterListShow';
			}

			switch (tbID) {
				case 'buttonMinimize' :
					if (isAltKey) {
						tbViewport.setHotspotsVisibility(!tbViewport.getHotspotsVisibility());
					} else {
						self.minimize(true);
						if (Z.Navigator) {
							Z.Navigator.setVisibility(false);
							if (Z.comparison) { Z.Navigator2.setVisibility(false); }
						}
						if (Z.Gallery) { Z.Gallery.setVisibility(false); }
					}
					break;
				case 'buttonExpand' :
					if (isAltKey) {
						tbViewport.setHotspotsVisibility(!tbViewport.getHotspotsVisibility());
					} else {
						self.minimize(false);
						if (Z.Navigator) {
							Z.Navigator.setVisibility(true);
							if (Z.comparison) { Z.Navigator2.setVisibility(true); }
						}
						if (Z.Gallery) { Z.Gallery.setVisibility(true); }
					}
					break;
				case 'buttonZoomOut' :
					if (!isAltKey) { tbViewport.zoom('out'); }
					break;

				case 'buttonZoomIn' :
					if (!isAltKey) { tbViewport.zoom('in'); }
					break;
				case 'buttonPanLeft' :
					tbViewport.pan('left');
					break;
				case 'buttonPanUp' :
					tbViewport.pan('up');
					break;
				case 'buttonPanDown' :
					tbViewport.pan('down');
					break;
				case 'buttonPanRight' :
					tbViewport.pan('right');
					break;
				case 'buttonReset' :
					tbViewport.reset(isAltKey);
					break;

				case 'buttonFullView' :
					// DEV NOTE: Function called on mouseup to avoid conflict with fullscreen mode change processing.
					//tbViewport.toggleFullViewMode(true);
					break;
				case 'buttonFullViewExit' :
					// DEV NOTE: Function called on mouseup to avoid conflict with fullscreen mode change processing.
					//tbViewport.toggleFullViewMode(false);
					break;

				case 'buttonMeasure' :
					tbViewport.toggleEditModeMeasure(true);
					break;
				case 'buttonMeasureExit' :
					tbViewport.toggleEditModeMeasure(false);
					break;

				case 'buttonHelp' :
					// Help is provided in five ways: viewer help for toolbar button, viewer help + annotation viewing help for toolbar button in annotation viewing mode,
					// markup editing help for markup button in markup editing mode, and annotation editing help for annotation panel button in annotation editing mode.
					// In addition, the zHelpPath parameter enables a fifth alternative, a custom help window.
					// This fifth option is managed within the showHelp function.
					if (Z.annotations && Z.editMode === null) {
						// Viewer help + annotation viewing help for toolbar button in annotation viewing mode.
						Z.Utils.showHelp(Z.Utils.getResource('CONTENT_HELPTOOLBAR') + Z.Utils.getResource('CONTENT_HELPCONCATENATOR') + Z.Utils.getResource('CONTENT_HELPANNOTATIONVIEWING'));
					} else {
						// Viewer help for toolbar button.
						Z.Utils.showHelp(Z.Utils.getResource('CONTENT_HELPTOOLBAR'));
					}
					break;
				case 'buttonHelpMarkup' + vp0MIDStr :
					// Markup editing help for markup button in markup editing mode.
					Z.Utils.showHelp(Z.Utils.getResource('CONTENT_HELPMARKUP'));
					break;
				case 'buttonHelpAnnotation' + vp0MIDStr :
					// Annotation editing help for annotation panel button in annotation editing mode.
					Z.Utils.showHelp(Z.Utils.getResource('CONTENT_HELPANNOTATIONEDITING'));
					break;

				case 'buttonRotateClockwise' :
					tbViewport.rotate('clockwise', isAltKey);
					break;
				case 'buttonRotateCounterwise' :
					tbViewport.rotate('counterwise', isAltKey);
					break;

				case 'buttonTourPrior' :
					tbViewport.priorDestination(true);
					break;
				case 'buttonTourNext' :
					tbViewport.nextDestination(true);
					break;
				case 'buttonTourStart' :
					tbViewport.tourStart();
					break;
				case 'buttonTourStop' :
					tbViewport.tourStop();
					break;

				case 'buttonSlideshowPrior' :
					tbViewport.priorSlide(true);
					break;
				case 'buttonSlideshowNext' :
					tbViewport.nextSlide(true);
					break;
				case 'buttonSlideshowStart' :
					tbViewport.slideshowStart();
					break;
				case 'buttonSlideshowStop' :
					tbViewport.slideshowStop();
					break;

				case 'buttonAudioOn' :
					tbViewport.audioMute(true);
					break;
				case 'buttonAudioMuted' :
					tbViewport.audioMute(false);
					break;

				case 'buttonImageFilterPanelShow' :
					self.imageFilterPanelShow();
					break;
				case 'buttonImageFilterPanelHide' :
					self.imageFilterPanelHide();
					break;
				case 'buttonImageFilterPanelHideOnPanel' :
					self.imageFilterPanelHide();
					break;

				case 'buttonImageSetPrior' :
					// Handle here if animation, on mouseup if slidestack.
					if (Z.animation) { Z.Viewer.viewportChange('backward'); }
					break;
				case 'buttonImageSetNext' :
					// Handle here if animation, on mouseup if slidestack.
					if (Z.animation) { Z.Viewer.viewportChange('forward'); }
					break;

				case 'buttonPreload' :
					if (Z.imageSet) {
						Z.Viewer.preloadTiles();
					} else {
						Z.Viewport.preloadTiles();
					}
					break;

				case 'buttonPOIGo' + vp0MIDStr :
					tbViewport.goToPOICurrent();
					break;
				case 'buttonPOIAdd' + vp0MIDStr :
					tbViewport.addNewPOI();
					break;
				case 'buttonPOIEdit' + vp0MIDStr :
					tbViewport.editCurrentPOI();
					break;
				case 'buttonPOIDelete' + vp0MIDStr :
					tbViewport.deleteCurrentPOI();
					break;
				case 'buttonPOICancel' + vp0MIDStr :
					tbViewport.cancelEditsPOI();
					break;
				case 'buttonPOISave' + vp0MIDStr :
					tbViewport.saveEditsPOI();
					break;
				case 'buttonLabelGo' + vp0MIDStr :
					tbViewport.goToLabelCurrent();
					break;
				case 'buttonLabelAdd' + vp0MIDStr :
					tbViewport.addNewLabel();
					break;
				case 'buttonLabelEdit' + vp0MIDStr :
					tbViewport.editCurrentLabel();
					break;
				case 'buttonLabelDelete' + vp0MIDStr :
					tbViewport.deleteCurrentLabel();
					break;
				case 'buttonLabelCancel' + vp0MIDStr :
					tbViewport.cancelEditsLabel();
					break;
				case 'buttonLabelSave' + vp0MIDStr :
					tbViewport.saveEditsLabel(false, true, true); // Parameters are continueEditing, saveForce, saveImage.
					break;
				case 'buttonNoteAdd' + vp0MIDStr :
					tbViewport.addNewNote();
					break;
				case 'buttonNoteEdit' + vp0MIDStr :
					tbViewport.editCurrentNote();
					break;
				case 'buttonNoteDelete' + vp0MIDStr :
					tbViewport.deleteCurrentNote();
					break;
				case 'buttonNoteCancel' + vp0MIDStr :
					tbViewport.cancelEditsNote();
					break;
				case 'buttonNoteSave' + vp0MIDStr :
					tbViewport.saveEditsNote();
					break;

				case 'buttonClearAll' + vp0MIDStr :
					// Debug option:
					//tbViewport.testSetAnnotationPath();
					tbViewport.deleteAllAnnotations();
					break;

				case 'buttonViewMode' + vp0MIDStr :
					tbViewport.setEditModeLabel('view');
					break;
				case 'buttonEditColorPicker' + vp0MIDStr :
					tbViewport.toggleLabelColorPicker();
					break;
				case 'buttonEditModeFreehand' + vp0MIDStr :
					tbViewport.setEditModeLabel('freehand');
					break;
				case 'buttonEditModeText' + vp0MIDStr :
					tbViewport.setEditModeLabel('text');
					break;
				case 'buttonEditModeIcon' + vp0MIDStr :
					tbViewport.setEditModeLabel('icon');
					break;
				case 'buttonEditModeRectangle' + vp0MIDStr :
					tbViewport.setEditModeLabel('rectangle');
					break;
				case 'buttonEditModePolygon' + vp0MIDStr :
					tbViewport.setEditModeLabel('polygon');
					break;
				case 'buttonEditModeMeasure' + vp0MIDStr :
					tbViewport.setEditModeLabel('measure');
					break;

				case 'buttonLabelScaleDown' + vp0MIDStr :
					tbViewport.labelScale('down');
					break;
				case 'buttonLabelScaleUp' + vp0MIDStr :
					tbViewport.labelScale('up');
					break;

				case 'buttonCounterListShow' :
					tbViewport.trackingEventsManager(event, tbID);
					break;
				case 'buttonCounterListHide' + vp0MIDStr :
					tbViewport.trackingEventsManager(event, tbID);
					break;
				case 'buttonToggleTrackingNav' + vp0MIDStr :
					tbViewport.trackingEventsManager(event, tbID);
					break;
				case 'buttonTrackingClearLast' + vp0MIDStr :
					tbViewport.trackingEventsManager(event, tbID);
					break;
				case 'buttonTrackingClearType' + vp0MIDStr :
					tbViewport.trackingEventsManager(event, tbID);
					break;
				case 'buttonTrackingClearAll' + vp0MIDStr :
					tbViewport.trackingEventsManager(event, tbID);
					break;
				case 'buttonTrackingSave' + vp0MIDStr :
					tbViewport.trackingEventsManager(event, tbID);
					break;

				default :
					if (tbID.substr(0, 11) == 'buttonColor') {
						tbViewport.setDrawingColor(tbID);
					}
			}

		} else if (eventType == 'mouseup' || eventType == 'touchend' || eventType == 'touchcancel') {
			if (tbID == 'buttonSliderZoom' || buttonSliderZoomDown) {
				if (sliderIntervalZoom) {
					window.clearInterval(sliderIntervalZoom);
					sliderIntervalZoom = null;
				}
				setToolbarDefaults();
				sliderSlideEndZoom();
			} else if (tbID == 'trackSliderZoom') {
				sliderSnapZoom(event);
			} else if (tbID.indexOf('buttonSliderFilter') != -1 || buttonSliderFilterDown) {
				if (sliderIntervalFilter) {
					window.clearInterval(sliderIntervalFilter);
					sliderIntervalFilter = null;
				}
				setToolbarDefaults();
				imageFilterEventsManager(event, tbID, 'sliderEnd');
			} else if (tbID.indexOf('trackSliderFilter') != -1) {
				imageFilterEventsManager(event, tbID, 'sliderSnap');
			} else if (tbID == 'buttonImageFilterPlus' || tbID == 'buttonImageFilterMinus') {
				imageFilterEventsManager(event, tbID);
			} else if (tbID == 'buttonSliderImageSet' || buttonSliderImageSetDown) {
				if (sliderIntervalImageSet) {
					window.clearInterval(sliderIntervalImageSet);
					sliderIntervalImageSet = null;
				}
				setToolbarDefaults();
				sliderSlideEndImageSet();
			} else if (tbID == 'buttonZoomOut' || tbID == 'buttonZoomIn') {
				tbViewport.zoom('stop');
				// Optional means to toggle smooth zoom off and on.
				if (tbID == 'buttonZoomOut' && isAltKey) { tbViewport.toggleSmoothZoom(); }
				// Optional means to toggle between edit and view modes.
				if (tbID == 'buttonZoomIn' && isAltKey) { tbViewport.toggleEditMode(); }
			} else if (tbID == 'buttonPanLeft' || tbID == 'buttonPanRight') {
				if (!Z.tracking) {
					tbViewport.pan('horizontalStop');
				} else {
					if (tbID == 'buttonPanLeft') {
						Z.viewportCurrent.goToNextCell('left');
					} else {
						Z.viewportCurrent.goToNextCell('right');
					}
				}
				// Optional means to toggle smooth pan off and on.
				if (tbID == 'buttonPanLeft' && isAltKey) { tbViewport.toggleSmoothPan(); }
			} else if (tbID == 'buttonPanUp' || tbID == 'buttonPanDown') {
				if (!Z.tracking) {
					tbViewport.pan('verticalStop');
				} else {
					if (tbID == 'buttonPanUp' ) {
						Z.viewportCurrent.goToNextCell('up');
					} else {
						Z.viewportCurrent.goToNextCell('down');
					}
				}
			} else if (tbID == 'buttonHelp') {
				// Optional means to display Viewer global variable values when debug parameter is not set in web page.
				if (Z.debug == 0 && isAltKey) { Z.Utils.showGlobals(); }
			} else if (tbID == 'buttonRotateClockwise' || tbID == 'buttonRotateCounterwise') {
				if (Z.rotationFree) { tbViewport.rotate('stop'); }
			} else if (tbID == 'buttonLabelScaleDown' + vp0MIDStr || tbID == 'buttonLabelScaleUp' + vp0MIDStr) {
				tbViewport.labelScale('stop');
			} else if (tbID == 'buttonFullView') {
				// DEV NOTE: Function called on mouseup to avoid conflict with fullscreen mode change processing.
				tbViewport.toggleFullViewMode(true);
			} else if (tbID == 'buttonFullViewExit') {
				// DEV NOTE: Function called on mouseup to avoid conflict with fullscreen mode change processing.
				tbViewport.toggleFullViewMode(false);
			} else if (tbID == 'buttonImageFilterClear') {
				tbViewport.clearImageFilterLast();
			} else if (tbID == 'buttonImageFiltersClearAll') {
				tbViewport.clearImageFiltersAll();
			} else if (tbID == 'trackSliderImageSet') {
				if (Z.slidestack) { sliderSnapImageSet(event); }
			} else if (tbID == 'buttonImageSetPrior' || tbID == 'buttonImageSetNext') {
				if (Z.animation) {
					Z.Viewer.viewportChange('stop');
				} else if (Z.slidestack) {
					if (tbID == 'buttonImageSetPrior') {
						Z.Viewer.viewportChange('backward');
					} else if (tbID == 'buttonImageSetNext') {
						Z.Viewer.viewportChange('forward');
					}
				}
			}

		} else if (eventType == 'mouseout') {
			if (tbID == 'buttonZoomOut' || tbID == 'buttonZoomIn') {
				tbViewport.zoom('stop');
			} else if (tbID == 'buttonPanLeft' || tbID == 'buttonPanRight') {
				tbViewport.pan('horizontalStop');
			} else if (tbID == 'buttonPanUp' || tbID == 'buttonPanDown') {
				tbViewport.pan('verticalStop');
			} else if (tbID == 'buttonLabelScaleDown' + vp0MIDStr || tbID == 'buttonLabelScaleUp' + vp0MIDStr) {
				tbViewport.labelScale('stop');
			} else if (tbID == 'buttonImageSetPrior' || tbID == 'buttonImageSetNext') {
				Z.Viewer.viewportChange('stop');
			}
		}
	}

	this.backgroundEventsHandler = function (event) {
		// Background mouseover event is backup for mouseout of buttons.
		var event = Z.Utils.event(event);
		var relatedTarget = Z.Utils.relatedTarget(event);
		if (relatedTarget) {
			var targetBtn = relatedTarget.parentNode;
			if (targetBtn) {
				var tbID = targetBtn.id;
				if (tbID) {
					if (!buttonSliderZoomDown && !buttonSliderFilterDown && !buttonSliderImageSetDown && tbID.indexOf('button') != -1 && tbID.indexOf('buttonContainer') == -1) {
						Z.Utils.setButtonDefaults(relatedTarget.parentNode);
					}
				}
			}
		}
	}

	function setToolbarDefaults () {
		if (buttonSliderZoomDown) {
			Z.Utils.removeEventListener(document, 'mousemove', sliderMouseMoveHandlerZoom);
			Z.Utils.removeEventListener(document, 'mouseup', buttonEventsHandler);
			Z.Utils.removeEventListener(document, 'touchmove', sliderTouchMoveHandlerZoom);
		} else if (buttonSliderFilterDown) {
			Z.Utils.removeEventListener(document, 'mousemove', sliderMouseMoveHandlerFilter);
			Z.Utils.removeEventListener(document, 'mouseup', buttonEventsHandler);
			Z.Utils.removeEventListener(document, 'touchmove', sliderTouchMoveHandlerFilter);
		} else if (buttonSliderImageSetDown) {
			Z.Utils.removeEventListener(document, 'mousemove', sliderMouseMoveHandlerImageSet);
			Z.Utils.removeEventListener(document, 'mouseup', buttonEventsHandler);
			Z.Utils.removeEventListener(document, 'touchmove', sliderTouchMoveHandlerImageSet);
		}
		var toolbarChildren = Z.ToolbarDisplay.childNodes;
		for (var i = 0, j = toolbarChildren.length; i < j; i++) {
			var target = toolbarChildren[i];
			var tID = target.id;
			if (tID && tID.indexOf('button') != -1) {
				if (tID != 'buttonContainer' && tID != 'buttonContainerImageFilter') {
					Z.Utils.setButtonDefaults(target);
				} else {
					var targetChildren = target.childNodes;
					for (var k = 0, m = targetChildren.length; k < m; k++) {
						var targetSub = targetChildren[k];
						var tIDS = targetSub.id;
						if (tIDS && tIDS.indexOf('button') != -1) {
							Z.Utils.setButtonDefaults(targetSub);
						}
					}
				}
			}
		}
	}

	function sliderMouseMoveHandlerZoom (event) {
		sliderIntervalMousePtZoom = new Z.Utils.Point(event.clientX, event.clientY);
	}

	function sliderTouchMoveHandlerZoom (event) {
		var touch = Z.Utils.getFirstTouch(event);
		if (touch) {
			var target = touch.target;
			sliderIntervalMousePtZoom = new Z.Utils.Point(touch.pageX, touch.pageY);
		}
	}

	function buttonGraphicsUpdate (targetBtn, eT) {
		if (targetBtn.id.indexOf('button') != -1 && targetBtn.id.indexOf('buttonContainer') == -1) {
			var iU = targetBtn.firstChild;
			var iO = targetBtn.childNodes[1];
			var iD = targetBtn.childNodes[2];
			if (iU && iO && iD) {
				var iuS = iU.style;
				var ioS = iO.style;
				var idS = iD.style;
				iuS.visibility = ioS.visibility = idS.visibility = 'hidden';
				// First line assigns priority to slider button mousedown state over mouse out/over/up events of other buttons.
				if (eT == 'mouseover' && targetBtn.id == 'buttonSliderZoom' && buttonSliderZoomDown) {
					idS.visibility = 'visible';
				} else if (eT == 'mouseover' && targetBtn.id.indexOf('buttonSliderFilter') != -1 && buttonSliderFilterDown) {
					idS.visibility = 'visible';
				} else if (eT == 'mouseover' && targetBtn.id == 'buttonSliderImageSet' && buttonSliderImageSetDown) {
					idS.visibility = 'visible';
				} else if (eT == 'mouseover' || eT == 'mouseup') {
					ioS.visibility = 'visible';
				} else if (eT == 'mousedown' || eT == 'mousemove' || eT == 'touchstart' || eT == 'MSPointerDown') {
					idS.visibility = 'visible';
				} else if (eT == 'mouseout' || eT == 'touchend' || eT == 'touchcancel' || eT == 'MSPointerUp') {
					iuS.visibility = 'visible';
				}
			}
		}
	}

	function textElementRemoveFocus () {
		var elmt = document.activeElement.id;
		if (Z.Utils.stringValidate(elmt) && (elmt == 'poiNameTextElement' + tbViewportIDStr || elmt == 'labelNameTextElement' + tbViewportIDStr || elmt == 'captionTextElement' || elmt == 'commentTextElement' || elmt == 'tooltipTextElement' || elmt == 'clickURLTextElement' || elmt == 'noteNameTextElement' + tbViewportIDStr || elmt == 'noteTextElement' + tbViewportIDStr)) {
			var currentTextRegion = document.getElementById(elmt);
			currentTextRegion.blur();
		}
	}

	this.positionButtonBorder = function (tbID) {
		// Use vp ID 0 if one panel, or actual ID if many panels.
		var vp0MIDStr = (Z.annotationFileShared) ? '0' : tbViewportIDStr;

		// Position button border large around buttonViewMode, buttonEditModeFreehand, buttonEditModeRectangle,
		// or buttonModePolygon, or position button border small around clicked color button.
		if (tbID.substr(0, 11) == 'buttonColor') {
			var btnBrdr = document.getElementById('buttonBorderSm' + vp0MIDStr);
		} else {
			if (tbID == 'buttonViewMode' + vp0MIDStr || tbID == 'buttonEditModeFreehand' + vp0MIDStr || tbID == 'buttonEditModeText' + vp0MIDStr ||  tbID == 'buttonEditModeIcon' + vp0MIDStr || tbID == 'buttonEditModeRectangle' + vp0MIDStr || tbID == 'buttonEditModePolygon' + vp0MIDStr || tbID == 'buttonEditModeMeasure' + vp0MIDStr) {
				var btnBrdr = document.getElementById('buttonBorderLg' + vp0MIDStr);
			}
		}
		var tgtBtn = document.getElementById(tbID);
		if (btnBrdr && tgtBtn) {
			if (tbID == 'buttonClearAll' + vp0MIDStr) { tgtBtn = document.getElementById('buttonViewMode' + tbViewportID); }
			var btnBrdrS = btnBrdr.style;
			var tgtBtnS = tgtBtn.style;
			btnBrdrS.left = parseFloat(tgtBtnS.left) - 2 + 'px';
			btnBrdrS.top = parseFloat(tgtBtnS.top) - 2 + 'px';
		}
	}

	this.imageFilterPanelShow = function () {
		// Show panel, show Hide button, hide Show button.
		var bGF = document.getElementById('imageFilterPanelBackground');
		var bCF = document.getElementById('buttonContainerImageFilter');
		var bFPS = document.getElementById('buttonImageFilterPanelShow');
		var bFPH = document.getElementById('buttonImageFilterPanelHide');
		if (bGF && bCF && bFPS && bFPH) {
			bGF.style.width = imageFilterPanelW + 'px';
			bCF.style.display = 'inline-block';
			bFPS.style.display = 'none';
			bFPH.style.display = 'inline-block';
		}
		imageFilterPanelVisible = true;
	}

	this.imageFilterPanelHide = function () {
		// Hide panel, hide Hide button, show Show button.
		var bGF = document.getElementById('imageFilterPanelBackground');
		var bCF = document.getElementById('buttonContainerImageFilter');
		var bFPS = document.getElementById('buttonImageFilterPanelShow');
		var bFPH = document.getElementById('buttonImageFilterPanelHide');
		if (bGF && bCF && bFPS && bFPH) {
			bGF.style.width = '0px';
			bCF.style.display = 'none';
			bFPS.style.display = 'inline-block';
			bFPH.style.display = 'none';
		}
		imageFilterPanelVisible = false;
	}

	function imageFilterListChangeHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);

			// Prior implementation used list to select filter as target of buttons. Current implementation
			// presents slider for each filter and uses list to display filter history. This function is not used.
			target.selectedIndex = 0;
		}
	}

	this.addFilterToImageFilterList = function (imgFltrSel, filterValue, filterValue2, modifyPrior) {
		var cliF = document.getElementById('imageFilterList');
		if (cliF) {
			var imgFltrSelFirstUpper = Z.Utils.stringUpperCaseFirstLetter(imgFltrSel);
			var filterPriorIndex = Z.Utils.arrayIndexOfObjectValueSubstring(cliF.options, 'text', imgFltrSelFirstUpper);
			var filterName = '\u00A0\u00A0' + imgFltrSelFirstUpper;

			// Remove 'None' if present.
			if (cliF.options[cliF.options.length - 1].text == '\u00A0\u00A0None') { cliF.options.remove(cliF.options.length - 1); }

			// Calculate filter rounded value if value provided.
			var valueRoundedStr = '';
			if (typeof filterValue !== 'undefined' && filterValue !== null) {
				valueRoundedStr = Z.Utils.roundToFixed(filterValue, 3).toString();
			}

			// Calculate filter rounded second value if provided (used only for RGB range filters).
			var value2RoundedStr = '';
			if (typeof filterValue2 !== 'undefined' && filterValue2 !== null) {
				value2RoundedStr = '-' + Z.Utils.roundToFixed(filterValue2, 3).toString();
			}

			// Add new filter name and amount or modify amount of current entry.
			if (modifyPrior) {
				var currentEntry = cliF.options[filterPriorIndex].text;
				var currentEntryPreAmount = currentEntry.substring(0, currentEntry.indexOf(':\u00A0\u00A0') + 3);
				cliF.options[filterPriorIndex].text = currentEntryPreAmount + valueRoundedStr + value2RoundedStr;
			} else if (cliF.options[cliF.options.length - 1].text.toLowerCase().indexOf(imgFltrSel.toLowerCase()) == -1) {
				cliF.options[cliF.options.length] = new Option(filterName, imgFltrSel);
				if (Z.Utils.stringValidate(valueRoundedStr)) {
					cliF.options[cliF.options.length - 1].text += ':\u00A0\u00A0' + valueRoundedStr + value2RoundedStr;
				}
			} else {
				var currentEntry = cliF.options[cliF.options.length - 1].text;
				var currentEntryPreAmount = currentEntry.substring(0, currentEntry.indexOf(':\u00A0\u00A0') + 3);
				cliF.options[cliF.options.length - 1].text = currentEntryPreAmount + valueRoundedStr + value2RoundedStr;
			}
		}
	}

	function removeFilterFromImageFilterList (imgFltrSel, last) {
		var cliF = document.getElementById('imageFilterList');
		if (cliF) {
			// Remove filter name from history.
			var index = (last) ? cliF.options.length - 1 : Z.Utils.arrayIndexOfObjectValue(cliF.options, 'value', imgFltrSel);
			if (index != -1) {
				cliF.options.remove(index);
				// Consolidate matching sequential filters.
				if ((cliF.options.length > index) && (cliF.options[index].value == cliF.options[index - 1].value)) {
					var string1 = cliF.options[index - 1].text;
					var string2 = cliF.options[index].text;
					var filterName = string1.substring(0, string1.indexOf(':\u00A0\u00A0') + 2);
					var substring1 = string2.substring(string2.indexOf(':\u00A0\u00A0') + 3, string2.length);
					var substring2 = string2.substring(string2.indexOf(':\u00A0\u00A0') + 3, string2.length);
					var sumValue = parseFloat(substring2) + parseFloat(substring1);
					cliF.options[index - 1].text = filterName + sumValue.toString();
					cliF.options.remove(index);
				}
			}

			// Restore 'None' item if not present and history is empty.
			if (cliF.options.length == 2) { cliF.options[cliF.options.length] = new Option('\u00A0\u00A0None', 'null'); }
		}
	}

	function removeAllFiltersFromImageFilterList () {
		var cliF = document.getElementById('imageFilterList');
		if (cliF) {
			cliF.options.length = 0;
			for (var i = 0, j = imageFilterListDP.length; i < j; i++) {
				cliF.options[cliF.options.length] = new Option(imageFilterListDP[i].text, imageFilterListDP[i].value);
			}
		}
	}
};



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::: NAVIGATOR FUNCTIONS :::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.ZoomifyNavigator = function (navViewport) {

	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::: INIT FUNCTIONS ::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Declare variables for navigator internal self-reference and initialization completion.
	var self = this;
	var isInitialized = false;
	var navViewportIDStr = navViewport.getViewportID().toString();
	var validateNavigatorGlobalsInterval;

	// Declare variables for navigator display.
	var navigatorDisplay;
	var nD, ndS, nB, nbS, niC, nicS, nI, nR, nrS;
	var navigatorImage;
	var navigatorImages = [];
	var MOUSECLICK_THRESHOLD_NAVIGATOR = parseInt(Z.Utils.getResource('DEFAULT_MOUSECLICKTHRESHOLDNAVIGATOR'), 10);
	var TOUCHTAP_THRESHOLD_NAVIGATOR = parseInt(Z.Utils.getResource('DEFAULT_TOUCHTAPTHRESHOLDNAVIGATOR'), 10);

	// Declare and set variables local to navigator for size and position.
	var navW = Z.navigatorW;
	var navH = Z.navigatorH;
	var navL = 300;
	var navT = 20;
	var navFit = Z.navigatorFit;
	var navImageW, navImageH = null;

	if (Z.comparison && navViewportIDStr == '1') { navL = Z.viewerW - navW - 1; }

	// Load Zoomify Image thumbnail.
	var navigatorImagePath;

	// Support imageSet viewing.
	if (Z.imagePath != "multiple" || Z.comparison || (Z.overlays && navViewport.getViewportID() == '0')) {
		loadNavigatorImage(initializeNavigator);
	} else {
		loadNavigatorImagesMultiple(initializeNavigatorMultipleViewports);
	}

	function loadNavigatorImage (successFunction, multiViewport) {
		var oneVP = (typeof multiViewport !== "undefined" && multiViewport !== null) ? false : true;
		var navVP = (oneVP) ? navViewport : multiViewport;

		if (Z.tileSource != 'unconverted') {

			if (Z.tileSource == 'ZoomifyImageFile') {
				navigatorImagePath = navVP.formatTilePath(0, 0, 0);
			} else if (Z.tileSource == 'ZoomifyImageFolder') {
				navigatorImagePath = Z.Utils.cacheProofPath(navVP.getImagePath() + '/TileGroup0/' + '0-0-0.' + Z.tileType);
			} else if (Z.tileSource == 'ZoomifyPFFFile') {
				navigatorImagePath = navVP.formatTilePath(0, 0, 0);
			} else if (Z.tileSource == 'IIIFImageServer') {
				navigatorImagePath = navVP.formatTilePath(0, 0, 0);
			} else if (Z.tileSource == 'ImageServer') {
				navigatorImagePath = navVP.formatTilePath(0, 0, 0);
			}
			navigatorImage = null;
			navigatorImage = new Image();
			navigatorImage.onload = successFunction;
			navigatorImage.onerror = navigatorImageLoadingFailed;

			if (navigatorImagePath != 'offsetLoading') {
				if (!oneVP) {
					navigatorImages[navigatorImages.length] = { id:multiViewport.getViewportID().toString(), image:navigatorImage };
				}
				if (Z.tileSource == 'ZoomifyImageFile') {
					var navNetConnector = new Z.NetConnector();
					navNetConnector.loadImage(navigatorImagePath, Z.Utils.createCallback(null, successFunction), 'navigator', null);
				} else {
					navigatorImage.src = navigatorImagePath;
				}
			} else {
				var navigatorImageTimer = window.setTimeout( function () { loadNavigatorImage(successFunction); }, 100);
			}

		} else {
			var unconvertedImage = navVP.getUnconvertedImage();
			if (typeof unconvertedImage !== 'undefined' && unconvertedImage !== null) {
				// Unconverted image: create navigator thumbnail.
				navigatorImage = navVP.createUnconvertedImageThumbnail(unconvertedImage);

				// Initialize navigator if single viewport. If multiple, store thumbnail for one call to initialize in function loadNavigatorImagesMultiple outside for loop that calls this function loadNavigatorImage.
				if (oneVP && typeof successFunction === 'function') {
					successFunction(); // initializeNavigator(placeholder, image)
				} else {
					if (typeof multiViewport !== 'undefined') {
						navigatorImages[navigatorImages.length] = { id:multiViewport.getViewportID().toString(), image:navigatorImage };
					} else {
						// DEV NOTE: Placeholder workaround for browser issue under investigation.
						navigatorImages[navigatorImages.length] = { id:null, image:null };
					}
				}
			} else {
				var loadNavigatorImageTimer = window.setTimeout( function () { loadNavigatorImage(successFunction, multiViewport); }, 100);
			}
		}
	}

	// Support imageSet viewing.
	function loadNavigatorImagesMultiple (successFunction) {
		for (var i = 0, j = Z.imageSetLength; i < j; i++) {
			loadNavigatorImage(null, Z['Viewport' + i.toString()]);
		}
		successFunction(); // initializeNavigatorMultipleViewports
	}

	this.initializeNavigator = function (placeholder, image) {
		initializeNavigator(placeholder, image);
	}

	function initializeNavigator (placeholder, image) {
		//导航器缩略图将通过 navigator.src 赋值在 loadNavigatorImage 函数中接收，
		//除非tileSource是ZoomifyImageFile，在这种情况下缩略图将通过image参数接收
		//该函数作为 loadNavigatorImage 函数的成功函数。
		if (Z.tileSource == 'ZoomifyImageFile') { navigatorImage = image; }

		//验证图像加载完成。
		var testImageContainer = Z.Utils.createContainerElement('div', 'testImageContainer', 'inline-block', 'absolute', 'hidden', navW + 'px', navH + 'px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
		testImageContainer.appendChild(navigatorImage);
		testImageContainer.removeChild(navigatorImage);
		testImageContainer = null;
		var tW = navigatorImage.width;
		var tH = navigatorImage.height;
		if (tW != 0 && tH != 0) {

			//创建导航器显示以包含背景、图像和矩形。
			navigatorDisplay = Z.Utils.createContainerElement('div', 'navigatorDisplay' + navViewportIDStr, 'inline-block', 'absolute', 'hidden', navW + 'px', navH + 'px', navL + 'px', navT + 'px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', null, true);
			Z.NavigatorDisplay = navigatorDisplay; // Global reference for rapid opacity setting from Viewer - not necessary for second Navigator as no dual-navigator slideshows.
			nD = navigatorDisplay;
			ndS = nD.style;
			if (Z.slideshow) { Z.Utils.setOpacity(Z.NavigatorDisplay, 0); }

			//确保查看器元素的 z 顺序正确。
			ndS.zIndex = (Z.baseZIndex + 4).toString();

			//创建背景并设置透明度。
			var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
			var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
			var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');
			var navigatorBackground = Z.Utils.createContainerElement('div', 'navigatorBackground', 'inline-block', 'absolute', 'hidden', navW + 'px', navH + 'px', '0px', '0px', 'none', '0px', backColor, '0px', '0px', 'normal', null, true);
			Z.Utils.setOpacity(navigatorBackground, backAlpha, backColorNoAlpha);
			navigatorDisplay.appendChild(navigatorBackground);
			nB = navigatorBackground;
			nbS = nB.style;

			//添加之前加载的缩略图。
			var navigatorImageContainer = Z.Utils.createContainerElement('div', 'navigatorImageContainer', 'inline-block', 'absolute', 'hidden', navW + 'px', navH + 'px', '0px', '20px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
			navigatorImageContainer.appendChild(navigatorImage);
			navigatorImage.alt = Z.Utils.getResource('UI_NAVIGATORACCESSIBILITYALTATTRIBUTE');
			navigatorDisplay.appendChild(navigatorImageContainer);
			niC = navigatorImageContainer;
			nicS = niC.style;
			nI = navigatorImage;
			var niW = nI.width;
			var niH = nI.height;

			//创建矩形来指示当前视口视图图像中的位置。
			var navigatorRectangle = Z.Utils.createContainerElement('div', 'navigatorRectangle', 'inline-block', 'absolute', 'hidden', navW+1 + 'px', navH+1 + 'px', navL + 'px', navT + 'px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', null, true);
			navigatorRectangle.style.borderColor = Z.Utils.stringValidateColorValue(Z.navigatorRectangleColor);
			navigatorDisplay.appendChild(navigatorRectangle);
			nR = navigatorRectangle;
			nrS = nR.style;

			if (Z.comparison) {
				// Create outline to indicate current viewport.
				var navigatorBorderColor = Z.Utils.getResource('DEFAULT_NAVIGATORBORDERCOLOR');
				var navigatorBorder = Z.Utils.createContainerElement('div', 'navigatorBorder' + navViewportIDStr, 'inline-block', 'absolute', 'hidden', navW+1 + 'px', navH+1 + 'px', navL + 'px', navT + 'px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', null, true);
				navigatorBorder.style.borderColor = Z.Utils.stringValidateColorValue(navigatorBorderColor);
				navigatorDisplay.appendChild(navigatorBorder);
				nBO = navigatorBorder;
				nboS = nB.style;
			}

			// Add navigator to viewer display and set size, position, visibility, and zIndex.
			Z.ViewerDisplay.appendChild(navigatorDisplay);

			// DEV NOTE: Line above causes dimensions of nI to be 0 in IE11. Workaround
			// is to save values before line above and pass them into setSizeAndPosition function below.
			setSizeAndPosition(navW, navH, navL, navT, navFit, niW, niH);
			visibility(Z.navigatorVisible == 1 || Z.navigatorVisible == 2);

			// Enable mouse, initialize navigator, sync to viewport.
			// Prevent object dragging and bubbling.
			Z.Utils.addEventListener(nD, 'mouseover', Z.Utils.stopPropagation);
			Z.Utils.addEventListener(nD, 'mousedown', navigatorMouseDownHandler);
			Z.Utils.addEventListener(nD, 'touchstart', navigatorTouchStartHandler);
			Z.Utils.addEventListener(nD, 'touchmove', navigatorTouchMoveHandler);
			Z.Utils.addEventListener(nD, 'touchend', navigatorTouchEndHandler);
			Z.Utils.addEventListener(nD, 'touchcancel', navigatorTouchCancelHandler);

			setInitialized(true);
			syncToViewport(); // Method also called in setSizeAndPosition | drawLayout above but that is prior to full initialization of navigator.

		} else {
			var navigatorImageLoadedTimer = window.setTimeout( function () { initializeNavigator(placeholder, image); }, 100);
		}
	}

	// Support imageSet viewing.
	function initializeNavigatorMultipleViewports () {
		if (navigatorImages && navigatorImages.length > 0 && navigatorImages[0] !== null && navigatorImages[0].image.width > 0) {
			// Clone thumbnail to protect later reuse.
			var index = Z.Utils.arrayIndexOfObjectValue(navigatorImages, 'id', '0');
			if (index != -1 ) {
				var navigatorImageTemp = navigatorImages[index].image;
				navigatorImage = navigatorImageTemp.cloneNode(false);
				navigatorImageTemp = null;
				if (typeof placeholder === 'undefined') { var placeholder = null; }
				initializeNavigator(placeholder, navigatorImage);
			} else {
				var navigatorImageMultipleViewportTimer = window.setTimeout( function() { initializeNavigatorMultipleViewports(); }, 100);
			}
		} else {
			var navigatorImageMultipleViewportTimer = window.setTimeout( function() { initializeNavigatorMultipleViewports(); }, 100);
		}
	}

	this.setImage = function (imagePath) {
		if (niC && navigatorImage && niC.childNodes.length > 0) {
			if (Z.tracking) { navigatorDisplay.removeChild(navigatorTrackingOverlay);}
			niC.innerHTML = '';
		}
		if (typeof navigatorImages === 'undefined' || navigatorImages === null || navigatorImages.length == 0) {
			loadNavigatorImage(reinitializeNavigator);
		} else {
			var index = Z.Utils.arrayIndexOfObjectValue(navigatorImages, 'id', navViewportIDStr);
			if (index != -1) {
				navigatorImage = navigatorImages[index].image;
				reinitializeNavigator(navigatorImage);
			}
		}
	}

	function reinitializeNavigator (image) {
		if (navigatorDisplay) {
			if (Z.slideshow) { Z.Utils.setOpacity(navigatorDisplay, 0); }
			if (Z.tileSource == 'ZoomifyImageFile') { navigatorImage = image; }

			if (niC && navigatorImage && navigatorImage.width > 0 && navigatorImage.height > 0) {
				// DEV NOTE: Line above causes dimensions of nI to be 0 in IE11. Workaround is to save values before line above and pass them into setSizeAndPosition function below.
				var niW = navigatorImage.width;
				var niH = navigatorImage.height;
				niC.appendChild(navigatorImage);
				nI = navigatorDisplay.childNodes[1].firstChild; // Thumbnail.
				setSizeAndPosition(navW, navH, navL, navT, navFit, niW, niH);
				var componentsVisible = ((Z.ToolbarDisplay && Z.ToolbarDisplay.style.display == 'inline-block' && !Z.ToolbarMinimized) || (typeof slideList !== 'undefined' && slideList !== null && slideList.style.visibility == 'visible'));
				visibility((Z.navigatorVisible == 1 || Z.navigatorVisible == 2) && componentsVisible);

				// Ensure proper z-ordering of Viewer elements.
				navigatorDisplay.style.zIndex = (Z.baseZIndex + 4).toString();

				syncToViewport();

			} else {
				var navigatorImageReinitializationTimer = window.setTimeout( function () { reinitializeNavigator(); }, 100);
			}
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: GET & SET FUNCTIONS ::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getInitialized = function () {
		return getInitialized();
	}

	function getInitialized () {
		return isInitialized;
	}

	function setInitialized (initialized) {
		if (!isInitialized && initialized) {
			isInitialized = true;
			Z.Utils.validateCallback('navigatorInitialized');
			Z.Viewer.validateViewerReady('navigatorInitialized');
		}
	}

	this.setVisibility = function (visible) {
		visibility(visible);
	}

	this.setSelected = function (selected) {
		if (!nBO) { var nBO = document.getElementById('navigatorBorder' + navViewportIDStr); }
		if (nBO) {
			var nboS = nBO.style;
			nboS.display = (selected) ? 'inline-block' : 'none';
		}
	}

	this.syncToViewport = function () {
		syncToViewport();
	}

	this.syncNavigatorRectangleDimensions = function () {
		syncNavigatorRectangleDimensions();
	}

	this.syncNavigatorRotation = function () {
		syncNavigatorRotation();
	}

	this.syncNavigatorRectangleToViewport = function (currentCenterPt) {
		syncNavigatorRectangleToViewport(currentCenterPt);
	}

	// Support imageSet viewing.
	this.setViewport = function (navVwprt) {
		navViewport = navVwprt;
		navViewportIDStr = navViewport.getViewportID().toString();

		// If using overlays and linking navigator to top VP, prevent resetting of thumbnail from base VP to top VP.
		if (!Z.overlays ) { self.setImage(navViewport.getImagePath()); }
	}

	this.drawNavigatorTrackingOverlay = function (trackingCells, navImgArr) {
		var navTrackOverlay = document.getElementById('navigatorTrackingOverlay');
		if (typeof navTrackOverlay === 'undefined' || navTrackOverlay === null) {
			var navTrackOverlay = Z.Utils.createContainerElement('div', 'navigatorTrackingOverlay', 'none', 'absolute', 'visible', navW+1 + 'px', navH+1 + 'px', navL + 'px', navT + 'px', 'none', '0px', 'transparent-none', '0px', '0px', 'normal', null, true);
			navigatorDisplay.appendChild(navTrackOverlay);
		}
		if (navTrackOverlay) {
			while (navTrackOverlay.hasChildNodes()) { navTrackOverlay.removeChild(navTrackOverlay.lastChild); }
			if (typeof navImgArr === 'undefined' || navImgArr === null) { navImgArr = Z.Navigator.getSizeAndPositionNavigatorImage(); }
			if (navImgArr) {
				var overlayCellWPercent = navImgArr.width / Z.imageW;
				var overlayCellHPercent = navImgArr.height / Z.imageH;
				var overlayCellW = Math.round(Z.viewerW * overlayCellWPercent);
				var overlayCellH = Math.round(Z.viewerH * overlayCellHPercent);

				for (var i = 0, j = trackingCells.length; i < j; i++) {
					if (trackingCells[i].complete) {
						var cellIDValues = navViewport.getCoordinatesFromTrackingCellID(trackingCells[i].id);
						if (cellIDValues.x !== null && cellIDValues.y !== null && cellIDValues.z !== null) {

							// Calculate overlay cell sizes and positions.
							var overlayCellZ = cellIDValues.z / 100;
							var cellW = overlayCellW / overlayCellZ;
							var cellH = overlayCellH / overlayCellZ;
							var overlayCellL = Math.floor(cellIDValues.x * cellW);
							var overlayCellT = Math.floor(cellIDValues.y * cellH);

							// Constrain edge overlay cell dimensions to thumbnail area.
							cellW = ((overlayCellL + cellW) <= navImgArr.width) ? cellW : navImgArr.width - overlayCellL;
							cellH = ((overlayCellT + cellH) <= navImgArr.height) ? cellH : navImgArr.height - overlayCellT;

							// Create overlay cells.
							var cellComp = 'cellComp' + i.toString();
							var trackingOverlayCellColor = getTrackingOverlayColor(overlayCellZ);
							navTrackOverlay[cellComp] = Z.Utils.createContainerElement('div', cellComp, 'inline-block', 'absolute', 'visible', cellW + 'px', cellH + 'px', overlayCellL + 'px', overlayCellT + 'px', 'solid', '1px', trackingOverlayCellColor, '0px', '0px', 'normal', null, true);
							navTrackOverlay.appendChild(navTrackOverlay[cellComp]);
							Z.Utils.setOpacity(navTrackOverlay[cellComp], 0.25);
						}
					}
				}
			} else {
				var drawTrackingTimer = window.setTimeout( function () { self.drawNavigatorTrackingOverlay(trackingCells); }, 10);
			}
		}
	}

	getTrackingOverlayColor = function (zoom) {
		var mag = Z.Utils.convertZoomPercentToMagnification(zoom * 100, Z.sourceMagnification, true);
		var magLevelStr = (mag < 2) ? '1' : (mag < 4) ? '2' : (mag < 10) ? '4' : (mag < 16) ? '10' : (mag < 25) ? '16' : (mag < 40) ? '25' : (mag < 60) ? '40' : (mag < 100) ? '60' : 'INFINITY';
		var magColorStr = 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER' + magLevelStr;
		var trackingOverlayColor = Z.Utils.stringValidateColorValue(Z.Utils.getResource(magColorStr));
		return trackingOverlayColor;
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::: CORE FUNCTIONS ::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.validateNavigatorGlobals = function () {
		if (getInitialized()) {
			validateNavigatorGlobals();
		} else {
			validateNavigatorGlobalsInterval = window.setInterval(validateNavigatorGlobals, 300);
		}
	}

	function validateNavigatorGlobals () {
		// Ensure synchronizing calls to navigator functions from viewport have access to navigator
		// internal global variables.  First clear any interval used to call this function after initialization.
		if (getInitialized()) {
			if (validateNavigatorGlobalsInterval) {
				window.clearInterval(validateNavigatorGlobalsInterval);
				validateNavigatorGlobalsInterval = null;
			}
			if (!nD || !ndS || !nB || !nbS || !niC || !nicS || !nI || !nR || !nrS) {
				nD = navigatorDisplay;
				ndS = nD.style;
				nB = navigatorDisplay.firstChild; // Background.
				nbS = nB.style
				niC = navigatorDisplay.childNodes[1]; // Image container.
				nicS = niC.style
				nI = navigatorDisplay.childNodes[1].firstChild; // Thumbnail.
				nR = navigatorDisplay.childNodes[2]; // Navigation rectangle
				nrS = nR.style;
			}
		}
	}

	// DEV NOTE: Dual setSizeAndPosition functions below are workaround for undefined error on load
	// due to unhoisted function expression vs hoisted function declaration and/or IE8 limitations.
	this.setSizeAndPosition = function (width, height, left, top, fit, niW, niH) {
		setSizeAndPosition(width, height, left, top, fit, niW, niH);
	}

	function setSizeAndPosition (width, height, right, top, fit, niW, niH) {
		if (!fit) { fit = navFit; }
		if (typeof width === 'undefined' || width === null) { width = Z.navigatorW; }
		if (typeof height === 'undefined' || height === null) { height = Z.navigatorH; }
		if (typeof right === 'undefined' || right === null) { right = 0; }
		if (typeof top === 'undefined' || top === null) { top = 0; }

		if (!nD) { nD = navigatorDisplay; }
		if (!ndS) { ndS = nD.style; }

		// Set navigator image var explicitly in case image is being reset using setImage function to ensure thumbnail size is reset.
		nI = nD.childNodes[1].firstChild;

		// DEV NOTE: Next two lines are workaround for IE11 issue getting correct navigator image dimensions.
		// See comment on this line in calling function initializeNavigator: Z.ViewerDisplay.appendChild(navigatorDisplay);
		if (nI.width == 0 && niW !== 'undefined' && niW !== null) { nI.width = niW; }
		if (nI.height == 0 && niH !== 'undefined' && niH !== null) { nI.height = niH; }

		if (nD && ndS && nI) {
			// Override defaults and parameters and match Navigator aspect ratio to Viewer.
			if (Z.tracking) { fit = 0; }

			// If fitting navigator to aspect ratio of image or viewer calculate and apply aspect ratio to reset navigator
			// dimensions while constraining it within width and height parameters as bounding maximum values.
			if (typeof fit !== 'undefined' && fit !== null) {
				var navAspect = nI.width / nI.height;
				var viewerAspect = Z.viewerW / Z.viewerH;
				var targetAspect = (fit == 0) ? viewerAspect : navAspect;
				if (navAspect > 1) {
					height = width;
					height /= targetAspect;
				} else {
					width = height;
					width *= targetAspect;
				}
			}

			// Size navigator.
			ndS.width = width + 'px';
			ndS.height = height + 'px';

			// Set navigator position.
			ndS.left = left + 'px';
			ndS.top = top + 'px';

			drawLayout(width, height);
		}

		// Update global values and reposition dependent components.
		Z.navigatorW = width;
		Z.navigatorH = height;
		if (Z.tracking || Z.annotations) {
			if (Z.Ruler && Z.Ruler.getInitialized()) {
				var left = (Z.rulerL == -1 && Z.Navigator) ? Z.navigatorL : Z.rulerL;
				var top = (Z.rulerT == -1 && Z.Navigator) ? (Z.navigatorT + Z.navigatorH + 1) : Z.rulerT;
				Z.Ruler.setSizeAndPosition(Z.rulerW, Z.rulerH, left, top);
			}
			if (Z.userPanelVisible && Z.UserPanel !== null) {
				var panelW = Z.rulerW;
				var panelH = parseInt(Z.Utils.getResource('DEFAULT_USERPANELHEIGHT'), 10);
				var panelCoords = Z.Utils.calculateUserPanelCoords(Z.userPanelPosition, panelW, panelH, Z.viewerW, Z.viewerH);
				var left = (Z.rulerL == -1 && Z.Navigator) ? Z.navigatorL : Z.rulerL;
				var top = (Z.rulerT == -1 && Z.Navigator) ? (Z.navigatorT + Z.navigatorH + 1) : Z.rulerT;
				Z.Utils.sizeAndPositionUserPanel(Z.UserPanel.style, panelW, panelH, panelCoords.x, panelCoords.y);
			}
			if (Z.imageList && navViewport.getStatus('initializedImageList')) {
				navViewport.setSizeAndPositionImageList();
				if (Z.comparison) {
					var vpComparison = (navViewport.getViewportID() == 0) ? Z.Viewport1 : Z.Viewport0;
					if (vpComparison && vpComparison.getStatus('initializedImageList')) { 
						vpComparison.setSizeAndPositionImageList();
					}
				}
			}
		}
	}

	function drawLayout (width, height) {
		if (!nI) { nI = navigatorDisplay.childNodes[1].firstChild; } // Thumbnail image.
		if (nI && nI.width != 0 && nI.height != 0) {
			if (!nbS) { nbS = navigatorDisplay.firstChild.style; } // Background.
			if (!nicS) { nicS = navigatorDisplay.childNodes[1].style; } // Image container.
			if (nbS && nicS) {
				nbS.width = width + 'px';
				nbS.height = height + 'px';
				setSizeNavigatorImage(width, height);
				nicS.width = nI.width + 'px';
				nicS.height = nI.height + 'px';
				nicS.left = ((width - nI.width) / 2) + 'px';
				nicS.top = ((height - nI.height) / 2) + 'px';
				syncToViewport();
				if (Z.comparison) {
					if (!nBO) { var nBO = document.getElementById('navigatorBorder' + navViewportIDStr); }
					if (nBO) {
						var nboS = nBO.style;
						nboS.width = (width - 2) + 'px';
						nboS.height = (height - 2) + 'px';
						nboS.left = parseFloat(nbS.left) + 'px';
						nboS.top = parseFloat(nbS.top) + 'px';
						nboS.display = (navViewportIDStr == Z.viewportCurrentID) ? 'inline-block' : 'none';
					}
				}
			}
		} else {
			var drawLayoutTimer = window.setTimeout( function () { drawLayout(width, height); }, 100);
		}
	}

	function setSizeNavigatorImage (navW, navH) {
		if (!nI) { nI = navigatorDisplay.childNodes[1].firstChild; } // Thumbnail image.
		if (nI) {
			var navImgW = nI.width;
			var navImgH = nI.height;
			var imageAspectRatio = navImgW / navImgH;
			var scaleW = navW / navImgW;
			var scaleH = navH / navImgH;
			if (scaleW <= scaleH) {
				navImgW = navW;
				navImgH = navW / imageAspectRatio;
				navImageT = ((navH - navImgH * (navW / navImgW)) / 2);
			} else if (scaleH < scaleW) {
				navImgH = navH;
				navImgW = navH * imageAspectRatio;
				navImageL = ((navW - navImgW * (navH / navImgH)) / 2);
			}
			nI.width = navImgW;
			nI.height = navImgH;
		}
	}

	this.getSizeAndPositionNavigatorImage = function () {
		if (!nI) { nI = navigatorDisplay.childNodes[1].firstChild; } // Thumbnail image.
		var niArr = null;
		if (typeof nI.parentNode !== 'undefined' && nI.parentNode !== null) {
			var niPS = nI.parentNode.style;
			var niArr = { width:nI.width, height:nI.height, left:parseFloat(niPS.left)-1, top:parseFloat(niPS.top)-1 }
		}
		return niArr;
	}

	function visibility (visible) {
		if (!ndS && navigatorDisplay) { ndS = navigatorDisplay.style; }
		if (ndS) {
			if (visible) {
				ndS.display = 'inline-block';
			} else {
				ndS.display = 'none';
			}
		}
	}

	function syncToViewport () {
		// Set navigator rectangle size and position.
		if (navViewport && navViewport.getStatus('initializedViewport')) {
			syncNavigatorRotation();
			syncNavigatorRectangleDimensions();
			var currentCenterPt = navViewport.calculateCurrentCenterCoordinates();
			syncNavigatorRectangleToViewport(currentCenterPt);
		}
	}

	function syncNavigatorRectangleDimensions () {
		if (nI && nrS) {
			var scaleW = nI.width / Z.imageW;
			var scaleH = nI.height / Z.imageH;

			var recalculate = (Z.comparison && navViewportIDStr != Z.viewportCurrentID);
			var currentZ = navViewport.getZoom(recalculate);

			var vpScaledW = Z.viewerW * scaleW / currentZ;
			if (Z.comparison) { vpScaledW /= 2; }
			var vpScaledH = Z.viewerH * scaleH / currentZ;

			nrS.width = vpScaledW + 'px';
			nrS.height = vpScaledH + 'px';
		}
	}

	function syncNavigatorRotation () {
		if (!nicS && navigatorDisplay) { nicS = navigatorDisplay.childNodes[1].style; } // Image container.
		if (nicS) {
			var currentR = navViewport.getRotation();
			Z.Utils.rotateElement(nicS, currentR, true);
		}
	}

	function syncNavigatorRectangleToViewport (vpImgCtrPt) {
		// Convert image pixel coordinates at viewport display center to navigator
		// pixel coordinates to position top left of navigator rectangle.
		if (nI && nrS && nicS) {
			if (typeof vpImgCtrPt === 'undefined' || vpImgCtrPt === null || (vpImgCtrPt.x == 0 && vpImgCtrPt.y == 0)) {
				var vpImgCtrPt = new Z.Utils.Point(Z.imageX, Z.imageY);
			}
			if (typeof z === 'undefined' || z === null) { z = Z.imageZ; }
			var r = Z.imageR;
			if (r < 0) { r += 360; } // Ensure positive values.

			// Convert coordinates from image pixels to thumbnail pixels.
			var tW = parseFloat(nI.width);
			var tH = parseFloat(nI.height);
			var scaleW = tW / Z.imageW;
			var scaleH = tH / Z.imageH;
			var tX = vpImgCtrPt.x * scaleW;
			var tY = vpImgCtrPt.y * scaleH;

			// Translate coordinates to center axis perspective and rotate.
			var tcX = tX - tW / 2;
			var tcY = tY - tH / 2;
			var rcPt = Z.Utils.rotatePoint(tcX, tcY, -r);

			// Adjust new rectangle position for rectangle and navigator offsets.
			var rL = rcPt.x - parseFloat(nrS.width) / 2;
			var rT = rcPt.y - parseFloat(nrS.height) / 2;
			var ncX = parseFloat(ndS.width) / 2;
			var ncY = parseFloat(ndS.height) / 2;

			var compAdj = (Z.comparison) ? -1 : 0;
			var rnL = ncX + rL + compAdj;
			var rnT = ncY + rT - 1;

			// Apply new thumbnail rectangle coordinates to navigator display.
			nrS.left = rnL + 'px';
			nrS.top = rnT + 'px';
		}
	}

	// Convert navigator pixel coordinates at top left of navigator rectangle to image
	// pixel coordinates at viewport display center and pass to viewport to position view.
	function syncViewportToNavigatorRectangle (click) {
		if (nI && nrS && nicS) {
			var z = Z.imageZ;
			var r = Z.imageR;
			if (r < 0) { r += 360; } // Ensure positive values.

			// Get scaling factor and scale current image coordinates.
			var thumbW = parseFloat(nI.width);
			var thumbH = parseFloat(nI.height);
			 var scaleW = thumbW / Z.imageW;
			var scaleH = thumbH / Z.imageH;
			var thumbX = Z.imageX * scaleW;
			var thumbY = Z.imageY * scaleH;

			// Get offset corrected position of navigator rectangle.
			var psPt = Z.Utils.getPageScroll();
			var scrollOffsetX = (click) ? psPt.x : 0;
			var scrollOffsetY = (click) ? psPt.y : 0;
			var navRectL = parseFloat(nrS.left) + scrollOffsetX;
			var navRectT = parseFloat(nrS.top) + scrollOffsetY;
			var currentX = (navRectL - parseFloat(ndS.width) / 2) + parseFloat(nrS.width) / 2 + thumbW / 2;
			var currentY = (navRectT - parseFloat(ndS.height) / 2) + parseFloat(nrS.height) / 2 + thumbH / 2;

			// Rotate current thumb coords and scale to image pixels.
			var currentPtRotated = Z.Utils.getPositionRotated(currentX, currentY, thumbX, thumbY, -r);
			var newVPImgCtrX = Math.round(currentPtRotated.x / scaleW);
			var newVPImgCtrY = Math.round(currentPtRotated.y / scaleH);

			// Apply new image pixel coordinates to viewport display.
			if (click) {
				navViewport.zoomAndPanToView(newVPImgCtrX, newVPImgCtrY, z, r);
			} else {
				var newVPImgCtrPt = new Z.Utils.Point(newVPImgCtrX, newVPImgCtrY);
				navViewport.syncViewportToNavigator(newVPImgCtrPt);
			}

			// Sync counter tracking.
			if (Z.tracking) { navViewport.syncTrackingToViewport(); }
		}
	}

	function navigatorImageLoadingFailed () {
		Z.Utils.showMessage(Z.Utils.getResource('ERROR_NAVIGATORIMAGEPATHINVALID'));
	}



	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::: EVENT FUNCTIONS :::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function navigatorMouseDownHandler (event) {
		if (!Z.interactive) { return; }

		navViewport.zoomAndPanAllStop(false, true);
		Z.mouseIsDown = true;
		if (Z.comparison) { Z.Viewer.viewportSelect(parseInt(navViewportIDStr, 10)); }
		if (Z.maskingSelection && Z.maskClearOnUserAction) { navViewport.clearMask(); }

		if (nD && nR && nrS) {
			var event = Z.Utils.event(event);
			nR.mouseXPrior = event.clientX;
			nR.mouseYPrior = event.clientY;
			dragPtStart = new Z.Utils.Point(event.clientX, event.clientY);
			Z.Utils.addEventListener(nD, 'mousemove', navigatorMouseMoveHandler);
			Z.Utils.addEventListener(nD, 'mouseup', navigatorMouseUpHandler);
			Z.Utils.addEventListener(document, 'mouseup', navigatorMouseUpHandler);
		}
	}

	function navigatorMouseMoveHandler (event) {
		if (!Z.interactive) { return; }
		if (nR && nrS) {
			var x = parseFloat(nrS.left);
			var y = parseFloat(nrS.top);
			nrS.left = x + (event.clientX - nR.mouseXPrior) + 'px';
			nrS.top = y + (event.clientY - nR.mouseYPrior) + 'px';
			nR.mouseXPrior = event.clientX;
			nR.mouseYPrior = event.clientY;
			syncViewportToNavigatorRectangle(false);
			return false;
		}
	}

	function navigatorMouseUpHandler (event) {
		if (!Z.interactive) { return; }

		Z.mouseIsDown = false;

		if (nD && nR && nrS) {
			document.mousemove = null;
			document.mouseup = null;
			Z.Utils.removeEventListener(nD, 'mousemove', navigatorMouseMoveHandler);
			Z.Utils.removeEventListener(nD, 'mouseup', navigatorMouseUpHandler);
			Z.Utils.removeEventListener(document, 'mouseup', navigatorMouseUpHandler);
			var event = Z.Utils.event(event);
			var dragPtEnd = new Z.Utils.Point(event.clientX, event.clientY);
			var dragDist = Z.Utils.calculatePointsDistance(dragPtStart.x, dragPtStart.y, dragPtEnd.x, dragPtEnd.y);
			var click = dragDist < MOUSECLICK_THRESHOLD_NAVIGATOR;
			if (click) {
				var navDispOffsets = Z.Utils.getElementPosition(navigatorDisplay);
				nrS.left = event.clientX - navDispOffsets.x - (parseFloat(nrS.width) / 2) + 'px';
				nrS.top = event.clientY - navDispOffsets.y - (parseFloat(nrS.height) / 2) + 'px';
			}
			syncViewportToNavigatorRectangle(click);
			if (!Z.comparison || !click) { 
				navViewport.updateView();
			}
		}
	}

	function navigatorTouchStartHandler (event) {
		if (!Z.interactive) { return; }
		Z.mouseIsDown = true;

		event.preventDefault(); // Prevent copy selection.
		if (nD && nR && nrS) {
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				var target = touch.target;
				var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				dragPtStart = new Z.Utils.Point(mPt.x, mPt.y);
				nR.mouseXPrior = mPt.x;
				nR.mouseYPrior = mPt.y;
			}
		}
	}

	function navigatorTouchMoveHandler (event) {
		if (!Z.interactive) { return; }
		event.preventDefault(); // Prevent page dragging.
		if (!Z.mousePan) { return; }  // Disallow mouse panning if parameter false.

		if (nR && nrS) {
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				var target = touch.target;
				var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				var x = parseFloat(nrS.left);
				var y = parseFloat(nrS.top);
				nrS.left = x + (mPt.x - nR.mouseXPrior) + 'px';
				nrS.top = y + (mPt.y - nR.mouseYPrior) + 'px';
				nR.mouseXPrior = mPt.x;
				nR.mouseYPrior = mPt.y;
				syncViewportToNavigatorRectangle(false);
				return false;
			}
		}

		return false;
	}

	function navigatorTouchEndHandler (event) {
		if (!Z.interactive) { return; }
		Z.mouseIsDown = false;

		if (nD && nR && nrS) {
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				var target = touch.target;
				var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				var dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
				var dragDist = Z.Utils.calculatePointsDistance(dragPtStart.x, dragPtStart.y, dragPtEnd.x, dragPtEnd.y);
				var click = dragDist < TOUCHTAP_THRESHOLD_NAVIGATOR;
				if (click) {
					var navDispOffsets = Z.Utils.getElementPosition(navigatorDisplay);
					nrS.left = mPt.x - navDispOffsets.x - (parseFloat(nrS.width) / 2) + 'px';
					nrS.top = mPt.y - navDispOffsets.y - (parseFloat(nrS.height) / 2) + 'px';
				}
			}
			syncViewportToNavigatorRectangle(click);
			navViewport.updateView();
		}
	}

	function navigatorTouchCancelHandler (event) {
		if (!Z.interactive) { return; }
		Z.mouseIsDown = false;

		if (nD && nR && nrS) {
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				var target = touch.target;
				var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				var dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
				var dragDist = Z.Utils.calculatePointsDistance(dragPtStart.x, dragPtStart.y, dragPtEnd.x, dragPtEnd.y);
				var click = dragDist < TOUCHTAP_THRESHOLD_NAVIGATOR;
				if (click) {
					var navDispOffsets = Z.Utils.getElementPosition(navigatorDisplay);
					nrS.left = mPt.x - navDispOffsets.x - (parseFloat(nrS.width) / 2) + 'px';
					nrS.top = mPt.y - navDispOffsets.y - (parseFloat(nrS.height) / 2) + 'px';
				}
			}
			syncViewportToNavigatorRectangle(click);
			navViewport.updateView();
		}
	}
};



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::: GALLERY FUNCTIONS ::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.ZoomifyGallery = function (galViewport) {

	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::: INIT FUNCTIONS ::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Declare variables for gallery internal self-reference and initialization completion.
	var self = this;
	var isInitialized = false;
	var galViewportIDStr = galViewport.getViewportID().toString();
	var validateGalleryGlobalsInterval;

	// Declare variables for gallery display.
	var galleryDisplay, currentGalleryID;
	var gD, gdS, nB, gbS, gSP, gispS, gR, grS, pSL, btnslS, btnSR, btnsrS;
	var slides = [], galleryImages = [];
	var galleryImagePath, galleryImage;
	var MOUSECLICK_THRESHOLD_VIEWPORT = parseInt(Z.Utils.getResource('DEFAULT_MOUSECLICKTHRESHOLDVIEWPORT'), 10);
	var smoothPanGalleryInterval = null, smoothPanGalleryStartX = null, smoothPanGalleryDisplayStartX = null, smoothPanGalleryMouseX = null;
	var smoothPanGalleryDeltaX = 0, smoothPanGalleryLastDeltaX = 0;
	var smoothPanGalleryGliding = null, smoothPanGalleryGlideX = null;

	// Load Zoomify Image thumbnails.
	if (Z.slideshow) {
		loadGalleryImagesSlideshow(initializeGallerySlideshow);
	} else if (Z.imageSet) {
		loadGalleryImagesMultipleViewports(initializeGalleryMultipleViewports);
	} else {
		loadGalleryImage(initializeGallery); // Failsafe if only one image. Otherwise loading function called multiple times by 'multiple function in condition above.
	}

	function loadGalleryImagesSlideshow (successFunction) {
		slides = Z.viewportCurrent.getSlides();
		for (var i = 0, j = slides.length; i < j; i++) {
			loadGalleryImage(null, null, slides[i]);
		}
		successFunction();
	}

	// Support imageSet viewing.
	function loadGalleryImagesMultipleViewports (successFunction) {
		for (var k = 0, m = Z.imageSetLength; k < m; k++) {
			loadGalleryImage(null, Z['Viewport' + k.toString()]);
		}
		successFunction();
	}

	function loadGalleryImage (successFunction, multiViewport, slide) {
		var oneVP = (typeof multiViewport !== 'undefined' && multiViewport !== null) ? false : true;
		var galVP = (oneVP) ? galViewport : multiViewport;
		var slideshow = Z.slideshow && typeof slide !== 'undefined' && slide !== null;

		if (Z.tileSource != 'unconverted') {
			if (Z.tileSource == 'ZoomifyImageFile') {
				galleryImagePath = (slideshow) ? null : galVP.formatTilePath(0, 0, 0);
			} else if (Z.tileSource == 'ZoomifyImageFolder') {
				galleryImagePath = (slideshow) ? Z.Utils.cacheProofPath(slide.media + '/TileGroup0/' + '0-0-0.' + Z.tileType) : galleryImagePath = Z.Utils.cacheProofPath(galVP.getImagePath() + '/TileGroup0/' + '0-0-0.' + Z.tileType);
			} else if (Z.tileSource == 'ZoomifyPFFFile') {
				galleryImagePath = (slideshow) ? null : galVP.formatTilePath(0, 0, 0);
			} else if (Z.tileSource == 'ImageServer') {
				galleryImagePath = (slideshow) ? null : galVP.formatTilePath(0, 0, 0);
			}

			if (galleryImagePath !== null) {
				galleryImage = null;
				galleryImage = new Image();
				galleryImage.onload = successFunction;
				galleryImage.onerror = galleryImageLoadingFailed;

				if (galleryImagePath != 'offsetLoading') {
					if (Z.slideshow || !oneVP) {
						var galleryID = (slideshow) ? slide.internalID : multiViewport.getViewportID().toString();
						var galleryName = (slideshow) ? slide.name : multiViewport.getViewportID().toString();
						galleryImages[galleryImages.length] = { internalID:galleryID, image:galleryImage, name:galleryName };
					}

					if (Z.tileSource == 'ZoomifyImageFile') {
						var galNetConnector = new Z.NetConnector();
						galNetConnector.loadImage(galleryImagePath, Z.Utils.createCallback(null, successFunction), 'gallery', null);
					} else {
						galleryImage.src = galleryImagePath;
					}
				} else {
					var galleryImageTimer = window.setTimeout( function () { loadGalleryImage(successFunction); }, 100);
				}
			}

		} else {
			if (typeof unconvertedImage !== 'undefined' && unconvertedImage !== null) {
				// Unconverted image: create gallery thumbnail.
				galleryImage = galVP.createUnconvertedImageThumbnail(unconvertedImage);

				// Initialize gallery if single viewport. If multiple, store thumbnail for one call to initialize in function loadGalleryImagesMultiple outside for loop that calls this function loadGalleryImage.
				if (oneVP && typeof successFunction === 'function') {
					successFunction(); // initializeGallery(placeholder, image)
				} else {
					if (typeof multiViewport !== 'undefined') {
						galleryImages[galleryImages.length] = { id:multiViewport.getViewportID().toString(), image:galleryImage };
					} else {
						// DEV NOTE: Placeholder workaround for browser issue under investigation.
						galleryImages[galleryImages.length] = { id:null, image:null };
					}
				}
			} else {
				var loadGalleryImageTimer = window.setTimeout( function () { loadGalleryImage(successFunction, multiViewport); }, 100);
			}
		}
	}

	function initializeGallerySlideshow () {
		var imagesReady = galleryImages && slides && galleryImages.length == slides.length;
		if (imagesReady) { imagesReady = Z.Utils.arrayImageLoadingValidate(galleryImages); }
		if (imagesReady) {
			initializeGallery();
		} else {
			var galleryImageSlideshowTimer = window.setTimeout( function() { initializeGallerySlideshow(); }, 100);
		}
	}

	// Support imageSet viewing.
	function initializeGalleryMultipleViewports () {
		var imagesReady = galleryImages && slides && galleryImages.length == slides.length;
		if (imagesReady) { imagesReady = Z.Utils.arrayImageLoadingValidate(galleryImages); }
		if (imagesReady) {
			// Clone thumbnail to protect later reuse.
			var index = Z.Utils.arrayIndexOfObjectValue(galleryImages, 'internalID', '0');
			if (index != -1 ) {
				var galleryImageTemp = galleryImages[index].image;
				galleryImage = galleryImageTemp.cloneNode(false);
				galleryImageTemp = null;
				if (typeof placeholder === 'undefined') { var placeholder = null; }
				initializeGallery();
			} else {
				var galleryImageMultipleViewportTimer = window.setTimeout( function() { initializeGalleryMultipleViewports(); }, 100);
			}
		} else {
			var galleryImageMultipleViewportTimer = window.setTimeout( function() { initializeGalleryMultipleViewports(); }, 100);
		}
	}

	this.initializeGallery = function (placeholder, image) {
		initializeGallery(placeholder, image);
	}

	function initializeGallery (placeholder, galImage) {
		// Failsafe. Gallery intended for multiple images.
		if (typeof galImage !== 'undefined' && galImage !== null) { galleryImage = galImage; }

		// Create gallery display to contain background, image, and rectangle.
		galleryDisplay = Z.Utils.createContainerElement('div', 'galleryDisplay', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', null, true);
		Z.GalleryDisplay = galleryDisplay; // Global reference for rapid opacity setting from Viewer - not necessary for second Gallery as no dual-gallery slideshows.
		gD = galleryDisplay;
		gdS = gD.style;
		if (Z.slideshow) { Z.Utils.setOpacity(Z.GalleryDisplay, 0); }

		// Ensure proper z-ordering of Viewer elements.
		gdS.zIndex = (Z.baseZIndex + 10).toString();

		// Create background and set transparency.
		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_GALLERYBACKGROUNDALPHA'));
		var backColor = Z.Utils.getResource('DEFAULT_GALLERYBACKGROUNDCOLOR');
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_GALLERYBACKGROUNDCOLORNOALPHA');
		var galleryBackground = Z.Utils.createContainerElement('div', 'galleryBackground', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', backColor, '0px', '0px', 'normal', null, true);
		Z.Utils.setOpacity(galleryBackground, backAlpha, backColorNoAlpha);
		galleryDisplay.appendChild(galleryBackground);
		gB = galleryBackground;
		gbS = gB.style;

		// Add scrollable container for image thumbnails.
		var galleryScrollPanel = Z.Utils.createContainerElement('div', 'galleryScrollPanel', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
		Z.GalleryScrollPanel = galleryScrollPanel; // Global reference for rapid sliding from Viewer.
		galleryImage.alt = Z.Utils.getResource('UI_GALLERYACCESSIBILITYALTATTRIBUTE');
		galleryDisplay.appendChild(galleryScrollPanel);
		gSP = galleryScrollPanel;
		gspS = gSP.style;

		// Create rectangle to indicate position within image of current viewport view.
		var galleryRectangle = Z.Utils.createContainerElement('div', 'galleryRectangle', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'solid', '2px', 'transparent none', '0px', '0px', 'normal', null, true);
		galleryRectangle.style.borderColor = Z.Utils.stringValidateColorValue(Z.galleryRectangleColor);
		galleryDisplay.appendChild(galleryRectangle);
		gR = galleryRectangle;
		grS = gR.style;

		// Add gallery to viewer display and set size, position, visibility, and zIndex.
		Z.ViewerDisplay.appendChild(galleryDisplay);

		// Add toolbar height to position of gallery if both at top of Viewer, subtract if both at bottom of Viewer.
		// If Toolbar not yet initialized because still loading XML, use 0 value. Gallery function setSizeAndPosition will be called again when Toolbar initialization completes.
		setSizeAndPosition();
		visibility(Z.galleryVisible == 1 || Z.galleryVisible == 2);

		// Enable mouse, initialize gallery, sync to viewport.
		// Prevent object dragging and bubbling.
		Z.Utils.addEventListener(gD, 'mouseover', Z.Utils.stopPropagation);
		Z.Utils.addEventListener(gD, 'mousedown', galleryMouseDownHandler);
		Z.Utils.addEventListener(document, 'touchstart', galleryTouchStartHandler);
		Z.Utils.addEventListener(document, 'touchmove', galleryTouchMoveHandler);
		Z.Utils.addEventListener(document, 'touchend', galleryTouchEndHandler);
		Z.Utils.addEventListener(document, 'touchcancel', galleryTouchCancelHandler);

		configureGallery();

		var galleryID = (Z.slideshow) ? 0 : (Z.imageSet) ? Z.viewportCurrentID : 0
		self.syncGalleryToViewport(galleryID);
		Z.Utils.setOpacity(Z.GalleryDisplay, 1);
		visibility(true);
		setInitialized(true);

	}

	function configureGallery () {
		var newW, newH, newHRatio, newImg, newImgS;
		var gH = parseFloat(Z.GalleryDisplay.style.height);
		var gW = parseFloat(Z.GalleryDisplay.style.width);
		var margin = Z.galleryM;
		var gppW = margin;
		var dx = margin;

		for (var i = 0, j = galleryImages.length; i < j; i++) {
			var imgContainer = Z.Utils.createContainerElement('div', 'imgContainer' + i.toString(), 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
			imgContainer.appendChild(galleryImages[i].image);
			newImg = imgContainer.firstChild;
			var niW = newImg.width;
			var niH = newImg.height;

			// DEV NOTE: Line below causes dimensions of nI to be 0 in IE11. Workaround
			// is to save values before line above and pass them into setSizeAndPosition function below.
			Z.GalleryScrollPanel.appendChild(imgContainer);
			giC = imgContainer;
			gicS = giC.style;

			newImg.title = galleryImages[i].name; // Set tooltip.
			newImgS = newImg.style;

			newH = Math.round(gH - (margin * 2));
			newHRatio = newH / niH;
			newW = Math.round(niW * newHRatio);

			newImg.width = newW;
			newImg.height = newH;
			imgContainer.style.width = newW + 'px';
			imgContainer.style.height = newH + 'px';
			imgContainer.style.left = dx + 'px';
			imgContainer.style.top = margin + 'px';

			gppW += (newW + margin);
			dx += (newW + margin);

			Z.Utils.addEventListener(imgContainer, 'mouseup', galleryImageMouseUpHandler);
			Z.Utils.addEventListener(imgContainer, 'touchend', galleryImageTouchEndHandler);
			Z.Utils.addEventListener(imgContainer, 'touchcancel', galleryImageTouchCancelHandler);
		}

		gspS.width = gppW + 'px';
		gspS.height = gH + 'px';
		gspS.left = (gppW < gW) ? ((gW - gppW) / 2) + 'px' : '0px';
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: GET & SET FUNCTIONS ::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getInitialized = function () {
		return getInitialized();
	}

	function getInitialized () {
		return isInitialized;
	}

	function setInitialized (initialized) {
		if (!isInitialized && initialized) {
			isInitialized = true;
			Z.Utils.validateCallback('galleryInitialized');
			Z.Viewer.validateViewerReady('galleryInitialized');
		}
	}

	this.setVisibility = function (visible) {
		visibility(visible);
	}

	this.syncGalleryToViewport = function (galleryID) {
		syncGalleryToViewport(galleryID);
	}

	// Support imageSet viewing.
	this.setViewport = function (galVwprt) {
		galViewport = galVwprt;
		galViewportIDStr = galViewport.getViewportID().toString();
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::: CORE FUNCTIONS ::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.validateGalleryGlobals = function () {
		if (getInitialized()) {
			validateGalleryGlobals();
		} else {
			validateGalleryGlobalsInterval = window.setInterval(validateGalleryGlobals, 300);
		}
	}

	function validateGalleryGlobals () {
		// Ensure synchronizing calls to gallery functions from viewport have access to gallery
		// internal global variables.  First clear any interval used to call this function after initialization.
		if (getInitialized()) {
			if (validateGalleryGlobalsInterval) {
				window.clearInterval(validateGalleryGlobalsInterval);
				validateGalleryGlobalsInterval = null;
			}
			if (!gD || !gdS || !gB || !gbS || !gR || !grS) {
				gD = galleryDisplay;
				gdS = gD.style;
				gB = galleryDisplay.firstChild; // Background.
				gbS = gB.style
				gR = galleryDisplay.childNodes[2]; // Gallery rectangle
				grS = gR.style;
			}
		}
	}

	this.setSizeAndPosition = function (width, height, left, top) {
		setSizeAndPosition(width, height, left, top);
	}

	function setSizeAndPosition (width, height, left, top) {
		var toolbarH = (Z.ToolbarDisplay && Z.Toolbar.getInitialized() && Z.toolbarPosition == Z.galleryPosition) ? Z.toolbarH + 2 : 0;
		if (typeof width === 'undefined' || width === null) {
			width = (Z.galleryW != -1) ? Z.galleryW : Z.viewerW;
		}
		if (typeof height === 'undefined' || height === null) {
			height = Z.galleryH;
		}
		if (typeof left === 'undefined' || left === null) { left = 0; }
		if (typeof top === 'undefined' || top === null) {
			top = (Z.galleryT != -1) ? Z.galleryT: (Z.galleryPosition == 0) ? toolbarH : Z.viewerH - toolbarH - Z.galleryH;
		}

		if (!gD) { gD = galleryDisplay; }
		if (!gdS) { gdS = gD.style; }
		if (gD && gdS) {
			// Size gallery and position
			gdS.width = width + 'px';
			gdS.height = height + 'px';
			gdS.left = (left - 1) + 'px'; // Dev Note: -1 is workaround.
			gdS.top = top + 'px';

			drawLayout(width, height);
		}
	}

	function drawLayout (width, height) {
		if (!gbS) { gbS = galleryDisplay.firstChild.style; } // Background.
		if (gbS) {
			gbS.width = (width * 2) + 'px';
			gbS.height = height + 'px';
			gbS.left = 0 + 'px';
		}
	}

	function visibility (visible) {
		if (!gdS && galleryDisplay) { gdS = galleryDisplay.style; }
		if (gdS) {
			if (visible) {
				gdS.display = 'inline-block';
			} else {
				gdS.display = 'none';
			}
		}
	}

	function syncGalleryToViewport (galleryID) {
		if (Z.GalleryScrollPanel) {
			currentGalleryID = galleryID;
			var imgContainer = Z.GalleryScrollPanel.childNodes[galleryID];
			var imgContS = imgContainer.style;

			// Get positioning values.
			var gW = parseFloat(gdS.width);
			var gspL = parseFloat(gspS.left);
			var imgL = parseFloat(imgContS.left);
			var imgT = parseFloat(imgContS.top);
			var imgW = parseFloat(imgContS.width);
			var imgH = parseFloat(imgContS.height);
			var imgR = imgL + imgW;

			// Scroll selected gallery image into view if out of view.
			var newL = imgL;
			if (imgL + gspL < 0) { newL = -imgL + 1; }
			if (imgR + gspL > gW) {
				console.log(gW, gspL, imgL, imgW);
				newL = -(imgL + imgW + 1 - gW);
			}
			if (newL != imgL) {
				var constrainedL = constrainPanGallery(newL);
				gspS.left = constrainedL + 'px';
				gspL = constrainedL;
				imgL = parseFloat(imgContS.left);
			}

			// Sync rectangle on selected gallery image.
			grS.width = (imgW - 2) + 'px';
			grS.height = (imgH - 3) + 'px';
			grS.left = (imgL - 1 + gspL) + 'px';
			grS.top = imgT + 'px';
		}
	}

	function syncViewportToGallery (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			if (target) {
				var targetId = target.parentNode.id;
				var index = targetId.indexOf('imgContainer');
				if (index != -1) {
					var id = targetId.substring(index + 12, targetId.length);
					if (Z.slideshow) {
						if (Z.slideshowPlaying) { Z.viewportCurrent.slideshowStop(); }
						Z.viewportCurrent.goToSlide(id, null, null, true);
					} else if (Z.imageSet) {
						Z.Viewer.viewportSelect(parseInt(id, 10));
					}
				}
			}
		}
	}

	function galleryImageLoadingFailed () {
		Z.Utils.showMessage(Z.Utils.getResource('ERROR_GALLERYIMAGEPATHINVALID'));
	}



	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::: EVENT FUNCTIONS ::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function galleryMouseOverHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var mouseInGallery = (event.relatedTarget && event.relatedTarget.id == 'galleryDisplay'
				|| event.relatedTarget && event.relatedTarget.parentNode && event.relatedTarget.parentNode.id == 'galleryDisplay'
				|| event.relatedTarget && event.relatedTarget.parentNode.parentNode && event.relatedTarget.parentNode.parentNode.id == 'galleryDisplay'
				|| event.relatedTarget && event.relatedTarget.parentNode.parentNode.parentNode && event.relatedTarget.parentNode.parentNode.parentNode.id == 'galleryDisplay');
			if (mouseInGallery) {
				Z.mouseOutDownPointGallery = null;
			}
		}
	}

	function galleryMouseDownHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			galViewport.zoomAndPanAllStop(false, true);
			if (Z.maskingSelection && Z.maskClearOnUserAction) { galViewport.clearMask(); }
			Z.mouseIsDownGallery = true;
			dragPtStart = Z.Utils.getMousePosition(event);
			smoothPanGalleryMouseX = dragPtStart.x;
			Z.Utils.removeEventListener(gD, 'mousedown', galleryMouseDownHandler);
			Z.Utils.addEventListener(document, 'mousemove', galleryMouseMoveHandler);
			Z.Utils.addEventListener(document, 'mouseup', galleryMouseUpHandler);
			smoothPanGalleryStart();
		}
	}

	function galleryMouseMoveHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			smoothPanGalleryMouseX = Z.Utils.getMousePosition(event).x;
		}
	}

	function galleryMouseUpHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			Z.mouseIsDownGallery = false;
			Z.Utils.removeEventListener(document, 'mousemove', galleryMouseMoveHandler);
			Z.Utils.removeEventListener(document, 'mouseup', galleryMouseUpHandler);
			Z.Utils.addEventListener(gD, 'mousedown', galleryMouseDownHandler);
		}
	}

	function galleryMouseOutHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var mouseInGallery = (event.relatedTarget && event.relatedTarget.id == 'galleryDisplay'
				|| event.relatedTarget && event.relatedTarget.parentNode && event.relatedTarget.parentNode.id == 'galleryDisplay'
				|| event.relatedTarget && event.relatedTarget.parentNode.parentNode && event.relatedTarget.parentNode.parentNode.id == 'galleryDisplay'
				|| event.relatedTarget && event.relatedTarget.parentNode.parentNode.parentNode && event.relatedTarget.parentNode.parentNode.parentNode.id == 'galleryDisplay');
			if (!mouseInGallery) {
				var mPt = Z.Utils.getMousePosition(event);
				Z.mouseOutDownPointGallery = mPt;
			}
		}
	}

	function galleryImageMouseUpHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			var mPt = Z.Utils.getMousePosition(event);
			var dragPtEnd;
			if (!Z.mouseOutDownPointGallery) {
				dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
			} else {
				dragPtEnd = Z.mouseOutDownPointGallery;
			}
			var dragDist = dragPtEnd.x - dragPtStart.x;
			if (Math.abs(dragDist) < MOUSECLICK_THRESHOLD_VIEWPORT) {
				syncViewportToGallery(event);
			}
		}
	}

	function galleryTouchStartHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent copy selection.
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				galViewport.zoomAndPanAllStop(false, true);
				if (Z.maskingSelection && Z.maskClearOnUserAction) { galViewport.clearMask(); }
				Z.mouseIsDownGallery = true;
				var target = touch.target;
				var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				dragPtStart = new Z.Utils.Point(mPt.x, mPt.y);
				smoothPanGalleryMouseX = dragPtStart.x;
				smoothPanGalleryStart();
			}
		}
	}

	function galleryTouchMoveHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent copy selection, delay, and simulated mouse events.
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				smoothPanGalleryMouseX = touch.pageX;
			}
		}
		return false;
	}

	function galleryTouchEndHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent delay and simulated mouse events.
			Z.mouseIsDownGallery = false;
		}
	}

	function galleryTouchCancelHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent delay and simulated mouse events.
			Z.mouseIsDownGallery = false;
		}
	}

	function galleryImageTouchEndHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent copy selection.
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				var dragPtEnd;
				if (!Z.mouseOutDownPointGallery) {
					dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
				} else {
					dragPtEnd = Z.mouseOutDownPointGallery;
				}
				var dragDist = dragPtEnd.x - dragPtStart.x;
				if (Math.abs(dragDist) < MOUSECLICK_THRESHOLD_VIEWPORT) {
					syncViewportToGallery(event);
				}
			}
		}
	}

	function galleryImageTouchCancelHandler (event) {
		var event = Z.Utils.event(event);
		if (event) {
			event.preventDefault(); // Prevent copy selection.
			var touch = Z.Utils.getFirstTouch(event);
			if (touch) {
				var mPt = new Z.Utils.Point(touch.pageX, touch.pageY);
				var dragPtEnd;
				if (!Z.mouseOutDownPointGallery) {
					dragPtEnd = new Z.Utils.Point(mPt.x, mPt.y);
				} else {
					dragPtEnd = Z.mouseOutDownPointGallery;
				}
				var dragDist = dragPtEnd.x - dragPtStart.x;
				if (Math.abs(dragDist) < MOUSECLICK_THRESHOLD_VIEWPORT) {
					syncViewportToGallery(event);
				}
			}
		}
	}

	// The gallery smooth pan functions are based on the display smooth pan functions but track horizontal panning only.
	function smoothPanGalleryStart () {
	 	if (Z.smoothPanEasing > 1) {
	 		// Stop smooth pan interval already in progress, if any.
			smoothPanGalleryStop();

			// Get starting cursor and display positions.
			smoothPanGalleryStartX = dragPtStart.x;
			if (smoothPanGalleryDisplayStartX === null) { smoothPanGalleryDisplayStartX = parseFloat(gspS.left); }

			// Start smooth pan interval.
			if (smoothPanGalleryInterval === null) { smoothPanGalleryInterval = window.setInterval(smoothPanGalleryIntervalHandler, 50); }
		}
	}

	function smoothPanGalleryStop () {
		if (smoothPanGalleryInterval !== null) {
			window.clearInterval(smoothPanGalleryInterval);
			smoothPanGalleryInterval = null;
			smoothPanGalleryStartX = null;
			smoothPanGalleryDisplayStartX = null;
			smoothPanGalleryMouseX = null;
			smoothPanGalleryDeltaX = 0;
			smoothPanGalleryLastDeltaX = 0;
			smoothPanGalleryGliding = null;
			smoothPanGalleryGlideX = null;
		}
	}

	function smoothPanGalleryIntervalHandler () {
		smoothPanGalleryStep();
	}

	function smoothPanGalleryStep () {
		// Get current scrollpane position.
		var scrollPaneCurrL = parseFloat(gspS.left);

		if (Z.mouseIsDownGallery || smoothPanGalleryGliding) {

			// Calculate offsets of mouse and scrollpane. Use float endpoint for target if set because mouse is up.
			var targetX = (smoothPanGalleryGliding) ? smoothPanGalleryGlideX : smoothPanGalleryMouseX;
			var deltaGalleryMouseX = targetX - smoothPanGalleryStartX;

			// Calculate offsets of scrollpane.
			var deltaGalleryDisplayX = scrollPaneCurrL - smoothPanGalleryDisplayStartX;

			// Pan the display if mouse offsets do not equal display offsets.
			var smoothPanGalleryRequired = ((!isNaN(deltaGalleryMouseX) && !isNaN(deltaGalleryDisplayX)) && (deltaGalleryMouseX != 0 || deltaGalleryDisplayX != 0));
			if (smoothPanGalleryRequired) {

				// Calculate new position of displays container.
				var easingMore = (smoothPanGalleryGliding) ? Z.smoothPanGlide : 1;
				var easingEndLess = (smoothPanGalleryGliding) ? 1 : 100;
				smoothPanGalleryDeltaX = Math.round((((deltaGalleryMouseX - deltaGalleryDisplayX) / (Z.smoothPanEasing * easingMore)) * easingEndLess) / easingEndLess);

				// If dragging track deltas, if gliding use last tracked deltas to constrain glide deltas.
				if (Z.mouseIsDownGallery) {
					smoothPanGalleryLastDeltaX = smoothPanGalleryDeltaX;
				} else {
					if (Math.abs(smoothPanGalleryDeltaX) > Math.abs(smoothPanGalleryLastDeltaX)) { smoothPanDeltaX = smoothPanGalleryLastDeltaX; }
				}

				// Constrain and implement new position and if effect constrained, also apply constraint to delta values.
				var newL = scrollPaneCurrL + smoothPanGalleryDeltaX;
				var constrainedL = constrainPanGallery(newL);
				gspS.left = constrainedL + 'px';
				smoothPanGalleryDeltaX -= (newL - constrainedL);

				// Sync gallery rectangle.
				var imgContainer = Z.GalleryScrollPanel.childNodes[currentGalleryID];
				var imgContS = imgContainer.style;
				grS.left = (parseFloat(gspS.left) + parseFloat(imgContS.left) - 1) + 'px';

				// Set gliding variable false if delta variable reaches zero to finish glide and updateView. Complemented by test in viewportEventsManager in mouseup event.
				if (smoothPanGalleryGliding && Math.round(smoothPanGalleryDeltaX * easingEndLess) / easingEndLess == 0) {
					smoothPanGalleryGliding = false;
				}
			}

		} else if (!Z.mouseIsDownGallery && smoothPanGalleryGliding === null && smoothPanGalleryDeltaX != 0) {
			// Calculate and record extended pan endpoint to enable drag-glide.
			var testL = scrollPaneCurrL + smoothPanGalleryLastDeltaX;
			var constrainedL = constrainPanGallery(testL);
			smoothPanGalleryLastDeltaX = constrainedL- scrollPaneCurrL;
			if (smoothPanGalleryLastDeltaX != 0) {
				smoothPanGalleryGlideX = smoothPanGalleryMouseX + smoothPanGalleryLastDeltaX;
				smoothPanGalleryGliding = true;
			}

		} else {
			// Stop smooth pan by clearing interval.
			smoothPanGalleryStop();
		}
	}

	// Apply strict contraint if mouse up, otherwise loose.
	function constrainPanGallery (scrollPanelL) {
		var imgContainer = Z.GalleryScrollPanel.childNodes[currentGalleryID];
		var imgContS = imgContainer.style;
		var imgW = parseFloat(imgContS.width);
		var imageOffset = imgW / 2;
		var gW = parseFloat(gdS.width);
		var gppW = parseFloat(gspS.width);
		if (gppW < gW) {
			if (scrollPanelL < 0) {
				scrollPanelL = 0;
			} else if (scrollPanelL >= gW - gppW) {
				scrollPanelL = gW - gppW;
			} else if (!Z.mouseIsDownGallery && !smoothPanGalleryGliding) {
				scrollPanelL = (gW - gppW) / 2;
			}
		} else {
			if (scrollPanelL > 0) {
				scrollPanelL = 0;
			} else if (scrollPanelL <= gW - gppW) {
				scrollPanelL = gW - gppW;
			}
		}
		return scrollPanelL;
	}
};



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::: RULER FUNCTIONS ::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.ZoomifyRuler = function (rulerViewport) {

	// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	// ::::::::::::::::::::::::::::::::: INIT FUNCTIONS :::::::::::::::::::::::::::::::::::::
	// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Declare variables for ruler internal self-reference and initialization completion.
	var self = this;
	var isInitialized = false;

	// Declare and set variables local to ruler for size and position.
	var rD, rdS, rB, rbS, rSB, rsbS, eTB, etbS, sTB, stbS, uTB, utbS, mL, mlS;
	var noParamsText= Z.Utils.getResource('UI_RULERNOPARAMS');
	var minText = ''; //Alternative implementation: Z.Utils.getResource('UI_RULERMIN');
	var maxText = ''; //Alternative implementation: Z.Utils.getResource('UI_RULERMAX');
	var sourceMagnification = Z.sourceMagnification;
	var magnificationList, magnificationListDP = [];
	var units = Z.units;
	var unitsPerImage = Z.unitsPerImage;
	var pixelsPerUnit = Z.pixelsPerUnit;
	var actualPixelsPerUnit = 1;
	var unitsArray = [];
	var unitsIndex = -1;
	var scaleBarW = 1;

	initializeRuler();

	function initializeRuler () {

		// Create ruler display to contain background, scalebar and magnification list.
		Z.RulerDisplay = Z.Utils.createContainerElement('div', 'RulerDisplay', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal');
		rD = Z.RulerDisplay;
		rdS = rD.style;

		// Create background and set transparency.
		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
		var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');
		var rulerBackground = Z.Utils.createContainerElement('div', 'rulerBackground', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', backColor, '0px', '0px', 'normal', null, true);
		Z.Utils.setOpacity(rulerBackground, backAlpha, backColorNoAlpha);
		Z.RulerDisplay.appendChild(rulerBackground);
		rB = rulerBackground;
		rbS = rB.style;

		// Create scale bar.
		var scaleBarColor = Z.Utils.getResource('DEFAULT_SCALEBARCOLOR');
		var rulerScaleBar = Z.Utils.createContainerElement('div', 'rulerScaleBar', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', scaleBarColor, '0px', '0px', 'normal', null, true);
		Z.RulerDisplay.appendChild(rulerScaleBar);
		rSB = rulerScaleBar;
		rsbS = rSB.style;

		// Ensure proper z-ordering of Viewer elements.
		rsbS.zIndex = (Z.baseZIndex + 6).toString();

		var rulerScaleBarNotchL = Z.Utils.createContainerElement('div', 'rulerScaleBarNotchL', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', scaleBarColor, '0px', '0px', 'normal', null, true);
		Z.RulerDisplay.appendChild(rulerScaleBarNotchL);
		rSBNL = rulerScaleBarNotchL;
		rsbnlS = rSBNL.style;
		var rulerScaleBarNotchR = Z.Utils.createContainerElement('div', 'rulerScaleBarNotchR', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', scaleBarColor, '0px', '0px', 'normal', null, true);
		Z.RulerDisplay.appendChild(rulerScaleBarNotchR);
		rSBNR = rulerScaleBarNotchR;
		rsbnrS = rSBNR.style;

		// Create scale bar text elements.
		var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_RULERTEXTFONTSIZE'), 10);
		var errorTextBox = Z.Utils.createContainerElement('div', 'errorTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
		var errorTextNode = document.createTextNode('');
		errorTextBox.appendChild(errorTextNode);
		Z.Utils.setTextNodeStyle(errorTextNode, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none');
		Z.RulerDisplay.appendChild(errorTextBox);
		eTB = errorTextBox;
		etbS = eTB.style;
		var scaleTextBox = Z.Utils.createContainerElement('div', 'scaleTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
		var scaleTextNode = document.createTextNode('');
		scaleTextBox.appendChild(scaleTextNode);
		Z.Utils.setTextNodeStyle(scaleTextNode, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'right', 'none');
		Z.RulerDisplay.appendChild(scaleTextBox);
		sTB = scaleTextBox;
		stbS = sTB.style;
		var unitTextBox = Z.Utils.createContainerElement('div', 'unitTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
		var unitTextNode = document.createTextNode('');
		unitTextBox.appendChild(unitTextNode);
		Z.Utils.setTextNodeStyle(unitTextNode, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
		Z.RulerDisplay.appendChild(unitTextBox);
		uTB = unitTextBox;
		utbS = uTB.style;

		// Create magnitude choicelist object from resourced data.
		if (Z.rulerListType != 0) {
			populateMagnificationsArray();
			magnificationList = new Z.Utils.createSelectElement('magnificationList', '', magnificationListDP, 1, 1, 1, null, true, magnificationListChangeHandler, 'change');
			Z.RulerDisplay.appendChild(magnificationList);
			mL = magnificationList;
			mlS = mL.style;
			validateMagnificationList();
		}

		// Create ruler data elements and configure.
		populateUnitsArray();
		drawLayout();

		// Add ruler to viewer display and set size, position, visibility, and zIndex.
		Z.ViewerDisplay.appendChild(Z.RulerDisplay);
		visibility(Z.rulerVisible);

		// Enable mouse, initialize ruler, sync to viewport.
		// Prevent object dragging and bubbling.
		// DEV NOTE: Do note use next line to block panel selection because blocks choicelist use.
		//Z.Utils.addEventListener(rD, 'mousedown', Z.Utils.preventDefault);
		Z.Utils.addEventListener(rD, 'mouseover', Z.Utils.stopPropagation)

		setInitialized(true);
		syncToViewport();
	}

	function populateUnitsArray () {
		unitsArray = [
			{ magnitude:Math.pow(10,24), symbol:'Ym' },
			{ magnitude:Math.pow(10,21), symbol:'Zm' },
			{ magnitude:Math.pow(10,18), symbol:'Em' },
			{ magnitude:Math.pow(10,15), symbol:'Pm' },
			{ magnitude:Math.pow(10,12), symbol:'Tm' },
			{ magnitude:Math.pow(10,9), symbol:'Gm' },
			{ magnitude:Math.pow(10,6), symbol:'Mm' },
			{ magnitude:Math.pow(10,3), symbol:'km' },
			{ magnitude:Math.pow(10,2), symbol:'hm' },
			{ magnitude:Math.pow(10,1), symbol:'dam' },
			{ magnitude:Math.pow(10,0), symbol:'m' },
			{ magnitude:Math.pow(10,-1), symbol:'dm' },
			{ magnitude:Math.pow(10,-2), symbol:'cm' },
			{ magnitude:Math.pow(10,-3), symbol:'mm' },
			{ magnitude:Math.pow(10,-6), symbol:'um' },
			{ magnitude:Math.pow(10,-9), symbol:'nm' },
			{ magnitude:Math.pow(10,-12), symbol:'pm' },
			{ magnitude:Math.pow(10,-15), symbol:'fm' },
			{ magnitude:Math.pow(10,-18), symbol:'am' },
			{ magnitude:Math.pow(10,-21), symbol:'zm' },
			{ magnitude:Math.pow(10,-24), symbol:'ym' },
			{ magnitude:Math.pow(10,-24), symbol:'pixels' }
		];
	}

	function populateMagnificationsArray () {
		if (Z.rulerListType == 1 && sourceMagnification != 0) {
			if (!Z.tracking) {
				magnificationListDP = [
					{ text:'1.25x', value:1.25 },
					{ text:'2.5x', value:2.5 },
					{ text:'5x', value:5 },
					{ text:'10x', value:10 },
					{ text:'20x', value:20 },
					{ text:'40x', value:40 },
					{ text:'60x', value:60 },
					{ text:'100x', value:100 }
				];
			} else {
				magnificationListDP = [
					{ text:'1.25x', value:1.25 },
					{ text:'1.5x', value:1.5 },
					{ text:'2x', value:2 },
					{ text:'2.5x', value:2.5 },
					{ text:'4x', value:4 },
					{ text:'5x', value:5 },
					{ text:'10x', value:10 },
					{ text:'16x', value:16 },
					{ text:'20x', value:20 },
					{ text:'25x', value:25 },
					{ text:'32x', value:32 },
					{ text:'40x', value:40 },
					{ text:'50x', value:50 },
					{ text:'60x', value:60 },
					{ text:'100x', value:100 },
					{ text:'150x', value:150 },
					{ text:'250x', value:250 }
				];
			}
		} else {
			magnificationListDP = [
				{ text:'10%', value:10 },
				{ text:'20%', value:20 },
				{ text:'30%', value:30 },
				{ text:'40%', value:40 },
				{ text:'50%', value:50 },
				{ text:'60%', value:60 },
				{ text:'70%', value:70 },
				{ text:'80%', value:80 },
				{ text:'90%', value:90 },
				{ text:'100%', value:100 }
			];
		}
	}

	function validateMagnificationList () {
		var minZoom = Z.minZ * 100;
		var maxZoom = Z.maxZ * 100;
		var minZoomRounded = Math.round(minZoom);
		var maxZoomRounded = Math.round(maxZoom);
		var magSymbol = '%';
		var approxSymbol;

		// Remove beginning data array items less than min zoom.
		if (minZoom == -1) { minZoom = Math.round(rulerViewport.calcZoomDecimalToFitDisplay() * 100); }
		if (Z.rulerListType == 1 && sourceMagnification != 0) {
			minZoom = Z.Utils.convertZoomPercentToMagnification(minZoom, sourceMagnification);
			minZoomRounded = Math.round(minZoom);
			magSymbol = 'x';
		}

		while(magnificationListDP[0].value <= minZoomRounded) {
			magnificationListDP = Z.Utils.arraySplice(magnificationListDP, 0, 1);
		}

		// Remove ending data array items greater than max zoom.
		if (maxZoom == -1) { maxZoom = Math.round(rulerViewport.calcZoomDecimalToFitDisplay() * 100); }
		if (Z.rulerListType == 1 && sourceMagnification != 0) {
			maxZoom = Z.Utils.convertZoomPercentToMagnification(maxZoom, sourceMagnification);
			maxZoomRounded = Math.round(maxZoom);
			magSymbol = 'x';
		}
		while(magnificationListDP[magnificationListDP.length - 1].value >= maxZoomRounded) {
			magnificationListDP = Z.Utils.arraySplice(magnificationListDP, magnificationListDP.length - 1, 1);
		}

		// Add beginning data array item with min zoom value, rounded if necessary.
		approxSymbol = (minZoomRounded == minZoom) ? '' : '~';
		magnificationListDP = Z.Utils.arraySplice(magnificationListDP, 0, 0, { text:minZoomRounded.toString() + magSymbol + approxSymbol + minText, value:minZoomRounded } );

		// Add ending data array item with max zoom value, rounded if necessary.
		approxSymbol = (maxZoomRounded == maxZoom) ? '' : '~';
		magnificationListDP[magnificationListDP.length] = { text:maxZoomRounded.toString() + magSymbol + approxSymbol + maxText, value:maxZoom };

		// Update choicelist with updated data.
		Z.Utils.updateSelectElement(mL, magnificationListDP);
		mL.selectedIndex = 0;
	}

	function drawLayout () {
		var width = Z.rulerW;
		var height = Z.rulerH;
		var left = (Z.rulerL == -1 && Z.Navigator) ? Z.navigatorL : Z.rulerL;
		var top = (Z.rulerT == -1 && Z.Navigator) ? (Z.navigatorT + Z.navigatorH + 1) : Z.rulerT;
		var listW = 60;
		var listH = 20;
		var scaleBarVisible = (Z.rulerListType != 0);
		scaleBarW = (scaleBarVisible) ? (width - listW - 16) : (width - 10);
		var scaleBarH = 1;
		var scaleBarNotchH = 6;
		var scaleBarL = 5;
		var scaleBarT = (height - scaleBarH + 5) / 2;
		var textW = scaleBarW / 2 - 5;
		var textH = 15;
		var textL = scaleBarL + 10;
		var textT = scaleBarT - 10;
		var pixUnitMod = (Z.units == 'pixels') ? 7 : 0;

		if (rbS && rsbS && rsbnlS && rsbnrS && eTB && etbS && sTB && stbS && uTB && utbS) {
			setSizeAndPosition(width, height, left, top);

			rbS.width = width + 'px';
			rbS.height = height + 'px';
			rbS.left = '0px';
			rbS.top = '0px';
			if (mlS) {
				mlS.width = listW + 'px';
				mlS.left = (width - listW -  3) + 'px';
				mlS.top = ((height  - listH) / 2) + 'px';
				mlS.visibility = 'visible';
			}

			rsbS.width = scaleBarW + 'px';
			rsbS.height = scaleBarH + 'px';
			rsbS.left = scaleBarL + 'px'
			rsbS.top = scaleBarT + 3 + 'px';
			rsbnlS.width = 1 + 'px';
			rsbnlS.height = scaleBarNotchH + 'px';
			rsbnlS.left = scaleBarL + 'px'
			rsbnlS.top = scaleBarT + 'px';
			rsbnrS.width = 1 + 'px';
			rsbnrS.height = scaleBarNotchH + 'px';
			rsbnrS.left = scaleBarL + scaleBarW + 'px'
			rsbnrS.top = scaleBarT + 'px';

			etbS.width = scaleBarW + 'px';
			etbS.height = textH + 'px';
			etbS.left = textL - 3 + 'px';
			etbS.top = textT + 'px';
			stbS.width = textW + 'px';
			stbS.height = textH + 'px';
			stbS.left = textL - pixUnitMod + 'px';
			stbS.top = textT + 'px';
			utbS.width = textW + 'px';
			utbS.height = textH + 'px';
			utbS.left = scaleBarW / 2 + 15 - pixUnitMod + 'px';
			utbS.top = textT + 'px';
		}
	}



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: GET & SET FUNCTIONS ::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	this.getInitialized = function () {
		return getInitialized();
	}

	function getInitialized () {
		return isInitialized;
	}

	function setInitialized (initialized) {
		if (!isInitialized && initialized) {
			isInitialized = true;
			Z.Utils.validateCallback('rulerInitialized');
			Z.Viewer.validateViewerReady('rulerInitialized');
		}
	}

	this.setVisibility = function (visible) {
		visibility(visible);
	}

	// DEV NOTE: Dual setSizeAndPosition functions below are workaround for undefined error on load
	// due to unhoisted function expression vs hoisted function declaration and/or IE8 limitations.
	this.setSizeAndPosition = function (panel, width, height, left, top) {
		setSizeAndPosition(panel, width, height, left, top);
	}

	function setSizeAndPosition (width, height, left, top) {
		if (typeof width === 'undefined' || width === null) { var width = Z.rulerW; }
		if (typeof height === 'undefined' || height !== null) { var height = Z.rulerH; }
		if (typeof left === 'undefined' || left !== null) { left = (Z.rulerL == -1 && Z.Navigator) ? Z.navigatorL : Z.rulerL; }
		if (typeof top === 'undefined' || top !== null) { top = (Z.rulerT == -1 && Z.Navigator) ? (Z.navigatorT + Z.navigatorH + 1) : Z.rulerT; }
		rdS.width = width + 'px';
		rdS.height = height + 'px';
		rdS.left = left + 'px';
		rdS.top = top + 'px';
	}

	this.syncToViewport = function (reset) {
		syncToViewport();
	}


	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::: CORE FUNCTIONS :::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function visibility (visible) {
		if (!rdS) { rdS = Z.RulerDisplay.style; }
		if (rdS) {
			if (visible) {
				rdS.display = 'inline-block';
			} else {
				rdS.display = 'none';
			}
		}
	}

	// Set ruler scale bar and magnification list.
	function syncToViewport (reset) {
		if (rulerViewport && rulerViewport.getStatus('initializedViewport')) {
			setScaleBar();
			setMagnificationList(reset);
		}
	}

	function setScaleBar () {
		var zoom = rulerViewport.getZoom();
		var digits = (Z.units == 'pixels') ? 0 : 4;

		if (mlS) {
			mlS.visibility = 'visible';
			var magnification;
			if (sourceMagnification !=  0) {
				magnification = sourceMagnification * zoom;
			} else {
				magnification = 100 * zoom;
			}
			if (magnification < 1) {
				magnification = Math.round(magnification * 100) / 100;
			} else {
				magnification = Math.round(magnification);
			}
		}

		for (var i = 0, j = unitsArray.length; i < j; i++) {
			if (unitsArray[i].symbol == Z.units) { unitsIndex = i; }
		}

		if (pixelsPerUnit !== null && pixelsPerUnit != 0) {
			actualPixelsPerUnit = pixelsPerUnit;
		} else if (unitsPerImage !== null && unitsPerImage != 0) {
			actualPixelsPerUnit = Z.imageW / unitsPerImage;
		} else {
			actualPixelsPerUnit = 1;
			// DEV NOTE: Alternative implementation - if no units param show error.
			/* eTB.firstChild.nodeValue = noParamsText;
			stbS.visibility = 'hidden';
			utbS.visibility = 'hidden';
			return; */
		}

		var pixelsPerScaleBar = scaleBarW;
		var unitsPerScaleBar = pixelsPerScaleBar / actualPixelsPerUnit;
		var unitsPerScaleBarAtCurrentZoom = unitsPerScaleBar / zoom;
		var unitsPerScaleBarRounded = Z.Utils.roundToFixed(unitsPerScaleBarAtCurrentZoom, digits);
		sTB.firstChild.nodeValue = unitsPerScaleBarRounded.toString();

		utbS.visibility = 'visible';
		if (unitsArray[unitsIndex].symbol != 'um') {
			uTB.firstChild.nodeValue = unitsArray[unitsIndex].symbol;
		} else {
			uTB.firstChild.nodeValue = '\u03BC' + 'm'; // Unicode representation for lowercase mu symbol ('�').
		}
	}

	function setMagnificationList (reset) {
		if (mlS) {
			var newMag, newMagRounded, magSymbol;
			var approxSymbol = (Math.round(rulerViewport.getZoom() * 100) == Math.round(rulerViewport.getZoom() * 1000) / 1000 * 100) ? '' : '~';
			if (Z.rulerListType == 2) {
				newMag = Math.round(rulerViewport.getZoom() * 100);
				newMagRounded = Math.round(newMag);
				magSymbol = '%';
			} else if (Z.rulerListType == 1 && sourceMagnification != 0) {
				newMag = Z.Utils.convertZoomPercentToMagnification(rulerViewport.getZoom(), sourceMagnification) * 100;
				newMagRounded = Math.round(newMag);
				magSymbol = 'x';
			}
			var listTitle = newMagRounded.toString() + magSymbol + approxSymbol;
			var i = insertIndex = 0;
			while(newMagRounded > magnificationListDP[i].value) {
				i++;
			}
			insertIndex = i;
			if (newMagRounded == magnificationListDP[insertIndex].value) {
				Z.Utils.updateSelectElement(mL, magnificationListDP);
			} else {
				var tempArray = Z.Utils.arrayClone('magnifications', magnificationListDP, tempArray);
				tempArray = Z.Utils.arraySplice(tempArray, insertIndex, 0, { text:listTitle, value:newMagRounded.toString() } );
				Z.Utils.updateSelectElement(mL, tempArray);
			}
			mL.selectedIndex = insertIndex;
		}
	}



	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::: EVENT HANDLERS ::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	function magnificationListChangeHandler (event) {
		var selectedMag = 0;
		var event = Z.Utils.event(event);
		if (event) {
			var target = Z.Utils.target(event);
			selectedMag = parseInt(target.options[target.selectedIndex].value, 10);

			if (!isNaN(selectedMag)) {
				var newZoom;
				if (Z.rulerListType == 1) {
					newZoom = 100 * selectedMag / sourceMagnification;
				} else {
					newZoom = selectedMag;
				}
				rulerViewport.zoomAndPanToView(rulerViewport.viewX, rulerViewport.viewY, newZoom / 100);
			}
		}
	}
};



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::: NETCONNECTOR FUNCTIONS ::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.NetConnector = function () {
	var imagesLoading = 0;
	var IMAGES_LOADING_MAX = parseInt(Z.Utils.getResource('DEFAULT_IMAGESLOADINGMAX'), 10);
	var IMAGE_LOAD_TIMEOUT = parseFloat(Z.Utils.getResource('DEFAULT_IMAGELOADTIMEOUT'));
	var loadImageQueueDelay = Z.Utils.getResource('DEFAULT_IMAGELOADQUEUEDELAY');
	var loadImageQueueInterval;
	var loadImageQueue = [];

	this.loadHTML = function (htmlPath, recResp) {
		makeNetRequest(htmlPath, recResp, null);
	}

	this.loadXML = function (xmlPath, vpID) {
		if (typeof vpID === 'undefined' || vpID === null) {
			makeNetRequest(xmlPath, receiveResponse, null);
		} else {
			makeNetRequest(xmlPath, function(xhr) { receiveResponse(xhr, vpID); }, null);
		}
	}

	this.loadJSON = function (jsonPath) {
		makeNetRequest(jsonPath, receiveResponse, null);
	}

	this.loadByteRange = function (filePath, rangeStart, rangeEnd, contentType, tile, chunkID) {
		var rangeData = new Z.Utils.Range(rangeStart, rangeEnd);
		makeNetRequest(filePath, receiveResponse, rangeData, contentType, tile, chunkID);
	}

	function loadImageByteRange (filePath, contentType, tile) {
		var imagePath = filePath.substring(0, filePath.indexOf('?'));
		var rangeStart = parseFloat(filePath.substring(filePath.indexOf('?') + 1, filePath.indexOf(',')));
		var rangeLength = parseFloat(filePath.substring(filePath.indexOf(',') + 1, filePath.length));
		var rangeEnd = rangeStart + rangeLength;
		var rangeData = new Z.Utils.Range(rangeStart, rangeEnd);
		makeNetRequest(imagePath, receiveResponse, rangeData, contentType, tile);
	}

	this.postXML = function (saveHandlerPath, xmlData, postType) {
		makeNetRequest(saveHandlerPath, receiveResponse, xmlData, 'postXML', null, null, postType);
	}

	this.postImage = function (saveImageHandlerPath, imageData) {
		makeNetRequest(saveImageHandlerPath, receiveResponse, imageData, 'postImage');
	}

	function makeNetRequest (url, callback, data, contentType, tile, chunkN, postType) {
		var netRequest = createXMLHttpRequest();
		if (netRequest === null) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_XMLHTTPREQUESTUNSUPPORTED'));

		} else {
			var isAsync = (typeof callback === 'function');
			if (isAsync) {
				var actual = callback;
				var callback = function () { window.setTimeout(Z.Utils.createCallback(null, actual, netRequest), 1); };
				netRequest.onreadystatechange = function () {
					if (netRequest.readyState == 4) {
						netRequest.onreadystatechange = new Function ();
						callback();
					}
				};
			}

			try {
				if (typeof data === 'undefined' || data === null) {
					// Load XML here. Also support loading of HTML for custom Help page.
					netRequest.open('GET', url, isAsync);
					if (contentType == 'loadHTML') { netRequest.setRequestHeader('Content-Type', 'text/html'); }
					netRequest.send(null);

				} else if (typeof contentType !== 'undefined' && contentType !== null) {
					// Prevent local posting attempts.
					if (Z.localUse && (contentType == 'postXML' || contentType == 'postImage')) {
						Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALSAVING'), false, Z.messageDurationStandard, 'center', true);
						return;
					}

					if (contentType == 'postXML') {
						var postErrorString = null;
						if (postType == 'annotation' && (typeof Z.annotationPath === 'undefined' || !Z.Utils.stringValidate(Z.annotationPath))) {
							postErrorString = Z.Utils.getResource('ERROR_ANNOTATIONPATHMISSING');
						} else if (postType == 'tracking' && (typeof Z.trackingPath === 'undefined' || !Z.Utils.stringValidate(Z.trackingPath))) {
							postErrorString = Z.Utils.getResource('ERROR_TRACKINGPATHMISSING');
						}
						if (postErrorString !== null) {
							Z.Utils.showMessage(postErrorString, false, Z.messageDurationStandard, 'center');

						} else {
							// Debug option: console.log('url: ' + url + '  data: ' + Z.Utils.xmlConvertDocToText(data));
							var postPath, postPathLen, postPathLower, postFile, postFileDef;
							if (postType == 'annotation') {
								postPath = Z.annotationPath;
								postPathLower = postPath.toLowerCase();
								postFileDef = Z.Utils.getResource('DEFAULT_ANNOTATIONSXMLFILE');
							} else if (postType == 'tracking') {
								postPath = Z.trackingPath;
								postPathLower = postPath.toLowerCase();
								postFileDef = Z.Utils.getResource('DEFAULT_TRACKINGXMLFILE');
							}
							postPathLen = postPathLower.length;

							if ((postPathLower.substring(postPathLen - 5, postPathLen) != '.json') && (postPathLower.substring(postPathLen - 4, postPathLen) != '.xml')) {
								postFile = '/' + postFileDef;
							}
							var postPathFull = postPath + postFile;

							Z.postingXML = true;
							netRequest.open('POST', url + '?file=' + postPathFull, true);

							// Alternative implementation - also enabled: Requires upload file that receives variable rather than parsing query string from upload script file path.
							Z.Utils.defineObjectProperty(netRequest, 'file', { value : postPathFull, writable : false, enumerable : false, configurable : false });

							netRequest.setRequestHeader('Content-Type', 'application/xml');
							netRequest.send(data);
						}

					} else if (contentType == 'postImage') {
						// Debug option: console.log('url: ' + url + ' data.length: ' + data.length + ' fileName: ' + Z.saveImageFilename + ' fileFormat: ' + Z.saveImageFormat + '  fileCompression: ' + Z.saveImageCompression);
						// DEV NOTE: Form submission required or progress event. Also, 'multipart/form-data' stated as required for form upload but appears not so, and prevents use of simpler file_get_contents("php://input"); approach on server-side in php.
						Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVEUPLOADING'), false, 'none', 'center');

						Z.postingImage = true;
						var fd = new FormData();
						fd.append('fileToUpload', data);
						Z.Utils.addEventListener(netRequest.upload, 'progress', Z.Utils.uploadProgress);
						netRequest.open('POST', url, true);
						Z.Utils.defineObjectProperty(netRequest, 'zType', { value : 'postingImage', writable : false, enumerable : false, configurable : false });
						netRequest.setRequestHeader('Content-Type', 'application/upload');
						netRequest.send(fd);

					} else if (Z.tileSource == 'ZoomifyImageFile') {

						// Cache proofing applied here on all byterange requests for header and chunks but not tiles. This approach
						// supports consistency and avoids duplicate applications. These are non-XML, non-posting, non-PFF requests.
						// Note that byte range start and end values are in imagePath until function loadImageByteRange parses them
						// and passes them to this function as data parameter, leaving url parameter clean for cache proofing.
						if (contentType != 'tile') { url = Z.Utils.cacheProofPath(url); }
						netRequest.open('GET', url, true);
						netRequest.responseType = 'arraybuffer';

						// Include contentType, tile, and chunk number values to be returned in response.
						Z.Utils.defineObjectProperty(netRequest, 'zType', { value : contentType, writable : false, enumerable : false, configurable : false });
						Z.Utils.defineObjectProperty(netRequest, 'zTile', { value : tile, writable : false, enumerable : false, configurable : false });
						Z.Utils.defineObjectProperty(netRequest, 'zChunkNumber', { value : chunkN, writable : false, enumerable : false, configurable : false });

						// Prevent Safari byte range request response caching.
						if (Z.browser == Z.browsers.SAFARI) {
							netRequest.setRequestHeader('If-Modified-Since', 'Thu, 01 Dec 1994 16:00:00 GMT');
						}

						// Set range header and send request.
						netRequest.setRequestHeader('Range', 'bytes=' + data.start.toString() + '-' + data.end.toString());
						netRequest.send(null);
					}
				}

			} catch (e) {
				netRequestErrorHandler(e, url, contentType);
				netRequest = null;
				console.log(e);

				// if (isAsync) { callback(); } // Debug option.
			}
		}
	}

	function createXMLHttpRequest () {
		var netReq = null;
		switch (Z.xmlHttpRequestSupport) {
			case 'XMLHttpRequest' :
				netReq = new XMLHttpRequest();
				break;
			case 'Msxml2.XMLHTTP.6.0' :
				netReq = new ActiveXObject('Msxml2.XMLHTTP.6.0');
				break;
			case 'Msxml2.XMLHTTP.3.0' :
				netReq = new ActiveXObject('Msxml2.XMLHTTP.3.0');
				break;
			case 'Microsoft.XMLHTTP' :
				netReq = new ActiveXObject('Microsoft.XMLHTTP');
				break;
		}
		return netReq;
	}

	// This error handler is applied within the function makeNetRequest in two ways for two different purposes:
	// first, as an onerror method which handles errors in the response to file requests, and second in the outer
	// try/catch statement, which handles errors in the creation of the netRequest calls themselves. Additional error
	// handling occurs in the function receiveResponse, where 404 and other server responses are handled.
	function netRequestErrorHandler (e, url, contentType) {
		if (Z.localUse == true && (Z.browser == Z.browsers.CHROME  || Z.browser == Z.browsers.OPERA || (Z.browser == Z.browsers.IE && Z.browserVersion == 11) || (Z.browser == Z.browsers.SAFARI && Z.browserVersion >= 7))) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALVIEWING-BROWSER'), false, Z.messageDurationStandard, 'center');
		} else if (Z.localUse == true && Z.tileSource == 'ZoomifyImageFile') {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALVIEWING-FORMAT-ZIF'), false, Z.messageDurationShort, 'center');
		} else if (Z.localUse == true && Z.tileSource == 'ZoomifyPFFFile') {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_UNSUPPORTEDLOCALVIEWING-FORMAT-PFF'), false, Z.messageDurationShort, 'center');
		} else if (url.toLowerCase().indexOf('.zif') != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-ZIFBYTERANGE') + contentType + '.', false, Z.messageDurationShort, 'center');
		} else if (url.indexOf('ImageProperties.xml') != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-IMAGEXML'), true, null, 'left');
		} else if (url.toLowerCase().indexOf('.pff') != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-IMAGEHEADER'), false, Z.messageDurationShort, 'center');
		} else if (url.toLowerCase().indexOf('reply_data') != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-IMAGEOFFSET'), false, Z.messageDurationShort, 'center');
		} else if (url.indexOf(Z.Utils.getResource('DEFAULT_SKINXMLFILE')) != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-TOOLBARSKINSXML'), true, null, 'left');
		} else if (url.indexOf(Z.Utils.getResource('DEFAULT_IMAGELISTXMLFILE')) != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-IMAGELISTXML'), false, Z.messageDurationShort, 'center');
		} else if (url.indexOf(Z.Utils.getResource('DEFAULT_COMPARISONXMLFILE')) != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-COMPARISONXML'), false, Z.messageDurationShort, 'center');
		} else if (url.indexOf(Z.Utils.getResource('DEFAULT_SLIDESXMLFILE')) != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-SLIDESXML'), false, Z.messageDurationShort, 'center');
		} else if (url.indexOf(Z.Utils.getResource('DEFAULT_HOTSPOTSXMLFILE')) != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-HOTSPOTSXML'), false, Z.messageDurationShort, 'center');
		} else if (url.indexOf(Z.Utils.getResource('DEFAULT_ANNOTATIONSXMLFILE')) != -1) {
			// The following attempt to address a missing annotations XML file is a failsafe for attempt in function receiveResponse.
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-CREATINGANNOTATIONSXMLFILE'), false, Z.messageDurationShort, 'center');
			Z.Viewport.createAnnotationsXMLFile();
			// Alternative implementation: Display error intead of creating annotations.xml file.
			//Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-ANNOTATIONSXML'), false, Z.messageDurationShort, 'center');
		} else if (url.indexOf(Z.Utils.getResource('DEFAULT_ANNOTATIONSJSONFILE')) != -1) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-ANNOTATIONSJSON'), false, Z.messageDurationShort, 'center');
		} else if ((url.toLowerCase().indexOf(Z.Utils.getResource('DEFAULT_ANNOTATIONSXMLSAVEHANDLERNAME1')) != -1) || (url.toLowerCase().indexOf(Z.Utils.getResource('DEFAULT_ANNOTATIONSXMLSAVEHANDLERNAME1')) != -1)) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-ANNOTATIONSSAVEHANDLER'), false, Z.messageDurationShort, 'center');
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST'), false, Z.messageDurationShort, 'center');
		}
	}

	// DEV NOTE: The conditionals in the clause below for the xhr.status values of 200/0/206 are timing dependent and therefore not optimal. They are necessary because
	// the onerror function assigned to the XMLHttpRequest in the function makeNetRequest above will fire on a failure at the network level, not the application level. A 404
	// file not found error is a valid network response so the test must occur here in the onreadystatechange handler. However, here, the url for the request is not known.
	// Note that the onerror can fire in Firefox for a local attempt with a 404 response. Note also that debugger consoles will show the requested url with a 404 response due
	// to privledged access. Future implementation may include a wrapper for the XMLHttpRequest request object that records the url.
	function receiveResponse (xhr, vpID) {
		if (!xhr) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_NETWORKSECURITY'), false, Z.messageDurationShort, 'center');
		} else if (xhr.status !== 200 && xhr.status !== 0 && xhr.status !== 206) {
			var status = xhr.status;
			var statusText = (status == 404) ? 'Not Found' : xhr.statusText;
			if (Z.xmlParametersParsing) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-PARAMETERSXML'), true, null, 'left');
			} else if (Z.Toolbar && !Z.Toolbar.getInitialized()) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-TOOLBARSKINSXML'), true, null, 'left');
			} else if (Z.Viewport && Z.annotationPath !== null && Z.Viewport.getStatus('initializedViewport') && !Z.Viewport.getStatus('XMLParsedViewport')) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-CREATINGANNOTATIONSXMLFILE'), false, Z.messageDurationShort, 'center');
				Z.Viewport.createAnnotationsXMLFile();
			} else if (Z.tileSource == 'ZoomifyImageFile') {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_NETWORKSTATUSRANGEREQUESTS') + status + ' - ' + statusText, true, null, 'left');
			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_NETWORKSTATUS') + status + ' - ' + statusText, false, Z.messageDurationShort, 'center');
			}

		} else {
			var doc = null;
			var annotPathHasJSONExtension = (typeof Z.annotationPath !== 'undefined' && Z.Utils.stringValidate(Z.annotationPath) && Z.annotationPath.toLowerCase().substring(Z.annotationPath.length - 5, Z.annotationPath.length) == '.json');
			if (Z.postingImage && xhr.zType && xhr.zType == 'postingImage') {
				Z.postingImage = false;
				Z.Utils.showMessage(Z.Utils.getResource('ALERT_IMAGESAVESUCCESSFUL'), false, Z.messageDurationShort, 'center');
			} else if (xhr.response && xhr.zType && Z.tileSource == 'ZoomifyImageFile') {
				validateBytes(xhr, vpID);
			} else if (xhr.responseXML && xhr.responseXML.documentElement && !annotPathHasJSONExtension) {
				doc = xhr.responseXML;
				validateXML(doc, vpID);
			} else if (xhr.responseText) {
				var respText = xhr.responseText;
				if (respText.indexOf('ZAS') != -1 && annotPathHasJSONExtension) {
					validateJSON(respText, vpID);
				} else if (Z.tileSource == 'IIIFImageServer') {
					validateJSON(respText, vpID, true);
				} else if (Z.postingXML) {
					Z.postingXML = false;
					Z.Utils.showMessage(Z.Utils.getResource('ALERT_ANNOTATIONSAVESUCCESSFUL'), false, Z.messageDurationShort, 'center');
					if (Z.Viewport) { Z.Viewport.setAllHotspotsSaved(); }
				} else if (Z.tileSource == 'ZoomifyImageFolder') {
					// Fallback for annotations XML incorrectly sent as Content Type  as text/html rather than  as text/xml.
					doc = Z.Utils.xmlConvertTextToDoc(respText);
					validateXML(doc, vpID);
				} else if (Z.tileSource == 'ZoomifyImageFile') {
					// Fallback for annotations XML incorrectly sent as Content Type  as text/html rather than  as text/xml.
					doc = Z.Utils.xmlConvertTextToDoc(respText);
					validateXML(doc, vpID);
				} else if (Z.tileSource == 'ZoomifyPFFFile') {
					if (respText.toUpperCase().indexOf('PFFHEADER') != -1) {
						var dataIndex = respText.indexOf('reply_data=') + 'reply_data='.length;
						respText = respText.substring(dataIndex, respText.length);
					} else {
						// Normalize Zoomify Servlet response.
						var beginIndex = respText.indexOf('begin=') + 'begin='.length;
						var beginEndIndex = respText.indexOf('&', beginIndex);
						beginValue = respText.substring(beginIndex, beginEndIndex);
						var replyDataIndex = respText.indexOf('reply_data=') + 'reply_data='.length;
						replyDataValue = respText.substring(replyDataIndex, respText.length);
						respText = "<PFFOFFSET BEGIN='" + beginValue + "' REPLYDATA='" + replyDataValue + "' />";
					}
					doc = Z.Utils.xmlConvertTextToDoc(respText);
					validateXML(doc, vpID);
				} /*else if (Z.tileSource == 'ImageServer') {
					// Example image server protocol implementation.
					// DEV NOTE: Process image server response here.
				}*/
			}
		}
	}

	function validateBytes (xhr, vpID) {
		if (Z.Viewport) {
			var data = new Z.Utils.createUint8Array(xhr.response, 0);
			if (xhr.zType == 'header') {
				if (typeof vpID === 'undefined' || vpID === null) {
					Z.Viewport.parseZIFHeader(data);
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseZIFHeader(data); }
					}
				}
			} else if (xhr.zType == 'offset') {
				if (typeof vpID === 'undefined' || vpID === null) {
					Z.Viewport.parseZIFOffsetChunk(data, xhr.zChunkNumber);
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseZIFOffsetChunk(data, xhr.zChunkNumber); }
					}
				}
			} else if (xhr.zType == 'byteCount') {
				if (typeof vpID === 'undefined' || vpID === null) {
					Z.Viewport.parseZIFByteCountChunk(data, xhr.zChunkNumber);
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseZIFByteCountChunk(data, xhr.zChunkNumber); }
					}
				}
			} else if (xhr.zType.substring(0,5) == 'image') {
				imagesLoading--;
				Z.Viewport.parseZIFImage(data, xhr.zTile, xhr.zType);
			} else if (xhr.zType == 'navigator') {
				if (typeof vpID === 'undefined' || vpID === null) {
					Z.viewportCurrent.parseZIFImage(data, xhr.zTile, xhr.zType);
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseZIFImage(data, xhr.zTile, xhr.zType); }
					}
				}
			} else if (xhr.zType == 'gallery') {
				if (typeof vpID === 'undefined' || vpID === null) {
					Z.viewportCurrent.parseZIFImage(data, xhr.zTile, xhr.zType);
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseZIFImage(data, xhr.zTile, xhr.zType); }
					}
				}
			} else {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_MAKINGNETWORKREQUEST-ZIFBYTES'), false, Z.messageDurationShort, 'center');
			}
		}
	}

	// Current implementation creates XML from received JSON and passes image properties back to Viewer to reenter image loading process.
	function validateJSON (jsonText, vpID, iiifInfo) {
		var jsonObject = null;
		try {
			jsonObject = JSON.parse(jsonText);
		} catch (e) {
			Z.Utils.showMessage(e.name + Z.Utils.getResource('ERROR_PARSINGANNOTATIONSJSONFILE') + e.message);
		}

		if (jsonObject) {
			if (iiifInfo) {
				Z.iiifInfoJSONObject = jsonObject;
				var xmlText = '<IMAGE_PROPERTIES WIDTH="' + jsonObject.width + '" HEIGHT="' + jsonObject.height + '" />'
				var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
				if (typeof vpID === 'undefined' || vpID === null) {
					if (Z.Viewport) { Z.Viewport.parseImageXML(xmlDoc); }
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseImageXML(xmlDoc); }
					}
				}

			} else if (Z.overlays) {
				Z.overlayJSONObject = jsonObject;
				var xmlText = Z.Utils.jsonConvertObjectToXMLText(jsonObject);
				var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
				if (Z.Viewer) { Z.Viewer.parseImageSetXML(xmlDoc, 'overlay'); }

			} else {
				Z.annotationJSONObject = jsonObject;
				var xmlText = Z.Utils.jsonConvertObjectToXMLText(jsonObject);
				var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
				if (typeof vpID === 'undefined' || vpID === null) {
					if (Z.Viewport) { Z.Viewport.parseAnnotationsXML(xmlDoc); }
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseAnnotationsXML(xmlDoc); }
					}
				}
			}
		}
	}

	function validateXML (xmlDoc, vpID) {
		if (xmlDoc && xmlDoc.documentElement) {
			var rootName = xmlDoc.documentElement.tagName;
			if (Z.xmlParametersParsing) {
				Z.Utils.parseParametersXML(xmlDoc);
			} else if (rootName == 'USERDATA') {
				// Get username list for login validation.
				Z.Utils.parseUsersXML(xmlDoc);
			} else if (rootName == 'COPYRIGHT') {
				// Get text for copyright display.
				var cStatementText = xmlDoc.documentElement.getAttribute('STATEMENTTEXT');
				var cDeclinedText = xmlDoc.documentElement.getAttribute('DECLINEDTEXT');
				if (Z.Utils.stringValidate(cStatementText)) {
					Z.Utils.showCopyright(cStatementText, cDeclinedText);
				} else {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGEXMLINVALID'), true);
				}
			} else if ((rootName == 'IMAGE_PROPERTIES') || (rootName == 'ZIFHEADER') || (rootName == 'PFFHEADER')) {
				// Pass received image properties XML from file, folder, or other tilesource back to Viewer to reenter image loading process.
				if ((Z.tileSource == 'ZoomifyImageFile') || (Z.tileSource == 'ZoomifyImageFolder') || (Z.tileSource == 'ZoomifyPFFFile') || (Z.tileSource == 'ImageServer')) {
					if (Z.imagePath != "multiple") {
						var targetViewport;
						if (typeof vpID === 'undefined' || vpID === null || vpID == 0) {
							targetViewport = Z.Viewport;
						} else {
							targetViewport = Z['Viewport' + vpID.toString()];
						}
						targetViewport.parseImageXML(xmlDoc);
					} else {
						for (var i = 0, j = Z.imageSetLength; i < j; i++) {
							if (vpID == i) { Z['Viewport' + i.toString()].parseImageXML(xmlDoc); }
						}
					}

					// Debug option: Offset a viewport's position relative to others see it more easily.
					//if (vpID == 0) { Z.Viewport0.setSizeAndPosition(900, 550, 150, 0); }
				}
			} else if (rootName == 'PFFOFFSET') {
				// Pass received chunk offset data back to Viewer to reenter tile loading process.
				if (Z.imagePath != "multiple") {
					var targetViewport;
					if (typeof vpID === 'undefined' || vpID === null || vpID == 0) {
						targetViewport = Z.Viewport;
					} else {
						targetViewport = Z['Viewport' + vpID.toString()];
					}
					targetViewport.parseOffsetChunk(xmlDoc);
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseOffsetChunk(xmlDoc); }
					}
				}
			} else if (rootName == 'SKINDATA') {
				// Pass received chunk offset data back to Viewer to reenter tile loading process.
				if (typeof Z.xmlCallbackFunction === 'function') {
					Z.xmlCallbackFunction(xmlDoc);
				} else if (Z.Toolbar) {
					Z.Toolbar.parseSkinXML(xmlDoc);
				}
			} else if (rootName == 'GEODATA') {
				if (Z.Viewport) { Z.Viewport.parseGeoCoordinatesXML(xmlDoc); }
			} else if (rootName == 'IMAGELISTDATA') {
				// Pass received image list XML back to Viewer to reenter annotation loading process.
				if (typeof vpID === 'undefined' || vpID === null) {
					if (Z.Viewport) { Z.Viewport.parseImageListXML(xmlDoc); }
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseImageListXML(xmlDoc, vpID); }
					}
				}
			} else if (rootName == 'SLIDEDATA') {
				// Pass received slides XML back to Viewer to reenter slide loading process.
				if (Z.Viewport) { Z.Viewport.parseSlidesXML(xmlDoc); }
			} else if (rootName == 'HOTSPOTDATA') {
				// Pass received hotspot XML back to Viewer to reenter hotspot loading process.
				if (typeof vpID === 'undefined' || vpID === null) {
					if (Z.Viewport) { Z.Viewport.parseHotspotsXML(xmlDoc); }
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseHotspotsXML(xmlDoc); }
					}
				}
			} else if (rootName == 'ZAS') {
				// Pass received annotation XML back to Viewer to reenter annotation loading process.
				if (typeof vpID === 'undefined' || vpID === null) {
					if (Z.Viewport) { Z.Viewport.parseAnnotationsXML(xmlDoc); }
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseAnnotationsXML(xmlDoc, vpID); }
					}
				}
			} else if (rootName == "COMPARISONDATA") {
				// Pass received image set XML back to Viewer to reenter image set loading process.
				if (Z.Viewer) { Z.Viewer.parseImageSetXML(xmlDoc, 'comparison'); }
			} else if (rootName == "OVERLAYDATA") {
				// Pass received image set XML back to Viewer to reenter image set loading process.
				if (Z.Viewer) { Z.Viewer.parseImageSetXML(xmlDoc, 'overlay'); }
			} else if (rootName == "ANIMATIONDATA") {
				// Pass received image set XML back to Viewer to reenter image set loading process.
				if (Z.Viewer) { Z.Viewer.parseImageSetXML(xmlDoc, 'animation'); }
			} else if (rootName == "SLIDESTACKDATA") {
				// Pass received image set XML back to Viewer to reenter image set loading process.
				if (Z.Viewer) { Z.Viewer.parseImageSetXML(xmlDoc, 'slidestack'); }
			} else if (rootName == "TRACKINGDATA") {
				// Pass received tracking XML back to Viewer to reenter tracking panel loading process.
				if (typeof vpID === 'undefined' || vpID === null) {
					if (Z.Viewport) { Z.Viewport.parseTrackingXML(xmlDoc); }
				} else {
					for (var i = 0, j = Z.imageSetLength; i < j; i++) {
						if (vpID == i) { Z['Viewport' + i.toString()].parseTrackingXML(xmlDoc, vpID); }
					}
				}
			} else if (Z.postingImage) {
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_SAVEIMAGEHANDLERPATHINVALID'), true);
			} else {
				// Is there a problem here saving to image file or only and xml error because missing a condition specific to a different error?
				//console.log(Z.Utils.xmlConvertDocToText(xmlDoc));
				Z.Utils.showMessage(Z.Utils.getResource('ERROR_XMLINVALID'), true);
			}
		} else {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_XMLDOCINVALID'), true);
		}
	}

	this.loadImage = function (src, callback, contentType, tile) {
		loadImage(src, callback, contentType, tile);
	}

	function loadImage (src, callback, contentType, tile) {
		if (imagesLoading < IMAGES_LOADING_MAX) {
			imagesLoading++;
			if (Z.tileSource == 'ZoomifyImageFile' && ((typeof tile !== 'undefined' && tile !== null) || contentType == 'navigator')) {
				loadImageByteRange(src, contentType, tile);
			} else {
				var func = Z.Utils.createCallback(null, onComplete, callback);
				var imageNetRequest = new ImageNetRequest(src, func, contentType);
				imageNetRequest.start();
			}
			return true;

		} else {
			var index = Z.Utils.arrayIndexOfObjectValue(loadImageQueue, 'sc', src);
			if (index == -1) {
				loadImageQueue[loadImageQueue.length] = { sc:src, cb:callback, ct:contentType, t:tile };
				// Debug option: console.log('Adding to queue: ' + tile.name + '  Queue length: ' + loadImageQueue.length);
				if (!loadImageQueueInterval) {
					loadImageQueueInterval = window.setInterval( function() { loadImagesFromQueue(); }, loadImageQueueDelay);
				}
			}
			return false;
		}
	}

	function loadImagesFromQueue () {
		var qNext = loadImageQueue[0];
		var loadingImage = loadImage(qNext.sc, qNext.cb, qNext.ct, qNext.t);
		if (loadingImage) { loadImageQueue = Z.Utils.arraySplice(loadImageQueue, 0, 1); }
		if (loadImageQueue.length == 0 && loadImageQueueInterval) {
			window.clearInterval(loadImageQueueInterval);
			loadImageQueueInterval = null;
		}
	}

	function onComplete (callback, src, img) {
		imagesLoading--;
		if (typeof callback === 'function') {
			try {
				callback(img);
			} catch (e) {
				Z.Utils.showMessage(e.name + Z.Utils.getResource('ERROR_EXECUTINGCALLBACK') + src + ' ' + e.message, true);
			}
		}
	}

	function ImageNetRequest (src, callback, contentType) {
		var image = null;
		var timeout = null;
		this.start = function () {
			image = new Image();
			var successFunction = function () { complete(true); };
			var errorFunction = function () { complete(false); };

			var timeoutFunc = function () {
				// Debug option: Append source data to error message below: + ': ' + src);
				console.log(Z.Utils.getResource('ERROR_IMAGEREQUESTTIMEDOUT')); // Options for showMessage:, false, Z.messageDurationShort, 'center');
				complete(false);

				Z.Viewport.traceDebugValues('imageRequestTimeout', contentType + ' timeout: ' + src);
			};

			image.onload = successFunction;
			image.onabort = errorFunction;
			image.onerror = errorFunction;
			timeout = window.setTimeout(timeoutFunc, IMAGE_LOAD_TIMEOUT);
			image.src = src;
		};

		function complete (result) {
			image.onload = null;
			image.onabort = null;
			image.onerror = null;
			if (timeout) { window.clearTimeout(timeout); }
			window.setTimeout(function () { callback(src, result ? image : null); }, 1);
		};
	}
};



//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::::::::::::::::::::::::::::::::::: UTILITY FUNCTIONS :::::::::::::::::::::::::::::::::::
//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

Z.Utils = {

	addCrossBrowserMethods : function () {
		// Meta methods are used to ensure consistent functional support.  Specific browser
		// differences are managed within each event handler.
		if (document.addEventListener) {
			// Methods required for missing W3C DOM functionality

			this.disableTextInteraction = function (tN) {
				if (tN) {
					var tnS = tN.parentNode.style;
					if (tnS) {
						tN.parentNode.unselectable = 'on'; // For IE and Opera
						tnS.userSelect = 'none';
						tnS.MozUserSelect = 'none';
						tnS.webkitUserSelect = 'none';
						tnS.webkitTouchCallout = 'none';
						tnS.webkitTapHighlightColor = 'transparent';
					}
				}
			};

			this.renderQuality = function (image, quality) {
				if (quality) {
					var rndrQuality = (quality == 'high') ? 'optimizeQuality' : 'optimizeSpeed';
					image.style.setProperty ('image-rendering', rndrQuality, null);
				}
			};

			this.setOpacity = function (element, value, altColor) {
				if (Z.alphaSupported) {
					element.style.opacity=value;
				} else if (altColor) {
					element.style.backgroundColor = altColor;
				}
			};

		} else if (document.attachEvent) {
			// Methods required for missing Internet Explore functionality

			this.disableTextInteraction = function (tN) {
				if (tN) {
					tN.parentNode.unselectable = 'on';
					tN.parentNode.onselectstart = function () { return false; };
				}
			};

			this.renderQuality = function (image, quality) {
				if (quality) {
					var rndrQuality = (quality == 'high') ? 'bicubic' : 'nearest-neighbor';
					image.style.msInterpolationMode = rndrQuality;
				}
			};

			this.setOpacity = function (element, value, altColor) {
				if (Z.alphaSupported) {
					value *= 100; // IE uses range of 1 to 100 rather than 0.1 to 1.
					element.style.zoom = 1; // Workaround to enable alpha support for elements not positioned.
					element.style.filter = 'progid:DXImageTransform.Microsoft.Alpha(Opacity=' + value + ')'; // IE8
					element.style.filter = 'alpha(opacity=' + value + ')'; // IE7, 6

					// Next line is workaround for IE problem with overwriting right and bottom borders of div where
					// overflow is set to 'hidden' but content's filter is set to value=100 in the two filter lines above.
					if (value == 100) { element.style.filter = ''; }

				} else if (altColor) {
					element.style.backgroundColor = altColor;
				}
			};
		}
	},

	addCrossBrowserEvents : function () {
		// Meta events model is used only to ensure consistent event listener methods.
		// Specific browser differences are managed within each event handler.
		if (document.addEventListener) {
			// W3C DOM 2 Events model

			this.addEventListener = function (target, eventName, handler) {
				if (target) {
					if (eventName == 'mousewheel') { target.addEventListener('DOMMouseScroll', handler, false); }
					target.addEventListener(eventName, handler, false);
				}
			};

			this.removeEventListener = function (target, eventName, handler) {
				if (target) {
					if (eventName == 'mousewheel') { target.removeEventListener('DOMMouseScroll', handler, false); }
					target.removeEventListener(eventName, handler, false);
				}
			};

			this.event = function (event) {
				return event;
			};

			this.target = function (event) {
				return event.target;
			};

			this.relatedTarget = function (event) {
				return event.relatedTarget;
			};

			this.isRightMouseButton = function (event) {
				var rightButton = false;
				if (event.which == 2 || event.which == 3) { rightButton = true; }
				return rightButton;
			};

			this.preventDefault = function (event) {
				event.preventDefault();
			};

			this.stopPropagation = function (event) {
				event.stopPropagation();
			};

		} else if (document.attachEvent) {
			// Internet Explorer Events model

			this.addEventListener = function (target, eventName, handler) {
				if (this._findListener(target, eventName, handler) != -1) return; // Prevent redundant listeners (DOM 2).
				var handler2 = function () {
					// IE version-specific listener (method of target, event object global)
					var event = window.event;
					if (Function.prototype.call) {
						handler.call(target, event);
					} else {
						target._currentListener = handler;
						target._currentListener(event)
						target._currentListener = null;
					}
				};
				target.attachEvent('on' + eventName, handler2);
				// Object supports cleanup
				var listenerRecord = {
					target: target,
					eventName: eventName,
					handler: handler,
					handler2: handler2
				};
				var targetDoc = target.document || target; // Get window object reference containing target.
				var targetWin = targetDoc.parentWindow;
				var listenerId = 'l' + this._listenerCounter++; // Create unique ID
				if (!targetWin._allListeners) { targetWin._allListeners = {}; } // Record listener in window object.
				targetWin._allListeners[listenerId] = listenerRecord;
				if (!target._listeners) { target._listeners = [];} // Record listener ID in target.
				target._listeners[target._listeners.length] = listenerId;
				if (!targetWin._unloadListenerAdded) {
					targetWin._unloadListenerAdded = true;
					targetWin.attachEvent('onunload', this._removeAllListeners); // Ensure listener cleanup on unload.
				}
			};

			this.removeEventListener = function (target, eventName, handler) {
				if (target) {
					var listenerIndex = this._findListener(target, eventName, handler); // Verify listener added to target.
					if (listenerIndex == -1) { return; }
					var targetDoc = target.document || target; // Get window object reference containing target.
					var targetWin = targetDoc.parentWindow;
					var listenerId = target._listeners[listenerIndex]; // Get listener in window object.
					var listenerRecord = targetWin._allListeners[listenerId];
					target.detachEvent('on' + eventName, listenerRecord.handler2); // Remove listener. Remove ID from target.
					target._listeners = Z.Utils.arraySplice(target._listeners, listenerIndex, 1);
					delete targetWin._allListeners[listenerId]; // Remove listener record from window object.
				}
			};

			this.event = function (event) {
				return window.event;
			};

			this.target = function (event) {
				return event.srcElement;
			};

			this.relatedTarget = function (event) {
				var relTarg = null;
				if (event.type == 'mouseover') {
					relTarg = event.fromElement;
				} else if (event.type == 'mouseout') {
					relTarg = event.toElement;
				}
				return relTarg;
			};

			this.isRightMouseButton = function (event) {
				var rightButton = false;
				if (event.button == 2) { rightButton = true; }
				return rightButton;
			};

			this.preventDefault = function (event) {
				if (event) { event.returnValue = false; }
			};

			this.stopPropagation = function (event) {
				event.cancelBubble = true;
			};

			this._findListener = function (target, eventName, handler) {
				var listeners = target._listeners; // Get array of listener IDs added to target.
				if (!listeners) { return -1; }
				var targetDoc = target.document || target; // Get window object reference containing target.
				var targetWin = targetDoc.parentWindow;
				for (var i = listeners.length - 1; i >= 0; i--) {
					// Find listener (backward search for faster onunload).
					var listenerId = listeners[i]; // Get listener's ID from target.
					var listenerRecord = targetWin._allListeners[listenerId]; // Get listener record from window object.
					// Compare eventName and handler with the retrieved record.
					if (listenerRecord && listenerRecord.eventName == eventName && listenerRecord.handler == handler) { return i; }
				}
				return -1;
			};

			this._removeAllListeners = function () {
				var targetWin = this;
				for (id in targetWin._allListeners) {
					var listenerRecord = targetWin._allListeners[id];
					listenerRecord.target.detachEvent('on' + listenerRecord.eventName, listenerRecord.handler2);
					delete targetWin._allListeners[id];
				}
			};

			this._listenerCounter = 0;
		}
	},

	declareGlobals : function () {
		// IMAGE & SKIN
		Z.pageContainerID = null;
		Z.imagePath = null;
		Z.imagePath2 = null;
		Z.parameters = null;
		Z.xmlParametersPath = null;
		Z.xMLParametersPath = null; // Lower case 'xml' version above used internally. This version prevents error message in function setParameters.
		Z.xmlParametersParsing = null;
		Z.xMLParametersParsing = null; // Lower case 'xml' version above used internally. This version prevents error message in function setParameters.
		Z.skinPath = null;
		Z.skinMode = null;
		Z.cacheProofCounter = 0;
		Z.timerCounter = 0;

		// PAGE & BROWSER
		Z.browsers = null;
		Z.browser = null;
		Z.browserVersion = null;
		Z.scaleThreshold = null;
		Z.canvasSupported = null;
		Z.cssTransformsSupported = null;
		Z.cssTransformProperty = null;
		Z.cssTransformNoUnits = null;
		Z.alphaSupported = null;
		Z.renderQuality = null;
		Z.rotationSupported = null;
		Z.fullScreenSupported = null;
		Z.arrayMapSupported = null;
		Z.arraySpliceSupported = null;
		Z.float32ArraySupported = null;
		Z.uInt8ArraySupported = null
		Z.xmlHttpRequestSupport = null;
		Z.definePropertySupported = null;
		Z.responseArraySupported = null;
		Z.responseArrayPrototyped = false;
		Z.touchSupport = null;
		Z.mobileDevice = null;
		Z.localUse = null;
		Z.zifSupported = null;

		// VIEWER OPTIONS & DEFAULTS
		Z.onReady = null;
		Z.onAnnotationReady = null;
		Z.initialX = null;
		Z.initialY = null;
		Z.initialZ = null;
		Z.initialZoom = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.minZ = null;
		Z.minZoom = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.maxZ = null;
		Z.maxZoom = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.zoomSpeed = null;
		Z.panSpeed = null;
		Z.smoothPan = null;
		Z.smoothPanEasing = null;
		Z.smoothZoom = null;
		Z.smoothZoomEasing = null;
		Z.smoothPanGlide = null;
		Z.autoResize = null;
		Z.fadeIn = null;
		Z.fadeInSpeed = null;
		Z.toolbarInternal = null;
		Z.toolbarVisible = null;
		Z.toolbarAutoShowHide = null;
		Z.toolbarW = null;
		Z.toolbarH = null;
		Z.toolbarPosition = null;
		Z.navigatorVisible = null;
		Z.navigatorW = null;
		Z.navigatorWidth = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.navigatorH = null;
		Z.navigatorHeight = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.navigatorL = null;
		Z.navigatorLeft = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.navigatorT = null;
		Z.navigatorTop = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.navigatorFit = null;
		Z.navigatorRectangleColor = null;
		Z.GalleryScrollPanel = null;
		Z.galleryVisible = null;
		Z.galleryAutoShowHide = null;
		Z.galleryW = null;
		Z.galleryH = null;
		Z.galleryL = null;
		Z.galleryT = null;
		Z.galleryPosition = null;
		Z.galleryRectangleColor = null;
		Z.mouseIsDownGallery = null;
		Z.clickZoom = null;
		Z.doubleClickZoom = null;
		Z.doubleClickDelay = null;
		Z.clickPan = null;
		Z.clickZoomAndPanBlock = false;
		Z.mousePan = null;
		Z.keys = null;
		Z.constrainPan = null;
		Z.constrainPanLimit = null;
		Z.constrainPanStrict = null;
		Z.panBuffer = null;
		Z.tooltipsVisible = null;
		Z.helpVisible = 0;
		Z.helpPath = null;
		Z.helpCustom = false;
		Z.helpContent = null;
		Z.helpW = null;
		Z.helpWidth = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.helpH = null;
		Z.helpHeight = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.helpL = null;
		Z.helpLeft = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.helpT = null;
		Z.helpTop = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.minimizeVisible = null;
		Z.sliderZoomVisible = null;
		Z.sliderVisible = null; // Deprecated. Now Z.sliderZoomVisible. HTML parameter still zSliderVisible. This set here to prevent specific error message in function setParameters.
		Z.panButtonsVisible = null;
		Z.resetVisible = null;

		Z.fullViewVisible = null;
		Z.fullScreenVisible = null;
		Z.fullPageVisible = null;
		Z.initialFullPage = null;
		Z.fullPageInitial = null; // Deprecated. Set here to enable specific error message in function setParameters.
		Z.fullScreenEntering = null;

		Z.progressVisible = null;
		Z.messagesVisible = null;
		Z.logoVisible = null;
		Z.logoLink = null;
		Z.logoLinkURL = null;
		Z.logoCustomPath = null;

		Z.bookmarksGet = null;
		Z.bookmarksSet = null;

		Z.copyrightPath = null;
		Z.watermarkPath = null;
		Z.watermarks = null;

		Z.virtualPointerVisible = null;
		Z.crosshairsVisible = null;
		Z.zoomRectangle = null;

		Z.rulerVisible = null;
		Z.units = null;
		Z.unitsPerImage = null;
		Z.pixelsPerUnit = null;
		Z.sourceMagnification = null;
		Z.magnification = null; //  Deprecated. Set here to enable specific error message in function setParameters.
		Z.rulerListType = null;
		Z.rulerW = null;
		Z.rulerWidth = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.rulerH = null;
		Z.rulerHeight = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.rulerL = null;
		Z.rulerLeft = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.rulerT = null;
		Z.rulerTop = null; // Concise version above used internally. This long version prevents error message in function setParameters.
		Z.measureVisible = false;
		Z.rotationVisible = null;
		Z.rotationFree = null;
		Z.initialR = null;
		Z.initialRotation = null; // Concise version above used internally. This long version prevents error message in function setParameters.

		Z.imageListPath = null;
		Z.imageList = null;
		Z.imageListTitle = null;
		Z.imageListFolder = null;
		Z.imageListFileShared = false;
		Z.imageSetImageListPath = null;
		Z.imageListTimeout = null;

		Z.screensaver = false;
		Z.screensaverSpeed = null;
		Z.tour = false;
		Z.tourPath = null;
		Z.tourListTitle = null;
		Z.tourPlaying = null;
		Z.tourStop = false;

		Z.comparison = false;
		Z.comparisonPath = null; // Supports zComparisonPath parameter test.
		Z.syncVisible = null;
		Z.initialSync = null;
		Z.syncComparison = null;

		Z.slideshow = false;
		Z.slidePath = null;
		Z.slideListTitle = null;
		Z.slideshowPlaying = null;
		Z.slideTransitionTimeout = null;
		Z.slideTransitionSpeed = null;
		Z.slideOpacity = 0;

		Z.audioContent = false;
		Z.audioMuted = false;

		Z.hotspots = false;
		Z.hotspotPath = null;
		Z.hotspotFolder = null;
		Z.hotspotListTitle = null;
		Z.hotspotsDrawOnlyInView = true;
		Z.captionBoxes = false;
		Z.captionsColorsDefault = true;

		Z.annotations = false;
		Z.annotationPath = null;
		Z.annotationFolder = null;
		Z.annotationXMLText = null;
		Z.annotationJSONObject = null;
		Z.annotationsAddMultiple = null;
		Z.annotationsAutoSave = null;
		Z.annotationPanelVisible = null; // Include panel in interface.
		Z.annotationPanelVisibleState = false; // Show or hide panel currently.

		Z.saveButtonVisible = null;

		Z.labelClickSelect = null;
		Z.simplePath = false;
		Z.noPost = false;
		Z.noPostDefaults = false;
		Z.unsavedEditsTest = true;

		Z.maskVisible = null;
		Z.maskingSelection = false;
		Z.maskFadeTimeout = null;
		Z.maskFadeSpeed = null;
		Z.maskOpacity = 0;
		Z.maskClearOnUserAction = null;

		Z.externalEditPermissionFunction = null; // Value must be function to be invoked. Function must return true or false.
		Z.annotationSort = 'none';

		Z.saveHandlerPath = null;
		Z.saveImageHandlerPath = null;
		Z.saveImageFull = null;
		Z.postingXML = false;
		Z.postingImage = false;

		Z.coordinatesVisible = null;
		Z.geoCoordinatesPath = null;
		Z.geoCoordinatesVisible = null;
		Z.geoCoordinatesFolder = null;

		Z.preloadVisible = null;

		Z.imageFilters = null;
		Z.imageFiltersVisible = null;
		Z.initialImageFilters = null;
		Z.brightnessVisible = null;
		Z.contrastVisible = null;
		Z.sharpnessVisible = null;
		Z.blurrinessVisible = null;
		Z.colorRedVisible = null;
		Z.colorGreenVisible = null;
		Z.colorBlueVisible = null;
		Z.colorRedRangeVisible = null;
		Z.colorGreenRangeVisible = null;
		Z.colorBlueRangeVisible = null;
		Z.colorRedRangeMin = null;
		Z.colorRedRangeMax = null;
		Z.colorGreenRangeMin = null;
		Z.colorGreenRangeMax = null;
		Z.colorBlueRangeMin = null;
		Z.colorBlueRangeMax = null;

		Z.saveImageFull = null;
		Z.saveImageFilename = null;
		Z.saveImageFormat = null;
		Z.saveImageCompression = null;
		Z.saveImageBackColor = null;

		Z.tracking = false;
		Z.trackingPath = null;
		Z.trackingFolder = null;
		Z.trackingPathProvided = false;
		Z.trackingEditMode = false;
		Z.trackingFileShared = false;
		Z.imageSetTrackingPath = null;
		Z.trackingPanelPosition = null;
		Z.trackingCounts = [];
		Z.trackingTypeCurrent = '0';
		Z.trackingOverlayVisible = false;
		Z.initialTrackingOverlayVisible = null;
		Z.trackingCellCurrent = null;
		Z.trackingPanelVisible = null; // Include panel in interface.
		Z.trackingPanelVisibleState = false; // Show or hide panel currently.

		Z.userName = null;
		Z.userInitials = null;
		Z.userLogin = null;
		Z.userNamePrompt = null;
		Z.userNamePromptRetry = null;
		Z.userPath = null;
		Z.userFolder = null;
		Z.userPathProvided = false;
		Z.userList = [];
		Z.userLogging = false;
		Z.UserPanel = null;
		Z.userPanelVisible = null; // Include panel in interface.
		Z.userPanelVisibleState = false; // Show or hide panel currently.

		Z.canvas = null;
		Z.baseZIndex = null;
		Z.debug = null;
		Z.imageProperties = null;
		Z.serverIP = null;
		Z.serverPort = null;
		Z.tileHandlerPath = null;
		Z.tileHandlerPathFull = null;

		Z.iiifInfoJSONObject =null;
		Z.iiifScheme = null;
		Z.iIIFScheme = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifServer = null;
		Z.iIIFServer = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifPrefix = null;
		Z.iIIFPrefix = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifIdentifier = null;
		Z.iIIFIdentifier = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifRegion = null;
		Z.iIIFRegion = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifSize = null;
		Z.iIIFSize = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifRotation = null;
		Z.iIIFRotation = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifQuality = null;
		Z.iIIFQuality = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.
		Z.iiifFormat = null;
		Z.iIIFFormat = null; // Lower case 'iiif' version above used internally. This version prevents error message in function setParameters.

		Z.tileW = null;
		Z.tileH = null;
		Z.tileType = 'jpg';
		Z.tilesPNG = null;  // Deprecated.  zTilesPNG now sets Z.tileType above. Set here to enable specific error message in function setParameters.
		Z.freehandVisible = null;
		Z.textVisible = null;
		Z.iconVisible = null;
		Z.rectangleVisible = null;
		Z.polygonVisible = null;
		Z.captionTextColor = null;
		Z.captionBackColor = null;
		Z.polygonLineColor = null;
		Z.polygonFillColor = null;
		Z.captionTextVisible = true;
		Z.captionBackVisible = true;
		Z.polygonFillVisible = false;
		Z.polygonLineVisible = true;

		Z.annotationPathProvided = false;
		Z.saveHandlerProvided = false;
		Z.imageSetPathProvided = false;
		Z.slidePathProvided = false;
		Z.saveImageHandlerProvided = false;
		Z.tileSource = null;
		Z.tileSourceMultiple = null;
		Z.focal = null;
		Z.quality = null;
		Z.markupMode = null; // Used only to ensure zMarkupMode validity test does not return 'undefined'.
		Z.editMode = null; // Supported values: null, 'edit', 'markup'.
		Z.editAdmin = false; // Supported values: false (default), true.
		Z.editing = null; // Supported values: null, 'addPOI', 'editPOI', 'addLabel', 'editLabel', 'addNote', 'editNote'.
		Z.labelMode = 'view'; // Supported values: 'view', 'freehand', 'text', 'icon', 'rectangle', 'polygon', 'measure'.
		Z.editModePrior = Z.editMode;
		Z.xmlCallbackFunction = null;
		Z.labelsClickDrag = false;
		Z.sliderFocus = 'zoom';
		Z.overlayPath = null; // Supports zOverlayPath parameter test.
		Z.overlays = false;
		Z.overlayJSONObject = null;
		Z.overlaysInitialVisibility = null;
		Z.animation = false;
		Z.animationPath = null; // Supports zAnimationPath parameter test.
		Z.animationCount = 0;
		Z.animationAxis = null;
		Z.animator = null;
		Z.animationFlip = null;
		Z.slidestack = false;
		Z.slidestackPath = null; // Supports zSlidestackPath parameter test.
		Z.imageSet = false;
		Z.imageSetPath = null;
		Z.imageSetLength = null;
		Z.imageSetListPosition = null;
		Z.imageSetListTitle = null;
		Z.imageSetStart = null;
		Z.imageSetLoop = null;
		Z.sliderImageSetVisible = null;
		Z.mouseWheelParmeterProvided = null;
		Z.mouseWheel = null;
		Z.imageSetHotspotPath = null;
		Z.hotspotFileShared = false;
		Z.imageSetAnnotationPath = null;
		Z.annotationFileShared = false;

		// VIEWER COMPONENTS & STATE VALUES
		Z.messageDurationLong = parseInt(Z.Utils.getResource('DEFAULT_MESSAGEDURATIONLONG'), 10);
		Z.messageDurationStandard = parseInt(Z.Utils.getResource('DEFAULT_MESSAGEDURATIONSTANDARD'), 10);
		Z.messageDurationShort = parseInt(Z.Utils.getResource('DEFAULT_MESSAGEDURATIONSHORT'), 10);
		Z.messageDurationVeryShort = parseInt(Z.Utils.getResource('DEFAULT_MESSAGEDURATIONVERYSHORT'), 10);
		Z.Viewer = null;
		Z.ViewerDisplay = null;
		Z.Viewport = null;
		Z.Toolbar = null;
		Z.ToolbarDisplay = null;
		Z.ToolbarMinimized = false;
		Z.TooltipDisplay = null;
		Z.Navigator = null;
		Z.Navigator2 = null;
		Z.NavigatorDisplay = null;
		Z.MessageDisplay = null;
		Z.messages = null;
		Z.messageDisplayList = [];
		Z.overlayMessage = null;
		Z.CoordinatesDisplay = null;
		Z.coordinates = null;
		Z.coordinatesSave = null;
		Z.CopyrightDisplay = null;
		Z.AnnotationPanelDisplay = null;
		Z.imageW = null;
		Z.imageH = null;
		Z.imageD = null;
		Z.imageCtrX = null;
		Z.imageCtrY = null;
		Z.imageX = 0;
		Z.imageY = 0;
		Z.imageZ = 0;
		Z.imageR = 0;
		Z.priorX = 0;
		Z.priorY = 0;
		Z.priorZ = 0;
		Z.priorR = 0;
		Z.preventDupCall = false;
		Z.fitZ = null;
		Z.fillZ = null;
		Z.zooming = 'stop';
		Z.panningX = 'stop';
		Z.panningY = 'stop';
		Z.rotating = 'stop';
		Z.fullView = false;
		Z.fullViewPrior = false;
		Z.interactive = true;
		Z.useCanvas = true;
		Z.expressParamsEnabled = null;
		Z.proParamsEnabled = null;
		Z.specialStorageEnabled = null;
		Z.enterpriseParamsEnabled = null;
		Z.updateViewPercent = 0;
		Z.TraceDisplay = null;
		Z.traces = null;
		Z.mouseIsDown = false;
		Z.buttonIsDown = false;
		Z.keyIsDown = false;
		Z.mouseWheelIsDown = false;
		Z.mouseWheelCompleteDuration = null;
		Z.mouseWheelCompleteTimer = null;
		Z.mouseOutDownPoint = null;

		// ImageSet support.
		Z.viewportCurrentID = 0;
		Z.viewportCurrent = null;
		Z.viewportChangeTimeout = null;
	},

	detectBrowserFeatures : function () {
		// Detect browser and version.
		Z.browsers = { UNKNOWN: 0, IE: 1, FIREFOX: 2, SAFARI: 3, CHROME: 4, OPERA: 5, EDGE: 6 };
		var browser = Z.browsers.UNKNOWN;
		var browserVersion = 0;
		var scaleThreshold = 10000; // Safe value set, actual value may be 1M.
		var app = navigator.appName;
		var ver = navigator.appVersion;
		var msInterpolationMode = false;
		var gwkRenderingMode = false;
		var ua = navigator.userAgent.toLowerCase();

		if (ua.indexOf('edge') != -1) {
			browser = Z.browsers.EDGE;
			browserVersion = ver;
		} else if (app == 'Microsoft Internet Explorer' && !! window.attachEvent && !! window.ActiveXObject) {
			var ieOffset = ua.indexOf('msie');
			browser = Z.browsers.IE;
			browserVersion = parseFloat(ua.substring(ieOffset + 5, ua.indexOf(';', ieOffset)));
			msInterpolationMode = (typeof document.documentMode !== 'undefined');
		} else if (app == 'Netscape' && ua.indexOf('trident') != -1) {
			browser = Z.browsers.IE;
			browserVersion = 11;
		} else if (app == 'Netscape' && !! window.addEventListener) {
			var idxFF = ua.indexOf('firefox');
			var idxSA = ua.indexOf('safari');
			var idxCH = ua.indexOf('chrome');
			if (idxFF >= 0) {
				browser = Z.browsers.FIREFOX;
				browserVersion = parseFloat(ua.substring(idxFF + 8));
				scaleThreshold = 10000; // Safe value set, actual value may be 100,000.
			} else if (idxSA >= 0) {
				var slash = ua.substring(0, idxSA).lastIndexOf('/');
				browser = (idxCH >= 0) ? Z.browsers.CHROME : Z.browsers.SAFARI;
				browserVersion = parseFloat(ua.substring(slash + 1, idxSA));
				scaleThreshold = 10000;
			}
			var testImage = new Image();
			if (testImage.style.getPropertyValue) { gwkRenderingMode = testImage.style.getPropertyValue ('image-rendering'); }
		} else if (app == 'Opera' && !! window.opera && Object.prototype.toString.call(window.opera) == '[object Opera]') {
			browser = Z.browsers.OPERA;
			browserVersion = parseFloat(ver);
		}

		// Detect network request support
		var xmlHttpRequestSupport;
		if (window.XMLHttpRequest) {
			netReq = new XMLHttpRequest();
			xmlHttpRequestSupport = 'XMLHttpRequest';
		} else if (window.ActiveXObject) {
			var arrActiveX = ['Msxml2.XMLHTTP.6.0', 'Msxml2.XMLHTTP.3.0', 'Microsoft.XMLHTTP'];
			for (var i = 0, j = arrActiveX.length; i < j; i++) {
				try {
					netReq = new ActiveXObject(arrActiveX[i]);
					xmlHttpRequestSupport = arrActiveX[i];
					break;
				} catch (e) {
					continue;
				}
			}
		}

		var responseArraySupported = ('response' in XMLHttpRequest.prototype || 'mozResponseArrayBuffer' in XMLHttpRequest.prototype || 'mozResponse' in XMLHttpRequest.prototype || 'responseArrayBuffer' in XMLHttpRequest.prototype);

		// Detect Canvas support.
		var elem = document.createElement('canvas');
		var canvasSupportPresent = !!(elem.getContext && elem.getContext('2d'));
		var canvasSuppSubpix = !((browser == Z.browsers.SAFARI && browserVersion < 4) || (browser == Z.browsers.CHROME && browserVersion < 2));
		var canvasSupported = canvasSupportPresent && canvasSuppSubpix;
		var alphaSupported = !(browser == Z.browsers.CHROME && browserVersion < 2);
		var renderQuality = (msInterpolationMode || gwkRenderingMode) ? 'high' : null;

		// Detect transform support - for rotation and non-canvas tile placement.
		var docElmt = document.documentElement || {};
		var docElmtStyle = docElmt.style || {};
		var cssTransformsSupported = false;
		var cssTransformProperties = ['transform', 'WebkitTransform', 'MozTransform', 'OTransform', 'msTransform'];
		var cssTransformProperty;
		var cssTransformNoUnits;
		while (cssTransformProperty = cssTransformProperties.shift()) {
			if (typeof docElmtStyle[cssTransformProperty] !== 'undefined') {
				cssTransformsSupported = true;
				cssTransformNoUnits = /webkit/i.test(cssTransformProperty);
				break;
			}
		}
		var rotationSupported = cssTransformsSupported;

		// Detect touch event support - enable touch event handlers but do not disable mouse event handlers.
		var touchSupport = (('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));

		// Detect mobile device - affects pan buffer size, buttons sizes, zoom step size, label scaling step size, label control point size, and whether some errors are presented as messages in the user display are in the developer console.
		var iOSDevice = (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1);
		var mobileDevice = (ua.indexOf('android') > -1 || iOSDevice);

		// Detect fullscreen support - native and vendor.
		var fullScreenSupported = false;
		 if (typeof document.cancelFullScreen !== 'undefined'
			|| typeof document.webkitCancelFullScreen !== 'undefined'
			|| typeof document.mozCancelFullScreen !== 'undefined'
			|| typeof document.oCancelFullScreen !== 'undefined'
			|| typeof document.msCancelFullScreen !== 'undefined'
			|| typeof document.msExitFullscreen !== 'undefined') {
			fullScreenSupported = true;
		}

		// Detect array support, type, and property support.
		var arrayMapSupported = Array.prototype.map;
		var arraySpliceSupported = Array.prototype.splice;
		var float32ArraySupported = false;
		try {
			var a = new Float32Array(1);
			float32ArraySupported = true;
		} catch (e) { }

		var uInt8ArraySupported = false;
		try {
			var a = new Uint8Array(1);
			uInt8ArraySupported = true;
		} catch (e) { }
		var definePropertySupported = false;
		if (typeof Object.defineProperty == 'function') {
			try {
				Object.defineProperty({}, 'x', {});
				definePropertySupported = true;
			} catch (e) { }
		}

		// Detect local access - alert users of Chrome/Opera/IE11 (folders) and ZIF/PFF (all browsers).
		var localUse;
		switch (window.location.protocol) {
			case 'http:':
				localUse = false;
				break;
			case 'https:':
				localUse = false;
				break;
			case 'file:':
				localUse = true;
				break;
			default:
				localUse = null;
				break;
		}

		// Detect browser use not supporting ZIF single file storage. Access not supported on IE <= v8 and Opera <= v12 and most pre-canvas browsers.
		// Numerous browsers with limited adoption not tested and functional failures will present specific errors rather than general ZIF support message.
		var zifSupported = !((Z.browser == Z.browsers.IE && Z.browserVersion < 9) || (Z.browser == Z.browsers.OPERA && Z.browserVersion < 15) || (Z.browser == Z.browsers.CHROME && Z.browserVersion < 25) && (Z.browser == Z.browsers.FIREFOX && Z.browserVersion < 20) && (Z.browser == Z.browsers.SAFARI && Z.browserVersion < 5));

		// Set global variables.
		Z.browser = browser;
		Z.browserVersion = browserVersion;
		Z.scaleThreshold = scaleThreshold;
		Z.xmlHttpRequestSupport = xmlHttpRequestSupport;
		Z.responseArraySupported = responseArraySupported;
		Z.canvasSupported = canvasSupported;
		Z.useCanvas = Z.canvasSupported;  // Can be overridden by false zCanvas parameter.
		Z.imageFilters = (!Z.useCanvas && Z.imageFilters) ? false : Z.imageFilters;
		Z.cssTransformsSupported = cssTransformsSupported;
		Z.cssTransformProperty = cssTransformProperty;
		Z.cssTransformNoUnits = cssTransformNoUnits;
		Z.alphaSupported = alphaSupported;
		Z.renderQuality = renderQuality;
		Z.rotationSupported = rotationSupported;
		Z.fullScreenSupported = fullScreenSupported;
		Z.arrayMapSupported = arrayMapSupported;
		Z.arraySpliceSupported = arraySpliceSupported;
		Z.float32ArraySupported = float32ArraySupported;
		Z.uInt8ArraySupported = uInt8ArraySupported;
		Z.definePropertySupported = definePropertySupported;
		Z.touchSupport = touchSupport;
		Z.mobileDevice = mobileDevice;
		Z.localUse = localUse;
		Z.zifSupported = zifSupported;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::: BOOKMARKS UTILITY FUNCTIONS :::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	getBookmarksURL : function () {
		if (Z.bookmarksGet) {
			var urlFull = window.location.href;
			var indexQS = urlFull.indexOf('?');
			if (indexQS != -1) {
				var urlBookmark = '';
				var indexX = -1, indexY = -1, indexZ = -1, indexR = -1;
				var initX = Z.imageW / 2, initY = Z.imageH / 2, initZ = -1, initR = 0;
				urlBookmark = urlFull.substring(indexQS + 1, urlFull.length);

				if (Z.tileSource != 'IIIFImageServer') {
					indexX = urlBookmark.indexOf('x=');
					indexY = urlBookmark.indexOf('y=');
					indexZ = urlBookmark.indexOf('z=');
					indexR = urlBookmark.indexOf('r=');
					if (indexR == -1) { indexR = urlBookmark.length + 1; }

					if (indexX != -1) { initX = parseFloat(urlBookmark.substring(indexX + 2, indexY - 1)); }
					if (indexY != -1) { initY = parseFloat(urlBookmark.substring(indexY + 2, indexZ - 1)); }
					if (indexZ != -1) { initZ = parseFloat(urlBookmark.substring(indexZ + 2, indexR - 1)); }
					if (indexR != urlBookmark.length + 1) { initR = parseFloat(urlBookmark.substring(indexR + 2, urlBookmark.length)); }

				} else {
					var iiifValues, regionValues, sizeValues, rotationValue;
					iiifValues = urlBookmark.split('/');
					for (var i = iiifValues.length - 1; i > -1; i--) {
						var iiifVal = iiifValues[i];
						if (iiifVal.indexOf(',') != -1) {
							rotationValue = parseInt(iiifValues[i+1], 10)
							if (isNaN(rotationValue) || rotationValue < 0 || rotationValue > 360) { rotationValue = 0; }
							sizeValues = iiifVal.split(',');
							regionValues = iiifValues[i-1].split(',');
							break;
						}
					}
					initX = Math.round(parseFloat(regionValues[0]) + parseFloat(regionValues[2]) / 2);
					initY = Math.round(parseFloat(regionValues[1]) + parseFloat(regionValues[3]) / 2);
					initZ = Math.round((parseFloat(sizeValues[0]) / parseFloat(regionValues[2])) * 100) / 100;
					initR = rotationValue;
				}
			}

			Z.initialX = initX;
			Z.initialY = initY;
			Z.initialZ = initZ;
			Z.initialR = initR;
		}
	},

	setBookmarksURL : function () {
		if (Z.bookmarksSet) {
			var iiifProtocol = (Z.tileSource == 'IIIFImageServer');
			var bookmarkString = Z.Viewport.getCoordinatesBookmark(null, iiifProtocol);
			window.history.pushState({id:'zBookmark'},'', bookmarkString);
		}
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::: USER LOGIN UTILITY FUNCTIONS :::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// If user list path provided load XML. If panel visible parameter true and user panel not yet created, create, and populate.
	// If login not yet presented, display require user entry. If list provided validate entry against list.
	enforceUserLogin : function (promptText, namesList) {
		var loginContinue = true;

		// Prevent prompts if cookie present.
		var userCookie = this.readCookie('zoomifyUserLogin');
		if (Z.Utils.stringValidate(userCookie)) {
			Z.Viewer.configureViewer();
			Z.userName = userCookie;
			Z.userInitials = Z.Utils.stringGetInitials(Z.userName);

			// If login as guest, add guest to user list as first item.
			if (Z.Utils.stringValidate(Z.userGuestPrompt) && Z.userName == Z.userGuestPrompt) {
				Z.userList.splice(0, 0, { name:Z.userGuestPrompt, id:'0', countCell:0, countImage:0 });
			}

			loginContinue = false;
		}

		// Load usernames if path provided and not yet loaded.
		if (Z.userPathProvided && (typeof namesList === 'undefined' || namesList === null)) {
			this.loadUsersXML();
			loginContinue = false;

			// Alternative implementation: Alert user to loading process.
			//Z.Utils.showMessage(Z.Utils.getResource('ALERT_LOADINGUSERLIST'), false, null, 'center', false, '5');
		}

		if (loginContinue) {
			if (!Z.Utils.stringValidate(Z.userName)) {
				if (typeof promptText === 'undefined' || !Z.Utils.stringValidate(Z.promptText)) {
					var promptNow = (Z.Utils.stringValidate(Z.userNamePrompt)) ? Z.userNamePrompt : Z.Utils.getResource('UI_USERNAMEPROMPT');
					promptText = promptNow;
				}
			} else if (Z.userName != Z.userGuestPrompt && (Z.Utils.stringValidate(Z.userName) && namesList && Z.Utils.arrayIndexOfObjectValue(namesList, 'name', Z.userName) == -1)) {
				var promptNow = (Z.Utils.stringValidate(Z.userNamePromptRetry)) ? Z.userNamePromptRetry : Z.Utils.getResource('UI_USERNAMEPROMPTRETRY');
				promptText = Z.Utils.getResource('UI_USERNAMEPROMPTRETRY');
			} else {
				promptText = 'complete';
			}

			if (promptText != 'complete') {
				Z.userName = prompt(promptText, Z.userGuestPrompt);
				Z.Utils.enforceUserLogin(Z.userName, namesList);

			} else {
				Z.Utils.hideMessage();
				Z.userInitials = Z.Utils.stringGetInitials(Z.userName);
				document.cookie = 'zoomifyUserLogin=' + Z.userName;

				// If login as guest, add guest to user list as first item.
				if (Z.Utils.stringValidate(Z.userGuestPrompt) && Z.userName == Z.userGuestPrompt) {
					Z.userList.splice(0, 0, { name:Z.userGuestPrompt, id:'0', countCell:0, countImage:0 });
				}

				Z.Viewer.configureViewer();
			}
		}
	},

	// Load approved list of user names for login validation and record stamping.
	loadUsersXML : function () {
		if (Z.Utils.stringValidate(Z.userPath)) {
			// Use zSimplePath parameter to avoid processing of users.xml path for integrated applications.
			if (!Z.simplePath) {
				if ((Z.userPath.toLowerCase().substring(Z.userPath.length - 5, Z.userPath.length) != '.json') && (Z.userPath.toLowerCase().substring(Z.userPath.length - 4, Z.userPath.length) != '.xml')) {
					Z.userPath = Z.userPath + '/' + Z.Utils.getResource('DEFAULT_USERXMLFILE');
				}
				dataPath = Z.Utils.cacheProofPath(Z.userPath);
			} else {
				dataPath = Z.userPath;
			}
		}
		if (typeof dataPath !== 'undefined' && Z.Utils.stringValidate(dataPath)) {
			var netConnector = new Z.NetConnector();
			if (dataPath.toLowerCase().indexOf('.xml') != -1) {
				netConnector.loadXML(dataPath);
			} else if (dataPath.toLowerCase().indexOf('.json') != -1) {
				netConnector.loadJSON(dataPath);
			}
		} else if (typeof Z.userXMLText === 'string' && Z.Utils.stringValidate(Z.userXMLText)) {
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(Z.userXMLText);
			this.parseUsersXML(xmlDoc);
		} else if (typeof Z.userJSONObject !== 'undefined' && typeof Z.userJSONObject === 'object' && Z.userJSONObject !== null) {
			var xmlText = Z.Utils.jsonConvertObjectToXMLText(Z.userJSONObject);
			var xmlDoc = Z.Utils.xmlConvertTextToDoc(xmlText);
			this.parseUsersXML(xmlDoc);
		}
	},

	parseUsersXML: function (xmlDoc) {
		Z.Viewer.setStatus('XMLParsedViewer', false);

		// Parse user setup values.
		var usersSetup = xmlDoc.getElementsByTagName('SETUP')[0];
		if (usersSetup) {
			if (Z.userPanelVisible != 0) { Z.userPanelPosition = usersSetup.getAttribute('PANELPOSITION'); }
			var guestPrompt = usersSetup.getAttribute('GUESTPROMPT');
			Z.userGuestPrompt = (typeof guestPrompt !== 'undefined' && Z.Utils.stringValidate(guestPrompt)) ? guestPrompt : '';
			if (!Z.Utils.stringValidate(Z.userNamePrompt)) { 
				var userNamePrompt = usersSetup.getAttribute('PROMPTTEXT');
				Z.userNamePrompt = (typeof userNamePrompt !== 'undefined' && Z.Utils.stringValidate(userNamePrompt)) ? userNamePrompt : '';
			}
			if (!Z.Utils.stringValidate(Z.userNamePromptRetry)) { 
				var userNamePromptRetry = usersSetup.getAttribute('PROMPTRETRYTEXT');
				Z.userNamePromptRetry = (typeof userNamePromptRetry !== 'undefined' && Z.Utils.stringValidate(userNamePromptRetry)) ? userNamePromptRetry : '';
			}
		}
		
		// Parse users for username list.
		var usersContainer = xmlDoc.getElementsByTagName('USERS')[0];
		if (usersContainer) {
			var users = usersContainer.getElementsByTagName('USER');
			for (var i = 0, j = users.length; i < j; i++) {
				var userNode = users[i];
				Z.userList[Z.userList.length] = { name:userNode.getAttribute('NAME'), id:userNode.getAttribute('ID'), countCell:0, countImage:0 };
			}
		}

		// Complete XML parsing.
		Z.Viewer.setStatus('XMLParsedViewer', true);

		if (typeof Z.userList !== 'undefined' && Z.userList.length > 0) {
			Z.Utils.hideMessage();
			this.enforceUserLogin(null, Z.userList);

			Z.Viewer.setStatus('usersLoadedViewer', true);
			Z.Utils.validateCallback('usersLoaded');

			// Create user panel.
			if (Z.userPanelVisible && Z.UserPanel === null) {
				if (Z.Viewer.getStatus('readyViewer')) {
					Z.Utils.createUserPanel(Z.userList);
				} else {
					Z.setCallback('readyViewer', function () {
						Z.Utils.createUserPanel(Z.userList);
					});
				}
			}
		}
	},

	createUserPanel : function (userList) {
		var userPanelDisplay = Z.Utils.createContainerElement('div', 'userPanelDisplay', 'inline-block', 'absolute', 'hidden', '1px', '1px', '1px', '1px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', 'default');
		Z.UserPanel = userPanelDisplay; // Global reference for rapid access.
		var upD = userPanelDisplay;
		var upS = upD.style;
		Z.ViewerDisplay.appendChild(userPanelDisplay);

		// Ensure proper z-ordering of Viewer elements.
		upS.zIndex = (Z.baseZIndex + 34).toString();

		// Create background.
		var userPanelBackground = Z.Utils.createContainerElement('div', 'userPanelBackground', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal');
		userPanelDisplay.appendChild(userPanelBackground);

		// Create placeholder content for lists.
		var listFontSize = parseInt(Z.Utils.getResource('DEFAULT_USERPANELLISTFONTSIZE'), 10);
		var placeHolderListText = Z.Utils.getResource('CONTENT_USERPLACEHOLDERLISTTEXT');
		var placeholderDP = [ { text:placeHolderListText, value:'0' } ];

		// Create scrollable container.
		if (typeof userCountainer === 'undefined' || userCountainer === null) {

			// Create text descriptions for six counter features: Add button (colored), Show checkbox, Name text (non-editable), Count, Count All, and List (instances filtered).
			var containerUserLabels = Z.Utils.createContainerElement('div', 'containerUserLabels', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			userPanelDisplay.appendChild(containerUserLabels);

			var labelNameTextBox = Z.Utils.createContainerElement('div', 'labelNameTextBox', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelNameTextNode = document.createTextNode(Z.Utils.getResource('UI_USERPANELLABELNAME'));
			labelNameTextBox.appendChild(labelNameTextNode);
			containerUserLabels.appendChild(labelNameTextBox);

			if (Z.tracking) {
				var labelCountPerUserTextBox = Z.Utils.createContainerElement('div', 'labelCountPerUserTextBox', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelCountPerUserTextNode = document.createTextNode(Z.Utils.getResource('UI_USERPANELLABELCOUNT'));
				labelCountPerUserTextBox.appendChild(labelCountPerUserTextNode);
				containerUserLabels.appendChild(labelCountPerUserTextBox);

				var labelUserCountersShowTextBox = Z.Utils.createContainerElement('div', 'labelUserCountersShowTextBox', 'inline-block', 'absolute', 'visible', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				var labelUserCountersShowTextNode = document.createTextNode(Z.Utils.getResource('UI_USERPANELLABELSHOW'));
				labelUserCountersShowTextBox.appendChild(labelUserCountersShowTextNode);
				containerUserLabels.appendChild(labelUserCountersShowTextBox);
			}

			// Set size and position variables.
			var rowColor = '#FFFFFF', rowH = 24, marginL = 6;
			var chkBxW = 20, chkBxH = 20, chkBxT = 1;
			var textW = 100, textH = 20, textT = 6, labelW = 34, adjLg = 4;
			var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_USERPANELLABELFONTSIZE'), 10);
			var dx = marginL, dy = 0;

			// Create scrollable container with row of elements for each user.
			containerUsers = Z.Utils.createContainerElement('div', 'containerUsers', 'inline-block', 'absolute', 'auto', '1px', '1px', '0px', '0px', 'solid', '1px', '#FFFFFF', '0px', '0px', 'nowrap', null, true);
			containerUsers.style.overflowX = 'hidden';
			userPanelDisplay.appendChild(containerUsers);

			// Add rows for each user.
			for (var i = 0, j = userList.length; i < j; i++) {

				var rowColor = (i % 2 == 0) ? '#F8F8F8' : '#FFFFFF';
				var rowContainer = Z.Utils.createContainerElement('div', 'rowContainer', 'inline-block', 'absolute', 'visible', '100%', rowH + 'px', '0px', dy + 'px', 'none', '0px', rowColor, '0px', '0px', 'nowrap', null, true);
				containerUsers.appendChild(rowContainer);

				var rowNameTextBox = 'rowNameTextBox' + i.toString();
				var rowNameTextNode = 'rowNameTextNode' + i.toString();
				rowContainer[rowNameTextBox] = Z.Utils.createContainerElement('div', rowNameTextBox, 'inline-block', 'absolute', 'visible', textW + 'px', textH + 'px', dx + 'px', textT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
				rowContainer[rowNameTextNode] = document.createTextNode(userList[i].name);
				rowContainer[rowNameTextBox].appendChild(rowContainer[rowNameTextNode]);
				rowContainer.appendChild(rowContainer[rowNameTextBox]);
				Z.Utils.setTextNodeStyle(rowContainer[rowNameTextBox], 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');

				if (Z.tracking) {
					dx += textW;
					var rowCountPerUserTextBox = 'rowCountPerUserTextBox' + i.toString();
					var rowCountPerUserTextNode = 'rowCountPerUserTextNode' + i.toString();
					rowContainer[rowCountPerUserTextBox] = Z.Utils.createContainerElement('div', rowCountPerUserTextBox, 'inline-block', 'absolute', 'visible', textW + 'px', textH + 'px', dx + 'px', textT + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
					var countImageStr = (userList[i].countImage !== null) ? userList[i].countImage : '0';
					rowContainer[rowCountPerUserTextNode] = document.createTextNode(countImageStr);
					rowContainer[rowCountPerUserTextBox].appendChild(rowContainer[rowCountPerUserTextNode]);
					rowContainer.appendChild(rowContainer[rowCountPerUserTextBox]);
					Z.Utils.setTextNodeStyle(rowContainer[rowCountPerUserTextBox], 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
					dx += labelW - adjLg;

					var checkboxUserCountersShowStr = 'checkboxUserCountersShow' + i.toString();
					rowContainer[checkboxUserCountersShowStr] = new Z.Utils.Checkbox(checkboxUserCountersShowStr, 'show', chkBxW + 'px', chkBxH + 'px', dx + 'px', chkBxT + 'px', 'click', Z.Toolbar.buttonEventsHandler, 'TIP_COUNTERTYPESHOW');
					rowContainer.appendChild(rowContainer[checkboxUserCountersShowStr]);
					var checkboxUserCountersShowInDOM = document.getElementById(checkboxUserCountersShowStr);
					checkboxUserCountersShowInDOM.checked = true;
				}

				dx = marginL;
				dy += rowH;
			}
		}

		Z.Utils.drawLayoutUserPanel();

		// DEV NOTE: This prevents drag selection from panel over hotspots, but not if cursor is in list or text
		// region in panel. Preventing default on container not helpful, because disables list and text editing.
		Z.Utils.addEventListener(userPanelBackground, 'mousedown', Z.Utils.preventDefault);
	},

	drawLayoutUserPanel : function () {
		// Size and position panel.
		var panelW = parseInt(Z.Utils.getResource('DEFAULT_USERPANELWIDTH'), 10);
		var panelH = parseInt(Z.Utils.getResource('DEFAULT_USERPANELHEIGHT'), 10);
		var panelCoords = Z.Utils.calculateUserPanelCoords(Z.userPanelPosition, panelW, panelH, Z.viewerW, Z.viewerH);
		var upS = Z.UserPanel.style;
		Z.Utils.sizeAndPositionUserPanel(upS, panelW, panelH, panelCoords.x, panelCoords.y);
		Z.userPanelVisibleState = (Z.userPanelVisible && Z.userPanelPosition != '0');
		upS.display = (Z.userPanelVisibleState) ? 'inline-block' : 'none';

		var backAlpha = parseFloat(Z.Utils.getResource('DEFAULT_BACKGROUNDALPHA'));
		var backColor = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLOR');
		var backColorNoAlpha = Z.Utils.getResource('DEFAULT_BACKGROUNDCOLORNOALPHA');
		var labelW = parseInt(Z.Utils.getResource('DEFAULT_USERLABELWIDTH'), 10);
		var labelH = 15;
		var labelFontSize = parseInt(Z.Utils.getResource('DEFAULT_USERPANELLABELFONTSIZE'), 10);
		var rowGap = labelH * 0.5;
		var adjSm = 1;
		var adjLg = 4;
		var marginEdgeL = 8;
		var marginEdgeT = 8;
		var containerUserW = (panelW - marginEdgeL * 2 - adjSm * 2);
		var containerUserH = (panelH - marginEdgeT * 4 - adjLg);

		// Draw background.
		var uPBG = document.getElementById('userPanelBackground');
		if (uPBG) {
			var upbgS = uPBG.style;
			upbgS.width = panelW + 'px';
			upbgS.height = panelH + 'px';
			upbgS.backgroundColor = backColor;
			Z.Utils.setOpacity(uPBG, backAlpha, backColorNoAlpha);
		}

		dx = marginEdgeL + adjLg;
		var cUL = document.getElementById('containerUserLabels');
		if (cUL) {
			var culS = cUL.style;
			culS.width = panelW + 'px';
			culS.height = labelH + 'px';
			culS.left = dx + 'px';
			culS.top = (marginEdgeT - adjSm) + 'px';
			culS.visibility = 'visible';
			Z.Utils.setTextNodeStyle(cUL.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
		}
		dx = 0;
		var lNTB = document.getElementById('labelNameTextBox');
		if (lNTB) {
			var lntbS = lNTB.style;
			lntbS.width = labelW + 'px';
			lntbS.height = labelH + 'px';
			lntbS.left = '0px'
			lntbS.top = '0px'
			Z.Utils.setTextNodeStyle(lNTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW * 1.5;
		}
		var lCPUTB = document.getElementById('labelCountPerUserTextBox');
		if (lCPUTB) {
			var lcputbS = lCPUTB.style;
			lcputbS.width = labelW + 'px';
			lcputbS.height = labelH + 'px';
			lcputbS.left = dx + 'px';
			lcputbS.top = '0px'
			Z.Utils.setTextNodeStyle(lCPUTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW - adjLg;
		}
		var lUCSTB = document.getElementById('labelUserCountersShowTextBox');
		if (lUCSTB) {
			var lucstbS = lUCSTB.style;
			lucstbS.width = labelW + 'px';
			lucstbS.height = labelH + 'px';
			lucstbS.left = dx + 'px';
			lucstbS.top = '0px'
			Z.Utils.setTextNodeStyle(lUCSTB.firstChild, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			dx += labelW - adjLg * 3;
		}

		dy = (marginEdgeT * 3);
		var cUSR = document.getElementById('containerUsers');
		if (cUSR) {
			var cusrS = cUSR.style;
			cusrS.width = containerUserW + 'px';
			cusrS.height = containerUserH + 'px';
			cusrS.left = marginEdgeL + 'px';
			cusrS.top = dy + 'px';
			cUSR.size = 6;
		}
	},

	calculateUserPanelCoords : function (position, userPanelW, userPanelH, viewerW, viewerH) {
		// User panel positioning: 0 hides, 1 top left, 2 top-right, 3 bottom right, 4 bottom left
		// Note that viewerH  allows for toolbar height if static in viewer display area, but annotationPanelH
		// requires additional adjustment to Y position of panel if position is at bottom of viewer.
		var panelX, panelY;
		if (Z.userPanelVisible === null) {
			panelX = -1000;
			panelY = -1000;
		} else {
			var margin = 15;
			switch (position) {
				case '0':
					panelX = -1000;
					panelY = -1000;
					break;
				case '1':
					panelX = Z.navigatorL;
					panelY = Z.navigatorT + Z.navigatorH + Z.rulerH + 2;
					break;
				case '2':
					panelX = viewerW - userPanelW - margin;
					panelY = margin;
					if (Z.trackingPanelPosition == 2) { panelY += 170; }
					break;
				case '3':
					panelX = viewerW - userPanelW - margin;
					if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
						panelY = viewerH - userPanelH - margin;
					} else {
						panelY = viewerH - margin;
					}
					break;
				case '4':
					panelX = margin;
					if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
						panelY = viewerH - userPanelH - margin;
					} else {
						panelY = viewerH - margin;
					}
					break;
				default:
					panelX = viewerW - userPanelW - margin;
					panelY = margin;
			}
		}
		return new Z.Utils.Point(panelX, panelY);
	},

	sizeAndPositionUserPanel : function (panel, width, height, left, top) {
		if (typeof width !== 'undefined' && width !== null) { panel.width = width + 'px'; }
		if (typeof height !== 'undefined' && height !== null) { panel.height = height + 'px'; }
		if (typeof left !== 'undefined' && left !== null) { panel.left = left + 'px'; }
		if (typeof top !== 'undefined' && top !== null) { panel.top = top + 'px'; }
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::: COPYRIGHT UTILITY FUNCTIONS :::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	enforceCopyright : function () {
		// Test whether copyright has already been presented, and if not, load and display text and require user OK.
		var copyrightCookieExists = this.readCookie('zoomifyImageCopyright')
		if (copyrightCookieExists) {
			Z.Viewer.configureViewer();
		} else {
			this.loadCopyrightText();
		}
	},

	loadCopyrightText : function () {
		// Load copyright XML for text to display.
		var netConnector = new Z.NetConnector();
		netConnector.loadXML(Z.copyrightPath);
	},

	showCopyright : function (cStateTxt, cDecTxt) {
		// Display copyright text and, if confirmed, create cookie to prevent re-display during the current browser session.
		var scrnColor = this.getResource('DEFAULT_COPYRIGHTSCREENCOLOR');
		var btnColor = this.getResource('DEFAULT_COPYRIGHTBUTTONCOLOR');

		Z.CopyrightDisplay = this.createContainerElement('div', 'CopyrightDisplay', 'inline-block', 'absolute', 'hidden', (Z.viewerW - 2) + 'px', (Z.viewerH - 2) + 'px', '0px', '0px', 'solid', '1px', scrnColor, '0px', '0px', 'normal', null, true);
		Z.ViewerDisplay.appendChild(Z.CopyrightDisplay);

		// Ensure proper z-ordering of Viewer elements.
		Z.CopyrightDisplay.style.zIndex = (Z.baseZIndex + 36).toString();


		// Create centered container for text.
		var textBoxW = 440;
		var textBoxH = 200;
		var textBoxLeft = (parseFloat(Z.CopyrightDisplay.style.width) / 2) - (textBoxW / 2);
		var textBoxTop = (parseFloat(Z.CopyrightDisplay.style.height) / 2) - (textBoxH / 2);
		var textBox = this.createContainerElement('div', 'textBox', 'inline-block', 'absolute', 'hidden', textBoxW + 'px', textBoxH + 'px', textBoxLeft + 'px', textBoxTop + 'px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
		textBox.id='textBox';
		Z.CopyrightDisplay.appendChild(textBox);

		// Create text node and add text from xml file.
		var copyrightTextNode = document.createTextNode(cStateTxt);
		textBox.appendChild(this.createCenteredElement(copyrightTextNode, 'copyrightTextNode'));
		this.setTextNodeStyle(copyrightTextNode, 'black', 'verdana', '16px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'justify', 'none');

		// Add hidden text node to store decline text for Exit condition.
		var declinedTextContainer = this.createContainerElement('div', 'declinedTextContainer', 'hidden', 'absolute', 'hidden', '0px', '0px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'normal', null, true);
		var declinedTextNode = document.createTextNode(cDecTxt);
		declinedTextContainer.appendChild(declinedTextNode);
		textBox.appendChild(declinedTextContainer);

		var btnW = 80;
		var btnH = 20;
		var dvdrW = 30;
		var dvdrH = 20;

		var btnL = textBoxLeft + (textBoxW / 2) - ((btnW * 2 + dvdrW) / 2);
		var btnT = textBoxTop + textBoxH + dvdrH;
		var btnTxt = this.getResource('UI_COPYRIGHTAGREEBUTTONTEXT');
		var buttonAgree = new Z.Utils.Button('buttonAgree', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', this.copyrightAgreeButtonHandler, 'TIP_COPYRIGHTAGREE', 'solid', '1px', btnColor, '0px', '0px');
		Z.CopyrightDisplay.appendChild(buttonAgree.elmt);

		btnL += btnW + dvdrW;
		btnTxt = this.getResource('UI_COPYRIGHTEXITBUTTONTEXT');
		var buttonExit = new Z.Utils.Button('buttonExit', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', this.copyrightExitButtonHandler, 'TIP_COPYRIGHTEXIT', 'solid', '1px', btnColor, '0px', '0px');
		Z.CopyrightDisplay.appendChild(buttonExit.elmt);
	},

	hideCopyright : function () {
		// Option 1: Change text to remind user they have declined copyright agreement.
		var copyrightTextNode = document.getElementById('copyrightTextNode').firstChild;
		var declinedText = document.getElementById('declinedTextContainer').firstChild.nodeValue;
		copyrightTextNode.nodeValue = declinedText;

		// Option 2: remove text field. Combine this with code to leave page or other custom steps.
		//var textBox = document.getElementById('textBox');
		// Z.CopyrightDisplay.removeChild(textBox);

		var buttonAgree = document.getElementById('buttonAgree');
		Z.Utils.removeEventListener(buttonAgree, 'mousedown', this.copyrightAgreeButtonHandler);
		Z.CopyrightDisplay.removeChild(buttonAgree);

		var buttonExit = document.getElementById('buttonExit');
		Z.Utils.removeEventListener(buttonExit, 'mousedown', this.copyrightExitButtonHandler);
		Z.CopyrightDisplay.removeChild(buttonExit);
	},

	copyrightAgreeButtonHandler : function (event) {
		Z.ViewerDisplay.removeChild(Z.CopyrightDisplay);
		document.cookie = 'zoomifyImageCopyright=confirmed';
		Z.Viewer.configureViewer();
	},

	copyrightExitButtonHandler : function (event) {
		// DEV NOTE: Insert preferred alternative action here, for example return to site Terms Of Use page or homepage.
		Z.Utils.hideCopyright();
		return;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::: PARAMETER & RESOURCE UTILITY FUNCTIONS ::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	parseParametersXML : function (xmlDoc) {
		Z.xmlParametersParsing = false;
		var optionalParams = '';
		var embedRoot = xmlDoc.getElementsByTagName('ZOOMIFY')[0];

		// Get image path values and apply.
		zImagePath = embedRoot.getAttribute('IMAGEPATH');
		zImagePath2 = embedRoot.getAttribute('IMAGEPATH2');
		if (typeof zImagePath !== 'undefined' && Z.Utils.stringValidate(zImagePath)) { Z.imagePath = zImagePath; }
		if (typeof zImagePath2 !== 'undefined' && Z.Utils.stringValidate(zImagePath2)) { Z.imagePath2 = zImagePath2; }

		// Get values with standard parameter names.
		var parameterListTextArray = Z.Utils.getResource('DEFAULT_PARAMETERLISTTEXT').split(',');
		for (var i = 0, j = parameterListTextArray.length; i < j; i++) {
			var pName = parameterListTextArray[i];
			var pNameBase = Z.Utils.stringLowerCaseFirstLetter(pName.substr(1));
			var pAttribName = pNameBase.toUpperCase();
			var pVal = embedRoot.getAttribute(pAttribName);
			if (typeof pVal !== 'undefined' && Z.Utils.stringValidate(pVal)) {
				optionalParams += pName + '=' + pVal + '&';
			}
		}

		// Get values with legacy names.
		var legacyVal = embedRoot.getAttribute('FULLPAGEINITIAL');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zInitialFullPage=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('TOOLBARSKINXMLPATH');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zSkinPath=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('TOOLBARTOOLTIPS');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zTooltipsVisible=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('SHOWTOOLTIPS');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zTooltipsVisible=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('WATERMARKMEDIA');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zWatermarkPath=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('SLIDESXMLPATH');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zSlidePath=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('HOTSPOTSXMLPATH');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zHotspotPath=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('ANNOTATIONSXMLPATH');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zAnnotationPath=' + legacyVal + '&'; }
		var legacyVal = embedRoot.getAttribute('SAVETOFILE');
		if (typeof legacyVal !== 'undefined' && Z.Utils.stringValidate(legacyVal)) { optionalParams += 'zSaveImageHandlerPath=' + legacyVal + '&'; }

		// Process optional parameters.
		optionalParams = (optionalParams.slice(-1, optionalParams.length) == '&') ? optionalParams.slice(0, optionalParams.length - 1) : optionalParams;
		var optionalParamsUnescaped = unescape(optionalParams);
		var optionalParamsFullyUnescaped = Z.Utils.stringUnescapeAmpersandCharacters(optionalParamsUnescaped);
		Z.Utils.arrayClear(Z.parameters);
		Z.parameters = Z.Utils.parseParameters(optionalParamsFullyUnescaped);
		Z.initialize();
	},

	parseParameters : function (params) {
		var parsedParams = [];
		if (typeof params === 'object') {
			parsedParams = params;
		} else if (typeof params === 'string') {
			var splitParams = params.split('&');
			for (var i = 0, j = splitParams.length; i < j; i++) {
				var nameValuePair = splitParams[i];
				var sep = nameValuePair.indexOf('=');
				if (sep > 0) {
					var pName = nameValuePair.substring(0, sep)
					var pValue = nameValuePair.substring(sep + 1)
					parsedParams[pName] = pValue;
				}
			}
		}
		return parsedParams;
	},

	parametersToDelimitedString : function (params, delimiter) {
		var outputString = '';
		for (var pName in params) {
			outputString += pName + '=' + params[pName].toString() + delimiter;
		}
		outputString = outputString.slice(0, - 1);
		return outputString;
	},

	setParameters : function (params) {
		var expressParamsEnableTest = this.getResource('DEFAULT_EXPRESSPARAMETERSENABLETEST');
		var expressParamsDisableValue = this.getResource('DEFAULT_EXPRESSPARAMETERSDISABLEVALUE');
		var expressParamsDisabledAlert = this.getResource('DEFAULT_EXPRESSPARAMETERSDISABLEDALERT');
		Z.expressParamsEnabled = (expressParamsEnableTest != expressParamsDisableValue) ? true : false;
		if (!Z.expressParamsEnabled) {
			Z.toolbarInternal = true;
			Z.logoLinkURL = Z.Utils.getResource('UI_LOGOLINK');
		}

		var proParamsEnableTest = this.getResource('DEFAULT_PROPARAMETERSENABLETEST');
		var proParamsDisableValue = this.getResource('DEFAULT_PROPARAMETERSDISABLEVALUE');
		var proParamsDisabledAlert = this.getResource('DEFAULT_PROPARAMETERSDISABLEDALERT');
		Z.proParamsEnabled = (proParamsEnableTest != proParamsDisableValue) ? true : false;

		var specialStorageEnableTest = this.getResource('DEFAULT_SPECIALSTORAGESUPPORTENABLETEST');
		var specialStorageDisableValue = this.getResource('DEFAULT_SPECIALSTORAGESUPPORTDISABLEVALUE');
		var specialStorageDisabledAlert = this.getResource('DEFAULT_SPECIALSTORAGESUPPORTDISABLEDALERT');
		Z.specialStorageEnabled = (specialStorageEnableTest != specialStorageDisableValue) ? true : false;

		var enterpriseParamsEnableTest = this.getResource('DEFAULT_ENTERPRISEPARAMETERSENABLETEST');
		var enterpriseParamsDisableValue = this.getResource('DEFAULT_ENTERPRISEPARAMETERSDISABLEVALUE');
		var enterpriseParamsDisabledAlert = this.getResource('DEFAULT_ENTERPRISEPARAMETERSDISABLEDALERT');
		Z.enterpriseParamsEnabled = (enterpriseParamsEnableTest != enterpriseParamsDisableValue) ? true : false;

		Z.skinPath = this.getResource('DEFAULT_SKINXMLPATH');
		Z.skinMode = this.getResource('DEFAULT_SKINMODE');

		if (!isNaN(parseFloat(this.getResource('DEFAULT_INITIALX')))) { Z.initialX = parseFloat(this.getResource('DEFAULT_INITIALX')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_INITIALY')))) { Z.initialY = parseFloat(this.getResource('DEFAULT_INITIALY')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_INITIALZOOM')))) { Z.initialZ = parseFloat(this.getResource('DEFAULT_INITIALZOOM')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_MINZOOM')))) { Z.minZ = parseFloat(this.getResource('DEFAULT_MINZOOM')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_MAXZOOM')))) { Z.maxZ = parseFloat(this.getResource('DEFAULT_MAXZOOM')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_ZOOMSPEED')))) { Z.zoomSpeed = parseFloat(this.getResource('DEFAULT_ZOOMSPEED')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_PANSPEED')))) { Z.panSpeed = parseFloat(this.getResource('DEFAULT_PANSPEED')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_FADEINSPEED')))) { Z.fadeInSpeed = parseFloat(this.getResource('DEFAULT_FADEINSPEED')); }
		Z.fadeIn = (Z.fadeInSpeed > 0);

		Z.navigatorVisible = parseInt(this.getResource('DEFAULT_NAVIGATORVISIBLE'), 10);
		if (Z.navigatorW === null) { Z.navigatorW = parseInt(this.getResource('DEFAULT_NAVIGATORWIDTH'), 10); }
		if (Z.navigatorH === null) { Z.navigatorH = parseInt(this.getResource('DEFAULT_NAVIGATORHEIGHT'), 10); }
		if (Z.navigatorL === null) { Z.navigatorL = parseInt(this.getResource('DEFAULT_NAVIGATORLEFT'), 10); }
		if (Z.navigatorT === null) { Z.navigatorT = parseInt(this.getResource('DEFAULT_NAVIGATORTOP'), 10); }
		if (Z.navigatorFit === null) { Z.navigatorFit = this.getResource('DEFAULT_NAVIGATORFIT'); }
		if (Z.navigatorRectangleColor === null) { Z.navigatorRectangleColor = this.getResource('DEFAULT_NAVIGATORRECTANGLECOLOR'); }

		Z.galleryVisible = parseInt(this.getResource('DEFAULT_GALLERYVISIBLE'), 10);
		Z.galleryAutoShowHide = (Z.galleryVisible == 2);
		Z.galleryW = parseInt(this.getResource('DEFAULT_GALLERYWIDTH'), 10);
		Z.galleryH = parseInt(this.getResource('DEFAULT_GALLERYHEIGHT'), 10);
		Z.galleryM = parseInt(this.getResource('DEFAULT_GALLERYMARGIN'), 10);
		Z.galleryL = parseInt(this.getResource('DEFAULT_GALLERYLEFT'), 10);
		Z.galleryT = parseInt(this.getResource('DEFAULT_GALLERYTOP'), 10);
		Z.galleryPosition = parseFloat(this.getResource('DEFAULT_GALLERYPOSITION'));
		Z.galleryRectangleColor = this.getResource('DEFAULT_GALLERYRECTANGLECOLOR');

		Z.clickZoom = (this.getResource('DEFAULT_CLICKZOOM') != '0');
		Z.doubleClickZoom = (this.getResource('DEFAULT_DOUBLECLICKZOOM') != '0');
		Z.doubleClickDelay = parseFloat(this.getResource('DEFAULT_DOUBLECLICKDELAY'));
		Z.clickPan = (this.getResource('DEFAULT_CLICKPAN') != '0');
		Z.mousePan = (this.getResource('DEFAULT_MOUSEPAN') != '0');
		Z.constrainPan = (this.getResource('DEFAULT_CONSTRAINPAN') != '0');
		Z.constrainPanLimit = parseInt(this.getResource('DEFAULT_CONSTRAINPANLIMIT'), 10);
		Z.constrainPanStrict = (this.getResource('DEFAULT_CONSTRAINPANSTRICT') != '0');
		Z.panBuffer = parseFloat(this.getResource('DEFAULT_PANBUFFER'));
		Z.smoothPan = (Z.useCanvas && !Z.comparison && this.getResource('DEFAULT_SMOOTHPAN') != '0');
		Z.smoothPanEasing = parseInt(this.getResource('DEFAULT_SMOOTHPANEASING'), 10);
		Z.smoothPanGlide = parseInt(this.getResource('DEFAULT_SMOOTHPANGLIDE'), 10);
		Z.smoothZoom = (this.getResource('DEFAULT_SMOOTHZOOM') != '0');
		Z.smoothZoomEasing = parseInt(this.getResource('DEFAULT_SMOOTHZOOMEASING'), 10);

		Z.keys = (this.getResource('DEFAULT_KEYS') != '0');
		Z.canvas = (this.getResource('DEFAULT_CANVAS') != '0');
		Z.baseZIndex = parseInt(this.getResource('DEFAULT_BASEZINDEX'), 10);
		Z.debug = parseInt(this.getResource('DEFAULT_DEBUG'), 10);

		Z.toolbarVisible = parseInt(this.getResource('DEFAULT_TOOLBARVISIBLE'), 10);
		Z.toolbarAutoShowHide = (Z.toolbarVisible != 0 && Z.toolbarVisible != 1 && Z.toolbarVisible != 6 && Z.toolbarVisible != 7 && Z.toolbarVisible != 8);
		Z.toolbarPosition = parseFloat(this.getResource('DEFAULT_TOOLBARPOSITION'));
		Z.logoVisible = (this.getResource('DEFAULT_LOGOVISIBLE') != '0');
		Z.logoCustomPath = this.getResource('DEFAULT_LOGOCUSTOMPATH');
		Z.minimizeVisible = (this.getResource('DEFAULT_MINIMIZEVISIBLE') != '0');
		Z.sliderZoomVisible = (this.getResource('DEFAULT_SLIDERZOOMVISIBLE') != '0');
		Z.mouseWheel = parseInt(this.getResource('DEFAULT_MOUSEWHEEL'), 10);

		Z.zoomButtonsVisible = (this.getResource('DEFAULT_ZOOMBUTTONSVISIBLE') != '0');
		Z.panButtonsVisible = (this.getResource('DEFAULT_PANBUTTONSVISIBLE') != '0');
		Z.resetVisible = (this.getResource('DEFAULT_RESETVISIBLE') != '0');
		Z.tooltipsVisible = (this.getResource('DEFAULT_TOOLTIPSVISIBLE') != '0');

		Z.helpVisible = parseInt(this.getResource('DEFAULT_HELPVISIBLE'), 10);
		Z.helpW = parseInt(this.getResource('UI_HELPDISPLAYWIDTH'), 10);
		Z.helpH = parseInt(this.getResource('UI_HELPDISPLAYHEIGHT'), 10);

		Z.progressVisible = (this.getResource('DEFAULT_PROGRESSVISIBLE') != '0');
		Z.messagesVisible = (this.getResource('DEFAULT_MESSAGESVISIBLE') != '0');

		Z.fullViewVisible = (this.getResource('DEFAULT_FULLVIEWVISIBLE') != '0');
		Z.fullScreenVisible = (this.getResource('DEFAULT_FULLSCREENVISIBLE') != '0');
		Z.fullPageVisible = (this.getResource('DEFAULT_FULLPAGEVISIBLE') != '0');
		Z.initialFullPage = (this.getResource('DEFAULT_INITIALFULLPAGE') != '0');

		if (Z.bookmarksGet === null) { Z.bookmarksGet = (this.getResource('DEFAULT_BOOKMARKSGET') != '0'); }
		if (Z.bookmarksSet === null) { Z.bookmarksSet = (this.getResource('DEFAULT_BOOKMARKSSET') != '0'); }

		Z.measureVisible = (this.getResource('DEFAULT_MEASUREVISIBLE') != '0');
		Z.rotationVisible = (this.getResource('DEFAULT_ROTATIONVISIBLE') != '0');
		Z.rotationFree = (this.getResource('DEFAULT_ROTATIONFREE') != '0');
		Z.initialR = this.getResource('DEFAULT_INITIALR');

		if (!isNaN(parseFloat(this.getResource('DEFAULT_SCREENSAVERSPEED')))) { Z.screensaverSpeed = parseFloat(this.getResource('DEFAULT_SCREENSAVERSPEED')); }

		if (!isNaN(parseFloat(this.getResource('DEFAULT_MASKFADESPEED')))) { Z.maskFadeSpeed = parseFloat(this.getResource('DEFAULT_MASKFADESPEED')); }
		Z.maskClearOnUserAction = (this.getResource('DEFAULT_MASKCLEARONUSERACTION') != '0');

		Z.units = this.getResource('DEFAULT_UNITS');
		Z.sourceMagnification = parseInt(this.getResource('DEFAULT_SOURCEMAGNIFICATION'), 10);

		if (Z.virtualPointerVisible === null) { Z.virtualPointerVisible = (this.getResource('DEFAULT_VIRTUALPOINTERVISIBLE') != '0'); }
		if (Z.crosshairsVisible === null) { Z.crosshairsVisible = (this.getResource('DEFAULT_CROSSHAIRSVISIBLE') != '0'); }
		if (Z.zoomRectangle === null) { Z.zoomRectangle = (this.getResource('DEFAULT_ZOOMRECTANGLE') != '0'); }

		if (Z.rulerVisible === null) { Z.rulerVisible = parseInt(this.getResource('DEFAULT_RULERVISIBLE'), 10); }
		if (Z.rulerListType === null) { Z.rulerListType = this.getResource('DEFAULT_RULERLISTTYPE'); }
		if (Z.rulerW === null) { Z.rulerW = parseInt(this.getResource('DEFAULT_RULERWIDTH'), 10); }
		if (Z.rulerH === null) { Z.rulerH = parseInt(this.getResource('DEFAULT_RULERHEIGHT'), 10); }
		if (Z.rulerL === null) { Z.rulerL = parseInt(this.getResource('DEFAULT_RULERLEFT'), 10); }
		if (Z.rulerT === null) { Z.rulerT = parseInt(this.getResource('DEFAULT_RULERTOP'), 10); }

		if (!isNaN(parseFloat(this.getResource('DEFAULT_SLIDETRANSITIONSPEED')))) { Z.slideTransitionSpeed = parseFloat(this.getResource('DEFAULT_SLIDETRANSITIONSPEED')); }

		if (Z.coordinatesVisible === null) { Z.coordinatesVisible = (this.getResource('DEFAULT_COORDINATESVISIBLE') != '0'); }

		if (Z.geoCoordinatesVisible === null) { Z.geoCoordinatesVisible = (this.getResource('DEFAULT_GEOCOORDINATESVISIBLE') != '0'); }

		if (Z.preloadVisible === null) { Z.preloadVisible = (this.getResource('DEFAULT_PRELOADVISIBLE') != '0'); }

		Z.saveImageFull = (this.getResource('DEFAULT_SAVEIMAGEFULL') != '0');
		Z.saveImageFilename = this.getResource('DEFAULT_SAVEIMAGEFILENAME');
		Z.saveImageFormat = this.getResource('DEFAULT_SAVEIMAGEFORMAT');
		Z.saveImageCompression = parseFloat(this.getResource('DEFAULT_SAVEIMAGECOMPRESSION'));

		var dB, dbS, dbsBGC, pageContainer, pcS, pcsBGC;
		dB = document.body;
		if (dB) {
			dbS = document.body.style;
			dbsBGC = dbS.backgroundColor
		}
		pageContainer = document.getElementById(Z.pageContainerID);
		if (pageContainer) {
			pcS = Z.Utils.getElementStyle(pageContainer);
			pcsBGC = pcS.backgroundColor
		}

		if (Z.imageFilters === null) { Z.imageFilters = (this.getResource('DEFAULT_IMAGEFILTERS') != '0'); }
		Z.initialImageFilters = (this.getResource('DEFAULT_INITIALMAGEFILTERS') != '0');
		Z.brightnessVisible = (this.getResource('DEFAULT_BRIGHTNESSVISIBLE') != '0');
		Z.contrastVisible = (this.getResource('DEFAULT_CONTRASTVISIBLE') != '0');
		Z.sharpnessVisible = (this.getResource('DEFAULT_SHARPNESSVISIBLE') != '0');
		Z.blurrinessVisible = (this.getResource('DEFAULT_BLURRINESSVISIBLE') != '0');
		Z.colorRedVisible = (this.getResource('DEFAULT_COLORREDVISIBLE') != '0');
		Z.colorGreenVisible = (this.getResource('DEFAULT_COLORGREENVISIBLE') != '0');
		Z.colorBlueVisible = (this.getResource('DEFAULT_COLORBLUEVISIBLE') != '0');
		Z.colorRedRangeVisible = (this.getResource('DEFAULT_COLORREDRANGEVISIBLE') != '0');
		Z.colorGreenRangeVisible = (this.getResource('DEFAULT_COLORGREENRANGEVISIBLE') != '0');
		Z.colorBlueRangeVisible = (this.getResource('DEFAULT_COLORBLUERANGEVISIBLE') != '0');
		Z.gammaVisible = (this.getResource('DEFAULT_GAMMAVISIBLE') != '0');
		Z.gammaRedVisible = (this.getResource('DEFAULT_GAMMAREDVISIBLE') != '0');
		Z.gammaGreenVisible = (this.getResource('DEFAULT_GAMMAGREENVISIBLE') != '0');
		Z.gammaBlueVisible = (this.getResource('DEFAULT_GAMMABLUEVISIBLE') != '0');
		Z.hueVisible = (this.getResource('DEFAULT_HUEVISIBLE') != '0');
		Z.saturationVisible = (this.getResource('DEFAULT_SATURATIONVISIBLE') != '0');
		Z.lightnessVisible = (this.getResource('DEFAULT_LIGHTNESSVISIBLE') != '0');
		Z.whiteBalanceVisible = (this.getResource('DEFAULT_WHITEBALANCEVISIBLE') != '0');
		Z.normalizeVisible = (this.getResource('DEFAULT_NORMALIZEVISIBLE') != '0');
		Z.equalizeVisible = (this.getResource('DEFAULT_EQUALIZEVISIBLE') != '0');
		Z.noiseVisible = (this.getResource('DEFAULT_NOISEVISIBLE') != '0');
		Z.grayscaleVisible = (this.getResource('DEFAULT_GRAYSCALEVISIBLE') != '0');
		Z.thresholdVisible = (this.getResource('DEFAULT_THRESHOLDVISIBLE') != '0');
		Z.inversionVisible = (this.getResource('DEFAULT_INVERSIONVISIBLE') != '0');
		Z.edgesVisible = (this.getResource('DEFAULT_EDGESVISIBLE') != '0');
		Z.sepiaVisible = (this.getResource('DEFAULT_SEPIAVISIBLE') != '0');

		Z.freehandVisible = (this.getResource('DEFAULT_FREEHANDVISIBLE') != '0');
		Z.textVisible = (this.getResource('DEFAULT_TEXTVISIBLE') != '0');
		Z.iconVisible = (this.getResource('DEFAULT_ICONVISIBLE') != '0');
		Z.rectangleVisible = (this.getResource('DEFAULT_RECTANGLEVISIBLE') != '0');
		Z.polygonVisible = (this.getResource('DEFAULT_POLYGONVISIBLE') != '0');
		Z.annotationPanelVisible = parseInt(this.getResource('DEFAULT_ANNOTATIONPANELVISIBLE'), 10);
		Z.labelIconsInternal = (this.getResource('DEFAULT_LABELICONSINTERNAL') != '0');
		Z.annotationsAddMultiple = (this.getResource('DEFAULT_ANNOTATIONSADDMULTIPLE') != '0');
		Z.annotationsAutoSave = (this.getResource('DEFAULT_ANNOTATIONSAUTOSAVE') != '0');
		Z.saveButtonVisible = (this.getResource('DEFAULT_ANNOTATIONSAVEBUTTONVISIBLE') != '0');
		Z.labelClickSelect = (this.getResource('DEFAULT_LABELCLICKSELECT') != '0');
		
		if (Z.userPanelVisible === null) { Z.userPanelVisible = this.getResource('DEFAULT_USERPANELVISIBLE'); }
		if (Z.userNamePrompt) { Z.userNamePrompt = Z.Utils.getResource('UI_USERNAMEPROMPT'); }
		if (Z.userNamePromptRetry) { Z.userNamePromptRetry = Z.Utils.getResource('UI_USERNAMEPROMPTRETRY'); }
		
		Z.trackingPanelVisible = parseInt(this.getResource('DEFAULT_TRACKINGPANELVISIBLE'), 10);
		Z.initialTrackingOverlayVisible = parseInt(this.getResource('DEFAULT_INITIALTRACKINGOVERLAYVISIBLE'), 10);
		
		Z.focal = parseInt(this.getResource('DEFAULT_FOCAL'), 10);
		Z.quality = parseInt(this.getResource('DEFAULT_QUALITY'), 10);

		Z.saveImageBackColor = (Z.Utils.stringValidate(pcsBGC) && pcsBGC != 'transparent') ? pcsBGC : (Z.Utils.stringValidate(dbsBGC) && dbsBGC != 'transparent') ? dbsBGC : Z.Utils.getResource('DEFAULT_SAVEIMAGEBACKCOLOR');

		Z.sliderImageSetVisible = (this.getResource('DEFAULT_IMAGESETSLIDERVISIBLE') != '0');
		if (typeof params === 'object' && params !== null) {
			var unrecognizedParamAlert = this.getResource('ERROR_UNRECOGNIZEDPARAMETERALERT');

			// Test for hotspot or annotation path and save handler path before allow setting of markup or annotation mode below.
			Z.annotationPathProvided = (params['zHotspotPath'] !== undefined || params['zAnnotationPath'] !== undefined || params['zAnnotationXMLText'] !== undefined || params['zAnnotationJSONObject'] !== undefined);
			Z.saveHandlerProvided = (params['zSaveHandlerPath'] !== undefined || (params['zNoPost'] !== undefined && params['zNoPost'] == '1'));
			Z.imageSetPathProvided = (params['zAnimationPath'] !== undefined || params['zSlidestackPath'] !== undefined);
			Z.saveImageHandlerProvided = (params['zSaveImageHandlerPath'] !== undefined);
			Z.mouseWheelParmeterProvided = (params['zMouseWheel'] !== undefined);
			Z.trackingPathProvided = (params['zTrackingPath'] !== undefined || params['zTrackingXMLText'] !== undefined || params['zTrackingJSONObject'] !== undefined);
			Z.userPathProvided = (params['zUserPath'] !== undefined || params['zUserXMLText'] !== undefined || params['zUserJSONObject'] !== undefined);

			// Also test for slide path to enable test for impacts of Prototype.js library below.
			Z.slidePathProvided = ((Z.imagePath && Z.imagePath.indexOf('zSlidePath') != -1) || params['zSlidePath'] !== undefined);
			var specialHandlingForPrototypeLib = (Z.slidePathProvided || Z.comparison || Z.overlays || Z.slideshow || Z.imageSetPathProvided || Z.animation || Z.slidestack);

			for (var pName in params) {

				// DEV NOTE: The Prototype.js library extends native data type prototypes and causes the for-in used to parse the optional parameters string
				// to fill the params object with extension functions that must be ignored. Exceptions added for Zoomify parameters that are functions.
				// Function test not effective when slide, animation, or slidestack path in use. Explicit name test then required.
				// String test may miss new prototype features so second condition below uses console rather than alert to avoid interruption of processing.
				if ((typeof params[pName] === 'function' && pName !== 'zOnAnnotationReady' && pName !== 'zOnReady')
					|| (specialHandlingForPrototypeLib && (pName == 'each' || pName == 'eachSlice' || pName == 'all' || pName == 'any' || pName == 'collect' || pName == 'detect' || pName == 'findAll' || pName == 'select' || pName == 'grep' || pName == 'include' || pName == 'member' || pName == 'inGroupsOf' || pName == 'inject' || pName == 'invoke' || pName == 'max' || pName == 'min' || pName == 'partition' || pName == 'pluck' || pName == 'reject' || pName == 'sortBy' || pName == 'toArray' || pName == 'zip' || pName == 'size' || pName == 'inspect' || pName == '_reverse' || pName == '_each' || pName == 'clear' || pName == 'first' || pName == 'last' || pName == 'compact' || pName == 'flatten' || pName == 'without' || pName == 'uniq' || pName == 'intersect' || pName == 'clone'))
					|| (pName.indexOf('this.indexOf') != -1)) {
						continue;

				} else if (typeof Z[Z.Utils.stringLowerCaseFirstLetter(pName.substr(1))] === 'undefined') {
					if (specialHandlingForPrototypeLib) {
						console.log(unrecognizedParamAlert + ' ' +pName);
					} else {
						alert(unrecognizedParamAlert + ' ' +pName);
					}

				} else {

					pValue = params[pName];

					// For limited feature edition, disable Express, Pro, and Enterprise parameters.
					// Then only one is supported, zNavigatorVisible, and Z logo link is enabled.
					if (!Z.expressParamsEnabled && pName != 'zNavigatorVisible') {
						alert(expressParamsDisabledAlert + ' ' +pName);

					} else {
						switch (pName) {

							case 'zOnAnnotationReady' : // Callback function option for completion of Annotation Panel initialization.
								if (typeof pValue === 'function') {
									Z.setCallback('annotationPanelInitializedViewer', pValue);
								}
								break;
							case 'zOnReady' : // Callback function option for completion of Viewer initialization.
								if (typeof pValue === 'function') {
									Z.setCallback('readyViewer', pValue);
								}
								break;

							case 'zInitialX' : // Default is null (centered).
								if (!isNaN(parseFloat(pValue))) { Z.initialX = parseFloat(pValue); }
								break;
							case 'zInitialY' : // Default is null (centered).
								if (!isNaN(parseFloat(pValue))) { Z.initialY = parseFloat(pValue); }
								break;
							case 'zInitialZoom' : // '1' to '100' recommended range (internally 0.1 to 1). Special inputs are 'fit' (default, zoom-to-fit in view area) and 'fill' (zoom-to-fill view area). Input value of -1 for zoom-to-fit is deprecated.
								if (pValue == 'fit') { pValue = '-1'; }
								if (pValue == 'fill') { pValue = '0'; }
								if (!isNaN(parseFloat(pValue))) {
									Z.initialZ = parseFloat(pValue);
									if (Z.initialZ && Z.initialZ > 0 && Z.initialZ <= 100) { Z.initialZ /= 100; }
								}
								break;
							case 'zMinZoom' : // '1' to '100' recommended range (internally 0.1 to 1). Special inputs are 'fit' (default, zoom-to-fit in view area) and 'fill' (zoom-to-fill view area). Input value of -1 for zoom-to-fit is deprecated.
								if (pValue == 'fit') { pValue = '-1'; }
								if (pValue == 'fill') { pValue = '0'; }
								if (!isNaN(parseFloat(pValue))) {
									Z.minZ = parseFloat(pValue);
									if (Z.minZ && Z.minZ > 0 && Z.minZ <= 100) { Z.minZ /= 100; }
								}
								break;
							case 'zMaxZoom' : // '1' to '100' recommended range (internally 0.1 to 1), default is 1 (100%).
								if (!isNaN(parseFloat(pValue))) {
									Z.maxZ = parseFloat(pValue);
									if (Z.maxZ && Z.maxZ != -1) { Z.maxZ /= 100; }
								}
								break;

							case 'zNavigatorVisible' :  // '0'=hide, '1'=show, '2'= initially show then hide on mouse-out (default), '3'=initially hide then show when mouse over.
								Z.navigatorVisible = parseInt(pValue, 10);
								break;
							case 'zNavigatorRectangleColor' :  // Valid web color, '#' character permitted but not required.
								Z.navigatorRectangleColor = pValue;
								break;

							case 'zToolbarInternal' :  // '0'=false (default), '1'=true, substitutes simple canvas-drawn toolbar with no need for external skin graphics files in Assets folder.
								Z.toolbarInternal = pValue;
								break;
							case 'zToolbarVisible' :  // '0'=hide, '1'=show, '2'= initially show then hide on mouse-out (default), '3'=initially hide then show when mouse over, '4' and '5'=same as '2' and '3' but minimize rather than hiding, '6' and '7'= same as '1' and '2' but minimize buttons still visible (and toolbar overlaps display), '8' hides toolbar and keeps it hidden (supports external toolbar with editing functions fully enabled). On mobile devices behavior is forced from '2' and '3' to '4' and '5'.
								Z.toolbarVisible = parseInt(pValue, 10);
								Z.toolbarAutoShowHide = (Z.toolbarVisible != 0 && Z.toolbarVisible != 1 && Z.toolbarVisible != 6 && Z.toolbarVisible != 7 && Z.toolbarVisible != 8);
								break;
							case 'zLogoVisible' :  // '0'=hide, '1'=show (default).
								if (pValue == '0') { Z.logoVisible = false; }
								break;
							case 'zMinimizeVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '0') { Z.minimizeVisible = false; }
								break;
							case 'zSliderVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '0') { Z.sliderZoomVisible = false; }
								break;
							case 'zZoomButtonsVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '0') { Z.zoomButtonsVisible = false; }
								break;
							case 'zPanButtonsVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '0') { Z.panButtonsVisible = false; }
								break;
							case 'zResetVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '0') { Z.resetVisible = false; }
								break;

							case 'zFullViewVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '1') {
									Z.fullScreenVisible = true;
									Z.fullPageVisible = false;
								} else if (pValue == '0') {
									Z.fullScreenVisible = false;
									Z.fullPageVisible = false;
								}
								break;
							case 'zFullScreenVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '0') {
									Z.fullScreenVisible = false;
									Z.fullPageVisible = false;
								}
								break;
							case 'zFullPageVisible' :  // '0'=false (default), '1'=true.
								if (pValue == '1') {
									Z.fullScreenVisible = false;
									Z.fullPageVisible = true;
								}
								break;
							case 'zInitialFullPage' :  // '0'=false (default), '1'=true.
								if (pValue == '1') { Z.initialFullPage = true; }
								break;
							case 'zFullPageInitial' :  // Deprecated. Replaced with the above for consistency.
								alert(Z.Utils.getResource('ERROR_PARAMETERDEPRECATED') + ' zFullPageInitial is now zInitialFullPage');
								break;

							case 'zSkinPath' :
								Z.skinPath = pValue;
								break;
							case 'zTooltipsVisible' :  // '0'=hide, '1'=show (default).
								if (pValue == '0') { Z.tooltipsVisible = false; }
								break;

							case 'zHelpVisible' :  // '0'=hide, '1'=show (default), '2'=hide toolbar help, show annotation & markup help, '3'=reverse.
								Z.helpVisible = parseInt(pValue, 10);
								break;
							case 'zHelpPath' :
								Z.helpPath = pValue;
								Z.helpCustom = true;
								break;
							case 'zHelpWidth' : // Size in pixels, default is 430.
								if (!isNaN(parseInt(pValue, 10))) { Z.helpW = parseInt(pValue, 10); }
								break;
							case 'zHelpHeight' : // Size in pixels, default is 300.
								if (!isNaN(parseInt(pValue, 10))) { Z.helpH = parseInt(pValue, 10); }
								break;
							case 'zHelpLeft' : // Position in pixels, default is centered horizontally in display.
								if (!isNaN(parseInt(pValue, 10))) { Z.helpL = parseInt(pValue, 10); }
								break;
							case 'zHelpTop' : // Position in pixels, default is centered vertically in display.
								if (!isNaN(parseInt(pValue, 10))) { Z.helpT = parseInt(pValue, 10); }
								break;

							case 'zProgressVisible' :  // '0'=false, '1'=true (default).
								if (pValue == '0') { Z.progressVisible = false; }
								break;
							case 'zMessagesVisible' :  // '0'=hide, '1'=show (default).
								if (pValue == '0') { Z.messagesVisible = false; }
								break;

							default :
								if (!Z.proParamsEnabled) {
									alert(proParamsDisabledAlert + ' ' +pName);
								} else {
									switch (pName) {
										case 'zXMLParametersPath' : // Meta-parameter substitutes XML parameter file for HTML parameters.
											// Substitute zXMLParametersPath for image path parameter, include image path in parameters XML file and exclude 3rd optional parameter.
											Z.xmlParametersPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.loadParametersXML();
											break;

										case 'zZoomSpeed' : // '1'=slow to '10'=fast, default is '5'.
											Z.zoomSpeed = parseInt(pValue, 10);
											break;
										case 'zPanSpeed' :  // '1'=slow to '10'=fast, default is '5'.
											Z.panSpeed = parseInt(pValue, 10);
											break;
										case 'zFadeInSpeed' : // '1'=slow to '10'=fast, default is '5', '0' = no fade-in.
											Z.fadeInSpeed = parseInt(pValue, 10);
											Z.fadeIn = (Z.fadeInSpeed > 0 && !Z.imageFilters); // Disable fade-in if filters available for use, to optimize performace.
											break;

										case 'zInteractive' :  // '0'=disable, '1'=enable (default).
											if (pValue == '0') {
												Z.interactive = false;
												Z.navigatorVisible = false;
												Z.toolbarVisible = false;
												Z.clickZoom = false;
												Z.doubleClickZoom = false;
												Z.clickPan = false;
												Z.mousePan = false;
												Z.keys = false;
											}
											break;
										case 'zClickZoom' :  // '0'=disable, '1'=enable (default).
											if (pValue == '0') { Z.clickZoom = false; }
											break;
										case 'zDoubleClickZoom' :  // '0'=disable, '1'=enable (default).
											if (pValue == '0') { Z.doubleClickZoom = false; }
											break;
										case 'zDoubleClickDelay' : // '600'=slow to '200'=fast, default is '350'.
											Z.doubleClickDelay = parseInt(pValue, 10);
											break;
										case 'zClickPan' :  // '0'=disable, '1'=enable (default).
											if (pValue == '0') { Z.clickPan = false; }
											break;
										case 'zMousePan' :  // '0'=disable, '1'=enable (default).
											if (pValue == '0') { Z.mousePan = false; }
											break;
										case 'zKeys' :  // '0'=disable, '1'=enable (default).
											if (pValue == '0') { Z.keys = false; }
											break;

										case 'zConstrainPan' :  // '0'=false, '1'=loose (constrain image center to viewport edge), '2'=relaxed (default, constrain trailing edge to viewport center), '3'=strict (constrain trailing edge of image to far edge of display and center image when zoomed-out).
											Z.constrainPan = (pValue != '0');
											Z.constrainPanLimit = parseInt(pValue, 10);
											Z.constrainPanStrict = (pValue == '3');
											break;
										case 'zPanBuffer' :  // '1'=none, '1.5' (default), '2'=double, '3'=impractical. Does not affect mobile value (always 1, none). Will not override canvasSizeMax based on limit for image sets, limit for Firefox due to unconverted image use, or general browser limit.
											var panBuffTest = parseFloat(pValue);
											if (!isNaN(panBuffTest)) { Z.panBuffer = panBuffTest; }
											break;

										case 'zSmoothPan' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.smoothPan = false; }
											break;
										case 'zSmoothPanEasing' : // '1'=direct, '2'=fluid (default), '3'=gentle, '4'=relaxed, '5'=loose;
											var easingValue = parseInt(pValue, 10);
											if (easingValue >= 1 && easingValue <= 5) { Z.smoothPanEasing = easingValue; }
											break;
										case 'zSmoothPanGlide' : // '1'=none, '2'=fluid (default), '3'=gentle, '4'=relaxed, '5'=loose;
											var glideValue = parseInt(pValue, 10);
											if (glideValue >= 1 && glideValue <= 5) { Z.smoothPanGlide = glideValue; }
											break;
										case 'zSmoothZoom' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.smoothZoom = false; }
											break;
										case 'zSmoothZoomEasing' : // '1'=direct, '2'=fluid (default), '3'=gentle, '4'=relaxed;
											var easingValue = parseInt(pValue, 10);
											if (easingValue >= 1 && easingValue <= 4) { Z.smoothZoomEasing = easingValue; }
											break;

										case 'zAutoResize' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.autoResize = true; }
											break;

										case 'zCanvas' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.canvas = false; }
											// Use canvas if supported by browser and not disabled by parameter.
											if (!Z.canvasSupported || !Z.canvas) { Z.useCanvas = false; }
											break;
										case 'zBaseZIndex' :  // '2000' default, range -2147483648 to +2147483647. Locate affected Viewer elements by searching for variable Z.baseZIndex.
											Z.baseZIndex = parseInt(pValue, 10);
											break;
										case 'zDebug' :  // '0'=disable (default), '1'=enable debug panel (fast), '2'=enable debug panel, tile loading calculations, tile name displays, tile tracing (slow), 3=enable debug panel, tile loading calculations, no tracing, no tile names (medium), '4'=enable tile names only (fast).
											Z.debug = parseInt(pValue, 10);
											break;

										case 'zImageProperties' :
											Z.imageProperties = pValue;
											break;

										case 'zNavigatorWidth' : // Size in pixels, default is 150, useful max is thumbnail width.
											if (!isNaN(parseInt(pValue, 10))) {
												Z.navigatorW = parseInt(pValue, 10);
												if (Z.rulerVisible > 0 && Z.rulerW === null || Z.rulerW == -1) { Z.rulerW = Z.navigatorW; }
											}
											break;
										case 'zNavigatorHeight' : // Size in pixels, default is 100, useful max is thumbnail height.
											if (!isNaN(parseInt(pValue, 10))) { Z.navigatorH = parseInt(pValue, 10); }
											break;
										case 'zNavigatorLeft' : // Position in pixels, default is -1 (0 after calculation).
											if (!isNaN(parseInt(pValue, 10))) { Z.navigatorL = parseInt(pValue, 10); }
											break;
										case 'zNavigatorTop' : // Position in pixels, default is 0.
											if (!isNaN(parseInt(pValue, 10))) { Z.navigatorT = parseInt(pValue, 10); }
											break;
										case 'zNavigatorFit' :  // '0'= fit to viewer (default), '1'= fit to image.
											if (!isNaN(parseFloat(pValue))) { Z.navigatorFit = parseInt(pValue, 10); }
											break;

										case 'zGalleryVisible' :  // '0'=hide (default if not slideshow or image set), '1'=show, '2'= initially show then hide on mouse-out (default if slideshow).
											Z.galleryVisible = parseInt(pValue, 10);
											Z.galleryAutoShowHide = (Z.galleryVisible == 2);
											break;
										case 'zGalleryWidth' : // Size in pixels, default is 150, useful max is thumbnail width.
											if (!isNaN(parseInt(pValue, 10))) { Z.galleryW = parseInt(pValue, 10); }
											break;
										case 'zGalleryHeight' : // Size in pixels, default is 100, useful max is thumbnail height.
											if (!isNaN(parseInt(pValue, 10))) { Z.galleryH = parseInt(pValue, 10); }
											break;
										case 'zGalleryLeft' : // Position in pixels, default is -1 (0 after calculation).
											if (!isNaN(parseInt(pValue, 10))) { Z.galleryL = parseInt(pValue, 10); }
											break;
										case 'zGalleryTop' : // Position in pixels, default is 0.
											if (!isNaN(parseInt(pValue, 10))) { Z.galleryT = parseInt(pValue, 10); }
											break;
										case 'zGalleryPosition' :  // '0'=top, '1'=bottom (default).
											Z.galleryPosition = parseInt(pValue, 10);
											break;

										case 'zToolbarPosition' :  // '0'=top, '1'=bottom (default).
											Z.toolbarPosition = parseInt(pValue, 10);
											break;
										case 'zLogoCustomPath' :
											Z.logoCustomPath = pValue;
											break;

										case 'zBookmarksGet' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.bookmarksGet = true; }
											break;
										case 'zBookmarksSet' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.bookmarksSet = true; }
											break;

										case 'zCopyrightPath' :
											Z.copyrightPath = pValue;
											break;
										case 'zWatermarkPath' :
											Z.watermarkPath = pValue;
											Z.watermarks = true;
											break;

										case 'zVirtualPointerVisible' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.virtualPointerVisible = true; }
											break;
										case 'zCrosshairsVisible' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.crosshairsVisible = true; }
											break;

										case 'zZoomRectangle' :  // '0'=false (default for Express edition and mobile devices), '1'=true (default for Pro and Enterprise editions).
											if (pValue == '0') { Z.zoomRectangle = false; }
											break;

										case 'zRulerVisible' :  // '0'=hide, '1'=show, '2'= initially show then hide on mouse-out (default), '3'=initially hide then show when mouse over.
											Z.rulerVisible = parseInt(pValue, 10);
											break;
										case 'zRulerListType' : // '0'=hide, '1'=magnifications, '2'=percents (default).
											if (this.stringValidate(pValue)) { Z.rulerListType = pValue; }
											break;
										case 'zRulerWidth' : // Size in pixels, default is 150.
											if (!isNaN(parseInt(pValue, 10))) { Z.rulerW = parseInt(pValue, 10); }
											break;
										case 'zRulerHeight' : // Size in pixels, default is 50.
											if (!isNaN(parseInt(pValue, 10))) { Z.rulerH = parseInt(pValue, 10); }
											break;
										case 'zRulerLeft' : // Position in pixels, default is 0.
											if (!isNaN(parseInt(pValue, 10))) { Z.rulerL = parseInt(pValue, 10); }
											break;
										case 'zRulerTop' : // Position in pixels, default is 0.
											if (!isNaN(parseInt(pValue, 10))) { Z.rulerT = parseInt(pValue, 10); }
											break;
										case 'zUnits' : // Supported values: 'Ym', 'Zm', 'Em', 'Pm', 'Tm', 'Gm', 'Mm', 'km', 'hm', 'dam', 'm', 'dm', 'cm', 'mm', 'um', 'nm', 'pm', 'fm', 'am', 'zm', 'ym', 'pixels' (default).
											if (this.stringValidate(pValue)) { Z.units = pValue; }
											break;
										case 'zUnitsPerImage' :
											if (!isNaN(parseFloat(pValue))) { Z.unitsPerImage = parseFloat(pValue); }
											break;
										case 'zPixelsPerUnit' :
											if (!isNaN(parseFloat(pValue))) { Z.pixelsPerUnit = parseFloat(pValue); }
											break;
										case 'zSourceMagnification' :
											if (!isNaN(parseInt(pValue, 10))) { Z.sourceMagnification = parseInt(pValue, 10); }
											break;
										case 'zMagnification' :  // Deprecated. Replaced with the above for clarity.
											alert(Z.Utils.getResource('ERROR_PARAMETERDEPRECATED') + ' zMagnification is now zSourceMagnification');
											break;

										case 'zMeasureVisible' :  // '0'=false (default), '1'=true.
											Z.measureVisible = (pValue == '1');
											break;

										case 'zRotationVisible' :  // '0'=false (default), '1'= free rotation true, '2'= 90 degree increments true.
											if (pValue != '0') {
												Z.rotationVisible = true;
												Z.rotationFree = (pValue == '1');
											}
											break;
										case 'zInitialRotation' : // '90', '180', '270' supported unless Z.rotationFree, other values constrained, default is '0'.
											if (!isNaN(parseFloat(pValue))) {
												Z.initialR = parseInt(pValue, 10);
											}
											break;

										case 'zImageListPath' :
											Z.imageListPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.imageList = true;
											break;

										case 'zScreensaver' :  // '0'=false (default), '1'=true.
											if (pValue == '1') {
												Z.screensaver = true;
												Z.tour = true;
											}
											break;
										case 'zScreensaverSpeed' : // '1'=slow to '10'=fast, default is '5', '0' = no zoom-and-pan transition.
											Z.screensaverSpeed = parseInt(pValue, 10);
											break;

										case 'zTourPath' :
											Z.tourPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.hotspotPath = Z.tourPath;
											Z.hotspotFolder = Z.hotspotPath;
											if (Z.hotspotPath.toLowerCase().substring(Z.hotspotPath.length - 4, Z.hotspotPath.length) == '.xml') {
												Z.hotspotFolder = Z.hotspotFolder.substring(0, Z.hotspotFolder.lastIndexOf('/'));
											}
											Z.tour = true;
											break;
										case 'zTourListTitle' :
											Z.tourListTitle = pValue;
											break;

										case 'zComparisonPath' :
											Z.imageSetPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.imageSet = true;
											Z.comparison = true;
											Z.smoothPan = false; // DEV NOTE: Disabling smooth pan in comparison mode as workaround to avoid loops when sync'ing viewports during rapid pan or zoom while switching between viewports.
											break;
										case 'zSyncVisible' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.syncVisible = false; }
											break;
										case 'zInitialSync' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.initialSync = false; }
											break;

										case 'zSlidePath' :
											Z.slidePath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.slideshow = true;
											break;
										case 'zSlideListTitle' :
											Z.slideListTitle = pValue;
											break;

										case 'zHotspotPath' :
											Z.hotspotPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.hotspotFolder = Z.hotspotPath;
											if (Z.hotspotPath.toLowerCase().substring(Z.hotspotPath.length - 4, Z.hotspotPath.length) == '.xml') {
												Z.hotspotFolder = Z.hotspotFolder.substring(0, Z.hotspotFolder.lastIndexOf('/'));
											}
											Z.hotspots = true;
											break;
										case 'zHotspotListTitle' :
											Z.hotspotListTitle = pValue;
											break;
										case 'zHotspotsDrawOnlyInView' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.hotspotsDrawOnlyInView = false; }
											break;
										case 'zCaptionBoxes' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.captionBoxes = true; }
											break;

										case 'zCaptionTextColor' :  // Valid web color, '#' character not required but permitted.
											Z.captionTextColor = Z.Utils.stringValidateColorValue(pValue);
											Z.captionsColorsDefault = false;
											break;
										case 'zCaptionBackColor' :  // Valid web color, '#' character not required but permitted.
											Z.captionBackColor = Z.Utils.stringValidateColorValue(pValue);
											Z.captionsColorsDefault = false;
											break;
										case 'zPolygonLineColor' :  // Valid web color, '#' character not required but permitted.
											Z.polygonLineColor = Z.Utils.stringValidateColorValue(pValue);
											break;
										case 'zPolygonFillColor' :  // Valid web color, '#' character not required but permitted.
											Z.polygonFillColor = Z.Utils.stringValidateColorValue(pValue);
											break;
										case 'zCaptionTextVisible' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.captionTextVisible = false; }
											break;
										case 'zCaptionBackVisible' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.captionBackVisible = false; }
											break;
										case 'zPolygonLineVisible' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.polygonLineVisible = false; }
											break;
										case 'zPolygonFillVisible' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.polygonFillVisible = true; }
											break;

										case 'zCoordinatesVisible' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.coordinatesVisible = true; }
											break;

										case 'zGeoCoordinatesPath' :
											Z.geoCoordinatesPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.geoCoordinatesFolder = Z.geoCoordinatesPath;
											if (Z.geoCoordinatesPath.toLowerCase().substring(Z.geoCoordinatesPath.length - 4, Z.geoCoordinatesPath.length) == '.xml') {
												Z.geoCoordinatesFolder = Z.geoCoordinatesFolder.substring(0, Z.geoCoordinatesFolder.lastIndexOf('/'));
											}
											Z.geoCoordinatesVisible = true;
											Z.coordinatesVisible = true;
											break;

										case 'zPreloadVisible' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.preloadVisible = true; }
											break;

										case 'zOverlayPath' :
											Z.imageSetPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.imageSet = true;
											Z.overlays = true;
											break;
										case 'zOverlayJSONObject' :
											Z.overlayJSONObject = pValue;
											Z.imageSet = true;
											Z.overlays = true;
											break;

										case 'zAnimationPath' :
											Z.imageSetPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
											Z.imageSet = true;
											Z.animation = true;
											if (!Z.mouseWheelParmeterProvided) {
												Z.mouseWheel = parseInt(this.getResource('DEFAULT_MOUSEWHEELANIMATION'), 10);
												Z.sliderFocus = (Z.mouseWheel == 2) ? 'imageSet' : 'zoom';
											}
											if (!Z.constrainPanStrict) { Z.constrainPanStrict = true; }
											break;
										case 'zAnimationAxis' : // Supported values: 'horizontal' (default), 'vertical'.
											Z.animationAxis = (this.stringValidate(pValue) && pValue == 'vertical') ? 'vertical' : 'horizontal';
											break;
										case 'zAnimator' : // Supported values: 'motion' (default), 'position'.
											Z.animator = (this.stringValidate(pValue) && pValue == 'motion') ? 'motion' : 'position';
											break;
										case 'zAnimationFlip' :  // '0'=false (default), '1'=true.
											if (pValue == '1') { Z.animationFlip = true; }
											break;

										case 'zImageSetSliderVisible' :  // '0'=false, '1'=true (default).
											if (pValue == '0') { Z.sliderImageSetVisible = false; }
											break;

										case 'zMouseWheel' : // '0'=disabled, '1'=zoom priority (default), '2'=image set priority.
											Z.mouseWheel = parseInt(pValue, 10);
											Z.sliderFocus = (Z.mouseWheel == 2) ? 'imageSet' : 'zoom';
											break;

										case 'zTilesPNG' :   // '0'=false (default, jpeg), '1'=true.
											if (pValue == '1') { Z.tileType = 'png'; }
											break;
										case 'zTileW' :
											Z.tileW = parseInt(pValue, 10);
											break;
										case 'zTileH' :
											Z.tileH = parseInt(pValue, 10);
											break;

										default :
											if (!Z.enterpriseParamsEnabled) {
												alert(enterpriseParamsDisabledAlert + ' ' +pName);
											} else {
												switch (pName) {

													case 'zImageFiltersVisible' :  // '0'=false (default), '1'=true=all, other supported options: 'all', 'creative', 'hsl', 'pathology', 'colors', 'ranges', 'gammaColors'.
														if (Z.Utils.stringValidate(pValue)) {
															switch(pValue) {
																case 'all' :
																	Z.brightnessVisible = true;
																	Z.contrastVisible = true;
																	Z.sharpnessVisible = true;
																	Z.blurrinessVisible = true;
																	Z.colorRedVisible = true;
																	Z.colorGreenVisible = true;
																	Z.colorBlueVisible = true;
																	Z.colorRedRangeVisible = true;
																	Z.colorGreenRangeVisible = true;
																	Z.colorBlueRangeVisible = true;
																	Z.gammaVisible = true;
																	Z.gammaRedVisible = true;
																	Z.gammaGreenVisible = true;
																	Z.gammaBlueVisible = true;
																	Z.hueVisible = true;
																	Z.saturationVisible = true;
																	Z.lightnessVisible = true;
																	Z.whiteBalanceVisible = true;
																	//Z.normalizeVisible = true;
																	//Z.equalizeVisible = true;
																	Z.noiseVisible = true;
																	Z.grayscaleVisible = true;
																	Z.thresholdVisible = true;
																	Z.inversionVisible = true;
																	Z.edgesVisible = true;
																	Z.sepiaVisible = true;
																	break;
																case 'creative' :
																	Z.brightnessVisible = true;
																	Z.contrastVisible = true;
																	Z.sharpnessVisible = true;
																	Z.blurrinessVisible = true;
																	Z.colorRedVisible = true;
																	Z.colorGreenVisible = true;
																	Z.colorBlueVisible = true;
																	Z.gammaVisible = true;
																	Z.whiteBalanceVisible = true;
																	Z.noiseVisible = true;
																	Z.grayscaleVisible = true;
																	Z.inversionVisible = true;
																	Z.sepiaVisible = true;
																	break;
																case 'hsl' :
																	Z.hueVisible = true;
																	Z.saturationVisible = true;
																	Z.lightnessVisible = true;
																	break;
																case 'pathology' :
																	Z.brightnessVisible = true;
																	Z.contrastVisible = true;
																	Z.sharpnessVisible = true;
																	//Z.colorRedVisible = true;
																	//Z.colorGreenVisible = true;
																	//Z.colorBlueVisible = true;
																	//Z.gammaVisible = true;
																	Z.gammaRedVisible = true;
																	Z.gammaGreenVisible = true;
																	Z.gammaBlueVisible = true;
																	Z.whiteBalanceVisible = true;
																	//Z.normalizeVisible = true;
																	//Z.equalizeVisible = true;
																	Z.thresholdVisible = true;
																	Z.edgesVisible = true;
																	break;
																case 'colors' :
																	Z.colorRedVisible = true;
																	Z.colorGreenVisible = true;
																	Z.colorBlueVisible = true;
																	break;
																case 'ranges' :
																	Z.colorRedRangeVisible = true;
																	Z.colorGreenRangeVisible = true;
																	Z.colorBlueRangeVisible = true;
																	break;
																case 'gammaColors' :
																	Z.gammaRedVisible = true;
																	Z.gammaGreenVisible = true;
																	Z.gammaBlueVisible = true;
																	break;
															}
														}
														break;
													case 'zInitialImageFilters' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.initialImageFilters = false; }
														break;
													case 'zBrightnessVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.brightnessVisible = true; }
														break;
													case 'zContrastVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.contrastVisible = true; }
														break;
													case 'zSharpnessVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.sharpnessVisible = true; }
														break;
													case 'zBlurrinessVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.blurrinessVisible = true; }
														break;
													case 'zColorRedVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.colorRedVisible = true; }
														break;
													case 'zColorGreenVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.colorGreenVisible = true; }
														break;
													case 'zColorBlueVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.colorBlueVisible = true; }
														break;
													case 'zColorRedRangeVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.colorRedRangeVisible = true; }
														break;
													case 'zColorGreenRangeVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.colorGreenRangeVisible = true; }
														break;
													case 'zColorBlueRangeVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.colorBlueRangeVisible = true; }
														break;
													case 'zGammaVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.gammaVisible = true; }
														break;
													case 'zGammaRedVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.gammaRedVisible = true; }
														break;
													case 'zGammaGreenVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.gammaGreenVisible = true; }
														break;
													case 'zGammaBlueVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.gammaBlueVisible = true; }
														break;
													case 'zHueVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.hueVisible = true; }
														break;
													case 'zSaturationVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.saturationVisible = true; }
														break;
													case 'zLightnessVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.lightnessVisible = true; }
														break;
													case 'zWhiteBalanceVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.whiteBalanceVisible = true; }
														break;
													case 'zNormalizeVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.normalizeVisible = true; }
														break;
													case 'zEqualizeVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.equalizeVisible = true; }
														break;
													case 'zNoiseVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.noiseVisible = true; }
														break;
													case 'zGrayscaleVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.grayscaleVisible = true; }
														break;
													case 'zThresholdVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.thresholdVisible = true; }
														break;
													case 'zInversionVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.inversionVisible = true; }
														break;
													case 'zEdgesVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.edgesVisible = true; }
														break;
													case 'zSepiaVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.sepiaVisible = true; }
														break;

													case 'zAnnotationPath' :
														Z.annotationPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
														if (typeof Z.annotationPath !== 'undefined' && Z.Utils.stringValidate(Z.annotationPath)) {
															Z.annotationFolder = Z.annotationPath;
															if (Z.annotationPath.toLowerCase().substring(Z.annotationPath.length - 4, Z.annotationPath.length) == '.xml') {
																Z.annotationFolder = Z.annotationFolder.substring(0, Z.annotationFolder.lastIndexOf('/'));
															}
															Z.annotations = true;
														} else {
															alert(this.getResource('ERROR_ANNOTATIONPATHMISSING')); // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
														}
														break;
													case 'zAnnotationPanelVisible' :  // '0'=hide, '1'=show, '2'= initially show then hide on mouse-out (default), '3'=initially hide then show when mouse over. '4' hides and does not show on mouse-over to support integration projects. Use Z.Toolbar.setVisibilityAnnotationPanel(true) to show.
														Z.annotationPanelVisible = parseInt(pValue, 10);
														break;
													case 'zAnnotationXMLText' :
														Z.annotationXMLText = pValue;
														Z.annotations = true;
														break;
													case 'zLabelIconsInternal' :  // '0'=false, '1'=true (default), '2'=permit shapes and external graphics (no auto-sustitution, primarily for debugging).
														if (pValue == '0') { Z.labelIconsInternal = false; }
														break;
													case 'zAnnotationJSONObject' :
														Z.annotationJSONObject = pValue;
														Z.annotations = true;
														break;
													case 'zAnnotationsAddMultiple' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.annotationsAddMultiple = false; }
														break;
													case 'zAnnotationsAutoSave' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.annotationsAutoSave = false; }
														break;
													case 'zSaveButtonVisible' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.saveButtonVisible = false; }
														break;
													case 'zLabelClickSelect' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.labelClickSelect = true; }
														break;

													case 'zSimplePath' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.simplePath = true; }
														break;
													case 'zNoPost' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.noPost = true; }
														break;
													case 'zNoPostDefaults' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.noPostDefaults = true; }
														break;
													case 'zUnsavedEditsTest' :  // '0'=false, '1'=true (true).
														if (pValue == '0') { Z.unsavedEditsTest = false; }
														break;
													case 'zAnnotationSort' :  // Supported values are common to list arrays of POIs, labels, and notes: 'id' (value), 'name' (text), and 'none' (no sorting, default).
														Z.annotationSort = pValue;
														break;

													case 'zMaskVisible' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.maskVisible = true; }
														break;
													case 'zMaskFadeSpeed' : // '1'=slow to '10'=fast, default is '5', '0' = no fade-in.
														Z.maskFadeSpeed = parseInt(pValue, 10);
														break;
													case 'zMaskClearOnUserAction' : // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.maskClearOnUserAction = false; }
														break;

													case 'zFreehandVisible' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.freehandVisible = false; }
														break;
													case 'zTextVisible' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.textVisible = false; }
														break;
													case 'zIconVisible' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.iconVisible = false; }
														break;
													case 'zRectangleVisible' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.rectangleVisible = false; }
														break;
													case 'zPolygonVisible' :  // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.polygonVisible = false; }
														break;

													case 'zMarkupMode' :
														if (pValue == '1' || pValue == '2') {
															if (Z.annotationPathProvided || Z.imageSetPathProvided) {
																Z.editMode = 'markup';
																Z.editing = 'addLabel';
																if (pValue == '2') { Z.editAdmin = true; }

																// DEV NOTE: Alternative implementation - alert rather than simply hiding Save button
																// if (!Z.saveHandlerProvided) { alert(this.getResource('ERROR_XMLSAVEHANDLERPATHMISSING')); } // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
															} else {
																alert(this.getResource('ERROR_ANNOTATIONPATHMISSING')); // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
															}
														}
														break;

													case 'zEditMode' :
														if (pValue == '1' || pValue == '2') {
															if (Z.annotationPathProvided || Z.imageSetPathProvided) {
																Z.editMode = 'edit';
																if (pValue == '2') { Z.editAdmin = true; }

																// DEV NOTE: Alternative implementation - alert rather than simply hiding Save button
																// if (!Z.saveHandlerProvided) { alert(this.getResource('ERROR_XMLSAVEHANDLERPATHMISSING')); } // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
															} else {
																alert(this.getResource('ERROR_ANNOTATIONPATHMISSING')); // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
															}
														}
														break;

													case 'zSlidestackPath' :
														Z.imageSetPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
														Z.imageSet = true;
														Z.slidestack = true;
														if (!Z.mouseWheelParmeterProvided) {
															Z.mouseWheel = parseInt(this.getResource('DEFAULT_MOUSEWHEELSLIDESTACK'), 10);
															Z.sliderFocus = (Z.mouseWheel == 2) ? 'imageSet' : 'zoom';
														}
														break;

													case 'zSaveHandlerPath' :
														Z.saveHandlerPath = pValue;
														break;

													case 'zSaveImageHandlerPath' :
														Z.saveImageHandlerPath = pValue;
														break;
													case 'zSaveImageFull' :  // '0'=false (default), '1'=true.
														if (pValue == '1') { Z.saveImageFull = true; }
														break;
													case 'zSaveImageFilename' : // Default is 'zoomifySavedImage'.
														if (Z.Utils.stringValidate(pValue)) { Z.saveImageFilename = pValue; }
														break;
													case 'zSaveImageFormat' :  // Supported values: 'png' and 'jpg' (default).
														switch (pValue.toLowerCase()) {
															case 'png' :
																Z.saveImageFormat = 'png';
																break;
															default :
																Z.saveImageFormat = 'jpg';
														}
														break;
													case 'zSaveImageCompression' :  // Supported values: '0.1' to '1.0', default '0.8'.
														var temp = parseFloat(pValue);
														if (!isNaN(temp) && temp >= 0.1 && temp <= 1) { Z.saveImageCompression = temp; }
														break;
													case 'zSaveImageBackColor' :  // Valid web color, '#' character permitted but not required.
														Z.saveImageBackColor = Z.Utils.stringValidateColorValue(pValue);
														break;

													case 'zTrackingPath' :
														Z.trackingPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
														if (typeof Z.trackingPath !== 'undefined' && Z.Utils.stringValidate(Z.trackingPath)) {
															Z.trackingFolder = Z.trackingPath;
															if (Z.trackingPath.toLowerCase().substring(Z.trackingPath.length - 4, Z.trackingPath.length) == '.xml') {
																Z.trackingFolder = Z.trackingFolder.substring(0, Z.trackingFolder.lastIndexOf('/'));
															}
															Z.tracking = true;
														} else {
															alert(this.getResource('ERROR_TRACKINGPATHMISSING')); // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
														}
														break;
													case 'zTrackingEditMode' :
														if (pValue == '1') {
															if (Z.trackingPathProvided) {
																Z.trackingEditMode = 'edit';
																Z.markupMode = true;
																Z.editMode = 'markup';
																Z.editing = 'addLabel';
																Z.labelMode = 'counter';
															} else {
																alert(this.getResource('ERROR_TRACKINGPATHMISSING')); // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
															}
														}
														break;
													case 'zTrackingAuto' :  // '0'=false (default), '1'=true. Changes 'Complete' checkbox to 'Viewed' and auto-sets true after default viewing time interval.
														if (pValue == '1') { Z.trackingAuto = true; }
														break;
													case 'zTrackingPanelVisible' :  // '0'=hide, '1'=show, '2'= initially show then hide on mouse-out (default), '3'=initially hide then show when mouse over. '4' hides and does not show on mouse-over to support integration projects. Use Z.Toolbar.setVisibilityTrackingPanel(true) to show.
														Z.trackingPanelVisible = parseInt(pValue, 10);
														break;
													case	'zInitialTrackingOverlayVisible' : // '0'=false, '1'=true (default).
														if (pValue == '0') { Z.initialTrackingOverlayVisible = false; }
														break;

													case 'zUserLogin' :  // '1'=request user name on init, 'skip'=assign default value, other string=hide request and set string as username for annotation time/date stamps and tracking.
														if (pValue == '1') {
															Z.userLogin = 'request';
														} else if (pValue == 'skip') {
															Z.userName = this.getResource('CONTENT_SKIPUSERNAME');
															Z.userInitials = Z.Utils.stringGetInitials(Z.userName);
														} else if (Z.Utils.stringValidate(pValue)) {
															Z.userName = pValue;
															Z.userInitials = Z.Utils.stringGetInitials(Z.userName);
														}
														break;
													case 'zUserNamePrompt' :
														if (Z.Utils.stringValidate(pValue)) { Z.userNamePrompt = pValue; }
														break;
													case 'zUserPath' :
														Z.userPath = Z.Utils.stringRemoveTrailingSlashCharacters(pValue);
														if (typeof Z.userPath !== 'undefined' && Z.Utils.stringValidate(Z.userPath)) {
															Z.userFolder = Z.userPath;
															if (Z.userPath.toLowerCase().substring(Z.userPath.length - 4, Z.userPath.length) == '.xml') {
																Z.userFolder = Z.userFolder.substring(0, Z.userFolder.lastIndexOf('/'));
															}
															Z.userLogging = true;
														} else {
															alert(this.getResource('ERROR_USERPATHMISSING')); // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
														}
														break;
													case 'zUserPanelVisible' : // '0'=hide, '1'=show, '2'= initially show then hide on mouse-out (default), '3'=initially hide then show when mouse over. '4' hides and does not show on mouse-over to support integration projects. Use Z.Toolbar.setVisibilityUserPanel(true) to show.
														if (pValue != '0') {
															if (Z.userPathProvided) {
																Z.userPanelVisible = parseInt(pValue, 10);
															} else {
																alert(this.getResource('ERROR_USERPATHMISSING')); // DEV NOTE: Use alert rather than showMessage as Viewer display initializing and yet not ready for message display.
															}
														}
														break;

													default :
														if (Z.specialStorageEnabled == specialStorageDisableValue) {
															alert(specialStorageDisabledAlert + ' ' +pName);
														} else {
															switch (pName) {

																case 'zServerIP' :
																	Z.serverIP = pValue;
																	break;
																case 'zServerPort' :
																	Z.serverPort = pValue;
																	break;
																case 'zTileHandlerPath' :
																	Z.tileHandlerPath = pValue;
																	break;

																case 'zIIIFScheme' :
																	Z.iiifScheme = pValue;
																	break;
																case 'zIIIFServer' :
																	Z.iiifServer = pValue;
																	break;
																case 'zIIIFPrefix' :
																	Z.iiifPrefix = pValue;
																	break;
																case 'zIIIFIdentifier' :
																	Z.iiifIdentifier = pValue;
																	break;
																case 'zIIIFRegion' :
																	Z.iiifRegion = pValue;
																	break;
																case 'zIIIFSize' :
																	Z.iiifSize = pValue;
																	break;
																case 'zIIIFRotation' :
																	Z.iiifRotation = pValue;
																	break;
																case 'zIIIFQuality' :
																	Z.iiifQuality = pValue;
																	break;
																case 'zIIIFFormat' :
																	Z.iiifFormat = pValue;
																	break;

																case 'zImageW' :
																	Z.imageW = parseInt(pValue, 10);
																	Z.imageCtrX = Z.imageW / 2;
																	if (Z.imageW != null && Z.imageW > 0 && Z.imageH != null && Z.imageH > 0) { Z.imageD = Math.round(Math.sqrt(Z.imageW * Z.imageW + Z.imageH * Z.imageH)); }
																	break;
																case 'zImageH' :
																	Z.imageH = parseInt(pValue, 10);
																	Z.imageCtrY = Z.imageH / 2;
																	if (Z.imageW != null && Z.imageW > 0 && Z.imageH != null && Z.imageH > 0) { Z.imageD = Math.round(Math.sqrt(Z.imageW * Z.imageW + Z.imageH * Z.imageH)); }
																	break;

																// Deprecated: Use zSourceMagnification.
																/*case 'zMagnification' :
																	Z.sourceMagnification = parseInt(pValue, 10);
																	break;*/

																case 'zFocal' :
																	Z.focal = parseInt(pValue, 10);
																	break;
																case 'zQuality' :
																	Z.quality = parseInt(pValue, 10);
																	break;
															}
														}
												}
											}
									}
								}
								break;
						}
					}
				}
			}
		}
		
		// Get and apply any view coordinates included in web page URL. This sets initial coodinate variables for primary Viewport
		// and overrides any HTML or XML parameter values. This occurs last to ensure zBookmarksGet parameter has been processed.
		Z.Utils.getBookmarksURL();

		// Set image filters general test variable and disable fade-in if any filter enabled.
		if (Z.brightnessVisible || Z.contrastVisible || Z.sharpnessVisible || Z.blurrinessVisible || Z.colorRedVisible || Z.colorGreenVisible || Z.colorBlueVisible || Z.colorRedRangeVisible || Z.colorGreenRangeVisible || Z.colorBlueRangeVisible || Z.gammaVisible || Z.gammaRedVisible || Z.gammaGreenVisible || Z.gammaBlueVisible || Z.hueVisible || Z.saturationVisible || Z.lightnessVisible || Z.whiteBalanceVisible || Z.normalizeVisible || Z.equalizeVisible || Z.noiseVisible || Z.grayscaleVisible || Z.thresholdVisible || Z.inversionVisible || Z.edgesVisible || Z.sepiaVisible) {
			Z.imageFilters = true;
			Z.imageFiltersVisible = true;
			Z.fadeIn = false;
		}

		// Process or disallow special paths for annotation features.
		if (Z.Utils.stringValidate(Z.annotationPath) || Z.Utils.stringValidate(Z.saveHandlerPath) || Z.Utils.stringValidate(Z.saveImageHandlerPath)) {
			if (Z.enterpriseParamsEnabled) {
				if (Z.Utils.stringValidate(Z.saveHandlerPath)) {
					// Build full save handler paths.
					var sHPF = Z.saveHandlerPath;
					var sIHPF = Z.saveImageHandlerPath;

					// DEV NOTE: JavaScript cross-domain block conflicts with specifying server IP and port.
					/*	if (sHPF.substr(0,1) != '/') { sHPF = '/' + sHPF; }
						if (Z.serverPort != '80') { sHPF = ':' + Z.serverPort + sHPF; }
						sHPF = Z.serverIP + sHPF;
						if (sIHPF.substr(0,1) != '/') { sIHPF = '/' + sIHPF; }
						if (Z.serverPort != '80') { sIHPF = ':' + Z.serverPort + sIHPF; }
						sIHPF = Z.serverIP + sIHPF;
					*/

					Z.saveHandlerPath = sHPF;
					Z.saveImageHandlerPath = sIHPF;
				}
			} else {
				Z.annotationPath = '';
				alert(enterpriseParamsDisabledAlert);
			}
		}

		Z.Utils.validateImagePath();
	},

	resetParametersXYZ : function (params) {
		if (!isNaN(parseFloat(this.getResource('DEFAULT_INITIALX')))) { Z.initialX = parseFloat(this.getResource('DEFAULT_INITIALX')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_INITIALY')))) { Z.initialY = parseFloat(this.getResource('DEFAULT_INITIALY')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_INITIALZOOM')))) { Z.initialZ = parseFloat(this.getResource('DEFAULT_INITIALZOOM')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_MINZOOM')))) { Z.minZ = parseFloat(this.getResource('DEFAULT_MINZOOM')); }
		if (!isNaN(parseFloat(this.getResource('DEFAULT_MAXZOOM')))) { Z.maxZ = parseFloat(this.getResource('DEFAULT_MAXZOOM')); }

		if (this.stringValidate(params)) {
			for (var i = 0, j = params.length; i < j; i++) {
				var nameValuePair = params[i];
				var sep = nameValuePair.indexOf('=');
				if (sep > 0) {
					var pName = nameValuePair.substring(0, sep)
					var pValue = nameValuePair.substring(sep + 1)
					if (this.stringValidate(pValue)) {
						switch (pName) {
							case 'zInitialX' : // Default is null (centered).
								if (!isNaN(parseFloat(pValue))) { Z.initialX = parseFloat(pValue); }
								break;
							case 'zInitialY' : // Default is null (centered).
								if (!isNaN(parseFloat(pValue))) { Z.initialY = parseFloat(pValue); }
								break;
							case 'zInitialZoom' : // '1' to '100' recommended range (internally 0.1 to 1). Special inputs are 'fit' (default, zoom-to-fit in view area) and 'fill' (zoom-to-fill view area). Input value of -1 for zoom-to-fit is deprecated.
								if (pValue == 'fit') { pValue = '-1'; }
								if (pValue == 'fill') { pValue = '0'; }
								if (!isNaN(parseFloat(pValue))) {
									Z.initialZ = parseFloat(pValue);
									if (Z.initialZ && Z.initialZ > 0 && Z.initialZ <= 100) { Z.initialZ /= 100; }
								}
								break;
							case 'zMinZoom' : // '1' to '100' recommended range (internally 0.1 to 1). Special inputs are 'fit' (default, zoom-to-fit in view area) and 'fill' (zoom-to-fill view area). Input value of -1 for zoom-to-fit is deprecated.
								if (pValue == 'fit') { pValue = '-1'; }
								if (pValue == 'fill') { pValue = '0'; }
								if (!isNaN(parseFloat(pValue))) {
									Z.minZ = parseFloat(pValue);
									if (Z.minZ && Z.minZ > 0 && Z.minZ <= 100) { Z.minZ /= 100; }
								}
								break;
							case 'zMaxZoom' : // '1' to '100' recommended range (internally 0.1 to 1), default is 1 (100%).
								if (!isNaN(parseFloat(pValue))) {
									Z.maxZ = parseFloat(pValue);
									if (Z.maxZ && Z.maxZ != -1) { Z.maxZ /= 100; }
								}
								break;
						}
					}
				}
			}
		}
	},

	readCookie : function (name) {
		var nameEq = name + '=';
		var nameValuePairs = document.cookie.split(';');
		for (var i = 0, j = nameValuePairs.length; i < j; i++) {
			var nvP = nameValuePairs[i];
			while (nvP.charAt(0) == ' ') { nvP = nvP.substring(1,nvP.length); }
			if (nvP.indexOf(nameEq) == 0) { return nvP.substring(nameEq.length,nvP.length); }
		}
		return null;
	},

	// Process or disallow special paths for storage options.
	validateImagePath : function (imageSetPath) {
		var imgPath = (typeof imageSetPath !== 'undefined' && Z.Utils.stringValidate(imageSetPath)) ? imageSetPath : Z.imagePath;
		if (imgPath !== null) {
			var specialStorageDisabledAlert = this.getResource('DEFAULT_SPECIALSTORAGESUPPORTDISABLEDALERT');

			if (imgPath.toLowerCase().indexOf('.zif') != -1) {
				if (Z.zifSupported) {
					Z.tileSource = 'ZoomifyImageFile';
					Z.Utils.validateResponseArrayFunctionality();
				} else {
					alert(this.getResource('ALERT_ZIFREQUIRESNEWERBROWSER'));
				}

			} else if (imgPath.toLowerCase().indexOf('.jpg') != -1 || imgPath.toLowerCase().indexOf('.png') != -1) {
				Z.tileSource = 'unconverted';

			} else if (imgPath.toLowerCase().indexOf('.pff') != -1) {
				if (Z.specialStorageEnabled) {
					Z.tileSource = 'ZoomifyPFFFile';

					// Build full tile handler path.
					var tHPF = Z.tileHandlerPath;

					// DEV NOTE: JavaScript cross-domain block conflicts with specifying server IP and port.
					//if (tHPF.substr(0,1) != '/') { tHPF = '/' + tHPF; }
					//if (Z.serverPort != '80') { tHPF = ':' + Z.serverPort + tHPF; }
					//tHPF = Z.serverIP + tHPF;

					Z.tileHandlerPathFull = tHPF;
				} else {
					alert(specialStorageDisabledAlert);
				}

			} else if (Z.Utils.stringValidate(Z.iiifServer)) {
				// IIIF server protocol implementation.
				Z.tileSource = 'IIIFImageServer';

				var scheme = (typeof Z.iiifScheme != 'undefined' && Z.Utils.stringValidate(Z.iiifScheme)) ? Z.iiifScheme + '://' : 'https' + '://';
				var server = (typeof Z.iiifServer != 'undefined' && Z.Utils.stringValidate(Z.iiifServer)) ? Z.iiifServer + '/' : null;
				var prefix = (typeof Z.iiifPrefix != 'undefined' && Z.Utils.stringValidate(Z.iiifPrefix)) ? Z.iiifPrefix + '/' : null;
				var identifier = (typeof Z.iiifIdentifier != 'undefined' && Z.Utils.stringValidate(Z.iiifIdentifier)) ? Z.iiifIdentifier : null;
				if (scheme && server && identifier) {
					Z.imagePath = scheme + server + prefix + identifier;
				} else {
					Z.imagePath = Z.Utils.getResource('ERROR_SETTINGIIIFIMAGEPATH');
				}

			} else if (!Z.Utils.stringValidate(Z.tileHandlerPath)) {
				Z.tileSource = 'ZoomifyImageFolder';

			} else if (Z.Utils.stringValidate(Z.tileHandlerPath)) {
				if (Z.specialStorageEnabled) {
					 // Example image server protocol implementation.
					Z.tileSource = 'ImageServer';

					// Build full tile handler path.
					var tHPF = Z.tileHandlerPath;

					// DEV NOTE: JavaScript cross-domain block conflicts with specifying server IP and port.
					//if (tHPF.substr(0,1) != '/') { tHPF = '/' + tHPF; }
					//if (Z.serverPort != '80') { tHPF = ':' + Z.serverPort + tHPF; }
					//tHPF = Z.serverIP + tHPF;

					Z.tileHandlerPathFull = tHPF;

				} else {
					alert(specialStorageDisabledAlert);
				}
			}

		} else if (Z.imageSet || Z.slideshow) {
			Z.tileSourceMultiple = true;
		}
	},

	clearImageParameters : function () {
		Z.imagePath = null;
		Z.imagePath2 = null;
		Z.parameters = null;
		Z.xmlParametersPath = null;
		Z.xmlParametersParsing = null;
		Z.initialX = null;
		Z.initialY = null;
		Z.initialZ = null;
		Z.minZ = null;
		Z.maxZ = null;
		Z.geoCoordinatesPath = null;
		Z.geoCoordinatesVisible = null;
		Z.geoCoordinatesFolder = null;
		Z.tour = false;
		Z.tourPath = null;
		Z.tourPlaying = null;
		Z.tourStop = false;
		Z.hotspots = false;
		Z.hotspotPath = null;
		Z.hotspotFolder = null;
		Z.annotations = false;
		Z.annotationPath = null;
		Z.annotationPanelVisible = null;
		Z.annotationFolder = null;
		Z.annotationJSONObject = null;
		Z.annotationXMLText = null;
		Z.labelIconsInternal = null;
		Z.annotationsAddMultiple = null;
		Z.annotationsAutoSave = null;
		Z.postingXML = false;
		Z.postingImage = false;
		Z.initialR = null;

		Z.unitsPerImage = null;
		Z.pixelsPerUnit = null;
		Z.sourceMagnification = null;
		Z.imageProperties = null;
		Z.annotationPathProvided = false;
		Z.imageSetPathProvided = false;
		Z.slidePathProvided = false;
		Z.tileSource = null;
		Z.tileSourceMultiple = null;
		Z.focal = null;
		Z.quality = null;

		if (!Z.tracking) {
			Z.markupMode = null;
			Z.editMode = null;
			Z.editAdmin = false;
			Z.editing = null;
			Z.labelMode = 'view';
			Z.editModePrior = Z.editMode;
		}

		Z.sliderFocus = 'zoom';
		Z.animation = false;
		Z.animationPath = null;
		Z.animationCount = 0;
		Z.animationAxis = null;
		Z.animator = null;
		Z.animationFlip = null;
		Z.slidestack = false;
		Z.slidestackPath = null;

		Z.brightnessVisible = null;
		Z.contrastVisible = null;
		Z.sharpnessVisible = null;
		Z.blurrinessVisible = null;
		Z.colorRedVisible = null;
		Z.colorGreenVisible = null;
		Z.colorBlueVisible = null;
		Z.colorRedRangeVisible = null;
		Z.colorGreenRangeVisible = null;
		Z.colorBlueRangeVisible = null;
		Z.colorRedRangeMin = null;
		Z.colorRedRangeMax = null;
		Z.colorGreenRangeMin = null;
		Z.colorGreenRangeMax = null;
		Z.colorBlueRangeMin = null;
		Z.colorBlueRangeMax = null;
		Z.gammaVisible = null;
		Z.gammaRedVisible = null;
		Z.gammaGreenVisible = null;
		Z.gammaBlueVisible = null;
		Z.hueVisible = null;
		Z.saturationVisible = null;
		Z.lightnessVisible = null;
		Z.whiteBalanceVisible = null;
		Z.grayscaleVisible = null;
		Z.thresholdVisible = null;
		Z.inversionVisible = null;
		Z.normalizeVisible = null;
		Z.equalizeVisible = null;
		Z.edgesVisible = null;
		Z.sepiaVisible = null;

		Z.mouseWheelParmeterProvided = null;
		Z.mouseWheel = null;
		Z.imageSetHotspotPath = null;
		Z.hotspotFileShared = false;
		Z.imageSetAnnotationPath = null;
		Z.annotationFileShared = false;
		Z.imageW = null;
		Z.imageH = null;
		Z.imageD = null;
		Z.imageCtrX = null;
		Z.imageCtrY = null;
		Z.imageX = 0;
		Z.imageY = 0;
		Z.imageZ = 0;
		Z.imageR = 0;
		Z.fitZ = null;
		Z.fillZ = null;
		Z.zooming = 'stop';
		Z.panningX = 'stop';
		Z.panningY = 'stop';
		Z.rotating = 'stop';
		Z.fullView = false;
		Z.fullViewPrior = false;

		Z.iiifInfoJSONObject =null;
		Z.iiifIdentifier = null;
		Z.iiifRegion = null;
		Z.iiifSize = null;
		Z.iiifRotation = null;
		Z.iiifQuality = null;
		Z.iiifFormat = null;

		// Must not clear these parameters if resetting image.
		//Z.priorX = 0; // Image coordinates cleared but prior values remain for use by setImage in comparison context.
		//Z.priorY = 0;
		//Z.priorZ = 0;
		//Z.priorR = 0;
		//Z.imageListPath = null; // Setting new image from list must not clear list title var or index calculation will fail.
		//Z.imageList = null;
		//Z.imageListTitle = null;
		//Z.tileW = null;
		//Z.tileH = null;
		//Z.tileType = 'jpg';
		//Z.comparison = false;
		//Z.comparisonPath = null;
		//Z.syncVisible = null;
		//Z.initialSync = null;
		//Z.syncComparison = null;
		//Z.overlayPath = null;
		//Z.overlayJSONObject = null;
		//Z.overlays = false;
		//Z.overlaysInitialVisibility = null;
		//Z.slideshow = false;
		//Z.slideList = false;
		//Z.slidePath = null;
		//Z.slideshowPlaying = null;
		//Z.imageSet = false;
		//Z.imageSetPath = null;
		//Z.imageSetLength = null;
		//Z.sliderImageSetVisible = null;
		//Z.imageSetSliderVisible = null; // Deprecated. Now Z.sliderImageSetVisible. HTML parameter still zImageSetSliderVisible. This set here to prevent specific error message in function setParameters.
		//Z.tracking = false; // Retain this value
		//Z.trackingPath = null; // Tracking variables will be overwritten if need to change for new image and must be retained if being used across images. Z.tracking is also used to avoid reset of edit modes above when using tracking with image list.
		//Z.trackingFolder = null;
		//Z.trackingPathProvided = false;
		//Z.trackingEditMode = false;
		//Z.trackingFileShared = false;
		//Z.imageSetTrackingPath = null;
		//Z.trackingCounts = [];
		//Z.trackingTypeCurrent = '0';
		//Z.trackingOverlayVisible = false;
		//Z.initialTrackingOverlayVisible = null;
		//Z.trackingCellCurrent = null;
	},

	getResource : function (resName) {
		// Access default values, constants, and localizable strings (tooltips, messages, errors).
		var resTxt = '';
		switch(resName) {
			case 'DEFAULT_EXPRESSPARAMETERSENABLETEST' :
				// Use 'Enable Express parameters' to enable Express parameter support and value of DEFAULT_EXPRESSPARAMETERSDISABLEVALUE to disable.
				resTxt = 'Enable Express parameters';
				//resTxt = 'Changing This Violates License Agreement';
				break;
			case 'DEFAULT_EXPRESSPARAMETERSDISABLEVALUE' :
				resTxt = 'Changing This Violates License Agreement';
				break;
			case 'DEFAULT_EXPRESSPARAMETERSDISABLEDALERT' :
				resTxt = 'Support for this parameter is enabled only in the Zoomify Image Viewer included in the Zoomify HTML5 Express, Pro, and Enterprise editions: ';
				break;

			case 'DEFAULT_PROPARAMETERSENABLETEST' :
				// Use 'Enable Pro parameters' to enable Pro parameter support and value of DEFAULT_PARAMETERSDISABLEVALUE to disable.
				resTxt = 'Enable Pro parameters';
				//resTxt = 'Changing This Violates License Agreement';
				break;
			case 'DEFAULT_PROPARAMETERSDISABLEVALUE' :
				resTxt = 'Changing This Violates License Agreement';
				break;
			case 'DEFAULT_PROPARAMETERSDISABLEDALERT' :
				resTxt = 'Support for this parameter is enabled only in the Zoomify Image Viewer included in the Zoomify HTML5 Pro and Enterprise editions: ';
				break;

			case 'DEFAULT_SPECIALSTORAGESUPPORTENABLETEST' :
				// Use 'Enable special storage support' to enable Enterprise PFF and other special storage support and value of DEFAULT_SPECIALSTORAGESUPPORTDISABLEVALUE to disable.
				resTxt = 'Enable special storage support';
				//resTxt = 'Changing this violates License Agreement';
				break;
			case 'DEFAULT_SPECIALSTORAGESUPPORTDISABLEVALUE' :
				resTxt = 'Changing this violates License Agreement';
				break;
			case 'DEFAULT_SPECIALSTORAGESUPPORTDISABLEDALERT' :
				resTxt = 'Support for Zoomify Image File (PFF) storage and other special storage options is enabled only in the Zoomify Image Viewer included in the Zoomify HTML5 Enterprise edition.';
				break;

			case 'DEFAULT_ENTERPRISEPARAMETERSENABLETEST' :
				// Use 'Enable Enterprise parameters' to enable Enterprise parameter support and value of DEFAULT_ENTERPRISEPARAMETERSDISABLEVALUE to disable.
				resTxt = 'Enable Enterprise parameters';
				//resTxt = 'Changing this violates License Agreement';
				break;
			case 'DEFAULT_ENTERPRISEPARAMETERSDISABLEVALUE' :
				resTxt = 'Changing this violates License Agreement';
				break;
			case 'DEFAULT_ENTERPRISEPARAMETERSDISABLEDALERT' :
				resTxt = 'Support for this parameter is enabled only in the Zoomify Image Viewer included in the Zoomify HTML5 Enterprise edition: ';
				break;

			case 'DEFAULT_PARAMETERLISTTEXT' :
				resTxt = 'zImagePath,zImagePath2,zOnAnnotationReady,zOnReady,zInitialX,zInitialY,zInitialZoom,zMinZoom,zMaxZoom,zNavigatorVisible,zToolbarInternal,zToolbarVisible,zLogoVisible,zMinimizeVisible,zSliderVisible,zZoomButtonsVisible,zPanButtonsVisible,zResetVisible,zFullViewVisible,zFullScreenVisible,zFullPageVisible,zInitialFullPage,zSkinPath,zTooltipsVisible,zHelpVisible,zHelpPath,zHelpWidth,zHelpHeight,zHelpLeft,zHelpTop,zProgressVisible,zMessagesVisible,zZoomSpeed,zPanSpeed,zFadeInSpeed,zInteractive,zClickZoom,zDoubleClickZoom,zDoubleClickDelay,zClickPan,zMousePan,zKeys,zConstrainPan,zPanBuffer,zSmoothPan,zSmoothPanEasing,zSmoothPanGlide,zSmoothZoom,zSmoothZoomEasing,zAutoResize,zCanvas,zBaseZIndex,zDebug,zImageProperties,zNavigatorWidth,zNavigatorHeight,zNavigatorLeft,zNavigatorTop,zNavigatorFit,zNavigatorRectangleColor,zGalleryVisible,zGalleryWidth,zGalleryHeight,zGalleryLeft,zGalleryTop,zGalleryPosition,zToolbarPosition,zLogoCustomPath,zBookmarksGet,zBookmarksSet,zCopyrightPath,zWatermarkPath,zVirtualPointerVisible,zCrosshairsVisible,zZoomRectangle,zRulerVisible,zRulerListType,zRulerWidth,zRulerHeight,zRulerLeft,zRulerTop,zUnits,zUnitsPerImage,zPixelsPerUnit,zSourceMagnification,zMagnification,zMeasureVisible,zRotationVisible,zInitialRotation,zImageListPath,zScreensaver,zScreensaverSpeed,zTourPath,zTourListTitle,zComparisonPath,zSyncVisible,zInitialSync,zSlidePath,zSlideListTitle,zHotspotPath,zHotspotListTitle,zHotspotsDrawOnlyInView,zCaptionBoxes,zCaptionTextColor,zCaptionBackColor,zPolygonLineColor,zPolygonFillColor,zCaptionTextVisible,zCaptionBackVisible,zPolygonLineVisible,zPolygonFillVisible,zCoordinatesVisible,zGeoCoordinatesPath,zPreloadVisible,zOverlayPath,zOverlayJSONObject,zAnimationPath,zAnimationAxis,zAnimator,zAnimationFlip,zImageSetSliderVisible,zMouseWheel,zTilesPNG,zTileW,zTileH,zImageFiltersVisible,zInitialImageFilters,zBrightnessVisible,zContrastVisible,zSharpnessVisible,zBlurrinessVisible,zColorRedVisible,zColorGreenVisible,zColorBlueVisible,zColorRedRangeVisible,zColorGreenRangeVisible,zColorBlueRangeVisible,zGammaVisible,zGammaRedVisible,zGammaGreenVisible,zGammaBlueVisible,zHueVisible,zSaturationVisible,zLightnessVisible,zWhiteBalanceVisible,zNormalizeVisible,zEqualizeVisible,zNoiseVisible,zGrayscaleVisible,zThresholdVisible,zInversionVisible,zEdgesVisible,zSepiaVisible,zAnnotationPath,zAnnotationPanelVisible,zAnnotationXMLText,zLabelIconsInternal,zAnnotationJSONObject,zAnnotationsAddMultiple,zAnnotationsAutoSave,zSaveButtonVisible,zLabelClickSelect,zSimplePath,zNoPost,zNoPostDefaults,zUnsavedEditsTest,zAnnotationSort,zMaskVisible,zMaskFadeSpeed,zMaskClearOnUserAction,zFreehandVisible,zTextVisible,zIconVisible,zRectangleVisible,zPolygonVisible,zMarkupMode,zEditMode,zSlidestackPath,zSaveHandlerPath,zSaveImageHandlerPath,zSaveImageFull,zSaveImageFilename,zSaveImageFormat,zSaveImageCompression,zSaveImageBackColor,zTrackingPath,zTrackingEditMode,zTrackingAuto,zTrackingPanelVisible,zInitialTrackingOverlayVisible,zUserLogin,zUserNamePrompt,zUserPath,zUserPanelVisible,zServerIP,zServerPort,zTileHandlerPath,zIIIFScheme,zIIIFServer,zIIIFPrefix,zIIIFIdentifier,zIIIFRegion,zIIIFSize,zIIIFRotation,zIIIFQuality,zIIIFFormat,zImageW,zImageH,zFocal,zQuality';
				break;

			case 'DEFAULT_HEADERSTARTBYTE' :
				resTxt = '0';
				break;
			case 'DEFAULT_HEADERENDBYTEZIF' :
				resTxt = '8192';
				break;
			case 'DEFAULT_HEADERENDBYTEPFF' :
				resTxt = '1060';
				break;
			case 'DEFAULT_CHUNKSIZE' :
				// Number of offsets or byte counts to request when one is needed.  Offsets
				// are 8 bytes each while byte counts are 4 bytes each.
				resTxt = (Z.tileSource == 'ZoomifyImageFile') ? '1024' : '256';
				break;
			case 'DEFAULT_CHUNKSIZE-PFF' :
				resTxt = '256';
				break;

			case 'DEFAULT_TILEW' :
				resTxt = (Z.tileSource != 'IIIFImageServer') ? '256' : '512';
				break;
			case 'DEFAULT_TILEH' :
				resTxt = (Z.tileSource != 'IIIFImageServer') ? '256' : '512';
				break;
			case 'DEFAULT_IMAGESLOADINGMAX' :
				resTxt = '300';
				break;
			case 'DEFAULT_IMAGELOADTIMEOUT' :
				resTxt = '60000';	// 60 seconds.
				break;
			case 'DEFAULT_IMAGELOADQUEUEDELAY' :
				resTxt = '100';	// 1 tenth of a second.
				break;
			case 'DEFAULT_TIERSMAXSCALEUP' :
				resTxt = '1.15';
				break;
			case 'DEFAULT_TILESMAXCACHE' :
				// Alternative implementation: Reduce cache max on mobile devices. Currently not implemented because RAM less limited than bandwidth.
				//if (!Z.mobileDevice) {
					resTxt = '300';	// At average 10K / tile, average 3MB max cache - 30MB if stored uncompressed - plus whatever browser caches by default.
				//} else {
				//	resTxt = '50';	// At average 10K / tile, average 0.5MB max cache - 5MB if stored uncompressed - plus whatever browser caches by default.
				//}
				break;
			case 'DEFAULT_BACKFILLTHRESHOLD3' :
				resTxt = '6';
				break;
			case 'DEFAULT_BACKFILLDYNAMICADJUST' :
				resTxt = '3';
				break;
			case 'DEFAULT_BACKFILLTHRESHOLD2' :
				resTxt = '5';
				break;
			case 'DEFAULT_BACKFILLCHOICE2' :
				resTxt = '3';
				break;
			case 'DEFAULT_BACKFILLTHRESHOLD1' :
				resTxt = '3';
				break;
			case 'DEFAULT_BACKFILLCHOICE1' :
				resTxt = '2';
				break;
			case 'DEFAULT_BACKFILLCHOICE0' :
				resTxt = '0';
				break;
			case 'DEFAULT_PANBUFFER' :
				// Typical display area dimensions of 900 x 550 pixels requires 12 tiles (4 x 3)
				// if pan buffer set to 1 (no buffer), 24 tiles (6 x 4) if set to 1.5, and 40 (8 x 5)
				// if set to 2.  If zoomed between tiers needed tiles can double or triple (rare).
				resTxt = (!Z.mobileDevice) ? '1.5' : '1';
				// Enlarge tile buffer if rotation enabled.
				if (Z.rotationVisible) { resTxt = '2'; }
				break;
			case 'DEFAULT_PANBUFFERUNCONVERTED' :
				// Larger buffer area used if viewing unconverted image and not on mobile device. Buffer constrained in function
				// setSizeAndPosition based on Z.imageSet and whether browser is Firefox, general browser limit, and image size.
				resTxt = (!Z.mobileDevice) ? '10' : (Z.rotationVisible) ? '2' : '1';
				break;
			case 'DEFAULT_PAN_BUFFERSIZEMAXBROWSER' :
				resTxt = '10000';
				break;
			case 'DEFAULT_PAN_BUFFERSIZEMAXFIREFOX' :
				resTxt = '4000';
				break;
			case 'DEFAULT_PAN_BUFFERSIZEMAXMOBILE' :
				resTxt = '3000';
				break;
			case 'DEFAULT_PAN_BUFFERSIZEMAXIMAGESET' :
				resTxt = '1000';
				break;
			case 'DEFAULT_BACKFILLBUFFER' :
				// Implemented for images with 7 or more tiers where tier 3 backfill is insufficient to hide tile gaps and where deep zoom would
				// cause scaling of tier 3 to exceed maximum size supported by browsers. See additional notes in function scaleTierToZoom.
				reTxt = (!Z.mobileDevice) ? '2' : '1';
				break;
			case 'DEFAULT_CANVAS' :  // '0'=false, '1'=true.
				resTxt = '1';
				break;
			case 'DEFAULT_BASEZINDEX' :  // '2000' default, range -2147483648 to +2147483647. Locate affected Viewer elements by searching for variable Z.baseZIndex.
				resTxt = '2000';
				break;

			case 'DEFAULT_VALIDATEVIEWRETRYLIMIT' :
				resTxt = '2';
				break;
			case 'DEFAULT_VALIDATEVIEWRETRYDELAY' :
				resTxt = '1000';
				break;

			case 'DEFAULT_DEBUG' :  // '0'=disable, '1'=enable, '2'=enable with tile name labels and tracing, '3'=enable without tile names or tracing but with validate view tile loading values.
				resTxt = '0';
				break;

			case 'DEFAULT_MOUSECLICKTHRESHOLDVIEWPORT' :
				resTxt = 4;
				break;
			case 'DEFAULT_MOUSECLICKTHRESHOLDTIMEVIEWPORT' :
				resTxt = 500;
				break;
			case 'DEFAULT_MOUSECLICKTHRESHOLDHOTSPOT' :
				resTxt = 4;
				break;
			case 'DEFAULT_TOUCHTAPTHRESHOLDVIEWPORT' :
				resTxt = (!Z.mobileDevice) ? 4 : 6;
				break;
			case 'DEFAULT_TOUCHTAPTHRESHOLDTIMEVIEWPORT' :
				resTxt = 500;
				break;
			case 'DEFAULT_MOUSECLICKTHRESHOLDNAVIGATOR' :
				resTxt = 4;
				break;
			case 'DEFAULT_TOUCHTAPTHRESHOLDNAVIGATOR' :
				resTxt = (!Z.mobileDevice) ? 3 : 6;
				break;

			case 'DEFAULT_PANSPEED' :
				resTxt = '5'; // '1'=slow to '10'=fast, default is '5'.
				break;
			case 'DEFAULT_PANSTEPDISTANCE' :
				resTxt = '10'; // 5 * 10 = 50 pixel step per 0.1 second interval.
				break;
			case 'DEFAULT_ZOOMSPEED' :
				resTxt = '5'; // '1'=slow to '10'=fast, default is '5'.
				break;
			case 'DEFAULT_ZOOMSTEPDISTANCE' :
				resTxt = '0.02'; // 5 * 0.02 = .1 percent step default.
				break;
			case 'DEFAULT_ZAPSTEPDURATION' :
				resTxt = '30';  // Milliseconds.
				break;
			case 'DEFAULT_ZAPTVSTEPS' :
				resTxt = '20'; // 800 / 20 = 0.04 seconds per step default with variable distance per step.
				break;
			case 'DEFAULT_ZAPTVDURATION' :
				resTxt = '800'; // 800 / 20 = 0.04 seconds per step default with variable distance per step.
				break;
			case 'DEFAULT_CLICKZOOMTIERSKIPTHRESHOLD' :
				resTxt = '0.2';  // % of zoom delta from exact next tier.
				break;
			case 'DEFAULT_ROTATIONSTEPDEGREES' :
				resTxt = '1';  // Degrees.
				break;
			case 'DEFAULT_ROTATIONSTEPDURATION' :
				resTxt = '1';  // Milliseconds.
				break;
			case 'DEFAULT_GESTURETESTDURATION' :
				resTxt = '10';  // Milliseconds.
				break;

			case 'DEFAULT_AUTORESIZESKIPDURATION' :
				resTxt = '10'; // Milliseconds.
				break;

			case 'DEFAULT_MOUSEWHEEL' :
				resTxt = '1';  // '0'=disabled, '1'=zoom priority (default), '2'=image set priority.
				break;
			case 'DEFAULT_MOUSEWHEELANIMATION' :
				resTxt = '1';  // '0'=disabled, '1'=zoom priority (default), '2'=image set priority.
				break;
			case 'DEFAULT_MOUSEWHEELSLIDESTACK' :
				resTxt = '1';  // '0'=disabled, '1'=zoom priority (default), '2'=image set priority.
				break;
			case 'DEFAULT_MOUSEWHEELCOMPLETEDURATION' :
				resTxt = '300'; // Milliseconds.
				break;
			case 'DEFAULT_FADEINSPEED' :
				resTxt = '5'; // '1'=slow to '10'=fast, default is '5'.
				break;
			case 'DEFAULT_FADEINSTEP' :
				resTxt = '0.067'; // 0.067 * default fade in speed of 5 = 0.335 x 3 steps to get over 1, at 50 milliseconds per step = 0.2 seconds to fade-in.
				break;

			case 'DEFAULT_KEYS' :
				resTxt = '1'; // '0'=disable, '1'=enable (default).
				break;
			case 'DEFAULT_MOUSEPAN' :
				resTxt = '1'; // '0'=disable, '1'=enable (default).
				break;
			case 'DEFAULT_CLICKPAN' :
				resTxt = '1'; // '0'=disable, '1'=enable (default).
				break;
			case 'DEFAULT_CLICKZOOM' :
				resTxt = '1'; // '0'=disable, '1'=enable (default).
				break;
			case 'DEFAULT_DOUBLECLICKZOOM' :
				resTxt = '1'; // '0'=disable, '1'=enable (default).
				break;
			case 'DEFAULT_DOUBLECLICKDELAY' :
				resTxt = '250'; // Milliseconds.
				break;
			case 'DEFAULT_CONSTRAINPAN' :
				resTxt = '1'; // '0'=disable, '1'=enable (default).
				break;
			case 'DEFAULT_CONSTRAINPANLIMIT' :
				resTxt = '2'; // '0'=false, '1'=loose (constrain image center to viewport edge), '2'=relaxed (default, constrain trailing edge to viewport center), '3'=strict (constrain trailing edge of image to far edge of display and center image when zoomed-out).
				break;
			case 'DEFAULT_CONSTRAINPANSTRICT' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_SMOOTHPAN' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_SMOOTHPANEASING' :
				resTxt = '2'; // '1'=direct, '2'=fluid (default), '3'=gentle, '4'=relaxed, '5'=loose;
				break;
			case 'DEFAULT_SMOOTHPANGLIDE' :
				resTxt = '2'; // '1'=none, '2'=fluid (default), '3'=gentle, '4'=relaxed, '5'=loose;
				break;
			case 'DEFAULT_SMOOTHZOOM' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_SMOOTHZOOMEASING' :
				resTxt = '2'; // '1'=direct, '2'=fluid (default), '3'=gentle, '4'=relaxed;
				break;

			case 'DEFAULT_INITIALX' :
				resTxt = null;
				break;
			case 'DEFAULT_INITIALY' :
				resTxt = null;
				break;
			case 'DEFAULT_INITIALZOOM' :
				resTxt = null; // '0.01' to '0.5' recommended range, default is null (zoom-to-fit view area).
				break;
			case 'DEFAULT_MINZOOM' :
				resTxt = null; // '0.01' to '0.5' recommended range, default is null (zoom-to-fit view area).
				break;
			case 'DEFAULT_MAXZOOM' :
				resTxt = '1'; // '0.5' to '3' recommended range, default is '1' (100%).
				break;

			case 'DEFAULT_BACKGROUNDCOLOR' :
				resTxt = '#FBFAFA';
				break;
			case 'DEFAULT_BACKGROUNDCOLORNOALPHA' :
				resTxt = '#FBFAFA';
				break;
			case 'DEFAULT_BACKGROUNDCOLORLIGHT' :
				resTxt = '#FEFEFE';
				break;
			case 'DEFAULT_BACKGROUNDALPHA' :
				resTxt = '0.75';
				break;
			case 'DEFAULT_BACKGROUNDSMALLDALPHA' :
				resTxt = '0.75';
				break;
			case 'DEFAULT_BUTTONBORDERCOLOR' :
				resTxt = '#C0C0C0';
				break;

			case 'DEFAULT_SKINXMLFILE' :
				resTxt = 'skinFiles.xml';
				break;
			case 'DEFAULT_SKINXMLPATH' :
				resTxt = 'Assets/Skins/Default';
				break;
			case 'DEFAULT_SKINMODE' :
				resTxt = '0'; // '0'=autoswitch if mobile device (default), '1'=always standard, '2'= always large.
				break;

			case 'DEFAULT_NAVIGATORVISIBLE' :
				resTxt = '2';  // '0'=hide, '1'=show, '2'=show/hide (default), '3'=hide/show.
				break;
			case 'DEFAULT_NAVIGATORWIDTH' :
				resTxt = '150'; // Pixels.
				break;
			case 'DEFAULT_NAVIGATORHEIGHT' :
				resTxt = '100'; // Pixels.
				break;
			case 'DEFAULT_NAVIGATORLEFT' :
				resTxt = '-1'; // Pixels from left viewport edge.
				break;
			case 'DEFAULT_NAVIGATORTOP' :
				resTxt = '-1'; // Pixels from top viewport edge.
				break;
			case 'DEFAULT_NAVIGATORFIT' :
				resTxt = null;
				break;
			case 'DEFAULT_NAVIGATORRECTANGLECOLOR' :
				resTxt = '#0000FF';
				break;
			case 'DEFAULT_NAVIGATORBORDERCOLOR' : // For Comparison viewing.
				resTxt = '#FFFFFF';
				break;

			case 'DEFAULT_GALLERYVISIBLE' :
				resTxt = (Z.slideshow) ? '2': '0';  // '0'=hide (default if not slideshow), '1'=show, '2'=show/hide (default if slideshow), '3'=hide/show.
				break;
			case 'DEFAULT_GALLERYWIDTH' :
				resTxt = '-1'; // Pixels.
				break;
			case 'DEFAULT_GALLERYHEIGHT' :
				resTxt = '70'; // Pixels.
				break;
			case 'DEFAULT_GALLERYMARGIN' :
				resTxt = '1'; // Pixels.
				break;
			case 'DEFAULT_GALLERYLEFT' :
				resTxt = '0'; // Pixels from left viewport edge.
				break;
			case 'DEFAULT_GALLERYTOP' :
				resTxt = '-1'; // Pixels from top viewport edge.
				break;
			case 'DEFAULT_GALLERYPOSITION' :
				resTxt = '1'; // '0'=top, '1'=bottom (default).
				break;
			case 'DEFAULT_GALLERYBACKGROUNDALPHA' :
				resTxt = '0.5';
				break;
			case 'DEFAULT_GALLERYBACKGROUNDCOLOR' :
				resTxt = '#696969';
				break;
			case 'DEFAULT_GALLERYBACKGROUNDCOLORNOALPHA' :
				resTxt = '#696969';
				break;
			case 'DEFAULT_GALLERYRECTANGLECOLOR' :
				resTxt = '#DDDDDD';
				break;

			case 'DEFAULT_TOOLBARVISIBLE' :
				resTxt = '4';  // '0'=hide, '1'=show, '2'=show/hide (default), '3'=hide/show, '4' & '5'=same as 2 and 3 but minimize rather than hiding. 8 hides toolbar and keeps it hidden (supports external toolbar with editing functions fully enabled). Note: minimize forced if setting is 2 or 3 and browser is on mobile device (no mouse-over).
				break;
			case 'DEFAULT_TOOLBARPOSITION' :
				resTxt = '1'; // '0'=top, '1'=bottom (default).
				break;
			case 'DEFAULT_TOOLTIPSVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;

			case 'DEFAULT_HELPVISIBLE' :
				resTxt = '1'; // '0'=hide, '1'=show (default), '2'=hide toolbar help, show annotation & markup help, '3'=reverse.
				break;

			case 'DEFAULT_LOGOVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_LOGOCUSTOMPATH' :
				resTxt = null;
				break;
			case 'DEFAULT_MINIMIZEVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_SLIDERZOOMVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_SLIDERTESTDURATIONZOOM' :
				resTxt = '10';  // Milliseconds.
				break;

			case 'DEFAULT_ZOOMBUTTONSVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_PANBUTTONSVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_RESETVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;

			case 'DEFAULT_FULLVIEWVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_FULLSCREENVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_FULLVIEWBACKCOLOR' :
				resTxt = 'white';
				break;
			case 'DEFAULT_FULLPAGEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_INITIALFULLPAGE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_BOOKMARKSGET' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_BOOKMARKSSET' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_VIRTUALPOINTERPATH' :
				resTxt = 'Assets/VirtualPointer/virtualPointer.png';
				break;

			case 'DEFAULT_ZOOMRECTANGLE' :
				var comparison = (Z.comparison || (Z.imagePath !== null && Z.imagePath.indexOf('zComparisonPath') != -1)
					|| (typeof Z.parameters !== 'undefined' && Z.parameters !== null
					&& typeof Z.parameters.zComparisonPath !== 'undefined'
					&& (typeof Z.parameters.zZoomRectangle === 'undefined' || Z.parameters.zZoomRectangle != 0)));
				resTxt = (!Z.mobileDevice && !comparison && (Z.proParamsEnabled || Z.enterpriseParamsEnabled)) ? '1' : '0'; // '0'=false (default for mobile devices and Express edition), '1'=true (default for Pro and Enterprise editions).

				// DEV NOTE: Blocking zoom rectangle if in comparison mode to avoid update loop.
				//resTxt = (Z.proParamsEnabled || Z.enterpriseParamsEnabled) ? '1' : '0'; // '0'=false (default for Express edition), '1'=true (default for Pro and Enterprise editions).
				break;

			case 'DEFAULT_MEASUREVISIBLE' :
				// '0'=false (default), '1'=true.  False is default unless in markup or edit mode.
				if (typeof Z.parameters !== 'undefined' && Z.parameters !== null
					&& (typeof Z.parameters.zMeasureVisible === 'undefined' || Z.parameters.zMeasureVisible != '0')
					&& ((typeof Z.parameters.zMarkupMode !== 'undefined' && (Z.parameters.zMarkupMode == '1' || Z.parameters.zMarkupMode == '2'))
					|| (typeof Z.parameters.zEditMode !== 'undefined' && (Z.parameters.zEditMode == '1' || Z.parameters.zEditMode == '2')))) {
						resTxt = '1';
				} else {
					resTxt = '0';
				}
				break;

			case 'DEFAULT_FULLVIEWEXITEXTERNALBUTTONCOLOR' :
				resTxt = '	#F8F8F8'; // Very light gray.
				break;

			case 'DEFAULT_ROTATIONVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_ROTATIONFREE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_INITIALR' :
				resTxt = '0'; // Degrees
				break;

			case 'DEFAULT_PROGRESSVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_PROGRESSDURATION' :
				resTxt = '500';  // Milliseconds.
				break;
			case 'DEFAULT_PROGRESSTEXT' :
				resTxt = ' ';  // Blank.
				break;
			case 'DEFAULT_PROGRESSTEXTCOLOR' :
				resTxt = '#000000'; // Black.
				break;
			case 'DEFAULT_MESSAGESVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;

			case 'DEFAULT_COPYRIGHTSCREENCOLOR' :
				resTxt = '#D3D3D3';
				break;
			case 'DEFAULT_COPYRIGHTBUTTONCOLOR' :
				resTxt = '#FFFFFF';
				break;

			case 'DEFAULT_WATERMARKALPHA' :
				resTxt = '0.6';
				break;
			case 'DEFAULT_WATERMARKMINSCALE' :
				resTxt = '0.33';
				break;
			case 'DEFAULT_WATERMARKSPANW' :
				resTxt = '512'; // Horizontal image pixels per watermark.
				break;
			case 'DEFAULT_WATERMARKSPANH' :
				resTxt = '384'; // Vertical image pixels per watermark.
				break;

			case 'DEFAULT_VIRTUALPOINTERVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_CROSSHAIRSVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_RULERVISIBLE' :
				resTxt = '0';  // '0'=hide (default), '1'=show, '2'=show/hide, '3'=hide/show.
				break;
			case 'DEFAULT_RULERLISTTYPE' :
				resTxt = '2'; // '0'=hide, '1'=magnifications, '2'=percents (default).
				break;
			case 'DEFAULT_RULERTEXTFONTSIZE' :
				resTxt = '10';
				break;
			case 'DEFAULT_SCALEBARCOLOR' :
				resTxt = '#696969';
				break;
			case 'DEFAULT_RULERWIDTH' :
				resTxt = '150'; // Pixels.
				break;
			case 'DEFAULT_RULERHEIGHT' :
				resTxt = '30'; // Pixels.
				break;
			case 'DEFAULT_RULERLEFT' :
				resTxt = '-1';  // Pixels from left viewport edge.
				break;
			case 'DEFAULT_RULERTOP' :
				resTxt = '-1';  // Pixels from top viewport edge.
				break;
			case 'DEFAULT_SOURCEMAGNIFICATION' :
				resTxt = '40'; // Options: '2.5', '5', '10', '20', '40' (default), '60', '100'.
				break;
			case 'DEFAULT_UNITS' :
				resTxt = 'pixels'; // Options: 'Ym', 'Zm', 'Em', 'Pm', 'Tm', 'Gm', 'Mm', 'km', 'hm', 'dam', 'm', 'dm', 'cm', 'mm' (default), 'um', 'nm', 'pm', 'fm', 'am', 'zm', 'ym'.
				break;

			case 'DEFAULT_MEASURECAPTIONWIDTH' :
				resTxt = '170';
				break;
			case 'DEFAULT_MEASURECAPTIONHEIGHT' :
				resTxt = '12';
				break;
			case 'DEFAULT_MEASURECAPTIONBACKALPHA' :
				resTxt = '0.3';
				break;
			case 'DEFAULT_MEASURECAPTIONFONTSIZE' :
				resTxt = '11';
				break;

			case 'DEFAULT_COORDINATESVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_GEOCOORDINATESVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_PRELOADVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_SCREENSAVERSPEED' :
				resTxt = '5'; // '1'=slow to '10'=fast, default is '5'.
				break;

			case 'DEFAULT_MASKFADESPEED' :
				resTxt = '5'; // '1'=slow to '10'=fast, default is '5'.
				break;
			case 'DEFAULT_MASKFADESTEP' :
				resTxt = '0.05'; // 0.05 * default transition speed of 2 = 0.1 x 10 steps to get over 1, at 50 milliseconds per step = 0.5 seconds each to transition in out.
				break;
			case 'DEFAULT_MASKCLEARONUSERACTION' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;

			case 'DEFAULT_IMAGELISTXMLFILE' :
				resTxt = 'imageList.xml';
				break;
			case 'DEFAULT_IMAGELISTPOSITION' :
				resTxt = '2';
				break;
			case 'DEFAULT_IMAGELISTSOURCE' :
				resTxt = 'NAME';
				break;
			case 'DEFAULT_IMAGELISTWIDTH' :
				resTxt = '200';
				break;

			case 'DEFAULT_TOURSXMLFILE' :
				resTxt = 'destinations.xml';
				break;
			case 'DEFAULT_TOURAUTOSTART' :
				resTxt = true;
				break;
			case 'DEFAULT_TOURAUTOLOOP' :
				resTxt = true;
				break;

			case 'DEFAULT_COMPARISONXMLFILE' :
				resTxt = 'comparison.xml';
				break;
			case 'DEFAULT_COMPARISONSYNCVISIBLE' :
				resTxt = '1';
				break;
			case 'DEFAULT_COMPARISONINITIALSYNC' :
				resTxt = '1';
				break;
			case 'DEFAULT_COMPARISONSYNC' :
				resTxt = '1';
				break;
				break;
			case 'DEFAULT_TOOLBARLABELFONTSIZE' :
				resTxt = '11';
				break;

			case 'DEFAULT_SLIDESXMLFILE' :
				resTxt = 'slides.xml';
				break;
			case 'DEFAULT_SLIDESHOWAUTOSTART' :
				resTxt = true;
				break;
			case 'DEFAULT_SLIDESHOWAUTOLOOP' :
				resTxt = true;
				break;
			case 'DEFAULT_SLIDELISTSOURCE' :
				resTxt = 'NAME';
				break;
			case 'DEFAULT_SLIDELISTWIDTH' :
				resTxt = '200';
				break;
			case 'DEFAULT_SLIDELISTPOSITION' :
				resTxt = '2';
				break;
			case 'DEFAULT_SLIDETRANSITIONSPEED' :
				resTxt = '2'; // '1'=slow to '10'=fast, default is '5'.
				break;
			case 'DEFAULT_SLIDETRANSITIONSTEP' :
				resTxt = '0.05'; // 0.05 * default transition speed of 2 = 0.1 x 10 steps to get over 1, at 50 milliseconds per step = 0.5 seconds each to transition in out.
				break;

			case 'DEFAULT_HOTSPOTSXMLFILE' :
				resTxt = 'hotspots.xml';
				break;
			case 'DEFAULT_HOTSPOTCAPTIONPADDING' :
				resTxt = '6';
				break;
			case 'DEFAULT_HOTSPOTCAPTIONPADDINGCANVAS' :
				resTxt = '12';
				break;
			case 'DEFAULT_MINHOTSPOTCAPTIONPADDING' :
				resTxt = '2';
				break;
			case 'DEFAULT_MAXHOTSPOTCAPTIONPADDING' :
				resTxt = '7';
				break;
			case 'DEFAULT_HOTSPOTCAPTIONFONTSIZE' :
				resTxt = '14';
				break;
			case 'DEFAULT_MINHOTSPOTCAPTIONFONTSIZE' :
				resTxt = '3';
				break;
			case 'DEFAULT_MAXHOTSPOTCAPTIONFONTSIZE' :
				resTxt = '14';
				break;
			case 'DEFAULT_FONTTOPIXELSCONVERSIONFACTOR' :
				resTxt = '1.8';
				break;
			case 'DEFAULT_HOTSPOTSINITIALVISIBILITY' :
				resTxt = true;
				break;
			case 'DEFAULT_HOTSPOTSMINSCALE' :
				resTxt = '0.2';
				break;
			case 'DEFAULT_HOTSPOTSMAXSCALE' :
				resTxt = '2';
				break;
			case 'DEFAULT_HOTSPOTLISTSOURCE' :
				resTxt = 'NAME';
				break;
			case 'DEFAULT_HOTSPOTLISTWIDTH' :
				resTxt = '200';
				break;
			case 'DEFAULT_HOTSPOTLISTPOSITION' :
				resTxt = '2';
				break;

			case 'DEFAULT_IMAGEFILTERS' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_INITIALMAGEFILTERS' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_BRIGHTNESSVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_CONTRASTVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_SHARPNESSVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_BLURRINESSVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_COLORREDVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_COLORGREENVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_COLORBLUEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_COLORREDRANGEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_COLORGREENRANGEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_COLORBLUERANGEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_GAMMAVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_GAMMAREDVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_GAMMAGREENVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_GAMMABLUEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_HUEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_SATURATIONVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_LIGHTNESSVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_WHITEBALANCEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_NORMALIZEVISIBLE' : // DEV NOTE: Normalize filter disabled pending changes.
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_EQUALIZEVISIBLE' : // DEV NOTE: Equalize filter disabled pending changes.
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_NOISEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_GRAYSCALEVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_THRESHOLDVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_INVERSIONVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_EDGESVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_SEPIAVISIBLE' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_SLIDERTESTDURATIONFILTER' :
				resTxt = '10';  // Milliseconds.
				break;
			case 'DEFAULT_IMAGEFILTERLISTWIDTH' :
				resTxt = '150';
				break;
			case 'DEFAULT_IMAGEFILTERPANELLABELFONTSIZE' :
				resTxt = '11';
				break;
			case 'DEFAULT_IMAGEFILTERPANELTEXTFONTSIZE' :
				resTxt = '11';
				break;
			case 'DEFAULT_IMAGEFILTERTEXTPADDINGSMALL' :
				resTxt = '2';
				break;

			case 'DEFAULT_FREEHANDVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_TEXTVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_ICONVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_RECTANGLEVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_POLYGONVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_ANNOTATIONPANELVISIBLE' :
				resTxt = '2';  // '0'=hide, '1'=show, '2'=show/hide (default), '3'=hide/show.
				break;
			case 'DEFAULT_LABELICONSINTERNAL' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_ANNOTATIONSADDMULTIPLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_ANNOTATIONSAUTOSAVE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_ANNOTATIONSAVEBUTTONVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_LABELCLICKSELECT' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_ANNOTATIONSXMLFILE' :
				resTxt = 'annotations.xml';
				break;
			case 'DEFAULT_ANNOTATIONSJSONFILE' :
				resTxt = 'annotations.json';
				break;
			case 'DEFAULT_ANNOTATIONMEDIA' :
				resTxt = (Z.labelIconsInternal) ? 'circle' : 'circle.png';
				break;
			case 'DEFAULT_ANNOTATIONMEDIATYPE' :
				resTxt = 'icon';
				break;
			case 'DEFAULT_ANNOTATIONSXMLSAVEHANDLERNAME1' :
				resTxt = 'save';
				break;
			case 'DEFAULT_ANNOTATIONSXMLSAVEHANDLERNAME2' :
				resTxt = 'upload';
				break;
			case 'DEFAULT_ANNOTATIONSINITIALVISIBILITY' :
				resTxt = true;
				break;
			case 'DEFAULT_ANNOTATIONPANELWIDTH' :
				resTxt = '220';
				break;
			case 'DEFAULT_ANNOTATIONPANELHEIGHT' :
				resTxt = '257';
				break;
			case 'DEFAULT_ANNOTATIONPANELLABELFONTSIZE' :
				resTxt = '11';
				break;
			case 'DEFAULT_ANNOTATIONPANELLISTFONTSIZE' :
				resTxt = '11';
				break;
			case 'DEFAULT_ANNOTATIONPANELTEXTFONTSIZE' :
				resTxt = '11';
				break;
			case 'DEFAULT_ANNOTATIONTEXTPADDINGSMALL' :
				resTxt = '2';
				break;
			case 'DEFAULT_ANNOTATIONTEXTPADDING' :
				resTxt = '3';
				break;
			case 'DEFAULT_ANNOTATIONLABELWIDTH' :
				resTxt = '50';
				break;
			case 'DEFAULT_ANNOTATIONLABELTEXTWIDTH' :
				resTxt = '122';
				break;
			case 'DEFAULT_ANNOTATIONLISTWIDTH' :
				resTxt = '160';
				break;
			case 'DEFAULT_ANNOTATIONLISTNARROWWIDTH' :
				resTxt = '88';
				break;
			case 'DEFAULT_ANNOTATIONMARGIN' :
				resTxt = '10';
				break;
			case 'DEFAULT_ANNOTATIONCOMMENTHEIGHT' :
				resTxt = '82';
				break;
			case 'DEFAULT_ANNOTATIONNOTEHEIGHT' :
				resTxt = '82';
				break;
			case 'DEFAULT_ANNOTATIONPOIVISIBILITY' :
				resTxt = '0';
				break;
			case 'DEFAULT_ANNOTATIONLABELVISIBILITY' :
				resTxt = '1';
				break;
			case 'DEFAULT_ANNOTATIONNOTEVISIBILITY' :
				resTxt = '0';
				break;
			case 'DEFAULT_ANNOTATIONCOMMENTVISIBILITY' :
				resTxt = '1';
				break;

			case 'DEFAULT_LABELSCALESTEPDISTANCE' :
				resTxt = '0.02'; // 5 * 0.02 = .1 percent step default.
				break;
			case 'DEFAULT_LABELSCALESTEPDURATION' :
				resTxt = '30';  // Milliseconds.
				break;

			case 'DEFAULT_LABELICONWIDTH' :
				resTxt = '200';
				break;
			case 'DEFAULT_LABELICONHEIGHT' :
				resTxt = '200';
				break;

			case 'DEFAULT_ICONLINEWIDTH' :
				resTxt = 3;
				break;

			case 'DEFAULT_POLYGONLINEWIDTH' :
				resTxt = 2;
				break;
			case 'DEFAULT_POLYGONALPHA' :
				resTxt = 0.3;
				break;
			case 'DEFAULT_POLYGONVIEWBUFFER' :
				resTxt = 300;
				break;
			case 'DEFAULT_CONTROLPOINTLINEWIDTH' :
				resTxt = '1';
				break;
			case 'DEFAULT_CONTROLPOINTSTROKECOLOR' :
				resTxt = '#FFFFFF';
				break;
			case 'DEFAULT_CAPTIONTEXTCOLOR' :
				resTxt = '#FFFFFF';
				break;
			case 'DEFAULT_CAPTIONBACKCOLOR' :
				resTxt = '#000000';
				break;
			case 'DEFAULT_POLYGONLINEWIDTHFREEHAND' :
				resTxt = 2;
				break;
			case 'DEFAULT_FIRSTCONTROLPOINTFILLCOLOR' :
				resTxt = '#FFFFFF';
				break;
			case 'DEFAULT_STANDARDCONTROLPOINTFILLCOLOR' :
				resTxt = '#999999';
				break;
			case 'DEFAULT_CONTROLPOINTRADIUS' :
				resTxt = '10';
				break;

			case 'DEFAULT_TRACKINGPANELVISIBLE' :
				resTxt = '2';  // '0'=hide, '1'=show, '2'=show/hide (default), '3'=hide/show.
				break;
			case 'DEFAULT_INITIALTRACKINGOVERLAYVISIBLE' :
				resTxt = '1';  // '0'=hide, '1'=show (default).
				break;
			case 'DEFAULT_TRACKINGPANELWIDTH' :
				resTxt = '350';
				break;
			case 'DEFAULT_TRACKINGPANELHEIGHT' :
				resTxt = '163';
				break;
			case 'DEFAULT_TRACKINGPANELLABELFONTSIZE' :
				resTxt = '12';
				break;
			case 'DEFAULT_TRACKINGPANELLISTFONTSIZE' :
				resTxt = '12';
				break;
			case 'DEFAULT_TRACKINGPANELTEXTFONTSIZE' :
				resTxt = '11';
				break;
			case 'DEFAULT_TRACKINGTEXTPADDINGSMALL' :
				resTxt = '2';
				break;
			case 'DEFAULT_TRACKINGTEXTPADDING' :
				resTxt = '3';
				break;
			case 'DEFAULT_TRACKINGLABELWIDTH' :
				resTxt = '50';
				break;
			case 'DEFAULT_TRACKINGLABELTEXTWIDTH' :
				resTxt = '122';
				break;
			case 'DEFAULT_TRACKINGLISTWIDTH' :
				resTxt = '160';
				break;
			case 'DEFAULT_TRACKINGLISTNARROWWIDTH' :
				resTxt = '88';
				break;
			case 'DEFAULT_TRACKINGMARGIN' :
				resTxt = '10';
				break;
			case 'DEFAULT_TRACKINGALPHA' :
				resTxt = '0.75';
				break;

			case 'DEFAULT_USERPANELVISIBLE' :
				resTxt = '0';  // '0'=hide (default), '1'=show, '2'=show/hide, '3'=hide/show.
				break;
			case 'DEFAULT_USERPANELWIDTH' :
				resTxt = '200';
				break;
			case 'DEFAULT_USERPANELHEIGHT' :
				resTxt = '85';
				break;
			case 'DEFAULT_USERPANELLABELFONTSIZE' :
				resTxt = '12';
				break;
			case 'DEFAULT_USERPANELLISTFONTSIZE' :
				resTxt = '12';
				break;
			case 'DEFAULT_USERLABELWIDTH' :
				resTxt = '50';
				break;

			case 'DEFAULT_IMAGESETLISTSOURCE' :
				resTxt = 'NAME';
				break;
			case 'DEFAULT_IMAGESETLISTWIDTH' :
				resTxt = '222';
				break;
			case 'DEFAULT_IMAGESETLISTPOSITION' :
				resTxt = '2';
				break;
			case 'DEFAULT_IMAGESETSLIDERVISIBLE' :
				resTxt = '1'; // '0'=false, '1'=true (default).
				break;
			case 'DEFAULT_SLIDERTESTDURATIONIMAGESET' :
				resTxt = '10';  // Milliseconds.
				break;

			case 'DEFAULT_OVERLAYSVISIBLE' :
				resTxt = '1';
				break;

			case 'DEFAULT_ANIMATIONOPTIMALMOTIONIMAGES' :
				resTxt = '30';
				break;
			case 'DEFAULT_ANIMATIONOPTIMALPOSITIONDELTA' :
				resTxt = '50';
				break;
			case 'DEFAULT_ANIMATIONAXIS' :
				resTxt = 'horizontal'; // Supported values: 'horizontal' (default), 'vertical'.
				break;
			case 'DEFAULT_ANIMATOR' :
				resTxt = 'motion';
				break;
			case 'DEFAULT_ANIMATIONFLIP' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;

			case 'DEFAULT_SAVEIMAGEFULL' :
				resTxt = '0'; // '0'=false (default), '1'=true.
				break;
			case 'DEFAULT_SAVEIMAGEFILENAME' :
				resTxt = 'zoomifySavedImage';
				break;
			case 'DEFAULT_SAVEIMAGEFORMAT' :
				resTxt = 'jpg'; // Supported values: 'png' and 'jpg' (default).
				break;
			case 'DEFAULT_SAVEIMAGECOMPRESSION' :
				resTxt = '0.8'; // Supported values: '0.1' to '1.0', default '0.8'.
				break;
			case 'DEFAULT_SAVEIMAGEBACKCOLOR' :
				resTxt = '#FFFFFF';
				break;
			case 'DEFAULT_SAVEIMAGELABELMARGIN' :
				resTxt = '50';
				break;

			case 'DEFAULT_TRACKINGXMLFILE' :
				resTxt = 'tracking.xml';
				break;
			case 'DEFAULT_TRACKINGPANELPOSITION' :
				resTxt = '2';
				break;

			case 'DEFAULT_USERXMLFILE' :
				resTxt = 'users.xml';
				break;

			case 'DEFAULT_MESSAGESCREENCOLOR' :
				resTxt = 'lightgray';
				break;
			case 'DEFAULT_MESSAGEBUTTONCOLOR' :
				resTxt = 'white';
				break;
			case 'DEFAULT_MESSAGEDURATIONLONG' :
				resTxt = '5000';
				break;
			case 'DEFAULT_MESSAGEDURATIONSTANDARD' :
				resTxt = '3000';
				break;
			case 'DEFAULT_MESSAGEDURATIONSHORT' :
				resTxt = '1500';
				break;
			case 'DEFAULT_MESSAGEDURATIONVERYSHORT' :
				resTxt = '750';
				break;

			case 'DEFAULT_COORDINATESSCREENCOLOR' :
				resTxt = 'lightgray';
				break;

			case 'DEFAULT_TRACEDISPLAYTEXTFONTSIZE' :
				resTxt = '11';
				break;
			case 'DEFAULT_TRACEDISPLAYTEXTPADDINGSMALL' :
				resTxt = '2';
				break;
			case 'DEFAULT_TRACEDISPLAYSCREENCOLOR' :
				resTxt = '#D3D3D3';
				break;
			case 'DEFAULT_TRACEDISPLAYBUTTONCOLOR' :
				resTxt = '#FFFFFF';
				break;

			case 'DEFAULT_FOCAL' :
				resTxt = '1';
				break;
			case 'DEFAULT_QUALITY' :
				resTxt = '55';
				break;

			case 'DEFAULT_IMAGESETXMLFILE' :
				resTxt = (Z.animation) ? 'animation.xml' : (Z.overlay) ? 'overlays.xml' : 'slidestack.xml';
				break;

			case 'ALERT_POLYGONSREQUIRECANVAS' :
				resTxt = 'Displaying or editing polygon hotspots requires a browser that supports the HTML5 canvas feature.';
				break;
			case 'ALERT_ROTATIONREQUIRESNEWERBROWSER' :
				resTxt = 'Rotation requires a newer browser version. Please consider upgrading to the current release of your browser.';
				break;
			case 'ALERT_ZIFREQUIRESNEWERBROWSER' :
				resTxt = 'Viewing Zoomify Images stored in the ZIF format requires a newer browser version. Please consider upgrading to the current release of your browser.';
				break;


			case 'ALERT_HOWTOHELPREMINDER' :
				resTxt = '\nClick the \'?\' button for help.';
				break;

			case 'ALERT_LOADINGANNOTATIONS' :
				resTxt = '\nLoading annotations...';
				break;
			case 'ALERT_HOWTOCREATEFIRSTLABELSHORT' :
				resTxt = 'Click a button to\npick a label type';
				break;
			case 'ALERT_HOWTOCREATEFIRSTLABEL' :
				resTxt = 'Click a button to pick a label type.\nTips will show only on first use of each button.';
				break;
			case 'ALERT_HOWTOEDITMODEVIEW' :
				resTxt = 'Click image to zoom-in.\nAlt-click to zoom-out.\nClick-drag to pan.';
				break;
			case 'ALERT_HOWTOEDITMODEFREEHAND' :
				resTxt = '\nClick-drag in image to draw.';
				break;
			case 'ALERT_HOWTOEDITMODETEXT' :
				resTxt = '\nClick in image to create caption. Edit text in panel.';
				break;
			case 'ALERT_HOWTOEDITMODEICON' :
				resTxt = 'Select icon type from list.\nClick image to create icon.\nAlt-click-drag icon to position.';
				break;
			case 'ALERT_HOWTOEDITMODERECTANGLE' :
				resTxt = '\nClick-drag in image to create rectangle.';
				break;
			case 'ALERT_HOWTOEDITMODEPOLYGON' :
				resTxt = 'Click in image to start polygon and add control points.\nRe-click first point to close the polygon.\nOr alt-click in image to leave polygon open.';
				break;
			case 'ALERT_HOWTOEDITMODEMEASURE' :
				resTxt = 'Click in image to measure length.\nAdditional clicks measure perimeter.\nRe-click starting point to measure area.';
				break;
			case 'ALERT_HOTSPOTCLICKURLDISABLED' :
				resTxt = 'Click links are disabled in edit mode\nto allow hotspot positioning by click-dragging:\n';
				break;
			case 'ALERT_CLICKDRAGEXITTOVIEWMODE' :
				var measureOrEdit = (Z.labelMode == 'measure') ? 'measure' : 'edit';
				resTxt = 'Exiting ' + measureOrEdit + ' mode to allow mouse panning.\nTo navigate in ' + measureOrEdit + ' mode use arrow keys.';
				break;
			case 'ALERT_NONEDITABLEPOI' :
				resTxt = '\nThis POI is not editable.';
				break;
			case 'ALERT_NONEDITABLELABEL' :
				resTxt = '\nThis label is not editable.';
				break;
			case 'ALERT_NONEDITABLELABELPOI' :
				resTxt = '\nThis label is not editable because its POI is not editable.';
				break;
			case 'ALERT_NONEDITABLENOTE' :
				resTxt = '\nThis note is not editable.';
				break;
			case 'ALERT_NONEDITABLENOTEPOI' :
				resTxt = '\nThis note is not editable because its POI is not editable.';
				break;
			case 'ALERT_UNSAVEDEDITSEXIST-BROWSER' :
				resTxt = '\nYou have unsaved edits. Stay on page to save edits?';
				break;
			case 'ALERT_UNSAVEDEDITSEXIST-CUSTOM' :
				resTxt = '\nYou have unsaved edits.\nClick Cancel to stay on page to save edits.\nClick OK to DISCARD edits and proceed.';
				break;
			case 'ALERT_CANCELLINGUNSAVEDEDITS' :
				resTxt = '\nCancelling all unsaved edits.';
				break;
			case 'ALERT_SAVINGUNSAVEDEDITS' :
				resTxt = '\nSaving unsaved edits.';
				break;
			case 'ALERT_ANNOTATIONSAVESUCCESSFUL' :
				resTxt = '\nXML save complete.';
				break;

			case 'ALERT_IMAGESAVEPREPARING' :
				resTxt = '\nPreparing to save full image...';
				break;
			case 'ALERT_VIEWSAVEPREPARING' :
				resTxt = '\nPreparing to save view...';
				break;
			case 'ALERT_IMAGESAVELOADINGDATA' :
				resTxt = '\nDownloading image data...';
				break;
			case 'ALERT_IMAGESAVERECEIVINGTILE' :
				resTxt = '\nReceiving image tile: ';
				break;
			case 'ALERT_IMAGESAVEDRAWINGTILE' :
				resTxt = '\nDrawing image tile: ';
				break;
			case 'ALERT_IMAGESAVEDRAWINGANNOTATION' :
				resTxt = '\nDrawing annotation: ';
				break;
			case 'ALERT_IMAGESAVEUPLOADING' :
				resTxt = '\nUploading...';
				break;
			case 'ALERT_IMAGESAVEINPROGRESS' :
				resTxt = '\nUploading image data to save as file: ' ;
				break;
			case 'ALERT_VIEWSAVEINPROGRESS' :
				resTxt = '\nUploading view data to save as file: ';
				break;
			case 'ALERT_IMAGESAVESUCCESSFUL' :
				resTxt = '\nImage save complete';
				break;
			case 'ALERT_IMAGESAVEHTMLCAPTIONUNSUPPORTED' :
				resTxt = '\nSaving HTML captions to image is not currently supported';
				break;

			case 'ALERT_SAVEDISABLEDFORDEMOKEY' :
				resTxt = 'SAVEDISABLEDFORDEMO';
				break;
			case 'ALERT_SAVEDISABLEDFORDEMOTEXT' :
				resTxt = '\nDemo edits are saved only during the browser session.';
				break;

			case 'ALERT_PRELOADINGIMAGE-DATA' :
				resTxt = '\nPreloading image content...';
				break;
			case 'ALERT_PRELOADINGONEIMAGE-LOADINGTILES' :
				resTxt = '\nPreloading current view for all zoom levels...';
				break;
			case 'ALERT_PRELOADINGIMAGESET-LOADINGTILES' :
				resTxt = (Z.animation) ? '\nPreloading current view for all images:' : '\nPreloading current view for all slides:';
				break;
			case 'ALERT_PRELOADINGIMAGESET-UPDATINGVIEW' :
				resTxt = (Z.animation) ? '\nUpdating current view for all images:' : '\nUpdating current view for all slides:';
				break;
			case 'ALERT_PRELOADING-STORINGORDRAWINGTILES' :
				resTxt = (!Z.imageSet) ? '\nStoring preloaded image:' : (Z.animation) ? '\nDrawing animation:   Image ' : '\nDrawing slidestack:   Slide ';
				break;

			case 'ALERT_LOADINTRACKINGDATA' :
				resTxt = '\nLoading tracking data...';
				break;

			case 'ALERT_PROCESSINGIMAGEFILTER' :
				resTxt = '\nProcessing image filter...';
				break;
			case 'ALERT_PROCESSINGBACKFILLIMAGEFILTER' :
				resTxt = '\nProcessing backfill image filter...'
				break;
			case 'ALERT_PROCESSINGIMAGEFILTER-CONVOLUTION-ONMOUSEUP' :
				resTxt = ' filter will begin on slider release...';
				break;
			case 'ALERT_PROCESSINGIMAGEFILTER-CONVOLUTION' :
				resTxt = '\nProcessing image convolution filter...';
				break;
			case 'ALERT_PROCESSINGBACKFILLIMAGEFILTER-CONVOLUTION' :
				resTxt = '\nProcessing backfill image convolution filter...'
				break;

			case 'ALERT_LOADINGIMAGESET' :
				resTxt = (Z.comparison) ? '\nLoading comparison images...' : (Z.overlays) ? '\nLoading overlays...' : (Z.animation) ? '\nLoading animation images...' : '\nLoading slides...';
				break;

			case 'ALERT_LOADINGUSERLIST' :
				resTxt = '\nLoading username list to validate entry...';
				break;
			case 'ALERT_USERNAMEACCEPTED' :
				resTxt = '\nUsername accepted!';
				break;

			case 'ERROR_ERROR' :
				resTxt = 'error';
				break;

			case 'ERROR_UNRECOGNIZEDPARAMETERALERT' :
				resTxt = 'Parameter unrecognized or deprecated - see the Parameters List documentation: ';
				break;
			case 'ERROR_PARAMETERDEPRECATED' :
				resTxt = 'Parameter deprecated - please replace: ';
				break;

			case 'ERROR_UNSUPPORTEDLOCALSAVING' :
				resTxt = 'Standard browser security prevents local saving of edits.\nFor details see Developer Resources/Testing Tools/Local Host.';
				break;
			case 'ERROR_UNSUPPORTEDLOCALVIEWING-BROWSER' :
				resTxt = 'Use Firefox for local viewing or see READ ME FIRST\nfile for optional settings for other browsers.';
				break;
			case 'ERROR_UNSUPPORTEDLOCALVIEWING-FORMAT-ZIF' :
				resTxt = 'Browsers allow ZIF file viewing only from a web server.\nPlease use Zoomify Image folders for local viewing.';
				break;
			case 'ERROR_UNSUPPORTEDLOCALVIEWING-FORMAT-PFF' :
				resTxt = 'Browsers allow PFF file viewing only from a web server.\nPlease use Zoomify Image folders for local viewing.';
				break;
			case 'ERROR_IMAGEPATHINVALID' :
				resTxt = 'Image failed to load: possible invalid path, missing image, or network error.';
				break;
			case 'ERROR_TILEPATHINVALID' :
				resTxt = 'Sorry!  Part of this view is not refreshing.  The network may be slow, or the website may be missing a file:  ';
				break;
			case 'ERROR_SETTINGIIIFIMAGEPATH' :
				resTxt = 'Error setting IIIF image path';
				break;

			case 'ERROR_VALIDATEVIEW' :
				resTxt = 'Sorry!  Part of this view is not refreshing. The network\nmay be slow, or the website may be missing a file.  ';
				break;
			case 'ERROR_TILEPATHINVALID-ZIF' :
				resTxt = 'Sorry!  Part of this view is not refreshing.  The network may be slow, or the ZIF file may be faulty:  ';
				break;
			case 'ERROR_ANNOTATIONPATHMISSING' :
				resTxt = 'Attempt to start edit mode or save data without providing path to annotations XML data file.';
				break;
			case 'ERROR_TRACKINGPATHMISSING' :
				resTxt = 'Attempt to start edit mode or save data without providing path to tracking XML data file.';
				break;

			case 'ERROR_HOTSPOTPOPUPPATHINVALID' :
				resTxt = 'Hotspot popup graphic failed to load: possible invalid path or missing file.';
				break;
			case 'ERROR_HOTSPOTMEDIAPATHINVALID' :
				resTxt = 'Hotspot media failed to load: possible invalid path, missing file, or legacy hotspot media such as library clip of Flash-based viewer.';
				break;
			case 'ERROR_HOTSPOTMEDIAINVALID' :
				resTxt = "Media of one or more hotspots unsupported: hotspot media of type 'symbol' depend on internal Library of Flash-based viewers."; // Quotes reversed to display quoted single quotes.
				break;
			case 'ERROR_XMLSAVEHANDLERPATHMISSING' :
				resTxt = 'Attempt to initiate Edit mode without providing path to Save Handler - server side script or other resource to post XML data.';
				break;
			case 'ERROR_XMLSAVEHANDLERPATHINVALID' :
				resTxt = 'Annotations cannot be saved: missing or incorrect save\nhandler path parameter, or missing file on server.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-ZIFBYTERANGE' :
				resTxt = 'Error loading image: ZIF file data request failed. Request content type: ';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-ZIFBYTES' :
				resTxt = 'Error loading image: ZIF file invalid.';
				break;
			case 'ERROR_XMLHTTPREQUESTUNSUPPORTED' :
				resTxt = 'Browser does not support XMLHttpRequest.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-IMAGEXML' :
				resTxt = 'Error loading image: please make sure image path in web page matches image folder location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-PFFIMAGEHEADER' :
				resTxt = 'Error loading image: image header request invalid.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-PFFIMAGEOFFSET' :
				resTxt = 'Error loading image: image offset request invalid.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-PARAMETERSXML' :
				resTxt = "Error loading parameters XML: please make sure the zXMLParametersPath value is correct.";
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-IMAGELISTXML' :
				resTxt = 'Error loading image list images: please make sure image list path in web page matches image list folder location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-TOOLBARSKINSXML' :
				resTxt = "Error loading toolbar - skin files not found: please verify that the folders 'Assets/Skins/Default' are in same folder as the web page displaying the Viewer, or add zSkinPath parameter to web page. The zSkinPath parameter may be required if using a content management system such as Drupal, Joomla, or WordPress."; // Quotes reversed to display quoted single quotes.
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-COMPARISONXML' :
				resTxt = 'Error loading comparison images: please make sure comparison path in web page matches comparison folder location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-SLIDESXML' :
				resTxt = 'Error loading slides: please make sure slide path in web page matches slides folder location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-HOTSPOTSXML' :
				resTxt = 'Error loading hotspots: please make sure hotspot path in web page matches hotspots folder location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-CREATINGANNOTATIONSXMLFILE' :
				resTxt = 'Error finding annotations XML at location provided.\nCreating new file.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-ANNOTATIONSXML' :
				resTxt = 'Error loading annotations: please make sure annotation XML path in web page matches annotation folder location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-ANNOTATIONSJSON' :
				resTxt = 'Error loading annotations: please make sure annotation JSON path in web page matches annotation folder location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST-ANNOTATIONSSAVEHANDLER' :
				resTxt = 'Error saving annotations: please make sure save handler path in web page matches save handler file location on webserver.';
				break;
			case 'ERROR_MAKINGNETWORKREQUEST' :
				resTxt = 'Error making network request:\npossible invalid path or network error.';
				break;
			case 'ERROR_NETWORKSECURITY' :
				resTxt = 'Error related to network security: ';
				break;
			case 'ERROR_NETWORKSTATUS' :
				resTxt = 'Error related to network status: ';
				break;
			case 'ERROR_NETWORKSTATUSRANGEREQUESTS' :
				resTxt = 'Network error. If using ZIF storage, setting MIME type on web server may be necessary. See READ ME FIRST file in ZIF Storage folder or contact Support: ';
				break;
			case 'ERROR_CONVERTINGXMLTEXTTODOC' :
				resTxt = ' converting XML text to XML doc (DOMParser): ';
				break;
			case 'ERROR_CONVERTINGXMLDOCTOTEXT' :
				resTxt = ' converting XML doc to XML text (DOMParser): ';
				break;
			case 'ERROR_PARSINGANNOTATIONSJSONFILE' :
				resTxt = ' parsing JSON file to JSON object: ';
				break;
			case 'ERROR_PARSINGANNOTATIONSJSONLABEL' :
				resTxt = ' parsing JSON label to JSON object: ';
				break;
			case 'ERROR_XMLDOMUNSUPPORTED' :
				resTxt = 'Browser does not support XML DOM.';
				break;
			case 'ERROR_XMLDOCINVALID' :
				resTxt = 'XML Doc invalid.';
				break;
			case 'ERROR_XMLINVALID' :
				resTxt = 'XML invalid.';
				break;
			case 'ERROR_IMAGEXMLINVALID' :
				resTxt = 'Image XML invalid.';
				break;
			case 'ERROR_IMAGEPROPERTIESXMLINVALID' :
				resTxt = 'Image properties XML invalid.';
				break;
			case 'ERROR_IMAGEPROPERTIESINVALID' :
				resTxt = 'Image properties invalid.';
				break;
			case 'ERROR_IMAGEPROPERTIESPARAMETERINVALID' :
				resTxt = 'Image properties parameter invalid.';
				break;
			case 'ERROR_IMAGETILECOUNTINVALID' :
				resTxt = 'Image tile count does not match value in image XML. If the count is invalid display problems can result.';
				break;
			case 'ERROR_EXECUTINGCALLBACK' :
				resTxt = ' while executing callback: ';
				break;
			case 'ERROR_IMAGEREQUESTTIMEDOUT' :
				resTxt = '\nImage tile request not fulfilled within time period expected';
				break;

			case 'ERROR_UNCONVERTEDIMAGEPATHINVALID' :
				resTxt = 'Unconverted JPEG or PNG image failed to load: possible invalid path, missing image, or network error.';
				break;
			case 'ERROR_TRANSLATINGCANVASFORUNCONVERTEDIMAGE' :
				resTxt = '\nTranslation of canvas failed';
				break;
			case 'ERROR_SCALINGCANVASFORUNCONVERTEDIMAGE' :
				resTxt = '\nScaling of canvas failed';
				break;
			case 'ERROR_SETTINGTRANSFORMONCANVASFORUNCONVERTEDIMAGE' :
				resTxt = '\nTransform on canvas failed';
				break;

			case 'ERROR_NAVIGATORIMAGEPATHINVALID' :
				resTxt = 'Navigator image failed to load: possible invalid path, missing image, or network error.';
				break;
			case 'ERROR_SKINXMLINVALID' :
				resTxt = 'Skin XML invalid.';
				break;
			case 'ERROR_SKINXMLMISSINGNAMES' :
				resTxt = 'The skin XML file has one or more faulty name lines.';
				break;
			case 'ERROR_VIRTUALPOINTERPATHINVALID' :
				resTxt = 'Virtual pointer graphic failed to load: ';
				break;
			case 'ERROR_WATERMARKPATHINVALID' :
				resTxt = 'Watermark image failed to load: ';
				break;
			case 'ERROR_SAVEIMAGEHANDLERPATHINVALID' :
				resTxt = 'Image failed to save';
				break;

			case 'ERROR_TRACKINGPATHMISSING' :
				resTxt = 'Attempt to initiate Tracking mode without providing path to tracking XML data file.';
				break;

			case 'ERROR_USERPATHMISSING' :
				resTxt = 'Attempt to initiate user list display without providing path to users XML data file.';
				break;

			case 'ERROR_UNKNOWNELEMENTSTYLE' :
				resTxt = 'Unknown element style - no known method to identify.';
				break;
			case 'ERROR_UNKNOWNMOUSEPOSITION' :
				resTxt = 'Unknown mouse position - no known method to calculate.';
				break;
			case 'ERROR_UNKNOWNMOUSESCROLL' :
				resTxt = 'Unknown mouse scroll - no known method to calculate.';
				break;
			case 'ERROR_UNKNOWNWINDOWSIZE' :
				resTxt = 'Unknown window size - no known method to calculate.';
				break;
			case 'ERROR_UNEXPECTEDFILTERSELECTION' :
				resTxt = 'Selected filter requires assignment of increment or toggle interface.';
				break;

			case 'ERROR_IMAGEFILTEREQUALIZEARRAYSUPPORT' :
				resTxt = '\nUnable to process Equalize filter: browser does not support Uint8ClampedArray' ;
				break;

			case 'ERROR_IMAGESAVEUNABLETOCOMPUTEPROGRESS' :
				resTxt = 'unable to calculate progress' ;
				break;
			case 'ERROR_IMAGESAVELOCALUNSUPPORTEDBROWSER' :
				resTxt = '\nLocal saving only supported by Firefox and Chrome browsers' ;
				break;

			case 'TIP_LOGO' :
				resTxt = 'Launch Zoomify Website';
				break;
			case 'TIP_MINIMIZE' :
				var toggleText = (Z.hotspots) ? '\nAlt-Click: Toggle Hotspot Visibility' : (Z.annotations) ? '\nAlt-Click: Toggle Label Visibility' : '';
				resTxt = 'Minimize Toolbar' + toggleText;
				break;
			case 'TIP_EXPAND' :
				var toggleText = (Z.hotspots) ? '\nAlt-Click: Toggle Hotspot Visibility' : (Z.annotations) ? '\nAlt-Click: Toggle Label Visibility' : '';
				resTxt = 'Expand Toolbar' + toggleText;
				break;
			case 'TIP_ZOOMOUT' :
				resTxt = 'Zoom Out';
				break;
			case 'TIP_SLIDERZOOM' :
				resTxt = 'Zoom In And Out';
				break;
			case 'TIP_ZOOMIN' :
				resTxt = 'Zoom In';
				break;
			case 'TIP_PANLEFT' :
				resTxt = 'Pan Left';
				break;
			case 'TIP_PANUP' :
				resTxt = 'Pan Up';
				break;
			case 'TIP_PANDOWN' :
				resTxt = 'Pan Down';
				break;
			case 'TIP_PANRIGHT' :
				resTxt = 'Pan Right';
				break;
			case 'TIP_RESET' :
				resTxt = 'Reset Initial View\nAlt-Click: Prior View';
				break;

			case 'TIP_TOGGLEFULLVIEW' :
				resTxt = 'Enter Full View';
				break;
			case 'TIP_TOGGLEFULLVIEWEXIT' :
				resTxt = 'Exit Full View';
				break;
			case 'TIP_TOGGLEFULLVIEWEXITEXTERNAL' :
				resTxt = 'Exit Full View';
				break;

			case 'TIP_HELP' :
				resTxt = 'Show Help';
				break;
			case 'TIP_HELPMARKUP' :
				resTxt = 'Show Markup Help';
				break;
			case 'TIP_HELPANNOTATION' :
				resTxt = 'Show Annotation Help';
				break;

			case 'TIP_ROTATECLOCKWISE' :
				resTxt = 'Rotate Clockwise 90 Degrees';
				break;
			case 'TIP_ROTATECOUNTERWISE' :
				resTxt = 'Rotate Counterwise 90 Degrees';
				break;

			case 'TIP_GALLERYSCROLLBUTTONLEFT' :
				resTxt = 'Scroll Gallery Left';
				break;
			case 'TIP_GALLERYSCROLLBUTTONRIGHT' :
				resTxt = 'Scroll Gallery Right';
				break;

			case 'TIP_VIRTUALPOINTER' :
				resTxt = 'Click-Drag To Position';
				break;

			case 'TIP_TOGGLEMEASURING' :
				resTxt = 'Begin Measuring';
				break;
			case 'TIP_TOGGLEMEASURINGEXIT' :
				resTxt = 'Stop Measuring';
				break;

			case 'TIP_TOURPRIOR' :
				resTxt = 'Prior Destination';
				break;
			case 'TIP_TOURNEXT' :
				resTxt = 'Next Destination';
				break;
			case 'TIP_TOURSTART' :
				resTxt = 'Start Tour';
				break;
			case 'TIP_TOURSTOP' :
				resTxt = 'Stop Tour';
				break;

			case 'TIP_SLIDEPRIOR' :
				resTxt = 'Prior Slide';
				break;
			case 'TIP_SLIDENEXT' :
				resTxt = 'Next Slide';
				break;
			case 'TIP_SLIDESHOWSTART' :
				resTxt = 'Start Slideshow';
				break;
			case 'TIP_SLIDESHOWSTOP' :
				resTxt = 'Stop Slideshow';
				break;

			case 'TIP_AUDIOMUTE' :
				resTxt = 'Mute Sound';
				break;
			case 'TIP_AUDIOON' :
				resTxt = 'Enable Sound';
				break;

			case 'TIP_IMAGEFILTERPANELHIDE' :
				resTxt = 'Hide Image Filter Panel';
				break;
			case 'TIP_IMAGEFILTERPANELSHOW' :
				resTxt = 'Show Image Filter Panel';
				break;
			case 'TIP_SLIDERBRIGHTNESS' :
				resTxt = 'Change Brightness';
				break;
			case 'TIP_SLIDERCONTRAST' :
				resTxt = 'Change Contrast';
				break;
			case 'TIP_SLIDERSHARPNESS' :
				resTxt = 'Change Sharpness';
				break;
			case 'TIP_SLIDERBLURINESS' :
				resTxt = 'Change Blurriness';
				break;
			case 'TIP_SLIDERCOLORRED' :
				resTxt = 'Change Color Red';
				break;
			case 'TIP_SLIDERCOLORGREEN' :
				resTxt = 'Change Color Green';
				break;
			case 'TIP_SLIDERCOLORBLUE' :
				resTxt = 'Change Color Blue';
				break;
			case 'TIP_SLIDERCOLORREDRANGE' :
				resTxt = 'Change Color Red Minimum';
				break;
			case 'TIP_SLIDERCOLORGREENRANGE' :
				resTxt = 'Change Color Green Minimum';
				break;
			case 'TIP_SLIDERCOLORBLUERANGE' :
				resTxt = 'Change Color Blue Minimum';
				break;
			case 'TIP_SLIDERCOLORREDRANGE2' :
				resTxt = 'Change Color Red Maximum';
				break;
			case 'TIP_SLIDERCOLORGREENRANGE2' :
				resTxt = 'Change Color Green Maximum';
				break;
			case 'TIP_SLIDERCOLORBLUERANGE2' :
				resTxt = 'Change Color Blue Maximum';
				break;
			case 'TIP_SLIDERGAMMA' :
				resTxt = 'Change Gamma';
				break;
			case 'TIP_SLIDERGAMMARED' :
				resTxt = 'Change Gamma Red';
				break;
			case 'TIP_SLIDERGAMMAGREEN' :
				resTxt = 'Change Gamma Green';
				break;
			case 'TIP_SLIDERGAMMABLUE' :
				resTxt = 'Change Gamma Blue';
				break;
			case 'TIP_SLIDERHUE' :
				resTxt = 'Change Hue';
				break;
			case 'TIP_SLIDERSATURATION' :
				resTxt = 'Change Saturation';
				break;
			case 'TIP_SLIDERLIGHTNESS' :
				resTxt = 'Change Lightness';
				break;
			case 'TIP_SLIDERWHITEBALANCE' :
				resTxt = 'Change White Balance';
				break;
			case 'TIP_SLIDERNOISE' :
				resTxt = 'Change Noise';
				break;

			case 'TIP_GRAYSCALE' :
				resTxt = 'Set Grayscale Filter';
				break;
			case 'TIP_THRESHOLD' :
				resTxt = 'Set Threshold Filter';
				break;
			case 'TIP_INVERSION' :
				resTxt = 'Set Inversion Filter';
				break;
			case 'TIP_EQUALIZE' :
				resTxt = 'Set Equalize Filter';
				break;
			case 'TIP_EDGES' :
				resTxt = 'Set Edges Filter';
				break;
			case 'TIP_SEPIA' :
				resTxt = 'Set Sepia Filter';
				break;

			case 'TIP_IMAGEFILTERPLUS' :
				resTxt = 'Increase Filter';
				break;
			case 'TIP_IMAGEFILTERMINUS' :
				resTxt = 'Decrease Filter';
				break;
			case 'TIP_IMAGEFILTERAPPLY' :
				resTxt = 'Apply Selected Filter';
				break;
			case 'TIP_IMAGEFILTERCLEAR' :
				resTxt = 'Clear Last Filter';
				break;
			case 'TIP_IMAGEFILTERCLEARALL' :
				resTxt = 'Clear All Filters';
				break;

			case 'TIP_IMAGESETPRIOR' :
				resTxt = (Z.animation) ? 'Prior Image' : 'Prior Slide';
				break;
			case 'TIP_SLIDERIMAGESET' :
				resTxt = (Z.animation) ? 'Change Image' : 'Change Slide';
				break;
			case 'TIP_IMAGESETNEXT' :
				resTxt = (Z.animation) ? 'Next Image' : 'Next Slide';
				break;

			case 'TIP_PRELOAD' :
				resTxt = (!Z.imageSet) ? 'Preload All Zoom Levels For Current View' : (Z.animation) ? 'Preload Current View For All Images' : 'Preload Current View For All Slides';
				break;

			case 'TIP_POIGO' :
				resTxt = 'Go To Point Of Interest';
				break;
			case 'TIP_LABELGO' :
				resTxt = 'Go To Label';
				break;
			case 'TIP_VIEWMODE' :
				resTxt = 'Image Navigation';
				break;
			case 'TIP_EDITMODECOLORPICKER' :
				resTxt = 'Toggle Color Palette';
				break;

			case 'TIP_EDITMODEFREEHAND' :
				resTxt = 'Freehand Drawings';
				break;
			case 'TIP_EDITMODETEXT' :
				resTxt = 'Text Labels';
				break;
			case 'TIP_EDITMODEICON' :
				resTxt = 'Icon Labels';
				break;
			case 'TIP_EDITMODERECTANGLE' :
				resTxt = 'Rectangle Labels';
				break;
			case 'TIP_EDITMODEPOLYGON' :
				resTxt = 'Polygon Labels';
				break;
			case 'TIP_EDITMODEMEASURE' :
				resTxt = 'Measurements';
				break;

			case 'TIP_POIADD' :
				resTxt = 'Add New POI';
				break;
			case 'TIP_POIEDIT' :
				resTxt = 'Edit Current POI';
				break;
			case 'TIP_POIDELETE' :
				resTxt = 'Delete Current POI';
				break;
			case 'TIP_POICANCEL' :
				resTxt = 'Cancel POI Changes';
				break;
			case 'TIP_POISAVE' :
				resTxt = 'Save POI Changes';
				break;
			case 'TIP_LABELADD' :
				resTxt = 'Add New Label';
				break;
			case 'TIP_LABELEDIT' :
				resTxt = 'Edit Current Label';
				break;
			case 'TIP_LABELDELETE' :
				resTxt = 'Delete Current Label';
				break;
			case 'TIP_LABELCANCEL' :
				resTxt = 'Cancel Label Changes';
				break;
			case 'TIP_LABELSAVE' :
				resTxt = 'Save Label Changes';
				break;
			case 'TIP_NOTEADD' :
				resTxt = 'Add New Note';
				break;
			case 'TIP_NOTEEDIT' :
				resTxt = 'Edit Current Note';
				break;
			case 'TIP_NOTEDELETE' :
				resTxt = 'Delete Current Note';
				break;
			case 'TIP_NOTECANCEL' :
				resTxt = 'Cancel Note Changes';
				break;
			case 'TIP_NOTESAVE' :
				resTxt = 'Save Note Changes';
				break;

			case 'TIP_COLOR0' :
				resTxt = 'Select Color';
				break;
			case 'TIP_COLOR1' :
				resTxt = 'Select Color';
				break;
			case 'TIP_COLOR2' :
				resTxt = 'Select Color';
				break;
			case 'TIP_COLOR3' :
				resTxt = 'Select Color';
				break;
			case 'TIP_COLOR4' :
				resTxt = 'Select Color';
				break;
			case 'TIP_COLOR5' :
				resTxt = 'Select Color';
				break;
			case 'TIP_COLOR6' :
				resTxt = 'Select Color';
				break;
			case 'TIP_COLOR7' :
				resTxt = 'Select Color';
				break;

			case 'TIP_LABELSCALEUP' :
				resTxt = 'Grow Label';
				break;
			case 'TIP_LABELSCALEDOWN' :
				resTxt = 'Shrink Label';
				break;
			case 'TIP_ROLLOVER' :
				resTxt = 'Hide Icon Until Mouse-Over';
				break;

			case 'TIP_COUNTINGLISTHIDE' :
				resTxt = 'Hide Counter List';
				break;
			case 'TIP_COUNTINGCOMPLETE' :
				resTxt = 'Set Current Cell Counting Complete';
				break;
			case 'TIP_TRACKINGNAVTOGGLE' :
				resTxt = 'Toggle Navigator Tracking Overlay';
				break;
			case 'TIP_COUNTERCLEARLAST' :
				resTxt = 'Clear Last Counter Added';
				break;
			case 'TIP_COUNTERCLEARTYPE' :
				resTxt = 'Clear Counters Of Selected Type';
				break;
			case 'TIP_COUNTERSCLEARALL' :
				resTxt = 'Clear All Counters';
				break;
			case 'TIP_COUNTERSSAVE' :
				resTxt = 'Save All';
				break;

			case 'TIP_HELPOK' :
				resTxt = 'Close Help Display';
				break;

			case 'TIP_COUNTERTYPE' :
				resTxt = 'Set Image Click To Add This Type';
				break;
			case 'TIP_COUNTERTYPESHOW' :
				resTxt = 'Show Labels For This Type In Image';
				break;
			case 'TIP_COUNTERLIST' :
				resTxt = 'Show List Of Labels For This Type';
				break;

			case 'TIP_MESSAGEOK' :
				resTxt = 'Accept And Close Message';
				break;
			case 'TIP_MESSAGECANCEL' :
				resTxt = 'Decline And Close Message';
				break;
			case 'TIP_COPYRIGHTAGREE' :
				resTxt = 'Agree To Copyright And View Images';
				break;
			case 'TIP_COPYRIGHTEXIT' :
				resTxt = 'Exit And Do Not View Images';
				break;
			case 'TIP_SHOWGLOBALS' :
				resTxt = 'Toggle Full Page View';
				break;
			case 'TIP_TOGGLEDISPLAY' :
				resTxt = 'Toggle Viewport Display';
				break;
			case 'TIP_TOGGLEBACKFILL' :
				resTxt = 'Toggle Viewport Backfill';
				break;
			case 'TIP_TOGGLECONSTRAINPAN' :
				resTxt = 'Toggle Constrain Pan';
				break;

			case 'TIP_SYNC' :
				resTxt = 'Synchronize Viewports';
				break;

			case 'UI_LOGOLINKDISPLAY' :
				resTxt = 'www.zoomify.com';
				break;
			case 'UI_LOGOLINK' :
				resTxt = 'http://www.zoomify.com';
				break;
			case 'UI_LOGOLINKTARGET' :
				resTxt = '_blank';
				break;

			case 'UI_TOOLBARINTERNALBACKGROUNDALPHA' :
				resTxt = '0.75';
				break;
			case 'UI_TOOLBARINTERNALBACKGROUNDCOLOR' :
				resTxt = 'lightgray';
				break;
			case 'UI_TOOLBARINTERNALBUTTONUPCOLOR' :
				resTxt = 'white';
				break;
			case 'UI_TOOLBARINTERNALBUTTONOVERCOLOR' :
				resTxt = 'lightgray';
				break;
			case 'UI_TOOLBARINTERNALBUTTONDOWNCOLOR' :
				resTxt = 'darkgray';
				break;
			case 'UI_TOOLBARINTERNALBUTTONZOOMINTEXT' :
				resTxt = '+';
				break;
			case 'UI_TOOLBARINTERNALBUTTONRESETTEXT' :
				resTxt = 'Z'
				break;
			case 'UI_TOOLBARINTERNALBUTTONZOOMOUTTEXT' :
				resTxt = '-';
				break;

			case 'UI_NAVIGATORACCESSIBILITYALTATTRIBUTE' :
				resTxt = "Navigator Bird's Eye View"; // Quotes reversed to support possessive use.
				break;
			case 'UI_FVCANCELBUTTONTEXT' :
				resTxt = 'X';
				break;

			case 'UI_GALLERYACCESSIBILITYALTATTRIBUTE' :
				resTxt = "Scrolling Gallery Of Image Thumbnails"; // Quotes reversed to support possessive use.
				break;

			case 'UI_RULERMIN' :
				resTxt = ' min';
				break;
			case 'UI_RULERMAX' :
				resTxt = ' max';
				break;
			case 'UI_RULERNOPARAMS' :
				resTxt = 'units in %s';
				break;

			case 'UI_MEASURELENGTH' :
				resTxt = 'Length: ';
				break;
			case 'UI_MEASURELENGTHTOTAL' :
				resTxt = 'Total length: ';
				break;
			case 'UI_MEASUREPERIMETER' :
				resTxt = 'Perimeter: ';
				break;
			case 'UI_MEASUREAREA' :
				resTxt = 'Area: ';
				break;
			case 'UI_MEASURESQUARE' :
				resTxt = '\u00B2'; // Unicode representation for squared symbol (superscript 2: '�').
				break;

			case 'UI_IMAGEFILTERCHOICELISTTEXT' :
				resTxt = 'Filter History,\u00A0\u00A0\u2014,\u00A0\u00A0None';
				// Alternative implementation: resTxt = 'Filter History,\u00A0\u00A0\u2014,\u00A0\u00A0Brightness,\u00A0\u00A0Contrast,\u00A0\u00A0Sharpness,\u00A0\u00A0Blurriness,\u00A0\u00A0\u2014,\u00A0\u00A0Edges,\u00A0\u00A0Inversion,\u00A0\u00A0Grayscale,\u00A0\u00A0Threshold';
				break;
			case 'UI_IMAGEFILTERCHOICELISTVALUES' :
				resTxt = 'null,null,null';
				// Alternative implementation: resTxt = 'null,null,brightness,contrast,sharpness,blurriness,null,edges,inversion,grayscale,threshold';
				break;
			case 'UI_IMAGEFILTERPANELLABELBRIGHTNESS' :
				resTxt = 'Brightness';
				break;
			case 'UI_IMAGEFILTERPANELLABELCONTRAST' :
				resTxt = 'Contrast';
				break;
			case 'UI_IMAGEFILTERPANELLABELCOLORRED' :
				resTxt = 'Red';
				break;
			case 'UI_IMAGEFILTERPANELLABELCOLORGREEN' :
				resTxt = 'Green';
				break;
			case 'UI_IMAGEFILTERPANELLABELCOLORBLUE' :
				resTxt = 'Blue';
				break;
			case 'UI_IMAGEFILTERPANELLABELCOLORREDRANGE' :
				resTxt = (Z.colorRedVisible) ? 'Red Range' : 'Red';
				break;
			case 'UI_IMAGEFILTERPANELLABELCOLORGREENRANGE' :
				resTxt = (Z.colorGreenVisible) ? 'Green Range' : 'Green';
				break;
			case 'UI_IMAGEFILTERPANELLABELCOLORBLUERANGE' :
				resTxt = (Z.colorBlueVisible) ? 'Blue Range' : 'Blue';
				break;
			case 'UI_IMAGEFILTERPANELLABELGAMMA' :
				resTxt = 'Gamma';
				break;
			case 'UI_IMAGEFILTERPANELLABELGAMMARED' :
				resTxt = 'Gamma Red';
				break;
			case 'UI_IMAGEFILTERPANELLABELGAMMAGREEN' :
				resTxt = 'Gamma Green';
				break;
			case 'UI_IMAGEFILTERPANELLABELGAMMABLUE' :
				resTxt = 'Gamma Blue';
				break;
			case 'UI_IMAGEFILTERPANELLABELHUE' :
				resTxt = 'Hue';
				break;
			case 'UI_IMAGEFILTERPANELLABELSATURATION' :
				resTxt = 'Saturation';
				break;
			case 'UI_IMAGEFILTERPANELLABELLIGHTNESS' :
				resTxt = 'Lightness';
				break;
			case 'UI_IMAGEFILTERPANELLABELWHITEBALANCE' :
				resTxt = 'White Balance';
				break;
			case 'UI_IMAGEFILTERPANELLABELNORMALIZE' :
				resTxt = 'Normalize';
				break;
			case 'UI_IMAGEFILTERPANELLABELEQUALIZE' :
				resTxt = 'Equalize';
				break;
			case 'UI_IMAGEFILTERPANELLABELNOISE' :
				resTxt = 'Noise';
				break;
			case 'UI_IMAGEFILTERPANELLABELGLOW' :
				resTxt = 'Glow';
				break;

			case 'UI_IMAGEFILTERPANELLABELSHARPNESS' :
				resTxt = 'Sharpness';
				break;
			case 'UI_IMAGEFILTERPANELLABELBLURRINESS' :
				resTxt = 'Blurriness';
				break;
			case 'UI_IMAGEFILTERPANELLABELGRAYSCALE' :
				resTxt = 'Grayscale';
				break;
			case 'UI_IMAGEFILTERPANELLABELTHRESHOLD' :
				resTxt = 'Threshold';
				break;
			case 'UI_IMAGEFILTERPANELLABELINVERSION' :
				resTxt = 'Inversion';
				break;
			case 'UI_IMAGEFILTERPANELLABELEDGES' :
				resTxt = 'Edges';
				break;
			case 'UI_IMAGEFILTERPANELLABELSEPIA' :
				resTxt = 'Sepia';
				break;

			case 'UI_COPYRIGHTAGREEBUTTONTEXT' :
				resTxt = 'Agree';
				break;
			case 'UI_COPYRIGHTEXITBUTTONTEXT' :
				resTxt = 'Exit';
				break;

			case 'UI_LISTMOUSEDOWNTEXT' :
				resTxt = 'Select an item...';
				break;

			case 'UI_TOURLISTTITLE' :
				resTxt = 'Tour Destinations';
				break;
			case 'UI_SLIDELISTTITLE' :
				resTxt = 'Slides';
				break;
			case 'UI_HOTSPOTLISTTITLE' :
				resTxt = 'Hotspots';
				break;

			case 'UI_ANNOTATIONPANELLABELPOI' :
				resTxt = 'POI';
				break;
			case 'UI_ANNOTATIONPANELLABELLABEL' :
				resTxt = 'Label';
				break;
			case 'UI_ANNOTATIONPANELLABELCAPTION' :
				resTxt = 'Caption';
				break;
			case 'UI_ANNOTATIONPANELLABELTOOLTIP' :
				resTxt = 'Tooltip';
				break;
			case 'UI_ANNOTATIONPANELLABELURL' :
				resTxt = 'Click';
				break;
			case 'UI_ANNOTATIONPANELLABELSCALE' :
				resTxt = 'Scale';
				break;
			case 'UI_ANNOTATIONPANELLABELROLLOVER' :
				resTxt = 'Rollover';
				break;
			case 'UI_ANNOTATIONPANELLABELNOTE' :
				resTxt = 'Note';
				break;

			case 'UI_ANNOTATIONLABELICONCHOICELISTTEXT' :
				resTxt = 'Select Icon Type,Circle,Triangle,Square,Arrow Down,Arrow Down Left,Arrow Down Right,Arrow Left,Arrow Right,Arrow Up,Arrow Up Left,Arrow Up Right,Line Horizontal,Line Vertical,External Graphics File';
				break;
			case 'UI_ANNOTATIONLABELICONCHOICELISTVALUES' :
				if (Z.labelIconsInternal) {
					resTxt = 'shim,circle,triangle,square,arrowDown,arrowDownLeft,arrowDownRight,arrowLeft,arrowRight,arrowUp,arrowUpLeft,arrowUpRight,lineHorizontal,lineVertical,External Graphics File';
				} else {
					resTxt = 'shim,circle.png,triangle.png,square.png,arrowDown.png,arrowDownLeft.png,arrowDownRight.png,arrowLeft.png,arrowRight.png,arrowUp.png,arrowUpLeft.png,arrowUpRight.png,lineHorizontal.png,lineVertical.png,External Graphics File';
				}
				break;
			case 'UI_ANNOTATIONLABELCAPTIONPOSITIONCHOICELISTTEXT' :
				resTxt = 'Caption position...,Bottom Left,Bottom Center,Bottom Right,Center Left,Center Center,Center Right,Top Left,Top Center,Top Right';
				break;
			case 'UI_ANNOTATIONLABELCAPTIONPOSITIONCHOICELISTVALUES' :
				resTxt = 'shim,7,8,9,4,5,6,1,2,3';
				break;
			case 'UI_ANNOTATIONLABELTARGETCHOICELISTTEXT' :
				resTxt = 'Open URL in...,Same Window,New Window,Parent Frame,Top Frame';
				break;
			case 'UI_ANNOTATIONLABELTARGETCHOICELISTVALUES' :
				resTxt = 'shim,_self,_blank,_parent,_top';
				break;

			case 'UI_TOOLBARLABELSYNC' :
				resTxt = 'Sync';
				break;

			case 'UI_IMAGESETLISTTITLE' :
				resTxt = (Z.comparison || Z.overlays) ? '': 'ImageSet Slide List';
				break;
			case 'UI_IMAGESETSTART' :
				resTxt = '0';
				break;
			case 'UI_IMAGESETLOOP' :
				resTxt = '1';
				break;
			case 'UI_IMAGESETSLIDER' :
				resTxt = (Z.comparison || Z.overlays) ? '0': '1';
				break;

			case 'UI_TRACKINGROWBUTTONCOLORUPCOLOR' :
				resTxt = 'white';
				break;
			case 'UI_TRACKINGROWBUTTONCOLOROVERCOLOR' :
				resTxt = 'lightgray';
				break;
			case 'UI_TRACKINGROWBUTTONCOLORDOWNCOLOR' :
				resTxt = 'darkgray';
				break;
			case 'UI_TRACKINGPANELLABELADD' :
				resTxt = 'Add';
				break;
			case 'UI_TRACKINGPANELLABELSHOW' :
				resTxt = 'Show';
				break;
			case 'UI_TRACKINGPANELLABELNAME' :
				resTxt = 'Name';
				break;
			case 'UI_TRACKINGPANELLABELCOUNT' :
				resTxt = 'Cell';
				break;
			case 'UI_TRACKINGPANELLABELCOUNTALL' :
				resTxt = 'All';
				break;
			case 'UI_TRACKINGPANELLABELLIST' :
				resTxt = 'List';
				break;
			case 'UI_TRACKINGPANELLABELCELL' :
				resTxt = 'Cell';
				break;
			case 'UI_TRACKINGPANELLABELX' :
				resTxt = 'X';
				break;
			case 'UI_TRACKINGPANELLABELY' :
				resTxt = 'Y';
				break;
			case 'UI_TRACKINGPANELLABELZOOM' :
				resTxt = 'Zoom';
				break;
			case 'UI_TRACKINGPANELLABELUSERNAME' :
				resTxt = 'UserName';
				break;
			case 'UI_TRACKINGPANELLABELCURRENTCELL' :
				resTxt = 'Cell';
				break;
			case 'UI_TRACKINGPANELLABELCOUNTINGCOMPLETE' :
				resTxt = (Z.trackingAuto) ? 'Viewed' : 'Complete';
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER2' :
				resTxt = '#000000'; // Black
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER4' :
				resTxt = '#8B4513'; // Brown
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER10' :
				resTxt = '#FF0000'; // Red
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER16' :
				resTxt = '#FFFF00'; // Yellow
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER25' :
				resTxt = '#00FF00'; // Green
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER40' :
				resTxt = '#40E0D0'; // Turquoise
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER60' :
				resTxt = '#0000FF'; // Light Blue
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDER100' :
				resTxt = '#000033'; // Cobalt Blue
				break;
			case 'UI_TRACKINGNAVIGATOROVERLAYCOLOR_UNDERINFINITY' :
				resTxt = '#FFFFFF'; // White
				break;

			case 'UI_USERNAMEPROMPT' :
				resTxt = 'Please enter a username for your edits';
				break;
			case 'UI_USERNAMEPROMPTRETRY' :
				resTxt = 'Name not on approved list, please try again';
				break;
			case 'UI_USERPANELLABELNAME' :
				resTxt = 'Name';
				break;
			case 'UI_USERPANELLABELCOUNT' :
				resTxt = 'Count';
				break;
			case 'UI_USERPANELLABELSHOW' :
				resTxt = 'Show';
				break;

			case 'UI_HELPDISPLAYWIDTH' :
				resTxt = '430';
				break;
			case 'UI_HELPDISPLAYHEIGHT' :
				resTxt = '300';
				break;
			case 'UI_HELPOKBUTTONTEXT' :
				resTxt = 'OK';
				break;
			case 'UI_HELPSCREENCOLOR' :
				resTxt = 'lightgray';
				break;
			case 'UI_HELPBUTTONCOLOR' :
				resTxt = 'white';
				break;

			case 'UI_MESSAGEDISPLAYWIDTH' :
				resTxt = '430';
				break;
			case 'UI_MESSAGEDISPLAYHEIGHT' :
				resTxt = '84';
				break;
			case 'UI_MESSAGECANCELBUTTONTEXT' :
				resTxt = 'Cancel';
				break;
			case 'UI_MESSAGEOKBUTTONTEXT' :
				resTxt = 'OK';
				break;

			case 'UI_COORDINATESDISPLAYWIDTH' :
				resTxt = '290';
				break;
			case 'UI_COORDINATESDISPLAYHEIGHT' :
				resTxt = '200';
				break;
			case 'UI_COORDINATESDISPLAYTEXT' :
				resTxt = 'Mouse Coordinates\nAlt-click, select in list, right-click, Copy';
				break;
			case 'UI_GEOCOORDINATESDISPLAYTEXT' :
				resTxt = 'Latitude & Longitude\nAlt-click, select in list, right-click, Copy';
				break;
			case 'UI_IIIFCOORDINATESDISPLAYTEXT' :
				resTxt = 'IIIF Values For View\nAlt-click, select in list, right-click, Copy';
				break;

			case 'UI_TRACEDISPLAYTITLE' :
				resTxt = "Trace Values\n\n";
				break;
			case 'UI_TRACEDISPLAYDEBUGINFOTEXT' :
				resTxt = "This panel is enabled using the HTML parameter 'zDebug=1' (basic) or 'zDebug=2' (adds tile tracing). " +
				"It can be called in JavaScript as follows:\n\n   Z.Utils.trace('value to display');  \n\nThe " +
				"buttons below display or modify important state values.  Web designers " +
				"new to JavaScript will also benefit from the console, trace, profiling, and " +
				"other debugging features of leading browsers."; // Quotes reversed to display quoted single quotes.
				break;
			case 'UI_TRACEDISPLAYTILESTATUSTEXT' :
				resTxt = 'Required Cached Requested Loaded Displayed Waiting';
				break;
			case 'UI_TRACEDISPLAYELAPSEDTIMETEXT' :
				resTxt = 'Seconds';
				break;
			case 'UI_TRACEDISPLAYTILESPERSECONDTEXT' :
				resTxt = 'Loads / Second';
				break;
			case 'UI_TRACEDISPLAYSHOWGLOBALSBUTTONTEXT' :
				resTxt = 'Show Globals';
				break;
			case 'UI_TRACEDISPLAYTOGGLEDISPLAYBUTTONTEXT' :
				resTxt = 'Toggle Display';
				break;
			case 'UI_TRACEDISPLAYTOGGLEBACKFILLBUTTONTEXT' :
				resTxt = 'Toggle Backfill';
				break;
			case 'UI_TRACEDISPLAYTOGGLECONSTRAINPANBUTTONTEXT' :
				resTxt = 'Toggle Constrain Pan';
				break;

			case 'CONTENT_HELPTOOLBAR' :
				resTxt = '<p align=%22center%22><font face=%22Arial,Helvetica,sans-serif%22><strong>Viewer Help</strong></font></p>'
				+ '<p align=%22justify%22><font face=%22Arial,Helvetica,sans-serif%22>To explore this image, simply <strong>click</strong> the image to zoom, <strong>double-click</strong> to zoom out, or <strong>click-drag</strong> to pan.'
				+ '<br><br>Shortcuts:<br>&nbsp;&nbsp;&nbsp;<strong>Alt-click-drag</strong> to create a <i>zoom-rectangle</i>.<br>&nbsp;&nbsp;&nbsp;<strong>Alt-click</strong> / <strong>Alt-double-click</strong> to zoom fully in / out.<br>&nbsp;&nbsp;&nbsp;<strong>Alt-click-Reset</strong> button to return to the prior view.<br>&nbsp;&nbsp;&nbsp;(Alt is Option on Macintosh).'
				+ '<br><br>The Navigator thumbnail overview can also be clicked or click-dragged to pan.'
				+ '<br><br>Use the Toolbar for exact navigation - if using a mouse, hold it over any button to see a helpful tip.'
				+ '<br><br>Keyboard shortcuts:'
				+ '<br>&nbsp;&nbsp;&nbsp;<strong>a</strong> or <strong>Shift</strong> to zoom in.'
				+ '<br>&nbsp;&nbsp;&nbsp;<strong>z</strong> or <strong>Ctrl</strong> to zoom out.'
				+ '<br>&nbsp;&nbsp;&nbsp;<strong>Arrows</strong> change image in slideshow/animation.'
				+ '<br>&nbsp;&nbsp;&nbsp;<strong>Escape</strong> to reset initial view or exits fullscreen.'
				+ '<br>&nbsp;&nbsp;&nbsp;<strong>&lt;</strong> or <strong>&gt;</strong> to rotate image if rotation buttons visible.'
				+ '<br>&nbsp;&nbsp;&nbsp;<strong>Page Up/Down</strong> change image in slidestack.'
				+ '</font></p>';
				break;
			case 'CONTENT_HELPMARKUP' :
				resTxt = '<p align=%22center%22><font face=%22Arial,Helvetica,sans-serif%22><strong>Markup Help</strong></font></p>'
				+ '<p align=%22justify%22><font face=%22Arial,Helvetica,sans-serif%22>Markup Mode allows fast, easy addition of labels to a zoomable image.'
				+ '<br><br><strong>Creating A Label</strong>'
				+ '<br><br>Click any of the buttons at the top of the Markup Panel: Freehand, Text, Rectangle, Polygon, or Measure.'
				+ '<br><br>Next, click or click-drag in the image:'
				+ '<ul>'
				+ '<li>Freehand drawings are created by click-dragging.'
				+ '<li>Text labels are created with a simple click in the image.'
				+ '<li>Icons first require the type of icon to be chosen from the icon list. Then the icon is created by clicking the image.'
				+ '<li>Rectangles do not require multiple clicks - just click-drag and all four corners are automatically created and positioned.'
				+ '<li>Polygons require multiple clicks in the image to create corner <i>control points</i>.  Alt-click the image to create a final point, or click the first point to close the polygon.'
				+ '<li>Measurements are just like polygons but the caption dynamically changes to display the current length or area.'
				+ '<li>Control points of rectangles, polygons, and measurments can be click-dragged to modify a polygon.'
				+ '</ul>'
				+ 'Use the Color button to set a color. The color selected affects freehand drawings, text captions, icon captions, and the lines and captions of rectangles, polygons, and measurements.'
				+ '<br><br>Use the View button to return to navigation mode.'
				+ '<br><br><strong>Editing Label Values</strong>'
				+ '<br><br>The Markup Panel also displays the name and caption of the currently selected label for easy editing. Use the TAB key to implement any edits or click in the image.'
				+ '<br><br>Delete a label using the trash can button. The label will be removed from the image and the Markup Panel will display the prior label in the label list.'
				+ '<br><br>Save a label using the button with the disk icon. Or, use the label list to change the selected label - the previously selected label will be automatically saved.'
				+ '<br><br><i><strong>Special Tips:</strong>'
				+ '<ul>'
				+ '<li>Alt-click any label to display its name and caption in the Markup Panel for editing.'
				+ '<li>Alt-click-drag any completed label to reposition it in the image.'
				+ '<li>If using a mouse, hold the cursor over any button at any time to see a helpful reminder.'
				+ '</ul>'
				+ '</i></font></p>';
				break;
			case 'CONTENT_HELPANNOTATIONEDITING' :
				resTxt = '<p align=%22center%22><font face=%22Arial,Helvetica,sans-serif%22><strong>Annotation Editing Help</strong></font></p>'
				+ '<p align=%22justify%22><font face=%22Arial,Helvetica,sans-serif%22>The Annotation Panel provides an intuitive, visual means, to add <i>Points of Interest</i> to a zoomable image, including the option of associated <i>Labels</i> and <i>Notes</i>.'
				+ '<br><br><strong>Point Of Interests</strong>'
				+ '<br><br>A Point Of Interest (POI) is a place in the image that is named and listed so that it can be navigated to easily.'
				+ '<br><br>To create a Point Of Interest, click the <i>Add</i> button beneath the Point Of Interest choice list at the top of the Annotation Panel to create a new Point of Interest.'
				+ ' Or, click the <i>Edit</i> button to modify the current POI. If no Annotations have been created, a placeholder POI will be the only item in the Point Of Interest list.'
				+ '<br><br><i><strong>More Buttons:</strong></i>'
				+ '<br><br>When the Add button is clicked, two different buttons will be displayed: <i>Save</i> and <i>Cancel</i>. If the Edit button is clicked, a third button will also be displayed: <i>Delete</i>.'
				+ '<br><br>Save a Point Of Interest using the button with the disk icon.'
				+ ' Cancel edits to a Point Of Interest using the button with the large X icon.'
				+ '<br><br>Delete a Point Of Interest using the trash can button. The POI will be removed from the list and the prior POI in the list will be displayed.'
				+ '<br><br><i><strong>Important:</strong>'
				+ '<ul>'
				+ '<li>Changing the selected POI in the POI list will automatically save any edits to the current POI.'
				+ '<li>Clicking any of the buttons Save, Cancel, and Delete will leave the Add or Edit mode and return to Annotation Panel to its default display.'
				+ '<li>If using a mouse, hold the cursor over any button to see a helpful reminder.'
				+ '</ul>'
				+ '</i>'
				+ '<strong>Labels</strong>'
				+ '<br><br>To add a new Label to the current Point Of Interest, click the Add button beneath the Label section of the Annotation Panel. Or, click the Edit button to edit the current Label. If no Labels have been created yet, the Label list will be empty.'
				+ '<br><br>If adding a new Label, click any of the buttons at the top of the Label section of the Annotation Panel: Freehand, Text, Rectangle, Polygon, or Measure.'
				+ '<br><br>Now click or click-drag in the image to create a new Label:'
				+ '<ul>'
				+ '<li>Freehand drawings are created by click-dragging.'
				+ '<li>Text labels are created with a simple click in the image.'
				+ '<li>Icons first require the type of icon to be chosen from the icon list. Then the icon is created by clicking the image.'
				+ '<li>Rectangles do not require multiple clicks - just click-drag and all four corners are automatically created and repositioned.'
				+ '<li>Polygons require multiple clicks in the image to create corner <i>control points</i>.  Alt-click the image to create a final point, or click the first point to close the polygon.'
				+ '<li>Measurements are just like polygons except that the caption dynamically changes to display the current length or area.'
				+ '</ul>'
				+ 'Use the Color button to set the color of new freehand drawings, text captions, icon captions, and the lines and captions of rectangles, polygons, and measurements.'
				+ '<br><br>Use the View button to return to navigation mode in the current Label.'
				+ '<br><br><i><strong>Important:</strong>'
				+ '<ul>'
				+ '<li>In Add mode, multiple clicks or click-drags will create multiple Labels - to support rapid annotation authoring.'
				+ '<li>In Edit mode, any clicks or click-drags will simple replace the current Label in the image.'
				+ '<li>Alt-click any label in the image to display its values in the Annotatoin Panel for editing. (Add or Edit mode)'
				+ '<li>Alt-click-drag any completed label in the image to reposition it.  (Add or Edit mode)'
				+ '<li>Control points of rectangles, polygons, and measurments can be click-dragged to modify a polygon.'
				+ '</ul>'
				+ '</i>'
				+ '<i><strong>More Label Values:</strong></i>'
				+ '<br><br>The Annotation Panel also displays the name, caption, tooltip, and click-URL of of the currently selected label for easy editing. Use the TAB key to implement any edits or click in another text field or in the image. '
				+ '<br><br>Two choice lists are also included: the first allows the caption to be positioned relative to the Label in the image while the second determines whether the click-URL (if any) will open in the current browser window or a new browser window or a specific frame in the web page. '
				+ '<br><br>The Scale buttons allow the Label to be sized in the image.  The Rollover checkbox can be used to hide a Label in the image until the cursor is over it (not supported by mobile devices).'
				+ '<br><br>The Save, Cancel, and Delete buttons for Labels work just as they do with Points of Interest, as described above. And remember, changing the selected Label in the Label list will automatically save any edits to the current Label. Alt-clicking or alt-click-dragging a Label in the image will also change the current Label in the Label list and cause any edits to be saved (see the first two Special Tips below).'
				+ '<br><br><i><strong>Important:</strong>'
				+ '<ul>'
				+ '<li>Changing the selected Label by clicking or click-dragging it in the image will change the selected Point Of Interest if the newly selected Label is associated with a different POI - if editing is in progress the edits will be automatically saved.'
				+ '<li>If using a mouse, hold the cursor over any button to see a helpful reminder.'
				+ '</ul>'
				+ '</i>'
				+ '<strong>Notes</strong>'
				+ '<br><br>To add a new Note to the current Point Of Interest, click the Add button beneath the Note section of the Annotation Panel. Or, click the Edit button to edit the current Note. If no Notes have been created yet, the Note list will be empty.'
				+ '<br><br>Use the name and text fields to easily add or edit the Note values. Notes can hold a virtually unlimited number of characters (spaces included). A vertical scrollbar automatically appears when a note requires more lines than fit in the note area. Notes can contain carriage returns.'
				+ '<br><br>The Save, Cancel, and Delete buttons for Notes work just as they do with Points of Interest, as described above. And remember, changing the selected Note in the Note list will automatically save any edits to the current Note.'
				+ '</font></p>';
				break;
			case 'CONTENT_HELPCONCATENATOR' :
				resTxt = '<p align=%22center%22><font face=%22Arial,Helvetica,sans-serif%22><strong>\\/ \\/ \\/</strong></font></p>'
				break;
			case 'CONTENT_HELPANNOTATIONVIEWING' :
				resTxt = '<p align=%22center%22><font face=%22Arial,Helvetica,sans-serif%22><strong>Annotation Help</strong></font></p>'
				+ '<p align=%22justify%22><font face=%22Arial,Helvetica,sans-serif%22>The Annotation Panel provides an intuitive display of <i>Points of Interest</i> in a zoomable image, along with associated <i>Labels</i> and <i>Notes</i>, if any.'
				+ '<br><br>A Point Of Interest (POI) is a place in the image that is named and listed so that it can be navigated to easily.'
				+ '<br><br>A Label is a visual element in the image: a freehand drawing, text caption, rectangle or other polygon, or a measurement.'
				+ '<br><br>A Note is text associated with a Point Of Interest. Notes can hold a virtually unlimited number of characters (spaces included). A vertical scrollbar automatically appears when a note requires more lines than fit in the note area.'
				+ '</font></p>';
				break;

			case 'CONTENT_SKIPUSERNAME' :
				resTxt = 'Anonymous User';
				break;
			case 'CONTENT_FIRSTPOINAME' :
				resTxt = 'Whole Image';
				break;
			case 'CONTENT_POINAME' :
				resTxt = 'New Point Of Interest ';
				break;
			case 'CONTENT_POIUSER' :
				resTxt = this.getResource('CONTENT_SKIPUSERNAME');
				break;
			case 'CONTENT_HOTSPOTNAME' :
				resTxt = 'New Hotspot ';
				break;
			case 'CONTENT_HOTSPOTCAPTION' :
				resTxt = 'Caption for hotspot ';
				break;
			case 'CONTENT_LABELNAME' :
				resTxt = 'New Label ';
				break;
			case 'CONTENT_LABELCAPTION' :
				resTxt = 'Caption for label ';
				break;
			case 'CONTENT_LABELCOMMENT' :
				resTxt = 'Comment for label ';
				break;
			case 'CONTENT_LABELCOMMENTMARKUPNOLABELS' :
				resTxt = 'Pick a label type above then click in the image to create!';
				break;
			case 'CONTENT_ANNOTATIONPLACEHOLDERCOMMENTTEXT' :
				resTxt = '';
				break;
			case 'CONTENT_POLYGONCAPTION' :
				resTxt = 'Polygon ';
				break;
			case 'CONTENT_LABELTOOLTIP' :
				resTxt = 'Tooltip for label ';
				break;
			case 'CONTENT_LABELCLICKURL' :
				resTxt = '';
				break;
			case 'CONTENT_LABELUSER' :
				resTxt = this.getResource('CONTENT_SKIPUSERNAME');
				break;
			case 'CONTENT_NOTENAME' :
				resTxt = 'New Note ';
				break;
			case 'CONTENT_NOTETEXT' :
				resTxt = 'Note text';
				break;
			case 'CONTENT_NOTEUSER' :
				resTxt = this.getResource('CONTENT_SKIPUSERNAME');
				break;
			case 'CONTENT_ANNOTATIONPLACEHOLDERLISTTEXT' :
				resTxt = 'List creation in progress...';
				break;
			case 'CONTENT_ANNOTATIONPLACEHOLDERNOTETEXT' :
				resTxt = 'Note loading in progress...';
				break;

			case 'CONTENT_CAPTIONTEXTCOLOR' :
				resTxt = (Z.captionTextColor) ? Z.captionTextColor : '#FFFFFF';
				break;
			case 'CONTENT_CAPTIONBACKCOLOR' :
				resTxt = (Z.captionBackColor) ? Z.captionBackColor : '#000000';
				break;
			case 'CONTENT_POLYGONLINECOLOR' :
				resTxt = (Z.polygonLineColor) ? Z.polygonLineColor : '#FFFFFF';
				break;
			case 'CONTENT_POLYGONFILLCOLOR' :
				resTxt = (Z.polygonFillColor) ? Z.polygonFillColor : '#FFFFFF';
				break;
			case 'CONTENT_CAPTIONTEXTVISIBLE' :
				resTxt = (Z.captionTextVisible) ? '1' : '0';
				break;
			case 'CONTENT_CAPTIONBACKVISIBLE' :
				resTxt = (Z.captionBackVisible) ? '1' : '0';
				break;
			case 'CONTENT_POLYGONLINEVISIBLE' :
				resTxt = (Z.polygonLineVisible) ? '1' : '0';
				break;
			case 'CONTENT_POLYGONFILLVISIBLE' :
				resTxt = (Z.polygonFillVisible) ? '1' : '0';
				break;

			case 'CONTENT_CAPTIONPOSITION' :
				resTxt = '8';
				break;
			case 'CONTENT_EDITABLE' :
				resTxt = '1';
				break;

			case 'CONTENT_TRACKINGPLACEHOLDERLISTTEXT' :
				resTxt = 'List creation in progress...';
				break;
			case 'CONTENT_TRACKINGTEXTCOLOR' :
				resTxt = '#FFFFFF';
				break;
			case 'CONTENT_TRACKINGLINECOLOR' :
				resTxt = '#000000';
				break;
			case 'CONTENT_TRACKINGFILLCOLOR' :
				resTxt = '#FFFFFF';
				break;
			case 'CONTENT_COUNTERNAME' :
				resTxt = 'Counter Type 0';
				break;
			case 'CONTENT_COUNTERCAPTION' :
				resTxt = 'Caption for counter';
				break;
			case 'CONTENT_COUNTERCAPTIONPOSITION' :
				resTxt = '5';
				break;
			case 'CONTENT_COUNTERFILLCOLOR' :
				resTxt = '#FFFFFF';
				break;
			case 'CONTENT_COUNTERCELL' :
				resTxt = '0:0:100';
				break;
			case 'CONTENT_COUNTERUSER' :
				resTxt = 'Anonymous User';
				break;
			case 'CONTENT_COUNTERUSERINITIALS' :
				resTxt = 'AU';
				break;

			case 'CONTENT_USERPLACEHOLDERLISTTEXT' :
				resTxt = 'List creation in progress...';
				break;

			default:
				resTxt = 'Unexpected resource request';
		}
		return resTxt;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::: ELEMENT & OBJECT UTILITY FUNCTIONS ::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	clearDisplay : function (display) {
		// Completely clear viewport or other display including prior tiles better than backfill. Subsequent
		// redraw of new tiles will leave gaps with backfill showing rather than tiles from prior view.
		if (display) {
			if (Z.useCanvas && display.tagName == 'CANVAS') {
				Z.Utils.clearCanvas(display);
			} else {
				while (display.hasChildNodes()) {
				 	display.removeChild(display.lastChild);
				}
			}
		}
	},

	clearCanvas : function (canvas) {
		var ctx = canvas.getContext('2d');
		ctx.save();
		// Trap possible NS_ERROR_FAILURE error especially in firefox especially if working with large unconverted image.
		// DEV NOTE: Add retry or soft fail in catch in future implementation for firefox issue with large canvases.
		try {
			ctx.setTransform(1,0,0,1,0,0);
		} catch (e) {
			Z.Utils.showMessage(Z.Utils.getResource('ERROR_SETTINGTRANSFORMONCANVASFORUNCONVERTEDIMAGE'));
			console.log('In function clearCanvas setting transform on canvas:  ' + e);
		}
		ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
		ctx.restore();
	},

	colorCanvas : function (canvas, color) {
		var ctx = canvas.getContext('2d');
		ctx.save();
		ctx.setTransform(1,0,0,1,0,0);
		ctx.fillStyle = color;
		ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
		ctx.restore();
	},

	deleteDiv : function (divID) {
		var targetDiv = document.getElementById(divID);
		if (targetDiv) {
			while (targetDiv.hasChildNodes()) {
				targetDiv.removeChild(targetDiv.lastChild);
			}
			targetDiv.parentNode.removeChild(targetDiv);
		}
	},

	createCallback : function (object, method) {
		var initialArgs = [];
		for (var i = 2, j = arguments.length; i < j; i++) {
			initialArgs[initialArgs.length] = arguments[i];
		}
		return function () {
			var args = initialArgs.concat([]);
			for (var i = 0, j = arguments.length; i < j; i++) {
				args[args.length] = arguments[i];
			}
			return method.apply(object, args);
		};
	},

	// Timer permits completion of callback-related events such as mouseup during updateView.
	// Passing in array ensures multiple callbacks on same event will not be interfered with by clearCallback calls of any.
	validateCallback : function (callbackEvent) {
		if (typeof Z.callbacks === 'undefined') { Z.callbacks = []; }
		var callbacksTempCopy = Z.callbacks.slice(0);
		Z.Utils.functionCallWithDelay(function () { Z.Utils.validateCallbackDelayed(callbackEvent, callbacksTempCopy); }, 10);
	},

	// For loop enables more than one function call to be assigned to a callback event.
	validateCallbackDelayed : function (callbackEvent, callbacksTempArr) {
		for (var i = 0, j = callbacksTempArr.length; i < j; i++) {
			var callback = callbacksTempArr[i];

			// DEV NOTE: First condition needed due to asynchronous callbacks array deletions.
			if (callback && callback.callbackEvent == callbackEvent && typeof callback === 'object' && typeof callback.callbackFunction === 'function') {

				switch (callbackEvent) {
					case 'viewChanging' :
						callback.callbackFunction();
						break;
					case 'viewPanningGetCurrentCoordinates' :
						var currCoords = Z.Viewport.getCoordinates();
						callback.callbackFunction(currCoords);
						break;
					case 'viewZoomingGetCurrentZoom' :
						var currentZ = Z.Viewport.getZoom();
						callback.callbackFunction(currentZ);
						break;
					case 'viewChangingGetCurrentCoordinatesFull' :
						var currCoordsFull = Z.Viewport.getCoordinatesFull();
						callback.callbackFunction(currCoordsFull);
						break;
					case 'viewUpdateCompleteGetLabelIDs' :
						var labelIDsInView = Z.Viewport.getLabelIDsInCurrentView(false, true, true);
						callback.callbackFunction(labelIDsInView);
						break;
					case 'viewUpdateCompleteGetLabelInternalIDs' :
						var labelInternalIDsInView = Z.Viewport.getLabelIDsInCurrentView(true, true, true);
						callback.callbackFunction(labelInternalIDsInView);
						break;
					case 'labelSavedGetJSONObject' :
						var labelCurr = Z.Viewport.getCurrentLabel();
						if (labelCurr) {
							var labelIDCurrent = labelCurr.internalID;
							var jsonLabelObject = Z.Viewport.getLabelJSONObject(labelIDCurrent, true);
							callback.callbackFunction(jsonLabelObject);
						}
						break;
					case 'labelCreatedGetInternalID' :
						if (Z.Viewport && Z.Viewport.getStatus('XMLParsedViewport')) {
							var labelCurr = Z.Viewport.getCurrentLabel();
							if (labelCurr) {
								var labelIDCurrent = labelCurr.internalID;
								callback.callbackFunction(labelIDCurrent);
							}
						}
						break;
					case 'labelSelectedInViewportGetIDs' :
						if (Z.Viewport) {
							var labelCurr = Z.Viewport.getCurrentLabel();
							if (labelCurr) {
								callback.callbackFunction(labelCurr.id, labelCurr.internalID);
							}
						}
						break;
					case 'currentLabelChangedGetID' :
						if (Z.Viewport) {
							var labelCurr = Z.Viewport.getCurrentLabel();
							if (labelCurr) {
								callback.callbackFunction(labelCurr.id, labelCurr.internalID);
							}
						}
						break;
					default :
						callback.callbackFunction();
				}
			}
		}
		Z.Utils.arrayClear(callbacksTempArr);
	},

	getContainerSize : function (container, display) {
		var containerS = Z.Utils.getElementStyle(container);
		var containerW = parseFloat(containerS.width);
		var containerH = parseFloat(containerS.height);

		if (Z.Utils.stringValidate(containerS.width) && containerS.width.indexOf('%') != -1) { containerW = parseFloat(Z.Utils.getElementStyleProperty(container, 'width')); } // Win IE only.
		if (Z.Utils.stringValidate(containerS.height) && containerS.height.indexOf('%') != -1) { containerH = parseFloat(Z.Utils.getElementStyleProperty(container, 'height')); } // Win IE only.
		if (isNaN(containerW)) { containerW = display.clientWidth; }
		if (isNaN(containerH)) { containerH = display.clientHeight; }
		if (containerW == 0 || containerH == 0) {
			winDimensions = Z.Utils.getWindowSize();
			if (containerW == 0) {
				container.parentNode.style.width = winDimensions.x + 'px';
				containerW = container.clientWidth;
			}
			if (containerH == 0) {
				container.parentNode.style.height = winDimensions.y + 'px';
				containerH = container.clientHeight;
			}
		}

		// Fail-safe defaults.
		if (isNaN(containerW) || containerW == 0) { containerW = 800; }
		if (isNaN(containerH) || containerH == 0) { containerH = 400; }

		return new Z.Utils.Point(containerW, containerH);
	},

	createContainerElement : function (tagName, id, display, position, overflow, width, height, right, top, borderStyle, borderWidth, background, margin, padding, whiteSpace, cursor, preventSelect) {
		var emptyContainer = document.createElement(tagName);
		if (this.stringValidate(id)) { emptyContainer.id = id; }
		var ecS = emptyContainer.style;
		ecS.display = (this.stringValidate(display)) ? display : 'inline-block';
 		ecS.position = (this.stringValidate(position)) ? position : 'static';
 		ecS.overflow = (this.stringValidate(overflow)) ? overflow : 'hidden';
 		if (tagName == 'canvas') {
 			if (this.stringValidate(width)) { emptyContainer.setAttribute('width', width); }
 			if (this.stringValidate(height)) { emptyContainer.setAttribute('height', height); }
 		} else {
 			if (this.stringValidate(width)) { ecS.width = width; }
 			if (this.stringValidate(height)) { ecS.height = height; }
 		}
 		if (this.stringValidate(right)) { ecS.right = right; }
 		if (this.stringValidate(top)) { ecS.top = top; }
 		ecS.borderStyle = (this.stringValidate(borderStyle)) ? borderStyle : 'none';
 		ecS.borderWidth = (this.stringValidate(borderWidth)) ? borderWidth : '0px';
 		ecS.borderColor = '#696969';
 		ecS.background = (this.stringValidate(background)) ? background : 'transparent none';
 		ecS.margin = (this.stringValidate(margin)) ? margin : '0px';
 		ecS.padding = (this.stringValidate(padding)) ? padding : '0px';
 		ecS.whiteSpace = (this.stringValidate(whiteSpace)) ? whiteSpace : 'normal';
 		if (this.stringValidate(cursor)) { ecS.cursor = cursor; } // No explicit default assignment.
		if (preventSelect !== 'undefined' && preventSelect) {
			Z.Utils.addEventListener(emptyContainer, 'touchstart', Z.Utils.preventDefault);
			Z.Utils.addEventListener(emptyContainer, 'mousedown', Z.Utils.preventDefault);
			Z.Utils.addEventListener(emptyContainer, 'contextmenu', Z.Utils.preventDefault);
		}
		return emptyContainer;
	},

	createCenteredElement : function (elmt, id) {
		// Note that id is assigned to inner centered container not to embedded text node. To access use
		// firstChild, for example: var textNode = document.getElementById('myTextNode').firstChild;
		var div = this.createContainerElement('div');
		var html = [];
		html[html.length] = '<div style="#position:relative; display:table; height:100%; width:100%; border:none; margin:0px; padding:0px; overflow:hidden; text-align:left;">';
		html[html.length] = '<div style="#position:absolute; display:table-cell; #top:50%; width:100%; border:none; margin:0px; padding:0px; vertical-align:middle;">';
		html[html.length] = '<div id="' + id + '"; style="#position:relative; width:100%; #top:-50%; border:none; margin:0px; padding:0px; text-align:center;"></div></div></div>';

		// Debug option: console.log(html.toString());
		div.innerHTML = html.join('');
		div = div.firstChild;
		var innerDiv = div;
		var innerDivs = div.getElementsByTagName('div');
		while (innerDivs.length > 0) {
			innerDiv = innerDivs[0];
			innerDivs = innerDiv.getElementsByTagName('div');
		}
		innerDiv.appendChild(elmt);
		return div;
	},

	createTextElement : function (id, value, width, height, left, top, padding, border, borderWidth, readOnly, fontFamily, fontSize, resize, columns, rows, overflowX, overflowY, wrap) {
		var textBox = Z.Utils.createContainerElement('div', 'textBoxFor-' + id, 'inline-block', 'absolute', 'hidden', width, height, left, top, border, borderWidth, 'white', '0px', padding, 'normal');
		var textArea = document.createElement('textarea');
		textBox.appendChild(textArea);
		var ntA = textArea;
		var ntaS = ntA.style;
		ntA.id = id;
		ntA.value = value;
		ntA.readOnly = readOnly;
		ntaS.width = '100%';
		ntaS.height = '100%';
		ntaS.margin = '0';
		ntaS.border = '0';
		if (this.stringValidate(fontFamily)) { ntaS.fontFamily = fontFamily; }
		if (this.stringValidate(fontSize)) { ntaS.fontSize = fontSize; }
		if (this.stringValidate(resize)) { ntaS.resize = resize; }
		if (this.stringValidate(columns)) { ntA.columns = columns; }

		// Support single-line, non-wrapping, no scrollbar textarea (use createTextNode for labels).
		if (this.stringValidate(rows)) { ntA.rows = rows; }
		if (this.stringValidate(overflowX)) { ntaS.overflowX = overflowX; }
		if (this.stringValidate(overflowY)) { ntaS.overflowY = overflowY; }
		if (this.stringValidate(wrap)) {
			ntA.wrap = wrap;
			// DEV NOTE: Alternative implementation - may require overlow='auto' and/or whiteSpace='pre'.
			if (wrap == 'off') { ntaS.whiteSpace = 'nowrap'; }
		}

		return textBox;
	},

	createSelectElement : function (listID, listTitle, dataProvider, listW, listX, listY, fontSize, visible, handler, handlerType) {
		// Create list.
		var sList = document.createElement('select');
		sList.id = listID;
		if (Z.Utils.stringValidate(listTitle) && listTitle != 'none') { sList.options[0] = new Option(listTitle, null); } // First option, set without value.
		for (var i = 0, j = dataProvider.length; i < j; i++) {
			sList.options[sList.options.length] = new Option(dataProvider[i].text, dataProvider[i].value);
		}

		// Assigning handler to mousedown event allows handler to set selected element to null and then assign change handler which
		// enables reselection of current element in list which would otherwise not trigger a change event. Alternative is to assign handler
		// to onchange event. Additional note: if no need to remove handler, direct assignment is possible as follows: sList.onchange = handler;
		var hType = (typeof handlerType !== 'undefined' && handlerType !== null) ? handlerType : 'change';
		Z.Utils.addEventListener(sList, hType, handler);

		// Set list position and visibilty.
		var slS = sList.style;
		slS.width = listW + 'px';
		slS.position = 'absolute';
		slS.left = listX + 'px';
		slS.top = listY + 'px';
		slS.fontSize = (fontSize == null) ? '11px' : fontSize + 'px';
		slS.fontFamily = 'verdana';
		slS.visibility = visible;

		return sList;
	},

	updateSelectElement : function (listObject, dataProvider, selID) {
		if (listObject) {
			var index = (listObject.selectedIndex != -1) ? listObject.selectedIndex : 0;
			listObject.innerHTML = '';
			for (var i = 0, j = dataProvider.length; i < j; i++) {
				listObject.options[listObject.options.length] = new Option(dataProvider[i].text, dataProvider[i].value.toString());
			}
			if (typeof selID !== 'undefined' && selID !== null) {
				var indexID = parseInt(Z.Utils.arrayIndexOfObjectValue(dataProvider, 'value', selID), 10);
				if (indexID != -1) { index = indexID; }
			}
			var indexLast = listObject.options.length - 1;
			listObject.selectedIndex = (index <= indexLast) ? index : indexLast;
		}
	},

	getChildElementByID : function (container, id) {
		var targetElmt = null;
		for (var i = 0, j = container.childNodes.length; i < j; i++) {
			var currNode = container.childNodes[i];
			if (currNode.id == id) {
				targetElmt = currNode;
				return targetElmt;
			} else {
				targetElmt = Z.Utils.getChildElementByID(currNode, id);
				if (targetElmt !== null) { return targetElmt; }
			}
		}
		return targetElmt;
	},

	getElementPosition : function (elmt) {
		var left = 0;
		var top = 0;
		var isFixed = this.getElementStyle(elmt).position == 'fixed';
		var offsetParent = this.getOffsetParent(elmt, isFixed);
		while (offsetParent) {
			left += elmt.offsetLeft;
			top += elmt.offsetTop;
			if (isFixed) {
				var psPt = this.getPageScroll();
				left += psPt.x;
				top += psPt.y;
			}
			elmt = offsetParent;
			isFixed = this.getElementStyle(elmt).position == 'fixed';
			offsetParent = this.getOffsetParent(elmt, isFixed);
		}
		return new this.Point(left, top);
	},

	getOffsetParent : function (elmt, isFixed) {
		if (isFixed && elmt != document.body) {
			return document.body;
		} else {
			return elmt.offsetParent;
		}
	},

	getElementSize : function (elmt) {
		return new this.Point(elmt.clientWidth, elmt.clientHeight);
	},

	getElementStyle : function (elmt) {
		if (elmt.currentStyle) {
			return elmt.currentStyle;
		} else if (window.getComputedStyle) {
			return window.getComputedStyle(elmt, '');
		} else {
			this.showMessage(this.getResource('ERROR_UNKNOWNELEMENTSTYLE'));
		}
	},

	getElementStyleProperty : function (elmt, styleProp) {
		if (window.getComputedStyle) {
			return window.getComputedStyle(elmt, null).getPropertyValue(styleProp);
		} else if (elmt.currentStyle) {
			return elmt.currentStyle[styleProp];
		} else {
			this.showMessage(this.getResource('ERROR_UNKNOWNELEMENTSTYLE'));
		}
	},

	getElementStylePropertyZIndex : function (elmt) {
		var zIndex = 0;
		if (window.document.defaultView.getComputedStyle) {
			zIndex = window.document.defaultView.getComputedStyle(elmt, null).getPropertyValue('z-index');
		} else if (elmt.currentStyle) {
			zIndex = elmt.currentStyle['z-index'];
		} else {
			this.showMessage(this.getResource('ERROR_UNKNOWNELEMENTSTYLE'));
		}
		return zIndex;
	},

	isElementFluid : function (element) {
		var valuesPixel = null;
		var clone = element.cloneNode(false);
		var testContainer, offsetW, offsetH, percent1, percent2;
		var wFluid = false, hFluid = false;
		var fluidNew = null, fluidFailSafe = null;
		var containerW = 0, containerH = 0;

		var containerS = Z.Utils.getElementStyle(element);
		if (containerS) {
			containerW = containerS.width;
			containerH = containerS.height;
			valuesPixel = (containerW.indexOf('px') != -1 && containerH.indexOf('px') != -1);
		}

		// Prevent auto resizing in old versions of IE due to lack of support for CSS tests in function isElementFluid.
		if (Z.browser != Z.browsers.IE || (Z.browserVersion >= 9 && !valuesPixel)) {

			// First test width.
			if (window.getComputedStyle) {
				value = window.getComputedStyle(clone,null).width;
			} else if (clone.currentStyle) {
				value = clone.currentStyle.width;
			}
			if (typeof value !== 'undefined' && value !== null && value !== '') {
				wFluid = (value.toString().indexOf('%') != -1 || value == 'auto'); // Test for 'auto' for IE.
			}

			// If width not fluid, test height.
			if (!wFluid) {
				if (window.getComputedStyle) {
					value = window.getComputedStyle(clone,null).height;
				} else if (clone.currentStyle) {
					value = clone.currentStyle.height;
				}
				if (typeof value !== 'undefined' && value !== null && value != '') {
					hFluid = (value.toString().indexOf('%') != -1 || value == 'auto'); // Test for 'auto' for IE.
				}
			}

			// If neither width nor height is fluid, test for vw or vh values.
			if (!wFluid && !hFluid) { fluidNew = Z.Utils.isElementFluidNew(element); }

			// Fail-safe: assume decimal pixel value computed and therefore fluid.
			if (!wFluid && !hFluid) { fluidFailSafe = (parseFloat(containerW) % 1 != 0 || parseFloat(containerH) % 1 != 0); }
		}

		return (wFluid || hFluid || fluidNew || fluidFailSafe);
	},

	// Workaround to determine if vw or vh is used rather than pixels or percents.
	// DEV NOTE: This workaround is not robust. Use zAutoResize=1 to force resizability if using vw and vh rather than percent values.
	isElementFluidNew : function (element) {
		// Debug: attempt to search for vw or vh value in container settings.
		//console.log(element.parentNode.parentNode.innerHTML);

		var clone = element.cloneNode(false);
		var testContainer, offsetW, offsetH, percent1, percent2;
		var wFluidNew = false, hFluidNew = false;

		// First test width.
		clone.style.margin = '0';
		clone.style.padding = '0';
		clone.style.maxWidth = 'none';
		clone.style.minWidth = 'none';
		testContainer = document.createElement('testContainer');
		testContainer.style.display = 'block';
		testContainer.style.width = '800px';
		testContainer.style.padding = '0';
		testContainer.style.margin = '0';
		testContainer.appendChild(clone);
		element.parentNode.insertBefore(testContainer, element);
		offsetW = clone.offsetWidth;
		testContainer.style.width = '900px';
		if ( clone.offsetWidth == offsetW ){
			element.parentNode.removeChild(testContainer);
			wFluidNew = false;
		} else {
			percent1 = Math.floor(100 / 800 * offsetW);
			percent2 = Math.floor(100 / 900 * clone.offsetWidth);
			element.parentNode.removeChild(testContainer);
			wFluidNew = (percent1 == percent2) ? true : false;
			// Debug option: console.log(Math.round(percent1) + '%');
		}

		// If width not fluid, test height.
		if (!wFluidNew) {
			clone.style.margin = '0';
			clone.style.padding = '0';
			clone.style.maxHeight = 'none';
			clone.style.minHeight = 'none';
			testContainer = document.createElement('testContainer');
			testContainer.style.display = 'block';
			testContainer.style.height = '800px';
			testContainer.style.padding = '0';
			testContainer.style.margin = '0';
			testContainer.appendChild(clone);
			element.parentNode.insertBefore(testContainer, element);
			offsetH = clone.offsetHeight;
			testContainer.style.height = '900px';
			if ( clone.offsetHeight == offsetH ){
				element.parentNode.removeChild(testContainer);
				hFluidNew = false;
			} else {
				percent1 = Math.floor(100 / 800 * offsetH);
				percent2 = Math.floor(100 / 900 * clone.offsetHeight);
				element.parentNode.removeChild(testContainer);
				hFluidNew = (percent1 == percent2) ? true : false;
				// Debug option: console.log(Math.round(percent1) + '%');
			}
		}

		return (wFluidNew || hFluidNew);
	},

	getEventTargetCoords : function (event) {
		return getElementPosition(Z.Utils.target(event));
	},

	getFirstTouch : function (event) {
		var firstTouch = null;
		var touches = event.touches;
		var changed = event.changedTouches;
		if (typeof touches !== 'undefined') {
			firstTouch = touches[0];
		} else if (typeof changed !== 'undefined') {
			firstTouch = changed[0];
		}
		return firstTouch;
	},

	getMousePosition : function (event) {
		var x = 0;
		var y = 0;
		if (event.type == 'DOMMouseScroll' && Z.browser == Z.browsers.FIREFOX && Z.browserVersion < 3) {
			x = event.screenX;
			y = event.screenY;
		} else if (typeof event.pageX === 'number') {
			x = event.pageX;
			y = event.pageY;
		} else if (typeof event.clientX === 'number') {
			x = event.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
			y = event.clientY + document.body.scrollTop + document.documentElement.scrollTop;
		} else {
			// DEV NOTE: Error reported onSony Z3. Investigating.
			console.log(this.getResource('ERROR_UNKNOWNMOUSEPOSITION'));
		}
		return new this.Point(x, y);
	},

	getMouseScroll : function (event) {
		var delta = 0;
		if (typeof event.wheelDelta === 'number') {
			delta = event.wheelDelta;
		} else if (typeof event.detail === 'number') {
			delta = event.detail * -1;
		} else {
			this.showMessage(this.getResource('ERROR_UNKNOWNMOUSESCROLL'));
		}
		return delta ? delta / Math.abs(delta) : 0;
	},

	getPageScroll : function () {
		var x = 0;
		var y = 0;
		var docElmt = document.documentElement || {};
		var body = document.body || {};
		if (typeof window.pageXOffset === 'number') {
			x = window.pageXOffset;
			y = window.pageYOffset;
		} else if (body.scrollLeft || body.scrollTop) {
			x = body.scrollLeft;
			y = body.scrollTop;
		} else if (docElmt.scrollLeft || docElmt.scrollTop) {
			x = docElmt.scrollLeft;
			y = docElmt.scrollTop;
		}
		return new this.Point(x, y);
	},

	getScreenSize : function () {
		var x = window.screen?.width;
		var y = window.screen?.height;
		return new this.Point(x, y);
	},

	getWindowSize : function () {
		var x = 0;
		var y = 0;
		var docElmt = document.documentElement || {};
		var body = document.body || {};
		if (typeof window.innerWidth === 'number') {
			x = window.innerWidth;
			y = window.innerHeight;
		} else if (docElmt.clientWidth || docElmt.clientHeight) {
			x = docElmt.clientWidth;
			y = docElmt.clientHeight;
		} else if (body.clientWidth || body.clientHeight) {
			x = body.clientWidth;
			y = body.clientHeight;
		} else {
			this.showMessage(this.getResource('ERROR_UNKNOWNWINDOWSIZE'));
		}
		return new this.Point(x, y);
	},

	Button : function (id, label, graphicPath, graphicUp, graphicOver, graphicDown, w, h, x, y, btnEvnt, btnEvntHndlr, tooltipResource, borderStyle, borderWidth, background, margin, padding, whiteSpace, cursor) {
		var button = Z.Utils.createContainerElement('span', id, 'inline-block', 'absolute', 'hidden', w, h, x, y, borderStyle, borderWidth, background, margin, padding, whiteSpace, cursor);

		if (!(Z.Utils.stringValidate(label))) {
			// Load images for each button state.
			graphicPath = Z.Utils.stringRemoveTrailingSlashCharacters(graphicPath);
			var imgUp = Z.Utils.createGraphicElement(graphicPath + '/' + graphicUp);
			var imgOver = Z.Utils.createGraphicElement(graphicPath + '/' + graphicOver);
			var imgDown = Z.Utils.createGraphicElement(graphicPath + '/' + graphicDown);

			// Set size and position of button images.
			imgUp.style.width = imgOver.style.width = imgDown.style.width = w;
			imgUp.style.height = imgOver.style.height = imgDown.style.height = h;
			imgUp.style.position = imgOver.style.position = imgDown.style.position = 'absolute';
			if (Z.browser == Z.browsers.FIREFOX && Z.browserVersion < 3) { imgUp.style.top = imgOver.style.top = imgDown.style.top = ''; }

			// Set size and position of button images. Do not explicitly set 'up' graphic visible
			// because this leads to button showing even if in CSS layer that is initially hidden.
			imgOver.style.visibility = imgDown.style.visibility = 'hidden';

			// Set image alt attribute for accessibility compliance.
			imgUp.alt = imgOver.alt = imgDown.alt = '';
			if (typeof tooltipResource !== 'undefined' && Z.Utils.stringValidate(tooltipResource)) {
				imgUp.alt = Z.Utils.getResource(tooltipResource);
			}

			// Add images to button.
			button.appendChild(imgUp);
			button.appendChild(imgOver);
			button.appendChild(imgDown);

		} else {
			var textNode = document.createTextNode(label);
			button.appendChild(Z.Utils.createCenteredElement(textNode));
			Z.Utils.setTextNodeStyle(textNode, 'black', 'verdana', '13px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none');
		}

		// Prevent graphic dragging, event bubbling, menu display, label text selection.
		Z.Utils.addEventListener(button, 'mousedown', Z.Utils.preventDefault);
		Z.Utils.addEventListener(button, 'mouseover', Z.Utils.stopPropagation);
		Z.Utils.addEventListener(button, 'mousedown', Z.Utils.stopPropagation);
		Z.Utils.addEventListener(button, 'mouseup', Z.Utils.stopPropagation);
		Z.Utils.addEventListener(button, 'mouseout', Z.Utils.stopPropagation);
		if (typeof imageUp !== 'undefined') {
			Z.Utils.addEventListener(imgUp, 'contextmenu', Z.Utils.preventDefault);
			Z.Utils.addEventListener(imgOver, 'contextmenu', Z.Utils.preventDefault);
			Z.Utils.addEventListener(imgDown, 'contextmenu', Z.Utils.preventDefault);
			//imgUp.oncontextmenu = Z.Utils.preventDefault; // DEV NOTE: Ineffective on IE.
		}
		Z.Utils.addEventListener(button, "touchstart", Z.Utils.preventDefault);
		Z.Utils.addEventListener(button, "touchend", Z.Utils.preventDefault);
		Z.Utils.addEventListener(button, "touchcancel", Z.Utils.preventDefault);
		if (!(Z.Utils.stringValidate(label))) {
			Z.Utils.disableTextInteraction(textNode);
			Z.Utils.addEventListener(button, 'contextmenu', Z.Utils.preventDefault);
		}

		// Set tooltip visibility per optional parameter.
		if (Z.tooltipsVisible && Z.Utils.stringValidate(tooltipResource)) { button.title = Z.Utils.getResource(tooltipResource); }

		// Return button with event handler enabled.
		Z.Utils.setButtonHandler(button, btnEvnt, btnEvntHndlr);
		this.elmt = button;
	},

	buttonSize : function (targetBtn, w, h) {
		var btnS = targetBtn.style;
		btnS.width = w + 'px';
		btnS.height = h + 'px';
		var iU = targetBtn.firstChild;
		var iO = targetBtn.childNodes[1];
		var iD = targetBtn.childNodes[2];
		if (iU && iO && iD) {
			iU.style.width = iO.style.width = iD.style.width = w + 'px';
			iU.style.height = iO.style.height = iD.style.height = w + 'px';
		}
	},

	setButtonDefaults : function (targetBtn) {
		Z.Utils.clearButtonSettings(targetBtn);
		Z.Utils.setButtonState(targetBtn, 'up');
		Z.Utils.setButtonHandler(targetBtn, 'mouseover', Z.Toolbar.buttonEventsHandler);
	},

	clearButtonSettings : function (targetBtn) {
		var iU = targetBtn.firstChild;
		var iO = targetBtn.childNodes[1];
		var iD = targetBtn.childNodes[2];
		if (iU && iO && iD) {
			iU.style.visibility = iO.style.visibility = iD.style.visibility = 'hidden';
			Z.Utils.removeEventListener(iU, 'mouseover', Z.Toolbar.buttonEventsHandler);
			Z.Utils.removeEventListener(iO, 'mousedown', Z.Toolbar.buttonEventsHandler);
			Z.Utils.removeEventListener(iO, 'mouseout', Z.Toolbar.buttonEventsHandler);
			Z.Utils.removeEventListener(iD, 'mouseup', Z.Toolbar.buttonEventsHandler);
			Z.Utils.removeEventListener(targetBtn, 'touchstart', Z.Toolbar.buttonEventsHandler);
			Z.Utils.removeEventListener(targetBtn, 'touchend', Z.Toolbar.buttonEventsHandler);
			Z.Utils.removeEventListener(targetBtn, 'touchcancel', Z.Toolbar.buttonEventsHandler);
		}
		Z.Utils.removeEventListener(targetBtn, 'mouseover', Z.Toolbar.buttonEventsHandler);
		Z.Utils.removeEventListener(targetBtn, 'mousedown', Z.Toolbar.buttonEventsHandler);
		Z.Utils.removeEventListener(targetBtn, 'mouseout', Z.Toolbar.buttonEventsHandler);
		Z.Utils.removeEventListener(targetBtn, 'mouseup', Z.Toolbar.buttonEventsHandler);
	},

	setButtonState : function (targetBtn, state) {
		var graphic = (state == 'up') ? targetBtn.firstChild : (state == 'down') ? targetBtn.childNodes[1] : targetBtn.childNodes[2];
		if (graphic) { graphic.style.visibility = 'visible'; }
	},

	setButtonHandler : function (target, btnEvnt, btnEvntHndlr) {
		// Allow for button with graphics or label, context as pc or mobile device, and event up, over, or down state relevant.

		var targetEventHandler = (btnEvntHndlr !== 'undefined') ? btnEvntHndlr : Z.Toolbar.buttonEventsHandler;
		var mouseEvent = (btnEvnt !== 'undefined') ? btnEvnt : 'mouseover';
		var touchEvent = (btnEvnt == 'mousedown') ? 'touchstart' : 'touchend';
		var pointerEvent = (btnEvnt == 'mousedown') ? 'MSPointerDown' : 'MSPointerUp';

		// MSPointer event support to follow.
		//targetEvent = (window.navigator.msPointerEnabled) ? pointerEvent : (Z.touchSupport) ? touchEvent : mouseEvent;

		// Support touch and mouse events and prevent touch events from simulating mouse events and creating duplicate function calls.
		//targetEvent = (Z.touchSupport) ? touchEvent : mouseEvent;

		var target = target;
		if (btnEvnt == 'mouseover' && typeof target.firstChild !== 'undefined') {
			target = target.firstChild;
		} else if (btnEvnt == 'mousedown' && typeof target.childNodes[1] !== 'undefined') {
			//target = target.childNodes[1];
		} else if (btnEvnt == 'mouseup' && typeof target.childNodes[2] !== 'undefined') {
			target = target.childNodes[2];
		} else if (btnEvnt == 'mouseout' && typeof target.childNodes[1] !== 'undefined') {
			target = target.childNodes[1];
		}

		// Support touch and mouse events and prevent touch events from simulating mouse events and creating duplicate function calls.
		//Z.Utils.addEventListener(target, targetEvent, targetEventHandler);
		Z.Utils.addEventListener(target, touchEvent, targetEventHandler);
		Z.Utils.addEventListener(target, mouseEvent, targetEventHandler);
	},

	Checkbox : function (id, value, w, h, x, y, checkEvnt, checkEvntHndlr, tooltipResource) {
		// Container serves as workaround for checkbox and form sizing and positioning problems.
		var containerBox = Z.Utils.createContainerElement('div', 'containerFor-' + id, 'inline-block', 'absolute', 'hidden', w, h, x, y, 'none', '0px', 'transparent none', '0px', '0px', 'normal');
		var checkbox = document.createElement('input');
		containerBox.appendChild(checkbox);
		checkbox.type = 'checkbox';
		checkbox.id = id;
		checkbox.value = value;
		checkbox.width = w;
		checkbox.height = h;
		var cS = containerBox.style;
		cS.width = w + 'px';
		cS.height = h + 'px';
		cS.left = x + 'px';
		cS.top = y + 'px';

		// Set event handler and element reference - the handler must support mouse and touch contexts.
		Z.Utils.addEventListener(checkbox, checkEvnt, checkEvntHndlr);
		Z.Utils.addEventListener(checkbox, 'touchstart', checkEvntHndlr);

		// Set tooltip visibility per optional parameter.
		if (Z.tooltipsVisible && Z.Utils.stringValidate(tooltipResource)) { checkbox.title = Z.Utils.getResource(tooltipResource); }

		return containerBox;
	},

	Graphic : function (id, graphicPath, graphic, w, h, x, y, altResource) {
		// Load image for graphic.
		graphicPath = Z.Utils.stringRemoveTrailingSlashCharacters(graphicPath);
		var graphicPathFull = (graphic) ? graphicPath + '/' + graphic : graphicPath;
		var img = Z.Utils.createGraphicElement(graphicPathFull);
		var igS = img.style;
		igS.width = w;
		igS.height = h;

		// Set image alt attribute for accessibility compliance.
		if (typeof altResource !== 'undefined' && Z.Utils.stringValidate(altResource)) {
			img.alt = Z.Utils.getResource(altResource);
		} else {
			img.alt = '';
		}

		// Create graphic element and add image to it.
		var graphic = Z.Utils.createContainerElement('span', id, 'inline-block', 'absolute', 'hidden', w, h, x, y, 'none', '0px', 'transparent none', '0px', '0px', 'normal');
		graphic.appendChild(img);
		this.elmt = graphic;

		// Prevent graphic dragging and disable context menu.
		Z.Utils.addEventListener(img, 'mousedown', Z.Utils.preventDefault);
		Z.Utils.addEventListener(img, 'touchstart', Z.Utils.preventDefault);
		Z.Utils.addEventListener(img, 'contextmenu', Z.Utils.preventDefault);
	},

	createGraphicElement : function (imageSrc) {
		var gImg = this.createContainerElement('img');
		var gElmt = null;
		if (Z.browser == Z.browsers.IE && Z.browserVersion < 7) {
			gElmt = this.createContainerElement('span', null, 'inline-block');
			gImg.onload = function () {
				gElmt.style.width = gElmt.style.width || gImg.width + 'px';
				gElmt.style.height = gElmt.style.height || gImg.height + 'px';
				gImg.onload = null;
				gImg = null;
			};
			gElmt.style.filter = 'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="' + imageSrc + '", sizingMethod="scale")';
		} else {
			gElmt = gImg;
			gElmt.src = imageSrc;
		}
		return gElmt;
	},

	graphicSize : function (targetGphc, w, h) {
			var gS = targetGphc.style;
			gS.width = w + 'px';
			gS.height = h + 'px';
			var img = targetGphc.firstChild;
			var imgS = img.style;
			imgS.width = w + 'px';
			imgS.height = h + 'px';
	},

	Slider : function (id, container, skinArr, btnEvntsHndlr, txtEvntsHndlr, range) {
		var idUpperFirst = Z.Utils.stringUpperCaseFirstLetter(id);
		var idUpperAll = id.toUpperCase();
		var labelTextBox = Z.Utils.createContainerElement('div', 'label' + idUpperFirst + 'TextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
		var labelTextNode = document.createTextNode(Z.Utils.getResource('UI_IMAGEFILTERPANELLABEL' + idUpperAll));
		labelTextBox.appendChild(labelTextNode);
		container.appendChild(labelTextBox);
		var trackSliderFilter = new Z.Utils.Graphic('trackSliderFilter' + idUpperFirst, Z.skinPath, skinArr[15], '1px', '1px', '0px', '0px', 'TIP_SLIDER' + idUpperAll);
		container.appendChild(trackSliderFilter.elmt);
		Z.Utils.addEventListener(trackSliderFilter.elmt, 'mousedown', btnEvntsHndlr);
		Z.Utils.addEventListener(trackSliderFilter.elmt, 'touchstart', btnEvntsHndlr);
		Z.Utils.addEventListener(trackSliderFilter.elmt, 'mouseover', btnEvntsHndlr);
		var buttonSliderFilter = new Z.Utils.Button('buttonSliderFilter' + idUpperFirst, null, Z.skinPath, skinArr[17], skinArr[18], skinArr[19], '1px', '1px', '1px', '1px',  'mouseover', btnEvntsHndlr, 'TIP_SLIDER' + idUpperAll);
		container.appendChild(buttonSliderFilter.elmt);
		if (range) {
			var buttonSliderFilter = new Z.Utils.Button('buttonSliderFilter' + idUpperFirst + '2', null, Z.skinPath, skinArr[17], skinArr[18], skinArr[19], '1px', '1px', '1px', '1px',  'mouseover', btnEvntsHndlr, 'TIP_SLIDER' + idUpperAll + '2');
			container.appendChild(buttonSliderFilter.elmt);
		}
		var sliderTextElement = Z.Utils.createTextElement(id + 'TextElement', '0', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
		Z.Utils.addEventListener(sliderTextElement.firstChild, 'focus', txtEvntsHndlr);
		Z.Utils.addEventListener(sliderTextElement.firstChild, 'input', txtEvntsHndlr);
		Z.Utils.addEventListener(sliderTextElement.firstChild, 'change', txtEvntsHndlr);
		Z.Utils.addEventListener(sliderTextElement.firstChild, 'blur', txtEvntsHndlr);
		container.appendChild(sliderTextElement);
		if (range) {
			var sliderTextElement = Z.Utils.createTextElement(id + 'TextElement' + '2', '0', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.Utils.addEventListener(sliderTextElement.firstChild, 'focus', txtEvntsHndlr);
			Z.Utils.addEventListener(sliderTextElement.firstChild, 'input', txtEvntsHndlr);
			Z.Utils.addEventListener(sliderTextElement.firstChild, 'change', txtEvntsHndlr);
			Z.Utils.addEventListener(sliderTextElement.firstChild, 'blur', txtEvntsHndlr);
			container.appendChild(sliderTextElement);
		}
	},

	Point : function (x, y) {
		this.x = typeof x === 'number' ? x : 0;
		this.y = typeof y === 'number' ? y : 0;
	},

	Point3D : function (x, y, z) {
		this.x = typeof x === 'number' ? x : 0;
		this.y = typeof y === 'number' ? y : 0;
		this.z = typeof z === 'number' ? z : 0;
	},

	Coordinates : function (x, y, z, r) {
		this.x = typeof x === 'number' ? x : 0;
		this.y = typeof y === 'number' ? y : 0;
		this.z = typeof z === 'number' ? z : 0;
		this.r = typeof r === 'number' ? r : 0;
	},

	CoordinatesDisplayStyle : function (cLeft, cTop, vWidth, vHeight, vLeft, vTop, bWidth, bHeight, bLeft, bTop, cRotation) {
		this.cLeft = cLeft;
		this.cTop = cTop;
		this.vWidth = vWidth;
		this.vHeight = vHeight;
		this.vLeft = vLeft;
		this.vTop = vTop;
		this.bWidth = bWidth;
		this.bHeight = bHeight;
		this.bLeft = bLeft;
		this.bTop = bTop;
		this.cRotation = cRotation;
	},

	Pair : function (a, b) {
		this.a = a;
		this.b = b;
	},

	Trio : function (a, b, c) {
		this.a = a;
		this.b = b;
		this.c = c;
	},

	Range : function (start, end) {
		this.start = typeof start === 'number' ? start : 0;
		this.end = typeof end === 'number' ? end : 0;
	},

	RangeScale : function (min, max) {
		this.min = typeof min === 'number' ? min : 0;
		this.max = typeof max === 'number' ? max : 0;
	},

	// Function requires improvement to deal with 'auto' values. Current workaround OK for swapping Comparison viewports.
	swapZIndices : function (element1, element2) {
		var zIndex1 = Z.Utils.getElementStylePropertyZIndex(element1);
		var zIndex2 = Z.Utils.getElementStylePropertyZIndex(element2);
		if (zIndex1 == 'auto' || zIndex2 == 'auto') {
			zIndex1 = (Z.baseZIndex - 101).toString();
			zIndex2 = (Z.baseZIndex - 100).toString();
		}
		element1.style.zIndex = zIndex2;
		element2.style.zIndex = zIndex1;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::: COLOR, STRING, TEXT STYLE UTILITY FUNCTIONS :::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	stringValidate : function (str) {
		return (typeof str !== 'undefined' && str !== null && str !== '' && str !== 'null'); // Final check for 'null' string value added for XML uses.
	},

	// Replace spaces to make escaped XML easier to read. Not currently required due to minimal escaping by function xmlEscapeMinimal.
	stringReadable : function (stringToModify) {
		var stringToReplace;
		var regularExpression;
		var stringToInsert;
		var modifiedString;

		// DEV NOTE: Replace single quotes (apostrophes).
		stringToReplace = "%20";
		regularExpression = new RegExp(stringToReplace, "g");
		stringToInsert = " ";
		modifiedString = stringToModify.replace(regularExpression, stringToInsert);

		// DEV NOTE: To replace other characters, replicate four preceeding code lines here:

		return modifiedString;
	},

	stringGetInitials : function (str) {
		var initialsStrUp = '';
		if (str) {
			var initials = str.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);
			var initialsStr = initials.join('');
			initialsStrUp = initialsStr.toUpperCase();
		}
		return initialsStrUp;
	},

	stringLowerCaseFirstLetter : function (str) {
		return str.charAt(0).toLowerCase() + str.slice(1);
	},

	stringUpperCaseFirstLetter : function (str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	},

	stringMultiply : function (str, num) {
		var i = Math.ceil(Math.log(num) / Math.LN2);
		var result = str;
		do {
			result += result;
		} while (0 < --i);
		return result.slice(0, str.length * num);
	},

	stringPadFront : function (strVal, strChars, charVal) {
		var padChars = (strChars - strVal.length);
		var padding = Z.Utils.stringMultiply(charVal, padChars);
		strVal = padding + strVal;
		return strVal;
	},

	stringRemoveTrailingSlashCharacters : function (stringToClean) {
		var stringCleaned = (stringToClean.slice(-1, stringToClean.length) == '/') ? stringToClean.slice(0, stringToClean.length - 1) : stringToClean;
		// Next line removed to allow for leading slash signifying root context.
		//stringCleaned = (stringToClean.slice(0, 1) == '/') ? stringToClean.slice(1, stringToClean.length) : stringToClean;
		return stringCleaned;
	},

	stringRemoveFileExtension : function (stringToClean) {
		var len = stringToClean.length;
		if (stringToClean.slice(len - 4, len - 3) == '.') { stringToClean = stringToClean.slice(0, len - 4); }
		return stringToClean;
	},

	stringRemoveTabAndLineWrapCharacters : function (stringToClean) {
		var stringCleaned = stringToClean.replace(/\n/g, '');
		stringCleaned = stringCleaned.replace(/\r/g, '');
		stringCleaned = stringCleaned.replace(/\t/g, '');
		return stringCleaned;
	},

	stringUnescapeAmpersandCharacters : function (stringToClean) {
		var stringCleaned = stringToClean.replace(/\n/g, '');
		stringCleaned = stringCleaned.replace(/&#38;/g, '&');
		stringCleaned = stringCleaned.replace(/&#038;/g, '&');
		stringCleaned = stringCleaned.replace(/&amp;/g, '&');
		return stringCleaned;
	},

	setHTMLTextDefaultCaptionStyle : function (htmlTextNode, HTML, color, fontFamily, fontSize, fontSizeAdjust, fontStyle, fontStretch, fontVariant, fontWeight, lineHeight, textAlign, textDecoration) {
		var htmlTextStyle = htmlTextNode.style;
		if (HTML.indexOf('color=') == -1) { htmlTextStyle.color = color; }
		if (HTML.indexOf('font-family=') == -1) { htmlTextStyle.fontFamily = fontFamily; }
		if (HTML.indexOf('font-size=') == -1) { htmlTextStyle.fontSize = fontSize; }
		if (HTML.indexOf('font-size-adjust=') == -1) { htmlTextStyle.fontSizeAdjust = fontSizeAdjust; }
		if (HTML.indexOf('font-style=') == -1) { htmlTextStyle.fontStyle = fontStyle; }
		if (HTML.indexOf('font-stretch=') == -1) { htmlTextStyle.fontStretch = fontStretch; }
		if (HTML.indexOf('font-variant=') == -1) { htmlTextStyle.fontVariant = fontVariant; }
		if (HTML.indexOf('font-weight=') == -1) { htmlTextStyle.fontWeight = fontWeight; }
		if (HTML.indexOf('line-height=') == -1) { htmlTextStyle.lineHeight = lineHeight; }
		if (HTML.indexOf('text-align=') == -1) { htmlTextStyle.textAlign = textAlign; }
		if (HTML.indexOf('text-decoration=') == -1) { htmlTextStyle.textDecoration = textDecoration; }
	},

	setHTMLTextStyle : function (htmlTextNode, color, fontFamily, fontSize, fontSizeAdjust, fontStyle, fontStretch, fontVariant, fontWeight, lineHeight, textAlign, textDecoration) {
		var htmlTextStyle = htmlTextNode.style;
		htmlTextStyle.color = color;
		htmlTextStyle.fontFamily = fontFamily;
		htmlTextStyle.fontSize = fontSize;
		htmlTextStyle.fontSizeAdjust = fontSizeAdjust;
		htmlTextStyle.fontStyle = fontStyle;
		htmlTextStyle.fontStretch = fontStretch;
		htmlTextStyle.fontVariant = fontVariant;
		htmlTextStyle.fontWeight = fontWeight;
		htmlTextStyle.lineHeight = lineHeight;
		htmlTextStyle.textAlign = textAlign;
		htmlTextStyle.textDecoration = textDecoration;
	},

	setTextAreaStyle : function (textBox, color, fontFamily, fontSize, fontSizeAdjust, fontStyle, fontStretch, fontVariant, fontWeight, lineHeight, textAlign, textDecoration, padding) {
		var tStyle = textBox.firstChild.style;
		tStyle.color = color;
		tStyle.fontFamily = fontFamily;
		tStyle.fontSize = fontSize;
		tStyle.fontSizeAdjust = fontSizeAdjust;
		tStyle.fontStyle = fontStyle;
		tStyle.fontStretch = fontStretch;
		tStyle.fontVariant = fontVariant;
		tStyle.fontWeight = fontWeight;
		tStyle.lineHeight = lineHeight;
		tStyle.textAlign = textAlign;
		tStyle.textDecoration = textDecoration;
		tStyle.padding = padding;
	},

	setTextNodeStyle : function (textNode, color, fontFamily, fontSize, fontSizeAdjust, fontStyle, fontStretch, fontVariant, fontWeight, lineHeight, textAlign, textDecoration) {
		var tStyle = textNode.parentNode.style;
		tStyle.color = color;
		tStyle.fontFamily = fontFamily;
		tStyle.fontSize = fontSize;
		tStyle.fontSizeAdjust = fontSizeAdjust;
		tStyle.fontStyle = fontStyle;
		tStyle.fontStretch = fontStretch;
		tStyle.fontVariant = fontVariant;
		tStyle.fontWeight = fontWeight;
		tStyle.lineHeight = lineHeight;
		tStyle.textAlign = textAlign;
		tStyle.textDecoration = textDecoration;
	},

	stringValidateColorValue : function (value) {
		if (!Z.Utils.stringValidate(value)) { value = '#000000'; }
		if (value.indexOf('#') != 0) { value = '#' + value; }
		return value;
	},

	hexToRGB : function (hexStr) {
		// Expand shorthand to full form.
		var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hexStr = hexStr.replace(shorthandRegex, function(m, r, g, b) {
			return r + r + g + g + b + b;
		});

		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexStr);
		return result ? {
			r: parseInt(result[1], 16),
			g: parseInt(result[2], 16),
			b: parseInt(result[3], 16)
		} : null;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::: XML & JSON UTILITY FUNCTIONS ::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	xmlConvertTextToDoc : function (xmlText) {
		var xmlDoc = null;
		if (window.ActiveXObject) {
			try {
				xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
				xmlDoc.async = false;
				xmlDoc.loadXML(xmlText);
			} catch (e) {
				this.showMessage(e.name + this.getResource('ERROR_CONVERTINGXMLTEXTTODOC') + e.message);
			}
		} else if (window.DOMParser) {
			try {
				var parser = new DOMParser();
				xmlDoc = parser.parseFromString(xmlText, 'text/xml');
			} catch (e) {
				this.showMessage(e.name + this.getResource('ERROR_CONVERTINGXMLTEXTTODOC') + e.message);
			}
		} else {
			this.showMessage(this.getResource('ERROR_XMLDOMUNSUPPORTED'));
		}
		return xmlDoc;
	},

	xmlConvertDocToText : function (xmlDoc) {
		var xmlText = null;
		if (window.ActiveXObject) {
			try {
				xmlText = xmlDoc.xml;
			} catch (e) {
				this.showMessage(e.name + this.getResource('ERROR_CONVERTINGXMLDOCTOTEXT') + e.message);
			}
		} else if (window.DOMParser) {
			try {
				xmlText = (new XMLSerializer()).serializeToString(xmlDoc);
			} catch (e) {
				this.showMessage(e.name + this.getResource('ERROR_CONVERTINGXMLDOCTOTEXT') + e.message);
			}
		} else {
			this.showMessage(this.getResource('ERROR_XMLDOMUNSUPPORTED'));
		}
		return xmlText;
	},

	xmlEscapeMinimal : function (content) {
		var repCont = null;
		if (typeof content !== 'undefined' && content !== null) {
			repCont = content.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&apos;')
				.replace(/\r?\n/g, '%0A');
		}
		return repCont;
	},

	xmlUnescapeMinimal : function (content) {
		var repCont = null;
		if (typeof content !== 'undefined' && content !== null) {
			repCont = content.replace(/%0A/g, '\n')
				.replace(/&apos;/g, "'")
				.replace(/&quot;/g, '"')
				.replace(/&gt;/g, '>')
				.replace(/&lt;/g, '<')
				.replace(/&amp;/g, "&");
		}
		return repCont;
	},

	// This is a not a generic JSON to XML conversion function.  It is tailored to the objects in this application (CDATA not currently supported).
	jsonConvertObjectToXMLText : function (jsonObject) {
		var convertToXML = function (pValue, pName) {
			var xmlNew = '';
			if (pValue instanceof Array) {
				for (var i = 0, j = pValue.length; i < j; i++) {
					xmlNew += convertToXML(pValue[i], pName) + '\n';
				}
			} else if (typeof pValue === 'object') {
				var hasChild = false;
				xmlNew += '<' + pName;
				for (var propName in pValue) {
					if (typeof pValue[propName] !== 'object') {
						xmlNew += ' ' + propName + '=\"' + pValue[propName].toString() + '\"';
					} else {
						hasChild = true;
					}
				}

				// DEV NOTE: Workaround for 'object' test causing redundant close.
				xmlNew += '>'; //xmlNew += hasChild ? '>' : '/>';
				if (hasChild) {
					for (var propName in pValue) {
						if (propName == '#text') {
							xmlNew += pValue[propName];
						} else if (typeof pValue[propName] === 'object') {
							xmlNew += convertToXML(pValue[propName], propName);
						}
					}
				}
				xmlNew += '</' + pName + '>';
			} else {
				xmlNew += '<' + pName + '>' + pValue.toString() +  '</' + pName + '>';
			}
			return xmlNew;
		}, xmlNew='';

		for (var propName in jsonObject) {
			xmlNew += convertToXML(jsonObject[propName], propName);
		}

		// Excape or remove characters in fields that will interfere with parameter parsing.
		var xmlOut = xmlNew.replace(/&/g, '&amp;')
				.replace(/\t|\n/g, '');

		// Debug option: Compare values loaded and converted.
		//console.log('JSON object in: ' + JSON.stringify(jsonObject, null, ' '));
		//console.log('XML out: ' + xmlOut);

		return xmlOut;
	},

	// This is a not a generic XML to JSON conversion function.  It is tailored to the objects in this application (CDATA not currently supported).
	jsonConvertXMLTextToJSONText : function (xmlIn) {

		var Converter = {

			convertToObject : function (xml) {
				var cvrtObj = {};
				if (xml.nodeType == 1) {
					if (xml.attributes.length) {
						for (var i = 0, j = xml.attributes.length; i < j; i++) {
							cvrtObj[xml.attributes[i].nodeName] = (xml.attributes[i].nodeValue||'').toString();
						}
					}
					if (xml.firstChild) {
						var textChild = 0, hasElementChild = false;
						for (var n = xml.firstChild; n; n = n.nextSibling) {
							if (n.nodeType == 1) {
								hasElementChild = true;
							} else if (n.nodeType == 3 && n.nodeValue.match(/[^ \f\n\r\t\v]/)) {
								textChild++;
							}
						}
						if (hasElementChild) {
							if (textChild < 2) {
								Converter.reduceWhitespace(xml);
								for (var n = xml.firstChild; n; n = n.nextSibling) {
									if (n.nodeType == 3) {
										cvrtObj['#text'] = Converter.escapeMinimal(n.nodeValue);
									} else if (cvrtObj[n.nodeName]) {
										if (cvrtObj[n.nodeName] instanceof Array) {
											cvrtObj[n.nodeName][cvrtObj[n.nodeName].length] = Converter.convertToObject(n);
										} else {
											cvrtObj[n.nodeName] = [cvrtObj[n.nodeName], Converter.convertToObject(n)];
										}
									} else {
										cvrtObj[n.nodeName] = Converter.convertToObject(n);
									}
								}
							} else {
								if (!xml.attributes.length) {
									cvrtObj = Converter.escapeMinimal(Converter.innerXML(xml));
								} else {
									cvrtObj['#text'] = Converter.escapeMinimal(Converter.innerXML(xml));
								}
							}
						} else if (textChild) {
							if (!xml.attributes.length) {
								cvrtObj = Converter.escapeMinimal(Converter.innerXML(xml));
							} else {
								cvrtObj['#text'] = Converter.escapeMinimal(Converter.innerXML(xml));
							}
						}
					}
					if (!xml.attributes.length && !xml.firstChild) {
						cvrtObj = null;
					}
				} else if (xml.nodeType == 9) {
					cvrtObj = Converter.convertToObject(xml.documentElement);
				} else {
					alert('This node type not supported : ' + xml.nodeType);
				}
				return cvrtObj;
			},

			convertToJSONText : function (cvrtObj, name) {
				var jsonTxt = name ? ('\"' + name + '\"') : '';
				if (cvrtObj instanceof Array) {
					for (var i = 0, n = cvrtObj.length; i < n; i++) {
						cvrtObj[i] = Converter.convertToJSONText(cvrtObj[i], '', '\t');
					}
					jsonTxt += (name ? ':[' : '[') + (cvrtObj.length > 1 ? ('\n' + '\t' + cvrtObj.join(',\n' + '\t') + '\n') : cvrtObj.join('')) + ']';
				} else if (cvrtObj == null) {
					jsonTxt += (name && ':') + 'null';
				} else if (typeof(cvrtObj) === 'object') {
					var arrJTxt = [];
					for (var m in cvrtObj) {
						arrJTxt[arrJTxt.length] = Converter.convertToJSONText(cvrtObj[m], m, '\t');
					}
					jsonTxt += (name ? ':{' : '{') + (arrJTxt.length > 1 ? ('\n' + '\t' + arrJTxt.join(',\n' + '\t') + '\n') : arrJTxt.join('')) + '}';
				} else if (typeof(cvrtObj) == 'string') {
					jsonTxt += (name && ':') + '\"' + cvrtObj.toString() + '\"';
				} else {
					jsonTxt += (name && ':') + cvrtObj.toString();
				}
				return jsonTxt;
			},
		
			reduceWhitespace : function (xmlToReduce) {
				xmlToReduce.normalize();
				for (var n = xmlToReduce.firstChild; n; ) {
					if (n.nodeType == 3) {
						if (!n.nodeValue.match(/[^ \f\n\r\t\v]/)) {
							var nxt = n.nextSibling;
							xmlToReduce.removeChild(n);
							n = nxt;
						} else {
							n = n.nextSibling;
						}
					} else if (n.nodeType == 1) {
						Converter.reduceWhitespace(n);
						n = n.nextSibling;
					} else {
						n = n.nextSibling;
					}
				}
				return xmlToReduce;
			},

			escapeMinimal : function (content) {
				return content.replace(/[\\]/g, '\\\\')
					.replace(/[\"]/g, '\\"')
					.replace(/[\n]/g, '\\n')
					.replace(/[\r]/g, '\\r');
			},

			innerXML : function (node) {
				var toXML = '';
				if ('innerHTML' in node) {
					toXML = node.innerHTML;
				} else {
					var asXML = function (n) {
						var toXML = '';
						if (n.nodeType == 1) {
							toXML += '<' + n.nodeName;
							for (var i = 0, j = n.attributes.length; i < j; i++) {
								toXML += ' ' + n.attributes[i].nodeName + '=\'' + (n.attributes[i].nodeValue||'').toString() + '\'';
							}
							if (n.firstChild) {
								toXML += '>';
								for (var childNode = n.firstChild; childNode; childNode = childNode.nextSibling) {
									toXML += asXML(childNode);
								}
								toXML += '</' + n.nodeName + '>';
							} else {
								toXML += '/>';
							}
						} else if (n.nodeType == 3) {
							toXML += n.nodeValue;
						}
						return toXML;
					};
					for (var childNode = node.firstChild; childNode; childNode = childNode.nextSibling) {
						toXML += asXML(childNode);
					}
				}
				return toXML;
			}
		};
		
		if (xmlIn.nodeType == 9) {
			xml = xml.documentElement;
		}

		var jsonText = Converter.convertToJSONText(Converter.convertToObject(Converter.reduceWhitespace(xmlIn)), xmlIn.nodeName, '\t');
		jsonTextOut = '{\n' + '  ' + ('  ' ? jsonText.replace(/\t/g, '  ') : jsonText.replace(/\t|\n/g, '')) + '\n}';

		// Debug option: Compare values loaded and converted.
		//console.log('XML text in: \n' + Z.Utils.xmlConvertDocToText(xmlIn));
		//console.log('JSON text out: \n' + jsonTextOut);

		return jsonTextOut;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::: ARRAY UTILITY FUNCTIONS ::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Deletes all elements. Note that arr = []; creates new empty array and leaves any referenced original
	// array unchanged. Also note that this approach performs up to 10x faster than arr.length = 0;
	arrayClear : function (arr) {
		if (arr) {
			while(arr.length > 0) {
			    arr.pop();
			}
		}
	},

	arrayClearObjectValue : function (arr, subobj) {
		for (var i = 0, j = arr.length; i < j; i++) {
			arr[i][subobj] = null;
		}
	},

	// This is a not a generic deep object copy function.  It is a three-level copy function for specific objects in this application.
	arrayClone : function (arrName, arrFrom, arrTo) {
		arrTo = [];
		switch (arrName) {
			case 'pois' :
				for (var i = 0, j = arrFrom.length; i < j; i++) {
					arrTo[arrTo.length] = { text:arrFrom[i].text, value:arrFrom[i].value, id:arrFrom[i].id, x:arrFrom[i].x, y:arrFrom[i].y, z:arrFrom[i].z, user:arrFrom[i].user, date:arrFrom[i].date, editable:arrFrom[i].editable };
				}
				break;
			case 'labels' :
				for (var i = 0, j = arrFrom.length; i < j; i++) {
					arrTo[arrTo.length] = { text:arrFrom[i].text, value:arrFrom[i].value, poiID:arrFrom[i].poiID, editable:arrFrom[i].editable };
				}
				break;
			case 'hotspots' :
				for (var i = 0, j = arrFrom.length; i < j; i++) {
					arrTo[arrTo.length] = {
						id: arrFrom[i].id,
						name: arrFrom[i].name,
						mediaType: arrFrom[i].mediaType,
						media: arrFrom[i].media,
						audio: arrFrom[i].audio,
						x: arrFrom[i].x,
						y: arrFrom[i].y,
						z: arrFrom[i].z,
						xScale: arrFrom[i].xScale,
						yScale: arrFrom[i].yScale,
						radius: arrFrom[i].radius,
						zMin: arrFrom[i].zMin,
						zMax: arrFrom[i].zMax,
						clickURL: arrFrom[i].clickURL,
						urlTarget: arrFrom[i].urlTarget,
						rollover: arrFrom[i].rollover,
						caption: arrFrom[i].caption,
						tooltip: arrFrom[i].tooltip,
						textColor: arrFrom[i].textColor,
						backColor: arrFrom[i].backColor,
						lineColor: arrFrom[i].lineColor,
						fillColor: arrFrom[i].fillColor,
						textVisible: arrFrom[i].textVisible,
						backVisible: arrFrom[i].backVisible,
						lineVisible: arrFrom[i].lineVisible,
						fillVisible: arrFrom[i].fillVisible,
						captionPosition: arrFrom[i].captionPosition,
						saved: arrFrom[i].saved,
						visibility: arrFrom[i].visibility,
						internalID: arrFrom[i].internalID,
						poiID: arrFrom[i].poiID,
						captionHTML: arrFrom[i].captionHTML,
						tooltipHTML: arrFrom[i].tooltipHTML,
						polyClosed: arrFrom[i].polyClosed,
						polygonPts: arrFrom[i].polygonPts,
						showFor: arrFrom[i].showFor,
						transition: arrFrom[i].transition,
						changeFor: arrFrom[i].changeFor,
						rotation: arrFrom[i].rotation,
						editable: arrFrom[i].editable,
						popup: arrFrom[i].popup,
						popupOffsetX: arrFrom[i].popupOffsetX,
						popupOffsetY: arrFrom[i].popupOffsetY,
						comment: arrFrom[i].comment,
						user: arrFrom[i].user,
						date: arrFrom[i].date,
						iW: arrFrom[i].iW,
						iH: arrFrom[i].iH,
						image: arrFrom[i].image
					 };
				}
				break;
			case 'polygon' :
				for (var i = 0, j = arrFrom.length; i < j; i++) {
					arrTo[arrTo.length] = { x:arrFrom[i].x, y:arrFrom[i].y };
				}
				break;
			case 'notes' :
				for (var i = 0, j = arrFrom.length; i < j; i++) {
					arrTo[arrTo.length] = { text:arrFrom[i].text, value:arrFrom[i].value, noteText:arrFrom[i].noteText, poiID:arrFrom[i].poiID, id:arrFrom[i].id, user:arrFrom[i].user, date:arrFrom[i].date, editable:arrFrom[i].editable };
				}
				break;
			case 'magnifications' :
				for (var i = 0, j = arrFrom.length; i < j; i++) {
					arrTo[arrTo.length] = { text:arrFrom[i].text, value:arrFrom[i].value };
				}
				break;
		}
		return arrTo;
	},

	// Assumes object including 'image' property.
	arrayImageLoadingValidate : function (arrOfImages) {
		var imagesReady = false;
		if (arrOfImages && arrOfImages.length > 0) {
			imagesReady = true;
			for (var i = 0, j = arrOfImages.length; i < j; i++) {
				if (arrOfImages[i] === null || arrOfImages[i].image.width == 0 || arrOfImages[i].image.height == 0) {
					imagesReady = false;
				}
			}
		}
		return imagesReady;
	},

	arrayIndexOf : function (arr, obj, fromIndex) {
		if (!fromIndex) {
			fromIndex = 0;
		} else if (fromIndex < 0) {
			fromIndex = Math.max(0, arr.length + fromIndex);
		}
		for (var i = fromIndex, j = arr.length; i < j; i++) {
			if (arr[i] === obj) { return i; }
		}
		return -1;
	},

	arrayIndexOfObjectValue : function (arr, subobj, obj, fromIndex) {
		if (typeof arr !== 'undefined') {
			if (!fromIndex) {
				fromIndex = 0;
			} else if (fromIndex < 0) {
				fromIndex = Math.max(0, arr.length + fromIndex);
			}
			for (var i = fromIndex, j = arr.length; i < j; i++) {
				if (arr[i][subobj] === obj) { return i; }
			}
		}
		return -1;
	},

	arrayIndexOfObjectTwoValues : function (arr, subobj, obj, fromIndex, subobj2, obj2) {
		if (typeof arr !== 'undefined') {
			if (!fromIndex) {
				fromIndex = 0;
			} else if (fromIndex < 0) {
				fromIndex = Math.max(0, arr.length + fromIndex);
			}
			for (var i = fromIndex, j = arr.length; i < j; i++) {
				if (arr[i][subobj] === obj) { // Find first match.
					if (arr[i][subobj2].toString() === obj2.toString()) { // Find second match. // DEV NOTE .toString MAY CONFICT WITH SOME USES.
						return i;
					}
				}
			}
		}
		return -1;
	},

	arrayIndexOfSubstring : function (arr, obj, fromIndex) {
		if (!fromIndex) {
			fromIndex = 0;
		} else if (fromIndex < 0) {
			fromIndex = Math.max(0, arr.length + fromIndex);
		}
		for (var i = fromIndex, j = arr.length; i < j; i++) {
			if (arr[i].indexOf(obj) != -1) { return i; }
		}
		return -1;
	},

	arrayIndexOfObjectValueSubstring : function (arr, subobj, obj, fromIndex, caseInsensitive) {
		if (!fromIndex) {
			fromIndex = 0;
		} else if (fromIndex < 0) {
			fromIndex = Math.max(0, arr.length + fromIndex);
		}
		for (var i = fromIndex, j = arr.length; i < j; i++) {
			if (caseInsensitive) {
				if (arr[i][subobj].toLowerCase().indexOf(obj) != -1) { return i; }
			} else {
				if (arr[i][subobj].indexOf(obj) != -1) { return i; }
			}
		}
		return -1;
	},

	// This function requires sorted arrays, each without duplicate values.
	arrayIntersect : function (a1, a2) {
		var elmt1, elmt2, found;
		var a3 = [];
		for (var i = 0, j = a1.length; i < j; i++) {
			elmt1 = a1[i];
			found = false;
			for (var k=0, m = a2.length; (k < m) && (elmt1 >= (elmt2 = a2[k])); k++) {
				if (elmt2 == elmt1) {
					found = true;
					break;
				}
			}
			if (found) { a3[a3.length] = a1[i]; }
		}
		return a3;
	},

	arrayMap : function (arr, fxn) {
		var arrOut = [];
		if (Z.arrayMapSupported) {
			arrOut = arr.map(fxn);
		} else {
			for(var i = 0, j = arr.length; i < j; i++) {
				arrOut[i] = fxn(arr[i]);
	   		}
		}
		return arrOut;
	},

	arraySplice : function (arr, iStart, iLength) {
		if (Z.arraySpliceSupported) {
			if (arguments.length > 3) {
				for (var i = 3, j = arguments.length; i < j; i++) {
					arr.splice(iStart, iLength, arguments[i]);
				}
			} else {
				arr.splice(iStart, iLength);
			}
		} else {
			if (iLength < 0) { iLength = 0; }
			var aInsert = [];
			if (arguments.length > 3) {
				for (var i = 3, j = arguments.length; i < j; i++) { aInsert[aInsert.length] = arguments[i]; }
			}
			var aHead = Z.Utils.arraySubarray(arr, 0, iStart);
			var aDelete = Z.Utils.arraySubarrayLen(arr, iStart, iLength);
			var aTail = Z.Utils.arraySubarray(arr, iStart + iLength);
			var aNew = aHead.concat(aInsert, aTail);
			arr.length = 0;
			for (var i = 0, j = aNew.length; i < j; i++) { arr[arr.length] = aNew[i]; }
			arr = aDelete;
		}
		return arr;
	},

	arraySubarraySimple : function (start, end) {
		return this.slice(start, end);
	},

	arraySortNumericAscending : function (arr, a, b) {
		arr.sort( function (a,b) { return a-b; } );
		return arr; // Fail-safe for empty arr.
	},

	arraySortNumericDescending : function (arr, a, b) {
		arr.sort( function (a,b) { return b-a; } );
		return arr; // Fail-safe for empty arr.
	},

	arraySortByObjectValue : function (arr, subobj, a, b) {
		arr.sort( function (a,b) { return a[subobj] > b[subobj]; } );
		return arr; // Fail-safe for empty arr.
	},

	arraySubarray : function (arr, iIndexA, iIndexB ) {
		if (iIndexA < 0) { iIndexA = 0; }
		if (!iIndexB || iIndexB > arr.length) { iIndexB = arr.length; }
		if (iIndexA == iIndexB) { return []; }
		var aReturn = [];
		for (var i = iIndexA; i < iIndexB; i++) {
			aReturn[aReturn.length] = arr[i];
		}
		return aReturn;
	},

	arraySubarrayLen : function (arr, iStart, iLength) {
		if (iStart >= arr.length || (iLength && iLength <= 0)) {
			return [];
		} else if (iStart < 0) {
			if (Math.abs(iStart) > arr.length) iStart = 0;
			else iStart = arr.length + iStart;
		}
		if (!iLength || iLength + iStart > arr.length) { iLength = arr.length - iStart; }
		var aReturn = [];
		for (var i = iStart; i < iStart + iLength; i++) {
			aReturn[aReturn.length] = arr[i];
		}
		return aReturn;
	},

	// This function requires sorted arrays, each without duplicate values.
	arraySubtract : function (a1, a2) {
		var aReturn = a1.slice(0);
		for (var i = 0, j = aReturn.length; i < j; i++) {
			var elmt1 = aReturn[i];
			var found = false;
			for (var k = 0, m = a2.length; (k < m) && (elmt1 >= (elmt2 = a2[k])); k++) {
				if (elmt2 == elmt1) {
					found = true;
					break;
				}
			}
			if (found) { aReturn = Z.Utils.arraySplice(aReturn, i--, 1); }
		}
		return aReturn;
	},

	arrayToArrayOfStrings : function (inputArr) {
		var outputArr = [];
		for (var i = 0, j = inputArr.length; i < j; i++) {
			outputArr[i] = !(typeof inputArr[i] === 'undefined' || inputArr[i] == 'undefined' || inputArr[i] === null) ? inputArr[i].toString() : '';
		}
		return outputArr;
	},

	// This function requires a sorted array.
	arrayUnique : function (arr) {
		for (var i = 1;i < arr.length;) {
			if (arr[i-1] == arr[i]) {
				arr = Z.Utils.arraySplice(arr, i, 1);
			} else{
				i++;
			}
		}
		return arr;
	},

	// This function requires a sorted array.
	arrayUniqueByObjectValue : function (arr, subobj) {
		if (typeof arr !== 'undefined') {
			for (var i = 1;i < arr.length;) {
				if (arr[i-1][subobj] == arr[i][subobj]) {
					arr = Z.Utils.arraySplice(arr, i, 1);
				} else{
					i++;
				}
			}
		}
		return arr;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::::::: AUDIO UTILITY FUNCTIONS ::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// Play audio: first parameter is preloaded audio object in viewer global, second parameter is fallback source path to load now.
	playAudio : function (destinationNextAudio, destinationCurrentAudioSrc) {
		if (!Z.audioMuted) {
			if (typeof destinationNextAudio !== 'undefined' && destinationNextAudio !== null) {
				destinationNextAudio.play();
			} else {
				if (Z.Utils.stringValidate(destinationCurrentAudioSrc)) {
					var destinationCurrentAudio = new Audio(destinationCurrentAudioSrc);
					destinationCurrentAudio.play();
				}
			}
		}
	},

	loadAudio : function (destinationNextAudioSrc) {
		if (Z.Utils.stringValidate(destinationNextAudioSrc)) {
			var destinationNextAudio = new Audio(destinationNextAudioSrc);
			destinationNextAudio.load();
		}
	},


	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::: RULER & MEASURING UTILITY FUNCTIONS ::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	convertZoomPercentToMagnification : function (zoom, srcMag, constrain) {
		var mag = zoom * srcMag / 100;
		if (constrain) { mag = (mag < 1.5) ? 1.25 : (mag < 2) ? 1.5 : (mag < 2.5) ? 2 : (mag < 4) ? 2.5 : (mag < 5) ? 4 : (mag < 10) ? 5 : (mag < 16) ? 10 : (mag < 20) ? 16 : (mag < 25) ? 20 : (mag < 32) ? 25 : (mag < 40) ? 32 : (mag < 50) ? 40 : (mag < 60) ? 50 : (mag < 100) ? 60 : (mag < 150) ? 100: (mag < 250) ? 150 : 250; }
		return mag;
	},

	calculatePointsDistance : function (x1, y1, x2, y2) {
		return Math.sqrt((x1 -= x2) * x1 + (y1 -= y2) * y1);

		// DEV NOTE: Alternative implementation:
		//return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	},

	convertPixelsToUnits : function (pixels, pixelsPerUnit, unitsPerImage) {
		var actualPixelsPerUnit = 1;
		if (typeof pixelsPerUnit !== 'undefined' && pixelsPerUnit !== null && pixelsPerUnit != 0) {
			actualPixelsPerUnit = pixelsPerUnit;
		} else if (typeof unitsPerImage !== 'undefined' && unitsPerImage !== null && unitsPerImage != 0) {
			actualPixelsPerUnit = Z.imageW / unitsPerImage;
		}
		var units = pixels / actualPixelsPerUnit;
		return units;
	},

	polygonArea : function (polyPts, polyClosed, clickPt, digits) {
		if (typeof digits === 'undefined' || digits === null) { digits = 4; }
		var tPolyPts = polyPts.slice(0);

		// Use first control point or mouse position as last control point.
		if (polyClosed) {
			tPolyPts[tPolyPts.length] = { x:tPolyPts[0].x, y:tPolyPts[0].y };
		} else if (typeof clickPt !== 'undefined' && clickPt !== null) {
			tPolyPts[tPolyPts.length] = { x:clickPt.x, y:clickPt.y };
		}

		var sum1 = 0;
		var sum2 = 0;
		for (var i = 0, j = tPolyPts.length - 1; i < j; i++) {
			sum1 += tPolyPts[i].x * tPolyPts[i + 1].y;
			sum2 += tPolyPts[i].y * tPolyPts[i + 1].x;
		}

		var area = (sum1 - sum2) / 2;
		area = Z.Utils.convertPixelsToUnits(area, Z.pixelsPerUnit, Z.unitsPerImage);
		area = Z.Utils.convertPixelsToUnits(area, Z.pixelsPerUnit, Z.unitsPerImage); // Scale in both dimensions.
		area = Z.Utils.roundToFixed(Math.abs(area), digits);

		return area;
	},

	polygonCenter : function (polyPts, polyClosed, clickPt) {
		var ctrX = 0, ctrY = 0;
		if (typeof polyPts !== 'undefined' && polyPts !== null && polyPts.length > 0) {
			var tPolyPts = polyPts.slice(0);

			// Use first control point or mouse position as last control point.
			if (polyClosed) {
				tPolyPts[tPolyPts.length] = { x:tPolyPts[0].x, y:tPolyPts[0].y };
			} else if (typeof clickPt !== 'undefined' && clickPt !== null) {
				tPolyPts[tPolyPts.length] = { x:clickPt.x, y:clickPt.y };
			}

			var tPolyPt = tPolyPts[0];
			var smallestX = tPolyPt.x;
			var smallestY = tPolyPt.y;
			var largestX = tPolyPt.x;
			var largestY = tPolyPt.y;
			for (var i = 1, j = tPolyPts.length; i < j; i++) {
				tPolyPt = tPolyPts[i];
				smallestX = Math.min(smallestX, tPolyPt.x);
				smallestY = Math.min(smallestY, tPolyPt.y);
				largestX = Math.max(largestX, tPolyPt.x);
				largestY = Math.max(largestY, tPolyPt.y);
			}
			ctrX = smallestX + ((largestX - smallestX) / 2);
			ctrY = smallestY + ((largestY - smallestY) / 2);
		}
		return new Z.Utils.Point(ctrX, ctrY);
	},

	polygonDimensions : function (polyPts, clickPt) {
		var w = 0, h = 0;
		if (typeof polyPts !== 'undefined' && polyPts !== null && polyPts.length > 0) {
			var tPolyPts = polyPts.slice(0);

			// Optional second parameter enables use of mouse position as last control point. Reduce span
			// so container is not under mouse, to avoid conflict between alt-click-drag and alt-click complete.
			if (typeof clickPt !== 'undefined' && clickPt !== null) {
				var adjX = (tPolyPts[tPolyPts.length - 1].x - clickPt.x) * 0.1;
				var adjY = (tPolyPts[tPolyPts.length - 1].y - clickPt.y) * 0.1;
				tPolyPts[tPolyPts.length] = { x:clickPt.x + adjX, y:clickPt.y + adjY };
			}

			var smallestX = tPolyPts[0].x;
			var smallestY = tPolyPts[0].y;
			var largestX = tPolyPts[0].x;
			var largestY = tPolyPts[0].y;
			for (var i = 1, j = tPolyPts.length; i < j; i++) {
				if (tPolyPts[i].x < smallestX) { smallestX = tPolyPts[i].x; }
				if (tPolyPts[i].x > largestX) { largestX = tPolyPts[i].x; }
				if (tPolyPts[i].y < smallestY) { smallestY = tPolyPts[i].y; }
				if (tPolyPts[i].y > largestY) { largestY = tPolyPts[i].y; }
			}
			w = largestX - smallestX;
			h = largestY - smallestY;
		}

		return new Z.Utils.Point(w, h);
	},

	polygonPerimeter : function (polyPts, polyClosed, clickPt, digits) {
		if (typeof digits === 'undefined' || digits === null) { digits = 5; }
		var tPolyPts = polyPts.slice(0);

		// Use first control point or mouse position as last control point.
		if (polyClosed) {
			tPolyPts[tPolyPts.length] = { x:tPolyPts[0].x, y:tPolyPts[0].y };
		} else if (typeof clickPt !== 'undefined' && clickPt !== null) {
			tPolyPts[tPolyPts.length] = { x:clickPt.x, y:clickPt.y };
		}

		var perimeter = 0;
		for (var i = 0, j = tPolyPts.length - 1; i < j; i++ ) {
			perimeter += Z.Utils.calculatePointsDistance(tPolyPts[i].x, tPolyPts[i].y, tPolyPts[i + 1].x, tPolyPts[i + 1].y);
		}
		perimeter = Z.Utils.convertPixelsToUnits(perimeter, Z.pixelsPerUnit, Z.unitsPerImage);
		perimeter = Z.Utils.roundToFixed(Math.abs(perimeter), digits);

		return perimeter;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::: SCREEN MODE, ROTATION, & TRANSLATION UTILITY FUNCTIONS ::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	fullScreenView : function (element, fullScreen, escaped) {
		// DEV NOTE: Watch for capitalization changes in specification and implementation: 'Fullscreen' vs 'FullScreen'.
		if (typeof escaped === 'undefined' || escaped === null) { var escaped = false; }

		if (fullScreen) {
			var docElm = document.documentElement;
			var eventString = null;
			if (docElm.requestFullScreen) {
				element.requestFullScreen();
				eventString = 'fullscreenchange'
			} else if (docElm.mozRequestFullScreen) {
				element.mozRequestFullScreen();
				eventString = 'mozfullscreenchange'
			} else if (docElm.webkitRequestFullScreen) {
				// DEV NOTE: Element.ALLOW_KEYBOARD_INPUT parameter blocks fullscreen mode in some versions of Chrome and Safari.
				// Testing for failed mode change allows second call without parameter in Safari but this workaround is not effective in Chrome.
				element.webkitRequestFullScreen();
				eventString = 'webkitfullscreenchange'
			} else if (docElm.msRequestFullscreen) {
				element.msRequestFullscreen();
				eventString = 'MSFullscreenChange'
			}
			if (eventString) { Z.Utils.addEventListener(document, eventString, Z.Viewport.fullScreenEscapeHandler); }

		} else {
			if (document.cancelFullScreen) {
				if (!escaped) { document.cancelFullScreen(); }
				eventString = 'fullscreenchange'
			} else if (document.mozCancelFullScreen) {
				if (!escaped) { document.mozCancelFullScreen(); }
				eventString = 'mozfullscreenchange'
			} else if (document.webkitCancelFullScreen) {
				if (!escaped) { document.webkitCancelFullScreen(); }
				eventString = 'webkitfullscreenchange'
			} else if (document.msExitFullscreen) {
				if (!escaped) { document.msExitFullscreen(); }
				eventString = 'MSFullscreenChange'
			}
			if (eventString) { Z.Utils.removeEventListener(document, eventString, Z.Viewport.fullScreenEscapeHandler); }
		}
	},

	rotatePoint : function (x, y, rotDegs) {
		var degToRad = Math.PI / 180;
		var rotRads = -rotDegs * degToRad;
		var newX = x * Math.cos(rotRads) - y * Math.sin(rotRads);
		var newY = x * Math.sin(rotRads) + y * Math.cos(rotRads);
		return new Z.Utils.Point(newX, newY);
	},

	rotateElement : function (displayS, r, override) {
		// DEV NOTE: Condition below is workaround for Safari mispositioning of hotspot captions after application of this method. This workaround only addresses unrotated displays.
		// Override ensures first condition does not block rotation of Navigator image as its r will equal Z.imageR because it is always catching up to main display.
		if (r != Z.imageR || override) {
			var tranString = 'rotate(' + r.toString() + 'deg)';
			displayS.transform = tranString; // Standard.
			displayS.msTransform = tranString; // IE9.
			displayS.mozTransform = tranString; // Firefox.
			displayS.webkitTransform = tranString; // Chrome & Safari.
			displayS.oTransform = tranString; // Opera.
		}
	},

	getPositionRotated : function (pLeft, pTop, oLeft, oTop, r) {
		if (typeof r === 'undefined' || r === null) { r = Z.imageR; }
		if (r < 0) { r += 360; } // Ensure positive values.
		var rad = r * Math.PI / 180;
		var x = pLeft - oLeft;
		var y = pTop - oTop;
		var xRot = x * Math.cos(rad) - y * Math.sin(rad);
		var yRot = x * Math.sin(rad) + y * Math.cos(rad);
		var pLeftRot = Math.round(xRot + oLeft);
		var pTopRot = Math.round(yRot + oTop);
		return new Z.Utils.Point(pLeftRot, pTopRot);
	},

	getDisplayPositionRotated : function (displayS, r) {
		if (typeof r === 'undefined' || r === null) { r = Z.imageR; }
		if (r < 0) { r += 360; } // Ensure positive values.
		var pLeft = parseFloat(displayS.left);
		var pTop = parseFloat(displayS.top);
		var w = parseFloat(displayS.width);
		var h = parseFloat(displayS.height);
		var oLeft = pLeft + w / 2;
		var oTop = pTop + h / 2;
		var rotPoint = Z.Utils.getPositionRotated(pLeft, pTop, oLeft, oTop, r);
		return rotPoint;
	},

	translateElement : function (displayS, x, y) {
		var tranString = 'translate(' + x.toString() + 'px,' + y.toString() +'px)';
		displayS.transform = tranString; // Standard.
		displayS.msTransform = tranString; // IE9.
		displayS.mozTransform = tranString; // Firefox.
		displayS.webkitTransform = tranString; // Chrome & Safari.
		displayS.oTransform = tranString; // Opera.
	},

	scaleElement : function (displayS, scaleVal) {
		var scaleString = 'scale(' + scaleVal.toString() + ')';
		displayS.transform = scaleString; // Standard.
		displayS.msTransform = scaleString; // IE9.
		displayS.mozTransform = scaleString; // Firefox.
		displayS.webkitTransform = scaleString; // Chrome & Safari.
		displayS.oTransform = scaleString; // Opera.
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::: IMAGE FILTER UTILITY FUNCTIONS ::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	filterImage : function (imageDataObject, filter, filterValue, filterValue2) {
		// Value for filterValue optional, defaults provided below for filters where required.
		var w = imageDataObject.width;
		var h = imageDataObject.height;
		var data = imageDataObject.data;

		// Handle six range filters in three switch statement cases with two filter value variables.
		if (filter.substring(filter.length - 1) == '2') { filter = filter.substring(0, filter.length - 1); }

		// DEV NOTE: This function will be streamlined once individual filters are validated by customers.
		switch (filter) {
			case 'brightness' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 40; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i] += filterValue;
					data[i + 1] += filterValue;
					data[i + 2] += filterValue;
				}
				break;

			case 'contrast' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 10; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					var avg = Math.round(( data[i] + data[i + 1] + data[i + 2] ) / 3 );
					if (avg > 127) {
						data[i] += ( data[i] / avg ) * filterValue;
						data[i + 1] += ( data[i + 1] / avg ) * filterValue;
						data[i + 2] += ( data[i + 2] / avg ) * filterValue;
					} else {
						data[i] -= ( data[i] / avg ) * filterValue;
						data[i + 1] -= ( data[i + 1] / avg ) * filterValue;
						data[i + 2] -= ( data[i + 2] / avg ) * filterValue;
					}
				}
				break;

			case 'colorRed' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i] += filterValue;
				}
				break;

			case 'colorGreen' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i + 1] += filterValue;
				}
				break;

			case 'colorBlue' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i + 2] += filterValue;
				}
				break;

			case 'colorRedRange' :
				if (typeof filterValue !== 'undefined' && filterValue !== null && typeof filterValue2 !== 'undefined' && filterValue2 !== null) {
					var a = filterValue, b = filterValue2;
					for (var i = 0, j = data.length; i < j; i += 4) {
						var n = data[i];
						n = (n < a) ? a : (n > b) ? b : n;
						data[i] = n;
					}
				}
				break;

			case 'colorGreenRange' :
				if (typeof filterValue !== 'undefined' && filterValue !== null && typeof filterValue2 !== 'undefined' && filterValue2 !== null) {
					var a = filterValue, b = filterValue2;
					for (var i = 0, j = data.length; i < j; i += 4) {
						var n = data[i + 1];
						n = (n < a) ? a : (n > b) ? b : n;
						data[i + 1] = n;
					}
				}
				break;

			case 'colorBlueRange' :
				if (typeof filterValue !== 'undefined' && filterValue !== null && typeof filterValue2 !== 'undefined' && filterValue2 !== null) {
					var a = filterValue, b = filterValue2;
					for (var i = 0, j = data.length; i < j; i += 4) {
						var n = data[i + 2];
						n = (n < a) ? a : (n > b) ? b : n;
						data[i + 2] = n;
					}
				}
				break;

			case 'gamma' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i] = Math.pow(255 * (data[i] / 255), 1 / filterValue);
					data[i + 1] = Math.pow(255 * (data[i + 1] / 255), 1 / filterValue);
					data[i + 2] = Math.pow(255 * (data[i + 2] / 255), 1 / filterValue);
				}
				break;

			case 'gammaRed' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i] = Math.pow(255 * (data[i] / 255), 1 / filterValue);
				}
				break;

			case 'gammaGreen' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i + 1] = Math.pow(255 * (data[i + 1] / 255), 1 / filterValue);
				}
				break;

			case 'gammaBlue' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i + 2] = Math.pow(255 * (data[i + 2] / 255), 1 / filterValue);
				}
				break;

			case 'hue' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					var r = data[i];
					var g = data[i + 1];
					var b = data[i + 2];
					var hsl = Z.Utils.colorToHSL(r, g, b);
					hsl.h = hsl.h + filterValue / 360;
					var rgb = Z.Utils.colorToRGB(hsl.h, hsl.s, hsl.l);
					data[i] = rgb.r;
					data[i + 1] = rgb.g;
					data[i + 2] = rgb.b;
				}
				break;

			case 'saturation' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				if (filterValue > 0) { filterValue /= 10; }
				var filVal = (filterValue == -100) ? 0 : (filterValue < 0) ? (filterValue + 100) / 100 : (filterValue == 0) ? 1 : filterValue + 1;
				for (var i = 0, j = data.length; i < j; i += 4) {
					var r = data[i];
					var g = data[i + 1];
					var b = data[i + 2];
					var hsl = Z.Utils.colorToHSL(r, g, b);
					hsl.s = Math.min(Math.max(hsl.s * filVal, 0), 1);
					var rgb = Z.Utils.colorToRGB(hsl.h, hsl.s, hsl.l);
					data[i] = rgb.r;
					data[i + 1] = rgb.g;
					data[i + 2] = rgb.b;
				}
				break;

			case 'lightness' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				var level = filterValue * -1;
				for (var i = 0, j = data.length; i < j; i += 4) {
					var r = data[i];
					var g = data[i + 1];
					var b = data[i + 2];
					var max = Math.max(r, g, b);
					var avg = (r + g + b) / 3;
					var amt = ((Math.abs(max - avg) * 2 / 255) * level) / 100;
					if (r !== max) { r += (max - r) * amt; }
					if (g !== max) { g += (max - g) * amt; }
					if (b !== max) { b += (max - b) * amt; }
					data[i] = r;
					data[i + 1] = g;
					data[i + 2] = b;
				}

			case 'whiteBalance' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				var color = this.colorTempToRGB(filterValue);
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i] = data[i] * (255 / color.r);
					data[i + 1] = data[i + 1] * (255 / color.g);
					data[i + 2] = data[i + 2] * (255 / color.b);
				}
				break;

			case 'noise' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					var noise = -filterValue / 2 + Math.random() * filterValue * 2;
					data[i] += noise;
					data[i + 1] += noise;
					data[i + 2] += noise;
				}
				break;

			case 'sharpness' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 1; }
				var sharpenMatrix = [0, -0.05, 0, -0.05, 1.2, -0.05, 0, -0.05, 0];
				for (var i = 0, j = filterValue / 2; i < j; i++) {
					for (var k = 1, m = sharpenMatrix.length; k < m; k += 2) {
						sharpenMatrix[k] *= 1.5;
					}
					sharpenMatrix[4] = Math.abs(sharpenMatrix[1] * 4) + 1;
				}
				imageDataObject = Z.Utils.convolveImage(imageDataObject, sharpenMatrix);
				break;

			case 'blurriness' : // Gaussian.
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 3; }
				var diameter = Math.abs(filterValue);
				if (diameter > 1) {
					var radius = diameter / 2;
					var length = Math.ceil(diameter) + (1 - (Math.ceil(diameter) % 2));
					var weights = new Z.Utils.createFloat32Array(length);
					var rMod = (radius + 0.5) / 3;
					var rModSq = rMod * rMod;
					var rFactor = -1 / (2 * rModSq);
					var gFactor = 1 / Math.sqrt(2 * Math.PI * rModSq);
					var midLen = Math.floor(length / 2);
					var wSum = 0;
					for (var i=0; i < length; i++) {
						var x = i - midLen;
						var gx = gFactor * Math.exp(x * x * rFactor);
						weights[i] = gx;
						wSum += gx;
					}
					for (var i = 0, j = weights.length; i < j; i++) { weights[i] /= wSum; }
					imageDataObject = Z.Utils.convolveImageSeparable(imageDataObject, weights, weights, false);
				}
				break;

			case 'grayscale' :
				// Luminosity, CIE standard observer weighting. Alternative formulas included below.
				for (var i = 0, j = data.length; i < j; i += 4) {
					var r = data[i];
					var g = data[i + 1];
					var b = data[i + 2];
                			var avgValue = Math.round(r * 0.299 + g * 0.587 + b * 0.114); // Weighted.
					//var avgValue = Math.round(r * 0.2126 + g * 0.7152 + b * 0.0722); // Weighted.
					//var avgValue = Math.round((r + g + b) / 3); // Unweighted.
                			data[i] = data[i + 1] = data[i + 2] = avgValue;
				}
				break;

			case 'threshold' :
				if (typeof filterValue === 'undefined' || filterValue === null) { var filterValue = 128; }
				for (var i = 0, j = data.length; i < j; i += 4) {
					var r = data[i];
					var g = data[i + 1];
					var b = data[i + 2];
					var avgWeightedThreshold = ((0.2126 * r + 0.7152 * g + 0.0722 * b) >= filterValue) ? 255 : 0;
					data[i] = data[i + 1] = data[i + 2] = avgWeightedThreshold;
				}
				break;

			case 'inversion' :
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i] = 255-data[i];
					data[i + 1] = 255-data[i + 1];
					data[i + 2] = 255-data[i + 2];
					data[i + 3] = 255;
				}
				break;

			case 'normalize' :
				// DEV NOTE: Histogram normalization (contrast stretching for linear balance) filter disabled pending changes.
				// DEV NOTE: Modify range function below to span three channels and get range min and max once on image load.
				var rangeMaxAbsFactor = 255 / Z.Viewport.getImageFilterRangeMaxAbsolute(filter);
				var a = Math.round(filterValue * rangeMaxAbsFactor);
				var b = Math.round(filterValue2 * rangeMaxAbsFactor);
				var range = Z.Utils.getColorRange(data, 'red');
				c = range.min;
				d = range.max;
				for (var i = 0, j = data.length; i < j; i += 4) {
					data[i] = ((data[i] - c) * ((b-a)/(d-c)) + a);
				}
				break;

			case 'equalize' :
				// DEV NOTE: Histogram equalization (non-linear flattening) filter disabled pending changes.
				if (typeof Uint8ClampedArray === "undefined") {
					Z.Utils.showMessage(Z.Utils.getResource('ERROR_IMAGEFILTEREQUALIZEARRAYSUPPORT'), false, Z.messageDurationStandard, 'center');
					return;
				}

				// Create brightness lookup table.
				var tableB = new Uint8ClampedArray(w * h);
				var tB = 0;
				for (var i = 0, j = data.length; i < j; i += 4) {
					var r = data[i];
					var g = data[i + 1];
					var b = data[i + 2];
					tableB[tB] = (r * 0.2126 + g * 0.7152 + b * 0.0722);
					tB++;
				}

				// Equalize values.
				var bLen = tableB.length;
				var hist = new Float32Array(256);
				var sum = 0;
				for (var i = 0; i < bLen; ++i) {
					++hist[~~tableB[i]];
					++sum;
				}
				var prev = hist[0];
				for (var i = 1; i < 256; ++i) {
					prev = hist[i] += prev;
				}
				var norm = 255 / sum;
				for (var i = 0; i < bLen; ++i) {
					tableB[i] = hist[~~tableB[i]] * norm;
				}

				// Equalize image.
				tB = 0;
				for (var i = 0, j = data.length; i < j; i += 4) {
					var r = data[i];
					var g = data[i + 1];
					var b = data[i + 2];
					var hsl = Z.Utils.colorToHSL(r, g, b);
					// Debug option: substituting next line even generated brighter image verifying that tableB values are faulty, not conversions or references.
					//hsl.l += 0.2;
					hsl.l = tableB[tB] / 255;
					var rgb = Z.Utils.colorToRGB(hsl.h, hsl.s, hsl.l);
					data[i] = rgb.r;
					data[i + 1] = rgb.g;
					data[i + 2] = rgb.b;
					tB++;
				}
				break;

			case 'sepia' :
				// Sepia.
				for (var i = 0, j = data.length; i < j; i += 4) {
					var red = data[i];
					var green = data[i + 1];
					var blue = data[i + 2];
					var alpha = data[i + 3];
					var redOut = (red * 0.393) + (green * 0.769) + (blue * 0.189);
					var greenOut = (red * 0.349) + (green * 0.686) + (blue * 0.168);
					var blueOut = (red * 0.272) + (green * 0.534) + (blue * 0.131);
					data[i] = redOut < 255 ? redOut : 255;
					data[i + 1] = greenOut < 255 ? greenOut : 255;
					data[i + 2] = blueOut < 255 ? blueOut : 255
					data[i + 3] = alpha;
				}
				break;

			case 'edges' :
				// Laplacian.
				var laplaceKernel = new Z.Utils.createFloat32Array(
					[-1,-1,-1,
					-1, 8,-1,
					-1,-1,-1]);
				imageDataObject = Z.Utils.convolveImage(imageDataObject, laplaceKernel, true);
				break;
		}

		return imageDataObject;
	},

	getColorRange : function (data) {
		var c, d, n;
		c = d = data[0];
		for (var i = 0, j = data.length; i < j; i += 4) {
			n = data[i];
			c = c < n ? c : n;
			d = d > n ? d : n;
		}
		return new Z.Utils.RangeScale(c, d);
	},

	getImageData : function (img) {
		var c = this.getCanvas(img.width, img.height);
		var ctx = c.getContext('2d');
		ctx.drawImage(img, 0, 0);
		return ctx.getImageData(0, 0, c.width, c.height);
	},

	getCanvas : function (w, h) {
		var c = document.createElement('canvas');
		c.width = w;
		c.height = h;
		return c;
	},

	createImageData : function (w,h) {
		var tmpCanvas = document.createElement('canvas');
		var tmpCtx = tmpCanvas.getContext('2d');
		return tmpCtx.createImageData(w,h);
	},

	// Hue, saturation, lightness to red, green blue.
	colorToHSL : function (r, g, b) {
		r /= 255;
		g /= 255;
		b /= 255;
		var max = Math.max(r, g, b);
		var min = Math.min(r, g, b);
		var h, s, l = (max + min) / 2;

		if (max === min) {
			h = s = 0;
		} else {
			var d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
			switch (max) {
				case r:
					h = (g - b) / d + (g < b ? 6 : 0);
					break;
				case g:
					h = (b - r) / d + 2;
					break;
				case b:
					h = (r - g) / d + 4;
					break;
			}
		}
		h /= 6;

		return { h: h, s: s, l: l };
	},

	// Red, green blue to hue, saturation, lightness.
	colorToRGB : function (h, s, l) {
		var r, g, b;

		if (s == 0) {
			r = g = b = l; //Achromatic
		} else {
			var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
			var p = 2 * l - q;

			function hue2rgb (p, q, t) {
				if (t < 0) t += 1;
				if (t > 1) t -= 1;
				if (t < 1 / 6) return p + (q - p) * 6 * t;
				if (t < 1 / 2) return q;
				if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
				return p;
			}

			r = hue2rgb(p, q, h + 1 / 3);
			g = hue2rgb(p, q, h);
			b = hue2rgb(p, q, h - 1 / 3);
		}

		return { r: r * 255, g: g * 255, b: b * 255 };
	},

	colorTempToRGB : function (temp) {
		temp /= 100;
		var r, g, b;
		if (temp <= 66) {
			r = 255;
			g = Math.min(Math.max(99.4708025861 * Math.log(temp) - 161.1195681661, 0), 255);
		} else {
			r = Math.min(Math.max(329.698727446 * Math.pow(temp - 60, -0.1332047592), 0), 255);
			g = Math.min(Math.max(288.1221695283 * Math.pow(temp - 60, -0.0755148492), 0), 255);
		}
		if (temp >= 66) {
			b = 255;
		} else if (temp <= 19) {
			b = 0;
		} else {
			b = temp - 10;
			b = Math.min(Math.max(138.5177312231 * Math.log(b) - 305.0447927307, 0), 255);
		}
		return { r: r, g: g, b: b }
	},

	createImageDataFloat32 : function (w,h) {
		return { width: w, height: h, data: new Z.Utils.createFloat32Array(w * h * 4) };
	},

	// DEV NOTE: Following added for image filters requiring convolution.
	createFloat32Array : function (len) {
		if (Z.float32ArraySupported) {
			return new Float32Array(len);
		} else {
			return new Array(len);
		}
	},

	convolveImage : function (imgDataObj, weights, opaque) {
		var side = Math.round(Math.sqrt(weights.length));
		var sideHalf = Math.floor(side / 2);
		var data = imgDataObj.data;
		var w = imgDataObj.width;
		var h = imgDataObj.height;
		var alphaFactor = opaque ? 1 : 0;

		var output = Z.Utils.createImageData(w, h);
		var dataOut = output.data;

		for (var y = 0; y < h; y++) {
			for (var x = 0; x < w; x++) {
				var sy = y;
				var sx = x;
				var doOff = (y * w + x) * 4;
				var r = 0, g = 0, b = 0, a = 0;
				for (var cy = 0; cy < side; cy++) {
					for (var cx = 0; cx < side; cx++) {
						var scy = sy + cy - sideHalf;
						var scx = sx + cx - sideHalf;
						if (scy >= 0 && scy < h && scx >= 0 && scx < w) {
							var dOff = (scy * w + scx) * 4;
							var wt = weights[cy * side + cx];
							r += data[dOff] * wt;
							g += data[dOff + 1] * wt;
							b += data[dOff + 2] * wt;
							a += data[dOff + 3] * wt;
						}
					}
				}
				dataOut[doOff] = r;
				dataOut[doOff + 1] = g;
				dataOut[doOff + 2] = b;
				dataOut[doOff + 3] = a + alphaFactor * (255 - a);
			}
		}
		return output;
	},

	convolveImageHorizontal : function (imgDataObj, weightsVector, opaque) {
		var side = weightsVector.length;
		var sideHalf = Math.floor(side / 2);
		var data = imgDataObj.data;
		var w = imgDataObj.width;
		var h = imgDataObj.height;
		var alphaFactor = opaque ? 1 : 0;

		var output = Z.Utils.createImageData(w, h);
		var dataOut = output.data;

		for (var y = 0; y < h; y++) {
			for (var x = 0; x < w; x++) {
				var sy = y;
				var sx = x;
				var doOff = (y * w + x)*4;
				var r = 0, g = 0, b = 0, a = 0;
				for (var cx = 0; cx < side; cx++) {
					var scy = sy;
					var scx = Math.min(w - 1, Math.max(0, sx + cx - sideHalf));
					var dOff = (scy * w + scx) * 4;
					var wt = weightsVector[cx];
					r += data[dOff] * wt;
					g += data[dOff + 1] * wt;
					b += data[dOff + 2] * wt;
					a += data[dOff + 3] * wt;
				}
				dataOut[doOff] = r;
				dataOut[doOff + 1] = g;
				dataOut[doOff + 2] = b;
				dataOut[doOff + 3] = a + alphaFactor * (255 - a);
			}
		}
		return output;
	},

	convolveImageVertical : function (imgDataObj, weightsVector, opaque) {
		var side = weightsVector.length;
		var sideHalf = Math.floor(side / 2);
		var data = imgDataObj.data;
		var w = imgDataObj.width;
		var h = imgDataObj.height;
		var alphaFactor = opaque ? 1 : 0;

		var output = Z.Utils.createImageData(w, h);
		var dataOut = output.data;

		for (var y = 0; y < h; y++) {
			for (var x = 0; x < w; x++) {
				var sy = y;
				var sx = x;
				var doOff = (y * w + x)*4;
				var r = 0, g = 0, b = 0, a = 0;
				for (var cy = 0; cy < side; cy++) {
					var scy = Math.min(h - 1, Math.max(0, sy + cy - sideHalf));
					var scx = sx;
					var dOff = (scy * w + scx) * 4;
					var wt = weightsVector[cy];
					r += data[dOff] * wt;
					g += data[dOff + 1] * wt;
					b += data[dOff + 2] * wt;
					a += data[dOff + 3] * wt;
				}
				dataOut[doOff] = r;
				dataOut[doOff + 1] = g;
				dataOut[doOff + 2] = b;
				dataOut[doOff + 3] = a + alphaFactor * (255 - a);
			}
		}
		return output;
	},

	convolveImageSeparable : function (imgDataObj, weightsH, weightsV, opaque) {
		return Z.Utils.convolveImageHorizontal(Z.Utils.convolveImageFloat32Vertical(imgDataObj, weightsV, opaque), weightsH, opaque);
	},

	convolveImageFloat32 : function (imgDataObj, weights, opaque) {
		var side = Math.round(Math.sqrt(weights.length));
		var sideHalf = Math.floor(side / 2);
		var data = imgDataObj.data;
		var w = imgDataObj.width;
		var h = imgDataObj.height;
		var alphaFactor = opaque ? 1 : 0;

		var output = { width: w, height: h, data: new Z.Utils.Float32ArrayZ(w * h * 4) };
		var dataOut = output.data;

		for (var y = 0; y < h; y++) {
			for (var x = 0; x < w; x++) {
				var sy = y;
				var sx = x;
				var doOff = (y * w + x) * 4;
				var r = 0, g = 0, b = 0, a = 0;
				for (var cy = 0; cy < side; cy++) {
					for (var cx = 0; cx < side; cx++) {
						var scy = Math.min(h - 1, Math.max(0, sy + cy - sideHalf));
						var scx = Math.min(w - 1, Math.max(0, sx + cx - sideHalf));
						var dOff = (scy * w + scx) * 4;
						var wt = weights[cy * side + cx];
						r += data[dOff] * wt;
						g += data[dOff + 1] * wt;
						b += data[dOff + 2] * wt;
						a += data[dOff + 3] * wt;
					}
				}
				dataOut[doOff] = r;
				dataOut[doOff + 1] = g;
				dataOut[doOff + 2] = b;
				dataOut[doOff + 3] = a + alphaFactor * (255 - a);
			}
		}
		return output;
        },

	convolveImageFloat32Horizontal : function (imgDataObj, weightsVector, opaque) {
		var side = weightsVector.length;
		var sideHalf = Math.floor(side / 2);
		var data = imgDataObj.data;
		var w = imgDataObj.width;
		var h = imgDataObj.height;
		var alphaFactor = opaque ? 1 : 0;

		var output = Z.Utils.createImageDataFloat32(w, h);
		var dataOut = output.data;

		for (var y = 0; y < h; y++) {
			for (var x = 0; x < w; x++) {
				var sy = y;
				var sx = x;
				var doOff = (y * w + x) * 4;
				var r = 0, g = 0, b = 0, a = 0;
				for (var cx = 0; cx < side; cx++) {
					var scy = sy;
					var scx = Math.min(w - 1, Math.max(0, sx + cx - sideHalf));
					var dOff = (scy * w + scx) * 4;
					var wt = weightsVector[cx];
					r += data[dOff] * wt;
					g += data[dOff + 1] * wt;
					b += data[dOff + 2] * wt;
					a += data[dOff + 3] * wt;
				}
				dataOut[doOff] = r;
				dataOut[doOff + 1] = g;
				dataOut[doOff + 2] = b;
				dataOut[doOff + 3] = a + alphaFactor * (255 - a);
			}
		  }
		  return output;
	},

	convolveImageFloat32Vertical : function (imgDataObj, weightsVector, opaque) {
		var side = weightsVector.length;
		var sideHalf = Math.floor(side / 2);
		var data = imgDataObj.data;
		var w = imgDataObj.width;
		var h = imgDataObj.height;
		var alphaFactor = opaque ? 1 : 0;

		var output = Z.Utils.createImageDataFloat32(w, h);
		var dataOut = output.data;

		for (var y = 0; y < h; y++) {
			for (var x = 0; x < w; x++) {
				var sy = y;
				var sx = x;
				var doOff = (y * w + x)*4;
				var r = 0, g = 0, b = 0, a = 0;
				for (var cy = 0; cy < side; cy++) {
					var scy = Math.min(h - 1, Math.max(0, sy + cy - sideHalf));
					var scx = sx;
					var dOff = (scy * w + scx) * 4;
					var wt = weightsVector[cy];
					r += data[dOff] * wt;
					g += data[dOff + 1] * wt;
					b += data[dOff + 2] * wt;
					a += data[dOff + 3] * wt;
				}
				dataOut[doOff] = r;
				dataOut[doOff + 1] = g;
				dataOut[doOff + 2] = b;
				dataOut[doOff + 3] = a + alphaFactor * (255 - a);
			}
		}
		return output;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::: ZIF UTILITY FUNCTIONS :::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	intValue : function (array, offset) {
		return (array[offset] + (array[offset + 1] << 8) | (array[offset + 2] << 16)) + (array[offset + 3] * 16777216);
	},

	longValue : function (array, offset) {
		var value = (array[offset] + (array[offset + 1] << 8) | (array[offset + 2] << 16)) + (array[offset + 3] * 16777216);
		if (array[offset + 4] != 0) { value = value + array[offset + 4] * 4294967296; }
		return value;
	},

	shortValue : function (array, offset) {
		return array[offset] + (array[offset + 1] << 8);
	},

	createUint8Array : function (array, offset) {
		if (Z.uInt8ArraySupported) {
			return new Uint8Array(array, offset);
		} else {
			return new Z.Utils.TypedArray(array, offset);
		}
	},

	TypedArray : function (arg1) {
		var result;
		if (typeof arg1 === 'number') {
			result = new Array(arg1);
			for (var i = 0; i < arg1; ++i) {
				result[i] = 0;
			}
		} else {
			result = arg1.slice(0);
		}
		result.subarray = Z.Utils.arraySubarraySimple;
		result.buffer = result;
		result.byteLength = result.length;
		result.set = Z.Utils.setSimple;
		if (typeof arg1 === 'object' && arg1.buffer) {
			result.buffer = arg1.buffer;
		}
		return result;
	},

	setSimple : function (array, offset) {
		if (arguments.length < 2) { offset = 0; }
		for (var i = 0, n = array.length; i < n; ++i, ++offset) {
			this[offset] = array[i] & 0xFF;
		}
	},

	encodeBase64 : function (data) {
		var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
		var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
		if (!data) { return data; }

		do { // Pack three octets into four hexets.
		    o1 = data[i++];
		    o2 = data[i++];
		    o3 = data[i++];
		    bits = o1 << 16 | o2 << 8 | o3;
		    h1 = bits >> 18 & 0x3f;
		    h2 = bits >> 12 & 0x3f;
		    h3 = bits >> 6 & 0x3f;
		    h4 = bits & 0x3f;

		    // Use hexets to index into b64, and append result to encoded string.
		    tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
		} while (i < data.length);

		enc = tmp_arr.join('');
		var r = data.length % 3;
		return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
	},

	// Prototyping and property modifications are used only to ensure legacy browser support for needed
	// functionality and is otherwise avoided to limit potential conflicts during code integration or customization.
	// One instance is currently implemented: adding response array support to net requests if not present.
	validateResponseArrayFunctionality : function () {
		if (Z.tileSource == 'ZoomifyImageFile' && !Z.responseArraySupported && !Z.responseArrayPrototyped) {
			Z.Utils.defineObjectProperty(XMLHttpRequest.prototype, 'response', {
				get : function () { return new VBArray(this.responseBody).toArray(); }
			});
			Z.responseArrayPrototyped = true;
		}
	},

	defineObjectProperty : function (obj, name, def) {
		if (Z.definePropertySupported) {
			Object.defineProperty(obj, name, def);
		} else {
			// DEV NOTE: Verify value of optional implementation.
			delete obj[name];
			if ('get' in def) { obj.__defineGetter__(name, def['get']); }
			if ('set' in def) { obj.__defineSetter__(name, def['set']); }
			if ('value' in def) {
				obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
					this.__defineGetter__(name, function objectDefinePropertyGetter() {
						return value;
					});
					return value;
				});
				obj[name] = def.value;
			}
		}
	},

	createImageElementFromBytes : function (src, callback) {
		var image = new Image();
		var timeout = null;
		var IMAGE_LOAD_TIMEOUT = parseFloat(this.getResource('DEFAULT_IMAGELOADTIMEOUT'));

		var timeoutFunc = function () {
			console.log(Z.Utils.getResource('ERROR_IMAGEREQUESTTIMEDOUT'));
			complete(false);

			// Debug option: Append source data to error message above: + ": " + src);
		};

		function complete (result) {
			image.onload = null;
			image.onabort = null;
			image.onerror = null;
			if (timeout) { window.clearTimeout(timeout); }
			window.setTimeout(function () { callback(image); }, 1);
		};

		var successFunction = function () { complete(true); };
		var errorFunction = function () { complete(false); };
		image.onload = successFunction;
		image.onabort = errorFunction;
		image.onerror = errorFunction;
		timeout = window.setTimeout(timeoutFunc, IMAGE_LOAD_TIMEOUT);
		image.src = src;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//:::::::::::::::::::::::::::: MISCELLANEOUS UTILITY FUNCTIONS :::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	getCurrentUTCDateAsString : function () {
		var date = new Date();
		var month = ((date.getUTCMonth() + 1 < 10) ? '0' : '') + (date.getUTCMonth() + 1);
		var day = ((date.getUTCDate() < 10) ? '0' : '') + date.getUTCDate();
		var hour = ((date.getUTCHours() < 10) ? '0' : '') + date.getUTCHours();
		var minute = ((date.getUTCMinutes() < 10) ? '0' : '') + date.getUTCMinutes();
		var second = ((date.getUTCSeconds() < 10) ? '0' : '') + date.getUTCSeconds();
		return date.getUTCFullYear() + month + day + hour + minute + second;
	},

	cacheProofPath : function (url) {
		// Uses time stamp plus counter to guarantee uniqueness. Implementation with only time stamp fails to produce unique value on some versions of some browsers, and appending Math.random() slower.
		// Apply to support setImage feature, non-caching implementations, and to avoid IE problem leading to correct image with wrong dimensions. (DEV NOTE: Formerly limited to Z.browser == Z.browsers.IE)
		// Note: currently applied to most XML calls prior to loadXML(), to image folder tile requests in function formatTilePathImageFolder.  NOT applied directly in loadXML function in Z.NetConnector because not
		// applied to all XML paths. Not applied to annotation XML where Z.simplePath used to prevent modifications to provided path. Also not applied to JSON paths. Not applied in PFF requests due to server
		// parsing requirements. Applied to all ZIF byterange requests directly in Z.NetConnector. Further consolidation and broader application anticipated in future releases.
		url += '?t' + new Date().getTime().toString() + 'n' + Z.cacheProofCounter.toString();
		Z.cacheProofCounter += 1;
		return url;
	},

	easing : function (b, t, c, d, effect) {
		// Key: b=beginning position, t=target position, c=current time or position, d=duration or distance total, calculated s = span.
		if (typeof effect === 'undefined' || effect === null) { effect = Z.smoothZoomEasing; }
		var retVal = t;

		if (Z.smoothZoom && effect > 1) {
			switch (effect) {
				case 2 :
					// Quintic out.
					var s = t - b;
					c /= d;
					c--;
					retVal = s * (c * c * c * c * c + 1) + b;
					break;
				case 3 :
					// Exponential out, longer glide to stop.
					var s = t - b;
					retVal = s * ( -Math.pow( 2, -10 * c/d ) + 1 ) + b;
					break;
				case 4 :
					// Quintic in-out, long start and stop.
					var s = t - b;
					if ((c /= d / 2) < 1) {
						retVal = s / 2 * c * c * c * c * c + b;
					} else {
						retVal = s / 2 * ((c -= 2) * c * c * c * c + 2) + b;
					}
					break;
			}
		}

		return retVal;
	},

	functionCallWithDelay : function (functionToCall, delay) {
		var timer = window.setTimeout( functionToCall, delay);
	},

	nodeIsInViewer : function (nodeToTest) {
		var isInViewer = false;
		var ancestor = nodeToTest;
		while (isInViewer == false) {
			if (ancestor) {
				if (ancestor.id) {
					if (ancestor.id == 'ViewerDisplay') {
						isInViewer = true;
					} else {
						ancestor = ancestor.parentNode;
					}
				} else {
					ancestor = ancestor.parentNode;
				}
			} else {
				break;
			}
		}
		return isInViewer;
	},

	// Limit total digits, not just decimal places like JavaScript toFixed function, but do not convert to string.
	roundToFixed : function (value, digits) {
		var digitsBeforeDec = Math.round(value).toString().length;
		var digitsAfterDec = digits - digitsBeforeDec;
		var targetDigits = (digitsAfterDec < 0) ? 0 : digitsAfterDec;
		var roundFactor = Math.pow(10, targetDigits);
		value = Math.round(value * roundFactor) / roundFactor;
		return value;
	},

	// Returns pseudo-random integer between min and max.
	getRandomInt : function (min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	},

	getSign : function (x) {
		return x ? x < 0 ? -1 : 1 : 0;
	},



	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::: DEBUGGING UTILITY FUNCTIONS :::::::::::::::::::::::::::
	//::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	drawCrosshairs : function (display, w, h) {
		var viewportCenterLineVertical = Z.Utils.createContainerElement('div', 'viewportCenterLineVertical', 'inline-block', 'absolute', 'visible', '1px', h + 'px', (w / 2) + 'px', '0px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', null, true);
		var viewportCenterLineHorizontal = Z.Utils.createContainerElement('div', 'viewportCenterLineHorizontal', 'inline-block', 'absolute', 'visible', w + 'px', '1px', '0px', (h / 2) + 'px', 'solid', '1px', 'transparent none', '0px', '0px', 'normal', null, true);
		display.appendChild(viewportCenterLineHorizontal);
		display.appendChild(viewportCenterLineVertical);
	},

	configureHelpDisplay : function () {
		// Calculate help display dimensions, position, and presentation.
		var marginW = 80, marginH = 80;
		var mdW = Z.helpW;
		var mdH = Z.helpH;
		if (mdW >= Z.viewerW) {
			mdW = Z.viewerW - marginW;
			marginW -= 40;
		}
		if (mdH >= Z.viewerH) {
			mdH = Z.viewerH - marginH;
			marginH -= 40;
		}
		var mdL = (Z.helpL) ? Z.helpL : (Z.viewerW - mdW) / 2;
		var mdT = (Z.helpT) ? Z.helpT : (Z.viewerH - mdH) / 2;
		var scrnColor = this.getResource('UI_HELPSCREENCOLOR');
		var btnColor = this.getResource('UI_HELPBUTTONCOLOR');

		// Create help display.
		Z.HelpDisplay = this.createContainerElement('div', 'HelpDisplay', 'inline-block', 'absolute', 'hidden', mdW + 'px', mdH + 'px', mdL + 'px', mdT + 'px', 'solid', '1px', scrnColor, '0px', '0px', 'normal', null, true);
		Z.ViewerDisplay.appendChild(Z.HelpDisplay);
		var helpTextBox = Z.Utils.createContainerElement('div', 'helpTextBox', 'inline-block', 'absolute', 'auto', (mdW - 50) + 'px', (mdH - 74) + 'px', '4px', '4px', 'solid', '1px', 'white', '0px', '20px', null);
		helpTextBox.style.overflowY = 'auto';
		// Alternative implementation: Text rather than HTML content.
		//var helpTextBox = Z.Utils.createTextElement('helpTextBox', '', (mdW - 18) + 'px', (mdH - 40) + 'px', '4px', '4px', '4px', 'solid', '1px', true, 'verdana', '12px', 'none', null, 1, 'auto', 'auto', null);
		Z.HelpDisplay.appendChild(helpTextBox);
		Z.help = document.getElementById('helpTextBox');

		// Ensure proper z-ordering of Viewer elements.
		Z.HelpDisplay.style.zIndex = (Z.baseZIndex + 26).toString();

		// Configure and add display buttons.
		var btnW = 56;
		var btnH = 18;
		var dvdrW = 10;
		var dvdrH = 5;
		var btnL = mdW;
		var btnT = mdH - btnH - dvdrH;
		var btnTxt;

		btnL -= (btnW + dvdrW);
		btnTxt = this.getResource('UI_HELPOKBUTTONTEXT');
		var buttonHelpOk = new Z.Utils.Button('buttonHelpOk', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', this.helpOkButtonHandler, 'TIP_HELPOK', 'solid', '1px', btnColor, '0px', '0px');
		Z.HelpDisplay.appendChild(buttonHelpOk.elmt);
	},

	helpOkButtonHandler : function (event) {
		Z.Utils.hideHelp();
		return true;
	},

	showHelp : function (helpContent) {
		// Create help display on first use.
		if (!Z.HelpDisplay) { Z.Utils.configureHelpDisplay(); }

		if (Z.help) {
			if (!Z.helpCustom) {
				Z.help.innerHTML = unescape(helpContent);
			} else {
				// If zHelpPath present use previously loaded custom help page in place of default internal content.
				Z.help.innerHTML = Z.helpContent;
			}

			Z.HelpDisplay.style.display = 'inline-block';

			var buttonHelpOk = document.getElementById('buttonHelpOk');
			buttonHelpOk.style.display = 'inline-block';

			// Alternative implementation: Text rather than HTML content.
			//Z.help.value = helpContent;
			//var mTB = document.getElementById('textBoxFor-helpBox');
			//if (mTB) { mTB.firstChild.style.textAlign = 'left'; }
		}
	},

	hideHelp : function () {
		Z.HelpDisplay.style.display = 'none';
	},

	configureMessageDisplay : function () {
		// Calculate message display dimensions, position, and presentation.
		var mdW = parseInt(this.getResource('UI_MESSAGEDISPLAYWIDTH'), 10);
		var mdH = parseInt(this.getResource('UI_MESSAGEDISPLAYHEIGHT'), 10);

		var displayCoords = Z.Utils.getMessageDisplayCoords('6', mdW, Z.viewerW, Z.viewerH); // Z.viewerW allows for toolbar height if static in viewer display area.

		var scrnColor = this.getResource('DEFAULT_MESSAGESCREENCOLOR');
		var btnColor = this.getResource('DEFAULT_MESSAGEBUTTONCOLOR');

		// Create message display.
		Z.MessageDisplay = this.createContainerElement('div', 'MessageDisplay', 'inline-block', 'absolute', 'auto', mdW + 'px', mdH + 'px', displayCoords.x + 'px', displayCoords.y + 'px', 'solid', '1px', scrnColor, '0px', '0px', 'normal', null, true);
		Z.ViewerDisplay.appendChild(Z.MessageDisplay);

		// Ensure proper z-ordering of Viewer elements.
		Z.MessageDisplay.style.zIndex = (Z.baseZIndex + 30).toString();

		var messageBox = Z.Utils.createTextElement('messageBox', '', (mdW - 18) + 'px', (mdH - 40) + 'px', '4px', '4px', '4px', 'solid', '1px', true, 'verdana', '12px', 'none', null, 1, 'auto', 'auto', null);
		Z.MessageDisplay.appendChild(messageBox);
		Z.messages = document.getElementById('messageBox');

		// Configure and add display buttons.
		var btnW = 56;
		var btnH = 18;
		var dvdrW = 10;
		var dvdrH = 5;
		var btnL = mdW;
		var btnT = mdH - btnH - dvdrH;
		var btnTxt;

		// DEV NOTE: Cancel option not required for current feature set.
		/* btnL -= (btnW + dvdrW);
		btnTxt = this.getResource('UI_MESSAGECANCELBUTTONTEXT');
		var buttonMessageCancel = new Z.Utils.Button('buttonMessageCancel', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', this.messageCancelButtonHandler, 'TIP_MESSAGECANCEL', 'solid', '1px', btnColor, '0px', '0px');
		Z.MessageDisplay.appendChild(buttonMessageCancel.elmt);
		*/

		btnL -= (btnW + dvdrW);
		btnTxt = this.getResource('UI_MESSAGEOKBUTTONTEXT');
		var buttonMessageOk = new Z.Utils.Button('buttonMessageOk', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', this.messageOkButtonHandler, 'TIP_MESSAGEOK', 'solid', '1px', btnColor, '0px', '0px');
		Z.MessageDisplay.appendChild(buttonMessageOk.elmt);
	},

	getMessageDisplayCoords : function (position, displayW, viewerW, viewerH) {
		//Message display positioning: 1 top-left, 2 top-center, 3 top-right, 4 bottom right, 5 bottom-center, 6 bottom left.
		var displayX, displayY;
		var margin = 40;
		switch (position) {
			case '1':
				displayX = margin;
				displayY = margin;
				break;
			case '2':
				displayX = viewerW / 2 - displayW / 2;
				displayY = margin;
				break;
			case '3':
				displayX = viewerW - displayW - margin * 2;
				displayY = margin;
				break;
			case '4':
				displayX = viewerW - displayW - margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					displayY = viewerH - margin * 3;
				} else {
					displayY = viewerH - margin * 2;
				}
				break;
			case '5':
				displayX = viewerW / 2 - displayW / 2;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					displayY = viewerH - margin * 3;
				} else {
					displayY = viewerH - margin * 2;
				}
				break;
			case '6':
				displayX = margin;
				if (Z.toolbarVisible > 0 && Z.toolbarVisible != 8) {
					displayY = viewerH - margin * 3;
				} else {
					displayY = viewerH - margin * 2;
				}
				break;
			default:
				displayX = viewerW - displayW;
				displayY = margin;
		}
		return new Z.Utils.Point(displayX, displayY);
	},

	messageOkButtonHandler : function (event) {
		Z.Utils.hideMessage();
		if (Z.Viewport && Z.coordinatesVisible) { Z.Viewport.setCoordinatesDisplayVisibility(false); }
		return true;
	},

	messageCancelButtonHandler : function (event) {
		// DEV NOTE: Cancel option not required by current feature set.
		Z.Utils.hideMessage();
		return false;
	},

	showMessage : function (messageText, button, displayTime, textAlign, once, position) {
		// // Parameter zMessagesVisible permits disabling display.
		// if (Z.messagesVisible) {

		// 	// Create message display on first use and clear any pending message timers prior to new use.
		// 	if (!Z.MessageDisplay) { Z.Utils.configureMessageDisplay(); }

		// 	//Message display positioning: 1 top-left, 2 top-center, 3 top-right, 4 bottom right, 5 bottom-center, 6 bottom left.
		// 	if (typeof position === 'undefined' || position === null) { position = '6'; }
		// 	var mdW = parseInt(this.getResource('UI_MESSAGEDISPLAYWIDTH'), 10);
		// 	var displayCoords = Z.Utils.getMessageDisplayCoords(position, mdW, Z.viewerW, Z.viewerH); // Z.viewerW allows for toolbar height if static in viewer display area.
		// 	Z.MessageDisplay.style.left = displayCoords.x + 'px';
		// 	Z.MessageDisplay.style.top = displayCoords.y + 'px';

		// 	if (Z.MessageDisplay.messageTimer) { window.clearTimeout(MessageDisplay.messageTimer); }

		// 	// Record and check prior displays if message to be displayed only once.
		// 	var displayOK = true;
		// 	if (once) {
		// 		if (Z.Utils.arrayIndexOf(Z.messageDisplayList, messageText) != -1) {
		// 			displayOK = false;
		// 		} else {
		// 			Z.messageDisplayList[Z.messageDisplayList.length] = messageText;
		// 		}
		// 	}
		// 	if (displayOK) {
		// 		// Show message display.
		// 		if (Z.messages) { Z.messages.value = messageText; }
		// 		Z.MessageDisplay.style.display = 'inline-block';
		// 		if (typeof textAlign !== 'undefined' && textAlign !== null) {
		// 			var mTB = document.getElementById('textBoxFor-messageBox');
		// 			if (mTB) { mTB.firstChild.style.textAlign = textAlign; }
		// 		}

		// 		// Add buttons if specified.
		// 		var buttonMessageOk = document.getElementById('buttonMessageOk');
		// 		var mdH = parseInt(this.getResource('UI_MESSAGEDISPLAYHEIGHT'), 10);
		// 		if (typeof button !== 'undefined' && button !== null && button) {
		// 			buttonMessageOk.style.display = 'inline-block';
		// 			Z.MessageDisplay.style.height = mdH + 'px';
		// 		} else {
		// 			buttonMessageOk.style.display = 'none';
		// 			Z.MessageDisplay.style.height = (mdH - 22) + 'px';
		// 		}

		// 		// Automatically hide message if display time specified.
		// 		if (typeof displayTime !== 'undefined' && displayTime !== null && !isNaN(displayTime)) {
		// 			if (typeof Z.MessageDisplay.messageTimer !== 'undefined' && Z.MessageDisplay.messageTimer !== null) { window.clearTimeout(Z.MessageDisplay.messageTimer); }
		// 			if (typeof displayTime === 'undefined' || displayTime === null) { displayTime = 3000; }
		// 			Z.MessageDisplay.messageTimer = window.setTimeout(Z.Utils.hideMessageTimerHandler, displayTime);
		// 		}
		// 	}
		// }
	},

	getMessage : function () {
		var messageText = '';
		if (Z.messages && Z.Utils.stringValidate(Z.messages.value)) {
			messageText = Z.messages.value;
		}
		return messageText;
	},

	hideMessage : function () {
		if (Z.MessageDisplay) {
			Z.MessageDisplay.style.display = 'none';
		}
	},

	hideMessageTimerHandler : function () {
		if (Z.MessageDisplay.messageTimer) {
			window.clearTimeout(Z.MessageDisplay.messageTimer);
			Z.MessageDisplay.messageTimer = null;
		}
		Z.Utils.hideMessage();
	},

	uploadProgress : function (event) {
		var messageText = Z.saveImageMessage;
		if (event.lengthComputable) {
			var percentComplete = Math.round(event.loaded * 100 / event.total);
			messageText += percentComplete.toString() + '%';
		} else {
			messageText += Z.Utils.getResource('ERROR_IMAGESAVEUNABLETOCOMPUTEPROGRESS');
		}
		Z.Utils.showMessage(messageText, false, 'none', 'center');
	},

	configureCoordinatesDisplay : function () {
		// Calculate message display dimensions, position, and presentation.
		var mdW = parseInt(this.getResource('UI_COORDINATESDISPLAYWIDTH'), 10);
		var mdH = parseInt(this.getResource('UI_COORDINATESDISPLAYHEIGHT'), 10);
		var mdL = Z.viewerW - mdW - 20;
		var mdT = Z.viewerH - mdH - 30;
		var scrnColor = this.getResource('DEFAULT_COORDINATESSCREENCOLOR');

		// Create message display.
		Z.CoordinatesDisplay = this.createContainerElement('div', 'CoordinatesDisplay', 'inline-block', 'absolute', 'auto', mdW + 'px', mdH + 'px', mdL + 'px', mdT + 'px', 'solid', '1px', scrnColor, '0px', '0px', 'normal');
		Z.ViewerDisplay.appendChild(Z.CoordinatesDisplay);

		// Ensure proper z-ordering of Viewer elements.
		Z.CoordinatesDisplay.style.zIndex = (Z.baseZIndex + 12).toString();

		var labelText = (Z.geoCoordinatesVisible) ? Z.Utils.getResource('UI_GEOCOORDINATESDISPLAYTEXT') : (Z.tileSource == 'IIIFImageServer') ? Z.Utils.getResource('UI_IIIFCOORDINATESDISPLAYTEXT') : Z.Utils.getResource('UI_COORDINATESDISPLAYTEXT');

		var coordsLabelBox = Z.Utils.createTextElement('coordsLabelBox', labelText, (mdW - 18) + 'px', '28px', '4px', '4px', '4px', 'solid', '1px', true, 'verdana', '12px', 'none', null, 1, 'auto', 'auto', null);
		Z.CoordinatesDisplay.appendChild(coordsLabelBox);
		var clTB = document.getElementById('textBoxFor-coordsLabelBox');
		if (clTB) { clTB.firstChild.style.textAlign = 'center'; }

		var coordsDisplayBox = Z.Utils.createTextElement('coordsDisplayBox', '', (mdW - 18) + 'px', '18px', '4px', '46px', '4px', 'solid', '1px', true, 'verdana', '12px', 'none', null, 1, 'auto', 'auto', null);
		Z.CoordinatesDisplay.appendChild(coordsDisplayBox);
		Z.coordinates = document.getElementById('coordsDisplayBox');
		var cdTB = document.getElementById('textBoxFor-coordsDisplayBox');
		if (cdTB) { cdTB.firstChild.style.textAlign = 'center'; }

		var coordsSaveBox = Z.Utils.createTextElement('coordsSaveBox', '', (mdW - 18) + 'px', (mdH - 92) + 'px', '4px', '78px', '4px', 'solid', '1px', true, 'verdana', '12px', 'none', null, 1, 'auto', 'auto', null);
		Z.CoordinatesDisplay.appendChild(coordsSaveBox);
		Z.coordinatesSave = document.getElementById('coordsSaveBox');
		var csTB = document.getElementById('textBoxFor-coordsSaveBox');
		if (csTB) { csTB.firstChild.style.textAlign = 'center'; }
	},

	showCoordinates : function (coordsText) {
		// Create message display on first use.
		if (!Z.CoordinatesDisplay) { Z.Utils.configureCoordinatesDisplay(); }
		if (Z.coordinates) { Z.coordinates.value = coordsText; }
	},

	saveCoordinates : function (coordsText) {
		// Create message display on first use.
		if (!Z.CoordinatesDisplay) { Z.Utils.configureCoordinatesDisplay(); }
		if (Z.coordinatesSave) { Z.coordinatesSave.value += coordsText + '\n'; }
	},

	configureTraceDisplay : function () {
		if (typeof Z.Viewport !== 'undefined' && Z.Viewport !== null) {
			var tdW = 280;
			var tdH = 280;
			var tdL = 10;
			var tdT = Z.viewerH - 330;
			var traceHOffset = 125;
			var scrnColor = this.getResource('DEFAULT_TRACEDISPLAYSCREENCOLOR');

			Z.TraceDisplay = this.createContainerElement('div', 'TraceDisplay', 'inline-block', 'absolute', 'auto', tdW + 'px', tdH+ 'px', tdL + 'px', tdT + 'px', 'solid', '1px', scrnColor, '0px', '10px', 'normal');
			Z.ViewerDisplay.appendChild(Z.TraceDisplay);

			// Ensure proper z-ordering of Viewer elements.
			Z.TraceDisplay.style.zIndex = (Z.baseZIndex + 28).toString();

			var placeHolderTraceText = Z.Utils.getResource('UI_TRACEDISPLAYTITLE');
			var tracesBox = Z.Utils.createTextElement('debugTraces', placeHolderTraceText, (tdW - 15) + 'px', (tdH - traceHOffset) + 'px', '10px', '10px', '5px', 'solid', '1px', true, 'verdana', '12px', 'none', null, 1, 'auto', 'auto', null);
			Z.TraceDisplay.appendChild(tracesBox);
			Z.traces = document.getElementById('debugTraces');

			// Set dimensions for tile loading and tile speed status bars.
			var textFontSize = parseInt(Z.Utils.getResource('DEFAULT_TRACEDISPLAYTEXTFONTSIZE'), 10);
			var textPaddingSmall= parseInt(Z.Utils.getResource('DEFAULT_TRACEDISPLAYTEXTPADDINGSMALL'), 10);
			var textW = 37;
			var textSpan = textW + 8;
			var labelW = tdW - 5, labelH = textH = 16, margin = 10;
			var labelFontSize = textFontSize - 2;
			var labelsOffset = 97, elementsOffset = 82;
			var margin2 = 15, labelWSingle = 85, textW2 = 50, labelsOffset2 = 56, elementsOffset2 = 60;

			// Configure tile loading status bar.
			var labelTileStatusTextBox = Z.Utils.createContainerElement('div', 'labelTileStatusTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelTileStatusTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACEDISPLAYTILESTATUSTEXT'));
			labelTileStatusTextBox.appendChild(labelTileStatusTextNode);
			Z.TraceDisplay.appendChild(labelTileStatusTextBox);
			var lTSTB = document.getElementById('labelTileStatusTextBox');
			if (lTSTB) {
				var ltstbS = lTSTB.style;
				ltstbS.width = labelW + 'px';
				ltstbS.height = labelH + 'px';
				ltstbS.left = margin + 'px';
				ltstbS.top = (tdH - labelsOffset)  + 'px';
				Z.Utils.setTextNodeStyle(lTSTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none');
			}

			var dx = margin + 7;
			var tilesRequiredTextElement = Z.Utils.createTextElement('tilesRequiredTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesRequiredTextElement);
			var trTS = document.getElementById('textBoxFor-tilesRequiredTextElement');
			if (trTS) {
				var trtsS = trTS.style;
				trtsS.width = textW + 'px';
				trtsS.height = textH + 'px';
				trtsS.left = dx + 'px';
				trtsS.top = (tdH - elementsOffset)  + 'px';
				Z.Utils.setTextAreaStyle(trTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
				dx += textSpan;
			}

			var tilesCachedTextElement = Z.Utils.createTextElement('tilesCachedTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesCachedTextElement);
			var tcTS = document.getElementById('textBoxFor-tilesCachedTextElement');
			if (tcTS) {
				var tctsS = tcTS.style;
				tctsS.width = textW + 'px';
				tctsS.height = textH + 'px';
				tctsS.left = dx + 'px';
				tctsS.top = (tdH - elementsOffset)  + 'px';
				Z.Utils.setTextAreaStyle(tcTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
				dx += textSpan;
			}

			var tilesRequestedTextElement = Z.Utils.createTextElement('tilesRequestedTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesRequestedTextElement);
			var trqTS = document.getElementById('textBoxFor-tilesRequestedTextElement');
			if (trqTS) {
				var trqtsS = trqTS.style;
				trqtsS.width = textW + 'px';
				trqtsS.height = textH + 'px';
				trqtsS.left = dx + 'px';
				trqtsS.top = (tdH - elementsOffset)  + 'px';
				Z.Utils.setTextAreaStyle(trqTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
				dx += textSpan;
			}

			var tilesLoadedTextElement = Z.Utils.createTextElement('tilesLoadedTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesLoadedTextElement);
			var tlTS = document.getElementById('textBoxFor-tilesLoadedTextElement');
			if (tlTS) {
				var tltsS = tlTS.style;
				tltsS.width = textW + 'px';
				tltsS.height = textH + 'px';
				tltsS.left = dx + 'px';
				tltsS.top = (tdH - elementsOffset)  + 'px';
				Z.Utils.setTextAreaStyle(tlTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
				dx += textSpan;
			}

			var tilesDisplayedTextElement = Z.Utils.createTextElement('tilesDisplayedTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesDisplayedTextElement);
			var tdTS = document.getElementById('textBoxFor-tilesDisplayedTextElement');
			if (tdTS) {
				var tdtsS = tdTS.style;
				tdtsS.width = textW + 'px';
				tdtsS.height = textH + 'px';
				tdtsS.left = dx + 'px';
				tdtsS.top = (tdH - elementsOffset)  + 'px';
				Z.Utils.setTextAreaStyle(tdTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
				dx += textSpan;
			}

			var tilesWaitingTextElement = Z.Utils.createTextElement('tilesWaitingTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesWaitingTextElement);
			var twTS = document.getElementById('textBoxFor-tilesWaitingTextElement');
			if (twTS) {
				var twtsS = twTS.style;
				twtsS.width = textW + 'px';
				twtsS.height = textH + 'px';
				twtsS.left = dx + 'px';
				twtsS.top = (tdH - elementsOffset)  + 'px';
				Z.Utils.setTextAreaStyle(twTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
			}

			// Configure loading speed status bar.
			var labelElapsedTimeTextBox = Z.Utils.createContainerElement('div', 'labelElapsedTimeTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelElapsedTimeTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACEDISPLAYELAPSEDTIMETEXT'));
			labelElapsedTimeTextBox.appendChild(labelElapsedTimeTextNode);
			Z.TraceDisplay.appendChild(labelElapsedTimeTextBox);
			var lETTB = document.getElementById('labelElapsedTimeTextBox');
			if (lETTB) {
				var lettbS = lETTB.style;
				lettbS.width =labelWSingle + 'px';
				lettbS.height = labelH + 'px';
				lettbS.left = margin2 + 'px';
				lettbS.top = (tdH - labelsOffset2)  + 'px';
				Z.Utils.setTextNodeStyle(lETTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			}

			var tilesTimeElapsedTextElement = Z.Utils.createTextElement('tilesTimeElapsedTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesTimeElapsedTextElement);
			var tteTS = document.getElementById('textBoxFor-tilesTimeElapsedTextElement');
			if (tteTS) {
				var ttetsS = tteTS.style;
				ttetsS.width = textW2 + 'px';
				ttetsS.height = textH + 'px';
				ttetsS.left = (margin2 + labelWSingle / 2 + 10) + 'px';
				ttetsS.top = (tdH - elementsOffset2)  + 'px';
				Z.Utils.setTextAreaStyle(tteTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
			}

			var labelTilesPerSecondTextBox = Z.Utils.createContainerElement('div', 'labelTilesPerSecondTextBox', 'inline-block', 'absolute', 'hidden', '1px', '1px', '0px', '0px', 'none', '0px', 'transparent none', '0px', '0px', 'nowrap', null, true);
			var labelTilesPerSecondTextNode = document.createTextNode(Z.Utils.getResource('UI_TRACEDISPLAYTILESPERSECONDTEXT'));
			labelTilesPerSecondTextBox.appendChild(labelTilesPerSecondTextNode);
			Z.TraceDisplay.appendChild(labelTilesPerSecondTextBox);
			var lTPSTB = document.getElementById('labelTilesPerSecondTextBox');
			if (lTPSTB) {
				var ltpstbS = lTPSTB.style;
				ltpstbS.width = labelWSingle + 'px';
				ltpstbS.height = labelH + 'px';
				ltpstbS.left = (margin2 + labelWSingle + textW2 - 20) + 'px';
				ltpstbS.top = (tdH - labelsOffset2)  + 'px';
				Z.Utils.setTextNodeStyle(lTPSTB, 'black', 'verdana', labelFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'left', 'none');
			}

			var tilesPerSecondTextElement = Z.Utils.createTextElement('tilesPerSecondTextElement', '', '1px', '1px', '1px', '1px', '0px', 'solid', '1px', false, 'verdana', '1px', 'none', null, 1, 'hidden', 'hidden', 'off');
			Z.TraceDisplay.appendChild(tilesPerSecondTextElement);
			var tpsTS = document.getElementById('textBoxFor-tilesPerSecondTextElement');
			if (tpsTS) {
				var tpstsS = tpsTS.style;
				tpstsS.width = textW2 + 'px';
				tpstsS.height = textH + 'px';
				tpstsS.left = (margin2 + labelWSingle * 2 + textW2 - 20) + 'px';
				tpstsS.top = (tdH - elementsOffset2)  + 'px';
				Z.Utils.setTextAreaStyle(tpsTS, 'black', 'verdana', textFontSize + 'px', 'none', 'normal', 'normal', 'normal', 'normal', '1em', 'center', 'none', textPaddingSmall + 'px');
			}

			// Configure debug panel buttons.
			var btnW = 58;
			var btnH = 42;
			var btnL = 10;
			var btnT = tdH - (btnH / 2) - 10;
			var btnSpan = 10;
			var btnColor = this.getResource('DEFAULT_TRACEDISPLAYBUTTONCOLOR');
			var btnTxt = this.getResource('UI_TRACEDISPLAYSHOWGLOBALSBUTTONTEXT');
			var buttonShowGlobals = new this.Button('buttonShowGlobals', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', this.showGlobals, 'TIP_SHOWGLOBALS', 'solid', '1px', btnColor, '0px', '0px');
			Z.TraceDisplay.appendChild(buttonShowGlobals.elmt);

			btnL += btnW + btnSpan;
			var btnTxt = this.getResource('UI_TRACEDISPLAYTOGGLEDISPLAYBUTTONTEXT');
			var buttonToggleDisplay = new this.Button('buttonToggleDisplay', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', Z.Viewport.buttonToggleDisplayHandler, 'TIP_TOGGLEDISPLAY', 'solid', '1px', btnColor, '0px', '0px');
			Z.TraceDisplay.appendChild(buttonToggleDisplay.elmt);

			btnL += btnW + btnSpan;
			var btnTxt = this.getResource('UI_TRACEDISPLAYTOGGLEBACKFILLBUTTONTEXT');
			var buttonToggleBackfill = new this.Button('buttonToggleBackfill', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', Z.Viewport.buttonToggleBackfillHandler, 'TIP_TOGGLEBACKFILL', 'solid', '1px', btnColor, '0px', '0px');
			Z.TraceDisplay.appendChild(buttonToggleBackfill.elmt);

			btnL += btnW + btnSpan;
			btnW += 12;
			var btnTxt = this.getResource('UI_TRACEDISPLAYTOGGLECONSTRAINPANBUTTONTEXT');
			var buttonToggleConstrainPan = new this.Button('buttonToggleConstrainPan', btnTxt, null, null, null, null, btnW + 'px', btnH + 'px', btnL + 'px', btnT + 'px', 'mousedown', Z.Viewport.toggleConstrainPan, 'TIP_TOGGLECONSTRAINPAN', 'solid', '1px', btnColor, '0px', '0px');
			Z.TraceDisplay.appendChild(buttonToggleConstrainPan.elmt);
		} else {
			var configureTraceDisplayTimer = window.setTimeout( function() { Z.Utils.configureTraceDisplay(); }, 100);
		}
	},

	showTraces : function () {
		// Debug option: Displays cummulative list of trace values.
		if (!Z.TraceDisplay) {
			Z.Utils.configureTraceDisplay();
		} else {
			Z.TraceDisplay.style.display = 'inline-block';
		}
	},

	hideTraces : function () {
		Z.TraceDisplay.style.display = 'none';
	},

	trace : function (text, blankLineBefore, blankLineAfter) {
		var preLines = (blankLineBefore) ? '\n' : '';
		var postLines = (blankLineAfter) ? '\n\n' : '\n';
		if (!Z.TraceDisplay) { Z.Utils.configureTraceDisplay(); }
		if (Z.traces) {
			Z.traces.value += preLines + text + postLines;
			if (Z.debug == 2) { Z.traces.scrollTop = Z.traces.scrollHeight; }
		}
	},

	traceTileStatus : function (required, cached, requested, loaded, displayed, waiting) {
		if (!(trTS && tcTS && trqTS && tlTS && tdTS && twTS)) {
			var trTS = document.getElementById('tilesRequiredTextElement');
			var tcTS = document.getElementById('tilesCachedTextElement');
			var trqTS = document.getElementById('tilesRequestedTextElement');
			var tlTS = document.getElementById('tilesLoadedTextElement');
			var tdTS = document.getElementById('tilesDisplayedTextElement');
			var twTS = document.getElementById('tilesWaitingTextElement');
		}
		if (trTS && tcTS && trqTS && tlTS && tdTS && twTS) {
			if (typeof required !== 'undefined' && required !== null) {
				trTS.value = required.toString();
			}
			if (typeof cached !== 'undefined' && cached !== null) {
				tcTS.value = cached.toString();
			}
			if (typeof requested !== 'undefined' && requested !== null) {
				trqTS.value = requested.toString();
			}
			if (typeof loaded !== 'undefined' && loaded !== null) {
				tlTS.value = loaded.toString();
			}
			if (typeof displayed !== 'undefined' && displayed !== null) {
				tdTS.value = displayed.toString();
			}
			if (typeof waiting !== 'undefined' && waiting !== null) {
				twTS.value = waiting.toString();
			}
		}
	},

	traceTileSpeed : function (tmElpsd, loadsPerSec) {
		if (!(tteTS && tpsTS)) {
			var tteTS = document.getElementById('tilesTimeElapsedTextElement');
			var tpsTS = document.getElementById('tilesPerSecondTextElement');
		}
		if (tteTS && tpsTS) {
			if (typeof tmElpsd !== 'undefined' && tmElpsd !== null) {
				tteTS.value = tmElpsd.toString();
			}
			if (typeof loadsPerSec !== 'undefined' && loadsPerSec !== null) {
				tpsTS.value = Math.round(loadsPerSec).toString();
			}
		}
	},

	showGlobals : function () {
		// Debug option: Combines global variables as a single string and displays their current values.
		var gVs = '';
		gVs += '\n';
		gVs += '                            ZOOMIFY IMAGE VIEWER - CURRENT VALUES' + '\n';
		gVs += '\n';
		gVs += 'VIEW' + ':    ';
		gVs += 'Z.imageX=' + Z.imageX + ',   ';
		gVs += 'Z.imageY=' + Z.imageY + ',   ';
		gVs += 'Z.imageZ=' + Z.imageZ + ',   ';
		gVs += 'Z.imageR=' + Z.imageR + ',   ';
		gVs += 'Z.priorX=' + Z.priorX + ',   ';
		gVs += 'Z.priorY=' + Z.priorY + ',   ';
		gVs += 'Z.priorZ=' + Z.priorZ + ',   ';
		gVs += 'Z.priorR=' + Z.priorR + ',   ';
		gVs += '\n';
		gVs += 'IMAGE & SKIN' + ':    ';
		gVs += 'Z.imagePath=' + Z.imagePath + ',   ';
		gVs += 'Z.skinPath=' + Z.skinPath + ',   ';
		gVs += 'Z.skinMode=' + Z.skinMode + ',   ';
		gVs += 'Z.imageW=' + Z.imageW + ',   ';
		gVs += 'Z.imageH=' + Z.imageH + ',   ';
		gVs += 'tierCount=' + Z.Viewport.getTierCount() + ',   ';
		gVs += 'TILE_WIDTH=' + Z.Viewport.getTileW() + ',   ';
		gVs += 'TILE_HEIGHT=' + Z.Viewport.getTileH() + '\n';
		gVs += '\n';
		gVs += 'PAGE & BROWSER' + ':    ';
		gVs += 'Z.pageContainer=' + Z.pageContainer + ',   ';
		gVs += 'Z.browser=' + Z.browser + ',   ';
		gVs += 'Z.browserVersion=' + Z.browserVersion + ',   ';
		gVs += 'Z.canvasSupported=' + Z.canvasSupported + ',   ';
		gVs += 'Z.cssTransformsSupported=' + Z.cssTransformsSupported + ',   ';
		gVs += 'Z.cssTransformProperty=' + Z.cssTransformProperty + ',   ';
		gVs += 'Z.cssTransformNoUnits=' + Z.cssTransformNoUnits + ',   ';
		gVs += 'Z.alphaSupported=' + Z.alphaSupported + ',   ';
		gVs += 'Z.renderQuality=' + Z.renderQuality + ',   ';
		gVs += 'Z.rotationSupported=' + Z.rotationSupported + ',   ';
		gVs += 'Z.fullScreenSupported=' + Z.fullScreenSupported + ',   ';
		gVs += 'Z.float32ArraySupported=' + Z.float32ArraySupported + ',   ';
		gVs += 'Z.uInt8ArraySupported=' + Z.uInt8ArraySupported + ',   ';
		gVs += 'Z.xmlHttpRequestSupport=' + Z.xmlHttpRequestSupport + ',   ';
		gVs += 'Z.definePropertySupported=' + Z.definePropertySupported + ',   ';
		gVs += 'Z.responseArraySupported=' + Z.responseArraySupported + ',   ';
		gVs += 'Z.responseArrayPrototyped=' + Z.responseArrayPrototyped + ',   ';
		gVs += 'Z.mobileDevice=' + Z.mobileDevice + ',   ';
		gVs += 'Z.zifSupported=' + Z.zifSupported + ',   ';
		gVs += 'Z.localUse=' + Z.localUse + '\n';
		gVs += '\n';
		gVs += 'VIEWER OPTIONS & DEFAULTS' + ':    ';
		gVs += 'Z.initialX=' + Z.initialX + ',   ';
		gVs += 'Z.initialY=' + Z.initialY + ',   ';
		gVs += 'Z.initialZ=' + Z.initialZ + ',   ';
		gVs += 'Z.minZ=' + Z.minZ + ',   ';
		gVs += 'Z.maxZ=' + Z.maxZ + ',   ';
		gVs += 'Z.fitZ=' + Z.fitZ + ',   ';
		gVs += 'Z.zoomSpeed=' + Z.zoomSpeed + ',   ';
		gVs += 'Z.panSpeed=' + Z.panSpeed + ',   ';
		gVs += 'Z.fadeInSpeed=' + Z.fadeInSpeed + ',   ';
		gVs += 'Z.toolbarVisible=' + Z.toolbarVisible + ',   ';
		gVs += 'Z.toolbarW=' + Z.toolbarW + ',   ';
		gVs += 'Z.toolbarCurrentW=' + Z.toolbarCurrentW + ',   ';
		gVs += 'Z.toolbarH=' + Z.toolbarH + ',   ';
		gVs += 'Z.toolbarPosition=' + Z.toolbarPosition + ',   ';
		gVs += 'Z.tooltipsVisible=' + Z.tooltipsVisible + ',   ';
		gVs += 'Z.helpVisible=' + Z.helpVisible + ',   ';
		gVs += 'Z.navigatorVisible=' + Z.navigatorVisible + ',   ';
		gVs += 'Z.navigatorW=' + Z.navigatorW + ',   ';
		gVs += 'Z.navigatorH=' + Z.navigatorH + ',   ';
		gVs += 'Z.navigatorL=' + Z.navigatorL + ',   ';
		gVs += 'Z.navigatorT=' + Z.navigatorT + ',   ';
		gVs += 'Z.navigatorFit=' + Z.navigatorFit + ',   ';
		gVs += 'Z.clickZoom=' + Z.clickZoom + ',   ';
		gVs += 'Z.clickPan=' + Z.clickPan + ',   ';
		gVs += 'Z.mousePan=' + Z.mousePan + ',   ';
		gVs += 'Z.keys=' + Z.keys + ',   ';
		gVs += 'Z.constrainPan=' + Z.constrainPan + ',   ';
		gVs += 'Z.constrainPanStrict=' + Z.constrainPanStrict + ',   ';
		gVs += 'Z.smoothPan=' + Z.smoothPan + ',   ';
		gVs += 'Z.smoothPanEasing=' + Z.smoothPanEasing + ',   ';
		gVs += 'Watermark alpha = ' + Z.Utils.getResource('DEFAULT_WATERMARKALPHA') + ',   ';
		gVs += 'Z.watermarkPath=' + Z.watermarkPath + ',   ';
		gVs += 'Z.copyrightPath=' + Z.copyrightPath + ',   ';
		gVs += 'Z.hotspotPath=' + Z.hotspotPath + ',   ';
		gVs += 'Z.tourPath=' + Z.tourPath + ',   ';
		gVs += 'Z.slidePath=' + Z.slidePath + ',   ';
		gVs += 'Z.slideTransitionSpeed=' + Z.slideTransitionSpeed + ',   ';
		gVs += 'Z.audioContent=' + Z.audioContent + ',   ';
		gVs += 'Z.audioMuted=' + Z.audioMuted + ',   ';
		gVs += 'Z.annotationPath=' + Z.annotationPath + ',   ';
		gVs += 'Z.saveHandlerPath=' + Z.saveHandlerPath + ',   ';
		gVs += 'Z.trackingPath=' + Z.trackingPath + ',   ';
		gVs += 'Z.minimizeVisible=' + Z.minimizeVisible + ',   ';
		gVs += 'Z.sliderZoomVisible=' + Z.sliderZoomVisible + ',   ';
		gVs += 'Z.zoomButtonsVisible=' + Z.zoomButtonsVisible + ',   ';
		gVs += 'Z.panButtonsVisible=' + Z.panButtonsVisible + ',   ';
		gVs += 'Z.resetVisible=' + Z.resetVisible + ',   ';
		gVs += 'Z.fullScreenVisible=' + Z.fullScreenVisible + ',   ';
		gVs += 'Z.fullPageVisible=' + Z.fullPageVisible + ',   ';
		gVs += 'Z.initialFullPage=' + Z.initialFullPage + ',   ';
		gVs += 'Z.measureVisible=' + Z.measureVisible + ',   ';
		gVs += 'Z.captionTextColor=' + Z.captionTextColor + ',   ';
		gVs += 'Z.captionBackColor=' + Z.captionBackColor + ',   ';
		gVs += 'Z.polygonLineColor=' + Z.polygonLineColor + ',   ';
		gVs += 'Z.polygonFillColor=' + Z.polygonFillColor + ',   ';
		gVs += 'Z.captionTextVisible=' + Z.captionTextVisible + ',   ';
		gVs += 'Z.captionBackVisible=' + Z.captionBackVisible + ',   ';
		gVs += 'Z.polygonFillVisible=' + Z.polygonFillVisible + ',   ';
		gVs += 'Z.polygonLineVisible=' + Z.polygonLineVisible + ',   ';
		gVs += 'Z.rotationVisible=' + Z.rotationVisible + ',   ';
		gVs += 'Z.rotationFree=' + Z.rotationFree + ',   ';
		gVs += 'Z.initialRotation=' + Z.initialRotation + ',   ';
		gVs += 'Z.virtualPointerVisible=' + Z.virtualPointerVisible + ',   ';
		gVs += 'Z.crosshairsVisible=' + Z.crosshairsVisible + ',   ';
		gVs += 'Z.rulerVisible=' + Z.rulerVisible + ',   ';
		gVs += 'Z.units=' + Z.units + ',   ';
		gVs += 'Z.unitsPerImage=' + Z.unitsPerImage + ',   ';
		gVs += 'Z.pixelsPerUnit=' + Z.pixelsPerUnit + ',   ';
		gVs += 'Z.sourceMagnification=' + Z.sourceMagnification + ',   ';
		gVs += 'Z.rulerListType=' + Z.rulerListType + ',   ';
		gVs += 'Z.rulerW=' + Z.rulerW + ',   ';
		gVs += 'Z.rulerH=' + Z.rulerH + ',   ';
		gVs += 'Z.rulerL=' + Z.rulerL + ',   ';
		gVs += 'Z.rulerT=' + Z.rulerT + ',   ';
		gVs += 'Z.coordinatesVisible=' + Z.coordinatesVisible + ',   ';
		gVs += 'Z.imageFiltersVisible=' + Z.imageFiltersVisible + ',   ';
		gVs += 'Z.progressVisible=' + Z.progressVisible + ',   ';
		gVs += 'Z.logoVisible=' + Z.logoVisible + ',   ';
		gVs += 'Z.logoLinkURL=' + Z.logoLinkURL + ',   ';
		gVs += 'Z.logoCustomPath=' + Z.logoCustomPath + ',   ';
		gVs += 'Z.canvas=' + Z.canvas + ',   ';
		gVs += 'Z.debug=' + Z.debug + ',   ';
		gVs += 'Z.imageProperties=' + Z.imageProperties + ',   ';
		gVs += 'Z.serverIP=' + Z.serverIP + ',   ';
		gVs += 'Z.serverPort=' + Z.serverPort + ',   ';
		gVs += 'Z.tileHandlerPath=' + Z.tileHandlerPath + ',   ';
		gVs += 'Z.tileHandlerPathFull=' + Z.tileHandlerPathFull + ',   ';
		gVs += 'Z.tileSource=' + Z.tileSource + ',   ';
		gVs += 'Z.tileType=' + Z.tileType + ',   ';
		gVs += 'Z.freehandVisible=' + Z.freehandVisible + ',   ';
		gVs += 'Z.textVisible=' + Z.textVisible + ',   ';
		gVs += 'Z.iconVisible=' + Z.iconVisible + ',   ';
		gVs += 'Z.rectangleVisible=' + Z.rectangleVisible + ',   ';
		gVs += 'Z.polygonVisible=' + Z.polygonVisible + ',   ';
		gVs += '\n';
		gVs += 'INTERNAL VALUES' + ':    ';
		gVs += '\n';
		gVs += 'displayW=' + Z.Viewport.getDisplayW() + ',   ';
		gVs += 'displayH=' + Z.Viewport.getDisplayH() + ',   ';
		gVs += 'tierCurrent=' + Z.Viewport.getTierCurrent() + ',   ';
		gVs += 'tierBackfill=' + Z.Viewport.getTierBackfill() + ',   ';
		gVs += 'tierBackfillDynamic=' + Z.Viewport.getTierBackfillDynamic() + ',   ';
		gVs += 'tierBackfillOversize=' + Z.Viewport.getTierBackfillOversize() + ',   ';
		gVs += 'tierScale=' + Z.Viewport.getTierScale() + ',   ';
		gVs += 'TIERS_SCALE_UP_MAX=' + Z.Viewport.getTiersScaleUpMax() + ',   ';
		gVs += 'TIERS_SCALE_DOWN_MAX=' + Z.Viewport.getTiersScaleDownMax() + ',   ';
		gVs += 'TILES_CACHE_MAX=' + Z.Viewport.getTilesCacheMax() + ',   ';
		gVs += 'Z.useCanvas=' + Z.useCanvas + '\n';
		gVs += 'Z.specialStorageEnabled=' + Z.specialStorageEnabled + '\n';
		gVs += 'Z.editMode=' + Z.editMode + '\n';
		gVs += 'Z.labelMode=' + Z.labelMode + '\n';
		gVs += 'Z.editing=' + Z.editing + '\n';
		gVs += '\n';
		gVs += 'INTERNAL LISTS' + ':    ';
		gVs += 'tierWs=' + Z.Viewport.getTierWs() + ',   ';
		gVs += 'tierHs=' + Z.Viewport.getTierHs() + ',   ';
		gVs += 'tierTileCounts=' + Z.Viewport.getTierTileCounts() + ',   ';
		gVs += 'tilesLoadingNames=' + Z.Viewport.getTilesLoadingNames() + '\n';
		gVs += '\n';
		alert(gVs);
	}
};
export default Z